/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'My.theme.components',
      'My.theme.inputs',
      'localization'
  ]);

})();

(function () {
  "use strict";
  angular
    .module("My.pages", [
      "ui.router",
      //,'My.pages.agroscoop'
      "My.pages.home",
      "My.pages.home-arvesta",
      "My.pages.cockpit",
      "My.pages.herds",
      "My.pages.rap",
      "My.pages.robotView",
      "My.pages.redirect",
      //'My.pages.animals'
      // , 'My.pages.fields'
      // , 'My.pages.machinery'
      // , 'My.pages.barns'
      // , 'My.pages.personnel'
      // , 'My.pages.profitCenter'
      "My.pages.videos",
      // , 'My.pages.websites'
      //, 'My.pages.data'
      // , 'My.pages.configuration'
      // , 'My.pages.shop'
      "My.pages.calendar",
      "My.pages.treatments_protocols",
      "My.pages.invoice",
      "My.pages.claw_health",
      "My.pages.csv-import",
      "My.pages.addNewHerd",
      "My.pages.myHerds",
      "My.pages.lists",
      "My.pages.editHerd",
      "My.pages.presalesAudit",
      "My.pages.postSalesReport",
      "My.pages.postSalesImport",
      "My.pages.dq",
      "My.pages.insemination-strategy-cows",
      "My.pages.insemination-strategy-heifers",
      "My.pages.conception-rate",
      "My.pages.oestrus-interval",
      "My.pages.conception-strategy-heifers",
      "My.pages.conception-cusum-analysis",
      "My.pages.conception-cusum-analysis-heifers",
      "My.pages.herd-overview",
      "My.pages.milk-production",
      "My.pages.concentrate",
      "My.pages.robot-efficiency",
      "My.pages.milkings",
      "My.settings",
      "My.pages.animals",
      "My.pages.greeting"
      //'My.pages.streamerHealth',
      //should be visible only on development
      //'My.pages.overview',
      //'My.pages.reproduction',
      //'My.pages.production',
      //'My.pages.MRO',
      //'My.pages.lactationAnalysis'
    ])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise("/login");
  }
})();

(function () {
  "use strict";
  angular.module("My.pages.redirect", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("redirect", {
      url: "/redirect",
      controller: function (permissionService, $state, APP_CONSTANTS) {
        var toState = localStorage.getItem("toState");
        if (toState) {
          var statesPermissionsList =
            APP_CONSTANTS.constants.statesPermissionsList;
          toState = JSON.parse(toState);
          var keys = Object.keys(toState.param);
          if (toState.name) {
            var statePermission;
            for (var i = 0; i < statesPermissionsList.length; i++) {
              if (statesPermissionsList[i].state == toState.name) {
                statePermission = statesPermissionsList[i];
                break;
              }
            }
            if (
              statePermission &&
              permissionService.can(statePermission.permissionId)
            ) {
              if (keys.length) {
                $state.go(toState.name, toState.param);
              } else {
                $state.go(toState.name);
              }
              localStorage.removeItem("toState");
            } else {
              var sso = localStorage.getItem("auth0.ssodata");
              var login_type = localStorage.getItem("login_type");
              localStorage.clear();
              localStorage.setItem("login_type", login_type);
              if (sso) {
                localStorage.setItem("auth0.ssodata", sso);
              }
              if (login_type && login_type == "sso") {
                $state.go("login-sso");
              } else {
                $state.go("login");
              }
            }
          }
        } else {
          //development only
          /*if(permissionService.can(234)){
						$state.go('overview');
					}else if(permissionService.can(42)){
						$state.go('home');
					}else{
						if(permissionService.can(49)){
							$state.go('rap');
						}else if(permissionService.can(163)){
							$state.go('clawHealth')
						}else if(permissionService.can(214)){
							$state.go('myHerds')	
						}else if(permissionService.can(16)){
							$state.go('herds.dashboards')	
						}else if(permissionService.can(231)){
                            $state.go('presalesAudit')	
                        }else if(permissionService.can(252)){
                            $state.go('postSalesReport')	
                        }else{
							var sso = localStorage.getItem('auth0.ssodata');
                            localStorage.clear();
                            if (sso) {
                                localStorage.setItem('auth0.ssodata', sso);
                            }
                            localStorage.clear();
                            $state.go('login');
						}
					}*/

          if (permissionService.can(42)) {
            $state.go("home");
          } else if (permissionService.can(357)) {
            $state.go("home-arvesta");
          } else {
            if (permissionService.can(49)) {
              $state.go("rap");
            } else if (permissionService.can(163)) {
              $state.go("clawHealth");
            } else if (permissionService.can(214)) {
              $state.go("myHerds");
            } else if (
              permissionService.can(16) &&
              permissionService.can(318)
            ) {
              $state.go("herds.dashboards");
            } else if (permissionService.can(294)) {
              $state.go("robot-view");
            } else if (permissionService.can(231)) {
              $state.go("presalesAudit");
            } else if (permissionService.can(343)) {
              $state.go("d-insemination-strategy-cows");
            } else if (permissionService.can(344)) {
              $state.go("d-insemination-strategy-heifers");
            } else if (permissionService.can(345)) {
              $state.go("d-conception-rate-cows");
            } else if (permissionService.can(347)) {
              $state.go("d-oestrus-interval-analysis");
            } else if (permissionService.can(346)) {
              $state.go("d-conception-strategy-heifers");
            } else if (permissionService.can(346)) {
              $state.go("d-conception-cusum-analysis");
            } else if (permissionService.can(346)) {
              $state.go("d-conception-cusum-analysis-heifers");
            } else if (permissionService.can(252)) {
              $state.go("postSalesReport");
            } else if (
              permissionService.can(354) &&
              !permissionService.can(357)
            ) {
              $state.go("greeting-page");
            } else {
              var sso = localStorage.getItem("auth0.ssodata");
              var login_type = localStorage.getItem("login_type");
              localStorage.clear();
              localStorage.setItem("login_type", login_type);
              if (sso) {
                localStorage.setItem("auth0.ssodata", sso);
              }
              if (login_type && login_type == "sso") {
                $state.go("login-sso");
              } else {
                $state.go("login");
              }
            }
          }
        }
      },
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('My.theme.inputs', []);

})();

(function () {
	'use strict';
	angular.module('My.pages.animals', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('animals', {
			url: '/animals',
			templateUrl: 'app/pages/herds/animals/animals.html',
			controller: 'animalsCtrl',
			controllerAs: 'vm',
			title: '_page_title_animals_',

			sidebarMeta: {
                img: "assets/img/icons/herds.svg",
                aveve_img: "assets/img/icons/animals.svg",
                proxani_img: "assets/img/icons/animals_proxani.png",
				permission: 426,
				order: 900,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(426)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.agroscoop', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('agroscoop', {
            url: '/agroscoop',
            templateUrl: 'app/pages/agroscoop/agroscoop.html',
            controller: 'agroscoopCtrl',
            controllerAs: 'vm',
            title: '_page_title_agroscoop_',

            sidebarMeta: {
                //icon: 'ion-android-home'
                img: 'assets/img/icons/agroscoop.png',
                 permission: 50,
                order: 0,
            },
             resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(50)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.calendar', [
    ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('calendar', {
            url: '/calendar'
            , templateUrl: 'app/pages/calendar/calendar.html'
            , controller: 'controlerCtrl'
            , controllerAs: 'vm'
            , title: '_page_title_calendar_'
            , sidebarMeta: {
               img: 'assets/img/icons/calendar.png'
                , order: 900
                , permission: 47
            , },
                resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(47)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
         });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.claw_health', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('clawHealth', {
			url: '/claw-health',
			templateUrl: 'app/pages/claw_health/claw_health.html',
			controller: 'clawHealthCtrl',
			controllerAs: 'vm',
			title: '_animal_claw_health_',

			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				 permission: 163,
				//to be defined
				order: 70,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(163)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
  'use strict';

  angular.module('My.pages.cockpit', [
      'angularLazyImg',
      'lazy-scroll',
      'thatisuday.ng-image-gallery',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('cockpit', {
          url: '/cockpit',
          templateUrl: 'app/pages/cockpit/cockpit.html',
          title: '_page_title_farm_cockpit_',
        controller: 'cockpitCtrl',
        controllerAs: 'vm',
          sidebarMeta: {
              img: 'assets/img/icons/farm_cockpit.svg',
            order: 200,
              permission: 43
          },
         resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(43)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
  }

})();

(function () {
    "use strict";
    angular
      .module("My.pages.concentrate", [
        "My.pages.concentrate.feeding",
        "My.pages.concentrate.intake",
        "My.pages.concentrate.leftovers",
        "My.pages.concentrate.overview"
       
      ])
      .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider.state("concentrate", {
        url: "/concentrate",
        title: "_page_title_concentrate_",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          img: "assets/img/icons/premix.png",
          aveve_img: "assets/img/icons/concentrate.svg",
          proxani_img: "assets/img/icons/concentrate_proxani.png",
          order: 30,
          permission: 360,
          goToState: 'concentrate.overview'
        },
      });
    }
  })();
  
(function () {
  "use strict";
  angular.module("My.pages.conception-cusum-analysis", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("d-conception-cusum-analysis", {
      url: "/conception-cusum-analysis",
      title: "_z_conception_cusum_analysis_name_",
      templateUrl: "app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.html",
      controller: "conceptionCusumAnalysisCtrl",
      controllerAs: "vm",
      sidebarMeta: {
        img: "assets/img/icons/herds.svg",
        order: 260,
        permission: 345,
      },
      resolve: {
        permissions: [
          "$q",
          "permissionService",
          function ($q, permissionService) {
            if (permissionService.can(345)) {
              return true;
            } else {
              return $q.reject("Unauthorized");
            }
          },
        ],
      },
    });
  }
})();

(function () {
  "use strict";
  angular.module("My.pages.conception-cusum-analysis-heifers", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("d-conception-cusum-analysis-heifers", {
      url: "/conception-cusum-analysis-heifers",
      title: "_z_conception_cusum_analysis_heifers_name_",
      templateUrl: "app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.html",
      controller: "conceptionCusumAnalysisHeifersCtrl",
      controllerAs: "vm",
      sidebarMeta: {
        img: "assets/img/icons/herds.svg",
        order: 270,
        permission: 345,
      },
      resolve: {
        permissions: [
          "$q",
          "permissionService",
          function ($q, permissionService) {
            if (permissionService.can(345)) {
              return true;
            } else {
              return $q.reject("Unauthorized");
            }
          },
        ],
      },
    });
  }
})();

(function () {
  "use strict";
  angular.module("My.pages.conception-rate", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("d-conception-rate-cows", {
      url: "/conception-rate-cows",
      title: "_z_conception_rate_cows_name_",
      templateUrl: "app/pages/conceptionRateCows/conceptionRateCows.html",
      controller: "conceptionRateCowsCtrl",
      controllerAs: "vm",
      sidebarMeta: {
        img: "assets/img/icons/herds.svg",
        order: 220,
        permission: 345,
      },
      resolve: {
        permissions: [
          "$q",
          "permissionService",
          function ($q, permissionService) {
            if (permissionService.can(345)) {
              return true;
            } else {
              return $q.reject("Unauthorized");
            }
          },
        ],
      },
    });
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.dq', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('dq', {
            url: '/data-quality',
            templateUrl: 'app/pages/DQ/dq.html',
            controller: 'dqCtrl',
            controllerAs: 'vm',
            title: '_page_title_dq_',

            sidebarMeta: {
                //icon: 'ion-android-home'
                img: 'assets/img/icons/dq.svg',
                aveve_img: 'assets/img/icons/dq_aveve.svg',
				proxani_img: 'assets/img/icons/dq_proxani.svg',
                order: 999,
                permission: 316,
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(316)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.dq2', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('dq2', {
            url: '/data-quality2',
            templateUrl: 'app/pages/DQ/dq.html',
            controller: 'dq2Ctrl',
            controllerAs: 'vm',
            title: '_page_title_dq_',

            sidebarMeta: {
                //icon: 'ion-android-home'
                img: 'assets/img/icons/dq.svg',
                order: 999,
                permission: 316,
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(316)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.conception-strategy-heifers', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('d-conception-strategy-heifers', {
            url: '/conception-strategy-heifers'
            , title: '_z_conception_strategy_heifers_name_'
            , templateUrl: 'app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.html'
            , controller: 'conceptionStrategyHeifersCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                img: 'assets/img/icons/herds.svg',
                 order: 250,
                permission: 346
            }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(346)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.greeting', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('greeting-page', {
			url: '/greeting-page',
			templateUrl: 'app/pages/greeting/greeting.html',
			title: '_page_title_home_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/herds.svg',
				permission: 354,
				permission_2: 357,
				order: 10,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(354) && !permissionService.can(357)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
  "use strict";
  angular.module("My.pages.herd-overview", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("herd-overview", {
      url: "/herd-overview",
      templateUrl: "app/pages/herdOverview/herdOverview.html",
      controller: "herdOverviewCtrl",
      controllerAs: "vm",
      title: "_page_title_herd_overview_",

      sidebarMeta: {
        //icon: 'ion-android-home'
        img: "assets/img/icons/herds.svg",
        aveve_img: "assets/img/icons/herd_overview.svg",
        proxani_img: "assets/img/icons/herd_overview_proxani.png",
        permission: 358,
        order: 10,
      },
      resolve: {
        permissions: [
          "$q",
          "permissionService",
          function ($q, permissionService) {
            if (permissionService.can(358)) {
              return true;
            } else {
              return $q.reject("Unauthorized");
            }
          },
        ],
      },
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.home', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('home', {
			url: '/home',
			templateUrl: 'app/pages/home/home.html',
			//templateUrl: 'app/pages/home/home_new.html',
			controller: 'homeCtrl',
			//controller: 'homeCtrlNew',
			controllerAs: 'vm',
			title: '_page_title_home_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 42,
				order: 0,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(42)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds", [
      "My.pages.herds.dashboardsV2",
      "My.pages.herds.animals",
      "My.pages.herds.spartan",
      "My.pages.herds.listGeneratorV2",
      "My.pages.herds.attentionMRO"
    ])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("herds", {
      url: "/herds",
      title: "_page_title_herds_",
      
      template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
      controller: "herdsCtrl",
      controllerAs: "vm",
      abstract: true,
      sidebarMeta: {
        img: "assets/img/icons/herds.svg",
        order: 300,
        permission: 16
      },
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.home-arvesta', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('home-arvesta', {
			url: '/home-page',
			templateUrl: 'app/pages/homeArvesta/homeArvesta.html',
			controller: 'homeArvestaCtrl',
			controllerAs: 'vm',
			title: '_page_title_home_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				aveve_img: 'assets/img/icons/home_aveve.svg',
				proxani_img: 'assets/img/icons/home_proxani.png',
				permission: 357,
				order: 0,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(357)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.csv-import', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('importAnimals', {
			url: '/import-animals',
			templateUrl: 'app/pages/importAnimals/importAnimals.html',
			title: '_page_title_import_animals_',
			controller: 'importAnimalsCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/import.png',
				order: 90,
				permission: 212
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(212)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                }]
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.insemination-strategy-cows', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('d-insemination-strategy-cows', {
            url: '/insemination-strategy-cows'
            , title: '_z_insemination_strategy_cows_name_'
            , templateUrl: 'app/pages/inseminationStrategyCows/inseminationStrategyCows.html'
            , controller: 'inseminationStrategyCowsCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                img: 'assets/img/icons/herds.svg',
                 order: 210,
                permission: 343
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(343)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.insemination-strategy-heifers', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('d-insemination-strategy-heifers', {
            url: '/insemination-strategy-heifers'
            , title: '_z_insemination_strategy_heifers_name_'
            , templateUrl: 'app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.html'
            , controller: 'inseminationStrategyHeifersCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                img: 'assets/img/icons/herds.svg',
                 order: 240,
                permission: 344
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(344)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.invoice', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('invoice', {
			url: '/invoice',
			templateUrl: 'app/pages/invoice/invoice.html',
			controller: 'invoiceCtrl',
			controllerAs: 'vm',
			title: '_page_title_invoice_',

			sidebarMeta: {
				img: 'assets/img/icons/invoice.png',
				 permission: 213,
				order: 99,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(213)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.lactationAnalysis', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lactationAnalysis', {
			url: '/lactation-analysis',
			templateUrl: 'app/pages/lactationAnalysis/lactationAnalysis.html',
			controller: 'lactationAnalysisCtrl',
			controllerAs: 'vm',
			title: '_page_lactation_analysis_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/production.png',
				 permission: 229,
				//to be defined
				order: 79,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(229)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.lists', [
		'My.pages.lists.trimList',
		'My.pages.lists.wrapList',
		'My.pages.lists.recheckList',
		'My.pages.lists.blockList'
	]).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lists', {
			url: '/lists',
			template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
			title: '_page_title_lists_',
			abstract: true,
			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				order: 101,
				permission: 216
			}
		});
	}
})();
(function () {
    'use strict';
    angular.module('My.login', [
    'ui.router'
  , ]).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('login', {
            url: '/login'
            , templateUrl: 'auth.html'
            , controller: 'loginCtrl'
            , controllerAs: 'vm'
            , title: "login"
        });
    }
})();

(function () {
    "use strict";
    angular
      .module("My.pages.milk-production", [
        "My.pages.milk-production.milk-trend",
        "My.pages.milk-production.spp",
        "My.pages.milk-production.components",
        "My.pages.milk-production.pregnant",
        "My.pages.milk-production.conductivity",
       
      ])
      .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider.state("milk-production", {
        url: "/milk-production",
        title: "_page_title_milk_production_",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          img: "assets/img/icons/production.png",
          aveve_img: "assets/img/icons/milk_production.svg",
          proxani_img: "assets/img/icons/milk_production_proxani.png",
          order: 20,
          permission: 359,
          goToState: 'milk-production.milk-trend'
        },
      });
    }
  })();
  
(function () {
    'use strict';
    angular.module('My.login-sso', [
    'ui.router'
  , ]).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider.state('login-sso', {
            url: '/sso-login'
            , templateUrl: 'auth.html'
            , controller: 'loginSsoCtrl'
            , controllerAs: 'vm'
            , title: "login"
        });
    }
})();

(function () {
    "use strict";
    angular
      .module("My.pages.milkings", [
        "My.pages.milkings.actual",
        "My.pages.milkings.failures",
        "My.pages.milkings.refusals"
       
      ])
      .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider.state("milkings", {
        url: "/milkings",
        title: "_page_title_milkings_",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          img: "assets/img/icons/production.png",
          aveve_img: "assets/img/icons/milkings.svg",
          proxani_img: "assets/img/icons/milkings_proxani.png",
          order: 40,
          permission: 361,
          goToState: 'milkings.actual'
        },
      });
    }
  })();
  
(function () {
    'use strict';
    angular.module('My.pages.oestrus-interval', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('d-oestrus-interval-analysis', {
            url: '/oestrus-interval-analysis'
            , title: '_z_oestrus_interval_analysis_name_'
            , templateUrl: 'app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.html'
            , controller: 'oestrusIntervalAnalysisCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                img: 'assets/img/icons/herds.svg',
                 order: 230,
                permission: 347
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(347)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.MRO', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('mro', {
			url: '/mro',
			templateUrl: 'app/pages/MRO/MRO.html',
			controller: 'mroCtrl',
			controllerAs: 'vm',
			title: '_page_mro_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/production.png',
				 permission: 230,
				//to be defined
				order: 77,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(230)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.overview', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('overview', {
			url: '/overview',
			templateUrl: 'app/pages/overview/overview.html',
			controller: 'overviewCtrl',
			controllerAs: 'vm',
			title: '_page_title_home_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				 permission: 234,
				//to be defined
				order: 50,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(234)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.presalesAudit', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('presalesAudit', {
			url: '/presales-audit',
			templateUrl: 'app/pages/presalesAudit/presalesAudit.html',
			controller: 'presalesAuditCtrl',
			controllerAs: 'vm',
			title: '_page_presales_audit_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/overview.svg',
				permission: 231,
				//to be defined
				order: 310,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(231)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.production', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('production', {
			url: '/production',
			templateUrl: 'app/pages/production/production.html',
			controller: 'productionCtrl',
			controllerAs: 'vm',
			title: '_page_milk_meter_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/production.png',
				 permission: 232,
				//to be defined
				order: 75,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(232)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.rap', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('rap', {
            url: '/rap',
            templateUrl: 'app/pages/rap/rap.html',
            controller: 'rapCtrl',
            controllerAs: 'vm',
            title: '_page_title_rap_',

            sidebarMeta: {
                //icon: 'ion-android-home'
                img: 'assets/img/icons/rap.svg',
                order: 50,
                permission: 49,
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(49)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.reproduction', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('reproduction', {
			url: '/reproduction',
			templateUrl: 'app/pages/reproduction/reproduction.html',
			controller: 'reproductionCtrl',
			controllerAs: 'vm',
			title: '_dc_reproduction_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/repro.png',
				 permission: 233,
				//to be defined
				order: 75,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(233)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
    "use strict";
    angular
      .module("My.pages.robot-efficiency", [
        "My.pages.robot-efficiency.milk-hour",
        "My.pages.robot-efficiency.milk-speed",
        "My.pages.robot-efficiency.robot-prestations"
       
      ])
      .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider.state("robot-efficiency", {
        url: "/robot-efficiency",
        title: "_page_title_robot_efficiency_",
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        sidebarMeta: {
          img: "assets/img/icons/production.png",
          aveve_img: "assets/img/icons/robot_efficiency.svg",
          proxani_img: "assets/img/icons/robot_efficiency_proxani.png",
          order: 50,
          permission: 362,
          goToState: 'robot-efficiency.robot-prestations'
        },
      });
    }
  })();
  
(function () {
  "use strict";
  angular.module("My.settings", []).config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state("settings", {
      url: "/settings",
      templateUrl: "app/pages/settings/settings.html",
      title: "_label_settings_",
      controller: "settingsCtrl",
      controllerAs: "vm",
      resolve: {
        accessContols: [
          "$q",
          "permissionService",
          function ($q, permissionService) {
            if (permissionService.can(14)) {
              return true;
            } else {
              return $q.reject("Unauthorized");
            }
          },
        ],
      },
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.robotView', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('robot-view', {
			url: '/robot-view',
			templateUrl: 'app/pages/robotView/robotView.html',
			title: '_page_title_robot_view_',
			controller: 'robotViewCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/production.png',
				order: 305,
				permission: 294
			},
			resolve: {
                'accessContols': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(294)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.streamerHealth', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('streamer-health', {
            url: '/streamer-health',
            templateUrl: 'app/pages/streamerHealth/streamerHealth.html',
            controller: 'streamerHealthCtrl',
            controllerAs: 'vm',
            title: '_page_title_streamer_health_',

            sidebarMeta: {
                //icon: 'ion-android-home'
                img: 'assets/img/icons/dq.svg',
                order: 999,
                permission: 999,
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(999)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
        });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
    angular.module('My.pages.videos', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('videos', {
             abstract: true
            , title: '_page_title_videos_'
            , fixedHref: 'https://www.youtube.com/channel/UCEj1VeH8a-l0rIvbb4P4wLw/playlists'

            , sidebarMeta: {
                img: 'assets/img/icons/videos.svg'
                , order: 600
                , permission : 46
            , }
        , });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.treatments_protocols', []).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('treatments_protocols', {
            url: '/treatmentsprotocols'
            , templateUrl: 'app/pages/treatments_protocols/treatments_protocols.html'
            , controller: 'treatmentsProtocolsCtrl'
            , controllerAs: 'vm'
            , title: '_page_title_treatments_protocols_'
            , sidebarMeta: {
                 img: 'assets/img/icons/data.svg'
                , order: 950
                , permission: 48
            , },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(48)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
         });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.concentrate.feeding', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('concentrate.feeding', {
			url: '/feeding',
			templateUrl: 'app/pages/concentrate/concentrateFeeding/concentrateFeeding.html',
			controller: 'feedingCtrl',
			controllerAs: 'vm',
			title: '_page_title_concentrate_feeding_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 367,
				order: 310,
				parentTitle: '_page_title_concentrate_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(367)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.concentrate.intake', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('concentrate.intake', {
			url: '/intake',
			templateUrl: 'app/pages/concentrate/concentrateIntake/concentrateIntake.html',
			controller: 'intakeCtrl',
			controllerAs: 'vm',
			title: '_page_title_concentrate_intake_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 369,
				order: 330,
				parentTitle: '_page_title_concentrate_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(369)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.concentrate.overview', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('concentrate.overview', {
			url: '/overview',
			templateUrl: 'app/pages/concentrate/overview/overview.html',
			controller: 'overviewCtrl',
			controllerAs: 'vm',
			title: '_page_title_overview_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 366,
				order: 300,
				parentTitle: '_page_title_concentrate_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(366)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.concentrate.leftovers', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('concentrate.leftovers', {
			url: '/leftovers',
			templateUrl: 'app/pages/concentrate/leftovers/leftovers.html',
			controller: 'leftoversCtrl',
			controllerAs: 'vm',
			title: '_page_title_leftovers_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 368,
				order: 320,
				parentTitle: '_page_title_concentrate_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(368)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.addNewHerd', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('addNewHerd', {
			url: '/add-new-herd',
			templateUrl: 'app/pages/herds/addNewHerd/addNewHerd.html',
			title: '_page_title_add_new_herd_',
			controller: 'addNewHerdCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/herds.svg',
				order: 80,
				permission: 214
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(214)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
    'use strict';
    angular.module('My.pages.herds.attentionMRO', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.attention-mro', {
            url: '/attention-mro'
            , title: '_page_title_attention_mro_'
            , templateUrl: 'app/pages/herds/attentionListMRO/attentionListMRO.html'
            , controller: 'attentionListMROCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                 order: 220,
                permission: 529
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(529)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.animals', [
        'My.pages.herds.animals.details'
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.animals', {
            url: '/animals',
            templateUrl: 'app/pages/herds/animals/animals.html',
            title: '_page_title_animals_',
            controller: 'animalsCtrl',
            controllerAs: 'vm',
            sidebarMeta: {
                icon: 'ion-android-clipboard',
                order: 100,
                permission: 44
            },
              resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(44)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.dashboardsV2', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.dashboards', {
            url: '/dashboards'
            , title: '_page_title_dashboards_'
            , templateUrl: 'app/pages/herds/dashboardsV2/dashboards.html'
            , controller: 'herdsDashboardsCtrlV2'
            , controllerAs: 'vm'
            , sidebarMeta: {
                 order: 200,
                permission: 318
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(318)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.dashboards', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.dashboards', {
            url: '/dashboards'
            , title: '_page_title_dashboards_'
            , templateUrl: 'app/pages/herds/dashboards/dashboards.html'
            , controller: 'herdsDashboardsCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                 order: 200,
                permission: 318
            , }
            , resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(318)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

(function () {
	'use strict';

	angular.module('My.pages.editHerd', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('editHerd', {
			url: '/edit-herd/{herd_id:string}',
			templateUrl: 'app/pages/herds/editHerd/editHerd.html',
			title: '_page_title_edit_herd_',
			controller: 'editHerdCtrl',
			controllerAs: 'vm',
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(214)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
    'use strict';
    angular.module('My.pages.herds.listGeneratorV2', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.listGenerator', {
            url: '/listGenerator'
            , templateUrl: 'app/pages/herds/listGeneratorV2/listGenerator.html'
            , title: '_page_title_list_generator_'
            , controller: 'listGeneratorCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                 order: 150,
                permission: 45
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(45)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
         });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.listGenerator', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('herds.listGenerator', {
            url: '/listGenerator'
            , templateUrl: 'app/pages/herds/listGenerator/listGenerator.html'
            , title: '_page_title_list_generator_'
            , controller: 'listGeneratorCtrl'
            , controllerAs: 'vm'
            , sidebarMeta: {
                 order: 150,
                permission: 45
            },
            resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(45)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            },
         });
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.spartan', [
  ]).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('herds.spartan', {

			title: '_page_spartan_'


			, abstract: true
			, fixedHref: "https://ration.mmmooogle.com/"
			, sidebarMeta: {
				 order: 600,
				 permission: 319
			, }
		, });
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.myHerds', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('myHerds', {
			url: '/my-herds',
			templateUrl: 'app/pages/herds/myHerds/myHerds.html',
			title: '_page_title_my_herds_',
			controller: 'myHerdsCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/herds.svg',
				order: 70,
				permission: 214
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(214)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('My.pages.lists.blockList', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lists.blockList', {
			url: '/block-list',
			templateUrl: 'app/pages/lists/blockList/blockList.html',
			title: '_page_title_block_list_',
			controller: 'blockListCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				order: 105,
				permission: 217
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(217)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('My.pages.lists.recheckList', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lists.recheckList', {
			url: '/recheck-list',
			templateUrl: 'app/pages/lists/recheckList/recheckList.html',
			title: '_page_title_recheck_list',
			controller: 'recheckListCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				order: 120,
				permission: 218
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(218)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('My.pages.lists.trimList', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lists.trimList', {
			url: '/trim-list',
			templateUrl: 'app/pages/lists/trimList/trimList.html',
			title: '_page_title_trim_list',
			controller: 'trimListCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				order: 102,
				permission: 217
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(217)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
	'use strict';

	angular.module('My.pages.lists.wrapList', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('lists.wrapList', {
			url: '/wrap-list',
			templateUrl: 'app/pages/lists/wrapList/wrapList.html',
			title: '_page_title_wrap_list_',
			controller: 'wrapListCtrl',
			controllerAs: 'vm',
			sidebarMeta: {
				img: 'assets/img/icons/clawHealth.png',
				order: 110,
				permission: 317
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(317)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
                 }]
			}
		});
	}
})();
(function () {
	'use strict';
	angular.module('My.pages.milk-production.components', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milk-production.components', {
			url: '/components',
			templateUrl: 'app/pages/milkProduction/components/components.html',
			controller: 'componentsCtrl',
			controllerAs: 'vm',
			title: '_page_title_components_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 365,
				order: 230,
				parentTitle: '_page_title_milk_production_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(365)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milk-production.conductivity', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milk-production.conductivity', {
			url: '/conductivity',
			templateUrl: 'app/pages/milkProduction/conductivity/conductivity.html',
			controller: 'conductivityCtrl',
			controllerAs: 'vm',
			title: '_page_title_conductivity_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 528,
				order: 200,
				parentTitle: '_page_title_milk_production_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(528)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milk-production.milk-trend', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milk-production.milk-trend', {
			url: '/milk-trend',
			templateUrl: 'app/pages/milkProduction/milkTrend/milkTrend.html',
			controller: 'milkTrendCtrl',
			controllerAs: 'vm',
			title: '_page_title_milk_trend_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 363,
				order: 200,
				parentTitle: '_page_title_milk_production_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(363)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milk-production.pregnant', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milk-production.pregnant', {
			url: '/pregnant',
			templateUrl: 'app/pages/milkProduction/pregnant/pregnant.html',
			controller: 'pregnantCtrl',
			controllerAs: 'vm',
			title: '_page_title_pregnant_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 527,
				order: 200,
				parentTitle: '_page_title_milk_production_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(527)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milkings.refusals', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milkings.refusals', {
			url: '/refusals',
			templateUrl: 'app/pages/milkings/refusals/refusals.html',
			controller: 'refusalsCtrl',
			controllerAs: 'vm',
			title: '_page_title_refusals_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 371,
				order: 410,
				parentTitle: '_page_title_milkings_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(371)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milk-production.spp', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milk-production.spp', {
			url: '/spp',
			templateUrl: 'app/pages/milkProduction/spp/spp.html',
			controller: 'sppCtrl',
			controllerAs: 'vm',
			title: '_page_title_spp_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 364,
				order: 210,
				parentTitle: '_page_title_milk_production_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(364)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milkings.actual', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milkings.actual', {
			url: '/actual',
			templateUrl: 'app/pages/milkings/milkingsActual/milkingsActual.html',
			controller: 'actualCtrl',
			controllerAs: 'vm',
			title: '_page_title_milkings_actual_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 370,
				order: 400,
				parentTitle: '_page_title_milkings_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(370)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.milkings.failures', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('milkings.failures', {
			url: '/failures',
			templateUrl: 'app/pages/milkings/failures/failures.html',
			controller: 'failuresCtrl',
			controllerAs: 'vm',
			title: '_page_title_failures_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 372,
				order: 420,
				parentTitle: '_page_title_milkings_'
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(372)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.postSalesReport', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('postSalesReport', {
			url: '/post-sales',
			templateUrl: 'app/pages/postSales/postSalesReport/postSalesReport.html',
			controller: 'postSalesReportCtrl',
			controllerAs: 'vm',
			title: '_page_post_sales_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/dna.svg',
				permission: 252,
				order: 320,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(252)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.postSalesImport', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('postSalesImport', {
			url: '/import-post-sales',
			templateUrl: 'app/pages/postSales/postSalesImport/postSalesImport.html',
			controller: 'postSalesImportCtrl',
			controllerAs: 'vm',
			title: '_page_post_sales_import_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/dna.svg',
				permission: 253,
				order: 330,
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(253)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.robot-efficiency.milk-speed', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('robot-efficiency.milk-speed', {
			url: '/milking-speed',
			templateUrl: 'app/pages/robotEfficiency/milkingSpeed/milkingSpeed.html',
			controller: 'milkingSpeedCtrl',
			controllerAs: 'vm',
			title: '_page_title_milking_speed_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 374,
				order: 510,
				parentTitle: "_page_title_robot_efficiency_"
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(374)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.robot-efficiency.milk-hour', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('robot-efficiency.milk-hour', {
			url: '/milk-hour',
			templateUrl: 'app/pages/robotEfficiency/milkHour/milkHour.html',
			controller: 'milkHourCtrl',
			controllerAs: 'vm',
			title: '_page_title_milk_hour_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 375,
				order: 520,
				parentTitle: "_page_title_robot_efficiency_"
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(375)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.robot-efficiency.robot-prestations', []).config(routeConfig);
	/** @ngInject */
	function routeConfig($stateProvider) {
		$stateProvider.state('robot-efficiency.robot-prestations', {
			url: '/robot-prestations',
			templateUrl: 'app/pages/robotEfficiency/robotPrestations/robotPrestations.html',
			controller: 'robotPrestationsCtrl',
			controllerAs: 'vm',
			title: '_page_title_robot_prestations_',

			sidebarMeta: {
				//icon: 'ion-android-home'
				img: 'assets/img/icons/home.svg',
				permission: 373,
				order: 500,
				parentTitle: "_page_title_robot_efficiency_"
			},
			resolve: {
				'permissions': ['$q', 'permissionService', function ($q, permissionService) {
					if (permissionService.can(373)) {
						return true;
					} else {
						return $q.reject('Unauthorized');
					}
				}]
			},
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.animals.details', [
  ]).config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider.state('animalDatails', {
            url: '/herds/animals/{animal_id:string}?hi'
            , templateUrl: 'app/pages/herds/animals/animalDetails/animalDetails.html'
            , title: '_page_animal_details_'
            , controller: 'animalDetailsCtrl'
            , controllerAs: 'vm'
            ,  resolve: {
                'permissions': ['$q', 'permissionService', function ($q, permissionService) {
                    if (permissionService.can(44)) {
                        return true;
                    } else {
                        return $q.reject('Unauthorized');
                    }
                }]
            }
        , });
    }
})();

"use strict";
angular
  .module("My", [
    //'auth0.lock',
    "ngAnimate",
    "ui.bootstrap",
    "ui.sortable",
    "ui.router",
    "ui.select",
    "ngSanitize",
    "ngTouch",
    "toastr",
    "smart-table",
    "xeditable",
    "ui.slimscroll",
    "ngJsTree",
    "angular-progress-button-styles",
    "angular.filter",
    "angular-jwt",
    "ngCookies",
    "rzModule",
    "ngCsv",
    "ngFileUpload",
    "tmh.dynamicLocale",
    "ion.rangeslider",
    "My.theme",
    "My.pages",
    "My.login",
    "My.login-sso",
  ])
  .config(appConfig)
  .run(appRun)
  .factory("$exceptionHandler", catchExceptions);
/** @ngInject */
function appConfig(
  $httpProvider,
  $locationProvider,
  toastrConfig,
  jwtOptionsProvider,
  jwtInterceptorProvider,
  APP_CONSTANTS,
  lazyImgConfigProvider,
  tmhDynamicLocaleProvider,
  bugsnagServiceProvider
) {
  bugsnagServiceProvider.load();
  setupGoogleAnalytics();
  jwtOptionsProvider.config({
    tokenGetter: [
      "options",
      function (options) {
        return localStorage.getItem("id_token");
      },
    ],
    whiteListedDomains: [
      "localhost",
      "local-test-mmm.com",
      APP_CONSTANTS.backoffice_domen,
      "spartan-api.mmmooogle.com",
      APP_CONSTANTS.animals_domen,
      "events.mmmooogle.com",
      "events-k8s.mmmooogle.com",
      APP_CONSTANTS.tableau_domen,
      "backoffice-stg.mmmooogle.com",
      APP_CONSTANTS.my_api_base_domen,
    ],
    //, unauthenticatedRedirectPath: '/login'
  });
  $locationProvider.html5Mode(true);
  // Add the jwtInterceptor to the array of HTTP interceptors
  // so that JWTs are attached as Authorization headers
  $httpProvider.interceptors.push("jwtInterceptor");
  $httpProvider.interceptors.push(httpInterceptor);

  tmhDynamicLocaleProvider.localeLocationPattern(
    "assets/js/angular-i18n/angular-locale_{{locale}}.js"
  );

  function httpInterceptor(
    $q,
    $window,
    $location,
    $timeout,
    $injector,
    $filter,
    bugsnagService
  ) {
    var vm = this;
    return {
      responseError: responseError,
    };

    function responseError(rejection) {
      if (rejection.status === 401) {
        var login_type = localStorage.getItem("login_type");
        localStorage.clear();
        localStorage.setItem("login_type", login_type);
        $timeout(function () {
          if (login_type && login_type == "sso") {
            $location.path("/sso-login");
          } else {
            $location.path("/login");
          }
        }, 1);
      } else {
        bugsnagService.logError(rejection);
      }
      return $q.reject(rejection);
    }
  }
  lazyImgConfigProvider.setOptions({
    headers: {
      Authorization: "Bearer auth-token",
    },
  });

  var options = {
    newestOnTop: true,

    preventDuplicates: true,

    timeOut: "10000",
  };

  angular.extend(toastrConfig, options);

  function setupGoogleAnalytics() {
    var elem = document.createElement("script");
    elem.src = "https://www.googletagmanager.com/gtag/js?id=G-WSN3575YVG";
    elem.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(elem);
  }
}
/** @ngInject */
function appRun(
  $rootScope,
  $state,
  $window,
  $timeout,
  $location,
  $anchorScroll,
  localize,
  $cookies,
  APP_CONSTANTS,
  tmhDynamicLocale,
  toastr,
  $filter,
  cookiesService
) {
  var connectionTimer;
  if ($location.path() == "/") {
    var login_type = localStorage.getItem("login_type");
    if (login_type && login_type == "sso") {
      $window.location.href = "/sso-login";
    } else {
      $window.location.href = "/login";
    }
  }
  checkVersion();
  $anchorScroll.yOffset = 50;
  $rootScope.$on("$stateChangeStart", stateChange);
  $rootScope.$on("$stateChangeError", changeError);
  $rootScope.$on("$stateChangeSuccess", stateChangeSuccess);
  if (localStorage.getItem("dirty")) {
    localStorage.removeItem("dirty");
  }

  function gtag() {
    $window.dataLayer = $window.dataLayer || [];
    dataLayer.push(arguments);
  }

  try {
    gtag("js", new Date());
    gtag("set", {
      page_title: $location.path(),
    });
    gtag("config", "G-WSN3575YVG");
  } catch (error) {
    console.log(error);
  }

  function stateChangeSuccess() {
    if ($location.path() != "/redirect") {
      try {
        gtag("set", {
          page_title: $location.path(),
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  function stateChange(event, toState) {
    var token = localStorage.getItem("id_token");
    var message = toState.name + "token" + token + event.toString();
    if (token) {
      if (toState.name === "login" || toState.name === "login-sso") {
        //lock.hide();
        event.preventDefault();
        $state.go("redirect");
      }
    } else {
      if (
        toState.name != "login" &&
        toState.name != "privacyPolicy" &&
        toState.name != "login-sso"
      ) {
        var sso = localStorage.getItem("auth0.ssodata");
        var login_type = localStorage.getItem("login_type");
        localStorage.clear();
        if (sso) {
          localStorage.setItem("auth0.ssodata", sso);
        }
        localStorage.setItem("login_type", login_type);
        event.preventDefault();
        if (login_type && login_type == "sso") {
          $timeout(function () {
            $window.location.href = "/sso-login";
          }, 1000);
        } else {
          $timeout(function () {
            $window.location.href = "/login";
          }, 1000);
        }
      }
    }

    if ($state.current.name == "animalDatails") {
      if (
        toState.name == "herds.animals" ||
        toState.name == "herds.listGenerator" ||
        toState.name == "animals"
      ) {
        var data = JSON.parse(localStorage.getItem("animalList"));
        if (data) {
          data.goBack = true;
          localStorage.setItem("animalList", JSON.stringify(data));
        }
      } else {
        localStorage.removeItem("animalList");
      }
    }

    if (
      $state.current.name == "herds.listGenerator" ||
      $state.current.name == "herds.animals"
    ) {
      if (toState.name != "animalDatails") {
        localStorage.removeItem("animalList");
      } else {
        localStorage.setItem("fromAnimal", true);
      }
    }

    /*if($state.current.name == 'animalDatails' && (toState.name == 'herds.animals' || toState.name == 'herds.listGenerator')){
			var data = JSON.parse(localStorage.getItem('animalList'));
			if(data){
				data.goBack = true;
			localStorage.setItem('animalList', JSON.stringify(data));
			}

		}else{

		}*/
  }

  function changeError(event, toState, toParams, fromState, fromParams, error) {
    var state = {
      name: toState.name,
      param: toParams,
    };
    localStorage.setItem("toState", JSON.stringify(state));
    event.preventDefault();
    $state.go("redirect");
    //console.log(rejection)
  }
  window.onbeforeunload = function () {
    var dirty = localStorage.getItem("dirty");
    if (dirty) {
      return "Are you sure you want to navigate away?";
    }
  };

  function checkVersion() {
    var currentVersion = $cookies.get("version");
    if (currentVersion) {
      if (currentVersion != APP_CONSTANTS.buildTimeStamp) {
        var date = new Date().toISOString();
        var d = {
          date: date,
          type: "version",
        };
        localStorage.setItem("cachecleared", JSON.stringify(d));
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 1);
        cookiesService.setCookie("version", APP_CONSTANTS.buildTimeStamp, {
          samesite: "strict",
          expires: expireDate,
        });
        window.location.reload(true);
      }
    } else {
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 1);
      cookiesService.setCookie("version", APP_CONSTANTS.buildTimeStamp, {
        samesite: "strict",
        expires: expireDate,
      });
    }
  }

  $rootScope.online = navigator.onLine;
  $window.addEventListener(
    "offline",
    function () {
      $rootScope.online = false;
      if (connectionTimer) {
        $timeout.cancel(connectionTimer);
      }

      connectionTimer = $timeout(function () {
        if (!$rootScope.online) {
          toastr.error(
            $filter("i18n")("_label_connection_lost_message_"),
            $filter("i18n")("_label_connection_lost_")
          );
        }
      }, 750);
    },
    false
  );

  $window.addEventListener(
    "online",
    function () {
      $rootScope.online = true;
      if (connectionTimer) {
        $timeout.cancel(connectionTimer);
      }

      connectionTimer = $timeout(function () {
        if ($rootScope.online) {
          toastr.success(
            $filter("i18n")("_label_connection_established_message_"),
            $filter("i18n")("_label_connection_established_")
          );
        }
      }, 750);
    },
    false
  );
}

/** @ngInject */
function catchExceptions($log, bugsnagService) {
  return function (exception) {
    $log.error(exception);
    console.log("unhandled error");
    bugsnagService.logUnhandledError(exception);
  };
}

/**
 * @Author: Geoffrey Bauduin <bauduin.geo@gmail.com>
 */

angular.module("ion.rangeslider", []);

angular.module("ion.rangeslider").directive("ionRangeSlider",
    ['$timeout', function($timeout) {
        return {
            restrict: "A",
            scope: {
                min: "=",
                max: "=",
                from: "=",
                to: "=",
                disable: "=",
                values: "=",

                type: "@",
                step: "@",
                minInterval: "@",
                maxInterval: "@",
                dragInterval: "@",
                fromFixed: "@",
                fromMin: "@",
                fromMax: "@",
                fromShadow: "@",
                toFixed: "@",
                toMax: "@",
                toShadow: "@",
                prettifyEnabled: "@",
                prettifySeparator: "@",
                forceEdges: "@",
                keyboard: "@",
                keyboardStep: "@",
                grid: "@",
                gridMargin: "@",
                gridNum: "@",
                gridSnap: "@",
                hideMinMax: "@",
                hideFromTo: "@",
                prefix: "@",
                postfix: "@",
                maxPostfix: "@",
                decorateBoth: "@",
                valuesSeparator: "@",
                inputValuesSeparator: "@",

                prettify: "&",
                onChange: "&",
                onFinish: "&",
            },
            replace: true,
            link: function($scope, $element, attrs) {
                $element.ionRangeSlider({
                    min: $scope.min,
                    max: $scope.max,
                    from: $scope.from,
                    to: $scope.to,
                    disable: $scope.disable,
                    type: $scope.type,
                    step: $scope.step,
                    min_interval: $scope.minInterval,
                    max_interval: $scope.maxInterval,
                    drag_interval: $scope.dragInterval,
                    values: $scope.values,
                    from_fixed: $scope.fromFixed,
                    from_min: $scope.fromMin,
                    from_max: $scope.fromMax,
                    from_shadow: $scope.fromShadow,
                    to_fixed: $scope.toFixed,
                    to_max: $scope.toMax,
                    to_shadow: $scope.toShadow,
                    prettify_enabled: $scope.prettifyEnabled,
                    prettify_separator: $scope.prettifySeparator,
                    force_edges: $scope.forceEdges,
                    keyboard: $scope.keyboard,
                    keyboard_step: $scope.keyboardStep,
                    grid: $scope.grid,
                    grid_margin: $scope.gridMargin,
                    grid_num: $scope.gridNum,
                    grid_snap: $scope.gridSnap,
                    hide_min_max: $scope.hideMinMax,
                    hide_from_to: $scope.hideFromTo,
                    prefix: $scope.prefix,
                    postfix: $scope.postfix,
                    max_postfix: $scope.maxPostfix,
                    decorate_both: $scope.decorateBoth,
                    values_separator: $scope.valuesSeparator,
                    input_values_separator: $scope.inputValuesSeparator,

                    prettify: function(value) {
                        if (!attrs.prettify) {
                            return value;
                        }
                        return $scope.prettify({
                            value: value
                        });
                    },
                    onChange: function(a) {
                        $scope.$apply(function() {
                            $scope.from = a.from;
                            $scope.to = a.to;
                            $scope.onChange && $scope.onChange({
                                a: a
                            });
                        });
                    },
                    onFinish: function() {
                        $timeout(function() {
                            $scope.$apply($scope.onFinish);
                        });
                    },
                });
                var watchers = [];
                watchers.push($scope.$watch("min", function(value) {
                    $element.data("ionRangeSlider").update({
                        min: value
                    });
                }));
                watchers.push($scope.$watch('max', function(value) {
                    $element.data("ionRangeSlider").update({
                        max: value
                    });
                }));
                watchers.push($scope.$watch('from', function(value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_from !== value) {
                        slider.update({
                            from: value
                        });
                    }
                }));
                watchers.push($scope.$watch('to', function(value) {
                    var slider = $element.data("ionRangeSlider");
                    if (slider.old_to !== value) {
                        slider.update({
                            to: value
                        });
                    }
                }));
                watchers.push($scope.$watch('disable', function(value) {
                    $element.data("ionRangeSlider").update({
                        disable: value
                    });
                }));
            }
        };

    }]
);

!function(e){"function"==typeof define&&define.amd?define(["jquery","moment"],e):"object"==typeof exports?module.exports=e(require("jquery"),require("moment")):e(jQuery,moment)}(function(e,a){!function(){!function(){var e={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},n=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5},r={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},s=function(e){return function(a,t,s,d){var i=n(a),o=r[e][n(a)];return 2===i&&(o=o[t?0:1]),o.replace(/%d/i,a)}},d=["كانون الثاني يناير","شباط فبراير","آذار مارس","نيسان أبريل","أيار مايو","حزيران يونيو","تموز يوليو","آب أغسطس","أيلول سبتمبر","تشرين الأول أكتوبر","تشرين الثاني نوفمبر","كانون الأول ديسمبر"],i=a.defineLocale("ar",{months:d,monthsShort:d,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:s("s"),m:s("m"),mm:s("m"),h:s("h"),hh:s("h"),d:s("d"),dd:s("d"),M:s("M"),MM:s("M"),y:s("y"),yy:s("y")},preparse:function(e){return e.replace(/\u200f/g,"").replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(a){return a.replace(/\d/g,function(a){return e[a]}).replace(/,/g,"،")},week:{dow:6,doy:12}});return i}(),e.fullCalendar.datepickerLocale("ar","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ar",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})}(),function(){!function(){var e=a.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:6,doy:12}});return e}(),e.fullCalendar.datepickerLocale("ar-ma","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ar-ma",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})}(),function(){!function(){var e={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},t={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},n=a.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e,a,t){return e<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(a){return a.replace(/\d/g,function(a){return e[a]}).replace(/,/g,"،")},week:{dow:6,doy:12}});return n}(),e.fullCalendar.datepickerLocale("ar-sa","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ar-sa",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})}(),function(){!function(){var e=a.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("ar-tn","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["أحد","اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ar-tn",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى",noEventsMessage:"أي أحداث لعرض"})}(),function(){!function(){var e=a.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[В изминалата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[В изминалия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дни",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},ordinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("bg","bg",{closeText:"затвори",prevText:"&#x3C;назад",nextText:"напред&#x3E;",nextBigText:"&#x3E;&#x3E;",currentText:"днес",monthNames:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Яну","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Нов","Дек"],dayNames:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"],dayNamesShort:["Нед","Пон","Вто","Сря","Чет","Пет","Съб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Съ"],weekHeader:"Wk",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("bg",{buttonText:{month:"Месец",week:"Седмица",day:"Ден",list:"График"},allDayText:"Цял ден",eventLimitText:function(e){return"+още "+e},noEventsMessage:"Няма събития за показване"})}(),function(){!function(){var e=a.defineLocale("ca",{months:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),monthsShort:"gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"Dg_Dl_Dt_Dc_Dj_Dv_Ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd D MMMM YYYY H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"fa %s",s:"uns segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},ordinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,a){var t=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return"w"!==a&&"W"!==a||(t="a"),e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("ca","ca",{closeText:"Tanca",prevText:"Anterior",nextText:"Següent",currentText:"Avui",monthNames:["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"],monthNamesShort:["gen","feb","març","abr","maig","juny","jul","ag","set","oct","nov","des"],dayNames:["diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte"],dayNamesShort:["dg","dl","dt","dc","dj","dv","ds"],dayNamesMin:["dg","dl","dt","dc","dj","dv","ds"],weekHeader:"Set",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ca",{buttonText:{month:"Mes",week:"Setmana",day:"Dia",list:"Agenda"},allDayText:"Tot el dia",eventLimitText:"més",noEventsMessage:"No hi ha esdeveniments per mostrar"})}(),function(){!function(){function e(e){return e>1&&e<5&&1!==~~(e/10)}function t(a,t,n,r){var s=a+" ";switch(n){case"s":return t||r?"pár sekund":"pár sekundami";case"m":return t?"minuta":r?"minutu":"minutou";case"mm":return t||r?s+(e(a)?"minuty":"minut"):s+"minutami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(e(a)?"hodiny":"hodin"):s+"hodinami";case"d":return t||r?"den":"dnem";case"dd":return t||r?s+(e(a)?"dny":"dní"):s+"dny";case"M":return t||r?"měsíc":"měsícem";case"MM":return t||r?s+(e(a)?"měsíce":"měsíců"):s+"měsíci";case"y":return t||r?"rok":"rokem";case"yy":return t||r?s+(e(a)?"roky":"let"):s+"lety"}}var n="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),r="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),s=a.defineLocale("cs",{months:n,monthsShort:r,monthsParse:function(e,a){var t,n=[];for(t=0;t<12;t++)n[t]=new RegExp("^"+e[t]+"$|^"+a[t]+"$","i");return n}(n,r),shortMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(r),longMonthsParse:function(e){var a,t=[];for(a=0;a<12;a++)t[a]=new RegExp("^"+e[a]+"$","i");return t}(n),weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return s}(),e.fullCalendar.datepickerLocale("cs","cs",{closeText:"Zavřít",prevText:"&#x3C;Dříve",nextText:"Později&#x3E;",currentText:"Nyní",monthNames:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],monthNamesShort:["led","úno","bře","dub","kvě","čer","čvc","srp","zář","říj","lis","pro"],dayNames:["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"],dayNamesShort:["ne","po","út","st","čt","pá","so"],dayNamesMin:["ne","po","út","st","čt","pá","so"],weekHeader:"Týd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("cs",{buttonText:{month:"Měsíc",week:"Týden",day:"Den",list:"Agenda"},allDayText:"Celý den",eventLimitText:function(e){return"+další: "+e},noEventsMessage:"Žádné akce k zobrazení"})}(),function(){!function(){var e=a.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY HH:mm"},calendar:{sameDay:"[I dag kl.] LT",nextDay:"[I morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[I går kl.] LT",lastWeek:"[sidste] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("da","da",{closeText:"Luk",prevText:"&#x3C;Forrige",nextText:"Næste&#x3E;",currentText:"Idag",monthNames:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],dayNamesShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayNamesMin:["Sø","Ma","Ti","On","To","Fr","Lø"],weekHeader:"Uge",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("da",{buttonText:{month:"Måned",week:"Uge",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"flere",noEventsMessage:"Ingen arrangementer at vise"})}(),function(){!function(){function e(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}var t=a.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:e,mm:"%d Minuten",h:e,hh:"%d Stunden",d:e,dd:e,M:e,MM:e,y:e,yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t}(),e.fullCalendar.datepickerLocale("de","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("de",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})}(),function(){!function(){function e(e,a,t,n){var r={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?r[t][0]:r[t][1]}var t=a.defineLocale("de-at",{months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:e,mm:"%d Minuten",h:e,hh:"%d Stunden",d:e,dd:e,M:e,MM:e,y:e,yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return t}(),e.fullCalendar.datepickerLocale("de-at","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("de-at",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e},noEventsMessage:"Keine Ereignisse anzuzeigen"})}(),function(){!function(){function e(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}var t=a.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,a){return/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,a,t){return e>11?t?"μμ":"ΜΜ":t?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(a,t){var n=this._calendarEl[a],r=t&&t.hours();return e(n)&&(n=n.apply(t)),n.replace("{}",r%12===1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},ordinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}});return t}(),e.fullCalendar.datepickerLocale("el","el",{closeText:"Κλείσιμο",prevText:"Προηγούμενος",nextText:"Επόμενος",currentText:"Σήμερα",monthNames:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],monthNamesShort:["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],dayNames:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"],dayNamesShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayNamesMin:["Κυ","Δε","Τρ","Τε","Πε","Πα","Σα"],weekHeader:"Εβδ",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("el",{buttonText:{month:"Μήνας",week:"Εβδομάδα",day:"Ημέρα",list:"Ατζέντα"},allDayText:"Ολοήμερο",eventLimitText:"περισσότερα",noEventsMessage:"Δεν υπάρχουν γεγονότα για να εμφανιστεί"})}(),function(){!function(){var e=a.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th";return e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("en-au","en-AU",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("en-au")}(),function(){!function(){var e=a.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th";return e+t}});return e}(),e.fullCalendar.locale("en-ca")}(),function(){!function(){var e=a.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th";return e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("en-gb","en-GB",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("en-gb")}(),function(){!function(){var e=a.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th";return e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.locale("en-ie")}(),function(){!function(){var e=a.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"th":1===a?"st":2===a?"nd":3===a?"rd":"th";return e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("en-nz","en-NZ",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("en-nz")}(),function(){!function(){var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=a.defineLocale("es",{
months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(a,n){return/-MMM-/.test(n)?t[a.month()]:e[a.month()]},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return n}(),e.fullCalendar.datepickerLocale("es","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("es",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})}(),function(){!function(){var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),t="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=a.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(a,n){return/-MMM-/.test(n)?t[a.month()]:e[a.month()]},monthsParseExact:!0,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return n}(),e.fullCalendar.datepickerLocale("es-do","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("es-do",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más",noEventsMessage:"No hay eventos para mostrar"})}(),function(){!function(){var e=a.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("eu","eu",{closeText:"Egina",prevText:"&#x3C;Aur",nextText:"Hur&#x3E;",currentText:"Gaur",monthNames:["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua"],monthNamesShort:["urt.","ots.","mar.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe."],dayNames:["igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata"],dayNamesShort:["ig.","al.","ar.","az.","og.","ol.","lr."],dayNamesMin:["ig","al","ar","az","og","ol","lr"],weekHeader:"As",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("eu",{buttonText:{month:"Hilabetea",week:"Astea",day:"Eguna",list:"Agenda"},allDayHtml:"Egun<br/>osoa",eventLimitText:"gehiago",noEventsMessage:"Ez dago ekitaldirik erakusteko"})}(),function(){!function(){var e={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},t={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"},n=a.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e,a,t){return e<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چندین ثانیه",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return t[e]}).replace(/،/g,",")},postformat:function(a){return a.replace(/\d/g,function(a){return e[a]}).replace(/,/g,"،")},ordinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}});return n}(),e.fullCalendar.datepickerLocale("fa","fa",{closeText:"بستن",prevText:"&#x3C;قبلی",nextText:"بعدی&#x3E;",currentText:"امروز",monthNames:["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["يکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayNamesShort:["ی","د","س","چ","پ","ج","ش"],dayNamesMin:["ی","د","س","چ","پ","ج","ش"],weekHeader:"هف",dateFormat:"yy/mm/dd",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("fa",{buttonText:{month:"ماه",week:"هفته",day:"روز",list:"برنامه"},allDayText:"تمام روز",eventLimitText:function(e){return"بیش از "+e},noEventsMessage:"هیچ رویدادی به نمایش"})}(),function(){!function(){function e(e,a,n,r){var s="";switch(n){case"s":return r?"muutaman sekunnin":"muutama sekunti";case"m":return r?"minuutin":"minuutti";case"mm":s=r?"minuutin":"minuuttia";break;case"h":return r?"tunnin":"tunti";case"hh":s=r?"tunnin":"tuntia";break;case"d":return r?"päivän":"päivä";case"dd":s=r?"päivän":"päivää";break;case"M":return r?"kuukauden":"kuukausi";case"MM":s=r?"kuukauden":"kuukautta";break;case"y":return r?"vuoden":"vuosi";case"yy":s=r?"vuoden":"vuotta"}return s=t(e,r)+" "+s}function t(e,a){return e<10?a?r[e]:n[e]:e}var n="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),r=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",n[7],n[8],n[9]],s=a.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return s}(),e.fullCalendar.datepickerLocale("fi","fi",{closeText:"Sulje",prevText:"&#xAB;Edellinen",nextText:"Seuraava&#xBB;",currentText:"Tänään",monthNames:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],monthNamesShort:["Tammi","Helmi","Maalis","Huhti","Touko","Kesä","Heinä","Elo","Syys","Loka","Marras","Joulu"],dayNamesShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayNames:["Sunnuntai","Maanantai","Tiistai","Keskiviikko","Torstai","Perjantai","Lauantai"],dayNamesMin:["Su","Ma","Ti","Ke","To","Pe","La"],weekHeader:"Vk",dateFormat:"d.m.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("fi",{buttonText:{month:"Kuukausi",week:"Viikko",day:"Päivä",list:"Tapahtumat"},allDayText:"Koko päivä",eventLimitText:"lisää",noEventsMessage:"Ei tapahtumia näytettäviä"})}(),function(){!function(){var e=a.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|)/,ordinal:function(e){return e+(1===e?"er":"")},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("fr","fr",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("fr",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})}(),function(){!function(){var e=a.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|e)/,ordinal:function(e){return e+(1===e?"er":"e")}});return e}(),e.fullCalendar.datepickerLocale("fr-ca","fr-CA",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"yy-mm-dd",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("fr-ca",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})}(),function(){!function(){var e=a.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|e)/,ordinal:function(e){return e+(1===e?"er":"e")},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("fr-ch","fr-CH",{closeText:"Fermer",prevText:"&#x3C;Préc",nextText:"Suiv&#x3E;",currentText:"Courant",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sm",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("fr-ch",{buttonText:{year:"Année",month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus",noEventsMessage:"Aucun événement à afficher"})}(),function(){!function(){var e=a.defineLocale("gl",{months:"Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro".split("_"),monthsShort:"Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.".split("_"),monthsParseExact:!0,weekdays:"Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado".split("_"),weekdaysShort:"Dom._Lun._Mar._Mér._Xov._Ven._Sáb.".split("_"),weekdaysMin:"Do_Lu_Ma_Mé_Xo_Ve_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd D MMMM YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return"uns segundos"===e?"nuns segundos":"en "+e},past:"hai %s",s:"uns segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("gl","gl",{closeText:"Pechar",prevText:"&#x3C;Ant",nextText:"Seg&#x3E;",currentText:"Hoxe",monthNames:["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],monthNamesShort:["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],dayNames:["Domingo","Luns","Martes","Mércores","Xoves","Venres","Sábado"],dayNamesShort:["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"],dayNamesMin:["Do","Lu","Ma","Mé","Xo","Ve","Sá"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("gl",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Axenda"},allDayHtml:"Todo<br/>o día",eventLimitText:"máis",noEventsMessage:"Non hai eventos para amosar"})}(),function(){!function(){var e=a.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":e%10===0&&10!==e?e+" שנה":e+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(e){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(e)},meridiem:function(e,a,t){return e<5?"לפנות בוקר":e<10?"בבוקר":e<12?t?'לפנה"צ':"לפני הצהריים":e<18?t?'אחה"צ':"אחרי הצהריים":"בערב"}});return e}(),e.fullCalendar.datepickerLocale("he","he",{closeText:"סגור",prevText:"&#x3C;הקודם",nextText:"הבא&#x3E;",currentText:"היום",monthNames:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],monthNamesShort:["ינו","פבר","מרץ","אפר","מאי","יוני","יולי","אוג","ספט","אוק","נוב","דצמ"],dayNames:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת"],dayNamesShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayNamesMin:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("he",{buttonText:{month:"חודש",week:"שבוע",day:"יום",list:"סדר יום"},allDayText:"כל היום",eventLimitText:"אחר",noEventsMessage:"אין אירועים להצגה",weekNumberTitle:"שבוע"})}(),function(){!function(){var e={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},t={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},n=a.defineLocale("hi",{months:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return t[e]})},postformat:function(a){return a.replace(/\d/g,function(a){return e[a]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,a){return 12===e&&(e=0),"रात"===a?e<4?e:e+12:"सुबह"===a?e:"दोपहर"===a?e>=10?e:e+12:"शाम"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"रात":e<10?"सुबह":e<17?"दोपहर":e<20?"शाम":"रात"},week:{dow:0,doy:6}});return n}(),e.fullCalendar.datepickerLocale("hi","hi",{closeText:"बंद",prevText:"पिछला",nextText:"अगला",currentText:"आज",monthNames:["जनवरी ","फरवरी","मार्च","अप्रेल","मई","जून","जूलाई","अगस्त ","सितम्बर","अक्टूबर","नवम्बर","दिसम्बर"],monthNamesShort:["जन","फर","मार्च","अप्रेल","मई","जून","जूलाई","अग","सित","अक्ट","नव","दि"],dayNames:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],dayNamesShort:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],dayNamesMin:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],weekHeader:"हफ्ता",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("hi",{buttonText:{month:"महीना",week:"सप्ताह",day:"दिन",list:"कार्यसूची"},allDayText:"सभी दिन",eventLimitText:function(e){return"+अधिक "+e},noEventsMessage:"कोई घटनाओं को प्रदर्शित करने के लिए"})}(),function(){!function(){function e(e,a,t){var n=e+" ";switch(t){case"m":return a?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}var t=a.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",m:e,mm:e,h:e,hh:e,d:"dan",dd:e,M:"mjesec",MM:e,y:"godinu",yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("hr","hr",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthNamesShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Tje",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("hr",{buttonText:{month:"Mjesec",week:"Tjedan",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e},noEventsMessage:"Nema događaja za prikaz"})}(),function(){!function(){function e(e,a,t,n){var r=e;switch(t){case"s":return n||a?"néhány másodperc":"néhány másodperce";case"m":return"egy"+(n||a?" perc":" perce");case"mm":return r+(n||a?" perc":" perce");case"h":return"egy"+(n||a?" óra":" órája");case"hh":return r+(n||a?" óra":" órája");case"d":return"egy"+(n||a?" nap":" napja");case"dd":return r+(n||a?" nap":" napja");case"M":return"egy"+(n||a?" hónap":" hónapja");case"MM":return r+(n||a?" hónap":" hónapja");case"y":return"egy"+(n||a?" év":" éve");case"yy":return r+(n||a?" év":" éve")}return""}function t(e){return(e?"":"[múlt] ")+"["+n[this.day()]+"] LT[-kor]"}var n="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" "),r=a.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?t===!0?"de":"DE":t===!0?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return t.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return t.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return r}(),e.fullCalendar.datepickerLocale("hu","hu",{closeText:"bezár",prevText:"vissza",nextText:"előre",currentText:"ma",monthNames:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],monthNamesShort:["Jan","Feb","Már","Ápr","Máj","Jún","Júl","Aug","Szep","Okt","Nov","Dec"],dayNames:["Vasárnap","Hétfő","Kedd","Szerda","Csütörtök","Péntek","Szombat"],dayNamesShort:["Vas","Hét","Ked","Sze","Csü","Pén","Szo"],dayNamesMin:["V","H","K","Sze","Cs","P","Szo"],weekHeader:"Hét",dateFormat:"yy.mm.dd.",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),e.fullCalendar.locale("hu",{buttonText:{month:"Hónap",week:"Hét",day:"Nap",list:"Napló"},allDayText:"Egész nap",eventLimitText:"további",noEventsMessage:"Nincs megjeleníthető események"})}(),function(){!function(){var e=a.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?e>=11?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("id","id",{closeText:"Tutup",prevText:"&#x3C;mundur",nextText:"maju&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","Nopember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agus","Sep","Okt","Nop","Des"],dayNames:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"],dayNamesShort:["Min","Sen","Sel","Rab","kam","Jum","Sab"],dayNamesMin:["Mg","Sn","Sl","Rb","Km","jm","Sb"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("id",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayHtml:"Sehari<br/>penuh",eventLimitText:"lebih",noEventsMessage:"Tidak ada acara untuk ditampilkan"})}(),function(){!function(){function e(e){return e%100===11||e%10!==1}function t(a,t,n,r){var s=a+" ";switch(n){case"s":return t||r?"nokkrar sekúndur":"nokkrum sekúndum";case"m":return t?"mínúta":"mínútu";case"mm":return e(a)?s+(t||r?"mínútur":"mínútum"):t?s+"mínúta":s+"mínútu";case"hh":return e(a)?s+(t||r?"klukkustundir":"klukkustundum"):s+"klukkustund";case"d":return t?"dagur":r?"dag":"degi";case"dd":return e(a)?t?s+"dagar":s+(r?"daga":"dögum"):t?s+"dagur":s+(r?"dag":"degi");case"M":return t?"mánuður":r?"mánuð":"mánuði";case"MM":return e(a)?t?s+"mánuðir":s+(r?"mánuði":"mánuðum"):t?s+"mánuður":s+(r?"mánuð":"mánuði");case"y":return t||r?"ár":"ári";case"yy":return e(a)?s+(t||r?"ár":"árum"):s+(t||r?"ár":"ári")}}var n=a.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{
sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:t,m:t,mm:t,h:"klukkustund",hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return n}(),e.fullCalendar.datepickerLocale("is","is",{closeText:"Loka",prevText:"&#x3C; Fyrri",nextText:"Næsti &#x3E;",currentText:"Í dag",monthNames:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],dayNames:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"],dayNamesShort:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"],dayNamesMin:["Su","Má","Þr","Mi","Fi","Fö","La"],weekHeader:"Vika",dateFormat:"dd.mm.yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("is",{buttonText:{month:"Mánuður",week:"Vika",day:"Dagur",list:"Dagskrá"},allDayHtml:"Allan<br/>daginn",eventLimitText:"meira",noEventsMessage:"Engir viðburðir til að sýna"})}(),function(){!function(){var e=a.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),weekdaysShort:"Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),weekdaysMin:"Do_Lu_Ma_Me_Gi_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("it","it",{closeText:"Chiudi",prevText:"&#x3C;Prec",nextText:"Succ&#x3E;",currentText:"Oggi",monthNames:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthNamesShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],dayNames:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],dayNamesShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayNamesMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("it",{buttonText:{month:"Mese",week:"Settimana",day:"Giorno",list:"Agenda"},allDayHtml:"Tutto il<br/>giorno",eventLimitText:function(e){return"+altri "+e},noEventsMessage:"Non ci sono eventi da visualizzare"})}(),function(){!function(){var e=a.defineLocale("ja",{months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"Ah時m分",LTS:"Ah時m分s秒",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah時m分",LLLL:"YYYY年M月D日Ah時m分 dddd"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e,a,t){return e<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:"[来週]dddd LT",lastDay:"[昨日] LT",lastWeek:"[前週]dddd LT",sameElse:"L"},ordinalParse:/\d{1,2}日/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";default:return e}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}});return e}(),e.fullCalendar.datepickerLocale("ja","ja",{closeText:"閉じる",prevText:"&#x3C;前",nextText:"次&#x3E;",currentText:"今日",monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNamesShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayNamesShort:["日","月","火","水","木","金","土"],dayNamesMin:["日","月","火","水","木","金","土"],weekHeader:"週",dateFormat:"yy/mm/dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.locale("ja",{buttonText:{month:"月",week:"週",day:"日",list:"予定リスト"},allDayText:"終日",eventLimitText:function(e){return"他 "+e+" 件"},noEventsMessage:"イベントが表示されないように"})}(),function(){!function(){var e=a.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h시 m분",LTS:"A h시 m분 s초",L:"YYYY.MM.DD",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h시 m분",LLLL:"YYYY년 MMMM D일 dddd A h시 m분"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"일분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},ordinalParse:/\d{1,2}일/,ordinal:"%d일",meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e,a,t){return e<12?"오전":"오후"}});return e}(),e.fullCalendar.datepickerLocale("ko","ko",{closeText:"닫기",prevText:"이전달",nextText:"다음달",currentText:"오늘",monthNames:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],monthNamesShort:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayNames:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],dayNamesShort:["일","월","화","수","목","금","토"],dayNamesMin:["일","월","화","수","목","금","토"],weekHeader:"주",dateFormat:"yy. m. d.",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"년"}),e.fullCalendar.locale("ko",{buttonText:{month:"월",week:"주",day:"일",list:"일정목록"},allDayText:"종일",eventLimitText:"개",noEventsMessage:"일정이 표시 없습니다"})}(),function(){!function(){function e(e,a,t,n){var r={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?r[t][0]:r[t][1]}function t(e){var a=e.substr(0,e.indexOf(" "));return r(a)?"a "+e:"an "+e}function n(e){var a=e.substr(0,e.indexOf(" "));return r(a)?"viru "+e:"virun "+e}function r(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;if(e<100){var a=e%10,t=e/10;return r(0===a?t:a)}if(e<1e4){for(;e>=10;)e/=10;return r(e)}return e/=1e3,r(e)}var s=a.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:t,past:n,s:"e puer Sekonnen",m:e,mm:"%d Minutten",h:e,hh:"%d Stonnen",d:e,dd:"%d Deeg",M:e,MM:"%d Méint",y:e,yy:"%d Joer"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return s}(),e.fullCalendar.datepickerLocale("lb","lb",{closeText:"Fäerdeg",prevText:"Zréck",nextText:"Weider",currentText:"Haut",monthNames:["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonndeg","Méindeg","Dënschdeg","Mëttwoch","Donneschdeg","Freideg","Samschdeg"],dayNamesShort:["Son","Méi","Dën","Mët","Don","Fre","Sam"],dayNamesMin:["So","Mé","Dë","Më","Do","Fr","Sa"],weekHeader:"W",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("lb",{buttonText:{month:"Mount",week:"Woch",day:"Dag",list:"Terminiwwersiicht"},allDayText:"Ganzen Dag",eventLimitText:"méi",noEventsMessage:"Nee Evenementer ze affichéieren"})}(),function(){!function(){function e(e,a,t,n){return a?"kelios sekundės":n?"kelių sekundžių":"kelias sekundes"}function t(e,a,t,n){return a?r(t)[0]:n?r(t)[1]:r(t)[2]}function n(e){return e%10===0||e>10&&e<20}function r(e){return d[e].split("_")}function s(e,a,s,d){var i=e+" ";return 1===e?i+t(e,a,s[0],d):a?i+(n(e)?r(s)[1]:r(s)[0]):d?i+r(s)[1]:i+(n(e)?r(s)[1]:r(s)[2])}var d={m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"},i=a.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:e,m:t,mm:s,h:t,hh:s,d:t,dd:s,M:t,MM:s,y:t,yy:s},ordinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});return i}(),e.fullCalendar.datepickerLocale("lt","lt",{closeText:"Uždaryti",prevText:"&#x3C;Atgal",nextText:"Pirmyn&#x3E;",currentText:"Šiandien",monthNames:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],monthNamesShort:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],dayNames:["sekmadienis","pirmadienis","antradienis","trečiadienis","ketvirtadienis","penktadienis","šeštadienis"],dayNamesShort:["sek","pir","ant","tre","ket","pen","šeš"],dayNamesMin:["Se","Pr","An","Tr","Ke","Pe","Še"],weekHeader:"SAV",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),e.fullCalendar.locale("lt",{buttonText:{month:"Mėnuo",week:"Savaitė",day:"Diena",list:"Darbotvarkė"},allDayText:"Visą dieną",eventLimitText:"daugiau",noEventsMessage:"Nėra įvykių rodyti"})}(),function(){!function(){function e(e,a,t){return t?a%10===1&&a%100!==11?e[2]:e[3]:a%10===1&&a%100!==11?e[0]:e[1]}function t(a,t,n){return a+" "+e(s[n],a,t)}function n(a,t,n){return e(s[n],a,t)}function r(e,a){return a?"dažas sekundes":"dažām sekundēm"}var s={m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")},d=a.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:r,m:n,mm:t,h:n,hh:t,d:n,dd:t,M:n,MM:t,y:n,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return d}(),e.fullCalendar.datepickerLocale("lv","lv",{closeText:"Aizvērt",prevText:"Iepr.",nextText:"Nāk.",currentText:"Šodien",monthNames:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],monthNamesShort:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],dayNames:["svētdiena","pirmdiena","otrdiena","trešdiena","ceturtdiena","piektdiena","sestdiena"],dayNamesShort:["svt","prm","otr","tre","ctr","pkt","sst"],dayNamesMin:["Sv","Pr","Ot","Tr","Ct","Pk","Ss"],weekHeader:"Ned.",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("lv",{buttonText:{month:"Mēnesis",week:"Nedēļa",day:"Diena",list:"Dienas kārtība"},allDayText:"Visu dienu",eventLimitText:function(e){return"+vēl "+e},noEventsMessage:"Nav notikumu, lai parādītu"})}(),function(){!function(){var e=a.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"после %s",past:"пред %s",s:"неколку секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",M:"месец",MM:"%d месеци",y:"година",yy:"%d години"},ordinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-ев":0===t?e+"-ен":t>10&&t<20?e+"-ти":1===a?e+"-ви":2===a?e+"-ри":7===a||8===a?e+"-ми":e+"-ти"},week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("mk","mk",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Денес",monthNames:["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],dayNames:["Недела","Понеделник","Вторник","Среда","Четврток","Петок","Сабота"],dayNamesShort:["Нед","Пон","Вто","Сре","Чет","Пет","Саб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Са"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("mk",{buttonText:{month:"Месец",week:"Недела",day:"Ден",list:"График"},allDayText:"Цел ден",eventLimitText:function(e){return"+повеќе "+e},noEventsMessage:"Нема настани за прикажување"})}(),function(){!function(){var e=a.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("ms","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ms",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})}(),function(){!function(){var e=a.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?e>=11?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}});return e}(),e.fullCalendar.datepickerLocale("ms-my","ms",{closeText:"Tutup",prevText:"&#x3C;Sebelum",nextText:"Selepas&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Mac","April","Mei","Jun","Julai","Ogos","September","Oktober","November","Disember"],monthNamesShort:["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],dayNames:["Ahad","Isnin","Selasa","Rabu","Khamis","Jumaat","Sabtu"],dayNamesShort:["Aha","Isn","Sel","Rab","kha","Jum","Sab"],dayNamesMin:["Ah","Is","Se","Ra","Kh","Ju","Sa"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ms-my",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayText:"Sepanjang hari",eventLimitText:function(e){return"masih ada "+e+" acara"},noEventsMessage:"Tiada peristiwa untuk dipaparkan"})}(),function(){!function(){var e=a.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("nb","nb",{closeText:"Lukk",prevText:"&#xAB;Forrige",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["søn","man","tir","ons","tor","fre","lør"],dayNames:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],dayNamesMin:["sø","ma","ti","on","to","fr","lø"],weekHeader:"Uke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("nb",{buttonText:{month:"Måned",week:"Uke",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})}(),function(){!function(){var e="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),t="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),n=a.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(a,n){return/-MMM-/.test(n)?t[a.month()]:e[a.month()]},monthsParseExact:!0,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"Zo_Ma_Di_Wo_Do_Vr_Za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}});return n}(),e.fullCalendar.datepickerLocale("nl","nl",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("nl",{buttonText:{month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra",noEventsMessage:"Geen evenementen om te laten zien"})}(),function(){!function(){var e=a.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"sun_mån_tys_ons_tor_fre_lau".split("_"),weekdaysMin:"su_må_ty_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("nn","nn",{closeText:"Lukk",prevText:"&#xAB;Førre",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["sun","mån","tys","ons","tor","fre","lau"],dayNames:["sundag","måndag","tysdag","onsdag","torsdag","fredag","laurdag"],dayNamesMin:["su","må","ty","on","to","fr","la"],weekHeader:"Veke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("nn",{buttonText:{month:"Månad",week:"Veke",day:"Dag",list:"Agenda"},allDayText:"Heile dagen",eventLimitText:"til",noEventsMessage:"Ingen hendelser å vise"})}(),function(){!function(){function e(e){return e%10<5&&e%10>1&&~~(e/10)%10!==1}function t(a,t,n){var r=a+" ";switch(n){case"m":return t?"minuta":"minutę";case"mm":return r+(e(a)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return r+(e(a)?"godziny":"godzin");case"MM":return r+(e(a)?"miesiące":"miesięcy");case"yy":return r+(e(a)?"lata":"lat")}}var n="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),r="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),s=a.defineLocale("pl",{months:function(e,a){return""===a?"("+r[e.month()]+"|"+n[e.month()]+")":/D MMMM/.test(a)?r[e.month()]:n[e.month()]},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"nie_pon_wt_śr_czw_pt_sb".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:"[W] dddd [o] LT",lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",m:t,mm:t,h:t,hh:t,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:t,y:"rok",yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return s}(),e.fullCalendar.datepickerLocale("pl","pl",{closeText:"Zamknij",prevText:"&#x3C;Poprzedni",nextText:"Następny&#x3E;",currentText:"Dziś",monthNames:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthNamesShort:["Sty","Lu","Mar","Kw","Maj","Cze","Lip","Sie","Wrz","Pa","Lis","Gru"],dayNames:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],dayNamesShort:["Nie","Pn","Wt","Śr","Czw","Pt","So"],dayNamesMin:["N","Pn","Wt","Śr","Cz","Pt","So"],weekHeader:"Tydz",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("pl",{buttonText:{month:"Miesiąc",week:"Tydzień",day:"Dzień",list:"Plan dnia"},allDayText:"Cały dzień",eventLimitText:"więcej",noEventsMessage:"Brak wydarzeń do wyświetlenia"})}(),function(){!function(){var e=a.defineLocale("pt",{months:"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Dom_2ª_3ª_4ª_5ª_6ª_Sáb".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("pt","pt",{closeText:"Fechar",prevText:"Anterior",nextText:"Seguinte",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sem",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("pt",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Agenda"},allDayText:"Todo o dia",eventLimitText:"mais",noEventsMessage:"Não há eventos para mostrar"})}(),function(){!function(){var e=a.defineLocale("pt-br",{months:"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Dom_2ª_3ª_4ª_5ª_6ª_Sáb".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"%s atrás",s:"poucos segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº"});return e}(),e.fullCalendar.datepickerLocale("pt-br","pt-BR",{closeText:"Fechar",prevText:"&#x3C;Anterior",nextText:"Próximo&#x3E;",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],
weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("pt-br",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Compromissos"},allDayText:"dia inteiro",eventLimitText:function(e){return"mais +"+e},noEventsMessage:"Não há eventos para mostrar"})}(),function(){!function(){function e(e,a,t){var n={mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"},r=" ";return(e%100>=20||e>=100&&e%100===0)&&(r=" de "),e+r+n[t]}var t=a.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",m:"un minut",mm:e,h:"o oră",hh:e,d:"o zi",dd:e,M:"o lună",MM:e,y:"un an",yy:e},week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("ro","ro",{closeText:"Închide",prevText:"&#xAB; Luna precedentă",nextText:"Luna următoare &#xBB;",currentText:"Azi",monthNames:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthNamesShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],dayNamesShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],dayNamesMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],weekHeader:"Săpt",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ro",{buttonText:{prev:"precedentă",next:"următoare",month:"Lună",week:"Săptămână",day:"Zi",list:"Agendă"},allDayText:"Toată ziua",eventLimitText:function(e){return"+alte "+e},noEventsMessage:"Nu există evenimente de afișat"})}(),function(){!function(){function e(e,a){var t=e.split("_");return a%10===1&&a%100!==11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(a,t,n){var r={mm:t?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"};return"m"===n?t?"минута":"минуту":a+" "+e(r[n],+a)}var n=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i],r=a.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:n,longMonthsParse:n,shortMonthsParse:n,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., HH:mm",LLLL:"dddd, D MMMM YYYY г., HH:mm"},calendar:{sameDay:"[Сегодня в] LT",nextDay:"[Завтра в] LT",lastDay:"[Вчера в] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В следующее] dddd [в] LT";case 1:case 2:case 4:return"[В следующий] dddd [в] LT";case 3:case 5:case 6:return"[В следующую] dddd [в] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",m:t,mm:t,h:"час",hh:t,d:"день",dd:t,M:"месяц",MM:t,y:"год",yy:t},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночи":e<12?"утра":e<17?"дня":"вечера"},ordinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:7}});return r}(),e.fullCalendar.datepickerLocale("ru","ru",{closeText:"Закрыть",prevText:"&#x3C;Пред",nextText:"След&#x3E;",currentText:"Сегодня",monthNames:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthNamesShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],dayNames:["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],dayNamesShort:["вск","пнд","втр","срд","чтв","птн","сбт"],dayNamesMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Нед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("ru",{buttonText:{month:"Месяц",week:"Неделя",day:"День",list:"Повестка дня"},allDayText:"Весь день",eventLimitText:function(e){return"+ ещё "+e},noEventsMessage:"Нет событий для отображения"})}(),function(){!function(){function e(e){return e>1&&e<5}function t(a,t,n,r){var s=a+" ";switch(n){case"s":return t||r?"pár sekúnd":"pár sekundami";case"m":return t?"minúta":r?"minútu":"minútou";case"mm":return t||r?s+(e(a)?"minúty":"minút"):s+"minútami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?s+(e(a)?"hodiny":"hodín"):s+"hodinami";case"d":return t||r?"deň":"dňom";case"dd":return t||r?s+(e(a)?"dni":"dní"):s+"dňami";case"M":return t||r?"mesiac":"mesiacom";case"MM":return t||r?s+(e(a)?"mesiace":"mesiacov"):s+"mesiacmi";case"y":return t||r?"rok":"rokom";case"yy":return t||r?s+(e(a)?"roky":"rokov"):s+"rokmi"}}var n="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),r="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_"),s=a.defineLocale("sk",{months:n,monthsShort:r,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:t,m:t,mm:t,h:t,hh:t,d:t,dd:t,M:t,MM:t,y:t,yy:t},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});return s}(),e.fullCalendar.datepickerLocale("sk","sk",{closeText:"Zavrieť",prevText:"&#x3C;Predchádzajúci",nextText:"Nasledujúci&#x3E;",currentText:"Dnes",monthNames:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],monthNamesShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],dayNames:["nedeľa","pondelok","utorok","streda","štvrtok","piatok","sobota"],dayNamesShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],dayNamesMin:["Ne","Po","Ut","St","Št","Pia","So"],weekHeader:"Ty",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("sk",{buttonText:{month:"Mesiac",week:"Týždeň",day:"Deň",list:"Rozvrh"},allDayText:"Celý deň",eventLimitText:function(e){return"+ďalšie: "+e},noEventsMessage:"Žiadne akcie na zobrazenie"})}(),function(){!function(){function e(e,a,t,n){var r=e+" ";switch(t){case"s":return a||n?"nekaj sekund":"nekaj sekundami";case"m":return a?"ena minuta":"eno minuto";case"mm":return r+=1===e?a?"minuta":"minuto":2===e?a||n?"minuti":"minutama":e<5?a||n?"minute":"minutami":a||n?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return r+=1===e?a?"ura":"uro":2===e?a||n?"uri":"urama":e<5?a||n?"ure":"urami":a||n?"ur":"urami";case"d":return a||n?"en dan":"enim dnem";case"dd":return r+=1===e?a||n?"dan":"dnem":2===e?a||n?"dni":"dnevoma":a||n?"dni":"dnevi";case"M":return a||n?"en mesec":"enim mesecem";case"MM":return r+=1===e?a||n?"mesec":"mesecem":2===e?a||n?"meseca":"mesecema":e<5?a||n?"mesece":"meseci":a||n?"mesecev":"meseci";case"y":return a||n?"eno leto":"enim letom";case"yy":return r+=1===e?a||n?"leto":"letom":2===e?a||n?"leti":"letoma":e<5?a||n?"leta":"leti":a||n?"let":"leti"}}var t=a.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("sl","sl",{closeText:"Zapri",prevText:"&#x3C;Prejšnji",nextText:"Naslednji&#x3E;",currentText:"Trenutni",monthNames:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"],dayNamesShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayNamesMin:["Ne","Po","To","Sr","Če","Pe","So"],weekHeader:"Teden",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("sl",{buttonText:{month:"Mesec",week:"Teden",day:"Dan",list:"Dnevni red"},allDayText:"Ves dan",eventLimitText:"več",noEventsMessage:"Ni dogodkov za prikaz"})}(),function(){!function(){var e={words:{m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(a,t,n){var r=e.words[n];return 1===n.length?t?r[0]:r[1]:a+" "+e.correctGrammaticalCase(a,r)}},t=a.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){var e=["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",m:e.translate,mm:e.translate,h:e.translate,hh:e.translate,d:"dan",dd:e.translate,M:"mesec",MM:e.translate,y:"godinu",yy:e.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("sr","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("sr",{buttonText:{month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e},noEventsMessage:"Нема догађаја за приказ"})}(),function(){!function(){var e={words:{m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:e>=2&&e<=4?a[1]:a[2]},translate:function(a,t,n){var r=e.words[n];return 1===n.length?t?r[0]:r[1]:a+" "+e.correctGrammaticalCase(a,r)}},t=a.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){var e=["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",m:e.translate,mm:e.translate,h:e.translate,hh:e.translate,d:"дан",dd:e.translate,M:"месец",MM:e.translate,y:"годину",yy:e.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("sr-cyrl","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("sr-cyrl",{buttonText:{month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e},noEventsMessage:"Нема догађаја за приказ"})}(),function(){!function(){var e=a.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var a=e%10,t=1===~~(e%100/10)?"e":1===a?"a":2===a?"a":"e";return e+t},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("sv","sv",{closeText:"Stäng",prevText:"&#xAB;Förra",nextText:"Nästa&#xBB;",currentText:"Idag",monthNames:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNamesShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayNames:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],dayNamesMin:["Sö","Må","Ti","On","To","Fr","Lö"],weekHeader:"Ve",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("sv",{buttonText:{month:"Månad",week:"Vecka",day:"Dag",list:"Program"},allDayText:"Heldag",eventLimitText:"till",noEventsMessage:"Inga händelser att visa"})}(),function(){!function(){var e=a.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H นาฬิกา m นาที",LTS:"H นาฬิกา m นาที s วินาที",L:"YYYY/MM/DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H นาฬิกา m นาที",LLLL:"วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e,a,t){return e<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}});return e}(),e.fullCalendar.datepickerLocale("th","th",{closeText:"ปิด",prevText:"&#xAB;&#xA0;ย้อน",nextText:"ถัดไป&#xA0;&#xBB;",currentText:"วันนี้",monthNames:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],monthNamesShort:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],dayNames:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"],dayNamesShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayNamesMin:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("th",{buttonText:{month:"เดือน",week:"สัปดาห์",day:"วัน",list:"แผนงาน"},allDayText:"ตลอดวัน",eventLimitText:"เพิ่มเติม",noEventsMessage:"ไม่มีกิจกรรมที่จะแสดง"})}(),function(){!function(){var e={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"},t=a.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[haftaya] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen hafta] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinalParse:/\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,ordinal:function(a){if(0===a)return a+"'ıncı";var t=a%10,n=a%100-t,r=a>=100?100:null;return a+(e[t]||e[n]||e[r])},week:{dow:1,doy:7}});return t}(),e.fullCalendar.datepickerLocale("tr","tr",{closeText:"kapat",prevText:"&#x3C;geri",nextText:"ileri&#x3e",currentText:"bugün",monthNames:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthNamesShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],dayNames:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],dayNamesShort:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],dayNamesMin:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],weekHeader:"Hf",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("tr",{buttonText:{next:"ileri",month:"Ay",week:"Hafta",day:"Gün",list:"Ajanda"},allDayText:"Tüm gün",eventLimitText:"daha fazla",noEventsMessage:"Herhangi bir etkinlik görüntülemek için"})}(),function(){!function(){function e(e,a){var t=e.split("_");return a%10===1&&a%100!==11?t[0]:a%10>=2&&a%10<=4&&(a%100<10||a%100>=20)?t[1]:t[2]}function t(a,t,n){var r={mm:t?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:t?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"};return"m"===n?t?"хвилина":"хвилину":"h"===n?t?"година":"годину":a+" "+e(r[n],+a)}function n(e,a){var t={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")},n=/(\[[ВвУу]\]) ?dddd/.test(a)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(a)?"genitive":"nominative";return t[n][e.day()]}function r(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}var s=a.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:n,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:r("[Сьогодні "),nextDay:r("[Завтра "),lastDay:r("[Вчора "),nextWeek:r("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return r("[Минулої] dddd [").call(this);case 1:case 2:case 4:return r("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",m:t,mm:t,h:"годину",hh:t,d:"день",dd:t,M:"місяць",MM:t,y:"рік",yy:t},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e,a,t){return e<4?"ночі":e<12?"ранку":e<17?"дня":"вечора"},ordinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-й";case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}});return s}(),e.fullCalendar.datepickerLocale("uk","uk",{closeText:"Закрити",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Сьогодні",monthNames:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthNamesShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],dayNames:["неділя","понеділок","вівторок","середа","четвер","п’ятниця","субота"],dayNamesShort:["нед","пнд","вів","срд","чтв","птн","сбт"],dayNamesMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Тиж",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("uk",{buttonText:{month:"Місяць",week:"Тиждень",day:"День",list:"Порядок денний"},allDayText:"Увесь день",eventLimitText:function(e){return"+ще "+e+"..."},noEventsMessage:"Немає подій для відображення"})}(),function(){!function(){var e=a.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"sa":"SA":t?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần rồi lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},ordinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("vi","vi",{closeText:"Đóng",prevText:"&#x3C;Trước",nextText:"Tiếp&#x3E;",currentText:"Hôm nay",monthNames:["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"],monthNamesShort:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayNames:["Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy"],dayNamesShort:["CN","T2","T3","T4","T5","T6","T7"],dayNamesMin:["CN","T2","T3","T4","T5","T6","T7"],weekHeader:"Tu",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.locale("vi",{buttonText:{month:"Tháng",week:"Tuần",day:"Ngày",list:"Lịch biểu"},allDayText:"Cả ngày",eventLimitText:function(e){return"+ thêm "+e},noEventsMessage:"Không có sự kiện để hiển thị"})}(),function(){!function(){var e=a.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah点mm分",LTS:"Ah点m分s秒",L:"YYYY-MM-DD",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日Ah点mm分",LLLL:"YYYY年MMMD日ddddAh点mm分",l:"YYYY-MM-DD",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日Ah点mm分",llll:"YYYY年MMMD日ddddAh点mm分"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"下午"===a||"晚上"===a?e+12:e>=11?e:e+12},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:function(){return 0===this.minutes()?"[今天]Ah[点整]":"[今天]LT"},nextDay:function(){return 0===this.minutes()?"[明天]Ah[点整]":"[明天]LT"},lastDay:function(){return 0===this.minutes()?"[昨天]Ah[点整]":"[昨天]LT"},nextWeek:function(){var e,t;return e=a().startOf("week"),t=this.diff(e,"days")>=7?"[下]":"[本]",0===this.minutes()?t+"dddAh点整":t+"dddAh点mm"},lastWeek:function(){var e,t;return e=a().startOf("week"),t=this.unix()<e.unix()?"[上]":"[本]",0===this.minutes()?t+"dddAh点整":t+"dddAh点mm"},sameElse:"LL"},ordinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s内",past:"%s前",s:"几秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}});return e}(),e.fullCalendar.datepickerLocale("zh-cn","zh-CN",{closeText:"关闭",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.locale("zh-cn",{buttonText:{month:"月",week:"周",day:"日",list:"日程"},allDayText:"全天",eventLimitText:function(e){return"另外 "+e+" 个"},noEventsMessage:"没有事件显示"})}(),function(){!function(){var e=a.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah點mm分",LTS:"Ah點m分s秒",L:"YYYY年MMMD日",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日Ah點mm分",LLLL:"YYYY年MMMD日ddddAh點mm分",l:"YYYY年MMMD日",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日Ah點mm分",llll:"YYYY年MMMD日ddddAh點mm分"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,a){return 12===e&&(e=0),"凌晨"===a||"早上"===a||"上午"===a?e:"中午"===a?e>=11?e:e+12:"下午"===a||"晚上"===a?e+12:void 0},meridiem:function(e,a,t){var n=100*e+a;return n<600?"凌晨":n<900?"早上":n<1130?"上午":n<1230?"中午":n<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},ordinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";
default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}});return e}(),e.fullCalendar.datepickerLocale("zh-tw","zh-TW",{closeText:"關閉",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy/mm/dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.locale("zh-tw",{buttonText:{month:"月",week:"週",day:"天",list:"待辦事項"},allDayText:"全天",eventLimitText:"更多",noEventsMessage:"没有事件显示"})}(),a.locale("en"),e.fullCalendar.locale("en"),e.datepicker&&e.datepicker.setDefaults(e.datepicker.regional[""])});

'use strict';

/*
 * An AngularJS Localization Service
 *
 * Written by Jim Lavin
 * http://codingsmackdown.tv
 *
 */

angular.module('localization', [])
    // localization service responsible for retrieving resource files from the server and
    // managing the translation dictionary
    .provider('localize', function localizeProvider() {

        //supported languages en-GB en-US nl-NL de-DE fr-FR es-ES ja cs-CZ pl
        this.languages = ['en-GB', 'en-US', 'nl-NL', 'de-DE', 'fr-FR', 'es-ES', 'ja-JP', 'cs-CZ', 'pl-PL'];
        this.defaultLanguage = 'en-GB';
        var date = new Date().getTime();
        this.ext = 'js?' + date;
        this.baseUrl = '/assets/js/i18n/';

        var provider = this;

        this.$get = ['$http', '$rootScope', '$window', '$filter', function ($http, $rootScope, $window, $filter) {

            var localize = {
                // use the $window service to get the language of the user's browser
                language:'',
                // array to hold the localized resource string entries
                dictionary:[],
                // location of the resource file
                url: undefined,
                // flag to indicate if the service hs loaded the resource file
                resourceFileLoaded:false,

                // success handler for all server communication
                successCallback:function (data) {
                    // store the returned array in the dictionary
                    localize.dictionary = data;
                    // set the flag that the resource are loaded
                    localize.resourceFileLoaded = true;
                    // broadcast that the file has been loaded
                    $rootScope.$broadcast('localizeResourcesUpdated', data);
                },

                // allows setting of language on the fly
                setLanguage: function(value) {
                    localize.language = this.fallbackLanguage(value);
                    localize.initLocalizedResources();
                },

                fallbackLanguage: function(value) {

                    value = String(value);

                    if (provider.languages.indexOf(value) > -1) {
                        return value;
                    }

                    value = value.split('-')[0];

                    if (provider.languages.indexOf(value) > -1) {
                        return value;
                    }

                    return provider.defaultLanguage;
                },

                // allows setting of resource url on the fly
                setUrl: function(value) {
                    localize.url = value;
                    localize.initLocalizedResources();
                },
                // builds the url for locating an image
                buildImgUrl: function(imageUrl) {
                    return $http({ method: "GET", url: imageUrl, cache: false });
                },
                // builds the url for locating the resource file
                buildUrl: function(baseUrl) {
                    if(!localize.language){
                        var lang, androidLang;
                        // works for earlier version of Android (2.3.x)
                        if ($window.navigator && $window.navigator.userAgent && (androidLang = $window.navigator.userAgent.match(/android.*\W(\w\w)-(\w\w)\W/i))) {
                            lang = androidLang[1];
                        } else {
                            // works for iOS, Android 4.x and other devices
                            lang = $window.navigator.userLanguage || $window.navigator.language;
                        }
                        // set language
                        localize.language = this.fallbackLanguage(lang);
                    }
                    return baseUrl + 'resources-locale_' + localize.language + '.' + provider.ext;
                },

                // loads the language resource file from the server
                initLocalizedResources:function () {
                    // build the url to retrieve the localized resource file
                    var url = localize.url || localize.buildUrl(provider.baseUrl);
                    // request the resource file
                    $http({ method:"GET", url:url, cache:false }).success(localize.successCallback).error(function () {
                        // the request failed set the url to the default resource file
                        var url = provider.baseUrl + 'resources-locale_default' + '.' + provider.ext;

                        // request the default resource file
                        $http({ method:"GET", url:url, cache:false }).success(localize.successCallback);
                    });
                },

                // checks the dictionary for a localized resource string
                getLocalizedString: function(KEY) {
					//console.log('key', KEY)
                    // default the result to an empty string
                    var result = '';

                    // make sure the dictionary has valid data
                    if (localize.resourceFileLoaded) {
                        // use the filter service to only return those entries which match the KEY
                        // and only take the first result
                        var entry = $filter('filter')(localize.dictionary, function(element) {
                                return element.key === KEY;
                            }
                        )[0];
                        // set the result
                        result = entry.value ? entry.value : KEY;
                    }
					//console.log('result', result)
                    // return the value to the call
                    return result;
                }
            };

            // force the load of the resource file
            //localize.initLocalizedResources();

            // return the local instance when called
            return localize;
        } ];
    })
    // simple translation filter
    // usage {{ TOKEN | i18n }}
    .filter('i18n', ['localize', function (localize) {
        return function (input) {
            return localize.getLocalizedString(input);
        };
    }])
    // translation directive that can handle dynamic strings
    // updates the text value of the attached element
    // usage <span data-i18n="TOKEN" ></span>
    // or
    // <span data-i18n="TOKEN|VALUE1|VALUE2" ></span>
    .directive('i18n', ['localize', function(localize){
        var i18nDirective = {
            restrict:"EAC",
            updateText:function(elm, token, html){
                //console.log('token', token)
                //console.log('elm', elm)
                var values = token.split('|');
                if (values.length >= 1) {
                    // construct the tag to insert into the element
                    var tag = localize.getLocalizedString(values[0]);
                    // update the element only if data was returned
                    if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                        if (values.length > 1) {
                            for (var index = 1; index < values.length; index++) {
                                var target = '{' + (index - 1) + '}';
                                tag = tag.replace(target, values[index]);
                            }
                        }
                        // insert the text into the element
                        elm[html ? 'html':'text'](tag);
                    };
                }
            },

            link:function (scope, elm, attrs) {
                scope.$on('localizeResourcesUpdated', function() {
                    i18nDirective.updateText(elm, attrs.i18n, angular.isDefined(attrs.i18nHtml));
                });

                attrs.$observe('i18n', function (value) {
                    i18nDirective.updateText(elm, attrs.i18n, angular.isDefined(attrs.i18nHtml));
                });
            }
        };

        return i18nDirective;
    }])
    // translation directive that can handle dynamic strings
    // updates the attribute value of the attached element
    // usage <span data-i18n-attr="TOKEN|ATTRIBUTE" ></span>
    // or
    // <span data-i18n-attr="TOKEN|ATTRIBUTE|VALUE1|VALUE2" ></span>
    .directive('i18nAttr', ['localize', function (localize) {
        var i18NAttrDirective = {
            restrict: "EAC",
            updateText:function(elm, token){
                var values = token.split('|');
                // construct the tag to insert into the element
                var tag = localize.getLocalizedString(values[0]);
                // update the element only if data was returned
                if ((tag !== null) && (tag !== undefined) && (tag !== '')) {
                    if (values.length > 2) {
                        for (var index = 2; index < values.length; index++) {
                            var target = '{' + (index - 2) + '}';
                            tag = tag.replace(target, values[index]);
                        }
                    }
                    // insert the text into the element
                    elm.attr(values[1], tag);
                }
            },
            link: function (scope, elm, attrs) {
                scope.$on('localizeResourcesUpdated', function() {
                    i18NAttrDirective.updateText(elm, attrs.i18nAttr);
                });

                attrs.$observe('i18nAttr', function (value) {
                    i18NAttrDirective.updateText(elm, value);
                });
            }
        };

        return i18NAttrDirective;
    }])
    // translation directive that handles the localization of images.
    // usage <img data-i18n-img-src="IMAGE" />
    .directive('i18nImgSrc', [
        'localize', function(localize) {
            var i18NImageDirective = {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var i18Nsrc = attrs.i18nImgSrc;
                    var imagePath = provider.baseUrl + '/images/' + localize.language + '/';
                    var imageUrl = imagePath + i18Nsrc;
                    localize.buildImgUrl(imageUrl).success(function() {
                        element[0].src = imageUrl;
                    }).error(function() { element[0].src = provider.baseUrl + '/images/default/' + i18Nsrc; });
                }
            };
            return i18NImageDirective;
        }
    ]);

/* @license
Papa Parse
v5.3.0
https://github.com/mholt/PapaParse
License: MIT
*/
!function(e,t){"function"==typeof define&&define.amd?define([],t):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function s(){"use strict";var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=n&&/blob:/i.test((f.location||{}).protocol),a={},h=0,b={parse:function(e,t){var i=(t=t||{}).dynamicTyping||!1;U(i)&&(t.dynamicTypingFunction=i,i={});if(t.dynamicTyping=i,t.transform=!!U(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var r=function(){if(!b.WORKERS_SUPPORTED)return!1;var e=(i=f.URL||f.webkitURL||null,r=s.toString(),b.BLOB_URL||(b.BLOB_URL=i.createObjectURL(new Blob(["(",r,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var i,r;return t.onmessage=m,t.id=h++,a[t.id]=t}();return r.userStep=t.step,r.userChunk=t.chunk,r.userComplete=t.complete,r.userError=t.error,t.step=U(t.step),t.chunk=U(t.chunk),t.complete=U(t.complete),t.error=U(t.error),delete t.worker,void r.postMessage({input:e,config:t,workerId:r.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?n=t.download?new l(t):new p(t):!0===e.readable&&U(e.read)&&U(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,m=!0,_=",",v="\r\n",s='"',a=s+s,i=!1,r=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(_=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(i=t.skipEmptyLines);"string"==typeof t.newline&&(v=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(m=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");r=t.columns}void 0!==t.escapeChar&&(a=t.escapeChar+s);"boolean"==typeof t.escapeFormulae&&(o=t.escapeFormulae)}();var h=new RegExp(q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return f(null,e,i);if("object"==typeof e[0])return f(r||u(e[0]),e,i)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:u(e.data[0])),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),f(e.fields||[],e.data||[],i);throw new Error("Unable to serialize unrecognized input");function u(e){if("object"!=typeof e)return[];var t=[];for(var i in e)t.push(i);return t}function f(e,t,i){var r="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&m){for(var a=0;a<e.length;a++)0<a&&(r+=_),r+=y(e[a],a);0<t.length&&(r+=v)}for(var o=0;o<t.length;o++){var h=n?e.length:t[o].length,u=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(i&&!n&&(u="greedy"===i?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===i&&n){for(var d=[],l=0;l<h;l++){var c=s?e[l]:l;d.push(t[o][c])}u=""===d.join("").trim()}if(!u){for(var p=0;p<h;p++){0<p&&!f&&(r+=_);var g=n&&s?e[p]:p;r+=y(t[o][g],p)}o<t.length-1&&(!i||0<h&&!f)&&(r+=v)}}return r}function y(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);!0===o&&"string"==typeof e&&null!==e.match(/^[=+\-@].*$/)&&(e="'"+e);var i=e.toString().replace(h,a),r="boolean"==typeof n&&n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var i=0;i<t.length;i++)if(-1<e.indexOf(t[i]))return!0;return!1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(_)||" "===i.charAt(0)||" "===i.charAt(i.length-1);return r?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=w,b.ParserHandle=i,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var i=o.config||{},h=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)h.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},i)})}),e(),this;function e(){if(0!==h.length){var e,t,i,r,n=h[0];if(U(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,i=n.inputElem,r=s.reason,void(U(o.error)&&o.error({name:e},t,i,r));if("skip"===s.action)return void u();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void u()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){U(a)&&a(e,n.file,n.inputElem),u()},b.parse(n.file,n.instanceConfig)}else U(o.complete)&&o.complete()}function u(){h.splice(0,1),e()}}}function u(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=E(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new i(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&U(this._config.beforeFirstChunk)){var i=this._config.beforeFirstChunk(e);void 0!==i&&(e=i)}this.isFirstChunk=!1,this._halted=!1;var r=this._partialLine+e;this._partialLine="";var n=this._handle.parse(r,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=r.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(U(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!U(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0},this._sendError=function(e){U(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1})}}function l(e){var r;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),u.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(r=new XMLHttpRequest,this._config.withCredentials&&(r.withCredentials=this._config.withCredentials),n||(r.onload=y(this._chunkLoaded,this),r.onerror=y(this._chunkError,this)),r.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)r.setRequestHeader(t,e[t])}if(this._config.chunkSize){var i=this._start+this._config.chunkSize-1;r.setRequestHeader("Range","bytes="+this._start+"-"+i)}try{r.send(this._config.downloadRequestBody)}catch(e){this._chunkError(e.message)}n&&0===r.status&&this._chunkError()}},this._chunkLoaded=function(){4===r.readyState&&(r.status<200||400<=r.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:r.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(r),this.parseChunk(r.responseText)))},this._chunkError=function(e){var t=r.statusText||e;this._sendError(new Error(t))}}function c(e){var r,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),u.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((r=new FileReader).onload=y(this._chunkLoaded,this),r.onerror=y(this._chunkError,this)):r=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var i=r.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:i}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(r.error)}}function p(e){var i;u.call(this,e=e||{}),this.stream=function(e){return i=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=i.substring(0,t),i=i.substring(t)):(e=i,i=""),this._finished=!i,this.parseChunk(e)}}}function g(e){u.call(this,e=e||{});var t=[],i=!0,r=!1;this.pause=function(){u.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){u.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){r&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):i=!0},this._streamData=y(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),i&&(i=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=y(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=y(function(){this._streamCleanUp(),r=!0,this._streamData("")},this),this._streamCleanUp=y(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function i(_){var a,o,h,r=Math.pow(2,53),n=-r,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)(e[-+]?\d+)?\s*$/,u=/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,t=this,i=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(U(_.step)){var p=_.step;_.step=function(e){if(c=e,m())g();else{if(g(),0===c.data.length)return;i+=e.data.length,_.preview&&i>_.preview?o.abort():(c.data=c.data[0],p(c,t))}}}function v(e){return"greedy"===_.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){if(c&&h&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),h=!1),_.skipEmptyLines)for(var e=0;e<c.data.length;e++)v(c.data[e])&&c.data.splice(e--,1);return m()&&function(){if(!c)return;function e(e,t){U(_.transformHeader)&&(e=_.transformHeader(e,t)),l.push(e)}if(Array.isArray(c.data[0])){for(var t=0;m()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1)}else c.data.forEach(e)}(),function(){if(!c||!_.header&&!_.dynamicTyping&&!_.transform)return c;function e(e,t){var i,r=_.header?{}:[];for(i=0;i<e.length;i++){var n=i,s=e[i];_.header&&(n=i>=l.length?"__parsed_extra":l[i]),_.transform&&(s=_.transform(s,n)),s=y(n,s),"__parsed_extra"===n?(r[n]=r[n]||[],r[n].push(s)):r[n]=s}return _.header&&(i>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+i,f+t):i<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+i,f+t)),r}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);_.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function m(){return _.header&&0===l.length}function y(e,t){return i=e,_.dynamicTypingFunction&&void 0===_.dynamicTyping[i]&&(_.dynamicTyping[i]=_.dynamicTypingFunction(i)),!0===(_.dynamicTyping[i]||_.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<r)return!0}return!1}(t)?parseFloat(t):u.test(t)?new Date(t):""===t?null:t):t;var i}function k(e,t,i,r){var n={type:e,code:t,message:i};void 0!==r&&(n.row=r),c.errors.push(n)}this.parse=function(e,t,i){var r=_.quoteChar||'"';if(_.newline||(_.newline=function(e,t){e=e.substring(0,1048576);var i=new RegExp(q(t)+"([^]*?)"+q(t),"gm"),r=(e=e.replace(i,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<r[0].length;if(1===r.length||s)return"\n";for(var a=0,o=0;o<r.length;o++)"\n"===r[o][0]&&a++;return a>=r.length/2?"\r\n":"\r"}(e,r)),h=!1,_.delimiter)U(_.delimiter)&&(_.delimiter=_.delimiter(e),c.meta.delimiter=_.delimiter);else{var n=function(e,t,i,r,n){var s,a,o,h;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var u=0;u<n.length;u++){var f=n[u],d=0,l=0,c=0;o=void 0;for(var p=new w({comments:r,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(i&&v(p.data[g]))c++;else{var m=p.data[g].length;l+=m,void 0!==o?0<m&&(d+=Math.abs(m-o),o=m):o=m}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===h||h<l)&&1.99<l&&(a=d,s=f,h=l)}return{successful:!!(_.delimiter=s),bestDelimiter:s}}(e,_.newline,_.skipEmptyLines,_.comments,_.delimitersToGuess);n.successful?_.delimiter=n.bestDelimiter:(h=!0,_.delimiter=b.DefaultDelimiter),c.meta.delimiter=_.delimiter}var s=E(_);return _.preview&&_.header&&s.preview++,a=e,o=new w(s),c=o.parse(a,t,i),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=U(_.chunk)?"":a.substring(o.getCharIndex())},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,U(_.complete)&&_.complete(c),a=""}}function q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function w(e){var O,D=(e=e||{}).delimiter,I=e.newline,T=e.comments,A=e.step,L=e.preview,F=e.fastMode,z=O=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(z=e.escapeChar),("string"!=typeof D||-1<b.BAD_DELIMITERS.indexOf(D))&&(D=","),T===D)throw new Error("Comment character same as delimiter");!0===T?T="#":("string"!=typeof T||-1<b.BAD_DELIMITERS.indexOf(T))&&(T=!1),"\n"!==I&&"\r"!==I&&"\r\n"!==I&&(I="\n");var M=0,j=!1;this.parse=function(a,t,i){if("string"!=typeof a)throw new Error("Input must be a string");var r=a.length,e=D.length,n=I.length,s=T.length,o=U(A),h=[],u=[],f=[],d=M=0;if(!a)return R();if(F||!1!==F&&-1===a.indexOf(O)){for(var l=a.split(I),c=0;c<l.length;c++){if(f=l[c],M+=f.length,c!==l.length-1)M+=I.length;else if(i)return R();if(!T||f.substring(0,s)!==T){if(o){if(h=[],b(f.split(D)),S(),j)return R()}else b(f.split(D));if(L&&L<=c)return h=h.slice(0,L),R(!0)}}return R()}for(var p=a.indexOf(D,M),g=a.indexOf(I,M),m=new RegExp(q(z)+q(O),"g"),_=a.indexOf(O,M);;)if(a[M]!==O)if(T&&0===f.length&&a.substring(M,M+s)===T){if(-1===g)return R();M=g+n,g=a.indexOf(I,M),p=a.indexOf(D,M)}else{if(-1!==p&&(p<g||-1===g)){if(!(p<_)){f.push(a.substring(M,p)),M=p+e,p=a.indexOf(D,M);continue}var v=x(p,_,g);if(v&&void 0!==v.nextDelim){p=v.nextDelim,_=v.quoteSearch,f.push(a.substring(M,p)),M=p+e,p=a.indexOf(D,M);continue}}if(-1===g)break;if(f.push(a.substring(M,g)),C(g+n),o&&(S(),j))return R();if(L&&h.length>=L)return R(!0)}else for(_=M,M++;;){if(-1===(_=a.indexOf(O,_+1)))return i||u.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:h.length,index:M}),E();if(_===r-1)return E(a.substring(M,_).replace(m,O));if(O!==z||a[_+1]!==z){if(O===z||0===_||a[_-1]!==z){-1!==p&&p<_+1&&(p=a.indexOf(D,_+1)),-1!==g&&g<_+1&&(g=a.indexOf(I,_+1));var y=w(-1===g?p:Math.min(p,g));if(a[_+1+y]===D){f.push(a.substring(M,_).replace(m,O)),a[M=_+1+y+e]!==O&&(_=a.indexOf(O,M)),p=a.indexOf(D,M),g=a.indexOf(I,M);break}var k=w(g);if(a.substring(_+1+k,_+1+k+n)===I){if(f.push(a.substring(M,_).replace(m,O)),C(_+1+k+n),p=a.indexOf(D,M),_=a.indexOf(O,M),o&&(S(),j))return R();if(L&&h.length>=L)return R(!0);break}u.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:h.length,index:M}),_++}}else _++}return E();function b(e){h.push(e),d=M}function w(e){var t=0;if(-1!==e){var i=a.substring(_+1,e);i&&""===i.trim()&&(t=i.length)}return t}function E(e){return i||(void 0===e&&(e=a.substring(M)),f.push(e),M=r,b(f),o&&S()),R()}function C(e){M=e,b(f),f=[],g=a.indexOf(I,M)}function R(e){return{data:h,errors:u,meta:{delimiter:D,linebreak:I,aborted:j,truncated:!!e,cursor:d+(t||0)}}}function S(){A(R()),h=[],u=[]}function x(e,t,i){var r={nextDelim:void 0,quoteSearch:void 0},n=a.indexOf(O,t+1);if(t<e&&e<n&&(n<i||-1===i)){var s=a.indexOf(D,n);if(-1===s)return r;n<s&&(n=a.indexOf(O,n+1)),r=x(s,n,i)}else r={nextDelim:e,quoteSearch:t};return r}},this.abort=function(){j=!0},this.getCharIndex=function(){return M}}function m(e){var t=e.data,i=a[t.workerId],r=!1;if(t.error)i.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){r=!0,_(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:v,resume:v};if(U(i.userStep)){for(var s=0;s<t.results.data.length&&(i.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!r);s++);delete t.results}else U(i.userChunk)&&(i.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!r&&_(t.workerId,t.results)}function _(e,t){var i=a[e];U(i.userComplete)&&i.userComplete(t),i.terminate(),delete a[e]}function v(){throw new Error("Not implemented.")}function E(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var i in e)t[i]=E(e[i]);return t}function y(e,t){return function(){e.apply(t,arguments)}}function U(e){return"function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var i=b.parse(t.input,t.config);i&&f.postMessage({workerId:b.WORKER_ID,results:i,finished:!0})}}),(l.prototype=Object.create(u.prototype)).constructor=l,(c.prototype=Object.create(u.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(u.prototype)).constructor=g,b});
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('My.theme')
	.config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
	$provide.decorator('$uiViewScroll', uiViewScrollDecorator);
	//baConfigProvider.changeTheme({blur: true});
	//
	//baConfigProvider.changeColors({
	//  default: 'rgba(#000000, 0.2)',
	//  defaultText: '#ffffff',
	//  dashboard: {
	//    white: '#ffffff',
	//  },
	//});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
	return function (uiViewElement) {
	  if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
		$anchorScroll();
	  } else {
		$delegate(uiViewElement);
	  }
	};
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    var basic = {
        default: '#ffffff',
        defaultText: '#666666',
        border: '#dddddd',
        borderDark: '#aaaaaa',
    };

    // main functional color scheme
    var colorScheme = {
        primary: '#209e91',
        info: '#2dacd1',
        success: '#90b900',
        warning: '#dfb81c',
        danger: '#e85656',
    };

    // dashboard colors for charts
    var dashboardColors = {
        blueStone: '#005562',
        surfieGreen: '#0e8174',
        silverTree: '#6eba8c',
        gossip: '#b9f2a1',
        white: '#10c4b5',
        importance_1: '#388E3C',
        importance_2: '#FB8C00',
        importance_3: '#E53935',
    };

    angular.module('My.theme')
        .provider('baConfig', configProvider);

    /** @ngInject */
    function configProvider(colorHelper) {
        var conf = {
            theme: {
                blur: false,
            },
            colors: {
                default: basic.default,
                defaultText: basic.defaultText,
                border: basic.border,
                borderDark: basic.borderDark,

                primary: colorScheme.primary,
                info: colorScheme.info,
                success: colorScheme.success,
                warning: colorScheme.warning,
                danger: colorScheme.danger,

                primaryLight: colorHelper.tint(colorScheme.primary, 30),
                infoLight: colorHelper.tint(colorScheme.info, 30),
                successLight: colorHelper.tint(colorScheme.success, 30),
                warningLight: colorHelper.tint(colorScheme.warning, 30),
                dangerLight: colorHelper.tint(colorScheme.danger, 30),

                primaryDark: colorHelper.shade(colorScheme.primary, 15),
                infoDark: colorHelper.shade(colorScheme.info, 15),
                successDark: colorHelper.shade(colorScheme.success, 15),
                warningDark: colorHelper.shade(colorScheme.warning, 15),
                dangerDark: colorHelper.shade(colorScheme.danger, 15),

                dashboard: {
                    blueStone: dashboardColors.blueStone,
                    surfieGreen: dashboardColors.surfieGreen,
                    silverTree: dashboardColors.silverTree,
                    gossip: dashboardColors.gossip,
                    white: dashboardColors.white,
                    importance_1: dashboardColors.importance_1,
                    importance_2: dashboardColors.importance_2,
                    importance_3: dashboardColors.importance_3,
                },
            }
        };

        conf.changeTheme = function (theme) {
            angular.merge(conf.theme, theme)
        };

        conf.changeColors = function (colors) {
            angular.merge(conf.colors, colors)
        };

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('My.theme')
	.constant('layoutSizes', {
	  resWidthCollapseSidebar: 1200,
	  resWidthHideSidebar: 500
	})
	.constant('layoutPaths', {
	  images: {
		root: IMAGES_ROOT,
		profile: IMAGES_ROOT + 'app/profile/',
		amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
		amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
	  }
	})
	.constant('colorHelper', {
	  tint: function(color, weight) {
		return mix('#ffffff', color, weight);
	  },
	  shade: function(color, weight) {
		return mix('#000000', color, weight);
	  },
	});

  function shade(color, weight) {
	return mix('#000000', color, weight);
  }

  function tint(color, weight) {
	return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
	// convert a decimal value to hex
	function d2h(d) {
	  return d.toString(16);
	}
	// convert a hex value to decimal
	function h2d(h) {
	  return parseInt(h, 16);
	}

	var result = "#";
	for(var i = 1; i < 7; i += 2) {
	  var color1Part = h2d(color1.substr(i, 2));
	  var color2Part = h2d(color2.substr(i, 2));
	  var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
	  result += ('0' + resultPart).slice(-2);
	}
	return result;
  }
})();

(function () {
    'use strict';

    angular.module('My.theme')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
        var whatToWait = [
        preloader.getUserTeamHerdAccess(),
        preloader.setLanguage(),
      $timeout(2000)
    ];

        $q.all(whatToWait).then(function () {
            $rootScope.$pageFinishedLoading = true;
        });

        $timeout(function () {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 90000);

        $rootScope.$baSidebarService = baSidebarService;
    }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('My.theme')
	.service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
	var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
	var mobileClass = isMobile ? 'mobile' : '';
	var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
	angular.element(document.body).addClass(mobileClass).addClass(blurClass);

	return {
	  blur: baConfig.theme.blur,
	  mobile: isMobile,
	}
  }

})();

(function () {
    'use strict';
    angular.module('My.pages').factory('appService', appService);
    /** @ngInject */
    function appService() {
        return {
           round: round,
           groupBy: groupBy
        }

        function round(value, decimals) {
			if (value && !isNaN(value)) {
				return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
			} else {
				return 0;
			}
		}

        function groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		}
      
    }
})();

/** 
* @version 2.1.9
* @license MIT
*/
!function(t,e){"use strict";t.module("smart-table",[]).run(["$templateCache",function(t){t.put("template/smart-table/pagination.html",'<nav ng-if="numPages && pages.length >= 2"><ul class="pagination"><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a href="#" ng-click="selectPage(page); $event.preventDefault(); $event.stopPropagation();">{{page}}</a></li></ul></nav>')}]),t.module("smart-table").constant("stConfig",{pagination:{template:"template/smart-table/pagination.html",itemsByPage:10,displayedPages:5},search:{delay:400,inputEvent:"input"},select:{mode:"single",selectedClass:"st-selected"},sort:{ascentClass:"st-sort-ascent",descentClass:"st-sort-descent",descendingFirst:!1,skipNatural:!1,delay:300},pipe:{delay:100}}),t.module("smart-table").controller("stTableController",["$scope","$parse","$filter","$attrs",function(e,a,n,s){function i(t){return t?[].concat(t):[]}function r(){h=i(c(e)),!0===v&&P.pipe()}function l(t,e){if(-1!=e.indexOf(".")){var n=e.split("."),s=n.pop(),i=n.join("."),r=a(i)(t);delete r[s],0==Object.keys(r).length&&l(t,i)}else delete t[e]}var c,o,u,p=s.stTable,g=a(p),d=g.assign,f=n("orderBy"),m=n("filter"),h=i(g(e)),b={sort:{},search:{},pagination:{start:0,totalItemCount:0}},v=!0,P=this;s.stSafeSrc&&(c=a(s.stSafeSrc),e.$watch(function(){var t=c(e);return t&&t.length?t[0]:void 0},function(t,e){t!==e&&r()}),e.$watch(function(){var t=c(e);return t?t.length:0},function(t,e){t!==h.length&&r()}),e.$watch(function(){return c(e)},function(t,e){t!==e&&(b.pagination.start=0,r())})),this.sortBy=function(e,a){return b.sort.predicate=e,b.sort.reverse=!0===a,t.isFunction(e)?b.sort.functionName=e.name:delete b.sort.functionName,b.pagination.start=0,this.pipe()},this.search=function(e,n,s){var i=b.search.predicateObject||{},r=n||"$";return e=t.isString(e)?e.trim():e,a(r).assign(i,e),e||l(i,r),b.search.predicateObject=i,b.pagination.start=0,this.pipe()},this.pipe=function(){var t,a=b.pagination;o=b.search.predicateObject?m(h,b.search.predicateObject):h,b.sort.predicate&&(o=f(o,b.sort.predicate,b.sort.reverse)),a.totalItemCount=o.length,void 0!==a.number&&(a.numberOfPages=o.length>0?Math.ceil(o.length/a.number):1,a.start=a.start>=o.length?(a.numberOfPages-1)*a.number:a.start,t=o.slice(a.start,a.start+parseInt(a.number))),d(e,t||o)},this.select=function(t,a){var n=i(g(e)),s=n.indexOf(t);-1!==s&&("single"===a?(t.isSelected=!0!==t.isSelected,u&&(u.isSelected=!1),u=!0===t.isSelected?t:void 0):n[s].isSelected=!n[s].isSelected)},this.slice=function(t,e){return b.pagination.start=t,b.pagination.number=e,this.pipe()},this.tableState=function(){return b},this.getFilteredCollection=function(){return o||h},this.setFilterFunction=function(t){m=n(t)},this.setSortFunction=function(t){f=n(t)},this.preventPipeOnWatch=function(){v=!1}}]).directive("stTable",function(){return{restrict:"A",controller:"stTableController",link:function(t,e,a,n){a.stSetFilter&&n.setFilterFunction(a.stSetFilter),a.stSetSort&&n.setSortFunction(a.stSetSort)}}}),t.module("smart-table").directive("stSearch",["stConfig","$timeout","$parse",function(t,e,a){return{require:"^stTable",link:function(n,s,i,r){var l=r,c=null,o=i.stDelay||t.search.delay,u=i.stInputEvent||t.search.inputEvent;i.$observe("stSearch",function(t,e){var a=s[0].value;t!==e&&a&&(r.tableState().search={},l.search(a,t))}),n.$watch(function(){return r.tableState().search},function(t,e){var n=i.stSearch||"$";t.predicateObject&&a(n)(t.predicateObject)!==s[0].value&&(s[0].value=a(n)(t.predicateObject)||"")},!0),s.bind(u,function(t){t=t.originalEvent||t,null!==c&&e.cancel(c),c=e(function(){l.search(t.target.value,i.stSearch||""),c=null},o)})}}}]),t.module("smart-table").directive("stSelectRow",["stConfig",function(t){return{restrict:"A",require:"^stTable",scope:{row:"=stSelectRow"},link:function(e,a,n,s){var i=n.stSelectMode||t.select.mode;a.bind("click",function(){e.$apply(function(){s.select(e.row,i)})}),e.$watch("row.isSelected",function(e){!0===e?a.addClass(t.select.selectedClass):a.removeClass(t.select.selectedClass)})}}}]),t.module("smart-table").directive("stSort",["stConfig","$parse","$timeout",function(e,a,n){return{restrict:"A",require:"^stTable",link:function(s,i,r,l){function c(){b?g=0===g?2:g-1:g++;var e;u=t.isFunction(p(s))||t.isArray(p(s))?p(s):r.stSort,g%3==0&&!0!=!!h?(g=0,l.tableState().sort={},l.tableState().pagination.start=0,e=l.pipe.bind(l)):e=l.sortBy.bind(l,u,g%2==0),null!==v&&n.cancel(v),P<0?e():v=n(function(){e()},P)}var o,u=r.stSort,p=a(u),g=0,d=r.stClassAscent||e.sort.ascentClass,f=r.stClassDescent||e.sort.descentClass,m=[d,f],h=void 0!==r.stSkipNatural?r.stSkipNatural:e.sort.skipNatural,b=void 0!==r.stDescendingFirst?r.stDescendingFirst:e.sort.descendingFirst,v=null,P=r.stDelay||e.sort.delay;r.stSortDefault&&(o=void 0!==s.$eval(r.stSortDefault)?s.$eval(r.stSortDefault):r.stSortDefault),i.bind("click",function(){u&&s.$apply(c)}),o&&(g="reverse"===o?1:0,c()),s.$watch(function(){return l.tableState().sort},function(t){t.predicate!==u?(g=0,i.removeClass(d).removeClass(f)):(g=!0===t.reverse?2:1,i.removeClass(m[g%2]).addClass(m[g-1]))},!0)}}}]),t.module("smart-table").directive("stPagination",["stConfig",function(t){return{restrict:"EA",require:"^stTable",scope:{stItemsByPage:"=?",stDisplayedPages:"=?",stPageChange:"&"},templateUrl:function(e,a){return a.stTemplate?a.stTemplate:t.pagination.template},link:function(e,a,n,s){function i(){var t,a,n=s.tableState().pagination,i=1,r=e.currentPage;for(e.totalItemCount=n.totalItemCount,e.currentPage=Math.floor(n.start/n.number)+1,(t=(i=Math.max(i,e.currentPage-Math.abs(Math.floor(e.stDisplayedPages/2))))+e.stDisplayedPages)>n.numberOfPages&&(t=n.numberOfPages+1,i=Math.max(1,t-e.stDisplayedPages)),e.pages=[],e.numPages=n.numberOfPages,a=i;a<t;a++)e.pages.push(a);r!==e.currentPage&&e.stPageChange({newPage:e.currentPage})}e.stItemsByPage=e.stItemsByPage?+e.stItemsByPage:t.pagination.itemsByPage,e.stDisplayedPages=e.stDisplayedPages?+e.stDisplayedPages:t.pagination.displayedPages,e.currentPage=1,e.pages=[],e.$watch(function(){return s.tableState().pagination},i,!0),e.$watch("stItemsByPage",function(t,a){t!==a&&e.selectPage(1)}),e.$watch("stDisplayedPages",i),e.selectPage=function(t){t>0&&t<=e.numPages&&s.slice((t-1)*e.stItemsByPage,e.stItemsByPage)},s.tableState().pagination.number||s.slice(0,e.stItemsByPage)}}}]),t.module("smart-table").directive("stPipe",["stConfig","$timeout",function(e,a){return{require:"stTable",scope:{stPipe:"="},link:{pre:function(n,s,i,r){var l=null;t.isFunction(n.stPipe)&&(r.preventPipeOnWatch(),r.pipe=function(){return null!==l&&a.cancel(l),l=a(function(){n.stPipe(r.tableState(),r)},e.pipe.delay)})},post:function(t,e,a,n){n.pipe()}}}}])}(angular);


/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
	  .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
	angular.extend(toastrConfig, {
	  closeButton: true,
	  closeHtml: '<button>&times;</button>',
	  timeOut: 5000,
	  autoDismiss: false,
	  containerId: 'toast-container',
	  maxOpened: 0,
	  newestOnTop: true,
	  positionClass: 'toast-top-right',
	  preventDuplicates: false,
	  preventOpenDuplicates: false,
	  target: 'body'
	});
  }
})();

(function () {
    'use strict';
  
    angular.module('My.theme')
        .filter('gender', gender);
  
    /** @ngInject */
    function gender() {
      return function(gender_code) {
        if(gender_code == 1){
          return '_animal_breed_male_short_';
        }else{
          return '_animal_breed_female_short_';
        }
      };
    }
  
  })();

(function () {
    'use strict';
  
    angular.module('My.theme')
        .filter('unique', unique);
  
    /** @ngInject */
    function unique(layoutPaths) {
        return function(collection, keyname) {
            var output = [],
              keys = [];
        
            angular.forEach(collection, function(item) {
              var key = item[keyname];
              if (keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
              }
            });
            return output;
          };
    }
  
  })();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
	return {
	  link: function (scope, element) {
		$timeout(function () {
		  var newValue = element.attr('new-value');
		  var oldvalue = parseInt(element.html());

		  function changeValue(val) {
			$timeout(function () {
			  element.html(val);
			}, 30);
		  }

		  if (newValue > oldvalue) {
			for (var i = oldvalue; i <= newValue; i++) {
			  changeValue(i);
			}
		  } else {
			for (var j = oldvalue; j >= newValue; j--) {
			  changeValue(j);
			}
		  }
		  $timeout(function () {
			element.next().find('i').addClass('show-arr');
		  }, 500);
		}, 3500);
	  }
	};
  }

})();

/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
	return {
	  restrict: 'A',
	  link: function ($scope, elem) {
		elem.bind('keydown', function ($event) {
		  var element = $event.target;
		  $(element).height(0);
		  var height = $(element)[0].scrollHeight;
		  height = (height < 16) ? 16 : height;
		  $(element).height(height);
		});

		// Expand the textarea as soon as it is added to the DOM
		setTimeout(function () {
		  var element = elem;
		  $(element).height(0);
		  var height = $(element)[0].scrollHeight;
		  height = (height < 16) ? 16 : height;
		  $(element).height(height);
		}, 0)
	  }
	};
  }

})();

(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
	return {
	  link: function (scope, element, attrs) {
		var model = $parse(attrs.autoFocus);
		scope.$watch(model, function (value) {
		  if (value === true) {
			$timeout(function () {
			  element[0].focus();
			  element[0].select();
			});
		  }
		});
		element.bind('blur', function () {
		  scope.$apply(model.assign(scope, false));
		});
	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
	return {
	  restrict: 'AE',
	  templateUrl: function(ele, attrs) {
		return attrs.includeWithScope;
	  }
	};
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	.directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
	return {
	  restrict: 'EA',
	  template: '<div></div>',
	  replace: true,
	  scope: {
		min: '=',
		max: '=',
		type: '@',
		prefix: '@',
		maxPostfix: '@',
		prettify: '=',
		prettifySeparator: '@',
		grid: '=',
		gridMargin: '@',
		postfix: '@',
		step: '@',
		hideMinMax: '@',
		hideFromTo: '@',
		from: '=',
		to: '=',
		disable: '=',
		onChange: '=',
		onFinish: '=',
		values: '=',
		timeout: '@'
	  },
	  link: function ($scope, $element) {
			$element.ionRangeSlider({
			  min: $scope.min,
			  max: $scope.max,
			  type: $scope.type,
			  prefix: $scope.prefix,
			  maxPostfix: $scope.maxPostfix,
			  prettify_enabled: $scope.prettify,
			  prettify_separator: $scope.prettifySeparator,
			  grid: $scope.grid,
			  gridMargin: $scope.gridMargin,
			  postfix: $scope.postfix,
			  step: $scope.step,
			  hideMinMax: $scope.hideMinMax,
			  hideFromTo: $scope.hideFromTo,
			  from: $scope.from,
			  to: $scope.to,
			  disable: $scope.disable,
			  onChange: $scope.onChange,
			  onFinish: $scope.onFinish,
			  values: $scope.values
			});

			$scope.$watch('min', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({min: value});
			  });
			}, true);
			$scope.$watch('max', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({max: value});
			  });
			});
			$scope.$watch('from', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({from: value});
			  });
			});
			$scope.$watch('to', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({to: value});
			  });
			});
			$scope.$watch('disable', function (value) {
			  $timeout(function () {
				$element.data("ionRangeSlider").update({disable: value});
			  });
			});
	  }
	};
  }

})();

/*
** lazy-scroll v1.00
** (c) shabeeb
** mail@shabeebk.com
* shabeebk.com/blog/lazy-scroll-infinite-scrolling-angularjs
*
*/
angular.module("lazy-scroll",[]).directive("lazyScroll",["$rootScope","$window",function(l,o){return{link:function(l,r,n){var e,i,c=.9,e=!0;o=angular.element(o),null!=n.lazyNoScroll&&l.$watch(n.lazyNoScroll,function(l){e=1==l?!1:!0}),void 0!=n.lazyScrollTrigger&&n.lazyScrollTrigger>0&&n.lazyScrollTrigger<100&&(c=n.lazyScrollTrigger/100),i=function(){var o=window.pageYOffset,r=window.document.body.clientHeight,i=window.innerHeight,a=o/(r-i);return e&&a>=c?l.$apply(n.lazyScroll):void 0},o.on("scroll",i),l.$on("$destroy",function(){return o.off("scroll",i)})}}}]);

(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
	return {
	  link: function ($scope, el) {
		el.bind('change', function (e) {
		  $scope.file = (e.srcElement || e.target).files[0];
		  $scope.getFile();
		})
	  }
	}
  }

})();

angular.module('My.theme').directive('execOnScrollToTop', function () {
    return {
        scope: {
            onTop: '&onTop'
        }
        , link: function (scope, element, attrs) {
            $(window).on('scroll', function (e) {
                if ($(window).scrollTop() == 0) {
                    scope.onTop();
                }
            });

            scope.$on('$destroy', function(){
                $(window).off('scroll');
            })
        }
    };
});



(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
	return {
	  scope: {
		scrollPosition: '=',
		maxHeight: '='
	  },
	  link: function (scope) {
		$(window).on('scroll', function() {
		  var scrollTop = $(window).scrollTop() > scope.maxHeight;
		  if (scrollTop !== scope.prevScrollTop) {
			scope.$apply(function() {
			  scope.scrollPosition = scrollTop;
			});
		  }
		  scope.prevScrollTop = scrollTop;
		});
	  }
	};
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.pages')
	  .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
	return {
	  restrict: 'A',
	  require: '?ngOptions',
	  priority: 1500, // make priority bigger than ngOptions and ngRepeat
	  link: {
		pre: function(scope, elem, attrs) {
		  elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
		},
		post: function(scope, elem, attrs) {
		  function refresh() {
			elem.selectpicker('refresh');
		  }

		  if (attrs.ngModel) {
			scope.$watch(attrs.ngModel, refresh);
		  }

		  if (attrs.ngDisabled) {
			scope.$watch(attrs.ngDisabled, refresh);
		  }

		  elem.selectpicker({ dropupAuto: false, hideDisabled: true });
		}
	  }
	};
  }


})();

(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
	return {
	  scope: {
		trackWidth: '=',
		minWidth: '=',
	  },
	  link: function (scope, element) {
		scope.trackWidth = $(element).width() < scope.minWidth;
		scope.prevTrackWidth = scope.trackWidth;

		$(window).resize(function() {
		  var trackWidth = $(element).width() < scope.minWidth;
		  if (trackWidth !== scope.prevTrackWidth) {
			scope.$apply(function() {
			  scope.trackWidth = trackWidth;
			});
		  }
		  scope.prevTrackWidth = trackWidth;
		});
	  }
	};
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
	return {
	  restrict: 'A',
	  link: function ($scope, elem) {
		var delay = 1000;

		if ($rootScope.$pageFinishedLoading) {
		  delay = 100;
		}

		$timeout(function () {
		  elem.removeClass('full-invisible');
		  elem.addClass('animated zoomIn');
		}, delay);
	  }
	};
  }

})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
	'use strict';

	angular.module('My.theme')
		.factory('baProgressModal', baProgressModal);

	/** @ngInject */
	function baProgressModal($uibModal) {
		var methods = {};
		var progress = 0;
		var max = 100;
		var opened = false;

		return {
			setProgress: function (value) {
				if (value > max) {
					throw Error('Progress can\'t be greater than max');
				}
				progress = value;
			},
			getProgress: function () {
				return progress;
			},
			open: function() {
				if (!opened) {
					methods = $uibModal.open({
						animation: true,
						templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
						size: 'sm',
						keyboard: false,
						backdrop: 'static'
					});
					opened = true;
				} else {
					throw Error('Progress modal opened now');
				}

			},
			close: function() {
				if (opened) {
					methods.close();
					opened = false;
				} else {
					throw Error('Progress modal is not active');
				}

			}
		};
	}

})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

	this.isDescendant = function(parent, child) {
	  var node = child.parentNode;
	  while (node != null) {
		if (node == parent) {
		  return true;
		}
		node = node.parentNode;
	  }
	  return false;
	};

	this.hexToRGB = function(hex, alpha) {
	  var r = parseInt( hex.slice(1,3), 16 );
	  var g = parseInt( hex.slice(3,5), 16 );
	  var b = parseInt( hex.slice(5,7), 16 );
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	};

	this.hasAttr = function (elem, attrName) {
	  var attr = $(elem).attr(attrName);
	  return (typeof attr !== typeof undefined && attr !== false);
	}
  }
})();

(function () {
	'use strict';
	angular.module('My.theme').provider('bugsnagService', bugsnagService);

	/** @ngInject */
	function bugsnagService() {
		var bugsnagClient;
		var jwtHelper;
		var testEnv = false;

		this.load = load;

		this.$get = function ($injector) {
			if (!jwtHelper) {
				jwtHelper = $injector.get('jwtHelper');
			}
			return {
				logMessage: logMessage,
				logError: logError,
				logUnhandledError: logUnhandledError
			};
		};

		function load() {
			try {
				bugsnagClient = Bugsnag.start({
					apiKey: '24ce9d356b0a5cc8138b7d7409f81ccc',
					releaseStage: 'MY-MmmooOgle',
					redactedKeys: [
						'access_token',
						/^authorization$/i
					  ]
				});
				console.log('Bugsnag is loaded');
			} catch (e) {
				console.log('Bugsnag failed to load');
				console.error(e);
			}
		}

		function logMessage(message) {
			try {
				if (bugsnagClient) {
					var user = setClientId();
					bugsnagClient.notify(message.message, function (event) {
						event.severity = message.severity ? message.severity : 'info';
						event.setUser(user);
						for (var prop in message.metaData) {
							event.addMetadata(prop, message.metaData[prop]);
						}
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function logError(error) {
			try {
				if (bugsnagClient) {
					var user = setClientId();
					bugsnagClient.notify(new Error('Resonse error log'), function (event) {
						event.severity = setSeverity(error);
						event.setUser(user);
						event.addMetadata('error', {
							staus: error.status,
							data: error.data,
							url: error.config.url
						});
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function logUnhandledError(error) {
			try {
				if (bugsnagClient) {
					var user = setClientId();
					bugsnagClient.notify(new Error('Unhandled error'), function (event) {
						event.severity = setSeverity(error);
						event.setUser(user);
						event.addMetadata('error', {
							error: error
						});
					});
					return true;
				}
			} catch (e) {
				console.error(e);
				return false;
			}
		}

		function setClientId() {
			try {
				var user = JSON.parse(localStorage.getItem('user_profile'));
				if (user) {
					return user.user_id;
				} else {
					return 'User id not available';
				}
			} catch (e) {
				console.error(e);
				return 'User id not available';
			}
		}

		function setSeverity(error) {
			return error.status === 401 || error.status === 403 ? 'info' : 'warning';
		}
	}
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
	var onLoad = function(reader, deferred, scope) {
	  return function () {
		scope.$apply(function () {
		  deferred.resolve(reader.result);
		});
	  };
	};

	var onError = function (reader, deferred, scope) {
	  return function () {
		scope.$apply(function () {
		  deferred.reject(reader.result);
		});
	  };
	};

	var onProgress = function(reader, scope) {
	  return function (event) {
		scope.$broadcast('fileProgress',
			{
			  total: event.total,
			  loaded: event.loaded
			});
	  };
	};

	var getReader = function(deferred, scope) {
	  var reader = new FileReader();
	  reader.onload = onLoad(reader, deferred, scope);
	  reader.onerror = onError(reader, deferred, scope);
	  reader.onprogress = onProgress(reader, scope);
	  return reader;
	};

	var readAsDataURL = function (file, scope) {
	  var deferred = $q.defer();

	  var reader = getReader(deferred, scope);
	  reader.readAsDataURL(file);

	  return deferred.promise;
	};

	return {
	  readAsDataUrl: readAsDataURL
	};
  }
})();

(function () {
  "use strict";
  angular.module("My.theme").service("preloader", preloader);
  /** @ngInject */
  function preloader(
    $q,
    $timeout,
    authManager,
    isFarmerService,
    $state,
    localize,
    tmhDynamicLocale,
    $cookies,
    $rootScope,
    $http,
    permissionService,
    $interval,
    APP_CONSTANTS,
    cookiesService,
    auth0Service
  ) {
    return {
      getUserTeamHerdAccess: function () {
        console.log('preloader');
        
        var MYPermission = 14;
        var d = $q.defer();
        var id_token = localStorage.getItem("id_token");
        var user_profile = localStorage.getItem("user_profile");
        if (id_token && user_profile) {
          var url = APP_CONSTANTS.backoffice_base_url + "userpermissions";
          $http
            .get(url)
            .then(function (response) {
              var permissions = response.data.Teams;
              if (response.data.IsGlobalAdmin) {
                permissionService.isGlobalAdmin = true;
                getTeams();
              } else {
                permissionService.isGlobalAdmin = false;
                processPermissions(response.data.Teams);
              }
            })
            .catch(function (error) {
              authManager.unauthenticate();
              auth0Service.handleUnauthorized(500);
            });
        } else {
          d.resolve();
        }
        return d.promise;

        function processPermissions(permissions) {
          var haveMyPermissions = false;
          permissionService.permissions = permissions;
          for (var i = 0; i < permissions.length; i++) {
            for (var j = 0; j < permissions[i].Permissions.length; j++) {
              if (permissions[i].Permissions[j] == MYPermission) {
                haveMyPermissions = true;
                break;
              }
            }
          }
          if (haveMyPermissions) {
            var expireDate = moment();
            expireDate.add(10, "hours");
            expireDate = new Date(expireDate);
            cookiesService.setCookie(
              "mmmooogle_token",
              localStorage.getItem("id_token"),
              {
                samesite: "lax",
                //samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              }
            );
            var house_style = permissionService.getHouseStyle();
            if(house_style){
              localStorage.setItem('style', house_style);
              
            }
            var teamsWithPermissionToAccess = generateTeamsWPTA(permissions);
            authorizePermissionsTeams(
              teamsWithPermissionToAccess,
              JSON.parse(user_profile)
            );
          } else {
            authManager.unauthenticate();
            auth0Service.handleUnauthorized(500);
          }
        }

        function generateTeamsWPTA(permissions) {
          var list = [];
          var spartanList = [];
          // create teams list
          for (var i = 0; i < permissions.length; i++) {
            for (var j = 0; j < permissions[i].Permissions.length; j++) {
              if (permissions[i].Permissions[j] == MYPermission) {
                spartanList.push(permissions[i].TeamId);
              }
            }
          }
          return spartanList;
        }

        function authorizePermissionsTeams(teams, profile) {
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 365);
          permissionService.teams = teams;
          var cookie;
          var cookies = $cookies.getAll();
          Object.keys(cookies).forEach(function (key) {
            if (key == profile.email) {
              cookie = JSON.parse(cookies[key]);
            }
          });
          if (cookie && cookie.team_id) {
            if (cookie.filterDH == null || cookie.filterDH == undefined) {
              cookie.filterDH = true;
            }
            var has_team_permission = false;
            var team_with_permission = {};
            for (var i = 0; i < teams.length; i++) {
              if (teams[i] == cookie.team_id) {
                has_team_permission = true;
                team_with_permission = teams[i];
                break;
              }
            }
            cookie.herd_ids = [];
            cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
              samesite: "strict",
              expires: expireDate,
            });
            if (has_team_permission) {
              localStorage.setItem("default_values", JSON.stringify(cookie));
              cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
                samesite: "lax",
                //samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
              });
            } else {
              cookie.team_id = null;
              cookie.herd_ids = [];
            }
          } else {
            cookie = {
              team_id: teams[0],
              herd_ids: [],
              filterDH: true,
              DNSAL: [],
            };
            cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
              samesite: "strict",
              expires: expireDate,
            });
            localStorage.setItem("default_values", JSON.stringify(cookie));
            cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
              samesite: "lax",
              //samesite: "none",
              secure: true,
              domain: ".mmmooogle.com",
            });
          }
          d.resolve();
        }

        function getTeams() {
          var permissions = [];
          for (var i = 0; i < 700; i++) {
            permissions.push(i);
          }
          return $http
            .get(APP_CONSTANTS.backoffice_base_url + "teams")
            .then(function (response) {
              var teams = [];
              for (var i = 0; i < response.data.length; i++) {
                var team = {
                  TeamId: response.data[i].Id,
                  Permissions: permissions,
                };
                teams.push(team);
              }
              processPermissions(teams);
            })
            .catch(function (error) {
              authManager.unauthenticate();
              auth0Service.handleUnauthorized(500);
            });
        }
      },
      setLanguage: function () {
        var d = $q.defer();
        var userLang = navigator.language || navigator.userLanguage;
        userLang = userLang.toLowerCase();
        var user = JSON.parse(localStorage.getItem("user_profile"));
        var name = (user ? user.email : "unknown").concat("_lng");
        var lng_cookie = $cookies.getObject(name);
        var languages = APP_CONSTANTS.constants.languages;
        var lng;
        if (lng_cookie && lng_cookie != "auto") {
          var lng_index = languages.findIndex(function (item) {
            return item.code == lng_cookie;
          });

          if (lng_index != -1) {
            lng = lng_cookie;
          }
        }

        if (!lng) {
          if (userLang.indexOf("en") != -1) {
            if (userLang == "en-gb") {
              lng = "en-GB";
            } else if (userLang == "en-us") {
              lng = "en-US";
            } else {
              lng = "en-GB";
            }
          } else if (userLang.indexOf("nl") != -1) {
            if (userLang == "nl-nl") {
              lng = "nl-NL";
            } else {
              lng = "nl-NL";
            }
          } else if (userLang.indexOf("de") != -1) {
            if (userLang == "de-de") {
              lng = "de-DE";
            } else {
              lng = "de-DE";
            }
          } else if (userLang.indexOf("fr") != -1) {
            if (userLang == "fr-fr") {
              lng = "fr-FR";
            } else {
              lng = "fr-FR";
            }
          } else if (userLang.indexOf("es") != -1) {
            if (userLang == "es-es") {
              lng = "es-ES";
            } else {
              lng = "es-ES";
            }
          } else if (userLang.indexOf("ja") != -1) {
            lng = "ja-JP";
          } else if (userLang.indexOf("pl") != -1) {
            lng = "pl-PL";
          } else if (userLang.indexOf("cs") != -1) {
            lng = "cs-CZ";
          } else {
            lng = "en-GB";
          }
        }
        localize.setLanguage(lng);
        tmhDynamicLocale.set(lng);
        localStorage.setItem("lng", lng);
        var cookie_set_time = new Date().toISOString();
        var currentLng = $cookies.get("lng_data");
        if (currentLng) {
          currentLng = JSON.parse(currentLng);
        }
        if (currentLng) {
          if (currentLng.lng != lng) {
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 1);
            var cookieObj = {
              lng: lng,
              cookie_set_time: cookie_set_time,
            };
            cookiesService.setCookie("lng_data", JSON.stringify(cookieObj), {
              samesite: "strict",
              expires: expireDate,
            });

            var newCookie = $cookies.get("lng_data");
            if (
              newCookie &&
              JSON.parse(newCookie).cookie_set_time == cookie_set_time
            ) {
              var date = new Date().toISOString();
              var d = {
                date: date,
                type: "lng",
              };
              localStorage.setItem("cachecleared", JSON.stringify(d));
              window.location.reload(true);
            }
          }
        } else {
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);
          var cookieObj = {
            lng: lng,
            cookie_set_time: cookie_set_time,
          };
          cookiesService.setCookie("lng_data", JSON.stringify(cookieObj), {
            samesite: "strict",
            expires: expireDate,
          });
          var newCookie = $cookies.get("lng_data");
          if (
            newCookie &&
            JSON.parse(newCookie).cookie_set_time == cookie_set_time
          ) {
            var date = new Date().toISOString();
            var d = {
              date: date,
              type: "lng",
            };
            localStorage.setItem("cachecleared", JSON.stringify(d));
            window.location.reload(true);
          }
        }
        if (localize.resourceFileLoaded) {
          d.resolve();
        } else {
          $rootScope.$on("localizeResourcesUpdated", function (event, data) {
            d.resolve();
          });
        }
        return d.promise;
      },
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('My.theme')
	.service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
	return {
	  start: function (interval, calback, time) {
		function startInterval() {
		  return interval(calback, time);
		}

		var i = startInterval();

		angular.element($window).bind('focus', function () {
		  if (i) interval.cancel(i);
		  i = startInterval();
		});

		angular.element($window).bind('blur', function () {
		  if (i) interval.cancel(i);
		});
	  }
	}
  }

})();

(function () {
    'use strict';
    angular.module('My.pages.agroscoop').controller('agroscoopCtrl', agroscoopCtrl);
    /** @ngInject */
    function agroscoopCtrl($timeout, $state, $sce, $scope, isFarmerService, herdDashboardsService, $rootScope, $http, $cookies, $filter, $uibModal, $uibModalStack, $q, APP_CONSTANTS, agroscoopService, toastr, $interval) {
        var vm = this;
        var heightSetted = false;
        var teamTimeout;
        var mapTimeout;
        var viz;
        var activeSheet;
        var workbook;
        var sheet;
        var fatParam;
        var proteinParam;
        var fatChanged;
        var proteinChanged;
        var timeout = $q.defer();
        var loadingDotsCounter = 0;
        var loadingDotsInterval;
        var herdsPromise;
        var dashboardsPromise;
        var addToReportPromise;
        var i18nFilter = $filter('i18n');
        vm.goToState = goToState;
        vm.setActiveMap = setActiveMap;
        vm.hideButtons = hideButtons;
        vm.openRangeSelector = openRangeSelector;
        vm.closeModal = closeModal;
        vm.setRange = setRange;
        vm.openCreateReport = openCreateReport;
        vm.closeCreateReport = closeCreateReport;
        vm.setReportData = setReportData;
        vm.setReportDate = setReportDate;
        vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
        vm.openReportCommentModal = openReportCommentModal;
        vm.setReportDashboardComment = setReportDashboardComment;
        vm.setReportDashboardRange = setReportDashboardRange;
        var cropper;

        function getCroppedImage(dashboard, index, name) {
            console.log(dashboard)
            var imageId = 'image-test' + dashboard.index;
            var image = document.getElementById(imageId);
            console.log(image);
            var cropped_image;

            image.addEventListener('ready', function () {
                var top = 0;
                var height = 0;
                var left = 0;
                var width = 1920;
                if(dashboard.top){
                    top = dashboard.top;
                }
                if(dashboard.height){
                    height = dashboard.height;
                }
                 if(dashboard.left){
                    left = dashboard.left;
                }
                if(dashboard.width){
                    width = dashboard.width;
                }
                console.log(vm[image.id]);
                cropped_image = vm[image.id].setCropBoxData({
                    left: left,
                    top: top,
                    width: width,
                    height: height
                }).getCroppedCanvas({
                    fillColor: '#fff',
                }).toDataURL('image/jpeg');
                vm.orderedDashboards[index].image = cropped_image;
                console.log(cropped_image);
                vm[name].resolve();

            })
            vm[image.id] = new Cropper(image, {
                aspectRatio: NaN,
                viewMode: 3,
            });

        }
        //test();

        function test(){
            vm.showCropArea = true;
            vm.images = [{
                index: 123,
                image: "data:image/png;base64,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"
            }];


            $timeout(function(){
                 var imageId = 'image-test' + vm.images[0].index;
            var image = document.getElementById(imageId);



             image.addEventListener('ready', function () {

               var cropped_image = cropper.setCropBoxData({
                    left: 100,
                    top: 350,
                    width: 1800,
                    height: 650
                }).getCroppedCanvas({
                    fillColor: '#fff',
                }).toDataURL('image/jpeg');
                console.log(cropped_image);

            })

            var cropper = new Cropper(image, {
                aspectRatio: NaN,
                viewMode: 3,
            });
            },500)




        }
        setDates();
        init();

        function useAPI(team_id) {
            localStorage.setItem('tableauLoading', true);
            var setSession = setSessionHandler(team_id);
            setSession.then(function (data) {
                if (localStorage.getItem('lng')) {
                    var tableauSuffix = '?locale=' + localStorage.getItem('lng')
                } else {
                    var tableauSuffix = '?locale=en-GB'
                }
                var suffix = tableauSuffix + '&category=production'
                return agroscoopService.getDashboards(team_id, tableauSuffix).then(function (response) {
                    var obj = {
                        dashboards: response,
                        expires: moment().add(30, 'minutes').format(),
                        team_id: team_id
                    }
                    herdDashboardsService.tableauStored = obj;
                    localStorage.removeItem('tableauLoading');
                    $rootScope.$broadcast('tableau_loaded');
                    processDashboards(response);
                }).catch(function (error) {
                    localStorage.removeItem('tableauLoading');
                    vm.loadingDashboards = false;
                    vm.errorLoading = true;
                })
            }, function (error) {
                localStorage.removeItem('tableauLoading');
                vm.loadingDashboards = false;
                vm.errorLoading = true;
            });
        }

        function setSessionHandler(team_id) {
            var result = $q.defer(),
                setSession, url = APP_CONSTANTS.tableau_base_url + team_id + '/session'
            setSession = $http({
                method: 'post',
                url: url,
                data: {},
                cache: false,
                timeout: timeout.promise,
                withCredentials: true
            });
            setSession.success(function (data, status, headers, config) {
                result.resolve(data);
            });
            setSession.error(function (data, status, headers, config) {
                result.reject(data);
            });
            return result.promise;
        }

        function setDates() {
            vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
            vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(0).subtract(30, 'days').toISOString());
            vm.actual_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(0).subtract(7, 'days').toISOString());
            vm.init_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(0).subtract(30, 'days').toISOString());
        }

        function init() {
            vm.showCreateReportButton = false;
            $timeout(function () {
                var cookies = $cookies.getAll();
                console.log(cookies);
            }, 2000)
            vm.actualDashboardOpen = false;
            if (teamTimeout) {
                $timeout.cancel(teamTimeout)
            }
            vm.dashboards = [];
            vm.errorLoading = false;
            vm.loadingDashboards = true;
            vm.showButtons = false;
            vm.noAvailableDashboards = false;
            vm.reselectTeamError = false;
            vm.setFilterToAll = true;
            vm.lastDataSourceFilter;
            vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
            vm.selectedTeam = vm.defaultValues.team_id;
            vm.user = JSON.parse(localStorage.getItem('user_profile'));
            if (vm.defaultValues && vm.defaultValues.herd_ids) {
                vm.selectedHerds = vm.defaultValues.herd_ids;
            } else {
                vm.selectedHerds = [];
            }
            console.log(vm.selectedHerds)
            if (vm.defaultValues && vm.defaultValues.team_id) {
                getDashboards(vm.defaultValues.team_id);
            } else {
                teamTimeout = $timeout(function () {
                    vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
                    if (vm.defaultValues && vm.defaultValues.team_id) {
                        getDashboards(vm.defaultValues.team_id);
                    } else {
                        vm.embed = null;
                        vm.loadingDashboards = false;
                        vm.reselectTeamError = true;
                    }
                }, 5000);
            }
        }

        function getDashboards(team_id) {
            //testing
          /*  herdDashboardsService.tableauStored.dashboards = [{"id":"RAPMainherdoverview","description":"RAP Main herd overview","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=RAPMainherdoverview&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"RAPHerddashboard","description":"RAP Herd dashboard","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=RAPHerddashboard&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkyieldactual","description":"Milk yield actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkyieldactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbyyield","description":"Concentrate actual by yield","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbyyield&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"SPPactual","description":"SPP actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=SPPactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkingsactual","description":"Milkings actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkingsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Leftoversactual","description":"Leftovers actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Leftoversactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"LeftoversactualTable","description":"Leftovers actual Table","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=LeftoversactualTable&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"LeftoversactualMilkSpeed","description":"Leftovers actual Milk Speed","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=LeftoversactualMilkSpeed&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"MilkMilkingsactual","description":"Milk/Milkings actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkMilkingsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbyfeed","description":"Concentrate actual by feed","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbyfeed&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbymilkproduction","description":"Concentrate actual by milk production","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbymilkproduction&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Firstmilkyieldbycalvingdate","description":"First milk yield by calving date","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Firstmilkyieldbycalvingdate&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkyieldtrend","description":"Milk yield trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkyieldtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"SPPtrend","description":"SPP trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=SPPtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkingstrend","description":"Milkings trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkingstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Leftoverstrend","description":"Leftovers trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Leftoverstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"MilkMilkingstrend","description":"Milk/Milkings trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkMilkingstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Daysinmilktrend","description":"Days in milk trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Daysinmilktrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"FeedIntake","description":"Feed Intake","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=FeedIntake&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentratekgtrend","description":"Concentrate kg trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentratekgtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateyieldtrend","description":"Concentrate yield trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateyieldtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Robotprestations","description":"Robot prestations","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Robotprestations&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Herdprestationsactual","description":"Herd prestations actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Herdprestationsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Herdprestationstrend","description":"Herd prestations trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Herdprestationstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"TankMilkmeterActualDashboard","description":"Tank/Milk meter Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=TankMilkmeterActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MROActualDashboard","description":"MRO Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MROActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"HerdDashboard","description":"Herd Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=HerdDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionDashboard","description":"Milk Production Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionActualDashboard","description":"Milk Production Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionTrendsDashboard","description":"Milk Production Trends Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"ProteinPercentageDashboard","description":"Protein Percentage Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=ProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"FatProteinPercentageDashboard","description":"Fat + Protein Percentage Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=FatProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"UreaActualDashboard","description":"Urea Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=UreaActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"UreaTrendsDashboard","description":"Urea Trends Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=UreaTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"Milkmeterdashboard","description":"Milk meter dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkmeterdashboard&category=production&subcategory=agroscoop&locale=en-GB"}];
            herdDashboardsService.tableauStored.team_id = team_id;*/

            if (herdDashboardsService.tableauStored.dashboards && herdDashboardsService.tableauStored.team_id == team_id) {
                if (moment(herdDashboardsService.tableauStored.expires).isBefore(moment())) {
                    useAPI(team_id);
                } else {
                    processDashboards(herdDashboardsService.tableauStored.dashboards);
                }
            } else {
                useAPI(team_id);
            }
        }

        function processDashboards(response) {
            if (response.length > 0) {
                var dashboards = [];
                for (var i = 0; i < response.length; i++) {
                    if (response[i].subcategory == 'agroscoop' && (response[i].id == 'TankMilkmeterActualDashboard')) {
                        dashboards.push(response[i]);
                    }
                }
                vm.allDashboards = response;
                vm.dashboards = dashboards;
                vm.mapActive = vm.dashboards[0];
                if (vm.dashboards[0]) {
                    embedPage(vm.dashboards[0]);
                    mapTimeout = $timeout(function () {
                        var height = document.getElementById('panel-map').offsetHeight;
                        if (height == 666) {
                            try {
                                var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                                var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                                if (bodyWidth > 767) {
                                    var newHeight = bodyHeight - 300;
                                    document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
                                    var newHeightFrame = bodyHeight - 330;
                                    document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
                                    document.getElementById('frame').style.height = newHeightFrame + 'px';
                                } else {
                                    var newHeight = bodyHeight - 435;
                                    document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
                                    var newHeightFrame = bodyHeight - 465;
                                    document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
                                    document.getElementById('frame').style.height = newHeightFrame + 'px';
                                }
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    }, 0)
                } else {
                    vm.embed = null;
                    vm.loadingDashboards = false;
                    vm.noAvailableDashboards = true;
                }
            } else {
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
            }
        }

        function hideButtons() {
            vm.showButtons = !vm.showButtons
        }

        function goToState(state) {
            $state.go(state);
        }

        function setActiveMap(dashboard) {
            console.log(dashboard)
            vm.mapActive = dashboard;
            embedPage(dashboard);
        }
        //set dashboard date range
        function setRange() {
            var start_date_changed = false;
            var end_date_changed = false;
            if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
                start_date_changed = true;
            }
            if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
                end_date_changed = true;
            }
            var range_error = checkRangeError(vm.actualDashboardOpen);
            if (!range_error) {
                vm.start_date = angular.copy(vm.modal_start_date);
                vm.end_date = angular.copy(vm.modal_end_date);
                if (vm.actualDashboardOpen) {
                    vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').toISOString());
                    vm.start_date = angular.copy(vm.actual_start_date);
                    vm.init_start_date = new Date(moment(vm.end_date).subtract(30, 'days').toISOString());
                    start_date_changed = true;
                } else {
                    vm.init_start_date = angular.copy(vm.start_date);
                    vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').toISOString());
                }
                if (vm.mapActive) {
                    applyParameters(start_date_changed, end_date_changed);
                }
                closeModal();
            }
        }

        function openCreateReport(is_default) {
            var parser = new UAParser();
            var os = parser.getOS();
            var brw = parser.getBrowser();
            if (os.name == 'iOS' && brw.name == 'Mobile Safari') {
                vm.safariMobileUsed = true;
            } else {
                vm.safariMobileUsed = false;
            }
            vm.reportDate = new Date();
            vm.showCreateReportBlock = true;
            vm.reportLoading = true;
            vm.pdfLoading = false;
            if (is_default) {
                vm.hideCustomPart = true;
            } else {
                vm.hideCustomPart = false;
            }
            if (vm.selectedHerds && vm.selectedHerds.length == 1) {
                herdsPromise = $q.defer();
                dashboardsPromise = $q.defer();
                addToReportPromise = $q.defer();
                $q.all([herdsPromise.promise, dashboardsPromise.promise, addToReportPromise.promise]).then(function () {
                    vm.reportError = false;
                    vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport, is_default);
                    if (vm.reportDashboards.length) {
                        vm.reportLoading = false;
                        vm.herdNotSelected = false;
                    } else {
                        vm.showCreateReportBlock = false;
                        vm.noAvailableDashboards = true;
                        vm.reportLoading = false;
                        vm.herdNotSelected = false;
                    }
                }).catch(function (error) {
                    vm.reportLoading = false;
                    vm.reportError = true;
                    vm.pdfLoading = false;
                })
                if (is_default) {
                    vm.addedToReport = [];
                    addToReportPromise.resolve();
                } else {
                    getAddedToReport(true, vm.reportDate, true);
                }
                var herd_id = vm.selectedHerds[0];
                console.log(herd_id)
                checkHerds(herd_id);
                checkAllDashboards();
            } else {
                vm.reportLoading = false;
                $interval.cancel(loadingDotsInterval);
                vm.herdNotSelected = true;
            }
        }

        function checkAllDashboards() {
            if (localStorage.getItem('lng')) {
                var tableauSuffix = '?locale=' + localStorage.getItem('lng')
            } else {
                var tableauSuffix = '?locale=en-GB'
            }
            return agroscoopService.getDashboards(vm.selectedTeam, tableauSuffix).then(function (response) {
                //testing
                /*response = [{"id":"RAPMainherdoverview","description":"RAP Main herd overview","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=RAPMainherdoverview&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"RAPHerddashboard","description":"RAP Herd dashboard","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=RAPHerddashboard&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkyieldactual","description":"Milk yield actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkyieldactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbyyield","description":"Concentrate actual by yield","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbyyield&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"SPPactual","description":"SPP actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=SPPactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkingsactual","description":"Milkings actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkingsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Leftoversactual","description":"Leftovers actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Leftoversactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"LeftoversactualTable","description":"Leftovers actual Table","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=LeftoversactualTable&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"LeftoversactualMilkSpeed","description":"Leftovers actual Milk Speed","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=LeftoversactualMilkSpeed&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"MilkMilkingsactual","description":"Milk/Milkings actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkMilkingsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbyfeed","description":"Concentrate actual by feed","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbyfeed&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateactualbymilkproduction","description":"Concentrate actual by milk production","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateactualbymilkproduction&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Firstmilkyieldbycalvingdate","description":"First milk yield by calving date","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Firstmilkyieldbycalvingdate&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkyieldtrend","description":"Milk yield trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkyieldtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"SPPtrend","description":"SPP trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=SPPtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Milkingstrend","description":"Milkings trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkingstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Leftoverstrend","description":"Leftovers trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Leftoverstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"MilkMilkingstrend","description":"Milk/Milkings trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkMilkingstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Daysinmilktrend","description":"Days in milk trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Daysinmilktrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"FeedIntake","description":"Feed Intake","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=FeedIntake&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentratekgtrend","description":"Concentrate kg trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentratekgtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Concentrateyieldtrend","description":"Concentrate yield trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Concentrateyieldtrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Robotprestations","description":"Robot prestations","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Robotprestations&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Herdprestationsactual","description":"Herd prestations actual","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Herdprestationsactual&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"Herdprestationstrend","description":"Herd prestations trend","category":"production","subcategory":"rap-fame-v3","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Herdprestationstrend&category=production&subcategory=rap-fame-v3&locale=en-GB"},{"id":"TankMilkmeterActualDashboard","description":"Tank/Milk meter Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=TankMilkmeterActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MROActualDashboard","description":"MRO Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MROActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"HerdDashboard","description":"Herd Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=HerdDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionDashboard","description":"Milk Production Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionActualDashboard","description":"Milk Production Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"MilkProductionTrendsDashboard","description":"Milk Production Trends Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=MilkProductionTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"ProteinPercentageDashboard","description":"Protein Percentage Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=ProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"FatProteinPercentageDashboard","description":"Fat + Protein Percentage Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=FatProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"UreaActualDashboard","description":"Urea Actual Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=UreaActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"UreaTrendsDashboard","description":"Urea Trends Dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=UreaTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"},{"id":"Milkmeterdashboard","description":"Milk meter dashboard","category":"production","subcategory":"agroscoop","locale":"en-GB","url":"https://tabvis-dev.mmmooogle.com/dashboard?id=Milkmeterdashboard&category=production&subcategory=agroscoop&locale=en-GB"}];*/
                var dashboards = getAgroscoopDashboards(response);
                vm.allReportDashboards = createReportDashboardsList(dashboards);
                dashboardsPromise.resolve();
            }).catch(function (error) {
                dashboardsPromise.reject();
            })
        }

        function getAgroscoopDashboards(dashboards) {
            var list = [];
            var listOfDashboardsIds = [];
            var currentLng;
            if (localStorage.getItem('lng')) {
                currentLng = localStorage.getItem('lng')
            } else {
                currentLng = 'en-GB'
            }
            for (var i = 0; i < APP_CONSTANTS.constants.dashboardIdLngList.length; i++) {
                if (APP_CONSTANTS.constants.dashboardIdLngList[i].lng == currentLng) {
                    listOfDashboardsIds.push(APP_CONSTANTS.constants.dashboardIdLngList[i]);
                }
            }
            for (var i = 0; i < listOfDashboardsIds.length; i++) {
                for (var j = 0; j < dashboards.length; j++) {
                    if (listOfDashboardsIds[i].id == dashboards[j].id && dashboards[j].locale == currentLng && dashboards[j].subcategory == 'agroscoop') {
                        dashboards[j].index = listOfDashboardsIds[i].index;
                        dashboards[j].selected = listOfDashboardsIds[i].selected;
                        dashboards[j].default = listOfDashboardsIds[i].default;
                        dashboards[j].actual = listOfDashboardsIds[i].actual;
                        dashboards[j].size = listOfDashboardsIds[i].size;
                        if (listOfDashboardsIds[i].actual) {
                            dashboards[j].start_date = vm.actual_start_date;
                        } else {
                            dashboards[j].start_date = vm.init_start_date;
                        }
                        dashboards[j].end_date = vm.end_date;
                        list.push(dashboards[j]);
                    }
                }
            }
            return list;
        }

        function createReportDashboardsList(dashboards){
            var MilkProductionActualDashboard = $filter('i18n')("_agroscoop_workbook_id_milk_production_actual_");
            var MilkProductionTrendsDashboard = $filter('i18n')("_agroscoop_workbook_id_milk_production_trends_");
            var ProteinPercentageDashboard = $filter('i18n')("_agroscoop_workbook_id_protein_percentage_");
            var FatProteinPercentageDashboard = $filter('i18n')("_agroscoop_workbook_id_fat_protein_percentage_");
            var UreaActualDashboard = $filter('i18n')("_agroscoop_workbook_id_urea_actual_");
            var UreaTrendsDashboard = $filter('i18n')("_agroscoop_workbook_id_urea_trends_");
            var list = [];
            for(var i = 0; i < dashboards.length; i++){
                if(dashboards[i].id == MilkProductionActualDashboard || dashboards[i].id == MilkProductionTrendsDashboard || dashboards[i].id == ProteinPercentageDashboard || dashboards[i].id == FatProteinPercentageDashboard || dashboards[i].id == UreaActualDashboard || dashboards[i].id == UreaTrendsDashboard){
                    var d = getIndividualDashboards(dashboards[i]);
                    for(var j = 0; j< d.length; j++){
                      list.push(d[j]);
                    }

                }

            }
            console.log(list);
            return list;
        }

        function getIndividualDashboards(dashboard){
            var MilkProductionActualDashboard = $filter('i18n')("_agroscoop_workbook_id_milk_production_actual_");
            var MilkProductionTrendsDashboard = $filter('i18n')("_agroscoop_workbook_id_milk_production_trends_");
            var ProteinPercentageDashboard = $filter('i18n')("_agroscoop_workbook_id_protein_percentage_");
            var FatProteinPercentageDashboard = $filter('i18n')("_agroscoop_workbook_id_fat_protein_percentage_");
            var UreaActualDashboard = $filter('i18n')("_agroscoop_workbook_id_urea_actual_");
            var UreaTrendsDashboard = $filter('i18n')("_agroscoop_workbook_id_urea_trends_");
            console.log(dashboard);
            var list = [];
            if(dashboard.id == MilkProductionActualDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 800;
                d1.height = 600;
                d1.index = d1.index + 'd1';
                d1.description = "Milk production by DIM - MRO";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
                var d2 = angular.copy(dashboard);
                d2.top = 2000;
                d2.height = 600;
                d2.description = "Change in milk - MRO";
                d2.suffix = '&Data Source=MRO';
                d2.index = d2.index + 'd2';
                list.push(d2);

            }else if(dashboard.id == MilkProductionTrendsDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 800;
                d1.height = 370;
                d1.index = d1.index + 'd1';
                d1.description = "Milk yield Urea Fat Protein Trend - MRO";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
                var d2 = angular.copy(dashboard);
                d2.top = 1170;
                d2.height = 370;
                d2.description = "Milk production over time - MRO";
                d2.suffix = '&Data Source=MRO';
                d2.index = d2.index + 'd2';
                list.push(d2);
                var d3 = angular.copy(dashboard);
                d3.top = 1900;
                d3.height = 370;
                d3.description = "Trend by period meter";
                d3.suffix = '&Data Source=MRO';
                d3.index = d3.index + 'd3';
                list.push(d3);
                var d4 = angular.copy(dashboard);
                d4.top = 2270;
                d4.height = 370;
                d4.description = "Trend by year meter";
                d4.suffix = '&Data Source=MRO';
                d4.index = d4.index + 'd4';
                list.push(d4);
            }else if(dashboard.id == ProteinPercentageDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 350;
                d1.height = 570;
                d1.left = 100;
                d1.width = 1800;
                d1.index = d1.index + 'd1';
                d1.description = "Protein Percentage Actual";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
                var d2 = angular.copy(dashboard);
                d2.top = 900;
                d2.height = 570;
                d2.description = "Protein Percentage Trend";
                d2.suffix = '&Data Source=MRO';
                d2.index = d2.index + 'd2';
                list.push(d2);
            }else if(dashboard.id == FatProteinPercentageDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 350;
                d1.height = 650;
                d1.left = 100;
                d1.width = 1800;
                d1.index = d1.index + 'd1';
                d1.description = "Fat + Protein Trend";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
            }else if(dashboard.id == UreaActualDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 350;
                d1.height = 650;
                d1.left = 100;
                d1.width = 1800;
                d1.index = d1.index + 'd1';
                d1.description = "Urea by DIM Actual";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
            }else if(dashboard.id == UreaTrendsDashboard){
                var d1 = angular.copy(dashboard);
                d1.top = 350;
                d1.height = 650;
                d1.left = 100;
                d1.width = 1800;
                d1.index = d1.index + 'd1';
                d1.description = "Urea by DIM Trend";
                d1.suffix = '&Data Source=MRO';
                list.push(d1);
            }

            return list;
        }

        function checkHerds(herd_id) {
            console.log('checkHerds', herd_id)
            if (agroscoopService.loadedHerds && agroscoopService.loadedHerds.herds && agroscoopService.loadedHerds.herds.length && agroscoopService.loadedHerds.team_id && agroscoopService.loadedHerds.team_id == vm.selectedTeam) {
                vm.currentHerdName = getHerdNameById(herd_id, agroscoopService.loadedHerds.herds);
                herdsPromise.resolve();
            } else {
                return agroscoopService.getHerdsByTeam(vm.selectedTeam).then(function (response) {
                    vm.currentHerdName = getHerdNameById(herd_id, response);
                    herdsPromise.resolve();
                }).catch(function (error) {
                    herdsPromise.reject();
                })
            }
        }

        function getHerdNameById(herd_id, herds) {
            var herdName = '';
            for (var i = 0; i < herds.length; i++) {
                if (herds[i].Id == herd_id) {
                    herdName = herds[i].Name;
                    break;
                }
            }
            console.log(herdName)
            return herdName;
        }

        function setReportDate() {
            vm.reportDateOpened = false;
            if (vm.reportDate) {
                getAddedToReport(false, vm.reportDate, true);
            }
        }

        function getAddedToReport(init, date, createReport) {
            vm.multipleReports = false;
            if (vm.selectedHerds && vm.selectedHerds.length == 1 && vm.selectedTeam) {
                var date = moment(vm.reportDate).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
                var suffix = '?HerdId=' + vm.selectedHerds;
                suffix = suffix + '&Date=' + date;
                return agroscoopService.getReports(suffix).then(function (response) {
                //testing
                //var response = [];
                    var added = response[0];
                    vm.availableReports = response;
                    vm.selectedReport = response[0];
                    console.log(vm.availableReports)
                    console.log(vm.selectedReport)
                    if (response.length > 1) {
                        vm.multipleReports = true;
                    }
                    if (createReport) {
                        setReport(init, added);
                    } else {
                        setCurrentEntry(added);
                    }
                }).catch(function (error) {
                    vm.addToReportModalLoading = false;
                    addToReportPromise.reject();
                })
            } else {
                if (createReport) {} else {
                    vm.addToReportModalLoading = false;
                }
            }
        }

        function setReportDashboardComment() {
            vm.addCommentModalLoading = true;
            var end_date = moment(vm.selectedReportDashboard.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
            var start_date = moment(vm.selectedReportDashboard.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
            if (vm.selectedReportDashboard.entry_id) {
                var obj = {
                    id: vm.selectedReportDashboard.entry_id,
                    comment: vm.selectedReportDashboard.comment,
                    endDate: end_date,
                    startDate: start_date,
                    locale: vm.selectedReportDashboard.locale,
                    dashboardId: vm.selectedReportDashboard.id
                }
                return agroscoopService.updateReportEntry(obj.id, obj).then(function (response) {
                    vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
                    closeModal();
                }).catch(function (error) {
                    console.log(error);
                    vm.addCommentModalLoading = false;
                })
            } else {
                vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
                closeModal();
            }
        }

        function setReportDashboardRange() {
            var range_error = checkRangeError(vm.selectedReportDashboard.actual, vm.report_modal_start_date, vm.report_modal_end_date);
            if (!range_error) {
                vm.setRangeModalLoading = true;
                if (vm.selectedReportDashboard.entry_id) {
                    var end_date = moment(vm.report_modal_end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
                    if (vm.selectedReportDashboard.actual) {
                        var start_date = moment(vm.report_modal_end_date).subtract(7, 'days').hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
                    } else {
                        var start_date = moment(vm.report_modal_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
                    }
                    var obj = {
                        id: vm.selectedReportDashboard.entry_id,
                        comment: vm.selectedReportDashboard.comment,
                        endDate: end_date,
                        startDate: start_date,
                        locale: vm.selectedReportDashboard.locale,
                        dashboardId: vm.selectedReportDashboard.id
                    }
                    return agroscoopService.updateReportEntry(obj.id, obj).then(function (response) {
                        vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
                        if (vm.selectedReportDashboard.actual) {
                            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
                        } else {
                            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
                        }
                        closeModal();
                    }).catch(function (error) {
                        console.log(error);
                        vm.setRangeModalLoading = false;
                    })
                } else {
                    vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
                    if (vm.selectedReportDashboard.actual) {
                        vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
                    } else {
                        vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
                    }
                    closeModal();
                }
            }
        }

        function setReport(init, added) {
            if (localStorage.getItem('lng')) {
                var lng = localStorage.getItem('lng')
            } else {
                var lng = 'en-GB'
            }
            if (added && added.entries) {
                for (var i = 0; i < added.entries.length; i++) {
                    if (added.entries[i].locale != lng) {
                        added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
                        added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale);
                    }
                }
                vm.addedToReport = added.entries;
            } else {
                vm.addedToReport = [];
            }
            if (!init) {
                vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
            }
            if (init) {
                addToReportPromise.resolve();
            } else {
                vm.reportLoading = false;
            }
        }

        function setReportData() {
            var parser = new UAParser();
            var brw = parser.getBrowser();
            var os = parser.getOS();
            vm.reportLoading = true;
            vm.pdfLoading = true;
            loadingDotsCounter = 0;
            loadingDotsInterval = $interval(function () {
                if (loadingDotsCounter == 0) {
                    vm.loadingDots = '.';
                    loadingDotsCounter++;
                } else if (loadingDotsCounter == 1) {
                    vm.loadingDots = '..';
                    loadingDotsCounter++;
                } else if (loadingDotsCounter == 2) {
                    vm.loadingDots = '...';
                    loadingDotsCounter = 0;
                }
            }, 400)
            var list = [];
            for (var i = 0; i < vm.reportDashboards.length; i++) {
                if (vm.reportDashboards[i].selected) {
                    list.push(vm.reportDashboards[i])
                }
            }
            vm.orderedDashboards = $filter('orderBy')(list, 'index');
            var url_promise_list = [];
            for (var i = 0; i < vm.orderedDashboards.length; i++) {
                var name = 'pr' + i;
                vm[name] = $q.defer();
                url_promise_list.push(vm[name].promise);
                getImageUrl(vm.orderedDashboards[i].url, i, name);
            }

            function getImageUrl(url, index, name) {
                //for testing//
                /*var image_url = 'assets/img/hoof_health.jpg?4564545';
                vm.orderedDashboards[index].image_url = image_url;
                vm[name].resolve();*/
                //production//
                return agroscoopService.setSession(url).then(function (response) {
                    var image_url = response.headers('tabvis-location');
                    vm.orderedDashboards[index].image_url = image_url;
                    vm[name].resolve();
                }).catch(function (error) {
                    vm[name].reject();
                })
            }
            $q.all(url_promise_list).then(function () {
                setDataUrls(vm.orderedDashboards);
            }).catch(function (error) {
                vm.reportLoading = false;
                vm.reportError = true;
                vm.pdfLoading = false;
            })
            //}
        }

        function getDataUrl(url, index, name) {
            toDataURL(url, function (dataUrl) {
                console.log(dataUrl);
                vm.orderedDashboards[index].image = dataUrl;
                vm[name].resolve();
            }, name)
        }

        function setImageUrl(dashboard) {
            var tmrParamName = $filter('i18n')('_dashboard_filter_TMR_concentrate_');
            var dmParamName = $filter('i18n')('_dashboard_filter_dry_matter_');
            var image_url;
            var size = '1920,1080';
            var splitted = dashboard.image_url.split('?');
            //comment for testing
            image_url = splitted[0] + '.png';
            //use for testing
            //image_url = splitted[0];
            var start_date = moment(dashboard.start_date).format('YYYY-MM-DD');
            var end_date = moment(dashboard.end_date).format('YYYY-MM-DD');
            console.log(vm.selectedHerds)
            var herd = vm.selectedHerds[0];
            var suffix = '?Start%20Date=' + start_date + '&End%20Date=' + end_date + '&herd_id=' + herd + '&herd%20param=' + herd + '&:size=';
            if (dashboard.size) {
                suffix = suffix + dashboard.size;
            } else {
                suffix = suffix + size;
            }
            image_url = image_url + suffix;
            if (dashboard.filter) {
                image_url = image_url + dashboard.filter;
            }else {
                if(dashboard.suffix){
                    image_url = image_url + dashboard.suffix;
                }
            }
            return image_url;
        }

        function checkForAddedToReport(dashboards, addedToReport, is_default) {
            var list = angular.copy(dashboards);
            if (is_default) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].id == 'MilkProductionActualDashboard' || list[i].id == 'MelkproductieActueelDashboard') {
                        list[i].selected = true;
                    }

                }
            } else {
                for (var i = 0; i < list.length; i++) {
                    console.log(list[i]);
                    for (var j = 0; j < addedToReport.length; j++) {
                        if (list[i].id == addedToReport[j].dashboardId) {
                            list[i].comment = addedToReport[j].comment;
                            list[i].end_date = new Date(addedToReport[j].endDate);
                            list[i].start_date = new Date(addedToReport[j].startDate);
                            list[i].index = addedToReport[j].Order;
                            list[i].selected = true;
                            list[i].entry_id = addedToReport[j].id;
                            list[i].filter = addedToReport[j].filter;
                        }
                    }
                }
            }
            return list;
        }

        function setDataUrls() {
            var image_url_promise_list = [];
            for (var i = 0; i < vm.orderedDashboards.length; i++) {
                var name = 'imgpr' + i;
                vm[name] = $q.defer();
                image_url_promise_list.push(vm[name].promise);
                var image_url = setImageUrl(vm.orderedDashboards[i])
                getDataUrl(image_url, i, name);
            }
            vm.logoPrm = $q.defer();
            image_url_promise_list.push(vm.logoPrm.promise);
            toDataURL('assets/img/ForFarmersLogo.png', function (dataUrl) {
                vm.logo = dataUrl;
                vm.logoPrm.resolve();
            }, 'logoPrm')
            $q.all(image_url_promise_list).then(function () {
                 setCroppedImages();
               /* if (vm.hideCustomPart) {

                } else {
                    var date = new Date();
                    date = $filter('date')(date);
                    var pdfData = {
                        date: date,
                        logo: vm.logo,
                        user: vm.user.name,
                        blue: '#033384',
                        green: '#99B71B',
                        red: 'red',
                        positive_points: (vm.positivePoints ? vm.positivePoints : ''),
                        points_to_improve: (vm.pointsToImprove ? vm.pointsToImprove : ''),
                        herd_name: vm.currentHerdName,
                        dashboards: vm.orderedDashboards
                    }

                    createPDF(pdfData);
                }*/
                //test(pdfData);
            }).catch(function (error) {
                vm.reportLoading = false;
                vm.reportError = true;
                vm.pdfLoading = false;
            })
        }

        function setCroppedImages() {
            vm.showCropArea = true;
            var crp_img_list = [];
            console.log(vm.orderedDashboards);
            vm.images = angular.copy(vm.orderedDashboards);
            $timeout(function () {
                for (var i = 0; i < vm.orderedDashboards.length; i++) {
                    var name = 'crpimg' + i;
                    vm[name] = $q.defer();
                    crp_img_list.push(vm[name].promise);
                    getCroppedImage(vm.orderedDashboards[i], i, name);
                }

                $q.all(crp_img_list).then(function () {
                    var date = new Date();
                    date = $filter('date')(date);
                    var pdfData = {
                        date: date,
                        logo: vm.logo,
                        user: vm.user.name,
                        blue: '#033384',
                        green: '#99B71B',
                        red: 'red',
                        positive_points: (vm.positivePoints ? vm.positivePoints : ''),
                        points_to_improve: (vm.pointsToImprove ? vm.pointsToImprove : ''),
                        herd_name: vm.currentHerdName,
                        dashboards: vm.orderedDashboards
                    }
                    console.log(pdfData)
                    createPDF(pdfData);
                    vm.showCropArea = false;
                })
            }, 500)
        }

        function createPDF(pdfData) {
            console.log(pdfData)
            var dd = {
                pageMargins: [20, 20, 20, 20],
                pageSize: 'A4',
                content: [
                    {
                        image: pdfData.logo,
                        width: 120,
                        alignment: 'right'
                    }
                        , {
                        text: i18nFilter('_report_title_robot_analysis_') + ':',
                        alignment: 'left',
                        fontSize: 16,
                        bold: true,
                        color: pdfData.blue
                    }
                        , {
                        text: pdfData.herd_name,
                        alignment: 'left',
                        fontSize: 14,
                        color: pdfData.blue,
                        margin: [0, 10, 0, 0],
                        italics: true
                    }, {
                        text: pdfData.date,
                        alignment: 'left',
                        fontSize: 14,
                        color: pdfData.blue,
                        italics: true
                    }, {
                        table: {
                            widths: ['auto', '*'],
                            body: [
                    [
                                    {
                                        text: i18nFilter('_report_robot_specialist_') + ':',
                                        color: pdfData.blue,
                                        fontSize: 14,
                                        border: [false, false, false, true],
                                        italics: true,
                                        margin: [-5, 0, -5, 0],
                                    }, {
                                        text: pdfData.user,
                                        color: pdfData.blue,
                                        fontSize: 14,
                                        border: [false, false, false, true],
                                        italics: true
                        }
                        ]
                , ]
                        },
                        layout: {
                            hLineColor: pdfData.green
                        }
                    }, {
                        text: i18nFilter('_report_positive_points_') + ':',
                        alignment: 'left',
                        bold: true,
                        margin: [0, 5, 15, 0]
                    }, {
                        text: pdfData.positive_points,
                        alignment: 'left',
                        pageBreak: ((pdfData.positive_points.length > 1700 || pdfData.positive_points.split(/\r\n|\r|\n/).length > 22) && (pdfData.points_to_improve.length > 1700 || pdfData.points_to_improve.split(/\r\n|\r|\n/).length > 22)) ? 'after' : false
                    }, {
                        text: i18nFilter('_report_points_to_improve_') + ':',
                        alignment: 'left',
                        bold: true,
                        margin: [0, 5, 15, 0]
                    }, {
                        text: pdfData.points_to_improve,
                        alignment: 'left',
                    },



                ],
            }
            for (var i = 0; i < pdfData.dashboards.length; i++) {
                var obj = {
                    text: pdfData.dashboards[i].comment ? pdfData.dashboards[i].comment : '',
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 10]
                };
                var table = {
                    table: {
                        dontBreakRows: true,
                        widths: ['*'],
                        body: [[{
                            border: [false, false, false, false],
                            margin: [-5, 5, -5, 10],
                            stack: [
                                {
                                    margin: [0, 5, 0, 10],
                                    text: pdfData.dashboards[i].description + ' (' + $filter('date')(pdfData.dashboards[i].start_date) + ' - ' + $filter('date')(pdfData.dashboards[i].end_date) + ')',
                                    border: [false, false, false, false],
                                    bold: true
                        }, {
                                    image: pdfData.dashboards[i].image,
                                    width: 555,
                                    border: [false, false, false, false]
                         },

                            ]
                    }]]
                    },
                    layout: {
                        hLineColor: pdfData.green
                    }
                }
                if (pdfData.dashboards[i].selected) {
                    dd.content.push(table);
                    dd.content.push(obj);
                }
            }
            var reportName = i18nFilter('_report_title_robot_analysis_') + ' ' + $filter('date')(new Date(), 'yyyy-MM-dd');
            var parser = new UAParser();
            var os = parser.getOS();
            var brw = parser.getBrowser();
            var device = parser.getDevice();
            var pdf = pdfMake.createPdf(dd);
            if (device && device.type) {
                if (os.name == 'iOS') {
                    if (brw.name == 'Mobile Safari') {
                        try {
                            pdf.open();
                        } catch (error) {
                            toastr.error(error)
                        }
                    } else {
                        try {
                            var reader = new FileReader();
                            pdf.open();
                            pdf.getBlob(function (blob) {
                                reader.onload = function (e) {
                                    var uri = reader.result
                                    var link = document.createElement("a");
                                    link.download = reportName + '.pdf';
                                    link.href = uri;
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }
                                reader.readAsDataURL(blob);
                            })
                        } catch (error) {
                            toastr.error(error)
                        }
                    }
                } else {
                    pdfMake.createPdf(dd).download(reportName);
                }
            } else {
                try {
                    pdfMake.createPdf(dd).open();
                } catch (error) {
                    toastr.error(i18nFilter('_report_create_popup_message_'));
                }
            }
            vm.pointsToImprove = '';
            vm.positivePoints = '';
            $timeout(function () {
                vm.showCreateReportBlock = false;
                vm.reportLoading = false;
                vm.pdfLoading = false;
                $interval.cancel(loadingDotsInterval);
            }, 500)
        }

        function setCurrentEntry(added) {
            if (localStorage.getItem('lng')) {
                var lng = localStorage.getItem('lng')
            } else {
                var lng = 'en-GB'
            }
            if (added && added.entries) {
                for (var i = 0; i < added.entries.length; i++) {
                    if (added.entries[i].locale != lng) {
                        added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
                        added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale);
                        added.entries[i].locale = lng;
                    }
                }
                vm.addedToReport = added.entries;
            } else {
                vm.addedToReport = [];
            }
            var entry;
            for (var i = 0; i < vm.addedToReport.length; i++) {
                if (vm.addedToReport[i].dashboardId == vm.currentSheet) {
                    entry = vm.addedToReport[i];
                    break;
                }
            }
            if (entry) {
                vm.entryAlradyExist = true;
                vm.currentEntry = entry;
                vm.modalComment = angular.copy(vm.currentEntry.comment);
            } else {
                vm.modalComment = '';
            }
            vm.addToReportModalLoading = false;
        }

        function checkRangeError(actual_open) {
            var error = false;
            var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
            if (today.isBefore(vm.modal_end_date)) {
                error = true;
            }
            if (!actual_open) {
                if (moment(vm.modal_end_date).isBefore(vm.modal_start_date)) {
                    error = true;
                }
            }
            return error;
        }

        function openReportDashboardPeriodModal(index) {
            vm.report_modal_start_date = vm.reportDashboards[index].start_date;
            vm.report_modal_end_date = vm.reportDashboards[index].end_date;
            vm.selectedReportDashboardIndex = index;
            vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
            vm.setRangeModalLoading = false;
            openModal('app/pages/agroscoop/reportRangeSelector.modal.html', 'sm');
        }

        function openReportCommentModal(index) {
            vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
            vm.selectedReportDashboardIndex = index;
            vm.addCommentModalLoading = false;
            openModal('app/pages/agroscoop/reportComment.modal.html', 'sm');
        }

        function applyParameters(start_date_changed, end_date_changed) {
            var start_date;
            var end_date = vm.end_date;
            if (vm.actualDashboardOpen) {
                start_date = vm.init_start_date;
            } else {
                start_date = vm.start_date;
            }
            if (viz) {
                if (start_date_changed && end_date_changed) {
                    viz.getWorkbook().changeParameterValueAsync('Start Date', start_date).then(function (param) {
                        viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
                    });
                } else if (start_date_changed && !end_date_changed) {
                    viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
                } else if (!start_date_changed && end_date_changed) {
                    viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
                }
            }
        }

        function openModal(template, size) {
            $uibModal.open({
                animation: true,
                templateUrl: template,
                size: size,
                scope: $scope,
                backdrop: 'static',
                keyboard: false
            })
        }

        function closeCreateReport() {
            vm.showCreateReportBlock = false;
            vm.pointsToImprove = '';
            vm.positivePoints = '';
        }

        function openRangeSelector() {
            vm.modal_start_date = angular.copy(vm.start_date);
            vm.modal_end_date = angular.copy(vm.end_date);
            openModal('app/pages/agroscoop/rangeSelector.modal.html', 'sm');
        }

        function closeModal() {
            $uibModalStack.dismissAll();
        }

        function embedPage(dashboard) {
            vm.loadingDashboards = false;
            var url = dashboard.url;
            var start_date_suffix = '&startDate=' + vm.start_date.toISOString();
            //var start_date_suffix = '&startDate=' + '2019-04-01T10:00:00.000Z';
            var end_date_suffix = '&endDate=' + vm.end_date.toISOString();
            //var end_date_suffix = '&endDate=' + '2019-09-01T21:59:59.999Z';
            url = url + start_date_suffix + end_date_suffix;
            //chek if user is 'forfarmers'
            // if true use Tableau JS API
            // if false just embed page
            vm.workSheetName = dashboard.description;
            var tank_milk = $filter('i18n')('_dashboard_name_agroscoop_tank_milk_meter_');
            var mro = $filter('i18n')('_dashboard_name_agroscoop_mro_');
            var agr_main_overview = $filter('i18n')('_dashboard_name_agroscoop_main_overview_');
            if (dashboard.description == tank_milk || dashboard.description == mro) {
                $rootScope.$broadcast('home_dashboard_embedded', agr_main_overview)
            } else {
                $rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
            }
            embedForFarmers(url);
        }

        function embedForFarmers(url) {
            var herdIdentifierFilter = $filter('i18n')('_dashboard_name_filter_herd_identifier_');
            var deviceType;
            var parser = new UAParser();
            var device = parser.getDevice();
            if (device && device.type) {
                if (device.type == 'mobile') {
                    //deviceType = 'phone';
                    deviceType = 'tablet';
                } else if (device.type == 'tablet') {
                    deviceType = 'tablet';
                } else if (device.type == 'smarttv') {
                    deviceType = 'desktop';
                } else if (device.type == 'wearable') {
                    //deviceType = 'phone';
                    deviceType = 'tablet';
                } else {
                    //deviceType = 'phone';
                    deviceType = 'tablet';
                }
            } else {
                if (window.screen.height <= 900) {
                    deviceType = 'tablet';
                } else {
                    deviceType = 'desktop';
                }
            }
            deviceType = 'desktop';
            console.log(deviceType);
            if (vm.selectedHerds.length > 0) {
                url = url + '&herd=';
                for (var i = 0; i < vm.selectedHerds.length; i++) {
                    if (i > 0) {
                        url = url + ',';
                    }
                    url = url + vm.selectedHerds[i];
                }
            }
            if (viz) {
                viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
                viz.dispose();
            }
            //call used to set session and to fetch internal url
            return agroscoopService.setSession(url).then(function (response) {
                vm.loadingDashboards = false;
                vm.showButtons = true;
                var url = response.headers('tabvis-location');
                if (url) {
                    url += '&refresh=yes'
                    var containerDiv = document.getElementById("frame");
                    var options = {
                        device: deviceType,
                        onFirstInteractive: function () {
                            var fatParamName = $filter('i18n')('_dashboard_filter_fat_');
                            var proteinParamName = $filter('i18n')('_dashboard_filter_protein_');
                            workbook = viz.getWorkbook();
                            activeSheet = workbook.getActiveSheet();
                            var wrks = workbook.getActiveSheet().getWorksheets();
                            workbook.getParametersAsync().then(function (parameters) {
                                for (var i = 0; i < parameters.length; i++) {
                                    if (!fatParam) {
                                        if (parameters[i].getName() == fatParamName) {
                                            fatParam = parameters[i].getCurrentValue().formattedValue;
                                        }
                                    }
                                    if (!proteinParam) {
                                        if (parameters[i].getName() == proteinParamName) {
                                            proteinParam = parameters[i].getCurrentValue().formattedValue;
                                        }
                                    }
                                }
                            })
                            var worksheetName;
                            for (var i = 0; i < wrks.length; i++) {
                                if (wrks[i].getName()) {
                                    worksheetName = wrks[i].getName();
                                    break;
                                }
                            }
                            if (worksheetName && vm.selectedHerds.length == 0) {
                                workbook.getActiveSheet().getWorksheets().get(worksheetName).clearFilterAsync('herd_id');
                            }
                        }
                    }
                    viz = new tableau.Viz(containerDiv, url, options);
                    viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onMarksSelection);
                    viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, onParameterChange);
                }
            }).catch(function (response) {})

            function onParameterChange(event) {
                var fatParamName = $filter('i18n')('_dashboard_filter_fat_');
                var proteinParamName = $filter('i18n')('_dashboard_filter_protein_');
                event.getParameterAsync().then(function (parameter) {
                    if (event.getParameterName() == fatParamName) {
                        fatChanged = true
                    } else if (event.getParameterName() == proteinParamName) {
                        proteinChanged = true;
                    }
                })
            }

            function onMarksSelection(marksEvent) {
                var oldName = $filter('i18n')('_dashboard_name_agroscoop_tank_milk_meter_');
                var newName = $filter('i18n')('_dashboard_name_agroscoop_herd_dashboard_');
                var oldName2 = $filter('i18n')('_dashboard_name_agroscoop_mro_');
                var selectedValue = $filter('i18n')('_dashboard_name_agroscoop_selected_value_');
                var herdFilterName = $filter('i18n')('_dashboard_name_agroscoop_herd_filter_');
                var tank_milk = $filter('i18n')('_dashboard_name_agroscoop_tank_milk_meter_');
                var mro = $filter('i18n')('_dashboard_name_agroscoop_mro_');
                var agr_main_overview = $filter('i18n')('_dashboard_name_agroscoop_main_overview_');
                var milk_production_actual_dashboard = $filter('i18n')('_workbook_name_milk_production_actual_dashboard_');
                var protein_percentage_dashboard = $filter('i18n')('_workbook_name_protein_percentage_dashboard_');
                var urea_actual_dashboard = $filter('i18n')('_workbook_name_urea_actual_dashboard_');
                var fat_percentage_dashboard = $filter('i18n')('_workbook_name_fat_percentage_dashboard_');
                var mro_date_filter = $filter('i18n')('_dashboards_filter_mro_date_');
                var milk_production_dashboard = $filter('i18n')('_workbook_name_milk_production_dashboard_');
                var milk_meter_dashboard = $filter('i18n')('_workbook_name_milk_meter_dashboard_');
                var data_source_parameter = $filter('i18n')('_dashboards_parameter_data_source_');
                var data_source_parameter_mro = $filter('i18n')('_dashboards_parameter_data_source_MRO_');
                var data_source_parameter_mm = $filter('i18n')('_dashboards_parameter_data_source_milk_meter_');
                var worksheetName;
                var filter;
                var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
                for (var i = 0; i < wrks.length; i++) {
                    if (wrks[i].getName()) {
                        worksheetName = wrks[i].getName();
                        break;
                    }
                }
                for (var i = 0; i < wrks.length; i++) {
                    if (wrks[i].getName()) {
                        getFilters(wrks[i].getName());
                    }
                }
                marksEvent.getViz().getWorkbook().getParametersAsync().then(function (parameters) {
                    console.log(parameters)
                })
                console.log("new sheet name" + " " + marksEvent.getNewSheetName());
                console.log("old sheet name" + " " + marksEvent.getOldSheetName());
                console.log('current worksheet name' + " " + worksheetName);
                if (marksEvent.getEventName() == 'tabswitch') {
                    if (marksEvent.getNewSheetName() == tank_milk || marksEvent.getNewSheetName() == mro) {
                        $rootScope.$broadcast('home_dashboard_embedded', agr_main_overview)
                    } else {
                        $rootScope.$broadcast('home_dashboard_embedded', marksEvent.getNewSheetName());
                    }
                    if ((marksEvent.getOldSheetName() == oldName && marksEvent.getNewSheetName() == newName) || (marksEvent.getOldSheetName() == oldName2 && marksEvent.getNewSheetName() == newName)) {
                        vm.showCreateReportButton = true;
                        marksEvent.getViz().getWorkbook().getParametersAsync().then(function (parameters) {
                            console.log(parameters)
                            for (var i = 0; i < parameters.length; i++) {
                                if (parameters[i].getName() == 'Select a herd') {
                                    selectHerdByHerdId(parameters[i].getCurrentValue().formattedValue);
                                }
                            }
                        })
                    } else if (marksEvent.getNewSheetName() == oldName || marksEvent.getNewSheetName() == oldName2) {
                        vm.showCreateReportButton = false;
                        marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).clearFilterAsync('herd_id');
                        $rootScope.$broadcast('deselect_all_herds');
                        vm.setFilterToAll = true;
                    } else if (marksEvent.getNewSheetName() == milk_production_actual_dashboard) {
                        vm.showCreateReportButton = false;
                        for (var i = 0; i < wrks.length; i++) {
                            if (wrks[i].getName()) {
                                if (wrks[i].getName() == 'Change in milk MRO') {
                                    if (vm.setFilterToAll) {
                                        wrks[i].applyFilterAsync(mro_date_filter, "", tableau.FilterUpdateType.ALL);
                                        vm.setFilterToAll = false;
                                    }
                                }
                            }
                        }
                    } else if (marksEvent.getNewSheetName() == newName) {
                        vm.showCreateReportButton = true;

                    } else if (marksEvent.getNewSheetName() == protein_percentage_dashboard) {
                        vm.showCreateReportButton = false;
                        for (var i = 0; i < wrks.length; i++) {
                            if (wrks[i].getName() == 'Protein Percentage Actual') {
                                if (vm.setFilterToAll) {
                                    wrks[i].applyFilterAsync(mro_date_filter, "", tableau.FilterUpdateType.ALL);
                                    vm.setFilterToAll = false;
                                }
                            }
                        }
                    } else if (marksEvent.getNewSheetName() == urea_actual_dashboard) {
                        vm.showCreateReportButton = false;
                        for (var i = 0; i < wrks.length; i++) {
                            if (wrks[i].getName() == 'Urea by DIM') {
                                if (vm.setFilterToAll) {
                                    wrks[i].applyFilterAsync(mro_date_filter, "", tableau.FilterUpdateType.ALL);
                                    vm.setFilterToAll = false;
                                }
                            }
                        }
                    } else if (marksEvent.getNewSheetName() == fat_percentage_dashboard) {
                        vm.showCreateReportButton = false;
                        for (var i = 0; i < wrks.length; i++) {
                            if (wrks[i].getName() == 'Fat Percentage Actual') {
                                if (vm.setFilterToAll) {
                                    wrks[i].applyFilterAsync(mro_date_filter, "", tableau.FilterUpdateType.ALL);
                                    vm.setFilterToAll = false;
                                }
                            }
                        }
                    } else if (marksEvent.getNewSheetName() == milk_production_dashboard) {
                        vm.showCreateReportButton = false;
                        marksEvent.getViz().getWorkbook().changeParameterValueAsync(data_source_parameter, data_source_parameter_mro);
                    } else if (marksEvent.getNewSheetName() == milk_meter_dashboard) {
                        vm.showCreateReportButton = false;
                        marksEvent.getViz().getWorkbook().changeParameterValueAsync(data_source_parameter, data_source_parameter_mm);
                    } else {
                        vm.showCreateReportButton = false;
                    }

                    function getFilters(wrkname) {
                        marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(wrkname).getFiltersAsync().then(function (filter) {
                            console.log(wrkname, filter)
                        })
                    }
                }
            }
        }

        function toDataURL(url, callback, prm) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                if (xhr.status == 200 || xhr.status == 204) {
                    reader.readAsDataURL(xhr.response);
                } else {
                    vm[prm].reject();
                }
            };
            xhr.open('GET', url);
            xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
            xhr.responseType = 'blob';
            xhr.withCredentials = true;
            xhr.send();
        }

        function selectHerdByHerdId(herd_id) {
            console.log(herd_id)
            vm.selectedHerds = [herd_id];
            $rootScope.$broadcast('default_herd_from_dashboard_selected', herd_id);
        }
        $scope.$on('default_herd_selected', function () {
            vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
            vm.selectedHerds = [];
            vm.selectedHerds = vm.defaultValues.herd_ids;
            init();
        });
        $scope.$on('default_values_loaded', function () {
            if (teamTimeout) {
                $timeout.cancel(teamTimeout)
            }
            var newDefaultValues = localStorage.getItem('default_values');
            if (newDefaultValues != JSON.stringify(vm.defaultValues)) {
                init();
            }
        })
        $scope.$on('$destroy', function () {
            timeout.resolve();
            if (viz) {
                viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
                viz.dispose();
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.agroscoop').factory('agroscoopService', agroscoopService);
    /** @ngInject */
    function agroscoopService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards,
            setTableauTenant: setTableauTenant,
            setSession: setSession,
            getReports: getReports,
            getHerdsByTeam: getHerdsByTeam,
            updateReportEntry: updateReportEntry,
            loadedDashboards: {},
            herds: [],
            laodedHerds: {},
            allDashboards: {}
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true,
                timeout: 20000
            }).then(success).catch(error);
        }

        function setTableauTenant(team_id) {
            //production
            //return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/cookie' ,{withCredentials: true}).then(success).catch(error);
            //staging
            return $http.post(APP_CONSTANTS.tableau_base_url + team_id + '/session', {}, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function getReports(suffix) {
            return $http.get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function getHerdsByTeam(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

         function updateReportEntry(id, obj){
             return $http.put(APP_CONSTANTS.tableau_reports_base_url+'/reportentry/' + id, obj, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return response;
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";

  angular.module("My").constant("APP_CONSTANTS", {
    //production
    backoffice_base_url: "https://backoffice.mmmooogle.com/api/v1/",
    backoffice_domen: "backoffice.mmmooogle.com",
    animals_base_url: "https://animals.mmmooogle.com/api/v1/",
    animals_domen: "animals.mmmooogle.com",
    my_api_base_url:
      "https://my-api.jollypond-cb3f90ce.westeurope.azurecontainerapps.io/api/v1/",
    my_api_base_domen:
      "my-api.jollypond-cb3f90ce.westeurope.azurecontainerapps.io",

    //staging
    //backoffice_base_url: "https://backoffice-stg.mmmooogle.com/api/v1/",
    //backoffice_domen: "backoffice-stg.mmmooogle.com",
    //animals_base_url: 'https://animals-stg.mmmooogle.com/api/v1/',
    //animals_domen: 'animals-stg.mmmooogle.com',

    //production
    tableau_base_url: "https://tabvis-prd.mmmooogle.com/api/v1/teams/",
    tableau_domen: "tabvis-prd.mmmooogle.com",
    tableau_reports_base_url: "https://tabvis-prd.mmmooogle.com/api/v1/reports",

    //staging
    //tableau_base_url: 'https://tabvis-stg.mmmooogle.com/api/v1/teams/',
    //tableau_domen: 'tabvis-stg.mmmooogle.com',
    //tableau_reports_base_url: 'https://tabvis-stg.mmmooogle.com/api/v1/reports',

    //development
    //tableau_base_url: "https://tabvis-dev.mmmooogle.com/api/v1/teams/",
    //tableau_domen: "tabvis-dev.mmmooogle.com",
    //tableau_reports_base_url: "https://tabvis-dev.mmmooogle.com/api/v1/reports",

    //do not change this value manually
    buildTimeStamp: "1712044053091",

    constants: {
      visuals: {
        production: [
          {
            id: "Recent-milk-recordings",
          },
          {
            id: "Milk-recording-(10Y)",
          },
          {
            id: "Milk-recording-(5Y)",
          },
          {
            id: "Fresh-cow",
          },
          {
            id: "Milk-deviations",
          },
          {
            id: "Milk-Alerts",
          },
          {
            id: "Milk-meter-2",
          },
          {
            id: "Milk-meter",
          },
        ],
        reproduction: [
          {
            id: "First-insemination-strategy",
          },
          {
            id: "Conception-Rate",
          },
          {
            id: "Reproduction-cows",
          },
          {
            id: "Reproduction-heifers",
          },
        ],

        udder_health: [
          {
            id: "Genetic-SCC-evaluation",
          },
          {
            id: "Mastitis-dashboard",
          },
          {
            id: "Transition-cow-cellcount-analysis",
          },
          {
            id: "General-cellcount-analysis",
          },
        ],

        hoof_health: [
          {
            id: "Hoof-trim",
          },
          {
            id: "Trim-overview",
          },
          {
            id: "Trim-vs-calved-overview",
          },
        ],
        herd_charachteristics: [
          {
            id: "Herd-inventory",
          },
        ],
        comments: [
          {
            id: "Comments-last-week",
          },
          {
            id: "Comments-last-month",
          },
        ],
        environmental: [
          {
            id: "Temperature-Humidity-Index-Quarter",
          },
          {
            id: "Temperature-Humidity-Index-Month",
          },
          {
            id: "Temperature-Humidity-Index",
          },
          {
            id: "Daily-carbon-footprint",
          },
        ],
        genetics: [
          {
            id: "Genetic-Prod-Life-progress",
          },
          {
            id: "Sire-evaluation",
          },
          {
            id: "Genetic-DPR-progress",
          },
          {
            id: "Genetic-production-evaluation",
          },
          {
            id: "Genetic-company-overview",
          },
        ],
        other: [
          {
            id: "Lactation-analysis-last-year",
          },
          {
            id: "Teatsealer-dashboard",
          },
          {
            id: "Kexxtone-dashboard",
          },
          {
            id: "Calving-Pattern",
          },
          {
            id: "High-genomic-animals",
          },
        ],
      },

      tags: [
        {
          value: null,
          label: "",
          trackByIndex: 0,
        },
        {
          value: "BCS",
          label: "BCS",
          group: "All",
          trackByIndex: 1,
          label_translate: "_animal_tag_bcs_",
        },
        {
          value: "BiosecurityPlan",
          label: "Biosecurity Plan",
          group: "All",
          trackByIndex: 2,
          label_translate: "_animal_tag_biosecurity_plan_",
        },
        {
          value: "BullsBloodlines",
          label: "Bulls Bloodlines",
          group: "All",
          trackByIndex: 3,
          label_translate: "_animal_tag_bulls_bloodlines_",
        },
        {
          value: "Calved",
          label: "Calved",
          group: "All",
          trackByIndex: 4,
          label_translate: "_animal_tag_calved_",
        },
        {
          value: "Collars",
          label: "Collars",
          group: "All",
          trackByIndex: 5,
          label_translate: "_animal_tag_collars_",
        },
        {
          value: "CowsDueToCalve",
          label: "Cows Due To Calve",
          group: "All",
          trackByIndex: 6,
          label_translate: "_animal_tag_cows_due_to_calve_",
        },
        {
          value: "DailyReport",
          label: "Daily Report",
          group: "All",
          trackByIndex: 7,
          label_translate: "_animal_tag_daily_report_",
        },
        {
          value: "Dead",
          label: "Dead",
          group: "All",
          trackByIndex: 8,
          label_translate: "_animal_tag_dead_",
        },
        {
          value: "DeliveryDocuments",
          label: "Delivery Documents",
          group: "All",
          trackByIndex: 9,
          label_translate: "_animal_tag_delivery_documents_",
        },
        {
          value: "DiscardedMilk",
          label: "Discarded Milk",
          group: "All",
          trackByIndex: 10,
          label_translate: "_animal_tag_discarded_milk_",
        },
        {
          value: "Disease",
          label: "Disease",
          group: "All",
          trackByIndex: 11,
          label_translate: "_animal_tag_disease_",
        },
        {
          value: "Prevention",
          label: "Prevention",
          group: "All",
          trackByIndex: 12,
          label_translate: "_animal_tag_prevention_",
        },
        {
          value: "DrugResidueTesting",
          label: "Drug Residue Testing",
          group: "All",
          trackByIndex: 13,
          label_translate: "_animal_tag_drug_residue_testing_",
        },
        {
          value: "EmbryotransferCalf",
          label: "Embryotransfer Calf",
          group: "All",
          trackByIndex: 14,
          label_translate: "_animal_tag_embryotransfer_calf_",
        },
        {
          value: "Feedbunks",
          label: "Feedbunks",
          group: "All",
          trackByIndex: 15,
          label_translate: "_animal_tag_feedbunks_",
        },
        {
          value: "FeedingCalvesBeforeWeaning",
          label: "Feeding Calves Before Weaning",
          group: "All",
          trackByIndex: 16,
          label_translate: "_animal_tag_feeding_calves_before_weaning_",
        },
        {
          value: "Footbath",
          label: "Footbath",
          group: "All",
          trackByIndex: 17,
          label_translate: "_animal_tag_footbath_",
        },
        {
          value: "FreshCows",
          label: "FreshCows",
          group: "All",
          trackByIndex: 18,
          label_translate: "_animal_tag_fresh_cows_",
        },
        {
          value: "GeneticProspects",
          label: "Genetic Prospects",
          group: "All",
          trackByIndex: 19,
          label_translate: "_animal_tag_genetic_prospects_",
        },
        {
          value: "Heat",
          label: "Heat",
          group: "All",
          trackByIndex: 20,
          label_translate: "_animal_tag_heat_",
        },
        {
          value: "HighGenomicAnimal",
          label: "High Genomic Animal",
          group: "All",
          trackByIndex: 21,
          label_translate: "_animal_tag_high_genomic_animal_",
        },
        {
          value: "HighProductionAtDryingOff",
          label: "High Production At Drying Off",
          group: "All",
          trackByIndex: 22,
          label_translate: "_animal_tag_high_production_at_drying_off_",
        },
        {
          value: "HighMaintenanceCowFertility",
          label: "High Maintenance Cow Fertility",
          group: "All",
          trackByIndex: 23,
          label_translate: "_animal_tag_high_maintenance_cow_fertility_",
        },
        {
          value: "HighMaintenanceCowLameness",
          label: "High Maintenance Cow Lameness",
          group: "All",
          trackByIndex: 24,
          label_translate: "_animal_tag_high_maintenance_cow_lameness_",
        },
        {
          value: "HighMaintenanceCowMisc",
          label: "High Maintenance Cow Misc",
          group: "All",
          trackByIndex: 25,
          label_translate: "_animal_tag_high_maintenance_cow_misc_",
        },
        {
          value: "HighMaintenanceCowUdderhealth",
          label: "High Maintenance Cow Udder health",
          group: "All",
          trackByIndex: 26,
          label_translate: "_animal_tag_high_maintenance_cow_udder_health_",
        },
        {
          value: "Hospital",
          label: "Hospital",
          group: "All",
          trackByIndex: 27,
          label_translate: "_animal_tag_hospital_",
        },
        {
          value: "HygienePlan",
          label: "Hygiene Plan",
          group: "All",
          trackByIndex: 28,
          label_translate: "_animal_tag_hygiene_plan_",
        },
        {
          value: "ListPredryDiet",
          label: "List Predry Diet",
          group: "All",
          trackByIndex: 29,
          label_translate: "_animal_tag_list_predry_diet_",
        },
        {
          value: "Milk",
          label: "Milk",
          group: "All",
          trackByIndex: 30,
          label_translate: "_animal_tag_milk_",
        },
        {
          value: "Milktank",
          label: "Milktank",
          group: "All",
          trackByIndex: 31,
          label_translate: "_animal_tag_milktank_",
        },
        {
          value: "NewbornCalves",
          label: "Newborn Calves",
          group: "All",
          trackByIndex: 32,
          label_translate: "_animal_tag_newborn_calves_",
        },
        {
          value: "PlanningPersonnel",
          label: "Planning Personnel",
          group: "All",
          trackByIndex: 33,
          label_translate: "_animal_tag_planning_personnel_",
        },
        {
          value: "ProceduresCleaning",
          label: "Procedures Cleaning",
          group: "All",
          trackByIndex: 34,
          label_translate: "_animal_tag_procedures_cleaning_",
        },
        {
          value: "ProceduresBulkTank",
          label: "Procedures Bulk Tank",
          group: "All",
          trackByIndex: 35,
          label_translate: "_animal_tag_procedures_bulk_tank_",
        },
        {
          value: "ProceduresManagementSop",
          label: "Procedures Management Sop",
          group: "All",
          trackByIndex: 36,
          label_translate: "_animal_tag_procedures_management_sop_",
        },
        {
          value: "ProceduresMilking",
          label: "Procedures Milking",
          group: "All",
          trackByIndex: 37,
          label_translate: "_animal_tag_procedures_milking_",
        },
        {
          value: "Proceduresmilking_parlour",
          label: "Procedures milking Parlour",
          group: "All",
          trackByIndex: 38,
          label_translate: "_animal_tag_procedures_milking_parlour_",
        },
        {
          value: "ProceduresPhotos",
          label: "Procedures Photos",
          group: "All",
          trackByIndex: 39,
          label_translate: "_animal_tag_procedures_photos_",
        },
        {
          value: "ProfilePicture",
          label: "Profile Picture",
          group: "All",
          trackByIndex: 40,
          label_translate: "_animal_tag_profile_picture_",
        },
        {
          value: "ProtocolsTreatments",
          label: "Protocols Treatments",
          group: "All",
          trackByIndex: 41,
          label_translate: "_animal_tag_protocols_treatments_",
        },
        {
          value: "PurchaseMedicines",
          label: "Purchase Medicines",
          group: "All",
          trackByIndex: 42,
          label_translate: "_animal_tag_purchase_medicines_",
        },
        {
          value: "SemenStock",
          label: "Semen Stock",
          group: "All",
          trackByIndex: 43,
          label_translate: "_animal_tag_semen_stock_",
        },
        {
          value: "SiloManagment",
          label: "Silo Managment",
          group: "All",
          trackByIndex: 44,
          label_translate: "_animal_tag_silo_managment_",
        },
        {
          value: "SoldOtherHerd",
          label: "Sold Other Herd",
          group: "All",
          trackByIndex: 45,
          label_translate: "_animal_tag_sold_other_herd_",
        },
        {
          value: "SoldToSlaughterhouse",
          label: "Sold To Slaughter house",
          group: "All",
          trackByIndex: 46,
          label_translate: "_animal_tag_sold_to_slaughterhouse_",
        },
        {
          value: "SyncProgramManagement",
          label: "Sync Program Management",
          group: "All",
          trackByIndex: 47,
          label_translate: "_animal_tag_sync_program_management_",
        },
        {
          value: "TMRManagementCows",
          label: "TMR Management Cows",
          group: "All",
          trackByIndex: 48,
          label_translate: "_animal_tag_tmr_management_cows_",
        },
        {
          value: "TMRManagementYoungstock",
          label: "TMR Management Youngstock",
          group: "All",
          trackByIndex: 49,
          label_translate: "_animal_tag_tmr_management_youngstock_",
        },
        {
          value: "ToBeCulled",
          label: "To Be Culled",
          group: "All",
          trackByIndex: 50,
          label_translate: "_animal_tag_to_be_culled_",
        },
        {
          value: "ToBeDriedOff",
          label: "To Be DriedOff",
          group: "All",
          trackByIndex: 51,
          label_translate: "_animal_tag_to_be_driedOff_",
        },
        {
          value: "ToBeExamined",
          label: "To Be Examined",
          group: "All",
          trackByIndex: 52,
          label_translate: "_animal_tag_to_be_examined_",
        },
        {
          value: "ToBeInseminated",
          label: "To Be Inseminated",
          group: "All",
          trackByIndex: 53,
          label_translate: "_animal_tag_to_be_inseminated_",
        },
        {
          value: "ToBeTreated",
          label: "To Be Treated",
          group: "All",
          trackByIndex: 54,
          label_translate: "_animal_tag_to_be_treated_",
        },
        {
          value: "ToBeTrimmed",
          label: "To Be Trimmed",
          group: "All",
          trackByIndex: 55,
          label_translate: "_animal_tag_to_be_trimmed_",
        },
        {
          value: "ToCalve",
          label: "To Calve",
          group: "All",
          trackByIndex: 56,
          label_translate: "_animal_tag_to_calve_",
        },
        {
          value: "TreatedCalves",
          label: "Treated Calves",
          group: "All",
          trackByIndex: 57,
          label_translate: "_animal_tag_treated_calves_",
        },
        {
          value: "TreatedCows",
          label: "Treated Cows",
          group: "All",
          trackByIndex: 58,
          label_translate: "_animal_tag_treated_cows_",
        },
        {
          value: "TreatedMastitis",
          label: "Treated Mastitis",
          group: "All",
          trackByIndex: 59,
          label_translate: "_animal_tag_treated_mastitis_",
        },
      ],
      popularTags: [
        {
          value: "Disease",
          label: "Disease",
          group: "All",
          label_translate: "_animal_tag_disease_",
        },
        {
          value: "Prevention",
          label: "Prevention",
          group: "All",
          label_translate: "_animal_tag_prevention_",
        },
        {
          value: "ToBeTrimmed",
          label: "To Be Trimmed",
          label_translate: "_animal_tag_to_be_trimmed_",
          group: "All",
        },
      ],

      calvingEase: [
        {
          value: 1,
          label: "Smooth Alone",
          label_translate: "_animal_details_calving_ease_smooth_alone_",
        },
        {
          value: 2,
          label: "Light Pull",
          label_translate: "_animal_details_calving_ease_light_pull_",
        },
        {
          value: 3,
          label: "Heavy Pull",
          label_translate: "_animal_details_calving_ease_heavy_pull_",
        },
        {
          value: 4,
          label: "Cesarean",
          label_translate: "_animal_details_calving_ease_cesarean_",
        },
      ],

      animalGender: [
        {
          value: 0,
          label: "Female",
          label_translate: "_animal_gender_female_",
        },
        {
          value: 1,
          label: "Male",
          label_translate: "_animal_gender_male_",
        },
      ],

      calfPresentation: [
        {
          value: 0,
          label: "Forward",
          label_translate: "_animal_details_calf_presentation_forward_",
        },
        {
          value: 1,
          label: "Backward",
          label_translate: "_animal_details_calf_presentation_backward_",
        },
      ],

      calfVitality: [
        {
          value: 1,
          label: "Bad",
          label_translate: "_animal_details_calf_vitality_bad_",
        },
        {
          value: 2,
          label: "Medium",
          label_translate: "_animal_details_calf_vitality_medium_",
        },
        {
          value: 3,
          label: "Good",
          label_translate: "_animal_details_calf_vitality_good_",
        },
      ],

      colostrumQuantity: [
        {
          value: 2,
          label: "0-4 Kg",
        },
        {
          value: 7,
          label: "5-9 Kg",
        },
        {
          value: 12,
          label: "10-14 Kg",
        },
        {
          value: 17,
          label: "15-19 Kg",
        },
        {
          value: 22,
          label: ">=20 Kg",
        },
      ],

      colostrumQuality: [
        {
          value: 1,
          label: "<20% (poor)",
          label_translate: "_animal_details_colostrum_quality_poor_",
        },
        {
          value: 2,
          label: "20-21.9% (medium)",
          label_translate: "_animal_details_colostrum_quality_medium_",
        },
        {
          value: 3,
          label: ">22% (good)",
          label_translate: "_animal_details_colostrum_quality_good_",
        },
      ],

      colostrumMeasurementType: [
        {
          value: 1,
          label: "Refractometer",
          label_translate:
            "_animal_details_colostrum_measurement_type_refractometer_",
        },
        {
          value: 2,
          label: "Colostrometer",
          label_translate:
            "_animal_details_colostrum_measurement_type_colostrometer_",
        },
      ],

      ColostrumIntake: [
        {
          value: 0.75,
          label: "<1 Kg",
        },
        {
          value: 1.2,
          label: "1-1.4 Kg",
        },
        {
          value: 1.7,
          label: "1.5-1.9 Kg",
        },
        {
          value: 2.2,
          label: "2-2.4 Kg",
        },
        {
          value: 2.7,
          label: "2.5-2.9 Kg",
        },
        {
          value: 3.2,
          label: "3-3.4 Kg",
        },
        {
          value: 3.7,
          label: "3.5-3.9 Kg",
        },
        {
          value: 4.2,
          label: "4-4.4 Kg",
        },
        {
          value: 4.7,
          label: ">4.5 Kg",
        },
      ],

      breedingTypes: [
        {
          value: 2,
          label: "Artificial Insemination",
          label_translate:
            "_animal_details_breeding_type_artificial_insemination_",
        },
        {
          value: 3,
          label: "Do It Yourself",
          label_translate: "_animal_details_breeding_type_do_it_yourself_",
        },
        {
          value: 4,
          label: "Natural Service",
          label_translate: "_animal_details_breeding_type_natural_service_",
        },
        {
          value: 5,
          label: "With Bull",
          label_translate: "_animal_details_breeding_type_with_bull_",
        },
        {
          value: 6,
          label: "Embryo Transfer",
          label_translate: "_animal_details_breeding_type_embryo_transfer_",
        },
      ],

      retainedPlacenta: [
        {
          value: 5,
          label: "<6h",
        },
        {
          value: 9,
          label: "6-12h",
        },
        {
          value: 18,
          label: "12-24h",
        },
        {
          value: 60,
          label: "1-5d",
        },
        {
          value: 84,
          label: ">5d",
        },
      ],

      antibiotic: [
        {
          value: 0,
          label: "None",
          label_translate: "_animal_details_antibiotic_none_",
        },
        {
          value: 2,
          label: "Tylosine",
          label_translate: "_animal_details_antibiotic_tylosine_",
        },
        {
          value: 4,
          label: "Penicilline",
          label_translate: "_animal_details_antibiotic_penicilline_",
        },
        {
          value: 8,
          label: "Cefquinome",
          label_translate: "_animal_details_antibiotic_cefquinome_",
        },
        {
          value: 16,
          label: "Tms",
          label_translate: "_animal_details_antibiotic_tms_",
        },
        {
          value: 32,
          label: "Ampicilline",
          label_translate: "_animal_details_antibiotic_ampicilline_",
        },
        {
          value: 64,
          label: "Enrofloxacine",
          label_translate: "_animal_details_antibiotic_enrofloxacine_",
        },
        {
          value: 128,
          label: "Neomycine",
          label_translate: "_animal_details_antibiotic_neomycine_",
        },
        {
          value: 256,
          label: "Lincomycine",
          label_translate: "_animal_details_antibiotic_lincomycine_",
        },
        {
          value: 512,
          label: "Erythromycine",
          label_translate: "_animal_details_antibiotic_erythromycine_",
        },
        {
          value: 1024,
          label: "Ceftiofur",
          label_translate: "_animal_details_antibiotic_ceftiofur_",
        },
        {
          value: 2048,
          label: "Amoxi&Clav",
          label_translate: "_animal_details_antibiotic_amoxi_clav_",
        },
        {
          value: 4096,
          label: "Streptomycine",
          label_translate: "_animal_details_antibiotic_streptomycine_",
        },
        {
          value: 8192,
          label: "Tetracycline",
          label_translate: "_animal_details_antibiotic_tetracycline_",
        },
        {
          value: 16384,
          label: "TrimSulfa",
          label_translate: "_animal_details_antibiotic_trim_sulfa_",
        },
        {
          value: 32768,
          label: "Polymixine",
          label_translate: "_animal_details_antibiotic_polymixine_",
        },
        {
          value: 65536,
          label: "Oxacilline",
          label_translate: "_animal_details_antibiotic_oxacilline_",
        },
      ],

      bacterium: [
        {
          value: 0,
          label: "None",
          label_translate: "_animal_details_bacterium_none_",
        },
        {
          value: 2,
          label: "Escherichia Coli",
          label_translate: "_animal_details_bacterium_escherichia_coli_",
        },
        {
          value: 4,
          label: "Enterobacterium",
          label_translate: "_animal_details_bacterium_enterobacterium_",
        },
        {
          value: 8,
          label: "Klebsiella Spp",
          label_translate: "_animal_details_bacterium_klebsiella_spp_",
        },
        {
          value: 16,
          label: "Non Coli form",
          label_translate: "_animal_details_bacterium_non_coli_form_",
        },
        {
          value: 32,
          label: "Staphylococcus Aureus",
          label_translate: "_animal_details_bacterium_staphylococcus_aureus_",
        },
        {
          value: 64,
          label: "Staphylococcus Spp",
          label_translate: "_animal_details_bacterium_staphylococcus_spp_",
        },
        {
          value: 128,
          label: "Corynebacterium Bovis",
          label_translate: "_animal_details_bacterium_corynebacterium_bovis_",
        },
        {
          value: 256,
          label: "Yeast",
          label_translate: "_animal_details_bacterium_yeast_",
        },
        {
          value: 512,
          label: "Aesculine Positive Cocci",
          label_translate:
            "_animal_details_bacterium_aesculine_positive_cocci_",
        },
        {
          value: 1024,
          label: "Aerococci Spp",
          label_translate: "_animal_details_bacterium_aerococci_spp_",
        },
        {
          value: 2048,
          label: "Lactococci Spp",
          label_translate: "_animal_details_bacterium_lactococci_spp_",
        },
        {
          value: 4096,
          label: "Streprococcus Uberis",
          label_translate: "_animal_details_bacterium_streprococcus_uberis_",
        },
        {
          value: 8192,
          label: "Arcanobacterium Pyogenes",
          label_translate:
            "_animal_details_bacterium_arcanobacterium_pyogenes_",
        },
        {
          value: 16384,
          label: "Streptococcus Agalactiae",
          label_translate:
            "_animal_details_bacterium_streptococcus_agalactiae_",
        },
        {
          value: 32768,
          label: "Streptococcus Dysgalactiae",
          label_translate:
            "_animal_details_bacterium_streptococcus_dysgalactiae_",
        },
        {
          value: 65536,
          label: "Mycoplasma",
          label_translate: "_animal_details_bacterium_mycoplasma_",
        },
        {
          value: 131072,
          label: "Poly Bacterial",
          label_translate: "_animal_details_bacterium_poly_bacterial_",
        },
        {
          value: 262144,
          label: "Negative",
          label_translate: "_animal_details_bacterium_negative_",
        },
      ],

      diseases: [
        {
          label: "Difficult Calving",
          value: 1,
          label_translate: "_animal_details_disease_difficult_calving_",
        },
        {
          label: "Retained Placenta",
          value: 2,
          label_translate: "_animal_details_disease_retained_placenta_",
        },
        {
          label: "Hypocalcemia",
          value: 3,
          label_translate: "_animal_details_disease_hypocalcemia_",
        },
        {
          label: "Metritis",
          value: 4,
          label_translate: "_animal_details_disease_metritis_",
        },
        {
          label: "LDA",
          value: 5,
          label_translate: "_animal_details_disease_lda_",
        },
        {
          label: "RDA",
          value: 6,
          label_translate: "_animal_details_disease_rda_",
        },
        {
          label: "Endometritis",
          value: 7,
          label_translate: "_animal_details_disease_endometritis_",
        },
        {
          label: "Ketosis",
          value: 8,
          label_translate: "_animal_details_disease_ketosis_",
        },
        {
          label: "Pneumonia",
          value: 9,
          label_translate: "_animal_details_disease_pneumonia_",
        },
        {
          label: "Enteritis",
          value: 10,
          label_translate: "_animal_details_disease_enteritis_",
        },
        {
          label: "TRP",
          value: 11,
          label_translate: "_animal_details_disease_trp_",
        },
        {
          label: "Peritonitis",
          value: 12,
          label_translate: "_animal_details_disease_peritonitis_",
        },
        {
          label: "Cocccidiosis",
          value: 13,
          label_translate: "_animal_details_disease_cocccidiosis_",
        },
        {
          label: "Cara",
          value: 14,
          label_translate: "_animal_details_disease_cara_",
        },
        {
          label: "Lungworm",
          value: 15,
          label_translate: "_animal_details_disease_lungworm_",
        },
        {
          label: "Parasit Gastro Enteritis",
          value: 16,
          label_translate: "_animal_details_disease_parasit_gastro_enteritis_",
        },
        {
          label: "Other",
          value: 17,
          label_translate: "_animal_details_disease_other_",
        },
        {
          label: "Twinning",
          value: 20,
          label_translate: "_animal_details_disease_twinning_",
        },
        {
          label: "FattyLiver",
          value: 21,
          label_translate: "_animal_details_disease_fatty_liver_",
        },
        {
          label: "Lame",
          value: 22,
          label_translate: "_animal_details_visit_reason_lame_",
        },
        {
          label: "DownerCow",
          value: 23,
          label_translate: "_animal_details_disease_downer_cow_",
        },
        {
          label: "Treatment",
          value: 24,
          label_translate: "_animal_treatment_",
        },
        {
          label: "Pyometra",
          value: 25,
          label_translate: "_animal_details_disease_pyometra_",
        },
        {
          label: "Bloat",
          value: 26,
          label_translate: "_animal_details_bloat_",
        },
        {
          label: "BovineViralDiarrhea",
          value: 27,
          label_translate: "_animal_details_bovine_viral_diarrhea_",
        },
        {
          label: "CysticOvarianFollicles",
          value: 28,
          label_translate: "_animal_details_cystic_ovarian_follicles_",
        },
        {
          label: "CysticCorpusLuteum",
          value: 29,
          label_translate: "_animal_details_cystic_corpus_luteum_",
        },
        {
          label: "Stillbirth",
          value: 30,
          label_translate: "_animal_details_stillbirth_",
        },
        {
          label: "ClinicalMastitis",
          value: 31,
          label_translate: "_animal_clinical_mastitis_",
        },
        {
          label: "SubclinicalMastitis",
          value: 32,
          label_translate: "_animal_subclinical_mastitis_",
        },
        {
          label: "ThreeTeat",
          value: 33,
          label_translate: "_animal_details_three_teat_",
        },
        {
          label: "Anoestrus",
          value: 35,
          label_translate: "_animal_details_anoestrus_",
        },
        {
          label: "DisplacedAbomasum",
          value: 36,
          label_translate: "_animal_details_displaced_abomasum_",
        },
        {
          label: "Omphilitis",
          value: 37,
          label_translate: "_animal_details_omphilitis_",
        },
        {
          label: "Suboestrus",
          value: 38,
          label_translate: "_animal_details_suboestrus_",
        },
      ],

      preventions: [
        {
          label: "Kexxtone",
          value: 1000,
          label_translate: "_animal_details_preventions_kexxtone_",
        },
        {
          label: "Bovikalc",
          value: 1001,
          label_translate: "_animal_details_preventions_bovikalc_",
        },
        {
          label: "Rotavec Corona",
          value: 1002,
          label_translate: "_animal_details_preventions_rotavec_corona_",
        },
        {
          label: "Teatsealer",
          value: 1003,
          label_translate: "_animal_details_preventions_teatsealer_",
        },
        {
          label: "Startvac",
          value: 1004,
          label_translate: "_animal_details_preventions_startvac_",
        },
        {
          label: "Imrestor",
          value: 1005,
          label_translate: "_animal_details_preventions_imrestor_",
        },
        {
          label: "Dry Off Products",
          value: 1006,
          label_translate: "_animal_details_preventions_dry_off_products_",
        },
      ],

      hoofTreatmentTypes: [
        {
          label: "Preventive Trim",
          value: 1,
          label_translate:
            "_animal_details_hoof_treatment_type_preventive_trim_",
        },
        {
          label: "Therapeutic Trim",
          value: 2,
          label_translate:
            "_animal_details_hoof_treatment_type_therapeutic_trim_",
        },
        {
          label: "Block",
          value: 4,
          label_translate: "_animal_details_hoof_treatment_type_block_",
        },
        {
          label: "Wrap",
          value: 8,
          label_translate: "_animal_details_hoof_treatment_type_wrap_",
        },
        {
          label: "Topical",
          value: 16,
          label_translate: "_animal_details_hoof_treatment_type_topical_",
        },
        {
          label: "Recheck",
          value: 2048,
          label_translate: "_animal_details_hoof_treatment_type_recheck_",
        },
        {
          label: "Two weeks",
          value: 128,
          label_translate: "_animal_details_hoof_treatment_type_two_weeks_",
        },
        {
          label: "One month",
          value: 256,
          label_translate: "_animal_details_hoof_treatment_type_one_month_",
        },
        {
          label: "Two months",
          value: 512,
          label_translate: "_animal_details_hoof_treatment_type_two_months_",
        },
        {
          label: "Three months",
          value: 1024,
          label_translate: "_animal_details_hoof_treatment_type_three_months_",
        },
        {
          label: "Antibiotic treatment",
          value: 4096,
          label_translate:
            "_animal_details_hoof_treatment_type_antibiotic_treatment_",
        },
        {
          label: "Conventional",
          value: 8192,
          label_translate: "_animal_details_hoof_treatment_type_conventional_",
        },
        {
          label: "One Day",
          value: 16384,
          label_translate: "_animal_details_hoof_recheck_one_day_",
        },
        {
          label: "Two Days",
          value: 32768,
          label_translate: "_animal_details_hoof_recheck_two_days",
        },
        {
          label: "Three Days",
          value: 65536,
          label_translate: "_animal_details_hoof_recheck_three_days",
        },
        {
          label: "Four Days",
          value: 131072,
          label_translate: "_animal_details_hoof_recheck_four_days_",
        },
        {
          label: "Five Days",
          value: 262144,
          label_translate: "_animal_details_hoof_recheck_five_days_",
        },
        {
          label: "Six Days",
          value: 524288,
          label_translate: "_animal_details_hoof_recheck_six_days_",
        },
        {
          label: "Seven Days",
          value: 1048576,
          label_translate: "_animal_details_hoof_recheck_seven_days_",
        },
        {
          label: "Eight Days",
          value: 2097152,
          label_translate: "_animal_details_hoof_recheck_eight_days_",
        },
        {
          label: "Nine Days",
          value: 4194304,
          label_translate: "_animal_details_hoof_recheck_nine_days_",
        },
        {
          label: "Ten Days",
          value: 8388608,
          label_translate: "_animal_details_hoof_recheck_ten_days_",
        },
        {
          label: "Eleven Days",
          value: 16777216,
          label_translate: "_animal_details_hoof_recheck_eleven_days_",
        },
        {
          label: "Twelve Days",
          value: 33554432,
          label_translate: "_animal_details_hoof_recheck_twelve_days",
        },
        {
          label: "Thirteen Days",
          value: 67108864,
          label_translate: "_animal_details_hoof_recheck_thirteen_days",
        },
        {
          label: "Fourteen Days",
          value: 134217728,
          label_translate: "_animal_details_hoof_recheck_fourteen_days",
        },
        {
          label: "Fifteen Days",
          value: 268435456,
          label_translate: "_animal_details_hoof_recheck_fifteen_days",
        },
      ],

      hoofLesionTypes: [
        {
          label: "Abcess(white line)",
          value: 2,
          label_translate: "_animal_details_hoof_lesion_type_abcess_",
        },
        {
          label: "Bruise",
          value: 4,
          label_translate: "_animal_details_hoof_lesion_type_bruise_",
        },
        {
          label: "Corn",
          value: 8,
          label_translate: "_animal_details_hoof_lesion_type_corn_",
        },
        {
          label: "Digital Dermatitis",
          value: 16,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_",
        },
        {
          label: "Erosion",
          value: 32,
          label_translate: "_animal_details_hoof_lesion_type_erosion_",
        },
        {
          label: "Foot Rot",
          value: 64,
          label_translate: "_animal_details_hoof_lesion_type_foot_rot_",
        },
        {
          label: "Deep Digital Sepsis",
          value: 128,
          label_translate:
            "_animal_details_hoof_lesion_type_deep_digital_sepsis_",
        },
        {
          label: "Hemorrhage",
          value: 256,
          label_translate: "_animal_details_hoof_lesion_type_hemorrhage_",
        },
        {
          label: "Upper Limb",
          value: 512,
          label_translate: "_animal_details_hoof_lesion_type_upper_limb_",
        },
        {
          label: "Rotated Claw",
          value: 1024,
          label_translate: "_animal_details_hoof_lesion_type_rotated_claw_",
        },
        {
          label: "Sole Fracture",
          value: 2048,
          label_translate: "_animal_details_hoof_lesion_type_sole_fracture_",
        },
        {
          label: "Toe Ulcer",
          value: 4096,
          label_translate: "_animal_details_hoof_lesion_type_toe_ulcer_",
        },
        {
          label: "Ulcer",
          value: 8196,
          label_translate: "_animal_details_hoof_lesion_type_ulcer_",
        },
        {
          label: "Vertical Fissure",
          value: 16384,
          label_translate: "_animal_details_hoof_lesion_type_vertical_fissure_",
        },
        //use toe necrosis instead hairy attack
        {
          label: "Toe Necrosis",
          value: 32768,
          label_translate: "_animal_details_hoof_lesion_type_toe_necrosis_",
        },
        {
          label: "Axial Wall Fissure",
          value: 65536,
          label_translate:
            "_animal_details_hoof_lesion_type_axial_wall_fissure_",
        },
        {
          label: "Horizontal Fissure",
          value: 131072,
          label_translate:
            "_animal_details_hoof_lesion_type_horizontal_fissure_",
        },
        {
          label: "Thin Soles",
          value: 262144,
          label_translate: "_animal_details_hoof_lesion_type_thin_soles_",
        },
        {
          label: "Toe Necrosis",
          value: 524288,
          label_translate: "_animal_details_hoof_lesion_type_toe_necrosis_",
        },
        {
          label: "DD D1",
          value: 1048576,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_d1_",
        },
        {
          label: "DD D2",
          value: 2097152,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_d2_",
        },
        {
          label: "DD D3",
          value: 4194304,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_d3_",
        },
        {
          label: "DD D4",
          value: 8388608,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_d4_",
        },
        {
          label: "DD D5",
          value: 16777216,
          label_translate:
            "_animal_details_hoof_lesion_type_digital_dermatitis_d5_",
        },
      ],

      hoofLesionSeverities: [
        {
          label: "Mild",
          value: 1,
          label_translate: "_animal_details_hoof_lesion_severity_mild_",
        },
        {
          label: "Mild Moderate",
          value: 2,
          label_translate:
            "_animal_details_hoof_lesion_severity_mild_moderate_",
        },
        {
          label: "Moderate",
          value: 3,
          label_translate: "_animal_details_hoof_lesion_severity_moderate_",
        },
        {
          label: "Moderate Severe",
          value: 4,
          label_translate:
            "_animal_details_hoof_lesion_severity_moderate_severe_",
        },
        {
          label: "Severe",
          value: 5,
          label_translate: "_animal_details_hoof_lesion_severity_severe_",
        },
      ],

      hoofReCheck: [
        {
          label: "No",
          value: 0,
          label_translate: "_animal_details_hoof_recheck_no_",
        },
        {
          label: "Two Weeks",
          value: 1,
          label_translate: "_animal_details_hoof_recheck_two_weeks_",
          v: 2,
          u: "weeks",
        },
        {
          label: "One Month",
          value: 2,
          label_translate: "_animal_details_hoof_recheck_one_month_",
          v: 1,
          u: "months",
        },
        {
          label: "Two Months",
          value: 3,
          label_translate: "_animal_details_hoof_recheck_two_months_",
          v: 2,
          u: "months",
        },
        {
          label: "Three Months",
          value: 4,
          label_translate: "_animal_details_hoof_recheck_three_months_",
          v: 3,
          u: "months",
        },
        {
          label: "One Day",
          value: 5,
          label_translate: "_animal_details_hoof_recheck_one_day_",
          v: 1,
          u: "days",
        },
        {
          label: "Two Days",
          value: 6,
          label_translate: "_animal_details_hoof_recheck_two_days",
          v: 2,
          u: "days",
        },
        {
          label: "Three Days",
          value: 7,
          label_translate: "_animal_details_hoof_recheck_three_days",
          v: 3,
          u: "days",
        },
        {
          label: "Four Days",
          value: 8,
          label_translate: "_animal_details_hoof_recheck_four_days_",
          v: 4,
          u: "days",
        },
        {
          label: "Five Days",
          value: 9,
          label_translate: "_animal_details_hoof_recheck_five_days_",
          v: 5,
          u: "days",
        },
        {
          label: "Six Days",
          value: 10,
          label_translate: "_animal_details_hoof_recheck_six_days_",
          v: 6,
          u: "days",
        },
        {
          label: "Seven Days",
          value: 11,
          label_translate: "_animal_details_hoof_recheck_seven_days_",
          v: 7,
          u: "days",
        },
        {
          label: "Eight Days",
          value: 12,
          label_translate: "_animal_details_hoof_recheck_eight_days_",
          v: 8,
          u: "days",
        },
        {
          label: "Nine Days",
          value: 13,
          label_translate: "_animal_details_hoof_recheck_nine_days_",
          v: 9,
          u: "days",
        },
        {
          label: "Ten Days",
          value: 14,
          label_translate: "_animal_details_hoof_recheck_ten_days_",
          v: 10,
          u: "days",
        },
        {
          label: "Eleven Days",
          value: 15,
          label_translate: "_animal_details_hoof_recheck_eleven_days_",
          v: 11,
          u: "days",
        },
        {
          label: "Twelve Days",
          value: 16,
          label_translate: "_animal_details_hoof_recheck_twelve_days",
          v: 12,
          u: "days",
        },
        {
          label: "Thirteen Days",
          value: 17,
          label_translate: "_animal_details_hoof_recheck_thirteen_days",
          v: 13,
          u: "days",
        },
        {
          label: "Fourteen Days",
          value: 18,
          label_translate: "_animal_details_hoof_recheck_fourteen_days",
          v: 14,
          u: "days",
        },
        {
          label: "Fifteen Days",
          value: 19,
          label_translate: "_animal_details_hoof_recheck_fifteen_days",
          v: 15,
          u: "days",
        },
        {
          label: "Recheck period unspecified",
          value: 255,
          label_translate: "_animal_details_hoof_recheck_period_unspecified_",
        },
      ],

      statesPermissionsList: [
        {
          state: "cockpit",
          permissionId: 43,
        },
        {
          state: "herds.animals",
          permissionId: 44,
        },
        {
          state: "animals",
          permissionId: 426,
        },
        {
          state: "animalDatails",
          permissionId: 44,
        },
        {
          state: "herds.listGenerator",
          permissionId: 45,
        },
        {
          state: "videos",
          permissionId: 46,
        },
        {
          state: "calendar",
          permissionId: 47,
        },
        {
          state: "treatments_protocols",
          permissionId: 48,
        },
        {
          state: "rap",
          permissionId: 49,
        },
        {
          state: "agroscoop",
          permissionId: 50,
        },
        {
          state: "home",
          permissionId: 42,
        },
        {
          state: "herds.dashboards",
          permissionId: 318,
        },
        {
          state: "clawHealth",
          permissionId: 163,
        },
        {
          state: "overview",
          permissionId: 234,
        },
        {
          state: "invoice",
          permissionId: 213,
        },
        {
          state: "importAnimals",
          permissionId: 212,
        },
        {
          state: "reproduction",
          permissionId: 233,
        },
        {
          state: "addNewHerd",
          permissionId: 214,
        },
        {
          state: "myHerds",
          permissionId: 214,
        },
        {
          state: "lists.trimList",
          permissionId: 217,
        },
        {
          state: "lists.recheckList",
          permissionId: 218,
        },
        {
          state: "production",
          permissionId: 232,
        },
        {
          state: "editHerd",
          permissionId: 214,
        },
        {
          state: "mro",
          permissionId: 230,
        },
        {
          state: "lactationAnalysis",
          permissionId: 229,
        },
        {
          state: "presalesAudit",
          permissionId: 231,
        },
        {
          state: "postSalesReport",
          permissionId: 252,
        },
        {
          state: "postSalesImport",
          permissionId: 253,
        },
        {
          state: "robot-view",
          permissionId: 294,
        },
        {
          state: "dq",
          permissionId: 316,
        },
        {
          state: "streamer-health",
          permissionId: 316,
        },
        {
          state: "lists.wrapList",
          permissionId: 317,
        },
        {
          state: "lists.blockList",
          permissionId: 317,
        },
        {
          state: "d-insemination-strategy-cows",
          permissionId: 343,
        },
        {
          state: "d-insemination-strategy-heifers",
          permissionId: 344,
        },
        {
          state: "d-conception-rate-cows",
          permissionId: 345,
        },
        {
          state: "d-oestrus-interval-analysis",
          permissionId: 347,
        },
        {
          state: "d-conception-strategy-heifers",
          permissionId: 346,
        },
        {
          state: "d-conception-cusum-analysis",
          permissionId: 346,
        },
        {
          state: "d-conception-cusum-analysis-heifers",
          permissionId: 346,
        },
        {
          state: "home-arvesta",
          permissionId: 357,
        },
        {
          state: "herd-overview",
          permissionId: 358,
        },
        {
          state: "milk-production.milk-trend",
          permissionId: 363,
        },
        {
          state: "milk-production.spp",
          permissionId: 364,
        },
        {
          state: "milk-production.components",
          permissionId: 365,
        },
        {
          state: "milk-production.pregnant",
          permissionId: 527,
        },
        {
          state: "milk-production.conductivity",
          permissionId: 528,
        },
        {
          state: "concentrate.feeding",
          permissionId: 367,
        },
        {
          state: "concentrate.intake",
          permissionId: 369,
        },
        {
          state: "concentrate.leftovers",
          permissionId: 368,
        },
        {
          state: "concentrate.overview",
          permissionId: 366,
        },
        {
          state: "milkings.actual",
          permissionId: 370,
        },
        {
          state: "milkings.refusals",
          permissionId: 371,
        },
        {
          state: "milkings.failures",
          permissionId: 372,
        },
        {
          state: "robot-efficiency.milk-hour",
          permissionId: 375,
        },
        {
          state: "robot-efficiency.milk-speed",
          permissionId: 374,
        },
        {
          state: "robot-efficiency.robot-prestations",
          permissionId: 373,
        },
        {
          state: "settings",
          permissionId: 14,
        },
        {
          state: "greeting-page",
          permissionId: 354,
        },
        {
          state: "herds.attention-mro",
          permissionId: 529,
        },
      ],

      // when dashboard name is changed update these translations
      dashboardIdList: [
        {
          name: "_rap_workbook_name_rap_main_herd_overview_",
          id: "_rap_workbook_id_rap_main_herd_overview_",
        },
        {
          name: "_rap_workbook_name_rap_herd_dashboard_",
          id: "_rap_workbook_id_rap_herd_dashboard_",
        },
        {
          name: "_rap_workbook_name_days_in_milk_trend_",
          id: "_rap_workbook_id_days_in_milk_trend_",
        },
        {
          name: "_rap_workbook_name_milk_yield_trend_",
          id: "_rap_workbook_id_milk_yield_trend_",
        },
        {
          name: "_rap_workbook_name_milk_yield_actual_",
          id: "_rap_workbook_id_milk_yield_actual_",
        },
        {
          name: "_rap_workbook_name_first_milk_yield_by_calving_date_",
          id: "_rap_workbook_id_first_milk_yield_by_calving_date_",
        },
        {
          name: "_rap_workbook_name_spp_trend_",
          id: "_rap_workbook_id_spp_trend_",
        },
        {
          name: "_rap_workbook_name_spp_actual_",
          id: "_rap_workbook_id_spp_actual_",
        },
        {
          name: "_rap_workbook_name_milkings_trend_",
          id: "_rap_workbook_id_milkings_trend_",
        },
        {
          name: "_rap_workbook_name_milkings_actual_",
          id: "_rap_workbook_id_milkings_actual_",
        },
        {
          name: "_rap_workbook_name_milk_milkings_actual_",
          id: "_rap_workbook_id_milk_milkings_actual_",
        },
        {
          name: "_rap_workbook_name_milk_milkings_trend_",
          id: "_rap_workbook_id_milk_milkings_trend_",
        },
        {
          name: "_rap_workbook_name_concentrate_yield_trend_",
          id: "_rap_workbook_id_concentrate_yield_trend_",
        },
        {
          name: "_rap_workbook_name_concentrate_actual_by_yield_",
          id: "_rap_workbook_id_concentrate_actual_by_yield_",
        },
        {
          name: "_rap_workbook_name_concentrate_kg_trend_",
          id: "_rap_workbook_id_concentrate_kg_trend_",
        },
        {
          name: "_rap_workbook_name_concentrate_actual_by_feed_",
          id: "_rap_workbook_id_concentrate_actual_by_feed_",
        },
        {
          name: "_rap_workbook_name_feed_intake_",
          id: "_rap_workbook_id_feed_intake_",
        },
        {
          name: "_rap_workbook_name_concentrate_actual_by_milk_production_",
          id: "_rap_workbook_id_concentrate_actual_by_milk_production_",
        },
        {
          name: "_rap_workbook_name_herd_prestations_actual_",
          id: "_rap_workbook_id_herd_prestations_actual_",
        },
        {
          name: "_rap_workbook_name_herd_prestations_trend_",
          id: "_rap_workbook_id_herd_prestations_trend_",
        },
        {
          name: "_rap_workbook_name_leftovers_trend_",
          id: "_rap_workbook_id_leftovers_trends_",
        },
        {
          name: "_rap_workbook_name_leftovers_actual_",
          id: "_rap_workbook_id_leftovers_actual_",
        },
        {
          name: "_rap_workbook_name_leftovers_actual_table_",
          id: "_rap_workbook_id_leftovers_actual_table_",
        },
        {
          name: "_rap_workbook_name_leftovers_actual_milk_speed_",
          id: "_rap_workbook_id_leftovers_actual_milk_speed_",
        },
        {
          name: "_dashboard_name_milk_yield_actual_by_date_",
          id: "_dashboard_id_milk_yield_actual_by_date_",
        },
        {
          name: "_dashboard_name_spp_actual_by_date_",
          id: "_dashboard_id_spp_actual_by_date_",
        },
        {
          name: "_dashboard_name_milkings_actual_by_date_",
          id: "_dashboard_id_milkings_actual_by_date_",
        },
        {
          name: "_rap_workbook_name_milk_milkings_actual_by_date_",
          id: "_rap_workbook_id_milk_milkings_actual_by_date_",
        },
        {
          name: "_dashboard_name_conc_actual_yield_by_date_",
          id: "_dashboard_id_conc_actual_yield_by_date_",
        },
        {
          name: "_dashboard_name_conc_actual_feed_by_date_",
          id: "_dashboard_id_conc_actual_feed_by_date_",
        },
        {
          name: "_dashboard_name_leftovers_actual_by_date_",
          id: "_dashboard_id_leftovers_actual_by_date_",
        },
        {
          name: "_dashboard_name_robot_prestations_dashboard_",
          id: "_dashboard_id_robot_prestations_dashboard_",
        },
        {
          name: "_dashboard_name_robot_prestations_trend_dashboard_",
          id: "_dashboard_id_robot_prestations_trend_dashboard_",
        },
        {
          name: "_dashboard_name_actual_dashboard_",
          id: "_dashboard_id_actual_dashboard_",
        },
        {
          name: "_dashboard_name_milk_yield_actual_by_date_robot_view_",
          id: "_dashboard_id_milk_yield_actual_by_date_robot_view_",
        },
        {
          name: "_dashboard_name_leftovers_actual_by_date_robot_view_",
          id: "_dashboard_id_leftovers_actual_by_date_robot_view_",
        },
      ],

      clawHealthdashboardIdLngList: [
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "en-GB",
          index: 1,
        },
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "en-US",
          index: 2,
        },
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "fr-FR",
          index: 3,
        },
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "de-DE",
          index: 4,
        },
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "nl-NL",
          index: 5,
        },
        {
          internal_id: "claw_health_dashboard",
          id: "Clawhealthdashboard",
          lng: "pl-PL",
          index: 6,
        },

        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "en-GB",
          index: 7,
        },
        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "en-US",
          index: 8,
        },
        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "fr-FR",
          index: 9,
        },
        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "de-DE",
          index: 10,
        },
        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "nl-NL",
          index: 11,
        },
        {
          internal_id: "number_of_cows_trimmed_dashboard",
          id: "Numberofcowstrimmeddashboard",
          lng: "pl-PL",
          index: 12,
        },

        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "en-GB",
          index: 13,
        },
        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "en-US",
          index: 14,
        },
        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "fr-FR",
          index: 15,
        },
        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "de-DE",
          index: 16,
        },
        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "nl-NL",
          index: 17,
        },
        {
          internal_id: "lesions_percentage_of_feet_trimmed_dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
          lng: "pl-PL",
          index: 18,
        },

        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "en-GB",
          index: 19,
        },
        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "en-US",
          index: 20,
        },
        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "fr-FR",
          index: 21,
        },
        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "de-DE",
          index: 22,
        },
        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "nl-NL",
          index: 23,
        },
        {
          internal_id: "lesions_percentage_of_all_lesions_dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
          lng: "pl-PL",
          index: 24,
        },

        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "en-GB",
          index: 25,
        },
        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "en-US",
          index: 26,
        },
        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "fr-FR",
          index: 27,
        },
        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "de-DE",
          index: 28,
        },
        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "nl-NL",
          index: 29,
        },
        {
          internal_id: "lesion_distribution_by_trim_date_dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
          lng: "pl-PL",
          index: 30,
        },

        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "en-GB",
          index: 31,
        },
        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "en-US",
          index: 32,
        },
        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "fr-FR",
          index: 33,
        },
        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "de-DE",
          index: 34,
        },
        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "nl-NL",
          index: 35,
        },
        {
          internal_id:
            "lesion_distribution_by_date_for_lactation_greater_than_zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
          lng: "pl-PL",
          index: 36,
        },

        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "en-GB",
          index: 37,
        },
        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "en-US",
          index: 38,
        },
        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "fr-FR",
          index: 39,
        },
        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "de-DE",
          index: 40,
        },
        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "nl-NL",
          index: 41,
        },
        {
          internal_id: "lesion_distribution_chronological_comparison",
          id: "Lesiondistributionchronologicalcomparison",
          lng: "pl-PL",
          index: 42,
        },

        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "en-GB",
          index: 43,
        },
        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "en-US",
          index: 44,
        },
        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "fr-FR",
          index: 45,
        },
        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "de-DE",
          index: 46,
        },
        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "nl-NL",
          index: 47,
        },
        {
          internal_id: "lesion_distributed_by_limb_dashboard",
          id: "Lesiondistributedbylimbdashboard",
          lng: "pl-PL",
          index: 48,
        },

        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "en-GB",
          index: 49,
        },
        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "en-US",
          index: 50,
        },
        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "fr-FR",
          index: 51,
        },
        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "de-DE",
          index: 52,
        },
        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "nl-NL",
          index: 53,
        },
        {
          internal_id: "lesion_distribution_of_limb_by_percentage_dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
          lng: "pl-PL",
          index: 54,
        },

        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "en-GB",
          index: 55,
        },
        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "en-US",
          index: 56,
        },
        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "fr-FR",
          index: 57,
        },
        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "de-DE",
          index: 58,
        },
        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "nl-NL",
          index: 59,
        },
        {
          internal_id: "lesions_distributed_by_dim_dashboard",
          id: "LesionsdistributedbyDIMdashboard",
          lng: "pl-PL",
          index: 60,
        },

        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "en-GB",
          index: 61,
        },
        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "en-US",
          index: 62,
        },
        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "fr-FR",
          index: 63,
        },
        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "de-DE",
          index: 64,
        },
        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "nl-NL",
          index: 65,
        },
        {
          internal_id: "lesions_distributed_by_dim_percentage_dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
          lng: "pl-PL",
          index: 66,
        },

        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "en-GB",
          index: 67,
        },
        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "en-US",
          index: 68,
        },
        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "fr-FR",
          index: 69,
        },
        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "de-DE",
          index: 70,
        },
        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "nl-NL",
          index: 71,
        },
        {
          internal_id: "lesions_distributed_by_parity_dashboard",
          id: "Lesionsdistributedbyparitydashboard",
          lng: "pl-PL",
          index: 72,
        },

        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "en-GB",
          index: 73,
        },
        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "en-US",
          index: 74,
        },
        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "fr-FR",
          index: 75,
        },
        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "de-DE",
          index: 76,
        },
        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "nl-NL",
          index: 77,
        },
        {
          internal_id: "lesions_by_parity_dashboard_percentage",
          id: "Lesionsbyparitydashboardpercentage",
          lng: "pl-PL",
          index: 78,
        },

        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "en-GB",
          index: 79,
        },
        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "en-US",
          index: 80,
        },
        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "fr-FR",
          index: 81,
        },
        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "de-DE",
          index: 82,
        },
        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "nl-NL",
          index: 83,
        },
        {
          internal_id: "digital_dermatitis_dashboard",
          id: "DigitalDermatitisDashboard",
          lng: "pl-PL",
          index: 84,
        },
      ],

      clawHealthdashboardIdList: [
        {
          name: "Claw health dashboard",
          id: "Clawhealthdashboard",
        },
        {
          name: "Number of cows trimmed dashboard",
          id: "Numberofcowstrimmeddashboard",
        },
        {
          name: "Lesions percentage of feet trimmed dashboard",
          id: "Lesionspercentageoffeettrimmeddashboard",
        },
        {
          name: "Lesions percentage of all lesions dashboard",
          id: "Lesionspercentageofalllesionsdashboard",
        },
        {
          name: "Lesion distribution by trim date dashboard",
          id: "Lesiondistributionbytrimdatedashboard",
        },
        {
          name: "Lesion distribution by date for lactation greater than zero",
          id: "Lesiondistributionbydateforlactationgreaterthanzero",
        },
        {
          name: "Lesion distribution chronological comparison",
          id: "Lesiondistributionchronologicalcomparison",
        },
        {
          name: "Lesion distributed by limb dashboard",
          id: "Lesiondistributedbylimbdashboard",
        },
        {
          name: "Lesion distribution of limb by percentage dashboard",
          id: "Lesiondistributionoflimbbypercentagedashboard",
        },
        {
          name: "Lesions distributed by DIM dashboard",
          id: "LesionsdistributedbyDIMdashboard",
        },
        {
          name: "Lesions distributed by DIM percentage dashboard",
          id: "LesionsdistributedbyDIMpercentagedashboard",
        },
        {
          name: "Lesions distributed by parity dashboard",
          id: "Lesionsdistributedbyparitydashboard",
        },
        {
          name: "Lesions by parity dashboard percentage",
          id: "Lesionsbyparitydashboardpercentage",
        },
        {
          name: "Digital Dermatitis Dashboard",
          id: "DigitalDermatitisDashboard",
        },
      ],

      // when dashboard name is changed update these ids
      dashboardIdLngList: [
        {
          internal_id: "rap_herd_dashboard",
          id: "RAPHerddashboard",
          lng: "en-GB",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,650",
        },
        {
          internal_id: "rap_herd_dashboard",
          id: "RAPHerddashboard",
          lng: "en-US",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,650",
        },
        {
          internal_id: "rap_herd_dashboard",
          id: "TableaudeborddutroupeauRAP",
          lng: "fr-FR",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,650",
        },
        {
          internal_id: "rap_herd_dashboard",
          id: "RAPHerdentabelle",
          lng: "de-DE",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,650",
        },
        {
          internal_id: "rap_herd_dashboard",
          id: "RAPBedrijfsdashboard",
          lng: "nl-NL",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,800",
        },
        {
          internal_id: "rap_herd_dashboard",
          id: "PulpitdanychstadaRAP",
          lng: "pl-PL",
          index: -2,
          selected: true,
          default: true,
          actual: false,
          size: "1050,800",
        },
        {
          internal_id: "herd_prestations_actual",
          id: "Herdprestationsactual",
          lng: "en-GB",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "herd_prestations_actual",
          id: "Herdprestationsactual",
          lng: "en-US",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "herd_prestations_actual",
          id: "Prestationsrellespourletroupeau",
          lng: "fr-FR",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "herd_prestations_actual",
          id: "tatschlicheHerdenvorhersage",
          lng: "de-DE",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "herd_prestations_actual",
          id: "Kuddeprestatiesactueel",
          lng: "nl-NL",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "herd_prestations_actual",
          id: "Aktualnystanstada",
          lng: "pl-PL",
          index: -1,
          selected: true,
          default: true,
          actual: true,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "RAPMainherdoverview",
          lng: "en-GB",
          index: 92,
          actual: false,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "RAPMainherdoverview",
          lng: "en-US",
          index: 92,
          actual: false,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "AperugnraldutroupeauRAP",
          lng: "fr-FR",
          index: 92,
          actual: false,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "RAPHauptherdenbersicht",
          lng: "de-DE",
          index: 92,
          actual: false,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "RAPHoofdoverzicht",
          lng: "nl-NL",
          index: 92,
          actual: false,
        },
        {
          internal_id: "rap_main_herd_overview",
          id: "PrzegldstadagwnegoRAP",
          lng: "pl-PL",
          index: 92,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Milkyieldtrend",
          lng: "en-GB",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Milkyieldtrend",
          lng: "en-US",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Tendancedelaproductionlaitire",
          lng: "fr-FR",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Milchleistungsentwicklung",
          lng: "de-DE",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Melkproductietrend",
          lng: "nl-NL",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_trend",
          id: "Trendwydajnocimlecznej",
          lng: "pl-PL",
          index: 93,
          actual: false,
        },
        {
          internal_id: "milk_yield_actual",
          id: "Milkyieldactual",
          lng: "en-GB",
          index: 94,
          actual: true,
        },
        {
          internal_id: "milk_yield_actual",
          id: "Milkyieldactual",
          lng: "en-US",
          index: 94,
          actual: true,
        },
        {
          internal_id: "milk_yield_actual",
          id: "Productionlaitirerelle",
          lng: "fr-FR",
          index: 94,
          actual: true,
        },
        {
          internal_id: "milk_yield_actual",
          id: "tatschlicheMilchleistung",
          lng: "de-DE",
          index: 94,
          actual: true,
        },
        {
          internal_id: "milk_yield_actual",
          id: "Melkproductieactueel",
          lng: "nl-NL",
          index: 94,
          actual: true,
        },
        {
          internal_id: "milk_yield_actual",
          id: "Aktualnawydajnomleczna",
          lng: "pl-PL",
          index: 94,
          actual: true,
        },
        {
          internal_id: "first_milk",
          id: "Firstmilkyieldbycalvingdate",
          lng: "en-GB",
          index: 95,
          actual: false,
        },
        {
          internal_id: "first_milk",
          id: "Firstmilkyieldbycalvingdate",
          lng: "en-US",
          index: 95,
          actual: false,
        },
        {
          internal_id: "first_milk",
          id: "Premireproductionlaitirepardatedevlage",
          lng: "fr-FR",
          index: 95,
          actual: false,
        },
        {
          internal_id: "first_milk",
          id: "ErsteMilchleistungnachKalbedatum",
          lng: "de-DE",
          index: 95,
          actual: false,
        },
        {
          internal_id: "first_milk",
          id: "Eerstemelkproductievolgenskalfdatum",
          lng: "nl-NL",
          index: 95,
          actual: false,
        },
        {
          internal_id: "first_milk",
          id: "Wydajnopierwszegomlekawedugdatywycielenia",
          lng: "pl-PL",
          index: 95,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "SPPtrend",
          lng: "en-GB",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "SPPtrend",
          lng: "en-US",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "TendanceBSK",
          lng: "fr-FR",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "BSK-Entwicklung",
          lng: "de-DE",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "BSKtrend",
          lng: "nl-NL",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_trend",
          id: "TrendSPS",
          lng: "pl-PL",
          index: 96,
          actual: false,
        },
        {
          internal_id: "spp_actual",
          id: "SPPactual",
          lng: "en-GB",
          index: 97,
          actual: true,
        },
        {
          internal_id: "spp_actual",
          id: "SPPactual",
          lng: "en-US",
          index: 97,
          actual: true,
        },
        {
          internal_id: "spp_actual",
          id: "BSKrel",
          lng: "fr-FR",
          index: 97,
          actual: true,
        },
        {
          internal_id: "spp_actual",
          id: "tatschlicheBSK",
          lng: "de-DE",
          index: 97,
          actual: true,
        },
        {
          internal_id: "spp_actual",
          id: "BSKactueel",
          lng: "nl-NL",
          index: 97,
          actual: true,
        },
        {
          internal_id: "spp_actual",
          id: "SPSaktualne",
          lng: "pl-PL",
          index: 97,
          actual: true,
        },
        {
          internal_id: "conc_yield_trend",
          id: "Concentrateyieldtrend",
          lng: "en-GB",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_yield_trend",
          id: "Concentrateyieldtrend",
          lng: "en-US",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_yield_trend",
          id: "Tendancedelaconsommationdeconcentrs",
          lng: "fr-FR",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_yield_trend",
          id: "EntwicklungderKraftfutterleistung",
          lng: "de-DE",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_yield_trend",
          id: "Krachtvoergifttrend",
          lng: "nl-NL",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_yield_trend",
          id: "Concentrateyieldtrend",
          lng: "pl-PL",
          index: 912,
          actual: false,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "Concentrateactualbyyield",
          lng: "en-GB",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "Concentrateactualbyyield",
          lng: "en-US",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "Concentrrelenfonctiondustadedelactation",
          lng: "fr-FR",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "tatschlichesKraftfutternachLeistung",
          lng: "de-DE",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "Krachtvoeractueelvolgensproductie",
          lng: "nl-NL",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_yield",
          id: "Paszatreciwawedugwydajnoci",
          lng: "pl-PL",
          index: 913,
          actual: true,
        },
        {
          internal_id: "conc_kg_trend",
          id: "Concentratekgtrend",
          lng: "en-GB",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_kg_trend",
          id: "Concentratekgtrend",
          lng: "en-US",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_kg_trend",
          id: "TendancedelaconsommationdeconcentrsKg",
          lng: "fr-FR",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_kg_trend",
          id: "KraftfutterecntwiklungK",
          lng: "de-DE",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_kg_trend",
          id: "Krachtvoerkgtrend",
          lng: "nl-NL",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_kg_trend",
          id: "Trendpobraniapaszytreciwejkg",
          lng: "pl-PL",
          index: 914,
          actual: false,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "Concentrateactualbyfeed",
          lng: "en-GB",
          index: 915,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "Concentrateactualbyfeed",
          lng: "en-US",
          index: 915,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "Concentrskgenfonctiondustadedelactation",
          lng: "fr-FR",
          index: 915,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "tatschlichesKraftfutternachFutter",
          lng: "de-DE",
          index: 915,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "Krachtvoeractueelvolgensvoer",
          lng: "nl-NL",
          index: 915,
          actual: true,
        },
        {
          internal_id: "conc_actual_by_feed",
          id: "Aktualnazawartopaszytreciwejwywieniu",
          lng: "pl-PL",
          index: 915,
          actual: true,
        },
        {
          internal_id: "feed_intake",
          id: "FeedIntake",
          lng: "en-GB",
          index: 916,
          actual: false,
        },
        {
          internal_id: "feed_intake",
          id: "FeedIntake",
          lng: "en-US",
          index: 916,
          actual: false,
        },
        {
          internal_id: "feed_intake",
          id: "Alimentation",
          lng: "fr-FR",
          index: 916,
          actual: false,
        },
        {
          internal_id: "feed_intake",
          id: "Futteraufnahme",
          lng: "de-DE",
          index: 916,
          actual: false,
        },
        {
          internal_id: "feed_intake",
          id: "Voeropname",
          lng: "nl-NL",
          index: 916,
          actual: false,
        },
        {
          internal_id: "feed_intake",
          id: "Pobraniepaszy",
          lng: "pl-PL",
          index: 916,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "Herdprestationstrend",
          lng: "en-GB",
          index: 919,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "Herdprestationstrend",
          lng: "en-US",
          index: 919,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "Tendancedesprestationsdutroupeau",
          lng: "fr-FR",
          index: 919,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "EntwicklungderHerdenvorhersage",
          lng: "de-DE",
          index: 919,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "Kuddeprestatiestrend",
          lng: "nl-NL",
          index: 919,
          actual: false,
        },
        {
          internal_id: "herd_prestations_trend",
          id: "Trendpreferencjistada",
          lng: "pl-PL",
          index: 919,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "Robotprestationsdashboard",
          lng: "en-GB",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "Robotprestationsdashboard",
          lng: "en-US",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "Prestationsdurobottableaudebord",
          lng: "fr-FR",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "RobotervorhersagenTabelle",
          lng: "de-DE",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "Robotprestatiesdashboard",
          lng: "nl-NL",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_dashboard",
          id: "Pulpitnawigacyjnyprestacjirobotw",
          lng: "pl-PL",
          index: 950,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "Robotprestationstrenddashboard",
          lng: "en-GB",
          index: 951,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "Robotprestationstrenddashboard",
          lng: "en-US",
          index: 951,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "Prestationsdurobottendancetableaudebord",
          lng: "fr-FR",
          index: 951,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "RobotervorhersagenEntwicklungtabelle",
          lng: "de-DE",
          index: 951,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "Robotprestatiestrenddashboard",
          lng: "nl-NL",
          index: 951,
          actual: false,
        },
        {
          internal_id: "robot_prestations_trend_dashboard",
          id: "Pulpitnawigacyjnytrendwprezentacjirobota",
          lng: "pl-PL",
          index: 951,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "Daysinmilktrend",
          lng: "en-GB",
          index: 921,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "Daysinmilktrend",
          lng: "en-US",
          index: 921,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "Tendancedesjoursdelactation",
          lng: "fr-FR",
          index: 921,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "EntwicklungderTageimMilch",
          lng: "de-DE",
          index: 921,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "Dageninlactatietrend",
          lng: "nl-NL",
          index: 921,
          actual: false,
        },
        {
          internal_id: "days_in_milk_trend",
          id: "Trenddnilaktacji",
          lng: "pl-PL",
          index: 921,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "Leftoverstrend",
          lng: "en-GB",
          index: 922,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "Leftoverstrend",
          lng: "en-US",
          index: 922,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "Tendancedesrestesaliments",
          lng: "fr-FR",
          index: 922,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "EntwicklungderReste",
          lng: "de-DE",
          index: 922,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "Restvoertrend",
          lng: "nl-NL",
          index: 922,
          actual: false,
        },
        {
          internal_id: "leftovers_trend",
          id: "Trendresztek",
          lng: "pl-PL",
          index: 922,
          actual: false,
        },

        {
          internal_id: "leftovers_actual",
          id: "Leftoversactual",
          lng: "en-GB",
          index: 923,
          actual: true,
        },
        {
          internal_id: "leftovers_actual",
          id: "Leftoversactual",
          lng: "en-US",
          index: 923,
          actual: true,
        },
        {
          internal_id: "leftovers_actual",
          id: "Restesactuels",
          lng: "fr-FR",
          index: 923,
          actual: true,
        },
        {
          internal_id: "leftovers_actual",
          id: "tatschlicheReste",
          lng: "de-DE",
          index: 923,
          actual: true,
        },
        {
          internal_id: "leftovers_actual",
          id: "Restvoeractueel",
          lng: "nl-NL",
          index: 923,
          actual: true,
        },
        {
          internal_id: "leftovers_actual",
          id: "Aktualnepozostaoci",
          lng: "pl-PL",
          index: 923,
          actual: true,
        },

        {
          internal_id: "leftovers_actual_table",
          id: "LeftoversactualTable",
          lng: "en-GB",
          index: 924,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_table",
          id: "LeftoversactualTable",
          lng: "en-US",
          index: 924,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_table",
          id: "Tableaudesrestesdaliments",
          lng: "fr-FR",
          index: 924,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_table",
          id: "TabellemitderzeitigenResten",
          lng: "de-DE",
          index: 924,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_table",
          id: "Restvoeractueeltabel",
          lng: "nl-NL",
          index: 924,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_table",
          id: "Aktualnatabelapozostaoci",
          lng: "pl-PL",
          index: 924,
          actual: true,
        },

        {
          internal_id: "leftovers_actual_milk_speed",
          id: "LeftoversactualMilkSpeed",
          lng: "en-GB",
          index: 926,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_milk_speed",
          id: "LeftoversactualMilkSpeed",
          lng: "en-US",
          index: 926,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_milk_speed",
          id: "Restealimentsenfonctiondelavitessedetraite",
          lng: "fr-FR",
          index: 925,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_milk_speed",
          id: "RestederzeitigerMelkgeschwindigkeit",
          lng: "de-DE",
          index: 925,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_milk_speed",
          id: "Restvoeractueelmelksnelheid",
          lng: "nl-NL",
          index: 925,
          actual: true,
        },
        {
          internal_id: "leftovers_actual_milk_speed",
          id: "Aktualnaprdkoudoju",
          lng: "pl-PL",
          index: 925,
          actual: true,
        },

        {
          internal_id: "milkings_actual",
          id: "Milkingsactual",
          lng: "en-GB",
          index: 926,
          actual: true,
        },
        {
          internal_id: "milkings_actual",
          id: "Milkingsactual",
          lng: "en-US",
          index: 926,
          actual: true,
        },
        {
          internal_id: "milkings_actual",
          id: "Traitesrelles",
          lng: "fr-FR",
          index: 926,
          actual: true,
        },
        {
          internal_id: "milkings_actual",
          id: "tatschlicheMelkvorgnge",
          lng: "de-DE",
          index: 926,
          actual: true,
        },
        {
          internal_id: "milkings_actual",
          id: "Melkingenactueel",
          lng: "nl-NL",
          index: 926,
          actual: true,
        },
        {
          internal_id: "milkings_actual",
          id: "Udojeaktualne",
          lng: "pl-PL",
          index: 926,
          actual: true,
        },

        {
          internal_id: "milkings_trend",
          id: "Milkingstrend",
          lng: "en-GB",
          index: 927,
          actual: false,
        },
        {
          internal_id: "milkings_trend",
          id: "Milkingstrend",
          lng: "en-US",
          index: 927,
          actual: false,
        },
        {
          internal_id: "milkings_trend",
          id: "Tendancetraites",
          lng: "fr-FR",
          index: 927,
          actual: false,
        },
        {
          internal_id: "milkings_trend",
          id: "EndwicklungderMelkungen",
          lng: "de-DE",
          index: 927,
          actual: false,
        },
        {
          internal_id: "milkings_trend",
          id: "Melkingentrend",
          lng: "nl-NL",
          index: 927,
          actual: false,
        },
        {
          internal_id: "milkings_trend",
          id: "Trendudojw",
          lng: "pl-PL",
          index: 927,
          actual: false,
        },

        {
          internal_id: "milk_milkings_actual",
          id: "MilkMilkingsactual",
          lng: "en-GB",
          index: 928,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual",
          id: "MilkMilkingsactual",
          lng: "en-US",
          index: 928,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual",
          id: "LaitTraitesenfonctiondustadedelactation",
          lng: "fr-FR",
          index: 928,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual",
          id: "MilchtatschlicheMelkungen",
          lng: "de-DE",
          index: 928,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual",
          id: "Melkmelkingactueel",
          lng: "nl-NL",
          index: 928,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual",
          id: "MlekoUdojeaktualne",
          lng: "pl-PL",
          index: 928,
          actual: true,
        },

        {
          internal_id: "milk_milkings_trend",
          id: "MilkMilkingstrend",
          lng: "en-GB",
          index: 929,
          actual: false,
        },
        {
          internal_id: "milk_milkings_trend",
          id: "MilkMilkingstrend",
          lng: "en-US",
          index: 929,
          actual: false,
        },
        {
          internal_id: "milk_milkings_trend",
          id: "Tendancelaittraites",
          lng: "fr-FR",
          index: 929,
          actual: false,
        },
        {
          internal_id: "milk_milkings_trend",
          id: "MilchMelkungenEntwicklung",
          lng: "de-DE",
          index: 929,
          actual: false,
        },
        {
          internal_id: "milk_milkings_trend",
          id: "Melkmelkingtrend",
          lng: "nl-NL",
          index: 929,
          actual: false,
        },
        {
          internal_id: "milk_milkings_trend",
          id: "Trendmlekoudoje",
          lng: "pl-PL",
          index: 929,
          actual: false,
        },

        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "Concentrateactualbymilkproduction",
          lng: "en-GB",
          index: 930,
          actual: true,
        },
        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "Concentrateactualbymilkproduction",
          lng: "en-US",
          index: 930,
          actual: true,
        },
        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "Consommationdeconcentrsenfonctiondelaproductiondelait",
          lng: "fr-FR",
          index: 930,
          actual: true,
        },
        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "tatschlichesKraftfutternachMilchproduktion",
          lng: "de-DE",
          index: 930,
          actual: true,
        },
        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "Krachtvoeractueelvolgensmelkproductie",
          lng: "nl-NL",
          index: 930,
          actual: true,
        },
        {
          internal_id: "concentrate_actual_by_milk_production",
          id: "Aktualnailopaszytreciwejkgkrowwedugprodukcjimleka",
          lng: "pl-PL",
          index: 930,
          actual: true,
        },

        {
          internal_id: "actual_dashboard",
          id: "Actualdashboard",
          lng: "en-GB",
          index: 950,
          actual: true,
        },
        {
          internal_id: "actual_dashboard",
          id: "Actualdashboard",
          lng: "en-US",
          index: 950,
          actual: true,
        },
        {
          internal_id: "actual_dashboard",
          id: "Actualdashboard",
          lng: "fr-FR",
          index: 950,
          actual: true,
        },
        {
          internal_id: "actual_dashboard",
          id: "Actualdashboard",
          lng: "de-DE",
          index: 950,
          actual: true,
        },
        {
          internal_id: "actual_dashboard",
          id: "Actualdashboard",
          lng: "nl-NL",
          index: 950,
          actual: true,
        },
        {
          internal_id: "actual_dashboard",
          id: "Aktualnypulpitnawigacyjny",
          lng: "pl-PL",
          index: 950,
          actual: true,
        },

        ///agroscoop

        //pl missing

        {
          internal_id: "tank_milkmeter_actual_dashboard",
          id: "TankMilkmeterActualDashboard",
          lng: "en-GB",
          index: 931,
          actual: true,
        },
        {
          internal_id: "tank_milkmeter_actual_dashboard",
          id: "TankMilkmeterActualDashboard",
          lng: "en-US",
          index: 931,
          actual: true,
        },
        {
          internal_id: "tank_milkmeter_actual_dashboard",
          id: "TankMilkmeterActualDashboard",
          lng: "fr-FR",
          index: 931,
          actual: true,
        },
        {
          internal_id: "tank_milkmeter_actual_dashboard",
          id: "TankMilkmeterActualDashboard",
          lng: "de-DE",
          index: 931,
          actual: true,
        },
        {
          internal_id: "tank_milkmeter_actual_dashboard",
          id: "TankMilkmeterActualDashboard",
          lng: "nl-NL",
          index: 931,
          actual: true,
        },

        {
          internal_id: "mro_actual_dashboard",
          id: "MROActualDashboard",
          lng: "en-GB",
          index: 932,
          actual: true,
        },
        {
          internal_id: "mro_actual_dashboard",
          id: "MROActualDashboard",
          lng: "en-US",
          index: 932,
          actual: true,
        },
        {
          internal_id: "mro_actual_dashboard",
          id: "MROActualDashboard",
          lng: "fr-FR",
          index: 932,
          actual: true,
        },
        {
          internal_id: "mro_actual_dashboard",
          id: "MROActualDashboard",
          lng: "de-DE",
          index: 932,
          actual: true,
        },
        {
          internal_id: "mro_actual_dashboard",
          id: "MROActualDashboard",
          lng: "nl-NL",
          index: 932,
          actual: true,
        },

        {
          internal_id: "herd_dashboard",
          id: "HerdDashboard",
          lng: "en-GB",
          index: 933,
          actual: false,
        },
        {
          internal_id: "herd_dashboard",
          id: "HerdDashboard",
          lng: "en-US",
          index: 933,
          actual: false,
        },
        {
          internal_id: "herd_dashboard",
          id: "HerdDashboard",
          lng: "fr-FR",
          index: 933,
          actual: false,
        },
        {
          internal_id: "herd_dashboard",
          id: "HerdDashboard",
          lng: "de-DE",
          index: 933,
          actual: false,
        },
        {
          internal_id: "herd_dashboard",
          id: "Bedrijfsdashboard",
          lng: "nl-NL",
          index: 933,
          actual: false,
        },

        {
          internal_id: "milk_production_dashboard",
          id: "MilkProductionDashboard",
          lng: "en-GB",
          index: 934,
          actual: false,
        },
        {
          internal_id: "milk_production_dashboard",
          id: "MilkProductionDashboard",
          lng: "en-US",
          index: 934,
          actual: false,
        },
        {
          internal_id: "milk_production_dashboard",
          id: "MilkProductionDashboard",
          lng: "fr-FR",
          index: 934,
          actual: false,
        },
        {
          internal_id: "milk_production_dashboard",
          id: "MilkProductionDashboard",
          lng: "de-DE",
          index: 934,
          actual: false,
        },
        {
          internal_id: "milk_production_dashboard",
          id: "MelkproductieDashboard",
          lng: "nl-NL",
          index: 934,
          actual: false,
        },

        {
          internal_id: "milk_production_actual_dashboard",
          id: "MilkProductionActualDashboard",
          lng: "en-GB",
          index: 935,
          actual: false,
        },
        {
          internal_id: "milk_production_actual_dashboard",
          id: "MilkProductionActualDashboard",
          lng: "en-US",
          index: 935,
          actual: false,
        },
        {
          internal_id: "milk_production_actual_dashboard",
          id: "MilkProductionActualDashboard",
          lng: "fr-FR",
          index: 935,
          actual: false,
        },
        {
          internal_id: "milk_production_actual_dashboard",
          id: "MilkProductionActualDashboard",
          lng: "de-DE",
          index: 935,
          actual: false,
        },
        {
          internal_id: "milk_production_actual_dashboard",
          id: "MelkproductieActueelDashboard",
          lng: "nl-NL",
          index: 935,
          actual: false,
        },

        {
          internal_id: "milk_production_trend_dashboard",
          id: "MilkProductionTrendsDashboard",
          lng: "en-GB",
          index: 936,
          actual: false,
        },
        {
          internal_id: "milk_production_trend_dashboard",
          id: "MilkProductionTrendsDashboard",
          lng: "en-US",
          index: 936,
          actual: false,
        },
        {
          internal_id: "milk_production_trend_dashboard",
          id: "MilkProductionTrendsDashboard",
          lng: "fr-FR",
          index: 936,
          actual: false,
        },
        {
          internal_id: "milk_production_trend_dashboard",
          id: "MilkProductionTrendsDashboard",
          lng: "de-DE",
          index: 936,
          actual: false,
        },
        {
          internal_id: "milk_production_trend_dashboard",
          id: "MilkProductionTrendsDashboard",
          lng: "nl-NL",
          index: 936,
          actual: false,
        },

        {
          internal_id: "protein_percentage_dashboard",
          id: "ProteinPercentageDashboard",
          lng: "en-GB",
          index: 937,
          actual: false,
        },
        {
          internal_id: "protein_percentage_dashboard",
          id: "ProteinPercentageDashboard",
          lng: "en-US",
          index: 937,
          actual: false,
        },
        {
          internal_id: "protein_percentage_dashboard",
          id: "ProteinPercentageDashboard",
          lng: "fr-FR",
          index: 937,
          actual: false,
        },
        {
          internal_id: "protein_percentage_dashboard",
          id: "ProteinPercentageDashboard",
          lng: "de-DE",
          index: 937,
          actual: false,
        },
        {
          internal_id: "protein_percentage_dashboard",
          id: "ProteinPercentageDashboard",
          lng: "nl-NL",
          index: 937,
          actual: false,
        },

        {
          internal_id: "fat_protein_percentage_dashboard",
          id: "FatProteinPercentageDashboard",
          lng: "en-GB",
          index: 938,
          actual: false,
        },
        {
          internal_id: "fat_protein_percentage_dashboard",
          id: "FatProteinPercentageDashboard",
          lng: "en-US",
          index: 938,
          actual: false,
        },
        {
          internal_id: "fat_protein_percentage_dashboard",
          id: "FatProteinPercentageDashboard",
          lng: "fr-FR",
          index: 938,
          actual: false,
        },
        {
          internal_id: "fat_protein_percentage_dashboard",
          id: "FatProteinPercentageDashboard",
          lng: "de-DE",
          index: 938,
          actual: false,
        },
        {
          internal_id: "fat_protein_percentage_dashboard",
          id: "FatProteinPercentageDashboard",
          lng: "nl-NL",
          index: 938,
          actual: false,
        },

        {
          internal_id: "urea_actual_dashboard",
          id: "UreaActualDashboard",
          lng: "en-GB",
          index: 940,
          actual: true,
        },
        {
          internal_id: "urea_actual_dashboard",
          id: "UreaActualDashboard",
          lng: "en-US",
          index: 940,
          actual: true,
        },
        {
          internal_id: "urea_actual_dashboard",
          id: "UreaActualDashboard",
          lng: "fr-FR",
          index: 940,
          actual: true,
        },
        {
          internal_id: "urea_actual_dashboard",
          id: "UreaActualDashboard",
          lng: "de-DE",
          index: 940,
          actual: true,
        },
        {
          internal_id: "urea_actual_dashboard",
          id: "UreaActualDashboard",
          lng: "nl-NL",
          index: 940,
          actual: true,
        },

        {
          internal_id: "urea_trends_dashboard",
          id: "UreaTrendsDashboard",
          lng: "en-GB",
          index: 941,
          actual: false,
        },
        {
          internal_id: "urea_trends_dashboard",
          id: "UreaTrendsDashboard",
          lng: "en-US",
          index: 941,
          actual: false,
        },
        {
          internal_id: "urea_trends_dashboard",
          id: "UreaTrendsDashboard",
          lng: "fr-FR",
          index: 941,
          actual: false,
        },
        {
          internal_id: "urea_trends_dashboard",
          id: "UreaTrendsDashboard",
          lng: "de-DE",
          index: 941,
          actual: false,
        },
        {
          internal_id: "urea_trends_dashboard",
          id: "UreaTrendsDashboard",
          lng: "nl-NL",
          index: 941,
          actual: false,
        },

        {
          internal_id: "milkmeter_dashboard",
          id: "Milkmeterdashboard",
          lng: "en-GB",
          index: 942,
          actual: false,
        },
        {
          internal_id: "milkmeter_dashboard",
          id: "Milkmeterdashboard",
          lng: "en-US",
          index: 942,
          actual: false,
        },
        {
          internal_id: "milkmeter_dashboard",
          id: "Tableaudebordducompteurlait",
          lng: "fr-FR",
          index: 942,
          actual: false,
        },
        {
          internal_id: "milkmeter_dashboard",
          id: "TabelleMilchmenge",
          lng: "de-DE",
          index: 942,
          actual: false,
        },
        {
          internal_id: "milkmeter_dashboard",
          id: "Melkmeterdashboard",
          lng: "nl-NL",
          index: 942,
          actual: false,
        },

        {
          internal_id: "milk_yield_by_date_dashboard",
          id: "Milkyieldactualbydate",
          lng: "en-GB",
          index: 943,
          actual: true,
        },
        {
          internal_id: "milk_yield_by_date_dashboard",
          id: "Milkyieldactualbydate",
          lng: "en-US",
          index: 943,
          actual: true,
        },
        {
          internal_id: "milk_yield_by_date_dashboard",
          id: "Productiondelaitrelletendance",
          lng: "fr-FR",
          index: 943,
          actual: true,
        },
        {
          internal_id: "milk_yield_by_date_dashboard",
          id: "Milchproduktiontatschlicherentwicklung",
          lng: "de-DE",
          index: 943,
          actual: true,
        },
        {
          internal_id: "milk_yield_by_date_dashboard",
          id: "Melkproductieactueeltrend",
          lng: "nl-NL",
          index: 943,
          actual: true,
        },

        {
          internal_id: "spp_by_date_dashboard",
          id: "SPPactualbydate",
          lng: "en-GB",
          index: 944,
          actual: true,
        },
        {
          internal_id: "spp_by_date_dashboard",
          id: "SPPactualbydate",
          lng: "en-US",
          index: 944,
          actual: true,
        },
        {
          internal_id: "spp_by_date_dashboard",
          id: "SPPreltendance",
          lng: "fr-FR",
          index: 944,
          actual: true,
        },
        {
          internal_id: "spp_by_date_dashboard",
          id: "BSKtatschlicherentwicklung",
          lng: "de-DE",
          index: 944,
          actual: true,
        },
        {
          internal_id: "spp_by_date_dashboard",
          id: "BSKactueeltrend",
          lng: "nl-NL",
          index: 944,
          actual: true,
        },

        {
          internal_id: "milkings_actual_by_date_dashboard",
          id: "Milkingsactualbydate",
          lng: "en-GB",
          index: 945,
          actual: true,
        },
        {
          internal_id: "milkings_actual_by_date_dashboard",
          id: "Milkingsactualbydate",
          lng: "en-US",
          index: 945,
          actual: true,
        },
        {
          internal_id: "milkings_actual_by_date_dashboard",
          id: "Traitesactuallestendance",
          lng: "fr-FR",
          index: 945,
          actual: true,
        },
        {
          internal_id: "milkings_actual_by_date_dashboard",
          id: "Melkungentatschlicherentwicklung",
          lng: "de-DE",
          index: 945,
          actual: true,
        },
        {
          internal_id: "milkings_actual_by_date_dashboard",
          id: "Melkingenactueeltrend",
          lng: "nl-NL",
          index: 945,
          actual: true,
        },

        {
          internal_id: "milk_milkings_actual_by_date_dashboard",
          id: "MilkMilkingsactualbydate",
          lng: "en-GB",
          index: 946,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual_by_date_dashboard",
          id: "MilkMilkingsactualbydate",
          lng: "en-US",
          index: 946,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual_by_date_dashboard",
          id: "Laittraiteactuelletendance",
          lng: "fr-FR",
          index: 946,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual_by_date_dashboard",
          id: "MilchMelkungtatschlicherentwicklung",
          lng: "de-DE",
          index: 946,
          actual: true,
        },
        {
          internal_id: "milk_milkings_actual_by_date_dashboard",
          id: "Melkmelkingactueeltrend",
          lng: "nl-NL",
          index: 946,
          actual: true,
        },

        {
          internal_id: "conc_actual_yield_by_date_dashboard",
          id: "Concentrateactualbyyieldbydate",
          lng: "en-GB",
          index: 947,
          actual: true,
        },
        {
          internal_id: "conc_actual_yield_by_date_dashboard",
          id: "Concentrateactualbyyieldbydate",
          lng: "en-US",
          index: 947,
          actual: true,
        },
        {
          internal_id: "conc_actual_yield_by_date_dashboard",
          id: "Concentrrelenfonctiondelaproductiontendance",
          lng: "fr-FR",
          index: 947,
          actual: true,
        },
        {
          internal_id: "conc_actual_yield_by_date_dashboard",
          id: "TatschlichesKraftfutterdurchLeistungentwicklung",
          lng: "de-DE",
          index: 947,
          actual: true,
        },
        {
          internal_id: "conc_actual_yield_by_date_dashboard",
          id: "Krachtvoeractueelvolgensmelkproductietrend",
          lng: "nl-NL",
          index: 947,
          actual: true,
        },

        {
          internal_id: "conc_actual_feed_by_date_dashboard",
          id: "Concentrateactualbyfeedbydate",
          lng: "en-GB",
          index: 948,
          actual: true,
        },
        {
          internal_id: "conc_actual_feed_by_date_dashboard",
          id: "Concentrateactualbyfeedbydate",
          lng: "en-US",
          index: 948,
          actual: true,
        },
        {
          internal_id: "conc_actual_feed_by_date_dashboard",
          id: "Concentrrelenfonctionduconcentrtendance",
          lng: "fr-FR",
          index: 948,
          actual: true,
        },
        {
          internal_id: "conc_actual_feed_by_date_dashboard",
          id: "KraftfuttertatschlicherdurchKraftfutterEntwicklung",
          lng: "de-DE",
          index: 948,
          actual: true,
        },
        {
          internal_id: "conc_actual_feed_by_date_dashboard",
          id: "Krachtvoeractueelvolgenskrachtvoertrend",
          lng: "nl-NL",
          index: 948,
          actual: true,
        },

        {
          internal_id: "leftovers_actual__by_date_dashboard",
          id: "Leftoversactualbydate",
          lng: "en-GB",
          index: 949,
          actual: true,
        },
        {
          internal_id: "leftovers_actual__by_date_dashboard",
          id: "Leftoversactualbydate",
          lng: "en-US",
          index: 949,
          actual: true,
        },
        {
          internal_id: "leftovers_actual__by_date_dashboard",
          id: "Restesactuelstendance",
          lng: "fr-FR",
          index: 949,
          actual: true,
        },
        {
          internal_id: "leftovers_actual__by_date_dashboard",
          id: "Restetatschlicherentwicklung",
          lng: "de-DE",
          index: 949,
          actual: true,
        },
        {
          internal_id: "leftovers_actual__by_date_dashboard",
          id: "Restvoeractueeltrend",
          lng: "nl-NL",
          index: 949,
          actual: true,
        },
      ],

      filtersLngList: [
        {
          internal_id: "parity",
          lng: "en-GB",
          name: "Parity",
        },
        {
          internal_id: "parity",
          lng: "en-US",
          name: "Parity",
        },
        {
          internal_id: "parity",
          lng: "fr-FR",
          name: "Lactation",
        },
        {
          internal_id: "parity",
          lng: "de-DE",
          name: "Laktation",
        },
        {
          internal_id: "parity",
          lng: "nl-NL",
          name: "Pariteit",
        },
        {
          internal_id: "parity",
          lng: "pl-PL",
          name: "Laktacja",
        },
        {
          internal_id: "parity_filter",
          lng: "en-GB",
          name: "Parity Filter",
        },
        {
          internal_id: "parity_filter",
          lng: "en-US",
          name: "Parity Filter",
        },
        {
          internal_id: "parity_filter",
          lng: "fr-FR",
          name: "Filtre de parité",
        },
        {
          internal_id: "parity_filter",
          lng: "de-DE",
          name: "Paritätsfilter",
        },
        {
          internal_id: "parity_filter",
          lng: "nl-NL",
          name: "Pariteit filter",
        },
        {
          internal_id: "parity_filter",
          lng: "pl-PL",
          name: "Parity Filter",
        },
        {
          internal_id: "reason",
          lng: "en-GB",
          name: "Reason",
        },
        {
          internal_id: "reason",
          lng: "en-US",
          name: "Reason",
        },
        {
          internal_id: "reason",
          lng: "fr-FR",
          name: "Reason",
        },
        {
          internal_id: "reason",
          lng: "de-DE",
          name: "Grund",
        },
        {
          internal_id: "reason",
          lng: "nl-NL",
          name: "Reason",
        },
        {
          internal_id: "reason",
          lng: "pl-PL",
          name: "Reason",
        },
        {
          internal_id: "first_lesion",
          lng: "en-GB",
          name: "First Lesion",
        },
        {
          internal_id: "first_lesion",
          lng: "en-US",
          name: "First Lesion",
        },
        {
          internal_id: "first_lesion",
          lng: "fr-FR",
          name: "First Lesion",
        },
        {
          internal_id: "first_lesion",
          lng: "de-DE",
          name: "First Lesion",
        },
        {
          internal_id: "first_lesion",
          lng: "nl-NL",
          name: "First Lesion",
        },
        {
          internal_id: "first_lesion",
          lng: "pl-PL",
          name: "First Lesion",
        },
        {
          internal_id: "lesion_type",
          lng: "en-GB",
          name: "Lesion type",
        },
        {
          internal_id: "lesion_type",
          lng: "en-US",
          name: "Lesion type",
        },
        {
          internal_id: "lesion_type",
          lng: "fr-FR",
          name: "Lesion type",
        },
        {
          internal_id: "lesion_type",
          lng: "de-DE",
          name: "Lesion type",
        },
        {
          internal_id: "lesion_type",
          lng: "nl-NL",
          name: "Lesion type",
        },
        {
          internal_id: "lesion_type",
          lng: "pl-PL",
          name: "Lesion type",
        },
        {
          internal_id: "lesion",
          lng: "en-GB",
          name: "Lesion",
        },
        {
          internal_id: "lesion",
          lng: "en-US",
          name: "Lesion",
        },
        {
          internal_id: "lesion",
          lng: "fr-FR",
          name: "Lesion",
        },
        {
          internal_id: "lesion",
          lng: "de-DE",
          name: "Lesion",
        },
        {
          internal_id: "lesion",
          lng: "nl-NL",
          name: "Lesion",
        },
        {
          internal_id: "lesion",
          lng: "pl-PL",
          name: "Lesion",
        },
        {
          internal_id: "group_by",
          lng: "en-GB",
          name: "Group by",
        },
        {
          internal_id: "group_by",
          lng: "en-US",
          name: "Group by",
        },
        {
          internal_id: "group_by",
          lng: "fr-FR",
          name: "Groupé par",
        },
        {
          internal_id: "group_by",
          lng: "de-DE",
          name: "Gruppierungen nach",
        },
        {
          internal_id: "group_by",
          lng: "nl-NL",
          name: "Groepeer op",
        },
        {
          internal_id: "group_by",
          lng: "pl-PL",
          name: "Grupa według",
        },
        {
          internal_id: "show_others",
          lng: "en-GB",
          name: "Show others",
        },
        {
          internal_id: "show_others",
          lng: "en-US",
          name: "Show others",
        },
        {
          internal_id: "show_others",
          lng: "fr-FR",
          name: "Show others",
        },
        {
          internal_id: "show_others",
          lng: "de-DE",
          name: "zeige andere",
        },
        {
          internal_id: "show_others",
          lng: "nl-NL",
          name: "Show others",
        },
        {
          internal_id: "show_others",
          lng: "pl-PL",
          name: "Show others",
        },
        {
          internal_id: "group_by_value",
          lng: "en-GB",
          name: "Parity",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "en-US",
          name: "Parity",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "fr-FR",
          name: "Lactation",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "de-DE",
          name: "Laktation",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "nl-NL",
          name: "Pariteit",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "pl-PL",
          name: "Laktacja",
          translate_string: "_dashboard_name_parameter_group_by_value_parity_",
        },
        {
          internal_id: "group_by_value",
          lng: "en-GB",
          name: "Herd",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "en-US",
          name: "Herd",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "fr-FR",
          name: "Troupeau",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "de-DE",
          name: "Herde",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "nl-NL",
          name: "Bedrijf",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "pl-PL",
          name: "Stado",
          translate_string: "_dashboard_name_parameter_group_by_value_herd_",
        },
        {
          internal_id: "group_by_value",
          lng: "en-GB",
          name: "Days in milk category",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_value",
          lng: "en-US",
          name: "Days in milk category",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_value",
          lng: "fr-FR",
          name: "Catégorie de jours de lactation",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_value",
          lng: "de-DE",
          name: "Kategorie Tage in Milch",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_value",
          lng: "nl-NL",
          name: "Dagen in lactatie categorie",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_value",
          lng: "pl-PL",
          name: "Kategoria dni laktacji",
          translate_string: "_dashboard_name_parameter_group_by_value_dim_",
        },
        {
          internal_id: "group_by_metric",
          lng: "en-GB",
          name: "Group by metric",
        },
        {
          internal_id: "group_by_metric",
          lng: "en-US",
          name: "Group by metric",
        },
        {
          internal_id: "group_by_metric",
          lng: "fr-FR",
          name: "Grouper par métrique",
        },
        {
          internal_id: "group_by_metric",
          lng: "de-DE",
          name: "Nach Metrik gruppieren",
        },
        {
          internal_id: "group_by_metric",
          lng: "nl-NL",
          name: "Groepeer op kengetal",
        },
        {
          internal_id: "group_by_metric",
          lng: "pl-PL",
          name: "Group by metric",
        },
        {
          internal_id: "feed_name",
          lng: "en-GB",
          name: "Feed name",
        },
        {
          internal_id: "feed_name",
          lng: "en-US",
          name: "Feed name",
        },
        {
          internal_id: "feed_name",
          lng: "fr-FR",
          name: "Nom de l'aliment",
        },
        {
          internal_id: "feed_name",
          lng: "de-DE",
          name: "Name des Futters",
        },
        {
          internal_id: "feed_name",
          lng: "nl-NL",
          name: "Voer naam",
        },
        {
          internal_id: "feed_name",
          lng: "pl-PL",
          name: "Feed name",
        },
        {
          internal_id: "dim_category",
          lng: "en-GB",
          name: "DIM Category",
        },
        {
          internal_id: "dim_category",
          lng: "en-US",
          name: "DIM Category",
        },
        {
          internal_id: "dim_category",
          lng: "fr-FR",
          name: "Catégorie de JEL",
        },
        {
          internal_id: "dim_category",
          lng: "de-DE",
          name: "TIM-Kategorie",
        },
        {
          internal_id: "dim_category",
          lng: "nl-NL",
          name: "DIM Categorie",
        },
        {
          internal_id: "dim_category",
          lng: "pl-PL",
          name: "Kategoria DL",
        },
        {
          internal_id: "date",
          lng: "en-GB",
          name: "Date",
        },
        {
          internal_id: "date",
          lng: "en-US",
          name: "Date",
        },
        {
          internal_id: "date",
          lng: "fr-FR",
          name: "Date",
        },
        {
          internal_id: "date",
          lng: "de-DE",
          name: "Datum",
        },
        {
          internal_id: "date",
          lng: "nl-NL",
          name: "Datum",
        },
        {
          internal_id: "date",
          lng: "pl-PL",
          name: "Data",
        },
        {
          internal_id: "vwp",
          lng: "en-GB",
          name: "VWP",
        },
        {
          internal_id: "vwp",
          lng: "en-US",
          name: "VWP",
        },
        {
          internal_id: "vwp",
          lng: "fr-FR",
          name: "Période d'attente volontaire (VWP)",
        },
        {
          internal_id: "vwp",
          lng: "de-DE",
          name: "VWP",
        },
        {
          internal_id: "vwp",
          lng: "nl-NL",
          name: "VWP (Vrijwillige wachtperiode)",
        },
        {
          internal_id: "vwp",
          lng: "pl-PL",
          name: "OPP",
        },
        {
          internal_id: "afi",
          lng: "en-GB",
          name: "AFI target",
        },
        {
          internal_id: "afi",
          lng: "en-US",
          name: "AFI target",
        },
        {
          internal_id: "afi",
          lng: "fr-FR",
          name: "Objectif AFI",
        },
        {
          internal_id: "afi",
          lng: "de-DE",
          name: "AFI-Ziel",
        },
        {
          internal_id: "afi",
          lng: "nl-NL",
          name: "Doel eerste inseminatie",
        },
        {
          internal_id: "afi",
          lng: "pl-PL",
          name: "Cel WPI",
        },

        {
          internal_id: "cow_scc",
          lng: "en-GB",
          name: "Cow SCC threshold",
        },
        {
          internal_id: "cow_scc",
          lng: "en-US",
          name: "Cow SCC threshold",
        },
        {
          internal_id: "cow_scc",
          lng: "fr-FR",
          name: "Cow SCC threshold",
        },
        {
          internal_id: "cow_scc",
          lng: "de-DE",
          name: "Cow SCC threshold",
        },
        {
          internal_id: "cow_scc",
          lng: "nl-NL",
          name: "Cow SCC threshold",
        },
        {
          internal_id: "cow_scc",
          lng: "pl-PL",
          name: "Próg LKS dla krów",
        },

        {
          internal_id: "heifer_scc",
          lng: "en-GB",
          name: "Heifer SCC threshold",
        },
        {
          internal_id: "heifer_scc",
          lng: "en-US",
          name: "Heifer SCC threshold",
        },
        {
          internal_id: "heifer_scc",
          lng: "fr-FR",
          name: "Heifer SCC threshold",
        },
        {
          internal_id: "heifer_scc",
          lng: "de-DE",
          name: "Heifer SCC threshold",
        },
        {
          internal_id: "heifer_scc",
          lng: "nl-NL",
          name: "Heifer SCC threshold",
        },
        {
          internal_id: "heifer_scc",
          lng: "pl-PL",
          name: "Próg LKS jałówek",
        },

        {
          internal_id: "parity_categories",
          lng: "en-GB",
          name: "Parity categories",
        },
        {
          internal_id: "parity_categories",
          lng: "en-US",
          name: "Parity categories",
        },
        {
          internal_id: "parity_categories",
          lng: "fr-FR",
          name: "Parity categories",
        },
        {
          internal_id: "parity_categories",
          lng: "de-DE",
          name: "Parity categories",
        },
        {
          internal_id: "parity_categories",
          lng: "nl-NL",
          name: "Parity categories",
        },
        {
          internal_id: "parity_categories",
          lng: "pl-PL",
          name: "Kategorie parzystości",
        },

        {
          internal_id: "dim_categories",
          lng: "en-GB",
          name: "DIM categories",
        },
        {
          internal_id: "dim_categories",
          lng: "en-US",
          name: "DIM categories",
        },
        {
          internal_id: "dim_categories",
          lng: "fr-FR",
          name: "DIM categories",
        },
        {
          internal_id: "dim_categories",
          lng: "de-DE",
          name: "DIM categories",
        },
        {
          internal_id: "dim_categories",
          lng: "nl-NL",
          name: "DIM categories",
        },
        {
          internal_id: "dim_categories",
          lng: "pl-PL",
          name: "Kategorie dni laktacji",
        },

        {
          internal_id: "scc_ln",
          lng: "en-GB",
          name: "SCC vs LN",
        },
        {
          internal_id: "scc_ln",
          lng: "en-US",
          name: "SCC vs LN",
        },
        {
          internal_id: "scc_ln",
          lng: "fr-FR",
          name: "SCC vs LN",
        },
        {
          internal_id: "scc_ln",
          lng: "de-DE",
          name: "SCC vs LN",
        },
        {
          internal_id: "scc_ln",
          lng: "nl-NL",
          name: "SCC vs LN",
        },
        {
          internal_id: "scc_ln",
          lng: "pl-PL",
          name: "LKS vs NL",
        },
        {
          internal_id: "animal_contribution",
          lng: "en-GB",
          name: "Animal contribution",
        },
        {
          internal_id: "animal_contribution",
          lng: "en-US",
          name: "Animal contribution",
        },
        {
          internal_id: "animal_contribution",
          lng: "fr-FR",
          name: "Animal contribution",
        },
        {
          internal_id: "animal_contribution",
          lng: "de-DE",
          name: "Animal contribution",
        },
        {
          internal_id: "animal_contribution",
          lng: "nl-NL",
          name: "Animal contribution",
        },
        {
          internal_id: "animal_contribution",
          lng: "pl-PL",
          name: "Udział zwierząt",
        },

        {
          internal_id: "number_of_cows",
          lng: "en-GB",
          name: "Number of cows",
        },
        {
          internal_id: "number_of_cows",
          lng: "en-US",
          name: "Number of cows",
        },
        {
          internal_id: "number_of_cows",
          lng: "fr-FR",
          name: "Number of cows",
        },
        {
          internal_id: "number_of_cows",
          lng: "de-DE",
          name: "Number of cows",
        },
        {
          internal_id: "number_of_cows",
          lng: "nl-NL",
          name: "Aantal koeien",
        },
        {
          internal_id: "number_of_cows",
          lng: "pl-PL",
          name: "Liczba krów",
        },

        {
          internal_id: "liner_type",
          lng: "en-GB",
          name: "Liner type",
        },
        {
          internal_id: "liner_type",
          lng: "en-US",
          name: "Liner type",
        },
        {
          internal_id: "liner_type",
          lng: "fr-FR",
          name: "Liner type",
        },
        {
          internal_id: "liner_type",
          lng: "de-DE",
          name: "Liner type",
        },
        {
          internal_id: "liner_type",
          lng: "nl-NL",
          name: "Liner type",
        },
        {
          internal_id: "liner_type",
          lng: "pl-PL",
          name: "Typ gum strzukowych",
        },

        {
          internal_id: "number_of_clusters",
          lng: "en-GB",
          name: "Number of clusters",
        },
        {
          internal_id: "number_of_clusters",
          lng: "en-US",
          name: "Number of clusters",
        },
        {
          internal_id: "number_of_clusters",
          lng: "fr-FR",
          name: "Number of clusters",
        },
        {
          internal_id: "number_of_clusters",
          lng: "de-DE",
          name: "Number of clusters",
        },
        {
          internal_id: "number_of_clusters",
          lng: "nl-NL",
          name: "Number of clusters",
        },
        {
          internal_id: "number_of_clusters",
          lng: "pl-PL",
          name: "Liczba aparatów udojowych",
        },

        {
          internal_id: "daily_milkings",
          lng: "en-GB",
          name: "Daily milkings",
        },
        {
          internal_id: "daily_milkings",
          lng: "en-US",
          name: "Daily milkings",
        },
        {
          internal_id: "daily_milkings",
          lng: "fr-FR",
          name: "Daily milkings",
        },
        {
          internal_id: "daily_milkings",
          lng: "de-DE",
          name: "Daily milkings",
        },
        {
          internal_id: "daily_milkings",
          lng: "nl-NL",
          name: "Daily milkings",
        },
        {
          internal_id: "daily_milkings",
          lng: "pl-PL",
          name: "Dzienne udoje",
        },

        {
          internal_id: "date_last_liner_change",
          lng: "en-GB",
          name: "Date last liner change",
        },
        {
          internal_id: "date_last_liner_change",
          lng: "en-US",
          name: "Date last liner change",
        },
        {
          internal_id: "date_last_liner_change",
          lng: "fr-FR",
          name: "Date last liner change",
        },
        {
          internal_id: "date_last_liner_change",
          lng: "de-DE",
          name: "Date last liner change",
        },
        {
          internal_id: "date_last_liner_change",
          lng: "nl-NL",
          name: "Tepelvoering",
        },
        {
          internal_id: "date_last_liner_change",
          lng: "pl-PL",
          name: "Data ostatniej wymiany gum strzykowych",
        },

        {
          internal_id: "exclude_early_dim",
          lng: "en-GB",
          name: "Exclude early DIM",
        },
        {
          internal_id: "exclude_early_dim",
          lng: "en-US",
          name: "Exclude early DIM",
        },
        {
          internal_id: "exclude_early_dim",
          lng: "fr-FR",
          name: "Exclude early DIM",
        },
        {
          internal_id: "exclude_early_dim",
          lng: "de-DE",
          name: "Exclude early DIM",
        },
        {
          internal_id: "exclude_early_dim",
          lng: "nl-NL",
          name: "Exclude early DIM",
        },
        {
          internal_id: "exclude_early_dim",
          lng: "pl-PL",
          name: "Wyklucz wczesny DL",
        },
        {
          internal_id: "select_kpi",
          lng: "en-GB",
          name: "Select KPI",
        },
        {
          internal_id: "select_kpi",
          lng: "en-US",
          name: "Select KPI",
        },
        {
          internal_id: "select_kpi",
          lng: "fr-FR",
          name: "Select KPI",
        },
        {
          internal_id: "select_kpi",
          lng: "de-DE",
          name: "Select KPI",
        },
        {
          internal_id: "select_kpi",
          lng: "nl-NL",
          name: "Selecteer KPI",
        },
        {
          internal_id: "select_kpi",
          lng: "pl-PL",
          name: "Wybierz KPI",
        },

        {
          internal_id: "select_kpi_first",
          lng: "en-GB",
          name: "Select KPI first",
        },
        {
          internal_id: "select_kpi_first",
          lng: "en-US",
          name: "Select KPI first",
        },
        {
          internal_id: "select_kpi_first",
          lng: "fr-FR",
          name: "Select KPI first",
        },
        {
          internal_id: "select_kpi_first",
          lng: "de-DE",
          name: "Select KPI first",
        },
        {
          internal_id: "select_kpi_first",
          lng: "nl-NL",
          name: "Select KPI first",
        },
        {
          internal_id: "select_kpi_first",
          lng: "pl-PL",
          name: "Select KPI first",
        },

        {
          internal_id: "view",
          lng: "en-GB",
          name: "View",
        },
        {
          internal_id: "view",
          lng: "en-US",
          name: "View",
        },
        {
          internal_id: "view",
          lng: "fr-FR",
          name: "View",
        },
        {
          internal_id: "view",
          lng: "de-DE",
          name: "View",
        },
        {
          internal_id: "view",
          lng: "nl-NL",
          name: "View",
        },
        {
          internal_id: "view",
          lng: "pl-PL",
          name: "View",
        },

        {
          internal_id: "view_by",
          lng: "en-GB",
          name: "View by",
        },
        {
          internal_id: "view_by",
          lng: "en-US",
          name: "View by",
        },
        {
          internal_id: "view_by",
          lng: "fr-FR",
          name: "View by",
        },
        {
          internal_id: "view_by",
          lng: "de-DE",
          name: "View by",
        },
        {
          internal_id: "view_by",
          lng: "nl-NL",
          name: "View by",
        },
        {
          internal_id: "view_by",
          lng: "pl-PL",
          name: "View by",
        },
      ],

      //when dashboard name or sheet name is changed update this list
      sheetNamePairs: [
        {
          sheet_name_transition: "Milk yield actual",
          sheet_name: "Milk yield (kg/cow) by DIM",
        },
        {
          sheet_name_transition: "Production laitière réelle",
          sheet_name:
            "Production laitière (kg/vache) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Milchleistung",
          sheet_name: "Milchleistung (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "Melkproductie actueel",
          sheet_name: "Melkproductie (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "First milk yield by calving date",
          sheet_name: "First milk yield (kg/cow) by calving date",
        },
        {
          sheet_name_transition:
            "Première production laitière par date de vêlage",
          sheet_name:
            "Première production laitière (kg/vache) par date de vêlage",
        },
        {
          sheet_name_transition: "Erste Milchleistung nach Kalbedatum",
          sheet_name: "Erste Milchleistung (kg/Kuh) nach Kalbedatum",
        },
        {
          sheet_name_transition: "Eerste melk productie volgens kalfdatum",
          sheet_name: "Eerste melk productie (kg/koe) volgens kalfdatum",
        },
        {
          sheet_name_transition: "Milk yield trend",
          sheet_name: "Milk yield (kg) over time",
        },
        {
          sheet_name_transition: "Tendance de la production laitière",
          sheet_name: "Production laitière (kg) en fonction du temps",
        },
        {
          sheet_name_transition: "Milchleistungsentwicklung",
          sheet_name: "Milchleistung (kg) im Zeitverlauf",
        },
        {
          sheet_name_transition: "Melkproductie trend",
          sheet_name: "Melkproductie (kg) in de tijd",
        },
        {
          sheet_name_transition: "SPP actual",
          sheet_name: "BSK (kg/cow) by DIM",
        },
        {
          sheet_name_transition: "BSK réel",
          sheet_name: "BSK (kg/vache) par DIM",
        },
        {
          sheet_name_transition: "tatsächliche BSK",
          sheet_name: "BSK (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "BSK actueel",
          sheet_name: "BSK (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "SPP trend",
          sheet_name: "BSK over time",
        },
        {
          sheet_name_transition: "Tendance BSK",
          sheet_name: "BSK en fonction du temps",
        },
        {
          sheet_name_transition: "BSK-Entwicklung",
          sheet_name: "BSK im Zeitverlauf",
        },
        {
          sheet_name_transition: "BSK trend",
          sheet_name: "BSK in de tijd",
        },
        {
          sheet_name_transition: "Milkings actual",
          sheet_name: "Milkings by DIM",
        },
        {
          sheet_name_transition: "Traites réelles",
          sheet_name: "Traites en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Melkvorgänge",
          sheet_name: "Melkungen nach tim",
        },
        {
          sheet_name_transition: "Melkingen actueel",
          sheet_name: "Melkingen volgens DIL",
        },
        {
          sheet_name_transition: "Milkings trend",
          sheet_name: "Milkings over time",
        },
        {
          sheet_name_transition: "Tendance traites",
          sheet_name: "Traites en fonction du temps",
        },
        {
          sheet_name_transition: "Endwicklung der Melkungen",
          sheet_name: "Melkungen im Zeitverlauf",
        },
        {
          sheet_name_transition: "Melkingen trend",
          sheet_name: "Melkingen over de tijd",
        },
        {
          sheet_name_transition: "Milk/Milkings trend",
          sheet_name: "Milk/Milkings over time",
        },
        {
          sheet_name_transition: "Tendance lait/traites",
          sheet_name: "Lait/Traites en fonction du temps",
        },
        {
          sheet_name_transition: "Milch/Melkungen Entwicklung",
          sheet_name: "Milch/Melkungen Übersicht",
        },
        {
          sheet_name_transition: "Melk/melking trend",
          sheet_name: "Melk/melking in de tijd",
        },
        {
          sheet_name_transition: "Milk/Milkings actual",
          sheet_name: "Milk/Milkings in DIM",
        },
        {
          sheet_name_transition:
            "Lait/Traites en fonction du stade de lactation",
          sheet_name: "Lait/Traites en fonction du JEL",
        },
        {
          sheet_name_transition: "Milch/tatsächliche Melkungen",
          sheet_name: "Milch/Melkungen nach tim",
        },
        {
          sheet_name_transition: "Melk/melking actueel",
          sheet_name: "Melk/Melking volgens DIL",
        },
        {
          sheet_name_transition: "Concentrate actual by yield",
          sheet_name: "Concentrate intake (kg/100) by milk yield",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction du stade de lactation",
          sheet_name:
            "Consommation de concentré (kg/100) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliches Kraftfutter nach Leistung",
          sheet_name: "Kraftfutteraufnahme (kg/100) nach Milchleistung",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens productie",
          sheet_name: "Krachtvoergift (kg/100) volgens melkproductie",
        },
        {
          sheet_name_transition: "Concentrate yield trend",
          sheet_name: "Concentrate intake (yield) over time",
        },
        {
          sheet_name_transition: "Trend wydajności z paszy treściwej",
          sheet_name: "Pobranie paszy treściwej (wydajność) w czasie",
        },
        {
          sheet_name_transition: "Tendance de la consommation de concentrés",
          sheet_name:
            "Consommation de concentré (rendement) en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Kraftfutterleistung",
          sheet_name: "Kraftfutteraufnahme (Leistung) im Zeitverlauf",
        },
        {
          sheet_name_transition: "Krachtvoergift trend",
          sheet_name: "Krachtvoergift over de tijd",
        },
        {
          sheet_name_transition: "Concentrate actual by feed",
          sheet_name: "Concentrate intake (kg/cow) by DIM",
        },
        {
          sheet_name_transition:
            "Concentrés (kg) en fonction du stade de lactation",
          sheet_name:
            "Consommation de concentré (kg/vache) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliches Kraftfutter nach Futter",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens voer",
          sheet_name: "Krachtvoergift (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "Concentrate kg trend",
          sheet_name: "Concentrate intake (kg) over time",
        },
        {
          sheet_name_transition:
            "Tendance de la consommation de concentrés (Kg)",
          sheet_name: "Consommation de concentré (kg) en fonction du temps",
        },
        {
          sheet_name_transition: "Kraftfutterecntwiklung (K)",
          sheet_name: "Kraftfutteraufnahme (kg) über die Zeit",
        },
        {
          sheet_name_transition: "Krachtvoer kg trend",
          sheet_name: "Krachtvoergift (kg) over de tijd",
        },
        {
          sheet_name_transition: "Concentrate actual by milk production",
          sheet_name: "Concentrate intake (kg/cow) by milk production",
        },
        {
          sheet_name_transition:
            "Consommation de concentrés en fonction de la production de lait",
          sheet_name:
            "Consommation de concentrés (kg/vache) en fonction de la production",
        },
        {
          sheet_name_transition:
            "tatsächliches Kraftfutter nach Milchproduktion",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) durch Milchproduktion",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens melkproductie",
          sheet_name: "Krachtvoergift (kg/koe) volgens melkproductie",
        },
        {
          sheet_name_transition: "Feed Intake",
          sheet_name: "Average feed intake over time",
        },
        {
          sheet_name_transition: "Alimentation",
          sheet_name: "Consommation moyenne d'aliments en fonction du temps",
        },
        {
          sheet_name_transition: "Futteraufnahme",
          sheet_name: "Durchschnittliche Futteraufnahme im Zeitverlauf",
        },
        {
          sheet_name_transition: "Voeropname",
          sheet_name: "Gemiddelde voeropname over de tijd",
        },
        {
          sheet_name_transition: "Leftovers actual",
          sheet_name: "Leftover by DIM",
        },
        {
          sheet_name_transition: "Restes actuels",
          sheet_name: "Restes aliments en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Reste",
          sheet_name: "Reste nach tim",
        },
        {
          sheet_name_transition: "Restvoer actueel",
          sheet_name: "Restvoer volgens DIL",
        },
        {
          sheet_name_transition: "Leftovers trend",
          sheet_name: "Leftovers over time",
        },
        {
          sheet_name_transition: "Tendance des restes aliments",
          sheet_name: "Restes aliments en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Reste",
          sheet_name: "Reste im Zeitverlauf",
        },
        {
          sheet_name_transition: "Restvoer trend",
          sheet_name: "Restvoer in de tijd",
        },
        {
          sheet_name_transition: "Leftovers actual Table",
          sheet_name: "Leftover Table",
        },
        {
          sheet_name_transition: "Tableau des restes d'aliments",
          sheet_name: "Tableau des restes d'aliments",
        },
        {
          sheet_name_transition: "Tabelle mit derzeitigen Resten",
          sheet_name: "Restetabelle",
        },
        {
          sheet_name_transition: "Restvoer actueel tabel",
          sheet_name: "Restvoer tabel",
        },
        {
          sheet_name_transition: "Leftovers actual Milk Speed",
          sheet_name: "Leftover by Milk Speed",
        },
        {
          sheet_name_transition:
            "Reste aliments en fonction de la vitesse de traite",
          sheet_name: "Reste aliments en fonction de la vitesse de stress",
        },
        {
          sheet_name_transition: "Reste derzeitiger Melkgeschwindigkeit",
          sheet_name: "Reste nach Melkgeschwindigkeit",
        },
        {
          sheet_name_transition: "Restvoer actueel melksnelheid",
          sheet_name: "Restvoer volgens melksnelheid",
        },
        {
          sheet_name_transition: "Herd prestations actual",
          sheet_name: "RAP Herd prestations actual (ani1)1",
        },
        {
          sheet_name_transition: "Prestations réelles pour le troupeau",
          sheet_name: "Prestations réelles pour le troupeau RAP (ani1)1",
        },
        {
          sheet_name_transition: "tatsächliche Herdenvorhersage",
          sheet_name: "RAP tatsächliche Herdvorhersage (ani1)1",
        },
        {
          sheet_name_transition: "Kuddeprestaties actueel",
          sheet_name: "RAP kuddeprestaties actueel (ani1)1",
        },
        {
          sheet_name_transition: "Herd prestations trend",
          sheet_name: "RAP Herd prestations trend",
        },
        {
          sheet_name_transition: "Tendance des prestations du troupeau",
          sheet_name: "Tendance pour les prestations pour le troupeau RAP",
        },
        {
          sheet_name_transition: "Entwicklung der Herdenvorhersage",
          sheet_name: "RAP  Entwicklung der Herdenvorhersage",
        },
        {
          sheet_name_transition: "Kuddeprestaties trend",
          sheet_name: "RAP kuddeprestaties trend",
        },
        {
          sheet_name_transition: "Days in milk trend",
          sheet_name: "Days in milk over time",
        },
        {
          sheet_name_transition: "Tendance des jours de lactation",
          sheet_name: "Jours de lactation en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Tage im Milch",
          sheet_name: "Tage in Milch im Zeitverlauf",
        },
        {
          sheet_name_transition: "Dagen in lactatie trend",
          sheet_name: "Dagen in lactatie in de tijd",
        },
        {
          sheet_name_transition: "RAP Herd dashboard",
          sheet_name: "Milk graph",
        },
        {
          sheet_name_transition: "Tableau de bord du troupeau RAP",
          sheet_name: "Milk graph",
        },
        {
          sheet_name_transition: "RAP Herdentabelle",
          sheet_name: "Milk graph",
        },
        {
          sheet_name_transition: "RAP Bedrijfsdashboard",
          sheet_name: "Milk graph",
        },

        {
          sheet_name_transition: "Milk yield actual by date",
          sheet_name: "Milk yield (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition: "Aktualna wydajność mleka wg daty",
          sheet_name: "Wydajność mleczna (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition: "Production de lait réelle tendance",
          sheet_name: "Production de lait (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition: "Milchproduktion tatsächlicher entwicklung",
          sheet_name: "Milchproduktion (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melkproductie actueel trend",
          sheet_name: "Melkproductie (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "SPP actual by date",
          sheet_name: "BSK (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition: "SPS aktualna wg daty",
          sheet_name: "SPS (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition: "SPP réel tendance",
          sheet_name: "SPP (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition: "BSK tatsächlicher entwicklung",
          sheet_name: "BSK (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "BSK actueel trend",
          sheet_name: "BSK (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Milkings actual by date",
          sheet_name: "Milkings by DIM by Date",
        },
        {
          sheet_name_transition: "Udoje aktualne wg daty",
          sheet_name: "Udoje wg DL wg daty",
        },
        {
          sheet_name_transition: "Traites actualles tendance",
          sheet_name: "Traites par JEL par date",
        },
        {
          sheet_name_transition: "Melkungen tatsächlicher entwicklung",
          sheet_name: "Melkungen durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melkingen actueel trend",
          sheet_name: "Melkingen volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Milk/Milkings actual by date",
          sheet_name: "Milk/Milkings in DIM by Date",
        },
        {
          sheet_name_transition: "Mleko / Udoje aktualne wg daty",
          sheet_name: "Milk/Milkings in DIM by Date",
        },
        {
          sheet_name_transition: "Lait/traite actuelle tendance",
          sheet_name: "Lait/traite s en fonction du JEL par date",
        },
        {
          sheet_name_transition: "Milch/Melkung tatsächlicher entwicklung",
          sheet_name: "Milch/Melkung durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melk/melking actueel trend",
          sheet_name: "Melk/melking in DIL volgens datum",
        },
        {
          sheet_name_transition: "Concentrate actual by yield by date",
          sheet_name: "Concentrate intake (kg/100) by milk yield by Date",
        },
        {
          sheet_name_transition: "Aktualna wydajność z paszy treściwej wg daty",
          sheet_name:
            "Pobranie paszy treściwej (kg/100) wg wydajności mleka wg daty",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction de la production tendance",
          sheet_name:
            "Consommation de concentré (kg/100kg) en fonction de production en fonction par date",
        },
        {
          sheet_name_transition:
            "Tatsächliches Kraftfutter durch Leistung entwicklung",
          sheet_name:
            "Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum",
        },
        {
          sheet_name_transition:
            "Krachtvoer actueel volgens melkproductie trend",
          sheet_name:
            "Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum",
        },
        {
          sheet_name_transition: "Concentrate actual by feed by date",
          sheet_name: "Concentrate intake (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition:
            "Aktualna ilość paszy treściwej wg paszy wg daty",
          sheet_name: "Pobranie paszy treściwej (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction du concentré tendance",
          sheet_name: "Consommation de concentré (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition:
            "Kraftfutter tatsächlicher durch Kraftfutter Entwicklung",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens krachtvoer trend",
          sheet_name: "Krachtvoer opname (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Leftovers actual by date",
          sheet_name: "Leftover by DIM by Date",
        },
        {
          sheet_name_transition: "Niedojady aktualne wg daty",
          sheet_name: "Leftover by DIM by Date",
        },
        {
          sheet_name_transition: "Restes actuels tendance",
          sheet_name: "Restes par JEL par date",
        },
        {
          sheet_name_transition: "Reste tatsächlicher entwicklung",
          sheet_name: "Reste durch TIM nach datum",
        },
        {
          sheet_name_transition: "Restvoer actueel trend",
          sheet_name: "Restvoer volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Robot prestations dashboard",
          sheet_name: "Robot prestations",
        },
        {
          sheet_name_transition: "Prestations du robot tableau de bord",
          sheet_name: "Prestations du robot",
        },
        {
          sheet_name_transition: "Robotervorhersagen Tabelle",
          sheet_name: "Robotervorhersagen",
        },
        {
          sheet_name_transition: "Robot prestaties dashboard",
          sheet_name: "Robotprestaties",
        },
        {
          sheet_name_transition: "Robot prestations trend dashboard",
          sheet_name: "Robot prestations trend",
        },
        {
          sheet_name_transition:
            "Prestations du robot tendance tableau de bord",
          sheet_name: "Prestations du robot tendance",
        },
        {
          sheet_name_transition: "Robotervorhersagen Entwicklungtabelle",
          sheet_name: "Robotervorhersagen Entwicklung",
        },
        {
          sheet_name_transition: "Robot prestaties trend dashboard",
          sheet_name: "Robot prestaties trend",
        },

        {
          sheet_name_transition: "Actual dashboard",
          sheet_name: "Graph",
        },
        {
          sheet_name_transition: "Trend wydajności mlecznej",
          sheet_name: "Wydajność mleczna (kg) w czasie",
        },
        {
          sheet_name_transition: "Aktualna wydajność mleczna",
          sheet_name: "Wydajność mleczna (kg/krowę) według dni laktacji",
        },
        {
          sheet_name_transition:
            "Wydajność pierwszego mleka według daty wycielenia",
          sheet_name:
            "Wydajność pierwszego mleka (kg/krowę) według daty wycielenia",
        },
        {
          sheet_name_transition: "Pulpit danych stada RAP",
          sheet_name: "Milk graph",
        },
        {
          sheet_name_transition: "Trend SPS",
          sheet_name: "SPS na przestrzeni czasu",
        },
        {
          sheet_name_transition: "SPS aktualne",
          sheet_name: "SPS (kg/krowa) wg dni laktacji",
        },
        {
          sheet_name_transition: "Trend udojów",
          sheet_name: "Udoje w czasie",
        },
        {
          sheet_name_transition: "Mleko/Udoje aktualne",
          sheet_name: "Mleko/Udoje w dniu laktacji",
        },
        {
          sheet_name_transition: "Udoje aktualne",
          sheet_name: "Udoje według DL",
        },
        {
          sheet_name_transition: "Trend mleko/udoje",
          sheet_name: "Mleko / Udoje w czasie",
        },
        {
          sheet_name_transition: "Pasza treściwa według wydajności",
          sheet_name:
            "Pobranie paszy treściwej (kg/100) według wydajności mlecznej",
        },
        {
          sheet_name_transition:
            "Aktualna zawartość paszy treściwej w żywieniu ",
          sheet_name:
            "Pobranie paszy treściwej (kg/krowę) według dnia laktacji",
        },
        {
          sheet_name_transition:
            "Aktualna ilość paszy treściwej (kg/krowę) według produkcji mleka",
          sheet_name:
            "Pobranie paszy treściwej (kg/krowę) według produkcji mleka",
        },
        {
          sheet_name_transition: "Pobranie paszy",
          sheet_name: "Średnie spożycie paszy w czasie",
        },
        {
          sheet_name_transition: "Trend pobrania paszy treściwej (kg)",
          sheet_name: "Pobranie paszy treściwej (kg) w czasie",
        },
        {
          sheet_name_transition: "Trend resztek",
          sheet_name: "Resztki w czasie",
        },
        {
          sheet_name_transition: "Aktualne pozostałości",
          sheet_name: "Pozostałości według DL",
        },
        {
          sheet_name_transition: "Aktualna prędkość udoju",
          sheet_name: "Resztki według szybkości udoju",
        },
        {
          sheet_name_transition: "Aktualna tabela pozostałości",
          sheet_name: "Tabela pozostałości",
        },
        {
          sheet_name_transition: "Trend dni laktacji",
          sheet_name: "Dni laktacji w czasie",
        },
        {
          sheet_name_transition: "Aktualny stan stada",
          sheet_name: "Herd Prestations Actual Table",
        },
        {
          sheet_name_transition: "Aktualny pulpit nawigacyjny",
          sheet_name: "Graph",
        },
        {
          sheet_name_transition: "Trend preferencji stada",
          sheet_name: "RAP Herd prestations trend",
        },
        {
          sheet_name_transition: "Pulpit nawigacyjny prestacji robotów",
          sheet_name: "Prestacje robotów",
        },
        {
          sheet_name_transition:
            "Pulpit nawigacyjny trendów prezentacji robota",
          sheet_name: "Trend prezentacji robotów",
        },
      ],

      sheetNamePairsRAP: [
        {
          sheet_name_transition: "Milk yield actual",
          sheet_name: "Milk yield (kg/cow) by DIM",
        },
        {
          sheet_name_transition: "Production laitière réelle",
          sheet_name:
            "Production laitière (kg/vache) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Milchleistung",
          sheet_name: "Milchleistung (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "Melkproductie actueel",
          sheet_name: "Melkproductie (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "First milk yield by calving date",
          sheet_name: "First milk yield (kg/cow) by calving date",
        },
        {
          sheet_name_transition:
            "Première production laitière par date de vêlage",
          sheet_name:
            "Première production laitière (kg/vache) par date de vêlage",
        },
        {
          sheet_name_transition: "Erste Milchleistung nach Kalbedatum",
          sheet_name: "Erste Milchleistung (kg/Kuh) nach Kalbedatum",
        },
        {
          sheet_name_transition: "Eerste melk productie volgens kalfdatum",
          sheet_name: "Eerste melk productie (kg/koe) volgens kalfdatum",
        },
        {
          sheet_name_transition: "Milk yield trend",
          sheet_name: "Milk yield (kg) over time",
        },
        {
          sheet_name_transition: "Tendance de la production laitière",
          sheet_name: "Production laitière (kg) en fonction du temps",
        },
        {
          sheet_name_transition: "Milchleistungsentwicklung",
          sheet_name: "Milchleistung (kg) im Zeitverlauf",
        },
        {
          sheet_name_transition: "Melkproductie trend",
          sheet_name: "Melkproductie (kg) in de tijd",
        },
        {
          sheet_name_transition: "SPP actual",
          sheet_name: "BSK (kg/cow) by DIM",
        },
        {
          sheet_name_transition: "BSK réel",
          sheet_name: "BSK (kg/vache) par DIM",
        },
        {
          sheet_name_transition: "tatsächliche BSK",
          sheet_name: "BSK (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "BSK actueel",
          sheet_name: "BSK (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "SPP trend",
          sheet_name: "BSK over time",
        },
        {
          sheet_name_transition: "Tendance BSK",
          sheet_name: "BSK en fonction du temps",
        },
        {
          sheet_name_transition: "BSK-Entwicklung",
          sheet_name: "BSK im Zeitverlauf",
        },
        {
          sheet_name_transition: "BSK trend",
          sheet_name: "BSK in de tijd",
        },
        {
          sheet_name_transition: "Milkings actual",
          sheet_name: "Milkings by DIM",
        },
        {
          sheet_name_transition: "Traites réelles",
          sheet_name: "Traites en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Melkvorgänge",
          sheet_name: "Melkungen nach tim",
        },
        {
          sheet_name_transition: "Melkingen actueel",
          sheet_name: "Melkingen volgens DIL",
        },
        {
          sheet_name_transition: "Milkings trend",
          sheet_name: "Milkings over time",
        },
        {
          sheet_name_transition: "Tendance traites",
          sheet_name: "Traites en fonction du temps",
        },
        {
          sheet_name_transition: "Endwicklung der Melkungen",
          sheet_name: "Melkungen im Zeitverlauf",
        },
        {
          sheet_name_transition: "Melkingen trend",
          sheet_name: "Melkingen over de tijd",
        },
        {
          sheet_name_transition: "Milk/Milkings trend",
          sheet_name: "Milk/Milkings over time",
        },
        {
          sheet_name_transition: "Tendance lait/traites",
          sheet_name: "Lait/Traites en fonction du temps",
        },
        {
          sheet_name_transition: "Milch/Melkungen Entwicklung",
          sheet_name: "Milch/Melkungen Übersicht",
        },
        {
          sheet_name_transition: "Melk/melking trend",
          sheet_name: "Melk/melking in de tijd",
        },
        {
          sheet_name_transition: "Milk/Milkings actual",
          sheet_name: "Milk/Milkings in DIM",
        },
        {
          sheet_name_transition:
            "Lait/Traites en fonction du stade de lactation",
          sheet_name: "Lait/Traites en fonction du JEL",
        },
        {
          sheet_name_transition: "Milch/tatsächliche Melkungen",
          sheet_name: "Milch/Melkungen nach tim",
        },
        {
          sheet_name_transition: "Melk/melking actueel",
          sheet_name: "Melk/Melking volgens DIL",
        },
        {
          sheet_name_transition: "Concentrate actual by yield",
          sheet_name: "Concentrate intake (kg/100) by milk yield",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction du stade de lactation",
          sheet_name:
            "Consommation de concentré (kg/100) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliches Kraftfutter nach Leistung",
          sheet_name: "Kraftfutteraufnahme (kg/100) nach Milchleistung",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens productie",
          sheet_name: "Krachtvoergift (kg/100) volgens melkproductie",
        },
        {
          sheet_name_transition: "Concentrate yield trend",
          sheet_name: "Concentrate intake (yield) over time",
        },
        {
          sheet_name_transition: "Trend wydajności z paszy treściwej",
          sheet_name: "Pobranie paszy treściwej (wydajność) w czasie",
        },
        {
          sheet_name_transition: "Tendance de la consommation de concentrés",
          sheet_name:
            "Consommation de concentré (rendement) en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Kraftfutterleistung",
          sheet_name: "Kraftfutteraufnahme (Leistung) im Zeitverlauf",
        },
        {
          sheet_name_transition: "Krachtvoergift trend",
          sheet_name: "Krachtvoergift over de tijd",
        },
        {
          sheet_name_transition: "Concentrate actual by feed",
          sheet_name: "Concentrate intake (kg/cow) by DIM",
        },
        {
          sheet_name_transition:
            "Concentrés (kg) en fonction du stade de lactation",
          sheet_name:
            "Consommation de concentré (kg/vache) en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliches Kraftfutter nach Futter",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) nach tim",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens voer",
          sheet_name: "Krachtvoergift (kg/koe) volgens DIL",
        },
        {
          sheet_name_transition: "Concentrate kg trend",
          sheet_name: "Concentrate intake (kg) over time",
        },
        {
          sheet_name_transition:
            "Tendance de la consommation de concentrés (Kg)",
          sheet_name: "Consommation de concentré (kg) en fonction du temps",
        },
        {
          sheet_name_transition: "Kraftfutterecntwiklung (K)",
          sheet_name: "Kraftfutteraufnahme (kg) über die Zeit",
        },
        {
          sheet_name_transition: "Krachtvoer kg trend",
          sheet_name: "Krachtvoergift (kg) over de tijd",
        },
        {
          sheet_name_transition: "Concentrate actual by milk production",
          sheet_name: "Concentrate intake (kg/cow) by milk production",
        },
        {
          sheet_name_transition:
            "Consommation de concentrés en fonction de la production de lait",
          sheet_name:
            "Consommation de concentrés (kg/vache) en fonction de la production",
        },
        {
          sheet_name_transition:
            "tatsächliches Kraftfutter nach Milchproduktion",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) durch Milchproduktion",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens melkproductie",
          sheet_name: "Krachtvoergift (kg/koe) volgens melkproductie",
        },
        {
          sheet_name_transition: "Feed Intake",
          sheet_name: "Average feed intake over time",
        },
        {
          sheet_name_transition: "Alimentation",
          sheet_name: "Consommation moyenne d'aliments en fonction du temps",
        },
        {
          sheet_name_transition: "Futteraufnahme",
          sheet_name: "Durchschnittliche Futteraufnahme im Zeitverlauf",
        },
        {
          sheet_name_transition: "Voeropname",
          sheet_name: "Gemiddelde voeropname over de tijd",
        },
        {
          sheet_name_transition: "Leftovers actual",
          sheet_name: "Leftover by DIM",
        },
        {
          sheet_name_transition: "Restes actuels",
          sheet_name: "Restes aliments en fonction du stade de lactation",
        },
        {
          sheet_name_transition: "tatsächliche Reste",
          sheet_name: "Reste nach tim",
        },
        {
          sheet_name_transition: "Restvoer actueel",
          sheet_name: "Restvoer volgens DIL",
        },
        {
          sheet_name_transition: "Leftovers trend",
          sheet_name: "Leftovers over time",
        },
        {
          sheet_name_transition: "Tendance des restes aliments",
          sheet_name: "Restes aliments en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Reste",
          sheet_name: "Reste im Zeitverlauf",
        },
        {
          sheet_name_transition: "Restvoer trend",
          sheet_name: "Restvoer in de tijd",
        },
        {
          sheet_name_transition: "Leftovers actual Table",
          sheet_name: "Leftover Table",
        },
        {
          sheet_name_transition: "Tableau des restes d'aliments",
          sheet_name: "Tableau des restes d'aliments",
        },
        {
          sheet_name_transition: "Tabelle mit derzeitigen Resten",
          sheet_name: "Restetabelle",
        },
        {
          sheet_name_transition: "Restvoer actueel tabel",
          sheet_name: "Restvoer tabel",
        },
        {
          sheet_name_transition: "Leftovers actual Milk Speed",
          sheet_name: "Leftover by Milk Speed",
        },
        {
          sheet_name_transition:
            "Reste aliments en fonction de la vitesse de traite",
          sheet_name: "Reste aliments en fonction de la vitesse de stress",
        },
        {
          sheet_name_transition: "Reste derzeitiger Melkgeschwindigkeit",
          sheet_name: "Reste nach Melkgeschwindigkeit",
        },
        {
          sheet_name_transition: "Restvoer actueel melksnelheid",
          sheet_name: "Restvoer volgens melksnelheid",
        },
        {
          sheet_name_transition: "Herd prestations actual",
          sheet_name: "RAP Herd prestations actual (ani1)1",
        },
        {
          sheet_name_transition: "Prestations réelles pour le troupeau",
          sheet_name: "Prestations réelles pour le troupeau RAP (ani1)1",
        },
        {
          sheet_name_transition: "tatsächliche Herdenvorhersage",
          sheet_name: "RAP tatsächliche Herdvorhersage (ani1)1",
        },
        {
          sheet_name_transition: "Kuddeprestaties actueel",
          sheet_name: "RAP kuddeprestaties actueel (ani1)1",
        },
        {
          sheet_name_transition: "Herd prestations trend",
          sheet_name: "RAP Herd prestations trend",
        },
        {
          sheet_name_transition: "Tendance des prestations du troupeau",
          sheet_name: "Tendance pour les prestations pour le troupeau RAP",
        },
        {
          sheet_name_transition: "Entwicklung der Herdenvorhersage",
          sheet_name: "RAP  Entwicklung der Herdenvorhersage",
        },
        {
          sheet_name_transition: "Kuddeprestaties trend",
          sheet_name: "RAP kuddeprestaties trend",
        },
        {
          sheet_name_transition: "Days in milk trend",
          sheet_name: "Days in milk over time",
        },
        {
          sheet_name_transition: "Tendance des jours de lactation",
          sheet_name: "Jours de lactation en fonction du temps",
        },
        {
          sheet_name_transition: "Entwicklung der Tage im Milch",
          sheet_name: "Tage in Milch im Zeitverlauf",
        },
        {
          sheet_name_transition: "Dagen in lactatie trend",
          sheet_name: "Dagen in lactatie in de tijd",
        },
        {
          sheet_name_transition: "RAP Herd dashboard",
          sheet_name: "Milk meter yield gauge",
        },
        {
          sheet_name_transition: "Tableau de bord du troupeau RAP",
          sheet_name: "Indicateur de production du compteur à lait",
        },
        {
          sheet_name_transition: "RAP Herdentabelle",
          sheet_name: "Anzeige/Messgerät Milchzählerleistung",
        },
        {
          sheet_name_transition: "RAP Bedrijfsdashboard",
          sheet_name: "Melkproductie1",
        },

        {
          sheet_name_transition: "Milk yield actual by date",
          sheet_name: "Milk yield (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition: "Aktualna wydajność mleka wg daty",
          sheet_name: "Wydajność mleczna (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition: "Production de lait réelle tendance",
          sheet_name: "Production de lait (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition: "Milchproduktion tatsächlicher entwicklung",
          sheet_name: "Milchproduktion (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melkproductie actueel trend",
          sheet_name: "Melkproductie (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "SPP actual by date",
          sheet_name: "BSK (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition: "SPS aktualna wg daty",
          sheet_name: "SPS (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition: "SPP réel tendance",
          sheet_name: "SPP (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition: "BSK tatsächlicher entwicklung",
          sheet_name: "BSK (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "BSK actueel trend",
          sheet_name: "BSK (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Milkings actual by date",
          sheet_name: "Milkings by DIM by Date",
        },
        {
          sheet_name_transition: "Udoje aktualne wg daty",
          sheet_name: "Udoje wg DL wg daty",
        },
        {
          sheet_name_transition: "Traites actualles tendance",
          sheet_name: "Traites par JEL par date",
        },
        {
          sheet_name_transition: "Melkungen tatsächlicher entwicklung",
          sheet_name: "Melkungen durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melkingen actueel trend",
          sheet_name: "Melkingen volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Milk/Milkings actual by date",
          sheet_name: "Milk/Milkings in DIM by Date",
        },
        {
          sheet_name_transition: "Mleko / Udoje aktualne wg daty",
          sheet_name: "Milk/Milkings in DIM by Date",
        },
        {
          sheet_name_transition: "Lait/traite actuelle tendance",
          sheet_name: "Lait/traite s en fonction du JEL par date",
        },
        {
          sheet_name_transition: "Milch/Melkung tatsächlicher entwicklung",
          sheet_name: "Milch/Melkung durch TIM nach datum",
        },
        {
          sheet_name_transition: "Melk/melking actueel trend",
          sheet_name: "Melk/melking in DIL volgens datum",
        },
        {
          sheet_name_transition: "Concentrate actual by yield by date",
          sheet_name: "Concentrate intake (kg/100) by milk yield by Date",
        },
        {
          sheet_name_transition: "Aktualna wydajność z paszy treściwej wg daty",
          sheet_name:
            "Pobranie paszy treściwej (kg/100) wg wydajności mleka wg daty",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction de la production tendance",
          sheet_name:
            "Consommation de concentré (kg/100kg) en fonction de production en fonction par date",
        },
        {
          sheet_name_transition:
            "Tatsächliches Kraftfutter durch Leistung entwicklung",
          sheet_name:
            "Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum",
        },
        {
          sheet_name_transition:
            "Krachtvoer actueel volgens melkproductie trend",
          sheet_name:
            "Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum",
        },
        {
          sheet_name_transition: "Concentrate actual by feed by date",
          sheet_name: "Concentrate intake (kg/cow) by DIM by Date",
        },
        {
          sheet_name_transition:
            "Aktualna ilość paszy treściwej wg paszy wg daty",
          sheet_name: "Pobranie paszy treściwej (kg/krowę) wg DL wg daty",
        },
        {
          sheet_name_transition:
            "Concentré réel en fonction du concentré tendance",
          sheet_name: "Consommation de concentré (kg/vache) par JEL par date",
        },
        {
          sheet_name_transition:
            "Kraftfutter tatsächlicher durch Kraftfutter Entwicklung",
          sheet_name: "Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum",
        },
        {
          sheet_name_transition: "Krachtvoer actueel volgens krachtvoer trend",
          sheet_name: "Krachtvoer opname (kg/koe) volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Leftovers actual by date",
          sheet_name: "Leftover by DIM by Date",
        },
        {
          sheet_name_transition: "Niedojady aktualne wg daty",
          sheet_name: "Leftover by DIM by Date",
        },
        {
          sheet_name_transition: "Restes actuels tendance",
          sheet_name: "Restes par JEL par date",
        },
        {
          sheet_name_transition: "Reste tatsächlicher entwicklung",
          sheet_name: "Reste durch TIM nach datum",
        },
        {
          sheet_name_transition: "Restvoer actueel trend",
          sheet_name: "Restvoer volgens DIL volgens datum",
        },
        {
          sheet_name_transition: "Robot prestations dashboard",
          sheet_name: "Robot prestations",
        },
        {
          sheet_name_transition: "Prestations du robot tableau de bord",
          sheet_name: "Prestations du robot",
        },
        {
          sheet_name_transition: "Robotervorhersagen Tabelle",
          sheet_name: "Robotervorhersagen",
        },
        {
          sheet_name_transition: "Robot prestaties dashboard",
          sheet_name: "Robotprestaties",
        },
        {
          sheet_name_transition: "Robot prestations trend dashboard",
          sheet_name: "Robot prestations trend",
        },
        {
          sheet_name_transition:
            "Prestations du robot tendance tableau de bord",
          sheet_name: "Prestations du robot tendance",
        },
        {
          sheet_name_transition: "Robotervorhersagen Entwicklungtabelle",
          sheet_name: "Robotervorhersagen Entwicklung",
        },
        {
          sheet_name_transition: "Robot prestaties trend dashboard",
          sheet_name: "Robot prestaties trend",
        },
      ],

      clawHealthMarkFilterPairs: [
        {
          mark: "Number of cows Trimmed by Trim Date",
          filter: "Action (Reason,MONTH(TrimDate)) 1",
          lng: "en-GB",
        },
        {
          mark: "Number of cows Trimmed by Trim Date",
          filter: "Action (Reason,MONTH(TrimDate)) 1",
          lng: "en-US",
        },
        {
          mark: "Number of cows Trimmed by Trim Date",
          filter: "Action (Reason,MONTH(TrimDate)) 1",
          lng: "nl-NL",
        },
        {
          mark: "Anzahl der geschnittenen Kühe nach Klauenpflegedatum",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "de-DE",
        },
        {
          mark: "Number of cows Trimmed by Trim Date",
          filter: "Action (Reason,MONTH(TrimDate)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Number of cows Trimmed by Trim Date",
          filter: "Action (Reason,MONTH(TrimDate)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Avg Milk Yield Kg",
          filter: "Action (MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Number of cows trimmed",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "en-GB",
        },
        {
          mark: "Number of cows trimmed",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "en-US",
        },
        {
          mark: "Number of cows trimmed",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "nl-NL",
        },
        {
          mark: "Number of cows trimmed",
          filter: "Action (Grund,MONTH(TrimDate))",
          lng: "de-DE",
        },
        {
          mark: "Number of cows trimmed",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "fr-FR",
        },
        {
          mark: "Number of cows trimmed",
          filter: "Action (Reason,MONTH(TrimDate))",
          lng: "pl-PL",
        },

        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions percentage of feet trimmed",
          filter: "Action (Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions percentage of total lesions",
          filter: "Action (Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "en-GB",
        },
        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "en-US",
        },
        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "nl-NL",
        },
        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "de-DE",
        },
        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "fr-FR",
        },
        {
          mark: "Lesions % by trim date",
          filter: "Action (Lesion type,MONTH(TrimDate))",
          lng: "pl-PL",
        },

        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Trim date),Lesion)",
          lng: "en-GB",
        },
        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Trim date),Lesion)",
          lng: "en-US",
        },
        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Trim date),Lesion)",
          lng: "nl-NL",
        },
        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Klauenpflegedatum),Verletzung/Wunde)",
          lng: "de-DE",
        },
        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Trim date),Lesion)",
          lng: "fr-FR",
        },
        {
          mark: "Chronological comparison for top six lesions",
          filter: "Action (YEAR(Trim date),Lesion)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Trim date),Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Trim date),Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Trim date),Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Klauenpflegedatum),Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Trim date),Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions percentage by trim date",
          filter: "Action (MONTH(Trim date),Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "en-GB",
        },
        {
          mark: "Lesions by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "en-US",
        },
        {
          mark: "Lesions by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "nl-NL",
        },
        {
          mark: "Wunden nach Parität",
          filter: "Action (Lesion type,Laktation 4)",
          lng: "de-DE",
        },
        {
          mark: "Lesions by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "pl-PL",
        },

        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "en-GB",
        },
        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "en-US",
        },
        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "nl-NL",
        },
        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Laktation 4)",
          lng: "de-DE",
        },
        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "fr-FR",
        },
        {
          mark: "Percentage of lesions distributed by parity",
          filter: "Action (Lesion type,Parity 4)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions % by limb",
          filter: "Action (Position,Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions percentage by limb",
          filter: "Action (Position,Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions % by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions % by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions % by DIM",
          filter: "Action (Dagen in lactatie categorie,Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Verletzungen % nach tim",
          filter: "Action (Kategorie Tage in Milch,Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions % by DIM",
          filter: "Action (Catégorie de jours de lactation,Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions % by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "en-GB",
        },
        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "en-US",
        },
        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Dagen in lactatie categorie,Lesion type)",
          lng: "nl-NL",
        },
        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Kategorie Tage in Milch,Lesion type)",
          lng: "de-DE",
        },
        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Catégorie de jours de lactation,Lesion type)",
          lng: "fr-FR",
        },
        {
          mark: "Lesions percentage by DIM",
          filter: "Action (Days in milk category,Lesion type)",
          lng: "pl-PL",
        },

        {
          mark: "Chronological comparison of Digital dermatitis by year and stage",
          filter: "Action (Severity,YEAR(Trim date),Lesion)",
          lng: "en-GB",
        },
        {
          mark: "Chronological comparison of Digital dermatitis by year and stage",
          filter: "Action (Severity,YEAR(Trim date),Lesion)",
          lng: "en-US",
        },
        {
          mark: "Chronological comparison of Digital dermatitis by year and stage",
          filter: "Action (Severity,YEAR(Trim date),Lesion)",
          lng: "nl-NL",
        },
        {
          mark: "chronologischer Vergleich für Mortellaro nach Jahr und Stadium",
          filter:
            "Action (Härte/Schwere,YEAR(Klauenpflegedatum),Verletzung/Wunde)",
          lng: "de-DE",
        },
        {
          mark: "Chronological comparison of Digital dermatitis by year and stage",
          filter: "Action (Severity,YEAR(Trim date),Lesion)",
          lng: "fr-FR",
        },
        {
          mark: "Chronological comparison of Digital dermatitis by year and stage",
          filter: "Action (Severity,YEAR(Trim date),Lesion)",
          lng: "pl-PL",
        },
      ],
      productionMarkFilterPairs: [
        {
          mark: "Milk meter by DIM",
          filter: "Action (Parity,Animal eartag,Herd identifier,DaysInMilk)",
          lng: "en-GB",
        },
        {
          mark: "Milk meter by DIM",
          filter: "Action (Parity,Animal eartag,Herd identifier,DaysInMilk)",
          lng: "en-US",
        },
        {
          mark: "Milk meter by DIM",
          filter: "Action (Pariteit,Dieroornummer,Bedrijfsnummer,DaysInMilk)",
          lng: "nl-NL",
        },
        {
          mark: "Milk meter by DIM",
          filter:
            "Action (Laktation,Ohrmarke des Tieres,Herdenerkennung,DaysInMilk)",
          lng: "de-DE",
        },
        {
          mark: "Milk meter by DIM",
          filter:
            "Action (Lactation,Marque auriculaire de l'animal,Identificateur de troupeau,DaysInMilk)",
          lng: "fr-FR",
        },
        {
          mark: "Milk meter by DIM",
          filter: "Action (Parity,Animal eartag,Herd identifier,DaysInMilk)",
          lng: "pl-PL",
        },

        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "en-GB",
        },
        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "en-US",
        },
        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "de-DE",
        },
        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Milk yield over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Evolution of DIM",
          filter: "Action (Date)",
          lng: "en-GB",
        },
        {
          mark: "Evolution of DIM",
          filter: "Action (Date)",
          lng: "en-US",
        },
        {
          mark: "Evolution of DIM",
          filter: "Action (Datum)",
          lng: "nl-NL",
        },
        {
          mark: "Evolution of DIM",
          filter: "Action (Datum)",
          lng: "de-DE",
        },
        {
          mark: "Evolution of DIM",
          filter: "Action (Date)",
          lng: "fr-FR",
        },
        {
          mark: "Evolution of DIM",
          filter: "Action (Date)",
          lng: "pl-PL",
        },

        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "en-GB",
        },
        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "en-US",
        },
        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "nl-NL",
        },
        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "de-DE",
        },
        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "fr-FR",
        },
        {
          mark: "M305 over time",
          filter: "Action (Group by metric,DAY(Date))",
          lng: "pl-PL",
        },
      ],
      mroMarkFilterPairs: [
        {
          mark: "MRO by month",
          filter: "Action (MY(Date))",
          lng: "en-GB",
        },
        {
          mark: "MRO by month",
          filter: "Action (MY(Date))",
          lng: "en-US",
        },
        {
          mark: "MRO by month",
          filter: "Action (MY(Datum))",
          lng: "nl-NL",
        },
        {
          mark: "MRO by month",
          filter: "Action (MY(Datum))",
          lng: "de-DE",
        },
        {
          mark: "MRO by month",
          filter: "Action (MY(Date))",
          lng: "fr-FR",
        },
        {
          mark: "MRO by month",
          filter: "Action (MY(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Milk by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "M305 by time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "FPCM by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "en-GB",
        },
        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "en-US",
        },
        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Pariteit,Bedrijfsnummer,Dieroornummer)",
          lng: "nl-NL",
        },
        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Laktation,Herdenerkennung,Ohrmarke des Tieres)",
          lng: "de-DE",
        },
        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "fr-FR",
        },
        {
          mark: "Fat + Protein by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "pl-PL",
        },

        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Fat + Protein by Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Urea by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "en-GB",
        },
        {
          mark: "Urea by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "en-US",
        },
        {
          mark: "Urea by days in milk",
          filter: "Action (Pariteit,Bedrijfsnummer,Dieroornummer)",
          lng: "nl-NL",
        },
        {
          mark: "Urea by days in milk",
          filter: "Action (Laktation,Herdenerkennung,Ohrmarke des Tieres)",
          lng: "de-DE",
        },
        {
          mark: "Urea by days in milk",
          filter:
            "Action (Lactation,Identificateur de troupeau,Marque auriculaire de l'animal)",
          lng: "fr-FR",
        },
        {
          mark: "Urea by days in milk",
          filter: "Action (Parity,Herd identifier,Animal eartag)",
          lng: "pl-PL",
        },

        {
          mark: "Urea By Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "Urea By Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "Ureum volgens tijd",
          filter: "Action (Group by,MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Urea By Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "Urea By Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Urea By Time",
          filter: "Action (Group by,MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "MRO table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "en-GB",
        },
        {
          mark: "MRO table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "en-US",
        },
        {
          mark: "MRO table",
          filter: "Action (Pariteit,0,Dagen in lactatie)",
          lng: "nl-NL",
        },
        {
          mark: "MRO table",
          filter: "Action (Laktation,0,Tage in Milch)",
          lng: "de-DE",
        },
        {
          mark: "MRO table",
          filter: "Action (Lactation,0,Jours en lactation)",
          lng: "fr-FR",
        },
        {
          mark: "MRO table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "pl-PL",
        },

        {
          mark: "305d Table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "en-GB",
        },
        {
          mark: "305d Table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "en-US",
        },
        {
          mark: "305d Table",
          filter: "Action (Pariteit,0,Dagen in lactatie)",
          lng: "nl-NL",
        },
        {
          mark: "305d Table",
          filter: "Action (Laktation,0,Tage in Milch)",
          lng: "de-DE",
        },
        {
          mark: "305d Table",
          filter: "Action (Lactation,0,Jours en lactation)",
          lng: "fr-FR",
        },
        {
          mark: "305d Table",
          filter: "Action (Parity,0,Days in milk)",
          lng: "pl-PL",
        },
      ],

      lactationAnalysisMarkFilterPairs: [
        {
          mark: "Milk yield (kg) by milk recording month",
          filter: "Action (Herd identifier,0,Animal eartag,Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "Milk yield (kg) by milk recording month",
          filter: "Action (Herd identifier,0,Animal eartag,Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "Melk productie (kg) volgens melkcontrole maand",
          filter: "Action (Bedrijfsnummer,0,Dieroornummer,Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "Milchleistung (kg) je Monat Milchmengenmessung",
          filter: "Action (Herdenerkennung,0,Ohrmarke des Tieres,Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "Production laitière (kg) par mois de contrôle laitier",
          filter:
            "Action (Identificateur de troupeau,0,Marque auriculaire de l'animal,Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "Milk yield (kg) by milk recording month",
          filter: "Action (Herd identifier,0,Animal eartag,Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "DIM by time by parity",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "Milk yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "305d yield (kg) by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "Peak yield by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "Time to half by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-GB",
        },
        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "en-US",
        },
        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "nl-NL",
        },
        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Datum),Parity 2+)",
          lng: "de-DE",
        },
        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "fr-FR",
        },
        {
          mark: "Time to peak by milk recording month MRO",
          filter: "Action (0,MONTH(Date),Parity 2+)",
          lng: "pl-PL",
        },

        {
          mark: "Lactation curve parameters by AI company",
          filter: "Action (0,AI Company)",
          lng: "en-GB",
        },
        {
          mark: "Lactation curve parameters by AI company",
          filter: "Action (0,AI Company)",
          lng: "en-US",
        },
        {
          mark: "Lactatie curve parameters volgens KI organisatie",
          filter: "Action (0,KI organisatie)",
          lng: "nl-NL",
        },
        {
          mark: "Laktationskurvenparameter nach Zuchtunternehmen",
          filter: "Action (0,KB Unternehmen)",
          lng: "de-DE",
        },
        {
          mark: "Paramètres de la courbe de lactation par centre d'IA",
          filter: "Action (0,Centre d'IA)",
          lng: "fr-FR",
        },
        {
          mark: "Lactation curve parameters by AI company",
          filter: "Action (0,AI Company)",
          lng: "pl-PL",
        },

        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter: "Action (0,Herd identifier,Animal eartag,Parity)",
          lng: "en-GB",
        },
        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter: "Action (0,Herd identifier,Animal eartag,Parity)",
          lng: "en-US",
        },
        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter: "Action (0,Bedrijfsnummer,Dieroornummer,Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter: "Action (0,Herdenerkennung,Ohrmarke des Tieres,Laktation)",
          lng: "de-DE",
        },
        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter:
            "Action (0,Identificateur de troupeau,Marque auriculaire de l'animal,Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Milk yield (kg) by milk recording month MM",
          filter: "Action (0,Herd identifier,Animal eartag,Parity)",
          lng: "pl-PL",
        },

        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Milk yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },

        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "DIM by month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },

        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "305d yield (kg) by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },

        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Peak yield by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },

        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Time to half by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },

        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-GB",
        },
        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "en-US",
        },
        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Pariteit)",
          lng: "nl-NL",
        },
        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Datum),Laktation)",
          lng: "de-DE",
        },
        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Time to peak by milk recording month trend MM",
          filter: "Action (0,MONTH(Date),Parity)",
          lng: "pl-PL",
        },
      ],
      presalesAuditFilterPairs: [
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "en-GB",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "en-US",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactatie nummer)",
          lng: "nl-NL",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Laktationsanzahl)",
          lng: "de-DE",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "pl-PL",
        },

        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "en-GB",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "en-US",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Gem. leeftijd,Aantal inseminaties)",
          lng: "nl-NL",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "de-DE",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "fr-FR",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "pl-PL",
        },

        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "en-GB",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "en-US",
        },
        {
          mark: "Fokwaarde vader tabel",
          filter: "Action (Geboortejaar)",
          lng: "nl-NL",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "de-DE",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "fr-FR",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "pl-PL",
        },

        {
          mark: "Sire PTA graph",
          filter: "Action (Birth year)",
          lng: "en-GB",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (Birth year)",
          lng: "en-US",
        },
        {
          mark: "Fokwaarde vader grafiek",
          filter: "Action (Geboortejaar)",
          lng: "nl-NL",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (Birth year)",
          lng: "de-DE",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (Birth year)",
          lng: "fr-FR",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (Birth year)",
          lng: "pl-PL",
        },

        {
          mark: "Sires of conception",
          filter:
            "Action (Bull type,Bull name,Pregnant,LastInseminationBullName)",
          lng: "en-GB",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull type,Bull name,Pregnant,LastInseminationBullName)",
          lng: "en-US",
        },
        {
          mark: "Stieren",
          filter:
            "Action (Bull type,Stier naam,Pregnant,LastInseminationBullName)",
          lng: "nl-NL",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull type,Name des Bullen,Pregnant,LastInseminationBullName)",
          lng: "de-DE",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull type,Nom du taureau,Pregnant,LastInseminationBullName)",
          lng: "fr-FR",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull type,Bull name,Pregnant,LastInseminationBullName)",
          lng: "pl-PL",
        },

        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-GB",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-US",
        },
        {
          mark: "Pinken bij 1ste inseminatie",
          filter: "Action (Soort sperma,PI NM$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,PI NM$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,PI NM$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "pl-PL",
        },

        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-GB",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-US",
        },
        {
          mark: "Lactatie 1 dieren bij 1ste inseminatie",
          filter: "Action (Soort sperma,PI NM$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,PI NM$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,PI NM$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "pl-PL",
        },

        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-GB",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "en-US",
        },
        {
          mark: "Lactatie >1 koeien bij eerste inseminatie",
          filter: "Action (Soort sperma,PI NM$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,PI NM$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,PI NM$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,PI NM$ category)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response DPR graph for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "en-GB",
        },
        {
          mark: "Herd response DPR graph for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "en-US",
        },
        {
          mark: "Bedrijfseffect DPR grafiek voor DIL > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response DPR graph for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "de-DE",
        },
        {
          mark: "Herd response DPR graph for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response DPR graph for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response milk for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "en-GB",
        },
        {
          mark: "Herd response milk for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "en-US",
        },
        {
          mark: "Bedrijfseffect melk voor DIL > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response milk for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "de-DE",
        },
        {
          mark: "Herd response milk for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response milk for DIM > 150",
          filter: "Action (AnimalEartag,HerdIdentifier)",
          lng: "pl-PL",
        },

        {
          mark: "Table",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "en-GB",
        },
        {
          mark: "Table",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "en-US",
        },
        {
          mark: "Tabel",
          filter: "Action (milkSTR,Afst. Index Melk)",
          lng: "nl-NL",
        },
        {
          mark: "Table",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "de-DE",
        },
        {
          mark: "Table",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "fr-FR",
        },
        {
          mark: "Table",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "pl-PL",
        },

        {
          mark: "Graph",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "en-GB",
        },
        {
          mark: "Graph",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "en-US",
        },
        {
          mark: "Graph",
          filter: "Action (milkSTR,Afst. Index Melk)",
          lng: "nl-NL",
        },
        {
          mark: "Graph",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "de-DE",
        },
        {
          mark: "Graph",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "fr-FR",
        },
        {
          mark: "Graph",
          filter: "Action (milkSTR,PI Milk rank)",
          lng: "pl-PL",
        },

        {
          mark: "N350 First Lactation Cows",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "en-GB",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "en-US",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (Afst.Index DPR,dprSTR)",
          lng: "nl-NL",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "de-DE",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "fr-FR",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "pl-PL",
        },

        {
          mark: "Pedigree index DPR",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "en-GB",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "en-US",
        },
        {
          mark: "Afstammingsindex DPR",
          filter: "Action (Afst.Index DPR,dprSTR)",
          lng: "nl-NL",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "de-DE",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "fr-FR",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (PI DPR  rank,dprSTR)",
          lng: "pl-PL",
        },
      ],

      postSalesReportFilterPairs: [
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "en-GB",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "en-US",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactatie nummer)",
          lng: "nl-NL",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Laktationsanzahl)",
          lng: "de-DE",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Herd Inventory Table",
          filter: "Action (Lactation number)",
          lng: "pl-PL",
        },

        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "en-GB",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "en-US",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Gem. leeftijd,Aantal inseminaties)",
          lng: "nl-NL",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "de-DE",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "fr-FR",
        },
        {
          mark: "Heifer Inventory Home",
          filter: "Action (Avg age,TBRD)",
          lng: "pl-PL",
        },

        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "en-GB",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "en-US",
        },
        {
          mark: "Fokwaarde vader tabel",
          filter: "Action (Geboortejaar)",
          lng: "nl-NL",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "de-DE",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "fr-FR",
        },
        {
          mark: "Sire PTA table",
          filter: "Action (Birth year)",
          lng: "pl-PL",
        },

        {
          mark: "Sire PTA graph",
          filter: "Action (YEAR(Birth date))",
          lng: "en-GB",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (YEAR(Birth date))",
          lng: "en-US",
        },
        {
          mark: "Fokwaarde vader grafiek",
          filter: "Action (YEAR(Geboortedatum))",
          lng: "nl-NL",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (YEAR(Birth date))",
          lng: "de-DE",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (YEAR(Birth date))",
          lng: "fr-FR",
        },
        {
          mark: "Sire PTA graph",
          filter: "Action (YEAR(Birth date))",
          lng: "pl-PL",
        },

        {
          mark: "Sires of conception",
          filter:
            "Action (Bull name,Pregnant,Bull type,LastInseminationBullName)",
          lng: "en-GB",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull name,Pregnant,Bull type,LastInseminationBullName)",
          lng: "en-US",
        },
        {
          mark: "Stieren",
          filter:
            "Action (Stier naam,Pregnant,Bull type,LastInseminationBullName)",
          lng: "nl-NL",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Name des Bullen,Pregnant,Bull type,LastInseminationBullName)",
          lng: "de-DE",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Nom du taureau,Pregnant,Bull type,LastInseminationBullName)",
          lng: "fr-FR",
        },
        {
          mark: "Sires of conception",
          filter:
            "Action (Bull name,Pregnant,Bull type,LastInseminationBullName)",
          lng: "pl-PL",
        },

        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-GB",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-US",
        },
        {
          mark: "Pinken bij 1ste inseminatie",
          filter: "Action (Soort sperma,DWP$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,DWP$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,DWP$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "Heifers at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "pl-PL",
        },

        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-GB",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-US",
        },
        {
          mark: "Lactatie 1 dieren bij 1ste inseminatie",
          filter: "Action (Soort sperma,DWP$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,DWP$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,DWP$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "1st lactation cows at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "pl-PL",
        },

        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-GB",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "en-US",
        },
        {
          mark: "Lactatie >1 koeien bij eerste inseminatie",
          filter: "Action (Soort sperma,DWP$ categorie)",
          lng: "nl-NL",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,DWP$ kategorie)",
          lng: "de-DE",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,DWP$ catégorie)",
          lng: "fr-FR",
        },
        {
          mark: "Cows with >1st lactation at 1st insemination",
          filter: "Action (Type of semen,DWP$ category)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response milk for DIM>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "en-GB",
        },
        {
          mark: "Herd response milk for DIM>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "en-US",
        },
        {
          mark: "Bedrijfseffect melk voor DIL>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "nl-NL",
        },
        {
          mark: "Herd response milk for DIM>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "de-DE",
        },
        {
          mark: "Herd response milk for DIM>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "fr-FR",
        },
        {
          mark: "Herd response milk for DIM>150",
          filter: "Action (AnimalEartag,HerdIdentifier) 1",
          lng: "pl-PL",
        },

        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "en-GB",
        },
        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "en-US",
        },
        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "nl-NL",
        },
        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "de-DE",
        },
        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "fr-FR",
        },
        {
          mark: "305ME milk table",
          filter: "Action (GPTA milk rank)",
          lng: "pl-PL",
        },

        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "en-GB",
        },
        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "en-US",
        },
        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "nl-NL",
        },
        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "de-DE",
        },
        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "fr-FR",
        },
        {
          mark: "305ME milk graph",
          filter: "Action (GPTA milk rank)",
          lng: "pl-PL",
        },

        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "en-GB",
        },
        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "en-US",
        },
        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "nl-NL",
        },
        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "de-DE",
        },
        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "fr-FR",
        },
        {
          mark: "GPTA CR Table",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "pl-PL",
        },

        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "en-GB",
        },
        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "en-US",
        },
        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "nl-NL",
        },
        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "de-DE",
        },
        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "fr-FR",
        },
        {
          mark: "GPTA Conception rate graph",
          filter: "Action (GPTA Conception rate rank,cr)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "en-GB",
        },
        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "en-US",
        },
        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "nl-NL",
        },
        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "de-DE",
        },
        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "fr-FR",
        },
        {
          mark: "Herd response DPR for DIM>150",
          filter: "Action (AnimalEartag,DIM>150,HerdIdentifier) 1",
          lng: "pl-PL",
        },

        {
          mark: "N350 First Lactation Cows",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "en-GB",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "en-US",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (GPTA DPR rank,DaysOpenDPR)",
          lng: "nl-NL",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "de-DE",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "fr-FR",
        },
        {
          mark: "N350 First Lactation Cows",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "pl-PL",
        },

        {
          mark: "Pedigree index DPR",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "en-GB",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "en-US",
        },
        {
          mark: "Afstammingsindex DPR",
          filter: "Action (GPTA DPR rank,DaysOpenDPR)",
          lng: "nl-NL",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "de-DE",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "fr-FR",
        },
        {
          mark: "Pedigree index DPR",
          filter: "Action (DaysOpenDPR,GPTA DPR rank)",
          lng: "pl-pL",
        },

        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% culled vs lactation number)",
          lng: "en-GB",
        },
        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% culled vs lactation number)",
          lng: "en-US",
        },
        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% afgevoerd vs lactatienummer)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% culled vs lactation number)",
          lng: "de-DE",
        },
        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% culled vs lactation number)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response culled table",
          filter: "Action (GPTA PL rank,% culled vs lactation number)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Lactation number)",
          lng: "en-GB",
        },
        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Lactation number)",
          lng: "en-US",
        },
        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Lactatie nummer)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Laktationsanzahl)",
          lng: "de-DE",
        },
        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response culled graph",
          filter: "Action (GPTA PL rank,Lactation number)",
          lng: "pl-PL",
        },

        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-US",
        },
        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Geboortedatum))",
          lng: "nl-NL",
        },
        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Dairy wellness profit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-US",
        },
        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Geboortedatum))",
          lng: "nl-NL",
        },
        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Net merit genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "en-GB",
        },
        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "en-US",
        },
        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "nl-NL",
        },
        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "de-DE",
        },
        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "fr-FR",
        },
        {
          mark: "Wellness traits prevalence summary",
          filter: "Action (DIsease)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "en-GB",
        },
        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "en-US",
        },
        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "de-DE",
        },
        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response to mastitis",
          filter: "Action (mastitisString,STA rank mastitis)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "en-GB",
        },
        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "en-US",
        },
        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "de-DE",
        },
        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response to metritis",
          filter: "Action (STA rank metritis,metritisString)",
          lng: "pl-PL",
        },

        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "en-GB",
        },
        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "en-US",
        },
        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "nl-NL",
        },
        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "de-DE",
        },
        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "fr-FR",
        },
        {
          mark: "Metritis STA vs Actual Metritis",
          filter: "Action (STA/Metritis/All,STAMet,metritisString)",
          lng: "pl-PL",
        },

        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "en-GB",
        },
        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "en-US",
        },
        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "nl-NL",
        },
        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "de-DE",
        },
        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "fr-FR",
        },
        {
          mark: "Mastitis STA vs Actual Mastitis",
          filter: "Action (STA/Mastitis/All,mastitisString,STAMast)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "en-GB",
        },
        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "en-US",
        },
        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "de-DE",
        },
        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response to lameness",
          filter: "Action (STA rank Lameness,lameString)",
          lng: "pl-PL",
        },

        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "en-GB",
        },
        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "en-US",
        },
        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "nl-NL",
        },
        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "de-DE",
        },
        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "fr-FR",
        },
        {
          mark: "Lameness STA vs Actual Lameness",
          filter: "Action (STA/Lameness/All,STALame,lameString)",
          lng: "pl-PL",
        },

        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "en-GB",
        },
        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "en-US",
        },
        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "nl-NL",
        },
        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "de-DE",
        },
        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "fr-FR",
        },
        {
          mark: "Herd response to retained placenta",
          filter: "Action (STA rank retained placenta,retainedplacentaString)",
          lng: "pl-PL",
        },

        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "en-GB",
        },
        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "en-US",
        },
        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "nl-NL",
        },
        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "de-DE",
        },
        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "fr-FR",
        },
        {
          mark: "Retained Placenta STA vs Actual Retained Placenta",
          filter: "Action (STA/RP/All,STARp,retainedplacentaString)",
          lng: "pl-PL",
        },

        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-GB",
        },
        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-US",
        },
        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Geboortedatum)) 1",
          lng: "nl-NL",
        },
        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "de-DE",
        },
        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "DWP$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-GB",
        },
        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "en-US",
        },
        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Geboortedatum)) 1",
          lng: "nl-NL",
        },
        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "de-DE",
        },
        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "NM$ genetic progress",
          filter: "Action (YEAR(Birth date)) 1",
          lng: "pl-PL",
        },
      ],

      masterKPIFilterValues: [
        {
          value:
            "[sqlproxy.0vc1z960xu8u74193hgyy0hhq60n].[usr:Calculation_744219862621671428:qk]",
          label: "% of lame cows",
          id: "poflamecows",
          module: "clawHealth",
        },
        {
          value:
            "[sqlproxy.0vc1z960xu8u74193hgyy0hhq60n].[usr:Calculation_744219862624780293:qk]",
          label: "% of Digital Dermatitis",
          id: "pofdigitaldermatitis",
          module: "clawHealth",
        },
        {
          value: "[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[avg:Interval:qk]",
          label: "Heat interval ",
          id: "heatinterval",
          module: "repro",
        },
        {
          value:
            "[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838913212438:qk]",
          label: "Inseminations Per Pregnancy",
          id: "inseminationsperpregnancy",
          module: "repro",
        },
        {
          value:
            "[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838914420759:qk]",
          label: "Conception Rate",
          id: "conceptionrate",
          module: "repro",
        },
        {
          value:
            "[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838914899992:qk]",
          label: "Number of pregnancies",
          id: "numberofpregnancies",
          module: "repro",
        },
        {
          value:
            "[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:IntakeConsumedKg:qk]",
          label: "Concentrate intake (kg)",
          id: "concentrateintakekg",
          module: "feed",
        },
        {
          value:
            "[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:IntakeProgrammedKg:qk]",
          label: "Concentrate programmed (kg)",
          id: "concentrateprogrammedkg",
          module: "feed",
        },
        {
          value: "[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:LeftoverKg:qk]",
          label: "Concentrate leftover (kg)",
          id: "concentrateleftoverkg",
          module: "feed",
        },
        {
          value:
            "[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:CalculatedSPP:qk]",
          label: "SPP",
          id: "spp",
          module: "milk",
        },
        {
          value: "[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:DaysInMilk:qk]",
          label: "Days in milk",
          id: "daysinmilk",
          module: "milk",
        },
        {
          value: "[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:MilkYieldKg:qk]",
          label: "Milk yield (kg)",
          id: "milkyieldkg",
          module: "milk",
        },
      ],
      //min period
      //1 - day, 2 - week
      mainKPIDashboards: [
        {
          iid: 1,
          id: "LatestTrimDateKPIDashboard",
          selected: false,
          datePeriod: 2,
          minPeriod: 1,
        },
        {
          iid: 2,
          id: "NumberofLameCowsKPIDashboard",
          selected: true,
          datePeriod: 2,
          minPeriod: 1,
        },
        {
          iid: 3,
          id: "NumberofTrimmedCowsKPIDashboard",
          selected: true,
          datePeriod: 4,
          minPeriod: 1,
        },
        {
          iid: 4,
          id: "PercentageoftopsixlesionsKPIdashboard",
          selected: false,
          datePeriod: 6,
          minPeriod: 1,
        },
        {
          iid: 5,
          id: "DashboardforKPInumberofotherslesions",
          selected: false,
          datePeriod: 6,
          minPeriod: 1,
        },
        {
          iid: 6,
          id: "KPIdashboardfornumberofDigitalDermatits",
          selected: false,
          datePeriod: 6,
          minPeriod: 1,
        },
        {
          iid: 7,
          id: "PregnancyrateonlastdayKPIdashboard",
          selected: true,
          datePeriod: 8,
          minPeriod: 2,
        },
        {
          iid: 8,
          id: "DashboardforConceptionratelastmonthKPI",
          selected: false,
          datePeriod: 7,
          minPeriod: 2,
        },
        {
          iid: 9,
          id: "SomaticCellcountKPIdashboard",
          selected: false,
          datePeriod: 8,
          minPeriod: 2,
        },
        {
          iid: 10,
          id: "KPINumberofanimalsonlastdaydashboard",
          selected: false,
          datePeriod: 4,
          minPeriod: 1,
        },
        {
          iid: 11,
          id: "AveragemilkyieldlastmonthKPIdashboard",
          selected: true,
          datePeriod: 7,
          minPeriod: 1,
        },
      ],

      countryCodeList: {
        AFG: 4,
        ALB: 8,
        ATA: 10,
        DZA: 12,
        ASM: 16,
        AND: 20,
        AGO: 24,
        ATG: 28,
        AZE: 31,
        ARG: 32,
        AUS: 36,
        AUT: 40,
        BHS: 44,
        BHR: 48,
        BGD: 50,
        ARM: 51,
        BRB: 52,
        BEL: 56,
        BMU: 60,
        BTN: 64,
        BOL: 68,
        BIH: 70,
        BWA: 72,
        BVT: 74,
        BRA: 76,
        BLZ: 84,
        IOT: 86,
        SLB: 90,
        VGB: 92,
        BRN: 96,
        BGR: 100,
        MMR: 104,
        BDI: 108,
        BLR: 112,
        KHM: 116,
        CMR: 120,
        CAN: 124,
        CPV: 132,
        CYM: 136,
        CAF: 140,
        LKA: 144,
        TCD: 148,
        CHL: 152,
        CHN: 156,
        TWN: 158,
        CXR: 162,
        CCK: 166,
        COL: 170,
        COM: 174,
        MYT: 175,
        COG: 178,
        COD: 180,
        COK: 184,
        CRI: 188,
        HRV: 191,
        CUB: 192,
        CYP: 196,
        CZE: 203,
        BEN: 204,
        DNK: 208,
        DMA: 212,
        DOM: 214,
        ECU: 218,
        SLV: 222,
        GNQ: 226,
        ETH: 231,
        ERI: 232,
        EST: 233,
        FRO: 234,
        FLK: 238,
        SGS: 239,
        FJI: 242,
        FIN: 246,
        ALA: 248,
        FRA: 250,
        GUF: 254,
        PYF: 258,
        ATF: 260,
        DJI: 262,
        GAB: 266,
        GEO: 268,
        GMB: 270,
        PSE: 275,
        DEU: 276,
        GHA: 288,
        GIB: 292,
        KIR: 296,
        GRC: 300,
        GRL: 304,
        GRD: 308,
        GLP: 312,
        GUM: 316,
        GTM: 320,
        GIN: 324,
        GUY: 328,
        HTI: 332,
        HMD: 334,
        VAT: 336,
        HND: 340,
        HKG: 344,
        HUN: 348,
        ISL: 352,
        IND: 356,
        IDN: 360,
        IRN: 364,
        IRQ: 368,
        IRL: 372,
        ISR: 376,
        ITA: 380,
        CIV: 384,
        JAM: 388,
        JPN: 392,
        KAZ: 398,
        JOR: 400,
        KEN: 404,
        PRK: 408,
        KOR: 410,
        KWT: 414,
        KGZ: 417,
        LAO: 418,
        LBN: 422,
        LSO: 426,
        LVA: 428,
        LBR: 430,
        LBY: 434,
        LIE: 438,
        LTU: 440,
        LUX: 442,
        MAC: 446,
        MDG: 450,
        MWI: 454,
        MYS: 458,
        MDV: 462,
        MLI: 466,
        MLT: 470,
        MTQ: 474,
        MRT: 478,
        MUS: 480,
        MEX: 484,
        MCO: 492,
        MNG: 496,
        MDA: 498,
        MNE: 499,
        MSR: 500,
        MAR: 504,
        MOZ: 508,
        OMN: 512,
        NAM: 516,
        NRU: 520,
        NPL: 524,
        NLD: 528,
        CUW: 531,
        ABW: 533,
        SXM: 534,
        BES: 535,
        NCL: 540,
        VUT: 548,
        NZL: 554,
        NIC: 558,
        NER: 562,
        NGA: 566,
        NIU: 570,
        NFK: 574,
        NOR: 578,
        MNP: 580,
        UMI: 581,
        FSM: 583,
        MHL: 584,
        PLW: 585,
        PAK: 586,
        PAN: 591,
        PNG: 598,
        PRY: 600,
        PER: 604,
        PHL: 608,
        PCN: 612,
        POL: 616,
        PRT: 620,
        GNB: 624,
        TLS: 626,
        PRI: 630,
        QAT: 634,
        REU: 638,
        ROU: 642,
        RUS: 643,
        RWA: 646,
        BLM: 652,
        SHN: 654,
        KNA: 659,
        AIA: 660,
        LCA: 662,
        MAF: 663,
        SPM: 666,
        VCT: 670,
        SMR: 674,
        STP: 678,
        SAU: 682,
        SEN: 686,
        SRB: 688,
        SYC: 690,
        SLE: 694,
        SGP: 702,
        SVK: 703,
        VNM: 704,
        SVN: 705,
        SOM: 706,
        ZAF: 710,
        ZWE: 716,
        ESP: 724,
        ESH: 732,
        SDN: 736,
        SUR: 740,
        SJM: 744,
        SWZ: 748,
        SWE: 752,
        CHE: 756,
        SYR: 760,
        TJK: 762,
        THA: 764,
        TGO: 768,
        TKL: 772,
        TON: 776,
        TTO: 780,
        ARE: 784,
        TUN: 788,
        TUR: 792,
        TKM: 795,
        TCA: 796,
        TUV: 798,
        UGA: 800,
        UKR: 804,
        MKD: 807,
        EGY: 818,
        GBR: 826,
        GGY: 831,
        JEY: 832,
        IMN: 833,
        TZA: 834,
        USA: 840,
        VIR: 850,
        BFA: 854,
        URY: 858,
        UZB: 860,
        VEN: 862,
        WLF: 876,
        WSM: 882,
        YEM: 887,
        ZMB: 894,
      },
      countries: [
        {
          name: "United States",
          code: "USA",
        },
        {
          name: "Canada",
          code: "CAN",
        },
        {
          name: "Afghanistan",
          code: "AFG",
        },
        {
          name: "Albania",
          code: "ALB",
        },
        {
          name: "Algeria",
          code: "DZA",
        },
        {
          name: "American Samoa",
          code: "ASM",
        },
        {
          name: "Andorra",
          code: "AND",
        },
        {
          name: "Angola",
          code: "AGO",
        },
        {
          name: "Anguilla",
          code: "AIA",
        },
        {
          name: "Antarctica",
          code: "ATA",
        },
        {
          name: "Antigua and Barbuda",
          code: "ATG",
        },
        {
          name: "Argentina",
          code: "ARG",
        },
        {
          name: "Armenia",
          code: "ARM",
        },
        {
          name: "Aruba",
          code: "ABW",
        },
        {
          name: "Australia",
          code: "AUS",
        },
        {
          name: "Austria",
          code: "AUT",
        },
        {
          name: "Azerbaijan",
          code: "AZE",
        },
        {
          name: "Bahamas",
          code: "BHS",
        },
        {
          name: "Bahrain",
          code: "BHR",
        },
        {
          name: "Bangladesh",
          code: "BGD",
        },
        {
          name: "Barbados",
          code: "BRB",
        },
        {
          name: "Belarus",
          code: "BLR",
        },
        {
          name: "Belgium",
          code: "BEL",
        },
        {
          name: "Belize",
          code: "BLZ",
        },
        {
          name: "Benin",
          code: "BEN",
        },
        {
          name: "Bermuda",
          code: "BMU",
        },
        {
          name: "Bhutan",
          code: "BTN",
        },
        {
          name: "Bolivia",
          code: "BOL",
        },
        {
          name: "Bosnia and Herzegowina",
          code: "BIH",
        },
        {
          name: "Botswana",
          code: "BWA",
        },
        {
          name: "Bouvet Island",
          code: "BVT",
        },
        {
          name: "Brazil",
          code: "BRA",
        },
        {
          name: "British Indian Ocean Territory",
          code: "IOT",
        },
        {
          name: "Brunei Darussalam",
          code: "BRN",
        },
        {
          name: "Bulgaria",
          code: "BGR",
        },
        {
          name: "Burkina Faso",
          code: "BFA",
        },
        {
          name: "Burundi",
          code: "BDI",
        },
        {
          name: "Cambodia",
          code: "KHM",
        },
        {
          name: "Cameroon",
          code: "CMR",
        },
        {
          name: "Cape Verde",
          code: "CPV",
        },
        {
          name: "Cayman Islands",
          code: "CYM",
        },
        {
          name: "Central African Republic",
          code: "CAF",
        },
        {
          name: "Chad",
          code: "TCD",
        },
        {
          name: "Chile",
          code: "CHL",
        },
        {
          name: "China",
          code: "CHN",
        },
        {
          name: "Christmas Island",
          code: "CXR",
        },
        {
          name: "Cocos (Keeling) Islands",
          code: "CCK",
        },
        {
          name: "Colombia",
          code: "COL",
        },
        {
          name: "Comoros",
          code: "COM",
        },
        {
          name: "Congo",
          code: "COG",
        },
        {
          name: "Cook Islands",
          code: "COK",
        },
        {
          name: "Costa Rica",
          code: "CRI",
        },
        {
          name: "Cote D&#39;Ivoire",
          code: "CIV",
        },
        {
          name: "Croatia",
          code: "HRV",
        },
        {
          name: "Cuba",
          code: "CUB",
        },
        {
          name: "Cyprus",
          code: "CYP",
        },
        {
          name: "Czech Republic",
          code: "CZE",
        },
        {
          name: "Denmark",
          code: "DNK",
        },
        {
          name: "Djibouti",
          code: "DJI",
        },
        {
          name: "Dominica",
          code: "DMA",
        },
        {
          name: "Dominican Republic",
          code: "DOM",
        },
        {
          name: "Ecuador",
          code: "ECU",
        },
        {
          name: "Egypt",
          code: "EGY",
        },
        {
          name: "El Salvador",
          code: "SLV",
        },
        {
          name: "Equatorial Guinea",
          code: "GNQ",
        },
        {
          name: "Eritrea",
          code: "ERI",
        },
        {
          name: "Estonia",
          code: "EST",
        },
        {
          name: "Ethiopia",
          code: "ETH",
        },
        {
          name: "Falkland Islands (Malvinas)",
          code: "FLK",
        },
        {
          name: "Faroe Islands",
          code: "FRO",
        },
        {
          name: "Fiji",
          code: "FJI",
        },
        {
          name: "Finland",
          code: "FIN",
        },
        {
          name: "France",
          code: "FRA",
        },
        {
          name: "French Guiana",
          code: "GUF",
        },
        {
          name: "French Polynesia",
          code: "PYF",
        },
        {
          name: "French Southern Territories",
          code: "ATF",
        },
        {
          name: "Gabon",
          code: "GAB",
        },
        {
          name: "Gambia",
          code: "GMB",
        },
        {
          name: "Georgia",
          code: "GEO",
        },
        {
          name: "Germany",
          code: "DEU",
        },
        {
          name: "Ghana",
          code: "GHA",
        },
        {
          name: "Gibraltar",
          code: "GIB",
        },
        {
          name: "Greece",
          code: "GRC",
        },
        {
          name: "Greenland",
          code: "GRL",
        },
        {
          name: "Grenada",
          code: "GRD",
        },
        {
          name: "Guadeloupe",
          code: "GLP",
        },
        {
          name: "Guam",
          code: "GUM",
        },
        {
          name: "Guatemala",
          code: "GTM",
        },
        {
          name: "Guinea",
          code: "GIN",
        },
        {
          name: "Guinea-bissau",
          code: "GNB",
        },
        {
          name: "Guyana",
          code: "GUY",
        },
        {
          name: "Haiti",
          code: "HTI",
        },
        {
          name: "Heard and Mc Donald Islands",
          code: "HMD",
        },
        {
          name: "Honduras",
          code: "HND",
        },
        {
          name: "Hong Kong",
          code: "HKG",
        },
        {
          name: "Hungary",
          code: "HUN",
        },
        {
          name: "Iceland",
          code: "ISL",
        },
        {
          name: "India",
          code: "IND",
        },
        {
          name: "Indonesia",
          code: "IDN",
        },
        {
          name: "Iran (Islamic Republic of)",
          code: "IRN",
        },
        {
          name: "Iraq",
          code: "IRQ",
        },
        {
          name: "Ireland",
          code: "IRL",
        },
        {
          name: "Israel",
          code: "ISR",
        },
        {
          name: "Italy",
          code: "ITA",
        },
        {
          name: "Jamaica",
          code: "JAM",
        },
        {
          name: "Japan",
          code: "JPN",
        },
        {
          name: "Jordan",
          code: "JOR",
        },
        {
          name: "Kazakhstan",
          code: "KAZ",
        },
        {
          name: "Kenya",
          code: "KEN",
        },
        {
          name: "Kiribati",
          code: "KIR",
        },
        {
          name: "Korea",
          code: "KOR",
        },
        {
          name: "Korea, Democratic People&#39;s Republic of",
          code: "PRK",
        },
        {
          name: "Kuwait",
          code: "KWT",
        },
        {
          name: "Kyrgyzstan",
          code: "KGZ",
        },
        {
          name: "Lao People&#39;s Democratic Republic",
          code: "LAO",
        },
        {
          name: "Latvia",
          code: "LVA",
        },
        {
          name: "Lebanon",
          code: "LBN",
        },
        {
          name: "Lesotho",
          code: "LSO",
        },
        {
          name: "Liberia",
          code: "LBR",
        },
        {
          name: "Libyan Arab Jamahiriya",
          code: "LBY",
        },
        {
          name: "Liechtenstein",
          code: "LIE",
        },
        {
          name: "Lithuania",
          code: "LTU",
        },
        {
          name: "Luxembourg",
          code: "LUX",
        },
        {
          name: "Macau",
          code: "MAC",
        },
        {
          name: "Macedonia",
          code: "MKD",
        },
        {
          name: "Madagascar",
          code: "MDG",
        },
        {
          name: "Malawi",
          code: "MWI",
        },
        {
          name: "Malaysia",
          code: "MYS",
        },
        {
          name: "Maldives",
          code: "MDV",
        },
        {
          name: "Mali",
          code: "MLI",
        },
        {
          name: "Malta",
          code: "MLT",
        },
        {
          name: "Marshall Islands",
          code: "MHL",
        },
        {
          name: "Martinique",
          code: "MTQ",
        },
        {
          name: "Mauritania",
          code: "MRT",
        },
        {
          name: "Mauritius",
          code: "MUS",
        },
        {
          name: "Mayotte",
          code: "MYT",
        },
        {
          name: "Mexico",
          code: "MEX",
        },
        {
          name: "Micronesia",
          code: "FSM",
        },
        {
          name: "Moldova",
          code: "MDA",
        },
        {
          name: "Monaco",
          code: "MCO",
        },
        {
          name: "Mongolia",
          code: "MNG",
        },
        {
          name: "Montenegro",
          code: "MNE",
        },
        {
          name: "Montserrat",
          code: "MSR",
        },
        {
          name: "Morocco",
          code: "MAR",
        },
        {
          name: "Mozambique",
          code: "MOZ",
        },
        {
          name: "Myanmar",
          code: "MMR",
        },
        {
          name: "Namibia",
          code: "NAM",
        },
        {
          name: "Nauru",
          code: "NRU",
        },
        {
          name: "Nepal",
          code: "NPL",
        },
        {
          name: "Netherlands",
          code: "NLD",
        },
        {
          name: "Netherlands Antilles",
          code: "ANT",
        },
        {
          name: "New Caledonia",
          code: "NCL",
        },
        {
          name: "New Zealand",
          code: "NZL",
        },
        {
          name: "Nicaragua",
          code: "NIC",
        },
        {
          name: "Niger",
          code: "NER",
        },
        {
          name: "Nigeria",
          code: "NGA",
        },
        {
          name: "Niue",
          code: "NIU",
        },
        {
          name: "Norfolk Island",
          code: "NFK",
        },
        {
          name: "Northern Mariana Islands",
          code: "MNP",
        },
        {
          name: "Norway",
          code: "NOR",
        },
        {
          name: "Oman",
          code: "OMN",
        },
        {
          name: "Pakistan",
          code: "PAK",
        },
        {
          name: "Palau",
          code: "PLW",
        },
        {
          name: "Panama",
          code: "PAN",
        },
        {
          name: "Papua New Guinea",
          code: "PNG",
        },
        {
          name: "Paraguay",
          code: "PRY",
        },
        {
          name: "Peru",
          code: "PER",
        },
        {
          name: "Philippines",
          code: "PHL",
        },
        {
          name: "Pitcairn",
          code: "PCN",
        },
        {
          name: "Poland",
          code: "POL",
        },
        {
          name: "Portugal",
          code: "PRT",
        },
        {
          name: "Puerto Rico",
          code: "PRI",
        },
        {
          name: "Qatar",
          code: "QAT",
        },
        {
          name: "Reunion",
          code: "REU",
        },
        {
          name: "Romania",
          code: "ROM",
        },
        {
          name: "Russia",
          code: "RUS",
        },
        {
          name: "Rwanda",
          code: "RWA",
        },
        {
          name: "Saint Kitts and Nevis",
          code: "KNA",
        },
        {
          name: "Saint Lucia",
          code: "LCA",
        },
        {
          name: "Saint Vincent and the Grenadines",
          code: "VCT",
        },
        {
          name: "Samoa",
          code: "WSM",
        },
        {
          name: "San Marino",
          code: "SMR",
        },
        {
          name: "Sao Tome and Principe",
          code: "STP",
        },
        {
          name: "Saudi Arabia",
          code: "SAU",
        },
        {
          name: "Senegal",
          code: "SEN",
        },
        {
          name: "Serbia",
          code: "SRB",
        },
        {
          name: "Seychelles",
          code: "SYC",
        },
        {
          name: "Sierra Leone",
          code: "SLE",
        },
        {
          name: "Singapore",
          code: "SGP",
        },
        {
          name: "Slovakia (Slovak Republic)",
          code: "SVK",
        },
        {
          name: "Slovenia",
          code: "SVN",
        },
        {
          name: "Solomon Islands",
          code: "SLB",
        },
        {
          name: "Somalia",
          code: "SOM",
        },
        {
          name: "South Africa",
          code: "ZAF",
        },
        {
          name: "South Georgia &amp; South Sandwich Islands",
          code: "SGS",
        },
        {
          name: "Spain",
          code: "ESP",
        },
        {
          name: "Sri Lanka",
          code: "LKA",
        },
        {
          name: "St. Helena",
          code: "SHN",
        },
        {
          name: "St. Pierre and Miquelon",
          code: "SPM",
        },
        {
          name: "Sudan",
          code: "SDN",
        },
        {
          name: "Suriname",
          code: "SUR",
        },
        {
          name: "Svalbard and Jan Mayen Islands",
          code: "SJM",
        },
        {
          name: "Swaziland",
          code: "SWZ",
        },
        {
          name: "Sweden",
          code: "SWE",
        },
        {
          name: "Switzerland",
          code: "CHE",
        },
        {
          name: "Syrian Arab Republic",
          code: "SYR",
        },
        {
          name: "Taiwan",
          code: "TWN",
        },
        {
          name: "Tajikistan",
          code: "TJK",
        },
        {
          name: "Tanzania",
          code: "TZA",
        },
        {
          name: "Thailand",
          code: "THA",
        },
        {
          name: "Togo",
          code: "TGO",
        },
        {
          name: "Tokelau",
          code: "TKL",
        },
        {
          name: "Tonga",
          code: "TON",
        },
        {
          name: "Trinidad and Tobago",
          code: "TTO",
        },
        {
          name: "Tunisia",
          code: "TUN",
        },
        {
          name: "Turkey",
          code: "TUR",
        },
        {
          name: "Turkmenistan",
          code: "TKM",
        },
        {
          name: "Turks and Caicos Islands",
          code: "TCA",
        },
        {
          name: "Tuvalu",
          code: "TUV",
        },
        {
          name: "Uganda",
          code: "UGA",
        },
        {
          name: "Ukraine",
          code: "UKR",
        },
        {
          name: "United Arab Emirates",
          code: "ARE",
        },
        {
          name: "United Kingdom",
          code: "GBR",
        },
        {
          name: "United States minor outlying islands",
          code: "UMI",
        },
        {
          name: "Uruguay",
          code: "URY",
        },
        {
          name: "Uzbekistan",
          code: "UZB",
        },
        {
          name: "Vanuatu",
          code: "VUT",
        },
        {
          name: "Vatican City State (Holy See)",
          code: "VAT",
        },
        {
          name: "Venezuela",
          code: "VEN",
        },
        {
          name: "Viet Nam",
          code: "VNM",
        },
        {
          name: "Virgin Islands (British)",
          code: "VGB",
        },
        {
          name: "Virgin Islands (U.S.)",
          code: "VIR",
        },
        {
          name: "Wallis and Futuna Islands",
          code: "WLF",
        },
        {
          name: "Western Sahara",
          code: "ESH",
        },
        {
          name: "Yemen",
          code: "YEM",
        },
        {
          name: "Zambia",
          code: "ZMB",
        },
        {
          name: "Zimbabwe",
          code: "ZWE",
        },
      ],
      languages: [
        {
          name: "English",
          code: "en-GB",
          image: "gb.png",
        },
        {
          name: "English",
          code: "en-US",
          image: "us.png",
        },
        {
          name: "Nederlands",
          code: "nl-NL",
          image: "nl.png",
        },
        {
          name: "Deutsch",
          code: "de-DE",
          image: "de.png",
        },
        {
          name: "Français",
          code: "fr-FR",
          image: "fr.png",
        },
        {
          name: "Español",
          code: "es-ES",
          image: "es.png",
        },
        {
          name: "日本語",
          code: "ja-JP",
          image: "jp.png",
        },
        {
          name: "Čeština",
          code: "cs-CZ",
          image: "cz.png",
        },
        {
          name: "Polski",
          code: "pl-PL",
          image: "pl.png",
        },
      ],
      adviceList: [
        {
          id: 1,
          title: "To be culled",
          value: "_advice_to_be_culled_long_",
        },
        {
          id: 2,
          title: "To wait",
          value: "_advice_wait_long_",
        },
        {
          id: 3,
          title: "To treat",
          value: "_advice_to_treat_long_",
        },
        {
          id: 4,
          title: "Bacteriology",
          value: "_advice_bacteriology_long_",
        },
        {
          id: 5,
          title: "Dry off quarter",
          value: "_advice_dry_off_quarters_long_",
        },
        {
          id: 6,
          title: "Dry off",
          value: "_advice_dry_off_long_",
        },
        {
          id: 7,
          title: "Do not inseminate",
          value: "_advice_do_not_inseminate_long_",
        },
      ],
      parityCategories: [
        {
          id: 1,
          value: "1/2+",
          parities: [
            {
              id: 1,
              value: "1",
            },
            {
              id: 3,
              value: "2+",
            },
          ],
        },
        {
          id: 2,
          value: "1/2/3+",
          parities: [
            {
              id: 1,
              value: "1",
            },
            {
              id: 2,
              value: "2",
            },
            {
              id: 4,
              value: "3+",
            },
          ],
        },
      ],
      dimCategories: [
        {
          id: 1,
          value: "_label_dim_category_old_",
          dims: [
            {
              id: 1,
              value: "<60",
            },
            {
              id: 2,
              value: "60-120",
            },
            {
              id: 3,
              value: "120-200",
            },
            {
              id: 4,
              value: "200-305",
            },
            {
              id: 5,
              value: ">305",
            },
          ],
        },
        {
          id: 2,
          value: "_label_dim_category_new_",
          dims: [
            {
              id: 6,
              value: "<41",
            },
            {
              id: 7,
              value: "41-80",
            },
            {
              id: 8,
              value: "81-120",
            },
            {
              id: 9,
              value: "121-160",
            },
            {
              id: 10,
              value: "161-200",
            },
            {
              id: 11,
              value: ">200",
            },
          ],
        },
      ],
      animalStatusList: [
        {
          id: 0,
          value: "_animal_status_none_",
        },
        {
          id: 1,
          value: "_animal_status_open_",
        },
        {
          id: 3,
          value: "_animal_status_inseminated_",
        },
        {
          id: 4,
          value: "_animal_status_not_pregnant_",
        },
        {
          id: 5,
          value: "_animal_status_pregnant_",
        },
        {
          id: 6,
          value: "_animal_status_barren_",
        },
        {
          id: 7,
          value: "_animal_status_aborted_",
        },
        {
          id: 8,
          value: "_animal_status_dry_",
        },
        {
          id: 9,
          value: "_animal_status_sold_",
        },
        {
          id: 10,
          value: "_animal_status_dead_",
        },
        {
          id: 11,
          value: "_animal_status_presume_left_",
        },
      ],
    },
  });
})();

(function () {
  "use strict";
  angular.module("My").controller("appCtrl", appCtrl);
  /** @ngInject */
  function appCtrl(
    $state,
    $timeout,
    $scope,
    $rootScope,
    permissionService,
    aDashboardsService
  ) {
    var ac = this;
    ac.viewMenu = viewMenu;
    ac.showFixedMenu = showFixedMenu;
    ac.getBackgroundClass = getBackgroundClass;
    ac.getCurrentUserClass = getCurrentUserClass;
    ac.isHomePage = isHomePage;
    ac.showSidebar = true;

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return "body-".concat(houseStyle);
    }

    function showFixedMenu() {
      if ($state.current.name == "cockpit") {
        return true;
      } else {
        return false;
      }
    }

    function getBackgroundClass() {
      if ($state.current.name == "herds.dashboards") {
        if (ac.current_category != null && ac.current_category != undefined) {
          if (ac.current_category == 0) {
            return "dashboard-image image-production";
          } else if (ac.current_category == 1) {
            return "dashboard-image image-reproduction";
          } else if (ac.current_category == 2) {
            return "dashboard-image image-udder_health";
          } else if (ac.current_category == 3) {
            return "dashboard-image image-hoof_health";
          } else if (ac.current_category == 4) {
            return "dashboard-image image-herd_characteristics";
          } else if (ac.current_category == 5) {
            return "dashboard-image image-comments";
          } else if (ac.current_category == 6) {
            return "dashboard-image image-herd_environmental";
          } else if (ac.current_category == 7) {
            return "dashboard-image image-herd_genetics";
          } else {
            return "dashboard-image";
          }
        } else {
          return "dashboard-image";
        }
      } else {
        return "";
      }
    }
    $scope.$on("set_category_background", function (event, data) {
      ac.current_category = data;
    });

    $scope.$on("update_sidebar", function () {
      ac.showSidebar = false;
      $timeout(function () {
        ac.showSidebar = true;
      }, 0);
    });

    $scope.$on("$stateChangeSuccess", function () {
      checkDashboardsState();
    });

    function checkDashboardsState() {
      if (
        $state.current.name != "milk-production.spp" &&
        $state.current.name != "milk-production.milk-trend" &&
        $state.current.name != "milk-production.components"
      ) {
        aDashboardsService.milkTrendActiveType = undefined;
        aDashboardsService.milkTrendSourceType = undefined;
      }

      if (
        $state.current.name != "concentrate.overview" &&
        $state.current.name != "concentrate.leftovers" &&
        $state.current.name != "concentrate.intake" &&
        $state.current.name != "concentrate.feeding"
      ) {
        aDashboardsService.concentrateActiveType = undefined;
        aDashboardsService.concentrateSourceType = undefined;
      }

      if (
        $state.current.name != "milkings.failures" &&
        $state.current.name != "milkings.actual" &&
        $state.current.name != "milkings.refusals"
      ) {
        aDashboardsService.milkingsActiveType = undefined;
      }
    }

    function viewMenu() {
      if ($state.current.title == "login") {
        return false;
      } else {
        return true;
      }
    }

    function isHomePage() {
      if ($state.current.name == "home-arvesta") {
        return true;
      }
      return false;
    }
  }
})();

(function () {
  "use strict";

  angular.module("My").constant("COUNTRY_CODES", {
    codes: [
      {
        name: "Afghanistan",
        "alpha-2": "AF",
        "alpha-3": "AFG",
        "country-code": "004",
        "iso_3166-2": "ISO 3166-2:AF",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Åland Islands",
        "alpha-2": "AX",
        "alpha-3": "ALA",
        "country-code": "248",
        "iso_3166-2": "ISO 3166-2:AX",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Albania",
        "alpha-2": "AL",
        "alpha-3": "ALB",
        "country-code": "008",
        "iso_3166-2": "ISO 3166-2:AL",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Algeria",
        "alpha-2": "DZ",
        "alpha-3": "DZA",
        "country-code": "012",
        "iso_3166-2": "ISO 3166-2:DZ",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "American Samoa",
        "alpha-2": "AS",
        "alpha-3": "ASM",
        "country-code": "016",
        "iso_3166-2": "ISO 3166-2:AS",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Andorra",
        "alpha-2": "AD",
        "alpha-3": "AND",
        "country-code": "020",
        "iso_3166-2": "ISO 3166-2:AD",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Angola",
        "alpha-2": "AO",
        "alpha-3": "AGO",
        "country-code": "024",
        "iso_3166-2": "ISO 3166-2:AO",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Anguilla",
        "alpha-2": "AI",
        "alpha-3": "AIA",
        "country-code": "660",
        "iso_3166-2": "ISO 3166-2:AI",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Antarctica",
        "alpha-2": "AQ",
        "alpha-3": "ATA",
        "country-code": "010",
        "iso_3166-2": "ISO 3166-2:AQ",
        region: "",
        "sub-region": "",
        "intermediate-region": "",
        "region-code": "",
        "sub-region-code": "",
        "intermediate-region-code": "",
      },
      {
        name: "Antigua and Barbuda",
        "alpha-2": "AG",
        "alpha-3": "ATG",
        "country-code": "028",
        "iso_3166-2": "ISO 3166-2:AG",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Argentina",
        "alpha-2": "AR",
        "alpha-3": "ARG",
        "country-code": "032",
        "iso_3166-2": "ISO 3166-2:AR",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Armenia",
        "alpha-2": "AM",
        "alpha-3": "ARM",
        "country-code": "051",
        "iso_3166-2": "ISO 3166-2:AM",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Aruba",
        "alpha-2": "AW",
        "alpha-3": "ABW",
        "country-code": "533",
        "iso_3166-2": "ISO 3166-2:AW",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Australia",
        "alpha-2": "AU",
        "alpha-3": "AUS",
        "country-code": "036",
        "iso_3166-2": "ISO 3166-2:AU",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "Austria",
        "alpha-2": "AT",
        "alpha-3": "AUT",
        "country-code": "040",
        "iso_3166-2": "ISO 3166-2:AT",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Azerbaijan",
        "alpha-2": "AZ",
        "alpha-3": "AZE",
        "country-code": "031",
        "iso_3166-2": "ISO 3166-2:AZ",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Bahamas",
        "alpha-2": "BS",
        "alpha-3": "BHS",
        "country-code": "044",
        "iso_3166-2": "ISO 3166-2:BS",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Bahrain",
        "alpha-2": "BH",
        "alpha-3": "BHR",
        "country-code": "048",
        "iso_3166-2": "ISO 3166-2:BH",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Bangladesh",
        "alpha-2": "BD",
        "alpha-3": "BGD",
        "country-code": "050",
        "iso_3166-2": "ISO 3166-2:BD",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Barbados",
        "alpha-2": "BB",
        "alpha-3": "BRB",
        "country-code": "052",
        "iso_3166-2": "ISO 3166-2:BB",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Belarus",
        "alpha-2": "BY",
        "alpha-3": "BLR",
        "country-code": "112",
        "iso_3166-2": "ISO 3166-2:BY",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Belgium",
        "alpha-2": "BE",
        "alpha-3": "BEL",
        "country-code": "056",
        "iso_3166-2": "ISO 3166-2:BE",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Belize",
        "alpha-2": "BZ",
        "alpha-3": "BLZ",
        "country-code": "084",
        "iso_3166-2": "ISO 3166-2:BZ",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Benin",
        "alpha-2": "BJ",
        "alpha-3": "BEN",
        "country-code": "204",
        "iso_3166-2": "ISO 3166-2:BJ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Bermuda",
        "alpha-2": "BM",
        "alpha-3": "BMU",
        "country-code": "060",
        "iso_3166-2": "ISO 3166-2:BM",
        region: "Americas",
        "sub-region": "Northern America",
        "intermediate-region": "",
        "region-code": "019",
        "sub-region-code": "021",
        "intermediate-region-code": "",
      },
      {
        name: "Bhutan",
        "alpha-2": "BT",
        "alpha-3": "BTN",
        "country-code": "064",
        "iso_3166-2": "ISO 3166-2:BT",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Bolivia (Plurinational State of)",
        "alpha-2": "BO",
        "alpha-3": "BOL",
        "country-code": "068",
        "iso_3166-2": "ISO 3166-2:BO",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Bonaire, Sint Eustatius and Saba",
        "alpha-2": "BQ",
        "alpha-3": "BES",
        "country-code": "535",
        "iso_3166-2": "ISO 3166-2:BQ",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Bosnia and Herzegovina",
        "alpha-2": "BA",
        "alpha-3": "BIH",
        "country-code": "070",
        "iso_3166-2": "ISO 3166-2:BA",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Botswana",
        "alpha-2": "BW",
        "alpha-3": "BWA",
        "country-code": "072",
        "iso_3166-2": "ISO 3166-2:BW",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Southern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "018",
      },
      {
        name: "Bouvet Island",
        "alpha-2": "BV",
        "alpha-3": "BVT",
        "country-code": "074",
        "iso_3166-2": "ISO 3166-2:BV",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Brazil",
        "alpha-2": "BR",
        "alpha-3": "BRA",
        "country-code": "076",
        "iso_3166-2": "ISO 3166-2:BR",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "British Indian Ocean Territory",
        "alpha-2": "IO",
        "alpha-3": "IOT",
        "country-code": "086",
        "iso_3166-2": "ISO 3166-2:IO",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Brunei Darussalam",
        "alpha-2": "BN",
        "alpha-3": "BRN",
        "country-code": "096",
        "iso_3166-2": "ISO 3166-2:BN",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Bulgaria",
        "alpha-2": "BG",
        "alpha-3": "BGR",
        "country-code": "100",
        "iso_3166-2": "ISO 3166-2:BG",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Burkina Faso",
        "alpha-2": "BF",
        "alpha-3": "BFA",
        "country-code": "854",
        "iso_3166-2": "ISO 3166-2:BF",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Burundi",
        "alpha-2": "BI",
        "alpha-3": "BDI",
        "country-code": "108",
        "iso_3166-2": "ISO 3166-2:BI",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Cabo Verde",
        "alpha-2": "CV",
        "alpha-3": "CPV",
        "country-code": "132",
        "iso_3166-2": "ISO 3166-2:CV",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Cambodia",
        "alpha-2": "KH",
        "alpha-3": "KHM",
        "country-code": "116",
        "iso_3166-2": "ISO 3166-2:KH",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Cameroon",
        "alpha-2": "CM",
        "alpha-3": "CMR",
        "country-code": "120",
        "iso_3166-2": "ISO 3166-2:CM",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Canada",
        "alpha-2": "CA",
        "alpha-3": "CAN",
        "country-code": "124",
        "iso_3166-2": "ISO 3166-2:CA",
        region: "Americas",
        "sub-region": "Northern America",
        "intermediate-region": "",
        "region-code": "019",
        "sub-region-code": "021",
        "intermediate-region-code": "",
      },
      {
        name: "Cayman Islands",
        "alpha-2": "KY",
        "alpha-3": "CYM",
        "country-code": "136",
        "iso_3166-2": "ISO 3166-2:KY",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Central African Republic",
        "alpha-2": "CF",
        "alpha-3": "CAF",
        "country-code": "140",
        "iso_3166-2": "ISO 3166-2:CF",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Chad",
        "alpha-2": "TD",
        "alpha-3": "TCD",
        "country-code": "148",
        "iso_3166-2": "ISO 3166-2:TD",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Chile",
        "alpha-2": "CL",
        "alpha-3": "CHL",
        "country-code": "152",
        "iso_3166-2": "ISO 3166-2:CL",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "China",
        "alpha-2": "CN",
        "alpha-3": "CHN",
        "country-code": "156",
        "iso_3166-2": "ISO 3166-2:CN",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Christmas Island",
        "alpha-2": "CX",
        "alpha-3": "CXR",
        "country-code": "162",
        "iso_3166-2": "ISO 3166-2:CX",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "Cocos (Keeling) Islands",
        "alpha-2": "CC",
        "alpha-3": "CCK",
        "country-code": "166",
        "iso_3166-2": "ISO 3166-2:CC",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "Colombia",
        "alpha-2": "CO",
        "alpha-3": "COL",
        "country-code": "170",
        "iso_3166-2": "ISO 3166-2:CO",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Comoros",
        "alpha-2": "KM",
        "alpha-3": "COM",
        "country-code": "174",
        "iso_3166-2": "ISO 3166-2:KM",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Congo",
        "alpha-2": "CG",
        "alpha-3": "COG",
        "country-code": "178",
        "iso_3166-2": "ISO 3166-2:CG",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Congo, Democratic Republic of the",
        "alpha-2": "CD",
        "alpha-3": "COD",
        "country-code": "180",
        "iso_3166-2": "ISO 3166-2:CD",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Cook Islands",
        "alpha-2": "CK",
        "alpha-3": "COK",
        "country-code": "184",
        "iso_3166-2": "ISO 3166-2:CK",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Costa Rica",
        "alpha-2": "CR",
        "alpha-3": "CRI",
        "country-code": "188",
        "iso_3166-2": "ISO 3166-2:CR",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Côte d'Ivoire",
        "alpha-2": "CI",
        "alpha-3": "CIV",
        "country-code": "384",
        "iso_3166-2": "ISO 3166-2:CI",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Croatia",
        "alpha-2": "HR",
        "alpha-3": "HRV",
        "country-code": "191",
        "iso_3166-2": "ISO 3166-2:HR",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Cuba",
        "alpha-2": "CU",
        "alpha-3": "CUB",
        "country-code": "192",
        "iso_3166-2": "ISO 3166-2:CU",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Curaçao",
        "alpha-2": "CW",
        "alpha-3": "CUW",
        "country-code": "531",
        "iso_3166-2": "ISO 3166-2:CW",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Cyprus",
        "alpha-2": "CY",
        "alpha-3": "CYP",
        "country-code": "196",
        "iso_3166-2": "ISO 3166-2:CY",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Czechia",
        "alpha-2": "CZ",
        "alpha-3": "CZE",
        "country-code": "203",
        "iso_3166-2": "ISO 3166-2:CZ",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Denmark",
        "alpha-2": "DK",
        "alpha-3": "DNK",
        "country-code": "208",
        "iso_3166-2": "ISO 3166-2:DK",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Djibouti",
        "alpha-2": "DJ",
        "alpha-3": "DJI",
        "country-code": "262",
        "iso_3166-2": "ISO 3166-2:DJ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Dominica",
        "alpha-2": "DM",
        "alpha-3": "DMA",
        "country-code": "212",
        "iso_3166-2": "ISO 3166-2:DM",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Dominican Republic",
        "alpha-2": "DO",
        "alpha-3": "DOM",
        "country-code": "214",
        "iso_3166-2": "ISO 3166-2:DO",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Ecuador",
        "alpha-2": "EC",
        "alpha-3": "ECU",
        "country-code": "218",
        "iso_3166-2": "ISO 3166-2:EC",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Egypt",
        "alpha-2": "EG",
        "alpha-3": "EGY",
        "country-code": "818",
        "iso_3166-2": "ISO 3166-2:EG",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "El Salvador",
        "alpha-2": "SV",
        "alpha-3": "SLV",
        "country-code": "222",
        "iso_3166-2": "ISO 3166-2:SV",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Equatorial Guinea",
        "alpha-2": "GQ",
        "alpha-3": "GNQ",
        "country-code": "226",
        "iso_3166-2": "ISO 3166-2:GQ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Eritrea",
        "alpha-2": "ER",
        "alpha-3": "ERI",
        "country-code": "232",
        "iso_3166-2": "ISO 3166-2:ER",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Estonia",
        "alpha-2": "EE",
        "alpha-3": "EST",
        "country-code": "233",
        "iso_3166-2": "ISO 3166-2:EE",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Eswatini",
        "alpha-2": "SZ",
        "alpha-3": "SWZ",
        "country-code": "748",
        "iso_3166-2": "ISO 3166-2:SZ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Southern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "018",
      },
      {
        name: "Ethiopia",
        "alpha-2": "ET",
        "alpha-3": "ETH",
        "country-code": "231",
        "iso_3166-2": "ISO 3166-2:ET",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Falkland Islands (Malvinas)",
        "alpha-2": "FK",
        "alpha-3": "FLK",
        "country-code": "238",
        "iso_3166-2": "ISO 3166-2:FK",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Faroe Islands",
        "alpha-2": "FO",
        "alpha-3": "FRO",
        "country-code": "234",
        "iso_3166-2": "ISO 3166-2:FO",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Fiji",
        "alpha-2": "FJ",
        "alpha-3": "FJI",
        "country-code": "242",
        "iso_3166-2": "ISO 3166-2:FJ",
        region: "Oceania",
        "sub-region": "Melanesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "054",
        "intermediate-region-code": "",
      },
      {
        name: "Finland",
        "alpha-2": "FI",
        "alpha-3": "FIN",
        "country-code": "246",
        "iso_3166-2": "ISO 3166-2:FI",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "France",
        "alpha-2": "FR",
        "alpha-3": "FRA",
        "country-code": "250",
        "iso_3166-2": "ISO 3166-2:FR",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "French Guiana",
        "alpha-2": "GF",
        "alpha-3": "GUF",
        "country-code": "254",
        "iso_3166-2": "ISO 3166-2:GF",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "French Polynesia",
        "alpha-2": "PF",
        "alpha-3": "PYF",
        "country-code": "258",
        "iso_3166-2": "ISO 3166-2:PF",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "French Southern Territories",
        "alpha-2": "TF",
        "alpha-3": "ATF",
        "country-code": "260",
        "iso_3166-2": "ISO 3166-2:TF",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Gabon",
        "alpha-2": "GA",
        "alpha-3": "GAB",
        "country-code": "266",
        "iso_3166-2": "ISO 3166-2:GA",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Gambia",
        "alpha-2": "GM",
        "alpha-3": "GMB",
        "country-code": "270",
        "iso_3166-2": "ISO 3166-2:GM",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Georgia",
        "alpha-2": "GE",
        "alpha-3": "GEO",
        "country-code": "268",
        "iso_3166-2": "ISO 3166-2:GE",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Germany",
        "alpha-2": "DE",
        "alpha-3": "DEU",
        "country-code": "276",
        "iso_3166-2": "ISO 3166-2:DE",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Ghana",
        "alpha-2": "GH",
        "alpha-3": "GHA",
        "country-code": "288",
        "iso_3166-2": "ISO 3166-2:GH",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Gibraltar",
        "alpha-2": "GI",
        "alpha-3": "GIB",
        "country-code": "292",
        "iso_3166-2": "ISO 3166-2:GI",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Greece",
        "alpha-2": "GR",
        "alpha-3": "GRC",
        "country-code": "300",
        "iso_3166-2": "ISO 3166-2:GR",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Greenland",
        "alpha-2": "GL",
        "alpha-3": "GRL",
        "country-code": "304",
        "iso_3166-2": "ISO 3166-2:GL",
        region: "Americas",
        "sub-region": "Northern America",
        "intermediate-region": "",
        "region-code": "019",
        "sub-region-code": "021",
        "intermediate-region-code": "",
      },
      {
        name: "Grenada",
        "alpha-2": "GD",
        "alpha-3": "GRD",
        "country-code": "308",
        "iso_3166-2": "ISO 3166-2:GD",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Guadeloupe",
        "alpha-2": "GP",
        "alpha-3": "GLP",
        "country-code": "312",
        "iso_3166-2": "ISO 3166-2:GP",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Guam",
        "alpha-2": "GU",
        "alpha-3": "GUM",
        "country-code": "316",
        "iso_3166-2": "ISO 3166-2:GU",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Guatemala",
        "alpha-2": "GT",
        "alpha-3": "GTM",
        "country-code": "320",
        "iso_3166-2": "ISO 3166-2:GT",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Guernsey",
        "alpha-2": "GG",
        "alpha-3": "GGY",
        "country-code": "831",
        "iso_3166-2": "ISO 3166-2:GG",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "Channel Islands",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "830",
      },
      {
        name: "Guinea",
        "alpha-2": "GN",
        "alpha-3": "GIN",
        "country-code": "324",
        "iso_3166-2": "ISO 3166-2:GN",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Guinea-Bissau",
        "alpha-2": "GW",
        "alpha-3": "GNB",
        "country-code": "624",
        "iso_3166-2": "ISO 3166-2:GW",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Guyana",
        "alpha-2": "GY",
        "alpha-3": "GUY",
        "country-code": "328",
        "iso_3166-2": "ISO 3166-2:GY",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Haiti",
        "alpha-2": "HT",
        "alpha-3": "HTI",
        "country-code": "332",
        "iso_3166-2": "ISO 3166-2:HT",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Heard Island and McDonald Islands",
        "alpha-2": "HM",
        "alpha-3": "HMD",
        "country-code": "334",
        "iso_3166-2": "ISO 3166-2:HM",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "Holy See",
        "alpha-2": "VA",
        "alpha-3": "VAT",
        "country-code": "336",
        "iso_3166-2": "ISO 3166-2:VA",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Honduras",
        "alpha-2": "HN",
        "alpha-3": "HND",
        "country-code": "340",
        "iso_3166-2": "ISO 3166-2:HN",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Hong Kong",
        "alpha-2": "HK",
        "alpha-3": "HKG",
        "country-code": "344",
        "iso_3166-2": "ISO 3166-2:HK",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Hungary",
        "alpha-2": "HU",
        "alpha-3": "HUN",
        "country-code": "348",
        "iso_3166-2": "ISO 3166-2:HU",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Iceland",
        "alpha-2": "IS",
        "alpha-3": "ISL",
        "country-code": "352",
        "iso_3166-2": "ISO 3166-2:IS",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "India",
        "alpha-2": "IN",
        "alpha-3": "IND",
        "country-code": "356",
        "iso_3166-2": "ISO 3166-2:IN",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Indonesia",
        "alpha-2": "ID",
        "alpha-3": "IDN",
        "country-code": "360",
        "iso_3166-2": "ISO 3166-2:ID",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Iran (Islamic Republic of)",
        "alpha-2": "IR",
        "alpha-3": "IRN",
        "country-code": "364",
        "iso_3166-2": "ISO 3166-2:IR",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Iraq",
        "alpha-2": "IQ",
        "alpha-3": "IRQ",
        "country-code": "368",
        "iso_3166-2": "ISO 3166-2:IQ",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Ireland",
        "alpha-2": "IE",
        "alpha-3": "IRL",
        "country-code": "372",
        "iso_3166-2": "ISO 3166-2:IE",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Isle of Man",
        "alpha-2": "IM",
        "alpha-3": "IMN",
        "country-code": "833",
        "iso_3166-2": "ISO 3166-2:IM",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Israel",
        "alpha-2": "IL",
        "alpha-3": "ISR",
        "country-code": "376",
        "iso_3166-2": "ISO 3166-2:IL",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Italy",
        "alpha-2": "IT",
        "alpha-3": "ITA",
        "country-code": "380",
        "iso_3166-2": "ISO 3166-2:IT",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Jamaica",
        "alpha-2": "JM",
        "alpha-3": "JAM",
        "country-code": "388",
        "iso_3166-2": "ISO 3166-2:JM",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Japan",
        "alpha-2": "JP",
        "alpha-3": "JPN",
        "country-code": "392",
        "iso_3166-2": "ISO 3166-2:JP",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Jersey",
        "alpha-2": "JE",
        "alpha-3": "JEY",
        "country-code": "832",
        "iso_3166-2": "ISO 3166-2:JE",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "Channel Islands",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "830",
      },
      {
        name: "Jordan",
        "alpha-2": "JO",
        "alpha-3": "JOR",
        "country-code": "400",
        "iso_3166-2": "ISO 3166-2:JO",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Kazakhstan",
        "alpha-2": "KZ",
        "alpha-3": "KAZ",
        "country-code": "398",
        "iso_3166-2": "ISO 3166-2:KZ",
        region: "Asia",
        "sub-region": "Central Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "143",
        "intermediate-region-code": "",
      },
      {
        name: "Kenya",
        "alpha-2": "KE",
        "alpha-3": "KEN",
        "country-code": "404",
        "iso_3166-2": "ISO 3166-2:KE",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Kiribati",
        "alpha-2": "KI",
        "alpha-3": "KIR",
        "country-code": "296",
        "iso_3166-2": "ISO 3166-2:KI",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Korea (Democratic People's Republic of)",
        "alpha-2": "KP",
        "alpha-3": "PRK",
        "country-code": "408",
        "iso_3166-2": "ISO 3166-2:KP",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Korea, Republic of",
        "alpha-2": "KR",
        "alpha-3": "KOR",
        "country-code": "410",
        "iso_3166-2": "ISO 3166-2:KR",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Kuwait",
        "alpha-2": "KW",
        "alpha-3": "KWT",
        "country-code": "414",
        "iso_3166-2": "ISO 3166-2:KW",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Kyrgyzstan",
        "alpha-2": "KG",
        "alpha-3": "KGZ",
        "country-code": "417",
        "iso_3166-2": "ISO 3166-2:KG",
        region: "Asia",
        "sub-region": "Central Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "143",
        "intermediate-region-code": "",
      },
      {
        name: "Lao People's Democratic Republic",
        "alpha-2": "LA",
        "alpha-3": "LAO",
        "country-code": "418",
        "iso_3166-2": "ISO 3166-2:LA",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Latvia",
        "alpha-2": "LV",
        "alpha-3": "LVA",
        "country-code": "428",
        "iso_3166-2": "ISO 3166-2:LV",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Lebanon",
        "alpha-2": "LB",
        "alpha-3": "LBN",
        "country-code": "422",
        "iso_3166-2": "ISO 3166-2:LB",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Lesotho",
        "alpha-2": "LS",
        "alpha-3": "LSO",
        "country-code": "426",
        "iso_3166-2": "ISO 3166-2:LS",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Southern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "018",
      },
      {
        name: "Liberia",
        "alpha-2": "LR",
        "alpha-3": "LBR",
        "country-code": "430",
        "iso_3166-2": "ISO 3166-2:LR",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Libya",
        "alpha-2": "LY",
        "alpha-3": "LBY",
        "country-code": "434",
        "iso_3166-2": "ISO 3166-2:LY",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "Liechtenstein",
        "alpha-2": "LI",
        "alpha-3": "LIE",
        "country-code": "438",
        "iso_3166-2": "ISO 3166-2:LI",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Lithuania",
        "alpha-2": "LT",
        "alpha-3": "LTU",
        "country-code": "440",
        "iso_3166-2": "ISO 3166-2:LT",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Luxembourg",
        "alpha-2": "LU",
        "alpha-3": "LUX",
        "country-code": "442",
        "iso_3166-2": "ISO 3166-2:LU",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Macao",
        "alpha-2": "MO",
        "alpha-3": "MAC",
        "country-code": "446",
        "iso_3166-2": "ISO 3166-2:MO",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Madagascar",
        "alpha-2": "MG",
        "alpha-3": "MDG",
        "country-code": "450",
        "iso_3166-2": "ISO 3166-2:MG",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Malawi",
        "alpha-2": "MW",
        "alpha-3": "MWI",
        "country-code": "454",
        "iso_3166-2": "ISO 3166-2:MW",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Malaysia",
        "alpha-2": "MY",
        "alpha-3": "MYS",
        "country-code": "458",
        "iso_3166-2": "ISO 3166-2:MY",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Maldives",
        "alpha-2": "MV",
        "alpha-3": "MDV",
        "country-code": "462",
        "iso_3166-2": "ISO 3166-2:MV",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Mali",
        "alpha-2": "ML",
        "alpha-3": "MLI",
        "country-code": "466",
        "iso_3166-2": "ISO 3166-2:ML",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Malta",
        "alpha-2": "MT",
        "alpha-3": "MLT",
        "country-code": "470",
        "iso_3166-2": "ISO 3166-2:MT",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Marshall Islands",
        "alpha-2": "MH",
        "alpha-3": "MHL",
        "country-code": "584",
        "iso_3166-2": "ISO 3166-2:MH",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Martinique",
        "alpha-2": "MQ",
        "alpha-3": "MTQ",
        "country-code": "474",
        "iso_3166-2": "ISO 3166-2:MQ",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Mauritania",
        "alpha-2": "MR",
        "alpha-3": "MRT",
        "country-code": "478",
        "iso_3166-2": "ISO 3166-2:MR",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Mauritius",
        "alpha-2": "MU",
        "alpha-3": "MUS",
        "country-code": "480",
        "iso_3166-2": "ISO 3166-2:MU",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Mayotte",
        "alpha-2": "YT",
        "alpha-3": "MYT",
        "country-code": "175",
        "iso_3166-2": "ISO 3166-2:YT",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Mexico",
        "alpha-2": "MX",
        "alpha-3": "MEX",
        "country-code": "484",
        "iso_3166-2": "ISO 3166-2:MX",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Micronesia (Federated States of)",
        "alpha-2": "FM",
        "alpha-3": "FSM",
        "country-code": "583",
        "iso_3166-2": "ISO 3166-2:FM",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Moldova, Republic of",
        "alpha-2": "MD",
        "alpha-3": "MDA",
        "country-code": "498",
        "iso_3166-2": "ISO 3166-2:MD",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Monaco",
        "alpha-2": "MC",
        "alpha-3": "MCO",
        "country-code": "492",
        "iso_3166-2": "ISO 3166-2:MC",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Mongolia",
        "alpha-2": "MN",
        "alpha-3": "MNG",
        "country-code": "496",
        "iso_3166-2": "ISO 3166-2:MN",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Montenegro",
        "alpha-2": "ME",
        "alpha-3": "MNE",
        "country-code": "499",
        "iso_3166-2": "ISO 3166-2:ME",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Montserrat",
        "alpha-2": "MS",
        "alpha-3": "MSR",
        "country-code": "500",
        "iso_3166-2": "ISO 3166-2:MS",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Morocco",
        "alpha-2": "MA",
        "alpha-3": "MAR",
        "country-code": "504",
        "iso_3166-2": "ISO 3166-2:MA",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "Mozambique",
        "alpha-2": "MZ",
        "alpha-3": "MOZ",
        "country-code": "508",
        "iso_3166-2": "ISO 3166-2:MZ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Myanmar",
        "alpha-2": "MM",
        "alpha-3": "MMR",
        "country-code": "104",
        "iso_3166-2": "ISO 3166-2:MM",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Namibia",
        "alpha-2": "NA",
        "alpha-3": "NAM",
        "country-code": "516",
        "iso_3166-2": "ISO 3166-2:NA",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Southern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "018",
      },
      {
        name: "Nauru",
        "alpha-2": "NR",
        "alpha-3": "NRU",
        "country-code": "520",
        "iso_3166-2": "ISO 3166-2:NR",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Nepal",
        "alpha-2": "NP",
        "alpha-3": "NPL",
        "country-code": "524",
        "iso_3166-2": "ISO 3166-2:NP",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Netherlands",
        "alpha-2": "NL",
        "alpha-3": "NLD",
        "country-code": "528",
        "iso_3166-2": "ISO 3166-2:NL",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "New Caledonia",
        "alpha-2": "NC",
        "alpha-3": "NCL",
        "country-code": "540",
        "iso_3166-2": "ISO 3166-2:NC",
        region: "Oceania",
        "sub-region": "Melanesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "054",
        "intermediate-region-code": "",
      },
      {
        name: "New Zealand",
        "alpha-2": "NZ",
        "alpha-3": "NZL",
        "country-code": "554",
        "iso_3166-2": "ISO 3166-2:NZ",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "Nicaragua",
        "alpha-2": "NI",
        "alpha-3": "NIC",
        "country-code": "558",
        "iso_3166-2": "ISO 3166-2:NI",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Niger",
        "alpha-2": "NE",
        "alpha-3": "NER",
        "country-code": "562",
        "iso_3166-2": "ISO 3166-2:NE",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Nigeria",
        "alpha-2": "NG",
        "alpha-3": "NGA",
        "country-code": "566",
        "iso_3166-2": "ISO 3166-2:NG",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Niue",
        "alpha-2": "NU",
        "alpha-3": "NIU",
        "country-code": "570",
        "iso_3166-2": "ISO 3166-2:NU",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Norfolk Island",
        "alpha-2": "NF",
        "alpha-3": "NFK",
        "country-code": "574",
        "iso_3166-2": "ISO 3166-2:NF",
        region: "Oceania",
        "sub-region": "Australia and New Zealand",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "053",
        "intermediate-region-code": "",
      },
      {
        name: "North Macedonia",
        "alpha-2": "MK",
        "alpha-3": "MKD",
        "country-code": "807",
        "iso_3166-2": "ISO 3166-2:MK",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Northern Mariana Islands",
        "alpha-2": "MP",
        "alpha-3": "MNP",
        "country-code": "580",
        "iso_3166-2": "ISO 3166-2:MP",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Norway",
        "alpha-2": "NO",
        "alpha-3": "NOR",
        "country-code": "578",
        "iso_3166-2": "ISO 3166-2:NO",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Oman",
        "alpha-2": "OM",
        "alpha-3": "OMN",
        "country-code": "512",
        "iso_3166-2": "ISO 3166-2:OM",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Pakistan",
        "alpha-2": "PK",
        "alpha-3": "PAK",
        "country-code": "586",
        "iso_3166-2": "ISO 3166-2:PK",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Palau",
        "alpha-2": "PW",
        "alpha-3": "PLW",
        "country-code": "585",
        "iso_3166-2": "ISO 3166-2:PW",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Palestine, State of",
        "alpha-2": "PS",
        "alpha-3": "PSE",
        "country-code": "275",
        "iso_3166-2": "ISO 3166-2:PS",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Panama",
        "alpha-2": "PA",
        "alpha-3": "PAN",
        "country-code": "591",
        "iso_3166-2": "ISO 3166-2:PA",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Central America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "013",
      },
      {
        name: "Papua New Guinea",
        "alpha-2": "PG",
        "alpha-3": "PNG",
        "country-code": "598",
        "iso_3166-2": "ISO 3166-2:PG",
        region: "Oceania",
        "sub-region": "Melanesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "054",
        "intermediate-region-code": "",
      },
      {
        name: "Paraguay",
        "alpha-2": "PY",
        "alpha-3": "PRY",
        "country-code": "600",
        "iso_3166-2": "ISO 3166-2:PY",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Peru",
        "alpha-2": "PE",
        "alpha-3": "PER",
        "country-code": "604",
        "iso_3166-2": "ISO 3166-2:PE",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Philippines",
        "alpha-2": "PH",
        "alpha-3": "PHL",
        "country-code": "608",
        "iso_3166-2": "ISO 3166-2:PH",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Pitcairn",
        "alpha-2": "PN",
        "alpha-3": "PCN",
        "country-code": "612",
        "iso_3166-2": "ISO 3166-2:PN",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Poland",
        "alpha-2": "PL",
        "alpha-3": "POL",
        "country-code": "616",
        "iso_3166-2": "ISO 3166-2:PL",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Portugal",
        "alpha-2": "PT",
        "alpha-3": "PRT",
        "country-code": "620",
        "iso_3166-2": "ISO 3166-2:PT",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Puerto Rico",
        "alpha-2": "PR",
        "alpha-3": "PRI",
        "country-code": "630",
        "iso_3166-2": "ISO 3166-2:PR",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Qatar",
        "alpha-2": "QA",
        "alpha-3": "QAT",
        "country-code": "634",
        "iso_3166-2": "ISO 3166-2:QA",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Réunion",
        "alpha-2": "RE",
        "alpha-3": "REU",
        "country-code": "638",
        "iso_3166-2": "ISO 3166-2:RE",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Romania",
        "alpha-2": "RO",
        "alpha-3": "ROU",
        "country-code": "642",
        "iso_3166-2": "ISO 3166-2:RO",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Russian Federation",
        "alpha-2": "RU",
        "alpha-3": "RUS",
        "country-code": "643",
        "iso_3166-2": "ISO 3166-2:RU",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Rwanda",
        "alpha-2": "RW",
        "alpha-3": "RWA",
        "country-code": "646",
        "iso_3166-2": "ISO 3166-2:RW",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Saint Barthélemy",
        "alpha-2": "BL",
        "alpha-3": "BLM",
        "country-code": "652",
        "iso_3166-2": "ISO 3166-2:BL",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Saint Helena, Ascension and Tristan da Cunha",
        "alpha-2": "SH",
        "alpha-3": "SHN",
        "country-code": "654",
        "iso_3166-2": "ISO 3166-2:SH",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Saint Kitts and Nevis",
        "alpha-2": "KN",
        "alpha-3": "KNA",
        "country-code": "659",
        "iso_3166-2": "ISO 3166-2:KN",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Saint Lucia",
        "alpha-2": "LC",
        "alpha-3": "LCA",
        "country-code": "662",
        "iso_3166-2": "ISO 3166-2:LC",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Saint Martin (French part)",
        "alpha-2": "MF",
        "alpha-3": "MAF",
        "country-code": "663",
        "iso_3166-2": "ISO 3166-2:MF",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Saint Pierre and Miquelon",
        "alpha-2": "PM",
        "alpha-3": "SPM",
        "country-code": "666",
        "iso_3166-2": "ISO 3166-2:PM",
        region: "Americas",
        "sub-region": "Northern America",
        "intermediate-region": "",
        "region-code": "019",
        "sub-region-code": "021",
        "intermediate-region-code": "",
      },
      {
        name: "Saint Vincent and the Grenadines",
        "alpha-2": "VC",
        "alpha-3": "VCT",
        "country-code": "670",
        "iso_3166-2": "ISO 3166-2:VC",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Samoa",
        "alpha-2": "WS",
        "alpha-3": "WSM",
        "country-code": "882",
        "iso_3166-2": "ISO 3166-2:WS",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "San Marino",
        "alpha-2": "SM",
        "alpha-3": "SMR",
        "country-code": "674",
        "iso_3166-2": "ISO 3166-2:SM",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Sao Tome and Principe",
        "alpha-2": "ST",
        "alpha-3": "STP",
        "country-code": "678",
        "iso_3166-2": "ISO 3166-2:ST",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Middle Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "017",
      },
      {
        name: "Saudi Arabia",
        "alpha-2": "SA",
        "alpha-3": "SAU",
        "country-code": "682",
        "iso_3166-2": "ISO 3166-2:SA",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Senegal",
        "alpha-2": "SN",
        "alpha-3": "SEN",
        "country-code": "686",
        "iso_3166-2": "ISO 3166-2:SN",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Serbia",
        "alpha-2": "RS",
        "alpha-3": "SRB",
        "country-code": "688",
        "iso_3166-2": "ISO 3166-2:RS",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Seychelles",
        "alpha-2": "SC",
        "alpha-3": "SYC",
        "country-code": "690",
        "iso_3166-2": "ISO 3166-2:SC",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Sierra Leone",
        "alpha-2": "SL",
        "alpha-3": "SLE",
        "country-code": "694",
        "iso_3166-2": "ISO 3166-2:SL",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Singapore",
        "alpha-2": "SG",
        "alpha-3": "SGP",
        "country-code": "702",
        "iso_3166-2": "ISO 3166-2:SG",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Sint Maarten (Dutch part)",
        "alpha-2": "SX",
        "alpha-3": "SXM",
        "country-code": "534",
        "iso_3166-2": "ISO 3166-2:SX",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Slovakia",
        "alpha-2": "SK",
        "alpha-3": "SVK",
        "country-code": "703",
        "iso_3166-2": "ISO 3166-2:SK",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "Slovenia",
        "alpha-2": "SI",
        "alpha-3": "SVN",
        "country-code": "705",
        "iso_3166-2": "ISO 3166-2:SI",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Solomon Islands",
        "alpha-2": "SB",
        "alpha-3": "SLB",
        "country-code": "090",
        "iso_3166-2": "ISO 3166-2:SB",
        region: "Oceania",
        "sub-region": "Melanesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "054",
        "intermediate-region-code": "",
      },
      {
        name: "Somalia",
        "alpha-2": "SO",
        "alpha-3": "SOM",
        "country-code": "706",
        "iso_3166-2": "ISO 3166-2:SO",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "South Africa",
        "alpha-2": "ZA",
        "alpha-3": "ZAF",
        "country-code": "710",
        "iso_3166-2": "ISO 3166-2:ZA",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Southern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "018",
      },
      {
        name: "South Georgia and the South Sandwich Islands",
        "alpha-2": "GS",
        "alpha-3": "SGS",
        "country-code": "239",
        "iso_3166-2": "ISO 3166-2:GS",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "South Sudan",
        "alpha-2": "SS",
        "alpha-3": "SSD",
        "country-code": "728",
        "iso_3166-2": "ISO 3166-2:SS",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Spain",
        "alpha-2": "ES",
        "alpha-3": "ESP",
        "country-code": "724",
        "iso_3166-2": "ISO 3166-2:ES",
        region: "Europe",
        "sub-region": "Southern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "039",
        "intermediate-region-code": "",
      },
      {
        name: "Sri Lanka",
        "alpha-2": "LK",
        "alpha-3": "LKA",
        "country-code": "144",
        "iso_3166-2": "ISO 3166-2:LK",
        region: "Asia",
        "sub-region": "Southern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "034",
        "intermediate-region-code": "",
      },
      {
        name: "Sudan",
        "alpha-2": "SD",
        "alpha-3": "SDN",
        "country-code": "729",
        "iso_3166-2": "ISO 3166-2:SD",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "Suriname",
        "alpha-2": "SR",
        "alpha-3": "SUR",
        "country-code": "740",
        "iso_3166-2": "ISO 3166-2:SR",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Svalbard and Jan Mayen",
        "alpha-2": "SJ",
        "alpha-3": "SJM",
        "country-code": "744",
        "iso_3166-2": "ISO 3166-2:SJ",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Sweden",
        "alpha-2": "SE",
        "alpha-3": "SWE",
        "country-code": "752",
        "iso_3166-2": "ISO 3166-2:SE",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "Switzerland",
        "alpha-2": "CH",
        "alpha-3": "CHE",
        "country-code": "756",
        "iso_3166-2": "ISO 3166-2:CH",
        region: "Europe",
        "sub-region": "Western Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "155",
        "intermediate-region-code": "",
      },
      {
        name: "Syrian Arab Republic",
        "alpha-2": "SY",
        "alpha-3": "SYR",
        "country-code": "760",
        "iso_3166-2": "ISO 3166-2:SY",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Taiwan, Province of China",
        "alpha-2": "TW",
        "alpha-3": "TWN",
        "country-code": "158",
        "iso_3166-2": "ISO 3166-2:TW",
        region: "Asia",
        "sub-region": "Eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "030",
        "intermediate-region-code": "",
      },
      {
        name: "Tajikistan",
        "alpha-2": "TJ",
        "alpha-3": "TJK",
        "country-code": "762",
        "iso_3166-2": "ISO 3166-2:TJ",
        region: "Asia",
        "sub-region": "Central Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "143",
        "intermediate-region-code": "",
      },
      {
        name: "Tanzania, United Republic of",
        "alpha-2": "TZ",
        "alpha-3": "TZA",
        "country-code": "834",
        "iso_3166-2": "ISO 3166-2:TZ",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Thailand",
        "alpha-2": "TH",
        "alpha-3": "THA",
        "country-code": "764",
        "iso_3166-2": "ISO 3166-2:TH",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Timor-Leste",
        "alpha-2": "TL",
        "alpha-3": "TLS",
        "country-code": "626",
        "iso_3166-2": "ISO 3166-2:TL",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Togo",
        "alpha-2": "TG",
        "alpha-3": "TGO",
        "country-code": "768",
        "iso_3166-2": "ISO 3166-2:TG",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Western Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "011",
      },
      {
        name: "Tokelau",
        "alpha-2": "TK",
        "alpha-3": "TKL",
        "country-code": "772",
        "iso_3166-2": "ISO 3166-2:TK",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Tonga",
        "alpha-2": "TO",
        "alpha-3": "TON",
        "country-code": "776",
        "iso_3166-2": "ISO 3166-2:TO",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Trinidad and Tobago",
        "alpha-2": "TT",
        "alpha-3": "TTO",
        "country-code": "780",
        "iso_3166-2": "ISO 3166-2:TT",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Tunisia",
        "alpha-2": "TN",
        "alpha-3": "TUN",
        "country-code": "788",
        "iso_3166-2": "ISO 3166-2:TN",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "Turkey",
        "alpha-2": "TR",
        "alpha-3": "TUR",
        "country-code": "792",
        "iso_3166-2": "ISO 3166-2:TR",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Turkmenistan",
        "alpha-2": "TM",
        "alpha-3": "TKM",
        "country-code": "795",
        "iso_3166-2": "ISO 3166-2:TM",
        region: "Asia",
        "sub-region": "Central Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "143",
        "intermediate-region-code": "",
      },
      {
        name: "Turks and Caicos Islands",
        "alpha-2": "TC",
        "alpha-3": "TCA",
        "country-code": "796",
        "iso_3166-2": "ISO 3166-2:TC",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Tuvalu",
        "alpha-2": "TV",
        "alpha-3": "TUV",
        "country-code": "798",
        "iso_3166-2": "ISO 3166-2:TV",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Uganda",
        "alpha-2": "UG",
        "alpha-3": "UGA",
        "country-code": "800",
        "iso_3166-2": "ISO 3166-2:UG",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Ukraine",
        "alpha-2": "UA",
        "alpha-3": "UKR",
        "country-code": "804",
        "iso_3166-2": "ISO 3166-2:UA",
        region: "Europe",
        "sub-region": "Eastern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "151",
        "intermediate-region-code": "",
      },
      {
        name: "United Arab Emirates",
        "alpha-2": "AE",
        "alpha-3": "ARE",
        "country-code": "784",
        "iso_3166-2": "ISO 3166-2:AE",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "United Kingdom of Great Britain and Northern Ireland",
        "alpha-2": "GB",
        "alpha-3": "GBR",
        "country-code": "826",
        "iso_3166-2": "ISO 3166-2:GB",
        region: "Europe",
        "sub-region": "Northern Europe",
        "intermediate-region": "",
        "region-code": "150",
        "sub-region-code": "154",
        "intermediate-region-code": "",
      },
      {
        name: "United States of America",
        "alpha-2": "US",
        "alpha-3": "USA",
        "country-code": "840",
        "iso_3166-2": "ISO 3166-2:US",
        region: "Americas",
        "sub-region": "Northern America",
        "intermediate-region": "",
        "region-code": "019",
        "sub-region-code": "021",
        "intermediate-region-code": "",
      },
      {
        name: "United States Minor Outlying Islands",
        "alpha-2": "UM",
        "alpha-3": "UMI",
        "country-code": "581",
        "iso_3166-2": "ISO 3166-2:UM",
        region: "Oceania",
        "sub-region": "Micronesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "057",
        "intermediate-region-code": "",
      },
      {
        name: "Uruguay",
        "alpha-2": "UY",
        "alpha-3": "URY",
        "country-code": "858",
        "iso_3166-2": "ISO 3166-2:UY",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Uzbekistan",
        "alpha-2": "UZ",
        "alpha-3": "UZB",
        "country-code": "860",
        "iso_3166-2": "ISO 3166-2:UZ",
        region: "Asia",
        "sub-region": "Central Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "143",
        "intermediate-region-code": "",
      },
      {
        name: "Vanuatu",
        "alpha-2": "VU",
        "alpha-3": "VUT",
        "country-code": "548",
        "iso_3166-2": "ISO 3166-2:VU",
        region: "Oceania",
        "sub-region": "Melanesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "054",
        "intermediate-region-code": "",
      },
      {
        name: "Venezuela (Bolivarian Republic of)",
        "alpha-2": "VE",
        "alpha-3": "VEN",
        "country-code": "862",
        "iso_3166-2": "ISO 3166-2:VE",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "South America",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "005",
      },
      {
        name: "Viet Nam",
        "alpha-2": "VN",
        "alpha-3": "VNM",
        "country-code": "704",
        "iso_3166-2": "ISO 3166-2:VN",
        region: "Asia",
        "sub-region": "South-eastern Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "035",
        "intermediate-region-code": "",
      },
      {
        name: "Virgin Islands (British)",
        "alpha-2": "VG",
        "alpha-3": "VGB",
        "country-code": "092",
        "iso_3166-2": "ISO 3166-2:VG",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Virgin Islands (U.S.)",
        "alpha-2": "VI",
        "alpha-3": "VIR",
        "country-code": "850",
        "iso_3166-2": "ISO 3166-2:VI",
        region: "Americas",
        "sub-region": "Latin America and the Caribbean",
        "intermediate-region": "Caribbean",
        "region-code": "019",
        "sub-region-code": "419",
        "intermediate-region-code": "029",
      },
      {
        name: "Wallis and Futuna",
        "alpha-2": "WF",
        "alpha-3": "WLF",
        "country-code": "876",
        "iso_3166-2": "ISO 3166-2:WF",
        region: "Oceania",
        "sub-region": "Polynesia",
        "intermediate-region": "",
        "region-code": "009",
        "sub-region-code": "061",
        "intermediate-region-code": "",
      },
      {
        name: "Western Sahara",
        "alpha-2": "EH",
        "alpha-3": "ESH",
        "country-code": "732",
        "iso_3166-2": "ISO 3166-2:EH",
        region: "Africa",
        "sub-region": "Northern Africa",
        "intermediate-region": "",
        "region-code": "002",
        "sub-region-code": "015",
        "intermediate-region-code": "",
      },
      {
        name: "Yemen",
        "alpha-2": "YE",
        "alpha-3": "YEM",
        "country-code": "887",
        "iso_3166-2": "ISO 3166-2:YE",
        region: "Asia",
        "sub-region": "Western Asia",
        "intermediate-region": "",
        "region-code": "142",
        "sub-region-code": "145",
        "intermediate-region-code": "",
      },
      {
        name: "Zambia",
        "alpha-2": "ZM",
        "alpha-3": "ZMB",
        "country-code": "894",
        "iso_3166-2": "ISO 3166-2:ZM",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
      {
        name: "Zimbabwe",
        "alpha-2": "ZW",
        "alpha-3": "ZWE",
        "country-code": "716",
        "iso_3166-2": "ISO 3166-2:ZW",
        region: "Africa",
        "sub-region": "Sub-Saharan Africa",
        "intermediate-region": "Eastern Africa",
        "region-code": "002",
        "sub-region-code": "202",
        "intermediate-region-code": "014",
      },
    ],
  });
})();

(function () {
  "use strict";
  angular.module("My").factory("permissionService", permissionService);
  /** @ngInject */
  function permissionService() {
    return {
      permissions: [],
      teamsHerds: [],
      teams: [],
      can: can,
      isGlobalAdmin: false,
      pageTopShowLegalNotice: pageTopShowLegalNotice,
      getTenant: getTenant,
      getHouseStyle: getHouseStyle,
      getDashboardsType: getDashboardsType,
    };

    function can(permission) {
      var hasPermission = false;
      var default_values = JSON.parse(localStorage.getItem("default_values"));
      if (default_values) {
        var team_id = default_values.team_id;
        var herd_ids = default_values.herd_ids;
        for (var i = 0; i < this.permissions.length; i++) {
          if (
            this.permissions[i].TeamId == team_id &&
            this.permissions[i].Permissions.length > 0
          ) {
            for (var j = 0; j < this.permissions[i].Permissions.length; j++) {
              if (this.permissions[i].Permissions[j] == permission) {
                hasPermission = true;
                break;
              }
            }
          }
        }
      }
      return hasPermission;
    }

    //show logal notice and required tenant
    function pageTopShowLegalNotice() {
      if (this.can(332) && this.can(330)) {
        return true;
      }
      return false;
    }

    function getTenant() {
      if (this.can(330)) {
        return "zoetis";
      }
      return undefined;
    }

    function getHouseStyle() {
      if (this.can(331)) {
        return "zoetis";
      }
      if (this.can(353)) {
        return "proxani";
      }

      if (this.can(352)) {
        return "aveve";
      }
    }

    function getDashboardsType() {
      if (!this.isGlobalAdmin) {
        if (this.can(330)) {
          return "zoetis";
        }
        if (this.can(50) || this.can(49)) {
          return "ff";
        }
        if (this.can(340)) {
          return "farmchamps";
        }

        if (!this.can(330) && !this.can(340) && this.can(333)) {
          return "zoetis";
        }
        return "user";
      } else {
        return "admin";
      }
    }
  }
})();

(function () {
  "use strict";
  angular.module("My").factory("auth0Service", auth0Service);
  /** @ngInject */
  function auth0Service($q, $timeout, cookiesService) {
    var host = window.location.origin;
    if (!host) {
      host = "https://my.mmmooogle.com";
    }

    var webAuth;

    return {
      login: login,
      handleAuthentication: handleAuthentication,
      logout: logout,
      init: init,
      handleUnauthorized: handleUnauthorized,
    };

    function login(sso) {
      init(sso);
      $timeout(function () {
        webAuth.authorize();
      }, 100);
    }

    function init(sso) {
      if (sso) {
        console.log('sso');
        var redirectUrl = host + "/sso-login";
        webAuth = new auth0.WebAuth({
          domain: "bovinet-eu.eu.auth0.com",
          clientID: "MQE93oKO8rxtb5jUiUJJxNwD3TlFZNUl",
          responseType: "token id_token",
          audience: "https://bovinet-eu.eu.auth0.com/userinfo",
          scope: "openid profile email",
          redirectUri: redirectUrl,
        });
      } else {
        console.log('regular');
        
        var redirectUrl = host + "/login";
        webAuth = new auth0.WebAuth({
          domain: "bovinet.auth0.com",
          clientID: "NlhcYlJF3qLmUApBigr5iaH7u4DNcMaW",
          responseType: "token id_token",
          audience: "https://bovinet.auth0.com/userinfo",
          scope: "openid profile email",
          redirectUri: redirectUrl,
        });
      }
    }

    function handleAuthentication() {
      var d = $q.defer();

      webAuth.parseHash(
        { __enableIdPInitiatedLogin: true },
        function (err, authResult) {
          if (authResult && authResult.accessToken && authResult.idToken) {
            d.resolve(authResult);
          } else if (err) {
            d.reject(err);
          } else {
            d.reject();
          }
        }
      );

      return d.promise;
    }

    function handleUnauthorized(timeout) {
      var login_type = localStorage.getItem("login_type");
      localStorage.clear();
      localStorage.setItem("login_type", login_type);
      cookiesService.deleteMToken();
      $timeout(function () {
        logout(login_type);
      }, timeout);
    }

    function logout(login_type) {
      var redirect;
      if (login_type) {
        if (login_type == "sso") {
          redirect = "/sso-login";
          init(true);
        } else {
          init();
        }
      } else {
        init();
      }
      webAuth.logout({
        returnTo: redirect ? host.concat(redirect) : host,
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("My").constant("A_DASH_CONSTANTS", {
    dashboard_id_list: [
      {
        name: "_rap_workbook_name_rap_main_herd_overview_",
        id: "_rap_workbook_id_rap_main_herd_overview_",
      },
      {
        name: "_rap_workbook_name_rap_herd_dashboard_",
        id: "_rap_workbook_id_rap_herd_dashboard_",
      },
      {
        name: "_rap_workbook_name_days_in_milk_trend_",
        id: "_rap_workbook_id_days_in_milk_trend_",
      },
      {
        name: "_rap_workbook_name_milk_yield_trend_",
        id: "_rap_workbook_id_milk_yield_trend_",
      },
      {
        name: "_rap_workbook_name_milk_yield_actual_",
        id: "_rap_workbook_id_milk_yield_actual_",
      },
      {
        name: "_rap_workbook_name_first_milk_yield_by_calving_date_",
        id: "_rap_workbook_id_first_milk_yield_by_calving_date_",
      },
      {
        name: "_rap_workbook_name_spp_trend_",
        id: "_rap_workbook_id_spp_trend_",
      },
      {
        name: "_rap_workbook_name_spp_actual_",
        id: "_rap_workbook_id_spp_actual_",
      },
      {
        name: "_rap_workbook_name_milkings_trend_",
        id: "_rap_workbook_id_milkings_trend_",
      },
      {
        name: "_rap_workbook_name_milkings_actual_",
        id: "_rap_workbook_id_milkings_actual_",
      },
      {
        name: "_rap_workbook_name_milk_milkings_actual_",
        id: "_rap_workbook_id_milk_milkings_actual_",
      },
      {
        name: "_rap_workbook_name_milk_milkings_trend_",
        id: "_rap_workbook_id_milk_milkings_trend_",
      },
      {
        name: "_rap_workbook_name_concentrate_yield_trend_",
        id: "_rap_workbook_id_concentrate_yield_trend_",
      },
      {
        name: "_rap_workbook_name_concentrate_actual_by_yield_",
        id: "_rap_workbook_id_concentrate_actual_by_yield_",
      },
      {
        name: "_rap_workbook_name_concentrate_kg_trend_",
        id: "_rap_workbook_id_concentrate_kg_trend_",
      },
      {
        name: "_rap_workbook_name_concentrate_actual_by_feed_",
        id: "_rap_workbook_id_concentrate_actual_by_feed_",
      },
      {
        name: "_rap_workbook_name_feed_intake_",
        id: "_rap_workbook_id_feed_intake_",
      },
      {
        name: "_rap_workbook_name_concentrate_actual_by_milk_production_",
        id: "_rap_workbook_id_concentrate_actual_by_milk_production_",
      },
      {
        name: "_rap_workbook_name_herd_prestations_actual_",
        id: "_rap_workbook_id_herd_prestations_actual_",
      },
      {
        name: "_rap_workbook_name_herd_prestations_trend_",
        id: "_rap_workbook_id_herd_prestations_trend_",
      },
      {
        name: "_rap_workbook_name_leftovers_trend_",
        id: "_rap_workbook_id_leftovers_trends_",
      },
      {
        name: "_rap_workbook_name_leftovers_actual_",
        id: "_rap_workbook_id_leftovers_actual_",
      },
      {
        name: "_rap_workbook_name_leftovers_actual_table_",
        id: "_rap_workbook_id_leftovers_actual_table_",
      },
      {
        name: "_rap_workbook_name_leftovers_actual_milk_speed_",
        id: "_rap_workbook_id_leftovers_actual_milk_speed_",
      },
      {
        name: "_dashboard_name_milk_yield_actual_by_date_",
        id: "_dashboard_id_milk_yield_actual_by_date_",
      },
      {
        name: "_dashboard_name_spp_actual_dim_",
        id: "_dashboard_id_spp_actual_dim_",
      },
      {
        name: "_dashboard_name_milkings_actual_by_date_",
        id: "_dashboard_id_milkings_actual_by_date_",
      },
      {
        name: "_rap_workbook_name_milk_milkings_actual_by_date_",
        id: "_rap_workbook_id_milk_milkings_actual_by_date_",
      },
      {
        name: "_dashboard_name_conc_actual_yield_by_date_",
        id: "_dashboard_id_conc_actual_yield_by_date_",
      },
      {
        name: "_dashboard_name_conc_actual_feed_by_date_",
        id: "_dashboard_id_conc_actual_feed_by_date_",
      },
      {
        name: "_dashboard_name_leftovers_actual_by_date_",
        id: "_dashboard_id_leftovers_actual_by_date_",
      },
      {
        name: "_dashboard_name_robot_prestations_dashboard_",
        id: "_dashboard_id_robot_prestations_dashboard_",
      },
      {
        name: "_dashboard_name_robot_prestations_trend_dashboard_",
        id: "_dashboard_id_robot_prestations_trend_dashboard_",
      },
      {
        name: "_dashboard_name_actual_dashboard_",
        id: "_dashboard_id_actual_dashboard_",
      },
      {
        name: "_dashboard_name_herd_prestation_trend_spp_",
        id: "_herd_prestation_trend_spp_",
      },
      {
        name: "_dashboard_name_milk_yield_trend_mro_",
        id: "_dashboard_id_milk_yield_trend_mro_",
      },
      {
        name: "_dashboard_name_spp_trend_mro_",
        id: "_dashboard_id_spp_trend_mro_",
      },
      {
        name: "_dashboard_name_spp_actual_mro_",
        id: "_dashboard_id_spp_actual_mro_",
      },
      {
        name: "_dashboard_name_spp_actual_dim_mro_",
        id: "_dashboard_id_spp_actual_dim_mro_",
      },
      {
        name: "_dashboard_name_milk_yield_actual_dim_mro_",
        id: "_dashboard_id_milk_yield_actual_dim_mro_",
      },
      {
        name: "_dashboard_name_milk_yield_actual_mro_",
        id: "_dashboard_id_milk_yield_actual_mro_",
      },
      {
        name: "_arv_components_dashboard_mro_name_",
        id: "_arv_components_dashboard_mro_",
      },
      {
        name: "_arv_components_dashboard_name_",
        id: "_arv_components_dashboard_",
      },
      {
        name: "_dashboard_name_concentrate_by_herd_",
        id: "_dashboard_id_concentrate_by_herd_",
      },
      {
        name: "_dashboard_name_cow_list_",
        id: "_dashboard_id_cow_list_",
      },
      {
        name: "_dashboard_name_concentrate_per_cow_trend_",
        id: "_dashboard_id_concentrate_per_cow_trend_",
      },
      {
        name: "_dashboard_name_concentrate_per_cow_actual_",
        id: "_dashboard_id_concentrate_per_cow_actual_",
      },
      {
        name: "_dashboard_name_concentrate_per_cow_actual_trend_",
        id: "_dashboard_id_concentrate_per_cow_actual_trend_",
      },
      {
        name: "_dashboard_name_concentrate_per_100Kg_trend_",
        id: "_dashboard_id_concentrate_per_100Kg_trend_",
      },
      {
        name: "_dashboard_name_concentrate_per_100Kg_actual_",
        id: "_dashboard_id_concentrate_per_100Kg_actual_",
      },
      {
        name: "_dashboard_name_concentrate_per_100Kg_actual_trend_",
        id: "_dashboard_id_concentrate_per_100Kg_actual_trend_",
      },
      {
        name: "_dashboard_name_leftovers_by_milking_speed_actual_",
        id: "_dashboard_id_leftovers_by_milking_speed_actual_",
      },
      {
        name: "_dashboard_name_concentrate_intake_trend_",
        id: "_dashboard_id_concentrate_intake_trend_",
      },
      {
        name: "_dashboard_name_concentrate_intake_by_conc_trend_",
        id: "_dashboard_id_concentrate_intake_by_conc_trend_",
      },
      {
        name: "_rap_workbook_name_robot_prestations_",
        id: "_dashboard_id_robot_efficiency_",
      },
      {
        name: "_dashboard_name_milkings_hour_",
        id: "_dashboard_id_milkings_hour_",
      },
      {
        name: "_dashboard_name_milkings_",
        id: "_dashboard_id_milkings_",
      },
      {
        name: "_dashboard_name_cow_list_robot_",
        id: "_dashboard_id_cow_list_robot_",
      },
      {
        name: "_dashboard_name_robot_efficiency_",
        id: "_dashboard_id_robot_efficiency_",
      },
      {
        name: "_dashboard_name_milk_per_milking_minutes_actual_",
        id: "_dashboard_id_milk_per_milking_minutes_actual_",
      },
      {
        name: "_dashboard_name_milk_hour_cow_",
        id: "_dashboard_id_milk_hour_cow_",
      },
      {
        name: "_arv_components_trend_dashboard_name_",
        id: "_arv_components_trend_dashboard_",
      },
      {
        name: "_arv_components_trend_dashboard_mro_name_",
        id: "_arv_components_trend_dashboard_mro_",
      },
      {
        name: "_worksheet_name_herd_overview_",
        id: "_arv_herd_overview_dashboard",
      },
      {
        name: "_dashboard_name_milkings_trend_",
        id: "_dashboard_id_milkings_trend_",
      },
      {
        name: "_dashboard_name_refusals_trend_",
        id: "_dashboard_id_refusals_trend_",
      },
      {
        name: "_dashboard_name_refusals_",
        id: "_dashboard_id_refusals_",
      },
      {
        name: "_dashboard_name_failures_trend_",
        id: "_dashboard_id_failures_trend_",
      },
      {
        name: "_dashboard_name_failures_",
        id: "_dashboard_id_failures_",
      },
      {
        name: "_dashboard_name_milkings_actual_dim_",
        id: "_dashboard_id_milkings_actual_dim_",
      },
      {
        name: "_dashboard_name_refusals_actual_dim_",
        id: "_dashboard_id_refusals_actual_dim_",
      },
      {
        name: "_dashboard_name_failures_actual_dim_",
        id: "_dashboard_id_failures_actual_dim_",
      },
      {
        name: "_dashboard_name_milking_speed_trend_",
        id: "_dashboard_id_milking_speed_trend_",
      },
      {
        name: "_dashboard_name_milking_speed_dim_",
        id: "_dashboard_id_milking_speed_dim_",
      },
      {
        name: "_dashboard_name_milking_speed_actual_dim_",
        id: "_dashboard_id_milking_speed_actual_dim_",
      },
      {
        name: "_dashboard_name_components_actual_dim_",
        id: "_dashboard_id_components_actual_dim_",
      },
      {
        name: "_dashboard_name_components_actual_dim_mro_",
        id: "_dashboard_id_components_actual_dim_mro_",
      },
      {
        name: "_rap_workbook_name_milk_yield_trend_",
        id: "_arv_milk_yield_trend_dashboard",
      },
      {
        name: "_dashboard_name_cow_list_milk_",
        id: "_dashboard_id_cow_list_milk_",
      },
      {
        name: "_dashboard_name_concentrate_intake_per_cow_actual_",
        id: "_dashboard_id_concentrate_intake_per_cow_actual_",
      },
      {
        name: "_dashboard_name_concentrate_intake_per_cow_actual_by_dim",
        id: "_dashboard_id_concentrate_intake_per_cow_actual_by_dim",
      },
      {
        name: "_dashboard_name_days_pregnant_",
        id: "_dashboard_id_days_pregnant_",
      },
      {
        name: "_dashboard_name_conductivity_dim_",
        id: "_dashboard_id_conductivity_dim_",
      },
      {
        name: "_dashboard_name_herd_overview_extra_column_",
        id: "_dashboard_id_herd_overview_extra_column_",
      },
    ],

    filters_lng_list: [
      {
        internal_id: "sort_by",
        lng: "en-GB",
        name: "Sort by",
      },
      {
        internal_id: "sort_by",
        lng: "en-US",
        name: "Sort by",
      },
      {
        internal_id: "sort_by",
        lng: "fr-FR",
        name: "Sort by",
      },
      {
        internal_id: "sort_by",
        lng: "de-DE",
        name: "Sort by",
      },
      {
        internal_id: "sort_by",
        lng: "nl-NL",
        name: "Sort by",
      },

      {
        internal_id: "group_by",
        lng: "en-GB",
        name: "Group by",
      },
      {
        internal_id: "group_by",
        lng: "en-US",
        name: "Group by",
      },
      {
        internal_id: "group_by",
        lng: "fr-FR",
        name: "Groupé par",
      },
      {
        internal_id: "group_by",
        lng: "de-DE",
        name: "Gruppierungen nach",
      },
      {
        internal_id: "group_by",
        lng: "nl-NL",
        name: "Groepeer op",
      },

      {
        internal_id: "group_by_p_d",
        lng: "en-GB",
        name: "Group by DIM/Parity",
      },
      {
        internal_id: "group_by_p_d",
        lng: "en-US",
        name: "Group by DIM/Parity",
      },
      {
        internal_id: "group_by_p_d",
        lng: "fr-FR",
        name: "Group by DIM/Parity",
      },
      {
        internal_id: "group_by_p_d",
        lng: "de-DE",
        name: "Group by DIM/Parity",
      },
      {
        internal_id: "group_by_p_d",
        lng: "nl-NL",
        name: "Group by DIM/Parity",
      },

      {
        internal_id: "group_by_value",
        lng: "en-GB",
        name: "Parity",
        translate_string: "_dashboard_name_parameter_group_by_value_parity_",
      },
      {
        internal_id: "group_by_value",
        lng: "en-US",
        name: "Parity",
        translate_string: "_dashboard_name_parameter_group_by_value_parity_",
      },
      {
        internal_id: "group_by_value",
        lng: "fr-FR",
        name: "Lactation",
        translate_string: "_dashboard_name_parameter_group_by_value_parity_",
      },
      {
        internal_id: "group_by_value",
        lng: "de-DE",
        name: "Laktation",
        translate_string: "_dashboard_name_parameter_group_by_value_parity_",
      },
      {
        internal_id: "group_by_value",
        lng: "nl-NL",
        name: "Pariteit",
        translate_string: "_dashboard_name_parameter_group_by_value_parity_",
      },

      {
        internal_id: "group_by_value",
        lng: "en-GB",
        name: "Herd",
        translate_string: "_dashboard_name_parameter_group_by_value_herd_",
      },
      {
        internal_id: "group_by_value",
        lng: "en-US",
        name: "Herd",
        translate_string: "_dashboard_name_parameter_group_by_value_herd_",
      },
      {
        internal_id: "group_by_value",
        lng: "fr-FR",
        name: "Troupeau",
        translate_string: "_dashboard_name_parameter_group_by_value_herd_",
      },
      {
        internal_id: "group_by_value",
        lng: "de-DE",
        name: "Herde",
        translate_string: "_dashboard_name_parameter_group_by_value_herd_",
      },
      {
        internal_id: "group_by_value",
        lng: "nl-NL",
        name: "Bedrijf",
        translate_string: "_dashboard_name_parameter_group_by_value_herd_",
      },

      {
        internal_id: "group_by_value",
        lng: "en-GB",
        name: "Days in milk category",
        translate_string: "_dashboard_name_parameter_group_by_value_dim_",
      },
      {
        internal_id: "group_by_value",
        lng: "en-US",
        name: "Days in milk category",
        translate_string: "_dashboard_name_parameter_group_by_value_dim_",
      },
      {
        internal_id: "group_by_value",
        lng: "fr-FR",
        name: "Catégorie de jours de lactation",
        translate_string: "_dashboard_name_parameter_group_by_value_dim_",
      },
      {
        internal_id: "group_by_value",
        lng: "de-DE",
        name: "Kategorie Tage in Milch",
        translate_string: "_dashboard_name_parameter_group_by_value_dim_",
      },
      {
        internal_id: "group_by_value",
        lng: "nl-NL",
        name: "Dagen in lactatie categorie",
        translate_string: "_dashboard_name_parameter_group_by_value_dim_",
      },

      {
        internal_id: "group_by_value",
        lng: "en-GB",
        name: "DIM Category",
        translate_string: "_dashboard_name_parameter_dim_category_",
      },
      {
        internal_id: "group_by_value",
        lng: "en-US",
        name: "DIM Category",
        translate_string: "_dashboard_name_parameter_dim_category_",
      },
      {
        internal_id: "group_by_value",
        lng: "fr-FR",
        name: "Catégorie de JEL",
        translate_string: "_dashboard_name_parameter_dim_category_",
      },
      {
        internal_id: "group_by_value",
        lng: "de-DE",
        name: "TIM-Kategorie",
        translate_string: "_dashboard_name_parameter_dim_category_",
      },
      {
        internal_id: "group_by_value",
        lng: "nl-NL",
        name: "DIM Categorie",
        translate_string: "_dashboard_name_parameter_dim_category_",
      },

      {
        internal_id: "select_kpi",
        lng: "en-GB",
        name: "Select KPI",
      },
      {
        internal_id: "select_kpi",
        lng: "en-US",
        name: "Select KPI",
      },
      {
        internal_id: "select_kpi",
        lng: "fr-FR",
        name: "Select KPI",
      },
      {
        internal_id: "select_kpi",
        lng: "de-DE",
        name: "Select KPI",
      },
      {
        internal_id: "select_kpi",
        lng: "nl-NL",
        name: "Selecteer KPI",
      },

      {
        internal_id: "select_kpi_value",
        lng: "en-GB",
        name: "Fat %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "en-US",
        name: "Fat %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "fr-FR",
        name: "Fat %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "de-DE",
        name: "Fett %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "nl-NL",
        name: "Vet %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_percentage_",
      },

      {
        internal_id: "select_kpi_value",
        lng: "en-GB",
        name: "Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "en-US",
        name: "Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "fr-FR",
        name: "Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "de-DE",
        name: "Fett %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "nl-NL",
        name: "Eiwit %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_protein_percentage_",
      },

      {
        internal_id: "select_kpi_value",
        lng: "en-GB",
        name: "Fat/Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "en-US",
        name: "Fat/Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "fr-FR",
        name: "Fat/Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "de-DE",
        name: "Fett/Protein %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_protein_percentage_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "nl-NL",
        name: "Vet/Eiwit %",
        translate_string:
          "_dashboards_parameter_select_kpi_value_fat_protein_percentage_",
      },

      {
        internal_id: "select_kpi_value",
        lng: "en-GB",
        name: "Urea",
        translate_string: "_dashboards_parameter_select_kpi_value_urea_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "en-US",
        name: "Urea",
        translate_string: "_dashboards_parameter_select_kpi_value_urea_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "fr-FR",
        name: "Urée",
        translate_string: "_dashboards_parameter_select_kpi_value_urea_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "de-DE",
        name: "Harnstoff",
        translate_string: "_dashboards_parameter_select_kpi_value_urea_",
      },
      {
        internal_id: "select_kpi_value",
        lng: "nl-NL",
        name: "Ureum",
        translate_string: "_dashboards_parameter_select_kpi_value_urea_",
      },

      {
        internal_id: "date",
        lng: "en-GB",
        name: "Date",
        translate_string: "_dashboard_name_parameter_date_",
      },
      {
        internal_id: "date",
        lng: "en-US",
        name: "Date",
        translate_string: "_dashboard_name_parameter_date_",
      },
      {
        internal_id: "date",
        lng: "fr-FR",
        name: "Date",
        translate_string: "_dashboard_name_parameter_date_",
      },
      {
        internal_id: "date",
        lng: "de-DE",
        name: "Datum",
        translate_string: "_dashboard_name_parameter_date_",
      },
      {
        internal_id: "date",
        lng: "nl-NL",
        name: "Datum",
        translate_string: "_dashboard_name_parameter_date_",
      },

      {
        internal_id: "parity_filter",
        lng: "en-GB",
        name: "Parity Filter",
      },
      {
        internal_id: "parity_filter",
        lng: "en-US",
        name: "Parity Filter",
      },
      {
        internal_id: "parity_filter",
        lng: "fr-FR",
        name: "Filtre de lactation",
      },
      {
        internal_id: "parity_filter",
        lng: "de-DE",
        name: "Paritätsfilter",
      },
      {
        internal_id: "parity_filter",
        lng: "nl-NL",
        name: "Pariteit filter",
      },
      {
        internal_id: "parity_filter",
        lng: "pl-PL",
        name: "Parity Filter",
      },

      {
        internal_id: "kg_basis",
        lng: "en-GB",
        name: "Kg in basis",
      },
      {
        internal_id: "kg_basis",
        lng: "en-US",
        name: "Kg in basis",
      },
      {
        internal_id: "kg_basis",
        lng: "fr-FR",
        name: "Kg in basis",
      },
      {
        internal_id: "kg_basis",
        lng: "de-DE",
        name: "Kg in basis",
      },
      {
        internal_id: "kg_basis",
        lng: "nl-NL",
        name: "Kg in basis",
      },

      {
        internal_id: "feed_name",
        lng: "en-GB",
        name: "Feed name",
      },
      {
        internal_id: "feed_name",
        lng: "en-US",
        name: "Feed name",
      },
      {
        internal_id: "feed_name",
        lng: "fr-FR",
        name: "Nom de l'aliment",
      },
      {
        internal_id: "feed_name",
        lng: "de-DE",
        name: "Name des Futters",
      },
      {
        internal_id: "feed_name",
        lng: "nl-NL",
        name: "Voer naam",
      },

      {
        internal_id: "x_axis",
        lng: "en-GB",
        name: "X-Axis",
      },
      {
        internal_id: "x_axis",
        lng: "en-US",
        name: "X-Axis",
      },
      {
        internal_id: "x_axis",
        lng: "fr-FR",
        name: "Axe X",
      },
      {
        internal_id: "x_axis",
        lng: "de-DE",
        name: "X-Achse",
      },
      {
        internal_id: "x_axis",
        lng: "nl-NL",
        name: "X-as",
      },

      {
        internal_id: "y_axis",
        lng: "en-GB",
        name: "Y-Axis",
      },
      {
        internal_id: "y_axis",
        lng: "en-US",
        name: "Y-Axis",
      },
      {
        internal_id: "y_axis",
        lng: "fr-FR",
        name: "Axe Y",
      },
      {
        internal_id: "y_axis",
        lng: "de-DE",
        name: "Y-Achse",
      },
      {
        internal_id: "y_axis",
        lng: "nl-NL",
        name: "Y-as",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milk yield(kg)",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_kg_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milk yield(kg)",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_kg_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Milk yield(kg)",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_kg_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Milk yield(kg)",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_kg_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melkproductie(kg)",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_kg_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milkings",
        translate_string: "_dashboards_parameter_x_axis_value_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milkings",
        translate_string: "_dashboards_parameter_x_axis_value_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Traites",
        translate_string: "_dashboards_parameter_x_axis_value_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Melkvorgänge",
        translate_string: "_dashboards_parameter_x_axis_value_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melkingen",
        translate_string: "_dashboards_parameter_x_axis_value_milkings_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milking speed",
        translate_string: "_dashboards_parameter_x_axis_value_milking_speed_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milking speed",
        translate_string: "_dashboards_parameter_x_axis_value_milking_speed_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Vitesse de traite",
        translate_string: "_dashboards_parameter_x_axis_value_milking_speed_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Melkgeschwindigheit",
        translate_string: "_dashboards_parameter_x_axis_value_milking_speed_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melksnelheid",
        translate_string: "_dashboards_parameter_x_axis_value_milking_speed_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milk/Milkings",
        translate_string: "_dashboards_parameter_x_axis_value_milkin_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milk/Milkings",
        translate_string: "_dashboards_parameter_x_axis_value_milkin_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Lait / Traites",
        translate_string: "_dashboards_parameter_x_axis_value_milkin_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Milch/Melkung",
        translate_string: "_dashboards_parameter_x_axis_value_milkin_milkings_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melk/Melking",
        translate_string: "_dashboards_parameter_x_axis_value_milkin_milkings_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Minutes of milking",
        translate_string: "_dashboards_parameter_x_axis_value_minutes_milking_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Minutes of milking",
        translate_string: "_dashboards_parameter_x_axis_value_minutes_milking_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Minutes of milking",
        translate_string: "_dashboards_parameter_x_axis_value_minutes_milking_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Minutes of milking",
        translate_string: "_dashboards_parameter_x_axis_value_minutes_milking_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melktijd (Minuten)",
        translate_string: "_dashboards_parameter_x_axis_value_minutes_milking_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milk/Hour",
        translate_string: "_dashboards_parameter_x_axis_value_milk_hour_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milk/Hour",
        translate_string: "_dashboards_parameter_x_axis_value_milk_hour_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Milk/Hour",
        translate_string: "_dashboards_parameter_x_axis_value_milk_hour_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Milk/Hour",
        translate_string: "_dashboards_parameter_x_axis_value_milk_hour_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melk/Uur",
        translate_string: "_dashboards_parameter_x_axis_value_milk_hour_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Days in milk",
        translate_string: "_dashboards_parameter_x_axis_days_in_milk_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Days in milk",
        translate_string: "_dashboards_parameter_x_axis_days_in_milk_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Jours en lactation",
        translate_string: "_dashboards_parameter_x_axis_days_in_milk_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Tage in Milch",
        translate_string: "_dashboards_parameter_x_axis_days_in_milk_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Lactatiedagen",
        translate_string: "_dashboards_parameter_x_axis_days_in_milk_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Concentrate intake (kg)",
        translate_string: "_dashboards_parameter_x_concentrate_intake_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Concentrate intake (kg)",
        translate_string: "_dashboards_parameter_x_concentrate_intake_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Consommation de concentrés (kg)",
        translate_string: "_dashboards_parameter_x_concentrate_intake_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Kraftfutteraufnahme (kg)",
        translate_string: "_dashboards_parameter_x_concentrate_intake_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Krachtvoeropname (kg)",
        translate_string: "_dashboards_parameter_x_concentrate_intake_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Leftovers",
        translate_string: "_dashboards_parameter_axis_leftovers_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Leftovers",
        translate_string: "_dashboards_parameter_axis_leftovers_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Restes",
        translate_string: "_dashboards_parameter_axis_leftovers_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Reste",
        translate_string: "_dashboards_parameter_axis_leftovers_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Restvoer",
        translate_string: "_dashboards_parameter_axis_leftovers_",
      },

      {
        internal_id: "animal_ear_tag",
        lng: "en-GB",
        name: "Animal ear tag",
      },
      {
        internal_id: "animal_ear_tag",
        lng: "en-US",
        name: "Animal ear tag",
      },
      {
        internal_id: "animal_ear_tag",
        lng: "fr-FR",
        name: "Marque auriculaire de l'animal",
      },
      {
        internal_id: "animal_ear_tag",
        lng: "de-DE",
        name: "Ohrmarke des Tieres",
      },
      {
        internal_id: "animal_ear_tag",
        lng: "nl-NL",
        name: "Dier oornummer",
      },

      {
        internal_id: "animal_ear_tag_v2",
        lng: "en-GB",
        name: "AnimalEartag",
      },
      {
        internal_id: "animal_ear_tag_v2",
        lng: "en-US",
        name: "AnimalEartag",
      },
      {
        internal_id: "animal_ear_tag_v2",
        lng: "fr-FR",
        name: "AnimalEartag",
      },
      {
        internal_id: "animal_ear_tag_v2",
        lng: "de-DE",
        name: "AnimalEartag",
      },
      {
        internal_id: "animal_ear_tag_v2",
        lng: "nl-NL",
        name: "AnimalEartag",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Fat %",
        translate_string: "_dashboards_parameter_axis_value_fat_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Fat %",
        translate_string: "_dashboards_parameter_axis_value_fat_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Matière grasse %",
        translate_string: "_dashboards_parameter_axis_value_fat_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Fett %",
        translate_string: "_dashboards_parameter_axis_value_fat_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Vet %",
        translate_string: "_dashboards_parameter_axis_value_fat_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Protein %",
        translate_string: "_dashboards_parameter_axis_value_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Protein %",
        translate_string: "_dashboards_parameter_axis_value_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Protéines %",
        translate_string: "_dashboards_parameter_axis_value_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Eiweiß %",
        translate_string: "_dashboards_parameter_axis_value_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Eiwit %",
        translate_string: "_dashboards_parameter_axis_value_protein_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Fat/Protein %",
        translate_string: "_dashboards_parameter_axis_value_fat_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Fat/Protein %",
        translate_string: "_dashboards_parameter_axis_value_fat_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Matière grasse/Protéines %",
        translate_string: "_dashboards_parameter_axis_value_fat_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Fett/Eiweiß %",
        translate_string: "_dashboards_parameter_axis_value_fat_protein_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Vet/Eiwit %",
        translate_string: "_dashboards_parameter_axis_value_fat_protein_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Urea",
        translate_string: "_dashboards_parameter_axis_value_urea_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Urea",
        translate_string: "_dashboards_parameter_axis_value_urea_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Urée",
        translate_string: "_dashboards_parameter_axis_value_urea_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Harnstoff",
        translate_string: "_dashboards_parameter_axis_value_urea_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Ureum",
        translate_string: "_dashboards_parameter_axis_value_urea_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "DIM",
        translate_string: "_dashboards_parameter_axis_value_dim_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "DIM",
        translate_string: "_dashboards_parameter_axis_value_dim_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "JEL",
        translate_string: "_dashboards_parameter_axis_value_dim_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "tim",
        translate_string: "_dashboards_parameter_axis_value_dim_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Lactatiedagen",
        translate_string: "_dashboards_parameter_axis_value_dim_",
      },

      {
        internal_id: "axis_value",
        lng: "en-GB",
        name: "Milk yield",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_",
      },
      {
        internal_id: "axis_value",
        lng: "en-US",
        name: "Milk yield",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_",
      },
      {
        internal_id: "axis_value",
        lng: "fr-FR",
        name: "Production laitière",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_",
      },
      {
        internal_id: "axis_value",
        lng: "de-DE",
        name: "Milchleistung",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_",
      },
      {
        internal_id: "axis_value",
        lng: "nl-NL",
        name: "Melkproductie",
        translate_string: "_dashboards_parameter_axis_value_milk_yield_",
      },

      {
        internal_id: "conductivity_type",
        lng: "en-GB",
        name: "Select type of conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_",
      },
      {
        internal_id: "conductivity_type",
        lng: "en-US",
        name: "Select type of conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_",
      },
      {
        internal_id: "conductivity_type",
        lng: "fr-FR",
        name: "Select type of conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_",
      },
      {
        internal_id: "conductivity_type",
        lng: "de-DE",
        name: "Select type of conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_",
      },
      {
        internal_id: "conductivity_type",
        lng: "nl-NL",
        name: "Selecteer type geleidbaarheid",
        translate_string: "_dashboards_parameter_conductivity_type_",
      },

      {
        internal_id: "conductivity_type_value",
        lng: "en-GB",
        name: "Average Daily conductivity",
        translate_string:
          "_dashboards_parameter_conductivity_type_value_average_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "en-US",
        name: "Average Daily conductivity",
        translate_string:
          "_dashboards_parameter_conductivity_type_value_average_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "fr-FR",
        name: "Average Daily conductivity",
        translate_string:
          "_dashboards_parameter_conductivity_type_value_average_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "de-DE",
        name: "Average Daily conductivity",
        translate_string:
          "_dashboards_parameter_conductivity_type_value_average_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "nl-NL",
        name: "Gemiddelde dagelijkse geleidbaarheid",
        translate_string:
          "_dashboards_parameter_conductivity_type_value_average_",
      },

      {
        internal_id: "conductivity_type_value",
        lng: "en-GB",
        name: "Max Daily conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_value_max_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "en-US",
        name: "Max Daily conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_value_max_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "fr-FR",
        name: "Max Daily conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_value_max_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "de-DE",
        name: "Max Daily conductivity",
        translate_string: "_dashboards_parameter_conductivity_type_value_max_",
      },
      {
        internal_id: "conductivity_type_value",
        lng: "nl-NL",
        name: "Max. dagelijkse geleidbaarheid",
        translate_string: "_dashboards_parameter_conductivity_type_value_max_",
      },
    ],

    dashboards: [
      {
        dashboard_id: "_arv_home_dashboard",
      },
      {
        dashboard_id: "_arv_herd_overview_dashboard",
        report: true,
        actual: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_p_d_",
            default: "_dashboard_name_parameter_group_by_value_parity_",
            translate: true,
          },
        ],

        links: [
          {
            sheetName: "_rap_workbook_name_herd_prestations_trend_",
            icon: "list-icon",
            tooltip: "_go_to_herd_prestations_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_herd_overview_extra_column_",
        report: true,
        actual: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_p_d_",
            default: "_dashboard_name_parameter_group_by_value_parity_",
            translate: true,
          },
        ],

        links: [
          {
            sheetName: "_rap_workbook_name_herd_prestations_trend_",
            icon: "list-icon",
            tooltip: "_go_to_herd_prestations_",
          },
        ],
      },
      {
        dashboard_id: "_arv_milk_yield_trend_dashboard",
        report: true,
        actual: false,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_over_time_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_milk_yield_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_milk_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_milk_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_rap_workbook_id_milk_yield_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_cow_by_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_milk_yield_kg_cow_by_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_milk_yield_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_milk_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_milk_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milk_yield_actual_by_date_",
        report: true,
        actual_by_date: true,
        worksheetName: "_milk_yield_kg_cow_dim_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_cow_dim_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_milk_yield_kg_cow_dim_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_milk_yield_kg_cow_dim_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_milk_yield_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_milk_trend_",
          },
        ],
      },
      {
        dashboard_id: "_rap_workbook_id_spp_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            worksheetName: "_spp_kg_cow_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_spp_kg_cow_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_spp_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_spp_trend_",
          },
        ],
      },
      {
        dashboard_id: "_rap_workbook_id_spp_trend_",
        report: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            worksheetName: "_spp_over_time_",
          },
        ],
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_spp_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_spp_actual_",
          },
        ],
      },
      {
        dashboard_id: "_herd_prestation_trend_spp_",
        report: true,
      },
      {
        dashboard_id: "_rap_workbook_id_herd_prestations_trend_",
        report: true,
        actual: false,
        links: [
          {
            sheetName: "_worksheet_name_herd_overview_",
            icon: "herd-overview-icon",
            tooltip: "_go_to_herd_overview_",
          }
        ],
      },
      {
        dashboard_id: "_dashboard_id_spp_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_spp_kg_cow_dim_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_spp_kg_cow_dim_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_spp_kg_cow_dim_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_spp_kg_cow_dim_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_spp_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_spp_trend_",
          },
        ],
      },
      {
        dashboard_id: "_arv_components_dashboard_mro_",
        report: true,
        mro: true,
        actual: true,
        parameters: [
          {
            name: "_dashboards_parameter_x_axis_",
            default: "gg",
          },
          {
            name: "_dashboards_parameter_y_axis_",
            default: "gg",
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_components_worksheet_mro_",
          },
        ],
        zoomFilter: {
          worksheetName: "_components_worksheet_mro_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_arv_components_trend_dashboard_mro_name_",
            icon: "trend-icon",
            tooltip: "_go_to_components_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_components_actual_dim_mro_",
        report: true,
        mro: true,
        actual_by_date: true,
        worksheetName: "_worksheet_components_actual_trend_mro_",
        parameters: [
          {
            name: "_dashboards_parameter_x_axis_",
            default: "gg",
          },
          {
            name: "_dashboards_parameter_y_axis_",
            default: "gg",
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_components_actual_trend_mro_",
          },
          {
            name: "_dashboard_name_action_day_filter_",
            id: 2,
            worksheetName: "_worksheet_components_actual_trend_mro_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_components_actual_trend_mro_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_arv_components_trend_dashboard_mro_name_",
            icon: "trend-icon",
            tooltip: "_go_to_components_trend_",
          },
        ],
      },
      {
        dashboard_id: "_arv_components_trend_dashboard_mro_",
        report: true,
        mro: true,
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default: "_dashboards_parameter_select_kpi_value_fat_percentage_",
            translate: true,
          },
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_name_components_trend_mro_",
          },
        ],
        links: [
          {
            sheetName: "_arv_components_dashboard_mro_name_",
            icon: "actual-icon",
            tooltip: "_go_to_components_actual_",
          },
        ],
      },
      {
        dashboard_id: "_arv_components_dashboard_",
        report: true,
        actual: true,
        parameters: [
          {
            name: "_dashboards_parameter_x_axis_",
            default: "gg",
          },
          {
            name: "_dashboards_parameter_y_axis_",
            default: "gg",
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_components_worksheet_",
          },
        ],
        zoomFilter: {
          worksheetName: "_components_worksheet_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_arv_components_trend_dashboard_name_",
            icon: "trend-icon",
            tooltip: "_go_to_components_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_components_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_worksheet_components_actual_trend_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_components_actual_trend_",
          },
          {
            name: "_dashboard_action_day_filter_",
            id: 2,
            worksheetName: "_worksheet_components_actual_trend_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_components_actual_trend_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_x_axis_",
            default: "gg",
          },
          {
            name: "_dashboards_parameter_y_axis_",
            default: "gg",
          },
        ],
        links: [
          {
            sheetName: "_arv_components_trend_dashboard_name_",
            icon: "trend-icon",
            tooltip: "_go_to_components_trend_",
          },
        ],
      },
      {
        dashboard_id: "_arv_components_trend_dashboard_",
        report: true,
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default: "_dashboards_parameter_select_kpi_value_fat_percentage_",
            translate: true,
          },
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_name_components_trend_",
          },
        ],
        links: [
          {
            sheetName: "_arv_components_dashboard_name_",
            icon: "actual-icon",
            tooltip: "_go_to_components_actual_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_days_pregnant_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_dashboard_days_pregnant_worksheet_",
          },
        ],
        zoomFilter: {
          worksheetName: "_dashboard_days_pregnant_worksheet_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
      },
      {
        dashboard_id: "_dashboard_id_milk_yield_trend_mro_",
        report: true,
        mro: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_over_time_mro_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_milk_yield_actual_mro_",
            icon: "actual-icon",
            tooltip: "_go_to_milk_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_milk_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_spp_trend_mro_",
        report: true,
        mro: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_spp_over_time_mro_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_spp_actual_mro_",
            icon: "actual-icon",
            tooltip: "_go_to_spp_actual_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_spp_actual_mro_",
        report: true,
        actual: true,
        mro: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_spp_dim_mro_",
          },
        ],
        zoomFilter: {
          worksheetName: "_spp_dim_mro_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_spp_trend_mro_",
            icon: "trend-icon",
            tooltip: "_go_to_spp_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_spp_actual_dim_mro_",
        report: true,
        actual_by_date: true,
        mro: true,
        worksheetName: "_spp_dim_mro_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_spp_dim_mro_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_spp_dim_mro_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_spp_dim_mro_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_spp_trend_mro_",
            icon: "trend-icon",
            tooltip: "_go_to_spp_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milk_yield_actual_dim_mro_",
        report: true,
        actual_by_date: true,
        worksheetName: "_milk_yield_kg_cow_dim_date_mro_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_cow_dim_date_mro_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_milk_yield_kg_cow_dim_date_mro_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_milk_yield_kg_cow_dim_date_mro_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_milk_yield_trend_mro_",
            icon: "trend-icon",
            tooltip: "_go_to_milk_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milk_yield_actual_mro_",
        report: true,
        actual: true,
        mro: true,
        worksheetName: "_milk_yield_kg_cow_dim_mro_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_milk_yield_kg_cow_dim_mro_",
          },
        ],
        zoomFilter: {
          worksheetName: "_milk_yield_kg_cow_dim_mro_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_v_2_",
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_2_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_milk_yield_trend_mro_",
            icon: "trend-icon",
            tooltip: "_go_to_milk_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_by_herd_",
        report: true,
        actual: true,
        links: [
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
        /* parameters: [
          {
            name: "_dashboards_parameter_kg_in_basis_",
            default: 2,
          },
        ],*/
      },
      {
        dashboard_id: "_dashboard_id_cow_list_",
        report: true,
        actual: true,
        /*links: [
          {
            icon: "herd-overview-icon",
            sheetName: "_dashboard_name_concentrate_by_herd_",
            tooltip: "_go_to_trend_dashboard_",
          },
        ],*/
        backButton: true,
        backButtonLinks: [
          {
            dashboard_id: "_dashboard_id_concentrate_by_herd_",
            icon: "herd-overview-icon",
            sheetName: "_dashboard_name_concentrate_by_herd_",
            tooltip: "_go_to_concentrate_overview_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_cow_trend_",
            sheetName: "_dashboard_name_concentrate_per_cow_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_cow_actual_",
            sheetName: "_dashboard_name_concentrate_per_cow_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_concentrate_gift_actual_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_cow_actual_",
            sheetName: "_dashboard_name_concentrate_per_cow_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_cow_trend_",
            sheetName: "_dashboard_name_concentrate_per_cow_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_concentrate_gift_actual_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_100Kg_trend_",
            sheetName: "_dashboard_name_concentrate_per_100Kg_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_per_100Kg_actual_",
            sheetName: "_dashboard_name_concentrate_per_100Kg_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_concentrate_gift_actual_",
          },
          {
            dashboard_id: "_rap_workbook_id_leftovers_actual_",
            sheetName: "_dashboard_name_leftovers_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_leftovers_actual_",
          },
          {
            dashboard_id: "_rap_workbook_id_leftovers_trends_",
            sheetName: "_rap_workbook_name_leftovers_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_leftovers_trend_",
          },
          {
            dashboard_id: "_rap_workbook_id_leftovers_trends_",
            sheetName: "_dashboard_name_leftovers_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_leftovers_actual_",
          },
          {
            dashboard_id: "_rap_workbook_id_leftovers_actual_",
            sheetName: "_rap_workbook_name_leftovers_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_leftovers_trend_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_intake_per_cow_actual_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_concentrate_intake_per_cow_actual_",
            tooltip: "_go_to_concentrate_intake_actual_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_intake_by_conc_trend_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_concentrate_intake_by_conc_trend_",
            tooltip: "_go_to_concentrate_intake_trend_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_intake_by_conc_trend_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_concentrate_intake_per_cow_actual_",
            tooltip: "_go_to_concentrate_intake_actual_",
          },
          {
            dashboard_id: "_dashboard_id_concentrate_intake_per_cow_actual_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_concentrate_intake_by_conc_trend_",
            tooltip: "_go_to_concentrate_intake_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_cow_list_milk_",
        report: true,
        actual: true,
        links: [
          {
            sheetName: "_rap_workbook_name_milk_yield_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_milk_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_cow_trend_",
        report: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_per_cow_trend_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_cow_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_concentrate_gift_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_cow_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_per_cow_actual_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_concentrate_per_cow_actual_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default:
              "_dashboards_parameter_select_kpi_value_concentrate_by_dim_",
            translate: true,
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_cow_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_cow_actual_trend_",
        report: true,
        actual_by_date: true,
        worksheetName: "_concentrate_gift_kg_cow_dim_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_concentrate_gift_kg_cow_dim_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_concentrate_gift_kg_cow_dim_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_concentrate_gift_kg_cow_dim_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default:
              "_dashboards_parameter_select_kpi_value_concentrate_by_dim_",
            translate: true,
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_cow_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_100Kg_trend_",
        report: true,
        per100: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_per_100Kg_trend_",
          },
        ],
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_100Kg_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_concentrate_gift_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_100Kg_actual_",
        report: true,
        actual: true,
        per100: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_per_100Kg_actual_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_concentrate_per_100Kg_actual_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_100Kg_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_per_100Kg_actual_trend_",
        report: true,
        actual_by_date: true,
        worksheetName: "_sheet_name_concentrate_per_100Kg_actual_trend_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_per_100Kg_actual_trend_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_sheet_name_concentrate_per_100Kg_actual_trend_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_concentrate_per_100Kg_actual_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_concentrate_per_100Kg_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_concentrate_gift_trend_",
          },
        ],
      },
      {
        dashboard_id: "_rap_workbook_id_leftovers_trends_",
        report: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_leftovers_over_time_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_leftovers_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_leftovers_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_rap_workbook_id_leftovers_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_leftover_by_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_leftover_by_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_leftovers_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_leftovers_trend_",
          },
          {
            icon: "milking-icon",
            sheetName: "_dashboard_name_leftovers_by_milking_speed_actual_",
            tooltip: "_go_to_milking_speed_dashboard_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_leftovers_actual_by_date_",
        report: true,
        actual_by_date: true,
        worksheetName: "_sheet_name_leftover_by_dim_by_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_leftover_by_dim_by_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_sheet_name_leftover_by_dim_by_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_leftover_by_dim_by_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        links: [
          {
            sheetName: "_rap_workbook_name_leftovers_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_leftovers_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_leftovers_by_milking_speed_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_leftover_by_milk_speed_",
          },
        ],
        links: [
          {
            sheetName: "_dashboard_name_leftovers_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_leftovers_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_intake_trend_",
        report: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_concentrate_intake_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_intake_by_conc_trend_",
        report: true,
        filters: [
          {
            name: "_dashboard_name_filter_feed_name_",
            id: 1,
            worksheetName: "_dashboard_name_workbook_avg_feed_over_time",
          },
        ],
        links: [
          {
            icon: "actual-icon",
            sheetName: "_dashboard_name_concentrate_intake_per_cow_actual_",
            tooltip: "_go_to_concentrate_intake_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_intake_per_cow_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_concentrate_intake_kg_cow_by_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_concentrate_intake_kg_cow_by_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default:
              "_dashboards_parameter_select_kpi_value_concentrate_by_dim_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_concentrate_intake_by_conc_trend_",
            tooltip: "_go_to_concentrate_intake_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_concentrate_intake_per_cow_actual_by_dim",
        report: true,
        actual_by_date: true,
        worksheetName: "_concentrate_intake_kg_cow_dim_date_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_concentrate_intake_kg_cow_dim_date_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_concentrate_intake_kg_cow_dim_date_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_concentrate_intake_kg_cow_dim_date_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_select_kpi_",
            default:
              "_dashboards_parameter_select_kpi_value_concentrate_by_dim_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_concentrate_intake_by_conc_trend_",
            tooltip: "_go_to_concentrate_intake_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milkings_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_milkings_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_milkings_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_milkings_trend_",
            tooltip: "_go_to_milkings_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milkings_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_worksheet_milkings_actual_trend_2_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_milkings_actual_trend_2_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_worksheet_milkings_actual_trend_2_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_milkings_actual_trend_2_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_milkings_trend_",
            tooltip: "_go_to_milkings_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milkings_trend_",
        report: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_milkings_over_time_",
          },
        ],
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "actual-icon",
            sheetName: "_dashboard_name_milkings_",
            tooltip: "_go_to_milkings_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_refusals_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_refusals_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_refusals_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_refusals_trend_",
            tooltip: "_go_to_refusals_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_refusals_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_worksheet_refusals_actual_trend_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_refusals_actual_trend_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_worksheet_refusals_actual_trend_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_refusals_actual_trend_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_refusals_trend_",
            tooltip: "_go_to_refusals_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_refusals_trend_",
        report: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_refusals_over_time_",
          },
        ],
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "actual-icon",
            sheetName: "_dashboard_name_refusals_",
            tooltip: "_go_to_refusals_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_failures_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_failures_dim_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_failures_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },

        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_failures_trend_",
            tooltip: "_go_to_failures_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_failures_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_worksheet_failures_actual_trend_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_failures_actual_trend_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_worksheet_failures_actual_trend_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_failures_dim_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_failures_trend_",
            tooltip: "_go_to_failures_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_failures_trend_",
        report: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_failures_over_time_",
          },
        ],
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "actual-icon",
            sheetName: "_dashboard_name_failures_",
            tooltip: "_go_to_failures_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milkings_hour_",
        report: true,
        actual: true,
        links: [
          {
            icon: "robot-efficiency-icon",
            sheetName: "_dashboard_name_robot_efficiency_",
            tooltip: "_go_to_robot_efficiency_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_robot_efficiency_",
        report: true,
        links: [
          {
            sheetName: "_dashboard_name_milkings_hour_",
            icon: "milkings-hour-icon",
            tooltip: "_go_to_milkings_by_hour_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_cow_list_robot_",
        report: true,
        actual: true,
        backButton: true,
        backButtonLinks: [
          {
            dashboard_id: "_dashboard_id_robot_efficiency_",
            icon: "robot-efficiency-icon",
            sheetName: "_dashboard_name_robot_efficiency_",
            tooltip: "_go_to_robot_efficiency_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_hour_",
            sheetName: "_dashboard_name_milkings_hour_",
            icon: "milkings-hour-icon",
            tooltip: "_go_to_milkings_by_hour_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_hour_",
            icon: "robot-efficiency-icon",
            sheetName: "_dashboard_name_robot_efficiency_",
            tooltip: "_go_to_robot_efficiency_",
          },
          {
            dashboard_id: "_dashboard_id_robot_efficiency_",
            sheetName: "_dashboard_name_milkings_hour_",
            icon: "milkings-hour-icon",
            tooltip: "_go_to_milkings_by_hour_",
          },
          {
            dashboard_id: "_dashboard_id_milking_speed_trend_",
            sheetName: "_dashboard_name_milking_speed_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_speed_trend_",
          },
          {
            dashboard_id: "_dashboard_id_milking_speed_dim_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_milking_speed_dim_",
            tooltip: "_go_to_speed_actual_",
          },
          {
            dashboard_id: "_dashboard_id_milking_speed_dim_",
            sheetName: "_dashboard_name_milking_speed_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_speed_trend_",
          },
          {
            dashboard_id: "_dashboard_id_milking_speed_trend_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_milking_speed_dim_",
            tooltip: "_go_to_speed_actual_",
          },
          {
            dashboard_id: "_dashboard_id_milk_per_milking_minutes_actual_",
            sheetName: "_dashboard_name_milk_per_milking_minutes_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_efficiency_actual_",
          },
          {
            dashboard_id: "_dashboard_id_milk_hour_cow_",
            icon: "milking-icon",
            sheetName: "_dashboard_name_milk_hour_cow_",
            tooltip: "_go_to_milk_per_hour_per_cow_",
          },
          {
            dashboard_id: "_dashboard_id_milk_hour_cow_",
            sheetName: "_dashboard_name_milk_per_milking_minutes_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_efficiency_actual_",
          },
          {
            dashboard_id: "_dashboard_id_milk_per_milking_minutes_actual_",
            icon: "milking-icon",
            sheetName: "_dashboard_name_milk_hour_cow_",
            tooltip: "_go_to_milk_per_hour_per_cow_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_trend_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_milkings_trend_",
            tooltip: "_go_to_milkings_trend_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_trend_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_milkings_",
            tooltip: "_go_to_milkings_actual_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_milkings_trend_",
            tooltip: "_go_to_milkings_trend_",
          },
          {
            dashboard_id: "_dashboard_id_milkings_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_milkings_",
            tooltip: "_go_to_milkings_actual_",
          },
          {
            dashboard_id: "_dashboard_id_refusals_trend_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_refusals_trend_",
            tooltip: "_go_to_refusals_trend_",
          },
          {
            dashboard_id: "_dashboard_id_refusals_trend_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_refusals_",
            tooltip: "_go_to_refusals_actual_",
          },
          {
            dashboard_id: "_dashboard_id_refusals_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_refusals_trend_",
            tooltip: "_go_to_refusals_trend_",
          },
          {
            dashboard_id: "_dashboard_id_refusals_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_refusals_",
            tooltip: "_go_to_refusals_actual_",
          },
          {
            dashboard_id: "_dashboard_id_failures_trend_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_failures_trend_",
            tooltip: "_go_to_failures_trend_",
          },
          {
            dashboard_id: "_dashboard_id_failures_trend_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_failures_",
            tooltip: "_go_to_failures_actual_",
          },
          {
            dashboard_id: "_dashboard_id_failures_",
            icon: "trend-icon",
            sheetName: "_dashboard_name_failures_trend_",
            tooltip: "_go_to_failures_trend_",
          },
          {
            dashboard_id: "_dashboard_id_failures_",
            icon: "actual-icon",
            sheetName: "_dashboard_name_failures_",
            tooltip: "_go_to_failures_actual_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milking_speed_dim_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_milking_speed_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_milking_speed_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            sheetName: "_dashboard_name_milking_speed_trend_",
            icon: "trend-icon",
            tooltip: "_go_to_speed_trend_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milking_speed_trend_",
        report: true,
        parameters: [
          {
            name: "_dashboard_name_parameter_group_by_",
            default: "_dashboard_name_parameter_group_by_value_herd_",
            translate: true,
          },
        ],
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_milking_speed_over_time_",
          },
        ],
        links: [
          {
            icon: "actual-icon",
            sheetName: "_dashboard_name_milking_speed_dim_",
            tooltip: "_go_to_speed_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milking_speed_actual_dim_",
        report: true,
        actual_by_date: true,
        worksheetName: "_worksheet_milking_speed_actual_trend_",
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_milking_speed_actual_trend_",
          },
          {
            name: "_dashboard_name_action_day_filter_1_",
            id: 2,
            worksheetName: "_worksheet_milking_speed_actual_trend_",
            date_filter: true,
            alias: "_dashboard_name_parameter_date_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_milking_speed_actual_trend_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        links: [
          {
            icon: "trend-icon",
            sheetName: "_dashboard_name_milking_speed_trend_",
            tooltip: "_go_to_speed_trend_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milk_hour_cow_",
        report: true,
        actual: true,
        links: [
          {
            sheetName: "_dashboard_name_milk_per_milking_minutes_actual_",
            icon: "actual-icon",
            tooltip: "_go_to_efficiency_actual_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_milk_per_milking_minutes_actual_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_sheet_name_milk_hour_cow_actual_",
          },
        ],
        zoomFilter: {
          worksheetName: "_sheet_name_milk_hour_cow_actual_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_v_3_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_x_axis_",
            default: "_dashboards_parameter_axis_value_milk_yield_kg_",
            translate: true,
          },
          {
            name: "_dashboards_parameter_y_axis_",
            default: "_dashboards_parameter_x_axis_value_minutes_milking_",
            translate: true,
          },
        ],
        links: [
          {
            icon: "milking-icon",
            sheetName: "_dashboard_name_milk_hour_cow_",
            tooltip: "_go_to_milk_per_hour_per_cow_",
          },
          {
            sheetName: "_dashboard_name_cow_list_robot_",
            icon: "list-icon",
            tooltip: "_go_to_cow_list_",
          },
        ],
      },
      {
        dashboard_id: "_dashboard_id_conductivity_dim_",
        report: true,
        actual: true,
        filters: [
          {
            name: "_dashboard_name_filter_parity_filter_",
            id: 1,
            worksheetName: "_worksheet_name_conductivity_dashboard_",
          },
        ],
        zoomFilter: {
          worksheetName: "_worksheet_name_conductivity_dashboard_",
          filter: {
            name: "_dashboard_action_zoom_filter_name_",
            type: 1,
          },
          compareFilter: {
            name: "_dashboard_inclusions_zoom_filter_name_",
          },
        },
        parameters: [
          {
            name: "_dashboards_parameter_conductivity_type_",
            default: "_dashboards_parameter_conductivity_type_value_average_",
            translate: true,
          },
        ],
      },
    ],

    dashboard_id_lng_list: [
      {
        internal_id: "home",
        id: "Home",
        lng: "en-GB",
        index: 1,
      },
      {
        internal_id: "home",
        id: "Home",
        lng: "en-US",
        index: 1,
      },
      {
        internal_id: "home",
        id: "Accueil",
        lng: "fr-FR",
        index: 1,
      },
      {
        internal_id: "home",
        id: "Startseite",
        lng: "de-DE",
        index: 1,
      },
      {
        internal_id: "home",
        id: "Home",
        lng: "nl-NL",
        index: 1,
      },

      {
        internal_id: "herd_overview",
        id: "HerdOverviewDashboard",
        lng: "en-GB",
        index: 2,
      },
      {
        internal_id: "herd_overview",
        id: "HerdOverviewDashboard",
        lng: "en-US",
        index: 2,
      },
      {
        internal_id: "herd_overview",
        id: "Tableaudeborddutroupeau",
        lng: "fr-FR",
        index: 2,
      },
      {
        internal_id: "herd_overview",
        id: "HerdenbersichtDashboard",
        lng: "de-DE",
        index: 2,
      },
      {
        internal_id: "herd_overview",
        id: "Bedrijfsoverzichtdashboard",
        lng: "nl-NL",
        index: 2,
      },

      {
        internal_id: "herd_overview_extra",
        id: "HerdOverviewDetailsDashboard",
        lng: "en-GB",
        index: 2,
      },
      {
        internal_id: "herd_overview_extra",
        id: "HerdOverviewDetailsDashboard",
        lng: "en-US",
        index: 2,
      },
      {
        internal_id: "herd_overview_extra",
        id: "HerdOverviewDetailsDashboard",
        lng: "fr-FR",
        index: 2,
      },
      {
        internal_id: "herd_overview_extra",
        id: "HerdOverviewDetailsDashboard",
        lng: "de-DE",
        index: 2,
      },
      {
        internal_id: "herd_overview_extra",
        id: "BedrijfsoverzichtDetaildashboard",
        lng: "nl-NL",
        index: 2,
      },

      {
        internal_id: "milk_yield_trend",
        id: "Milkyieldtrend",
        lng: "en-GB",
        index: 3,
        actual: false,
      },
      {
        internal_id: "milk_yield_trend",
        id: "Milkyieldtrend",
        lng: "en-US",
        index: 3,
        actual: false,
      },
      {
        internal_id: "milk_yield_trend",
        id: "Tendancedelaproductionlaitire",
        lng: "fr-FR",
        index: 3,
        actual: false,
      },
      {
        internal_id: "milk_yield_trend",
        id: "Milchleistungsentwicklung",
        lng: "de-DE",
        index: 3,
        actual: false,
      },
      {
        internal_id: "milk_yield_trend",
        id: "Melkproductietrend",
        lng: "nl-NL",
        index: 3,
        actual: false,
      },

      {
        internal_id: "cow_list_milk",
        id: "Cowlist-milk",
        lng: "en-GB",
        index: 4,
        actual: false,
      },
      {
        internal_id: "cow_list_milk",
        id: "Cowlist-milk",
        lng: "en-US",
        index: 4,
        actual: false,
      },
      {
        internal_id: "cow_list_milk",
        id: "Cowlist-milk",
        lng: "fr-FR",
        index: 4,
        actual: false,
      },
      {
        internal_id: "cow_list_milk",
        id: "Cowlist-milk",
        lng: "de-DE",
        index: 4,
        actual: false,
      },
      {
        internal_id: "cow_list_milk",
        id: "Koelijst-Melk",
        lng: "nl-NL",
        index: 4,
        actual: false,
      },

      {
        internal_id: "milk_yield_actual",
        id: "Milkyieldactual",
        lng: "en-GB",
        index: 5,
        actual: true,
      },
      {
        internal_id: "milk_yield_actual",
        id: "Milkyieldactual",
        lng: "en-US",
        index: 5,
        actual: true,
      },
      {
        internal_id: "milk_yield_actual",
        id: "Productionlaitirerelle",
        lng: "fr-FR",
        index: 5,
        actual: true,
      },
      {
        internal_id: "milk_yield_actual",
        id: "tatschlicheMilchleistung",
        lng: "de-DE",
        index: 5,
        actual: true,
      },
      {
        internal_id: "milk_yield_actual",
        id: "Melkproductieactueel",
        lng: "nl-NL",
        index: 5,
        actual: true,
      },

      {
        internal_id: "milk_yield_by_date_dashboard",
        id: "MilkyieldactualbyDIMdashboard",
        lng: "en-GB",
        index: 6,
        actual: true,
      },
      {
        internal_id: "milk_yield_by_date_dashboard",
        id: "MilkyieldactualbyDIMdashboard",
        lng: "en-US",
        index: 6,
        actual: true,
      },
      {
        internal_id: "milk_yield_by_date_dashboard",
        id: "MilkyieldactualbyDIMdashboard",
        lng: "fr-FR",
        index: 6,
        actual: true,
      },
      {
        internal_id: "milk_yield_by_date_dashboard",
        id: "MilkyieldactualbyDIMdashboard",
        lng: "de-DE",
        index: 6,
        actual: true,
      },
      {
        internal_id: "milk_yield_by_date_dashboard",
        id: "MelkproductieactueelperDILdashboard",
        lng: "nl-NL",
        index: 6,
        actual: true,
      },

      {
        internal_id: "herd_prestations_trend",
        id: "Herdprestationstrend",
        lng: "en-GB",
        index: 7,
        actual: false,
      },
      {
        internal_id: "herd_prestations_trend",
        id: "Herdprestationstrend",
        lng: "en-US",
        index: 7,
        actual: false,
      },
      {
        internal_id: "herd_prestations_trend",
        id: "Tendancedesprestationsdutroupeau",
        lng: "fr-FR",
        index: 7,
        actual: false,
      },
      {
        internal_id: "herd_prestations_trend",
        id: "EntwicklungderHerdenvorhersage",
        lng: "de-DE",
        index: 7,
        actual: false,
      },
      {
        internal_id: "herd_prestations_trend",
        id: "Kuddeprestatiestrend",
        lng: "nl-NL",
        index: 7,
        actual: false,
      },

      {
        internal_id: "spp_trend",
        id: "SPPtrend",
        lng: "en-GB",
        index: 8,
      },
      {
        internal_id: "spp_trend",
        id: "SPPtrend",
        lng: "en-US",
        index: 8,
      },
      {
        internal_id: "spp_trend",
        id: "TendanceBSK",
        lng: "fr-FR",
        index: 8,
      },
      {
        internal_id: "spp_trend",
        id: "BSK-Entwicklung",
        lng: "de-DE",
        index: 8,
      },
      {
        internal_id: "spp_trend",
        id: "BSKtrend",
        lng: "nl-NL",
        index: 8,
      },

      {
        internal_id: "spp_actual",
        id: "SPPactual",
        lng: "en-GB",
        index: 9,
        actual: true,
      },
      {
        internal_id: "spp_actual",
        id: "SPPactual",
        lng: "en-US",
        index: 9,
        actual: true,
      },
      {
        internal_id: "spp_actual",
        id: "BSKrel",
        lng: "fr-FR",
        index: 9,
        actual: true,
      },
      {
        internal_id: "spp_actual",
        id: "tatschlicheBSK",
        lng: "de-DE",
        index: 9,
        actual: true,
      },
      {
        internal_id: "spp_actual",
        id: "BSKactueel",
        lng: "nl-NL",
        index: 9,
        actual: true,
      },

      {
        internal_id: "herd_prestation_trend_spp",
        id: "HerdprestationstrendSPP",
        lng: "en-GB",
        index: 10,
      },
      {
        internal_id: "herd_prestation_trend_spp",
        id: "HerdprestationstrendSPP",
        lng: "en-US",
        index: 10,
      },
      {
        internal_id: "herd_prestation_trend_spp",
        id: "TendancedesprestationsBSKdutroupeau",
        lng: "fr-FR",
        index: 10,
      },
      {
        internal_id: "herd_prestation_trend_spp",
        id: "EntwicklungderHerdenprsenzSPP",
        lng: "de-DE",
        index: 10,
      },
      {
        internal_id: "herd_prestation_trend_spp",
        id: "KuddeprestatiestrendBSK",
        lng: "nl-NL",
        index: 10,
      },

      {
        internal_id: "spp_by_date_dashboard",
        id: "SPPactualbyDIMdashboard",
        lng: "en-GB",
        index: 11,
        actual: true,
      },
      {
        internal_id: "spp_by_date_dashboard",
        id: "SPPactualbyDIMdashboard",
        lng: "en-US",
        index: 11,
        actual: true,
      },
      {
        internal_id: "spp_by_date_dashboard",
        id: "SPPactualbyDIMdashboard",
        lng: "fr-FR",
        index: 11,
        actual: true,
      },
      {
        internal_id: "spp_by_date_dashboard",
        id: "SPPactualbyDIMdashboard",
        lng: "de-DE",
        index: 11,
        actual: true,
      },
      {
        internal_id: "spp_by_date_dashboard",
        id: "BSKactueelperDILdashboard",
        lng: "nl-NL",
        index: 11,
        actual: true,
      },

      {
        internal_id: "components_dashboard_mro",
        id: "ComponentsdashboardMRO",
        lng: "en-GB",
        index: 12,
      },
      {
        internal_id: "components_dashboard_mro",
        id: "ComponentsdashboardMRO",
        lng: "en-US",
        index: 12,
      },
      {
        internal_id: "components_dashboard_mro",
        id: "TableaudeborddescomposantsCL",
        lng: "fr-FR",
        index: 12,
      },
      {
        internal_id: "components_dashboard_mro",
        id: "KomponentenArmaturenbrettMRO",
        lng: "de-DE",
        index: 12,
      },
      {
        internal_id: "components_dashboard_mro",
        id: "GehaltendashboardMPR",
        lng: "nl-NL",
        index: 12,
      },

      {
        internal_id: "components_trend_dim_mro",
        id: "ComponentsActualbyDIMdashboardMRO",
        lng: "en-GB",
        index: 13,
      },
      {
        internal_id: "components_trend_dim_mro",
        id: "ComponentsActualbyDIMdashboardMRO",
        lng: "en-US",
        index: 13,
      },
      {
        internal_id: "components_trend_dim_mro",
        id: "ComponentsActualbyDIMdashboardMRO",
        lng: "fr-FR",
        index: 13,
      },
      {
        internal_id: "components_trend_dim_mro",
        id: "ComponentsActualbyDIMdashboardMRO",
        lng: "de-DE",
        index: 13,
      },
      {
        internal_id: "components_trend_dim_mro",
        id: "ComponentenActueelperDILdashboardMRO",
        lng: "nl-NL",
        index: 13,
      },

      {
        internal_id: "components_dashboard__trend_mro",
        id: "ComponentsTrenddashboardMRO",
        lng: "en-GB",
        index: 14,
      },
      {
        internal_id: "components_dashboard__trend_mro",
        id: "ComponentsTrenddashboardMRO",
        lng: "en-US",
        index: 14,
      },
      {
        internal_id: "components_dashboard__trend_mro",
        id: "ComponentsTrenddashboardMRO",
        lng: "fr-FR",
        index: 14,
      },
      {
        internal_id: "components_dashboard__trend_mro",
        id: "ComponentsTrenddashboardMRO",
        lng: "de-DE",
        index: 14,
      },
      {
        internal_id: "components_dashboard__trend_mro",
        id: "ComponentenTrenddashboardMPR",
        lng: "nl-NL",
        index: 14,
      },

      {
        internal_id: "components_dashboard",
        id: "Componentsdashboard",
        lng: "en-GB",
        index: 15,
      },
      {
        internal_id: "components_dashboard",
        id: "Componentsdashboard",
        lng: "en-US",
        index: 15,
      },
      {
        internal_id: "components_dashboard",
        id: "Tableaudeborddescomposants",
        lng: "fr-FR",
        index: 15,
      },
      {
        internal_id: "components_dashboard",
        id: "KomponentenDashboard",
        lng: "de-DE",
        index: 15,
      },
      {
        internal_id: "components_dashboard",
        id: "Gehaltendashboard",
        lng: "nl-NL",
        index: 15,
      },

      {
        internal_id: "components_actual_dim",
        id: "ComponentsActualbyDIMdashboard",
        lng: "en-GB",
        index: 16,
      },
      {
        internal_id: "components_actual_dim",
        id: "ComponentsActualbyDIMdashboard",
        lng: "en-US",
        index: 16,
      },
      {
        internal_id: "components_actual_dim",
        id: "ComponentsActualbyDIMdashboard",
        lng: "fr-FR",
        index: 16,
      },
      {
        internal_id: "components_actual_dim",
        id: "ComponentsActualbyDIMdashboard",
        lng: "de-DE",
        index: 16,
      },
      {
        internal_id: "components_actual_dim",
        id: "ComponentenActueelperDILdashboard",
        lng: "nl-NL",
        index: 16,
      },

      {
        internal_id: "components_trend_dashboard",
        id: "ComponentsTrenddashboard",
        lng: "en-GB",
        index: 17,
      },
      {
        internal_id: "components_trend_dashboard",
        id: "ComponentsTrenddashboard",
        lng: "en-US",
        index: 17,
      },
      {
        internal_id: "components_trend_dashboard",
        id: "ComponentsTrenddashboard",
        lng: "fr-FR",
        index: 17,
      },
      {
        internal_id: "components_trend_dashboard",
        id: "ComponentsTrenddashboard",
        lng: "de-DE",
        index: 17,
      },
      {
        internal_id: "components_trend_dashboard",
        id: "ComponentenTrenddashboard",
        lng: "nl-NL",
        index: 17,
      },

      {
        internal_id: "milk_yield_trend_mro",
        id: "MilkyieldTrendMRO",
        lng: "en-GB",
        index: 18,
      },
      {
        internal_id: "milk_yield_trend_mro",
        id: "MilkyieldTrendMRO",
        lng: "en-US",
        index: 18,
      },
      {
        internal_id: "milk_yield_trend_mro",
        id: "TendancedurendementlaitierCL",
        lng: "fr-FR",
        index: 18,
      },
      {
        internal_id: "milk_yield_trend_mro",
        id: "EntwicklungderMilchleistungMRO",
        lng: "de-DE",
        index: 18,
      },
      {
        internal_id: "milk_yield_trend_mro",
        id: "MelkproductieTrendMPR",
        lng: "nl-NL",
        index: 18,
      },

      {
        internal_id: "spp_trend_mro",
        id: "SPPtrendMRO",
        lng: "en-GB",
        index: 19,
      },
      {
        internal_id: "spp_trend_mro",
        id: "SPPtrendMRO",
        lng: "en-US",
        index: 19,
      },
      {
        internal_id: "spp_trend_mro",
        id: "TendanceBSKduCL",
        lng: "fr-FR",
        index: 19,
      },
      {
        internal_id: "spp_trend_mro",
        id: "SPP-TrendMRO",
        lng: "de-DE",
        index: 19,
      },
      {
        internal_id: "spp_trend_mro",
        id: "BSKtrendMPR",
        lng: "nl-NL",
        index: 19,
      },

      {
        internal_id: "spp_actual_mro",
        id: "SPPactualMRO",
        lng: "en-GB",
        index: 20,
      },
      {
        internal_id: "spp_actual_mro",
        id: "SPPactualMRO",
        lng: "en-US",
        index: 20,
      },
      {
        internal_id: "spp_actual_mro",
        id: "BSKactuelduCL",
        lng: "fr-FR",
        index: 20,
      },
      {
        internal_id: "spp_actual_mro",
        id: "SPPaktuelleMRO",
        lng: "de-DE",
        index: 20,
      },
      {
        internal_id: "spp_actual_mro",
        id: "BSKactueelMPR",
        lng: "nl-NL",
        index: 20,
      },

      {
        internal_id: "spp_actual_by_date_mro",
        id: "SPPactualbyDIMdashboardMRO",
        lng: "en-GB",
        index: 21,
      },
      {
        internal_id: "spp_actual_by_date_mro",
        id: "SPPactualbyDIMdashboardMRO",
        lng: "en-US",
        index: 21,
      },
      {
        internal_id: "spp_actual_by_date_mro",
        id: "SPPactualbyDIMdashboardMRO",
        lng: "fr-FR",
        index: 21,
      },
      {
        internal_id: "spp_actual_by_date_mro",
        id: "SPPactualbyDIMdashboardMRO",
        lng: "de-DE",
        index: 21,
      },
      {
        internal_id: "spp_actual_by_date_mro",
        id: "BSKactueelperDILdashboardMPR",
        lng: "nl-NL",
        index: 21,
      },

      {
        internal_id: "milk_yield_actual_by_date_mro",
        id: "MilkyieldactualbyDIMdashboardMRO",
        lng: "en-GB",
        index: 22,
      },
      {
        internal_id: "milk_yield_actual_by_date_mro",
        id: "MilkyieldactualbyDIMdashboardMRO",
        lng: "en-US",
        index: 22,
      },
      {
        internal_id: "milk_yield_actual_by_date_mro",
        id: "MilkyieldactualbyDIMdashboardMRO",
        lng: "fr-FR",
        index: 22,
      },
      {
        internal_id: "milk_yield_actual_by_date_mro",
        id: "MilkyieldactualbyDIMdashboardMRO",
        lng: "de-DE",
        index: 22,
      },
      {
        internal_id: "milk_yield_actual_by_date_mro",
        id: "MelkproductieactueelperDILdashboardMPR",
        lng: "nl-NL",
        index: 22,
      },

      {
        internal_id: "milk_yield_actual_mro",
        id: "MilkyieldactualMRO",
        lng: "en-GB",
        index: 23,
      },
      {
        internal_id: "milk_yield_actual_mro",
        id: "MilkyieldactualMRO",
        lng: "en-US",
        index: 23,
      },
      {
        internal_id: "milk_yield_actual_mro",
        id: "RendementlaitierrelduCL",
        lng: "fr-FR",
        index: 23,
      },
      {
        internal_id: "milk_yield_actual_mro",
        id: "TatschlicheMilchleistungMRO",
        lng: "de-DE",
        index: 23,
      },
      {
        internal_id: "milk_yield_actual_mro",
        id: "MelkproductieactueelMPR",
        lng: "nl-NL",
        index: 23,
      },

      {
        internal_id: "days_pregnant",
        id: "Dayspregnantdashboard",
        lng: "en-GB",
        index: 24,
      },
      {
        internal_id: "days_pregnant",
        id: "Dayspregnantdashboard",
        lng: "en-US",
        index: 24,
      },
      {
        internal_id: "days_pregnant",
        id: "Dayspregnantdashboard",
        lng: "fr-FR",
        index: 24,
      },
      {
        internal_id: "days_pregnant",
        id: "Dayspregnantdashboard",
        lng: "de-DE",
        index: 24,
      },
      {
        internal_id: "days_pregnant",
        id: "Dagendrachtigdashboard",
        lng: "nl-NL",
        index: 24,
      },

      {
        internal_id: "concentrate_by_herd",
        id: "Concentratebyherd",
        lng: "en-GB",
        index: 25,
      },
      {
        internal_id: "concentrate_by_herd",
        id: "Concentratebyherd",
        lng: "en-US",
        index: 25,
      },
      {
        internal_id: "concentrate_by_herd",
        id: "Concentrationpartroupeau",
        lng: "fr-FR",
        index: 25,
      },
      {
        internal_id: "concentrate_by_herd",
        id: "KonzentrierenSiesichnachHerden",
        lng: "de-DE",
        index: 25,
      },
      {
        internal_id: "concentrate_by_herd",
        id: "Krachtvoerperbedrijf",
        lng: "nl-NL",
        index: 25,
      },

      {
        internal_id: "cow_list",
        id: "Cowlist",
        lng: "en-GB",
        index: 26,
      },
      {
        internal_id: "cow_list",
        id: "Cowlist",
        lng: "en-US",
        index: 26,
      },
      {
        internal_id: "cow_list",
        id: "Listedesvaches",
        lng: "fr-FR",
        index: 26,
      },
      {
        internal_id: "cow_list",
        id: "ListederKhe",
        lng: "de-DE",
        index: 26,
      },
      {
        internal_id: "cow_list",
        id: "Lijstkoeien",
        lng: "nl-NL",
        index: 26,
      },

      {
        internal_id: "concentrate_per_cow_trend",
        id: "ConcentratepercowTrend",
        lng: "en-GB",
        index: 27,
      },
      {
        internal_id: "concentrate_per_cow_trend",
        id: "ConcentratepercowTrend",
        lng: "en-US",
        index: 27,
      },
      {
        internal_id: "concentrate_per_cow_trend",
        id: "Tendanceconcentrparvache",
        lng: "fr-FR",
        index: 27,
      },
      {
        internal_id: "concentrate_per_cow_trend",
        id: "KonzentratproKuhTrend",
        lng: "de-DE",
        index: 27,
      },
      {
        internal_id: "concentrate_per_cow_trend",
        id: "KrachtvoerperkoeTrend",
        lng: "nl-NL",
        index: 27,
      },

      {
        internal_id: "concentrate_per_cow_actual",
        id: "ConcentratepercowActual",
        lng: "en-GB",
        index: 28,
      },
      {
        internal_id: "concentrate_per_cow_actual",
        id: "ConcentratepercowActual",
        lng: "en-US",
        index: 28,
      },
      {
        internal_id: "concentrate_per_cow_actual",
        id: "Concentrparvacherel",
        lng: "fr-FR",
        index: 28,
      },
      {
        internal_id: "concentrate_per_cow_actual",
        id: "KonzentratproKuhTatschlich",
        lng: "de-DE",
        index: 28,
      },
      {
        internal_id: "concentrate_per_cow_actual",
        id: "KrachtvoerperkoeActueel",
        lng: "nl-NL",
        index: 28,
      },

      {
        internal_id: "concentrate_per_cow_actual_trend",
        id: "ConcentratepercowactualbyDIMdashboard",
        lng: "en-GB",
        index: 29,
      },
      {
        internal_id: "concentrate_per_cow_actual_trend",
        id: "ConcentratepercowactualbyDIMdashboard",
        lng: "en-US",
        index: 29,
      },
      {
        internal_id: "concentrate_per_cow_actual_trend",
        id: "ConcentratepercowactualbyDIMdashboard",
        lng: "fr-FR",
        index: 29,
      },
      {
        internal_id: "concentrate_per_cow_actual_trend",
        id: "ConcentratepercowactualbyDIMdashboard",
        lng: "de-DE",
        index: 29,
      },
      {
        internal_id: "concentrate_per_cow_actual_trend",
        id: "KrachtvoerperkoeActueelperDILdashboard",
        lng: "nl-NL",
        index: 29,
      },

      {
        internal_id: "concentrate_per_100kg_trend",
        id: "Concentrateper100kgMilkTrend",
        lng: "en-GB",
        index: 30,
      },
      {
        internal_id: "concentrate_per_100kg_trend",
        id: "Concentrateper100kgMilkTrend",
        lng: "en-US",
        index: 30,
      },
      {
        internal_id: "concentrate_per_100kg_trend",
        id: "Tendanceconcentrspar100kgdelait",
        lng: "fr-FR",
        index: 30,
      },
      {
        internal_id: "concentrate_per_100kg_trend",
        id: "Konzentratpro100kgMilchTrend",
        lng: "de-DE",
        index: 30,
      },
      {
        internal_id: "concentrate_per_100kg_trend",
        id: "Trendkrachtvoerper100kgmelk",
        lng: "nl-NL",
        index: 30,
      },

      {
        internal_id: "concentrate_per_100kg_actual",
        id: "Concentrateper100kgMilkactual",
        lng: "en-GB",
        index: 31,
      },
      {
        internal_id: "concentrate_per_100kg_actual",
        id: "Concentrateper100kgMilkactual",
        lng: "en-US",
        index: 31,
      },
      {
        internal_id: "concentrate_per_100kg_actual",
        id: "Concentrpar100kgdelaiteffectif",
        lng: "fr-FR",
        index: 31,
      },
      {
        internal_id: "concentrate_per_100kg_actual",
        id: "Konzentratpro100kgMilchtatschlich",
        lng: "de-DE",
        index: 31,
      },
      {
        internal_id: "concentrate_per_100kg_actual",
        id: "Krachtvoerper100kgMelkActueel",
        lng: "nl-NL",
        index: 31,
      },

      {
        internal_id: "concentrate_per_100kg_actual_trend",
        id: "Concentrateper100kgMilkactualbyDIMdashboard",
        lng: "en-GB",
        index: 32,
      },
      {
        internal_id: "concentrate_per_100kg_actual_trend",
        id: "Concentrateper100kgMilkactualbyDIMdashboard",
        lng: "en-US",
        index: 32,
      },
      {
        internal_id: "concentrate_per_100kg_actual_trend",
        id: "Concentrateper100kgMilkactualbyDIMdashboard",
        lng: "fr-FR",
        index: 32,
      },
      {
        internal_id: "concentrate_per_100kg_actual_trend",
        id: "Concentrateper100kgMilkactualbyDIMdashboard",
        lng: "de-DE",
        index: 32,
      },
      {
        internal_id: "concentrate_per_100kg_actual_trend",
        id: "Krachtvoerper100kgMelkActueelperDILdashboard",
        lng: "nl-NL",
        index: 32,
      },

      {
        internal_id: "leftovers_trend",
        id: "Leftoverstrend",
        lng: "en-GB",
        index: 33,
        actual: false,
      },
      {
        internal_id: "leftovers_trend",
        id: "Leftoverstrend",
        lng: "en-US",
        index: 33,
        actual: false,
      },
      {
        internal_id: "leftovers_trend",
        id: "Tendancedesrestes",
        lng: "fr-FR",
        index: 33,
        actual: false,
      },
      {
        internal_id: "leftovers_trend",
        id: "EntwicklungderReste",
        lng: "de-DE",
        index: 33,
        actual: false,
      },
      {
        internal_id: "leftovers_trend",
        id: "Restvoertrend",
        lng: "nl-NL",
        index: 33,
        actual: false,
      },

      {
        internal_id: "leftovers_actual",
        id: "Leftoversactual",
        lng: "en-GB",
        index: 34,
        actual: true,
      },
      {
        internal_id: "leftovers_actual",
        id: "Leftoversactual",
        lng: "en-US",
        index: 34,
        actual: true,
      },
      {
        internal_id: "leftovers_actual",
        id: "Restesactuels",
        lng: "fr-FR",
        index: 34,
        actual: true,
      },
      {
        internal_id: "leftovers_actual",
        id: "tatschlicheReste",
        lng: "de-DE",
        index: 34,
        actual: true,
      },
      {
        internal_id: "leftovers_actual",
        id: "Restvoeractueel",
        lng: "nl-NL",
        index: 34,
        actual: true,
      },

      {
        internal_id: "leftovers_actual_by_date_dashboard",
        id: "LeftoversactualbyDIMdashboard",
        lng: "en-GB",
        index: 35,
        actual: true,
      },
      {
        internal_id: "leftovers_actual_by_date_dashboard",
        id: "LeftoversactualbyDIMdashboard",
        lng: "en-US",
        index: 35,
        actual: true,
      },
      {
        internal_id: "leftovers_actual_by_date_dashboard",
        id: "Restesactuelstendance",
        lng: "fr-FR",
        index: 35,
        actual: true,
      },
      {
        internal_id: "leftovers_actual_by_date_dashboard",
        id: "LeftoversactualbyDIMdashboard",
        lng: "de-DE",
        index: 35,
        actual: true,
      },
      {
        internal_id: "leftovers_actual_by_date_dashboard",
        id: "RestvoerActueelperDILdashboard",
        lng: "nl-NL",
        index: 35,
        actual: true,
      },

      {
        internal_id: "leftovers_by_milking_speed_actual",
        id: "LeftoversbymilkingspeedActual",
        lng: "en-GB",
        index: 36,
        actual: true,
      },
      {
        internal_id: "leftovers_by_milking_speed_actual",
        id: "LeftoversbymilkingspeedActual",
        lng: "en-US",
        index: 36,
        actual: true,
      },
      {
        internal_id: "leftovers_by_milking_speed_actual",
        id: "Restesenfonctiondelavitessedetraite",
        lng: "fr-FR",
        index: 36,
        actual: true,
      },
      {
        internal_id: "leftovers_by_milking_speed_actual",
        id: "RestenachMelkgeschwindigkeitAktuell",
        lng: "de-DE",
        index: 36,
        actual: true,
      },
      {
        internal_id: "leftovers_by_milking_speed_actual",
        id: "LeftoversbymilkingspeedActual",
        lng: "nl-NL",
        index: 36,
        actual: true,
      },

      {
        internal_id: "concentrate_intake_trend",
        id: "ConcentrateIntakeTrend",
        lng: "en-GB",
        index: 37,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_trend",
        id: "ConcentrateIntakeTrend",
        lng: "en-US",
        index: 37,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_trend",
        id: "Tendancedelaconsommationdeconcentrs",
        lng: "fr-FR",
        index: 37,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_trend",
        id: "TrendbeiderAufnahmevonKonzentrat",
        lng: "de-DE",
        index: 37,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_trend",
        id: "KrachtvoeropnameTrend",
        lng: "nl-NL",
        index: 37,
        actual: true,
      },

      {
        internal_id: "concentrate_intake_by_conc_trend",
        id: "ConcentrateIntakebyconcTrend",
        lng: "en-GB",
        index: 38,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_conc_trend",
        id: "ConcentrateIntakebyconcTrend",
        lng: "en-US",
        index: 38,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_conc_trend",
        id: "Consommationdeconcentrsparlatendancedesconcentrs",
        lng: "fr-FR",
        index: 38,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_conc_trend",
        id: "KonzentrateinnahmenachKonzentrationstrend",
        lng: "de-DE",
        index: 38,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_conc_trend",
        id: "KrachtvoeropnamevolgenskrachtvoerTrend",
        lng: "nl-NL",
        index: 38,
        actual: true,
      },

      {
        internal_id: "concentrate_intake_by_cow_actual",
        id: "ConcentrateintakepercowActual",
        lng: "en-GB",
        index: 39,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual",
        id: "ConcentrateintakepercowActual",
        lng: "en-US",
        index: 39,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual",
        id: "ConcentrateintakepercowActual",
        lng: "fr-FR",
        index: 39,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual",
        id: "ConcentrateintakepercowActual",
        lng: "de-DE",
        index: 39,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual",
        id: "KrachtvoeropnameperkoeActueel",
        lng: "nl-NL",
        index: 39,
        actual: true,
      },

      {
        internal_id: "concentrate_intake_by_cow_actual_dim_",
        id: "ConcentrateintakepercowactualbyDIMdashboard",
        lng: "en-GB",
        index: 40,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual_dim_",
        id: "ConcentrateintakepercowactualbyDIMdashboard",
        lng: "en-US",
        index: 40,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual_dim_",
        id: "ConcentrateintakepercowactualbyDIMdashboard",
        lng: "fr-FR",
        index: 40,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual_dim_",
        id: "ConcentrateintakepercowactualbyDIMdashboard",
        lng: "de-DE",
        index: 40,
        actual: true,
      },
      {
        internal_id: "concentrate_intake_by_cow_actual_dim_",
        id: "KrachtvoeropnameperkoeActueelperDIL",
        lng: "nl-NL",
        index: 40,
        actual: true,
      },

      {
        internal_id: "milkings_actual",
        id: "Milkings",
        lng: "en-GB",
        index: 41,
        actual: true,
      },
      {
        internal_id: "milkings_actual",
        id: "Milkings",
        lng: "en-US",
        index: 41,
        actual: true,
      },
      {
        internal_id: "milkings_actual",
        id: "Traites",
        lng: "fr-FR",
        index: 41,
        actual: true,
      },
      {
        internal_id: "milkings_actual",
        id: "Melkvorgnge",
        lng: "de-DE",
        index: 41,
        actual: true,
      },
      {
        internal_id: "milkings_actual",
        id: "Melkingen",
        lng: "nl-NL",
        index: 41,
        actual: true,
      },

      {
        internal_id: "milkings_actual_dim",
        id: "MilkingsactualbyDIMdashboard",
        lng: "en-GB",
        index: 42,
        actual: true,
      },
      {
        internal_id: "milkings_actual_dim",
        id: "MilkingsactualbyDIMdashboard",
        lng: "en-US",
        index: 42,
        actual: true,
      },
      {
        internal_id: "milkings_actual_dim",
        id: "MilkingsactualbyDIMdashboard",
        lng: "fr-FR",
        index: 42,
        actual: true,
      },
      {
        internal_id: "milkings_actual_dim",
        id: "MilkingsactualbyDIMdashboard",
        lng: "de-DE",
        index: 42,
        actual: true,
      },
      {
        internal_id: "milkings_actual_dim",
        id: "MelkingenActueelperDILdashboard",
        lng: "nl-NL",
        index: 42,
        actual: true,
      },

      {
        internal_id: "milkings_trend",
        id: "Milkingstrenddashboard",
        lng: "en-GB",
        index: 43,
        actual: true,
      },
      {
        internal_id: "milkings_trend",
        id: "Milkingstrenddashboard",
        lng: "en-US",
        index: 43,
        actual: true,
      },
      {
        internal_id: "milkings_trend",
        id: "Milkingstrenddashboard",
        lng: "fr-FR",
        index: 43,
        actual: true,
      },
      {
        internal_id: "milkings_trend",
        id: "Milkingstrenddashboard",
        lng: "de-DE",
        index: 43,
        actual: true,
      },
      {
        internal_id: "milkings_trend",
        id: "MelkingenTrenddashboard",
        lng: "nl-NL",
        index: 43,
        actual: true,
      },

      {
        internal_id: "refusals",
        id: "Refusals",
        lng: "en-GB",
        index: 44,
        actual: true,
      },
      {
        internal_id: "refusals",
        id: "Refusals",
        lng: "en-US",
        index: 44,
        actual: true,
      },
      {
        internal_id: "refusals",
        id: "Refus",
        lng: "fr-FR",
        index: 44,
        actual: true,
      },
      {
        internal_id: "refusals",
        id: "Veweigerungen",
        lng: "de-DE",
        index: 44,
        actual: true,
      },
      {
        internal_id: "refusals",
        id: "Weigeringen",
        lng: "nl-NL",
        index: 44,
        actual: true,
      },

      {
        internal_id: "refusals_actual_dim",
        id: "RefusalsActualbyDIMdashboard",
        lng: "en-GB",
        index: 45,
        actual: true,
      },
      {
        internal_id: "refusals_actual_dim",
        id: "RefusalsActualbyDIMdashboard",
        lng: "en-US",
        index: 45,
        actual: true,
      },
      {
        internal_id: "refusals_actual_dim",
        id: "RefusalsActualbyDIMdashboard",
        lng: "fr-FR",
        index: 45,
        actual: true,
      },
      {
        internal_id: "refusals_actual_dim",
        id: "RefusalsActualbyDIMdashboard",
        lng: "de-DE",
        index: 45,
        actual: true,
      },
      {
        internal_id: "refusals_actual_dim",
        id: "WeigeringenActueelperDILdashboard",
        lng: "nl-NL",
        index: 45,
        actual: true,
      },

      {
        internal_id: "refusals_trend",
        id: "Refusalstrenddashboard",
        lng: "en-GB",
        index: 46,
        actual: true,
      },
      {
        internal_id: "refusals_trend",
        id: "Refusalstrenddashboard",
        lng: "en-US",
        index: 46,
        actual: true,
      },
      {
        internal_id: "refusals_trend",
        id: "Refusalstrenddashboard",
        lng: "fr-FR",
        index: 46,
        actual: true,
      },
      {
        internal_id: "refusals_trend",
        id: "Refusalstrenddashboard",
        lng: "de-DE",
        index: 46,
        actual: true,
      },
      {
        internal_id: "refusals_trend",
        id: "WeigeringenTrenddashboard",
        lng: "nl-NL",
        index: 46,
        actual: true,
      },

      {
        internal_id: "failures",
        id: "Failures",
        lng: "en-GB",
        index: 47,
        actual: true,
      },
      {
        internal_id: "failures",
        id: "Failures",
        lng: "en-US",
        index: 47,
        actual: true,
      },
      {
        internal_id: "failures",
        id: "checs",
        lng: "fr-FR",
        index: 47,
        actual: true,
      },
      {
        internal_id: "failures",
        id: "Ausflle",
        lng: "de-DE",
        index: 47,
        actual: true,
      },
      {
        internal_id: "failures",
        id: "Mislukkingen",
        lng: "nl-NL",
        index: 47,
        actual: true,
      },

      {
        internal_id: "failures_actual_dim",
        id: "FailuresActualbyDIMdashboard",
        lng: "en-GB",
        index: 48,
        actual: true,
      },
      {
        internal_id: "failures_actual_dim",
        id: "FailuresActualbyDIMdashboard",
        lng: "en-US",
        index: 48,
        actual: true,
      },
      {
        internal_id: "failures_actual_dim",
        id: "FailuresActualbyDIMdashboard",
        lng: "fr-FR",
        index: 48,
        actual: true,
      },
      {
        internal_id: "failures_actual_dim",
        id: "FailuresActualbyDIMdashboard",
        lng: "de-DE",
        index: 48,
        actual: true,
      },
      {
        internal_id: "failures_actual_dim",
        id: "MislukkingenActueelperDILdashboard",
        lng: "nl-NL",
        index: 48,
        actual: true,
      },

      {
        internal_id: "failures_trend",
        id: "Failurestrenddashboard",
        lng: "en-GB",
        index: 49,
        actual: true,
      },
      {
        internal_id: "failures_trend",
        id: "Failurestrenddashboard",
        lng: "en-US",
        index: 49,
        actual: true,
      },
      {
        internal_id: "failures_trend",
        id: "Failurestrenddashboard",
        lng: "fr-FR",
        index: 49,
        actual: true,
      },
      {
        internal_id: "failures_trend",
        id: "Failurestrenddashboard",
        lng: "de-DE",
        index: 49,
        actual: true,
      },
      {
        internal_id: "failures_trend",
        id: "MislukkingenTrenddashboard",
        lng: "nl-NL",
        index: 49,
        actual: true,
      },

      {
        internal_id: "milkings_hour",
        id: "Milkingsbyhour",
        lng: "en-GB",
        index: 50,
        actual: true,
      },
      {
        internal_id: "milkings_hour",
        id: "Milkingsbyhour",
        lng: "en-US",
        index: 50,
        actual: true,
      },
      {
        internal_id: "milkings_hour",
        id: "Traiteparheure",
        lng: "fr-FR",
        index: 50,
        actual: true,
      },
      {
        internal_id: "milkings_hour",
        id: "MelkungenproStunde",
        lng: "de-DE",
        index: 50,
        actual: true,
      },
      {
        internal_id: "milkings_hour",
        id: "Melkingenperuur",
        lng: "nl-NL",
        index: 50,
        actual: true,
      },

      {
        internal_id: "robot_efficiency",
        id: "RobotEfficiency",
        lng: "en-GB",
        index: 51,
        actual: true,
      },
      {
        internal_id: "robot_efficiency",
        id: "RobotEfficiency",
        lng: "en-US",
        index: 51,
        actual: true,
      },
      {
        internal_id: "robot_efficiency",
        id: "Efficacitdurobot",
        lng: "fr-FR",
        index: 51,
        actual: true,
      },
      {
        internal_id: "robot_efficiency",
        id: "Roboter-Effizienz",
        lng: "de-DE",
        index: 51,
        actual: true,
      },
      {
        internal_id: "robot_efficiency",
        id: "Robotefficintie",
        lng: "nl-NL",
        index: 51,
        actual: true,
      },

      {
        internal_id: "cowlist_robot",
        id: "Cowlist-robot",
        lng: "en-GB",
        index: 52,
        actual: true,
      },
      {
        internal_id: "cowlist_robot",
        id: "Cowlist-robot",
        lng: "en-US",
        index: 52,
        actual: true,
      },
      {
        internal_id: "cowlist_robot",
        id: "Listedesvaches-robot",
        lng: "fr-FR",
        index: 52,
        actual: true,
      },
      {
        internal_id: "cowlist_robot",
        id: "Kuhliste-Roboter",
        lng: "de-DE",
        index: 52,
        actual: true,
      },
      {
        internal_id: "cowlist_robot",
        id: "Koeienlijst-robot",
        lng: "nl-NL",
        index: 52,
        actual: true,
      },

      {
        internal_id: "milking_speed",
        id: "MilkingspeedbyDIM",
        lng: "en-GB",
        index: 53,
        actual: true,
      },
      {
        internal_id: "milking_speed",
        id: "MilkingspeedbyDIM",
        lng: "en-US",
        index: 53,
        actual: true,
      },
      {
        internal_id: "milking_speed",
        id: "VitessedetraiteparDIM",
        lng: "fr-FR",
        index: 53,
        actual: true,
      },
      {
        internal_id: "milking_speed",
        id: "Melkgeschwindigkeitnachtim",
        lng: "de-DE",
        index: 53,
        actual: true,
      },
      {
        internal_id: "milking_speed",
        id: "MelksnelheidvolgensDIM",
        lng: "nl-NL",
        index: 53,
        actual: true,
      },

      {
        internal_id: "milking_speed_trend",
        id: "Milkingspeedtrenddashboard",
        lng: "en-GB",
        index: 54,
        actual: true,
      },
      {
        internal_id: "milking_speed_trend",
        id: "Milkingspeedtrenddashboard",
        lng: "en-US",
        index: 54,
        actual: true,
      },
      {
        internal_id: "milking_speed_trend",
        id: "Milkingspeedtrenddashboard",
        lng: "fr-FR",
        index: 54,
        actual: true,
      },
      {
        internal_id: "milking_speed_trend",
        id: "Milkingspeedtrenddashboard",
        lng: "de-DE",
        index: 54,
        actual: true,
      },
      {
        internal_id: "milking_speed_trend",
        id: "MelksnelheidTrenddashboard",
        lng: "nl-NL",
        index: 54,
        actual: true,
      },

      {
        internal_id: "milking_speed_actual_dim",
        id: "MilkingspeedActualbyDIMdashboard",
        lng: "en-GB",
        index: 55,
        actual: true,
      },
      {
        internal_id: "milking_speed_actual_dim",
        id: "MilkingspeedActualbyDIMdashboard",
        lng: "en-US",
        index: 55,
        actual: true,
      },
      {
        internal_id: "milking_speed_actual_dim",
        id: "MilkingspeedActualbyDIMdashboard",
        lng: "fr-FR",
        index: 55,
        actual: true,
      },
      {
        internal_id: "milking_speed_actual_dim",
        id: "MilkingspeedActualbyDIMdashboard",
        lng: "de-DE",
        index: 55,
        actual: true,
      },
      {
        internal_id: "milking_speed_actual_dim",
        id: "MelksnelheidActueelperDILdashboard",
        lng: "nl-NL",
        index: 55,
        actual: true,
      },

      {
        internal_id: "milk_by_hour_cow",
        id: "Milkbyhourpercow",
        lng: "en-GB",
        index: 56,
        actual: true,
      },
      {
        internal_id: "milk_by_hour_cow",
        id: "Milkbyhourpercow",
        lng: "en-US",
        index: 56,
        actual: true,
      },
      {
        internal_id: "milk_by_hour_cow",
        id: "Laitparheureetparvache",
        lng: "fr-FR",
        index: 56,
        actual: true,
      },
      {
        internal_id: "milk_by_hour_cow",
        id: "MilchproStundeundKuh",
        lng: "de-DE",
        index: 56,
        actual: true,
      },
      {
        internal_id: "milk_by_hour_cow",
        id: "Melkperuurperkoe",
        lng: "nl-NL",
        index: 56,
        actual: true,
      },

      {
        internal_id: "milk_milking_minutes_actual",
        id: "MilkbymilkingminutesActual",
        lng: "en-GB",
        index: 57,
        actual: true,
      },
      {
        internal_id: "milk_milking_minutes_actual",
        id: "MilkbymilkingminutesActual",
        lng: "en-US",
        index: 57,
        actual: true,
      },
      {
        internal_id: "milk_milking_minutes_actual",
        id: "Laitparminutes",
        lng: "fr-FR",
        index: 57,
        actual: true,
      },
      {
        internal_id: "milk_milking_minutes_actual",
        id: "MilchnachMelkminutenTatschliche",
        lng: "de-DE",
        index: 57,
        actual: true,
      },
      {
        internal_id: "milk_milking_minutes_actual",
        id: "MelkperminutenmelkenActueel",
        lng: "nl-NL",
        index: 57,
        actual: true,
      },

      {
        internal_id: "conductivity_dim",
        id: "ConductivitybyDIMdashboard",
        lng: "en-GB",
        index: 58,
        actual: true,
      },
      {
        internal_id: "conductivity_dim",
        id: "ConductivitybyDIMdashboard",
        lng: "en-US",
        index: 58,
        actual: true,
      },
      {
        internal_id: "conductivity_dim",
        id: "ConductivitybyDIMdashboard",
        lng: "fr-FR",
        index: 58,
        actual: true,
      },
      {
        internal_id: "conductivity_dim",
        id: "MilchnachMelkminutenTatschliche",
        lng: "de-DE",
        index: 58,
        actual: true,
      },
      {
        internal_id: "conductivity_dim",
        id: "GeleidbaarheidvolgensDILdashboard",
        lng: "nl-NL",
        index: 58,
        actual: true,
      },
    ],

    development: {
      work_locally: false,
      dashboards: [],
      reports: [],
    },
  });
})();

(function () {
  "use strict";
  angular.module("My").factory("aDashboardsService", aDashboardsService);
  /** @ngInject */
  function aDashboardsService(
    $filter,
    A_DASH_CONSTANTS,
    $q,
    $rootScope,
    $cookies,
    $timeout,
    Upload,
    APP_CONSTANTS,
    $http
  ) {
    var i18nFilter = $filter("i18n");
    var dashboard_list = angular.copy(A_DASH_CONSTANTS.dashboard_id_lng_list);
    var filters_lng_list = angular.copy(A_DASH_CONSTANTS.filters_lng_list);
    var dashboards_list = angular.copy(A_DASH_CONSTANTS.dashboards);
    var dashboard_id_list = angular.copy(A_DASH_CONSTANTS.dashboard_id_list);

    return {
      getCurrentLngId: getCurrentLngId,
      getCurrentLngFilter: getCurrentLngFilter,
      getFilterListByDashboardId: getFilterListByDashboardId,
      getReportDashboards: getReportDashboards,
      changeFilterNameLanguage: changeFilterNameLanguage,
      getDashboardIdByName: getDashboardIdByName,
      getIsActual: getIsActual,
      getIsMRO: getIsMRO,
      getIsPer100: getIsPer100,
      getIsActualByDate: getIsActualByDate,
      sendErrorInfo: sendErrorInfo,
      getDashboardCategory: getDashboardCategory,
      getDashboardLinks: getDashboardLinks,
      getShowBackButton: getShowBackButton,
      orders: [],
      milkTrendActiveType: undefined,
      milkTrendSourceType: undefined,
      concentrateActiveType: undefined,
      concentrateSourceType: undefined,
      milkingsActiveType: undefined,
      dashboardCategory: undefined,
      start_date: null,
      end_date: null,
      current_dashboard: undefined,
    };

    function getCurrentLngId(id, lng) {
      var internal_id;
      for (var i = 0; i < dashboard_list.length; i++) {
        if (dashboard_list[i].id == id) {
          internal_id = dashboard_list[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboard_list.length; i++) {
          if (
            internal_id == dashboard_list[i].internal_id &&
            lng == dashboard_list[i].lng
          ) {
            translated_id = dashboard_list[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function getCurrentLngFilter(filter, lng) {
      var filter_string = angular.copy(filter);
      var splitted = filter_string.split("&");

      var sortByFilterString;
      var groupByFilterString;
      var groupByPDFilterString;
      var parityFilterString;
      var selectKPIFilterString;
      var dateFilterString;
      var kgBasisFilterString;
      var feedNameFilterString;
      var xAxisFilterString;
      var yAxisFilterString;
      var animalEarTagString;
      var animalEarTagStringV2;
      var conductivityTypeString;

      splitted.forEach(function (_split) {
        if (_split.indexOf("Sort by=") != -1) {
          sortByFilterString = _split;
        }

        if (
          _split.indexOf("Group by=") != -1 ||
          _split.indexOf("Groupé par==") != -1 ||
          _split.indexOf("Gruppierungen nach=") != -1 ||
          _split.indexOf("Grupa według=") != -1 ||
          _split.indexOf("Groepeer op=") != -1
        ) {
          groupByFilterString = _split;
        }

        if (_split.indexOf("Group by DIM/Parity=") != -1) {
          groupByPDFilterString = _split;
        }

        if (
          _split.indexOf("Parity Filter=") != -1 ||
          _split.indexOf("Parity filter=") != -1 ||
          _split.indexOf("Pariteit filter=") != -1 ||
          _split.indexOf("Filtre de lactation=") != -1 ||
          _split.indexOf("Paritätsfilter=") != -1
        ) {
          parityFilterString = _split;
        }

        if (
          _split.indexOf("Select KPI=") != -1 ||
          _split.indexOf("Selecteer KPI=") != -1 ||
          _split.indexOf("Wybierz KPI=") != -1
        ) {
          selectKPIFilterString = _split;
        }

        if (
          _split.indexOf("Date=") != -1 ||
          _split.indexOf("Datum=") != -1 ||
          _split.indexOf("Data=") != -1
        ) {
          dateFilterString = _split;
        }

        if (_split.indexOf("Kg in basis=") != -1) {
          kgBasisFilterString = _split;
        }

        if (
          _split.indexOf("Feed name=") != -1 ||
          _split.indexOf("Name des Futters=") != -1 ||
          _split.indexOf("Nom de l'aliment=") != -1 ||
          _split.indexOf("Voer naam=") != -1
        ) {
          feedNameFilterString = _split;
        }

        if (
          _split.indexOf("X-Axis=") != -1 ||
          _split.indexOf("X-Achse=") != -1 ||
          _split.indexOf("Axe X=") != -1 ||
          _split.indexOf("X-as=") != -1
        ) {
          xAxisFilterString = _split;
        }

        if (
          _split.indexOf("Y-Axis=") != -1 ||
          _split.indexOf("Y-Achse=") != -1 ||
          _split.indexOf("Axe Y=") != -1 ||
          _split.indexOf("Y-as=") != -1
        ) {
          yAxisFilterString = _split;
        }

        if (
          _split.indexOf("Animal ear tag=") != -1 ||
          _split.indexOf("Ohrmarke des Tieres=") != -1 ||
          _split.indexOf("Dier oornummer=") != -1 ||
          _split.indexOf("Kolczyk dla zwierzęcia=") != -1 ||
          _split.indexOf("Marque auriculaire de l'animal=") != -1
        ) {
          animalEarTagString = _split;
        }

        if (_split.indexOf("AnimalEartag=") != -1) {
          animalEarTagStringV2 = _split;
        }

        if (_split.indexOf("Select type of conductivity=") != -1) {
          conductivityTypeString = _split;
        }
      });

      var sortBy;
      var groupBy;
      var groupByValue;
      var groupByValueTranslateString;
      var groupByPD;
      var groupByPDValue;
      var groupByPDValueTranslateString;
      var parity;
      var selectKPI;
      var selectKPIValue;
      var selectKPIValueTranslateString;
      var date;
      var kgBasis;
      var feedName;
      var XAxis;
      var YAxis;
      var XaxisValue;
      var XAxisValueTranslateString;
      var YaxisValue;
      var YAxisValueTranslateString;
      var AnimalEarTag;
      var AnimalEarTagV2;
      var conductivityType;
      var conductivityValue;
      var conductivityValueTranslateString;

      filters_lng_list.forEach(function (f_l_l_item) {
        if (f_l_l_item.internal_id == "sort_by" && f_l_l_item.lng == lng) {
          sortBy = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "group_by" && f_l_l_item.lng == lng) {
          groupBy = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "group_by_value" &&
          f_l_l_item.lng == lng
        ) {
          if (
            groupByFilterString &&
            groupByFilterString.indexOf(f_l_l_item.name) != -1
          ) {
            groupByValue = f_l_l_item.name;
            groupByValueTranslateString = f_l_l_item.translate_string;
          }
        }

        if (f_l_l_item.internal_id == "group_by_p_d" && f_l_l_item.lng == lng) {
          groupByPD = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "group_by_value" &&
          f_l_l_item.lng == lng
        ) {
          if (
            groupByPDFilterString &&
            groupByPDFilterString.indexOf(f_l_l_item.name) != -1
          ) {
            groupByPDValue = f_l_l_item.name;
            groupByPDValueTranslateString = f_l_l_item.translate_string;
          }
        }

        if (
          f_l_l_item.internal_id == "parity_filter" &&
          f_l_l_item.lng == lng
        ) {
          parity = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "select_kpi" && f_l_l_item.lng == lng) {
          selectKPI = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "select_kpi_value" &&
          f_l_l_item.lng == lng
        ) {
          if (
            selectKPIFilterString &&
            selectKPIFilterString.indexOf(f_l_l_item.name) != -1
          ) {
            selectKPIValue = f_l_l_item.name;
            selectKPIValueTranslateString = f_l_l_item.translate_string;
          }
        }

        if (f_l_l_item.internal_id == "date" && f_l_l_item.lng == lng) {
          date = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "kg_basis" && f_l_l_item.lng == lng) {
          kgBasis = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "feed_name" && f_l_l_item.lng == lng) {
          feedName = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "x_axis" && f_l_l_item.lng == lng) {
          XAxis = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "y_axis" && f_l_l_item.lng == lng) {
          YAxis = f_l_l_item.name;
        }

        if (f_l_l_item.internal_id == "axis_value" && f_l_l_item.lng == lng) {
          if (
            xAxisFilterString &&
            xAxisFilterString.indexOf(f_l_l_item.name) != -1
          ) {
            XaxisValue = f_l_l_item.name;
            XAxisValueTranslateString = f_l_l_item.translate_string;
          }

          if (
            yAxisFilterString &&
            yAxisFilterString.indexOf(f_l_l_item.name) != -1
          ) {
            YaxisValue = f_l_l_item.name;
            YAxisValueTranslateString = f_l_l_item.translate_string;
          }
        }

        if (
          f_l_l_item.internal_id == "animal_ear_tag" &&
          f_l_l_item.lng == lng
        ) {
          AnimalEarTag = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "animal_ear_tag_v2" &&
          f_l_l_item.lng == lng
        ) {
          AnimalEarTagV2 = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "conductivity_type" &&
          f_l_l_item.lng == lng
        ) {
          conductivityType = f_l_l_item.name;
        }

        if (
          f_l_l_item.internal_id == "conductivity_type_value" &&
          f_l_l_item.lng == lng
        ) {
          if (
            conductivityTypeString &&
            conductivityTypeString.indexOf(f_l_l_item.name) != -1
          ) {
            conductivityValue = f_l_l_item.name;
            conductivityValueTranslateString = f_l_l_item.translate_string;
          }
        }
      });

      if (sortBy && sortByFilterString) {
        sortByFilterString = this.changeFilterNameLanguage(
          sortByFilterString,
          sortBy,
          i18nFilter("_dashboard_name_parameter_sort_by_")
        );
      }

      if (groupBy && groupByFilterString) {
        groupByFilterString = this.changeFilterNameLanguage(
          groupByFilterString,
          groupBy,
          i18nFilter("_dashboard_name_parameter_group_by_")
        );
      }

      if (groupByValue && groupByFilterString && groupByValueTranslateString) {
        groupByFilterString = this.changeFilterNameLanguage(
          groupByFilterString,
          groupByValue,
          i18nFilter(groupByValueTranslateString)
        );
      }

      if (groupByPD && groupByPDFilterString) {
        groupByPDFilterString = this.changeFilterNameLanguage(
          groupByPDFilterString,
          groupByPD,
          i18nFilter("_dashboard_name_parameter_group_by_p_d_")
        );
      }

      if (
        groupByPDValue &&
        groupByPDFilterString &&
        groupByPDValueTranslateString
      ) {
        var GBPFilterString = groupByPDFilterString.split("=");
        if (GBPFilterString.length == 2) {
          var p_1 = GBPFilterString[0];
          var p_2 = GBPFilterString[1];

          p_2 = this.changeFilterNameLanguage(
            p_2,
            groupByPDValue,
            i18nFilter(groupByPDValueTranslateString)
          );

          groupByPDFilterString = p_1 + "=" + p_2;
        }
      }

      if (parity && parityFilterString) {
        parityFilterString = this.changeFilterNameLanguage(
          parityFilterString,
          parity,
          i18nFilter("_dashboard_name_filter_parity_filter_")
        );
      }

      if (selectKPI && selectKPIFilterString) {
        selectKPIFilterString = this.changeFilterNameLanguage(
          selectKPIFilterString,
          selectKPI,
          i18nFilter("_dashboards_parameter_select_kpi_")
        );
      }

      if (
        selectKPIValue &&
        selectKPIFilterString &&
        selectKPIValueTranslateString
      ) {
        var KPIFilterString = selectKPIFilterString.split("=");
        if (KPIFilterString.length == 2) {
          var p_1 = KPIFilterString[0];
          var p_2 = KPIFilterString[1];

          p_2 = this.changeFilterNameLanguage(
            p_2,
            selectKPIValue,
            i18nFilter(selectKPIValueTranslateString)
          );

          selectKPIFilterString = p_1 + "=" + p_2;
        }
      }

      if (date && dateFilterString) {
        dateFilterString = this.changeFilterNameLanguage(
          dateFilterString,
          date,
          i18nFilter("_dashboard_name_parameter_date_")
        );
      }

      if (kgBasis && kgBasisFilterString) {
        kgBasisFilterString = this.changeFilterNameLanguage(
          kgBasisFilterString,
          kgBasis,
          i18nFilter("_dashboards_parameter_kg_in_basis_")
        );
      }

      if (feedName && feedNameFilterString) {
        feedNameFilterString = this.changeFilterNameLanguage(
          feedNameFilterString,
          feedName,
          i18nFilter("_dashboard_name_filter_feed_name_")
        );
      }

      if (XAxis && xAxisFilterString) {
        xAxisFilterString = this.changeFilterNameLanguage(
          xAxisFilterString,
          XAxis,
          i18nFilter("_dashboards_parameter_x_axis_")
        );
      }

      if (YAxis && yAxisFilterString) {
        yAxisFilterString = this.changeFilterNameLanguage(
          yAxisFilterString,
          YAxis,
          i18nFilter("_dashboards_parameter_y_axis_")
        );
      }

      if (XaxisValue && xAxisFilterString && XAxisValueTranslateString) {
        var splitValues = xAxisFilterString.split("=");
        if (splitValues.length == 2) {
          var p_1 = splitValues[0];
          var p_2 = splitValues[1];

          p_2 = this.changeFilterNameLanguage(
            p_2,
            XaxisValue,
            i18nFilter(XAxisValueTranslateString)
          );

          xAxisFilterString = p_1 + "=" + p_2;
        }
      }

      if (YaxisValue && yAxisFilterString && YAxisValueTranslateString) {
        var splitValues = yAxisFilterString.split("=");
        if (splitValues.length == 2) {
          var p_1 = splitValues[0];
          var p_2 = splitValues[1];

          p_2 = this.changeFilterNameLanguage(
            p_2,
            YaxisValue,
            i18nFilter(YAxisValueTranslateString)
          );

          yAxisFilterString = p_1 + "=" + p_2;
        }
      }

      if (
        conductivityValue &&
        conductivityTypeString &&
        conductivityValueTranslateString
      ) {
        var splitValues = conductivityTypeString.split("=");
        if (splitValues.length == 2) {
          var p_1 = splitValues[0];
          var p_2 = splitValues[1];

          p_2 = this.changeFilterNameLanguage(
            p_2,
            conductivityValue,
            i18nFilter(conductivityValueTranslateString)
          );

          conductivityTypeString = p_1 + "=" + p_2;
        }
      }

      if (animalEarTagString && AnimalEarTag) {
        animalEarTagString = this.changeFilterNameLanguage(
          animalEarTagString,
          AnimalEarTag,
          i18nFilter("_dashboard_field_animal_ear_tag_")
        );
      }

      if (animalEarTagStringV2 && AnimalEarTagV2) {
        animalEarTagStringV2 = this.changeFilterNameLanguage(
          animalEarTagStringV2,
          AnimalEarTagV2,
          "AnimalEartag"
        );
      }

      if (conductivityTypeString && conductivityType) {
        conductivityTypeString = this.changeFilterNameLanguage(
          conductivityTypeString,
          conductivityType,
          i18nFilter("_dashboards_parameter_conductivity_type_")
        );
      }

      filter_string = "";

      if (sortByFilterString) {
        filter_string += "&" + sortByFilterString;
      }

      if (groupByFilterString) {
        filter_string += "&" + groupByFilterString;
      }

      if (groupByPDFilterString) {
        filter_string += "&" + groupByPDFilterString;
      }

      if (parityFilterString) {
        filter_string += "&" + parityFilterString;
      }

      if (selectKPIFilterString) {
        filter_string += "&" + selectKPIFilterString;
      }

      if (dateFilterString) {
        filter_string += "&" + dateFilterString;
      }

      if (kgBasisFilterString) {
        filter_string += "&" + kgBasisFilterString;
      }

      if (feedNameFilterString) {
        filter_string += "&" + feedNameFilterString;
      }

      if (xAxisFilterString) {
        filter_string += "&" + xAxisFilterString;
      }

      if (yAxisFilterString) {
        filter_string += "&" + yAxisFilterString;
      }

      if (animalEarTagString) {
        filter_string += "&" + animalEarTagString;
      }

      if (animalEarTagStringV2) {
        filter_string += "&" + animalEarTagStringV2;
      }

      if (conductivityTypeString) {
        filter_string += "&" + conductivityTypeString;
      }

      return filter_string;
    }

    function getFilterListByDashboardId(dashboard_id) {
      var obj = {
        parameters: [],
        filters: [],
        zoomFilter: null,
      };

      var dash = dashboards_list.find(function (item) {
        return (
          dashboard_id == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.use_n_2) {
              if (filter.name_2) {
                if (filter.name_untranslated) {
                  filter.name = filter.name_2;
                } else {
                  filter.name = i18nFilter(filter.name_2);
                }
              }
            } else {
              if (filter.name && !filter.name_untranslated) {
                filter.name = i18nFilter(filter.name);
              }
            }

            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }

        if (dash.zoomFilter) {
          var zoomFilter = angular.copy(dash.zoomFilter);

          zoomFilter.filter.name = i18nFilter(dash.zoomFilter.filter.name);
          zoomFilter.worksheetName = i18nFilter(dash.zoomFilter.worksheetName);
          zoomFilter.compareFilter.name = i18nFilter(
            dash.zoomFilter.compareFilter.name
          );

          obj.zoomFilter = zoomFilter;
        }
      }
      return obj;
    }

    function getReportDashboards(
      dashboards,
      currentLng,
      startDate,
      endDate,
      actualStartDate
    ) {
      var list = [];
      var listOfDashboardsIds = [];
      for (var i = 0; i < dashboard_list.length; i++) {
        if (dashboard_list[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboard_list[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].addToReport &&
          (dashboards[i].subcategory == "aveve-milk-yield" ||
            dashboards[i].subcategory == "aveve-robot" ||
            dashboards[i].subcategory == "aveve-concentrate" ||
            dashboards[i].subcategory == "proxani-milk-yield" ||
            dashboards[i].subcategory == "proxani-robot" ||
            dashboards[i].subcategory == "proxani-concentrate")
        ) {
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
              dashboards[i].actual = listOfDashboardsIds[j].actual;
            }
          }

          dashboards[i].start_date = startDate;
          dashboards[i].end_date = endDate;
          if (dashboards[i].actual) {
            dashboards[i].start_date = actualStartDate;
          }

          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replaceAll(old_name, new_name);
    }

    function getDashboardIdByName(name) {
      var found = dashboard_id_list.find(function (_dili) {
        return i18nFilter(_dili.name) == name;
      });

      if (found) {
        return i18nFilter(found.id);
      }

      return null;
    }

    function getIsActual(dashboard_id) {
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash) {
        return dash.actual;
      }

      return false;
    }

    function getIsMRO(dashboard_id) {
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash && dash.mro) {
        return "mro";
      }

      return null;
    }

    function getIsPer100(dashboard_id) {
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash && dash.per100) {
        return "per100";
      }

      return null;
    }

    function getIsActualByDate(dashboard_id) {
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash) {
        return dash.worksheetName;
      }

      return null;
    }

    function sendErrorInfo(data) {
      var errorInfo = {
        last_selected_mark: data.last_selected_mark
          ? data.last_selected_mark
          : "/",
        sheet: "",
        comment: data.comment,
        herds: data.herds,
        team: data.team,
        mmmooogle_tenant: null,
        parameters: [],
        filters: [],
        user_id: data.user_id,
        host: data.host,
        url: data.url,
        dashboard: data.dashboard,
        last_sheet_name: data.last_sheet_name ? data.last_sheet_name : "/",
      };

      var parameters;
      var filters;
      var p = $q.defer();
      var f = $q.defer();

      var cookies = $cookies.getAll();
      angular.forEach(cookies, function (value, key) {
        if (key == "mmmooogle_tenant") {
          errorInfo.mmmooogle_tenant = value;
        }
      });

      $q.all([p.promise, f.promise])
        .then(function (response) {
          var p_list = [];
          var f_list = [];

          if (parameters) {
            for (var i = 0; i < parameters.length; i++) {
              var obj = {
                name: null,
                value: null,
                formated_value: null,
              };

              obj.name = parameters[i].getName();
              obj.value = parameters[i].getCurrentValue().value;
              obj.formated_value =
                parameters[i].getCurrentValue().formattedValue;

              p_list.push(obj);
            }
          }

          if (filters) {
            for (var i = 0; i < filters.length; i++) {
              var type = filters[i].getFilterType();
              var obj = {
                name: null,
                value: null,
              };
              if (type == "categorical") {
                obj.name = filters[i].getFieldName();
                obj.value = filters[i].getAppliedValues();
              } else if (type == "quantitative") {
                obj.name = filters[i].getFieldName();
                obj.value = {
                  d_max: filters[i].getDomainMax(),
                  d_min: filters[i].getDomainMin(),
                  max: filters[i].getMax(),
                  min: filters[i].getMin(),
                };
              } else {
                obj.name = filters[i].getFieldName();
                obj.value = {
                  period: filters[i].getDomainMax(),
                  range: filters[i].getRange(),
                  rangeN: filters[i].getRangeN(),
                };
              }
              f_list.push(obj);
            }
          }
          errorInfo.parameters = p_list;
          errorInfo.filters = f_list;

          var json = JSON.stringify(errorInfo);
          var blob = new Blob([json], {
            type: "application/json",
          });

          var file_name =
            errorInfo.user_id.replaceAll("|", "_") +
            "_" +
            errorInfo.team +
            ".json";
          var file = Upload.rename(blob, file_name);

          $timeout(function () {
            Upload.upload({
              url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

              data: {
                files: file,
              },
            })
              .then(function (response) {
                $rootScope.$broadcast("panic_button_success");
              })
              .catch(function (error) {
                console.log(error);
                $rootScope.$broadcast("panic_button_error");
              });
          }, 500);
        })
        .catch(function (error) {
          console.log(error);
        });

      $timeout(function () {
        if (!parameters) {
          p.resolve();
        }
        if (!filters) {
          f.resolve();
        }
      }, 3000);
      var wb = data.viz.getWorkbook();
      wb.getParametersAsync().then(function (_parameters) {
        parameters = _parameters;
        p.resolve();
      });

      var a_sheet = wb.getActiveSheet();
      errorInfo.sheet = a_sheet.getName();
      var wrks = a_sheet.getWorksheets();

      var worksheetName;
      for (var i = 0; i < wrks.length; i++) {
        if (wrks[i].getName()) {
          worksheetName = wrks[i].getName();
          break;
        }
      }

      wrks
        .get(worksheetName)
        .getFiltersAsync()
        .then(function (_filters) {
          filters = _filters;
          f.resolve();
        });
    }

    function getDashboardCategory(orders, category) {
      var aveve = orders.find(function (item) {
        return item.ProductId == 41;
      });

      var proxani = orders.find(function (item) {
        return item.ProductId == 42;
      });

      if (aveve && proxani) {
        return "aveve-".concat(category);
      } else {
        if (aveve) {
          return "aveve-".concat(category);
        }

        if (proxani) {
          return "proxani-".concat(category);
        }
      }

      return "aveve-".concat(category);
    }

    function getDashboardLinks(
      dashboard_id,
      style,
      category,
      prevous_dashboard_id
    ) {
      var links = [];
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash && dash.links && dash.links.length) {
        var dash_links = angular.copy(dash.links);
        var links = dash_links.map(function (item) {
          item.icon =
            style == "proxani"
              ? "proxani-".concat(item.icon).concat(".png")
              : "aveve-".concat(item.icon).concat(".png");
          return item;
        });

        if (category) {
          var has_category = links.find(function (item) {
            return item.category;
          });

          if (has_category) {
            links = links.filter(function (item) {
              return item.category && item.category == category;
            });
          }
        }
      }

      if (dash && dash.backButton) {
        var backButtonInfo = getBackButtonInfo(dash, prevous_dashboard_id);

        if (backButtonInfo && backButtonInfo.length) {
          backButtonInfo.forEach(function (item) {
            var backButton = {
              icon:
                style == "proxani"
                  ? "proxani-".concat(item.icon).concat(".png")
                  : "aveve-".concat(item.icon).concat(".png"),
              tooltip: item.tooltip,
              sheetName: item.sheetName,
            };
            links.push(backButton);
          });
        }
      }

      return links;
    }

    function getBackButtonInfo(dashboard, prevous_dashboard_id) {
      var link = dashboard.backButtonLinks.filter(function (item) {
        return i18nFilter(item.dashboard_id) == prevous_dashboard_id;
      });
      return link;
    }

    function getShowBackButton(dashboard_id) {
      var dash = dashboards_list.find(function (item) {
        return dashboard_id == i18nFilter(item.dashboard_id);
      });

      if (dash && dash.backButton) {
        return true;
      }

      return false;
    }
  }
})();

(function () {
  "use strict";
  angular.module("My").factory("cookiesService", cookiesService);
  /** @ngInject */
  function cookiesService($cookies) {
    return {
      setCookie: setCookie,
      deleteMToken: deleteMToken,
    };

    function setCookie(name, value, options) {
      if (options) {
        options.path = "/";
      } else {
        options = {
          path: "/",
        };
      }
      if (options.expires) {
        if (angular.isDate(options.expires)) {
          options.expires = options.expires.toUTCString();
        } else {
          options.expires = null;
        }
      }
      var cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      angular.forEach(options, function (value, key) {
        if (value) {
          cookie += "; " + key;
          if (value !== true) {
            cookie += "=" + value;
          }
        }
      });
      document.cookie = cookie;
    }

    function deleteMToken() {
      var expireDate = moment("01-01-2000");
      expireDate = new Date(expireDate);
      this.setCookie("mmmooogle_token", localStorage.getItem("id_token"), {
        samesite: "none",
        secure: true,
        domain: ".mmmooogle.com",
        expires: expireDate,
      });
    }
  }
})();

(function () {
	'use strict';
	angular.module('My').factory('dashboardsService', dashboardsService);
	/** @ngInject */
	function dashboardsService() {
		return {
			loadedDashboards: {}
		};
	}
})();

(function () {
  "use strict";
  angular.module("My").controller("mainCtrl", mainCtrl);
  /** @ngInject */
  function mainCtrl(
    $state,
    $timeout,
    $scope,
    $rootScope,
    permissionService,
    baSidebarService
  ) {
    var mc = this;
    mc.getCurrentUserClass = getCurrentUserClass;
    mc.getMainClass = getMainClass;
    mc.showSwoosh = showSwoosh;
    mc.swooshRestart = false;
    var style = localStorage.getItem("style");
    var timeout;

    function getCurrentUserClass() {
      if (style) {
        return style;
      }
      return "";
    }

    function getMenuCollapsed() {
      return baSidebarService.isMenuCollapsed() ? "menu-collapsed" : "";
    }

    function getMainClass() {
      var class_1 = getCurrentUserClass();
      var class_2 = getMenuCollapsed();
      return class_1.concat(" ").concat(class_2);
    }

    function showSwoosh() {
      if (style && (style == "proxani" || style == "aveve")) {
        if ($state.current.name == "home-arvesta") {
          return true;
        }

        return false;
      }

      return false;
    }

    $scope.$on("style_changed", function () {
      style = localStorage.getItem("style");
      
      if(timeout){
        $timeout.cancel(timeout);
      }
      mc.swooshRestart = true;

      timeout = $timeout(function(){
        mc.swooshRestart = false;
      },200)
    });
  }
})();

(function () {
  "use strict";
  angular.module("My").factory("xlsxService", xlsxService);
  /** @ngInject */
  function xlsxService() {
    return {
      getShortDateFormat: getShortDateFormat,
    };

    function getShortDateFormat(locale) {
      var date_format = locale.DATETIME_FORMATS.shortDate;
      if (
        locale.id == "cs-cz" ||
        locale.id == "de-de" ||
        locale.id == "pl-pl"
      ) {
        date_format = date_format.replaceAll(".", '"."');
      }

      if (
        locale.id == "fr-fr" ||
        locale.id == "ja-jp" ||
        locale.id == "pl-pl"
      ) {
        date_format = date_format.replaceAll("y", "yyyy");
      }
      return date_format;
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.calendar")
    .controller("controlerCtrl", controlerCtrl);
  /** @ngInject */
  function controlerCtrl(
    $uibModal,
    $uibModalStack,
    $scope,
    $timeout,
    $filter,
    $q,
    calendarService,
    Upload,
    APP_CONSTANTS
  ) {
    var vm = this;
    var events;
    var herds;
    var eventPromise;
    var picturePromise;
    var i18nFilter = $filter("i18n");
    vm.addNewEvent = addNewEvent;
    vm.showTimePickers = showTimePickers;
    vm.showRepeatBlock = showRepeatBlock;
    vm.openCreatePdf = openCreatePdf;
    vm.hideCreatePdfBlock = hideCreatePdfBlock;
    vm.openExportModal = openExportModal;
    vm.showNewDiscussion = showNewDiscussion;
    vm.exportPdf = exportPdf;
    vm.uploadChanged = uploadChanged;
    vm.removeSelectedFile = removeSelectedFile;
    vm.loadRight = loadRight;
    vm.loadLeft = loadLeft;
    vm.selectPicture = selectPicture;
    vm.herdSelectedChanged = herdSelectedChanged;
    vm.editEvent = editEvent;
    vm.closeEditBlock = closeEditBlock;
    vm.removePicture = removePicture;
    vm.updateEvent = updateEvent;
    vm.init = init;
    setDefaultColors();
    setRepeatList();
    init();

    function init() {
      vm.error = false;
      vm.selected_picture_id = null;
      vm.herdsList = [];
      toDataURL("assets/img/logo_mmm.png", function (dataurl) {
        vm.logo = dataurl;
      });
      toDataURL("assets/img/calendar.png", function (dataurl) {
        vm.defaultPicture = dataurl;
      });
      vm.loadingEvents = true;
      vm.showCreatePdfBlock = false;
      vm.showAddPictureBlock = false;
      vm.showEditBlock = false;
      vm.file = null;
      vm.fileName = null;
      vm.tagsList = APP_CONSTANTS.constants.tags;
      vm.tagsList.splice(0, 1);
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      if (vm.defaultValues.herd_ids && vm.defaultValues.herd_ids.length > 0) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
        if (vm.selectedHerds.length == 1) {
          vm.selectedHerd = vm.selectedHerds[0];
        }
        vm.selectedTeam = vm.defaultValues.team_id;
        vm.herdSelected = true;
        checkLng();
        setTimes();
        getData();
        vm.newEvent = {};
      } else {
        vm.herdSelected = false;
        if (vm.defaultValues.team_id) {
          vm.loadingEvents = true;
          vm.selectedTeam = vm.defaultValues.team_id;
          checkLng();
          setTimes();
          getHerds(vm.defaultValues.team_id, true);
          vm.newEvent = {};
        } else {
          vm.selectedTeam = null;
          vm.loadingEvents = false;
        }
      }
    }

    function setDefaultColors() {
      vm.colors = [
        "#31a6d4",
        "#0d0cd3",
        "#27efd6",
        "#667595",
        "#89107b",
        "#14be3d",
        "#771ef2",
        "#9aac9f",
        "#12d0fc",
        "#a60d8b",
        "#84c58b",
        "#8df13b",
        "#937386",
        "#60ae42",
        "#f4770b",
        "#e60b08",
        "#2bd5ad",
        "#7c1b26",
        "#fbbaba",
        "#a3ae16",
        "#4526f9",
      ];
    }

    function setRepeatList() {
      vm.repeatList = [
        {
          value: 0,
          label: "_calendar_do_not_repeat_",
        },
        {
          value: 1,
          label: "_calendar_daily_",
        },
        {
          value: 2,
          label: "_calendar_weekly_",
        },
        {
          value: 3,
          label: "_calendar_monthly_",
        },
        {
          value: 4,
          label: "_calendar_yearly_",
        },
      ];
    }

    function getData(herdNotSelected) {
      events = $q.defer();
      if (!herdNotSelected) {
        herds = $q.defer();
        getHerds(vm.selectedTeam);
      } else {
        herds = $q.defer();
        herds.resolve();
      }
      getEvents(vm.selectedHerds);
      $q.all([events.promise, herds.promise])
        .then(function () {
          $timeout(function () {
            vm.loadingEvents = false;
            for (var i = 0; i < vm.herds.length; i++) {
              if (vm.colors[i]) {
                vm.herds[i].color = vm.colors[i];
              } else {
                vm.herds[i].color =
                  "#" + Math.floor(Math.random() * 16777215).toString(16);
              }
            }
            for (var i = 0; i < vm.events.length; i++) {
              for (var j = 0; j < vm.herds.length; j++) {
                if (vm.events[i].herd_id == vm.herds[j].Id) {
                  vm.events[i].color = vm.herds[j].color;
                }
              }
            }
            $timeout(function () {
              initialize();
              createHerdsList();
            }, 0);
          }, 2345);
        })
        .catch(function (error) {
          vm.loadingEvents = false;
          vm.error = true;
        });
    }

    function getHerds(team_id, herdNotSelected) {
      return calendarService
        .getHerdsByTeam(team_id)
        .then(function (response) {
          vm.herds = response;
          if (herdNotSelected) {
            var list = [];
            for (var i = 0; i < response.length; i++) {
              list.push(response[i].Id);
            }
            vm.selectedHerds = list;
            getData(true);
          } else {
            herds.resolve();
          }
        })
        .catch(function (error) {
          if (!herdNotSelected) {
            herds.reject();
          }
          console.log(error);
        });
    }

    function checkLng() {
      vm.locale = "en-GB";
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "en-GB") {
          vm.locale = "en-gb";
        } else if (lng == "en-US") {
          vm.locale = "en";
        } else if (lng == "de-DE") {
          vm.locale = "de";
        } else if (lng == "fr-FR") {
          vm.locale = "fr";
        } else if (lng == "nl-NL") {
          vm.locale = "nl";
        } else if (lng == "es-ES") {
          vm.locale = "es";
        } else if (lng == "ja-JP") {
          vm.locale = "ja";
        } else if (lng == "cs-CZ") {
          vm.locale = "cs";
        } else if (lng == "pl-PL") {
          vm.locale = "pl";
        } else {
          vm.locale = "en";
        }
      }
    }

    function setTimes() {
      vm.times = [];
      var times = [
        "2018-07-10T00:00:00",
        "2018-07-10T00:30:00",
        "2018-07-10T01:00:00",
        "2018-07-10T01:30:00",
        "2018-07-10T02:00:00",
        "2018-07-10T02:30:00",
        "2018-07-10T03:00:00",
        "2018-07-10T03:30:00",
        "2018-07-10T04:00:00",
        "2018-07-10T04:30:00",
        "2018-07-10T05:00:00",
        "2018-07-10T05:30:00",
        "2018-07-10T06:00:00",
        "2018-07-10T06:30:00",
        "2018-07-10T07:00:00",
        "2018-07-10T07:30:00",
        "2018-07-10T08:00:00",
        "2018-07-10T08:30:00",
        "2018-07-10T09:00:00",
        "2018-07-10T09:30:00",
        "2018-07-10T10:00:00",
        "2018-07-10T10:30:00",
        "2018-07-10T11:00:00",
        "2018-07-10T11:30:00",
        "2018-07-10T12:00:00",
        "2018-07-10T12:30:00",
        "2018-07-10T13:00:00",
        "2018-07-10T13:30:00",
        "2018-07-10T14:00:00",
        "2018-07-10T14:30:00",
        "2018-07-10T15:00:00",
        "2018-07-10T15:30:00",
        "2018-07-10T16:00:00",
        "2018-07-10T16:30:00",
        "2018-07-10T17:00:00",
        "2018-07-10T17:30:00",
        "2018-07-10T18:00:00",
        "2018-07-10T18:30:00",
        "2018-07-10T19:00:00",
        "2018-07-10T19:30:00",
        "2018-07-10T20:00:00",
        "2018-07-10T20:30:00",
        "2018-07-10T21:00:00",
        "2018-07-10T21:30:00",
        "2018-07-10T22:00:00",
        "2018-07-10T22:30:00",
        "2018-07-10T23:00:00",
        "2018-07-10T23:30:00",
      ];
      for (var i = 0; i < times.length; i++) {
        var date = new Date(times[i]);
        var obj = {
          date: date,
          date_string: $filter("date")(date, "shortTime"),
          time: $filter("date")(date, "HH:mm:ss"),
        };
        vm.times.push(obj);
      }
    }

    function getEvents() {
      vm.loadingEvents = true;
      if (vm.selectedHerds && vm.selectedHerds.length > 0) {
        var suffix = "?herdid=[";
        for (var h = 0; h < vm.selectedHerds.length; h++) {
          suffix = suffix + vm.selectedHerds[h];
          if (h < vm.selectedHerds.length - 1) {
            suffix = suffix + ",";
          }
        }
        suffix = suffix + "]";
      } else {
        var suffix = "?herdid=[";
        for (var h = 0; h < vm.herds.length; h++) {
          suffix = suffix + vm.herds[h].Id;
          if (h < vm.herds.length - 1) {
            suffix = suffix + ",";
          }
        }
        suffix = suffix + "]";
      }
      return calendarService
        .getEvents(suffix)
        .then(function (response) {
          vm.responseEvents = response;
          vm.events = [];
          if (response.length > 0) {
            for (var i = 0; i < response.length; i++) {
              for (var j = 0; j < response[i].Dates.length; j++) {
                var start = response[i].Dates[j].StartDate
                  ? response[i].Dates[j].StartDate
                  : null;
                var end = response[i].Dates[j].EndDate
                  ? response[i].Dates[j].EndDate
                  : null;
                if (!end && start) {
                  start = $filter("date")(start, "yyyy-MM-dd");
                }
                if (
                  start &&
                  $filter("date")(start, "HH:mm:ss") == "00:00:00" &&
                  end &&
                  $filter("date")(end, "HH:mm:ss") == "00:00:00"
                ) {
                  start = $filter("date")(start, "yyyy-MM-dd");
                  end = $filter("date")(end, "yyyy-MM-dd");
                }
                var event = {
                  title: response[i].Title,
                  description: response[i].Description,
                  id: response[i].Id,
                  herd_id: response[i].HerdId,
                  start: start,
                  end: end,
                  pictures: response[i].Pictures,
                  recurring: response[i].Recurring,
                  recurringEndDate: response[i].RecurringEndDate,
                  recurringInterval: response[i].RecurringInterval,
                };
                vm.events.push(event);
              }
            }
          }
          events.resolve();
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function openModal(allDay) {
      if (vm.selectedHerds.length != 1) {
        vm.selectedHerd = null;
      }

      vm.showRepeat = false;
      vm.showPictures = true;
      vm.loadingAddNewEvent = false;
      vm.showAddPictureBlock = false;
      if (allDay) {
        vm.showTime = true;
        var startTime = vm.newEvent.start.split("T")[1];
        var endTime = vm.newEvent.end.split("T")[1];
        for (var i = 0; i < vm.times.length; i++) {
          if (vm.times[i].time == startTime) {
            vm.newEvent.startTime = vm.times[i];
          }
          if (vm.times[i].time == endTime) {
            vm.newEvent.endTime = vm.times[i];
          }
        }
      } else {
        vm.showTime = false;
      }
      vm.newEvent.startDate = new Date(vm.newEvent.start);
      vm.newEvent.endDate = new Date(vm.newEvent.end);
      vm.selected_picture_id = null;
      if (vm.selectedHerd) {
        getPicturesByHerd(vm.selectedHerd.Id);
      } else {
        vm.allPictures = [];
        vm.pictures = [];
        vm.showLoadLeft = false;
        vm.showLoadRight = false;
      }
      $uibModal
        .open({
          animation: true,
          templateUrl: "app/pages/calendar/newEvent.modal.html",
          size: "md",
          scope: $scope,
          backdrop: "static",
          keyboard: false,
        })
        .closed.then(function () {
          $("#calendar").fullCalendar("unselect");
          vm.newEvent = {};
        });
    }

    function createHerdsList() {
      if (vm.selectedHerds.length > 1) {
        vm.showHerdSelector = true;
        vm.herdsList = [];
        for (var i = 0; i < vm.herds.length; i++) {
          for (var j = 0; j < vm.selectedHerds.length; j++) {
            if (vm.herds[i].Id == vm.selectedHerds[j]) {
              vm.herdsList.push(vm.herds[i]);
            }
          }
        }
      } else {
        vm.showHerdSelector = false;
        for (var i = 0; i < vm.herds.length; i++) {
          if (vm.herds[i].Id == vm.selectedHerds[0]) {
            vm.selectedHerd = vm.herds[i];
            break;
          }
        }
      }
    }

    function updateEventDates(event, newStart, newEnd) {
      var newEvent;
      for (var i = 0; i < vm.responseEvents.length; i++) {
        if (event.id == vm.responseEvents[i].Id) {
          newEvent = vm.responseEvents[i];
          break;
        }
      }
      if (newEvent) {
        var suffix = "?id=" + newEvent.Id + "&";
        var herd_id = newEvent.HerdId;
        var has_start;
        var has_end;
        var has_title;
        var has_description;
        var has_repeat;
        var has_repeat_interval;
        if (newEvent.StartDate) {
          suffix = suffix + "startDate=" + newStart;
          has_start = true;
        }
        if (newEvent.EndDate) {
          if (has_start) {
            suffix = suffix + "&";
          }
          suffix = suffix + "endDate=" + newEnd;
          has_end = true;
        }
        if (newEvent.Title) {
          if (has_start || has_end) {
            suffix = suffix + "&";
          }
          suffix = suffix + "title=" + newEvent.Title;
          has_title = true;
        }
        if (newEvent.Description) {
          if (has_start || has_end || has_title) {
            suffix = suffix + "&";
          }
          suffix = suffix + "description=" + newEvent.Description;
          has_description = true;
        }
        if (newEvent.Recurring) {
          if (has_start || has_end || has_title || has_description) {
            suffix = suffix + "&";
          }
          suffix = suffix + "recurring=" + newEvent.Recurring;
          has_repeat = true;
        }
        if (newEvent.RecurringInterval) {
          if (
            has_start ||
            has_end ||
            has_title ||
            has_description ||
            has_repeat
          ) {
            suffix = suffix + "&";
          }
          suffix = suffix + "recurringinterval=" + newEvent.RecurringInterval;
          has_repeat_interval = true;
        }
        if (newEvent.RecurringEndDate) {
          if (
            has_start ||
            has_end ||
            has_title ||
            has_description ||
            has_repeat ||
            has_repeat_interval
          ) {
            suffix = suffix + "&";
          }
          suffix = suffix + "recurringenddate=" + newEvent.RecurringEndDate;
        }
        return calendarService
          .updateEvent(herd_id, suffix)
          .then(function (response) {
            for (var i = 0; i < vm.responseEvents.length; i++) {
              if (vm.responseEvents[i].id == response.id) {
                vm.responseEvents[i] = response;
                break;
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }

    function showRepeatBlock() {
      if (vm.showRepeat) {
        vm.showRepeat = false;
      } else {
        vm.showRepeat = true;
        vm.newEvent.repeatType = vm.repeatList[0];
      }
    }

    function addNewEvent() {
      if (vm.file) {
        eventPromise = $q.defer();
        picturePromise = $q.defer();
        $q.all([eventPromise.promise, picturePromise.promise])
          .then(function (responses) {
            vm.selected_picture_id = responses[1].Id;
            addPictureToEvent(responses[0]);
          })
          .catch(function (error) {
            console.log(error);
          });
        postNewEvent(true);
        postNewPicture();
      } else {
        postNewEvent(false);
      }
    }

    function postNewEvent(with_picture) {
      vm.loadingAddNewEvent = true;
      if (vm.showTime) {
        var start =
          $filter("date")(vm.newEvent.startDate, "yyyy-MM-dd") +
          "T" +
          vm.newEvent.startTime.time;
        var end =
          $filter("date")(vm.newEvent.endDate, "yyyy-MM-dd") +
          "T" +
          vm.newEvent.endTime.time;
      } else {
        var start = $filter("date")(vm.newEvent.startDate, "yyyy-MM-dd");
        var end = $filter("date")(vm.newEvent.endDate, "yyyy-MM-dd");
      }
      var suffix = "?";
      var herd_id = vm.selectedHerd.Id;
      var has_start;
      var has_end;
      var has_title;
      var has_description;
      var has_repeat;
      var has_repeat_interval;
      if (start) {
        suffix = suffix + "startDate=" + start;
        has_start = true;
      }
      if (end) {
        if (has_start) {
          suffix = suffix + "&";
        }
        suffix = suffix + "endDate=" + end;
        has_end = true;
      }
      if (vm.newEvent.title) {
        if (has_start || has_end) {
          suffix = suffix + "&";
        }
        suffix = suffix + "title=" + vm.newEvent.title;
        has_title = true;
      }
      if (vm.newEvent.description) {
        if (has_start || has_end || has_title) {
          suffix = suffix + "&";
        }
        suffix = suffix + "description=" + vm.newEvent.description;
        has_description = true;
      }
      if (vm.showRepeat && vm.newEvent.repeatType.value) {
        if (has_start || has_end || has_title || has_description) {
          suffix = suffix + "&";
        }
        suffix = suffix + "recurring=" + vm.newEvent.repeatType.value;
        has_repeat = true;
      }
      if (
        vm.showRepeat &&
        vm.newEvent.repeatType.value &&
        vm.newEvent.repeatInterval
      ) {
        if (
          has_start ||
          has_end ||
          has_title ||
          has_description ||
          has_repeat
        ) {
          suffix = suffix + "&";
        }
        suffix = suffix + "recurringinterval=" + vm.newEvent.repeatInterval;
        has_repeat_interval = true;
      }
      if (
        vm.showRepeat &&
        vm.newEvent.repeatType.value &&
        vm.newEvent.endRepeat
      ) {
        if (
          has_start ||
          has_end ||
          has_title ||
          has_description ||
          has_repeat ||
          has_repeat_interval
        ) {
          suffix = suffix + "&";
        }
        suffix =
          suffix +
          "recurringenddate=" +
          $filter("date")(vm.newEvent.endRepeat, "yyyy-MM-dd");
      }
      return calendarService
        .addNewEvent(herd_id, suffix)
        .then(function (response) {
          if (with_picture) {
            eventPromise.resolve(response);
          } else {
            if (vm.selected_picture_id) {
              addPictureToEvent(response);
            } else {
              handleNewEventResponse(response);
            }
          }
        })
        .catch(function (error) {
          vm.loadingAddNewEvent = false;
        });
    }

    function postNewPicture() {
      var suffix = "?created=" + new Date().toISOString();
      suffix = suffix + "&tags=calendarEvent";
      if (vm.file) {
        var url =
          APP_CONSTANTS.animals_base_url +
          "herds/" +
          vm.selectedHerd.Id +
          "/pictures" +
          suffix;
        Upload.upload({
          url: url,
          data: {
            file: vm.file,
          },
        })
          .then(function (response) {
            picturePromise.resolve(response.data);
          })
          .catch(function (error) {
            vm.loadingNewDiscussion = false;
            console.log(error);
          });
      } else {
        picturePromise.reject("no_file");
      }
    }

    function addPictureToEvent(event_response) {
      return calendarService
        .addPictureToEvent(event_response.Id, vm.selected_picture_id)
        .then(function (response) {
          handleNewEventResponse(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function handleNewEventResponse(response) {
      for (var j = 0; j < response.Dates.length; j++) {
        var start = response.Dates[j].StartDate
          ? response.Dates[j].StartDate
          : null;
        var end = response.Dates[j].EndDate ? response.Dates[j].EndDate : null;
        if (!end && start) {
          start = $filter("date")(start, "yyyy-MM-dd");
        }
        if (
          start &&
          $filter("date")(start, "HH:mm:ss") == "00:00:00" &&
          end &&
          $filter("date")(end, "HH:mm:ss") == "00:00:00"
        ) {
          start = $filter("date")(start, "yyyy-MM-dd");
          end = $filter("date")(end, "yyyy-MM-dd");
        }
        var event = {
          title: response.Title,
          description: response.Description,
          id: response.Id,
          herd_id: response.HerdId,
          start: start,
          end: end,
          color: vm.selectedHerd.color,
          pictures: response.Pictures,
        };
        $("#calendar").fullCalendar("renderEvent", event, true);
      }
      if (vm.responseEvents && vm.responseEvents.length > 0) {
        vm.responseEvents.push(response);
      } else {
        vm.responseEvents = [response];
      }
      vm.newEvent.title = null;
      $uibModalStack.dismissAll();
    }

    function showDescription(event) {
      for (var i = 0; i < vm.responseEvents.length; i++) {
        if (event.id == vm.responseEvents[i].Id) {
          vm.selected_event = vm.responseEvents[i];
          break;
        }
      }
      for (var r = 0; r < vm.repeatList.length; r++) {
        if (vm.repeatList[r].value == vm.selected_event.Recurring) {
          vm.selected_event.ReccuringString = vm.repeatList[r].label;
          break;
        }
      }
      if (event.allDay) {
        vm.selected_event.startDate = $filter("date")(
          event.start.format(),
          "shortDate"
        );
        if (event.end) {
          vm.selected_event.endDate = $filter("date")(
            event.end.format(),
            "shortDate"
          );
        } else {
          vm.selected_event.endDate = vm.selected_event.startDate;
        }
      } else {
        vm.selected_event.startDate = $filter("date")(
          event.start.format(),
          "short"
        );
        vm.selected_event.endDate = $filter("date")(
          event.end.format(),
          "short"
        );
      }
      vm.selected_event.color = event.color;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/calendar/description.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function showTimePickers() {
      var now = new Date();
      now.setDate(10);
      now.setMonth(6);
      now.setFullYear(2018);
      for (var i = 0; i < vm.times.length; i++) {
        if (moment(now).isBefore(vm.times[i].date)) {
          vm.newEvent.startTime = vm.times[i];
          vm.newEvent.endTime = vm.times[i];
          break;
        }
      }
      vm.showTime = true;
    }

    function initialize() {
      var $element = $("#calendar").fullCalendar({
        locale: vm.locale,
        height: 500,
        header: {
          left: "prev today next",
          center: "title",
          right: "month,agendaWeek,agendaDay",
        },
        defaultDate: new Date(),
        selectable: true,
        selectHelper: true,
        navLinks: true,
        weekNumbers: true,
        columnHeader: true,
        nowIndicator: true,
        select: function (start, end) {
          if (start.hasTime() || end.hasTime()) {
            var allDay = true;
          } else {
            var allDay = false;
          }
          vm.newEvent.start = start.format();
          vm.newEvent.end = end.format();
          checkEventList(vm.newEvent.start, vm.newEvent.end);
          openModal(allDay);
        },
        editable: true,
        eventLimit: true, // allow "more" link when too many events
        events: vm.events,
        eventClick: function (calEvent, jsEvent, view) {
          showDescription(calEvent);
        },
        eventDrop: function (event, delta, revertFunc) {
          var startDate = null;
          var endDate = null;
          if (event.start) {
            startDate = event.start.format();
          }
          if (event.end) {
            endDate = event.end.format();
          }
          updateEventDates(event, startDate, endDate);
        },
        eventResize: function (event, delta, revertFunc) {
          var startDate = null;
          var endDate = null;
          if (event.start) {
            startDate = event.start.format();
          }
          if (event.end) {
            endDate = event.end.format();
          }
          updateEventDates(event, startDate, endDate);
        },
      });
    }

    function checkEventList(start, end) {
      var eventList = [];
      for (var i = 0; i < vm.responseEvents.length; i++) {
        var insert = false;
        if (
          vm.responseEvents[i].Dates &&
          vm.responseEvents[i].Dates.length > 0
        ) {
          for (var j = 0; j < vm.responseEvents[i].Dates.length; j++) {
            if (
              ((moment(start).isBefore(
                vm.responseEvents[i].Dates[j].StartDate
              ) &&
                moment(end).isAfter(vm.responseEvents[i].Dates[j].StartDate)) ||
                (moment(start).isBefore(
                  vm.responseEvents[i].Dates[j].EndDate
                ) &&
                  moment(end).isAfter(
                    vm.responseEvents[i].Dates[j].EndDate
                  ))) &&
              vm.responseEvents[i].Dates[j].EndDate
            ) {
              insert = true;
              break;
            }
          }
        }
        if (insert) {
          for (var h = 0; h < vm.herds.length; h++) {
            if (vm.herds[h].Id == vm.responseEvents[i].HerdId) {
              vm.responseEvents[i].HerdName = vm.herds[h].Name;
              break;
            }
          }
          for (var r = 0; r < vm.repeatList.length; r++) {
            if (vm.repeatList[r].value == vm.responseEvents[i].Recurring) {
              vm.responseEvents[i].ReccuringString = vm.repeatList[r].label;
              break;
            }
          }
          eventList.push(vm.responseEvents[i]);
        }
      }
      if (eventList.length > 0) {
        vm.showEventPicker = true;
        vm.showNewEventBlock = false;
      } else {
        vm.showNewEventBlock = true;
        vm.showEventPicker = false;
      }
      vm.eventsForPdf = eventList;
    }

    function openCreatePdf() {
      $uibModalStack.dismissAll();
      vm.showCreatePdfBlock = true;
    }

    function hideCreatePdfBlock() {
      vm.showCreatePdfBlock = false;
      init();
    }

    function openExportModal() {
      vm.file_name = "Calendar";
      vm.showNewDiscussionBlock = false;
      vm.loadingModal = false;
      vm.includePictures = false;
      vm.discussion = {};
      vm.discussion = {};
      vm.discussion.importance = 0;
      if (vm.selectedHerd) {
        vm.showHerdSelector = false;
      } else {
        vm.showHerdSelector = true;
      }
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/calendar/exportPdf.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getPicturesByHerd(herd_id) {
      vm.loadingPictures = true;
      vm.currentPage = 1;
      return calendarService
        .getPicturesByHerd(herd_id)
        .then(function (response) {
          vm.allPictures = response;
          setToShowPictures(1);
          vm.loadingPictures = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function loadRight() {
      vm.currentPage++;
      vm.loadingPictures = true;
      setToShowPictures(vm.currentPage);
      $timeout(function () {
        vm.loadingPictures = false;
      }, 100);
    }

    function loadLeft() {
      vm.currentPage--;
      vm.loadingPictures = true;
      setToShowPictures(vm.currentPage);
      $timeout(function () {
        vm.loadingPictures = false;
      }, 100);
    }

    function setToShowPictures(page) {
      var list = [];
      var first = (page - 1) * 100;
      var last = page * 100;
      for (var i = first; i < last; i++) {
        if (vm.allPictures[i]) {
          list.push(vm.allPictures[i]);
        } else {
          break;
        }
      }
      if (vm.allPictures[first - 1]) {
        vm.showLoadLeft = true;
      } else {
        vm.showLoadLeft = false;
      }
      if (vm.allPictures[last + 1]) {
        vm.showLoadRight = true;
      } else {
        vm.showLoadRight = false;
      }
      vm.pictures = list;
    }

    function showNewDiscussion() {
      vm.showNewDiscussionBlock = true;
    }

    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.send();
    }

    function exportPdf(newDiscussion) {
      vm.loadingModal = true;
      setPDFPictures(newDiscussion);

      function setPDFPictures(newDiscussion) {
        var list = [];
        for (var i = 0; i < vm.eventsForPdf.length; i++) {
          if (
            vm.eventsForPdf[i].Pictures &&
            vm.eventsForPdf[i].Pictures.length > 0
          ) {
            var name = "pr" + i;
            vm[name] = $q.defer();
            list.push(vm[name].promise);
            getDataUrl(name, i, vm.eventsForPdf[i].Pictures[0].ThumbnailUrl);
          }
        }

        function getDataUrl(name, i, picture) {
          toDataURL(picture, function (dataUrl) {
            vm.eventsForPdf[i].Pictures[0].PdfPicture = dataUrl;
            vm[name].resolve();
          });
        }
        $q.all(list).then(function () {
          createPDF(newDiscussion);
        });
      }

      function createPDF(newDiscussion) {
        var dd = {
          pageMargins: [25, 50, 20, 0],
          content: [
            {
              table: {
                dontBreakRows: true,
                body: [],
                widths: ["auto", "*"],
              },
            },
          ],
          defaultStyle: {
            fontSize: 9,
          },
          styles: {
            headerStyle: {
              fontSize: 10,
              bold: true,
            },
          },
        };
        for (var i = 0; i < vm.eventsForPdf.length; i++) {
          var event = [
            {
              image:
                vm.eventsForPdf[i].Pictures &&
                vm.eventsForPdf[i].Pictures.length > 0
                  ? vm.eventsForPdf[i].Pictures[0].PdfPicture
                  : vm.defaultPicture,
              fit: [70, 70],
              margin: [0, 0, 0, 0],
              border: [false, false, false, true],
            },
            {
              text:
                (vm.eventsForPdf[i].Title
                  ? i18nFilter("_calendar_event_title_") +
                    ":  " +
                    vm.eventsForPdf[i].Title +
                    "\n"
                  : "") +
                (vm.eventsForPdf[i].Description
                  ? i18nFilter("_calendar_event_description_") +
                    ":  " +
                    vm.eventsForPdf[i].Description +
                    "\n"
                  : "") +
                (vm.eventsForPdf[i].HerdName
                  ? i18nFilter("_label_herd_") +
                    ":  " +
                    vm.eventsForPdf[i].HerdName +
                    "\n"
                  : "") +
                "(" +
                (vm.eventsForPdf[i].StartDate
                  ? $filter("date")(vm.eventsForPdf[i].StartDate, "shortDate")
                  : "") +
                ") - (" +
                (vm.eventsForPdf[i].EndDate
                  ? $filter("date")(vm.eventsForPdf[i].EndDate, "shortDate")
                  : "") +
                ")" +
                "\n" +
                (vm.eventsForPdf[i].Recurring &&
                vm.eventsForPdf[i].ReccuringString
                  ? i18nFilter("_calendar_repeat_event_") +
                    ":  " +
                    i18nFilter(vm.eventsForPdf[i].ReccuringString) +
                    "\n"
                  : "") +
                (vm.eventsForPdf[i].Recurring &&
                vm.eventsForPdf[i].RecurringInterval
                  ? i18nFilter("_calendar_repeat_interval_") +
                    ":  " +
                    vm.eventsForPdf[i].RecurringInterval +
                    "\n"
                  : "") +
                (vm.eventsForPdf[i].Recurring &&
                vm.eventsForPdf[i].RecurringEndDate
                  ? i18nFilter("_calendar_repeat_end_") +
                    ":  " +
                    $filter("date")(
                      vm.eventsForPdf[i].RecurringEndDate,
                      "shortDate"
                    ) +
                    "\n"
                  : "") +
                (vm.eventsForPdf[i].Comment
                  ? i18nFilter("_dc_comments_") +
                    ":  " +
                    vm.eventsForPdf[i].Comment
                  : ""),
              margin: [25, 0, 0, 0],
              border: [false, false, false, true],
            },
          ];
          dd.content[0].table.body.push(event);
        }
        if (
          vm.file_header &&
          vm.file_header != "" &&
          vm.file_header.length > 0
        ) {
          var header = [
            {
              columns: [
                {
                  image: vm.logo,
                  width: 150,
                  margin: [25, 0, 0, 0],
                },
              ],
            },
            {
              columns: [
                {
                  style: "headerStyle",
                  margin: [30, 0, 30, 10],
                  text: vm.file_header,
                },
              ],
            },
          ];
          dd.header = header;
        } else {
          var header = [
            {
              columns: [
                {
                  image: vm.logo,
                  width: 150,
                  margin: [25, 0, 0, 0],
                },
              ],
            },
          ];
          dd.header = header;
        }
        var name = vm.file_name + ".pdf";
        var dd2 = angular.copy(dd);
        if (newDiscussion) {
          pdfMake.createPdf(dd).getBlob(function (data) {
            createNewDiscussion(data);
            pdfMake.createPdf(dd2).download(name);
            $uibModalStack.dismissAll();
            vm.showCreatePdfBlock = false;
            init();
          });
        } else {
          pdfMake.createPdf(dd).download(name);
          $uibModalStack.dismissAll();
          vm.showCreatePdfBlock = false;
          init();
        }
      }
    }

    function uploadChanged() {
      vm.fileName = vm.file.name;
      vm.showPictures = false;
      vm.selected_picture_id = null;
    }

    function removeSelectedFile() {
      vm.file = null;
      vm.fileName = null;
      vm.showPictures = true;
      vm.selected_picture_id = null;
    }

    function selectPicture(picture) {
      vm.showPictures = false;
      vm.file = null;
      vm.selected_picture_id = picture.Id;
      if (picture.FileName) {
        vm.fileName = picture.FileName;
      } else {
        vm.fileName = "Picture.jpg";
      }
    }

    function herdSelectedChanged() {
      getPicturesByHerd(vm.selectedHerd.Id);
    }

    function editEvent() {
      vm.loadingEvents = true;
      vm.showPictures = true;
      vm.removePictureFromEvent = false;
      if (vm.selected_event.Recurring) {
        vm.showRepeat = true;
      } else {
        vm.showRepeat = false;
      }
      if (vm.selected_event.HerdId) {
        getPicturesByHerd(vm.selected_event.HerdId);
      }
      for (var i = 0; i < vm.repeatList.length; i++) {
        if (vm.repeatList[i].value == vm.selected_event.Recurring) {
          vm.selected_event.RecurringObject = vm.repeatList[i];
          break;
        }
      }
      if (vm.selected_event.RecurringEndDate) {
        vm.selected_event.RecurringEndDate = new Date(
          vm.selected_event.RecurringEndDate
        );
      }
      if (vm.selected_event.StartDate) {
        var startTime = $filter("date")(
          vm.selected_event.StartDate,
          "HH:mm:ss"
        );
        vm.selected_event.StartDate = new Date(vm.selected_event.StartDate);
      }
      if (vm.selected_event.EndDate) {
        var endTime = $filter("date")(vm.selected_event.EndDate, "HH:mm:ss");
        vm.selected_event.EndDate = new Date(vm.selected_event.EndDate);
      }
      if (startTime && endTime) {
        if (startTime == "00:00:00" && endTime == "00:00:00") {
          vm.showTime = false;
        } else {
          if (startTime) {
            for (var i = 0; i < vm.times.length; i++) {
              if (vm.times[i].time == startTime) {
                vm.selected_event.startTime = vm.times[i];
                break;
              }
            }
          }
          if (endTime) {
            for (var i = 0; i < vm.times.length; i++) {
              if (vm.times[i].time == endTime) {
                vm.selected_event.endTime = vm.times[i];
                break;
              }
            }
          }
          vm.showTime = true;
        }
      } else {
        vm.showTime = false;
      }
      if (vm.selected_event.Pictures && vm.selected_event.Pictures.length > 0) {
        vm.hidePicturesButton = true;
      } else {
        vm.hidePicturesButton = false;
      }
      vm.showEditBlock = true;
      vm.showCreatePdfBlock = false;
      $uibModalStack.dismissAll();
      vm.loadingEvents = false;
    }

    function closeEditBlock() {
      vm.showEditBlock = false;
      vm.showCreatePdfBlock = false;
      init();
    }

    function removePicture() {
      vm.removePictureFromEvent = true;
      vm.removedPicture = vm.selected_event.Pictures[0];
      vm.selected_event.Pictures = [];
      vm.hidePicturesButton = false;
    }

    function createNewDiscussion(file) {
      file.name = vm.file_name;
      var date = new Date().toISOString();
      var suffix = "?created=" + date;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix = suffix + "&tags=" + encodeURIComponent(vm.discussion.tags);
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      var url =
        APP_CONSTANTS.animals_base_url +
        "herds/" +
        vm.selectedHerd.Id +
        "/pictures" +
        suffix;
      Upload.upload({
        url: url,
        data: {
          file: file,
        },
      })
        .then(function (response) {
          $uibModalStack.dismissAll();
          vm.loadingModal = false;
          vm.loadingNewDiscussion = false;
        })
        .catch(function (error) {
          vm.loadingModal = false;
          console.log(error);
        });
    }

    function updateEvent() {
      vm.loadingEvents = true;
      vm.showEditBlock = false;
      if (vm.removePictureFromEvent) {
        removePicFromEvent();
      } else {
        checkPicture();
      }

      function checkPicture() {
        if (vm.file) {
          eventPromise = $q.defer();
          picturePromise = $q.defer();
          $q.all([eventPromise.promise, picturePromise.promise])
            .then(function (responses) {
              vm.selected_picture_id = responses[1].Id;
              addNewPictureToEvent(responses[0]);
            })
            .catch(function (error) {
              vm.loadingEvents = false;
              vm.showEditBlock = true;
              console.log(error);
            });
          eventUpdate(true);
          postPicture();
        } else {
          eventUpdate(false);
        }
      }

      function addNewPictureToEvent(event_response) {
        return calendarService
          .addPictureToEvent(event_response.Id, vm.selected_picture_id)
          .then(function (response) {
            init();
          })
          .catch(function (error) {
            console.log(error);
            vm.loadingEvents = false;
            vm.showEditBlock = true;
          });
      }

      function postPicture() {
        var suffix = "?created=" + new Date().toISOString();
        suffix = suffix + "&tags=calendarEvent";
        if (vm.file) {
          var url =
            APP_CONSTANTS.animals_base_url +
            "herds/" +
            vm.selected_event.HerdId +
            "/pictures" +
            suffix;
          Upload.upload({
            url: url,
            data: {
              file: vm.file,
            },
          })
            .then(function (response) {
              picturePromise.resolve(response.data);
            })
            .catch(function (error) {
              vm.loadingNewDiscussion = false;
              vm.loadingEvents = false;
              vm.showEditBlock = true;
            });
        } else {
          picturePromise.reject("no_file");
        }
      }

      function removePicFromEvent() {
        return calendarService
          .removePictureFromEvent(vm.selected_event.Id, vm.removedPicture.Id)
          .then(function (response) {
            checkPicture();
          })
          .catch(function (error) {
            vm.loadingEvents = false;
            vm.showEditBlock = true;
            console.log(error);
          });
      }

      function eventUpdate(with_picture) {
        vm.loadingAddNewEvent = true;
        if (vm.showTime) {
          var start =
            $filter("date")(vm.selected_event.StartDate, "yyyy-MM-dd") +
            "T" +
            vm.selected_event.startTime.time;
          var end =
            $filter("date")(vm.selected_event.EndDate, "yyyy-MM-dd") +
            "T" +
            vm.selected_event.endTime.time;
        } else {
          var start = $filter("date")(
            vm.selected_event.StartDate,
            "yyyy-MM-dd"
          );
          var end = $filter("date")(vm.selected_event.EndDate, "yyyy-MM-dd");
        }
        var suffix = "?";
        var herd_id = vm.selected_event.HerdId;
        var has_start;
        var has_end;
        var has_title;
        var has_description;
        var has_repeat;
        var has_repeat_interval;
        if (start) {
          suffix = suffix + "startDate=" + start;
          has_start = true;
        }
        if (end) {
          if (has_start) {
            suffix = suffix + "&";
          }
          suffix = suffix + "endDate=" + end;
          has_end = true;
        }
        if (vm.selected_event.Title) {
          if (has_start || has_end) {
            suffix = suffix + "&";
          }
          suffix = suffix + "title=" + vm.selected_event.Title;
          has_title = true;
        }
        if (vm.selected_event.Description) {
          if (has_start || has_end || has_title) {
            suffix = suffix + "&";
          }
          suffix = suffix + "description=" + vm.selected_event.Description;
          has_description = true;
        }
        if (vm.showRepeat && vm.selected_event.RecurringObject.value) {
          if (has_start || has_end || has_title || has_description) {
            suffix = suffix + "&";
          }
          suffix =
            suffix + "recurring=" + vm.selected_event.RecurringObject.value;
          has_repeat = true;
        }
        if (
          vm.showRepeat &&
          vm.selected_event.RecurringObject.value &&
          vm.selected_event.RecurringInterval
        ) {
          if (
            has_start ||
            has_end ||
            has_title ||
            has_description ||
            has_repeat
          ) {
            suffix = suffix + "&";
          }
          suffix =
            suffix + "recurringinterval=" + vm.selected_event.RecurringInterval;
          has_repeat_interval = true;
        }
        if (
          vm.showRepeat &&
          vm.selected_event.RecurringObject.value &&
          vm.selected_event.RecurringEndDate
        ) {
          if (
            has_start ||
            has_end ||
            has_title ||
            has_description ||
            has_repeat ||
            has_repeat_interval
          ) {
            suffix = suffix + "&";
          }
          suffix =
            suffix +
            "recurringenddate=" +
            $filter("date")(vm.selected_event.RecurringEndDate, "yyyy-MM-dd");
        }
        suffix = suffix + "&id=" + vm.selected_event.Id;
        return calendarService
          .addNewEvent(herd_id, suffix)
          .then(function (response) {
            if (with_picture) {
              eventPromise.resolve(response);
            } else {
              if (vm.selected_picture_id) {
                addNewPictureToEvent(response);
              } else {
                init();
              }
            }
          })
          .catch(function (error) {
            vm.loadingAddNewEvent = false;
          });
      }
    }
    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.calendar').directive('dashboardCalendar', dashboardCalendar);
    /** @ngInject */
    function dashboardCalendar() {
        return {
            restrict: 'E'
            , templateUrl: 'app/pages/calendar/calendar.panel.html'
        };
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.calendar').factory('calendarService', calendarService);
    /** @ngInject */
    function calendarService($http, $q, APP_CONSTANTS) {
        return {
            getHerdsByTeam: getHerdsByTeam,
            getEvents: getEvents,
            addNewEvent: addNewEvent,
            updateEvent: updateEvent,
            getPicturesByHerd: getPicturesByHerd,
            addPictureToEvent: addPictureToEvent,
            removePictureFromEvent: removePictureFromEvent
        }

        function getHerdsByTeam(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);

        };

        function getEvents(suffix) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'calendarevents' + suffix).then(success).catch(error);
        }

        function addNewEvent(herd_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/calendarevents' + suffix).then(success).catch(error);
        }

        function updateEvent(herd_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/calendarevents' + suffix).then(success).catch(error);
        }

        function getPicturesByHerd(herd_id) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/pictures?-orderby=-imagecommentdate').then(success).catch(error);

        };

        function addPictureToEvent(event_id, picture_id) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'calendarevents/' + event_id + '/pictures/' + picture_id).then(success).catch(error);

        };

        function removePictureFromEvent(event_id, picture_id) {
            return $http.delete(APP_CONSTANTS.animals_base_url + 'calendarevents/' + event_id + '/pictures/' + picture_id).then(success).catch(error);

        };

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular
    .module("My.pages")
    .controller("arvestaDashboardCtrl", arvestaDashboardCtrl);
  /** @ngInject */
  function arvestaDashboardCtrl(
    $timeout,
    aDashboardsService,
    $rootScope,
    arvestaDashboardService,
    $filter,
    $uibModal,
    $uibModalStack,
    $scope,
    $q,
    dashboardsDataService,
    toastr,
    $interval,
    A_DASH_CONSTANTS,
    $location,
    $state,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var panelTimeout;
    var viz;
    var herdsPromise;
    var dashboardsPromise;
    var addToReportPromise;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    vm.$onInit = onInit;
    vm.changeSheet = changeSheet;
    vm.goBack = goBack;
    vm.openRangeSelector = openRangeSelector;
    vm.closeModal = closeModal;
    vm.setRange = setRange;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.closeCreateReport = closeCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.setReportDate = setReportDate;
    vm.setReportData = setReportData;
    vm.showTopBar = showTopBar;
    vm.getFrameClass = getFrameClass;
    vm.showChangeState = showChangeState;
    vm.showQuickButtons = showQuickButtons;
    vm.changeState = changeState;
    vm.quickSetDates = quickSetDates;

    function onInit() {
      vm.showCreateReportButton = false;
      vm.showAddToReportButton = false;
      vm.disableRangeSelector = true;
      vm.showCreateReportBlock = false;
      vm.reportError = false;
      vm.errorLoading = false;
      vm.showButtons = false;
      vm.noAvailableDashboards = false;
      vm.showBackButton = false;
      vm.includePPoints = false;
      vm.includeIPoints = false;

      setDates();
      $timeout(function () {
        vm.initDone = true;
        handleData(vm.dashboardData);
        panelTimeout = $timeout(function () {
          var containerDiv = document.getElementById("dashboard-panel");
          var height;
          if (containerDiv) {
            height = containerDiv.offsetHeight;
          }
          if (height == 666) {
            try {
              var bodyHeight =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
              var bodyWidth =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
              if (bodyWidth > 767) {
                var newHeight = bodyHeight - 300;
                document.getElementById(
                  "dashboard-panel"
                ).firstChild.style.height = newHeight + "px";
                var newHeightFrame = bodyHeight - 330;
                document.getElementById("dashboard-frame").style.height =
                  newHeightFrame + "px";
              } else {
                var newHeight = bodyHeight - 435;
                document.getElementById(
                  "dashboard-panel"
                ).firstChild.style.height = newHeight + "px";
                var newHeightFrame = bodyHeight - 465;
                document.getElementById("dashboard-frame").style.height =
                  newHeightFrame + "px";
              }
            } catch (error) {
              console.log(error);
            }
          }
        }, 0);
      }, 0);
    }

    function setDates() {
      vm.endDate = new Date(
        moment()
          .hour(23)
          .minute(59)
          .seconds(59)
          .millisecond(999)
          .subtract(2, "days")
      );
      vm.startDate = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(33, "days")
          .toISOString()
      );
      vm.actualStartDate = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(8, "days")
          .toISOString()
      );
      vm.initStartDate = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(33, "days")
          .toISOString()
      );
    }

    function handleData(data) {
      vm.style = data.style;
      vm.allDashboards = data.allDashboards;
      vm.currentLng = data.language;
      vm.workLocally = data.workLocally;
      vm.selectedHerds = data.selectedHerds;
      vm.handleViewData = data.handleViewData;
      vm.viewDataDashboard = data.viewDataDashboard;
      vm.selectedTeam = data.selectedTeam;
      vm.user = data.user;
      vm.state = data.state;
      vm.frameClass = data.frameClass;
      vm.showTBar = data.showTopBar;
      vm.changeStateVisible = data.changeStateVisible;
      vm.quickButtonsVisible = data.quickButtonsVisible;
      vm.stateList = setStateList(data.stateList);
      vm.checkMRO = data.checkMRO;
      vm.checkMilk = data.checkMilk;
      vm.checkConcentrate = data.checkConcentrate;
      vm.handleBasis = data.handleBasis;
      vm.basisValues = data.basisValues;
      vm.basisValueParameterName = data.basisValueParameterName;
      vm.checkP100 = data.checkP100;
      vm.checkMilkings = data.checkMilkings;
      vm.category = data.category;
      embedDashboard(data.dashboard);
    }

    function setStateList(stateList) {
      var list = [];

      if (stateList && stateList.length) {
        for (var i = 0; i < stateList.length; i++) {
          var state = stateList[i];
          if (!state.permission) {
            list.push(state);
          } else {
            if (permissionService.can(state.permission)) {
              list.push(state);
            }
          }
        }
      }
      return list;
    }

    function embedDashboard(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.currentDashboardName = dashboard.title;
      vm.dashboardLinks = aDashboardsService.getDashboardLinks(
        dashboard.id,
        vm.style
      );

      vm.isActualDashboard = aDashboardsService.getIsActual(
        vm.currentDashboard
      );
      if (vm.isActualDashboard) {
        vm.actualDashboardOpen = true;
        vm.startDate = angular.copy(vm.actualStartDate);
      } else {
        vm.actualDashboardOpen = false;
        vm.startDate = angular.copy(vm.initStartDate);
      }

      sendShowPanicButtonEvent(false);
      vm.disableRangeSelector = true;
      vm.showActualCurrentDateMessage = false;
      vm.currentSheetName = angular.copy(dashboard.description);
      aDashboardsService.current_dashboard = vm.currentSheetName;
      var url = dashboard.url;
      if (vm.checkMRO) {
        setIsMRO(vm.currentDashboard);
      }
      if (vm.checkP100) {
        setIsPer100(vm.currentDashboard);
      }
      embed(url);
    }

    function embed(url) {
      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(
          tableau.TableauEventName.PARAMETER_VALUE_CHANGE
        );
        viz.dispose();
      }

      if (vm.workLocally) {
        var url = openDashboard(url, deviceType);
      } else {
        return arvestaDashboardService
          .setSession(url)
          .then(function (response) {
            vm.showButtons = true;
            var url = response.headers("tabvis-location");
            openDashboard(url, deviceType);
          })
          .catch(function (response) {
            vm.disableRangeSelector = false;
            console.log("error getting tabvis-location header");
          });
      }
    }

    function openDashboard(url, deviceType) {
      if (url) {
        url = url + "&:render=true&:refresh=yes";
        var options = {
          "herd param": setHerdParam(vm.selectedHerds),
          "Start Date": $filter("date")(vm.initStartDate, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.endDate, "yyyy-MM-dd"),
          device: deviceType,
          onFirstInteractive: function () {
            $timeout(function () {
              vm.disableRangeSelector = false;
              vm.disableAddToReport = false;
              sendShowPanicButtonEvent(true);
            }, 100);
            $timeout(function () {
              vm.showAddToReportButton = true;
              vm.showCreateReportButton = true;
            }, 200);
          },
        };

        if (vm.handleBasis && vm.basisValues && vm.basisValues.length) {
          var basis_value = getBasisValue(vm.basisValues, vm.endDate);
          options[vm.basisValueParameterName] = basis_value;
        }

        $timeout(function () {
          var containerDiv = document.getElementById("dashboard-frame");
          viz = new tableau.Viz(containerDiv, url, options);
          if (vm.state != "home-arvesta") {
            viz.addEventListener(
              tableau.TableauEventName.TAB_SWITCH,
              onTabSwitch
            );
          }
          if (vm.state == "home-arvesta") {
            viz.addEventListener(
              tableau.TableauEventName.MARKS_SELECTION,
              onMarksSelection
            );
          }
          if (vm.state == "concentrate.overview") {
            viz.addEventListener(
              tableau.TableauEventName.PARAMETER_VALUE_CHANGE,
              onParameterChange
            );
          }
        }, 200);
      }
    }

    function getBasisValue(values, date) {
      values = $filter("orderBy")(values, "DateValidFrom", true);
      var value = values.find(function (_value) {
        return moment(_value.DateValidFrom).isBefore(date);
      });

      if (value) {
        return value.BasisRationKg;
      }

      return null;
    }

    function updateBasisAfterEndDateChange() {
      if (vm.basisValues && vm.basisValues.length) {
        var basis_value = getBasisValue(vm.basisValues, vm.endDate);
        if (basis_value) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(vm.basisValueParameterName, basis_value);
        }
      }
    }

    function setHerdParam(selectedHerds) {
      if (selectedHerds && selectedHerds.length) {
        if (selectedHerds.length == 1) {
          return selectedHerds[0];
        } else {
          var herdParam = "";
          selectedHerds.forEach(function (herd, index) {
            herdParam += herd;
            if (index < selectedHerds.length - 1) {
              herdParam += " ";
            }
          });
          return herdParam;
        }
      }
      return 0;
    }

    function onTabSwitch(event) {
      vm.showActualCurrentDateMessage = false;
      vm.disableAddToReport = false;
      var activeSheet = event.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = event.getOldSheetName();
      var newSheetName = event.getNewSheetName();
      vm.currentDashboardName = newSheetName;
      $timeout(function () {
        aDashboardsService.current_dashboard = newSheetName;
      }, 0);
      vm.currentDashboard =
        aDashboardsService.getDashboardIdByName(newSheetName);
      var previousSheetId =
        aDashboardsService.getDashboardIdByName(oldSheetName);
      vm.lastSheetName = oldSheetName;
      vm.dashboardLinks = aDashboardsService.getDashboardLinks(
        vm.currentDashboard,
        vm.style,
        vm.category,
        previousSheetId
      );
      vm.isActualDashboard = aDashboardsService.getIsActual(
        vm.currentDashboard
      );

      if (vm.checkMRO) {
        setIsMRO(vm.currentDashboard);
      }

      if (vm.checkP100) {
        setIsPer100(vm.currentDashboard);
      }

      if (event.getEventName() == "tabswitch") {
        if (vm.handleViewData && vm.viewDataDashboard) {
          if (newSheetName == vm.viewDataDashboard) {
            vm.disableAddToReport = true;
            setBackButtonVisibility(true);
          } else {
            setBackButtonVisibility(false);
          }
        }

        var actualByDateSheet = aDashboardsService.getIsActualByDate(
          vm.currentDashboard
        );

        if (actualByDateSheet) {
          event
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(i18nFilter(actualByDateSheet))
            .getFiltersAsync()
            .then(function (filter) {
              for (var i = 0; i < filter.length; i++) {
                var name = filter[i].getFieldName();
                var lastMilkDayFilter;
                if (
                  name &&
                  (name.indexOf("(Datum)") != -1 ||
                    name.indexOf("(Date)") != -1)
                ) {
                  lastMilkDayFilter = name;
                  break;
                }
              }

              if (lastMilkDayFilter) {
                var filter_values = filter.get(lastMilkDayFilter);
                if (filter_values) {
                  var day = filter_values.getAppliedValues();
                  if (day.length == 1) {
                    day = day[0].value;
                    vm.actualFilterValue = {
                      type: 1,
                      day: new Date(day),
                      dim: null,
                      parity: null,
                    };
                    showActualDateMessage();
                  }
                }
              }
            });
        }
      }

      if (vm.isActualDashboard) {
        vm.actualDashboardOpen = true;
        vm.disableQuickButtons = true;
        if (vm.checkMilk) {
          aDashboardsService.milkTrendActiveType = "actual";
        }
        if (vm.checkConcentrate) {
          aDashboardsService.concentrateActiveType = "actual";
        }
        if (vm.checkMilkings) {
          aDashboardsService.milkingsActiveType = "actual";
        }

        $timeout(function () {
          vm.startDate = angular.copy(vm.actualStartDate);
        }, 0);
      } else {
        vm.actualDashboardOpen = false;
        vm.disableQuickButtons = false;

        if (vm.checkMilk) {
          aDashboardsService.milkTrendActiveType = "trend";
        }

        if (vm.checkConcentrate) {
          aDashboardsService.concentrateActiveType = "trend";
        }
        if (vm.checkMilkings) {
          aDashboardsService.milkingsActiveType = "trend";
        }
        $timeout(function () {
          vm.startDate = angular.copy(vm.initStartDate);
        });
      }
    }

    function showActualDateMessage() {
      $timeout(function () {
        vm.showActualCurrentDateMessage = true;
      }, 100);
    }

    function setIsMRO(dashboard_id) {
      vm.isMRODashboard = aDashboardsService.getIsMRO(dashboard_id);
      if (vm.isMRODashboard) {
        aDashboardsService.milkTrendSourceType = "mro";
      } else {
        aDashboardsService.milkTrendSourceType = null;
      }
    }

    function setIsPer100(dashboard_id) {
      vm.isPer100Dashboard = aDashboardsService.getIsPer100(dashboard_id);
      if (vm.isPer100Dashboard) {
        aDashboardsService.concentrateSourceType = "per100";
      } else {
        aDashboardsService.concentrateSourceType = null;
      }
    }

    function onMarksSelection(event) {
      viz
        .getWorkbook()
        .getParametersAsync()
        .then(function (parameters) {
          var herd_param;
          for (var i = 0; i < parameters.length; i++) {
            if (parameters[i].getName() == "herd param") {
              herd_param = parameters[i].getCurrentValue().value;
              break;
            }
          }
          if (herd_param) {
            vm.selectedHerds = [herd_param];
            $rootScope.$broadcast("default_herd_with_redirect", herd_param);
          } else {
            vm.selectedHerds = [];
            $rootScope.$broadcast("default_herd_with_redirect", null);
          }
        });
    }

    function onParameterChange(event) {
      if (event.getParameterName() == vm.basisValueParameterName) {
        if (vm.selectedHerds && vm.selectedHerds.length == 1) {
          event.getParameterAsync().then(function (parameter) {
            var parameter_v = parameter.getCurrentValue();
            var value = parameter_v.value;
            var obj = {
              BasisRationKg: value,
              DateValidFrom: moment(vm.endDate)
                .subtract(9, "days")
                .format("YYYY-MM-DD"),
              HerdId: vm.selectedHerds[0],
            };
            return arvestaDashboardService
              .setRationBasis(obj)
              .then(function (response) {})
              .catch(function (error) {
                console.log(error);
              });
          });
        }
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function changeSheet(link) {
      var sheet = link.sheetName;
      if (!link.translated) {
        sheet = i18nFilter(sheet);
      }

      if (viz) {
        viz.getWorkbook().activateSheetAsync(sheet);
      }
    }

    function goBack() {
      viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
      setBackButtonVisibility(false);
    }

    function openRangeSelector() {
      if (!vm.disableRangeSelector) {
        vm.modalStartDate = angular.copy(vm.startDate);
        vm.modalEndDate = angular.copy(vm.endDate);
        openModal("app/pages/arvestaDashboard/rangeSelector.modal.html", "sm");
      }
    }

    function setRange() {
      var startDateChanged = false;
      var endDateChanged = false;
      if (!moment(vm.startDate).isSame(vm.modalStartDate)) {
        startDateChanged = true;
      }
      if (!moment(vm.endDate).isSame(vm.modalEndDate)) {
        endDateChanged = true;
      }
      var range_error = checkRangeError(
        vm.actualDashboardOpen,
        vm.modalStartDate,
        vm.modalEndDate
      );
      if (!range_error) {
        vm.startDate = angular.copy(vm.modalStartDate);
        vm.endDate = angular.copy(vm.modalEndDate);

        if (vm.actualDashboardOpen) {
          vm.actualStartDate = new Date(
            moment(vm.endDate).subtract(6, "days").toISOString()
          );
          vm.startDate = angular.copy(vm.actualStartDate);
          vm.initStartDate = new Date(
            moment(vm.endDate)
              .subtract(31, "days")
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .toISOString()
          );
          startDateChanged = true;
        } else {
          vm.initStartDate = angular.copy(vm.startDate);
          vm.actualStartDate = new Date(
            moment(vm.endDate)
              .subtract(6, "days")
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .toISOString()
          );
        }
        applyParameters(startDateChanged, endDateChanged);
        closeModal();
      }
    }

    function applyParameters(startDateChanged, endDateChanged) {
      var startDate = vm.isActualDashboard ? vm.initStartDate : vm.startDate;
      var endDate = vm.endDate;
      if (viz) {
        if (startDateChanged && endDateChanged) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "Start Date",
              $filter("date")(startDate, "yyyy-MM-dd")
            )
            .then(function (param) {
              viz
                .getWorkbook()
                .changeParameterValueAsync(
                  "End Date",
                  $filter("date")(endDate, "yyyy-MM-dd")
                )
                .then(function (param) {
                  if (vm.handleBasis) {
                    updateBasisAfterEndDateChange();
                  }
                });
            });
        } else if (startDateChanged && !endDateChanged) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "Start Date",
              $filter("date")(startDate, "yyyy-MM-dd")
            );
        } else if (!startDateChanged && endDateChanged) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(endDate, "yyyy-MM-dd")
            )
            .then(function (param) {
              if (vm.handleBasis) {
                updateBasisAfterEndDateChange();
              }
            });
        }
      }
    }

    function openAddToReportModal() {
      vm.addToReportModalLoading = true;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/arvestaDashboard/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds[0];
        suffix = suffix + "&Date=" + date;

        if (vm.workLocally) {
          var response = A_DASH_CONSTANTS.development.reports;
          handleReports(init, createReport, response);
        } else {
          return arvestaDashboardService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              if (createReport) {
                addToReportPromise.reject();
              }
            });
        }
      } else {
        if (createReport) {
        } else {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      vm.addedToReport = added;
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = aDashboardsService.getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = aDashboardsService.getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.endDate = new Date(addedToReport[j].endDate);
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.startDate = new Date(addedToReport[j].startDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entryId = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = aDashboardsService.getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = aDashboardsService.getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      handleEntry(entry);
    }

    function handleEntry(entry) {
      vm.modalComment = "";
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = aDashboardsService.getFilterListByDashboardId(
          vm.currentDashboard
        );

        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        if (filterList.zoomFilter) {
          var name = "pr_zf_" + filterList.zoomFilter.filter.name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_default = filterList.parameters[j].translate
                        ? i18nFilter(filterList.parameters[j].default)
                        : filterList.parameters[j].default;
                      if (parameters[i].getCurrentValue().value != p_default) {
                        filter +=
                          "&" +
                          filterList.parameters[j].name +
                          "=" +
                          parameters[i].getCurrentValue().value;
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length || filterList.zoomFilter) {
              var worksheetName = filterList.filters.length
                ? filterList.filters[0].worksheetName
                : filterList.zoomFilter.worksheetName;
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  var filterValues = [];
                  var compareFilerValues = [];
                  var zoomFilterType;
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    if (filterList.filters.length) {
                      for (var j = 0; j < filterList.filters.length; j++) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();

                          if (filterList.filters[j].date_filter) {
                            filterValue = getDateFilter(
                              filter_values,
                              filterList.filters[j].alias
                            );
                          } else {
                            if (
                              (filterList.filters[j].m != undefined) &
                              (filterList.filters[j].m == filter_values.length)
                            ) {
                              filterValue = getFilterString(
                                filter_values,
                                name
                              );
                            } else {
                              if (
                                filtersResponse[i].getFilterType() ==
                                "categorical"
                              ) {
                                if (!filtersResponse[i].getIsAllSelected()) {
                                  filterValue = getFilterString(
                                    filter_values,
                                    name
                                  );
                                }
                              } else {
                                filterValue = getFilterString(
                                  filter_values,
                                  name
                                );
                              }
                            }
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          filterValue = null;
                          vm[p_name].resolve();
                        }
                      }
                    }
                    if (filterList.zoomFilter) {
                      if (name == filterList.zoomFilter.filter.name) {
                        zoomFilterType = filterList.zoomFilter.filter.type;
                        filterValues = filtersResponse[i].getAppliedValues();
                      }
                      if (filterList.zoomFilter.compareFilter) {
                        if (name == filterList.zoomFilter.compareFilter.name) {
                          compareFilerValues =
                            filtersResponse[i].getAppliedValues();
                        }
                      }
                    }
                  }

                  var filterValueLength = filterValues.length;
                  var compareFilterValueLength = compareFilerValues.length;

                  if (
                    compareFilterValueLength == 0 ||
                    compareFilterValueLength != filterValueLength
                  ) {
                    var zoomFilterValue = filterValues.map(function (value) {
                      return value.value;
                    });

                    if (zoomFilterValue && zoomFilterValue.length) {
                      filter +=
                        "&" +
                        (zoomFilterType == 1
                          ? i18nFilter("_dashboard_field_animal_ear_tag_")
                          : "AnimalEartag") +
                        "=" +
                        zoomFilterValue;
                    }

                    var p_name = "pr_zf_" + filterList.zoomFilter.filter.name;
                    vm[p_name].resolve();
                  } else {
                    var p_name = "pr_zf_" + filterList.zoomFilter.filter.name;
                    vm[p_name].resolve();
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getDateFilter(value, name) {
      var filter = "";
      if (value.length && value.length == 1) {
        var date = moment(value[0].value).format("YYYY-MM-DD");
        filter = "&" + i18nFilter(name) + "=" + date;
      }
      return filter;
    }

    function setEntry(filterUrl, paramName) {
      var startDate;
      startDate =
        moment(vm.startDate)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var endDate =
        moment(vm.endDate)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: endDate,
        startDate: startDate,
        locale: lng,
        dashboardId: vm.currentDashboard,
        filter: filterUrl,
      };
      return arvestaDashboardService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function openCreateReport() {
      if (
        vm.showAddToReportButton &&
        vm.selectedHerds.length == 1 &&
        !vm.disableAddToReport
      ) {
        vm.includePPoints = false;
        vm.includeIPoints = false;
        var parser = new UAParser();
        var os = parser.getOS();
        var brw = parser.getBrowser();
        if (os.name == "iOS" && brw.name == "Mobile Safari") {
          vm.safariMobileUsed = true;
        } else {
          vm.safariMobileUsed = false;
        }
        vm.reportDate = new Date();
        vm.showCreateReportBlock = true;
        vm.reportLoading = true;
        vm.pdfLoading = false;
        if (vm.selectedHerds && vm.selectedHerds.length == 1) {
          herdsPromise = $q.defer();
          dashboardsPromise = $q.defer();
          addToReportPromise = $q.defer();
          $q.all([
            herdsPromise.promise,
            dashboardsPromise.promise,
            addToReportPromise.promise,
          ])
            .then(function () {
              vm.reportError = false;
              vm.reportDashboards = checkForAddedToReport(
                vm.allReportDashboards,
                vm.addedToReport
              );
              if (vm.reportDashboards.length) {
                vm.reportLoading = false;
                vm.herdNotSelected = false;
              } else {
                vm.showCreateReportBlock = false;
                vm.noAvailableDashboards = true;
                vm.reportLoading = false;
                vm.herdNotSelected = false;
              }
            })
            .catch(function (error) {
              vm.reportLoading = false;
              vm.reportError = true;
              vm.pdfLoading = false;
            });
          getAddedToReport(true, vm.reportDate, true);
          var herd_id = vm.selectedHerds[0];
          checkHerds(herd_id);
          checkAllDashboards();
        } else {
          vm.reportLoading = false;
          $interval.cancel(loadingDotsInterval);
          vm.herdNotSelected = true;
        }
      }
    }

    function checkHerds(herd_id) {
      if (
        arvestaDashboardService.loadedHerds &&
        arvestaDashboardService.loadedHerds.herds &&
        arvestaDashboardService.loadedHerds.herds.length &&
        arvestaDashboardService.loadedHerds.team_id &&
        arvestaDashboardService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          arvestaDashboardService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return arvestaDashboardService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function checkAllDashboards() {
      vm.allReportDashboards = aDashboardsService.getReportDashboards(
        vm.allDashboards,
        vm.currentLng,
        vm.initStartDate,
        vm.endDate,
        vm.actualStartDate
      );
      //to do
      vm.allReportDashboards = vm.allReportDashboards.map(function (dashboard) {
        dashboard.startDate = dashboard.start_date;
        dashboard.endDate = dashboard.end_date;
        return dashboard;
      });

      dashboardsPromise.resolve();
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function openReportDashboardPeriodModal(index) {
      vm.reportModalStartDate = vm.reportDashboards[index].startDate;
      vm.reportModalEndDate = vm.reportDashboards[index].endDate;
      vm.reportActualDashboard = vm.reportDashboards[index].actual;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal("app/pages/common/reportRangeSelector.modal.html", "sm");
    }

    function setReportDashboardRange() {
      var rangeError = checkRangeError(
        vm.reportActualDashboard,
        vm.reportModalStartDate,
        vm.reportModalEndDate
      );
      if (!rangeError) {
        vm.setRangeModalLoading = true;
        vm.reportDashboards[vm.selectedReportDashboardIndex].endDate =
          vm.reportModalEndDate;
        if (vm.reportActualDashboard) {
          vm.reportDashboards[vm.selectedReportDashboardIndex].startDate =
            new Date(
              moment(vm.reportModalEndDate).subtract(6, "days").toISOString()
            );
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].startDate =
            vm.reportModalStartDate;
        }

        closeModal();
      }
    }

    function checkRangeError(actualOpen, startDate, endDate) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(endDate)) {
        error = true;
      }
      if (!actualOpen) {
        if (moment(endDate).isBefore(startDate)) {
          error = true;
        }
      }
      return error;
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/common/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
        vm.selectedReportDashboard.comment;
      closeModal();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      vm.reportLoading = true;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function setReportData() {
      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        include_positive_points: vm.includePPoints,
        include_points_to_improve: vm.includeIPoints,
        herd_name: vm.currentHerdName,
        work_locally: vm.workLocally,
        title: vm.reportTitle,
        style: vm.style,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          return dashboardsDataService
            .createPDF(data)
            .then(function (response) {
              vm.pointsToImprove = "";
              vm.positivePoints = "";
              $timeout(function () {
                vm.showCreateReportBlock = false;
                vm.reportLoading = false;
                vm.pdfLoading = false;
                $interval.cancel(loadingDotsInterval);
              }, 500);
            })
            .catch(function (error) {
              console.log(error);

              if (error) {
                toastr.error(i18nFilter(error));
              }

              $timeout(function () {
                vm.showCreateReportBlock = false;
                vm.reportLoading = false;
                vm.pdfLoading = false;
                $interval.cancel(loadingDotsInterval);
              }, 500);
            });
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function showTopBar() {
      return vm.showTBar;
    }

    function getFrameClass() {
      return vm.frameClass;
    }

    function showChangeState() {
      return vm.changeStateVisible;
    }

    function showQuickButtons() {
      return vm.quickButtonsVisible;
    }

    function changeState(state) {
      if (state) {
        $state.go(state);
      }
    }

    function quickSetDates(period) {
      vm.endDate = new Date(
        moment()
          .hour(23)
          .minute(59)
          .seconds(59)
          .millisecond(999)
          .subtract(2, "days")
      );

      vm.actualStartDate = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(8, "days")
          .toISOString()
      );

      switch (period) {
        case 1:
          vm.startDate = new Date(
            moment()
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .subtract(2, "days")
              .subtract(3, "months")
          );

          vm.initStartDate = angular.copy(vm.startDate);
          break;

        case 2:
          vm.startDate = new Date(
            moment()
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .subtract(2, "days")
              .subtract(1, "years")
          );

          vm.initStartDate = angular.copy(vm.startDate);
          break;

        case 3:
          vm.startDate = new Date(
            moment()
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .subtract(2, "days")
              .subtract(5, "years")
          );

          vm.initStartDate = angular.copy(vm.startDate);
          break;

        default:
          break;
      }

      applyParameters(true, true);
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == vm.state) {
        var obj = {
          viz: viz,
          comment: data.comment,
          last_selected_mark: vm.lastSelectedMark,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          user_id: vm.user.user_id,
          last_sheet_name: vm.lastSheetName,
          dashboard: vm.currentDashboardName,
          host: $location.host(),
          url: $location.url(),
        };

        if (viz) {
          aDashboardsService.sendErrorInfo(obj);
        } else {
          $rootScope.$broadcast("panic_button_error");
        }
      }
    });

    $scope.$on("$destroy", function () {
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(
          tableau.TableauEventName.PARAMETER_VALUE_CHANGE
        );
        viz.dispose();
      }
    });
  }
})();

(function () {
  "use strict";

  angular.module("My.pages").directive("arvestaDashboard", arvestaDashboard);

  /** @ngInject */
  function arvestaDashboard() {
    var directive = {
      restrict: "AE",
      templateUrl: "app/pages/arvestaDashboard/arvestaDashboard.html",
      scope: {
        dashboardData: "=",
      },
      controller: "arvestaDashboardCtrl",
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages")
    .factory("arvestaDashboardService", arvestaDashboardService);
  /** @ngInject */
  function arvestaDashboardService(APP_CONSTANTS, $http, $q) {
    return {
      getDashboards: getDashboards,
      setTableauTenant: setTableauTenant,
      setSession: setSession,
      getHerdsByTeam: getHerdsByTeam,
      addToReport: addToReport,
      getReports: getReports,
      getOrders: getOrders,
      setRationBasis: setRationBasis,
      getRationBasis: getRationBasis,
      loadedHerds: {},
      //allDashboards: {},
      //loadedDashboards: {}
    };

    function getDashboards(team_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url + team_id + "/dashboards" + suffix,
          {
            withCredentials: true,
            timeout: 20000,
          }
        )
        .then(success)
        .catch(error);
    }

    function setTableauTenant(team_id) {
      return $http
        .post(
          APP_CONSTANTS.tableau_base_url + team_id + "/session",
          {},
          {
            withCredentials: true,
          }
        )
        .then(success)
        .catch(error);
    }

    function getHerdsByTeam(team_id) {
      return $http
        .get(APP_CONSTANTS.backoffice_base_url + "teams/" + team_id + "/herds")
        .then(success)
        .catch(error);
    }

    function addToReport(obj) {
      return $http
        .post(APP_CONSTANTS.tableau_reports_base_url + "/reportentry", obj, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function getReports(suffix) {
      return $http
        .get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function getOrders(team_id) {
      return $http
        .get(APP_CONSTANTS.backoffice_base_url + "teams/" + team_id + "/orders")
        .then(success)
        .catch(error);
    }

    function setRationBasis(value) {
      return $http
        .post(APP_CONSTANTS.animals_base_url +"herds/basisrations", value)
        .then(success)
        .catch(error);
    }

    function getRationBasis(herd_id) {
      return $http
        .get(
          APP_CONSTANTS.animals_base_url +
            "herds/" +
            herd_id +
            "/basisrations"
        )
        .then(success)
        .catch(error);
    }

    function setSession(url) {
      return $http
        .get(url, {
          withCredentials: true,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          return $q.reject(error);
        });
    }

    function success(response) {
      return response.data;
    }

    function error(error) {
      return $q.reject(error);
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.claw_health")
    .controller("clawHealthCtrl", clawHealthCtrl);
  /** @ngInject */
  function clawHealthCtrl(
    $timeout,
    herdDashboardsService,
    clawHealtService,
    $q,
    APP_CONSTANTS,
    $rootScope,
    $http,
    $uibModalStack,
    $uibModal,
    $scope,
    $filter,
    $interval,
    toastr,
    cookiesService,
    dashboardsService,
    $location,
    Upload,
    $cookies,
    $state
  ) {
    var vm = this;
    var teamTimeout;
    var i18nFilter = $filter("i18n");
    var mapTimeout;
    var viz;
    var timeout;
    var herdIdentifierFiltterName;
    var herdParamName;
    var oldSheetName;
    var newSheetName;
    var startDateParameterName;
    var endDateParameterName;
    var dataDashboardName;
    var dataDashboardMilkName;
    var dataDashboardSheetName;
    var dataDashboardMilkSheetName;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var tmrParamName;
    var dmParamName;
    var dayFilterName;
    var TMR;
    var DryMatterChanged;
    var DryMatter;
    var herdsPromise;
    var addToReportPromise;
    var TMRchanged;
    var measureNameParam;
    var clawHealthMarkFilterPairs =
      APP_CONSTANTS.constants.clawHealthMarkFilterPairs;
    var addToReportPromise;
    var dashboardsPromise;
    var herdsPromise;
    var reasonFilter;
    var firstLesionFilter;
    var lesionTypeFilter;
    var lesionFilter;
    var showOthersFilter;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.openRangeSelector = openRangeSelector;
    vm.addToReport = addToReport;
    vm.openAddToReportModal = openAddToReportModal;
    vm.openCreateReport = openCreateReport;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportData = setReportData;
    vm.showStartEndDate = showStartEndDate;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.openReportDashboardDayModal = openReportDashboardDayModal;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.setActualReportDate = setActualReportDate;
    vm.setRange = setRange;
    vm.closeModal = closeModal;
    vm.goBack = goBack;
    vm.init = init;
    vm.sendErrorInfo = sendErrorInfo;
    vm.openWarningModal = openWarningModal;
    vm.redirectToHerds = redirectToHerds;
    init();

    function setStrings() {
      dataDashboardName = $filter("i18n")(
        "_claw_health_dashboard_name_show_data_dashboard_"
      );
      dataDashboardMilkName = "Show data Milk";
      dataDashboardSheetName = $filter("i18n")(
        "_claw_health_wrks_name_show_all_"
      );
      dataDashboardMilkSheetName = "Show all Milk";
      herdParamName = "Herd Parameter";
      herdIdentifierFiltterName = "HerdIdentifier";
      oldSheetName = $filter("i18n")(
        "_claw_health_dashboard_name_home_claw_health_dashboard_"
      );
      newSheetName = $filter("i18n")(
        "_claw_health_dashboard_name_claw_health_dashboard_"
      );
      startDateParameterName = "Start Date";
      endDateParameterName = "End Date";
      measureNameParam = "MeasureNameParam";
      reasonFilter = i18nFilter("_claw_health_filter_reason_");
      firstLesionFilter = i18nFilter("_claw_health_filter_first_lesion_");
      lesionTypeFilter = i18nFilter("_claw_health_filter_lesion_type_");
      lesionFilter = i18nFilter("_claw_health_filter_lesion_");
      showOthersFilter = i18nFilter("_claw_health_parameter_show_others_");
    }

    function init() {
      setBackButtonVisibility(false);
      setDates();

      setStrings();
      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.clawHealthdashboardIdList =
        APP_CONSTANTS.constants.clawHealthdashboardIdList;
      vm.dashboards = [];
      vm.work_locally = false;
      vm.showCreateReportButton = false;
      vm.errorLoading = false;
      vm.loadingDashboards = true;
      vm.showButtons = false;
      vm.showCreateReportBlock = false;
      vm.noAvailableDashboards = false;
      vm.reselectTeamError = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.defaultValues && vm.defaultValues.team_id) {
        getDashboards(vm.defaultValues.team_id);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function setDates() {
      vm.end_date = new Date(
        moment().hour(23).minute(59).seconds(59).millisecond(999)
      );
      vm.today = angular.copy(vm.end_date);
      vm.lastMonthDate = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(1)
          .subtract(1, "months")
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );
    }

    function getDashboards(team_id) {
      var dashboards = angular.copy(herdDashboardsService.tableauStored);
      if (vm.work_locally) {
        dashboards.dashboards = [];
        dashboards.team_id = team_id;
        dashboards.expires = new Date("2100-12-31");
        herdDashboardsService.tableauStored = dashboards;
      }

      if (dashboards.dashboards && dashboards.team_id == team_id) {
        if (moment(dashboards.expires).isBefore(moment())) {
          useAPI(team_id);
        } else {
          checkSelectedHerds(dashboards.dashboards);
        }
      } else {
        useAPI(team_id);
      }
    }

    function useAPI(team_id) {
      localStorage.setItem("tableauLoading", true);
      timeout = $q.defer();
      var setSession = setSessionHandler(team_id);
      setSession.then(
        function (data) {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return clawHealtService
            .getDashboards(team_id, tableauSuffix)
            .then(function (response) {
              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
              };
              herdDashboardsService.tableauStored = obj;
              localStorage.removeItem("tableauLoading");
              $rootScope.$broadcast("tableau_loaded");
              checkSelectedHerds(response);
            })
            .catch(function (error) {
              localStorage.removeItem("tableauLoading");
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            });
        },
        function (error) {
          if (!vm.teamReselected) {
            localStorage.removeItem("tableauLoading");
            vm.loadingDashboards = false;
            vm.errorLoading = true;
          } else {
            vm.teamReselected = false;
          }
        }
      );
    }

    function setSessionHandler(team_id) {
      var result = $q.defer(),
        setSession,
        url = APP_CONSTANTS.tableau_base_url + team_id + "/session";
      setSession = $http({
        method: "post",
        url: url,
        data: {},
        cache: false,
        timeout: timeout.promise,
        withCredentials: true,
      });
      setSession.success(function (data, status, headers, config) {
        result.resolve(data);
      });
      setSession.error(function (data, status, headers, config) {
        result.reject(data);
      });
      return result.promise;
    }

    function checkSelectedHerds(dashboards) {
      var n_herds = vm.selectedHerds.length;
      if (n_herds == 1) {
        return clawHealtService
          .getHerdById(vm.selectedHerds[0])
          .then(function (response) {
            if (response && response.Latitude && response.Longitude) {
              processDashboards(dashboards, false);
            } else {
              processDashboards(dashboards, true);
            }
          })
          .catch(function (error) {
            console.log(error);
            processDashboards(dashboards, true);
          });
      } else {
        processDashboards(dashboards, false);
      }
    }

    function processDashboards(response, without_address) {
      var clawHealthDashboardId = "Homeclawhealthdashboard";
      if (response.length > 0) {
        var dashboards = [];
        for (var i = 0; i < response.length; i++) {
          if (
            response[i].category == "health" &&
            response[i].id == clawHealthDashboardId
          ) {
            vm.clawHealthDashboard = response[i];
          }
        }
        vm.allDashboards = response;
        vm.dashboards = dashboards;
        vm.mapActive = vm.clawHealthDashboard;
        if (vm.clawHealthDashboard) {
          if (vm.work_locally) {
            embedPage(vm.clawHealthDashboard, false, without_address);
          } else {
            embedPage(vm.clawHealthDashboard, true, without_address);
          }
          mapTimeout = $timeout(function () {
            var height = document.getElementById("panel-map").offsetHeight;
            if (height == 666) {
              try {
                var bodyHeight =
                  window.innerHeight ||
                  document.documentElement.clientHeight ||
                  document.body.clientHeight;
                var bodyWidth =
                  window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth;
                if (bodyWidth > 767) {
                  var newHeight = bodyHeight - 300;
                  document.getElementById("panel-map").firstChild.style.height =
                    newHeight + "px";
                  var newHeightFrame = bodyHeight - 330;
                  document.getElementById("dashboard-area").style.height =
                    newHeightFrame + "px";
                  document.getElementById("frame").style.height =
                    newHeightFrame + "px";
                } else {
                  var newHeight = bodyHeight - 435;
                  document.getElementById("panel-map").firstChild.style.height =
                    newHeight + "px";
                  var newHeightFrame = bodyHeight - 465;
                  document.getElementById("dashboard-area").style.height =
                    newHeightFrame + "px";
                  document.getElementById("frame").style.height =
                    newHeightFrame + "px";
                }
              } catch (error) {
                console.log(error);
              }
            }
          }, 0);
        } else {
          vm.embed = null;
          vm.loadingDashboards = false;
          vm.noAvailableDashboards = true;
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function embedPage(dashboard, useTabvis, without_address) {
      vm.currentSheetName = angular.copy(dashboard.description);
      vm.loadingDashboards = false;
      var url = dashboard.url;
      vm.workSheetName = dashboard.description;
      $rootScope.$broadcast("home_dashboard_embedded", dashboard.description);
      embedUrl(url, useTabvis, without_address);
    }

    function embedUrl(url, useTabvis, without_address) {
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.dispose();
      }

      if (useTabvis) {
        if (vm.selectedHerds.length > 0) {
          url = url + "&herd=";
          for (var i = 0; i < vm.selectedHerds.length; i++) {
            if (i > 0) {
              url = url + ",";
            }
            url = url + vm.selectedHerds[i];
          }
        }
        return clawHealtService
          .setSession(url)
          .then(function (response) {
            vm.loadingDashboards = false;
            vm.showButtons = true;
            var url = response.headers("tabvis-location");
            embed(url, without_address);
          })
          .catch(function (response) {
            if (response.status && response.status == 404) {
              vm.noAvailableDashboards = true;
            } else {
              vm.errorLoading = true;
            }
            vm.embed = null;
            vm.loading = false;
            console.log("error getting tabvis-location header");
          });
      } else {
        if (vm.currentLng == "en-GB") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_en-GB_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        } else if (vm.currentLng == "en-US") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_en-GB_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        } else if (vm.currentLng == "fr-FR") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_fr-FR_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        } else if (vm.currentLng == "de-DE") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_de-DE_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        } else if (vm.currentLng == "nl-NL") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_nl-NL_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        } else if (vm.currentLng == "pl-PL") {
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-52-health-claw-module_nl-NL_twb/Homeclawhealthdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        var herdSuf = "";
        if (vm.selectedHerds.length > 0) {
          herdSuf = herdSuf + "&HerdIdentifier=";
          for (var i = 0; i < vm.selectedHerds.length; i++) {
            if (i > 0) {
              herdSuf = herdSuf + ",";
            }
            herdSuf = herdSuf + vm.selectedHerds[i];
          }
          url += herdSuf;
        }
        embed(url, without_address);
      }
    }

    function embed(url, without_address) {
      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Herd Parameter": 0,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          onFirstInteractive: function () {
            $timeout(function () {
              vm.disableCategoryButtons = false;
              sendShowPanicButtonEvent(true);
            }, 100);
            var workbook = viz.getWorkbook();
            var wrks = workbook.getActiveSheet().getWorksheets();
            var worksheetName;
            for (var i = 0; i < wrks.length; i++) {
              if (wrks[i].getName()) {
                worksheetName = wrks[i].getName();
                break;
              }
            }
            if (worksheetName && vm.selectedHerds.length == 0) {
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  wrks
                    .get(worksheetName)
                    .clearFilterAsync(herdIdentifierFiltterName);
                }
              }
            }
            viz
              .getWorkbook()
              .changeParameterValueAsync(measureNameParam, "0")
              .then(function (e) {
                if (vm.selectedHerds.length == 1 && without_address) {
                  viz
                    .getWorkbook()
                    .changeParameterValueAsync(
                      herdParamName,
                      vm.selectedHerds[0]
                    )
                    .then(function (r) {
                      viz.getWorkbook().activateSheetAsync(newSheetName);
                    });
                }
              });
            /*viz.getWorkbook().getParametersAsync().then(function (parameters) {
				console.log(parameters)
			})
			viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function(filters){
				console.log(filters)
			})*/
          },
        };
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
        }, 1000);

        /*
		viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, onParameterChange);*/
      }
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }
    function onTabSwitch(marksEvent) {
      var newSheetName = marksEvent.getNewSheetName();
      var wrks = marksEvent
        .getViz()
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets();
      var wrks = marksEvent
        .getViz()
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets();
      if (marksEvent.getEventName() == "tabswitch") {
        var worksheetName;
        vm.showCreateReportButton = true;
        vm.showAddToReportButton = true;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }
        if (worksheetName == "Home") {
          vm.showCreateReportButton = false;
          vm.showAddToReportButton = false;
        }
        /*marksEvent.getViz().getWorkbook().getParametersAsync().then(function (parameters) {
					  console.log(parameters)
				 })
				
				 wrks.get(worksheetName).getFiltersAsync().then(function (filters) {
					  console.log(filters)
				 })*/
        var currentSheet = newSheetName;
        vm.currentSheetId = getDashboardIdByName(currentSheet);
        if (
          marksEvent.getOldSheetName() == oldSheetName &&
          marksEvent.getNewSheetName() == newSheetName
        ) {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
          marksEvent
            .getViz()
            .getWorkbook()
            .getParametersAsync()
            .then(function (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                if (parameters[i].getName() == herdParamName) {
                  var herd_id = parameters[i].getCurrentValue().value;
                  vm.selectedHerds = [herd_id];
                  $rootScope.$broadcast(
                    "default_herd_from_claw_health_selected",
                    herd_id
                  );
                  break;
                }
              }
            });
        } else if (marksEvent.getNewSheetName() == oldSheetName) {
          setBackButtonVisibility(false);
          vm.selectedHerds = [];
          $rootScope.$broadcast("deselect_all_herds_claw_health");
          viz
            .getWorkbook()
            .changeParameterValueAsync(herdParamName, 0)
            .then(function (response) {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
            });
          marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(worksheetName)
            .clearFilterAsync(herdIdentifierFiltterName);
        } else if (
          marksEvent.getNewSheetName() == dataDashboardName ||
          marksEvent.getNewSheetName() == dataDashboardMilkName
        ) {
          vm.viewDataDashboard;
          if (marksEvent.getNewSheetName() == dataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardMilkSheetName;
          }
          var oldSheetNameData = marksEvent.getOldSheetName();
          //console.log(vm.lastSelectedMark)
          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          //   console.log(activeFilterName)
          checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          vm.lastSheetName = oldSheetNameData;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                resetFilter(listToClear[i]);
              }
            }
            //console.log("action", vm.actionFilterList);
            //console.log('clear', listToClear)
          } else {
            vm.actionFilterList = actionFilterList;
          }
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = clawHealthMarkFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function goBack() {
      var l = vm.actionFilterList.length;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterN(index) {
        return resetFilter(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }

      function resetFilter(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function openAddToReportModal() {
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/claw_health/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = [];
          handleReports(init, createReport, response);
        } else {
          return clawHealtService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var hasActual = false;
      var actualIndex;
      var actualList = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            list[i].comment = addedToReport[j].comment;
            list[i].end_date = new Date(addedToReport[j].endDate);
            list[i].start_date = new Date(addedToReport[j].startDate);
            list[i].selected = true;
            list[i].entry_id = addedToReport[j].id;
            list[i].filter = addedToReport[j].filter;
            list[i].report_date = isActualByDate(list[i])
              ? setActualDate(list[i].filter)
              : undefined;
          }
        }
      }
      if (actualIndex) {
        list.splice(actualIndex, 1);
      }
      if (hasActual) {
        list = list.concat(actualList);
      }
      return list;
    }
    function setActualDate(filter) {
      var splitted = filter.split("&");
      var dateFilterStr;
      for (var i = 0; i < splitted.length; i++) {
        if (splitted[i].indexOf(dayFilterName) != -1) {
          dateFilterStr = splitted[i].trim();
        }
      }
      var date;
      if (dateFilterStr) {
        var splitedDate = dateFilterStr.split("=");
        date = new Date(splitedDate[1]);
      } else {
        date = vm.end_date;
      }
      return date;
    }

    function setActualByDate(dashboards) {
      var list = angular.copy(dashboards);
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (isActualByDate(list[i])) {
          if (!list[i].filter) {
            list[i].filter =
              "&" +
              dayFilterName +
              "=" +
              moment(list[i].report_date).format("YYYY-MM-DD");
          }
        }
      }
      return list;
    }
    function isActualByDate(obj) {
      var isActual = false;
      if (
        obj.index == 943 ||
        obj.index == 944 ||
        obj.index == 945 ||
        obj.index == 946 ||
        obj.index == 947 ||
        obj.index == 948 ||
        obj.index == 949
      ) {
        isActual = true;
      }
      return isActual;
    }

    function showStartEndDate(dashboard) {
      var show = true;
      if (isActualByDate(dashboard)) {
        show = false;
      }
      return show;
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;

      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentSheetId) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }
    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var reasonFilterString;
      var firstLesionFilterString;
      var lesionTypeFilterString;
      var lesionFilterString;
      var showOthersFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("Reason=") != -1 ||
          splitted[i].indexOf("Grund=") != -1
        ) {
          reasonFilterString = splitted[i];
        }
        if (splitted[i].indexOf("First Lesion=") != -1) {
          firstLesionFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Lesion type=") != -1) {
          lesionTypeFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Lesion=") != -1) {
          lesionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Show others=") != -1 ||
          splitted[i].indexOf("zeige andere=") != -1
        ) {
          showOthersFilterString = splitted[i];
        }
      }
      var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
      var reason;
      var firstLesion;
      var lesionType;
      var lesion;
      var showOthers;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "reason" &&
          filtersLngList[i].lng == lng
        ) {
          reason = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "first_lesion" &&
          filtersLngList[i].lng == lng
        ) {
          firstLesion = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "lesion_type" &&
          filtersLngList[i].lng == lng
        ) {
          lesionType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "lesion" &&
          filtersLngList[i].lng == lng
        ) {
          lesion = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "show_others" &&
          filtersLngList[i].lng == lng
        ) {
          showOthers = filtersLngList[i].name;
        }
      }
      if (reason && reasonFilterString) {
        reasonFilterString = changeFilterNameLanguage(
          reasonFilterString,
          reason,
          reasonFilter
        );
      }
      if (firstLesion && firstLesionFilterString) {
        firstLesionFilterString = changeFilterNameLanguage(
          firstLesionFilterString,
          firstLesion,
          firstLesionFilter
        );
      }
      if (lesionType && lesionTypeFilterString) {
        lesionTypeFilterString = changeFilterNameLanguage(
          lesionTypeFilterString,
          lesionType,
          lesionTypeFilter
        );
      }
      if (lesion && lesionFilterString) {
        lesionFilterString = changeFilterNameLanguage(
          lesionFilterString,
          lesion,
          lesionFilter
        );
      }
      if (showOthers && showOthersFilterString) {
        showOthersFilterString = changeFilterNameLanguage(
          showOthersFilterString,
          showOthers,
          showOthersFilter
        );
      }

      filterString = "";
      if (reasonFilterString) {
        filterString += "&" + reasonFilterString;
      }
      if (firstLesionFilterString) {
        filterString += "&" + firstLesionFilterString;
      }
      if (lesionTypeFilterString) {
        filterString += "&" + lesionTypeFilterString;
      }
      if (lesionFilterString) {
        filterString += "&" + lesionFilterString;
      }
      if (showOthersFilterString) {
        filterString += "&" + showOthersFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(
        APP_CONSTANTS.constants.clawHealthdashboardIdLngList
      );
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function getFilterValues(value, name) {
      var filter = "";
      if (value.length != 3) {
        if (value.length == 1) {
          filter = value[0].formattedValue;
          if (name === "First Lesion") {
            filter = value[0].formattedValue.toLowerCase();
          }
        } else {
          for (var i = 0; i < value.length; i++) {
            if (i == 0) {
              filter = filter + value[i].formattedValue;
            } else {
              filter = filter + "," + value[i].formattedValue;
            }
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentSheetId);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      filter +=
                        "&" +
                        filterList.parameters[j].name +
                        "=" +
                        parameters[i].getCurrentValue().formattedValue;
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (name == filterList.filters[j].name) {
                        var filter_values =
                          filtersResponse[i].getAppliedValues();
                        if (
                          (filterList.filters[j].n != undefined) &
                          (filterList.filters[j].n != filter_values.length)
                        ) {
                          filterValue = getFilterValues(filter_values, name);
                        } else if (
                          (filterList.filters[j].m != undefined) &
                          (filterList.filters[j].m == filter_values.length)
                        ) {
                          filterValue = getFilterValues(filter_values, name);
                        } else if (
                          filterList.filters[j].n == undefined &&
                          filterList.filters[j].m == undefined
                        ) {
                          filterValue = getFilterValues(filter_values, name);
                        }
                        var p_name = "pr_f_" + filterList.filters[j].name;
                        if (filterValue) {
                          filter += filterValue;
                        }
                        vm[p_name].resolve();
                        filterValue = null;
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getDashboardIdByName(name) {
      var found;
      var id;
      for (var i = 0; i < vm.clawHealthdashboardIdList.length; i++) {
        if (name == vm.clawHealthdashboardIdList[i].name) {
          found = true;
          id = vm.clawHealthdashboardIdList[i].id;
          break;
        }
      }
      if (found) {
        return id;
      } else {
        return null;
      }
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      switch (dashboardId) {
        case $filter("i18n")("_claw_health_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_reason_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_number_of_cows_trimmed_by_trim_date_"
              ),
              default: "All",
              n: 4,
              m: undefined,
            },
          ];

          break;

        case $filter("i18n")("_number_of_cows_trimmed_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_reason_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_number_of_cows_trimmed_"
              ),
              default: "All",
              n: 4,
              m: undefined,
            },
          ];
          break;

        case $filter("i18n")("_lesions_percentage_of_feet_trimmed_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_of_feet_trimmed_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_of_feet_trimmed_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_leasons_percentage_of_all_lesions_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_of_total_lesions_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_of_total_lesions_"
              ),
              default: "",
              n: 9,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_lesion_distribution_by_trim_date_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_trim_date_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_trim_date_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")(
          "_lesion_distribution_by_date_for_lactation_greater_than_zero_"
        ):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_trim_date_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_trim_date_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_lesion_distribution_chronological_comparison_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_chronological_comparison_for_top_six_lesions_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_chronological_comparison_for_top_six_lesions_"
              ),
              default: "",
              n: 9,
              m: undefined,
            },
          ];

          break;

        case $filter("i18n")("_lesion_distributed_by_limb_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_limb_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_limb_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")(
          "_lesion_distribution_of_limb_by_percentage_dashboard_"
        ):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_limb_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_limb_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_lesions_distributed_by_dim_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_DIM_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_%_by_DIM_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")(
          "_lesions_distributed_by_dim_percentage_dashboard_"
        ):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_DIM_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_percentage_by_DIM_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_lesions_distributed_by_parity_dashboard_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_by_parity_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_lesions_by_parity_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_lesions_by_parity_dashboard_percentage_"):
          obj.filters = [
            {
              name: $filter("i18n")("_claw_health_filter_lesion_type_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_percentage_of_lesions_distributed_by_parity_"
              ),
              default: "All",
              n: 9,
              m: undefined,
            },
            {
              name: $filter("i18n")("_claw_health_filter_first_lesion_"),
              worksheetName: $filter("i18n")(
                "_worksheet_name_percentage_of_lesions_distributed_by_parity_"
              ),
              default: "All",
              n: 2,
              m: undefined,
            },
          ];

          obj.parameters = [
            {
              name: $filter("i18n")("_claw_health_parameter_show_others_"),
              default: "Off",
            },
          ];

          break;

        case $filter("i18n")("_digital_dermatitis_dashboard_"):
          break;

        default:
          break;
      }

      return obj;
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        dashboardsPromise = $q.defer();
        addToReportPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          dashboardsPromise.promise,
          addToReportPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            vm.reportDashboards = setActualByDate(vm.reportDashboards);
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        var herd_id = vm.selectedHerds[0];
        var team_id = vm.selectedTeam;
        checkAllDashboards(team_id);
        getAddedToReport(false, vm.reportDate, true);
        checkHerds(herd_id);
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function setActualByDate(dashboards) {
      var list = angular.copy(dashboards);
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (isActualByDate(list[i])) {
          if (!list[i].filter) {
            list[i].filter =
              "&" +
              dayFilterName +
              "=" +
              moment(list[i].report_date).format("YYYY-MM-DD");
          }
        }
      }
      return list;
    }

    function checkHerds(herd_id) {
      return clawHealtService
        .getHerdsByTeam(vm.selectedTeam)
        .then(function (response) {
          vm.currentHerdName = getHerdNameById(herd_id, response);
          herdsPromise.resolve();
        })
        .catch(function (error) {
          herdsPromise.reject();
        });
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function checkAllDashboards(team_id) {
      var dashboards = angular.copy(herdDashboardsService.tableauStored);
      if (
        dashboards.dashboards &&
        dashboards.team_id == team_id &&
        moment(dashboards.expires).isAfter(moment())
      ) {
        vm.allReportDashboards = getClawHealthDashboards(dashboards.dashboards);
        dashboardsPromise.resolve();
      } else {
        var tableauSuffix = "?locale=" + vm.currentLng;
        return clawHealtService
          .getDashboards(vm.selectedTeam, tableauSuffix)
          .then(function (response) {
            vm.allReportDashboards = getClawHealthDashboards(response);
            dashboardsPromise.resolve();
          })
          .catch(function (error) {
            dashboardsPromise.reject();
          });
      }
    }

    function getClawHealthDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (
        var i = 0;
        i < APP_CONSTANTS.constants.clawHealthdashboardIdLngList.length;
        i++
      ) {
        if (
          APP_CONSTANTS.constants.clawHealthdashboardIdLngList[i].lng ==
            currentLng &&
          APP_CONSTANTS.constants.clawHealthdashboardIdLngList[i].internal_id !=
            "Homeclawhealthdashboard"
        ) {
          listOfDashboardsIds.push(
            APP_CONSTANTS.constants.clawHealthdashboardIdLngList[i]
          );
        }
      }
      for (var i = 0; i < listOfDashboardsIds.length; i++) {
        for (var j = 0; j < dashboards.length; j++) {
          if (
            listOfDashboardsIds[i].id == dashboards[j].id &&
            dashboards[j].locale == currentLng &&
            dashboards[j].subcategory == "claw-module"
          ) {
            dashboards[j].index = listOfDashboardsIds[i].index;
            dashboards[j].start_date = vm.start_date;
            dashboards[j].end_date = vm.end_date;
            list.push(dashboards[j]);
          }
        }
      }
      return list;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.currentEntry) {
        var obj = {
          id: vm.currentEntry.id,
          comment: vm.modalComment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.currentEntry.locale,
          dashboardId: vm.currentSheetId,
          filter: filterUrl,
        };
        return clawHealtService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addToReportModalLoading = false;
          });
      } else {
        var lng = vm.currentLng;
        var date =
          moment()
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var obj = {
          date: date,
          herdId: vm.selectedHerds[0],
          comment: vm.modalComment,
          endDate: end_date,
          startDate: start_date,
          locale: lng,
          dashboardId: vm.currentSheetId,
          filter: filterUrl,
        };
        return clawHealtService
          .addToReport(obj)
          .then(function (response) {
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addToReportModalLoading = false;
          });
      }
    }

    function createPDF(pdfData) {
      var dd = {
        pageMargins: [20, 20, 20, 20],
        pageSize: "A4",
        content: [
          {
            image: pdfData.logo,
            width: 120,
            alignment: "left",
          },
          {
            text: i18nFilter("_report_title_claw_specialist_") + ":",
            alignment: "left",
            fontSize: 16,
            bold: true,
            color: pdfData.blue,
          },
          {
            text: pdfData.herd_name,
            alignment: "left",
            fontSize: 14,
            color: pdfData.blue,
            margin: [0, 10, 0, 0],
            italics: true,
          },
          {
            text: pdfData.date,
            alignment: "left",
            fontSize: 14,
            color: pdfData.blue,
            italics: true,
          },
          {
            table: {
              widths: ["auto", "*"],
              body: [
                [
                  {
                    text: i18nFilter("_report_claw_specialist_") + ":",
                    color: pdfData.blue,
                    fontSize: 14,
                    border: [false, false, false, true],
                    italics: true,
                    margin: [-5, 0, -5, 0],
                  },
                  {
                    text: pdfData.user,
                    color: pdfData.blue,
                    fontSize: 14,
                    border: [false, false, false, true],
                    italics: true,
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdfData.green,
            },
          },
          {
            text: i18nFilter("_report_positive_points_") + ":",
            alignment: "left",
            bold: true,
            margin: [0, 5, 15, 0],
          },
          {
            text: pdfData.positive_points,
            alignment: "left",
            pageBreak:
              (pdfData.positive_points.length > 1700 ||
                pdfData.positive_points.split(/\r\n|\r|\n/).length > 22) &&
              (pdfData.points_to_improve.length > 1700 ||
                pdfData.points_to_improve.split(/\r\n|\r|\n/).length > 22)
                ? "after"
                : false,
          },
          {
            text: i18nFilter("_report_points_to_improve_") + ":",
            alignment: "left",
            bold: true,
            margin: [0, 5, 15, 0],
          },
          {
            text: pdfData.points_to_improve,
            alignment: "left",
          },
        ],
      };
      for (var i = 0; i < pdfData.dashboards.length; i++) {
        var obj = {
          text: pdfData.dashboards[i].comment
            ? pdfData.dashboards[i].comment
            : "",
          border: [false, false, false, false],
          margin: [0, 5, 0, 10],
        };
        var table = {
          table: {
            dontBreakRows: true,
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  margin: [-5, 5, -5, 10],
                  stack: [
                    {
                      margin: [0, 5, 0, 10],
                      text: isActualByDate(pdfData.dashboards[i])
                        ? pdfData.dashboards[i].description +
                          " (" +
                          $filter("date")(pdfData.dashboards[i].report_date) +
                          ")"
                        : pdfData.dashboards[i].description +
                          " (" +
                          $filter("date")(pdfData.dashboards[i].start_date) +
                          " - " +
                          $filter("date")(pdfData.dashboards[i].end_date) +
                          ")",
                      border: [false, false, false, false],
                      bold: true,
                    },
                    {
                      image: pdfData.dashboards[i].image,
                      width: 555,
                      border: [false, false, false, false],
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineColor: pdfData.green,
          },
        };
        if (
          pdfData.dashboards[i].selected &&
          pdfData.dashboards[i].image_loaded
        ) {
          dd.content.push(table);
          dd.content.push(obj);
        }
      }
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      var pdf = pdfMake.createPdf(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            try {
              pdf.open();
            } catch (error) {
              toastr.error(error);
            }
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }
    function getDataUrl(url, index, name) {
      toDataURL(
        url,
        function (dataUrl) {
          if (dataUrl) {
            vm.orderedDashboards[index].image = dataUrl;
          } else {
            vm.orderedDashboards[index].image = null;
            vm.orderedDashboards[index].image_loaded = false;
          }

          vm[name].resolve();
        },
        name
      );
    }
    function setDataUrls() {
      var image_url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        if (vm.orderedDashboards[i].image_loaded) {
          var name = "imgpr" + i;
          vm[name] = $q.defer();
          image_url_promise_list.push(vm[name].promise);
          var image_url = setImageUrl(vm.orderedDashboards[i]);
          getDataUrl(image_url, i, name);
        }
      }
      vm.logoPrm = $q.defer();
      image_url_promise_list.push(vm.logoPrm.promise);
      toDataURL(
        "assets/img/logo_mmm.png",
        function (dataUrl) {
          vm.logo = dataUrl;
          vm.logoPrm.resolve();
        },
        "logoPrm"
      );
      $q.all(image_url_promise_list)
        .then(function () {
          var date = new Date();
          date = $filter("date")(date);
          var pdfData = {
            date: date,
            logo: vm.logo,
            user: vm.user.name,
            blue: "#033384",
            green: "#99B71B",
            red: "red",
            positive_points: vm.positivePoints ? vm.positivePoints : "",
            points_to_improve: vm.pointsToImprove ? vm.pointsToImprove : "",
            herd_name: vm.currentHerdName,
            dashboards: vm.orderedDashboards,
          };
          createPDF(pdfData);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }
    function toDataURL(url, callback, prm) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        if (xhr.status == 200 || xhr.status == 204) {
          reader.readAsDataURL(xhr.response);
        } else {
          callback(null);
        }
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.withCredentials = true;
      xhr.send();
    }

    function setImageUrl(dashboard) {
      var image_url;
      var size = "1920,1080";
      var splitted = dashboard.image_url.split("?");
      if (vm.work_locally) {
        image_url = splitted[0];
      } else {
        image_url = splitted[0] + ".png";
      }
      var start_date = moment(dashboard.start_date).format("YYYY-MM-DD");
      var end_date = moment(dashboard.end_date).format("YYYY-MM-DD");
      var herd = vm.selectedHerds[0];
      var suffix =
        "?Start%20Date=" +
        start_date +
        "&End%20Date=" +
        end_date +
        "&HerdIdentifier=" +
        herd +
        "&herd%20param=" +
        herd +
        "&:size=";
      if (dashboard.size) {
        suffix = suffix + dashboard.size;
      } else {
        suffix = suffix + size;
      }
      if (TMRchanged) {
        suffix = suffix + "&" + tmrParamName + "=" + TMR;
      }
      if (DryMatterChanged) {
        suffix = suffix + "&" + dmParamName + "=" + DryMatter;
      }
      image_url = image_url + suffix;
      if (dashboard.filter) {
        image_url = image_url + dashboard.filter;
      }
      return image_url;
    }
    function setReportData() {
      var parser = new UAParser();
      var brw = parser.getBrowser();
      var os = parser.getOS();
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);
      var list = [];
      for (var i = 0; i < vm.reportDashboards.length; i++) {
        if (vm.reportDashboards[i].selected) {
          list.push(vm.reportDashboards[i]);
        }
      }
      vm.orderedDashboards = $filter("orderBy")(list, "index");
      var url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        var name = "pr" + i;
        vm[name] = $q.defer();
        url_promise_list.push(vm[name].promise);
        getImageUrl(vm.orderedDashboards[i].url, i, name);
      }

      function getImageUrl(url, index, name) {
        if (vm.work_locally) {
          var image_url = "assets/img/hoof_health_bcg.jpg?4564545";
          vm.orderedDashboards[index].image_url = image_url;
          vm.orderedDashboards[index].image_loaded = true;
          vm[name].resolve();
        } else {
          return clawHealtService
            .setSession(url)
            .then(function (response) {
              var image_url = response.headers("tabvis-location");
              vm.orderedDashboards[index].image_url = image_url;
              vm.orderedDashboards[index].image_loaded = true;
              vm[name].resolve();
            })
            .catch(function (error) {
              vm[name].resolve();
            });
        }
      }
      $q.all(url_promise_list)
        .then(function () {
          setDataUrls(vm.orderedDashboards);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
      //}
    }
    function setRange() {
      var start_date_changed = false;
      var end_date_changed = false;
      if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
        start_date_changed = true;
      }
      if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
        end_date_changed = true;
      }
      var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
      if (!range_error) {
        vm.start_date = angular.copy(vm.modal_start_date);
        vm.end_date = angular.copy(vm.modal_end_date);
        var dates = {
          start_date: vm.start_date,
          end_date: vm.end_date,
        };
        cookiesService.setCookie("rap_actual_dates", JSON.stringify(dates), {
          domain: ".mmmooogle.com",
          samesite: "lax",
        });
        if (vm.mapActive) {
          applyParameters(start_date_changed, end_date_changed);
        }
        closeModal();
      }
    }

    function applyParameters(
      start_date_changed,
      end_date_changed,
      startDate,
      endDate
    ) {
      if (!endDate) {
        var end_date = vm.end_date;
      } else {
        var end_date = endDate;
      }

      if (!startDate) {
        var start_date = vm.start_date;
      } else {
        var start_date = startDate;
      }

      if (viz) {
        if (start_date_changed && end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(startDateParameterName, start_date)
            .then(function (param) {
              viz
                .getWorkbook()
                .changeParameterValueAsync(endDateParameterName, end_date);
            });
        } else if (start_date_changed && !end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(startDateParameterName, start_date);
        } else if (!start_date_changed && end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(endDateParameterName, end_date);
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return clawHealtService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setActualReportDate() {
      vm.setDateModalLoading = true;
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: vm.selectedReportDashboard.end_date,
          startDate: vm.selectedReportDashboard.start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
          filter: changeDateFilter(
            vm.selectedReportDashboard.filter,
            vm.report_modal_date
          ),
        };
        return clawHealtService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].report_date =
              vm.report_modal_date;
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_date;

            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.setDateModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].filter =
          "&" +
          dayFilterName +
          "=" +
          moment(vm.report_modal_date).format("YYYY-MM-DD");
        vm.reportDashboards[vm.selectedReportDashboardIndex].report_date =
          vm.report_modal_date;
        vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
          vm.report_modal_date;
        closeModal();
      }
    }

    function changeDateFilter(filter, date) {
      var regex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
      date = moment(date).format("YYYY-MM-DD");
      filter = filter.replace(regex, date);
      return filter;
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return clawHealtService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          dashboard: "Claw health",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        vm.modalError = false;
        vm.modalLoading = true;
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      }
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function openRangeSelector() {
      if (!vm.disableRangeSelector) {
        vm.modal_start_date = angular.copy(vm.start_date);
        vm.modal_end_date = angular.copy(vm.end_date);
        openModal("app/pages/claw_health/rangeSelector.modal.html", "sm");
      }
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal("app/pages/claw_health/reportRangeSelector.modal.html", "sm");
    }

    function openReportDashboardDayModal(index) {
      vm.setDateModalLoading = false;
      vm.report_modal_date = angular.copy(
        vm.reportDashboards[index].report_date
      );
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      openModal("app/pages/claw_health/daySelector.modal.html", "sm");
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/rap/reportComment.modal.html", "sm");
    }

    function openWarningModal() {
      openModal("app/pages/claw_health/warning.modal.html", "sm");
    }

    function redirectToHerds() {
      $state.go("myHerds");
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "clawHealth") {
        sendErrorInfo(data.comment);
      }
    });
    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.dispose();
      }
      $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 100);
    });

    $scope.$on("$destroy", function () {
      if (timeout) {
        timeout.resolve("cancel_request");
      }
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.dispose();
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.claw_health")
    .factory("clawHealtService", clawHealtService);
  /** @ngInject */
  function clawHealtService($http, $q, APP_CONSTANTS) {
    return {
      getDashboards: getDashboards,
      setSession: setSession,
      getHerdById: getHerdById,
      addToReport: addToReport,
      getReports: getReports,
      updateReportEntry: updateReportEntry,
      getHerdsByTeam: getHerdsByTeam,
      loadedDashboards: {},
      herds: [],
    };

    function getDashboards(team_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url + team_id + "/dashboards" + suffix,
          {
            withCredentials: true,
            timeout: 20000,
          }
        )
        .then(success)
        .catch(error);
    }

    function addToReport(obj) {
			return $http
				.post(APP_CONSTANTS.tableau_reports_base_url + '/reportentry', obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

    function getReports(suffix) {
			return $http
				.get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

    function updateReportEntry(id, obj) {
			return $http
				.put(APP_CONSTANTS.tableau_reports_base_url + '/reportentry/' + id, obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

    function getHerdsByTeam(team_id) {
			return $http
				.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds')
				.then(success)
				.catch(error);
		}

    function getHerdById(id) {
      return $http
        .get(APP_CONSTANTS.backoffice_base_url + "herds/" + id)
        .then(success)
        .catch(error);
    }

    function setSession(url) {
      return $http
        .get(url, {
          withCredentials: true,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (response) {
          return $q.reject(response);
        });
    }

    function success(response) {
      return response.data;
    }

    function error(error) {
      console.log(error);
      return $q.reject(error);
    }
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.cockpit').controller('cockpitCtrl', cockpitCtrl);
	/** @ngInject */
	function cockpitCtrl($sce, cockpitService, $timeout, $uibModal, $uibModalStack, $scope, APP_CONSTANTS, $filter, $location, $q, $interval, Upload, $window) {
		var vm = this;
		var sliderTimer;
		var pollTimer;
		var tagFilterTimer;
		var slideShowTimer;
		var searchSettingsTimer;
		var slideShowTimerInterval = 5000;
		vm.loadMore = loadMore;
		vm.getImage = getImage;
		vm.showMenu = showMenu;
		vm.showImage = showImage;
		vm.closeModal = closeModal;
		vm.previousImage = previousImage;
		vm.nextImage = nextImage;
		vm.setAnimalFilter = setAnimalFilter;
		vm.setAnimalFilterEnter = setAnimalFilterEnter;
		vm.setTagFilter = setTagFilter;
		vm.setCommentFilter = setCommentFilter;
		vm.setCommentFilterEnter = setCommentFilterEnter;
		vm.includePPChanged = includePPChanged;
		vm.loadUp = loadUp;
		vm.changeImportance = changeImportance;
		vm.changeIsTask = changeIsTask;
		vm.addComment = addComment;
		vm.addTag = addTag;
		vm.removeTag = removeTag;
		vm.rotateImage = rotateImage;
		vm.hideNotification = hideNotification;
		vm.moveToTop = moveToTop;
		vm.addCommentOnEnter = addCommentOnEnter;
		vm.startstopSlideshow = startstopSlideshow;
		vm.openNewDiscussionModal = openNewDiscussionModal;
		vm.addNewDiscussion = addNewDiscussion;
		vm.newDiscussionSetTags = newDiscussionSetTags;
		vm.uploadChanged = uploadChanged;
		vm.removeSelectedFile = removeSelectedFile;
		vm.selectSearchBy = selectSearchBy;
		vm.resetAnimalSearch = resetAnimalSearch;
		vm.resetCommentSearch = resetCommentSearch;
		vm.openDeleteImageModal = openDeleteImageModal;
		vm.deleteImage = deleteImage;
		vm.checkIsAdmin = checkIsAdmin;
		vm.goToAnimal = goToAnimal;
		vm.openDateRangeSelector = openDateRangeSelector;
		vm.setRange = setRange;
		vm.resetRange = resetRange;
		var activeMenu;
		var activeMenuIndex;
		var menuActivated = false;
		var startedFromFirst;
		vm.useLoadUp = false;
		var popularTags = [];
		vm.imagesToLoad = [];
		vm.includeProfilePicture = true;
		vm.showSlider = false;
		vm.loading = true;
		var loadingIndicator;
		var maxImageCommentDate;
		var minImageCommentDate;
		var lowerCommentDate;
		var upperCommentDate;
		var polling = false;
		vm.showNotification = false;
		var upimg;
		var downimg;
		var lastDateFilter;
		var firstImage;
		vm.modalOpen = false;
		vm.slideshow = false;
		vm.showSearchSetings = false;
		vm.searchByNumber = true;
		vm.searchByName = true;
		vm.searchByEarTag = true;

		function sliderChanged() {
			vm.loading = true;
			if (sliderTimer) {
				$timeout.cancel(sliderTimer);
			}
			sliderTimer = $timeout(function () {
				vm.loading = true;
				var date;
				for (var i = 0; i < vm.dates.length; i++) {
					if (vm.dates[i].value == vm.sliderOptions.value) {
						date = vm.dates[i];
						break;
					}
				}
				if (moment(date.date).year() == moment(firstImage.ImageCommentDate).year() && moment(date.date).month() == moment(firstImage.ImageCommentDate).month() && moment(date.date).date() == moment(firstImage.ImageCommentDate).date()) {
					var f = false;
					for (var i = 0; i < vm.images.length; i++) {
						if (vm.images[i].Id == firstImage.Id) {
							f = true;
							break;
						}
					}
					if (f) {
						var image = 'image' + firstImage.Id;
						$location.hash(image);
						vm.images[0].highlighted = true;
						lastDateFilter = date.date;
						vm.loading = false;
						$timeout(function () {
							vm.images[0].highlighted = false;
						}, 3000);
						return true;
					} else {
						moveToTop();
						return true;
					}
				}
				if (moment(date.date).isAfter(moment(firstImage.ImageCommentDate))) {
					var f = false;
					for (var i = 0; i < vm.images.length; i++) {
						if (vm.images[i].Id == firstImage.Id) {
							f = true;
							break;
						}
					}
					if (f) {
						var image = 'image' + firstImage.Id;
						$location.hash(image);
						vm.images[0].highlighted = true;
						lastDateFilter = date.date;
						vm.loading = false;
						$timeout(function () {
							vm.images[0].highlighted = false;
						}, 3000);
						return true;
					} else {
						moveToTop();
						return true;
					}
				}
				var imageFound;
				var imageIndex;
				var found = false;
				for (var i = 0; i < vm.images.length; i++) {
					if (moment(date.date).isBefore(moment(lastDateFilter)) || date.date == lastDateFilter) {
						if (moment(date.date).add(1, 'days').isAfter(moment(vm.images[i].ImageCommentDate))) {
							imageFound = vm.images[i];
							imageIndex = i;
							found = true;
							break;
						}
					} else {
						if (moment(date.date).add(1, 'days').isAfter(moment(vm.images[i].ImageCommentDate))) {
							imageFound = vm.images[i];
							imageIndex = i;
							if (imageIndex > 0) {
								found = true;
							} else {
								found = false;
							}
							break;
						}
					}
				}
				if (found) {
					var image = 'image' + imageFound.Id;
					$location.hash(image);
					vm.images[imageIndex].highlighted = true;
					lastDateFilter = date.date;
					$timeout(function () {
						vm.images[imageIndex].highlighted = false;
					}, 3000);
				} else {
					var imageId;
					var index;
					var foundAll = false;
					for (var i = 0; i < vm.allImages.length; i++) {
						if (moment(date.date).isBefore(moment(lastDateFilter)) || date.date == lastDateFilter) {
							if (moment(date.date).add(1, 'days').isAfter(moment(vm.allImages[i].ImageCommentDate))) {
								imageId = vm.allImages[i].Id;
								index = i;
								foundAll = true;
								break;
							}
						} else {
							if (moment(date.date).add(1, 'days').isAfter(moment(vm.allImages[i].ImageCommentDate))) {
								imageId = vm.allImages[i].Id;
								index = i;
								if (index > 0) {
									foundAll = true;
								} else {
									found = false;
								}
								break;
							}
						}
					}
					if (foundAll) {
						if (vm.allImages.length >= 1000 && vm.allImages.length - 1 - index <= 75) {
							getPicturesInBetween(date);
						} else {
							lastDateFilter = date.date;
							var tempList;
							var temp = [];
							angular.copy(vm.allImages, temp);
							var listToPush = temp.splice(index, 25);
							var commentsListToPush = temp.splice(index, 75);
							var listToPushToTop = [];
							var commentListToPushToTop = [];
							if (index > 0) {
								var temp = [];
								angular.copy(vm.allImages, temp);
								var lowerIndex = index - 25;
								var commentLowerIndex = index - 75;
								var numberOfImages = 25;
								var commentNumberOfImages = 75;
								if (lowerIndex < 0) {
									numberOfImages = 25 - Math.abs(lowerIndex);
									lowerIndex = 0;
								}
								if (commentLowerIndex < 0) {
									commentNumberOfImages = 75 - Math.abs(commentLowerIndex);
									commentLowerIndex = 0;
								}
								listToPushToTop = temp.splice(lowerIndex, numberOfImages);
								commentListToPushToTop = temp.splice(commentLowerIndex, commentNumberOfImages);
							}
							vm.images = listToPushToTop.concat(listToPush);
							var listForComments = commentListToPushToTop.concat(commentsListToPush);
							createListOfImagesWithComments(listForComments, true);
							var image = 'image' + imageId;
							$location.hash(image);
							var showIndex;
							for (var i = 0; i < vm.images.length; i++) {
								if (vm.images[i].Id == imageId) {
									showIndex = i;
									break;
								}
							}
							if (showIndex != null) {
								vm.images[showIndex].highlighted = true;
								$timeout(function () {
									vm.images[showIndex].highlighted = false;
								}, 3000);
							}
						}
					} else {
						getPicturesInBetween(date);
					}
				}
				$timeout(function () {
					vm.loading = false;
				}, 0);
			}, 500);
		}

		function getPicturesInBetween(date) {
			vm.loading = true;
			startedFromFirst = false;
			upimg = $q.defer();
			downimg = $q.defer();
			getUpImages(date);
			getDownImages(date);
			$q.all([upimg.promise, downimg.promise])
				.then(function (responses) {
					var list;
					list = vm.upresponse.concat(vm.downresponse);
					processRawData(list, 4);
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function getUpImages(date) {
			var suffix = createUrlSuffix(false, 4, date.date);
			return cockpitService
				.getImages(suffix)
				.then(function (response) {
					response.reverse();
					vm.upresponse = response;
					upimg.resolve();
				})
				.catch(function (error) {
					console.log(error);
					upimg.reject();
				});
		}

		function getDownImages(date) {
			var suffix = createUrlSuffix(false, 5, date.date);
			return cockpitService
				.getImages(suffix)
				.then(function (response) {
					vm.downresponse = response;
					downimg.resolve();
				})
				.catch(function (error) {
					console.log(error);
					downimg.reject();
				});
		}

		function getImage(image) {
			return $sce.trustAsResourceUrl(image);
		}
		setDatePeriods();
		init();

		function init() {
			vm.showResetAnimalSearchButton = false;
			vm.showResetCommentSearchButton = false;
			vm.tags = [];
			vm.tagsList = [];
			angular.copy(APP_CONSTANTS.constants.tags, vm.tags);
			angular.copy(APP_CONSTANTS.constants.tags, vm.tagsList);
			vm.tags = setTagTranslations(vm.tags);
			vm.tagsList = setTagTranslations(vm.tagsList);
			vm.tagsList.shift();
			vm.popularTags = APP_CONSTANTS.constants.popularTags;
			vm.popularTags = setTagTranslations(vm.popularTags);
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.images = [];
			vm.imagesTemp = [];
			getUserTeamHerds();
			vm.imagesLoaded = false;
			poll();
		}

		function setTagTranslations(tagsList) {
			var tags = angular.copy(tagsList);
			for (var i = 0; i < tags.length; i++) {
				if (tags[i].label_translate) {
					tags[i].label = $filter('i18n')(tags[i].label_translate);
				} else {
					tags[i].label = '';
				}
			}

			return tags;
		}

		function openDeleteImageModal(image) {
			vm.modalLoading = false;
			vm.deleteError = null;
			for (var i = 0; i < vm.images.length; i++) {
				if (image.Id == vm.images[i].Id) {
					image.index = i;
					break;
				}
			}
			vm.pictureToDelete = image;
			stopSlideShow();
			$uibModal
				.open({
					animation: true,
					templateUrl: 'app/pages/cockpit/delete.modal.html',
					size: 'sm',
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {
					vm.pictureToDelete = null;
				});
		}

		function deleteImage() {
			vm.modalLoading = true;
			if (vm.pictureToDelete && vm.pictureToDelete.Id) {
				cockpitService
					.deletePicture(vm.pictureToDelete.Id)
					.then(function () {
						for (var i = 0; i < vm.images.length; i++) {
							if (vm.images[i].Id == vm.pictureToDelete.Id) {
								vm.images.splice(i, 1);
								break;
							}
						}
						for (var i = 0; i < vm.allImages.length; i++) {
							if (vm.allImages[i].Id == vm.pictureToDelete.Id) {
								vm.allImages.splice(i, 1);
								break;
							}
						}
						if (vm.images[vm.pictureToDelete.index + 1]) {
							nextImage();
							var top = $uibModalStack.getTop();
							if (top) {
								$uibModalStack.dismiss(top.key);
							}
						} else if (vm.images[vm.pictureToDelete.index - 1]) {
							previousImage();
							var top = $uibModalStack.getTop();
							if (top) {
								$uibModalStack.dismiss(top.key);
							}
						} else {
							$uibModalStack.dismissAll();
						}
					})
					.catch(function (error) {
						console.log(error);
						vm.modalLoading = false;
						vm.deleteError = error;
					});
			}
		}

		function checkIsAdmin(image) {
			var isAdmin = false;
			for (var i = 0; i < vm.adminHerds.length; i++) {
				if (vm.adminHerds[i].HerdId == image.HerdId) {
					isAdmin = true;
					break;
				}
			}
			return isAdmin;
		}

		function getUserTeamHerds() {
			var user = JSON.parse(localStorage.getItem('user_profile'));
			vm.loading = true;
			return cockpitService
				.getUserTeamHerds(user.user_id)
				.then(function (response) {
					vm.teamsHerds = createTeamHerdList(response);
					vm.adminHerds = createAdminHerdsList(vm.teamsHerds);
					loadPictures(false, 1);
				})
				.catch(function (error) {
					console.log(error);
					loadPictures(false, 1);
				});
		}

		function createAdminHerdsList(teamsHerds) {
			var list = [];
			for (var i = 0; i < teamsHerds.length; i++) {
				for (var j = 0; j < teamsHerds[i].Herds.length; j++) {
					if (teamsHerds[i].Herds[j].Role == 1) {
						list.push(teamsHerds[i].Herds[j]);
					}
				}
			}
			return list;
		}

		function createTeamHerdList(list_of_herds) {
			Array.prototype.groupBy = function (prop) {
				return this.reduce(function (groups, item) {
					var val = item[prop];
					groups[val] = groups[val] || [];
					groups[val].push(item);
					return groups;
				}, {});
			};
			var list = [];
			var groupedByTeam = list_of_herds.groupBy('TeamId');
			Object.keys(groupedByTeam).forEach(function (teamKey) {
				var groupedByHerd = groupedByTeam[teamKey].groupBy('HerdId');
				var herds = [];
				Object.keys(groupedByHerd).forEach(function (herdKey) {
					var herd = {
						HerdId: herdKey,
						HerdName: groupedByHerd[herdKey][0].HerdName,
						Role: groupedByHerd[herdKey][0].Role
					};
					herds.push(herd);
				});
				var team = {
					TeamId: teamKey,
					TeamName: groupedByTeam[teamKey][0].TeamName,
					Herds: herds
				};
				list.push(team);
			});
			return list;
		}

		function loadPictures(reload, type) {
			if (type == 1) {
				vm.loading = true;
				vm.showSlider = false;
				startedFromFirst = true;
				getLastPicture();
			}
			var suffix = createUrlSuffix(reload, type);
			var control = JSON.stringify(vm.defaultValues.herd_ids);
			return cockpitService
				.getImages(suffix, control)
				.then(function (response) {
					if (control == JSON.stringify(vm.defaultValues.herd_ids)) {
						vm.loading = false;
						processRawData(response, type);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function getLastPicture() {
			var suffix = createUrlSuffix(false, 0);
			return cockpitService
				.getImages(suffix)
				.then(function (response) {
					if (response.length > 0) {
						minImageCommentDate = response[0].ImageCommentDate;
						createDaysMonthsYears(response[0].ImageCommentDate);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function processRawData(images, type) {
			if (images.length > 0) {
				/*types

                1 - first load
                2 - load down
                3 - load up
                4 - inbetween
                */
				var usedTags = [];
				var imagesWithComments = [];
				if (type == 1) {
					firstImage = images[0];
					maxImageCommentDate = images[0].ImageCommentDate;
					upperCommentDate = images[0].ImageCommentDate;
				}
				if (images.length > 0) {
					if (type == 1 || type == 2 || type == 4) {
						lowerCommentDate = images[images.length - 1].ImageCommentDate;
					}
					if (type == 4) {
						upperCommentDate = images[0].ImageCommentDate;
					}
					if (type == 3) {
						images.reverse();
						upperCommentDate = images[0].ImageCommentDate;
					}
				}
				for (var i = 0; i < images.length; i++) {
					images[i].ImageCommentDate = $filter('date')(images[i].ImageCommentDate, 'yyyy-MM-ddTHH:mm:ss.sss') + 'Z';
					images[i].ImageCreated = $filter('date')(images[i].ImageCreated, 'yyyy-MM-ddTHH:mm:ss.sss') + 'Z';
					images[i].Comments = [];
					images[i].HaveComment = false;
					//////define tags to show/////
					if (images[i].Tags) {
						images[i].TagsToShow = [];
						var tags = images[i].Tags.split('#');
						for (var j = 0; j < tags.length; j++) {
							for (var k = 0; k < vm.tags.length; k++) {
								if (tags[j] == vm.tags[k].value && tags[j] != '') {
									var tag_added = false;
									for (var t = 0; t < images[i].TagsToShow.length; t++) {
										if (images[i].TagsToShow[t].value == vm.tags[k].value) {
											tag_added = true;
										}
									}
									if (!tag_added) {
										images[i].TagsToShow.push(vm.tags[k]);
									}
									//create popular tags list
									if (usedTags.length < 6) {
										var found = false;
										for (var tag = 0; tag < usedTags.length; tag++) {
											if (vm.tags[k].value == usedTags[tag].value) {
												found = true;
											}
										}
										if (!found) {
											usedTags.push(vm.tags[k]);
										}
									}
									break;
								}
							}
						}
					}
				}
				///// create popular tags list /////
				if (popularTags.length < 6) {
					if (popularTags.length == 0 && usedTags.length == 0) {
						for (var i = 0; i < vm.popularTags.length; i++) {
							var tempTag = {};
							angular.copy(vm.popularTags[i], tempTag);
							tempTag.trackByIndex = vm.tags.length + 2;
							tempTag.group = 'Popular';
							vm.tags.splice(1, 0, tempTag);
							popularTags.push(tempTag);
						}
					} else {
						for (var ut = 0; ut < usedTags.length; ut++) {
							var found = false;
							for (var pt = 0; pt < popularTags.length; pt++) {
								if (usedTags[ut].value == popularTags[pt].value) {
									found = true;
								}
							}
							if (!found) {
								if (popularTags.length == 5) {
									break;
								} else {
									var tempTag = {};
									angular.copy(usedTags[ut], tempTag);
									tempTag.trackByIndex = vm.tags.length + 2;
									tempTag.group = 'Popular';
									vm.tags.splice(1, 0, tempTag);
									popularTags.push(tempTag);
								}
							}
						}
					}
				}
				if (type == 1) {
					vm.allImages = images;
					if (images.length >= 50) {
						var temp = [];
						angular.copy(vm.allImages, temp);
						vm.images = temp.splice(0, 50);
						if (vm.allImages.length >= 100) {
							temp = [];
							angular.copy(vm.allImages, temp);
							createListOfImagesWithComments(temp.splice(0, 100), true);
						} else {
							createListOfImagesWithComments(vm.allImages, true);
						}
					} else {
						temp = [];
						angular.copy(vm.allImages, temp);
						vm.images = temp;
						createListOfImagesWithComments(vm.images, true);
					}
					vm.imagesLoaded = true;
				}
				if (type == 2) {
					vm.allImages = vm.allImages.concat(images);
				}
				if (type == 3) {
					vm.allImages = images.concat(vm.allImages);
				}
				if (type == 4) {
					vm.allImages = images;
					sliderChanged();
				}
			}
		}

		function createListOfImagesWithComments(images, first) {
			var imagesWithComments = [];
			for (var i = 0; i < images.length; i++) {
				if (images[i].NumberComments > 0) {
					imagesWithComments.push(images[i].Id);
				}
			}
			getComments(imagesWithComments, first);
		}

		function processCommentsResponse(comments, first) {
			comments = comments.slice().reverse();
			for (var i = 0; i < vm.allImages.length; i++) {
				var haveComment = false;
				for (var r = 0; r < comments.length; r++) {
					if (vm.allImages[i].Id == comments[r].EntityId && !vm.allImages[i].HaveComment) {
						vm.allImages[i].Comments.push(comments[r]);
						haveComment = true;
					}
				}
				if (haveComment) {
					vm.allImages[i].HaveComment = true;
				}
			}
			if (first) {
				for (var i = 0; i < vm.images.length; i++) {
					var haveComment = false;
					for (var r = 0; r < comments.length; r++) {
						if (vm.images[i].Id == comments[r].EntityId && !vm.images[i].HaveComment) {
							vm.images[i].Comments.push(comments[r]);
							haveComment = true;
						}
					}
					if (haveComment) {
						vm.images[i].HaveComment = true;
					}
				}
			}
		}

		function getComments(images, first) {
			return cockpitService
				.getCommentsForIds(JSON.stringify(images))
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						response[i].CommentTimeStamp = $filter('date')(response[i].CommentTimeStamp, 'yyyy-MM-ddTHH:mm:ss.sss') + 'Z';
					}
					processCommentsResponse(response, first);
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function createUrlSuffix(reload, type, centerdate) {
			/*types
            0 - find first image
            1 - first load
            2 - load down
            3 - load up
            4 - inbetween up
            5 - inbetwen down
            */
			if (vm.commentFilter && vm.commentFilter.trim().length > 0) {
				var suffix = '/bycomment/' + vm.commentFilter.trim();
			} else {
				var suffix = '';
			}
			if (type == 0) {
				suffix = suffix + '?-orderby=imagecommentdate&-limit=1';
			} else if (type == 1) {
				suffix = suffix + '?-orderby=-imagecommentdate&-limit=1000';
				if (vm.use_date_range) {
					if (vm.period_end) {
						var period_end_date = vm.period_end.setHours(23);
						period_end_date = vm.period_end.setMinutes(59);
						period_end_date = vm.period_end.setSeconds(59);
						period_end_date = $filter('date')(period_end_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=<' + period_end_date;
					}
					if (vm.period_start) {
						var period_start_date = vm.period_start.setHours(0);
						period_start_date = vm.period_start.setMinutes(0);
						period_start_date = vm.period_start.setSeconds(1);
						period_start_date = $filter('date')(period_start_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=>' + period_start_date;
					}
				}
			} else if (type == 2) {
				var date = $filter('date')(lowerCommentDate, 'yyyy-MM-ddTHH:mm:ss.sss');
				suffix = suffix + '?-orderby=-imagecommentdate&-limit=1000&imagecommentdate=<' + date;
				if (vm.use_date_range) {
					if (vm.period_start) {
						var period_start_date = vm.period_start.setHours(0);
						period_start_date = vm.period_start.setMinutes(0);
						period_start_date = vm.period_start.setSeconds(1);
						period_start_date = $filter('date')(period_start_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=>' + period_start_date;
					}
				}
				if (!date) {
					return 0;
				}
			} else if (type == 3) {
				var date = $filter('date')(upperCommentDate, 'yyyy-MM-ddTHH:mm:ss.sss');
				suffix = suffix + '?-orderby=imagecommentdate&-limit=1000&imagecommentdate=>' + date;
				if (vm.use_date_range) {
					if (vm.period_end) {
						var period_end_date = vm.period_end.setHours(23);
						period_end_date = vm.period_end.setMinutes(59);
						period_end_date = vm.period_end.setSeconds(59);
						period_end_date = $filter('date')(period_end_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=<' + period_end_date;
					}
				}
				if (!date) {
					return 0;
				}
			} else if (type == 4) {
				var date = $filter('date')(centerdate, 'yyyy-MM-ddTHH:mm:ss.sss');
				suffix = suffix + '?-orderby=imagecommentdate&-limit=200&imagecommentdate=>' + date;
				if (vm.use_date_range) {
					if (vm.period_end) {
						var period_end_date = vm.period_end.setHours(23);
						period_end_date = vm.period_end.setMinutes(59);
						period_end_date = vm.period_end.setSeconds(59);
						period_end_date = $filter('date')(period_end_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=<' + period_end_date;
					}
				}
				if (!date) {
					return 0;
				}
			} else if (type == 5) {
				var date = $filter('date')(centerdate, 'yyyy-MM-ddTHH:mm:ss.sss');
				suffix = suffix + '?-orderby=-imagecommentdate&-limit=200&imagecommentdate=<' + date;
				if (vm.use_date_range) {
					if (vm.period_start) {
						var period_start_date = vm.period_start.setHours(0);
						period_start_date = vm.period_start.setMinutes(0);
						period_start_date = vm.period_start.setSeconds(1);
						period_start_date = $filter('date')(period_start_date, 'yyyy-MM-ddTHH:mm:ss.sss');
						suffix = suffix + '&imagecommentdate=>' + period_start_date;
					}
				}
				if (!date) {
					return 0;
				}
			}
			if (reload) {
				var date = $filter('date')(maxImageCommentDate, 'yyyy-MM-ddTHH:mm:ss.sss');
				suffix = suffix + '?-orderby=-imagecommentdate&imagecommentdate=>' + date;
				if (!date) {
					return 0;
				}
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids.length > 0) {
				suffix = suffix + '&herdId=[';
				for (var j = 0; j < vm.defaultValues.herd_ids.length; j++) {
					suffix = suffix + vm.defaultValues.herd_ids[j];
					if (j != vm.defaultValues.herd_ids.length - 1) {
						suffix = suffix + ',';
					} else {
						suffix = suffix + ']';
					}
				}
			} else {
				var team;
				for (var i = 0; i < vm.teamsHerds.length; i++) {
					if (vm.teamsHerds[i].TeamId == vm.defaultValues.team_id) {
						team = vm.teamsHerds[i];
						break;
					}
				}
				suffix = suffix + '&herdId=[';
				for (var j = 0; j < team.Herds.length; j++) {
					suffix = suffix + team.Herds[j].HerdId;
					if (j != team.Herds.length - 1) {
						suffix = suffix + ',';
					} else {
						suffix = suffix + ']';
					}
				}
			}
			if (vm.tagFilter && vm.tagFilter.length > 0) {
				suffix += '&Tags=' + vm.tagFilter[0].value;
			}
			if (!vm.includeProfilePicture) {
				suffix = suffix + '&Tags=<>ProfilePicture';
			}
			if (vm.animalFilter && vm.animalFilter.length > 0) {
				if (vm.searchByEarTag && vm.searchByNumber && vm.searchByName) {
					suffix = suffix + '&AnimalName=' + vm.animalFilter + '||AnimalNumberString=' + vm.animalFilter + '||AnimalEarTag=' + vm.animalFilter;
				} else if (vm.searchByEarTag && !vm.searchByNumber && !vm.searchByName) {
					suffix = suffix + '&AnimalEarTag=' + vm.animalFilter;
				} else if (!vm.searchByEarTag && vm.searchByNumber && !vm.searchByName) {
					suffix = suffix + '&AnimalNumberString=' + vm.animalFilter;
				} else if (!vm.searchByEarTag && !vm.searchByNumber && vm.searchByName) {
					suffix = suffix + '&AnimalName=' + vm.animalFilter;
				} else if (vm.searchByEarTag && vm.searchByNumber && !vm.searchByName) {
					suffix = suffix + '&AnimalNumberString=' + vm.animalFilter + '||AnimalEarTag=' + vm.animalFilter;
				} else if (vm.searchByEarTag && !vm.searchByNumber && vm.searchByName) {
					suffix = suffix + '&AnimalName=' + vm.animalFilter + '||AnimalEarTag=' + vm.animalFilter;
				} else if (!vm.searchByEarTag && vm.searchByNumber && vm.searchByName) {
					suffix = suffix + '&AnimalName=' + vm.animalFilter + '||AnimalNumberString=' + vm.animalFilter;
				}
			}
			return suffix;
		}

		function loadMore(set_current_index) {
			vm.loading = true;
			//add delay for better loading impression
			$timeout(function () {
				if (!loadingIndicator && vm.images.length) {
					var lnt = vm.images.length;
					var lastImg = vm.images[lnt - 1];
					lastImg = 'image' + lastImg.Id;
					var elem = document.getElementById(lastImg);
					$timeout(function () {
						elem.scrollIntoView(false);
					}, 0);

					loadingIndicator = true;
					var index;
					// find index in all images for last image in showned images
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.images[vm.images.length - 1].Id == vm.allImages[i].Id) {
							index = i;
							break;
						}
					}
					var temp = [];
					angular.copy(vm.allImages, temp);
					if (vm.allImages.length - 1 - index <= 100) {
						loadPictures(false, 2);
					}
					// list of new images to add to showned images
					var listToPush = temp.splice(index + 1, 50);
					var temp = [];
					angular.copy(vm.allImages, temp);
					// get list of images to get comments
					var getCommentsList = temp.splice(index + 51, 50);
					if (getCommentsList.length > 0) {
						createListOfImagesWithComments(getCommentsList, false);
					}
					//add new images
					var imagesTemp = vm.images.concat(listToPush);
					// remove images from top
					if (imagesTemp.length > 100) {
						var difference = imagesTemp.length - 100;
						imagesTemp.splice(0, difference);
					}
					vm.images = imagesTemp;
					if (set_current_index && vm.selectedImage) {
						for (var i = 0; i < vm.images.length; i++) {
							if (vm.selectedImage.Id == vm.images[i].Id) {
								vm.currentImageIndex = i;
								break;
							}
						}
					}
					//prevent calling load more by accident
					$timeout(function () {
						loadingIndicator = false;
						vm.loading = false;
					}, 500);
				}
			}, 100);
		}

		function loadUp(set_current_index) {
			vm.loading = true;
			//add delay for better loading impression
			$timeout(function () {
				if (!loadingIndicator && vm.images.length) {
					vm.first_item = vm.images[0].Id;
					vm.loading = true;
					var index;
					// find index in all images for first image in showned images
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.images[0].Id == vm.allImages[i].Id) {
							index = i;
							break;
						}
					}
					if (index <= 100) {
						loadPictures(false, 3);
					}
					if (index > 0) {
						var temp = [];
						angular.copy(vm.allImages, temp);
						var lowerIndex = index - 50;
						var numberOfImages = 50;
						if (lowerIndex < 0) {
							numberOfImages = 50 - Math.abs(lowerIndex);
							lowerIndex = 0;
						}
						if (lowerIndex == 0) {
						}
						var listToPush = temp.splice(lowerIndex, numberOfImages);
						var imagesTemp = listToPush.concat(vm.images);
						if (imagesTemp.length > 100) {
							var difference = imagesTemp.length - 100;
							imagesTemp = imagesTemp.slice(0, -difference);
						}
						vm.images = imagesTemp;
						$timeout(function () {
							var elem = document.getElementById(vm.first_item);
							if (elem) {
								var parent = elem.parentElement;
								parent.scrollIntoView(true);
							}
						}, 0);
					}
					if (!startedFromFirst) {
						var imageId = vm.images[0].Id;
						var index;
						var found = false;
						for (var i = 0; i < vm.allImages.length; i++) {
							if (vm.allImages[i].Id == imageId) {
								index = i;
								found = true;
								break;
							}
						}
						if (found) {
							if (index > 0) {
								var li = index - 50;
								var nImages = 50;
								if (li < 0) {
									nImages = 50 - Math.abs(li);
									li = 0;
								}
								var temp = [];
								angular.copy(vm.allImages, temp);
								var commentsList = temp.splice(li, nImages);
								createListOfImagesWithComments(commentsList, false);
							}
						}
					}
					if (set_current_index && vm.selectedImage) {
						for (var i = 0; i < vm.images.length; i++) {
							if (vm.selectedImage.Id == vm.images[i].Id) {
								vm.currentImageIndex = i;
								break;
							}
						}
					}
					$timeout(function () {
						vm.loading = false;
						loadingIndicator = false;
					}, 500);
				}
			}, 100);
		}

		function setAnimalFilter() {
			vm.images = [];
			vm.allImages = [];
			vm.animalFilter = vm.animal;
			if (vm.animal && vm.animal.length > 0) {
				vm.showResetAnimalSearchButton = true;
			} else {
				vm.showResetAnimalSearchButton = false;
			}
			loadPictures(false, 1);
		}

		function setAnimalFilterEnter(event) {
			if (event.keyCode == 13) {
				setAnimalFilter();
			}
		}

		function resetAnimalSearch() {
			vm.animal = null;
			setAnimalFilter();
		}

		function selectSearchBy(type) {
			if (type == 'number') {
				vm.searchByNumber = !vm.searchByNumber;
			} else if (type == 'name') {
				vm.searchByName = !vm.searchByName;
			} else if (type == 'ear_tag') {
				vm.searchByEarTag = !vm.searchByEarTag;
			}
			if (!vm.searchByNumber && !vm.searchByName && !vm.searchByEarTag) {
				vm.searchByNumber = true;
				vm.searchByName = true;
				vm.searchByEarTag = true;
			}
			if (searchSettingsTimer) {
				$timeout.cancel(searchSettingsTimer);
			}
			searchSettingsTimer = $timeout(function () {
				if (vm.animal && vm.animal.length > 0) {
					setAnimalFilter();
				}
			}, 500);
		}

		function setTagFilter(item) {
			if (vm.selectedTags.length != 0) {
				vm.selectedTags = [item];
			}
			if (tagFilterTimer) {
				$timeout.cancel(tagFilterTimer);
			}
			tagFilterTimer = $timeout(function () {
				vm.tagFilter = vm.selectedTags;
				vm.images = [];
				vm.allImages = [];
				loadPictures(false, 1);
			}, 500);
		}

		function setCommentFilter() {
			vm.commentFilter = vm.comment;
			vm.images = [];
			vm.allImages = [];
			if (vm.comment && vm.comment.length > 0) {
				vm.showResetCommentSearchButton = true;
			} else {
				vm.showResetCommentSearchButton = false;
			}
			loadPictures(false, 1);
		}

		function setCommentFilterEnter(event) {
			if (event.keyCode == 13) {
				setCommentFilter();
			}
		}

		function resetCommentSearch() {
			vm.comment = null;
			setCommentFilter();
		}

		function includePPChanged() {
			vm.includeProfilePicture = vm.includePP;
			vm.images = [];
			vm.allImages = [];
			loadPictures(false, 1);
		}

		function createDaysMonthsYears(lastDate) {
			var currentDate = new Date();
			var days = [];
			var months = [];
			var years = [];
			var allDates = [];
			var availableDays = [];
			var availableMonths = [];
			var availableYears = [];
			if (vm.use_date_range) {
				currentDate = vm.period_end;
				if (vm.period_start) {
					lastDate = vm.period_start;
				}
			}
			for (var i = 0; i < 8; i++) {
				var obj = {
					value: moment(currentDate).subtract(i, 'days').format('ddd. DD.MM.YYYY.'),
					date: moment(currentDate)
						.set({
							hour: 0,
							minute: 0,
							second: 0,
							milisecond: 0
						})
						.subtract(i, 'days')
						.format()
				};
				days.push(obj);
			}
			for (var i = 0; i < days.length; i++) {
				if (moment(days[i].date).isAfter(moment(lastDate))) {
					availableDays.push(days[i]);
				}
			}
			for (var i = 1; i < 13; i++) {
				var obj = {
					value: moment(currentDate).subtract(i, 'months').format('MMM. YYYY.'),
					date: moment(currentDate)
						.set({
							date: 1,
							hour: 0,
							minute: 0,
							second: 0,
							milisecond: 0
						})
						.subtract(i, 'months')
						.format()
				};
				months.push(obj);
			}
			for (var i = 0; i < months.length; i++) {
				if (moment(months[i].date).isAfter(moment(lastDate))) {
					availableMonths.push(months[i]);
				}
			}
			for (var i = 1; i < 6; i++) {
				var obj = {
					value: moment(currentDate).subtract(i, 'years').format('YYYY.'),
					date: moment(currentDate)
						.set({
							date: 1,
							hour: 0,
							minute: 0,
							second: 0,
							milisecond: 0
						})
						.subtract(i, 'years')
						.format()
				};
				years.push(obj);
			}
			for (var i = 0; i < years.length; i++) {
				if (moment(years[i].date).isAfter(moment(lastDate))) {
					if (moment(months[months.length - 1].date).year() < moment(years[i].date).year()) {
						availableYears.push(years[i]);
					}
				}
			}
			allDates = allDates.concat(availableDays);
			allDates = allDates.concat(availableMonths);
			allDates = allDates.concat(availableYears);
			vm.dates = allDates;
			lastDateFilter = vm.dates[0].date;
			vm.sliderOptions = {
				value: vm.dates[0],
				options: {
					minVal: 0,
					maxVal: 100,
					vertical: true,
					showTicks: true,
					showTicksValues: false,
					stepsArray: vm.dates.reverse(),
					onChange: sliderChanged
				}
			};
			vm.showSlider = true;
		}

		function showImage(index) {
			if (index!= null && index!=undefined) {
				vm.currentImageIndex = index;
				vm.selectedImage = vm.images[index];
				if (vm.currentImageIndex <= 4) {
					loadUp(true);
				} else if (vm.currentImageIndex >= vm.images.length - 5) {
					loadMore(true);
				}
				vm.modalOpen = true;
				startSlideShow();
				vm.slideshow = true;
				$uibModal
					.open({
						animation: true,
						templateUrl: 'app/pages/cockpit/cockpit.image.modal.html',
						size: 'lg',
						scope: $scope,
						backdrop: 'static',
						keyboard: false
					})
					.closed.then(function () {
						vm.modalOpen = false;
					});
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
			stopSlideShow();
		}

		function previousImage(click) {
			if (click && vm.slideshow) {
				startSlideShow();
			}
			if (vm.currentImageIndex > 0) {
				vm.currentImageIndex = vm.currentImageIndex - 1;
				vm.selectedImage = vm.images[vm.currentImageIndex];
				vm.hideImage = true;
				$scope.$evalAsync();
				$timeout(function () {
					vm.hideImage = false;
				}, 10);
				if (vm.currentImageIndex == 4) {
					loadUp(true);
				}
			}
		}

		function nextImage(click) {
			if (click && vm.slideshow) {
				startSlideShow();
			}
			if (vm.currentImageIndex < vm.images.length - 1) {
				vm.currentImageIndex = vm.currentImageIndex + 1;
				vm.selectedImage = vm.images[vm.currentImageIndex];
				vm.hideImage = true;
				$scope.$evalAsync();
				$timeout(function () {
					vm.hideImage = false;
				}, 10);
				if (vm.currentImageIndex == vm.images.length - 5) {
					loadMore(true);
				}
			}
		}

		function startSlideShow() {
			if (slideShowTimer) {
				$interval.cancel(slideShowTimer);
			}
			slideShowTimer = $interval(function () {
				nextImage();
			}, slideShowTimerInterval);
		}

		function stopSlideShow() {
			$interval.cancel(slideShowTimer);
			vm.slideshow = false;
		}

		function startstopSlideshow() {
			if (vm.slideshow) {
				stopSlideShow();
			} else {
				startSlideShow();
				vm.slideshow = true;
			}
		}
		// handling dropdown menu
		vm.showMenuModal = function () {
			stopSlideShow();
			menuActivated = true;
			activeMenu = 'modalMenu';
			document.getElementById('modalMenu').style.display = 'block';
		};

		function showMenu(Id, index) {
			if (activeMenuIndex) {
				vm.images[activeMenuIndex].showMenu = false;
			}
			activeMenuIndex = index;
			vm.images[index].showMenu = true;
			vm.commentText = null;
			menuActivated = true;
			if (activeMenu) {
				if (activeMenu != Id) {
					document.getElementById(activeMenu).style.display = 'none';
					document.getElementById(Id).style.display = 'block';
					activeMenu = Id;
				}
			} else {
				document.getElementById(Id).style.display = 'block';
				activeMenu = Id;
			}
		}

		function changeImportance(image, value, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (image.Importance != value) {
				image.Importance = value;
				if (isCarousel) {
					vm.images[index] = image;
				}
				var suffix = '';
				if (image.Tags) {
					suffix = '&tags=' + encodeURIComponent(image.Tags);
				}
				setImportance(image.Id, value, suffix);
			}
		}

		function changeIsTask(image, value, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (image.Id == vm.images[i].Id) {
						index = i;
						break;
					}
				}
			}
			var suffix = '/updateTask?isTask=';
			if (value) {
				var date = new Date().toISOString();
				suffix = suffix + true + '&taskCompleted=' + date;
				image.IsTask = true;
				image.TaskCompleted = date;
				vm.images[index].IsTask = true;
				vm.images[index].TaskCompleted = date;
				if (isCarousel) {
					vm.selectedImage.IsTask = true;
					vm.selectedImage.TaskCompleted = date;
				}
			} else {
				suffix = suffix + !image.IsTask;
				image.IsTask = !image.IsTask;
				vm.images[index].IsTask = !vm.images[index].IsTask;
				if (isCarousel) {
					vm.selectedImage.IsTask = !vm.selectedImage.IsTask;
				}
				if (!image.IsTask) {
					image.TaskCompleted = null;
					image.TaskCompletedBy = null;
					vm.images[index].TaskCompleted = null;
					vm.images[index].TaskCompletedBy = null;
					if (isCarousel) {
						vm.selectedImage.TaskCompleted = null;
						vm.selectedImage.TaskCompletedBy = null;
					}
				}
			}
			setIsTask(image.Id, suffix, index, isCarousel);
		}

		function setImportance(imageId, value, suffix) {
			return cockpitService
				.setImportance(imageId, value, suffix)
				.then(function (response) {
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.allImages[i].Id == imageId) {
							vm.allImages[i].Importance = response.Importance;
							break;
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function setIsTask(imageId, suffix, index, isCarousel) {
			return cockpitService
				.setIsTask(imageId, suffix)
				.then(function (response) {
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.allImages[i].Id == imageId) {
							vm.allImages[i].IsTask = response.IsTask;
							vm.allImages[i].TaskCompleted = response.TaskCompleted;
							vm.allImages[i].TaskCompletedBy = response.TaskCompletedBy;
						}
					}
					if (response.TaskCompletedBy) {
						if (isCarousel) {
							vm.selectedImage.TaskCompletedBy = response.TaskCompletedBy;
						}
						vm.images[index].TaskCompletedBy = response.TaskCompletedBy;
					}
					vm.images[index].IsTask = response.IsTask;
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function addCommentOnEnter(event, image, index, isCarousel) {
			if (event.keyCode == 13) {
				addComment(image, index, isCarousel);
				if (isCarousel) {
					document.getElementById('modalMenu').style.display = 'none';
				} else {
					document.getElementById(activeMenu).style.display = 'none';
				}
			} else if (event.keyCode == 32) {
				event.preventDefault();
			}
		}

		function addComment(image, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (vm.commentText) {
				vm.commentText.trim();
			}
			if (vm.commentText && vm.commentText.length) {
				var comment = {
					Message: vm.commentText
				};
				addNewComment(image.Id, comment, index, isCarousel);
			}
		}

		function addNewComment(imageId, comment, index) {
			return cockpitService
				.addComment(imageId, comment)
				.then(function (response) {
					vm.images[index].Comments.splice(0, 0, response);
					vm.images[index].NumberComments = vm.images[index].NumberComments + 1;
					vm.commentText = null;
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.allImages[i].Id == imageId) {
							vm.allImages[i].Comments.splice(0, 0, response);
							vm.allImages[i].NumberComments = vm.allImages[i].NumberComments + 1;
							break;
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function addTag(image, item, index) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (image.Tags) {
				var tags = image.Tags + '#' + item.value;
				vm.images[index].Tags = tags;
			} else {
				var tags = '#' + item.value;
				vm.images[index].Tags = tags;
			}
			var suffix = 'tagevent/' + image.Id + '/updateParameters?importance=' + image.Importance + '&tags=' + encodeURIComponent(tags);
			updateTags(image.Id, suffix);
		}

		function updateTags(imageId, suffix) {
			return cockpitService
				.updateTags(suffix)
				.then(function (response) {
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.allImages[i].Id == imageId) {
							vm.allImages[i].Tags = response.Tags;
							break;
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function removeTag(image, item, index) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			var tags = image.Tags.split('#');
			var tagsToSend = [];
			for (var i = 0; i < tags.length; i++) {
				if (tags[i] != '' && tags[i] != item.value) {
					tagsToSend.push(tags[i]);
				}
			}
			var newTags = '';
			for (var i = 0; i < tagsToSend.length; i++) {
				newTags = newTags + '#' + tagsToSend[i];
			}
			vm.images[index].Tags = newTags;
			var suffix = 'tagevent/' + image.Id + '/updateParameters?importance=' + image.Importance + '&tags=' + encodeURIComponent(newTags);
			updateTags(image.Id, suffix);
		}

		function rotateImage(image, rotation, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			return cockpitService
				.rotateImage(image.Id, rotation)
				.then(function (response) {
					vm.images[index].hideImage = true;
					if (isCarousel) {
						vm.selectedImage.hideImage = true;
					}
					var date = new Date().getTime();
					vm.images[index].ThumbnailUrl = vm.images[index].ThumbnailUrl + '?' + date;
					vm.images[index].ImageUrl = vm.images[index].ImageUrl + '?' + date;
					if (isCarousel) {
						vm.selectedImage.ThumbnailUrl = vm.images[index].ThumbnailUrl + '?' + date;
						vm.selectedImage.ImageUrl = vm.images[index].ImageUrl + '?' + date;
					}
					$timeout(function () {
						vm.images[index].hideImage = false;
						if (isCarousel) {
							vm.selectedImage.hideImage = false;
						}
					}, 0);
					for (var i = 0; i < vm.allImages.length; i++) {
						if (vm.allImages[i].Id == image.Id) {
							vm.allImages[i].ThumbnailUrl = vm.images[index].ThumbnailUrl + '?' + date;
							vm.allImages[i].ImageUrl = vm.images[index].ImageUrl + '?' + date;
							break;
						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		function checkForUpdates() {
			polling = true;
			var suffix = createUrlSuffix(true);
			if (suffix != 0) {
				return cockpitService
					.getImages(suffix)
					.then(function (response) {
						if (response.length > 0) {
							maxImageCommentDate = response[0].ImageCommentDate;
							showNotification();
						}
						polling = false;
					})
					.catch(function (error) {
						console.log(error);
						polling = false;
					});
			}
		}

		function poll() {
			if (pollTimer) {
				$timeout.cancel(pollTimer);
			}
			pollTimer = $timeout(function () {
				checkForUpdates();
				poll();
			}, 10000);
		}

		function openNewDiscussionModal() {
			vm.file = null;
			vm.fileName = null;
			vm.selectHerdError = false;
			vm.showHerdSelector = false;
			vm.discussion = {};
			vm.selectedHerd = null;
			vm.loadingNewDiscussion = false;
			vm.discussion.importance = 0;
			if (vm.defaultValues.herd_ids.length == 0) {
				vm.selectHerdError = true;
			} else if (vm.defaultValues.herd_ids.length == 1) {
				vm.selectedHerd = {};
				vm.selectedHerd.HerdId = vm.defaultValues.herd_ids[0];
				vm.discussion.created = new Date().toISOString();
			} else {
				vm.showHerdSelector = true;
				vm.herds = setHerdsByTeam(vm.defaultValues.team_id);
				vm.discussion.created = new Date().toISOString();
			}
			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/cockpit/addNewDiscussion.modal.html',
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function setHerdsByTeam(team_id) {
			var list = [];
			var teamHerds;
			for (var i = 0; i < vm.teamsHerds.length; i++) {
				if (vm.teamsHerds[i].TeamId == team_id) {
					teamHerds = vm.teamsHerds[i].Herds;
					break;
				}
			}
			for (var j = 0; j < vm.defaultValues.herd_ids.length; j++) {
				for (var k = 0; k < teamHerds.length; k++) {
					if (vm.defaultValues.herd_ids[j] == teamHerds[k].HerdId) {
						list.push(teamHerds[k]);
					}
				}
			}
			return list;
		}

		function addNewDiscussion() {
			vm.loadingNewDiscussion = true;
			vm.discussion.herdId = vm.selectedHerd.HerdId;
			var suffix = '?created=' + vm.discussion.created;
			if (vm.discussion.tags && vm.discussion.tags != '') {
				suffix = suffix + '&tags=' + encodeURIComponent(vm.discussion.tags);
			}
			if (vm.discussion.comments && vm.discussion.comments != '') {
				suffix = suffix + '&comments=' + vm.discussion.comments;
			}
			suffix = suffix + '&importance=' + vm.discussion.importance;
			if (vm.discussion.isTask) {
				suffix = suffix + '&isTask=true';
			} else {
				suffix = suffix + '&isTask=false';
			}
			if (vm.file) {
				var url = APP_CONSTANTS.animals_base_url + 'herds/' + vm.discussion.herdId + '/pictures' + suffix;
				Upload.upload({
					url: url,
					data: {
						file: vm.file
					}
				})
					.then(function (response) {
						init();
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						vm.loadingNewDiscussion = false;
						console.log(error);
					});
			} else {
				return cockpitService
					.addNewDiscussion(vm.discussion.herdId, suffix)
					.then(function (response) {
						init();
						$uibModalStack.dismissAll();
					})
					.catch(function (error) {
						vm.loadingNewDiscussion = false;
						console.log(error);
					});
			}
		}

		function newDiscussionSetTags(item, index) {
			var tagsString = '';
			for (var i = 0; i < vm.discussion.tags_list.length; i++) {
				tagsString = tagsString + vm.discussion.tags_list[i].value;
				if (i < vm.discussion.tags_list.length - 1) {
					tagsString = tagsString + '#';
				}
			}
			vm.discussion.tags = tagsString;
		}

		function goToAnimal(image) {
			if (image.AnimalId && Number.isInteger(image.AnimalId)) {
				var protocol = $location.protocol();
				var host = $location.host();
				var port = $location.port();
				var hexID = image.AnimalId.toString(16);
				var path = '/herds/animals/';
				var url = protocol + '://' + host + ':' + port + path + hexID;
				$window.open(url, '_blank');
			}
		}

		function openDateRangeSelector() {
			$uibModal
				.open({
					animation: true,
					templateUrl: 'app/pages/cockpit/dateRange.modal.html',
					size: 'sm',
					scope: $scope,
					backdrop: 'static',
					keyboard: false
				})
				.closed.then(function () {});
		}

		function uploadChanged() {
			vm.fileName = vm.file.name;
		}

		function removeSelectedFile() {
			vm.file = null;
			vm.fileName = null;
		}

		function hideNotification() {
			vm.showNotification = false;
		}

		function moveToTop() {
			init();
			vm.showNotification = false;
		}

		function showNotification() {
			vm.showNotification = true;
		}
		//set dates for date period picker
		function setDatePeriods() {
			vm.use_date_range = false;
			vm.period_end = new Date();
			vm.period_start = null;
		}
		//apply date period
		function setRange() {
			var range_error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (vm.period_start) {
				if (today.isBefore(moment(vm.period_start))) {
					range_error = true;
				}
				if (moment(vm.period_end).isBefore(moment(vm.period_start))) {
					range_error = true;
				}
			}
			if (!range_error) {
				closeModal();
				$timeout(function () {
					vm.use_date_range = true;
					init();
				}, 300);
			}
		}
		//reset and apply default date period
		function resetRange() {
			closeModal();
			setDatePeriods();
			init();
		}
		$scope.$on('$destroy', function () {
			$timeout.cancel(pollTimer);
			stopSlideShow();
		});
		$scope.$on('default_herd_selected', function (event, obj) {
			if (obj.state == 'cockpit') {
				init();
			}
		});
		$scope.$on('default_team_selected', function (event, obj) {
			if (obj.state == 'cockpit') {
				init();
			}
		});
		$(document).keydown(function (event) {
			if (vm.modalOpen) {
				if (event.keyCode == 37) {
					previousImage();
				} else if (event.keyCode == 39) {
					nextImage();
				}
			}
		});
		$(function () {
			$('body').click(function (e) {
				if (menuActivated) {
					$timeout(function () {
						menuActivated = false;
					}, 250);
				} else {
					if (e.target.id == activeMenu || $(e.target).parents('#' + activeMenu + '').length) {
					} else {
						if (activeMenu) {
							document.getElementById(activeMenu).style.display = 'none';
							activeMenu = null;
						}
					}
				}
			});
		});
		$(window).scroll(function () {
			if ($(window).scrollTop() > 130) {
				$timeout(function () {
					vm.showFixedMenu = true;
				}, 150);
			} else {
				$timeout(function () {
					vm.showFixedMenu = false;
				}, 150);
			}
		});
		$scope.$on('$destroy', function () {});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.cockpit').factory('cockpitService', cockpitService);
    /** @ngInject */
    function cockpitService($http, $q, APP_CONSTANTS) {
        return {
            getImages: getImages
            , getCommentsForIds: getCommentsForIds
            , setImportance: setImportance
            , setIsTask: setIsTask
            , addComment: addComment
            , updateTags: updateTags
            , rotateImage: rotateImage
            , getUserTeamHerds: getUserTeamHerds
            , addNewDiscussion: addNewDiscussion
            , deletePicture: deletePicture
        }

        function getImages(suffix) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'pictures' + suffix, {
                //withCredentials: true
            }).then(success).catch(error);
        }

        function getCommentsForIds(ids) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'comments?entityId=' + ids + '&orderby=-comentTimestamp', {
                //withCredentials: true
            }).then(success).catch(error);
        }

        function setImportance(image_id, value, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'tagevent/' + image_id + '/updateParameters?importance=' + value + suffix).then(success).catch(error);
        }

        function setIsTask(image_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + suffix, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function addComment(image_id, comment) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + '/comments', comment).then(success).catch(error);
        }

        function updateTags(suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + suffix).then(success).catch(error);
        }

        function rotateImage(imagId, rotation) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + imagId + '/rotate/' + rotation).then(success).catch(error);
        }

        function getUserTeamHerds(user_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'users/' + user_id + '/userteamherdaccess').then(success).catch(error);
        }

        function addNewDiscussion(herd_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/pictures' + suffix).then(success).catch(error);
        }

        function deletePicture(picture_id) {
            return $http.delete(APP_CONSTANTS.animals_base_url + 'pictures/' + picture_id).then(success).catch(error);
        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.conception-cusum-analysis")
    .controller("conceptionCusumAnalysisCtrl", conceptionCusumAnalysisCtrl);
  /** @ngInject */
  function conceptionCusumAnalysisCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_conception_cusum_analysis_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular
    .module("My.pages.conception-cusum-analysis-heifers")
    .controller("conceptionCusumAnalysisHeifersCtrl", conceptionCusumAnalysisHeifersCtrl);
  /** @ngInject */
  function conceptionCusumAnalysisHeifersCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular
    .module("My.pages.conception-rate")
    .controller("conceptionRateCowsCtrl", conceptionRateCowsCtrl);
  /** @ngInject */
  function conceptionRateCowsCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_conception_rate_cows_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular.module("My.pages.dq").controller("dqCtrl", dqCtrl);
  /** @ngInject */
  function dqCtrl(
    herdDashboardsService,
    dashboardsService,
    $q,
    $rootScope,
    $filter,
    $timeout,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService
  ) {
    var vm = this;

    var tableauPromise;
    var viz;
    var measureNameParam;
    var herdSelectedTimer;

    vm.init = init;
    vm.reload = reload;
    vm.selectDashboard = selectDashboard;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.showDatePeriod = showDatePeriod;

    vm.work_locally = false;

    init();

    function init() {
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      measureNameParam = "Measure name parameter";
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = [];

        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function () {
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response) {
        var d_list = [
          {
            dev: true,
            id: "StreamerHealthOverview",
            description: "Streamer Health Overview",
            category: "animal",
            subcategory: "data-quality",
            locale: "en-GB",
            url: "https://visual-stg.mmmooogle.com/t/Development/views/StreamerHerdOverviewLive/StreamerHealthOverview?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
          },
          {
            dev: true,
            id: "Herdoverviewdashboard",
            description: "Herd overview dashboard",
            category: "animal",
            subcategory: "data-quality",
            locale: "en-GB",
            url: "https://visual-stg.mmmooogle.com/t/Development/views/StreamerHerdOverviewLive/Herdoverviewdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
          },
        ];
        if (permissionService.isGlobalAdmin) {
          response = response.concat(d_list);
        }

        var list = [];
        for (var i = 0; i < response.length; i++) {
          if (
            response[i].category == "animal" &&
            response[i].subcategory == "data-quality"
          ) {
            response[i].title = response[i].description;
            list.push(response[i]);
          }
        }
        list = orderList(list);
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            thumbnail: setDashboardThumbnail(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        //setDashboardThumbnails(dash);
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }

      function orderList(list) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].id == "Dataoverview") {
            list[i].ord = i + 200;
          } else if (
            list[i].id == "StreamerHealthOverview" ||
            list[i].id == "Herdoverviewdashboard"
          ) {
            list[i].ord = i + 100;
          } else {
            list[i].ord = i;
          }
        }
        return $filter("orderBy")(list, "ord", true);
      }
    }

    function setDashboardThumbnail(dashboard) {
      var thumb;
      switch (dashboard.id) {
        case "Dataoverview":
          thumb = "assets/img/thumbnails/dq_data_overview.png";
          break;
        case "Dataoverviewdashboard":
          thumb = "assets/img/thumbnails/dq_data_overview_db.png";
          break;
        case "Eventsovertimedashboard":
          thumb = "assets/img/thumbnails/dq_events_over_time.png";
          break;
        case "Birthdashboard":
          thumb = "assets/img/thumbnails/dq_birth.png";
          break;
        case "Concentrateintakedashboard":
          thumb = "assets/img/thumbnails/dq_concentrate_intake.png";
          break;
        case "Milkmetersdashboard":
          thumb = "assets/img/thumbnails/dq_milk_meters.png";
          break;
        case "Healtheventsdashboard":
          thumb = "assets/img/thumbnails/dq_health_events.png";
          break;
        case "Reproductiondashboard":
          thumb = "assets/img/thumbnails/dq_reproduction.png";
          break;
        case "Reproductionheifersdashboard":
          thumb = "assets/img/thumbnails/dq_reproduction_heifers.png";
          break;
        case "Milkrecordingdashboard":
          thumb = "assets/img/thumbnails/dq_milk_recording.png";
          break;
        case "StreamerHealthOverview":
          thumb = "assets/img/thumbnails/dq_streamer_health_overview.png";
          break;
        case "Herdoverviewdashboard":
          thumb = "assets/img/thumbnails/dq_herd_overview_dashboard.png";
          break;
        default:
          thumb = null;
          break;
      }

      return thumb;
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function selectDashboard(dashboard, type, set_default) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        vm.selectedTime = 1;
      }
      openDashboard(dashboard, type);
    }

    function openDashboard(dashboard, type) {
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      embedPage(dash);
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function embedPage(dashboard) {
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }

      if (dev) {
        embed(url, herds, useTabvis);
      } else {
        if (useTabvis) {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        } else {
          //var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-3091-reproduction-zoetis_en-GB_twb/Conceptioncusumanalysisheifers?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
          var url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-animal-data-quality_en-GB_twb/Dataoverviewdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
          //var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-3091-health-subclinical-mastitis-list_en-GB_twb/Linerchangedashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

          // team-3091-reproduction-zoetis_nl-NL_twb/Inseminatiestrategiebijkoeien
          // team-3091-reproduction-zoetis_en-GB_twb/Inseminationstrategyincows

          embed(url, herds);
        }
      }
    }

    function embed(url, herds) {
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          "Herd Parameter": herdParam,
          onFirstInteractive: function () {
            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
            }
          },
        };
      }

      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      $timeout(function () {
        var containerDiv = document.getElementById("frame");
        viz = new tableau.Viz(containerDiv, url, options);
        viz.addEventListener(
          tableau.TableauEventName.STORY_POINT_SWITCH,
          onStoryPointChange
        );
      }, 1000);
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync("Herd Parameter", herdParam);
            });
        });
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function reload() {
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        vm.showBaseTable = true;
      }, 50);
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboards/custom.modal.html", "sm");
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function showDatePeriod() {
      return permissionService.isGlobalAdmin;
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });

    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });

    $scope.$on("dashboards_back", function () {
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });

    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.dq').controller('dq2Ctrl', dqCtrl);
	/** @ngInject */
	function dqCtrl($timeout, APP_CONSTANTS, dashboardsService, robotViewService, $uibModal, $uibModalStack, $filter, $scope, $http, $q, toastr) {
		var vm = this;
		var viz;
		var mapTimeout;
		var timeout;
		var reloadTimeout;
		vm.init = init;
		vm.openRangeSelector = openRangeSelector;
		vm.closeModal = closeModal;
		vm.setRange = setRange;

		init();

		function init() {
			setDates();
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			if (vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == "cs-CZ") {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.work_locally = false;
			if (vm.selectedTeam) {
				getDashboards(vm.selectedTeam);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			if (vm.work_locally) {
				var dashboards = [];
				var obj = {
					dashboards: dashboards,
					expires: moment().add(30, 'minutes').format(),
					team_id: team_id,
					lng: vm.currentLng
				};
				dashboardsService.loadedDashboards = obj;
				processDashboards(dashboards, team_id);
			} else {
				if (dashboardsService && dashboardsService.loadedDashboards.dashboards && dashboardsService.loadedDashboards.team_id == team_id && dashboardsService.loadedDashboards.lng == vm.currentLng) {
					if (moment(dashboardsService.loadedDashboards.expires).isBefore(moment())) {
						useAPI(team_id);
					} else {
						var dashboards = [];
						angular.copy(dashboardsService.loadedDashboards.dashboards, dashboards);
						processDashboards(dashboards, team_id);
					}
				} else {
					useAPI(team_id);
				}
			}
		}

		function useAPI(team_id) {
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return robotViewService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id,
								lng: vm.currentLng
							};
							dashboardsService.loadedDashboards = obj;
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					console.log(error);
					if (!vm.teamReselected) {
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				console.log('error', data);
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			if (response.length > 0) {
				var dashboard;
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'rap-fame-v3' && (response[i].id == 'RAPHerddashboard' || response[i].id == 'RAPBedrijfsdashboard' || response[i].id == 'RAPHerdentabelle' || response[i].id == 'TableaudeborddutroupeauRAP')) {
						dashboard = response[i];
						break;
					}
				}
				vm.allDashboards = response;
				vm.mapActive = dashboard;
				if (dashboard) {
					embedPage(dashboard);
					mapTimeout = $timeout(function () {
						var containerDiv = document.getElementById('panel-map');
						var height;
						if (containerDiv) {
							height = containerDiv.offsetHeight;
						}
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard) {
			vm.disableRangeSelector = true;
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			embed(url);
		}

		function embed(url) {
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}

			if (vm.work_locally) {
				//var url = 'https:///visual-prd.mmmooogle.com/t/Production/views/team-3091-production-rap-fame-v3_en-GB_twb/RAPHerddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-animal-data-quality_en-GB_twb/Dataoverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-animal-data-quality_en-GB_twb/Eventsovertime?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-2756-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-52-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

				openDashboard(url, deviceType);
			} else {
				return robotViewService
					.setSession(url)
					.then(function (response) {
						vm.loadingDashboards = false;
						vm.showButtons = true;
						//var url = response.headers('tabvis-location');
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-animal-data-quality_en-GB_twb/Dataoverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						openDashboard(url, deviceType);
					})
					.catch(function (response) {
						vm.disableRangeSelector = false;
						vm.loadingDashboards = false;
						vm.errorLoading = true;
						if (response.status == 404) {
							toastr.error('Workbook not deployed');
						}
						console.log('error getting tabvis-location header');
					});
			}
		}

		function createHerdParam(herds) {
			if (vm.selectedHerds.length == 0) {
				return 0;
			}
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function openDashboard(url, deviceType) {
			var herdParam = createHerdParam(vm.selectedHerds);
			if (url) {
				url = url + '&:render=true&:refresh=yes';
				var options = {
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd'),
					'Herd Parameter': herdParam,
					device: deviceType,
					onFirstInteractive: function () {
						$timeout(function () {
							vm.disableRangeSelector = false;
						}, 100);
					}
				};

				$timeout(function () {
					var containerDiv = document.getElementById('rapFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.STORY_POINT_SWITCH, onTabSwitch);
				}, 100);
			}
		}

		function onTabSwitch(event) {
			applyParameters(true, true, true);
		}

		function openRangeSelector() {
			if (!vm.disableRangeSelector) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.actualDashboardOpen, vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function checkRangeError(actual_open, start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (!actual_open) {
				if (moment(end_date).isBefore(start_date)) {
					error = true;
				}
			}
			return error;
		}

		function applyParameters(start_date_changed, end_date_changed, story) {
			var start_date = vm.start_date;
			var end_date = vm.end_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook()
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.getWorkbook()
								.changeParameterValueAsync('End Date', end_date)
								.then(function (param) {
									if (story && vm.selectedHerds.length > 0) {
										var herdParam = createHerdParam(vm.selectedHerds);
										viz.getWorkbook().changeParameterValueAsync('Herd Parameter', herdParam);
									}
								});
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.teamReselected = true;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}
			reloadTimeout = $timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 500);
		});

		$scope.$on('default_herd_selected', function (event, data) {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				var herdParam = createHerdParam(vm.selectedHerds);
				viz.getWorkbook().changeParameterValueAsync('Herd Parameter', herdParam);
			}
		});

		$scope.$on('$destroy', function () {
			if (reloadTimeout) {
				$timeout.cancel(reloadTimeout);
			}
			if (timeout) {
				timeout.resolve('cancel_request');
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
  "use strict";
  angular
    .module("My.pages.conception-strategy-heifers")
    .controller("conceptionStrategyHeifersCtrl", conceptionStrategyHeifersCtrl);
  /** @ngInject */
  function conceptionStrategyHeifersCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_conception_strategy_heifers_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herd-overview")
    .controller("herdOverviewCtrl", herdOverviewCtrl);
  /** @ngInject */
  function herdOverviewCtrl(
    $timeout,
    $filter,
    A_DASH_CONSTANTS,
    arvestaDashboardService,
    dashboardsService,
    cookiesService,
    aDashboardsService,
    permissionService,
    $scope
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboardsList = A_DASH_CONSTANTS.dashboards;
    vm.init = init;

    init();

    function init() {
      vm.loading = true;
      vm.loadingDashboards = true;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;
      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function setStrings() {
      vm.herdOverviewDashboard = i18nFilter("_arv_herd_overview_dashboard");
      vm.viewDataDashboard = i18nFilter("_dashboard_name_view_data_");
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.herdOverviewDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == vm.herdOverviewDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboardsList.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-milk-yield_en-GB_twb/HerdOverviewDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "herd-overview",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: true,
          viewDataDashboard: vm.viewDataDashboard,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init(true);
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.home').controller('homeCtrl', homeCtrl);
	/** @ngInject */
	function homeCtrl($timeout, homeService, $state, $sce, $scope, herdDashboardsService, $rootScope, $http, $q, APP_CONSTANTS, permissionService) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var timeout = $q.defer();
		vm.goToState = goToState;
		vm.setActiveMap = setActiveMap;
		vm.hideButtons = hideButtons;
		vm.work_locally = false;
		init();

		function init() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(30, 'days').toISOString());
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.showCockpitShortcut = permissionService.can(43);
			vm.showDashboardsShortcut = permissionService.can(16);
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function getDashboards(team_id) {
			if(vm.work_locally){
				var dashboards = []
				  processDashboards(dashboards);
			}else{
				var dashboards = angular.copy(herdDashboardsService.tableauStored);
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards);
				}
			} else {
				useAPI(team_id);
			}
			}
			
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			var setSession = setSessionHandler(team_id);

			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return homeService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							herdDashboardsService.tableauStored = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});

			return result.promise;
		}

		function processDashboards(response) {
			if (response.length > 0) {
				var thi_dashboard;
				var thi_dasboard_index;
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'front-page-mro' && (response[i].id == 'Milkrecordingmap' || response[i].id == 'KartemitMilchaufzeichnungen' || response[i].id == 'Cartographieducontrlelaitier' || response[i].id == 'Melkcontrolekaart')) {
						thi_dashboard = response[i];
						thi_dasboard_index = i;
						break;
					}
				}
				if (thi_dashboard && thi_dasboard_index != null && thi_dasboard_index != undefined) {
					response.splice(thi_dasboard_index, 1);
					response.splice(0, 0, thi_dashboard);
				} else {
					response = response.reverse();
				}
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'front-page-thi' || response[i].subcategory == 'front-page-mro' || response[i].subcategory == 'front-page-mm') {
						dashboards.push(response[i]);
					}
				}
				vm.dashboards = dashboards;
				vm.mapActive = vm.dashboards[0];
				if (vm.dashboards[0]) {
					embedPage(vm.dashboards[0]);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function hideButtons() {
			vm.showButtons = !vm.showButtons;
		}

		function goToState(state) {
			$state.go(state);
		}

		function setActiveMap(dashboard) {
			vm.mapActive = dashboard;
			embedPage(dashboard);
		}

		function embedPage(dashboard) {
			vm.loadingDashboards = false;
			var url = dashboard.url;
			if(vm.work_locally){
				url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-3091-plus-front-page-mro_en-GB_twb/Milkrecordingmap?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
			}
			var start_date_suffix = '&startDate=' + vm.start_date.toISOString();
			var end_date_suffix = '&endDate=' + vm.end_date.toISOString();
			url = url + start_date_suffix + end_date_suffix;
			//chek if user is 'forfarmers'
			// if true use Tableau JS API
			// if false just embed page
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			vm.loadingDashboards = false;
			vm.showButtons = true;
			if (vm.selectedHerds.length > 0) {
				url = url + '&herd=';
				for (var i = 0; i < vm.selectedHerds.length; i++) {
					if (i > 0) {
						url = url + ',';
					}
					url = url + vm.selectedHerds[i];
				}
			}
			vm.embed = $sce.trustAsResourceUrl(url);
		}

		$scope.$on('default_herd_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;

			embedPage(vm.mapActive);
		});

		$scope.$on('default_team_selected', function () {
			init();
		});
		$scope.$on('default_values_loaded', function () {
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			var newDefaultValues = localStorage.getItem('default_values');
			if (newDefaultValues != JSON.stringify(vm.defaultValues)) {
				init();
			}
		});

		$scope.$on('$destroy', function () {
			timeout.resolve();
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.home').controller('homeCtrlNew', homeCtrlNew);
	/** @ngInject */
	function homeCtrlNew($timeout, herdDashboardsService, homeService, $q, APP_CONSTANTS, $rootScope, $http, $uibModalStack, $cookies, $uibModal, $scope, $filter, cookiesService) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var viz;
		var timeout = $q.defer();
		var herdIdentifierFiltterName;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var startDateParameterName;
		var endDateParameterName;
		var dataDashboardName;
		var dataDashboardSheetName;
		var clawHealthDashboardFilterPairs = APP_CONSTANTS.constants.clawHealthDashboardFilterPairs;
		vm.selectCategory = selectCategory;
		vm.openRangeSelector = openRangeSelector;
		vm.setRange = setRange;
		vm.closeModal = closeModal;
		vm.goBack = goBack;
		vm.selectedCategory = 1;
		init();

		function setStrings() {
			dataDashboardName = "{{Show data dashboard}}";
			dataDashboardSheetName = "{{Show all}}";

			if (vm.selectedCategory == 1) {
				herdParamName = "herd parametar";
				herdIdentifierFiltterName = "HerdIdentifier";
				oldSheetName = "{{Home dashboard}}";
				newSheetName = "{{Reproduction dashboard}}";
				startDateParameterName = "Start Date";
				endDateParameterName = "End Date";
			} else if (vm.selectedCategory == 2) {
				herdIdentifierFiltterName = "Herd identifier";
				oldSheetName = "unknown";
				newSheetName = "unknown";
				startDateParameterName = "Start Date";
				endDateParameterName = "End Date";
			} else if (vm.selectedCategory == 3) {
				herdParamName = "{{Herd parametar}}";
				herdIdentifierFiltterName = "HerdIdentifier";
				oldSheetName = "{{Home claw health dashboard}}";
				newSheetName = "{{Claw health dashbaord}}";
				startDateParameterName = "{{Start Date}}";
				endDateParameterName = "{{End Date}}";
			} else if (vm.selectedCategory == 4) {
				herdIdentifierFiltterName = "Herd identifier";
				oldSheetName = "unknown";
				newSheetName = "unknown";
				startDateParameterName = "Start Date";
				endDateParameterName = "End Date";
			} else if (vm.selectedCategory == 5) {
				herdIdentifierFiltterName = "herd_id";
				oldSheetName = "unknown";
				newSheetName = "unknown";
				startDateParameterName = "";
				endDateParameterName = "";
			}
		}

		function init() {
			setBackButtonVisibility(false);
			setDates();
			vm.disableCategoryButtons = true;

			setStrings();
			if (teamTimeout) {
				$timeout.cancel(teamTimeout)
			}
			var lng = localStorage.getItem('lng');
			if (lng) {
				if(lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ'){
					vm.currentLng = 'en-GB';
				}else{
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		};

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(12).minute(0).seconds(0).millisecond(0).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			//for local testing
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			dashboards.dashboards = [{
				"id": "Cullinganddeadrate",
				"description": "Culling and dead rate",
				"category": "animal",
				"subcategory": "cullingrate",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Cullinganddeadrate&category=animal&subcategory=cullingrate&locale=en-GB"
			}, {
				"id": "THIdashboard",
				"description": "THI dashboard",
				"category": "environment",
				"subcategory": "thi",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=THIdashboard&category=environment&subcategory=thi&locale=en-GB"
			}, {
				"id": "Weeklytemperaturehumidityindexmap",
				"description": "Weekly temperature humidity index map",
				"category": "environment",
				"subcategory": "thi",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Weeklytemperaturehumidityindexmap&category=environment&subcategory=thi&locale=en-GB"
			}, {
				"id": "ConceptionrateTHIovertime",
				"description": "Conception rate & THI over time",
				"category": "environment",
				"subcategory": "thi",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=ConceptionrateTHIovertime&category=environment&subcategory=thi&locale=en-GB"
			}, {
				"id": "Hoofhealth",
				"description": "Hoof health",
				"category": "health",
				"subcategory": "cows-hoof",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Hoofhealth&category=health&subcategory=cows-hoof&locale=en-GB"
			}, {
				"id": "Clinicalmastitiscases",
				"description": "Clinical mastitis cases",
				"category": "health",
				"subcategory": "cows-mastitis",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Clinicalmastitiscases&category=health&subcategory=cows-mastitis&locale=en-GB"
			}, {
				"id": "Overallcellcountanalysis",
				"description": "Overall cell count analysis",
				"category": "health",
				"subcategory": "udder-health-cellcountanalysis",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Overallcellcountanalysis&category=health&subcategory=udder-health-cellcountanalysis&locale=en-GB"
			}, {
				"id": "Transitioninfection",
				"description": "Transition infection",
				"category": "health",
				"subcategory": "udder-health-cellcountanalysis",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Transitioninfection&category=health&subcategory=udder-health-cellcountanalysis&locale=en-GB"
			}, {
				"id": "Lactationinfectionrate",
				"description": "Lactation infection rate",
				"category": "health",
				"subcategory": "udder-health-cellcountanalysis",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Lactationinfectionrate&category=health&subcategory=udder-health-cellcountanalysis&locale=en-GB"
			}, {
				"id": "Milkmetermap",
				"description": "Milk meter map",
				"category": "plus",
				"subcategory": "front-page-mm",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmetermap&category=plus&subcategory=front-page-mm&locale=en-GB"
			}, {
				"id": "Milkrecordingmap",
				"description": "Milk recording map",
				"category": "plus",
				"subcategory": "front-page-mro",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkrecordingmap&category=plus&subcategory=front-page-mro&locale=en-GB"
			}, {
				"id": "SCCmap",
				"description": "SCC map",
				"category": "plus",
				"subcategory": "front-page-mro",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=SCCmap&category=plus&subcategory=front-page-mro&locale=en-GB"
			}, {
				"id": "Temperaturehumiditymap",
				"description": "Temperature humidity map",
				"category": "plus",
				"subcategory": "front-page-thi",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Temperaturehumiditymap&category=plus&subcategory=front-page-thi&locale=en-GB"
			}, {
				"id": "Milkmeter",
				"description": "Milk meter",
				"category": "plus",
				"subcategory": "mobile-milk-meter",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeter&category=plus&subcategory=mobile-milk-meter&locale=en-GB"
			}, {
				"id": "TankMilkmeterActualDashboard",
				"description": "Tank/Milk meter Actual Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=TankMilkmeterActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "MROActualDashboard",
				"description": "MRO Actual Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MROActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "HerdDashboard",
				"description": "Herd Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=HerdDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "MilkProductionDashboard",
				"description": "Milk Production Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MilkProductionDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "MilkProductionActualDashboard",
				"description": "Milk Production Actual Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MilkProductionActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "MilkProductionTrendsDashboard",
				"description": "Milk Production Trends Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MilkProductionTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "ProteinPercentageDashboard",
				"description": "Protein Percentage Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=ProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "FatProteinPercentageDashboard",
				"description": "Fat + Protein Percentage Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=FatProteinPercentageDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "UreaActualDashboard",
				"description": "Urea Actual Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=UreaActualDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "UreaTrendsDashboard",
				"description": "Urea Trends Dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=UreaTrendsDashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "Milkmeterdashboard",
				"description": "Milk meter dashboard",
				"category": "production",
				"subcategory": "agroscoop",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeterdashboard&category=production&subcategory=agroscoop&locale=en-GB"
			}, {
				"id": "Feedintakedetailbydaysinmilk",
				"description": "Feed intake detail by days in milk",
				"category": "production",
				"subcategory": "feed-intake",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Feedintakedetailbydaysinmilk&category=production&subcategory=feed-intake&locale=en-GB"
			}, {
				"id": "Feedintakedetailbyparity",
				"description": "Feed intake detail by parity",
				"category": "production",
				"subcategory": "feed-intake",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Feedintakedetailbyparity&category=production&subcategory=feed-intake&locale=en-GB"
			}, {
				"id": "Feedusagedashboard",
				"description": "Feed usage dashboard",
				"category": "production",
				"subcategory": "feed-intake",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Feedusagedashboard&category=production&subcategory=feed-intake&locale=en-GB"
			}, {
				"id": "IOFCdashboard",
				"description": "IOFC dashboard",
				"category": "production",
				"subcategory": "milk-iofc",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=IOFCdashboard&category=production&subcategory=milk-iofc&locale=en-GB"
			}, {
				"id": "IndividualIOFC",
				"description": "Individual IOFC",
				"category": "production",
				"subcategory": "milk-iofc",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=IndividualIOFC&category=production&subcategory=milk-iofc&locale=en-GB"
			}, {
				"id": "Milkmeteroverview",
				"description": "Milk meter overview",
				"category": "production",
				"subcategory": "milk-meter-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeteroverview&category=production&subcategory=milk-meter-curve&locale=en-GB"
			}, {
				"id": "Milkmeter305dyieldfocus",
				"description": "Milk meter 305d yield focus",
				"category": "production",
				"subcategory": "milk-meter-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeter305dyieldfocus&category=production&subcategory=milk-meter-curve&locale=en-GB"
			}, {
				"id": "Milkmeterfocus",
				"description": "Milk meter focus",
				"category": "production",
				"subcategory": "milk-meter-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeterfocus&category=production&subcategory=milk-meter-curve&locale=en-GB"
			}, {
				"id": "Milkmeterlactationcurveanalysis",
				"description": "Milk meter lactation curve analysis",
				"category": "production",
				"subcategory": "milk-meter-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeterlactationcurveanalysis&category=production&subcategory=milk-meter-curve&locale=en-GB"
			}, {
				"id": "Persistencyfocus",
				"description": "Persistency focus",
				"category": "production",
				"subcategory": "milk-meter-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Persistencyfocus&category=production&subcategory=milk-meter-curve&locale=en-GB"
			}, {
				"id": "Milkmeterdashboard",
				"description": "Milk meter dashboard",
				"category": "production",
				"subcategory": "milk-meter",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkmeterdashboard&category=production&subcategory=milk-meter&locale=en-GB"
			}, {
				"id": "Lactationcurveanalysisbyherd",
				"description": "Lactation curve analysis by herd",
				"category": "production",
				"subcategory": "milk-recording-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Lactationcurveanalysisbyherd&category=production&subcategory=milk-recording-curve&locale=en-GB"
			}, {
				"id": "Lactationcurveanalysisbyteam",
				"description": "Lactation curve analysis by team",
				"category": "production",
				"subcategory": "milk-recording-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Lactationcurveanalysisbyteam&category=production&subcategory=milk-recording-curve&locale=en-GB"
			}, {
				"id": "LactationcurveanalysisbyAIcompany",
				"description": "Lactation curve analysis by AI company",
				"category": "production",
				"subcategory": "milk-recording-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=LactationcurveanalysisbyAIcompany&category=production&subcategory=milk-recording-curve&locale=en-GB"
			}, {
				"id": "Lactationcurveanalysisbymilkrecordingdate",
				"description": "Lactation curve analysis by milk recording date",
				"category": "production",
				"subcategory": "milk-recording-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Lactationcurveanalysisbymilkrecordingdate&category=production&subcategory=milk-recording-curve&locale=en-GB"
			}, {
				"id": "Lactationcurveanalysisbycalvingdate",
				"description": "Lactation curve analysis by calving date",
				"category": "production",
				"subcategory": "milk-recording-curve",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Lactationcurveanalysisbycalvingdate&category=production&subcategory=milk-recording-curve&locale=en-GB"
			}, {
				"id": "MilkrecordingparametertablebyAIcompany",
				"description": "Milk recording parameter table by AI company",
				"category": "production",
				"subcategory": "milk-recording-genetics",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MilkrecordingparametertablebyAIcompany&category=production&subcategory=milk-recording-genetics&locale=en-GB"
			}, {
				"id": "Geneticmilkrecordingrealisation",
				"description": "Genetic milk recording realisation",
				"category": "production",
				"subcategory": "milk-recording-genetics",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Geneticmilkrecordingrealisation&category=production&subcategory=milk-recording-genetics&locale=en-GB"
			}, {
				"id": "Geneticmilkrecordingevolution",
				"description": "Genetic milk recording evolution ",
				"category": "production",
				"subcategory": "milk-recording-genetics",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Geneticmilkrecordingevolution&category=production&subcategory=milk-recording-genetics&locale=en-GB"
			}, {
				"id": "Milkrecordingbyherd",
				"description": "Milk recording by herd",
				"category": "production",
				"subcategory": "milk-recording",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkrecordingbyherd&category=production&subcategory=milk-recording&locale=en-GB"
			}, {
				"id": "Milkrecordingbyteam",
				"description": "Milk recording by team",
				"category": "production",
				"subcategory": "milk-recording",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkrecordingbyteam&category=production&subcategory=milk-recording&locale=en-GB"
			}, {
				"id": "MilkrecordingbyAIcompany",
				"description": "Milk recording by AI company",
				"category": "production",
				"subcategory": "milk-recording",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=MilkrecordingbyAIcompany&category=production&subcategory=milk-recording&locale=en-GB"
			}, {
				"id": "Milkrecordingdashboard",
				"description": "Milk recording dashboard",
				"category": "production",
				"subcategory": "milk-recording",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Milkrecordingdashboard&category=production&subcategory=milk-recording&locale=en-GB"
			}, {
				"id": "Calvingpatternbyparity",
				"description": "Calving pattern by parity",
				"category": "reproduction",
				"subcategory": "calving-pattern",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Calvingpatternbyparity&category=reproduction&subcategory=calving-pattern&locale=en-GB"
			}, {
				"id": "CalvingpatternbyAIcompany",
				"description": "Calving pattern by AI company",
				"category": "reproduction",
				"subcategory": "calving-pattern",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=CalvingpatternbyAIcompany&category=reproduction&subcategory=calving-pattern&locale=en-GB"
			}, {
				"id": "AIcompanypreferencebyherd",
				"description": "AI company preference by herd",
				"category": "reproduction",
				"subcategory": "calving-pattern",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=AIcompanypreferencebyherd&category=reproduction&subcategory=calving-pattern&locale=en-GB"
			}, {
				"id": "Inseminationstrategyincows",
				"description": "Insemination strategy in cows",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Inseminationstrategyincows&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Conceptionstrategyincows",
				"description": "Conception strategy in cows",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Conceptionstrategyincows&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Bullstrategyincows",
				"description": "Bull strategy in cows",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Bullstrategyincows&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Sirestrategyincows",
				"description": "Sire strategy in cows",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Sirestrategyincows&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Synchronisationcheck",
				"description": "Synchronisation check",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Synchronisationcheck&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Conceptioncusumanalysis",
				"description": "Conception cusum analysis",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Conceptioncusumanalysis&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Oestrusintervalanalysis",
				"description": "Oestrus interval analysis",
				"category": "reproduction",
				"subcategory": "cows",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Oestrusintervalanalysis&category=reproduction&subcategory=cows&locale=en-GB"
			}, {
				"id": "Inseminationstrategyinheifers",
				"description": "Insemination strategy in heifers",
				"category": "reproduction",
				"subcategory": "youngstock",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Inseminationstrategyinheifers&category=reproduction&subcategory=youngstock&locale=en-GB"
			}, {
				"id": "Conceptionstrategyinheifers",
				"description": "Conception strategy in heifers",
				"category": "reproduction",
				"subcategory": "youngstock",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Conceptionstrategyinheifers&category=reproduction&subcategory=youngstock&locale=en-GB"
			}, {
				"id": "Bullstrategyinheifers",
				"description": "Bull strategy in heifers",
				"category": "reproduction",
				"subcategory": "youngstock",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Bullstrategyinheifers&category=reproduction&subcategory=youngstock&locale=en-GB"
			}, {
				"id": "Sirestrategyinheifers",
				"description": "Sire strategy in heifers",
				"category": "reproduction",
				"subcategory": "youngstock",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Sirestrategyinheifers&category=reproduction&subcategory=youngstock&locale=en-GB"
			}, {
				"id": "Zoetisflowchart",
				"description": "Zoetis flowchart",
				"category": "reproduction",
				"subcategory": "zoetis",
				"locale": "en-GB",
				"url": "https://tabvis-prd.mmmooogle.com/dashboard?id=Zoetisflowchart&category=reproduction&subcategory=zoetis&locale=en-GB"
			}];
			dashboards.team_id = team_id;
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			var setSession = setSessionHandler(team_id);
			setSession.then(function (data) {
				var tableauSuffix = '?locale=' + vm.currentLng;
				var suffix = tableauSuffix + '&category=production'
				return homeService.getDashboards(team_id, tableauSuffix).then(function (response) {
					var obj = {
						dashboards: response,
						expires: moment().add(30, 'minutes').format(),
						team_id: team_id
					}
					herdDashboardsService.tableauStored = obj;
					localStorage.removeItem('tableauLoading');
					$rootScope.$broadcast('tableau_loaded');
					//processDashboards(response);
				}).catch(function (error) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				})
			}, function (error) {
				localStorage.removeItem('tableauLoading');
				vm.loadingDashboards = false;
				vm.errorLoading = true;
			});
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession, url = APP_CONSTANTS.tableau_base_url + team_id + '/session'
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response) {
			var reproductionDashboardId = "Inseminationstrategyincows";
			var productionDashboardId = "IOFCdashboard";
			var clowHealthDashboardId = "Hoofhealth";
			var udderHealthDashboardId = "Lactationinfectionrate";
			var diseasesDashboardId = "Clinicalmastitiscases";
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].category == "reproduction" && response[i].id == reproductionDashboardId) {
						vm.reproductionDashboard = response[i];
					}
					if (response[i].category == "production" && response[i].id == productionDashboardId) {
						vm.productionDashboard = response[i];
					}
					if (response[i].category == "health" && response[i].id == clowHealthDashboardId) {
						vm.clowHealthDashboard = response[i];
					}
					if (response[i].category == "health" && response[i].id == udderHealthDashboardId) {
						vm.udderHealthDashboard = response[i];
					}
					if (response[i].category == "health" && response[i].id == diseasesDashboardId) {
						vm.diseasesDashboard = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.reproductionDashboard;
				if (vm.reproductionDashboard) {
					embedPage(vm.reproductionDashboard, false, false, true);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0)
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		};

		function embedPage(dashboard, redirect, eartags, active) {
			if (active) {
				vm.showUnderConstruction = false;
				vm.currentSheetName = angular.copy(dashboard.description);
				//vm.currentSheet = getDashboardIdByName(dashboard.description);
				vm.loadingDashboards = false;
				var url = dashboard.url;
				var start_date_suffix = '&startDate=' + vm.start_date.toISOString();
				var end_date_suffix = '&endDate=' + vm.end_date.toISOString();
				url = url + start_date_suffix + end_date_suffix;
				//chek if user is 'forfarmers'
				// if true use Tableau JS API
				// if false just embed page
				vm.workSheetName = dashboard.description;
				$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
				embedUrl(url, redirect, eartags);
			} else {
				vm.disableCategoryButtons = false;
				if (viz) {
					viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
					viz.dispose();
					$timeout(function () {
						vm.showUnderConstruction = true;
					}, 200)
				}
			}
		}

		function embedUrl(url, redirect, eartags) {
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (vm.selectedHerds.length > 0) {
				url = url + '&herd=';
				for (var i = 0; i < vm.selectedHerds.length; i++) {
					if (i > 0) {
						url = url + ',';
					}
					url = url + vm.selectedHerds[i];
				}
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			//call used to set session and to fetch internal url(on server only)
			// return homeService.setSession(url).then(function (response) {
			vm.loadingDashboards = false;
			vm.showButtons = true;
			//for server only
			//var url = response.headers('tabvis-location');
			var herdSuf = '';
			if (vm.selectedHerds.length > 0) {
				herdSuf = herdSuf + '&HerdIdentifier=';
				for (var i = 0; i < vm.selectedHerds.length; i++) {
					if (i > 0) {
						herdSuf = herdSuf + ',';
					}
					herdSuf = herdSuf + vm.selectedHerds[i];
				}
			}
			if (vm.selectedCategory == 1) {
				var url = "https://visual-prd.mmmooogle.com/t/Production/views/reproduction-cows-test/Homedashboard?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + herdSuf + "&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
			} else if (vm.selectedCategory == 2) {
				var url = "https://visual-prd.mmmooogle.com/t/Production/views/team-1-production-milk-meter_en-GB_twb/Milkmeterdashboard?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + herdSuf + "&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
			} else if (vm.selectedCategory == 3) {
				var url = "https://visual-prd.mmmooogle.com/t/Production/views/health-cows-hoof-test/Homeclawhealthdashboard?%7B%7BStart%20Date%7D%7D=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&%7B%7BEnd%20Date%7D%7D=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + herdSuf + "&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
			} else if (vm.selectedCategory == 4) {
				var url = "https://visual-prd.mmmooogle.com/t/Production/views/team-1-health-udder-health-cellcountanalysis_en-GB_twb/Overallcellcountanalysis?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + herdSuf + "&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
			} else if (vm.selectedCategory == 5) {
				var url = "https://visual-prd.mmmooogle.com/t/Production/views/team-1-health-cows-mastitis_en-GB_twb/Clinicalmastitiscases?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + herdSuf + "&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
			}
			if (url) {
				if (redirect) {
					var urlparts = angular.copy(url);
					urlparts = urlparts.split('?');
					url = urlparts[0];
					url = url + '?Select%20a%20herd=';
					for (var i = 0; i < vm.selectedHerds.length; i++) {
						if (i > 0) {
							url = url + ',';
						}
						url = url + vm.selectedHerds[i];
					}
					url += "&eartag=" + eartags;
					url += "&refresh=yes";
					url = url + '&' + urlparts[1];
				}
				var options = {
					device: deviceType,
					onFirstInteractive: function () {
						$timeout(function () {
							vm.disableCategoryButtons = false;
						}, 100)
						var workbook = viz.getWorkbook();
						var wrks = workbook.getActiveSheet().getWorksheets();
						var worksheetName;
						for (var i = 0; i < wrks.length; i++) {
							if (wrks[i].getName()) {
								worksheetName = wrks[i].getName();
								break;
							}
						}
						workbook.getParametersAsync().then(function (parameters) {
							console.log(parameters);
						})
						wrks.get(worksheetName).getFiltersAsync().then(function (filter) {
							console.log(filter);
						})
						if (worksheetName && vm.selectedHerds.length == 0) {
							var herdIdName;
							if (vm.selectedCategory == 1) {
								wrks.get(worksheetName).clearFilterAsync(herdIdentifierFiltterName);
							} else if (vm.selectedCategory == 3 || vm.selectedCategory == 2 || vm.selectedCategory == 5 || vm.selectedCategory == 4) {
								for (var i = 0; i < wrks.length; i++) {
									if (wrks[i].getName()) {
										worksheetName = wrks[i].getName();
										wrks.get(worksheetName).clearFilterAsync(herdIdentifierFiltterName);
									}
								}
							}
						}
					}
				}
				$timeout(function () {
					var containerDiv = document.getElementById("frame");
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.FILTER_CHANGE, onFilterChange);
					viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, onParameterChange);
				}, 1000)


				/*
				viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, onParameterChange);*/
			}
			/* }).catch(function (response) {
				 console.log('error getting tabvis-location header', response)
			 })*/
		}

		function onFilterChange(markEvent) {
			console.log(markEvent)
		}

		function onParameterChange(markEvent) {
			console.log(markEvent)
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			if (marksEvent.getEventName() == 'tabswitch') {
				console.log("old:" + marksEvent.getOldSheetName());
				console.log("new:" + marksEvent.getNewSheetName());
				//reproduction workbook
				var worksheetName;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName()) {
						worksheetName = wrks[i].getName();
						break;
					}
				}
				wrks.get(worksheetName).getFiltersAsync().then(function (filter) {
					console.log(filter);
				})

				if (marksEvent.getOldSheetName() == oldSheetName && marksEvent.getNewSheetName() == newSheetName) {
					setBackButtonVisibility(false);
					marksEvent.getViz().getWorkbook().getParametersAsync().then(function (parameters) {
						for (var i = 0; i < parameters.length; i++) {
							if (parameters[i].getName() == herdParamName) {
								var herd_id = parameters[i].getCurrentValue().formattedValue;
								vm.selectedHerds = [herd_id];
								$rootScope.$broadcast('default_herd_from_dashboard_selected', herd_id);
							}
						}
					})
				} else if (marksEvent.getNewSheetName() == oldSheetName) {
					setBackButtonVisibility(false);
					vm.selectedHerds = [];
					$rootScope.$broadcast('deselect_all_herds');
					marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).clearFilterAsync(herdIdentifierFiltterName);
					checkStartEndDate();

					function checkStartEndDate() {
						var c_start_date = angular.copy(vm.start_date);
						var c_end_date = angular.copy(vm.end_date);
						var start_changed;
						var end_changed;
						setDates();
						if (!moment(c_start_date).isSame(vm.start_date)) {
							start_changed = true;
						}
						if (!moment(c_end_date).isSame(vm.end_date)) {
							end_changed = true;
						}
						if (start_changed && end_changed) {
							marksEvent.getViz().getWorkbook().changeParameterValueAsync(startDateParameterName, vm.start_date).then(function (param) {
								marksEvent.getViz().getWorkbook().changeParameterValueAsync(endDateParameterName, vm.end_date).then(function (param) {})
							})
						} else if (start_changed && !end_changed) {
							marksEvent.getViz().getWorkbook().changeParameterValueAsync(startDateParameterName, vm.start_date).then(function (param) {});
						} else if (!start_changed && end_changed) {
							marksEvent.getViz().getWorkbook().changeParameterValueAsync(endDateParameterName, vm.end_date).then(function (param) {})
						}
					}
				} else if (marksEvent.getNewSheetName() == dataDashboardName) {
					var oldSheetNameData = marksEvent.getOldSheetName();
					var activeFilterName = getActiveFilterName(oldSheetNameData);
					wrks.get(dataDashboardSheetName).getFiltersAsync().then(function (filters) {
						var l = filters.length;
						var actionFilterList = [];
						vm.actionFilterList = [];
						for (var i = 0; i < l; i++) {
							var name = filters[i].getFieldName();
							if (name.indexOf("Action") != -1) {
								actionFilterList.push(name);
							}
						}
						if (actionFilterList.length > 1 && activeFilterName) {
							var listToClear = [];
							var l = actionFilterList.length;
							for (var i = 0; i < l; i++) {
								if (actionFilterList[i] != activeFilterName) {
									listToClear.push(actionFilterList[i]);
								} else {
									vm.actionFilterList.push(actionFilterList[i])
								}
							}

							var ll = listToClear.length;
							if (ll > 0) {
								for (var i = 0; i < ll; i++) {
									resetFilter(listToClear[i]);
								}
							}
						} else {
							vm.actionFilterList = actionFilterList;
						}

						console.log("action:");
						console.log(vm.actionFilterList);
						console.log("clear:");
						console.log(listToClear);


					})
					vm.lastSheetName = oldSheetNameData;
					setBackButtonVisibility(true);

				} else {
					setBackButtonVisibility(false);
				}
			}

			function resetFilter(filter) {
				viz.getWorkbook().getActiveSheet().getWorksheets().get(dataDashboardSheetName).clearFilterAsync(filter);
			}
		}

		function getActiveFilterName(dashboard) {
			var filter;
			var list = clawHealthDashboardFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].dashboard == dashboard) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterN(index) {
				return resetFilter(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				})
			}

			function resetFilter(filter) {
				var d = $q.defer();
				viz.getWorkbook().getActiveSheet().getWorksheets().get(dataDashboardSheetName).clearFilterAsync(filter).then(function (response) {
					d.resolve();
				});

				return d.promise;
			}

		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function selectCategory(category) {
			if (category != vm.selectedCategory) {
				setBackButtonVisibility(false);
				vm.disableCategoryButtons = true;
				vm.selectedCategory = category;
				setStrings();
				if (category == 1) {
					embedPage(vm.reproductionDashboard, false, false, true);
				} else if (category == 2) {
					embedPage(vm.productionDashboard, false, false, true);
				} else if (category == 3) {

					embedPage(vm.clowHealthDashboard, false, false, true);
				} else if (category == 4) {
					embedPage(vm.udderHealthDashboard, false, false, true);
				} else if (category == 5) {
					embedPage(vm.diseasesDashboard, false, false, true);
				}
			}
		}

		function openRangeSelector() {
			if (!vm.disableCategoryButtons) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				}
				cookiesService.setCookie('rap_actual_dates', JSON.stringify(dates), {
					domain: ".mmmooogle.com",
					samesite: "lax"
				});
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var end_date = vm.end_date;
			var start_date = vm.start_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync(startDateParameterName, start_date).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync(endDateParameterName, end_date);
					})
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync(startDateParameterName, start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync(endDateParameterName, end_date);
				}
			}
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			})
		}
		$scope.$on('default_herd_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			init();
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.home').factory('homeService', homeService);
    /** @ngInject */
    function homeService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setTableauTenant: setTableauTenant
            , setSession: setSession
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }

        function setTableauTenant(team_id) {
            return $http.post(APP_CONSTANTS.tableau_base_url + team_id + '/session', {}, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return response;
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds').factory('animalsService', animalsService);
    /** @ngInject */
    function animalsService() {
        return {
            animalList : []
        }
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds').controller('herdsCtrl', herdsCtrl);
	/** @ngInject */
	function herdsCtrl($state, $scope) {
		var vm = this;
		vm.changeTab = changeTab;
		init();

		function init() {
			if ($state.current.name == "herds.overview") {
				vm.activeTab = 0;
			}
			else if ($state.current.name == "herds.cockpit") {
				vm.activeTab = 1;
			}
			else if ($state.current.name == "herds.reports") {
				vm.activeTab = 2;
			}
			else if ($state.current.name == "herds.insights") {
				vm.activeTab = 3;
			}
			else if ($state.current.name == "herds.videosWebsites") {
				vm.activeTab = 4;
			}
			else if ($state.current.name == "herds.configurations") {
				vm.activeTab = 5;
			}
			else if ($state.current.name == "herds.feedCenter") {
				vm.activeTab = 6;
			}
			else if ($state.current.name == "herds.millingCenter") {
				vm.activeTab = 7;
			}
		};
		$scope.$on('$stateChangeSuccess', function () {
			if ($state.current.name == "herds.overview") {
				vm.activeTab = 0;
			}
			else if ($state.current.name == "herds.cockpit") {
				vm.activeTab = 1;
			}
			else if ($state.current.name == "herds.reports") {
				vm.activeTab = 2;
			}
			else if ($state.current.name == "herds.insights") {
				vm.activeTab = 3;
			}
			else if ($state.current.name == "herds.videosWebsites") {
				vm.activeTab = 4;
			}
			else if ($state.current.name == "herds.configurations") {
				vm.activeTab = 5;
			}
			else if ($state.current.name == "herds.feedCenter") {
				vm.activeTab = 6;
			}
			else if ($state.current.name == "herds.millingCenter") {
				vm.activeTab = 7;
			}
		});

		function changeTab(value, state) {
			vm.activeTab = value;
			$state.go(state)
		}
	}
})();

(function () {
  "use strict";
  angular
    .module("My.pages.home-arvesta")
    .controller("homeArvestaCtrl", homeArvestaCtrl);
  /** @ngInject */
  function homeArvestaCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false

      if(vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.homeDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == vm.homeDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-aveve-milk-yield_en-GB_twb/Home?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "home-arvesta",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          viewDataDashboard: vm.viewDataDashboard,
          user: vm.user,
          frameClass: "dashboard-wrapper",
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.homeDashboard = i18nFilter("_arv_home_dashboard");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.csv-import').controller('importAnimalsCtrl', importAnimalsCtrl);
	/** @ngInject */
	function importAnimalsCtrl(importAnimalsService, $timeout, editableOptions, editableThemes, $scope, $uibModal, $uibModalStack, $filter, bugsnagService) {
		var vm = this;
		var readingTimeout;
		var dateTimeout;
		vm.uploadChanged = uploadChanged;
		vm.previewAnimals = previewAnimals;
		vm.previewFailedAnimals = previewFailedAnimals;
		vm.importAnimals = importAnimals;
		vm.loadMore = loadMore;
		vm.init = init;
		vm.headerIncludedChanged = headerIncludedChanged;
		vm.fieldDelimiterChanged = fieldDelimiterChanged;
		vm.stringDelimiterChanged = stringDelimiterChanged;
		vm.mappingChanged = mappingChanged;
		vm.hideErrorMessages = hideErrorMessages;
		vm.openDateFormatConfigurationPage = openDateFormatConfigurationPage;
		vm.closeModal = closeModal;
		vm.parseInvalidDate = parseInvalidDate;
		vm.parseDatesUsingCustomFilter = parseDatesUsingCustomFilter;
		vm.dateFormatSegmentChanged = dateFormatSegmentChanged;
		vm.selectDelimiter = selectDelimiter;
		vm.createDateDilimiter = createDateDilimiter;
		vm.openInfoModal = openInfoModal;
		vm.openDateInfoModal = openDateInfoModal;
		vm.modalLoadMore = modalLoadMore;
		vm.closeDateConfig = closeDateConfig;
		vm.previewLoadMore = previewLoadMore;
		vm.selectAll = selectAll;
		vm.deselectAll = deselectAll;
		vm.separatedDatesChanged = separatedDatesChanged;

		vm.fieldDelimiters = [
			{
				sym: ';',
				id: 1,
				name: ';'
			},
			{
				sym: ':',
				id: 2,
				name: ':'
			},
			{
				sym: ',',
				id: 3,
				name: ','
			},
			{
				sym: '\t',
				id: 4,
				name: '{tab}'
			},
			{
				sym: ' ',
				id: 5,
				name: '{space}'
			}
		];

		vm.stringDelimiters = [
			{
				sym: '"',
				id: 1,
				name: '"'
			},
			{
				sym: "'",
				id: 2,
				name: "'"
			}
		];

		vm.dateSegments = [
			{
				name: 'Day [01]',
				format: 'DD',
				date: '01'
			},
			{
				name: 'Day [1]',
				format: 'D',
				date: '1'
			},
			{
				name: 'Month [01]',
				format: 'MM',
				date: '01'
			},
			{
				name: 'Month [1]',
				format: 'M',
				date: '1'
			},
			{
				name: 'Year [' + moment().format('YYYY') + ']',
				format: 'YYYY',
				date: moment().format('YYYY')
			},
			{
				name: 'Year [' + moment().format('YY') + ']',
				format: 'YY',
				date: moment().format('YY')
			}
		];

		init();

		function init() {
			vm.error = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.showPreviewPage = false;
			if (vm.defaultValues.herd_ids.length == 1) {
				vm.numError = false;
			} else {
				vm.numError = true;
			}
		}

		function uploadChanged(files, file, newFiles, duplicateFiles, invalidFiles, event) {
			vm.wrongFormatError = false;
			if (vm.file) {
				vm.fileName = vm.file.name;
				vm.showImportResults = false;
				vm.showTable = false;
				var reader = new FileReader();
				var fileString;
				reader.onload = function (e) {
					fileString = e.target.result;
					vm.fileString = angular.copy(fileString);
					vm.fieldDelimiter = getFieldDelimiter(fileString);
					vm.stringDelimiter = getstringDelimiter(fileString);
					vm.headerIncluded = true;
					readFile(vm.fileString, vm.fieldDelimiter.sym, vm.stringDelimiter.sym, vm.headerIncluded);
				};

				reader.readAsText(vm.file);
			} else {
				if (invalidFiles && invalidFiles.length) {
					vm.wrongFormatError = true;
				}
			}
		}

		function readFile(fileString, delimiter, stringDelimiter, headerIncluded) {
			var config = {
				delimiter: delimiter,
				quoteChar: stringDelimiter,
				escapeChar: stringDelimiter,
				skipEmptyLines: true
			};

			var results = Papa.parse(fileString, config);

			vm.properties = setProperties(results.data, headerIncluded);
			vm.allAnimals = setAnimalList(results.data, headerIncluded, vm.properties);
			vm.loadIndex = 0;
			vm.earTag = null;
			vm.name = null;
			vm.number = null;
			vm.parity = null;
			vm.date = null;
			vm.birthDate = null;
			vm.useSeparatedDates = true;
			vm.separatedDates = true;
			vm.animals = getNAnimals(0, vm.allAnimals, 'showLoadMore');
			$timeout(function () {
				vm.showTable = true;
			}, 50);
		}

		function setProperties(list, headerIncluded) {
			var firstLine = list[0];
			var properties = [];
			var dn = 0;
			for (var i = 0; i < firstLine.length; i++) {
				var p = firstLine[i].trim();
				if (p && p.length) {
					if (!headerIncluded) {
						p = 'col';
					}
				} else {
					p = 'col';
				}
				var propertyObj = {
					id: i + 1
				};
				if (checkPropertyName(p.trim(), properties)) {
					dn++;
					propertyObj.name = p.trim() + '_' + dn;
				} else {
					propertyObj.name = p.trim();
				}

				properties.push(propertyObj);
			}
			return properties;
		}

		function setAnimalList(list, headerIncluded, properties) {
			var animalList = [];
			if (headerIncluded) {
				var i = 1;
			} else {
				var i = 0;
			}

			for (i; i < list.length; i++) {
				var obj = {};
				for (var j = 0; j < properties.length; j++) {
					obj[properties[j].name] = list[i][j];
				}
				if (list[i].length) {
					animalList.push(obj);
				}
			}
			return animalList;
		}

		function getNAnimals(index, animals, show_button) {
			var n = 75;
			var start = n * index;
			var end = start + n;
			var list = [];

			for (var i = start; i < end; i++) {
				if (animals[i]) {
					list.push(animals[i]);
				}
			}
			if (animals[end + 1]) {
				vm[show_button] = true;
			} else {
				vm[show_button] = false;
			}
			return list;
		}

		function loadMore() {
			vm.loadIndex++;
			vm.animals = vm.animals.concat(getNAnimals(vm.loadIndex, vm.allAnimals, 'showLoadMore'));
		}

		function modalLoadMore() {
			vm.modalLoadIndex++;
			vm.modalAnimals = vm.modalAnimals.concat(getNAnimals(vm.modalLoadIndex, vm.allAnimals, 'modalShowLoadMore'));
		}

		function previewLoadMore() {
			vm.previewLoadIndex++;
			vm.importAnimalsList = vm.importAnimalsList.concat(getNAnimals(vm.previewLoadIndex, vm.allImportAnimalsList, 'showPreviewLoadMore'));
		}

		function previewAnimals() {
			var list = [];

			for (var i = 0; i < vm.allAnimals.length; i++) {
				var obj = {
					EarTag: null,
					Number: null,
					Name: null,
					Parity: null,
					IsOnFarm: true,
					Tags: '#MyMmmooOgleImport',
					IsSelected: true
				};
				if (vm.earTag && vm.earTag.name) {
					obj.EarTag = vm.allAnimals[i][vm.earTag.name];
				}
				if (vm.number && vm.number.name) {
					obj.Number = vm.allAnimals[i][vm.number.name] ? vm.allAnimals[i][vm.number.name] : null;
				}
				if (vm.name && vm.name.name) {
					obj.Name = vm.allAnimals[i][vm.name.name];
				}
				if (vm.parity && vm.parity.name) {
					obj.Parity = vm.allAnimals[i][vm.parity.name] ? vm.allAnimals[i][vm.parity.name] : null;
				}

				if (vm.useSeparatedDates) {
					if (vm.date && vm.date.name) {
						if (vm.useCustomFormat) {
							obj.LastCalvingDate = vm.allAnimals[i][vm.date.name] ? moment(vm.allAnimals[i][vm.date.name], vm.dateFormat).format('YYYY-MM-DDT12:00:00.000') + 'Z' : null;
						} else {
							if (vm.allAnimals[i].importDateParsed) {
								obj.LastCalvingDate = moment(new Date(vm.allAnimals[i].importDateParsed)).format('YYYY-MM-DDT12:00:00.000') + 'Z';
							}
						}
					}
					if (vm.birthDate && vm.birthDate.name) {
						if (vm.useCustomFormatBirth) {
							obj.BirthDate = vm.allAnimals[i][vm.birthDate.name] ? moment(vm.allAnimals[i][vm.birthDate.name], vm.dateFormatBirth).format('YYYY-MM-DDT12:00:00.000') + 'Z' : null;
						} else {
							if (vm.allAnimals[i].importDateParsedBirth) {
								obj.BirthDate = moment(new Date(vm.allAnimals[i].importDateParsedBirth)).format('YYYY-MM-DDT12:00:00.000') + 'Z';
							}
						}
					}
				} else {
					if (vm.parity && vm.parity.name) {
						if (vm.date && vm.date.name) {
							if (vm.allAnimals[i][vm.parity.name] == 0) {
								if (vm.useCustomFormat) {
									obj.BirthDate = vm.allAnimals[i][vm.date.name] ? moment(vm.allAnimals[i][vm.date.name], vm.dateFormat).format('YYYY-MM-DDT12:00:00.000') + 'Z' : null;
								} else {
									if (vm.allAnimals[i].importDateParsed) {
										obj.BirthDate = moment(new Date(vm.allAnimals[i].importDateParsed)).format('YYYY-MM-DDT12:00:00.000') + 'Z';
									}
								}
							} else {
								if (vm.useCustomFormat) {
									obj.LastCalvingDate = vm.allAnimals[i][vm.date.name] ? moment(vm.allAnimals[i][vm.date.name], vm.dateFormat).format('YYYY-MM-DDT12:00:00.000') + 'Z' : null;
								} else {
									if (vm.allAnimals[i].importDateParsed) {
										obj.LastCalvingDate = moment(new Date(vm.allAnimals[i].importDateParsed)).format('YYYY-MM-DDT12:00:00.000') + 'Z';
									}
								}
							}
						}
					} else {
						if (vm.date && vm.date.name) {
							if (vm.useCustomFormat) {
								obj.BirthDate = vm.allAnimals[i][vm.date.name] ? moment(vm.allAnimals[i][vm.date.name], vm.dateFormat).format('YYYY-MM-DDT12:00:00.000') + 'Z' : null;
							} else {
								if (vm.allAnimals[i].importDateParsed) {
									obj.BirthDate = moment(new Date(vm.allAnimals[i].importDateParsed)).format('YYYY-MM-DDT12:00:00.000') + 'Z';
								}
							}
						}
					}
				}
				list.push(obj);
			}

			if (vm.selectedHerds && vm.selectedHerds.length == 1) {
				vm.allImportAnimalsList = angular.copy(list);
				vm.previewLoadIndex = 0;
				vm.importAnimalsList = getNAnimals(0, vm.allImportAnimalsList, 'showPreviewLoadMore');
				$timeout(function () {
					vm.showPreviewPage = true;
				}, 69);
			}
		}

		function importAnimals() {
			vm.loading = true;
			return importAnimalsService
				.importAnimals(vm.allImportAnimalsList, vm.selectedHerds[0])
				.then(function (response) {
					vm.results = {
						sucessful: 0,
						failed: 0,
						failedAnimals: []
					};
					for (var i = 0; i < response.length; i++) {
						if (response[i].Success) {
							vm.results.sucessful++;
						} else {
							vm.results.failed++;
							vm.results.failedAnimals.push(response[i]);
						}
					}
					vm.showPreviewPage = false;
					vm.loading = false;
					vm.showImportResults = true;
					sendToBugsnag('import', vm.selectedHerds[0], vm.allImportAnimalsList, vm.results);
					$timeout(function () {
						if (vm.results.failed > 0) {
							sendToBugsnag('failed', vm.selectedHerds[0], vm.allImportAnimalsList, vm.results);
						}
					}, 250);
				})
				.catch(function (error) {
					vm.loading = false;
					vm.error = true;
					console.log(error);
				});
		}

		function previewFailedAnimals() {
			vm.showFailedPreviewPage = true;
		}

		function sendToBugsnag(type, herd, list, results) {
			if (type == 'import') {
				var message = {
					message: 'ImportAnimals',
					metaData: {
						herd: {
							herd_id: herd
						},
						file: {
							fileName: vm.fileName,
							numberOfAnimals: list.length
						},
						mapping: {
							earTag: vm.earTag ? vm.earTag.name : null,
							name: vm.name ? vm.name.name : null,
							number: vm.number ? vm.number.name : null,
							parity: vm.parity ? vm.parity.name : null,
							date: vm.date ? vm.date.name : null,
							birthDate: vm.birthDate ? vm.birthDate.name : null,
							customFormat: vm.useCustomFormat ? vm.dateFormat : false,
							customFormatBirth: vm.useCustomFormatBirth ? vm.dateFormatBirth : false
						},
						results: {
							sucessful: results.sucessful,
							failed: results.failed
						},
						example: list[0]
					}
				};

				bugsnagService.logMessage(message);
			} else if (type == 'failed') {
				var message = {
					message: 'ImportFailedAnimals',
					metaData: {
						herd: {
							herd_id: herd
						},
						file: {
							fileName: vm.fileName,
							numberOfAnimals: list.length
						},
						animals: results.failedAnimals
					}
				}

				bugsnagService.logMessage(message);
			}
		}

		function selectAll() {
			for (var i = 0; i < vm.importAnimalsList.length; i++) {
				vm.importAnimalsList[i].IsSelected = true;
			}
		}

		function deselectAll() {
			for (var i = 0; i < vm.importAnimalsList.length; i++) {
				vm.importAnimalsList[i].IsSelected = false;
			}
		}

		function checkPropertyName(name, list) {
			var n = false;
			for (var i = 0; i < list.length; i++) {
				if (name == list[i].name) {
					n = true;
				}
			}
			return n;
		}

		function getFieldDelimiter(string) {
			var line = string;
			var fieldDelimiters = angular.copy(vm.fieldDelimiters);
			var maxSparatorCount;
			for (var i = 0; i < fieldDelimiters.length; i++) {
				var count = line.split(fieldDelimiters[i].sym).length - 1;
				fieldDelimiters[i].c = count;
				fieldDelimiters[i].i = i;
				if (maxSparatorCount) {
					if (maxSparatorCount.c < fieldDelimiters[i].c) {
						maxSparatorCount = fieldDelimiters[i];
					}
				} else {
					maxSparatorCount = fieldDelimiters[i];
				}
			}
			return vm.fieldDelimiters[maxSparatorCount.i];
		}

		function getstringDelimiter(string) {
			var line = string;
			var stringDelimiter = angular.copy(vm.stringDelimiters);
			var maxSparatorCount;
			for (var i = 0; i < stringDelimiter.length; i++) {
				var count = line.split(stringDelimiter[i].sym).length - 1;
				stringDelimiter[i].c = count;
				stringDelimiter[i].i = i;
				if (maxSparatorCount) {
					if (maxSparatorCount.c < stringDelimiter[i].c) {
						maxSparatorCount = stringDelimiter[i];
					}
				} else {
					maxSparatorCount = stringDelimiter[i];
				}
			}
			return vm.stringDelimiters[maxSparatorCount.i];
		}

		function headerIncludedChanged() {
			vm.headerIncluded = !vm.headerIncluded;
			if (readingTimeout) {
				$timeout.cancel(readingTimeout);
			}

			readingTimeout = $timeout(function () {
				readFile(vm.fileString, vm.fieldDelimiter.sym, vm.stringDelimiter.sym, vm.headerIncluded);
			}, 500);
		}

		function fieldDelimiterChanged() {
			if (readingTimeout) {
				$timeout.cancel(readingTimeout);
			}

			readingTimeout = $timeout(function () {
				readFile(vm.fileString, vm.fieldDelimiter.sym, vm.stringDelimiter.sym, vm.headerIncluded);
			}, 500);
		}

		function stringDelimiterChanged() {
			if (readingTimeout) {
				$timeout.cancel(readingTimeout);
			}

			readingTimeout = $timeout(function () {
				readFile(vm.fileString, vm.fieldDelimiter.sym, vm.stringDelimiter.sym, vm.headerIncluded);
			}, 500);
		}

		function mappingChanged(type) {
			if (type == 'date') {
				vm.useCustomFormat = false;
				vm.invalidDate = null;
				vm.disableCustomButton = true;
				vm.segmentOne = null;
				vm.segmentTwo = null;
				vm.segmentThree = null;
				vm.d1 = null;
				vm.d2 = null;
				vm.d3 = null;
				vm.d4 = null;
				vm.d5 = null;
				vm.customDateDelimiter = null;
				vm.resultingDateFormat = null;
				vm.resultingDate = null;
				vm.dateDelimiter = null;
				vm.lastUsedSetup = null;
			}
			if (vm.date && !vm.useCustomFormat) {
				var error = checkData('date', vm.date, vm.allAnimals);
				if (error) {
					vm.dateError = true;
				} else {
					vm.dateError = false;
				}
			}

			if (type == 'birthDate') {
				vm.useCustomFormatBirth = false;
				vm.invalidDateBirth = null;
				vm.disableCustomButtonBirth = true;
				vm.segmentOneBirth = null;
				vm.segmentTwoBirth = null;
				vm.segmentThreeBirth = null;
				vm.d1Birth = null;
				vm.d2Birth = null;
				vm.d3Birth = null;
				vm.d4Birth = null;
				vm.d5Birth = null;
				vm.customDateDelimiterBirth = null;
				vm.resultingDateFormatBirth = null;
				vm.resultingDateBirth = null;
				vm.dateDelimiterBirth = null;
				vm.lastUsedSetupBirth = null;
			}
			if (vm.birthDate && vm.useSeparatedDates && !vm.useCustomFormatBirth) {
				var error = checkData('birthDate', vm.birthDate, vm.allAnimals);
				if (error) {
					vm.dateErrorBirth = true;
				} else {
					vm.dateErrorBirth = false;
				}
			}

			if (vm.parity) {
				var error = checkData('parity', vm.parity, vm.allAnimals);
				if (error) {
					vm.parityError = true;
				} else {
					vm.parityError = false;
				}
			}

			if (vm.number) {
				var error = checkData('number', vm.number, vm.allAnimals);
				if (error) {
					vm.numberError = true;
				} else {
					vm.numberError = false;
				}
			}
		}

		function checkData(type, property, allAnimals) {
			var error = false;

			for (var i = 0; i < allAnimals.length; i++) {
				if (type == 'date') {
					allAnimals[i].hidden = false;
					if (!validateDate(allAnimals[i][property.name])) {
						if (!vm.invalidDate) {
							vm.invalidDate = allAnimals[i][property.name];
						}
						allAnimals[i].importInvalidDate = true;
						allAnimals[i].importDateParsed = null;
						allAnimals[i].importDate = 'Invalid Date';
						error = true;
					} else {
						allAnimals[i].importInvalidDate = false;
						allAnimals[i].importDateParsed = allAnimals[i][property.name];
						allAnimals[i].importDate = $filter('date')(new Date(allAnimals[i].importDateParsed), 'mediumDate');
					}
				} else if (type == 'birthDate') {
					allAnimals[i].hidden = false;
					if (!validateDate(allAnimals[i][property.name])) {
						if (!vm.invalidDateBirth) {
							vm.invalidDateBirth = allAnimals[i][property.name];
						}
						allAnimals[i].importInvalidDateBirth = true;
						allAnimals[i].importDateParsedBirth = null;
						allAnimals[i].importDateBirth = 'Invalid Date';
						error = true;
					} else {
						allAnimals[i].importInvalidDateBirth = false;
						allAnimals[i].importDateParsedBirth = allAnimals[i][property.name];
						allAnimals[i].importDateBirth = $filter('date')(new Date(allAnimals[i].importDateParsedBirth), 'mediumDate');
					}
				} else if (type == 'parity') {
					if (!validateParity(allAnimals[i][property.name])) {
						error = true;
						break;
					}
				} else if (type == 'number') {
					if (!validateNumber(allAnimals[i][property.name])) {
						error = true;
						break;
					}
				}
			}
			if (!vm.invalidDateBirth) {
				vm.invalidDateBirth = allAnimals[0][property.name];
			}
			if (!vm.invalidDate) {
				vm.invalidDate = allAnimals[0][property.name];
			}
			return error;
		}

		function validateDate(date) {
			var valid = true;
			var num = !isNaN(date);
			if (num) {
				valid = false;
			} else {
				var dateD = new Date(date);
				if (!moment(dateD).isValid()) {
					valid = false;
				}
			}
			return valid;
		}

		function validateParity(parity) {
			var valid = true;
			var num = !isNaN(parity);
			if (!num) {
				valid = false;
			} else {
				if (parity < 0 || parity > 20) {
					valid = false;
				} else {
					if (parity % 1 != 0) {
						valid = false;
					}
				}
			}
			return valid;
		}

		function validateNumber(number) {
			var valid = true;
			var num = !isNaN(number);
			if (!num) {
				valid = false;
			} else {
				if (number < 0) {
					valid = false;
				} else {
					if (number % 1 != 0) {
						valid = false;
					}
				}
			}
			return valid;
		}

		function hideErrorMessages() {
			vm.dateError = false;
			vm.dateErrorBirth = false;
			vm.parityError = false;
			vm.numberError = false;
		}

		function openDateFormatConfigurationPage(type, from_modal) {
			if (from_modal) {
				closeModal();
			}
			vm.currentDateType = type;
			vm.disableCustomButton = true;
			vm.readingDone = false;
			vm.config = {
				invalidDate: type == 'date' ? vm.invalidDate : vm.invalidDateBirth,
				segmentOne: type == 'date' ? vm.segmentOne : vm.segmentOneBirth,
				segmentTwo: type == 'date' ? vm.segmentTwo : vm.segmentTwoBirth,
				segmentThree: type == 'date' ? vm.segmentThree : vm.segmentThreeBirth,
				d1: type == 'date' ? vm.d1 : vm.d1Birth,
				d2: type == 'date' ? vm.d2 : vm.d2Birth,
				d3: type == 'date' ? vm.d3 : vm.d3Birth,
				d4: type == 'date' ? vm.d4 : vm.d4Birth,
				d5: type == 'date' ? vm.d5 : vm.d5Birth,
				customDateDelimiter: type == 'date' ? vm.customDateDelimiter : vm.customDateDelimiterBirth,
				resultingDateFormat: type == 'date' ? vm.resultingDateFormat : vm.resultingDateFormatBirth,
				resultingDate: type == 'date' ? vm.resultingDate : vm.resultingDateBirth,
				dateDelimiter: type == 'date' ? vm.dateDelimiter : vm.dateDelimiterBirth,
				dateFormat: type == 'date' ? vm.dateFormat : vm.dateFormatBirth
			};
			hideErrorMessages();
			vm.showDateConfigBlock = true;
			vm.readingDone = false;
		}

		function parseInvalidDate() {
			var dateFormat = vm.config.segmentOne.format;
			if (vm.config.dateDelimiter) {
				dateFormat += vm.config.dateDelimiter;
			}
			dateFormat += vm.config.segmentTwo.format;
			if (vm.config.dateDelimiter) {
				dateFormat += vm.config.dateDelimiter;
			}
			dateFormat += vm.config.segmentThree.format;
			vm.config.dateFormat = dateFormat;
			vm.config.resultingDate = new Date(moment(vm.config.invalidDate, dateFormat));
			vm.readingDone = true;
			if (vm.config.resultingDate == 'Invalid Date') {
				vm.disableCustomButton = true;
			} else {
				vm.disableCustomButton = false;
			}
		}

		function parseDatesUsingCustomFilter(type) {
			for (var i = 0; i < vm.allAnimals.length; i++) {
				if (type == 'date') {
					vm.allAnimals[i].importDate = $filter('date')(new Date(moment(vm.allAnimals[i][vm.date.name], vm.config.dateFormat)), 'mediumDate');
				} else {
					vm.allAnimals[i].importDateBirth = $filter('date')(new Date(moment(vm.allAnimals[i][vm.birthDate.name], vm.config.dateFormat)), 'mediumDate');
				}
			}
			if (type == 'date') {
				vm.useCustomFormat = true;
				vm.invalidDate = vm.config.invalidDate;
				vm.segmentOne = vm.config.segmentOne;
				vm.segmentTwo = vm.config.segmentTwo;
				vm.segmentThree = vm.config.segmentThree;
				vm.d1 = vm.config.d1;
				vm.d2 = vm.config.d2;
				vm.d3 = vm.config.d3;
				vm.d4 = vm.config.d4;
				vm.d5 = vm.config.d5;
				vm.customDateDelimiter = vm.config.customDateDelimiter;
				vm.resultingDateFormat = vm.config.resultingDateFormat;
				vm.resultingDate = vm.config.resultingDate;
				vm.dateDelimiter = vm.config.dateDelimiter;
				vm.dateFormat = vm.config.dateFormat;
			} else {
				vm.useCustomFormatBirth = true;
				vm.invalidDateBirth = vm.config.invalidDate;
				vm.segmentOneBirth = vm.config.segmentOne;
				vm.segmentTwoBirth = vm.config.segmentTwo;
				vm.segmentThreeBirth = vm.config.segmentThree;
				vm.d1Birth = vm.config.d1;
				vm.d2Birth = vm.config.d2;
				vm.d3Birth = vm.config.d3;
				vm.d4Birth = vm.config.d4;
				vm.d5Birth = vm.config.d5;
				vm.customDateDelimiterBirth = vm.config.customDateDelimiter;
				vm.resultingDateFormatBirth = vm.config.resultingDateFormat;
				vm.resultingDateBirth = vm.config.resultingDate;
				vm.dateDelimiterBirth = vm.config.dateDelimiter;
				vm.dateFormatBirth = vm.config.dateFormat;
			}
			vm.showDateConfigBlock = false;
			closeModal();
		}

		function closeDateConfig() {
			vm.showDateConfigBlock = false;
		}

		function dateFormatSegmentChanged(type) {
			vm.config.resultingDateFormat = '';
			vm.readingDone = false;
			vm.config.resultingDate = null;
			vm.disableCustomButton = true;
			if (vm.config.segmentOne) {
				vm.config.resultingDateFormat += vm.config.segmentOne.date;
			}
			if (vm.config.dateDelimiter) {
				vm.config.resultingDateFormat += vm.config.dateDelimiter;
			}
			if (vm.config.segmentTwo) {
				vm.config.resultingDateFormat += vm.config.segmentTwo.date;
			}
			if (vm.config.dateDelimiter) {
				vm.config.resultingDateFormat += vm.config.dateDelimiter;
			}
			if (vm.config.segmentThree) {
				vm.config.resultingDateFormat += vm.config.segmentThree.date;
			}
		}

		function selectDelimiter(id) {
			vm.config[id] = !vm.config[id];
			if (id == 'd1') {
				vm.config.d2 = false;
				vm.config.d3 = false;
				vm.config.d5 = false;
			} else if (id == 'd2') {
				vm.config.d1 = false;
				vm.config.d3 = false;
				vm.config.d5 = false;
			} else if (id == 'd3') {
				vm.config.d2 = false;
				vm.config.d1 = false;
				vm.config.d5 = false;
			} else if (id == 'd5') {
				vm.config.d2 = false;
				vm.config.d3 = false;
				vm.config.d1 = false;
			}
			createDateDilimiter();
		}

		function createDateDilimiter() {
			vm.config.dateDelimiter = '';
			if (vm.config.d1) {
				vm.config.dateDelimiter += '.';
			} else if (vm.config.d2) {
				vm.config.dateDelimiter += '-';
			} else if (vm.config.d3) {
				vm.config.dateDelimiter += '/';
			} else if (vm.config.d5) {
				if (vm.config.customDateDelimiter) {
					vm.config.dateDelimiter += vm.config.customDateDelimiter;
				}
			}

			if (vm.config.d4) {
				vm.config.dateDelimiter += ' ';
			}

			dateFormatSegmentChanged();
		}

		function separatedDatesChanged() {
			vm.separatedDates = !vm.separatedDates;
			if (dateTimeout) {
				$timeout.cancel(dateTimeout);
			}
			dateTimeout = $timeout(function () {
				vm.useSeparatedDates = vm.separatedDates;
			}, 600);
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function openInfoModal() {
			openModal('app/pages/importAnimals/mappingInfo.modal.html', 'md');
		}

		function openDateInfoModal(type) {
			vm.currentDateType = type;
			vm.modalLoadIndex = 0;
			vm.modalAnimals = getNAnimals(0, vm.allAnimals, 'modalShowLoadMore');

			openModal('app/pages/importAnimals/dateInfo.modal.html', 'md');
		}
		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('default_herd_selected', function (event, data) {
			init();
		});
		$scope.$on('default_team_selected', function (event, data) {
			init();
		});

		editableOptions.theme = 'bs3';
		editableOptions.blurElem = 'submit';
		editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
		editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.csv-import').factory('importAnimalsService', importAnimalsService);
    /** @ngInject */
    function importAnimalsService($http, $q, APP_CONSTANTS) {
        return {
            importAnimals: importAnimals
        }

        function importAnimals(list, herdId) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/animals', list).then(success).catch(error);
        }


        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.insemination-strategy-cows")
    .controller("inseminationStrategyCowsCtrl", inseminationStrategyCowsCtrl);
  /** @ngInject */
  function inseminationStrategyCowsCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_insemination_strategy_cows_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });

        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular
    .module("My.pages.insemination-strategy-heifers")
    .controller(
      "inseminationStrategyHeifersCtrl",
      inseminationStrategyHeifersCtrl
    );
  /** @ngInject */
  function inseminationStrategyHeifersCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_insemination_strategy_heifers_") && dashboard.subcategory == 'zoetis') {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular.module("My.pages.invoice").controller("invoiceCtrl", invoiceCtrl);
  /** @ngInject */
  function invoiceCtrl(
    $scope,
    invoiceService,
    $q,
    $filter,
    $locale,
    $uibModal,
    $uibModalStack,
    editableOptions,
    editableThemes,
    $timeout,
    $cookies,
    cookiesService,
    appService,
    bugsnagService
  ) {
    var vm = this;
    var herdInfo;
    var teamInfo;
    var visitdates;
    var additionalChargesTimeout;
    var discountTimeout;
    var discountUnitTimeout;
    var surchargeTimeout;
    var surchargeUnitTimeout;
    var timePeriodUnitTimeout;
    var filterUnitTimeout;
    var taxTimeout;
    var trimmerTimeout;
    var dairyTimeout;
    var i18nFilter = $filter("i18n");
    vm.exportToPdf = exportToPdf;
    vm.dateSelected = dateSelected;
    vm.priceChanged = priceChanged;
    vm.includeAdditionalCharges = includeAdditionalCharges;
    vm.additionalChargesChanged = additionalChargesChanged;
    vm.addDiscount = addDiscount;
    vm.changeDiscountUnit = changeDiscountUnit;
    vm.discountValueChanged = discountValueChanged;
    vm.addSurcharge = addSurcharge;
    vm.changeSurchargeUnit = changeSurchargeUnit;
    vm.changeHoofTrimPeriod = changeHoofTrimPeriod;
    vm.surchargeValueChanged = surchargeValueChanged;
    vm.includeTax = includeTax;
    vm.taxValueChanged = taxValueChanged;
    vm.init = init;
    vm.openRangeSelector = openRangeSelector;
    vm.setRange = setRange;
    vm.closeModal = closeModal;
    vm.trimmerDataChanged = trimmerDataChanged;
    vm.dairyDataChanged = dairyDataChanged;
    vm.dateChanged = dateChanged;
    vm.setAllPricesToZero = setAllPricesToZero;
    vm.changeFilter = changeFilter;
    vm.onTrimmerSelected = onTrimmerSelected;
    vm.includeTripCharge = false;
    vm.includeVisitCharge = false;
    vm.includeSetupCharge = false;
    vm.discountUsePercentage = true;
    vm.discountUnit = "toggle_off";
    vm.surchargeUsePercentage = true;
    vm.surchargeUnit = "toggle_off";
    vm.dpOptions = {
      customClass: getDayClass,
    };
    init();

    function init() {
      setDefaultPrices();
      vm.errorLoading = false;
      vm.noVisitDates = false;
      vm.hoofTrimByDate = true;
      vm.hoofTrimByHerd = true;
      vm.timePeriodUnit = "toggle_off";
      vm.filterUnit = "toggle_off";
      vm.treatmentNames = {
        therapeuticTrim: i18nFilter(
          "_animal_details_hoof_treatment_type_therapeutic_trim_"
        ),
        topical: i18nFilter("_animal_details_hoof_treatment_type_topical_"),
        //preventiveTrim: i18nFilter('_animal_details_hoof_treatment_type_preventive_trim_'),
        antibioticTreatment: i18nFilter(
          "_animal_details_hoof_treatment_type_antibiotic_treatment_"
        ),
        conventional: i18nFilter(
          "_animal_details_hoof_treatment_type_conventional_"
        ),
      };
      vm.currency = $locale.NUMBER_FORMATS.CURRENCY_SYM;
      vm.loading = true;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.userInfo = JSON.parse(localStorage.getItem("user_profile"));
      vm.trimmerName = angular.copy(vm.userInfo.name);
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.selectedTeam = vm.defaultValues.team_id;
      vm.trimDate = new Date();

      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.defaultPrices = checkPriceCookie(
          vm.defaultPrices,
          vm.selectedHerds[0]
        );
        var date = moment(vm.trimDate)
          .subtract(1, "days")
          .format("YYYY-MM-DDT00:00:00");
        getHerdData(vm.selectedHerds[0], vm.selectedTeam);
      }
    }

    function setDefaultPrices() {
      vm.defaultPrices = [
        {
          id: 1,
          name: "trim",
          price: 0,
        },
        {
          id: 2,
          name: "trimRear",
          price: 0,
        },
        {
          id: 3,
          name: "lame",
          price: 0,
        },
        {
          id: 4,
          name: "recheck",
          price: 0,
        },
        {
          id: 5,
          name: "block",
          price: 0,
        },
        {
          id: 6,
          name: "wrap",
          price: 0,
        },
        {
          id: 7,
          name: "therapeuticTrim",
          price: 0,
        },
        {
          id: 8,
          name: "topical",
          price: 0,
        },
        {
          id: 9,
          name: "antibioticTreatment",
          price: 0,
        },
        {
          id: 10,
          name: "conventional",
          price: 0,
        },
        {
          id: 11,
          name: "tripCharge",
          price: 0,
        },
        {
          id: 12,
          name: "visitCharge",
          price: 0,
        },
        {
          id: 13,
          name: "setupCharge",
          price: 0,
        },
        {
          id: 14,
          name: "discountPercentage",
          price: 0,
        },
        {
          id: 15,
          name: "discountFixed",
          price: 0,
        },
        {
          id: 16,
          name: "surchargePercentage",
          price: 0,
        },
        {
          id: 17,
          name: "surchargeFixed",
          price: 0,
        },
        {
          id: 18,
          name: "tax",
          price: 0,
        },
      ];
    }

    function checkPriceCookie(prices, herdId) {
      try {
        var cookie = $cookies.getObject("prices");
      } catch (error) {
        console.log(error);
      }
      if (cookie && cookie.length) {
        var cookiePrices;
        for (var i = 0; i < cookie.length; i++) {
          if (cookie[i].herdId == herdId) {
            cookiePrices = cookie[i].prices;
            break;
          }
        }
        if (cookiePrices && cookiePrices.length) {
          for (var p = 0; p < prices.length; p++) {
            for (var pp = 0; pp < cookiePrices.length; pp++) {
              if (prices[p].id == cookiePrices[pp].id) {
                if (
                  cookiePrices[pp].p != null &&
                  cookiePrices[pp].p != undefined
                ) {
                  prices[p].price = cookiePrices[pp].p;
                }
              }
            }
          }
        }
      }
      return prices;
    }

    function getHerdData(herdId, teamId) {
      herdInfo = $q.defer();
      visitdates = $q.defer();
      teamInfo = $q.defer();

      $q.all([herdInfo.promise, visitdates.promise, teamInfo.promise])
        .then(function (response) {
          if (!vm.noVisitDates) {
            vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);

            getHoofTrimsByDate(herdId, vm.selectedDate.VisitDate);
          }
        })
        .catch(function (error) {
          vm.errorLoading = true;
          console.log(error);
        });

      getHerdInfo(herdId);
      getTeamInfo(teamId);
      getVisitDates(herdId);
    }

    function getHerdInfo(herdId) {
      return invoiceService
        .getHerdInfo(herdId)
        .then(function (response) {
          vm.dairyCompany = response;
          vm.herdName = response.Name;

          var cookieName = "dairy-info";
          try {
            var cookie = $cookies.getObject(cookieName);
          } catch (error) {
            console.log(error);
          }
          if (cookie && cookie.length) {
            var herdFound = false;
            var herdIndex;
            for (var i = 0; i < cookie.length; i++) {
              if (cookie[i].herdId == vm.selectedHerds[0]) {
                herdFound = true;
                herdIndex = i;
                break;
              }
            }
            if (herdFound) {
              var data = cookie[herdIndex].data;
              if (data.cn) {
                vm.dairyCompany.Name = data.cn;
              }
              if (data.de) {
                vm.dairyCompany.Email = data.de;
              }
              if (data.st) {
                vm.dairyCompany.Street = data.st;
              }
              if (data.an) {
                vm.dairyCompany.Number = data.an;
              }
              if (data.ac) {
                vm.dairyCompany.City = data.ac;
              }
              if (data.as) {
                vm.dairyCompany.State = data.as;
              }
              if (data.az) {
                vm.dairyCompany.Zip = data.az;
              }
              if (data.dp) {
                vm.dairyCompany.PhoneNumber = data.dp;
              }
            }
          }

          herdInfo.resolve();
        })
        .catch(function (error) {
          console.log(error);
          herdInfo.reject(error);
        });
    }

    function getTeamInfo(teamId) {
      return invoiceService
        .getTeamInfo(teamId)
        .then(function (response) {
          vm.trimmerCompany = response;
          var cookieName = vm.userInfo.email + "_trimmer";
          try {
            var cookie = $cookies.getObject(cookieName);
          } catch (error) {
            console.log(error);
          }

          if (cookie) {
            if (cookie.cn) {
              vm.trimmerCompany.Name = cookie.cn;
            }
            if (cookie.tn) {
              vm.trimmerName = cookie.tn;
            }
            if (cookie.st) {
              vm.trimmerCompany.Address.Street = cookie.st;
            }
            if (cookie.an) {
              vm.trimmerCompany.Address.Number = cookie.an;
            }
            if (cookie.ac) {
              vm.trimmerCompany.Address.City = cookie.ac;
            }
            if (cookie.as) {
              vm.trimmerCompany.Address.State = cookie.as;
            }
            if (cookie.az) {
              vm.trimmerCompany.Address.Zip = cookie.az;
            }
            if (cookie.tp) {
              vm.trimmerCompany.PhoneNumber = cookie.tp;
            }
          }

          teamInfo.resolve();
        })
        .catch(function (error) {
          console.log(error);
          teamInfo.reject(error);
        });
    }

    function getVisitDates(herdId) {
      return invoiceService
        .getVisitDates(herdId)
        .then(function (response) {
          if (response) {
            if (response.length == 0) {
              vm.noVisitDates = true;
            } else {
              vm.noVisitDates = false;

              for (var i = 0; i < response.length; i++) {
                response[i].date = $filter("date")(
                  new Date(response[i].VisitDate),
                  "mediumDate"
                );
              }
              vm.visitDates = response;
              setStartEndDate(response);
              vm.selectedDate = vm.visitDates[0];
              vm.selectedDateObject = new Date(vm.visitDates[0].VisitDate);
              vm.nextTrimDate = "-";
              visitdates.resolve();
            }
          } else {
            vm.noVisitDates = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          visitdates.reject(error);
        });
    }

    function setStartEndDate(dates) {
      var lastDate = dates[0].VisitDate;
      var month = moment(lastDate).month();
      var year = moment(lastDate).year();
      var startDate = moment()
        .date(1)
        .year(year)
        .month(month)
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      var endDate = moment(startDate)
        .endOf("month")
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      vm.startDate = new Date(startDate);
      vm.endDate = new Date(endDate);
    }
    function resetTrimmerSelection() {
      vm.selectedTrimmer = "Select a trimmer";
    }
    function getTrimmerNamesFromResponse(response) {
      var trimmerNamesSet = new Set();

      for (var i = 0; i < response.length; i++) {
        trimmerNamesSet.add(response[i].Trimmer);
      }

      vm.trimmerNames = Array.from(trimmerNamesSet);
      return vm.trimmerNames;
    }

    function getHoofTrimsByDate(herdId, date) {
      if (vm.chart) {
        vm.chart.destroy();
      }
      vm.treatmentNames = {
        therapeuticTrim: i18nFilter(
          "_animal_details_hoof_treatment_type_therapeutic_trim_"
        ),
        topical: i18nFilter("_animal_details_hoof_treatment_type_topical_"),
        //preventiveTrim: i18nFilter('_animal_details_hoof_treatment_type_preventive_trim_'),
        antibioticTreatment: i18nFilter(
          "_animal_details_hoof_treatment_type_antibiotic_treatment_"
        ),
        conventional: i18nFilter(
          "_animal_details_hoof_treatment_type_conventional_"
        ),
      };
      vm.loadingHoofTrims = true;
      var suffix = date;
      return invoiceService
        .getHoofTrims(herdId, suffix)
        .then(function (response) {
          vm.fullHoofTrimData = angular.copy(response);
          if (!vm.hoofTrimByHerd) {
            vm.trimmerNames = getTrimmerNamesFromResponse(response);
            onTrimmerSelected();
          } else {
            var data = handleHoofTrimsResponse(response);
            data = calculateCosts(data);
            vm.hoofTrimData = data;
            $timeout(function () {
              createGraph();
            }, 150);
          }
          vm.loadingHoofTrims = false;
          vm.loading = false;
        })
        .catch(function (error) {
          vm.errorLoading = true;
          console.log(error);
        });
    }

    function getHoofTrimsByPeriod(herdId) {
      if (vm.chart) {
        vm.chart.destroy();
      }
      vm.treatmentNames = {
        therapeuticTrim: i18nFilter(
          "_animal_details_hoof_treatment_type_therapeutic_trim_"
        ),
        topical: i18nFilter("_animal_details_hoof_treatment_type_topical_"),
        //preventiveTrim: i18nFilter('_animal_details_hoof_treatment_type_preventive_trim_'),
        antibioticTreatment: i18nFilter(
          "_animal_details_hoof_treatment_type_antibiotic_treatment_"
        ),
        conventional: i18nFilter(
          "_animal_details_hoof_treatment_type_conventional_"
        ),
      };
      vm.loadingHoofTrims = true;
      var startDate = moment(vm.startDate).format("YYYY-MM-DDT00:00:00");
      var endDate = moment(vm.endDate).format("YYYY-MM-DDT23:59:59");
      var suffix = "?VisitDate=>=" + startDate + "&VisitDate=<=" + endDate;
      return invoiceService
        .getHoofTrimsByPeriod(herdId, suffix)
        .then(function (response) {
          vm.fullHoofTrimData = angular.copy(response);
          if (!response) {
            response = [];
          }
          var dates = appService.groupBy(response, "VisitDate");
          vm.numberOfVisits = 0;
          angular.forEach(dates, function (value, key) {
            vm.numberOfVisits++;
          });
          if (!vm.hoofTrimByHerd) {
            vm.trimmerNames = getTrimmerNamesFromResponse(response);
            onTrimmerSelected();
          } else {
            var data = handleHoofTrimsResponse(response);
            data = calculateCosts(data);
            vm.hoofTrimData = data;
            $timeout(function () {
              createGraph();
            }, 150);
          }
          vm.loadingHoofTrims = false;
          vm.loading = false;
        })
        .catch(function (error) {
          vm.errorLoading = true;
          console.log(error);
        });
    }
    function filterResponseByTrimmer(response, selectedTrimmer) {
      return response.filter(function (item) {
        return item.Trimmer === selectedTrimmer;
      });
    }
    function handleHoofTrimsResponse(response) {
      var data = {
        reason: {
          trim: {
            n: 0,
            price: getPriceByName("trim", vm.defaultPrices),
            cost: 0,
          },
          trimRear: {
            n: 0,
            price: getPriceByName("trimRear", vm.defaultPrices),
            cost: 0,
          },
          lame: {
            n: 0,
            price: getPriceByName("lame", vm.defaultPrices),
            cost: 0,
          },
          recheck: {
            n: 0,
            price: getPriceByName("recheck", vm.defaultPrices),
            cost: 0,
          },
          cost: 0,
          cows: response.length,
        },
        standardTreatments: {
          block: {
            n: 0,
            price: getPriceByName("block", vm.defaultPrices),
            cost: 0,
          },
          wrap: {
            n: 0,
            price: getPriceByName("wrap", vm.defaultPrices),
            cost: 0,
          },
          cost: 0,
          c: 0,
        },
        treatments: {
          therapeuticTrim: {
            n: 0,
            price: getPriceByName("therapeuticTrim", vm.defaultPrices),
            cost: 0,
          },
          topical: {
            n: 0,
            price: getPriceByName("topical", vm.defaultPrices),
            cost: 0,
          },
          /*preventiveTrim: {
						n: 0,
						price: getPriceByName("preventiveTrim", vm.defaultPrices),
						cost: 0
					},*/
          antibioticTreatment: {
            n: 0,
            price: getPriceByName("antibioticTreatment", vm.defaultPrices),
            cost: 0,
          },
          conventional: {
            n: 0,
            price: getPriceByName("conventional", vm.defaultPrices),
            cost: 0,
          },
          cost: 0,
          c: 0,
        },
        discount: {
          discountPercentage: getPriceByName(
            "discountPercentage",
            vm.defaultPrices
          ),
          discountFixed: getPriceByName("discountFixed", vm.defaultPrices),
        },
        surcharge: {
          surchargePercentage: getPriceByName(
            "surchargePercentage",
            vm.defaultPrices
          ),
          surchargeFixed: getPriceByName("surchargeFixed", vm.defaultPrices),
        },
        lesions: {
          abcess: 0,
          dd: 0,
          toeUlcer: 0,
          ulcer: 0,
          soleFracture: 0,
          thinSoles: 0,
          other: 0,
          total: 0,
        },
        tripCharge: getPriceByName("tripCharge", vm.defaultPrices),
        visitCharge: getPriceByName("visitCharge", vm.defaultPrices),
        setupCharge: getPriceByName("setupCharge", vm.defaultPrices),
        standardCosts: 0,
        additionalCharges: 0,
        total: 0,
        subTotal: 0,
        totalDiscount: 0,
        totalSurcharge: 0,
        tax: getPriceByName("tax", vm.defaultPrices),
        totalTax: 0,
      };

      for (var i = 0; i < response.length; i++) {
        var reasonType = getReasonType(response[i].Reason);
        if (reasonType) {
          /*if (reasonType == 'trim' || reasonType == 'trimRear') {
						var front = false;
						var rear = false;
						for (var l = 0; l < response[i].Limbs.length; l++) {
							if (response[i].Limbs[l].Position === 0 || response[i].Limbs[l].Position === 1) {
								front = true;
							}

							if (response[i].Limbs[l].Position === 2 || response[i].Limbs[l].Position === 3) {
								rear = true;
							}
						}
						if (front) {
							data.reason.trim.n++;
						}

						if (rear) {
							data.reason.trimRear.n++;
						}
					} else {*/
          data.reason[reasonType].n++;
          //}
        }
        for (var j = 0; j < response[i].Limbs.length; j++) {
          var actionTypes = getActionTypes(response[i].Limbs[j].ActionType);
          var treatmentTypes = getTreatmentTypes(
            response[i].Limbs[j].TreatmentType
          );
          if (actionTypes.length > 0) {
            for (var k = 0; k < actionTypes.length; k++) {
              if (actionTypes[k] == "block") {
                data.standardTreatments.block.n++;
              }
              if (actionTypes[k] == "wrap") {
                data.standardTreatments.wrap.n++;
              }
            }
          }
          if (treatmentTypes.length > 0) {
            for (var g = 0; g < treatmentTypes.length; g++) {
              if (treatmentTypes[g] == "therapeuticTrim") {
                data.treatments.therapeuticTrim.n++;
              }
              if (treatmentTypes[g] == "topical") {
                data.treatments.topical.n++;
              }
              /*	if (treatmentTypes[g] == 'preventiveTrim') {
									data.treatments.preventiveTrim.n++;
								}*/
              if (treatmentTypes[g] == "antibioticTreatment") {
                data.treatments.antibioticTreatment.n++;
              }
              if (treatmentTypes[g] == "conventional") {
                data.treatments.conventional.n++;
              }
            }
          }
          var lesions = response[i].Limbs[j].Lesions;
          if (lesions) {
            for (var l = 0; l < lesions.length; l++) {
              var leasionType = getLesionType(lesions[l]);
              if (leasionType) {
                data.lesions[leasionType]++;
              }
            }
          }
        }
      }

      return data;
    }

    function getLesionType(lesion) {
      var l;
      if (lesion.LesionType == 1) {
        l = "abcess";
      } else if (lesion.LesionType == 2) {
        l = "other";
      } else if (lesion.LesionType == 3) {
        l = "other";
      } else if (lesion.LesionType == 4) {
        l = "dd";
      } else if (lesion.LesionType == 5) {
        l = "other";
      } else if (lesion.LesionType == 6) {
        l = "other";
      } else if (lesion.LesionType == 7) {
        l = "other";
      } else if (lesion.LesionType == 8) {
        l = "other";
      } else if (lesion.LesionType == 9) {
        l = "other";
      } else if (lesion.LesionType == 10) {
        l = "other";
      } else if (lesion.LesionType == 11) {
        l = "soleFracture";
      } else if (lesion.LesionType == 12) {
        l = "toeUlcer";
      } else if (lesion.LesionType == 13) {
        l = "ulcer";
      } else if (lesion.LesionType == 14) {
        l = "other";
      } else if (lesion.LesionType == 15) {
        l = "other";
      } else if (lesion.LesionType == 16) {
        l = "other";
      } else if (lesion.LesionType == 17) {
        l = "other";
      } else if (lesion.LesionType == 18) {
        l = "thinSoles";
      } else if (lesion.LesionType == 19) {
        l = "other";
      }

      return l;
    }

    function getReasonType(en_type) {
      var reason;
      if (en_type === 0) {
        reason = "trim";
      } else if (en_type == 1) {
        reason = "lame";
      } else if (en_type == 2) {
        reason = "recheck";
      } else if (en_type == 3) {
        reason = "trim";
      } else if (en_type == 4) {
        reason = "trimRear";
      }
      return reason;
    }

    function getActionTypes(a_type) {
      var types = [];
      if (a_type != 0) {
        if ((a_type & 1) == 1) {
          types.push("block");
        }
        if ((a_type & 2) == 2) {
          types.push("wrap");
        }
      }

      return types;
    }

    function getTreatmentTypes(t_type) {
      var types = [];
      if (t_type != 0) {
        if ((t_type & 1) == 1) {
          types.push("therapeuticTrim");
        }
        if ((t_type & 2) == 2) {
          types.push("topical");
        }
        /*if ((t_type & 4) == 4) {
					types.push('preventiveTrim');
				}*/
        if ((t_type & 4096) == 4096) {
          types.push("antibioticTreatment");
        }
        if ((t_type & 8192) == 8192) {
          types.push("conventional");
        }
      }

      return types;
    }

    function calculateCosts(data) {
      data.reason.trim.cost = data.reason.trim.n * data.reason.trim.price;
      data.reason.lame.cost = data.reason.lame.n * data.reason.lame.price;
      data.reason.recheck.cost =
        data.reason.recheck.n * data.reason.recheck.price;
      data.reason.trimRear.cost =
        data.reason.trimRear.n * data.reason.trimRear.price;
      data.reason.cost =
        data.reason.trim.cost +
        data.reason.lame.cost +
        data.reason.recheck.cost +
        data.reason.trimRear.cost;
      //data.reason.cows = data.reason.trim.n + data.reason.lame.n + data.reason.recheck.n + data.reason.trimRear.n;

      data.treatments.therapeuticTrim.cost =
        data.treatments.therapeuticTrim.n *
        data.treatments.therapeuticTrim.price;
      data.treatments.topical.cost =
        data.treatments.topical.n * data.treatments.topical.price;
      //data.treatments.preventiveTrim.cost = data.treatments.preventiveTrim.n * data.treatments.preventiveTrim.price;
      data.treatments.antibioticTreatment.cost =
        data.treatments.antibioticTreatment.n *
        data.treatments.antibioticTreatment.price;
      data.treatments.conventional.cost =
        data.treatments.conventional.n * data.treatments.conventional.price;
      //data.treatments.cost = data.treatments.therapeuticTrim.cost + data.treatments.topical.cost + data.treatments.preventiveTrim.cost + data.treatments.antibioticTreatment.cost + data.treatments.conventional.cost;
      data.treatments.cost =
        data.treatments.therapeuticTrim.cost +
        data.treatments.topical.cost +
        data.treatments.antibioticTreatment.cost +
        data.treatments.conventional.cost;
      //data.treatments.c = data.treatments.therapeuticTrim.n + data.treatments.topical.n + data.treatments.preventiveTrim.n + data.treatments.antibioticTreatment.n + data.treatments.conventional.n;
      data.treatments.c =
        data.treatments.therapeuticTrim.n +
        data.treatments.topical.n +
        data.treatments.antibioticTreatment.n +
        data.treatments.conventional.n;

      data.standardTreatments.block.cost =
        data.standardTreatments.block.n * data.standardTreatments.block.price;
      data.standardTreatments.wrap.cost =
        data.standardTreatments.wrap.n * data.standardTreatments.wrap.price;
      data.standardTreatments.cost =
        data.standardTreatments.wrap.cost + data.standardTreatments.block.cost;
      data.standardTreatments.c =
        data.standardTreatments.wrap.n + data.standardTreatments.block.n;

      data.standardCosts =
        data.reason.cost + data.standardTreatments.cost + data.treatments.cost;
      data.additionalCharges =
        (vm.includeTripCharge ? data.tripCharge : 0) +
        (vm.includeVisitCharge ? data.visitCharge : 0) +
        (vm.includeSetupCharge ? data.setupCharge : 0);

      data.subTotal = data.standardCosts + data.additionalCharges;
      data.totalDiscount = appService.round(
        vm.includeDiscount
          ? vm.discountUsePercentage
            ? (data.subTotal * data.discount.discountPercentage) / 100
            : data.discount.discountFixed
          : 0,
        2
      );
      data.totalSurcharge = appService.round(
        vm.includeSurcharge
          ? vm.surchargeUsePercentage
            ? (data.subTotal * data.surcharge.surchargePercentage) / 100
            : data.surcharge.surchargeFixed
          : 0,
        2
      );

      data.beforeTax = data.subTotal - data.totalDiscount;
      data.totalTax = appService.round(
        vm.taxIncluded ? 0 : (data.beforeTax * data.tax) / 100,
        2
      );
      data.total =
        data.subTotal -
        data.totalDiscount +
        data.totalSurcharge +
        data.totalTax;

      data.lesions.total =
        data.lesions.abcess +
        data.lesions.dd +
        data.lesions.toeUlcer +
        data.lesions.other +
        data.lesions.ulcer +
        data.lesions.soleFracture +
        data.lesions.thinSoles;

      return data;
    }

    function getPriceByName(name, prices) {
      var price = 0;
      for (var i = 0; i < prices.length; i++) {
        if (prices[i].name == name) {
          price = prices[i].price;
          break;
        }
      }
      return price;
    }

    function getIndexByName(name, prices) {
      var index = 99;
      for (var i = 0; i < prices.length; i++) {
        if (prices[i].name == name) {
          index = i;
          break;
        }
      }
      return index;
    }

    function dateSelected() {
      if (vm.selectedDate.VisitDate != vm.lastHoofTrimDate) {
        vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
        getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
        setNextTrimDate(vm.lastHoofTrimDate);
      }
    }

    function dateChanged() {
      if (vm.selectedDateObject) {
        var dateFound = false;
        for (var i = 0; i < vm.visitDates.length; i++) {
          if (
            $filter("date")(vm.selectedDateObject, "mediumDate") ==
            vm.visitDates[i].date
          ) {
            vm.selectedDate = vm.visitDates[i];
            dateSelected();
            dateFound = true;
            break;
          }
        }
        if (dateFound) {
          vm.dateError = false;
        } else {
          vm.dateError = true;
        }
      } else {
        vm.dateError = true;
      }
    }

    function setNextTrimDate(date) {
      var index;
      for (var i = 0; i < vm.visitDates.length; i++) {
        if (vm.visitDates[i].VisitDate == date) {
          index = i;
          break;
        }
      }

      if (vm.visitDates[i - 1]) {
        vm.nextTrimDate = $filter("date")(
          new Date(vm.visitDates[i - 1].VisitDate),
          "mediumDate"
        );
      } else {
        vm.nextTrimDate = "-";
      }
    }

    function setAllPricesToZero() {
      priceChanged(0, "reason", "trim");
      priceChanged(0, "reason", "trimRear");
      priceChanged(0, "reason", "lame");
      priceChanged(0, "reason", "recheck");
      priceChanged(0, "treatments", "therapeuticTrim");
      priceChanged(0, "treatments", "topical");
      priceChanged(0, "treatments", "antibioticTreatment");
      priceChanged(0, "treatments", "conventional");
      priceChanged(0, "standardTreatments", "block");
      priceChanged(0, "standardTreatments", "wrap");
      additionalChargesChanged(0, "tripCharge");
      additionalChargesChanged(0, "visitCharge");
      additionalChargesChanged(0, "setupCharge");
      discountValueChanged(0, "discountPercentage");
      discountValueChanged(0, "discountFixed");
      taxValueChanged(0);
      surchargeValueChanged(0, "surchargePercentage");
      surchargeValueChanged(0, "surchargeFixed");
    }

    function priceChanged(data, type, property) {
      var index = getIndexByName(property, vm.defaultPrices);
      if (vm.defaultPrices[index].price != data) {
        vm.defaultPrices[index].price = data;
        vm.hoofTrimData[type][property].price = data;
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        setPriceCookie(index, data);
      }
    }

    function includeAdditionalCharges(charge) {
      if (charge == "trip") {
        vm.includeTripCharge = !vm.includeTripCharge;
      } else if (charge == "visit") {
        vm.includeVisitCharge = !vm.includeVisitCharge;
      } else if (charge == "setup") {
        vm.includeSetupCharge = !vm.includeSetupCharge;
      }

      if (additionalChargesTimeout) {
        $timeout.cancel(additionalChargesTimeout);
      }
      additionalChargesTimeout = $timeout(function () {
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
      }, 500);
    }

    function additionalChargesChanged(data, type) {
      var index = getIndexByName(type, vm.defaultPrices);
      if (vm.defaultPrices[index].price != data) {
        vm.defaultPrices[index].price = data;
        vm.hoofTrimData[type] = data;
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        setPriceCookie(index, data);
      }
    }

    function addDiscount() {
      vm.includeDiscount = !vm.includeDiscount;
      if (discountTimeout) {
        $timeout.cancel(discountTimeout);
      }
      discountTimeout = $timeout(function () {
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
      }, 500);
    }

    function changeDiscountUnit() {
      if (vm.includeDiscount) {
        vm.discountUsePercentage = !vm.discountUsePercentage;
        if (vm.discountUsePercentage) {
          vm.discountUnit = "toggle_off";
        } else {
          vm.discountUnit = "toggle_on";
        }

        if (discountUnitTimeout) {
          $timeout.cancel(discountUnitTimeout);
        }

        discountUnitTimeout = $timeout(function () {
          vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        }, 500);
      }
    }

    function discountValueChanged(data, type) {
      var index = getIndexByName(type, vm.defaultPrices);
      if (vm.defaultPrices[index].price != data) {
        vm.defaultPrices[index].price = data;
        vm.hoofTrimData.discount[type] = data;
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        setPriceCookie(index, data);
      }
    }

    function addSurcharge() {
      vm.includeSurcharge = !vm.includeSurcharge;
      if (surchargeTimeout) {
        $timeout.cancel(surchargeTimeout);
      }
      surchargeTimeout = $timeout(function () {
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
      }, 500);
    }

    function changeSurchargeUnit() {
      if (vm.includeSurcharge) {
        vm.surchargeUsePercentage = !vm.surchargeUsePercentage;
        if (vm.surchargeUsePercentage) {
          vm.surchargeUnit = "toggle_off";
        } else {
          vm.surchargeUnit = "toggle_on";
        }

        if (surchargeUnitTimeout) {
          $timeout.cancel(surchargeUnitTimeout);
        }

        surchargeUnitTimeout = $timeout(function () {
          vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        }, 500);
      }
    }

    function changeHoofTrimPeriod() {
      vm.hoofTrimByDate = !vm.hoofTrimByDate;
      if (vm.hoofTrimByDate) {
        vm.timePeriodUnit = "toggle_off";
      } else {
        vm.timePeriodUnit = "toggle_on";
      }

      resetTrimmerSelection();
      if (timePeriodUnitTimeout) {
        $timeout.cancel(timePeriodUnitTimeout);
      }

      timePeriodUnitTimeout = $timeout(function () {
        if (vm.hoofTrimByDate) {
          getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
        } else {
          getHoofTrimsByPeriod(vm.selectedHerds[0]);
        }
      }, 500);
    }

    function changeFilter() {
      vm.hoofTrimByHerd = !vm.hoofTrimByHerd;

      if (vm.hoofTrimByHerd) {
        vm.filterUnit = "toggle_off";
      } else {
        vm.filterUnit = "toggle_on";
      }
      resetTrimmerSelection();
      if (filterUnitTimeout) {
        $timeout.cancel(filterUnitTimeout);
      }

      filterUnitTimeout = $timeout(function () {
        if (vm.hoofTrimByDate) {
          getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
        } else {
          getHoofTrimsByPeriod(vm.selectedHerds[0]);
        }
      }, 500);
    }
    function onTrimmerSelected() {
      if (vm.chart) {
        vm.chart.destroy();
      }
      var filteredResponse = filterResponseByTrimmer(
        vm.fullHoofTrimData,
        vm.selectedTrimmer
      );
      var data = handleHoofTrimsResponse(filteredResponse);
      data = calculateCosts(data);
      vm.hoofTrimData = data;
      $timeout(function () {
        createGraph();
      }, 150);
    }
    function setRange() {
      var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
      if (!range_error) {
        vm.startDate = angular.copy(vm.modal_start_date);
        vm.endDate = angular.copy(vm.modal_end_date);

        getHoofTrimsByPeriod(vm.selectedHerds[0]);
        closeModal();
        resetTrimmerSelection();
      }
    }

    function checkRangeError(start_date, end_date) {
      var error = false;
      if (moment(end_date).isBefore(start_date)) {
        error = true;
      }
      return error;
    }

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode == "day") {
        for (var i = 0; i < vm.visitDates.length; i++) {
          if ($filter("date")(date, "mediumDate") == vm.visitDates[i].date) {
            return "datepicker-highlight";
          }
        }
      }
    }

    function openRangeSelector() {
      if (!vm.loadingHoofTrims) {
        vm.modal_start_date = angular.copy(vm.startDate);
        vm.modal_end_date = angular.copy(vm.endDate);
        openModal("app/pages/rap/rangeSelector.modal.html", "sm");
      }
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function surchargeValueChanged(data, type) {
      var index = getIndexByName(type, vm.defaultPrices);
      if (vm.defaultPrices[index].price != data) {
        vm.defaultPrices[index].price = data;
        vm.hoofTrimData.surcharge[type] = data;
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        setPriceCookie(index, data);
      }
    }

    function includeTax() {
      vm.taxIncluded = !vm.taxIncluded;
      if (taxTimeout) {
        $timeout.cancel(taxTimeout);
      }
      taxTimeout = $timeout(function () {
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
      }, 500);
    }

    function taxValueChanged(data) {
      var index = getIndexByName("tax", vm.defaultPrices);
      if (vm.defaultPrices[index].price != data) {
        vm.defaultPrices[index].price = data;
        vm.hoofTrimData.tax = data;
        vm.hoofTrimData = calculateCosts(vm.hoofTrimData);
        setPriceCookie(index, data);
      }
    }

    function setPriceCookie(index, price) {
      try {
        var cookie = $cookies.getObject("prices");
      } catch (error) {
        console.log(error);
      }
      if (cookie && cookie.length) {
        var herdFound = false;
        var herdIndex;
        for (var i = 0; i < cookie.length; i++) {
          if (cookie[i].herdId == vm.selectedHerds[0]) {
            herdFound = true;
            herdIndex = i;
            break;
          }
        }

        if (herdFound) {
          var prices = cookie[herdIndex].prices;
          var priceFound = false;
          var priceIndex;
          if (prices && prices.length) {
            for (var p = 0; p < prices.length; p++) {
              if (prices[p].id == vm.defaultPrices[index].id) {
                priceFound = true;
                priceIndex = p;
                break;
              }
            }
          }
          if (priceFound) {
            cookie[herdIndex].prices[priceIndex].p = price;
          } else {
            var obj = {
              id: vm.defaultPrices[index].id,
              p: price,
            };
            cookie[herdIndex].prices.push(obj);
          }
        } else {
          var obj = {
            herdId: vm.selectedHerds[0],
            prices: [
              {
                id: vm.defaultPrices[index].id,
                p: price,
              },
            ],
          };
          cookie.push(obj);
        }
      } else {
        cookie = [
          {
            herdId: vm.selectedHerds[0],
            prices: [
              {
                id: vm.defaultPrices[index].id,
                p: price,
              },
            ],
          },
        ];
      }
      var expireDate = moment().add(1, "years");
      expireDate = new Date(expireDate);
      cookie = JSON.stringify(cookie);
      cookiesService.setCookie("prices", cookie, {
        expires: expireDate,
        samesite: "Strict",
      });
    }

    function trimmerDataChanged(property) {
      if (trimmerTimeout) {
        $timeout.cancel(trimmerTimeout);
      }

      trimmerTimeout = $timeout(function () {
        setTrimmerCookie(property);
      }, 750);
    }

    function setTrimmerCookie(property) {
      var pName;
      var value;
      if (property == "company_name") {
        pName = "cn";
        value = vm.trimmerCompany.Name;
      } else if (property == "trimmer_name") {
        pName = "tn";
        value = vm.trimmerName;
      } else if (property == "address_street") {
        pName = "st";
        value = vm.trimmerCompany.Address.Street;
      } else if (property == "address_number") {
        pName = "an";
        value = vm.trimmerCompany.Address.Number;
      } else if (property == "address_city") {
        pName = "ac";
        value = vm.trimmerCompany.Address.City;
      } else if (property == "address_state") {
        pName = "as";
        value = vm.trimmerCompany.Address.State;
      } else if (property == "address_zip") {
        pName = "az";
        value = vm.trimmerCompany.Address.Zip;
      } else if (property == "trimmer_phone") {
        pName = "tp";
        value = vm.trimmerCompany.PhoneNumber;
      }
      var cookieName = vm.userInfo.email + "_trimmer";
      try {
        var cookie = $cookies.getObject(cookieName);
      } catch (error) {
        console.log(error);
      }

      if (cookie) {
        cookie[pName] = value;
      } else {
        cookie = {};
        cookie[pName] = value;
      }
      var expireDate = moment().add(1, "years");
      expireDate = new Date(expireDate);
      cookie = JSON.stringify(cookie);
      cookiesService.setCookie(cookieName, cookie, {
        expires: expireDate,
        samesite: "Strict",
      });
    }

    function dairyDataChanged(property) {
      if (dairyTimeout) {
        $timeout.cancel(dairyTimeout);
      }

      dairyTimeout = $timeout(function () {
        setDairyCookie(property);
      }, 750);
    }

    function setDairyCookie(property) {
      var pName;
      var value;
      if (property == "company_name") {
        pName = "cn";
        value = vm.dairyCompany.Name;
      } else if (property == "dairy_email") {
        pName = "de";
        value = vm.dairyCompany.Email;
      } else if (property == "address_street") {
        pName = "st";
        value = vm.dairyCompany.Street;
      } else if (property == "address_number") {
        pName = "an";
        value = vm.dairyCompany.Number;
      } else if (property == "address_city") {
        pName = "ac";
        value = vm.dairyCompany.City;
      } else if (property == "address_state") {
        pName = "as";
        value = vm.dairyCompany.State;
      } else if (property == "address_zip") {
        pName = "az";
        value = vm.dairyCompany.Zip;
      } else if (property == "dairy_phone") {
        pName = "dp";
        value = vm.dairyCompany.PhoneNumber;
      }
      var cookieName = "dairy-info";
      try {
        var cookie = $cookies.getObject(cookieName);
      } catch (error) {
        console.log(error);
      }

      if (cookie && cookie.length) {
        var herdFound = false;
        var herdIndex;
        for (var i = 0; i < cookie.length; i++) {
          if (cookie[i].herdId == vm.selectedHerds[0]) {
            herdFound = true;
            herdIndex = i;
            break;
          }
        }
        if (herdFound) {
          cookie[herdIndex].data[pName] = value;
        } else {
          var obj = {
            herdId: vm.selectedHerds[0],
            data: {},
          };
          obj.data[pName] = value;
          cookie.push(obj);
        }
      } else {
        cookie = [
          {
            herdId: vm.selectedHerds[0],
            data: {},
          },
        ];
        cookie[0].data[pName] = value;
      }
      var expireDate = moment().add(1, "years");
      expireDate = new Date(expireDate);
      cookie = JSON.stringify(cookie);
      cookiesService.setCookie(cookieName, cookie, {
        expires: expireDate,
        samesite: "Strict",
      });
    }

    function createGraph() {
      var data = {
        labels: [],
        datasets: [
          {
            label: i18nFilter("_invoice_label_number_of_lesions_"),
            data: [],

            borderWidth: 1,
          },
        ],
      };

      if (vm.hoofTrimData.lesions.abcess) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_abcess_") +
            " [" +
            vm.hoofTrimData.lesions.abcess +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.abcess);
      }
      if (vm.hoofTrimData.lesions.dd) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_digital_dermatitis_") +
            " [" +
            vm.hoofTrimData.lesions.dd +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.dd);
      }
      if (vm.hoofTrimData.lesions.toeUlcer) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_toe_ulcer_") +
            " [" +
            vm.hoofTrimData.lesions.toeUlcer +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.toeUlcer);
      }
      if (vm.hoofTrimData.lesions.ulcer) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_ulcer_") +
            " [" +
            vm.hoofTrimData.lesions.ulcer +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.ulcer);
      }
      if (vm.hoofTrimData.lesions.soleFracture) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_sole_fracture_") +
            " [" +
            vm.hoofTrimData.lesions.soleFracture +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.soleFracture);
      }
      if (vm.hoofTrimData.lesions.thinSoles) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_thin_soles_") +
            " [" +
            vm.hoofTrimData.lesions.thinSoles +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.thinSoles);
      }
      if (vm.hoofTrimData.lesions.other) {
        data.labels.push(
          i18nFilter("_animal_details_disease_other_") +
            " [" +
            vm.hoofTrimData.lesions.other +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimData.lesions.other);
      }
      var options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: i18nFilter("_invoice_label_number_of_lesions_"),
              },
              gridLines: {
                display: true,
              },
              ticks: {
                stepSize: 2,
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: i18nFilter("_invoice_label_lesion_"),
              },
              ticks: {
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
        },
      };
      if (vm.hoofTrimData.lesions.total) {
        var ctx = document.getElementById("graph");
        vm.chart = new Chart(ctx, {
          type: "horizontalBar",
          data: data,
          options: options,
        });
      }
    }

    function exportToPdf() {
      createPdf();
    }

    function createPdf() {
      try {
        var date = vm.selectedDate.VisitDate;
        var s_date = $filter("date")(new Date(date), "shortDate");
        var l_date = $filter("date")(new Date(date), "mediumDate");

        var dd = {
          pageMargins: [25, 30, 25, 30],
          pageSize: "A4",
          content: [
            {
              style: "header",

              table: {
                widths: ["*", 100],

                body: [
                  [
                    {
                      text: i18nFilter(
                        "_invoice_label_trimming_report_invoice_"
                      ),
                      alignment: "center",
                      border: [false, false, false, true],
                    },
                    {
                      text: $filter("date")(new Date(), "shortDate"),
                      border: [false, false, false, true],
                    },
                  ],
                ],
              },
            },
            {
              table: {
                widths: ["*", "*"],

                body: [
                  [
                    {
                      text: vm.trimmerCompany.Name
                        ? vm.trimmerCompany.Name
                        : "",
                      border: [false, false, false, false],
                    },
                    {
                      text: vm.dairyCompany.Name ? vm.dairyCompany.Name : "",
                      border: [false, false, false, false],
                    },
                  ],
                ],
              },
            },
            {
              style: "headerSm",

              table: {
                widths: ["*", "*"],

                body: [
                  [
                    {
                      text: i18nFilter("_invoice_label_billing_summary_"),
                      alignment: "center",
                      border: [false, false, false, true],
                    },
                    {
                      text: i18nFilter("_invoice_label_lesion_summary_"),
                      alignment: "center",
                      border: [false, false, false, true],
                    },
                  ],
                ],
              },
            },

            {
              table: {
                widths: [89, 56, 40, 50, 265],

                body: [
                  [
                    {
                      style: "tableHeader",
                      text: i18nFilter("_invoice_label_type_"),
                      alignment: "left",
                      border: [false, false, false, true],
                    },
                    {
                      style: "tableHeader",
                      text: i18nFilter("_invoice_label_n_cows_"),
                      alignment: "center",
                      border: [false, false, false, true],
                    },
                    {
                      style: "tableHeader",
                      text: i18nFilter("_invoice_label_price_"),
                      alignment: "center",
                      border: [false, false, false, true],
                    },
                    {
                      style: "tableHeader",
                      text: i18nFilter("_invoice_label_cost_"),
                      alignment: "center",
                      border: [false, false, true, true],
                    },
                    {
                      style: "tableHeader",
                      text:
                        i18nFilter("_invoice_label_total_number_of_lesions_") +
                        " = " +
                        (vm.hoofTrimData.lesions.total
                          ? vm.hoofTrimData.lesions.total
                          : ""),
                      alignment: "center",
                      border: [false, false, false, false],
                    },
                  ],
                ],
              },
            },
          ],
          styles: {
            header: {
              fontSize: 17,
              bold: true,
            },
            headerSm: {
              fontSize: 15,
              bold: true,
            },
            tableHeader: {
              bold: true,
            },
          },
          defaultStyle: {
            fontSize: 10,
          },
        };
        if (vm.trimmerName || vm.dairyCompany.Email) {
          var obj = [
            {
              text: vm.trimmerName ? vm.trimmerName : "",
              border: [false, false, false, false],
            },
            {
              text: vm.dairyCompany.Email ? vm.dairyCompany.Email : "",
              border: [false, false, false, false],
            },
          ];
          dd.content[1].table.body.push(obj);
        }

        if (vm.trimmerCompany.Address.Street || vm.dairyCompany.Street) {
          var obj = [
            {
              text:
                (vm.trimmerCompany.Address.Street
                  ? vm.trimmerCompany.Address.Street
                  : "") +
                " " +
                (vm.trimmerCompany.Address.Number
                  ? vm.trimmerCompany.Address.Number
                  : ""),
              border: [false, false, false, false],
            },
            {
              text:
                (vm.dairyCompany.Street ? vm.dairyCompany.Street : "") +
                " " +
                (vm.dairyCompany.Number ? vm.dairyCompany.Number : ""),
              border: [false, false, false, false],
            },
          ];
          dd.content[1].table.body.push(obj);
        }

        if (vm.trimmerCompany.Address.Zip || vm.dairyCompany.Zip) {
          var obj = [
            {
              text:
                (vm.trimmerCompany.Address.Zip
                  ? vm.trimmerCompany.Address.Zip
                  : "") +
                " " +
                (vm.trimmerCompany.Address.City
                  ? vm.trimmerCompany.Address.City
                  : "") +
                (vm.trimmerCompany.Address.State
                  ? ", " + vm.trimmerCompany.Address.State
                  : ""),
              border: [false, false, false, false],
            },
            {
              text:
                (vm.dairyCompany.Zip ? vm.dairyCompany.Zip : "") +
                " " +
                (vm.dairyCompany.City ? vm.dairyCompany.City : "") +
                (vm.dairyCompany.State ? ", " + vm.dairyCompany.State : ""),
              border: [false, false, false, false],
            },
          ];
          dd.content[1].table.body.push(obj);
        }

        if (vm.trimmerCompany.PhoneNumber || vm.dairyCompany.PhoneNumber) {
          var obj = [
            {
              text: vm.trimmerCompany.PhoneNumber
                ? $filter("tel")(vm.trimmerCompany.PhoneNumber)
                : "",
              border: [false, false, false, false],
            },
            {
              text: vm.dairyCompany.PhoneNumber
                ? $filter("tel")(vm.dairyCompany.PhoneNumber)
                : "",
              border: [false, false, false, false],
            },
          ];
          dd.content[1].table.body.push(obj);
        }
        var obj = [
          {
            text: vm.hoofTrimByDate
              ? i18nFilter("_invoice_label_visit_date_") + ": " + l_date
              : i18nFilter("_report_time_period_") +
                ": " +
                $filter("date")(vm.startDate, "mediumDate") +
                " - " +
                $filter("date")(vm.endDate, "mediumDate"),
            border: [false, false, false, true],
          },
          {
            text: vm.hoofTrimByDate
              ? i18nFilter("_invoice_label_next_trim_date_") +
                ": " +
                vm.nextTrimDate
              : i18nFilter("_invoice_label_total_number_visits_") +
                ": " +
                vm.numberOfVisits,
            border: [false, false, false, true],
          },
        ];

        dd.content[1].table.body.push(obj);

        var obj = [
          {
            text: "",
            colSpan: 4,
            border: [false, false, true, false],
          },
          {},
          {},
          {},
          {
            rowSpan: 4,
            image: vm.hoofTrimData.lesions.total
              ? vm.chart.toBase64Image()
              : "",
            width: 265,
            alignment: "center",
            border: [false, false, false, false],
          },
        ];

        dd.content[3].table.body.push(obj);
        if (vm.hoofTrimData.reason.trim.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_visit_reason_trim_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.reason.trim.n
                ? vm.hoofTrimData.reason.trim.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.trim.price),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.trim.cost),
              alignment: "right",
              border: [false, false, true, false],
            },
            {},
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.reason.trimRear.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_visit_reason_trim_rear_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.reason.trimRear.n
                ? vm.hoofTrimData.reason.trimRear.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.trimRear.price),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.trimRear.cost),
              alignment: "right",
              border: [false, false, true, false],
            },
            {},
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.reason.lame.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_visit_reason_lame_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.reason.lame.n
                ? vm.hoofTrimData.reason.lame.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.lame.price),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.lame.cost),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.reason.recheck.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_visit_reason_recheck_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.reason.recheck.n
                ? vm.hoofTrimData.reason.recheck.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.recheck.price),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(vm.hoofTrimData.reason.recheck.cost),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        var obj = [
          {
            text: i18nFilter("_invoice_label_total_cows_"),
            style: "tableHeader",
            alignment: "center",
            border: [false, false, false, true],
          },
          {
            text: vm.hoofTrimData.reason.cows
              ? vm.hoofTrimData.reason.cows
              : "",
            alignment: "center",
            style: "tableHeader",
            border: [false, false, false, true],
          },
          {
            text: "",
            alignment: "right",
            style: "tableHeader",
            border: [false, false, false, true],
          },
          {
            text: $filter("currency")(vm.hoofTrimData.reason.cost),
            alignment: "right",
            style: "tableHeader",
            border: [false, false, true, true],
          },
          {
            text: "",
            style: "tableHeader",
            alignment: "center",
            border: [false, false, false, false],
          },
        ];

        dd.content[3].table.body.push(obj);

        if (vm.hoofTrimData.treatments.c != 0) {
          var obj = [
            {
              style: "tableHeader",
              text: i18nFilter("_animal_treatment_"),
              alignment: "left",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_count_"),
              alignment: "center",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_price_"),
              alignment: "center",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_cost_"),
              alignment: "center",
              border: [false, false, true, true],
            },
            {
              style: "tableHeader",
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.treatments.therapeuticTrim.n != 0) {
          var obj = [
            {
              text: vm.treatmentNames.therapeuticTrim
                ? vm.treatmentNames.therapeuticTrim
                : "",
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.treatments.therapeuticTrim.n
                ? vm.hoofTrimData.treatments.therapeuticTrim.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.therapeuticTrim.price
              ),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.therapeuticTrim.cost
              ),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.treatments.topical.n != 0) {
          var obj = [
            {
              text: vm.treatmentNames.topical ? vm.treatmentNames.topical : "",
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.treatments.topical.n
                ? vm.hoofTrimData.treatments.topical.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.topical.price
              ),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.topical.cost
              ),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        /*	if(vm.hoofTrimData.treatments.preventiveTrim.n !=0 ){
					var obj = [{
										text: l_date,
										alignment: 'center',
										border: [false, false, false, false],
									}, {
										text: vm.treatmentNames.preventiveTrim,
										alignment: 'left',
										border: [false, false, false, false],
									}, {
										text: vm.hoofTrimData.treatments.preventiveTrim.n,
										alignment: 'center',
										border: [false, false, false, false],
									}, {
										text: $filter('currency')(vm.hoofTrimData.treatments.preventiveTrim.cost),
										alignment: 'right',
										border: [false, false, true, false],
									}, {
										text: '',
										alignment: 'center',
										border: [false, false, false, false],
									}];
				
				dd.content[3].table.body.push(obj);
				}*/

        if (vm.hoofTrimData.treatments.antibioticTreatment.n != 0) {
          var obj = [
            {
              text: vm.treatmentNames.antibioticTreatment
                ? vm.treatmentNames.antibioticTreatment
                : "",
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.treatments.antibioticTreatment.n
                ? vm.hoofTrimData.treatments.antibioticTreatment.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.antibioticTreatment.price
              ),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.antibioticTreatment.cost
              ),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.treatments.conventional.n != 0) {
          var obj = [
            {
              text: vm.treatmentNames.conventional
                ? vm.treatmentNames.conventional
                : "",
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.treatments.conventional.n
                ? vm.hoofTrimData.treatments.conventional.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.conventional.price
              ),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.treatments.conventional.cost
              ),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.treatments.c != 0) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_treatment_charges_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, true],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.treatments.cost),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, true],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.standardTreatments.c != 0) {
          var obj = [
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_action_"),
              alignment: "left",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_count_"),
              alignment: "center",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_price_"),
              alignment: "center",
              border: [false, false, false, true],
            },
            {
              style: "tableHeader",
              text: i18nFilter("_invoice_label_cost_"),
              alignment: "center",
              border: [false, false, true, true],
            },
            {
              style: "tableHeader",
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.standardTreatments.block.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_hoof_treatment_type_block_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.standardTreatments.block.n
                ? vm.hoofTrimData.standardTreatments.block.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.standardTreatments.block.price
              ),
              alignment: "right",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.standardTreatments.block.cost
              ),
              alignment: "right",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.standardTreatments.wrap.n != 0) {
          var obj = [
            {
              text: i18nFilter("_animal_details_hoof_treatment_type_wrap_"),
              alignment: "left",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData.standardTreatments.wrap.n
                ? vm.hoofTrimData.standardTreatments.wrap.n
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.standardTreatments.wrap.price
              ),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, false, false],
            },
            {
              text: $filter("currency")(
                vm.hoofTrimData.standardTreatments.wrap.cost
              ),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.hoofTrimData.standardTreatments.c != 0) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_action_charges_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, true],
            },
            {},
            {},
            {
              text: $filter("currency")(
                vm.hoofTrimData.standardTreatments.cost
              ),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, true],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.includeTripCharge) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_trip_charges_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.tripCharge),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];
          dd.content[3].table.body.push(obj);
        }

        if (vm.includeVisitCharge) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_visit_charges_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.visitCharge),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];
          dd.content[3].table.body.push(obj);
        }

        if (vm.includeSetupCharge) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_setup_charges_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.setupCharge),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];
          dd.content[3].table.body.push(obj);
        }

        var subTotal = [
          {
            text:
              i18nFilter("_invoice_label_sub_total_") +
              (vm.taxIncluded
                ? "(" + i18nFilter("_invoice_label_tax_included_") + ")"
                : ""),
            style: "tableHeader",
            alignment: "right",
            colSpan: 3,
            border: [false, false, false, false],
          },
          {},
          {},
          {
            text: $filter("currency")(vm.hoofTrimData.subTotal),
            alignment: "right",
            style: "tableHeader",
            border: [false, false, true, false],
          },
          {
            text: "",
            style: "tableHeader",
            alignment: "center",
            border: [false, false, false, false],
          },
        ];

        dd.content[3].table.body.push(subTotal);

        if (vm.includeDiscount) {
          var obj = [
            {
              text:
                i18nFilter("_invoice_label_discount_") +
                (vm.discountUsePercentage
                  ? "(" + vm.hoofTrimData.discount.discountPercentage + "%)"
                  : ""),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.totalDiscount),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (!vm.taxIncluded) {
          var obj = [
            {
              text: i18nFilter("_invoice_label_tax_"),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.totalTax),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        if (vm.includeSurcharge) {
          var obj = [
            {
              text:
                vm.surchargeName +
                " " +
                i18nFilter("_invoice_label_surcharge_") +
                (vm.includeSurcharge && vm.surchargeUsePercentage
                  ? "(" + vm.hoofTrimData.surcharge.surchargePercentage + "%)"
                  : ""),
              style: "tableHeader",
              alignment: "right",
              colSpan: 3,
              border: [false, false, false, false],
            },
            {},
            {},
            {
              text: $filter("currency")(vm.hoofTrimData.totalSurcharge),
              alignment: "right",
              style: "tableHeader",
              border: [false, false, true, false],
            },
            {
              text: "",
              style: "tableHeader",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          dd.content[3].table.body.push(obj);
        }

        var totalCost = [
          {
            text: i18nFilter("_animal_details_total_") + " ",
            style: "tableHeader",
            alignment: "right",
            colSpan: 3,
            border: [false, false, false, false],
          },
          {},
          {},
          {
            text: $filter("currency")(vm.hoofTrimData.total),
            alignment: "right",
            style: "tableHeader",
            border: [false, false, true, false],
          },
          {
            text: "",
            style: "tableHeader",
            alignment: "center",
            border: [false, false, false, false],
          },
        ];
        dd.content[3].table.body.push(totalCost);
        var rowSpan = dd.content[3].table.body.length - 1;
        dd.content[3].table.body[1][4].rowSpan = rowSpan;
        if (vm.hoofTrimData.lesions.total == 0) {
          delete dd.content[3].table.body[1][4].image;
          dd.content[3].table.body[1][4].text = " ";
        }
        var name = vm.herdName + "_" + s_date + ".pdf";
        pdfMake.createPdf(dd).download(name);
      } catch (error) {
        console.log(error);
        sendToBugsnag(dd, error);
      }
    }

    function sendToBugsnag(data, error) {
      var message = {
        message: "Invoice",
        severity: "error",
        metaData: {
          herd: {
            herd_id: vm.selectedHerds,
          },
          HoofTrimData: {
            data: vm.hoofTrimData,
          },
          Date: {
            byDate: vm.hoofTrimByDate,
            start_date: vm.startDate,
            end_date: vm.endDate,
            next_trim: vm.selectedDate,
            lng: localStorage.getItem("lng"),
          },
          cookies: {
            prices: $cookies.getObject("prices"),
          },
          event: {
            error: error,
          },
        },
      };
      bugsnagService.logMessage(message);
    }

    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });

    editableOptions.theme = "bs3";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.invoice').factory('invoiceService', invoiceService);
	/** @ngInject */
	function invoiceService($http, $q, APP_CONSTANTS) {
		return {
			getHoofTrims: getHoofTrims,
			getHerdInfo: getHerdInfo,
			getVisitDates: getVisitDates,
			getTeamInfo: getTeamInfo,
			getHoofTrimsByPeriod: getHoofTrimsByPeriod,
		}


		function getHoofTrims(herdId, date) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/hooftrims?VisitDate=' + date, {
				timeout: 15000
			}).then(success).catch(error);
		}

		function getHerdInfo(herdId) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herdId, {
				timeout: 15000
			}).then(success).catch(error);
		}

		function getVisitDates(herdId) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/hooftrims/visitdates?-orderby=-VisitDate', {
				timeout: 15000
			}).then(success).catch(error);
		}

		function getHoofTrimsByPeriod(herdId, suffix) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/hooftrims' + suffix, {
				timeout: 15000
			}).then(success).catch(error);
		}


		function getTeamInfo(teamId) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + teamId, {
				timeout: 15000
			}).then(success).catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.lactationAnalysis').controller('lactationAnalysisCtrl', lactationAnalysisCtrl);
	/** @ngInject */
	function lactationAnalysisCtrl($timeout, herdDashboardsService, lactationAnalysisService, $q, APP_CONSTANTS, $rootScope, $http, $uibModalStack, $uibModal, $scope, $filter) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var dataDashboardSheetName;
		var dataDashboardSheetNameMilk;
		var viewDataDashboardName;
		var viewDataDashboardNameMilk;
		var measureNameParam;
		var kpiTableName;
		var kpiTableNameMilk;
		var lactationAnalysisMarkFilterPairs = APP_CONSTANTS.constants.lactationAnalysisMarkFilterPairs;
		vm.openRangeSelector = openRangeSelector;
		vm.setRange = setRange;
		vm.closeModal = closeModal;
		vm.setRange = setRange;
		vm.goBack = goBack;
		vm.init = init;
		setDates();
		init();

		function init() {
			setStrings();
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			dataDashboardSheetName = 'Show data Milk Recordings';
			dataDashboardSheetNameMilk = 'Show all data Milk';
			viewDataDashboardName = $filter('i18n')('_dashboard_name_view_data_mro_');
			viewDataDashboardNameMilk = $filter('i18n')('_dashboard_name_view_data_milk_');
			herdParamName = 'Herd Parameter';
			measureNameParam = 'Measure name parameter';
			kpiTableName = 'DIM MRO KPI table';
			kpiTableNameMilk = 'DIM MM KPI Table';
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.dashboards = [
				{
					id: 'LactationanalysisbyDIMMROdashboard',
					description: 'Production dashboard',
					category: 'production',
					subcategory: 'module-lactation-analysis',
					locale: 'en-GB',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB'
				}
			];
			dashboards.team_id = team_id;
			dashboards.expires = new Date('2100-12-31');*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return lactationAnalysisService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							herdDashboardsService.tableauStored = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var lactationAnalysisDashboardId = $filter('i18n')('_lactation_analysis_dashboard_id_');
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'module-lactation-analysis' && response[i].id == lactationAnalysisDashboardId) {
						vm.lactationAnalysisDashboard = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.lactationAnalysisDashboard;
				if (vm.lactationAnalysisDashboard) {
					//local testing
					//embedPage(vm.lactationAnalysisDashboard, false);
					embedPage(vm.lactationAnalysisDashboard, true);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('lactationAnalysisFrame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('lactationAnalysisFrame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard, useTabvis) {
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return lactationAnalysisService
						.setSession(url)
						.then(function (response) {
							vm.loadingDashboards = false;
							vm.showButtons = true;
							var url = response.headers('tabvis-location');
							embed(url, herds, useTabvis);
						})
						.catch(function (response) {
							vm.embed = null;
							vm.errorLoading = true;
							vm.loading = false;
							console.log('error getting tabvis-location header');
						});
				} else {
					if (vm.currentLng == 'en-GB') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_en-GB_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'en-US') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_en-GB_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'fr-FR') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_fr-FR_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'de-DE') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_de-DE_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'nl-NL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_nl-NL_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'pl-PL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-module-lactation-analysis_pl-PL_twb/LactationanalysisbyDIMMROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					}
					embed(url, herds, useTabvis);
				}
			}
		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd'),
					onFirstInteractive: function () {
						/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
							console.log(parameters)
						})*/
						viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					}
				};
				options[herdParamName] = herdParam;
				$timeout(function () {
					var containerDiv = document.getElementById('lactationAnalysisFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarkSelection);
				}, 1000);
			}
		}

		function onMarkSelection(event) {
			vm.lastSelectedMark = event.getWorksheet().getName();
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			oldSheetName = marksEvent.getOldSheetName();
			newSheetName = marksEvent.getNewSheetName();
			vm.lastSheetName = oldSheetName;
			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}

				if (newSheetName == viewDataDashboardName || newSheetName == viewDataDashboardNameMilk) {
					if (newSheetName == viewDataDashboardName) {
						vm.viewDataDashboard = dataDashboardSheetName;
					} else {
						vm.viewDataDashboard = dataDashboardSheetNameMilk;
					}
					//console.log(vm.lastSelectedMark)
					var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
					//console.log(activeFilterName)
					if (vm.lastSelectedMark != kpiTableName && vm.lastSelectedMark != kpiTableNameMilk) {
						checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
					} else {
						checkFilters(wrks, vm.viewDataDashboard, 'empty');
					}

					setBackButtonVisibility(true);
				} else {
					viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
			}
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			wrks.get(sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].getFieldName();
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i]);
							}
						}
						//console.log('clear', listToClear)
					} else {
						vm.actionFilterList = actionFilterList;
					}
					//console.log('action', vm.actionFilterList)
				});
		}

		function resetFilter(filter) {
			viz.getWorkbook().getActiveSheet().getWorksheets().get(vm.viewDataDashboard).clearFilterAsync(filter);
		}

		function getActiveFilterName(mark) {
			var filter;
			var list = lactationAnalysisMarkFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].mark == mark && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(vm.viewDataDashboard)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function openRangeSelector() {
			if (!vm.disableCategoryButtons) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				};
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var end_date = vm.end_date;
			var start_date = vm.start_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook()
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}
		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}

				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						viz.getWorkbook().changeParameterValueAsync(herdParamName, herdParam);
					} else {
						init();
					}
				}
			}, 750);
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 100);
		});

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve('cancel_request');
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.lactationAnalysis').factory('lactationAnalysisService', lactationAnalysisService);
    /** @ngInject */
    function lactationAnalysisService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
    'use strict';
    angular.module('My.login').factory('isFarmerService', isFarmerService);
    /** @ngInject */
    function isFarmerService() {
        return {
            isFarmer: {}
        }
    }
})();

(function () {
  "use strict";
  angular.module("My.login").controller("loginCtrl", loginCtrl);
  /** @ngInject */
  function loginCtrl(
    $timeout,
    $state,
    authService,
    $scope,
    permissionService,
    $cookies,
    toastr,
    cookiesService,
    auth0Service,
    $rootScope
  ) {
    var vm = this;
    vm.login = login;
    vm.isCollapsed = true;
    vm.showAuth = false;
    vm.goToLogin = goToLogin;
    var MYPermission = 14;

    init();

    function init() {
      vm.showAuth = true;
      auth0Service.init();
      handleAuthentication();
      //lock.show();
    }

    function goToLogin() {
      auth0Service.login();
      //lock.show();
    }

    function handleAuthentication() {
      return auth0Service
        .handleAuthentication()
        .then(function (authResult) {
          onAuthenticated(authResult);
        })
        .catch(function (error) {
          console.log(error);
          auth0Service.login();
        });
    }

    function onAuthenticated(authResult) {
      vm.loading = true;
      var timeStamp = new Date().getTime();
      localStorage.setItem("authenticated", timeStamp);

      var user = {
        picture: authResult.idTokenPayload.picture,
        email: authResult.idTokenPayload.email,
        name: authResult.idTokenPayload.name,
        user_id: authResult.idTokenPayload.sub,
      };
      localStorage.setItem("access_token", authResult.accessToken);
      localStorage.setItem("user_profile", JSON.stringify(user));
      localStorage.setItem("id_token", authResult.idToken);
      localStorage.setItem("login_type", "regular");
      authorize(authResult.idTokenPayload);
    }

    function authorize(profile) {
      authService
        .getUserPermissions()
        .then(function (response) {
          if (response.IsGlobalAdmin) {
            permissionService.isGlobalAdmin = true;
            getTeams(profile);
          } else {
            permissionService.isGlobalAdmin = false;
            processPermissions(response.Teams, profile);
          }
        })
        .catch(function (error) {
          toastr.error("ERROR", "Please try again.");
          auth0Service.handleUnauthorized(500);
        });
    }

    function getTeams(profile) {
      var permissions = [];
      for (var i = 0; i < 700; i++) {
        permissions.push(i);
      }
      authService
        .getTeams()
        .then(function (response) {
          var teams = [];
          for (var i = 0; i < response.length; i++) {
            var team = {
              TeamId: response[i].Id,
              Permissions: permissions,
            };
            teams.push(team);
          }
          processPermissions(teams, profile);
        })
        .catch(function (error) {
          auth0Service.handleUnauthorized(500);
        });
    }

    //function used for team permission check
    function processPermissions(permissions, profile) {
      var haveMyPermissions = false;
      permissionService.permissions = permissions;
      for (var i = 0; i < permissions.length; i++) {
        for (var j = 0; j < permissions[i].Permissions.length; j++) {
          if (permissions[i].Permissions[j] == MYPermission) {
            haveMyPermissions = true;
            break;
          }
        }
      }
      if (haveMyPermissions) {
        var expireDate = moment();
        expireDate.add(10, "hours");
        expireDate = new Date(expireDate);
        cookiesService.setCookie(
          "mmmooogle_token",
          localStorage.getItem("id_token"),
          {
            samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
            expires: expireDate,
          }
        );

        var teamsWithPermissionToAccess = generateTeamsWPTA(permissions);
        authorizePermissionsTeams(
          teamsWithPermissionToAccess,
          profile,
          permissions
        );
      } else {
        toastr.error(
          "You don't have rights to access",
          "Contact mmmooogle.com"
        );
        auth0Service.handleUnauthorized(2000);
      }
    }

    function authorizePermissionsTeams(teams, profile, permissions) {
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 365);
      permissionService.teams = teams;
      var cookie;
      var cookies = $cookies.getAll();
      Object.keys(cookies).forEach(function (key) {
        if (key == profile.email) {
          cookie = JSON.parse(cookies[key]);
        }
      });

      if (cookie && cookie.team_id) {
        if (cookie.filterDH == null || cookie.filterDH == undefined) {
          cookie.filterDH = true;
        }
        var has_team_permission = false;
        var team_with_permission = {};
        for (var i = 0; i < teams.length; i++) {
          if (teams[i] == cookie.team_id) {
            has_team_permission = true;
            team_with_permission = teams[i];
            break;
          }
        }
        if (has_team_permission) {
          cookie.herd_ids = [];
          cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
            samesite: "strict",
            expires: expireDate,
          });
          cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
            samesite: "lax",
            //samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
          });
          localStorage.setItem("default_values", JSON.stringify(cookie));
        } else {
          cookie = {
            team_id: teams[0],
            herd_ids: [],
            filterDH: true,
            DNSAL: [],
          };
          cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
            samesite: "strict",
            expires: expireDate,
          });
          localStorage.setItem("default_values", JSON.stringify(cookie));
          cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
            samesite: "lax",
            //samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
          });
        }
      } else {
        cookie = {
          team_id: teams[0],
          herd_ids: [],
          filterDH: true,
        };
        cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
          samesite: "strict",
          expires: expireDate,
        });
        localStorage.setItem("default_values", JSON.stringify(cookie));
        cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
          samesite: "lax",
          //samesite: "none",
          secure: true,
          domain: ".mmmooogle.com",
        });
      }

      var house_style = permissionService.getHouseStyle();
      if (house_style) {
        localStorage.setItem("style", house_style);
        $rootScope.$broadcast("style_changed");
      }

      $timeout(function () {
        $state.go("redirect");
      }, 250);
    }

    function generateTeamsWPTA(permissions) {
      var list = [];
      var spartanList = [];
      // create teams list
      for (var i = 0; i < permissions.length; i++) {
        for (var j = 0; j < permissions[i].Permissions.length; j++) {
          if (permissions[i].Permissions[j] == MYPermission) {
            spartanList.push(permissions[i].TeamId);
          }
        }
      }
      return spartanList;
    }

    $scope.$on("lock_authenticated", function () {});

    function login() {
      authService.login();
    }
  }
})();

(function () {
    'use strict';
    angular.module('My.login').service('authService', authService);
    /** @ngInject */
    function authService( $http, APP_CONSTANTS, $q) {
        return {
            getUserPermissions: getUserPermissions,
            getTeams: getTeams
        }

        function getUserPermissions(){
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'userpermissions').then(success).catch(error);
        }

        function getTeams(){
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams').then(success).catch(error);
        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular.module("My.login-sso").controller("loginSsoCtrl", loginSsoCtrl);
  /** @ngInject */
  function loginSsoCtrl(
    $timeout,
    $state,
    authService,
    $scope,
    permissionService,
    $cookies,
    toastr,
    cookiesService,
    auth0Service,
    $rootScope
  ) {
    var vm = this;
    vm.login = login;
    vm.isCollapsed = true;
    vm.showAuth = false;
    vm.goToLogin = goToLogin;
    var MYPermission = 14;

    init();

    function init() {
      vm.showAuth = true;
      auth0Service.init(true);
      handleAuthentication();
      //lock.show();
    }

    function goToLogin() {
      auth0Service.login(true);
      //lock.show();
    }

    function handleAuthentication() {
      return auth0Service
        .handleAuthentication()
        .then(function (authResult) {
          onAuthenticated(authResult);
        })
        .catch(function (error) {
          console.log(error);
          auth0Service.login(true);
        });
    }

    function onAuthenticated(authResult) {
      vm.loading = true;
      var timeStamp = new Date().getTime();
      localStorage.setItem("authenticated", timeStamp);

      var user = {
        picture: authResult.idTokenPayload.picture,
        email: authResult.idTokenPayload.email,
        name: authResult.idTokenPayload.name,
        user_id: authResult.idTokenPayload.sub,
      };
      localStorage.setItem("access_token", authResult.accessToken);
      localStorage.setItem("user_profile", JSON.stringify(user));
      localStorage.setItem("id_token", authResult.idToken);
      localStorage.setItem("login_type", "sso");
      authorize(authResult.idTokenPayload);
    }

    function authorize(profile) {
      authService
        .getUserPermissions()
        .then(function (response) {
          if (response.IsGlobalAdmin) {
            permissionService.isGlobalAdmin = true;
            getTeams(profile);
          } else {
            permissionService.isGlobalAdmin = false;
            processPermissions(response.Teams, profile);
          }
        })
        .catch(function (error) {
          toastr.error("ERROR", "Please try again.");
          auth0Service.handleUnauthorized(500);
        });
    }

    function getTeams(profile) {
      var permissions = [];
      for (var i = 0; i < 700; i++) {
        permissions.push(i);
      }
      authService
        .getTeams()
        .then(function (response) {
          var teams = [];
          for (var i = 0; i < response.length; i++) {
            var team = {
              TeamId: response[i].Id,
              Permissions: permissions,
            };
            teams.push(team);
          }
          processPermissions(teams, profile);
        })
        .catch(function (error) {
          auth0Service.handleUnauthorized(500);
        });
    }

    //function used for team permission check
    function processPermissions(permissions, profile) {
      var haveMyPermissions = false;
      permissionService.permissions = permissions;
      for (var i = 0; i < permissions.length; i++) {
        for (var j = 0; j < permissions[i].Permissions.length; j++) {
          if (permissions[i].Permissions[j] == MYPermission) {
            haveMyPermissions = true;
            break;
          }
        }
      }
      if (haveMyPermissions) {
        var expireDate = moment();
        expireDate.add(10, "hours");
        expireDate = new Date(expireDate);
        cookiesService.setCookie(
          "mmmooogle_token",
          localStorage.getItem("id_token"),
          {
            samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
            expires: expireDate,
          }
        );
        var teamsWithPermissionToAccess = generateTeamsWPTA(permissions);
        authorizePermissionsTeams(
          teamsWithPermissionToAccess,
          profile,
          permissions
        );
      } else {
        toastr.error(
          "You don't have rights to access",
          "Contact mmmooogle.com"
        );
        auth0Service.handleUnauthorized(2000);
      }
    }

    function authorizePermissionsTeams(teams, profile, permissions) {
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 365);
      permissionService.teams = teams;
      var cookie;
      var cookies = $cookies.getAll();
      Object.keys(cookies).forEach(function (key) {
        if (key == profile.email) {
          cookie = JSON.parse(cookies[key]);
        }
      });
      if (cookie && cookie.team_id) {
        if (cookie.filterDH == null || cookie.filterDH == undefined) {
          cookie.filterDH = true;
        }
        var has_team_permission = false;
        var team_with_permission = {};
        for (var i = 0; i < teams.length; i++) {
          if (teams[i] == cookie.team_id) {
            has_team_permission = true;
            team_with_permission = teams[i];
            break;
          }
        }
        if (has_team_permission) {
          var has_permission = false;
          for (var i = 0; i < permissions.length; i++) {
            if (permissions[i].TeamId == cookie.team_id) {
              for (var j = 0; j < permissions[i].Permissions.length; j++) {
                if (permissions[i].Permissions[j] == 158) {
                  has_permission = true;
                  break;
                }
              }
            }
          }

          if (has_permission) {
            cookie.herd_ids = [];
            cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
              samesite: "strict",
              expires: expireDate,
            });
          }

          cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
            samesite: "lax",
            //samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
          });
          localStorage.setItem("default_values", JSON.stringify(cookie));
        } else {
          cookie = {
            team_id: teams[0],
            herd_ids: [],
            filterDH: true,
            DNSAL: [],
          };
          cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
            samesite: "strict",
            expires: expireDate,
          });
          localStorage.setItem("default_values", JSON.stringify(cookie));
          cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
            samesite: "lax",
            //samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
          });
        }
      } else {
        cookie = {
          team_id: teams[0],
          herd_ids: [],
          filterDH: true,
        };
        cookiesService.setCookie(profile.email, JSON.stringify(cookie), {
          samesite: "strict",
          expires: expireDate,
        });
        localStorage.setItem("default_values", JSON.stringify(cookie));
        cookiesService.setCookie("mmmooogle_tenant", cookie.team_id, {
          samesite: "lax",
          //samesite: "none",
          secure: true,
          domain: ".mmmooogle.com",
        });
      }

      var house_style = permissionService.getHouseStyle();
      if (house_style) {
        localStorage.setItem("style", house_style);
        $rootScope.$broadcast("style_changed");
      }

      $timeout(function () {
        $state.go("redirect");
      }, 250);
    }

    function generateTeamsWPTA(permissions) {
      var list = [];
      var spartanList = [];
      // create teams list
      for (var i = 0; i < permissions.length; i++) {
        for (var j = 0; j < permissions[i].Permissions.length; j++) {
          if (permissions[i].Permissions[j] == MYPermission) {
            spartanList.push(permissions[i].TeamId);
          }
        }
      }
      return spartanList;
    }

    $scope.$on("lock_authenticated", function () {});

    function login() {
      authService.login();
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.oestrus-interval")
    .controller("oestrusIntervalAnalysisCtrl", oestrusIntervalAnalysisCtrl);
  /** @ngInject */
  function oestrusIntervalAnalysisCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;

          if (vm.allDashboards && vm.allDashboards.length) {
            selectDashboard(
              vm.allDashboards[0],
              vm.allDashboards[0].type,
              true
            );
          } else {
            vm.showBaseTable = false;
            vm.showFrame = true;
            vm.dashboardNotAvailable = true;
            vm.embed = null;
            vm.errorLoading = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        response.forEach(function (dashboard) {
          if (dashboard.id == i18nFilter("_z_oestrus_interval_analysis_") && dashboard.subcategory == 'zoetis' ) {
            dashboard.title = dashboard.description;
            list.push(dashboard);
          }
        });

        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;
      for (var i = 0; i < vm.addedToReport.length; i++) {
        if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
          entry = vm.addedToReport[i];
          break;
        }
      }
      handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }
                          if (
                            (filterList.filters[j].n != undefined) &
                            (filterList.filters[j].n != filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else if (
                            filterList.filters[j].n == undefined &&
                            filterList.filters[j].m == undefined
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.name && !filter.name_untranslated) {
              filter.name = i18nFilter(filter.name);
            }
            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
	'use strict';
	angular.module('My.pages.MRO').controller('mroCtrl', mroCtrl);
	/** @ngInject */
	function mroCtrl($timeout, herdDashboardsService, mroService, $q, APP_CONSTANTS, $rootScope, $http, $uibModalStack, $uibModal, $scope, $filter, cookiesService) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var dataDashboardSheetName;
		var viewDataDashboardName;
		var measureNameParam;
		var kpiTableName;
		var mroMarkFilterPairs = APP_CONSTANTS.constants.mroMarkFilterPairs;
		vm.openRangeSelector = openRangeSelector;
		vm.setRange = setRange;
		vm.closeModal = closeModal;
		vm.setRange = setRange;
		vm.goBack = goBack;
		vm.init = init;
		setDates();
		init();

		function init() {
			setStrings();
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			dataDashboardSheetName = $filter('i18n')('_show_all_data_dashboard_name_');
			viewDataDashboardName = $filter('i18n')('_dashboard_name_view_data_');
			herdParamName = 'Herd Parameter';
			measureNameParam = $filter('i18n')('_dashboard_filter_measure_');
			kpiTableName = 'MRO Module KPI table';
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.dashboards = [
				{
					id: 'MROdashboard',
					description: 'MRO dashboard',
					category: 'reproduction',
					subcategory: 'module-mro',
					locale: 'en-GB',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB'
				}
			];
			dashboards.team_id = team_id;
			dashboards.expires = new Date('2100-12-31');*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return mroService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							herdDashboardsService.tableauStored = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var reproDashboardId = $filter('i18n')('_mro_dashboard_id_');
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'module-mro' && response[i].id == reproDashboardId) {
						vm.reproDashboard = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.reproDashboard;
				if (vm.reproDashboard) {
					//local testing
					//embedPage(vm.reproDashboard, false);
					embedPage(vm.reproDashboard, true);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('mroFrame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('mroFrame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard, useTabvis) {
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return mroService
						.setSession(url)
						.then(function (response) {
							vm.loadingDashboards = false;
							vm.showButtons = true;
							var url = response.headers('tabvis-location');
							embed(url, herds, useTabvis);
						})
						.catch(function (response) {
							vm.embed = null;
							vm.errorLoading = true;
							vm.loading = false;
							console.log('error getting tabvis-location header');
						});
				} else {
					if (vm.currentLng == 'en-GB') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_en-GB_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'en-US') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_en-GB_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'fr-FR') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_fr-FR_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'de-DE') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_de-DE_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'nl-NL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_nl-NL_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'pl-PL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-mro_pl-PL_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					}
					embed(url, herds, useTabvis);
				}
			}
		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd'),
					onFirstInteractive: function () {
						/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
							console.log(parameters)
						})*/

						viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					}
				};
				options[herdParamName] = herdParam;
				$timeout(function () {
					var containerDiv = document.getElementById('mroFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarkSelection);
				}, 1000);
			}
		}

		function onMarkSelection(event) {
			vm.lastSelectedMark = event.getWorksheet().getName();
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			oldSheetName = marksEvent.getOldSheetName();
			newSheetName = marksEvent.getNewSheetName();
			vm.lastSheetName = oldSheetName;
			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}
				//console.log(newSheetName)
				//console.log(vm.lastSelectedMark)
				if (newSheetName == viewDataDashboardName) {
					var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
					//console.log(activeFilterName)
					if (vm.lastSelectedMark != kpiTableName) {
						checkFilters(wrks, dataDashboardSheetName, activeFilterName);
					} else {
						checkFilters(wrks, dataDashboardSheetName, 'empty');
					}
					setBackButtonVisibility(true);
				} else if(newSheetName == 'Explore KPI dashboard'){
					setBackButtonVisibility(true, true);
					vm.actionFilterList = [];
				}else {
					viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
			}
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			wrks.get(sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].getFieldName();
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i], sheet_name);
							}
						}
						//console.log('clear', listToClear)
					} else {
						vm.actionFilterList = actionFilterList;
					}
					//console.log('action', vm.actionFilterList)
				});
		}

		function resetFilter(filter, sheet_name) {
			viz.getWorkbook().getActiveSheet().getWorksheets().get(sheet_name).clearFilterAsync(filter);
		}

		function getActiveFilterName(mark) {
			var filter;
			var list = mroMarkFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].mark == mark && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(dataDashboardSheetName)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display, positionRight) {
			
			$timeout(function () {
				vm.showBackButton = display;
				if(positionRight){
					vm.backPositionRight = true;
				}else{
					vm.backPositionRight = false;
				}
			}, 10);
		}

		function openRangeSelector() {
			if (!vm.disableCategoryButtons) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				};
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var end_date = vm.end_date;
			var start_date = vm.start_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook()
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}
		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}
				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						viz.getWorkbook().changeParameterValueAsync(herdParamName, herdParam);
					} else {
						init();
					}
				}
			}, 750);

			//init();
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 100);
		});

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve('cancel_request');
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.MRO').factory('mroService', mroService);
    /** @ngInject */
    function mroService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.overview').controller('overviewCtrl', overviewCtrl);
	/** @ngInject */
	function overviewCtrl(permissionService, $timeout, $sce, herdDashboardsService, overviewService, $rootScope, $q, $http, APP_CONSTANTS, $scope, $state, $uibModal, $uibModalStack, $cookies) {
		var vm = this;
		var timeout;

		var viz;
		var workbook;
		var worksheetName;
		var largeModuleTimer;

		vm.setKpis = setKpis;
		vm.goTo = goTo;
		vm.openMasterTable = openMasterTable;
		vm.closeModal = closeModal;
		vm.openKPIConfig = openKPIConfig;
		vm.saveKpis = saveKpis;
		vm.openMasterKPIConfig = openMasterKPIConfig;
		vm.saveConfig = saveConfig;
		vm.selectFrequency = selectFrequency;
		vm.openLargeView = openLargeView;
		vm.init = init;
		vm.useTableau = false;
		init();

		function init() {
			vm.masterDashboards = [
				{
					id: 'MasterDashboardDay',
					description: 'Master Dashboard Day',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MasterDashboardDay?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MasterDashboardWeek',
					description: 'Master Dashboard Week',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MasterDashboardWeek?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MasterDashboardMonth',
					description: 'Master Dashboard Month',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MasterDashboardMonth?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MasterDashboardQuarter',
					description: 'Master Dashboard Quarter',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MasterDashboardQuarter?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MasterDashboardYear',
					description: 'Master Dashboard Year',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MasterDashboardYear?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MastertableMonthlyDashboard',
					description: 'MastertableMonthlyDashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/reproduction-module-dev/MastertableMonthlyDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MastertableWeeklyDashboard',
					description: 'MastertableWeeklyDashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/reproduction-module-dev/MastertableWeeklyDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MastertableQuarterDashboard',
					description: 'MastertableQuarterDashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/reproduction-module-dev/MastertableQuarterDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'MastertableYearlyDashboard',
					description: 'MastertableYearlyDashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/reproduction-module-dev/MastertableYearlyDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				}
			];

			vm.repoLargeIcon = 'open_in_full';
			vm.productionLargeIcon = 'open_in_full';
			vm.MROLargeIcon = 'open_in_full';
			vm.lactationAnalysisLargeIcon = 'open_in_full';
			vm.presalesAuditLargeIcon = 'open_in_full';
			vm.showLargeProduction = false;
			vm.showLargeReproduction = false;
			vm.showLargeMRO = false;
			vm.showLargeLactationAnalysis = false;
			vm.showLargePresalesAudit = false;
			vm.CHLargeIcon = 'open_in_full';
			vm.showLargeCHealth = false;
			vm.errorLoading = false;
			vm.hideAll = false;
			vm.hide = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.masterKPIFilterValues = angular.copy(APP_CONSTANTS.constants.masterKPIFilterValues);
			vm.defaultMainKPIValues = angular.copy(APP_CONSTANTS.constants.mainKPIDashboards);
			vm.masterKPIFilterValues = getSelectedKPIFilterValues(vm.masterKPIFilterValues);
			vm.frequency = [false, false, true, false, false];
			vm.numberOfPeriods = 12;
			vm.endDate = new Date();
			vm.lastConfig = {
				frequency: angular.copy(vm.frequency),
				endDate: angular.copy(vm.endDate),
				numberOfPeriods: angular.copy(vm.numberOfPeriods),
				dashboardId: 'MastertableMonthlyDashboard'
			};

			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.loading = true;
			checkPermissions();
			getDashboards(vm.selectedTeam);
		}

		function checkPermissions() {
			if (permissionService.can(233)) {
				vm.showReproductionModule = true;
			} else {
				vm.showReproductionModule = false;
			}

			if (permissionService.can(163)) {
				vm.showClawHealthModule = true;
			} else {
				vm.showClawHealthModule = false;
			}

			if (permissionService.can(232)) {
				vm.showProductionModule = true;
			} else {
				vm.showProductionModule = false;
			}

			if (permissionService.can(230)) {
				vm.showMROModule = true;
			} else {
				vm.showMROModule = false;
			}

			if (permissionService.can(229)) {
				vm.showLactationAnalysisModule = true;
			} else {
				vm.showLactationAnalysisModule = false;
			}

			if (permissionService.can(231)) {
				vm.showPresalesAuditModule = true;
			} else {
				vm.showPresalesAuditModule = false;
			}

			if (permissionService.can(235)) {
				vm.showEmergencyWall = true;
			} else {
				vm.showEmergencyWall = false;
			}
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.dashboards = [
				{
					id: 'LatestTrimDateKPIDashboard',
					description: 'Latest Trim Date KPI Dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/LatestTrimDateKPIDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'NumberofLameCowsKPIDashboard',
					description: 'Number of Lame Cows KPI Dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/NumberofLameCowsKPIDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'NumberofTrimmedCowsKPIDashboard',
					description: 'Number of Trimmed Cows KPI Dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/NumberofTrimmedCowsKPIDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'PercentageoftopsixlesionsKPIdashboard',
					description: 'Percentage of top six lesions KPI dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/PercentageoftopsixlesionsKPIdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'DashboardforKPInumberofotherslesions',
					description: 'Dashboard for KPI number of others lesions',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/DashboardforKPInumberofotherslesions?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'KPIdashboardfornumberofDigitalDermatits',
					description: 'KPI dashboard for number of Digital Dermatits',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/KPIdashboardfornumberofDigitalDermatits?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'Clawhealthmoduleoverview',
					description: 'Claw healt hmodule overview',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/Clawhealthmoduleoverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'Homeclawhealthdashboard',
					description: 'Map dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/Homeclawhealthdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'ReproductionModuleOverview',
					description: 'Reproduction Module Overview',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/reproduction-module-param/ReproductionOverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'PregnancyrateonlastdayKPIdashboard',
					description: 'Pregnancy rate on last day KPI dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-reproduction-module_en-GB_twb/PregnancyrateonlastdayKPIdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'DashboardforConceptionratelastmonthKPI',
					description: 'Dashboard for Conception rate lastmonth KPI',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-reproduction-module_en-GB_twb/DashboardforConceptionratelastmonthKPI?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'SomaticCellcountKPIdashboard',
					description: 'Somatic Cellcount KPI dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-reproduction-module_en-GB_twb/SomaticCellcountKPIdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'KPINumberofanimalsonlastdaydashboard',
					description: 'KPI Number of animals on last day dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/KPINumberofanimalsonlastdaydashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'AveragemilkyieldlastmonthKPIdashboard',
					description: 'Average milk yield last month KPI dashboard',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-health-claw-module_en-GB_twb/AveragemilkyieldlastmonthKPIdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet'
				},
				{
					id: 'MilkrecordingparametertablebyAIcompany',
					description: 'Milk recording parameter table by AI company',
					url: 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-recording-genetics_en-GB_twb/MilkrecordingparametertablebyAIcompany?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no'
				},
				{
					id: 'LactationanalysisbyDIMMRO',
					description: 'Milk recording parameter table by AI company',
					subcategory: 'module-lactation-analysis',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=LactationanalysisbyDIMMRO&category=production&subcategory=module-lactation-analysis&locale=en-GB'
				},
				{
					id: 'MROdashboard',
					description: 'Milk recording parameter table by AI company',
					subcategory: 'module-mro',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=MROdashboard&category=production&subcategory=module-mro&locale=en-GB'
				},
				{
					id: 'Milkyield',
					description: 'Milk recording parameter table by AI company',
					subcategory: 'milk-meter-module',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=Milkyield&category=production&subcategory=milk-meter-module&locale=en-GB'
				}
			];

			//herdDashboardsService.tableauStored.dashboards = [];

			herdDashboardsService.tableauStored.team_id = team_id;*/

			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					var suffix = tableauSuffix;
					return overviewService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							herdDashboardsService.tableauStored = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(dashboards) {
			dashboards = dashboards.concat(vm.masterDashboards);
			vm.allDashboards = dashboards;
			vm.defaultMainKPIValues = checkCookie(vm.defaultMainKPIValues);
			vm.mainKPIDashboards = setMainKPIDashboards(vm.allDashboards, vm.defaultMainKPIValues);
			vm.loading = false;
		}

		function setMainKPIDashboards(dashboards, mainKPIs) {
			var list = [];
			for (var i = 0; i < dashboards.length; i++) {
				for (var j = 0; j < mainKPIs.length; j++) {
					if (dashboards[i].id == mainKPIs[j].id) {
						var startEndDate = getStartEndDateByPeriod(mainKPIs[j]);
						var suffix = '&startDate=' + startEndDate.start_date.toISOString() + '&endDate=' + startEndDate.end_date.toISOString();

						if (vm.selectedHerds.length > 0) {
							suffix = suffix + '&herd=';
							for (var k = 0; k < vm.selectedHerds.length; k++) {
								if (k > 0) {
									suffix = suffix + ',';
								}
								suffix = suffix + vm.selectedHerds[k];
							}
						}
						var obj = {
							id: dashboards[i].id,
							trastedUrl: $sce.trustAsResourceUrl(dashboards[i].url + suffix),
							url: dashboards[i].url,
							description: dashboards[i].description,
							selected: mainKPIs[j].selected,
							datePeriod: mainKPIs[j].datePeriod,
							startDate: startEndDate.start_date,
							endDate: startEndDate.end_date,
							iid: mainKPIs[j].iid
						};
						list.push(obj);
					}
				}
			}

			return list;
		}

		function checkCookie(mainKPIs) {
			var cookieName = vm.user.email + '_KPI';
			var cookie = $cookies.getObject(cookieName);
			if (cookie) {
				for (var i = 0; i < mainKPIs.length; i++) {
					for (var j = 0; j < cookie.length; j++) {
						if (mainKPIs[i].iid == cookie[j].iid) {
							mainKPIs[i].selected = cookie[j].selected;
							mainKPIs[i].datePeriod = cookie[j].datePeriod;
							if (mainKPIs[i].datePeriod == 99) {
								mainKPIs[i].startDate = new Date(cookie[j].startDate);
								mainKPIs[i].endDate = new Date(cookie[j].endDate);
							}
						}
					}
				}
			}

			return mainKPIs;
		}

		function getStartEndDateByPeriod(kpi) {
			var obj = {};
			if (kpi.datePeriod == 1) {
				obj.start_date = null;
				obj.end_date = new Date(moment().format());
			} else if (kpi.datePeriod == 2) {
				obj.start_date = new Date(moment().startOf('isoWeek').format());
				obj.end_date = new Date(moment().endOf('isoWeek').format());
			} else if (kpi.datePeriod == 3) {
				obj.start_date = new Date(moment().subtract(1, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().subtract(1, 'weeks').endOf('isoWeek').format());
			} else if (kpi.datePeriod == 4) {
				obj.start_date = new Date(moment().subtract(1, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().endOf('isoWeek').format());
			} else if (kpi.datePeriod == 5) {
				obj.start_date = new Date(moment().subtract(2, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().subtract(1, 'weeks').endOf('isoWeek').format());
			} else if (kpi.datePeriod == 6) {
				obj.start_date = new Date(moment().startOf('month').format());
				obj.end_date = new Date(moment().endOf('month').format());
			} else if (kpi.datePeriod == 7) {
				obj.start_date = new Date(moment().subtract(1, 'months').startOf('month').format());
				obj.end_date = new Date(moment().subtract(1, 'months').endOf('month').format());
			} else if (kpi.datePeriod == 8) {
				obj.start_date = new Date(moment().startOf('quarter').format());
				obj.end_date = new Date(moment().endOf('quarter').format());
			} else if (kpi.datePeriod == 9) {
				obj.start_date = new Date(moment().subtract(1, 'quarters').startOf('quarter').format());
				obj.end_date = new Date(moment().subtract(1, 'quarters').endOf('quarter').format());
			} else if (kpi.datePeriod == 10) {
				obj.start_date = new Date(moment().subtract(5, 'months').startOf('month').format());
				obj.end_date = new Date(moment().endOf('month').format());
			} else if (kpi.datePeriod == 11) {
				obj.start_date = new Date(moment().startOf('year').format());
				obj.end_date = new Date(moment().endOf('year').format());
			} else if (kpi.datePeriod == 12) {
				obj.start_date = new Date(moment().subtract(1, 'years').startOf('year').format());
				obj.end_date = new Date(moment().subtract(1, 'years').endOf('year').format());
			} else if (kpi.datePeriod == 99) {
				if (kpi.startDate && kpi.endDate) {
					obj.start_date = kpi.startDate;
					obj.end_date = kpi.endDate;
				} else {
					obj.start_date = new Date(moment().subtract(1, 'months').format());
					obj.end_date = new Date(moment().format());
				}
			}
			return obj;
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			});
		}

		function closeModal() {
			if (viz) {
				viz.dispose();
			}
			$uibModalStack.dismissAll();
		}

		function openMasterTable(module) {
			if (!vm.loading) {
				vm.module = module;
				vm.lastConfig = setLastConfigDashboardId(vm.lastConfig, module);
				vm.showMasterTable = false;
				if (vm.allDashboards && vm.allDashboards.length) {
					vm.masterDashboard = getUrl(vm.allDashboards, module, vm.lastConfig);
					embedPage(vm.masterDashboard, module);
				} else {
					vm.dashboardNotAvailable = true;
				}

				openModal('app/pages/overview/masterKpi/masterKpi.modal.html', 'lg', 'master-kpi-modal');
			}
		}

		function setLastConfigDashboardId(lastConfig, module) {
			if (module == 'repro') {
				vm.hideDayFrequency = true;
				if (lastConfig.frequency[0]) {
					vm.frequency = [false, false, true, false, false];
					vm.numberOfPeriods = 12;
					lastConfig.frequency = angular.copy(vm.frequency);
					lastConfig.numberOfPeriods = angular.copy(vm.numberOfPeriods);
					lastConfig.dashboardId = 'MastertableMonthlyDashboard';
				} else if (lastConfig.frequency[1]) {
					lastConfig.dashboardId = 'MastertableWeeklyDashboard';
				} else if (lastConfig.frequency[2]) {
					lastConfig.dashboardId = 'MastertableMonthlyDashboard';
				} else if (lastConfig.frequency[3]) {
					lastConfig.dashboardId = 'MastertableQuarterDashboard';
				} else if (lastConfig.frequency[4]) {
					lastConfig.dashboardId = 'MastertableYearlyDashboard';
				}
			} else {
				vm.hideDayFrequency = false;
				if (lastConfig.frequency[0]) {
					lastConfig.dashboardId = 'MasterDashboardDay';
				} else if (lastConfig.frequency[1]) {
					lastConfig.dashboardId = 'MasterDashboardWeek';
				} else if (lastConfig.frequency[2]) {
					lastConfig.dashboardId = 'MasterDashboardMonth';
				} else if (lastConfig.frequency[3]) {
					lastConfig.dashboardId = 'MasterDashboardQuarter';
				} else if (lastConfig.frequency[4]) {
					lastConfig.dashboardId = 'MasterDashboardYear';
				}
			}
			return lastConfig;
		}

		function setMeasureNamesFilter(module) {
			var list = [];
			var filterIds;
			if (module == 'clawHealth') {
				filterIds = ['poflamecows', 'pofdigitaldermatitis'];
			} else if (module == 'repro') {
				filterIds = ['heatinterval', 'inseminationsperpregnancy', 'conceptionrate', 'numberofpregnancies'];
			}

			for (var i = 0; i < vm.masterKPIFilterValues.length; i++) {
				for (var j = 0; j < filterIds.length; j++) {
					if (vm.masterKPIFilterValues[i].id == filterIds[j] && vm.masterKPIFilterValues[i].selected) {
						list.push(vm.masterKPIFilterValues[i].value);
					}
				}
			}

			return list;
		}

		function embedPage(dashboard, module) {
			if (dashboard) {
				vm.dashboardNotAvailable = false;
				if (viz) {
					viz.dispose();
				}

				var freq = getFrequency(vm.lastConfig.frequency);
				var endDate = moment().hour(23).minute(59).seconds(59).millisecond(999).toISOString();
				var startDate = moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(vm.lastConfig.numberOfPeriods, freq).toISOString();

				if (vm.useTableau) {
					return overviewService
						.setSession(dashboard.url)
						.then(function (response) {
							var url = response.headers('tabvis-location');
							if (url) {
								embed(url, startDate, endDate, freq, module);
							}
						})
						.catch(function (error) {
							console.log(error);
						});
				} else {
					var url = dashboard.url;
					if (url) {
						embed(url, startDate, endDate, freq, module);
					}
				}
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function embed(url, startDate, endDate, freq, module) {
			var measureNames;
			measureNames = setMeasureNamesFilter(module);

			url = url + '&:render=true&:refresh=yes';
			var options = {
				device: 'desktop',
				'Start Date': moment(startDate).format('YYYY-MM-DD'),
				'End Date': moment(endDate).format('YYYY-MM-DD'),
				dateFormat: freq,
				//HerdIdentifier: [],
				onFirstInteractive: function () {
					workbook = viz.getWorkbook();
					var wrks = workbook.getActiveSheet().getWorksheets();
					worksheetName;
					for (var i = 0; i < wrks.length; i++) {
						if (wrks[i].getName()) {
							worksheetName = wrks[i].getName();
							break;
						}
					}

					workbook.getParametersAsync().then(function (parameters) {
						console.log(parameters);
					});

					workbook
						.getActiveSheet()
						.getWorksheets()
						.get(worksheetName)
						.getFiltersAsync()
						.then(function (filters) {
							console.log(filters);
						});
				}
			};
			if (measureNames.length && module != 'repro') {
				options['Measure Names'] = measureNames;
			}

			if (vm.selectedHerds.length > 0) {
				var herdParams = [];
				for (var k = 0; k < vm.selectedHerds.length; k++) {
					herdParams.push(vm.selectedHerds[k]);
				}
				options.HerdIdentifier = herdParams;
			}
			vm.showMasterKPI = true;
			$timeout(function () {
				var containerDiv = document.getElementById('masterKPIFrame');
				viz = new tableau.Viz(containerDiv, url, options);
			}, 300);
		}

		function getFrequency(obj) {
			var f;
			if (obj[0]) {
				f = 'day';
			} else if (obj[1]) {
				f = 'week';
			} else if (obj[2]) {
				f = 'month';
			} else if (obj[3]) {
				f = 'quarter';
			} else if (obj[4]) {
				f = 'year';
			}
			return f;
		}

		function selectFrequency(index) {
			for (var i = 0; i < vm.frequency.length; i++) {
				if (i == index) {
					vm.frequency[i] = true;
				} else {
					vm.frequency[i] = false;
				}
			}
		}

		function openMasterKPIConfig() {
			vm.showMasterConfig = true;
			vm.modalLoading = false;
		}

		function saveConfig() {
			var dateError;
			var NPError;
			var freqChanged;
			var SDChanged;
			var EDChanged;
			var startDate;
			var endDate;
			var dateFormat;
			var dFormat;
			var sheetName;

			if (!vm.numberOfPeriods) {
				NPError = true;
				vm.NPError = true;
				removeError('NPError');
			}

			if (!vm.endDate) {
				dateError = true;
				vm.dateError = true;
				removeError('dateError');
			}

			if (vm.frequency[0]) {
				dateFormat = 'day';
				dFormat = 'd';
				sheetName = 'Master Dashboard Day';
			} else if (vm.frequency[1]) {
				dateFormat = 'week';
				dFormat = 'w';
				sheetName = 'Master Dashboard Week';
			} else if (vm.frequency[2]) {
				dateFormat = 'month';
				dFormat = 'M';
				sheetName = 'Master Dashboard Month';
			} else if (vm.frequency[3]) {
				dateFormat = 'quarter';
				dFormat = 'Q';
				sheetName = 'Master Dashboard Quarter';
			} else if (vm.frequency[4]) {
				dateFormat = 'year';
				dFormat = 'y';
				sheetName = 'Master Dashboard Year';
			}

			if (!NPError && !dateError) {
				if (vm.lastConfig.frequency[0] != vm.frequency[0] || vm.lastConfig.frequency[1] != vm.frequency[1] || vm.lastConfig.frequency[2] != vm.frequency[2] || vm.lastConfig.frequency[3] != vm.frequency[3] || vm.lastConfig.frequency[4] != vm.frequency[4]) {
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).toISOString());

					freqChanged = true;
					SDChanged = true;
				}

				if (vm.lastConfig.numberOfPeriods != vm.numberOfPeriods) {
					SDChanged = true;
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).toISOString());
				}

				if (moment(vm.lastConfig.endDate).format('YYYY-MM-DD') != moment(vm.endDate).format('YYYY-MM-DD')) {
					endDate = angular.copy(vm.endDate);
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).toISOString());
					EDChanged = true;
					SDChanged = true;
				}

				vm.lastConfig = {
					frequency: angular.copy(vm.frequency),
					endDate: angular.copy(vm.endDate),
					numberOfPeriods: angular.copy(vm.numberOfPeriods)
				};

				vm.lastConfig = setLastConfigDashboardId(vm.lastConfig, vm.module);

				if (freqChanged) {
					vm.masterDashboard = getUrl(vm.allDashboards, vm.module, vm.lastConfig);
					embedPage(vm.masterDashboard, vm.module);
				} else {
					checkStartEndDate(SDChanged, EDChanged, startDate, endDate);
				}

				function checkStartEndDate(sdc, edc, sd, ed) {
					if (sdc && edc) {
						workbook.changeParameterValueAsync('Start Date', sd).then(function (param) {
							workbook.changeParameterValueAsync('End Date', ed);
						});
					} else if (sdc && !edc) {
						workbook.changeParameterValueAsync('Start Date', sd);
					}
				}

				vm.showMasterConfig = false;
			}
		}

		function saveKpis() {
			var haveSelected;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					haveSelected = true;
					break;
				}
			}

			if (haveSelected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.masterKPIFilterValues.length; j++) {
						if (vm.KPIFilters[i].id == vm.masterKPIFilterValues[j].id) {
							vm.masterKPIFilterValues[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				vm.modalLoading = true;
				$timeout(function () {
					closeModal();
					vm.modalLoading = false;
				}, 500);
			}
		}

		function getSelectedKPIFilterValues(filters) {
			var selectedFilters = ['poflamecows', 'heatinterval'];

			for (var i = 0; i < filters.length; i++) {
				for (var j = 0; j < selectedFilters.length; j++) {
					if (filters[i].id == selectedFilters[j]) {
						filters[i].selected = true;
					}
				}
			}
			return filters;
		}

		function getKPIFiltersByModule(module, filters) {
			filters = angular.copy(filters);
			var modalFilters = [];
			for (var i = 0; i < filters.length; i++) {
				if (module == filters[i].module) {
					modalFilters.push(filters[i]);
				}
			}
			return modalFilters;
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = getKPIFiltersByModule(module, vm.masterKPIFilterValues);
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}
		}

		function getUrl(dashboards, module, lastConfig) {
			var dashboardId;
			dashboardId = lastConfig.dashboardId;
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == dashboardId) {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function setKpis() {
			vm.hideMainKPIS = true;
			vm.mainKPIDashboards = setMainKPIDashboards(vm.allDashboards, vm.mainKPIDashboards);
			$timeout(function () {
				vm.hideMainKPIS = false;
			}, 100);
		}

		function goTo(state) {
			if (!vm.loading) {
				$state.go(state);
			}
		}

		function openLargeView(module) {
			if (!vm.loading) {
				if (largeModuleTimer) {
					$timeout.cancel(largeModuleTimer);
				}
				largeModuleTimer = $timeout(function () {
					if (module == 'reproduction') {
						if (!vm.showLargeCHealth && !vm.showLargeProduction && !vm.showLargeMRO && !vm.showLargeLactationAnalysis && !vm.showLargePresalesAudit) {
							vm.showLargeReproduction = !vm.showLargeReproduction;

							if (vm.showLargeReproduction) {
								vm.repoLargeIcon = 'close_fullscreen';
							} else {
								vm.repoLargeIcon = 'open_in_full';
							}
						}
					} else if (module == 'claw_health') {
						if (!vm.showLargeProduction && !vm.showLargeReproduction && !vm.showLargeMRO && !vm.showLargeLactationAnalysis && !vm.showLargePresalesAudit) {
							vm.showLargeCHealth = !vm.showLargeCHealth;
							if (vm.showLargeCHealth) {
								vm.CHLargeIcon = 'close_fullscreen';
							} else {
								vm.CHLargeIcon = 'open_in_full';
							}
						}
					} else if (module == 'production') {
						if (!vm.showLargeCHealth && !vm.showLargeReproduction && !vm.showLargeMRO && !vm.showLargeLactationAnalysis && !vm.showLargePresalesAudit) {
							vm.showLargeProduction = !vm.showLargeProduction;
							if (vm.showLargeProduction) {
								vm.productionLargeIcon = 'close_fullscreen';
							} else {
								vm.productionLargeIcon = 'open_in_full';
							}
						}
					} else if (module == 'mro') {
						if (!vm.showLargeCHealth && !vm.showLargeReproduction && !vm.showLargeProduction && !vm.showLargeLactationAnalysis && !vm.showLargePresalesAudit) {
							vm.showLargeMRO = !vm.showLargeMRO;
							if (vm.showLargeMRO) {
								vm.MROLargeIcon = 'close_fullscreen';
							} else {
								vm.MROLargeIcon = 'open_in_full';
							}
						}
					} else if (module == 'lactationAnalysis') {
						if (!vm.showLargeCHealth && !vm.showLargeReproduction && !vm.showLargeProduction && !vm.showLargeMRO && !vm.showLargePresalesAudit) {
							vm.showLargeLactationAnalysis = !vm.showLargeLactationAnalysis;
							if (vm.showLargeLactationAnalysis) {
								vm.lactationAnalysisLargeIcon = 'close_fullscreen';
							} else {
								vm.lactationAnalysisLargeIcon = 'open_in_full';
							}
						}
					} else if (module == 'presalesAudit') {
						if (!vm.showLargeCHealth && !vm.showLargeReproduction && !vm.showLargeProduction && !vm.showLargeMRO && !vm.showLargeLactationAnalysis) {
							vm.showLargePresalesAudit = !vm.showLargePresalesAudit;
							if (vm.showLargePresalesAudit) {
								vm.presalesAuditLargeIcon = 'close_fullscreen';
							} else {
								vm.presalesAuditLargeIcon = 'open_in_full';
							}
						}
					}
				}, 500);
			}
		}

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve();
			}
		});

		$scope.$on('default_herd_selected', function () {
			vm.hide = true;
			$timeout(function () {
				init();
			}, 200);
		});
		$scope.$on('default_team_selected', function () {
			vm.hideAll = true;
			vm.teamReselected = true;
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 200);
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.overview').factory('overviewService', overviewService);
	/** @ngInject */
	function overviewService($http, $q, APP_CONSTANTS) {
		return {
			setSession: setSession,
			getDashboards: getDashboards
		}

		function setSession(url) {
			return $http.get(url, {
				withCredentials: true
			}).then(function (response) {
				return response;
			}).catch(function (error) {
				return $q.reject(error);
			});
		}
		
		 function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }

		function success(response) {
			return response.data;
		};

		function error(error) {
			console.log(error)
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.presalesAudit').controller('presalesAuditCtrl', presalesAuditCtrl);
	/** @ngInject */
	function presalesAuditCtrl($timeout, presalesAuditService, $q, APP_CONSTANTS, $rootScope, $http, $scope, $filter, $window, dashboardsService, $location, Upload, $cookies, $uibModal, $uibModalStack, herdDashboardsService) {
		var vm = this;
		var teamTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var dataDashboardSheetName;
		var viewDataDashboardName;
		var measureNameParam;
		var kpiTableName;
		var kpiTableNameResponseKpi;
		var kpiTableNameDPRKpi;
		var dateFilterSheetName;
		var dateFilterName;
		var mapTimeout;
		var presalesAuditFilterPairs = APP_CONSTANTS.constants.presalesAuditFilterPairs;
		vm.goBack = goBack;
		vm.init = init;
		vm.sendErrorInfo = sendErrorInfo;
		vm.closeModal = closeModal;
		init();

		function init() {
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if(!herdDashboardsService.excludeUsers(vm.user)){
				try {
					gtag('event', 'zoetis-presales', {
						user_id: vm.user.user_id
					});
				} catch (error) {
					console.log(error);
				}
			}
			
			vm.currentDate = null;
			setStrings();
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				vm.selectedTeam = vm.defaultValues.team_id;
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			dataDashboardSheetName = $filter('i18n')('_show_all_data_dashboard_name_');
			viewDataDashboardName = $filter('i18n')('_dashboard_name_show_data_');
			herdParamName = 'Herd Parameter';
			measureNameParam = 'Measure name parameter';
			kpiTableName = 'Sires Of Conception Table';
			kpiTableNameResponseKpi = 'Herd Response Milk KPIs';
			dateFilterSheetName = 'Trends navigation worksheet';
			dateFilterName = 'Date';
			kpiTableNameDPRKpi = 'Herd Response DPR KPIs';
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(dashboardsService.loadedDashboards);
			//local testing
			/*dashboards.dashboards = [
				{
					id: $filter('i18n')('_dashboard_id_herd_inventory_'),
					description: 'Production dashboard',
					category: 'reproduction',
					subcategory: 'pre-sales-audit',
					locale: 'en-GB',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB'
				}
			];
			dashboards.team_id = team_id;
			dashboards.expires = new Date('2100-12-31');*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return presalesAuditService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id,
								lng: vm.currentLng
							};
							dashboardsService.loadedDashboards = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var presalesAuditId = $filter('i18n')('_dashboard_id_herd_inventory_');
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'pre-sales-audit' && response[i].id == presalesAuditId) {
						vm.presalesAudit = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.presalesAudit;
				if (vm.presalesAudit) {
					embedPage(vm.presalesAudit, true);
					//local testing
					//embedPage(vm.presalesAudit, false);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('presalesAuditFrame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('presalesAuditFrame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard, useTabvis) {
			sendShowPanicButtonEvent(false);
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return presalesAuditService
						.setSession(url)
						.then(function (response) {
							vm.loadingDashboards = false;
							vm.showButtons = true;
							var url = response.headers('tabvis-location');
							embed(url, herds, useTabvis);
						})
						.catch(function (response) {
							vm.embed = null;
							vm.errorLoading = true;
							vm.loading = false;
							console.log('error getting tabvis-location header');
						});
				} else {
					if (vm.currentLng == 'en-GB') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_en-GB_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'en-US') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_en-US_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'fr-FR') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_fr-FR_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'de-DE') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_de-DE_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'nl-NL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_nl-NL_twb/Bedrijfsoverzicht?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'pl-PL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_pl-PL_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					}
					embed(url, herds, useTabvis);
				}
			}
		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					onFirstInteractive: function () {
						/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
								console.log(parameters)
							})*/
						var wrks = viz.getWorkbook().getActiveSheet().getWorksheets();
						viz.getWorkbook()
							.changeParameterValueAsync(measureNameParam, '0')
							.then(function (param) {
								wrks.get(dateFilterSheetName)
									.getFiltersAsync()
									.then(function (filters) {
										var date = filters.get(dateFilterName).getDomainMax().value;
										$timeout(function () {
											vm.currentDate = $filter('date')(new Date(date), 'shortDate');
										}, 0);
									});
							});

						$timeout(function () {
							sendShowPanicButtonEvent(true);
						}, 100);
					}
				};
				options[herdParamName] = herdParam;

				$timeout(function () {
					var containerDiv = document.getElementById('presalesAuditFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarkSelection);
				}, 1000);
			}
		}

		function onMarkSelection(event) {
			vm.lastSelectedMark = event.getWorksheet().getName();
			var wsName = event.getWorksheet().getName();
			if (wsName == 'Heifers' || wsName == 'Herd') {
				viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
			}
		}

		function createHerdParam(herds) {
			var herdsString = '';
			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			oldSheetName = marksEvent.getOldSheetName();
			newSheetName = marksEvent.getNewSheetName();
			vm.lastSheetName = oldSheetName;
			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}

				if (newSheetName == viewDataDashboardName) {
					var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
					//console.log(vm.lastSelectedMark);
					//console.log(activeFilterName);
					if (vm.lastSelectedMark != kpiTableName && vm.lastSelectedMark != kpiTableNameResponseKpi && vm.lastSelectedMark != kpiTableNameDPRKpi) {
						checkFilters(wrks, dataDashboardSheetName, activeFilterName);
					} else {
						checkFilters(wrks, dataDashboardSheetName, 'empty');
					}
					setBackButtonVisibility(true);
				} else {
					viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
					console.log(parameters)
				})
				viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
					console.log(filter)
				})*/
			}
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			wrks.get(sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].getFieldName();
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i]);
							}
						}
						//console.log('clear', listToClear);
					} else {
						vm.actionFilterList = actionFilterList;
					}

					//console.log('action', vm.actionFilterList);
				});
		}

		function resetFilter(filter) {
			viz.getWorkbook().getActiveSheet().getWorksheets().get(dataDashboardSheetName).clearFilterAsync(filter);
		}

		function getActiveFilterName(mark) {
			var filter;
			var list = presalesAuditFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].mark == mark && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(dataDashboardSheetName)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function setHerdParameter(param, value) {
			var control = 0;
			set(param, value);
			function set(parameter, herdValue) {
				if (control < 6) {
					try {
						viz.getWorkbook().changeParameterValueAsync(parameter, herdValue);
					} catch (error) {
						console.log('try again to set parameter');
						control++;
						$timeout(function () {
							set(parameter, herdValue);
						}, 500);
					}
				} else {
					console.log('reinitialize');
					init();
				}
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function sendErrorInfo(comment) {
			if (viz) {
				vm.errorInfo = {
					sheet: '',
					comment: comment,
					herds: vm.selectedHerds,
					team: vm.selectedTeam,
					mmmooogle_tenant: null,
					parameters: [],
					filters: [],
					user_id: vm.user.user_id,
					host: $location.host(),
					url: $location.url(),
					last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : '/',
					dashboard: 'Pre Sales',
					last_sheet_name: vm.lastSheetName ? vm.lastSheetName : '/'
				};
				vm.modalError = false;
				vm.modalLoading = true;
				var parameters;
				var filters;
				var p = $q.defer();
				var f = $q.defer();

				var cookies = $cookies.getAll();
				angular.forEach(cookies, function (value, key) {
					if (key == 'mmmooogle_tenant') {
						vm.errorInfo.mmmooogle_tenant = value;
					}
				});

				$q.all([p.promise, f.promise])
					.then(function (response) {
						var p_list = [];
						var f_list = [];

						if (parameters) {
							for (var i = 0; i < parameters.length; i++) {
								var obj = {
									name: null,
									value: null,
									formated_value: null
								};

								obj.name = parameters[i].getName();
								obj.value = parameters[i].getCurrentValue().value;
								obj.formated_value = parameters[i].getCurrentValue().formattedValue;

								p_list.push(obj);
							}
						}

						if (filters) {
							for (var i = 0; i < filters.length; i++) {
								var type = filters[i].getFilterType();
								var obj = {
									name: null,
									value: null
								};
								if (type == 'categorical') {
									obj.name = filters[i].getFieldName();
									obj.value = filters[i].getAppliedValues();
								} else if (type == 'quantitative') {
									obj.name = filters[i].getFieldName();
									obj.value = {
										d_max: filters[i].getDomainMax(),
										d_min: filters[i].getDomainMin(),
										max: filters[i].getMax(),
										min: filters[i].getMin()
									};
								} else {
									obj.name = filters[i].getFieldName();
									obj.value = {
										period: filters[i].getDomainMax(),
										range: filters[i].getRange(),
										rangeN: filters[i].getRangeN()
									};
								}
								f_list.push(obj);
							}
						}
						vm.errorInfo.parameters = p_list;
						vm.errorInfo.filters = f_list;

						var json = JSON.stringify(vm.errorInfo);
						var blob = new Blob([json], {
							type: 'application/json'
						});

						var file_name = vm.errorInfo.user_id.replaceAll('|', '_') + '_' + vm.errorInfo.team + '.json';
						var file = Upload.rename(blob, file_name);

						$timeout(function () {
							Upload.upload({
								url: 'https://io.mmmooogle.com/api/v1/files/upload?path=panic-button',

								data: {
									files: file
								}
							})
								.then(function (response) {
									$rootScope.$broadcast('panic_button_success');
								})
								.catch(function (error) {
									console.log(error);
									$rootScope.$broadcast('panic_button_error');
								});
						}, 500);
					})
					.catch(function (error) {
						console.log(error);
					});

				$timeout(function () {
					if (!parameters) {
						p.resolve();
					}
					if (!filters) {
						f.resolve();
					}
				}, 3000);
				var wb = viz.getWorkbook();
				wb.getParametersAsync().then(function (_parameters) {
					parameters = _parameters;
					p.resolve();
				});

				var a_sheet = wb.getActiveSheet();
				vm.errorInfo.sheet = a_sheet.getName();
				var wrks = a_sheet.getWorksheets();

				var worksheetName;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName()) {
						worksheetName = wrks[i].getName();
						break;
					}
				}

				wrks.get(worksheetName)
					.getFiltersAsync()
					.then(function (_filters) {
						filters = _filters;
						f.resolve();
					});
			} else {
				vm.modalError = true;
			}
		}

		function sendShowPanicButtonEvent(event) {
			if (event) {
				$rootScope.$broadcast('show_panic_button');
			} else {
				$rootScope.$broadcast('hide_panic_button');
			}
		}
		$scope.$on('send_error_info', function (event, data) {
			if (data.state == 'presalesAudit') {
				sendErrorInfo(data.comment);
			}
		});

		function gtag() {
			$window.dataLayer = $window.dataLayer || [];
			dataLayer.push(arguments);
		}

		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}
				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						setHerdParameter(herdParamName, herdParam);
					} else {
						init();
					}
				}
				sendShowPanicButtonEvent(true);
			}, 750);
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 100);
		});

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve('cancel_request');
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.presalesAudit').factory('presalesAuditService', presalesAuditService);
    /** @ngInject */
    function presalesAuditService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.production').controller('productionCtrl', productionCtrl);
	/** @ngInject */
	function productionCtrl($timeout, herdDashboardsService, productionService, $q, APP_CONSTANTS, $rootScope, $http, $uibModalStack, $uibModal, $scope, $filter) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var dataDashboardSheetName;
		var viewDataDashboardName;
		var measureNameParam;
		var kpiTableName;
		var productionMarkFilterPairs = APP_CONSTANTS.constants.productionMarkFilterPairs;
		vm.openRangeSelector = openRangeSelector;
		vm.setRange = setRange;
		vm.closeModal = closeModal;
		vm.setRange = setRange;
		vm.goBack = goBack;
		vm.init = init;
		setDates();
		init();

		function init() {
			setStrings();
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			dataDashboardSheetName = $filter('i18n')('_show_all_data_dashboard_name_');
			viewDataDashboardName = $filter('i18n')('_dashboard_name_view_data_');
			herdParamName = 'Herd Parameter';
			measureNameParam = 'Measure name parameter';
			kpiTableName = 'Home dashboard KPI table';
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.dashboards = [
				{
					id: 'Milkyielddashboard',
					description: 'Production dashboard',
					category: 'production',
					subcategory: 'milk-meter-module',
					locale: 'en-GB',
					url: 'https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB'
				}
			];
			dashboards.team_id = team_id;
			dashboards.expires = new Date('2100-12-31');*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return productionService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							herdDashboardsService.tableauStored = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var productionDashboardId =  $filter('i18n')('_milk_meter_dashboard_id_');
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'milk-meter-module' && response[i].id == productionDashboardId) {
						vm.productionDashboard = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.productionDashboard;
				if (vm.productionDashboard) {
					embedPage(vm.productionDashboard, true)
					//local testing
					//embedPage(vm.productionDashboard, false);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('productionFrame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('productionFrame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard, useTabvis) {
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return productionService
						.setSession(url)
						.then(function (response) {
							vm.loadingDashboards = false;
							vm.showButtons = true;
							var url = response.headers('tabvis-location');
							embed(url, herds, useTabvis);
						})
						.catch(function (response) {
							vm.embed = null;
							vm.errorLoading = true;
							vm.loading = false;
							console.log('error getting tabvis-location header');
						});
				} else {
					if (vm.currentLng == 'en-GB') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_en-GB_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'en-US') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_en-US_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'fr-FR') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_fr-FR_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'de-DE') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_de-DE_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'nl-NL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_nl-NL_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'pl-PL') {
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-122-production-milk-meter-module_pl-PL_twb/Milkyielddashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					}
					embed(url, herds, useTabvis);
				}
			}
		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd'),
					onFirstInteractive: function () {
						/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
							console.log(parameters)
						})*/
						viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					}
				};
				options[herdParamName] = herdParam;

				$timeout(function () {
					var containerDiv = document.getElementById('productionFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarkSelection);
				}, 1000);
			}
		}

		function onMarkSelection(event) {
			vm.lastSelectedMark = event.getWorksheet().getName();
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			oldSheetName = marksEvent.getOldSheetName();
			newSheetName = marksEvent.getNewSheetName();
			vm.lastSheetName = oldSheetName;
			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}

				if (newSheetName == viewDataDashboardName) {
					//console.log(vm.lastSelectedMark)
					var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
					//console.log(activeFilterName)
					if (vm.lastSelectedMark != kpiTableName) {
						checkFilters(wrks, dataDashboardSheetName, activeFilterName);
					} else {
						checkFilters(wrks, dataDashboardSheetName, 'empty');
					}

					setBackButtonVisibility(true);
				} else {
					viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
					console.log(parameters)
				})
				viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
					console.log(filter)
				})*/
			}
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			wrks.get(sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].getFieldName();
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i], sheet_name);
							}
						}
						//console.log('clear', listToClear)
					} else {
						vm.actionFilterList = actionFilterList;
					}
					//console.log('action', vm.actionFilterList)
				});
		}

		function resetFilter(filter, sheet_name) {
			viz.getWorkbook().getActiveSheet().getWorksheets().get(sheet_name).clearFilterAsync(filter);
		}

		function getActiveFilterName(mark) {
			var filter;
			var list = productionMarkFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].mark == mark && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(dataDashboardSheetName)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function openRangeSelector() {
			if (!vm.disableCategoryButtons) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				};
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var end_date = vm.end_date;
			var start_date = vm.start_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook()
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}
		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}
				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						viz.getWorkbook().changeParameterValueAsync(herdParamName, herdParam);
					} else {
						init();
					}
				}
			}, 750);
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 100);
		});

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve('cancel_request');
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.production').factory('productionService', productionService);
    /** @ngInject */
    function productionService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.rap').controller('rapCtrl', rapCtrl);
	/** @ngInject */
	function rapCtrl($timeout, rapService, $state, $scope, herdDashboardsService, $rootScope, $http, $cookies, $filter, $uibModal, $uibModalStack, $q, APP_CONSTANTS, $interval, toastr, cookiesService) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var viz;
		var workbook;
		var fatParam = $filter('number')(4.3, 2);
		var proteinParam = $filter('number')(3.4, 2);
		var resetAllParities;
		var fatChanged;
		var TMRchanged;
		var TMR;
		var DryMatterChanged;
		var DryMatter;
		var proteinChanged;
		var herdsPromise;
		var dashboardsPromise;
		var addToReportPromise;
		var i18nFilter = $filter('i18n');
		var timeout;
		var loadingDotsCounter = 0;
		var loadingDotsInterval;
		var parityPromise;
		var groupByPromise;
		var groupByMetricPromise;
		var DIMPromise;
		var dayPromise;
		var feedNamePromise;
		var fatParamName;
		var proteinParamName;
		var tmrParamName;
		var dmParamName;
		var oldName;
		var newName;
		var parityFilter;
		var DIMCategoryFilterName;
		var dayFilterName;
		var filterName;
		var milkYieldActual;
		var sppActual;
		var concentrateActualByYield;
		var concentrateActualByFeed;
		var herdPrestationsActual;
		var leftoversActual;
		var leftoversActualTable;
		var leftoversActualMilkSpeed;
		var milkingsActual;
		var milkMilkingsActual;
		var feedNameFilter;
		var concActualByMilk;
		var milkYieldActualByDate;
		var sppActualByDate;
		var milkingsActualByDate;
		var milkMilkingsActualByDate;
		var concentrateActualByYieldByDate;
		var concentrateActualByFeedByDate;
		var leftoversActualByDate;
		var robotPrestations;
		var robotPrestationsTrend;
		var groupByParam;
		var groupByMetric;
		var legend;
		var refusals;
		var failures;
		var milkingTime;
		var milkingTimePercentage;
		var freeTime;
		var freeTimePercentage;
		var avgMilkingSpeed;
		var maxMilkingSpeed;
		var sheetNameList = APP_CONSTANTS.constants.sheetNamePairsRAP;
		vm.goToState = goToState;
		vm.setActiveMap = setActiveMap;
		vm.hideButtons = hideButtons;
		vm.openRangeSelector = openRangeSelector;
		vm.closeModal = closeModal;
		vm.setRange = setRange;
		vm.setReportData = setReportData;
		vm.openCreateReport = openCreateReport;
		vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
		vm.openReportDashboardDayModal = openReportDashboardDayModal;
		vm.setReportDashboardRange = setReportDashboardRange;
		vm.openReportCommentModal = openReportCommentModal;
		vm.setReportDashboardComment = setReportDashboardComment;
		vm.addToReport = addToReport;
		vm.openAddToReportModal = openAddToReportModal;
		vm.setReportDate = setReportDate;
		vm.closeCreateReport = closeCreateReport;
		vm.reportSelected = reportSelected;
		vm.init = init;
		vm.showStartEndDate = showStartEndDate;
		vm.setActualReportDate = setActualReportDate;
		vm.hideMissingDataMessage = hideMissingDataMessage;
		setStrings();
		setDates();
		setDashboardIdList();
		init();

		function setStrings() {
			fatParamName = i18nFilter('_dashboard_filter_fat_');
			proteinParamName = i18nFilter('_dashboard_filter_protein_');
			tmrParamName = i18nFilter('_dashboard_filter_TMR_concentrate_');
			dmParamName = i18nFilter('_dashboard_filter_dry_matter_');
			oldName = i18nFilter('_dashboard_name_rap_main_herd_overview_');
			newName = i18nFilter('_dashboard_name_rap_herd_dashboard_');
			parityFilter = i18nFilter('_dashboard_name_filter_parity_');
			filterName = i18nFilter('_dashboard_name_filter_');
			milkYieldActual = i18nFilter('_dashboard_name_milk_yield_actual_');
			sppActual = i18nFilter('_dashboard_name_spp_actual_');
			concentrateActualByYield = i18nFilter('_dashboard_name_conc_actual_yield_');
			concentrateActualByFeed = i18nFilter('_dashboard_name_conc_actual_feed_');
			herdPrestationsActual = i18nFilter('_dashboard_name_herd_prestations_actual_');
			leftoversActual = i18nFilter('_dashboard_name_leftovers_actual_');
			leftoversActualTable = i18nFilter('_dashboard_name_leftovers_actual_table_');
			leftoversActualMilkSpeed = i18nFilter('_dashboard_name_leftovers_actual_milk_speed_');
			milkingsActual = i18nFilter('_dashboard_name_milkings_actual_');
			milkMilkingsActual = i18nFilter('_rap_workbook_name_milk_milkings_actual_');
			feedNameFilter = i18nFilter('_dashboard_name_filter_feed_name_');
			concActualByMilk = i18nFilter('_rap_workbook_name_concentrate_actual_by_milk_production_');
			milkYieldActualByDate = i18nFilter('_dashboard_name_milk_yield_actual_by_date_');
			sppActualByDate = i18nFilter('_dashboard_name_spp_actual_by_date_');
			milkingsActualByDate = i18nFilter('_dashboard_name_milkings_actual_by_date_');
			milkMilkingsActualByDate = i18nFilter('_rap_workbook_name_milk_milkings_actual_by_date_');
			concentrateActualByYieldByDate = i18nFilter('_dashboard_name_conc_actual_yield_by_date_');
			concentrateActualByFeedByDate = i18nFilter('_dashboard_name_conc_actual_feed_by_date_');
			leftoversActualByDate = i18nFilter('_dashboard_name_leftovers_actual_by_date_');
			resetAllParities = i18nFilter('_rap_reset_all_parities_');
			groupByParam = i18nFilter('_dashboard_name_parameter_group_by_');
			groupByMetric = i18nFilter('_dashboard_name_mark_group_by_metric_');
			legend = i18nFilter('_rap_workbook_name_legend_');
			DIMCategoryFilterName = i18nFilter('_dashboard_name_parameter_dim_category_');
			dayFilterName = i18nFilter('_dashboard_name_parameter_date_');
			robotPrestations = i18nFilter('_dashboard_name_robot_prestations_dashboard_');
			robotPrestationsTrend = i18nFilter('_dashboard_name_robot_prestations_trend_dashboard_');
			refusals = i18nFilter('_animal_details_refusal_');
			failures = i18nFilter('_animal_details_failures_');
			milkingTime = i18nFilter('_rap_milking_time_');
			milkingTimePercentage = i18nFilter('_rap_milking_time_percentage_');
			freeTime = i18nFilter('_rap_free_time_');
			freeTimePercentage = i18nFilter('_rap_free_time_percentage_');
			avgMilkingSpeed = i18nFilter('_rap_average_milking_speed_');
			maxMilkingSpeed = i18nFilter('_rap_max_milking_speed_');
		}

		function setDashboardIdList() {
			var dashboardIdList = angular.copy(APP_CONSTANTS.constants.dashboardIdList);
			for (var i = 0; i < dashboardIdList.length; i++) {
				dashboardIdList[i].name = i18nFilter(dashboardIdList[i].name);
				dashboardIdList[i].id = i18nFilter(dashboardIdList[i].id);
			}
			vm.dashboardIdList = dashboardIdList;
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(2, 'days'));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(32, 'days').toISOString());
			vm.actual_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(9, 'days').toISOString());
			vm.init_start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(32, 'days').toISOString());
		}

		function init() {
			vm.showCreateReportButton = false;
			vm.disableRangeSelector = true;
			vm.actualDashboardOpen = false;
			vm.showCreateReportBlock = false;
			vm.reportError = false;
			vm.showActualCurrentDateMessage = false;
			vm.showMissingDataMessage = false;
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if(lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ'){
					vm.currentLng = 'en-GB';
				}else{
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.team_id = team_id;
			dashboards.dashboards = [{
				"id": "RAPMainherdoverview",
				"description": "RAP Main herd overview",
				"category": "production",
				"subcategory": "rap-fame-v3",
				"locale": "en-GB",
				"url": "https://tabvis-dev.mmmooogle.com/dashboard?id=RAPMainherdoverview&category=production&subcategory=rap-fame-v3&locale=en-GB"
			}, {
				"id": "RAPHauptherdenbersicht",
				"description": "RAP Hauptherdenübersicht",
				"category": "production",
				"subcategory": "rap-fame-v3",
				"locale": "de-DE",
				"url": "https://tabvis-dev.mmmooogle.com/dashboard?id=RAPHauptherdenbersicht&category=production&subcategory=rap-fame-v3&locale=de-DE"
			}];*/


			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(function (data) {
				var tableauSuffix = '?locale=' + vm.currentLng;
				return rapService.getDashboards(team_id, tableauSuffix).then(function (response) {
					var obj = {
						dashboards: response,
						expires: moment().add(30, 'minutes').format(),
						team_id: team_id
					}
					herdDashboardsService.tableauStored = obj;
					localStorage.removeItem('tableauLoading');
					$rootScope.$broadcast('tableau_loaded');
					processDashboards(response);
				}).catch(function (error) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				})
			}, function (error) {
				console.log(error)
				if (!vm.teamReselected) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				} else {
					vm.teamReselected = false;
				}

			});
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession, url = APP_CONSTANTS.tableau_base_url + team_id + '/session'
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response) {
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'rap-fame-v3' && (response[i].id == 'RAPMainherdoverview' || response[i].id == 'RAPHoofdoverzicht' || response[i].id == 'AperugnraldutroupeauRAP' || response[i].id == 'RAPHauptherdenbersicht')) {
						dashboards.push(response[i]);
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.dashboards[0];
				if (vm.dashboards[0]) {
					embedPage(vm.dashboards[0]);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0)
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function hideButtons() {
			vm.showButtons = !vm.showButtons
		}

		function goToState(state) {
			$state.go(state);
		}

		function setActiveMap(dashboard) {
			vm.mapActive = dashboard;
			embedPage(dashboard);
		}
		//set dashboard date range
		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.actualDashboardOpen, vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				if (vm.actualDashboardOpen) {
					vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').toISOString());
					vm.start_date = angular.copy(vm.actual_start_date);
					vm.init_start_date = new Date(moment(vm.end_date).subtract(30, 'days').hour(0).minute(0).seconds(1).millisecond(1).toISOString());
					start_date_changed = true;
					var dates = {
						start_date: vm.start_date,
						end_date: vm.end_date
					}
					cookiesService.setCookie('rap_actual_dates', JSON.stringify(dates), {
						samesite: "lax",
						domain: ".mmmooogle.com"
					});
				} else {
					vm.init_start_date = angular.copy(vm.start_date);
					vm.actual_start_date = new Date(moment(vm.end_date).subtract(7, 'days').hour(0).minute(0).seconds(1).millisecond(1).toISOString());
				}
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
					vm.showActualCurrentDateMessage = false;
				}
				closeModal();
			}
		}

		function setReportDashboardRange() {
			var range_error = checkRangeError(vm.selectedReportDashboard.actual, vm.report_modal_start_date, vm.report_modal_end_date);
			if (!range_error) {
				vm.setRangeModalLoading = true;
				if (vm.selectedReportDashboard.entry_id) {
					var end_date = moment(vm.report_modal_end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
					if (vm.selectedReportDashboard.actual) {
						var start_date = moment(vm.report_modal_end_date).subtract(7, 'days').hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
					} else {
						var start_date = moment(vm.report_modal_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
					}
					var obj = {
						id: vm.selectedReportDashboard.entry_id,
						comment: vm.selectedReportDashboard.comment,
						endDate: end_date,
						startDate: start_date,
						locale: vm.selectedReportDashboard.locale,
						dashboardId: vm.selectedReportDashboard.id,
						filter: vm.selectedReportDashboard.filter
					}
					return rapService.updateReportEntry(obj.id, obj).then(function (response) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
						if (vm.selectedReportDashboard.actual) {
							vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
						} else {
							vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
						}
						closeModal();
					}).catch(function (error) {
						console.log(error);
						vm.setRangeModalLoading = false;
					})
				} else {
					vm.reportDashboards[vm.selectedReportDashboardIndex].end_date = vm.report_modal_end_date;
					if (vm.selectedReportDashboard.actual) {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = new Date(moment(vm.report_modal_end_date).subtract(7, 'days'));
					} else {
						vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_start_date;
					}
					closeModal();
				}
			}
		}

		function setActualReportDate() {
			vm.setDateModalLoading = true;
			if (vm.selectedReportDashboard.entry_id) {
				var obj = {
					id: vm.selectedReportDashboard.entry_id,
					comment: vm.selectedReportDashboard.comment,
					endDate: vm.selectedReportDashboard.end_date,
					startDate: vm.selectedReportDashboard.start_date,
					locale: vm.selectedReportDashboard.locale,
					dashboardId: vm.selectedReportDashboard.id,
					filter: changeDateFilter(vm.selectedReportDashboard.filter, vm.report_modal_date)
				}
				return rapService.updateReportEntry(obj.id, obj).then(function (response) {
					vm.reportDashboards[vm.selectedReportDashboardIndex].report_date = vm.report_modal_date;
					vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_date;

					closeModal();
				}).catch(function (error) {
					console.log(error);
					vm.setDateModalLoading = false;
				})
			} else {
				vm.reportDashboards[vm.selectedReportDashboardIndex].filter = "&" + dayFilterName + "=" + moment(vm.report_modal_date).format('YYYY-MM-DD');
				vm.reportDashboards[vm.selectedReportDashboardIndex].report_date = vm.report_modal_date;
				vm.reportDashboards[vm.selectedReportDashboardIndex].start_date = vm.report_modal_date;
				closeModal();
			}
		}

		function changeDateFilter(filter, date) {
			var regex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
			date = moment(date).format("YYYY-MM-DD");
			filter = filter.replace(regex, date);
			return filter;
		}

		function checkRangeError(actual_open, start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (!actual_open) {
				if (moment(end_date).isBefore(start_date)) {
					error = true;
				}
			}
			return error;
		}

		function applyParameters(start_date_changed, end_date_changed) {
			var start_date;
			var end_date = vm.end_date;
			if (vm.actualDashboardOpen) {
				start_date = vm.init_start_date;
			} else {
				start_date = vm.start_date;
			}
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync('End Date', end_date).then(function (param) {
							var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
							if (worksheetName) {
								viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
									for (var i = 0; i < filter.length; i++) {
										var name = filter[i].getFieldName();
										var lastMilkDayFilter;
										if (name.indexOf("(lastDate)") != -1) {
											lastMilkDayFilter = name;
										}
									}
									if (lastMilkDayFilter) {
										var filter_values = filter.get(lastMilkDayFilter);
										if (filter_values) {
											var last_date = filter_values.getDomainMax();
											last_date = last_date.value;
											checkLastMilkDate(last_date);
										}
									}
								})
							}
						})
					})
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date).then(function (param) {
						var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
						if (worksheetName) {
							viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
								for (var i = 0; i < filter.length; i++) {
									var name = filter[i].getFieldName();
									var lastMilkDayFilter;
									if (name.indexOf("(lastDate)") != -1) {
										lastMilkDayFilter = name;
									}
								}
								if (lastMilkDayFilter) {
									var filter_values = filter.get(lastMilkDayFilter);
									if (filter_values) {
										var last_date = filter_values.getDomainMax();
										last_date = last_date.value;
										checkLastMilkDate(last_date);
									}
								}
							})
						}
					})
				}
			}
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			})
		}

		function openRangeSelector() {
			if (!vm.disableRangeSelector) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function embedPage(dashboard) {
			vm.disableRangeSelector = true;
			vm.showActualCurrentDateMessage = false;
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.currentSheet = getDashboardIdByName(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			var start_date_suffix = '&startDate=' + vm.start_date.toISOString();
			var end_date_suffix = '&endDate=' + vm.end_date.toISOString();
			url = url + start_date_suffix + end_date_suffix;
			//chek if user is 'forfarmers'
			// if true use Tableau JS API
			// if false just embed page
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedForFarmers(url);
		}

		function embedForFarmers(url) {
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (vm.selectedHerds.length > 0) {
				vm.herdIdentifierFilterUsed = true;
				url = url + '&herd=';
				for (var i = 0; i < vm.selectedHerds.length; i++) {
					if (i > 0) {
						url = url + ',';
					}
					url = url + vm.selectedHerds[i];
				}
			} else {
				vm.herdIdentifierFilterUsed = false;
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.removeEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE);
				viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
				viz.dispose();
			}
			//call used to set session and to fetch internal url
			//comment out for local testing
			return rapService.setSession(url).then(function (response) {
				vm.loadingDashboards = false;
				vm.showButtons = true;
				var url = response.headers('tabvis-location');
				//local testing

				//var url = "https://visual-prd.mmmooogle.com/t/Production/views/team-249-production-rap-fame-v3_en-GB_twb/RAPMainherdoverview?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				//var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-249-production-rap-fame-v3_en-US_twb/RAPMainherdoverview?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				// de
				//var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-249-production-rap-fame-v3_de-DE_twb/RAPHauptherdenbersicht?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				// fr
				//var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-249-production-rap-fame-v3_fr-FR_twb/AperugnraldutroupeauRAP?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				// nl
				//var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-249-production-rap-fame-v3_nl-NL_twb/RAPHoofdoverzicht?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				// us
				//var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-249-production-rap-fame-v3_en-US_twb/RAPMainherdoverview?Start%20Date=" + $filter('date')(vm.start_date, "yyyy-MM-dd") + "&End%20Date=" + $filter('date')(vm.end_date, "yyyy-MM-dd") + "&:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no"

				if (url) {
					url = url + '&:render=true&:refresh=yes';
					var options = {
						"herd param": 0,
						device: deviceType,
						onFirstInteractive: function () {
							$timeout(function () {
								vm.disableRangeSelector = false;
								vm.disableAddToReport = false;
								vm.showMissingDataMessage = false;
							}, 100)
							workbook = viz.getWorkbook();
							var wrks = workbook.getActiveSheet().getWorksheets();
							var worksheetName;
							for (var i = 0; i < wrks.length; i++) {
								if (wrks[i].getName()) {
									worksheetName = wrks[i].getName();
									break;
								}
							}
							workbook.getParametersAsync().then(function (parameters) {
								for (var i = 0; i < parameters.length; i++) {
									if (parameters[i].getName() == fatParamName) {
										if (parameters[i].getCurrentValue().formattedValue != fatParam) {
											workbook.changeParameterValueAsync(fatParamName, $filter('number')(4.3));
										}
									}
									if (parameters[i].getName() == proteinParamName) {
										if (parameters[i].getCurrentValue().formattedValue != proteinParam) {
											workbook.changeParameterValueAsync(proteinParamName, $filter('number')(3.4));
										}
									}
									if (parameters[i].getName() == tmrParamName) {
										if (parameters[i].getCurrentValue().formattedValue != 0) {
											workbook.changeParameterValueAsync(tmrParamName, 0);
										}
									}
								}
							})
							if (worksheetName && vm.selectedHerds.length == 0) {
								wrks.get(worksheetName).clearFilterAsync('HerdIdentifier');
							}
						}
					}
					$timeout(function () {
						var containerDiv = document.getElementById("rapFrame");
						viz = new tableau.Viz(containerDiv, url, options);
						viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
						viz.addEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE, onParameterChange);
						viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarksSelection);
					}, 100)
				}
			}).catch(function (response) {
				vm.disableRangeSelector = false;
				console.log('error getting tabvis-location header')
			})
		}

		function onTabSwitch(marksEvent) {
			vm.disableRangeSelector = false;
			var oldSheetName = marksEvent.getOldSheetName();
			var newSheetName = marksEvent.getNewSheetName();
			if (marksEvent.getEventName() == 'tabswitch') {
				vm.showAddToReportButton = true;
				vm.showActualCurrentDateMessage = false;
				vm.disableAddToReport = false;
				vm.showMissingDataMessage = false;
				$rootScope.$broadcast('home_dashboard_embedded', newSheetName);
				var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
				var worksheetName;
				//get name of one of the worksheets
				var list = [];
				var sheetNameExists;
				var worksheetName = getSheetNameByTransitionName(newSheetName);
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName() == worksheetName) {
						sheetNameExists = true;
						break;
					}
				}
				if (!sheetNameExists) {
					worksheetName = wrks[0].getName();
				}
				var currentSheet = newSheetName;
				vm.currentSheetName = angular.copy(currentSheet);
				vm.currentSheet = getDashboardIdByName(currentSheet);
				/*viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function(filter) {
					console.log(filter)
				})

				viz.getWorkbook().getParametersAsync().then(function(parameters) {
					console.log(parameters)
				})*/
				if (oldSheetName == oldName && newSheetName == newName) {
					var filterDIMParityName;
					if (vm.currentLng == "de-DE") {
						filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
					} else if (vm.currentLng == "fr-FR") {
						filterDIMParityName = "Action (Catégorie de JEL,Lactation) 1";
					} else if (vm.currentLng == "en-GB") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					} else if (vm.currentLng == "en-US") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					} else if (vm.currentLng == "nl-NL") {
						filterDIMParityName = "Action (Dagen in lactatie,Pariteit) 1";
					} else if (vm.currentLng == "pl-PL") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					}
					viz.getWorkbook().getActiveSheet().getWorksheets().get("plc").applyFilterAsync(filterDIMParityName, "", tableau.FilterUpdateType.ALL);
					vm.actualDashboardOpen = true;
					vm.showAddToReportButton = false;
					$timeout(function () {
						vm.showCreateReportButton = true;
					}, 200)
					if (worksheetName) {
						//get active filters for worksheet
						var filters;
						var herdIdentifier;
						var reloadState = false;
						var herdFilterId;

						viz.getWorkbook().getParametersAsync().then(function (parameters) {
							for (var i = 0; i < parameters.length; i++) {
								if (parameters[i].getName() == "herd param") {
									var herd_param = parameters[i].getCurrentValue().value;

									break;
								}
							}
							if (herd_param) {
								vm.selectedHerds = [herd_param];
								$rootScope.$broadcast('default_herd_from_dashboard_selected', herd_param);
							} else {
								vm.selectedHerds = [];
								$rootScope.$broadcast('default_herd_from_dashboard_selected', null);
							}
						})
						marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
							for (var i = 0; i < filter.length; i++) {
								var name = filter[i].getFieldName();
								var lastMilkDayFilter;
								if (name.indexOf("(lastDate)") != -1) {
									lastMilkDayFilter = name;
								}
							}
							/*filters = filter.get(filterName).getAppliedValues();
							if (filters.length) {
								//extract one filter value
								var oneValue = filters[0].formattedValue;
								vm.selectedHerds = [oneValue];
								$rootScope.$broadcast('default_herd_from_dashboard_selected', oneValue);
								marksEvent.getViz().getWorkbook().changeParameterValueAsync('herd param', oneValue);
							}else{
								vm.selectedHerds = [];
								$rootScope.$broadcast('default_herd_from_dashboard_selected', null);
							}*/
							if (lastMilkDayFilter) {
								var filter_values = filter.get(lastMilkDayFilter);
								if (filter_values) {
									var last_date = filter_values.getDomainMax();
									last_date = last_date.value;
									checkLastMilkDate(last_date);
									$timeout(function(){
										vm.start_date = angular.copy(vm.actual_start_date);
									},0)
									
								}
							}
						})
					}
				} else if (newSheetName == oldName) {
					vm.actualDashboardOpen = false;
					vm.showCreateReportButton = false;
					vm.showAddToReportButton = false;
					clearfilters(worksheetName);
				} else if (newSheetName == newName) {
					var filterDIMParityName;
					if (vm.currentLng == "de-DE") {
						filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
					} else if (vm.currentLng == "fr-FR") {
						filterDIMParityName = "Action (Catégorie de JEL,Lactation) 1";
					} else if (vm.currentLng == "en-GB") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					} else if (vm.currentLng == "en-US") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					} else if (vm.currentLng == "nl-NL") {
						filterDIMParityName = "Action (Dagen in lactatie,Pariteit) 1";
					} else if (vm.currentLng == "pl-PL") {
						filterDIMParityName = "Action (DIM Category,Parity) 1";
					}
					viz.getWorkbook().getActiveSheet().getWorksheets().get("plc").applyFilterAsync(filterDIMParityName, "", tableau.FilterUpdateType.ALL);
					vm.showCreateReportButton = true;
					vm.actualDashboardOpen = true;
					vm.start_date = angular.copy(vm.actual_start_date);
				} else if (newSheetName == milkYieldActual || newSheetName == sppActual || newSheetName == concentrateActualByYield || newSheetName == concentrateActualByFeed || newSheetName == milkingsActual || newSheetName == herdPrestationsActual || newSheetName == leftoversActual || newSheetName == leftoversActualTable || newSheetName == leftoversActualMilkSpeed || newSheetName == milkingsActual || newSheetName == milkMilkingsActual || newSheetName == concActualByMilk) {
					vm.actualDashboardOpen = true;
					vm.showCreateReportButton = false;
					vm.start_date = angular.copy(vm.actual_start_date);
					if (oldSheetName == herdPrestationsActual) {
						marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (response) {
							var filterValueLength;
							for (var i = 0; i < response.length; i++) {
								var name = response[i].getFieldName();
								var dimLacFilter;
								if (name.indexOf("(TIM-Kategorie,Laktation)") != -1 || name.indexOf("(DIM Category,Parity)") != -1 || name.indexOf("(Catégorie de JEL,Lactation)") != -1 || name.indexOf("(Dagen in lactatie,Pariteit)") != -1) {
									dimLacFilter = name;
									break;
								}
							}
							if (dimLacFilter) {
								var filter_values = response.get(dimLacFilter);
								if (filter_values) {
									var dimLac = filter_values.getAppliedValues();
									var filterValueLength = dimLac.length;
									if (filterValueLength == 1) {
										dimLac = dimLac[0].formattedValue;
										var splited = dimLac.split(",");
										vm.actualFilterValue = {
											type: 2,
											day: null,
											dim: splited[0],
											parity: splited[1]
										}
									}
								}
							}
							if (newSheetName == milkYieldActual) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == sppActual) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == concentrateActualByYield) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == concentrateActualByFeed) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == leftoversActual) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == milkingsActual) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							} else if (newSheetName == milkMilkingsActual) {
								if (filterValueLength == 1) {
									showActualDateMessage();
								}
							}
						})

					}
				} else if (newSheetName == milkYieldActualByDate || newSheetName == sppActualByDate || newSheetName == milkingsActualByDate || newSheetName == milkMilkingsActualByDate || newSheetName == concentrateActualByYieldByDate || newSheetName == concentrateActualByFeedByDate || newSheetName == leftoversActualByDate) {
					vm.showCreateReportButton = false;
					$timeout(function () {
						vm.disableRangeSelector = true;
					}, 50)
					marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
						var cookies = $cookies.getAll();
						var dateFilter;
						if (vm.currentLng == "de-DE") {
							dateFilter = "DAY(Datum)";
						} else if (vm.currentLng == "fr-FR") {
							dateFilter = "DAY(Date)";
						} else if (vm.currentLng == "en-GB") {
							dateFilter = "DAY(Date)";
						} else if (vm.currentLng == "en-US") {
							dateFilter = "DAY(Date)";
						} else if (vm.currentLng == "nl-NL") {
							dateFilter = "DAY(Datum)";
						} else if (vm.currentLng == "pl-PL") {
							dateFilter = "DAY(Date)";
						}
							for (var i = 0; i < filter.length; i++) {
								var name = filter[i].getFieldName();
								var lastMilkDayFilter;
								if (name.indexOf(dateFilter) != -1) {
									lastMilkDayFilter = name;
									break;
								}
							}
						
						if (lastMilkDayFilter) {
							var filter_values = filter.get(lastMilkDayFilter);
							if (filter_values) {
								var day = filter_values.getAppliedValues();
								if (day.length == 1) {
									day = day[0].value;
									vm.actualFilterValue = {
										type: 1,
										day: new Date(day),
										dim: null,
										parity: null
									}
									showActualDateMessage();
								}
							}
						}
					})
				} else if (newSheetName == "Feed Intake" || newSheetName == "Alimentation" || newSheetName == "Futteraufnahme" || newSheetName == "Voeropname") {
					marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).clearFilterAsync(feedNameFilter);
					vm.showCreateReportButton = false;
					vm.start_date = angular.copy(vm.init_start_date);
					vm.actualDashboardOpen = false;
				} else if (newSheetName == robotPrestations || newSheetName == robotPrestationsTrend) {
					vm.showCreateReportButton = false;
					vm.start_date = angular.copy(vm.init_start_date);
					vm.actualDashboardOpen = false;

					if (newSheetName == robotPrestations) {
						checkMissingDataMessage(1)
					} else {
						checkMissingDataMessage(2)
					}


				} else {
					vm.showCreateReportButton = false;
					vm.start_date = angular.copy(vm.init_start_date);
					vm.actualDashboardOpen = false;
				}
			}
		}

		function checkMissingDataMessage(dashboard) {
			// 1 - robot prestations
			// 2 - robot prestations trend

			if (vm.selectedHerds && vm.selectedHerds.length == 1) {
				var herd = vm.selectedHerds[0];
				if (herd == 750 || herd == 794 || herd == 795) {
					var found = false;
					var cookie = $cookies.getObject(vm.user.email);
					var value = vm.selectedHerds[0] + '/' + dashboard;
					if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {
						for (var i = 0; i < cookie.DNSAL.length; i++) {
							if (cookie.DNSAL[i] == value) {
								found = true;
								break;
							}
						}
					}
					vm.doNotShowAgain = false;
					vm.missingDataMessageDashboard = dashboard;
					vm.missingDataColumns = [];
					var list;
					if (herd == 750) {
						if (dashboard == 1) {
							list = [refusals];

						} else if (dashboard == 2) {
							found = true;
						}

					} else if (herd == 794) {
						if (dashboard == 1) {
							list = [milkingTime, milkingTimePercentage, freeTime, freeTimePercentage, avgMilkingSpeed, maxMilkingSpeed, refusals, failures];
						} else if (dashboard == 2) {
							list = [freeTime];
						}

					} else if (herd == 795) {
						if (dashboard == 1) {
							list = [milkingTime, milkingTimePercentage, freeTime, freeTimePercentage, avgMilkingSpeed, maxMilkingSpeed, refusals, failures];
						} else if (dashboard == 2) {
							list = [freeTime];
						}
					}
					vm.missingDataColumns = angular.copy(list);
					$timeout(function () {
						if (!found) {
							vm.showMissingDataMessage = true;
						}

					}, 10);

				}
			}


		}

		function hideMissingDataMessage() {
			vm.showMissingDataMessage = false;
			if (vm.doNotShowAgain) {
				var cookie = $cookies.getObject(vm.user.email);
				var value = vm.selectedHerds[0] + '/' + vm.missingDataMessageDashboard;
				if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {

					cookie.DNSAL.push(value)
				} else {
					cookie.DNSAL = [value];
				}

				var expireDate = new Date();
				expireDate.setDate(expireDate.getDate() + 365);
				cookiesService.setCookie(vm.user.email, JSON.stringify(cookie), {
					samesite: "strict",
					expires: expireDate
				});
			}
		}


		function clearfilters(worksheet_name) {
			if (vm.herdIdentifierFilterUsed) {
				viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheet_name).clearFilterAsync("HerdIdentifier");
				vm.herdIdentifierFilterUsed = false;
			}

			viz.getWorkbook().changeParameterValueAsync('herd param', 0);
			viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheet_name).applyFilterAsync(parityFilter, "", tableau.FilterUpdateType.ALL);
			vm.selectedHerds = [];
			$rootScope.$broadcast('deselect_all_herds');
			checkStartEndDate();
		}

		function checkStartEndDate() {
			var c_start_date = angular.copy(vm.init_start_date);
			var c_end_date = angular.copy(vm.end_date);
			var start_changed;
			var end_changed;
			setDates();
			if (!moment(c_start_date).isSame(vm.start_date)) {
				start_changed = true;
			}
			if (!moment(c_end_date).isSame(vm.end_date)) {
				end_changed = true;
			}
			if (start_changed && end_changed) {
				viz.getWorkbook().changeParameterValueAsync('Start Date', vm.start_date).then(function (param) {
					viz.getWorkbook().changeParameterValueAsync('End Date', vm.end_date).then(function (param) {
						checkParameters();
					})
				})
			} else if (start_changed && !end_changed) {
				viz.getWorkbook().changeParameterValueAsync('Start Date', vm.start_date).then(function (param) {
					checkParameters();
				});
			} else if (!start_changed && end_changed) {
				viz.getWorkbook().changeParameterValueAsync('End Date', vm.end_date).then(function (param) {
					checkParameters();
				})
			} else {
				checkParameters();
			}
		}

		function checkParameters() {
			var changeFat = false;
			var changeProtein = false;
			var changeTMR = false;
			viz.getWorkbook().getParametersAsync().then(function (parameters) {
				for (var i = 0; i < parameters.length; i++) {
					if (parameters[i].getName() == fatParamName) {
						if (parameters[i].getCurrentValue().formattedValue != fatParam) {
							changeFat = true;
						}
					}
					if (parameters[i].getName() == proteinParamName) {
						if (parameters[i].getCurrentValue().formattedValue != proteinParam) {
							changeProtein = true;
						}
					}
					if (parameters[i].getName() == tmrParamName) {
						if (parameters[i].getCurrentValue().formattedValue != 0) {
							changeTMR = true;
						}
					}
				}
				checkFatParameter(changeFat, changeProtein, changeTMR);
			})
		}

		function checkFatParameter(changeFat, changeProtein, changeTMR) {
			if (changeFat) {
				viz.getWorkbook().changeParameterValueAsync(fatParamName, fatParam).then(function (parameter) {
					fatChanged = false;
					checkProteinParameter(changeProtein, changeTMR);
				})
			} else {
				checkProteinParameter(changeProtein, changeTMR);
			}
		}

		function checkProteinParameter(changeProtein, changeTMR) {
			if (changeProtein) {
				viz.getWorkbook().changeParameterValueAsync(proteinParamName, proteinParam).then(function (parameter) {
					proteinChanged = false;
					checkTMRParameter(changeTMR);
				})
			} else {
				checkTMRParameter(changeTMR);
			}
		}

		function checkTMRParameter(changeTMR) {
			if (changeTMR) {
				viz.getWorkbook().changeParameterValueAsync(tmrParamName, 0).then(function (parameter) {
					TMRchanged = false;
					checkDMParameter();
				})
			} else {
				checkDMParameter();
			}
		}

		function checkDMParameter() {
			if (DryMatterChanged) {
				viz.getWorkbook().changeParameterValueAsync(dmParamName, 0).then(function (parameter) {
					DryMatterChanged = false;
				})
			}
		}

		function showActualDateMessage() {
			$timeout(function () {
				vm.showActualCurrentDateMessage = true;
			}, 100);
		}

		function onMarksSelection(event) {
			if (event.getWorksheet().getName() == resetAllParities) {
				$timeout(function () {
					vm.showActualCurrentDateMessage = false;
				}, 0)
			}
		}

		function onParameterChange(event) {
			event.getParameterAsync().then(function (parameter) {
				if (event.getParameterName() == fatParamName) {
					fatChanged = true
				} else if (event.getParameterName() == proteinParamName) {
					proteinChanged = true;
				} else if (event.getParameterName() == tmrParamName) {
					TMR = parameter.getCurrentValue().value;
					TMRchanged = true;
				} else if (event.getParameterName() == dmParamName) {
					DryMatterChanged = true;
					DryMatter = parameter.getCurrentValue().value;
				}
			})
		}

		function checkLastMilkDate(last_milk_date) {
			var lmd = moment(last_milk_date).hour(23).minute(59).seconds(59).millisecond(999);
			var end_date = moment().year(vm.end_date.getFullYear()).month(vm.end_date.getMonth()).date(vm.end_date.getDate()).hour(23).minute(59).seconds(59).millisecond(999);
			if (moment(lmd).isBefore(end_date)) {
				$timeout(function () {
					vm.showDPMessage = true;
				}, 200)
				vm.end_date = new Date(lmd);
				vm.actual_start_date = new Date(moment(lmd).subtract(7, 'days'));
				vm.init_start_date = new Date(moment(lmd).subtract(30, 'days'));
				if (vm.actualDashboardOpen) {
					vm.start_date = angular.copy(vm.actual_start_date);
				}
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				}
				cookiesService.setCookie('rap_actual_dates', JSON.stringify(dates), {
					samesite: "lax",
					domain: ".mmmooogle.com"
				});
			}
		}

		function getDashboardIdByName(name) {
			var found;
			var id;
			for (var i = 0; i < vm.dashboardIdList.length; i++) {
				if (name == vm.dashboardIdList[i].name) {
					found = true;
					id = vm.dashboardIdList[i].id;
					break;
				}
			}
			if (found) {
				return id;
			} else {
				return null;
			}
		}

		function openReportDashboardPeriodModal(index) {
			vm.report_modal_start_date = vm.reportDashboards[index].start_date;
			vm.report_modal_end_date = vm.reportDashboards[index].end_date;
			vm.selectedReportDashboardIndex = index;
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.setRangeModalLoading = false;
			openModal('app/pages/rap/reportRangeSelector.modal.html', 'sm');
		}

		function openReportCommentModal(index) {
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.selectedReportDashboardIndex = index;
			vm.addCommentModalLoading = false;
			openModal('app/pages/rap/reportComment.modal.html', 'sm');
		}

		function openReportDashboardDayModal(index) {
			vm.setDateModalLoading = false;
			vm.report_modal_date = angular.copy(vm.reportDashboards[index].report_date);
			vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
			vm.selectedReportDashboardIndex = index;
			openModal('app/pages/rap/daySelector.modal.html', 'sm');
		}

		function openAddToReportModal() {
			vm.addToReportModalLoading = true;
			vm.entryAlradyExist = false;
			vm.currentEntry = null;
			var date = new Date();
			getAddedToReport(false, date, false);
			openModal('app/pages/rap/addToReport.modal.html', 'sm');
		}

		function getSheetNameByTransitionName(currentName) {
			var sheetName;
			for (var i = 0; i < sheetNameList.length; i++) {
				if (sheetNameList[i].sheet_name_transition == currentName) {
					sheetName = sheetNameList[i].sheet_name;
					break;
				}
			}
			return sheetName;
		}

		function setReportDashboardComment() {
			vm.addCommentModalLoading = true;
			var end_date = moment(vm.selectedReportDashboard.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
			var start_date = moment(vm.selectedReportDashboard.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
			if (vm.selectedReportDashboard.entry_id) {
				var obj = {
					id: vm.selectedReportDashboard.entry_id,
					comment: vm.selectedReportDashboard.comment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.selectedReportDashboard.locale,
					dashboardId: vm.selectedReportDashboard.id
				}
				return rapService.updateReportEntry(obj.id, obj).then(function (response) {
					vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
					closeModal();
				}).catch(function (error) {
					console.log(error);
					vm.addCommentModalLoading = false;
				})
			} else {
				vm.reportDashboards[vm.selectedReportDashboardIndex].comment = vm.selectedReportDashboard.comment;
				closeModal();
			}
		}

		function openCreateReport() {
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			if (os.name == 'iOS' && brw.name == 'Mobile Safari') {
				vm.safariMobileUsed = true;
			} else {
				vm.safariMobileUsed = false;
			}
			vm.reportDate = new Date();
			vm.showCreateReportBlock = true;
			vm.reportLoading = true;
			vm.pdfLoading = false;
			if (vm.selectedHerds && vm.selectedHerds.length == 1) {
				herdsPromise = $q.defer();
				dashboardsPromise = $q.defer();
				addToReportPromise = $q.defer();
				$q.all([herdsPromise.promise, dashboardsPromise.promise, addToReportPromise.promise]).then(function () {
					vm.reportError = false;
					vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
					vm.reportDashboards = setActualByDate(vm.reportDashboards);
					if (vm.reportDashboards.length) {
						vm.reportLoading = false;
						vm.herdNotSelected = false;
					} else {
						vm.showCreateReportBlock = false;
						vm.noAvailableDashboards = true;
						vm.reportLoading = false;
						vm.herdNotSelected = false;
					}
				}).catch(function (error) {
					vm.reportLoading = false;
					vm.reportError = true;
					vm.pdfLoading = false;
				})
				getAddedToReport(true, vm.reportDate, true);
				var herd_id = vm.selectedHerds[0];
				checkHerds(herd_id);
				checkAllDashboards();
			} else {
				vm.reportLoading = false;
				$interval.cancel(loadingDotsInterval);
				vm.herdNotSelected = true;
			}
		}

		function setReportDate() {
			vm.reportDateOpened = false;
			if (vm.reportDate) {
				getAddedToReport(false, vm.reportDate, true);
			}
		}

		function checkAllDashboards() {
			if (rapService.allDashboards && rapService.allDashboards.team_id == vm.selectedTeam && rapService.allDashboards.dashboards && rapService.allDashboards.dashboards.length) {
				vm.allReportDashboards = getRapDashboards(rapService.allDashboards.dashboards);
				dashboardsPromise.resolve();
			} else {
				var tableauSuffix = '?locale=' + vm.currentLng;
				return rapService.getDashboards(vm.selectedTeam, tableauSuffix).then(function (response) {
					vm.allReportDashboards = getRapDashboards(response);
					dashboardsPromise.resolve();
				}).catch(function (error) {
					dashboardsPromise.reject();
				})
			}
		}

		function checkHerds(herd_id) {
			if (rapService.loadedHerds && rapService.loadedHerds.herds && rapService.loadedHerds.herds.length && rapService.loadedHerds.team_id && rapService.loadedHerds.team_id == vm.selectedTeam) {
				vm.currentHerdName = getHerdNameById(herd_id, rapService.loadedHerds.herds);
				herdsPromise.resolve();
			} else {
				return rapService.getHerdsByTeam(vm.selectedTeam).then(function (response) {
					vm.currentHerdName = getHerdNameById(herd_id, response);
					herdsPromise.resolve();
				}).catch(function (error) {
					herdsPromise.reject();
				})
			}
		}

		function getAddedToReport(init, date, createReport) {
			vm.multipleReports = false;
			if (vm.selectedHerds && vm.selectedHerds.length == 1 && vm.selectedTeam) {
				var date = moment(vm.reportDate).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
				var suffix = '?HerdId=' + vm.selectedHerds;
				suffix = suffix + '&Date=' + date;

				return rapService.getReports(suffix).then(function (response) {
					var added = response[0];
					vm.availableReports = response;
					vm.selectedReport = response[0];
					if (response.length > 1) {
						vm.multipleReports = true;
					}
					if (createReport) {
						setReport(init, added);
					} else {
						setCurrentEntry(added);
					}
				}).catch(function (error) {
					vm.addToReportModalLoading = false;
					if (createReport) {
						addToReportPromise.reject();
					}

				})
			} else {
				if (createReport) {} else {
					vm.addToReportModalLoading = false;
				}
			}
		}

		function setReport(init, added) {
			var lng = vm.currentLng;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (added.entries[i].locale != lng || (added.entries[i].dashboardId == "Herdprestationsactual" || added.entries[i].dashboardId == "Prestationsrellespourletroupeau" || added.entries[i].dashboardId == "tatschlicheHerdenvorhersage" || added.entries[i].dashboardId == "Kuddeprestatiesactueel")) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			if (!init) {
				vm.reportDashboards = checkForAddedToReport(vm.allReportDashboards, vm.addedToReport);
			}
			if (init) {
				addToReportPromise.resolve();
			} else {
				vm.reportLoading = false;
			}
		}

		function setCurrentEntry(added) {
			var lng = vm.currentLng;
			if (added && added.entries) {
				for (var i = 0; i < added.entries.length; i++) {
					if (added.entries[i].locale != lng || (added.entries[i].dashboardId == "Herdprestationsactual" || added.entries[i].dashboardId == "Prestationsrellespourletroupeau" || added.entries[i].dashboardId == "tatschlicheHerdenvorhersage" || added.entries[i].dashboardId == "Kuddeprestatiesactueel")) {
						added.entries[i].dashboardId = getCurrentLngId(added.entries[i].dashboardId, lng);
						added.entries[i].filter = getCurrentLngFilter(added.entries[i].filter, added.entries[i].locale, added.entries[i].dashboardId);
						added.entries[i].locale = lng;
					}
				}
				vm.addedToReport = added.entries;
			} else {
				vm.addedToReport = [];
			}
			var entry;
			for (var i = 0; i < vm.addedToReport.length; i++) {
				if (vm.addedToReport[i].dashboardId == vm.currentSheet) {
					entry = vm.addedToReport[i];
					break;
				}
			}
			if (entry) {
				vm.entryAlradyExist = true;
				vm.currentEntry = entry;
				vm.modalComment = angular.copy(vm.currentEntry.comment);
			} else {
				vm.modalComment = '';
			}
			vm.addToReportModalLoading = false;
		}

		function reportSelected() {
			vm.reportLoading = true;
			$timeout(function () {
				setReport(false, vm.selectedReport);
			}, 100)
		}

		function checkForAddedToReport(dashboards, addedToReport) {
			var list = angular.copy(dashboards);
			for (var i = 0; i < list.length; i++) {
				for (var j = 0; j < addedToReport.length; j++) {
					if (list[i].id == addedToReport[j].dashboardId) {
						list[i].comment = addedToReport[j].comment;
						list[i].end_date = new Date(addedToReport[j].endDate);
						list[i].start_date = new Date(addedToReport[j].startDate);
						list[i].selected = true;
						list[i].entry_id = addedToReport[j].id;
						list[i].filter = addedToReport[j].filter;
						list[i].report_date = (isActualByDate(list[i])) ? setActualDate(list[i].filter) : undefined;
					}
				}
			}
			return list;
		}

		function setActualByDate(dashboards) {
			var list = angular.copy(dashboards);
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (isActualByDate(list[i])) {
					if (!list[i].filter) {
						list[i].filter = "&" + dayFilterName + "=" + moment(list[i].report_date).format('YYYY-MM-DD');
					}
				}
			}
			return list;
		}

		function setActualDate(filter) {
			var splitted = filter.split('&');
			var dateFilterStr;
			for (var i = 0; i < splitted.length; i++) {
				if (splitted[i].indexOf(dayFilterName) != -1) {
					dateFilterStr = splitted[i];
				}
			}
			var date;
			if (dateFilterStr) {
				var splitedDate = dateFilterStr.split('=');
				date = new Date(splitedDate[1]);
			} else {
				date = vm.end_date;
			}
			return date;
		}

		function getCurrentLngId(id, lng) {
			var dashboardList = angular.copy(APP_CONSTANTS.constants.dashboardIdLngList);
			//find internal id
			var internal_id;
			for (var i = 0; i < dashboardList.length; i++) {
				if (dashboardList[i].id == id) {
					internal_id = dashboardList[i].internal_id;
					break;
				}
			}
			var translated_id;
			//find language id for current language
			if (internal_id) {
				for (var i = 0; i < dashboardList.length; i++) {
					if (internal_id == dashboardList[i].internal_id && lng == dashboardList[i].lng) {
						translated_id = dashboardList[i].id;
						break;
					}
				}
			}
			if (translated_id) {
				id = translated_id;
			}
			return id;
		}

		function getCurrentLngFilter(filter, lng, dashboard_id) {
			var filterString = angular.copy(filter);
			//split filter by param
			var splitted = filterString.split('&');
			var parityFilterString;
			var groupByParameterString;
			var groupByMetricString;
			var feedNameFilterString;
			var DIMCatrgoryFilterString;
			var dateFilterString;
			for (var i = 0; i < splitted.length; i++) {
				if ((splitted[i].indexOf('Group by=') != -1) || (splitted[i].indexOf('Groupé par=') != -1) || (splitted[i].indexOf('Gruppiere nach=') != -1) || (splitted[i].indexOf('Groepeer op=') != -1)) {
					groupByParameterString = splitted[i];
				}
				if ((splitted[i].indexOf('Parity=') != -1) || (splitted[i].indexOf('Pariteit=') != -1) || (splitted[i].indexOf('Laktation=') != -1) || (splitted[i].indexOf('Lactation=') != -1)) {
					parityFilterString = splitted[i];
				}
				if ((splitted[i].indexOf('Nach Metrik gruppieren=') != -1) || (splitted[i].indexOf('Groepeer op kengetal=') != -1) || (splitted[i].indexOf('Grouper par métrique=') != -1) || (splitted[i].indexOf('Group by metric=') != -1)) {
					groupByMetricString = splitted[i];
				}
				if ((splitted[i].indexOf('Feed name=') != -1) || (splitted[i].indexOf('Name des Futters=') != -1) || (splitted[i].indexOf("Nom de l'aliment=") != -1) || (splitted[i].indexOf('Voer naam=') != -1)) {
					feedNameFilterString = splitted[i];
				}
				if ((splitted[i].indexOf('TIM-Kategorie=') != -1) || (splitted[i].indexOf('DIM Category=') != -1) || (splitted[i].indexOf("Catégorie de JEL=") != -1) || (splitted[i].indexOf('Dagen in lactatie=') != -1)) {
					DIMCatrgoryFilterString = splitted[i];
				}
				if ((splitted[i].indexOf('Datum=') != -1) || (splitted[i].indexOf('Date=') != -1)) {
					dateFilterString = splitted[i];
				}

			}
			var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
			var parity;
			var groupBy;
			var groupByValue;
			var groupByValueTranslateString;
			var groupByMetricValue;
			var DIMCategoryValue;
			var feedName;
			var dateValue;
			for (var i = 0; i < filtersLngList.length; i++) {
				if (filtersLngList[i].internal_id == 'parity' && filtersLngList[i].lng == lng) {
					parity = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by' && filtersLngList[i].lng == lng) {
					groupBy = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by_value' && filtersLngList[i].lng == lng) {
					if (groupByParameterString.indexOf(filtersLngList[i].name) != -1) {
						groupByValue = filtersLngList[i].name;
						groupByValueTranslateString = filtersLngList[i].translate_string;
					}
				}
				if (filtersLngList[i].internal_id == 'feed_name' && filtersLngList[i].lng == lng) {
					feedName = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'group_by_metric' && filtersLngList[i].lng == lng) {
					groupByMetricValue = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'dim_category' && filtersLngList[i].lng == lng) {
					DIMCategoryValue = filtersLngList[i].name;
				}
				if (filtersLngList[i].internal_id == 'date' && filtersLngList[i].lng == lng) {
					dateValue = filtersLngList[i].name;
				}

			}
			if (parity && parityFilterString) {
				parityFilterString = changeFilterNameLanguage(parityFilterString, parity, parityFilter);
			}
			if (groupBy && groupByParameterString) {
				groupByParameterString = changeFilterNameLanguage(groupByParameterString, groupBy, groupByParam);
			}
			if (groupByParameterString && groupByValue && groupByValueTranslateString) {
				groupByParameterString = changeFilterNameLanguage(groupByParameterString, groupByValue, i18nFilter(groupByValueTranslateString));
			}
			if (groupByMetricValue && groupByMetricString) {
				groupByMetricString = changeFilterNameLanguage(groupByMetricString, groupByMetricValue, groupByMetric);
			}
			if (feedName && feedNameFilterString) {
				feedNameFilterString = changeFilterNameLanguage(feedNameFilterString, feedName, feedNameFilter);
			}
			filterString = '';
			if (parityFilterString) {
				if (dashboard_id != "Herdprestationsactual" && dashboard_id != "Prestationsrellespourletroupeau" && dashboard_id != "tatschlicheHerdenvorhersage" && dashboard_id != "Kuddeprestatiesactueel") {
					filterString += '&' + parityFilterString;
				}
			}
			if (DIMCategoryValue && DIMCatrgoryFilterString) {
				DIMCatrgoryFilterString = changeFilterNameLanguage(DIMCatrgoryFilterString, DIMCategoryValue, DIMCategoryFilterName);
			}
			if (dateValue && dateFilterString) {
				dateFilterString = changeFilterNameLanguage(dateFilterString, dateValue, dayFilterName);
			}

			if (groupByParameterString) {
				filterString += '&' + groupByParameterString;
			}
			if (groupByMetricString) {
				filterString += '&' + groupByMetricString;
			}
			if (feedNameFilterString) {
				filterString += '&' + feedNameFilterString;
			}
			if (DIMCatrgoryFilterString) {
				filterString += '&' + DIMCatrgoryFilterString;
			}
			if (dateFilterString) {
				filterString += '&' + dateFilterString;
			}
			return filterString;
		}

		function changeFilterNameLanguage(filter, old_name, new_name) {
			var str = angular.copy(filter);
			return str.replace(old_name, new_name);
		}

		function getRapDashboards(dashboards) {
			var list = [];
			var listOfDashboardsIds = [];
			var currentLng = vm.currentLng;
			for (var i = 0; i < APP_CONSTANTS.constants.dashboardIdLngList.length; i++) {
				if (APP_CONSTANTS.constants.dashboardIdLngList[i].lng == currentLng) {
					listOfDashboardsIds.push(APP_CONSTANTS.constants.dashboardIdLngList[i]);
				}
			}
			for (var i = 0; i < listOfDashboardsIds.length; i++) {
				for (var j = 0; j < dashboards.length; j++) {
					if (listOfDashboardsIds[i].id == dashboards[j].id && dashboards[j].locale == currentLng && dashboards[j].subcategory == 'rap-fame-v3') {
						dashboards[j].index = listOfDashboardsIds[i].index;
						dashboards[j].selected = listOfDashboardsIds[i].selected;
						dashboards[j].default = listOfDashboardsIds[i].default;
						dashboards[j].actual = listOfDashboardsIds[i].actual;
						dashboards[j].size = listOfDashboardsIds[i].size;
						if (listOfDashboardsIds[i].actual) {
							dashboards[j].start_date = vm.actual_start_date;
						} else {
							dashboards[j].start_date = vm.init_start_date;
						}
						dashboards[j].end_date = vm.end_date;
						if (isActualByDate(dashboards[j])) {
							dashboards[j].report_date = vm.end_date;
						}
						list.push(dashboards[j]);
					}
				}
			}
			return list;
		}

		function getHerdNameById(herd_id, herds) {
			var herdName = '';
			for (var i = 0; i < herds.length; i++) {
				if (herds[i].Id == herd_id) {
					herdName = herds[i].Name;
					break;
				}
			}
			return herdName;
		}

		function setReportData() {
			var parser = new UAParser();
			var brw = parser.getBrowser();
			var os = parser.getOS();
			vm.reportLoading = true;
			vm.pdfLoading = true;
			loadingDotsCounter = 0;
			loadingDotsInterval = $interval(function () {
				if (loadingDotsCounter == 0) {
					vm.loadingDots = '.';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 1) {
					vm.loadingDots = '..';
					loadingDotsCounter++;
				} else if (loadingDotsCounter == 2) {
					vm.loadingDots = '...';
					loadingDotsCounter = 0;
				}
			}, 400)
			var list = [];
			for (var i = 0; i < vm.reportDashboards.length; i++) {
				if (vm.reportDashboards[i].selected) {
					list.push(vm.reportDashboards[i])
				}
			}
			vm.orderedDashboards = $filter('orderBy')(list, 'index');
			var url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				var name = 'pr' + i;
				vm[name] = $q.defer();
				url_promise_list.push(vm[name].promise);
				getImageUrl(vm.orderedDashboards[i].url, i, name);
			}

			function getImageUrl(url, index, name) {
				//for testing//
				/*var image_url = 'assets/img/hoof_health.jpg?4564545';
				vm.orderedDashboards[index].image_url = image_url;
				vm[name].resolve();*/
				//production//
				return rapService.setSession(url).then(function (response) {
					var image_url = response.headers('tabvis-location');
					vm.orderedDashboards[index].image_url = image_url;
					vm[name].resolve();
				}).catch(function (error) {
					vm[name].reject();
				})
			}
			$q.all(url_promise_list).then(function () {
				setDataUrls(vm.orderedDashboards);
			}).catch(function (error) {
				vm.reportLoading = false;
				vm.reportError = true;
				vm.pdfLoading = false;
			})
			//}
		}

		function getDataUrl(url, index, name) {
			toDataURL(url, function (dataUrl) {
				vm.orderedDashboards[index].image = dataUrl;
				vm[name].resolve();
			}, name)
		}

		function setImageUrl(dashboard) {
			var image_url;
			var size = '1920,1080';
			var splitted = dashboard.image_url.split('?');
			//comment for testing
			image_url = splitted[0] + '.png';
			//use for testing
			//image_url = splitted[0];
			var start_date = moment(dashboard.start_date).format('YYYY-MM-DD');
			var end_date = moment(dashboard.end_date).format('YYYY-MM-DD');
			var herd = vm.selectedHerds[0];
			var suffix = '?Start%20Date=' + start_date + '&End%20Date=' + end_date + '&HerdIdentifier=' + herd + '&herd%20param=' + herd + '&:size=';
			if (dashboard.size) {
				suffix = suffix + dashboard.size;
			} else {
				suffix = suffix + size;
			}
			if (TMRchanged) {
				suffix = suffix + '&' + tmrParamName + '=' + TMR;
			}
			if (DryMatterChanged) {
				suffix = suffix + '&' + dmParamName + '=' + DryMatter;
			}
			image_url = image_url + suffix;
			if (dashboard.filter) {
				image_url = image_url + dashboard.filter;
			}
			return image_url;
		}

		function setDataUrls() {
			var image_url_promise_list = [];
			for (var i = 0; i < vm.orderedDashboards.length; i++) {
				var name = 'imgpr' + i;
				vm[name] = $q.defer();
				image_url_promise_list.push(vm[name].promise);
				var image_url = setImageUrl(vm.orderedDashboards[i])
				getDataUrl(image_url, i, name);
			}
			vm.logoPrm = $q.defer();
			image_url_promise_list.push(vm.logoPrm.promise);
			toDataURL('assets/img/ForFarmersLogo.png', function (dataUrl) {
				vm.logo = dataUrl;
				vm.logoPrm.resolve();
			}, 'logoPrm')
			$q.all(image_url_promise_list).then(function () {
				var date = new Date();
				date = $filter('date')(date);
				var pdfData = {
					date: date,
					logo: vm.logo,
					user: vm.user.name,
					blue: '#033384',
					green: '#99B71B',
					red: 'red',
					positive_points: (vm.positivePoints ? vm.positivePoints : ''),
					points_to_improve: (vm.pointsToImprove ? vm.pointsToImprove : ''),
					herd_name: vm.currentHerdName,
					dashboards: vm.orderedDashboards
				}
				createPDF(pdfData);
			}).catch(function (error) {
				vm.reportLoading = false;
				vm.reportError = true;
				vm.pdfLoading = false;
			})
		}

		function createPDF(pdfData) {
			var dd = {
				pageMargins: [20, 20, 20, 20],
				pageSize: 'A4',
				content: [{
						image: pdfData.logo,
						width: 120,
						alignment: 'right'
					}, {
						text: i18nFilter('_report_title_robot_analysis_') + ':',
						alignment: 'left',
						fontSize: 16,
						bold: true,
						color: pdfData.blue
					}, {
						text: pdfData.herd_name,
						alignment: 'left',
						fontSize: 14,
						color: pdfData.blue,
						margin: [0, 10, 0, 0],
						italics: true
					}, {
						text: pdfData.date,
						alignment: 'left',
						fontSize: 14,
						color: pdfData.blue,
						italics: true
					}, {
						table: {
							widths: ['auto', '*'],
							body: [
								[{
									text: i18nFilter('_report_robot_specialist_') + ':',
									color: pdfData.blue,
									fontSize: 14,
									border: [false, false, false, true],
									italics: true,
									margin: [-5, 0, -5, 0],
								}, {
									text: pdfData.user,
									color: pdfData.blue,
									fontSize: 14,
									border: [false, false, false, true],
									italics: true
								}]
							, ]
						},
						layout: {
							hLineColor: pdfData.green
						}
					}, {
						text: i18nFilter('_report_positive_points_') + ':',
						alignment: 'left',
						bold: true,
						margin: [0, 5, 15, 0]
					}, {
						text: pdfData.positive_points,
						alignment: 'left',
						pageBreak: ((pdfData.positive_points.length > 1700 || pdfData.positive_points.split(/\r\n|\r|\n/).length > 22) && (pdfData.points_to_improve.length > 1700 || pdfData.points_to_improve.split(/\r\n|\r|\n/).length > 22)) ? 'after' : false
					}, {
						text: i18nFilter('_report_points_to_improve_') + ':',
						alignment: 'left',
						bold: true,
						margin: [0, 5, 15, 0]
					}, {
						text: pdfData.points_to_improve,
						alignment: 'left',
					},



				],
			}
			for (var i = 0; i < pdfData.dashboards.length; i++) {
				var obj = {
					text: pdfData.dashboards[i].comment ? pdfData.dashboards[i].comment : '',
					border: [false, false, false, false],
					margin: [0, 5, 0, 10]
				};
				var table = {
					table: {
						dontBreakRows: true,
						widths: ['*'],
						body: [
							[{
								border: [false, false, false, false],
								margin: [-5, 5, -5, 10],
								stack: [{
										margin: [0, 5, 0, 10],
										text: isActualByDate(pdfData.dashboards[i]) ?
											(pdfData.dashboards[i].description + ' (' + $filter('date')(pdfData.dashboards[i].report_date) + ')') : (pdfData.dashboards[i].description + ' (' + $filter('date')(pdfData.dashboards[i].start_date) + ' - ' + $filter('date')(pdfData.dashboards[i].end_date) + ')'),
										border: [false, false, false, false],
										bold: true
									}, {
										image: pdfData.dashboards[i].image,
										width: 555,
										border: [false, false, false, false]
									},

								]
							}]
						]
					},
					layout: {
						hLineColor: pdfData.green
					}
				}
				if (pdfData.dashboards[i].selected) {
					dd.content.push(table);
					dd.content.push(obj);
				}
			}
			var reportName = i18nFilter('_report_title_robot_analysis_') + ' ' + $filter('date')(new Date(), 'yyyy-MM-dd');
			var parser = new UAParser();
			var os = parser.getOS();
			var brw = parser.getBrowser();
			var device = parser.getDevice();
			var pdf = pdfMake.createPdf(dd);
			if (device && device.type) {
				if (os.name == 'iOS') {
					if (brw.name == 'Mobile Safari') {
						try {
							pdf.open();
						} catch (error) {
							toastr.error(error)
						}
					} else {
						try {
							var reader = new FileReader();
							pdf.open();
							pdf.getBlob(function (blob) {
								reader.onload = function (e) {
									var uri = reader.result
									var link = document.createElement("a");
									link.download = reportName + '.pdf';
									link.href = uri;
									document.body.appendChild(link);
									link.click();
									document.body.removeChild(link);
								}
								reader.readAsDataURL(blob);
							})
						} catch (error) {
							toastr.error(error)
						}
					}
				} else {
					pdfMake.createPdf(dd).download(reportName);
				}
			} else {
				try {
					pdfMake.createPdf(dd).open();
				} catch (error) {
					toastr.error(i18nFilter('_report_create_popup_message_'));
				}
			}
			vm.pointsToImprove = '';
			vm.positivePoints = '';
			$timeout(function () {
				vm.showCreateReportBlock = false;
				vm.reportLoading = false;
				vm.pdfLoading = false;
				$interval.cancel(loadingDotsInterval);
			}, 500)
		}

		function closeCreateReport() {
			vm.showCreateReportBlock = false;
			vm.pointsToImprove = '';
			vm.positivePoints = '';
		}

		function addToReport() {
			vm.addToReportModalLoading = true;
			var filter = '';
			var parityFilterUrl = '';
			var groupByFilterUrl = '';
			var groupByMetricMarkUrl = '';
			var feedNameFilterUrl = ''
			var DIMFilterUrl = '';
			var dayFilterUrl = '';
			parityPromise = $q.defer();
			groupByPromise = $q.defer();
			groupByMetricPromise = $q.defer();
			feedNamePromise = $q.defer();
			DIMPromise = $q.defer();
			dayPromise = $q.defer();
			var parityPromiseResolved = false;
			var groupByPromiseResolved = false;
			var groupByMetricPromiseResolved = false;
			var feedNamePromiseResolved = false;
			var dimPromiseResolved = false;
			var dayPromiseResolved = false;
			var promiseTimeout;
			promiseTimeout = $timeout(function () {
				if (!parityPromiseResolved) {
					parityPromise.resolve();
				}
				if (!groupByPromiseResolved) {
					groupByPromise.resolve();
				}
				if (!groupByMetricPromiseResolved) {
					groupByMetricPromise.resolve();
				}
				if (!feedNamePromiseResolved) {
					feedNamePromise.resolve();
				}
				if (!dimPromiseResolved) {
					DIMPromise.resolve();
				}
				if (!dayPromiseResolved) {
					dayPromise.resolve();
				}
			}, 7000);
			$q.all([parityPromise.promise, groupByPromise.promise, groupByMetricPromise.promise, feedNamePromise.promise, DIMPromise.promise, dayPromise]).then(function () {
				if (promiseTimeout) {
					$timeout.cancel(promiseTimeout);
				}
				if (parityFilterUrl) {
					filter += parityFilterUrl;
				}
				if (groupByFilterUrl) {
					filter += groupByFilterUrl;
				}
				if (groupByMetricMarkUrl) {
					filter += groupByMetricMarkUrl;
				}
				if (feedNameFilterUrl) {
					filter += feedNameFilterUrl;
				}
				if (DIMFilterUrl) {
					filter += DIMFilterUrl;
				}
				if (dayFilterUrl) {
					filter += dayFilterUrl;
				}
				setEntry(filter);
			})
			try {
				var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
				var sheetNameExists;
				var wrks = viz.getWorkbook().getActiveSheet().getWorksheets();
				var feedOverTimeExist = false;
				var isFeedIntake;
				var actualDashboard;
				var actualByDateDashboard;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName() == worksheetName) {
						sheetNameExists = true;
						break;
					}
				}

				if (worksheetName == "Milk yield (kg/cow) by DIM by Date" ||
					worksheetName == "Melkproductie (kg/koe) volgens DIL volgens datum" ||
					worksheetName == "Production de lait (kg/vache) par JEL par date" ||
					worksheetName == "Concentrate intake (kg/100) by milk yield by Date" ||
					worksheetName == "Milchproduktion (kg/Kuh) durch TIM nach datum" ||
					worksheetName == "Wydajność mleczna (kg/krowę) wg DL wg daty" ||
					worksheetName == "Pobranie paszy treściwej (kg/100) wg wydajności mleka wg daty" ||
					worksheetName == "BSK (kg/cow) by DIM by Date" ||
					worksheetName == "BSK (kg/koe) volgens DIL volgens datum" ||
					worksheetName == "SPP (kg/vache) par JEL par date" ||
					worksheetName == "BSK (kg/Kuh) durch TIM nach datum" ||
					worksheetName == "SPS (kg/krowę) wg DL wg daty" ||
					worksheetName == "Milkings by DIM by Date" ||
					worksheetName == "Udoje wg DL wg daty" ||
					worksheetName == "Melkingen volgens DIL volgens datum" ||
					worksheetName == "Traites par JEL par date" ||
					worksheetName == "Melkungen durch TIM nach datum" ||
					worksheetName == "Milk/Milkings in DIM by Date" ||
					worksheetName == "Melk/melking in DIL volgens datum" ||
					worksheetName == "Lait/traite s en fonction du JEL par date" ||
					worksheetName == "Milch/Melkung durch TIM nach datum" ||
					worksheetName == "Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum" ||
					worksheetName == "Consommation de concentré (kg/100kg) en fonction de production en fonction par date" ||
					worksheetName == "Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum" ||
					worksheetName == "Concentrate intake (kg/cow) by DIM by Date" ||
					worksheetName == "Krachtvoer opname (kg/koe) volgens DIL volgens datum" ||
					worksheetName == "Consommation de concentré (kg/vache) par JEL par date" ||
					worksheetName == "Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum" ||
					worksheetName == "Pobranie paszy treściwej (kg/krowę) wg DL wg daty" ||
					worksheetName == "Leftover by DIM by Date" ||
					worksheetName == "Restvoer volgens DIL volgens datum" ||
					worksheetName == "Restes par JEL par date" ||
					worksheetName == "Reste durch TIM nach datum") {
					actualByDateDashboard = true;
				}

				if (worksheetName == "Milk yield (kg/cow) by DIM" ||
					worksheetName == "Production laitière (kg/vache) en fonction du stade de lactation" ||
					worksheetName == "Milchleistung (kg/Kuh) nach tim" ||
					worksheetName == "Melkproductie (kg/koe) volgens DIL" ||
					worksheetName == "BSK (kg/cow) by DIM" ||
					worksheetName == "BSK (kg/vache) par DIM" ||
					worksheetName == "BSK (kg/Kuh) nach tim" ||
					worksheetName == "BSK (kg/koe) volgens DIL" ||
					worksheetName == "Milkings by DIM" ||
					worksheetName == "Traites en fonction du stade de lactation" ||
					worksheetName == "Melkungen nach tim" ||
					worksheetName == "Melkingen volgens DIL" ||
					worksheetName == "Milk/Milkings in DIM" ||
					worksheetName == "Lait/Traites en fonction du JEL" ||
					worksheetName == "Milch/Melkungen nach tim" ||
					worksheetName == "Melk/Melking volgens DIL" ||
					worksheetName == "Leftover by DIM" ||
					worksheetName == "Restes aliments en fonction du stade de lactation" ||
					worksheetName == "Reste nach tim" ||
					worksheetName == "Restvoer volgens DIL" ||
					worksheetName == "Concentrate intake (kg/100) by milk yield" ||
					worksheetName == "Consommation de concentré (kg/100) en fonction du stade de lactation" ||
					worksheetName == "Kraftfutteraufnahme (kg/100) nach Milchleistung" ||
					worksheetName == "Krachtvoergift (kg/100) volgens melkproductie" ||
					worksheetName == "Concentrate intake (kg/cow) by DIM" ||
					worksheetName == "Consommation de concentré (kg/vache) en fonction du stade de lactation" ||
					worksheetName == "Kraftfutteraufnahme (kg/Kuh) nach tim" ||
					worksheetName == "Krachtvoergift (kg/koe) volgens DIL") {
					actualDashboard = true;
				}
				if (worksheetName == "Average feed intake over time" || worksheetName == "Consommation moyenne d'aliments en fonction du temps" || worksheetName == "Durchschnittliche Futteraufnahme im Zeitverlauf" || worksheetName == "Gemiddelde voeropname over de tijd") {
					isFeedIntake = true;
				}
				if (!sheetNameExists) {
					parityPromise.resolve();
					parityPromiseResolved = true;
					feedNamePromise.resolve();
					feedNamePromiseResolved = true;
				} else {
					viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (response) {
						var filterValue = response.get(parityFilter).getAppliedValues();
						var feedNameFilterValue;
						if (isFeedIntake) {
							feedNameFilterValue = response.get(feedNameFilter).getAppliedValues();
							if (feedNameFilterValue && feedNameFilterValue.length) {
								feedNameFilterUrl = '&' + feedNameFilter + "=";
								for (var i = 0; i < feedNameFilterValue.length; i++) {
									var feedNameValue = encodeURIComponent(feedNameFilterValue[i].formattedValue);
									if (i == 0) {
										feedNameFilterUrl = feedNameFilterUrl + feedNameValue;
									} else {
										feedNameFilterUrl = feedNameFilterUrl + ',' + feedNameValue;
									}
								}
								feedNamePromise.resolve();
								feedNamePromiseResolved = true;
							} else {
								feedNamePromise.resolve();
								feedNamePromiseResolved = true;
							}
						} else {
							feedNamePromise.resolve();
							feedNamePromiseResolved = true;
						}

						if (actualByDateDashboard) {
							var dayFilterValue;
							var dateFilter;
							if (vm.currentLng == "de-DE") {
								dateFilter = "DAY(Datum)";
							} else if (vm.currentLng == "fr-FR") {
								dateFilter = "DAY(Date)";
							} else if (vm.currentLng == "en-GB") {
								dateFilter = "DAY(Date)";
							} else if (vm.currentLng == "en-US") {
								dateFilter = "DAY(Date)";
							} else if (vm.currentLng == "nl-NL") {
								dateFilter = "DAY(Datum)";
							} else if (vm.currentLng == "pl-PL") {
								dateFilter = "DAY(Date)";
							}
								for (var i = 0; i < response.length; i++) {
									var name = response[i].getFieldName();
									var lastMilkDayFilter;
									if (name.indexOf(dateFilter) != -1) {
										lastMilkDayFilter = name;
										break;
									}
								}
							if (lastMilkDayFilter) {
								var filter_values = response.get(lastMilkDayFilter);
								if (filter_values) {
									dayFilterValue = filter_values.getAppliedValues();
									var dayFilterValueLenght = dayFilterValue.length;
									if(dayFilterValueLenght == 1){
									dayFilterValue = moment(dayFilterValue[0].value).format('YYYY-MM-DD');
									dayFilterUrl = "&" + dayFilterName + "=" + dayFilterValue;
									}
									
									dayPromiseResolved = true;
									dayPromise.resolve();

								}
							} else {
								dayPromiseResolved = true;
								dayPromise.resolve();
							}
						} else {
							dayPromiseResolved = true;
							dayPromise.resolve();
						}

						if (actualDashboard) {
							var filterDIMParityName;
							if (vm.currentLng == "de-DE") {
								filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
							} else if (vm.currentLng == "fr-FR") {
								filterDIMParityName = "Action (Catégorie de JEL,Lactation) 1";
							} else if (vm.currentLng == "en-GB") {
								filterDIMParityName = "Action (DIM Category,Parity) 1";
							} else if (vm.currentLng == "en-US") {
								filterDIMParityName = "Action (DIM Category,Parity) 1";
							} else if (vm.currentLng == "nl-NL") {
								filterDIMParityName = "Action (Dagen in lactatie,Pariteit) 1";
							} else if (vm.currentLng == "pl-PL") {
								filterDIMParityName = "Action (DIM Category,Parity) 1";
							}
							var filterDimParityPresent;
							for (var i = 0; i < response.length; i++) {
								var name = response[i].getFieldName();
								if (name == filterDIMParityName) {
									filterDimParityPresent = true;
								}
							}
							if (filterDimParityPresent) {
								var filterDimParityNameValue = response.get(filterDIMParityName).getAppliedValues();
							} else {
								filterDimParityNameValue = null;
							}

							if (filterDimParityNameValue && filterDimParityNameValue.length == 1) {
								var splitted = filterDimParityNameValue[0].formattedValue.split(',');
								parityFilterUrl = "&" + parityFilter + "=" + splitted[1].trim();
								DIMFilterUrl = "&" + DIMCategoryFilterName + "=" + splitted[0].trim();
								DIMPromise.resolve();
								dimPromiseResolved = true;
								parityPromise.resolve();
								parityPromiseResolved = true;
							} else {
								DIMPromise.resolve();
								dimPromiseResolved = true;

								if (filterValue.length != 3) {
									if (worksheetName != "RAP Herd prestations actual (ani1)1" && worksheetName != "Prestations réelles pour le troupeau RAP (ani1)1" && worksheetName != "RAP tatsächliche Herdvorhersage (ani1)1" && worksheetName != "RAP kuddeprestaties actueel (ani1)1") {
										parityFilterUrl = '&' + parityFilter + "=";
										for (var i = 0; i < filterValue.length; i++) {
											if (i == 0) {
												parityFilterUrl = parityFilterUrl + filterValue[i].formattedValue;
											} else {
												parityFilterUrl = parityFilterUrl + ',' + filterValue[i].formattedValue;
											}
										}
									}
									parityPromise.resolve();
									parityPromiseResolved = true;
								} else {
									parityPromise.resolve();
									parityPromiseResolved = true;
								}
							}
						} else {
							DIMPromise.resolve();
							dimPromiseResolved = true;
							if (filterValue.length != 3) {
								if (worksheetName != "RAP Herd prestations actual (ani1)1" && worksheetName != "Prestations réelles pour le troupeau RAP (ani1)1" && worksheetName != "RAP tatsächliche Herdvorhersage (ani1)1" && worksheetName != "RAP kuddeprestaties actueel (ani1)1") {
									parityFilterUrl = '&' + parityFilter + "=";
									for (var i = 0; i < filterValue.length; i++) {
										if (i == 0) {
											parityFilterUrl = parityFilterUrl + filterValue[i].formattedValue;
										} else {
											parityFilterUrl = parityFilterUrl + ',' + filterValue[i].formattedValue;
										}
									}
								}
								parityPromise.resolve();
								parityPromiseResolved = true;
							} else {
								parityPromise.resolve();
								parityPromiseResolved = true;
							}
						}
					})
				}
				viz.getWorkbook().getParametersAsync().then(function (parameters) {
					var groupBy;
					for (var i = 0; i < parameters.length; i++) {
						if (parameters[i].getName() == groupByParam) {
							groupBy = parameters[i].getCurrentValue().formattedValue;
							break;
						}
					}
					if (groupBy) {
						groupByFilterUrl = '&' + groupByParam + '=' + groupBy;
					}
					groupByPromise.resolve();
					groupByPromiseResolved = true;
				})
				var legendExist = false;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName() == legend) {
						legendExist = true;
						break;
					}
				}
				if (legendExist) {
					wrks.get(legend).getSelectedMarksAsync().then(function (response) {
						if (response[0]) {
							var pairs = response[0].getPairs();
							var value;
							for (var i = 0; i < pairs.length; i++) {
								if (pairs[i].fieldName == groupByMetric) {
									value = pairs[i].formattedValue;
								}
							}
							if (value) {
								groupByMetricMarkUrl = '&' + groupByMetric + '=' + value;
							}
							groupByMetricPromise.resolve();
							groupByMetricPromiseResolved = true;
						} else {
							groupByMetricPromise.resolve();
							groupByMetricPromiseResolved = true;
						}
					})
				} else {
					groupByMetricPromise.resolve();
					groupByMetricPromiseResolved = true;
				}
			} catch (error) {
				console.log(error);
				parityPromise.resolve();
				groupByPromise.resolve();
				groupByMetricPromise.resolve();
				feedNamePromise.resolve();
				DIMPromise.resolve();
				dayPromise.resolve();
				parityPromiseResolved = false;
				groupByPromiseResolved = false;
				groupByMetricPromiseResolved = false;
				feedNamePromiseResolved = false;
				dimPromiseResolved = false;
				dayPromiseResolved = false;
			}
		}

		function setEntry(filterUrl) {
			var start_date;
			if (vm.actualDashboardOpen) {
				start_date = moment(vm.actual_start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
			} else {
				start_date = moment(vm.start_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
			}
			var end_date = moment(vm.end_date).hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
			if (vm.currentEntry) {
				var obj = {
					id: vm.currentEntry.id,
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: vm.currentEntry.locale,
					dashboardId: vm.currentEntry.dashboardId,
					filter: filterUrl
				}
				return rapService.updateReportEntry(obj.id, obj).then(function (response) {
					closeModal();
				}).catch(function (error) {
					console.log(error);
					vm.addToReportModalLoading = false;
				})
				closeModal();
			} else {
				var lng = vm.currentLng;
				var date = moment().hour(0).minute(0).seconds(0).milliseconds(0).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z";
				var obj = {
					date: date,
					herdId: vm.selectedHerds[0],
					comment: vm.modalComment,
					endDate: end_date,
					startDate: start_date,
					locale: lng,
					dashboardId: vm.currentSheet,
					filter: filterUrl
				}
				return rapService.addToReport(obj).then(function (response) {
					closeModal();
				}).catch(function (error) {
					console.log(error)
					vm.addToReportModalLoading = false;
				})
			}
		}

		function showStartEndDate(dashboard) {
			var show = true;
			if (isActualByDate(dashboard)) {
				show = false;
			}
			return show;
		}

		function isActualByDate(obj) {
			var isActual = false;
			if (obj.index == 943 || obj.index == 944 || obj.index == 945 || obj.index == 946 || obj.index == 947 || obj.index == 948 || obj.index == 949) {
				isActual = true;
			}
			return isActual;
		}

		function toDataURL(url, callback, prm) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				var reader = new FileReader();
				reader.onloadend = function () {
					callback(reader.result);
				}
				if (xhr.status == 200 || xhr.status == 204) {
					reader.readAsDataURL(xhr.response);
				} else {
					vm[prm].reject();
				}
			};
			xhr.open('GET', url);
			xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
			xhr.responseType = 'blob';
			xhr.withCredentials = true;
			xhr.send();
		}
		$scope.$on('default_herd_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			setDates();
			
			init();
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.teamReselected = true;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
				viz.removeEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve("cancel_request");
				}

				setDates();
				init();
			}, 100)

		});
		$scope.$on('default_values_loaded', function () {
			if (teamTimeout) {
				$timeout.cancel(teamTimeout)
			}
			var newDefaultValues = localStorage.getItem('default_values');
			if (newDefaultValues != JSON.stringify(vm.defaultValues)) {
				init();
			}
		})
		$scope.$on('$destroy', function () {
			var expires = new Date();
			expires.setFullYear(expires.getFullYear() - 1);
			cookiesService.setCookie('rap_actual_dates', null, {
				samesite: "lax",
				domain: ".mmmooogle.com",
				expires: expires
			});
			if (timeout) {
				timeout.resolve("cancel_request");
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.removeEventListener(tableau.TableauEventName.PARAMETER_VALUE_CHANGE);
				viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.rap').factory('rapService', rapService);
    /** @ngInject */
    function rapService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setTableauTenant: setTableauTenant
            , setSession: setSession
            , getHerdsByTeam: getHerdsByTeam
            , addToReport: addToReport
            , getReports: getReports
            , updateReportEntry: updateReportEntry
            , loadedDashboards: {}
            , herds: []
            , laodedHerds: {}
            , allDashboards: {}
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }

        function setTableauTenant(team_id) {
            //production
            //return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/cookie' ,{withCredentials: true}).then(success).catch(error);
            //staging
            return $http.post(APP_CONSTANTS.tableau_base_url + team_id + '/session', {}, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function getHerdsByTeam(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function addToReport(obj){
            return $http.post(APP_CONSTANTS.tableau_reports_base_url+'/reportentry', obj, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function getReports(suffix){
            return $http.get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function updateReportEntry(id, obj){
             return $http.put(APP_CONSTANTS.tableau_reports_base_url+'/reportentry/' + id, obj, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
	'use strict';
	angular.module('My.pages.reproduction').controller('reproductionCtrl', reproductionCtrl);
	/** @ngInject */
	function reproductionCtrl($timeout, herdDashboardsService, reproductionService, $q, APP_CONSTANTS, $rootScope, $http, $uibModalStack, $uibModal, $scope, $filter) {
		var vm = this;
		var teamTimeout;
		var mapTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName = "Herd Parameter";
		var clawHealthDashboardFilterPairs = APP_CONSTANTS.constants.clawHealthDashboardFilterPairs;
		vm.openRangeSelector = openRangeSelector;
		vm.setRange = setRange;
		vm.closeModal = closeModal;
		vm.setRange = setRange;
		vm.init = init;
		setDates();
		init();


		function init() {
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout)
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		};

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		};

		function getDashboards(team_id) {
			var dashboards = angular.copy(herdDashboardsService.tableauStored);
			//local testing
			/*dashboards.dashboards = [{
				"id": "Reproductiondashboard",
				"description": "Reproduction dashboard",
				"category": "reproduction",
				"subcategory": "module",
				"locale": "en-GB",
				"url": "https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB"
			}];
			dashboards.team_id = team_id;
			dashboards.expires = new Date("2100-12-31");*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(function (data) {
				var tableauSuffix = '?locale=' + vm.currentLng;
				return reproductionService.getDashboards(team_id, tableauSuffix).then(function (response) {
					var obj = {
						dashboards: response,
						expires: moment().add(30, 'minutes').format(),
						team_id: team_id
					}
					herdDashboardsService.tableauStored = obj;
					localStorage.removeItem('tableauLoading');
					$rootScope.$broadcast('tableau_loaded');
					processDashboards(response, team_id);
				}).catch(function (error) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				})
			}, function (error) {
				if (!vm.teamReselected) {
					localStorage.removeItem('tableauLoading');
					vm.loadingDashboards = false;
					vm.errorLoading = true;
				} else {
					vm.teamReselected = false;
				}
			});
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession, url = APP_CONSTANTS.tableau_base_url + team_id + '/session'
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var reproDashboardId = "Reproductiondashboard";
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].category == "reproduction" && response[i].id == reproDashboardId) {
						vm.reproDashboard = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.reproDashboard;
				if (team_id == 2756 || team_id == 2757) {
					if (vm.reproDashboard) {
						embedPage(vm.reproDashboard, true);
						mapTimeout = $timeout(function () {
							var height = document.getElementById('panel-map').offsetHeight;
							if (height == 666) {
								try {
									var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
									var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
									if (bodyWidth > 767) {
										var newHeight = bodyHeight - 300;
										document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
										var newHeightFrame = bodyHeight - 330;
										document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
										document.getElementById('frame').style.height = newHeightFrame + 'px';
									} else {
										var newHeight = bodyHeight - 435;
										document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
										var newHeightFrame = bodyHeight - 465;
										document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
										document.getElementById('frame').style.height = newHeightFrame + 'px';
									}
								} catch (error) {
									console.log(error);
								}
							}
						}, 0)
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.noAvailableDashboards = true;
					}
				} else {
					vm.reproDashboard = {
						"id": "Reproductiondashboard",
						"description": "Reproduction dashboard",
						"category": "reproduction",
						"subcategory": "module",
						"locale": "en-GB",
						"url": "https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB"
					}
					embedPage(vm.reproDashboard);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0)

				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		};

		function embedPage(dashboard, useTabvis) {
			console.log('use tabvis:' + useTabvis);
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return reproductionService.setSession(url).then(function (response) {
						vm.loadingDashboards = false;
						vm.showButtons = true;
						var url = response.headers('tabvis-location');
						embed(url, herds, useTabvis)

					}).catch(function (response) {
						vm.embed = null;
						vm.errorLoading = true;
						vm.loading = false;
						console.log('error getting tabvis-location header')
					})
				} else {

					var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-2756-reproduction-module_en-GB_twb/Reproductiondashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					embed(url, herds, useTabvis)
				}
			}

		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					"Start Date": $filter('date')(vm.start_date, "yyyy-MM-dd"),
					"End Date": $filter('date')(vm.end_date, "yyyy-MM-dd"),
					onFirstInteractive: function () {

						viz.getWorkbook().getParametersAsync().then(function (parameters) {
							console.log(parameters)
						})

					}
				}

				options[herdParamName] = herdParam;

				$timeout(function () {
					var containerDiv = document.getElementById("frame");
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
				}, 1000)

			}
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += (" " + herds[i]);
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}

				viz.getWorkbook().getParametersAsync().then(function (parameters) {
					console.log(parameters)
				})
				viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
					console.log(filter)
				})
			}
		}
		function getActiveFilterName(dashboard) {
			var filter;
			var list = clawHealthDashboardFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].dashboard == dashboard && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}


		function openRangeSelector() {
			if (!vm.disableCategoryButtons) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				var dates = {
					start_date: vm.start_date,
					end_date: vm.end_date
				}
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}


		function applyParameters(start_date_changed, end_date_changed) {
			var end_date = vm.end_date;
			var start_date = vm.start_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
					})
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			})
		}
		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}
				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						viz.getWorkbook().changeParameterValueAsync(herdParamName, herdParam);
					} else {
						init();
					}
				}
			}, 750)
		});

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve("cancel_request");
				}

				init();
			}, 100)
		});


		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve("cancel_request");
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});

	}
})();

(function () {
    'use strict';
    angular.module('My.pages.reproduction').factory('reproductionService', reproductionService);
    /** @ngInject */
    function reproductionService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular.module("My.settings").controller("settingsCtrl", settingsCtrl);
  /** @ngInject */
  function settingsCtrl(
    APP_CONSTANTS,
    $cookies,
    $timeout,
    cookiesService,
    tmhDynamicLocale,
    localize,
    $rootScope
  ) {
    var vm = this;

    var auto = {
      name: "Auto",
      code: "auto",
      image: "robot-line-icon.png",
    };

    vm.save = save;

    init();

    function init() {
      vm.loading = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      setLanguages();
      checkSelectedLanguage(vm.user.email);

      $timeout(function () {
        vm.loading = false;
      }, 100);
    }

    function setLanguages() {
      var languages = APP_CONSTANTS.constants.languages;
      vm.languages = [auto].concat(languages);
    }

    function checkSelectedLanguage(email) {
      var name = email.concat("_lng");
      var cookie = $cookies.getObject(name);
      if (cookie) {
        console.log(cookie);

        var lng_index = vm.languages.findIndex(function (item) {
          return item.code == cookie;
        });

        if (lng_index != -1) {
          vm.currentLanguage = vm.languages[lng_index];
        } else {
          vm.currentLanguage = auto;
        }
      } else {
        vm.currentLanguage = auto;
      }
    }

    function save() {
      if (vm.user && vm.user.email) {
        var name = vm.user.email.concat("_lng");

        var expires = new Date("2100-03-27");
        var value = vm.currentLanguage.code;

        if (value) {
          cookiesService.setCookie(name, JSON.stringify(value), {
            samesite: "strict",
            expires: expires,
          });
        }

        if (value == "auto") {
          var userLang = navigator.language || navigator.userLanguage;
          userLang = userLang.toLowerCase();
          var lng;
          if (userLang.indexOf("en") != -1) {
            if (userLang == "en-gb") {
              lng = "en-GB";
            } else if (userLang == "en-us") {
              lng = "en-US";
            } else {
              lng = "en-GB";
            }
          } else if (userLang.indexOf("nl") != -1) {
            if (userLang == "nl-nl") {
              lng = "nl-NL";
            } else {
              lng = "nl-NL";
            }
          } else if (userLang.indexOf("de") != -1) {
            if (userLang == "de-de") {
              lng = "de-DE";
            } else {
              lng = "de-DE";
            }
          } else if (userLang.indexOf("fr") != -1) {
            if (userLang == "fr-fr") {
              lng = "fr-FR";
            } else {
              lng = "fr-FR";
            }
          } else if (userLang.indexOf("es") != -1) {
            if (userLang == "es-es") {
              lng = "es-ES";
            } else {
              lng = "es-ES";
            }
          } else if (userLang.indexOf("ja") != -1) {
            lng = "ja-JP";
          } else if (userLang.indexOf("pl") != -1) {
            lng = "pl-PL";
          } else if (userLang.indexOf("cs") != -1) {
            lng = "cs-CZ";
          } else {
            lng = "en-GB";
          }

          value = lng;
        }
      }
      localStorage.setItem("lng", value);
      tmhDynamicLocale.set(value);
      localize.setLanguage(value);
      $rootScope.$broadcast("update_sidebar");
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.robotView")
    .controller("robotViewCtrl", robotViewCtrl);
  /** @ngInject */
  function robotViewCtrl(
    $timeout,
    $q,
    APP_CONSTANTS,
    $http,
    robotViewService,
    $filter,
    $rootScope,
    $uibModal,
    $uibModalStack,
    $scope,
    $interval,
    cookiesService,
    dashboardsService,
    toastr,
    $location,
    Upload,
    $cookies
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var fatParam = $filter("number")(4.3, 2);
    var proteinParam = $filter("number")(3.4, 2);
    var teamTimeout;
    var timeout;
    var mapTimeout;
    var reloadTimeout;
    var viz;
    var workbook;
    var fatParamName;
    var proteinParamName;
    var tmrParamName;
    var dmParamName;
    var oldName;
    var newName;
    var parityFilter;
    var filterName;
    var milkYieldActual;
    var sppActual;
    var concentrateActualByYield;
    var concentrateActualByFeed;
    var herdPrestationsActual;
    var leftoversActual;
    var leftoversActualTable;
    var leftoversActualMilkSpeed;
    var milkingsActual;
    var milkMilkingsActual;
    var feedNameFilter;
    var concActualByMilk;
    var milkYieldActualByDate;
    var sppActualByDate;
    var milkingsActualByDate;
    var milkMilkingsActualByDate;
    var concentrateActualByYieldByDate;
    var concentrateActualByFeedByDate;
    var leftoversActualByDate;
    var resetAllParities;
    var groupByParam;
    var groupByMetric;
    var legend;
    var DIMCategoryFilterName;
    var dayFilterName;
    var robotPrestations;
    var robotPrestationsTrend;
    var refusals;
    var failures;
    var milkingTime;
    var milkingTimePercentage;
    var freeTime;
    var freeTimePercentage;
    var avgMilkingSpeed;
    var maxMilkingSpeed;
    var fatChanged;
    var TMRchanged;
    var TMR;
    var DryMatterChanged;
    var DryMatter;
    var proteinChanged;
    var herdsPromise;
    var dashboardsPromise;
    var addToReportPromise;
    var parityPromise;
    var groupByPromise;
    var groupByMetricPromise;
    var DIMPromise;
    var dayPromise;
    var feedNamePromise;
    var measureNamePromise;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var sheetNameList = APP_CONSTANTS.constants.sheetNamePairs;
    var actualDashboardName;
    var measureParameterName;
    var actualDashboardFilterPromise;
    var actualDashboardFilterName;
    vm.openRangeSelector = openRangeSelector;
    vm.closeModal = closeModal;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.setRange = setRange;
    vm.openCreateReport = openCreateReport;
    vm.showStartEndDate = showStartEndDate;
    vm.closeCreateReport = closeCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.openReportDashboardDayModal = openReportDashboardDayModal;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.setActualReportDate = setActualReportDate;
    vm.setReportData = setReportData;
    vm.init = init;
    vm.hideMissingDataMessage = hideMissingDataMessage;
    vm.sendErrorInfo = sendErrorInfo;
    init();

    function init() {
      setStrings();
      setDates();
      setDashboardIdList();
      vm.showCreateReportButton = false;
      vm.disableRangeSelector = true;
      vm.actualDashboardOpen = false;
      vm.showCreateReportBlock = false;
      vm.reportError = false;
      vm.showActualCurrentDateMessage = false;
      vm.showMissingDataMessage = false;
      vm.showDPMessage = false;
      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.dashboards = [];
      vm.errorLoading = false;
      vm.loadingDashboards = true;
      vm.showButtons = false;
      vm.noAvailableDashboards = false;
      vm.reselectTeamError = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == 'cs-CZ') {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.work_locally = false;
      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function setStrings() {
      fatParamName = i18nFilter("_dashboard_filter_fat_");
      proteinParamName = i18nFilter("_dashboard_filter_protein_");
      tmrParamName = i18nFilter("_dashboard_filter_TMR_concentrate_");
      dmParamName = i18nFilter("_dashboard_filter_dry_matter_");
      oldName = i18nFilter("_dashboard_name_rap_main_herd_overview_");
      newName = i18nFilter("_dashboard_name_rap_herd_dashboard_");
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      filterName = i18nFilter("_dashboard_name_filter_");
      milkYieldActual = i18nFilter("_dashboard_name_milk_yield_actual_");
      sppActual = i18nFilter("_dashboard_name_spp_actual_");
      concentrateActualByYield = i18nFilter(
        "_dashboard_name_conc_actual_yield_"
      );
      concentrateActualByFeed = i18nFilter("_dashboard_name_conc_actual_feed_");
      herdPrestationsActual = i18nFilter(
        "_dashboard_name_herd_prestations_actual_"
      );
      leftoversActual = i18nFilter("_dashboard_name_leftovers_actual_");
      leftoversActualTable = i18nFilter(
        "_dashboard_name_leftovers_actual_table_"
      );
      leftoversActualMilkSpeed = i18nFilter(
        "_dashboard_name_leftovers_actual_milk_speed_"
      );
      milkingsActual = i18nFilter("_dashboard_name_milkings_actual_");
      milkMilkingsActual = i18nFilter(
        "_rap_workbook_name_milk_milkings_actual_"
      );
      feedNameFilter = i18nFilter("_dashboard_name_filter_feed_name_");
      concActualByMilk = i18nFilter(
        "_rap_workbook_name_concentrate_actual_by_milk_production_"
      );
      milkYieldActualByDate = i18nFilter(
        "_dashboard_name_milk_yield_actual_by_date_robot_view_"
      );
      sppActualByDate = i18nFilter("_dashboard_name_spp_actual_by_date_");
      milkingsActualByDate = i18nFilter(
        "_dashboard_name_milkings_actual_by_date_"
      );
      milkMilkingsActualByDate = i18nFilter(
        "_rap_workbook_name_milk_milkings_actual_by_date_"
      );
      concentrateActualByYieldByDate = i18nFilter(
        "_dashboard_name_conc_actual_yield_by_date_"
      );
      concentrateActualByFeedByDate = i18nFilter(
        "_dashboard_name_conc_actual_feed_by_date_"
      );
      leftoversActualByDate = i18nFilter(
        "_dashboard_name_leftovers_actual_by_date_robot_view_"
      );
      resetAllParities = i18nFilter("_rap_reset_all_parities_");
      groupByParam = i18nFilter("_dashboard_name_parameter_group_by_");
      groupByMetric = i18nFilter("_dashboard_name_mark_group_by_metric_");
      legend = i18nFilter("_rap_workbook_name_legend_");
      DIMCategoryFilterName = i18nFilter(
        "_dashboard_name_parameter_dim_category_"
      );
      dayFilterName = i18nFilter("_dashboard_name_parameter_date_");
      robotPrestations = i18nFilter(
        "_dashboard_name_robot_prestations_dashboard_"
      );
      robotPrestationsTrend = i18nFilter(
        "_dashboard_name_robot_prestations_trend_dashboard_"
      );
      refusals = i18nFilter("_animal_details_refusal_");
      failures = i18nFilter("_animal_details_failures_");
      milkingTime = i18nFilter("_rap_milking_time_");
      milkingTimePercentage = i18nFilter("_rap_milking_time_percentage_");
      freeTime = i18nFilter("_rap_free_time_");
      freeTimePercentage = i18nFilter("_rap_free_time_percentage_");
      avgMilkingSpeed = i18nFilter("_rap_average_milking_speed_");
      maxMilkingSpeed = i18nFilter("_rap_max_milking_speed_");
      actualDashboardName = "Actual dashboard";
      measureParameterName = "Measure name parameter";
      actualDashboardFilterName = i18nFilter("_dashboard_actual_filter_name_");
    }

    function setDates() {
      vm.end_date = new Date(
        moment()
          .hour(23)
          .minute(59)
          .seconds(59)
          .millisecond(999)
          .subtract(2, "days")
      );
      vm.start_date = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(
            32, "days")
          .toISOString()
      );
      vm.actual_start_date = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(9, "days")
          .toISOString()
      );
      vm.init_start_date = new Date(
        moment()
          .hour(0)
          .minute(0)
          .seconds(1)
          .millisecond(1)
          .subtract(32, "days")
          .toISOString()
      );
    }

    function setDashboardIdList() {
      var dashboardIdList = angular.copy(
        APP_CONSTANTS.constants.dashboardIdList
      );
      for (var i = 0; i < dashboardIdList.length; i++) {
        dashboardIdList[i].name = i18nFilter(dashboardIdList[i].name);
        dashboardIdList[i].id = i18nFilter(dashboardIdList[i].id);
      }
      vm.dashboardIdList = dashboardIdList;
    }

    function getDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = [];
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return robotViewService
        .setTableauTenant(team_id)
        .then(function(response){
          if (response && response.token) {
            var expireDate = moment();
            expireDate.add(10, "hours");
            expireDate = new Date(expireDate);
            cookiesService.setCookie("dashboard_token", response.token, {
              samesite: "none",
              secure: true,
              domain: ".mmmooogle.com",
              expires: expireDate,
            });
          }
          if (
            dashboardsService &&
            dashboardsService.loadedDashboards.dashboards &&
            dashboardsService.loadedDashboards.team_id == team_id &&
            dashboardsService.loadedDashboards.lng == vm.currentLng
          ) {
            if (
              moment(dashboardsService.loadedDashboards.expires).isBefore(
                moment()
              )
            ) {
              useAPI(team_id);
            } else {
              var dashboards = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                dashboards
              );
              processDashboards(dashboards, team_id);
            }
          } else {
            useAPI(team_id);
          }
        })
        .catch(function(error){
          console.log(error);
          if (!vm.teamReselected) {
            vm.loadingDashboards = false;
            vm.errorLoading = true;
          } else {
            vm.teamReselected = false;
          }
        })
        
      }
    }

    function useAPI(team_id) {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return robotViewService
            .getDashboards(team_id, tableauSuffix)
            .then(function (response) {
              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              processDashboards(response, team_id);
            })
            .catch(function (error) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            });
    }

    function processDashboards(response, team_id) {
      if (response.length > 0) {
        var dashboard;
        for (var i = 0; i < response.length; i++) {
          if (
            response[i].subcategory == "rap-fame-v3" &&
            (response[i].id == "RAPHerddashboard" ||
              response[i].id == "RAPBedrijfsdashboard" ||
              response[i].id == "RAPHerdentabelle" ||
              response[i].id == "TableaudeborddutroupeauRAP"||
              response[i].id == "PulpitdanychstadaRAP")
          ) {
            dashboard = response[i];
            break;
          }
        }
        vm.allDashboards = response;
        vm.mapActive = dashboard;
        if (dashboard) {
          embedPage(dashboard);
          mapTimeout = $timeout(function () {
            var containerDiv = document.getElementById("panel-map");
            var height;
            if (containerDiv) {
              height = containerDiv.offsetHeight;
            }
            if (height == 666) {
              try {
                var bodyHeight =
                  window.innerHeight ||
                  document.documentElement.clientHeight ||
                  document.body.clientHeight;
                var bodyWidth =
                  window.innerWidth ||
                  document.documentElement.clientWidth ||
                  document.body.clientWidth;
                if (bodyWidth > 767) {
                  var newHeight = bodyHeight - 300;
                  document.getElementById("panel-map").firstChild.style.height =
                    newHeight + "px";
                  var newHeightFrame = bodyHeight - 330;
                  document.getElementById("dashboard-area").style.height =
                    newHeightFrame + "px";
                  document.getElementById("frame").style.height =
                    newHeightFrame + "px";
                } else {
                  var newHeight = bodyHeight - 435;
                  document.getElementById("panel-map").firstChild.style.height =
                    newHeight + "px";
                  var newHeightFrame = bodyHeight - 465;
                  document.getElementById("dashboard-area").style.height =
                    newHeightFrame + "px";
                  document.getElementById("frame").style.height =
                    newHeightFrame + "px";
                }
              } catch (error) {
                console.log(error);
              }
            }
          }, 0);
        } else {
          vm.embed = null;
          vm.loadingDashboards = false;
          vm.noAvailableDashboards = true;
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function embedPage(dashboard) {
      sendShowPanicButtonEvent(false);
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.disableRangeSelector = true;
        vm.showActualCurrentDateMessage = false;
        vm.currentSheetName = angular.copy(dashboard.description);
        vm.currentSheet = getDashboardIdByName(dashboard.description);
        vm.loadingDashboards = false;
        var url = dashboard.url;
        vm.workSheetName = dashboard.description;
        embed(url);
      }
    }

    function embed(url) {
      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(
          tableau.TableauEventName.PARAMETER_VALUE_CHANGE
        );
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.dispose();
      }

      if (vm.work_locally) {
        var url =
          "https://visual-prd.mmmooogle.com/t/Production/views/team-3182-production-rap-fame-v3_en-GB_twb/RAPHerddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        //var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
        //var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-2756-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
        //var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-52-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

        openDashboard(url, deviceType);
      } else {
        return robotViewService
          .setSession(url)
          .then(function (response) {
            vm.loadingDashboards = false;
            vm.showButtons = true;
            var url = response.headers("tabvis-location");
            openDashboard(url, deviceType);
          })
          .catch(function (response) {
            vm.disableRangeSelector = false;
            console.log("error getting tabvis-location header");
          });
      }
    }

    function openDashboard(url, deviceType) {
      if (url) {
        url = url + "&:render=true&:refresh=yes";
        var options = {
          "herd param": vm.selectedHerds[0],
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          device: deviceType,
          onFirstInteractive: function () {
            $timeout(function () {
              vm.disableRangeSelector = false;
              vm.disableAddToReport = false;
              vm.showMissingDataMessage = false;
              sendShowPanicButtonEvent(true);
            }, 100);
            workbook = viz.getWorkbook();
            var wrks = workbook.getActiveSheet().getWorksheets();
            var worksheetName;
            for (var i = 0; i < wrks.length; i++) {
              if (wrks[i].getName()) {
                worksheetName = wrks[i].getName();
                break;
              }
            }

            var plc;
            for (var i = 0; i < wrks.length; i++) {
              if (wrks[i].getName() == "plc") {
                plc = true;
              }
            }
            var filterDIMParityName;
            if (vm.currentLng == "de-DE") {
              filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
            } else if (vm.currentLng == "fr-FR") {
              filterDIMParityName = "Action (Catégorie de JEL,Lactation) 1";
            } else if (vm.currentLng == "en-GB") {
              filterDIMParityName = "Action (DIM Category,Parity) 1";
            } else if (vm.currentLng == "en-US") {
              filterDIMParityName = "Action (DIM Category,Parity) 1";
            } else if (vm.currentLng == "nl-NL") {
              filterDIMParityName = "Action (DIM Categorie,Pariteit) 1";
            } else if (vm.currentLng == "pl-PL") {
              filterDIMParityName = "Action (Kategoria DL,Laktacja) 1";
            }
            if (plc) {
              console.log('plc');
              wrks
                .get("plc")
                .applyFilterAsync(
                  filterDIMParityName,
                  "",
                  tableau.FilterUpdateType.ALL
                );
            }

            /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					})*/

            vm.actualDashboardOpen = false;
            vm.showAddToReportButton = false;
            $timeout(function () {
              vm.showCreateReportButton = true;
            }, 200);
            viz
              .getWorkbook()
              .getActiveSheet()
              .getWorksheets()
              .get(worksheetName)
              .getFiltersAsync()
              .then(function (filter) {
                for (var i = 0; i < filter.length; i++) {
                  var name = filter[i].getFieldName();
                  var lastMilkDayFilter;
                  if (name && name.indexOf("(lastDate)") != -1) {
                    lastMilkDayFilter = name;
                  }
                }
                if (lastMilkDayFilter) {
                  var filter_values = filter.get(lastMilkDayFilter);
                  if (filter_values) {
                    var last_date = filter_values.getDomainMax();
                    last_date = last_date.value;
                    checkLastMilkDate(last_date);
                  }
                }
              });
          },
        };

        if (vm.selectedHerds && vm.selectedHerds.length == 1) {
          options.HerdIdentifier = vm.selectedHerds[0];
        }

        options[fatParamName] = 4.3;
        options[proteinParamName] = 3.4;
        options[tmrParamName] = 0;
        $timeout(function () {
          var containerDiv = document.getElementById("rapFrame");
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.PARAMETER_VALUE_CHANGE,
            onParameterChange
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarksSelection
          );
        }, 100);
      }
    }

    function onTabSwitch(marksEvent) {
      vm.disableRangeSelector = false;
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      if (marksEvent.getEventName() == "tabswitch") {
        vm.showAddToReportButton = true;
        vm.showActualCurrentDateMessage = false;
        vm.disableAddToReport = false;
        vm.showMissingDataMessage = false;
        var wrks = marksEvent
          .getViz()
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets();
        var worksheetName;
        //get name of one of the worksheets
        var list = [];
        var sheetNameExists;
        var worksheetName = getSheetNameByTransitionName(newSheetName);
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName() == worksheetName) {
            sheetNameExists = true;
            break;
          }
        }
        if (!sheetNameExists) {
          worksheetName = wrks[0].getName();
        }
        var currentSheet = newSheetName;
        vm.currentSheetName = angular.copy(currentSheet);
        vm.currentSheet = getDashboardIdByName(currentSheet);
        /*viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});

				viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});*/
        if (newSheetName == newName) {
          var filterDIMParityName;
          if (vm.currentLng == "de-DE") {
            filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
          } else if (vm.currentLng == "fr-FR") {
            filterDIMParityName = "Action (Catégorie de JEL,Lactation) 1";
          } else if (vm.currentLng == "en-GB") {
            filterDIMParityName = "Action (DIM Category,Parity) 1";
          } else if (vm.currentLng == "en-US") {
            filterDIMParityName = "Action (DIM Category,Parity) 1";
          } else if (vm.currentLng == "nl-NL") {
            filterDIMParityName = "Action (DIM Categorie,Pariteit) 1";
          } else if (vm.currentLng == "pl-PL") {
            filterDIMParityName = "Action (Kategoria DL,Laktacja) 1";
          }
          var plc;
          for (var i = 0; i < wrks.length; i++) {
            if (wrks[i].getName() == "plc") {
              plc = true;
            }
          }
          if (plc) {
            viz
              .getWorkbook()
              .getActiveSheet()
              .getWorksheets()
              .get("plc")
              .applyFilterAsync(
                filterDIMParityName,
                "",
                tableau.FilterUpdateType.ALL
              );
            
          }

          vm.showCreateReportButton = true;
          $timeout(function () {
            vm.start_date = angular.copy(vm.init_start_date);
          });
          vm.actualDashboardOpen = false;
        } else if (
          newSheetName == milkYieldActual ||
          newSheetName == sppActual ||
          newSheetName == concentrateActualByYield ||
          newSheetName == concentrateActualByFeed ||
          newSheetName == milkingsActual ||
          newSheetName == herdPrestationsActual ||
          newSheetName == leftoversActual ||
          newSheetName == leftoversActualTable ||
          newSheetName == leftoversActualMilkSpeed ||
          newSheetName == milkingsActual ||
          newSheetName == milkMilkingsActual ||
          newSheetName == concActualByMilk
        ) {
          vm.actualDashboardOpen = true;
          vm.showCreateReportButton = false;
          $timeout(function () {
            vm.start_date = angular.copy(vm.actual_start_date);
          }, 0);
        } else if (
          newSheetName == milkYieldActualByDate ||
          newSheetName == sppActualByDate ||
          newSheetName == milkingsActualByDate ||
          newSheetName == milkMilkingsActualByDate ||
          newSheetName == concentrateActualByYieldByDate ||
          newSheetName == concentrateActualByFeedByDate ||
          newSheetName == leftoversActualByDate
        ) {
          vm.showCreateReportButton = false;
          $timeout(function () {
            vm.disableRangeSelector = true;
          }, 50);
          marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(worksheetName)
            .getFiltersAsync()
            .then(function (filter) {
              var dateFilter;
              if (vm.currentLng == "de-DE") {
                dateFilter = "DAY(Datum)";
              } else if (vm.currentLng == "fr-FR") {
                dateFilter = "DAY(Date)";
              } else if (vm.currentLng == "en-GB") {
                dateFilter = "DAY(Date)";
              } else if (vm.currentLng == "en-US") {
                dateFilter = "DAY(Date)";
              } else if (vm.currentLng == "nl-NL") {
                dateFilter = "DAY(Datum)";
              } else if (vm.currentLng == "pl-PL") {
                dateFilter = "DAY(Data)";
              }
              for (var i = 0; i < filter.length; i++) {
                var name = filter[i].getFieldName();
                var lastMilkDayFilter;
                if (name && name.indexOf(dateFilter) != -1) {
                  lastMilkDayFilter = name;
                  break;
                }
              }

              if (lastMilkDayFilter) {
                var filter_values = filter.get(lastMilkDayFilter);
                if (filter_values) {
                  var day = filter_values.getAppliedValues();
                  if (day.length == 1) {
                    day = day[0].value;
                    vm.actualFilterValue = {
                      type: 1,
                      day: new Date(day),
                      dim: null,
                      parity: null,
                    };
                    showActualDateMessage();
                  }
                }
              }
            });
        } else if (
          newSheetName == "Feed Intake" ||
          newSheetName == "Alimentation" ||
          newSheetName == "Futteraufnahme" ||
          newSheetName == "Pobranie paszy" ||
          newSheetName == "Voeropname"
        ) {
          marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(worksheetName)
            .clearFilterAsync(feedNameFilter);
          vm.showCreateReportButton = false;
          $timeout(function () {
            vm.start_date = angular.copy(vm.init_start_date);
          });
          vm.actualDashboardOpen = false;
        } else if (
          newSheetName == robotPrestations ||
          newSheetName == robotPrestationsTrend
        ) {
          vm.showCreateReportButton = false;
          $timeout(function () {
            vm.start_date = angular.copy(vm.init_start_date);
          });
          vm.actualDashboardOpen = false;

          if (newSheetName == robotPrestations) {
            checkMissingDataMessage(1);
          } else {
            checkMissingDataMessage(2);
          }
        } else if (newSheetName == actualDashboardName) {
          marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(worksheetName)
            .getFiltersAsync()
            .then(function (response) {
              var filterValueLength;
              for (var i = 0; i < response.length; i++) {
                var name = response[i].getFieldName();
                var dimLacFilter;
                if (
                  (name && name.indexOf("(TIM-Kategorie,Laktation)") != -1) ||
                  name.indexOf("(DIM Category,Parity)") != -1 ||
                  name.indexOf("(Catégorie de JEL,Lactation)") != -1 ||
                  name.indexOf("(DIM Categorie,Pariteit)") != -1 ||
                  name.indexOf("(Kategoria DL,Laktacja)") != -1
                ) {
                  dimLacFilter = name;
                  break;
                }
              }
              if (dimLacFilter) {
                var filter_values = response.get(dimLacFilter);
                if (filter_values) {
                  var dimLac = filter_values.getAppliedValues();
                  var filterValueLength = dimLac.length;
                  if (filterValueLength == 1) {
                    dimLac = dimLac[0].formattedValue;
                    var splited = dimLac.split(",");
                    vm.actualFilterValue = {
                      type: 2,
                      day: null,
                      dim: splited[0].trim(),
                      parity: splited[1].trim(),
                    };
                  }
                }
              }
              showActualDateMessage();
            });
        } else {
          vm.showCreateReportButton = false;
          $timeout(function () {
            vm.start_date = angular.copy(vm.init_start_date);
          });
          vm.actualDashboardOpen = false;
        }
      }
    }

    function checkMissingDataMessage(dashboard) {
      // 1 - robot prestations
      // 2 - robot prestations trend

      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var herd = vm.selectedHerds[0];
        if (herd == 750 || herd == 794 || herd == 795) {
          var found = false;
          var cookie = $cookies.getObject(vm.user.email);
          var value = vm.selectedHerds[0] + "/" + dashboard;
          if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {
            for (var i = 0; i < cookie.DNSAL.length; i++) {
              if (cookie.DNSAL[i] == value) {
                found = true;
                break;
              }
            }
          }
          vm.doNotShowAgain = false;
          vm.missingDataMessageDashboard = dashboard;
          vm.missingDataColumns = [];
          var list;
          if (herd == 750) {
            if (dashboard == 1) {
              list = [refusals];
            } else if (dashboard == 2) {
              found = true;
            }
          } else if (herd == 794) {
            if (dashboard == 1) {
              list = [
                milkingTime,
                milkingTimePercentage,
                freeTime,
                freeTimePercentage,
                avgMilkingSpeed,
                maxMilkingSpeed,
                refusals,
                failures,
              ];
            } else if (dashboard == 2) {
              list = [freeTime];
            }
          } else if (herd == 795) {
            if (dashboard == 1) {
              list = [
                milkingTime,
                milkingTimePercentage,
                freeTime,
                freeTimePercentage,
                avgMilkingSpeed,
                maxMilkingSpeed,
                refusals,
                failures,
              ];
            } else if (dashboard == 2) {
              list = [freeTime];
            }
          }
          vm.missingDataColumns = angular.copy(list);
          $timeout(function () {
            if (!found) {
              vm.showMissingDataMessage = true;
            }
          }, 10);
        }
      }
    }

    function hideMissingDataMessage() {
      vm.showMissingDataMessage = false;
      if (vm.doNotShowAgain) {
        var cookie = $cookies.getObject(vm.user.email);
        var value = vm.selectedHerds[0] + "/" + vm.missingDataMessageDashboard;
        if (cookie && cookie.DNSAL && cookie.DNSAL.length > 0) {
          cookie.DNSAL.push(value);
        } else {
          cookie.DNSAL = [value];
        }

        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 365);
        cookiesService.setCookie(vm.user.email, JSON.stringify(cookie), {
          samesite: "strict",
          expires: expireDate,
        });
      }
    }

    function onParameterChange(event) {
      event.getParameterAsync().then(function (parameter) {
        if (event.getParameterName() == fatParamName) {
          fatChanged = true;
        } else if (event.getParameterName() == proteinParamName) {
          proteinChanged = true;
        } else if (event.getParameterName() == tmrParamName) {
          TMR = parameter.getCurrentValue().value;
          TMRchanged = true;
        } else if (event.getParameterName() == dmParamName) {
          DryMatterChanged = true;
          DryMatter = parameter.getCurrentValue().value;
        }
      });
    }
    function onMarksSelection(event) {
      if (event.getWorksheet().getName() == resetAllParities) {
        $timeout(function () {
          vm.showActualCurrentDateMessage = false;
        }, 0);
      }
    }

    function showActualDateMessage() {
      $timeout(function () {
        vm.showActualCurrentDateMessage = true;
      }, 100);
    }

    function checkLastMilkDate(last_milk_date) {
      var lmd = moment(last_milk_date)
        .hour(23)
        .minute(59)
        .seconds(59)
        .millisecond(999);
      var end_date = moment()
        .year(vm.end_date.getFullYear())
        .month(vm.end_date.getMonth())
        .date(vm.end_date.getDate())
        .hour(23)
        .minute(59)
        .seconds(59)
        .millisecond(999);
      if (moment(lmd).isBefore(end_date)) {
        $timeout(function () {
          vm.showDPMessage = true;
        }, 200);
        vm.end_date = new Date(lmd);
        vm.actual_start_date = new Date(moment(lmd).subtract(7, "days"));
        vm.init_start_date = new Date(moment(lmd).subtract(30, "days"));
        if (vm.actualDashboardOpen) {
          vm.start_date = angular.copy(vm.actual_start_date);
        }
        var dates = {
          start_date: vm.start_date,
          end_date: vm.end_date,
        };
        cookiesService.setCookie("rap_actual_dates", JSON.stringify(dates), {
          samesite: "lax",
          domain: ".mmmooogle.com",
        });
      }
    }

    function getSheetNameByTransitionName(currentName) {
      var sheetName;
      for (var i = 0; i < sheetNameList.length; i++) {
        if (sheetNameList[i].sheet_name_transition == currentName) {
          sheetName = sheetNameList[i].sheet_name;
          break;
        }
      }
      return sheetName;
    }

    function getDashboardIdByName(name) {
      var found;
      var id;
      for (var i = 0; i < vm.dashboardIdList.length; i++) {
        if (name == vm.dashboardIdList[i].name) {
          found = true;
          id = vm.dashboardIdList[i].id;
          break;
        }
      }
      if (found) {
        return id;
      } else {
        return null;
      }
    }

    function clearfilters(worksheet_name) {
      if (vm.herdIdentifierFilterUsed) {
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(worksheet_name)
          .clearFilterAsync("HerdIdentifier");
        vm.herdIdentifierFilterUsed = false;
      }

      viz.getWorkbook().changeParameterValueAsync("herd param", 0);
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(worksheet_name)
        .applyFilterAsync(parityFilter, "", tableau.FilterUpdateType.ALL);
      vm.vm.selectedHerds = [];
      $rootScope.$broadcast("deselect_all_herds");
      checkStartEndDate();
    }

    function checkStartEndDate() {
      var c_start_date = angular.copy(vm.init_start_date);
      var c_end_date = angular.copy(vm.end_date);
      var start_changed;
      var end_changed;
      setDates();
      if (!moment(c_start_date).isSame(vm.start_date)) {
        start_changed = true;
      }
      if (!moment(c_end_date).isSame(vm.end_date)) {
        end_changed = true;
      }
      if (start_changed && end_changed) {
        viz
          .getWorkbook()
          .changeParameterValueAsync("Start Date", $filter("date")(vm.start_date, "yyyy-MM-dd"))
          .then(function (param) {
            viz
              .getWorkbook()
              .changeParameterValueAsync("End Date", $filter("date")(vm.end_date, "yyyy-MM-dd"))
              .then(function (param) {
                checkParameters();
              });
          });
      } else if (start_changed && !end_changed) {
        viz
          .getWorkbook()
          .changeParameterValueAsync("Start Date", $filter("date")(vm.start_date, "yyyy-MM-dd"))
          .then(function (param) {
            checkParameters();
          });
      } else if (!start_changed && end_changed) {
        viz
          .getWorkbook()
          .changeParameterValueAsync("End Date", $filter("date")(vm.end_date, "yyyy-MM-dd"))
          .then(function (param) {
            checkParameters();
          });
      } else {
        checkParameters();
      }
    }

    function checkParameters() {
      var changeFat = false;
      var changeProtein = false;
      var changeTMR = false;
      viz
        .getWorkbook()
        .getParametersAsync()
        .then(function (parameters) {
          for (var i = 0; i < parameters.length; i++) {
            if (parameters[i].getName() == fatParamName) {
              if (parameters[i].getCurrentValue().formattedValue != fatParam) {
                changeFat = true;
              }
            }
            if (parameters[i].getName() == proteinParamName) {
              if (
                parameters[i].getCurrentValue().formattedValue != proteinParam
              ) {
                changeProtein = true;
              }
            }
            if (parameters[i].getName() == tmrParamName) {
              if (parameters[i].getCurrentValue().formattedValue != 0) {
                changeTMR = true;
              }
            }
          }
          checkFatParameter(changeFat, changeProtein, changeTMR);
        });
    }

    function checkFatParameter(changeFat, changeProtein, changeTMR) {
      if (changeFat) {
        viz
          .getWorkbook()
          .changeParameterValueAsync(fatParamName, fatParam)
          .then(function (parameter) {
            fatChanged = false;
            checkProteinParameter(changeProtein, changeTMR);
          });
      } else {
        checkProteinParameter(changeProtein, changeTMR);
      }
    }

    function checkProteinParameter(changeProtein, changeTMR) {
      if (changeProtein) {
        viz
          .getWorkbook()
          .changeParameterValueAsync(proteinParamName, proteinParam)
          .then(function (parameter) {
            proteinChanged = false;
            checkTMRParameter(changeTMR);
          });
      } else {
        checkTMRParameter(changeTMR);
      }
    }
    function checkTMRParameter(changeTMR) {
      if (changeTMR) {
        viz
          .getWorkbook()
          .changeParameterValueAsync(tmrParamName, 0)
          .then(function (parameter) {
            TMRchanged = false;
            checkDMParameter();
          });
      } else {
        checkDMParameter();
      }
    }

    function openRangeSelector() {
      if (!vm.disableRangeSelector) {
        vm.modal_start_date = angular.copy(vm.start_date);
        vm.modal_end_date = angular.copy(vm.end_date);
        openModal("app/pages/rap/rangeSelector.modal.html", "sm");
      }
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal("app/pages/rap/reportRangeSelector.modal.html", "sm");
    }

    function openReportDashboardDayModal(index) {
      vm.setDateModalLoading = false;
      vm.report_modal_date = angular.copy(
        vm.reportDashboards[index].report_date
      );
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      openModal("app/pages/rap/daySelector.modal.html", "sm");
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/rap/reportComment.modal.html", "sm");
    }

    function checkDMParameter() {
      if (DryMatterChanged) {
        viz
          .getWorkbook()
          .changeParameterValueAsync(dmParamName, 0)
          .then(function (parameter) {
            DryMatterChanged = false;
          });
      }
    }

    function setRange() {
      var start_date_changed = false;
      var end_date_changed = false;
      if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
        start_date_changed = true;
      }
      if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
        end_date_changed = true;
      }
      var range_error = checkRangeError(
        vm.actualDashboardOpen,
        vm.modal_start_date,
        vm.modal_end_date
      );
      if (!range_error) {
        vm.start_date = angular.copy(vm.modal_start_date);
        vm.end_date = angular.copy(vm.modal_end_date);
        if (vm.actualDashboardOpen) {
          vm.actual_start_date = new Date(
            moment(vm.end_date).subtract(7, "days").toISOString()
          );
          vm.start_date = angular.copy(vm.actual_start_date);
          vm.init_start_date = new Date(
            moment(vm.end_date)
              .subtract(30, "days")
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .toISOString()
          );
          start_date_changed = true;
          var dates = {
            start_date: vm.start_date,
            end_date: vm.end_date,
          };
          cookiesService.setCookie("rap_actual_dates", JSON.stringify(dates), {
            samesite: "lax",
            domain: ".mmmooogle.com",
          });
        } else {
          vm.init_start_date = angular.copy(vm.start_date);
          vm.actual_start_date = new Date(
            moment(vm.end_date)
              .subtract(7, "days")
              .hour(0)
              .minute(0)
              .seconds(1)
              .millisecond(1)
              .toISOString()
          );
        }
        if (vm.mapActive) {
          applyParameters(start_date_changed, end_date_changed);
          vm.showActualCurrentDateMessage = false;
        }
        closeModal();
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function applyParameters(start_date_changed, end_date_changed) {
      var start_date;
      var end_date = vm.end_date;
      if (vm.actualDashboardOpen) {
        start_date = vm.init_start_date;
      } else {
        start_date = vm.start_date;
      }
      if (viz) {
        if (start_date_changed && end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync("Start Date", $filter("date")(start_date, "yyyy-MM-dd"))
            .then(function (param) {
              viz
                .getWorkbook()
                .changeParameterValueAsync("End Date", $filter("date")(end_date, "yyyy-MM-dd"))
                .then(function (param) {
                  getLastMilkDate();
                });
            });
        } else if (start_date_changed && !end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync("Start Date", $filter("date")(start_date, "yyyy-MM-dd"))
            .then(function (param) {
              getLastMilkDate();
            });
        } else if (!start_date_changed && end_date_changed) {
          viz
            .getWorkbook()
            .changeParameterValueAsync("End Date", $filter("date")(end_date, "yyyy-MM-dd"))
            .then(function (param) {
              getLastMilkDate();
            });
        }
      }
    }

    function getLastMilkDate() {
      var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
      if (worksheetName) {
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (filter) {
            for (var i = 0; i < filter.length; i++) {
              var name = filter[i].getFieldName();
              var lastMilkDayFilter;
              if (name && name.indexOf("(lastDate)") != -1) {
                lastMilkDayFilter = name;
              }
            }
            if (lastMilkDayFilter) {
              var filter_values = filter.get(lastMilkDayFilter);
              if (filter_values) {
                var last_date = filter_values.getDomainMax();
                last_date = last_date.value;
                checkLastMilkDate(last_date);
              }
            }
          });
      }
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function openAddToReportModal() {
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/rap/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1 && vm.selectedTeam) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds[0];
        suffix = suffix + "&Date=" + date;

        if (vm.work_locally) {
          var response = [];
          handleReports(init, createReport, response);
        } else {
          return robotViewService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              if (createReport) {
                addToReportPromise.reject();
              }
            });
        }
      } else {
        if (createReport) {
        } else {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleActualDashboards(added);
      vm.addedToReport = added;
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleActualDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (id && (id.indexOf("Actualdashboard|") != -1 || id.indexOf("Aktualnypulpitnawigacyjny|") != -1 ) ) {
            reports.entries[i].actualDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter +=
              "&" + measureParameterName + "=" + splitted[1].trim();
            reports.entries[i].mnp = splitted[1].trim();
          }
        }
      }

      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (
            added.entries[i].locale != lng ||
            added.entries[i].dashboardId == "Herdprestationsactual" ||
            added.entries[i].dashboardId == "Prestationsrellespourletroupeau" ||
            added.entries[i].dashboardId == "tatschlicheHerdenvorhersage" ||
            added.entries[i].dashboardId == "Aktualnystanstada" ||
            added.entries[i].dashboardId == "Kuddeprestatiesactueel"
          ) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            if (added.entries[i].dashboardId == "Actualdashboard" || added.entries[i].dashboardId == "Aktualnypulpitnawigacyjny") {
              added.entries[i] = setCurrentLngActualDashboard(added.entries[i]);
            }
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (addToReportPromise) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var hasActual = false;
      var actualIndex;
      var actualList = [];
      var regularList = [];
      var reportList = [];

      list.forEach(function (item) {
        var found = false;
        addedToReport.forEach(function (reportItem) {
          if (item.id == reportItem.dashboardId) {
            var obj = angular.copy(item);
            found = true;
            obj.comment = reportItem.comment;
            obj.end_date = new Date(reportItem.endDate);
            obj.start_date = new Date(reportItem.startDate);
            obj.entry_id = reportItem.id;
            obj.filter = reportItem.filter;
            obj.report_date = isActualByDate(item)
              ? setActualDate(reportItem.filter)
              : undefined;
            obj.selected = true;
            if (item.id == "Actualdashboard" || item.id == "Aktualnypulpitnawigacyjny") {
              obj.id = reportItem.dashboardId;
              obj.description = decodeURIComponent(reportItem.mnp);
              obj.url = item.url;
            }

            reportList.push(obj);
          }
        });

        if (!found) {
          reportList.push(item);
        }
      });

      return reportList;
    }

    function setActualDate(filter) {
      var splitted = filter.split("&");
      var dateFilterStr;
      for (var i = 0; i < splitted.length; i++) {
        if (splitted[i].indexOf(dayFilterName) != -1) {
          dateFilterStr = splitted[i].trim();
        }
      }
      var date;
      if (dateFilterStr) {
        var splitedDate = dateFilterStr.split("=");
        date = new Date(splitedDate[1]);
      } else {
        date = vm.end_date;
      }
      return date;
    }

    function setActualByDate(dashboards) {
      var list = angular.copy(dashboards);
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (isActualByDate(list[i])) {
          if (!list[i].filter) {
            list[i].filter =
              "&" +
              dayFilterName +
              "=" +
              moment(list[i].report_date).format("YYYY-MM-DD");
          }
        }
      }
      return list;
    }

    function isActualByDate(obj) {
      var isActual = false;
      if (
        obj.index == 943 ||
        obj.index == 944 ||
        obj.index == 945 ||
        obj.index == 946 ||
        obj.index == 947 ||
        obj.index == 948 ||
        obj.index == 949
      ) {
        isActual = true;
      }
      return isActual;
    }

    function showStartEndDate(dashboard) {
      var show = true;
      if (isActualByDate(dashboard)) {
        show = false;
      }
      return show;
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var groupByParameterString;
      var groupByMetricString;
      var feedNameFilterString;
      var DIMCatrgoryFilterString;
      var dateFilterString;
      for (var i = 0; i < splitted.length; i++) {
        if (
          (splitted[i] && splitted[i].indexOf("Group by=") != -1) ||
          splitted[i].indexOf("Groupé par=") != -1 ||
          splitted[i].indexOf("Gruppierungen nach=") != -1 ||
          splitted[i].indexOf("Grupa według=") != -1 ||
          splitted[i].indexOf("Groepeer op=") != -1
        ) {
          groupByParameterString = splitted[i].trim();
        }
        if (
          (splitted[i] && splitted[i].indexOf("Parity=") != -1) ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Parytet=") != -1 ||
          splitted[i].indexOf("Laktacja=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i].trim();
        }
        if (
          (splitted[i] &&
            splitted[i].indexOf("Nach Metrik gruppieren=") != -1) ||
          splitted[i].indexOf("Groepeer op kengetal=") != -1 ||
          splitted[i].indexOf("Grouper par métrique=") != -1 ||
          splitted[i].indexOf("Group by metric=") != -1
        ) {
          groupByMetricString = splitted[i].trim();
        }
        if (
          (splitted[i] && splitted[i].indexOf("Feed name=") != -1) ||
          splitted[i].indexOf("Name des Futters=") != -1 ||
          splitted[i].indexOf("Nom de l'aliment=") != -1 ||
          splitted[i].indexOf("Voer naam=") != -1
        ) {
          feedNameFilterString = splitted[i].trim();
        }
        if (
          (splitted[i] && splitted[i].indexOf("TIM-Kategorie=") != -1) ||
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1 ||
          splitted[i].indexOf("Kategoria DL=") != -1
        ) {
          DIMCatrgoryFilterString = splitted[i].trim();
        }
        if (
          (splitted[i] && splitted[i].indexOf("Datum=") != -1) ||
          splitted[i].indexOf("Date=") != -1 ||
          splitted[i].indexOf("Data=") != -1
        ) {
          dateFilterString = splitted[i].trim();
        }
      }
      var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
      var parity;
      var groupBy;
      var groupByValue;
      var groupByValueTranslateString;
      var groupByMetricValue;
      var DIMCategoryValue;
      var feedName;
      var dateValue;
      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "group_by" &&
          filtersLngList[i].lng == lng
        ) {
          groupBy = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "group_by_value" &&
          filtersLngList[i].lng == lng
        ) {
          if (
            groupByParameterString &&
            groupByParameterString.indexOf(filtersLngList[i].name) != -1
          ) {
            groupByValue = filtersLngList[i].name;
            groupByValueTranslateString = filtersLngList[i].translate_string;
          }
        }
        if (
          filtersLngList[i].internal_id == "feed_name" &&
          filtersLngList[i].lng == lng
        ) {
          feedName = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "group_by_metric" &&
          filtersLngList[i].lng == lng
        ) {
          groupByMetricValue = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategoryValue = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date" &&
          filtersLngList[i].lng == lng
        ) {
          dateValue = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (groupBy && groupByParameterString) {
        groupByParameterString = changeFilterNameLanguage(
          groupByParameterString,
          groupBy,
          groupByParam
        );
      }
      if (
        groupByParameterString &&
        groupByValue &&
        groupByValueTranslateString
      ) {
        groupByParameterString = changeFilterNameLanguage(
          groupByParameterString,
          groupByValue,
          i18nFilter(groupByValueTranslateString)
        );
      }
      if (groupByMetricValue && groupByMetricString) {
        groupByMetricString = changeFilterNameLanguage(
          groupByMetricString,
          groupByMetricValue,
          groupByMetric
        );
      }
      if (feedName && feedNameFilterString) {
        feedNameFilterString = changeFilterNameLanguage(
          feedNameFilterString,
          feedName,
          feedNameFilter
        );
      }
      filterString = "";
      if (parityFilterString) {
        if (
          dashboard_id != "Herdprestationsactual" &&
          dashboard_id != "Prestationsrellespourletroupeau" &&
          dashboard_id != "tatschlicheHerdenvorhersage" &&
          dashboard_id != "Aktualnystanstada" &&
          dashboard_id != "Kuddeprestatiesactueel"
        ) {
          filterString += "&" + parityFilterString;
        }
      }
      if (DIMCategoryValue && DIMCatrgoryFilterString) {
        DIMCatrgoryFilterString = changeFilterNameLanguage(
          DIMCatrgoryFilterString,
          DIMCategoryValue,
          DIMCategoryFilterName
        );
      }
      if (dateValue && dateFilterString) {
        dateFilterString = changeFilterNameLanguage(
          dateFilterString,
          dateValue,
          dayFilterName
        );
      }

      if (groupByParameterString) {
        filterString += "&" + groupByParameterString;
      }
      if (groupByMetricString) {
        filterString += "&" + groupByMetricString;
      }
      if (feedNameFilterString) {
        filterString += "&" + feedNameFilterString;
      }
      if (DIMCatrgoryFilterString) {
        filterString += "&" + DIMCatrgoryFilterString;
      }
      if (dateFilterString) {
        filterString += "&" + dateFilterString;
      }
      return filterString;
    }

    function setCurrentLngActualDashboard(entry) {
      if (
        entry.mnp &&
        (entry.mnp == "Milkings%20" ||
          entry.mnp == "Melkingen" ||
          entry.mnp == "Udoje%20" ||
          entry.mnp == "Melkvorg%C3%A4nge")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_milkings_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Animals" ||
          entry.mnp == "Tiere" ||
          entry.mnp == "Animaux" ||
          entry.mnp == "Zwierz%C4%99ta" ||
          entry.mnp == "Dieren")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_animals_hpa_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Milk%20yield%20%28kg%29" ||
          entry.mnp == "Melk%20productie%20%28kg%29" ||
          entry.mnp == "Wydajno%C5%9B%C4%87%20mleczna%20%28kg%29" ||
          entry.mnp == "Milchleistung%20%28kg%29" ||
          entry.mnp == "Rendement%20en%20lait%20%28kg%29")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_milk_yield_");
      }

      if (entry.mnp && (entry.mnp == "SPP" || entry.mnp == "BSK"|| entry.mnp == "SPS")) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_spp_num_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "M%2FMilking" ||
          entry.mnp == "Melk%2FMelking" ||
          entry.mnp == "M%2Fud%C3%B3j" ||
          entry.mnp == "M%2FMelkung")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_m_milking_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Speed" ||
          entry.mnp == "Melksnelheid" ||
          entry.mnp == "Geschwindigkeit" ||
          entry.mnp == "Szybko%C5%9B%C4%87" ||
          entry.mnp == "Vitesse%20de%20traite")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_speed_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Refusals" ||
          entry.mnp == "Weigeringen" ||
          entry.mnp == "Veweigerungen" ||
          entry.mnp == "Odrzucenia" ||
          entry.mnp == "Refus")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_refusals_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Failures" ||
          entry.mnp == "Mislukkingen" ||
          entry.mnp == "Niepowodzenia" ||
          entry.mnp == "Ausf%C3%A4lle" ||
          entry.mnp == "%C3%89checs")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_failures_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "%25Leftover" ||
          entry.mnp == "Restvoer%20kg" ||
          entry.mnp == "%25%20Reste" ||
          entry.mnp == "%25Reszta" ||
          entry.mnp == "%25%20de%20reste")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_leftovers_");
      }

      if (
        entry.mnp &&
        (entry.mnp == "Concentrate%20Intake%20%28kg%2F100kg%29" ||
          entry.mnp == "Krachtvoergift%20%28kg%2F100kg%29" ||
          entry.mnp == "Kraftfutteraufnahme%20%28kg%2F100%20kg%29" ||
          entry.mnp == "Pobranie%20paszy%20tre%C5%9Bciwej%20%28kg%2F100kg%29" ||
          entry.mnp == "Consommation%20de%20concentr%C3%A9s%20%28kg%2F100kg%29")
      ) {
        entry.mnp = i18nFilter(
          "_dashboard_actual_filter_value_c_intake_kg_100_"
        );
      }

      if (
        entry.mnp &&
        (entry.mnp == "Concentrate%20intake%20%28kg%29" ||
          entry.mnp == "Krachtvoergift%20%28kg%29" ||
          entry.mnp == "Pobranie%20paszy%20tre%C5%9Bciwej%20%28kg%29" ||
          entry.mnp == "Kraftfutteraufnahme%20%28kg%29" ||
          entry.mnp == "Consommation%20de%20concentr%C3%A9s%20%28kg%29")
      ) {
        entry.mnp = i18nFilter("_dashboard_actual_filter_value_c_intake_kg_");
      }
      if (entry.mnp) {
        entry.filter += "&" + measureParameterName + "=" + entry.mnp;
      }
      return entry;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (
            added.entries[i].locale != lng ||
            added.entries[i].dashboardId == "Herdprestationsactual" ||
            added.entries[i].dashboardId == "Prestationsrellespourletroupeau" ||
            added.entries[i].dashboardId == "tatschlicheHerdenvorhersage" ||
            added.entries[i].dashboardId == "Aktualnystanstada" ||
            added.entries[i].dashboardId == "Kuddeprestatiesactueel"
          ) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            if (added.entries[i].dashboardId == "Actualdashboard" || added.entries[i].dashboardId == "Aktualnypulpitnawigacyjny") {
              added.entries[i] = setCurrentLngActualDashboard(added.entries[i]);
            }
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      //in the first implementation only one entry per dashboards was allowed
      var entry;
      handleEntry(entry);
      /*if (vm.currentSheet == 'Actualdashboard') {
				viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						var measureName;
						for (var i = 0; i < parameters.length; i++) {
							if (parameters[i].getName() == measureParameterName) {
								measureName = encode(parameters[i].getCurrentValue().formattedValue);
								break;
							}
						}

						for (var i = 0; i < vm.addedToReport.length; i++) {
							if (vm.addedToReport[i].dashboardId == vm.currentSheet && vm.addedToReport[i].mnp == measureName) {
								entry = vm.addedToReport[i];
								break;
							}
						}
						handleEntry(entry);
					});
			} else {
				
				for (var i = 0; i < vm.addedToReport.length; i++) {
					if (vm.addedToReport[i].dashboardId == vm.currentSheet) {
						entry = vm.addedToReport[i];
						break;
					}
				}
				handleEntry(entry);
			}*/
    }

    function handleEntry(entry) {
      vm.modalComment = "";
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(
        APP_CONSTANTS.constants.dashboardIdLngList
      );
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function addToReport() {
      vm.addToReportModalLoading = true;
      var filter = "";
      var parityFilterUrl = "";
      var groupByFilterUrl = "";
      var groupByMetricMarkUrl = "";
      var feedNameFilterUrl = "";
      var DIMFilterUrl = "";
      var dayFilterUrl = "";
      var measureName = "";
      var actualDashboardFilter = "";
      parityPromise = $q.defer();
      groupByPromise = $q.defer();
      groupByMetricPromise = $q.defer();
      feedNamePromise = $q.defer();
      DIMPromise = $q.defer();
      dayPromise = $q.defer();
      measureNamePromise = $q.defer();
      actualDashboardFilterPromise = $q.defer();
      var parityPromiseResolved = false;
      var groupByPromiseResolved = false;
      var groupByMetricPromiseResolved = false;
      var feedNamePromiseResolved = false;
      var dimPromiseResolved = false;
      var dayPromiseResolved = false;
      var measureNameResolved = false;
      var actualDashboardFilterResolved = false;
      var promiseTimeout;
      var isActualDashboard;

      promiseTimeout = $timeout(function () {
        if (!parityPromiseResolved) {
          parityPromise.resolve();
        }
        if (!groupByPromiseResolved) {
          groupByPromise.resolve();
        }
        if (!groupByMetricPromiseResolved) {
          groupByMetricPromise.resolve();
        }
        if (!feedNamePromiseResolved) {
          feedNamePromise.resolve();
        }
        if (!dimPromiseResolved) {
          DIMPromise.resolve();
        }
        if (!dayPromiseResolved) {
          dayPromise.resolve();
        }
        if (!measureNameResolved) {
          measureNamePromise.resolve();
        }
        if (!actualDashboardFilterResolved) {
          actualDashboardFilterPromise.resolve();
        }
      }, 7000);
      $q.all([
        parityPromise.promise,
        groupByPromise.promise,
        groupByMetricPromise.promise,
        feedNamePromise.promise,
        DIMPromise.promise,
        dayPromise,
        measureNamePromise.promise,
        actualDashboardFilterPromise.promise,
      ]).then(function () {
        if (promiseTimeout) {
          $timeout.cancel(promiseTimeout);
        }
        if (parityFilterUrl) {
          filter += parityFilterUrl;
        }
        if (groupByFilterUrl) {
          filter += groupByFilterUrl;
        }
        if (groupByMetricMarkUrl) {
          filter += groupByMetricMarkUrl;
        }
        if (feedNameFilterUrl) {
          filter += feedNameFilterUrl;
        }
        if (DIMFilterUrl) {
          filter += DIMFilterUrl;
        }
        if (dayFilterUrl) {
          filter += dayFilterUrl;
        }
        if (actualDashboardFilter) {
          filter += actualDashboardFilter;
        }
        setEntry(filter, measureName);
      });
      try {
        var worksheetName = getSheetNameByTransitionName(vm.currentSheetName);
        var sheetNameExists;
        var wrks = viz.getWorkbook().getActiveSheet().getWorksheets();
        var feedOverTimeExist = false;
        var isFeedIntake;
        var actualDashboard;
        var actualByDateDashboard;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName() == worksheetName) {
            sheetNameExists = true;
            break;
          }
        }

        if (
          worksheetName == "Milk yield (kg/cow) by DIM by Date" ||
          worksheetName == "Wydajność mleka (kg/krowę) według DL według daty" ||
          worksheetName == "Melkproductie (kg/koe) volgens DIL volgens datum" ||
          worksheetName == "Production de lait (kg/vache) par JEL par date" ||
          worksheetName == "Wydajność mleczna (kg/krowę) wg DL wg daty" ||
          worksheetName ==
            "Concentrate intake (kg/100) by milk yield by Date" ||
          worksheetName ==
            "Pobranie paszy treściwej (kg/100) wg wydajności mleka wg daty" ||
          worksheetName == "Milchproduktion (kg/Kuh) durch TIM nach datum" ||
          worksheetName == "BSK (kg/cow) by DIM by Date" ||
          worksheetName == "SPS (kg/krowa) wg dni laktacji wg daty" ||
          worksheetName == "BSK (kg/koe) volgens DIL volgens datum" ||
          worksheetName == "SPP (kg/vache) par JEL par date" ||
          worksheetName == "BSK (kg/Kuh) durch TIM nach datum" ||
          worksheetName == "SPS (kg/krowę) wg DL wg daty" ||
          worksheetName == "Milkings by DIM by Date" ||
          worksheetName == "Udoje wg DL wg daty" ||
          worksheetName == "Udoje według DL według daty" ||
          worksheetName == "Melkingen volgens DIL volgens datum" ||
          worksheetName == "Traites par JEL par date" ||
          worksheetName == "Melkungen durch TIM nach datum" ||
          worksheetName == "Milk/Milkings in DIM by Date" ||
          worksheetName == "Mleko/Udoje w dniu laktacji według daty" ||
          worksheetName == "Melk/melking in DIL volgens datum" ||
          worksheetName == "Lait/traite s en fonction du JEL par date" ||
          worksheetName == "Milch/Melkung durch TIM nach datum" ||
          worksheetName == "Concentrate intake (kg/100) by milk yield by Date" || 
          worksheetName == "Pobranie paszy treściwej (kg/100) wg wydajności mleka wg daty" || 
          worksheetName == "Pobranie paszy treściwej (kg/100) według wydajności mlecznej według daty" ||
          worksheetName ==
            "Krachtvoer opname (kg/100kg) volgens melkproductie volgens datum" ||
          worksheetName ==
            "Consommation de concentré (kg/100kg) en fonction de production en fonction par date" ||
          worksheetName ==
            "Kraftfutteraufnahme (kg/100kg) durch Leistung nach datum" ||
          worksheetName == "Concentrate intake (kg/cow) by DIM by Date" ||
          worksheetName == "Pobranie paszy treściwej (kg/krowę) wg DL wg daty" ||
          worksheetName == "Pobranie paszy treściwej (kg/krowę) według dnia laktacji według daty" ||
          worksheetName ==
            "Krachtvoer opname (kg/koe) volgens DIL volgens datum" ||
          worksheetName ==
            "Consommation de concentré (kg/vache) par JEL par date" ||
          worksheetName ==
            "Kraftfutteraufnahme (kg/Kuh) durch TIM nach datum" ||
          worksheetName == "Leftover by DIM by Date" ||
          worksheetName == "Pozostałości według dnia laktacji według daty" ||
          worksheetName == "Restvoer volgens DIL volgens datum" ||
          worksheetName == "Restes par JEL par date" ||
          worksheetName == "Reste durch TIM nach datum"
        ) {
          actualByDateDashboard = true;
        }

        if (
          worksheetName == "Milk yield (kg/cow) by DIM" ||
          worksheetName == "Wydajność mleczna (kg/krowę) według dni laktacji" ||
          worksheetName ==
            "Production laitière (kg/vache) en fonction du stade de lactation" ||
          worksheetName == "Milchleistung (kg/Kuh) nach tim" ||
          worksheetName == "Melkproductie (kg/koe) volgens DIL" ||
          worksheetName == "BSK (kg/cow) by DIM" ||
          worksheetName == "SPS (kg/krowa) wg dni laktacji" ||
          worksheetName == "BSK (kg/vache) par DIM" ||
          worksheetName == "BSK (kg/Kuh) nach tim" ||
          worksheetName == "BSK (kg/koe) volgens DIL" ||
          worksheetName == "Milkings by DIM" ||
          worksheetName == "Udoje według DL" ||
          worksheetName == "Traites en fonction du stade de lactation" ||
          worksheetName == "Melkungen nach tim" ||
          worksheetName == "Melkingen volgens DIL" ||
          worksheetName == "Milk/Milkings in DIM" ||
          worksheetName == "Mleko/Udoje w dniu laktacji" ||
          worksheetName == "Lait/Traites en fonction du JEL" ||
          worksheetName == "Milch/Melkungen nach tim" ||
          worksheetName == "Melk/Melking volgens DIL" ||
          worksheetName == "Leftover by DIM" ||
          worksheetName == "Pozostałości według DL" ||
          worksheetName ==
            "Restes aliments en fonction du stade de lactation" ||
          worksheetName == "Reste nach tim" ||
          worksheetName == "Restvoer volgens DIL" ||
          worksheetName == "Concentrate intake (kg/100) by milk yield" ||
          worksheetName == "Pobranie paszy treściwej (kg/100) według wydajności mlecznej" ||
          worksheetName ==
            "Consommation de concentré (kg/100) en fonction du stade de lactation" ||
          worksheetName == "Kraftfutteraufnahme (kg/100) nach Milchleistung" ||
          worksheetName == "Krachtvoergift (kg/100) volgens melkproductie" ||
          worksheetName == "Concentrate intake (kg/cow) by DIM" ||
          worksheetName == "Pobranie paszy treściwej (kg/krowę) według dnia laktacji" ||
          worksheetName ==
            "Consommation de concentré (kg/vache) en fonction du stade de lactation" ||
          worksheetName == "Kraftfutteraufnahme (kg/Kuh) nach tim" ||
          worksheetName == "Krachtvoergift (kg/koe) volgens DIL"
        ) {
          actualDashboard = true;
        }
        if (
          worksheetName == "Average feed intake over time" ||
          worksheetName ==
            "Consommation moyenne d'aliments en fonction du temps" ||
          worksheetName == "Durchschnittliche Futteraufnahme im Zeitverlauf" ||
          worksheetName == "Średnie spożycie paszy w czasie" ||
          worksheetName == "Gemiddelde voeropname over de tijd"
        ) {
          isFeedIntake = true;
        }
        if (worksheetName == "Graph") {
          isActualDashboard = true;
        } else {
          measureNamePromise.resolve();
          measureNameResolved = true;
        }
        if (!sheetNameExists) {
          parityPromise.resolve();
          parityPromiseResolved = true;
          feedNamePromise.resolve();
          feedNamePromiseResolved = true;
        } else {
          viz
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets()
            .get(worksheetName)
            .getFiltersAsync()
            .then(function (response) {
              if (isActualDashboard) {
                parityPromise.resolve();
                parityPromiseResolved = true;
                feedNamePromise.resolve();
                feedNamePromiseResolved = true;
                dayPromise.resolve();
                dayPromiseResolved = true;
                DIMPromise.resolve();
                dimPromiseResolved = true;
                var filterValue = response
                  .get(actualDashboardFilterName)
                  .getAppliedValues();
                var splitted = filterValue[0].formattedValue.split(",");
                actualDashboardFilter =
                  "&" +
                  DIMCategoryFilterName +
                  "=" +
                  splitted[0].trim() +
                  "&" +
                  parityFilter +
                  "=" +
                  splitted[1].trim();
                actualDashboardFilterPromise.resolve();
                actualDashboardFilterResolved = true;
              } else {
                actualDashboardFilterPromise.resolve();
                actualDashboardFilterResolved = true;
                var filterValue = response.get(parityFilter).getAppliedValues();
                var feedNameFilterValue;
                if (isFeedIntake) {
                  feedNameFilterValue = response
                    .get(feedNameFilter)
                    .getAppliedValues();
                  if (feedNameFilterValue && feedNameFilterValue.length) {
                    feedNameFilterUrl = "&" + feedNameFilter + "=";
                    for (var i = 0; i < feedNameFilterValue.length; i++) {
                      var feedNameValue = encode(
                        feedNameFilterValue[i].formattedValue
                      );
                      if (i == 0) {
                        feedNameFilterUrl = feedNameFilterUrl + feedNameValue;
                      } else {
                        feedNameFilterUrl =
                          feedNameFilterUrl + "," + feedNameValue;
                      }
                    }
                    feedNamePromise.resolve();
                    feedNamePromiseResolved = true;
                  } else {
                    feedNamePromise.resolve();
                    feedNamePromiseResolved = true;
                  }
                } else {
                  feedNamePromise.resolve();
                  feedNamePromiseResolved = true;
                }

                if (actualByDateDashboard) {
                  var dayFilterValue;
                  var dateFilter;
                  if (vm.currentLng == "de-DE") {
                    dateFilter = "DAY(Datum)";
                  } else if (vm.currentLng == "fr-FR") {
                    dateFilter = "DAY(Date)";
                  } else if (vm.currentLng == "en-GB") {
                    dateFilter = "DAY(Date)";
                  } else if (vm.currentLng == "en-US") {
                    dateFilter = "DAY(Date)";
                  } else if (vm.currentLng == "nl-NL") {
                    dateFilter = "DAY(Datum)";
                  } else if (vm.currentLng == "pl-PL") {
                    dateFilter = "DAY(Data)";
                  }
                  for (var i = 0; i < response.length; i++) {
                    var name = response[i].getFieldName();
                    var lastMilkDayFilter;
                    if (name && name.indexOf(dateFilter) != -1) {
                      lastMilkDayFilter = name;
                      break;
                    }
                  }
                  if (lastMilkDayFilter) {
                    var filter_values = response.get(lastMilkDayFilter);
                    if (filter_values) {
                      dayFilterValue = filter_values.getAppliedValues();
                      var dayFilterValueLenght = dayFilterValue.length;
                      if (dayFilterValueLenght == 1) {
                        dayFilterValue = moment(dayFilterValue[0].value).format(
                          "YYYY-MM-DD"
                        );
                        dayFilterUrl =
                          "&" + dayFilterName + "=" + dayFilterValue;
                      }

                      dayPromiseResolved = true;
                      dayPromise.resolve();
                    }
                  } else {
                    dayPromiseResolved = true;
                    dayPromise.resolve();
                  }
                } else {
                  dayPromiseResolved = true;
                  dayPromise.resolve();
                }

                if (actualDashboard) {
                  var filterDIMParityName;
                  if (vm.currentLng == "de-DE") {
                    filterDIMParityName = "Action (TIM-Kategorie,Laktation) 1";
                  } else if (vm.currentLng == "fr-FR") {
                    filterDIMParityName =
                      "Action (Catégorie de JEL,Lactation) 1";
                  } else if (vm.currentLng == "en-GB") {
                    filterDIMParityName = "Action (DIM Category,Parity) 1";
                  } else if (vm.currentLng == "en-US") {
                    filterDIMParityName = "Action (DIM Category,Parity) 1";
                  } else if (vm.currentLng == "nl-NL") {
                    filterDIMParityName = "Action (DIM Categorie,Pariteit) 1";
                  } else if (vm.currentLng == "pl-PL") {
                    filterDIMParityName = "Action (Kategoria DL,Laktacja) 1";
                  }
                  var filterDimParityPresent;
                  for (var i = 0; i < response.length; i++) {
                    var name = response[i].getFieldName();
                    if (name == filterDIMParityName) {
                      filterDimParityPresent = true;
                    }
                  }
                  if (filterDimParityPresent) {
                    var filterDimParityNameValue = response
                      .get(filterDIMParityName)
                      .getAppliedValues();
                  } else {
                    filterDimParityNameValue = null;
                  }

                  if (
                    filterDimParityNameValue &&
                    filterDimParityNameValue.length == 1
                  ) {
                    var splitted =
                      filterDimParityNameValue[0].formattedValue.split(",");
                    parityFilterUrl =
                      "&" + parityFilter + "=" + splitted[1].trim();
                    DIMFilterUrl =
                      "&" + DIMCategoryFilterName + "=" + splitted[0].trim();
                    DIMPromise.resolve();
                    dimPromiseResolved = true;
                    parityPromise.resolve();
                    parityPromiseResolved = true;
                  } else {
                    DIMPromise.resolve();
                    dimPromiseResolved = true;

                    if (filterValue.length != 3) {
                      if (
                        worksheetName !=
                          "RAP Herd prestations actual (ani1)1" &&
                        worksheetName !=
                          "Prestations réelles pour le troupeau RAP (ani1)1" &&
                        worksheetName !=
                          "RAP tatsächliche Herdvorhersage (ani1)1" &&
                        worksheetName != "RAP kuddeprestaties actueel (ani1)1"
                      ) {
                        parityFilterUrl = "&" + parityFilter + "=";
                        for (var i = 0; i < filterValue.length; i++) {
                          if (i == 0) {
                            parityFilterUrl =
                              parityFilterUrl + filterValue[i].formattedValue;
                          } else {
                            parityFilterUrl =
                              parityFilterUrl +
                              "," +
                              filterValue[i].formattedValue;
                          }
                        }
                      }
                      parityPromise.resolve();
                      parityPromiseResolved = true;
                    } else {
                      parityPromise.resolve();
                      parityPromiseResolved = true;
                    }
                  }
                } else {
                  DIMPromise.resolve();
                  dimPromiseResolved = true;
                  if (filterValue.length != 3) {
                    if (
                      worksheetName != "RAP Herd prestations actual (ani1)1" &&
                      worksheetName !=
                        "Prestations réelles pour le troupeau RAP (ani1)1" &&
                      worksheetName !=
                        "RAP tatsächliche Herdvorhersage (ani1)1" &&
                      worksheetName != "RAP kuddeprestaties actueel (ani1)1"
                    ) {
                      parityFilterUrl = "&" + parityFilter + "=";
                      for (var i = 0; i < filterValue.length; i++) {
                        if (i == 0) {
                          parityFilterUrl =
                            parityFilterUrl + filterValue[i].formattedValue;
                        } else {
                          parityFilterUrl =
                            parityFilterUrl +
                            "," +
                            filterValue[i].formattedValue;
                        }
                      }
                    }
                    parityPromise.resolve();
                    parityPromiseResolved = true;
                  } else {
                    parityPromise.resolve();
                    parityPromiseResolved = true;
                  }
                }
              }
            });
        }
        viz
          .getWorkbook()
          .getParametersAsync()
          .then(function (parameters) {
            if (isActualDashboard) {
              groupByPromise.resolve();
              groupByPromiseResolved = true;
              for (var i = 0; i < parameters.length; i++) {
                if (parameters[i].getName() == measureParameterName) {
                  measureName = parameters[i].getCurrentValue().formattedValue;
                  break;
                }
              }
              measureNamePromise.resolve();
              measureNameResolved = true;
            } else {
              var groupBy;
              for (var i = 0; i < parameters.length; i++) {
                if (parameters[i].getName() == groupByParam) {
                  groupBy = parameters[i].getCurrentValue().formattedValue;
                  break;
                }
              }
              if (groupBy) {
                groupByFilterUrl = "&" + groupByParam + "=" + groupBy;
              }
              groupByPromise.resolve();
              groupByPromiseResolved = true;
            }
          });
        var legendExist = false;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName() == legend) {
            legendExist = true;
            break;
          }
        }
        if (legendExist) {
          wrks
            .get(legend)
            .getSelectedMarksAsync()
            .then(function (response) {
              if (response[0]) {
                var pairs = response[0].getPairs();
                var value;
                for (var i = 0; i < pairs.length; i++) {
                  if (pairs[i].fieldName == groupByMetric) {
                    value = pairs[i].formattedValue;
                  }
                }
                if (value) {
                  groupByMetricMarkUrl = "&" + groupByMetric + "=" + value;
                }
                groupByMetricPromise.resolve();
                groupByMetricPromiseResolved = true;
              } else {
                groupByMetricPromise.resolve();
                groupByMetricPromiseResolved = true;
              }
            });
        } else {
          groupByMetricPromise.resolve();
          groupByMetricPromiseResolved = true;
        }
      } catch (error) {
        console.log(error);
        parityPromise.resolve();
        groupByPromise.resolve();
        groupByMetricPromise.resolve();
        feedNamePromise.resolve();
        DIMPromise.resolve();
        dayPromise.resolve();
        parityPromiseResolved = false;
        groupByPromiseResolved = false;
        groupByMetricPromiseResolved = false;
        feedNamePromiseResolved = false;
        dimPromiseResolved = false;
        dayPromiseResolved = false;
      }
    }

    function setEntry(filterUrl, paramName) {
      var start_date;
      if (vm.actualDashboardOpen) {
        start_date =
          moment(vm.actual_start_date)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      } else {
        start_date =
          moment(vm.start_date)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      }
      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentSheet + "|" + encode(paramName)
          : vm.currentSheet,
        filter: filterUrl,
      };
      return robotViewService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        dashboardsPromise = $q.defer();
        addToReportPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          dashboardsPromise.promise,
          addToReportPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            vm.reportDashboards = setActualByDate(vm.reportDashboards);
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        var herd_id = vm.selectedHerds[0];
        var team_id = vm.selectedTeam;
        checkAllDashboards(team_id);
        getAddedToReport(false, vm.reportDate, true);
        checkHerds(herd_id);
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkAllDashboards(team_id) {
      if (
        dashboardsService &&
        dashboardsService.loadedDashboards.dashboards &&
        dashboardsService.loadedDashboards.team_id == team_id &&
        dashboardsService.loadedDashboards.lng == vm.currentLng
      ) {
        vm.allReportDashboards = getRapDashboards(
          dashboardsService.loadedDashboards.dashboards
        );
        dashboardsPromise.resolve();
      } else {
        var tableauSuffix = "?locale=" + vm.currentLng;
        return robotViewService
          .getDashboards(vm.selectedTeam, tableauSuffix)
          .then(function (response) {
            vm.allReportDashboards = getRapDashboards(response);
            dashboardsPromise.resolve();
          })
          .catch(function (error) {
            dashboardsPromise.reject();
          });
      }
    }

    function getRapDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (
        var i = 0;
        i < APP_CONSTANTS.constants.dashboardIdLngList.length;
        i++
      ) {
        if (
          APP_CONSTANTS.constants.dashboardIdLngList[i].lng == currentLng &&
          APP_CONSTANTS.constants.dashboardIdLngList[i].internal_id !=
            "rap_main_herd_overview"
        ) {
          listOfDashboardsIds.push(
            APP_CONSTANTS.constants.dashboardIdLngList[i]
          );
        }
      }
      for (var i = 0; i < listOfDashboardsIds.length; i++) {
        for (var j = 0; j < dashboards.length; j++) {
          if (
            listOfDashboardsIds[i].id == dashboards[j].id &&
            dashboards[j].locale == currentLng &&
            dashboards[j].subcategory == "rap-fame-v3"
          ) {
            dashboards[j].index = listOfDashboardsIds[i].index;
            dashboards[j].selected = listOfDashboardsIds[i].selected;
            dashboards[j].default = listOfDashboardsIds[i].default;
            dashboards[j].actual = listOfDashboardsIds[i].actual;
            dashboards[j].size = listOfDashboardsIds[i].size;
            if (listOfDashboardsIds[i].actual) {
              dashboards[j].start_date = vm.actual_start_date;
            } else {
              dashboards[j].start_date = vm.init_start_date;
            }
            dashboards[j].end_date = vm.end_date;
            if (isActualByDate(dashboards[j])) {
              dashboards[j].report_date = vm.end_date;
            }
            list.push(dashboards[j]);
          }
        }
      }

      return list;
    }

    function checkHerds(herd_id) {
      return robotViewService
        .getHerdsByTeam(vm.selectedTeam)
        .then(function (response) {
          vm.currentHerdName = getHerdNameById(herd_id, response);
          herdsPromise.resolve();
        })
        .catch(function (error) {
          herdsPromise.reject();
        });
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return robotViewService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return robotViewService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setActualReportDate() {
      vm.setDateModalLoading = true;
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: vm.selectedReportDashboard.end_date,
          startDate: vm.selectedReportDashboard.start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
          filter: changeDateFilter(
            vm.selectedReportDashboard.filter,
            vm.report_modal_date
          ),
        };
        return robotViewService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].report_date =
              vm.report_modal_date;
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_date;

            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.setDateModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].filter =
          "&" +
          dayFilterName +
          "=" +
          moment(vm.report_modal_date).format("YYYY-MM-DD");
        vm.reportDashboards[vm.selectedReportDashboardIndex].report_date =
          vm.report_modal_date;
        vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
          vm.report_modal_date;
        closeModal();
      }
    }

    function changeDateFilter(filter, date) {
      var regex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
      date = moment(date).format("YYYY-MM-DD");
      filter = filter.replace(regex, date);
      return filter;
    }

    function setReportData() {
      var parser = new UAParser();
      var brw = parser.getBrowser();
      var os = parser.getOS();
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);
      var list = [];
      for (var i = 0; i < vm.reportDashboards.length; i++) {
        if (vm.reportDashboards[i].selected) {
          list.push(vm.reportDashboards[i]);
        }
      }
      vm.orderedDashboards = $filter("orderBy")(list, "index");
      var url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        var name = "pr" + i;
        vm[name] = $q.defer();
        url_promise_list.push(vm[name].promise);
        getImageUrl(vm.orderedDashboards[i].url, i, name);
      }

      function getImageUrl(url, index, name) {
        if (vm.work_locally) {
          var image_url = "assets/img/hoof_health_bcg.jpg?4564545";
          vm.orderedDashboards[index].image_url = image_url;
          vm.orderedDashboards[index].image_loaded = true;
          vm[name].resolve();
        } else {
          return robotViewService
            .setSession(url)
            .then(function (response) {
              var image_url = response.headers("tabvis-location");
              vm.orderedDashboards[index].image_url = image_url;
              vm.orderedDashboards[index].image_loaded = true;
              vm[name].resolve();
            })
            .catch(function (error) {
              vm[name].resolve();
            });
        }
      }
      $q.all(url_promise_list)
        .then(function () {
          setDataUrls(vm.orderedDashboards);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
      //}
    }

    function getDataUrl(url, index, name) {
      toDataURL(
        url,
        function (dataUrl) {
          if (dataUrl) {
            vm.orderedDashboards[index].image = dataUrl;
          } else {
            vm.orderedDashboards[index].image = null;
            vm.orderedDashboards[index].image_loaded = false;
          }

          vm[name].resolve();
        },
        name
      );
    }

    function toDataURL(url, callback, prm) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        if (xhr.status == 200 || xhr.status == 204) {
          reader.readAsDataURL(xhr.response);
        } else {
          callback(null);
        }
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.withCredentials = true;
      xhr.send();
    }

    function setImageUrl(dashboard) {
      var image_url;
      var size = "1920,1080";
      var splitted = dashboard.image_url.split("?");
      if (vm.work_locally) {
        image_url = splitted[0];
      } else {
        image_url = splitted[0] + ".png";
      }
      var start_date = moment(dashboard.start_date).format("YYYY-MM-DD");
      var end_date = moment(dashboard.end_date).format("YYYY-MM-DD");
      var herd = vm.selectedHerds[0];
      var suffix =
        "?Start%20Date=" +
        start_date +
        "&End%20Date=" +
        end_date +
        "&HerdIdentifier=" +
        herd +
        "&herd%20param=" +
        herd +
        "&:size=";
      if (dashboard.size) {
        suffix = suffix + dashboard.size;
      } else {
        suffix = suffix + size;
      }
      if (TMRchanged) {
        suffix = suffix + "&" + tmrParamName + "=" + TMR;
      }
      if (DryMatterChanged) {
        suffix = suffix + "&" + dmParamName + "=" + DryMatter;
      }
      image_url = image_url + suffix;
      if (dashboard.filter) {
        image_url = image_url + dashboard.filter;
      }
      return image_url;
    }

    function setDataUrls() {
      var image_url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        if (vm.orderedDashboards[i].image_loaded) {
          var name = "imgpr" + i;
          vm[name] = $q.defer();
          image_url_promise_list.push(vm[name].promise);
          var image_url = setImageUrl(vm.orderedDashboards[i]);
          getDataUrl(image_url, i, name);
        }
      }
      vm.logoPrm = $q.defer();
      image_url_promise_list.push(vm.logoPrm.promise);
      toDataURL(
        "assets/img/logo_mmm.png",
        function (dataUrl) {
          vm.logo = dataUrl;
          vm.logoPrm.resolve();
        },
        "logoPrm"
      );
      $q.all(image_url_promise_list)
        .then(function () {
          var date = new Date();
          date = $filter("date")(date);
          var pdfData = {
            date: date,
            logo: vm.logo,
            user: vm.user.name,
            blue: "#033384",
            green: "#99B71B",
            red: "red",
            positive_points: vm.positivePoints ? vm.positivePoints : "",
            points_to_improve: vm.pointsToImprove ? vm.pointsToImprove : "",
            herd_name: vm.currentHerdName,
            dashboards: vm.orderedDashboards,
          };
          createPDF(pdfData);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: "/",
          dashboard: "Robot View",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        vm.modalError = false;
        vm.modalLoading = true;
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function createPDF(pdfData) {
      var dd = {
        pageMargins: [20, 20, 20, 20],
        pageSize: "A4",
        content: [
          {
            image: pdfData.logo,
            width: 120,
            alignment: "left",
          },
          {
            text: i18nFilter("_report_title_robot_analysis_") + ":",
            alignment: "left",
            fontSize: 16,
            bold: true,
            color: pdfData.blue,
          },
          {
            text: pdfData.herd_name,
            alignment: "left",
            fontSize: 14,
            color: pdfData.blue,
            margin: [0, 10, 0, 0],
            italics: true,
          },
          {
            text: pdfData.date,
            alignment: "left",
            fontSize: 14,
            color: pdfData.blue,
            italics: true,
          },
          {
            table: {
              widths: ["auto", "*"],
              body: [
                [
                  {
                    text: i18nFilter("_report_robot_specialist_") + ":",
                    color: pdfData.blue,
                    fontSize: 14,
                    border: [false, false, false, true],
                    italics: true,
                    margin: [-5, 0, -5, 0],
                  },
                  {
                    text: pdfData.user,
                    color: pdfData.blue,
                    fontSize: 14,
                    border: [false, false, false, true],
                    italics: true,
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdfData.green,
            },
          },
          {
            text: i18nFilter("_report_positive_points_") + ":",
            alignment: "left",
            bold: true,
            margin: [0, 5, 15, 0],
          },
          {
            text: pdfData.positive_points,
            alignment: "left",
            pageBreak:
              (pdfData.positive_points.length > 1700 ||
                pdfData.positive_points.split(/\r\n|\r|\n/).length > 22) &&
              (pdfData.points_to_improve.length > 1700 ||
                pdfData.points_to_improve.split(/\r\n|\r|\n/).length > 22)
                ? "after"
                : false,
          },
          {
            text: i18nFilter("_report_points_to_improve_") + ":",
            alignment: "left",
            bold: true,
            margin: [0, 5, 15, 0],
          },
          {
            text: pdfData.points_to_improve,
            alignment: "left",
          },
        ],
      };
      for (var i = 0; i < pdfData.dashboards.length; i++) {
        var obj = {
          text: pdfData.dashboards[i].comment
            ? pdfData.dashboards[i].comment
            : "",
          border: [false, false, false, false],
          margin: [0, 5, 0, 10],
        };
        var table = {
          table: {
            dontBreakRows: true,
            widths: ["*"],
            body: [
              [
                {
                  border: [false, false, false, false],
                  margin: [-5, 5, -5, 10],
                  stack: [
                    {
                      margin: [0, 5, 0, 10],
                      text: isActualByDate(pdfData.dashboards[i])
                        ? pdfData.dashboards[i].description +
                          " (" +
                          $filter("date")(pdfData.dashboards[i].report_date) +
                          ")"
                        : pdfData.dashboards[i].description +
                          " (" +
                          $filter("date")(pdfData.dashboards[i].start_date) +
                          " - " +
                          $filter("date")(pdfData.dashboards[i].end_date) +
                          ")",
                      border: [false, false, false, false],
                      bold: true,
                    },
                    {
                      image: pdfData.dashboards[i].image,
                      width: 555,
                      border: [false, false, false, false],
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineColor: pdfData.green,
          },
        };
        if (
          pdfData.dashboards[i].selected &&
          pdfData.dashboards[i].image_loaded
        ) {
          dd.content.push(table);
          dd.content.push(obj);
        }
      }
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      var pdf = pdfMake.createPdf(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            try {
              pdf.open();
            } catch (error) {
              toastr.error(error);
            }
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function setSessionHandler(team_id) {
      var result = $q.defer(),
        setSession,
        url = APP_CONSTANTS.tableau_base_url + team_id + "/session";
      setSession = $http({
        method: "post",
        url: url,
        data: {},
        cache: false,
        timeout: timeout.promise,
        withCredentials: true,
      });
      setSession.success(function (data, status, headers, config) {
        result.resolve(data);
      });
      setSession.error(function (data, status, headers, config) {
        console.log("error", data);
        result.reject(data);
      });
      return result.promise;
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }
    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "robot-view") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      setDates();

      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(
          tableau.TableauEventName.PARAMETER_VALUE_CHANGE
        );
        viz.dispose();
      }
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        setDates();
        init();
      }, 500);
    });
    $scope.$on("default_values_loaded", function () {
      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      var newDefaultValues = localStorage.getItem("default_values");
      if (newDefaultValues != JSON.stringify(vm.defaultValues)) {
        init();
      }
    });
    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }
      var expires = new Date();
      expires.setFullYear(expires.getFullYear() - 1);
      cookiesService.setCookie("rap_actual_dates", null, {
        samesite: "lax",
        domain: ".mmmooogle.com",
        expires: expires,
      });
      if (timeout) {
        timeout.resolve("cancel_request");
      }
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(
          tableau.TableauEventName.PARAMETER_VALUE_CHANGE
        );
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.dispose();
      }
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.robotView').factory('robotViewService', robotViewService);
	/** @ngInject */
	function robotViewService(APP_CONSTANTS, $http, $q) {
		return {
			getDashboards: getDashboards,
			setTableauTenant: setTableauTenant,
			setSession: setSession,
			getHerdsByTeam: getHerdsByTeam,
			addToReport: addToReport,
			getReports: getReports,
			updateReportEntry: updateReportEntry,
			laodedHerds: {},
			allDashboards: {},
			loadedDashboards: {}
		};

		function getDashboards(team_id, suffix) {
			return $http
				.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
					withCredentials: true,
					timeout: 20000
				})
				.then(success)
				.catch(error);
		}

		function setTableauTenant(team_id) {
			return $http
				.post(
					APP_CONSTANTS.tableau_base_url + team_id + '/session',
					{},
					{
						withCredentials: true
					}
				)
				.then(success)
				.catch(error);
		}

		function getHerdsByTeam(team_id) {
			return $http
				.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds')
				.then(success)
				.catch(error);
		}

		function addToReport(obj) {
			return $http
				.post(APP_CONSTANTS.tableau_reports_base_url + '/reportentry', obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function getReports(suffix) {
			return $http
				.get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function updateReportEntry(id, obj) {
			return $http
				.put(APP_CONSTANTS.tableau_reports_base_url + '/reportentry/' + id, obj, {
					withCredentials: true
				})
				.then(success)
				.catch(error);
		}

		function setSession(url) {
			return $http
				.get(url, {
					withCredentials: true
				})
				.then(function (response) {
					return response;
				})
				.catch(function (error) {
					return $q.reject(error);
				});
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.streamerHealth').controller('streamerHealthCtrl', streamerHealthCtrl);
	/** @ngInject */
	function streamerHealthCtrl($timeout, APP_CONSTANTS, dashboardsService, robotViewService, $uibModal, $uibModalStack, $filter, $scope, $http, $q, toastr) {
		var vm = this;
		var viz;
		var mapTimeout;
		var timeout;
		var reloadTimeout;
		vm.init = init;
		vm.openRangeSelector = openRangeSelector;
		vm.closeModal = closeModal;
		vm.setRange = setRange;

		init();

		function init() {
			setDates();
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			if (vm.defaultValues.herd_ids) {
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.work_locally = false;
			if (vm.selectedTeam) {
				getDashboards(vm.selectedTeam);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setDates() {
			vm.end_date = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
			vm.start_date = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(1, 'years').toISOString());
		}

		function getDashboards(team_id) {
			if (vm.work_locally) {
				var dashboards = [];
				var obj = {
					dashboards: dashboards,
					expires: moment().add(30, 'minutes').format(),
					team_id: team_id,
					lng: vm.currentLng
				};
				dashboardsService.loadedDashboards = obj;
				processDashboards(dashboards, team_id);
			} else {
				if (dashboardsService && dashboardsService.loadedDashboards.dashboards && dashboardsService.loadedDashboards.team_id == team_id && dashboardsService.loadedDashboards.lng == vm.currentLng) {
					if (moment(dashboardsService.loadedDashboards.expires).isBefore(moment())) {
						useAPI(team_id);
					} else {
						var dashboards = [];
						angular.copy(dashboardsService.loadedDashboards.dashboards, dashboards);
						processDashboards(dashboards, team_id);
					}
				} else {
					useAPI(team_id);
				}
			}
		}

		function useAPI(team_id) {
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return robotViewService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id,
								lng: vm.currentLng
							};
							dashboardsService.loadedDashboards = obj;
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					console.log(error);
					if (!vm.teamReselected) {
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				console.log('error', data);
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			if (response.length > 0) {
				var dashboard;
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'rap-fame-v3' && (response[i].id == 'RAPHerddashboard' || response[i].id == 'RAPBedrijfsdashboard' || response[i].id == 'RAPHerdentabelle' || response[i].id == 'TableaudeborddutroupeauRAP')) {
						dashboard = response[i];
						break;
					}
				}
				vm.allDashboards = response;
				vm.mapActive = dashboard;
				if (dashboard) {
					embedPage(dashboard);
					mapTimeout = $timeout(function () {
						var containerDiv = document.getElementById('panel-map');
						var height;
						if (containerDiv) {
							height = containerDiv.offsetHeight;
						}
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('frame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard) {
			vm.disableRangeSelector = true;
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			embed(url);
		}

		function embed(url) {
			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}

			if (vm.work_locally) {
				//var url = 'https:///visual-prd.mmmooogle.com/t/Production/views/team-3091-production-rap-fame-v3_en-GB_twb/RAPHerddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				var url = 'https://visual-stg.mmmooogle.com/t/Development/views/StreamerHerdOverviewLive/StreamerHealthOverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-animal-data-quality_en-GB_twb/Eventsovertime?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-2756-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
				//var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-52-production-rap-fame-v3_nl-NL_twb/RAPBedrijfsdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

				openDashboard(url, deviceType);
			} else {
				return robotViewService
					.setSession(url)
					.then(function (response) {
						vm.loadingDashboards = false;
						vm.showButtons = true;
						//var url = response.headers('tabvis-location');
						var url = 'https://visual-stg.mmmooogle.com/t/Development/views/StreamerHerdOverviewLive/StreamerHealthOverview?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						openDashboard(url, deviceType);
					})
					.catch(function (response) {
						vm.disableRangeSelector = false;
						vm.loadingDashboards = false;
						vm.errorLoading = true;
						if (response.status == 404) {
							toastr.error('Workbook not deployed');
						}
						console.log('error getting tabvis-location header');
					});
			}
		}

		function createHerdParam(herds) {
			if (vm.selectedHerds.length == 0) {
				return 0;
			}
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function openDashboard(url, deviceType) {
			var herdParam = createHerdParam(vm.selectedHerds);
			if (url) {
				url = url + '&:render=true&:refresh=yes';
				var options = {
					// 'Start Date': $filter('date')(vm.start_date, 'yyyy-MM-dd'),
					// 'End Date': $filter('date')(vm.end_date, 'yyyy-MM-dd'),
					// 'Herd Parameter': herdParam,
					device: deviceType,
					onFirstInteractive: function () {
						$timeout(function () {
							vm.disableRangeSelector = false;
						}, 100);
					}
				};

				$timeout(function () {
					var containerDiv = document.getElementById('rapFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.STORY_POINT_SWITCH, onTabSwitch);
				}, 100);
			}
		}

		function onTabSwitch(event) {
			applyParameters(true, true, true);
		}

		function openRangeSelector() {
			if (!vm.disableRangeSelector) {
				vm.modal_start_date = angular.copy(vm.start_date);
				vm.modal_end_date = angular.copy(vm.end_date);
				openModal('app/pages/rap/rangeSelector.modal.html', 'sm');
			}
		}

		function setRange() {
			var start_date_changed = false;
			var end_date_changed = false;
			if (!moment(vm.start_date).isSame(vm.modal_start_date)) {
				start_date_changed = true;
			}
			if (!moment(vm.end_date).isSame(vm.modal_end_date)) {
				end_date_changed = true;
			}
			var range_error = checkRangeError(vm.actualDashboardOpen, vm.modal_start_date, vm.modal_end_date);
			if (!range_error) {
				vm.start_date = angular.copy(vm.modal_start_date);
				vm.end_date = angular.copy(vm.modal_end_date);
				if (vm.mapActive) {
					applyParameters(start_date_changed, end_date_changed);
				}
				closeModal();
			}
		}

		function checkRangeError(actual_open, start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(end_date)) {
				error = true;
			}
			if (!actual_open) {
				if (moment(end_date).isBefore(start_date)) {
					error = true;
				}
			}
			return error;
		}

		function applyParameters(start_date_changed, end_date_changed, story) {
			var start_date = vm.start_date;
			var end_date = vm.end_date;
			if (viz) {
				if (start_date_changed && end_date_changed) {
					viz.getWorkbook()
						.changeParameterValueAsync('Start Date', start_date)
						.then(function (param) {
							viz.getWorkbook()
								.changeParameterValueAsync('End Date', end_date)
								.then(function (param) {
									if (story && vm.selectedHerds.length > 0) {
										var herdParam = createHerdParam(vm.selectedHerds);
										viz.getWorkbook().changeParameterValueAsync('Herd Parameter', herdParam);
									}
								});
						});
				} else if (start_date_changed && !end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('Start Date', start_date);
				} else if (!start_date_changed && end_date_changed) {
					viz.getWorkbook().changeParameterValueAsync('End Date', end_date);
				}
			}
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.teamReselected = true;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}
			reloadTimeout = $timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 500);
		});

		$scope.$on('default_herd_selected', function (event, data) {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				var herdParam = createHerdParam(vm.selectedHerds);
				viz.getWorkbook().changeParameterValueAsync('Herd Parameter', herdParam);
			}
		});

		$scope.$on('$destroy', function () {
			if (reloadTimeout) {
				$timeout.cancel(reloadTimeout);
			}
			if (timeout) {
				timeout.resolve('cancel_request');
			}
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.treatments_protocols').controller('treatmentsProtocolsCtrl', treatmentsProtocolsCtrl);
	/** @ngInject */
	function treatmentsProtocolsCtrl($timeout, $scope, treatmentsProtocolsService, $uibModal, Upload, APP_CONSTANTS, $uibModalStack, $q, $filter) {
		var vm = this;
		vm.loading = true;
		vm.loadMoreImages = loadMoreImages;
		vm.openNewDiscussionModal = openNewDiscussionModal;
		vm.uploadChanged = uploadChanged;
		vm.removeSelectedFile = removeSelectedFile;
		vm.addNewFile = addNewFile;
		vm.showMenu = showMenu;
		vm.changeImportance = changeImportance;
		vm.changeIsTask = changeIsTask;
		vm.addComment = addComment;
		vm.addCommentOnEnter = addCommentOnEnter;
		vm.addTag = addTag;
		vm.removeTag = removeTag;
		vm.publishFile = publishFile;
		vm.init = init;

		var activeMenu;
		var activeMenuIndex;
		var menuActivated = false;
		var pictures;
		var comments;
		init();

		function init() {
			vm.errorLoading = false;
			menuActivated = false;
			vm.tags = [];
			vm.tagsList = [];
			angular.copy(APP_CONSTANTS.constants.tags, vm.tags);
			angular.copy(APP_CONSTANTS.constants.tags, vm.tagsList);
			vm.tagsList.shift();
			vm.settings = JSON.parse(localStorage.getItem('default_values'));

			if (vm.settings && vm.settings.herd_ids) {
				if (vm.settings.herd_ids.length == 1) {
					vm.selectedHerd = vm.settings.herd_ids[0];

					pictures = $q.defer();
					comments = $q.defer();
					getPictures();
					getComments();

					$q.all([pictures.promise, comments.promise]).then(function (response) {
						var comments = response[1].slice().reverse();
						for (var i = 0; i < vm.allPictures.length; i++) {
							for (var c = 0; c < comments.length; c++) {
								if (vm.allPictures[i].Id == comments[c].EntityId) {
									if (vm.allPictures[i].Comments) {
										vm.allPictures[i].Comments.push(comments[c])
									} else {
										vm.allPictures[i].Comments = [comments[c]];

									}
								}
							}
						}
					}).catch(function (error) {
						vm.errorLoading = true;
					})

				} else {
					vm.selectedHerd = null;
				}
			} else {
				vm.selectedHerd = null;
			}
		}

		function getPictures() {
			var suffix = '?-orderby=-imagecommentdate&';
			//tag specified for treatments / protocols
			suffix = suffix + '&Tags=treatmentsProtocols'
			return treatmentsProtocolsService.getPictures(vm.selectedHerd, suffix).then(function (response) {

				for (var i = 0; i < response.length; i++) {

					response[i].ImageCommentDate = $filter('date')(response[i].ImageCommentDate, 'yyyy-MM-ddTHH:mm:ss.sss') + 'Z';
					response[i].ImageCreated = $filter('date')(response[i].ImageCreated, 'yyyy-MM-ddTHH:mm:ss.sss') + 'Z';
					if (response[i].Tags) {
						response[i].TagsToShow = [];
						var tags = response[i].Tags.split('#');
						for (var j = 0; j < tags.length; j++) {
							for (var k = 0; k < vm.tags.length; k++) {
								if (tags[j] == vm.tags[k].value && tags[j] != '') {
									var tag_added = false;
									for (var t = 0; t < response[i].TagsToShow.length; t++) {
										if (response[i].TagsToShow[t].value == vm.tags[k].value) {
											tag_added = true;
										}
									}
									if (!tag_added) {
										response[i].TagsToShow.push(vm.tags[k]);
									}
								}
							}
						}
					}
				}
				vm.allPictures = response;
				vm.currentPage = 1;
				vm.images = setPicturesToShow(vm.allPictures, vm.currentPage);
				vm.loading = false;
				pictures.resolve();
			}).catch(function (error) {
				console.log(error);
				pictures.reject(error);
			})
		};

		function getComments() {
			return treatmentsProtocolsService.getComments(vm.selectedHerd).then(function (response) {
				comments.resolve(response);
			}).catch(function (error) {
				console.log(error);
				comments.reject(error);
			})
		}

		function setPicturesToShow(pictures, page) {
			var list = [];

			var first = (page - 1) * 100;
			var last = page * 100;

			for (var i = first; i < last; i++) {
				if (vm.allPictures[i]) {
					list.push(vm.allPictures[i]);
				} else {
					break;
				}

			}

			if (vm.allPictures[last + 1]) {
				vm.showLoadMore = true;
			} else {
				vm.showLoadMore = false;
			}
			return list;
		}

		function loadMoreImages() {
			vm.currentPage++;
			vm.images = vm.images.concat(setPicturesToShow(vm.allPictures, vm.currentPage));
		}

		function openNewDiscussionModal() {
			vm.file = null;
			vm.fileName = null;
			vm.discussion = {};
			vm.loadingNewDiscussion = false;
			vm.discussion.importance = 0;

			vm.discussion.created = new Date().toISOString();

			$uibModal.open({
				animation: true,
				templateUrl: 'app/pages/treatments_protocols/newFile.modal.html',
				size: 'md',
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			})
		}

		function uploadChanged() {
			vm.fileName = vm.file.name;
		}

		function removeSelectedFile() {
			vm.file = null;
			vm.fileName = null;
		}

		function addNewFile() {
			vm.loadingNewDiscussion = true;
			vm.discussion.herdId = vm.selectedHerd;
			var suffix = '?created=' + vm.discussion.created;

			suffix = suffix + "&tags=" + encodeURIComponent('treatmentsProtocols') + '&private=true';
			if (vm.file) {
				var url = APP_CONSTANTS.animals_base_url + 'herds/' + vm.discussion.herdId + '/pictures' + suffix;
				Upload.upload({
					url: url,
					data: {
						file: vm.file
					}
				}).then(function (response) {
					init();
					$uibModalStack.dismissAll();
				}).catch(function (error) {
					vm.loadingNewDiscussion = false;
					console.log(error)
				})
			} else {
				return cockpitService.addNewDiscussion(vm.discussion.herdId, suffix).then(function (response) {
					init();
					$uibModalStack.dismissAll();
				}).catch(function (error) {
					vm.loadingNewDiscussion = false;
					console.log(error)
				})
			}
		}

		function showMenu(Id, index) {
			if (activeMenuIndex) {
				vm.images[activeMenuIndex].showMenu = false;
			}
			activeMenuIndex = index;
			vm.images[index].showMenu = true;
			vm.commentText = null;
			menuActivated = true;
			if (activeMenu) {
				if (activeMenu != Id) {
					document.getElementById(activeMenu).style.display = "none";
					document.getElementById(Id).style.display = "block";
					activeMenu = Id;
				}
			} else {
				document.getElementById(Id).style.display = "block";
				activeMenu = Id;
			}
		};

		function changeImportance(image, value, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (image.Importance != value) {
				image.Importance = value;
				if (isCarousel) {
					vm.images[index] = image;
				}
				var suffix = '';
				if (image.Tags) {
					suffix = '&tags=' + encodeURIComponent(image.Tags);
				}
				setImportance(image.Id, value, suffix);
			}
		};

		function setImportance(imageId, value, suffix) {
			return treatmentsProtocolsService.setImportance(imageId, value, suffix).then(function (response) {
				for (var i = 0; i < vm.allPictures.length; i++) {
					if (vm.allPictures[i].Id == imageId) {
						vm.allPictures[i].Importance = response.Importance;
						break;
					}
				}
			}).catch(function (error) {
				console.log(error)
			})
		};

		function changeIsTask(image, value, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (image.Id == vm.images[i].Id) {
						index = i;
						break;
					}
				}
			}
			var suffix = '/updateTask?isTask='
			if (value) {
				var date = new Date().toISOString();
				suffix = suffix + true + '&taskCompleted=' + date;
				image.IsTask = true;
				image.TaskCompleted = date;
				vm.images[index].IsTask = true;
				vm.images[index].TaskCompleted = date;
			} else {
				suffix = suffix + !image.IsTask;
				image.IsTask = !image.IsTask;
				vm.images[index].IsTask = !vm.images[index].IsTask;
				if (!image.IsTask) {
					image.TaskCompleted = null;
					image.TaskCompletedBy = null;
					vm.images[index].TaskCompleted = null;
					vm.images[index].TaskCompletedBy = null;
				}
			}
			setIsTask(image.Id, suffix, index, isCarousel);
		}


		function setIsTask(imageId, suffix, index, isCarousel) {
			return treatmentsProtocolsService.setIsTask(imageId, suffix).then(function (response) {
				for (var i = 0; i < vm.allPictures.length; i++) {
					if (vm.allPictures[i].Id == imageId) {
						vm.allPictures[i].IsTask = response.IsTask;
						vm.allPictures[i].TaskCompleted = response.TaskCompleted;
						vm.allPictures[i].TaskCompletedBy = response.TaskCompletedBy;
					}
				}
				if (response.TaskCompletedBy) {
					vm.images[index].TaskCompletedBy = response.TaskCompletedBy;
				}
			}).catch(function (error) {
				console.log(error)
			})
		};

		function addCommentOnEnter(event, image, index, isCarousel) {
			if (event.keyCode == 13) {
				addComment(image, index, isCarousel)
			} else if (event.keyCode == 32) {
				event.preventDefault();
			}
		}

		function addComment(image, index, isCarousel) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (vm.commentText) {
				vm.commentText.trim();
			}
			if (vm.commentText && vm.commentText.length) {
				var comment = {
					Message: vm.commentText
				}
				addNewComment(image.Id, comment, index, isCarousel);
			}
		};

		function addNewComment(imageId, comment, index) {
			return treatmentsProtocolsService.addComment(imageId, comment).then(function (response) {
				if (vm.images[index].Comments) {
					vm.images[index].Comments.splice(0, 0, response);
				} else {
					vm.images[index].Comments = [response]
				}

				vm.images[index].NumberComments = vm.images[index].NumberComments + 1;
				vm.commentText = null;
			}).catch(function (error) {
				console.log(error)
			})
		};

		function addTag(image, item, index) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			if (image.Tags) {
				var tags = image.Tags + '#' + item.value;
				vm.images[index].Tags = tags;
			} else {
				var tags = '#' + item.value;
				vm.images[index].Tags = tags;
			}
			var suffix = 'tagevent/' + image.Id + '/updateParameters?importance=' + image.Importance + '&tags=' + encodeURIComponent(tags);
			updateTags(image.Id, suffix);
		}

		function updateTags(imageId, suffix) {
			return treatmentsProtocolsService.updateTags(suffix).then(function (response) {
				for (var i = 0; i < vm.allPictures.length; i++) {
					if (vm.allPictures[i].Id == imageId) {
						vm.allPictures[i].Tags = response.Tags;
						break;
					}
				}
			}).catch(function (error) {
				console.log(error)
			})
		}

		function removeTag(image, item, index) {
			if (!index) {
				for (var i = 0; i < vm.images.length; i++) {
					if (vm.images[i].Id == image.Id) {
						index = i;
						break;
					}
				}
			}
			var tags = image.Tags.split('#');
			var tagsToSend = [];
			for (var i = 0; i < tags.length; i++) {
				if (tags[i] != '' && tags[i] != item.value) {
					tagsToSend.push(tags[i]);
				}
			}
			var newTags = '';
			for (var i = 0; i < tagsToSend.length; i++) {
				newTags = newTags + '#' + tagsToSend[i];
			}
			vm.images[index].Tags = newTags;
			var suffix = 'tagevent/' + image.Id + '/updateParameters?importance=' + image.Importance + '&tags=' + encodeURIComponent(newTags);
			updateTags(image.Id, suffix);
		};


		function publishFile(file, index) {
			file.Private = false;
			return treatmentsProtocolsService.publishFile(file.Id).then(function (response) {}).catch(function (error) {
				console.log(error)
			})
		}


		$(function () {
			$("body").click(function (e) {
				if (menuActivated) {
					$timeout(function () {
						menuActivated = false;
					}, 250)
				} else {
					if (e.target.id == activeMenu || $(e.target).parents("#" + activeMenu + "").length) {} else {
						if (activeMenu) {
							document.getElementById(activeMenu).style.display = "none";
							activeMenu = null;
						}
					}
				}
			});
		})


		$scope.$on('default_herd_selected', function (event, data) {
			init();
		});
		$scope.$on('default_team_selected', function (event, data) {
			init();
		})

	}
})();

(function () {
    'use strict';
    angular.module('My.pages.treatments_protocols').factory('treatmentsProtocolsService', treatmentsProtocolsService);
    /** @ngInject */
    function treatmentsProtocolsService($http, $q, APP_CONSTANTS) {
        return {
            getPictures: getPictures,
            setImportance: setImportance,
            setIsTask: setIsTask,
            getComments: getComments,
            addComment: addComment,
            updateTags: updateTags,
            publishFile: publishFile
        }


        function getPictures(herd_id, suffix) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/'+herd_id+'/pictures/true' + suffix , {
                //withCredentials: true
            }).then(success).catch(error);
        }

        function setImportance(image_id, value, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'tagevent/' + image_id + '/updateParameters?importance=' + value + suffix).then(success).catch(error);
        }

        function setIsTask(image_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + suffix, {
                withCredentials: true
            }).then(success).catch(error);
        }


        function getComments(herd_id) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/comments', {
              //  withCredentials: true
            }).then(success).catch(error);
        }

         function addComment(image_id, comment) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + '/comments', comment).then(success).catch(error);
        }

        function updateTags(suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + suffix).then(success).catch(error);
        }

        function publishFile(image_id) {
            return $http.post(APP_CONSTANTS.animals_base_url +'pictures/' + image_id + '/private/false').then(success).catch(error);
        }

        function success(response){
            return response.data;
        };

        function error(error){
            return $q.reject(error);
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('My.theme')
	  .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
	return angular.extend({}, baPanel, {
	  template: function(el, attrs) {
		var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
		res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
		res += baPanel.template(el, attrs);
		res += '</div>';
		return res;
	  }
	});
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

	/** Base baPanel directive */
	return {
	  restrict: 'A',
	  transclude: true,
	  template: function(elem, attrs) {
		var res = '<div class="panel-body" ng-transclude></div>';
		if (attrs.baPanelTitle) {
		  var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
		  res = titleTpl + res; // title should be before
		}

		return res;
	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
	var bodyBgSize;

	baPanelBlurHelper.bodyBgLoad().then(function() {
	  bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
	});

	$window.addEventListener('resize', function() {
	  bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
	});

	return {
	  restrict: 'A',
	  link: function($scope, elem) {
		if(!$rootScope.$isMobile) {
		  baPanelBlurHelper.bodyBgLoad().then(function () {
			setTimeout(recalculatePanelStyle);
		  });
		  $window.addEventListener('resize', recalculatePanelStyle);

		  $scope.$on('$destroy', function () {
			$window.removeEventListener('resize', recalculatePanelStyle);
		  });
		}

		function recalculatePanelStyle() {
		  if (!bodyBgSize) {
			return;
		  }
		  elem.css({
			backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
			backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
		  });
		}

	  }
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
	var res = $q.defer();
	var computedStyle = getComputedStyle(document.body, ':before');
	var image = new Image();
	image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
	image.onerror = function() {
	  res.reject();
	};
	image.onload = function() {
	  res.resolve();
	};

	this.bodyBgLoad = function() {
	  return res.promise;
	};

	this.getBodyBgImageSizes = function() {
	  var elemW = document.documentElement.clientWidth;
	  var elemH = document.documentElement.clientHeight;
	  if(elemW <= 640) return;
	  var imgRatio = (image.height / image.width);       // original img ratio
	  var containerRatio = (elemH / elemW);     // container ratio

	  var finalHeight, finalWidth;
	  if (containerRatio > imgRatio) {
		finalHeight = elemH;
		finalWidth = (elemH / imgRatio);
	  } else {
		finalWidth = elemW;
		finalHeight = (elemW * imgRatio);
	  }
	  return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('My.theme')
	  .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
	return angular.extend({}, baPanel, {
	  link: function(scope, el, attrs) {
		el.addClass('panel panel-white');
		if (attrs.baPanelClass) {
		  el.addClass(attrs.baPanelClass);
		}
	  }
	});
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
	  .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
	return {
	  restrict: 'E',
	  templateUrl: 'app/theme/components/backTop/backTop.html',
	  controller: function () {
		$('#backTop').backTop({
		  'position': 200,
		  'speed': 100
		});
	  }
	};
  }

})();

(function () {
  'use strict';

  angular.module('My.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
            if(!baSidebarService.isMenuCollapsed()){
                if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
               }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }


      }
    };
  }

})();

(function () {
  "use strict";
  angular
    .module("My.theme.components")
    .provider("baSidebarService", baSidebarServiceProvider);
  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];
    this.addStaticItem = function () {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };
    /** @ngInject */
    this.$get = function (
      $state,
      layoutSizes,
      $filter,
      $timeout,
      permissionService
    ) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();
        this.getMenuItems = function () {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function (item) {
            if (
              (permissionService.can(352) || permissionService.can(353)) &&
              item.title_2
            ) {
              item.title = item.title_2;
            }

            if (item.permission) {
              if (item.permission_2) {
                if (
                  permissionService.can(item.permission) &&
                  !permissionService.can(item.permission_2)
                ) {
                  return item.level == 0;
                }
              } else {
                if (permissionService.can(item.permission)) {
                  return item.level == 0;
                }
              }
            } else {
              return item.level == 0;
            }
          });
                    
          menuItems.forEach(function (item) {
            $timeout(function () {
              item.titleTranslated = $filter("i18n")(item.title);
            }, 1500);
            var children = states.filter(function (child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            if (children.length) {
              var ch = [];
              for (var i = 0; i < children.length; i++) {
                if (children[i].permission) {
                  if (permissionService.can(children[i].permission)) {
                    ch.push(children[i]);
                  }
                } else {
                  ch.push(children[i]);
                }
              }

              item.subMenu = ch;
            } else {
              item.subMenu = null;
            }

            //item.subMenu = children.length ? children : null;
          });
          return menuItems.concat(staticMenuItems);
        };
        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;
        this.setMenuCollapsed = function (isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };
        this.isMenuCollapsed = function () {
          return isMenuCollapsed;
        };
        this.toggleMenuCollapsed = function () {
          isMenuCollapsed = !isMenuCollapsed;
        };
        this.getAllStateRefsRecursive = function (item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu &&
              currentItem.subMenu.forEach(function (subItem) {
                subItem.stateRef && result.push(subItem.stateRef);
                _iterateSubItems(subItem);
              });
          }
        };

        function defineMenuItemStates() {
          return $state
            .get()
            .filter(function (s) {
              return s.sidebarMeta;
            })
            .map(function (s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: (s.name.match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
                fixedHref: s.fixedHref,
                img: setImage(meta.img, meta.aveve_img, meta.proxani_img),
                permission: meta.permission,
                permission_2: meta.permission_2,
                title_2: meta.title_2,
                goToState: meta.goToState,
                                greeting: meta.greeting
              };
            })
            .sort(function (a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function setImage(img, aveve_img, proxani_img) {
          if (aveve_img && permissionService.can(352)) {
            return aveve_img;
          }

          if (proxani_img && permissionService.can(353)) {
            return proxani_img;
          }

          return img;
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, $state,$timeout) {
      baSidebarService.setMenuCollapsed(true);
      $scope.showMenu = true;

      $scope.stateTo = function(state){
            $state.go(state);
      }

    $scope.menuItems = baSidebarService.getMenuItems();
      if($scope.menuItems[0]){
            $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
      }


    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 46;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
        baSidebarService.setMenuCollapsed(true);
    });

       $scope.$on('default_team_selected', function () {

         $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
           baSidebarService.setMenuCollapsed(true);
           $scope.showMenu = false;
           $timeout(function(){
               $scope.showMenu = true;
           },0)

    });
  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
	  .directive('baSidebarToggleMenu', baSidebarToggleMenu)
	  .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
	  .directive('baSidebarTogglingItem', baSidebarTogglingItem)
	  .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
	  .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
	  .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
	return {
	  restrict: 'A',
	  link: function(scope, elem) {
		elem.on('click', function($evt) {
		  $evt.originalEvent.$sidebarEventProcessed = true;
		  scope.$apply(function() {
			baSidebarService.toggleMenuCollapsed();
		  });
		});
	  }
	};
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
	return {
	  restrict: 'A',
	  link: function(scope, elem) {
		elem.on('click', function($evt) {
		  $evt.originalEvent.$sidebarEventProcessed = true;
		  if (!baSidebarService.isMenuCollapsed()) {
			scope.$apply(function() {
			  baSidebarService.setMenuCollapsed(true);
			});
		  }
		});
	  }
	};
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
	return {
	  restrict: 'A',
	  controller: 'BaSidebarTogglingItemCtrl'
	};
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
	var vm = this;
	var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
	if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
	  vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
	  vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

	  var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

	  vm.$expand = function() {
		vm.$$expandSubmenu();
		$element.addClass('ba-sidebar-item-expanded');
		if(menuItem.goToState){
			$state.go(menuItem.goToState);
		}
	  };

	  vm.$collapse = function() {
		vm.$$collapseSubmenu();
		$element.removeClass('ba-sidebar-item-expanded');
	  };

	  vm.$toggle = function() {
		$element.hasClass('ba-sidebar-item-expanded') ?
			vm.$collapse() :
			vm.$expand();
	  };

	  if (_isState($state.current)) {
		$element.addClass('ba-sidebar-item-expanded');
	  }

	  $scope.$on('$stateChangeStart', function (event, toState) {
		if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
		  vm.$collapse();
		  $element.removeClass('ba-sidebar-item-expanded');
		}
	  });

	  $scope.$on('$stateChangeSuccess', function (event, toState) {
		if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
		  vm.$expand();
		  $element.addClass('ba-sidebar-item-expanded');
		}
	  });
	}

	function _isState(state) {
	  return state && subItemsStateRefs.some(function(subItemState) {
			return state.name.indexOf(subItemState) == 0;
		  });
	}
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
	return {
	  restrict: 'A',
	  require: '^baSidebarTogglingItem',
	  link: function(scope, el, attrs, baSidebarTogglingItem) {
		baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
		baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
	  }
	};
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
	return {
	  restrict: 'A',
	  require: '^baSidebarTogglingItem',
	  link: function(scope, el, attrs, baSidebarTogglingItem) {
		el.on('click', function() {
		  if (baSidebarService.isMenuCollapsed()) {
			// If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
			// This should not affect mobiles, because on mobiles sidebar should be hidden at all
			scope.$apply(function() {
			  baSidebarService.setMenuCollapsed(false);
			});
			baSidebarTogglingItem.$expand();
		  } else {
			baSidebarTogglingItem.$toggle();
		  }
		});
	  }
	};
  }

})();

(function() {
  'use strict';

  angular.module('My.theme.components')
	.directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
	return {
	  restrict: 'E',
	  transclude: true,
	  templateUrl: 'app/theme/components/baWizard/baWizard.html',
	  controllerAs: '$baWizardController',
	  controller: 'baWizardCtrl'
	}
  }
})();

(function() {
  'use strict';

  angular.module('My.theme.components')
	.controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
	var vm = this;
	vm.tabs = [];

	vm.tabNum = 0;
	vm.progress = 0;

	vm.addTab = function(tab) {
	  tab.setPrev(vm.tabs[vm.tabs.length - 1]);
	  vm.tabs.push(tab);
	  vm.selectTab(0);
	};

	$scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

	vm.selectTab = function (tabNum) {
	  vm.tabs[vm.tabNum].submit();
	  if (vm.tabs[tabNum].isAvailiable()) {
		vm.tabNum = tabNum;
		vm.tabs.forEach(function (t, tIndex) {
		  tIndex == vm.tabNum ? t.select(true) : t.select(false);
		});
	  }
	};

	vm.isFirstTab = function () {
	  return vm.tabNum == 0;
	};

	vm.isLastTab = function () {
	  return vm.tabNum == vm.tabs.length - 1 ;
	};

	vm.nextTab = function () {
	  vm.selectTab(vm.tabNum + 1)
	};

	vm.previousTab = function () {
	  vm.selectTab(vm.tabNum - 1)
	};

	function calcProgress() {
	  vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
	}
  }
})();


(function() {
  'use strict';

  angular.module('My.theme.components')
	.directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
	return {
	  restrict: 'E',
	  transclude: true,
	  require: '^baWizard',
	  scope: {
		form: '='
	  },
	  templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
	  link: function($scope, $element, $attrs, wizard) {
		$scope.selected = true;

		var tab = {
		  title: $attrs.title,
		  select: select,
		  submit: submit,
		  isComplete: isComplete,
		  isAvailiable: isAvailiable,
		  prevTab: undefined,
		  setPrev: setPrev
		};

		wizard.addTab(tab);

		function select(isSelected) {
		  if (isSelected) {
			$scope.selected = true;
		  } else {
			$scope.selected = false;
		  }
		}

		function submit() {
		  $scope.form && $scope.form.$setSubmitted(true);
		}

		function isComplete() {
		  return $scope.form ? $scope.form.$valid : true;
		}

		function isAvailiable() {
		  return tab.prevTab ? tab.prevTab.isComplete() : true;
		}

		function setPrev(pTab) {
		  tab.prevTab = pTab;
		}
	  }
	};
  }
})();

(function () {
  "use strict";
  angular
    .module("My.theme.components")
    .controller("contentTopCtrl", contentTopCtrl);
  /** @ngInject */
  function contentTopCtrl(
    $state,
    $rootScope,
    $scope,
    $filter,
    $timeout,
    permissionService,
    aDashboardsService
  ) {
    var vm = this;
    vm.addClass = addClass;
    vm.showDashboardState = showDashboardState;
    vm.activeCategorySelected = activeCategorySelected;
    vm.showSelectedDashboard = showSelectedDashboard;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.showAnimals = showAnimals;
    vm.goToAnimals = goToAnimals;
    vm.checkCurrentState = checkCurrentState;
    vm.goToHome = goToHome;
    vm.showDateSelector = showDateSelector;
    vm.showMMMInside = showMMMInside;
    vm.showHome = showHome;
    vm.isArvestaState = isArvestaState;
    vm.getDashboardName = getDashboardName;
    vm.hasParent = hasParent;
    vm.prevousState = "";

    checkPreviousState();

    function checkPreviousState() {
      var data = JSON.parse(localStorage.getItem("animalList"));
      if (data && data.state) {
        if (data.state == "herds.animals") {
          vm.previousState = $filter("i18n")("_page_title_animals_");
        } else if (data.state == "herds.listGenerator") {
          vm.previousState = $filter("i18n")("_page_title_list_generator_");
        }
      } else {
        vm.previousState = $filter("i18n")("_page_title_animals_");
      }
    }

    function addClass() {
      if (
        $state.current.name == "herds.dashboards" ||
        $state.current.name == "dq"
      ) {
        return "al-title-hover";
      } else {
        return "";
      }
    }
    vm.activePageSelected = activePageSelected;

    function activePageSelected() {
      if (
        $state.current.name == "herds.dashboards" ||
        $state.current.name == "dq"
      ) {
        $rootScope.$broadcast("dashboards_back");
        vm.selectedDashboard = null;
        vm.category = null;
      }
    }

    function activeCategorySelected() {
      $rootScope.$broadcast("category_back", vm.category);
      vm.selectedDashboard = null;
    }

    function showDashboardState() {
      if ($state.current.name == "herds.dashboards") {
        if (vm.category) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function timeSelectorChanged(time) {
        $rootScope.$broadcast("time_selector_changed", time);
        if ($state.current.name == "herds.attention-mro") {
          vm.selectedTime = time;
        }
    }

    function showSelectedDashboard() {
      vm.currentState = $state.current.name;

      if (vm.selectedDashboard) {
        if ($state.current.name == "dq") {
          if (permissionService.isGlobalAdmin) {
            return true;
          } else {
            return false;
          }
        } else if (
          $state.current.name == "herds.dashboards" ||
          $state.current.name == "d-insemination-strategy-cows" ||
          $state.current.name == "d-insemination-strategy-heifers" ||
          $state.current.name == "d-conception-rate-cows" ||
          $state.current.name == "d-oestrus-interval-analysis" ||
          $state.current.name == "d-conception-strategy-heifers" ||
          $state.current.name == "d-conception-cusum-analysis" ||
          $state.current.name == "d-conception-cusum-analysis-heifers"
        ) {
          return true;
        } else {
          return false;
        }
      } else if (vm.attentionMROOpened) {
        if ($state.current.name == "herds.attention-mro") {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }

    function showAnimals() {
      if ($state.current.name == "animalDatails") {
        return true;
      } else {
        return false;
      }
    }
    $scope.$on("category_selected", function (event, data) {
      if (data) {
        vm.category = data;
      } else {
        vm.category = null;
      }
    });

    function goToAnimals() {
      var data = JSON.parse(localStorage.getItem("animalList"));

      if (data && data.state) {
        data.goBack = true;
        localStorage.setItem("animalList", JSON.stringify(data));
        $state.go(data.state);
      } else {
        $state.go("herds.animals");
      }
    }

    //check if current sate is dashboard and return true if is not
    function checkCurrentState() {
      if (
        $state.current.name == "dashboard" ||
        $state.current.name == "agroscoop" ||
        $state.current.name == "rap"
      ) {
        return false;
      } else {
        return true;
      }
    }

    function goToHome() {
      if ($state.current.name == "rap") {
        $rootScope.$broadcast("deselect_herd_home");
      } else {
        $state.go("redirect");
      }
    }

    function showDateSelector() {
      if (
        vm.selectedDashboardId ==
        $filter("i18n")("_z_general_subclinical_table_overview_")
      ) {
        return false;
      }

      return true;
    }

    function showMMMInside() {
      if (permissionService.can(352) || permissionService.can(353)) {
        return true;
      } else {
        return false;
      }
    }

    function showHome() {
      if (
        $state.current.name == "home" ||
        $state.current.name == "home-arvesta"
      ) {
        return false;
      }
      return true;
    }

    function isArvestaState() {
      if (
        $state.current.name == "herd-overview" ||
        $state.current.name == "milk-production.components" ||
        $state.current.name == "milk-production.milk-trend" ||
        $state.current.name == "milk-production.spp" ||
        $state.current.name == "milk-production.conductivity" ||
        $state.current.name == "milk-production.pregnant" ||
        $state.current.name == "concentrate.feeding" ||
        $state.current.name == "concentrate.intake" ||
        $state.current.name == "concentrate.leftovers" ||
        $state.current.name == "concentrate.overview" ||
        $state.current.name == "milkings.failures" ||
        $state.current.name == "milkings.actual" ||
        $state.current.name == "milkings.refusals" ||
        $state.current.name == "robot-efficiency.milk-hour" ||
        $state.current.name == "robot-efficiency.milk-speed" ||
        $state.current.name == "robot-efficiency.robot-prestations"
      ) {
        return true;
      }
      return false;
    }

    function hasParent() {
      if (
        $state.current.name == "milk-production.components" ||
        $state.current.name == "milk-production.milk-trend" ||
        $state.current.name == "milk-production.spp" ||
        $state.current.name == "milk-production.conductivity" ||
        $state.current.name == "milk-production.pregnant" ||
        $state.current.name == "concentrate.feeding" ||
        $state.current.name == "concentrate.intake" ||
        $state.current.name == "concentrate.leftovers" ||
        $state.current.name == "concentrate.overview" ||
        $state.current.name == "milkings.failures" ||
        $state.current.name == "milkings.actual" ||
        $state.current.name == "milkings.refusals" ||
        $state.current.name == "robot-efficiency.milk-hour" ||
        $state.current.name == "robot-efficiency.milk-speed" ||
        $state.current.name == "robot-efficiency.robot-prestations"
      ) {
        return true;
      }
      return false;
    }

    function getDashboardName() {
      return aDashboardsService.current_dashboard;
    }

    $scope.$on("list_selected_animal", function () {
      vm.previousState = $filter("i18n")("_page_title_list_generator_");
    });

    $scope.$on("animals_selected_animal", function () {
      vm.previousState = $filter("i18n")("_page_title_animals_");
    });

    $scope.$on("dashboard_selected", function (event, data) {
      if (data) {
        vm.selectedTime = data.selectedTime;
        vm.selectedDashboardId = data.id;
        vm.selectedDashboard = data.title;
      } else {
        vm.selectedDashboard = null;
      }
    });

    $scope.$on("home_dashboard_embedded", function (event, data) {
      vm.dashboard_name = data;
      vm.hideDashboardName = true;
      $timeout(function () {
        vm.hideDashboardName = false;
      }, 50);
    });

    $scope.$on("dashboard_deselect", function () {
      vm.selectedDashboard = null;
      vm.category = null;
    });

    $scope.$on("attention_mro_data_loaded", function (event, data) {
      vm.selectedTime = 1;
      vm.attentionMROOpened = data;
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
	  .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
	return {
	  restrict: 'E',
	controller: 'contentTopCtrl',
		controllerAs: 'vm',
	  templateUrl: 'app/theme/components/contentTop/contentTop.html',
	  link: function($scope) {
		$scope.$watch(function () {
		  $scope.activePageTitle = $state.current.title;
		  $scope.activePageSideBarMeta = $state.current.sidebarMeta;
		});
	  }
	};
  }

})();

(function () {
	'use strict';
	angular.module('My.theme.components').controller('cookiePolicyCtrl', cookiePolicyCtrl);
	/** @ngInject */
	function cookiePolicyCtrl($timeout, $cookies, $state,$uibModal, $uibModalStack, $scope, cookiesService) {

		var vm = this;
		var cookie_name = 'cookies_accepted';

		vm.acceptCookies = acceptCookies;
		vm.openPrivacyPolicy = openPrivacyPolicy;
		vm.closePrivacyPolicy = closePrivacyPolicy;


		init();


		function init(){
			vm.showPrivacyPolicyText = false;
			$timeout(function(){
				var cookie = $cookies.get(cookie_name);
				if(!cookie){
				   vm.showCookiePolicyMessage = true;
				}
			},1000);
		}

		function acceptCookies(){
			vm.showCookiePolicyMessage = false;
			vm.showPrivacyPolicyText = false;
			var expireDate = new Date();
			expireDate.setYear(expireDate.getFullYear() + 1);
			cookiesService.setCookie(cookie_name, true, {
				samesite: "strict",
				expires: expireDate
			});
		}

		function openPrivacyPolicy(){
		   vm.showPrivacyPolicyText = true;
		}

		function closePrivacyPolicy(){
			vm.showPrivacyPolicyText = false;
		}

	}
})();

(function () {
    'use strict';

    angular.module('My.theme.components')
        .directive('cookiePolicy', cookiePolicy);

    /** @ngInject */
    function cookiePolicy($location, $state) {
        return {
            restrict: 'E',
            controller: 'cookiePolicyCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/theme/components/cookiePolicy/cookiePolicy.html',
            link: function ($scope) {
                $scope.$watch(function () {
                    $scope.activePageTitle = $state.current.title;
                });
            }
        };
    }

})();

(function () {
  'use strict';

  angular.module('My.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();

(function () {
  'use strict';

  angular.module('My.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();

(function () {
  "use strict";
  angular.module("My.theme.components").controller("pageTopCtrl", pageTopCtrl);
  /** @ngInject */
  function pageTopCtrl(
    $state,
    $window,
    $filter,
    $scope,
    $timeout,
    pageTopService,
    $cookies,
    $rootScope,
    herdDashboardsService,
    permissionService,
    rapService,
    cookiesService,
    auth0Service,
    aDashboardsService
  ) {
    var vm = this;
    vm.logout = logout;
    vm.selectTeam = selectTeam;
    vm.selectHerd = selectHerd;
    vm.selectedHerdChanged = selectedHerdChanged;
    vm.filterDuplicatedChanged = filterDuplicatedChanged;
    vm.openPanicButtonModal = openPanicButtonModal;
    vm.panic_button_text = "";
    vm.loadingPanicButton = false;
    vm.sendErrorInfo = sendErrorInfo;
    vm.openPanicButton = openPanicButton;
    vm.openPdf = openPdf;
    vm.openSettings = openSettings;
    vm.getPlaceholder = getPlaceholder;
    setIcons();
    init();

    function init() {
      vm.showOpenPdf = false;
      vm.showPanicButton = false;
      vm.current_state = $state.current.name;
      localStorage.removeItem("authenticated");
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.profilePicture = $filter("profilePicture")("Avatar");
      var teams = permissionService.teams;

      $timeout(function () {
        vm.showProfileIcon = true;
      }, 100);
      if (teams && teams.length > 0) {
        vm.teamsWP = teams;

        vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
        if (vm.user) {
          var cookie = $cookies.getAll();
          Object.keys(cookie).forEach(function (key) {
            if (key == vm.user.email) {
              vm.cookie = JSON.parse(cookie[key]);
            }
          });
          if (!vm.cookie) {
            vm.cookie = {
              team_id: null,
              herd_ids: [],
              filterDH: true,
            };
            vm.filterDuplicated = true;
          } else {
            if (vm.cookie.filterDH == null || vm.cookie.filterDH == undefined) {
              vm.cookie.filterDH = true;
              vm.filterDuplicated = true;
            } else {
              vm.filterDuplicated = vm.cookie.filterDH;
            }
          }
          if (vm.cookie.team_id) {
            vm.team_id = vm.cookie.team_id;
            if (vm.cookie.herd_ids) {
              vm.herd_ids = vm.cookie.herd_ids;
            }

            localStorage.setItem("default_values", JSON.stringify(vm.cookie));
          } else {
            vm.team_id = vm.defaultValues.team_id;
          }

          setProfile(vm.user);
          getTeams();
        } else {
          var sso = localStorage.getItem("auth0.ssodata");
          var login_type = localStorage.getItem("login_type");
          localStorage.clear();
          localStorage.setItem("login_type", login_type);
          if (sso) {
            localStorage.setItem("auth0.ssodata", sso);
          }
          if (login_type && login_type == "sso") {
            $state.go("login-sso");
          } else {
            $state.go("login");
          }
        }
      } else {
        var sso = localStorage.getItem("auth0.ssodata");
        var login_type = localStorage.getItem("login_type");
        localStorage.clear();
        localStorage.setItem("login_type", login_type);
        if (sso) {
          localStorage.setItem("auth0.ssodata", sso);
        }
        if (login_type && login_type == "sso") {
          $state.go("login-sso");
        } else {
          $state.go("login");
        }
      }
    }

    function getTeams() {
      return pageTopService
        .getTeams()
        .then(function (response) {
          var teams_with_permissions = [];

          for (var i = 0; i < response.length; i++) {
            for (var j = 0; j < vm.teamsWP.length; j++) {
              if (response[i].Id == vm.teamsWP[j]) {
                teams_with_permissions.push(response[i]);
              }
            }
          }

          vm.teams = teams_with_permissions;
          if (vm.teams.length > 0) {
            checkDefaultTeam(vm.teams);
          }
          vm.teamsLoaded = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function checkDefaultTeam(teams) {
      var defaultTeamHasPermission = false;
      for (var i = 0; i < vm.teamsWP.length; i++) {
        if (vm.teamsWP[i] == vm.defaultValues.team_id) {
          defaultTeamHasPermission = true;
          break;
        }
      }

      if (defaultTeamHasPermission) {
        for (var j = 0; j < teams.length; j++) {
          if (teams[j].Id == vm.defaultValues.team_id) {
            vm.selectedTeam = teams[j];
            break;
          }
        }
      } else {
        vm.selectedTeam = findTeamWithPermission(teams, vm.teamsWP);
        var defaultValues = {
          team_id: vm.selectedTeam.Id,
          herd_ids: [],
          filterDH: true,
        };
        cookiesService.setCookie("mmmooogle_tenant", defaultValues.team_id, {
          samesite: "none",
          secure: true,
          domain: ".mmmooogle.com",
        });
        localStorage.setItem("default_values", JSON.stringify(defaultValues));
      }

      if (vm.selectedTeam) {
        setLegalNoticeVisibility();
        getHerdsByTeam(vm.selectedTeam.Id);
        if (localStorage.getItem("lng")) {
          var tableauSuffix = "?locale=" + localStorage.getItem("lng");
        } else {
          var tableauSuffix = "?locale=en-GB";
        }
      } else {
        var sso = localStorage.getItem("auth0.ssodata");
        var login_type = localStorage.getItem("login_type");
        localStorage.clear();
        localStorage.setItem("login_type", login_type);
        if (sso) {
          localStorage.setItem("auth0.ssodata", sso);
        }
        if (login_type && login_type == "sso") {
          $state.go("login-sso");
        } else {
          $state.go("login");
        }
      }
    }

    function findTeamWithPermission(teams, teamsWP) {
      var team;
      for (var i = 0; i < teams.length; i++) {
        for (var j = 0; j < teamsWP.length; j++) {
          if (teams[i].Id == teamsWP[j]) {
            team = teams[i];
            break;
          }
        }
      }
      return team;
    }

    function getHerdsByTeam(team_id, skipDefaultCheck) {
      var suffix = null;
      if (vm.filterDuplicated) {
        suffix = "?duplicateofherdid=null";
      }

      return pageTopService
        .getHerdsByTeam(team_id, suffix)
        .then(function (response) {
          var herds = [];
          for (var i = 0; i < response.length; i++) {
            herds.push(response[i].Id);
          }
          vm.herds = $filter("orderBy")(response, "Name");
          vm.selectedTeam.Herds = response;
          rapService.loadedHerds = {
            team_id: team_id,
            herds: response,
          };
          if (!skipDefaultCheck) {
            checkDefaultHerds(vm.herds, herds);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function checkDefaultHerds(herds_with_permissions, herds) {
      var defaultHerdsWithPermission = [];

      for (var i = 0; i < vm.defaultValues.herd_ids.length; i++) {
        for (var j = 0; j < herds.length; j++) {
          if (vm.defaultValues.herd_ids[i] == herds[j]) {
            defaultHerdsWithPermission.push(vm.defaultValues.herd_ids[i]);
          }
        }
      }
      var default_herds = [];
      for (var k = 0; k < defaultHerdsWithPermission.length; k++) {
        for (var l = 0; l < herds_with_permissions.length; l++) {
          if (defaultHerdsWithPermission[k] == herds_with_permissions[l].Id) {
            default_herds.push(herds_with_permissions[l]);
          }
        }
      }

      vm.selectedHerds = default_herds;
    }

    function selectedHerdChanged() {
      vm.showPanicButton = false;
      var state = {
        state: $state.current.name,
      };
      vm.cookie.herd_ids = [];
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
      }
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      broadcastHerdSelected(state);
    }

    function checkDefaultHerd() {
      var team;
      for (var i = 0; i < vm.teams.length; i++) {
        if (vm.teams[i].TeamId == vm.selectedTeam.TeamId) {
          team = vm.teams[i];
          break;
        }
      }
      var listToRemove = [];
      for (var h = 0; h < vm.selectedHerds.length; h++) {
        var found = false;
        for (var t = 0; t < team.Herds.length; t++) {
          if (vm.selectedHerds[h].HerdId == team.Herds[t].HerdId) {
            found = true;
            break;
          }
        }
        if (!found) {
          listToRemove.push(vm.selectedHerds[h]);
        }
      }
      if (listToRemove.length > 0) {
        for (var r = 0; r < listToRemove.length; r++) {
          for (var s = vm.selectedHerds.length - 1; s >= 0; s--) {
            if (listToRemove[r].HerdId == vm.selectedHerds[s].HerdId) {
              vm.selectedHerds.splice(s, 1);
            }
          }
        }

        selectedHerdChanged();
      }
    }

    function setProfile(user) {
      if (user && user.picture) {
        vm.profilePicture = user.picture;
      }
      if (user && user.name) {
        vm.name = user.name;
      }
    }

    function setDefaultTeam(team_id, teams) {
      var is_farmer = vm.user.is_farmer;
      vm.selectedTeam = null;
      for (var i = 0; i < teams.length; i++) {
        if (team_id == teams[i].TeamId) {
          vm.selectedTeam = teams[i];
          vm.herds = vm.selectedTeam.Herds;
          //homeService.herds = vm.herds;
          vm.cookie.team_id = vm.selectedTeam.TeamId;
          setCookie(vm.user.email, JSON.stringify(vm.cookie));
          cookiesService.setCookie("mmmooogle_tenant", vm.selectedTeam.TeamId, {
            samesite: "none",
            secure: true,
            domain: ".mmmooogle.com",
          });

          localStorage.setItem("default_values", JSON.stringify(vm.cookie));
        }
      }

      if (vm.selectedTeam) {
        setDefaultHerd(vm.herd_ids, vm.selectedTeam);
      } else {
        if (teams && teams.length > 0) {
          vm.selectedTeam = teams[0];
          vm.herds = vm.selectedTeam.Herds;
          //homeService.herds = vm.herds;
          vm.cookie.team_id = vm.selectedTeam.TeamId;
          setCookie(vm.user.email, JSON.stringify(vm.cookie));
          localStorage.setItem("default_values", JSON.stringify(vm.cookie));
        }

        $timeout(function () {
          $rootScope.$broadcast("default_values_loaded");
        }, 100);
      }
    }

    function broadcastTeamSelected(state, redirect) {
      aDashboardsService.orders = [];
      if (!redirect) {
        $rootScope.$broadcast("default_team_selected", state);
      }
      changeStyle();
      setIcons();
      if (redirect) {
        $state.go("redirect");
      }
    }

    function changeStyle() {
      var house_style = permissionService.getHouseStyle();
      localStorage.setItem("style", house_style ? house_style : "");
      $rootScope.$broadcast("style_changed");
    }

    function setDefaultHerd(herd_ids, team) {
      vm.selectedHerds = [];
      vm.herd_ids = [];
      for (var i = 0; i < team.Herds.length; i++) {
        for (var j = 0; j < herd_ids.length; j++) {
          if (team.Herds[i].HerdId == herd_ids[j]) {
            vm.selectedHerds.push(team.Herds[i]);
            vm.herd_ids.push(team.Herds[i].HerdId);
          }
        }
      }

      $timeout(function () {
        $rootScope.$broadcast("default_values_loaded");
      }, 100);
    }

    function broadcastHerdSelected(state) {
      $rootScope.$broadcast("default_herd_selected", state);
    }

    function selectTeam(team) {
      vm.showPanicButton = false;
      vm.teamSelectorIsOpen = false;
      vm.teamSelectorIsOpenPT = false;
      vm.textFilter = "";
      var state = {
        state: $state.current.name,
      };
      herdDashboardsService.tableauStored = {};
      vm.selectedTeam = team;
      vm.selectedHerds = [];
      vm.herds = team.Herds;
      //homeService.herds = vm.herds;
      getHerdsByTeam(team.Id, true);
      vm.cookie.team_id = team.Id;
      vm.cookie.herd_ids = [];
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      cookiesService.setCookie("mmmooogle_tenant", vm.selectedTeam.Id, {
        samesite: "none",
        secure: true,
        domain: ".mmmooogle.com",
      });
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      $timeout(function () {
        setLegalNoticeVisibility();
      }, 200);
      if (
        !$state.current.sidebarMeta ||
        !permissionService.can($state.current.sidebarMeta.permission)
      ) {
        broadcastTeamSelected("redirect", true);
      } else {
        broadcastTeamSelected(state);
      }
      $rootScope.$broadcast("update_sidebar");
    }

    function filterDuplicatedChanged() {
      vm.cookie.filterDH = vm.filterDuplicated;
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));

      if (vm.selectedTeam) {
        getHerdsByTeam(vm.selectedTeam.Id, true);
      }
    }

    function selectHerd(herd) {
      vm.showPanicButton = false;
      var state = {
        state: $state.current.name,
      };
      vm.selectedHerd = herd;
      vm.cookie.herd_id = herd.HerdId;
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      broadcastHerdSelected(state);
    }

    function logout() {
      auth0Service.handleUnauthorized(100);
    }

    function setCookie(key, value) {
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 365);
      cookiesService.setCookie(key, value, {
        samesite: "strict",
        expires: expireDate,
      });
    }
    //listen for herd selection on dashboard
    $scope.$on("default_herd_from_dashboard_selected", function (event, herd) {
      vm.showPanicButton = false;
      vm.selectedHerds = [];
      if (vm.selectedTeam && vm.selectedTeam.Herds.length) {
        defaultHerdFromDashboardSelected(herd);
      } else {
        $timeout(function () {
          defaultHerdFromDashboardSelected(herd);
        }, 1000);
      }
    });

    function defaultHerdFromDashboardSelected(herd) {
      for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
        if (herd == vm.selectedTeam.Herds[i].Id) {
          vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
        }
      }

      vm.cookie.herd_ids = [];
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
      }
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      vm.hideHerdSelector = true;
      $timeout(function () {
        vm.hideHerdSelector = false;
      }, 0);
    }

    $scope.$on("default_herd_with_redirect", function (event, herd) {
      vm.showPanicButton = false;
      vm.selectedHerds = [];
      for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
        if (herd == vm.selectedTeam.Herds[i].Id) {
          vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
        }
      }

      vm.cookie.herd_ids = [];
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
      }
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      vm.hideHerdSelector = true;
      $timeout(function () {
        vm.hideHerdSelector = false;
        $state.go("herd-overview");
      }, 0);
    });

    $scope.$on(
      "default_herd_from_claw_health_selected",
      function (event, herd) {
        vm.selectedHerds = [];
        for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
          if (herd == vm.selectedTeam.Herds[i].Id) {
            vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
          }
        }

        vm.cookie.herd_ids = [];
        for (var i = 0; i < vm.selectedHerds.length; i++) {
          vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
        }
        setCookie(vm.user.email, JSON.stringify(vm.cookie));
        localStorage.setItem("default_values", JSON.stringify(vm.cookie));
        vm.herd_ids = vm.cookie.herd_ids;
        vm.hideHerdSelector = true;
        $timeout(function () {
          vm.hideHerdSelector = false;
        }, 0);
      }
    );

    $scope.$on("default_herd_from_map_selected", function (event, herd) {
      vm.showPanicButton = false;
      vm.selectedHerds = [];
      for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
        if (herd == vm.selectedTeam.Herds[i].Id) {
          vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
        }
      }

      vm.cookie.herd_ids = [];
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
      }
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      vm.hideHerdSelector = true;
      var state = {
        state: $state.current.name,
      };
      $timeout(function () {
        broadcastHerdSelected(state);
        vm.hideHerdSelector = false;
      }, 0);
    });

    function deselectHerds(skip_panic_button) {
      if (!skip_panic_button) {
        vm.showPanicButton = false;
      }
      vm.selectedHerds = [];
      vm.cookie.herd_ids = [];
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      vm.hideHerdSelector = true;
      $timeout(function () {
        vm.hideHerdSelector = false;
      }, 0);
    }

    function openPanicButtonModal() {
      $rootScope.$broadcast("open_panic_button", vm.current_state);
    }

    function sendErrorInfo() {
      vm.loadingPanicButton = true;
      $rootScope.$broadcast("send_error_info", {
        state: vm.current_state,
        comment: vm.panic_button_text,
      });
    }

    function openPanicButton() {
      vm.loadingPanicButton = false;
      vm.panic_button_text = "";
      vm.panicButtonError = false;
    }

    function openPdf() {
      var tenant = permissionService.getTenant();
      if (tenant) {
        if (tenant == "zoetis") {
          window.open(
            "/assets/pdf/Machtigingsformulier_CRV_data_voor_MmmooOgle_versie 5-4-2024.pdf"
          );
        }
      }
    }

    function setLegalNoticeVisibility() {
      if (permissionService.pageTopShowLegalNotice()) {
        vm.showOpenPdf = true;
      } else {
        vm.showOpenPdf = false;
      }
    }

    function getPlaceholder(){
      return $filter('i18n')('_placeholder_select_herd_');
    }

    function openSettings() {
      $state.go("settings");
    }

    $scope.$on("panic_button_success", function (event, data) {
      vm.panicButtonOpened = false;
      vm.panicButtonOpenedPT = false;
    });

    $scope.$on("panic_button_error", function (event, data) {
      vm.loadingPanicButton = false;
      vm.panicButtonError = true;
    });

    $scope.$on("new_herd", function (event, data) {
      if (vm.selectedTeam) {
        getHerdsByTeam(vm.selectedTeam.Id, true);
      }
    });

    //listen for herd by name selection on dashboard
    $scope.$on(
      "default_herd_by_name_from_dashboard_selected",
      function (event, herd) {
        vm.showPanicButton = false;
        herd = herd.toLowerCase();
        vm.selectedHerds = [];
        for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
          if (herd == vm.selectedTeam.Herds[i].Name.toLowerCase()) {
            vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
          }
        }

        vm.cookie.herd_ids = [];
        for (var i = 0; i < vm.selectedHerds.length; i++) {
          vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
        }
        setCookie(vm.user.email, JSON.stringify(vm.cookie));
        localStorage.setItem("default_values", JSON.stringify(vm.cookie));
        vm.herd_ids = vm.cookie.herd_ids;
        vm.hideHerdSelector = true;
        $timeout(function () {
          vm.hideHerdSelector = false;
        }, 0);
      }
    );

    $scope.$on("default_herds_selected", function (event, herds) {
      vm.showPanicButton = false;
      vm.selectedHerds = [];
      for (var i = 0; i < vm.selectedTeam.Herds.length; i++) {
        for (var j = 0; j < herds.length; j++) {
          if (herds[j] == vm.selectedTeam.Herds[i].Id) {
            vm.selectedHerds.push(vm.selectedTeam.Herds[i]);
          }
        }
      }

      vm.cookie.herd_ids = [];
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        vm.cookie.herd_ids.push(vm.selectedHerds[i].Id);
      }
      setCookie(vm.user.email, JSON.stringify(vm.cookie));
      localStorage.setItem("default_values", JSON.stringify(vm.cookie));
      vm.herd_ids = vm.cookie.herd_ids;
      vm.hideHerdSelector = true;
      var state = {
        state: $state.current.name,
      };
      $timeout(function () {
        vm.hideHerdSelector = false;
      }, 0);
    });

    function setIcons() {
      var style = localStorage.getItem("style");

      if (style && style.length) {
        if (style == "aveve") {
          vm.logo = "logo_l2m.png";
          vm.panic_button = "panic_button.svg";
        } else if (style == "proxani") {
          vm.logo = "logo_proXpert.png";
          vm.panic_button = "panic_button_proxani.png";
        } else {
          vm.logo = "logo_mmm.png";
          vm.panic_button = "bel.png";
        }
      } else {
        vm.logo = "logo_mmm.png";
        vm.panic_button = "bel.png";
      }
    }

    $scope.$on("$stateChangeSuccess", function () {
      vm.current_state = $state.current.name;
      vm.showPanicButton = false;
    });

    $scope.$on("show_panic_button", function () {
      vm.showPanicButton = true;
      vm.panic_button_text = "";
      vm.loadingPanicButton = false;
      vm.panicButtonError = false;
    });

    $scope.$on("hide_panic_button", function () {
      vm.showPanicButton = false;
    });

    $scope.$on("deselect_all_herds", function (event, herd) {
      deselectHerds();
    });
    $scope.$on("deselect_all_herds_claw_health", function (event, herd) {
      deselectHerds(true);
    });
    $scope.$on("deselect_herd_home", function (event, herd) {
      deselectHerds();
      $state.go("redirect");
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
	'use strict';
	angular.module('My.theme.components').directive('pageTop', pageTop);
	/** @ngInject */
	function pageTop() {
		return {
			restrict: 'E'
			, templateUrl: 'app/theme/components/pageTop/pageTop.html'
			, controller: 'pageTopCtrl'
			, controllerAs: 'vm'
		};
	}
})();

(function () {
    'use strict';
    angular.module('My.theme.components').factory('pageTopService', pageTopService);
    /** @ngInject */
    function pageTopService(APP_CONSTANTS, $http, $q) {

        return {
            getUserTeamHerdAccess: getUserTeamHerdAccess,
            getTeams: getTeams,
            getHerdsByTeam: getHerdsByTeam
        }


        function getUserTeamHerdAccess(user_id, suffix) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'users/' + user_id + '/userteamherdaccess' + suffix).then(success).catch(error);

        }


        function getHerdsByTeam(team_id, suffix) {
            var urls = '/herds';
            if(suffix){
                urls += suffix;
            }
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + urls).then(success).catch(error);
        }

        function getTeams() {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams?-orderby=name').then(success).catch(error);
        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }

    };
})();

(function () {
    "use strict";
    angular.module("My.theme.components").controller("swooshCtrl", swooshCtrl);
    /** @ngInject */
    function swooshCtrl($scope) {

        var vm = this;

        init();

        function init(){
            var style = localStorage.getItem("style");
            vm.style = style;
            if(style){
                if(style == 'proxani'){
                    vm.swoosh = 'assets/img/swoosh.svg'
                }else{
                    vm.swoosh = 'assets/img/swoosh_aveve.png'
                }

            }else {
                vm.swoosh = 'assets/img/logo_mmm.png'
            }
        }
        
    }
  })();
  
(function () {
    'use strict';
  
    angular.module('My.theme.components')
        .directive('swoosh', swoosh);
  
    /** @ngInject */
    function swoosh() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/swoosh/swoosh.html',
        controller: 'swooshCtrl',
        controllerAs: 'vm'
      };
    }
  
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme.components')
	  .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
	return {
	  restrict: 'EA',
	  scope: {
		ngModel: '='
	  },
	  templateUrl: 'app/theme/components/widgets/widgets.html',
	  replace: true
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
	return function(input) {
	  return layoutPaths.images.root + input;
	};
  }

})();

(function () {
    'use strict';
  
    angular.module('My.theme')
        .filter('flagImg', flagImg);
  
    /** @ngInject */
    function flagImg(layoutPaths) {
      return function(input) {
        return layoutPaths.images.root + 'flags/' + input;
      };
    }
  
  })();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
	return function(input) {
	  return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	  .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
	return function(input, ext) {
	  ext = ext || 'png';
	  return layoutPaths.images.profile + input + '.' + ext;
	};
  }

})();

(function(){
	'use strict'
	angular.module('My.theme').filter('tel', function () {
    return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return tel;
        }

        if (country == 1) {
            country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " (" + city + ") " + number).trim();
    };
});
	
})();
(function () {
	'use strict';
	angular.module('My.theme').filter('propsFilter', function () {
		return function (items, props) {
			var out = [];

			if (angular.isArray(items)) {
				var keys = Object.keys(props);

				items.forEach(function (item) {
					var itemMatches = false;

					for (var i = 0; i < keys.length; i++) {
						var prop = keys[i];
						var text = props[prop].toLowerCase();
						if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
							itemMatches = true;
							break;
						}
					}

					if (itemMatches) {
						out.push(item);
					}
				});
			} else {
				// Let the output be the input untouched
				out = items;
			}

			return out;
		};
	});
})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('My.theme')
	.filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
	return function(text) {
	  return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
	};
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('My.theme.inputs')
	  .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
	return {
	  templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
	  scope: {
		switcherStyle: '@',
		switcherValue: '='
	  }
	};
  }

})();

(function () {
  "use strict";
  angular
    .module("My.pages.concentrate.feeding")
    .controller("feedingCtrl", feedingCtrl);
  /** @ngInject */
  function feedingCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "concentrate"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "concentrate"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.concentrateActiveType;
      var activeSource = aDashboardsService.concentrateSourceType;
      var dashboard_id;
      if (!activeType && !activeSource) {
        dashboard_id = vm.concentrateFeedingDashboard;
        aDashboardsService.concentrateActiveType = "trend";
      } else {
        if (activeType == "trend") {
          if (activeSource) {
            dashboard_id = vm.concentrateFeedingPer100Dashboard;
          } else {
            dashboard_id = vm.concentrateFeedingDashboard;
          }
        } else {
          if (activeSource) {
            dashboard_id = vm.concentrateFeedingPer100ActualDashboard;
          } else {
            dashboard_id = vm.concentrateFeedingActualDashboard;
          }
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-concentrate" ||
              _dash.subcategory == "proxani-concentrate") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-concentrate_en-GB_twb/ConcentratepercowTrend?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "concentrate.feeding",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkP100: true,
          checkConcentrate: true,
          stateList: [
            {
              title: "_page_title_concentrate_overview_",
              state: "concentrate.overview",
            },
            {
              title: "_page_title_concentrate_feeding_short_",
            },
            { title: "_page_title_leftovers_", state: "concentrate.leftovers" },
            {
              title: "_page_title_concentrate_intake_short_",
              state: "concentrate.intake",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.concentrateFeedingDashboard = i18nFilter(
        "_dashboard_id_concentrate_per_cow_trend_"
      );
      vm.concentrateFeedingActualDashboard = i18nFilter(
        "_dashboard_id_concentrate_per_cow_actual_"
      );
      vm.concentrateFeedingPer100Dashboard = i18nFilter(
        "_dashboard_id_concentrate_per_100Kg_trend_"
      );
      vm.concentrateFeedingPer100ActualDashboard = i18nFilter(
        "_dashboard_id_concentrate_per_100Kg_actual_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.concentrate.intake")
    .controller("intakeCtrl", intakeCtrl);
  /** @ngInject */
  function intakeCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;
    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "concentrate"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "concentrate"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.concentrateActiveType;
      var dashboard_id;
      if (!activeType) {
        dashboard_id = vm.concentrateIntakeDashboard;
        aDashboardsService.concentrateActiveType = "trend";
      } else {
        if (activeType == "trend") {
          dashboard_id = vm.concentrateIntakeDashboard;
        } else {
          dashboard_id = vm.concentrateIntakeActualDashboard;
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-concentrate" ||
              _dash.subcategory == "proxani-concentrate") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-concentrate_en-GB_twb/ConcentrateIntakebyconcTrend?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "concentrate.intake",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkConcentrate: true,
          stateList: [
            {
              title: "_page_title_concentrate_overview_",
              state: "concentrate.overview",
            },
            {
              title: "_page_title_concentrate_feeding_short_",
              state: "concentrate.feeding",
            },
            { title: "_page_title_leftovers_", state: "concentrate.leftovers" },
            {
              title: "_page_title_concentrate_intake_short_",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.concentrateIntakeDashboard = i18nFilter(
        "_dashboard_id_concentrate_intake_by_conc_trend_"
      );
      vm.concentrateIntakeActualDashboard = i18nFilter(
        "_dashboard_id_concentrate_intake_per_cow_actual_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }
      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.concentrate.overview")
    .controller("overviewCtrl", overviewCtrl);
  /** @ngInject */
  function overviewCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "concentrate"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "concentrate"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.concentrateOverviewDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-concentrate" ||
              _dash.subcategory == "proxani-concentrate") &&
            _dash.id == vm.concentrateOverviewDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            " https://visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-concentrate_en-GB_twb/Concentratebyherd?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "concentrate.overview",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
          changeStateVisible: true,
          handleBasis: true,
          basisValueParameterName: vm.basisValueParameterName,
          stateList: [
            {
              title: "_page_title_concentrate_overview_",
            },
            {
              title: "_page_title_concentrate_feeding_short_",
              state: "concentrate.feeding",
            },
            { title: "_page_title_leftovers_", state: "concentrate.leftovers" },
            {
              title: "_page_title_concentrate_intake_short_",
              state: "concentrate.intake",
            },
          ],
        };

        if (vm.selectedHerds && vm.selectedHerds.length == 1) {
          arvestaDashboardService
            .getRationBasis(vm.selectedHerds[0])
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.dashboardData.basisValues = response;
              $timeout(function () {
                vm.loadingDashboards = false;
              }, 200);
            })
            .catch(function (e) {
              console.log(e);
              $timeout(function () {
                vm.loadingDashboards = false;
              }, 200);
            });
        } else {
          $timeout(function () {
            vm.loadingDashboards = false;
          }, 200);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ") {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.concentrateOverviewDashboard = i18nFilter(
        "_dashboard_id_concentrate_by_herd_"
      );

      vm.basisValueParameterName = i18nFilter(
        "_parameter_name_kg_basis_parameter_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.concentrate.leftovers")
    .controller("leftoversCtrl", leftoversCtrl);
  /** @ngInject */
  function leftoversCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "concentrate"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "concentrate"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.concentrateActiveType;
      var dashboard_id;
      if (!activeType) {
        dashboard_id = vm.leftoversDashboard;
        aDashboardsService.concentrateActiveType = "trend";
      } else {
        if (activeType == "trend") {
          dashboard_id = vm.leftoversDashboard;
        } else {
          dashboard_id = vm.leftoversDashboardActual;
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-concentrate" ||
              _dash.subcategory == "proxani-concentrate") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https:///visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-concentrate_en-GB_twb/Leftoverstrend?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "concentrate.leftovers",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkConcentrate: true,
          stateList: [
            {
              title: "_page_title_concentrate_overview_",
              state: "concentrate.overview",
            },
            {
              title: "_page_title_concentrate_feeding_short_",
              state: "concentrate.feeding",
            },
            { title: "_page_title_leftovers_" },
            {
              title: "_page_title_concentrate_intake_short_",
              state: "concentrate.intake",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.leftoversDashboard = i18nFilter("_rap_workbook_id_leftovers_trends_");
      vm.leftoversDashboardActual = i18nFilter(
        "_rap_workbook_id_leftovers_actual_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.addNewHerd').controller('addNewHerdCtrl', addNewHerdCtrl);
	/** @ngInject */
	function addNewHerdCtrl(addNewHerdService, $rootScope, $scope, $state, APP_CONSTANTS) {
		var vm = this;
		vm.addNewHerd = addNewHerd;
		vm.goToMyHerds = goToMyHerds;
		vm.init = init;
		init();

		function init() {
			setCountries();
			
			vm.errorOccured = false;
			vm.successfullyAdded = false;
			vm.selectPlaceholder = '_label_select_country_placeholder_';
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.herdDTO = {
				Email: vm.user.email ? angular.copy(vm.user.email): ''
			};
			vm.setFavorite = true;
			vm.setFavoriteError = false;
			if (vm.defaultValues && vm.defaultValues.team_id) {
				vm.selectedTeam = vm.defaultValues.team_id;
			}
		}

		function addNewHerd() {
			vm.errorOccured = false;
			if (!vm.herdForm.$invalid) {
				vm.loading = true;
				vm.herdDTO.Address.CountryCode = getCodeByName(vm.selectedCountry.code);
				return addNewHerdService.addNewHerd(vm.herdDTO, vm.selectedTeam).then(function (response) {
					if (vm.setFavorite) {
						setFavorite(response.HerdId);
					} else {
						vm.loading = false;
						vm.successfullyAdded = true;
					}
					brodcastNewHerd();
				}).catch(function (error) {
					console.log(error)
					vm.loading = false;
					vm.errorOccured = true;
				})
			}
		}

		function setFavorite(herd_id) {
			return addNewHerdService.setFavorite(herd_id).then(function (response) {
				vm.loading = false;
				vm.successfullyAdded = true;
				vm.setFavoriteError = false;

			}).catch(function (error) {
				console.log(error)
				vm.loading = false;
				vm.successfullyAdded = true;
				vm.setFavoriteError = true;
			})
		}

		function goToMyHerds() {
			$state.go('myHerds');
		}

		$scope.$on('default_team_selected', function () {
			init();
		})

		function getCodeByName(name) {
			var code = 0;
			var list = APP_CONSTANTS.constants.countryCodeList
			angular.forEach(list, function (value, key) {
				if (key == name) {
					code = value;
				}
			})
			return code;
		}

		function setCountries(){
			vm.countries = angular.copy(APP_CONSTANTS.constants.countries);
		}
		

		function brodcastNewHerd() {
			$rootScope.$broadcast('new_herd');
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.addNewHerd').factory('addNewHerdService', addNewHerdService);
	/** @ngInject */
	function addNewHerdService(APP_CONSTANTS, $http, $q) {
		return {
			addNewHerd: addNewHerd,
			setFavorite: setFavorite
			
		}

		function addNewHerd(herd, teamId) {
			return $http.post(APP_CONSTANTS.backoffice_base_url + 'teams/' + teamId + '/addherd', herd).then(success).catch(error);
		}
		
		function setFavorite(herd) {
			return $http.post(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd + '/addtofavorites').then(success).catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();
(function () {
  "use strict";
  angular
    .module("My.pages.herds.attentionMRO")
    .controller("attentionListMROCtrl", attentionListMROCtrl);
  /** @ngInject */
  function attentionListMROCtrl(
    $filter,
    $scope,
    attentionListMROService,
    $q,
    attentionListMRODataService,
    editableOptions,
    editableThemes,
    APP_CONSTANTS,
    $timeout,
    xlsxService,
    $locale,
    $rootScope,
    $uibModal,
    $uibModalStack,
    $window,
    $location
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");

    var parityTimeout;
    var DIMTimeout;
    var filterTimeout;
    var exportTimeout;
    var thresholdTimeout;

    vm.getSCCClass = getSCCClass;
    vm.init = init;
    vm.parityCategoryChanged = parityCategoryChanged;
    vm.DIMCategoryChanged = DIMCategoryChanged;
    vm.selectParity = selectParity;
    vm.selectDIM = selectDIM;
    vm.adviceChanged = adviceChanged;
    vm.thresholdChanged = thresholdChanged;
    vm.exportToExcel = exportToExcel;
    vm.exportToPDF = exportToPDF;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.saveAdvice = saveAdvice;
    vm.goToCow = goToCow;
    vm.selectAll = selectAll;
    vm.sort = sort;
    vm.sccFilterChanged = sccFilterChanged;
    vm.selectShowDry = selectShowDry;
    vm.tooltipExcel = i18nFilter("_button_export_");
    vm.tooltipPDF = i18nFilter("_label_export_pdf_");

    vm.loading = false;
    vm.errorLoading = false;
    vm.selectedHerds = [];
    vm.timeSelectorChangedTimeout;

    vm.cowSCCThreshold = 250;
    vm.cowSCCFilterValue = 250;
    vm.heiferSCCThreshold = 150;
    vm.heiferSCCFilterValue = 150;
    vm.adviceList = angular.copy(APP_CONSTANTS.constants.adviceList);
    vm.parityCategories = angular.copy(
      APP_CONSTANTS.constants.parityCategories
    );
    vm.DIMCategories = angular.copy(APP_CONSTANTS.constants.dimCategories);
    vm.adviceList = setAdviceList(vm.adviceList);

    vm.DIMCategories = setDIMCategories(vm.DIMCategories);

    init();

    function init() {
      vm.sort_col = "DIM_ASC";
      vm.sortedColumn = "DIM";
      vm.order = "ASC";
      vm.cowGreaterThan = true;
      vm.heiferGreaterThan = true;
      vm.showDry = true;
      vm.loading = false;
      vm.errorLoading = false;
      var width = $window.innerWidth;
      if (width < 1600) {
        vm.showColumns = true;
      }
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.dateFrom = moment().subtract(1, "years").format("YYYY-MM-DD");
      vm.dateTo = moment().format("YYYY-MM-DD");

      vm.selectedParityCategory = vm.parityCategories[0];
      vm.selectedDIMCategory = vm.DIMCategories[0];

      vm.parityList = setParityList(vm.selectedParityCategory);
      vm.DIMList = setDIMList(vm.selectedDIMCategory);
      vm.allParities = true;
      vm.allDIMs = true;

      if (vm.selectedHerds.length == 1) {
        $rootScope.$broadcast("attention_mro_data_loaded", true);
        getData(vm.selectedHerds[0]);
      }
    }

    function getData(herdId) {
      vm.loading = true;
      var loadedData = attentionListMRODataService.loadedData;
      if (loadedData && loadedData.herdId == herdId) {
        var mroData = loadedData.mroData;
        var healthEvents = loadedData.healthEvents;
        var animals = loadedData.animals;
        handleData(mroData, healthEvents, animals);
      } else {
        getDataFromAPI(herdId);
      }
    }

    function getDataFromAPI(herdId) {
      //var getAnimals = attentionListMROService.getAnimals(herdId);

      var startDate = moment(vm.dateFrom)
        .subtract(1, "years")
        .format("YYYY-MM-DD");
      var endDate = moment(vm.dateTo).add(1, "years").format("YYYY-MM-DD");
      var getMROData = attentionListMROService.getMROResults(
        herdId,
        startDate,
        endDate
      );
      var getHealthEvents = attentionListMROService.getHealthEvents(
        herdId,
        startDate,
        endDate
      );

      var getLactations = attentionListMROService.getLactations(herdId);

      $q.all([getMROData, getHealthEvents, getLactations])
        .then(function (data) {
          var mroData = data[0];
          var healthEvents = data[1];
          var animals = attentionListMRODataService.getAnimals(mroData);
          var lactations = data[2];
          handleData(mroData, healthEvents, animals, lactations);
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
        });
    }

    function handleData(mroData, healthEvents, animals, lactations) {
      vm.mroDates = attentionListMRODataService.getMRODates(
        mroData,
        vm.dateFrom,
        vm.dateTo
      );

      vm.lastMroDates = setLastMroDates(vm.mroDates);

      vm.animals = attentionListMRODataService.setAnimalsData(
        animals,
        mroData,
        vm.mroDates,
        healthEvents,
        vm.cowSCCThreshold,
        vm.heiferSCCThreshold,
        vm.adviceList,
        lactations
      );

      vm.filteredAnimals = filterAnimals(vm.animals);
      vm.filteredAnimals = orderList(
        vm.filteredAnimals,
        vm.order,
        vm.sortedColumn
      );
      vm.loading = false;
      vm.errorLoading = false;
    }

    function setLastMroDates(mroDates) {
      var list = mroDates.slice(-3);

      list = list.map(function (date) {
        return $filter("date")(new Date(date), "shortDate");
      });

      return list;
    }

    function onTimeSelectorChanged(time) {
      setDates(time);
    }

    function setDates(time) {
      vm.dateTo = moment().format("YYYY-MM-DD");
      if (time == 7) {
        vm.dateFrom = moment().subtract(7, "days").format("YYYY-MM-DD");
      } else if (time == 30) {
        vm.dateFrom = moment().subtract(30, "days").format("YYYY-MM-DD");
      } else if (time == 90) {
        vm.dateFrom = moment().subtract(90, "days").format("YYYY-MM-DD");
      } else if (time == 1) {
        vm.dateFrom = moment().subtract(1, "years").format("YYYY-MM-DD");
      } else if (time == 2) {
        vm.dateFrom = moment().subtract(2, "years").format("YYYY-MM-DD");
      } else if (time == 5) {
        vm.dateFrom = moment().subtract(5, "years").format("YYYY-MM-DD");
      } else if (time == 10) {
        vm.dateFrom = moment().subtract(10, "years").format("YYYY-MM-DD");
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            vm.dateFrom = moment(vm.start_date).format("YYYY-MM-DD");
            vm.dateTo = moment(vm.end_date).format("YYYY-MM-DD");
            closeModal();
            vm.loading = true;
            $timeout(function () {
              getData(vm.selectedHerds[0]);
            }, 50);
          }
        }
      }
    }

    function getSCCClass(animal, date) {
      return attentionListMRODataService.getSCCClass(
        animal,
        animal[date.propertyName],
        vm.cowSCCThreshold,
        vm.heiferSCCThreshold
      );
    }

    function setAdviceList(list) {
      var adviceList = [];

      list.forEach(function (advice) {
        var adviceObj = {
          id: advice.id,
          value: i18nFilter(advice.value),
        };
        adviceList.push(adviceObj);
      });

      adviceList.splice(0, 0, {
        id: 69,
        value: "",
      });
      return adviceList;
    }

    function saveAdvice(data, advice) {
      var advicelist = [
        {
          Id: advice.mroId,
          Advice: data.id != 69 ? data.id : null,
        },
      ];

      if (vm.selectedHerds.length == 1 && data.id) {
        return attentionListMROService
          .updateAdvice(vm.selectedHerds[0], advicelist)
          .then(function (response) {});
      }
    }

    function goToCow(cow) {
      var url =
        "https://my.mmmooogle.com/herds/animals/" + cow.AnimalId.toString(16);
      $window.open(url, "_blank");
    }

    function selectAll(value) {
      vm.filteredAnimals = vm.filteredAnimals.map(function (animal) {
        animal.Selected = value;
        return animal;
      });
    }

    function setDIMCategories(list) {
      list = list.map(function (category) {
        category.translatedValue = i18nFilter(category.value);
        return category;
      });

      return list;
    }

    function setParityList(selectedParity) {
      var parities = selectedParity.parities.map(function (parity) {
        parity.selected = true;
        return parity;
      });
      return parities;
    }

    function setDIMList(selectedDIM) {
      var DIMs = selectedDIM.dims.map(function (dim) {
        dim.selected = true;
        return dim;
      });
      return DIMs;
    }

    function parityCategoryChanged() {
      if (parityTimeout) {
        $timeout.cancel(parityTimeout);
      }

      parityTimeout = $timeout(function () {
        vm.allParities = true;
        vm.parityList = setParityList(vm.selectedParityCategory);
        filterChanged();
      }, 500);
    }

    function DIMCategoryChanged() {
      if (DIMTimeout) {
        $timeout.cancel(DIMTimeout);
      }

      DIMTimeout = $timeout(function () {
        vm.allDIMs = true;
        vm.DIMList = setDIMList(vm.selectedDIMCategory);
        filterChanged();
      }, 500);
    }

    function selectParity(parity) {
      if (parity.id == 69) {
        vm.allParities = !vm.allParities;
        vm.parityList = setAllParities(vm.parityList, vm.allParities);
      } else {
        vm.parityList = vm.parityList.map(function (p) {
          if (p.id == parity.id) {
            p.selected = !p.selected;
          }
          return p;
        });

        var hasUnselected = vm.parityList.some(function (p) {
          return !p.selected;
        });

        if (hasUnselected) {
          vm.allParities = false;
        } else {
          vm.allParities = true;
        }
      }

      filterChanged();
    }

    function setAllParities(parityList, value) {
      parityList = parityList.map(function (parity) {
        parity.selected = value;
        return parity;
      });

      return parityList;
    }

    function selectDIM(dim) {
      if (dim.id == 69) {
        vm.allDIMs = !vm.allDIMs;
        vm.DIMList = setAllDIMs(vm.DIMList, vm.allDIMs);
      } else {
        vm.DIMList = vm.DIMList.map(function (d) {
          if (d.id == dim.id) {
            d.selected = !d.selected;
          }
          return d;
        });

        var hasUnselected = vm.DIMList.some(function (d) {
          return !d.selected;
        });

        if (hasUnselected) {
          vm.allDIMs = false;
        } else {
          vm.allDIMs = true;
        }
      }

      filterChanged();
    }

    function setAllDIMs(dimList, value) {
      dimList = dimList.map(function (dim) {
        dim.selected = value;
        return dim;
      });

      return dimList;
    }

    function adviceChanged() {
      filterChanged();
    }

    function filterAnimals(animals) {
      var filteredAnimals = animals.filter(function (animal) {
        var parity = getParityFilter(animal, vm.parityList);
        var dim = getDIMFilter(animal, vm.DIMList);
        var advice = getAdviceFilter(animal, vm.selectedAdvice);
        var scc = getSCCFilter(animal);
        return parity && dim && advice && scc;
      });

      return filteredAnimals;
    }
    function getSCCFilter(animal) {
      var less = false;
      var greater = false;
      var equal = false;
      var equalSelected = false;
      var compareSelected = false;

      if (vm.showDry) {
        if (!animal.SCC) {
          return true;
        }
      }

      if (animal.Parity == 1) {
        equalSelected = vm.heiferEqual;
        compareSelected = vm.heiferLessThan || vm.heiferGreaterThan;
        if (vm.heiferLessThan && !animal.SCC) {
          return true;
        }
        if (vm.heiferEqual) {
          equal = animal.SCC == vm.heiferSCCFilterValue;
        } else {
          equal = true;
        }
        if (vm.heiferLessThan) {
          less = animal.SCC < vm.heiferSCCFilterValue;
          greater = true;
        } else {
          less = true;
        }

        if (vm.heiferGreaterThan) {
          greater = animal.SCC > vm.heiferSCCFilterValue;
          less = true;
        } else {
          greater = true;
        }
      } else {
        equalSelected = vm.cowEqual;
        compareSelected = vm.cowLessThan || vm.cowGreaterThan;
        if (vm.cowLessThan && !animal.SCC) {
          return true;
        }
        if (vm.cowEqual) {
          equal = animal.SCC == vm.cowSCCFilterValue;
        } else {
          equal = true;
        }
        if (vm.cowLessThan) {
          less = animal.SCC < vm.cowSCCFilterValue;
          greater = true;
        } else {
          less = true;
        }

        if (vm.cowGreaterThan) {
          greater = animal.SCC > vm.cowSCCFilterValue;
          less = true;
        } else {
          greater = true;
        }
      }

      if (equalSelected && compareSelected) {
        return (less || equal) && (greater || equal);
      }

      return less && greater && equal;
    }

    function sort(column) {
      var col;
      if (!vm.loading) {
        if (column != vm.sortedColumn) {
          vm.sortedColumn = column;
          vm.order = "ASC";
          col = column + "_" + vm.order;
        } else {
          if (vm.order == "ASC") {
            vm.order = "DESC";
            col = column + "_" + vm.order;
          } else if (vm.order == "DESC") {
            vm.order = null;
            vm.sortedColumn = null;
            col = null;
          }
        }
        vm.sort_col = col;

        vm.filteredAnimals = orderList(
          vm.filteredAnimals,
          vm.order,
          vm.sortedColumn
        );
      }
    }

    function orderList(list, orderValue, column) {
      var order;
      if (orderValue == "ASC") {
        order = false;
      } else if (orderValue == "DESC") {
        order = true;
      }
      if (column) {
        if (column.indexOf("display") == -1 && column.indexOf("advice") == -1) {
          list = $filter("orderBy")(list, column, order);
        } else {
          if (column.indexOf("advice") == -1) {
            list = list.sort(function (a, b) {
              return order ? b[column] - a[column] : a[column] - b[column];
            });
          } else {
            list = list.sort(function (a, b) {
              var aValue =
                a[column].advice && a[column].advice.id
                  ? a[column].advice.id
                  : 0;
              var bValue =
                b[column].advice && b[column].advice.id
                  ? b[column].advice.id
                  : 0;

              return order ? bValue - aValue : aValue - bValue;
            });
          }
        }
      } else {
        list = $filter("orderBy")(list, "Number");
      }
      return list;
    }

    function filterChanged() {
      if (filterTimeout) {
        $timeout.cancel(filterTimeout);
      }

      filterTimeout = $timeout(function () {
        vm.filteredAnimals = filterAnimals(vm.animals);
        vm.filteredAnimals = orderList(
          vm.filteredAnimals,
          vm.order,
          vm.sortedColumn
        );
      }, 500);
    }

    function getParityFilter(animal, parityList) {
      var parity = false;
      if (vm.allParities) {
        parity = true;
      } else {
        var flags = [];
        parityList.forEach(function (p) {
          var flag;
          if (p.selected) {
            switch (p.id) {
              case 1:
                flag = animal.Parity == 1 ? true : false;
                break;

              case 2:
                flag = animal.Parity == 2 ? true : false;
                break;

              case 3:
                flag = animal.Parity >= 2 ? true : false;

                break;
              case 4:
                flag = animal.Parity >= 3 ? true : false;
                break;

              default:
                break;
            }

            flags.push(flag);
          }
        });

        var trueFlag = flags.some(function (f) {
          return f;
        });

        if (trueFlag) {
          parity = true;
        }
      }

      return parity;
    }

    function getDIMFilter(animal, DIMList) {
      var dim = false;
      if (vm.allDIMs) {
        dim = true;
      } else {
        var flags = [];
        DIMList.forEach(function (d) {
          var flag;
          if (d.selected) {
            switch (d.id) {
              case 1:
                flag = animal.DIM < 60 ? true : false;
                break;

              case 2:
                flag = animal.DIM >= 60 && animal.DIM <= 120 ? true : false;
                break;

              case 3:
                flag = animal.DIM >= 120 && animal.DIM <= 200 ? true : false;
                break;

              case 4:
                flag = animal.DIM >= 200 && animal.DIM <= 305 ? true : false;
                break;
              case 5:
                flag = animal.DIM > 305 ? true : false;
                break;
              case 6:
                flag = animal.DIM < 41 ? true : false;
                break;
              case 7:
                flag = animal.DIM >= 41 && animal.DIM <= 80 ? true : false;
                break;
              case 8:
                flag = animal.DIM >= 81 && animal.DIM <= 120 ? true : false;
                break;
              case 9:
                flag = animal.DIM >= 121 && animal.DIM <= 160 ? true : false;
                break;
              case 10:
                flag = animal.DIM >= 161 && animal.DIM <= 200 ? true : false;
                break;
              case 11:
                flag = animal.DIM > 200 ? true : false;
                break;

              default:
                break;
            }

            flags.push(flag);
          }
        });

        var trueFlag = flags.some(function (f) {
          return f;
        });

        if (trueFlag) {
          dim = true;
        }
      }

      return dim;
    }

    function sccFilterChanged(animal, sign) {
      var signValue;
      var opositeValue;

      if (sign == 1) {
        signValue = "LessThan";
        opositeValue = "GreaterThan";
      } else if (sign == 3) {
        signValue = "GreaterThan";
        opositeValue = "LessThan";
      } else {
        signValue = "Equal";
      }

      var property = animal.concat(signValue);
      var opositeProperty = animal.concat(opositeValue);

      vm[property] = !vm[property];
      if (sign == 1 || sign == 3) {
        vm[opositeProperty] = false;
      }

      filterChanged();
    }

    function selectShowDry() {
      vm.showDry = !vm.showDry;
      filterChanged();
    }

    function thresholdChanged() {
      if (thresholdTimeout) {
        $timeout.cancel(thresholdTimeout);
      }
      thresholdTimeout = $timeout(function () {
        vm.filteredAnimals = setThresholds(vm.filteredAnimals);
      }, 500);

      filterChanged();
    }

    function setThresholds(animals) {
      animals = animals.map(function (animal) {
        animal.highSCC = attentionListMRODataService.calculateHighSCC(
          animal.MROList,
          animal.Parity,
          vm.cowSCCThreshold,
          vm.heiferSCCThreshold
        );
        animal.highSCCPrevious = attentionListMRODataService.calculateHighSCC(
          animal.MROList,
          animal.Parity - 1,
          vm.cowSCCThreshold,
          vm.heiferSCCThreshold
        );
        return animal;
      });

      return animals;
    }

    function getAdviceFilter(animal, selectedAdvice) {
      var advice = true;
      if (selectedAdvice) {
        if (selectedAdvice.id == 69) {
          advice = true;
        } else {
          advice =
            animal.advice_0 &&
            animal.advice_0.advice &&
            animal.advice_0.advice.id == selectedAdvice.id;
        }
      }

      return advice;
    }

    function exportToExcel() {
      if (exportTimeout) {
        $timeout.cancel(exportTimeout);
      }
      exportTimeout = $timeout(function () {
        exportData();
      }, 500);
    }

    function exportToPDF() {
      if (exportTimeout) {
        $timeout.cancel(exportTimeout);
      }
      exportTimeout = $timeout(function () {
        exportPDF();
      }, 500);
    }

    function exportData() {
      var data = attentionListMRODataService.generateExportData(
        vm.filteredAnimals,
        vm.mroDates,
        vm.cowSCCThreshold,
        vm.heiferSCCThreshold
      );

      var fileName = i18nFilter("_page_title_attention_mro_") + ".xlsx";
      var dateFormat = xlsxService.getShortDateFormat($locale);

      var ws = XLSX.utils.aoa_to_sheet(data.list, {
        cellDates: true,
        dateNF: dateFormat,
      });
      ws["!cols"] = attentionListMRODataService.setColumnsWidth(vm.mroDates);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        i18nFilter("_page_title_attention_mro_")
      );
      XLSX.writeFile(wb, fileName);
    }

    function exportPDF() {
      var maxDates = 18;
      var mroLength = vm.mroDates.length;
      var mroDates = angular.copy(vm.mroDates);

      if (mroLength > maxDates) {
        var diff = mroLength - maxDates;
        mroDates.splice(0, diff);
      }

      try {
        var dd = attentionListMRODataService.generatePDFData(
          vm.filteredAnimals,
          mroDates,
          vm.cowSCCThreshold,
          vm.heiferSCCThreshold
        );

        var customLayout = attentionListMRODataService.getCustomLayout();

        var fileName = i18nFilter("_page_title_attention_mro_") + ".pdf";
        pdfMake.createPdf(dd, customLayout).download(fileName);
      } catch (error) {
        console.log(error);
      }
    }

    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });
    $scope.$on("time_selector_changed", function (event, time) {
      if (time != 69) {
        vm.loading = true;
        if (vm.timeSelectorChangedTimeout) {
          $timeout.cancel(vm.timeSelectorChangedTimeout);
        }
        vm.timeSelectorChangedTimeout = $timeout(function () {
          onTimeSelectorChanged(time);
          if (vm.selectedHerds.length == 1) {
            getData(vm.selectedHerds[0]);
          }
        }, 750);
      } else {
        vm.start_date = new Date(vm.dateFrom);
        vm.end_date = new Date(vm.dateTo);

        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    });

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("attention_mro_data_loaded", null);
    });

    angular.element($window).bind("resize", function () {
      var width = $window.innerWidth;
      if (width < 1600) {
        vm.showColumns = true;
      } else {
        vm.showColumns = false;
      }
    });

    editableOptions.theme = "bs3";
    editableOptions.blurElem = "submit";
    editableThemes["bs3"].submitTpl =
      '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes["bs3"].cancelTpl =
      '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.attentionMRO")
    .factory("attentionListMRODataService", attentionListMRODataService);
  /** @ngInject */
  function attentionListMRODataService($filter, APP_CONSTANTS, appService) {
    var i18nFilter = $filter("i18n");
    var dryLabel = i18nFilter("_animal_status_dry_");
    var adviceList = APP_CONSTANTS.constants.adviceList;
    var statusList = APP_CONSTANTS.constants.animalStatusList;

    return {
      setAnimalsData: setAnimalsData,
      getMRODates: getMRODates,
      getSCCClass: getSCCClass,
      generateExportData: generateExportData,
      setColumnsWidth: setColumnsWidth,
      generatePDFData: generatePDFData,
      getCustomLayout: getCustomLayout,
      calculateHighSCC: calculateHighSCC,
      getAnimals: getAnimals,
      loadedData: {},
    };

    function getAnimals(mroData) {
      var animals = [];
      var gByAnimals = appService.groupBy(mroData, "AnimalId");
      for (var key in gByAnimals) {
        gByAnimals[key] = $filter("orderBy")(gByAnimals[key], "Parity", true);
        animals.push(gByAnimals[key][0]);
      }
      return animals;
    }

    function setAnimalsData(
      animals,
      mroData,
      mroDates,
      healthEvents,
      cowsThreshold,
      heifersThreshold,
      adviceList,
      lactations
    ) {
      dryLabel = i18nFilter("_animal_status_dry_");
      var animalsList = [];
      if (mroData && mroData.length > 0 && mroDates && mroDates.length > 0) {
        var lastMRODate = mroDates[mroDates.length - 1].date;
        var animalsWithMRO = getAnimalsWithMRO(animals, mroData, lastMRODate);
        animalsWithMRO = setClinicalMastitisData(animalsWithMRO, healthEvents);
        animalsWithMRO = setLactations(animalsWithMRO, lactations);

        animalsWithMRO.forEach(function (animal) {
          animalsList.push(
            new Animal(
              animal,
              cowsThreshold,
              heifersThreshold,
              lastMRODate,
              healthEvents
            )
          );
        });

        animalsList = setMROPerDate(animalsList, mroData, mroDates, adviceList);
        var totalMilk = calculateTotalMilk(animalsList, lastMRODate);
        animalsList = setTankPercentage(animalsList, totalMilk, lastMRODate);
        animalsList = $filter("orderBy")(animalsList, "SCC", true);
      }

      return animalsList;
    }

    function setLactations(animals, lactations) {
      return animals.map(function (animal) {
        var animalLactations = lactations.filter(function (lactation) {
          return lactation.AnimalId == animal.AnimalId;
        });
        animal.Lactations = animalLactations;
        return animal;
      });
    }

    function getMRODates(mroData, dateFrom, dateTo) {
      mroData = $filter("orderBy")(mroData, "Date");
      var dates = [];
      mroData.forEach(function (mro) {
        if (mro.Date) {
          var date = moment(mro.Date).format("YYYY-MM-DD");
          var dateProperty = "SCC_" + date;
          var datePropertyDisplay = "SCC_display_" + date;
          var existingDate = dates.find(function (d) {
            return d.date == date;
          });
          if (
            !existingDate &&
            moment(dateFrom).isSameOrBefore(date) &&
            moment(dateTo).isSameOrAfter(date)
          ) {
            var mroList = mroData.filter(function (mroItem) {
              return (
                moment(mroItem.Date).format("YYYY-MM-DD") == date &&
                mroItem.AmountKg
              );
            });

            if (mroList.length > 0) {
              dates.push({
                date: date,
                propertyName: dateProperty,
                displayPropertyName: datePropertyDisplay,
              });
            }
          }
        }
      });

      return dates;
    }

    function getAnimalsWithMRO(allAnimals, mroData, lastMRODate) {
      var animals = [];

      allAnimals = allAnimals.map(function (animal) {
        var mroList = mroData.filter(function (mro) {
          return mro.AnimalId == animal.AnimalId;
        });

        var hasLastMRO = mroList.some(function (mro) {
          return moment(mro.Date).format("YYYY-MM-DD") == lastMRODate;
        });

        animal.MROList = mroList ? mroList : [];
        animal.hasLastMRO = hasLastMRO;

        return animal;
      });

      animals = allAnimals.filter(function (animal) {
        return animal.MROList.length > 0 && animal.hasLastMRO;
      });

      return animals;
    }

    function Animal(animal, cowsThreshold, heifersThreshold, lastMRODate) {
      this.Selected = true;
      this.AnimalId = animal.AnimalId;
      this.EarTag = animal.EarTag;
      this.NumberString = animal.NumberString;
      this.Number = animal.Number;
      this.Name = animal.Name;
      this.Parity = animal.Parity;
      this.LastCalvingDate = animal.LastCalvingDate;
      this.CurrentStatus = animal.CurrentStatus;
      this.MROList = animal.MROList;
      this.Status = setStatus(animal.CurrentStatus);
      this.StatusDays = moment().diff(animal.StatusDate, "days");
      this.DIM = calculateDIM(animal);
      this.SCC = getLastSCC(animal.MROList, lastMRODate);
      this.highSCC = calculateHighSCC(
        animal.MROList,
        animal.Parity,
        cowsThreshold,
        heifersThreshold
      );
      this.highSCCPrevious = calculateHighSCC(
        animal.MROList,
        animal.Parity - 1,
        cowsThreshold,
        heifersThreshold
      );
      this.clinicalMastitisCases = getClinicalMastitisCases(
        animal.ClinicalMastitis,
        animal.Parity
      );
      this.clinicalMastitisCasesPrevious = getClinicalMastitisCases(
        animal.ClinicalMastitis,
        animal.Parity - 1
      );
      this.ClinicalMastitis = animal.ClinicalMastitis;
      this.Lactations = animal.Lactations;
    }

    function setStatus(currentStatus) {
      var currentStatus = statusList.find(function (status) {
        return status.id == currentStatus;
      });

      return currentStatus
        ? i18nFilter(currentStatus.value)
        : i18nFilter("_animal_status_none_");
    }

    function calculateDIM(animal) {
      if (animal.CurrentStatus == 8) {
        return 0;
      }

      var lastCalvingDate = animal.LastCalvingDate;
      var lastCalving = moment(lastCalvingDate);
      var today = moment();
      var diff = today.diff(lastCalving, "days");
      return diff + 1;
    }
    function calculateHighSCC(
      mroData,
      parity,
      cowsThreshold,
      heifersThreshold
    ) {
      var n = 0;

      mroData.forEach(function (mro) {
        if (mro.Parity == parity) {
          if (parity === 1) {
            if (mro.SCC > heifersThreshold) {
              n++;
            }
          } else {
            if (mro.SCC > cowsThreshold) {
              n++;
            }
          }
        }
      });

      return n;
    }

    function getLastSCC(mroData, lastMRODate) {
      var scc = 0;

      mroData.forEach(function (mro) {
        if (moment(mro.Date).format("YYYY-MM-DD") == lastMRODate) {
          scc = mro.SCC;
        }
      });

      return scc;
    }

    function setClinicalMastitisData(animals, healthEvents) {
      animals = animals.map(function (animal) {
        var healthEventsList = healthEvents.filter(function (healthEvent) {
          return healthEvent.AnimalId == animal.AnimalId;
        });

        animal.ClinicalMastitis = healthEventsList;

        return animal;
      });

      return animals;
    }

    function getClinicalMastitisCases(healthEvents, parity) {
      var n = 0;
      healthEvents.forEach(function (healthEvent) {
        if (healthEvent.Parity == parity) {
          n++;
        }
      });
      return n;
    }

    function setMROPerDate(animals, mroData, mroDates, adviceList) {
      animals = animals.map(function (animal) {
        mroDates.forEach(function (date, index) {
          var mro = mroData.filter(function (mro) {
            return (
              mro.AnimalId == animal.AnimalId &&
              moment(mro.Date).format("YYYY-MM-DD") == date.date
            );
          });

          var previousDate =
            mroDates[index - 1] && mroDates[index - 1].date
              ? mroDates[index - 1].date
              : moment(date.date).subtract(30, "days").format("YYYY-MM-DD");

          animal[date.propertyName] = {
            SCC: undefined,
            CMAlert: false,
            AmountKg: mro.length && mro[0].AmountKg ? mro[0].AmountKg : 0,
            Advice: mro.length ? setAdvice(mro[0], adviceList) : {},
          };

          if (index == mroDates.length - 1) {
            animal["advice_0"] = animal[date.propertyName].Advice;
          }
          if (index == mroDates.length - 2) {
            animal["advice_1"] = animal[date.propertyName].Advice;
          }
          if (index == mroDates.length - 3) {
            animal["advice_2"] = animal[date.propertyName].Advice;
          }

          animal[date.displayPropertyName] = 0;

          if (mro.length > 0) {
            animal[date.displayPropertyName] = mro[0].SCC
              ? Number(mro[0].SCC)
              : 0;
            animal[date.propertyName].SCC = mro[0].SCC
              ? mro[0].SCC
              : checkIfDry(animal, date.propertyName, date.date);
          } else {
            animal[date.displayPropertyName] = 0;
            animal[date.propertyName] = {
              SCC: checkIfDry(animal, date.propertyName, date.date),
              CMAlert: false,
              AmountKg: 0,
              Advice: {},
            };
          }

          if (animal.ClinicalMastitis && animal.ClinicalMastitis.length > 0) {
            animal[date.propertyName].CMAlert = animal.ClinicalMastitis.some(
              function (healthEvent) {
                return moment(healthEvent.StartDate).isBetween(
                  previousDate,
                  date.date,
                  "day",
                  "(]"
                );
              }
            );
          }
        });

        return animal;
      });

      return animals;
    }

    function setAdvice(mro, adviceList) {
      var adviceValue = adviceList.find(function (advice) {
        return advice.id == mro.Advice;
      });
      var advice = {
        mroId: mro.Id,
        advice: {},
      };

      if (adviceValue) {
        advice.advice = adviceValue;
      }

      return advice;
    }

    function checkIfDry(animal, propertyName, date) {
      var dry = false;
      var SCC = animal[propertyName];
      var lactations = $filter("orderBy")(animal.Lactations, "CalvingDate");

      lactations.forEach(function (lactation, index) {
        if (lactation.DryOffDate) {
          var start = lactation.DryOffDate;
          var end =
            lactations[index + 1] && lactations[index + 1].CalvingDate
              ? lactations[index + 1].CalvingDate
              : new Date();
          if (moment(date).isBetween(start, end, "day", "(]")) {
            dry = true;
          }
        }
      });

      if (SCC.AmountKg == 0 && dry) {
        return dryLabel;
      }

      return undefined;
    }

    function getSCCClass(animal, SCC, cowsThreshold, heifersThreshold) {
      var CMAlert = SCC.CMAlert;
      var SCCAlert = false;
      var dry = false;

      var classList = "";

      if (animal.Parity === 1) {
        if (SCC.SCC != dryLabel && SCC.SCC > heifersThreshold) {
          SCCAlert = true;
        }
      } else {
        if (SCC.SCC != dryLabel && SCC.SCC > cowsThreshold) {
          SCCAlert = true;
        }
      }

      if (SCC.SCC == dryLabel) {
        dry = true;
      }

      if (dry) {
        classList += "dry ";
      }

      if (CMAlert) {
        classList += "CMAlert ";
      }

      if (SCCAlert) {
        classList += "highSCC";
      }

      return classList;
    }

    function generateExportData(
      animals,
      mroDates,
      cowsThreshold,
      heifersThreshold
    ) {
      var data = {
        list: [],
      };

      var header = [
        i18nFilter("_animal_ear_tag_"),
        i18nFilter("_animal_number_"),
        i18nFilter("_animal_status_"),
        i18nFilter("_animal_parity_"),
        i18nFilter("_animal_last_calving_date_"),
        {
          v: i18nFilter("_animal_dim_"),
          t: "s",
          s: { border: { right: { style: "thin", color: { rgb: "000000" } } } },
        },
      ];
      var dates = [];
      mroDates.forEach(function (date) {
        dates.push(new Date(date.date));
      });

      header = header.concat(dates).concat(
        {
          v: i18nFilter("_label_p_tank_"),
          t: "s",
          s: {
            border: { left: { style: "thin", color: { rgb: "000000" } } },
          },
        },
        i18nFilter("_label_n_high_scc_"),
        i18nFilter("_label_n_high_scc_previous_"),
        i18nFilter("_label_n_clinical_mastitis_"),
        i18nFilter("_label_n_clinical_mastitis_previous_"),
        i18nFilter("_label_advice_")
          .concat(" ")
          .concat(
            mroDates[mroDates.length - 3].date
              ? $filter("date")(
                  new Date(mroDates[mroDates.length - 3].date),
                  "shortDate"
                )
              : ""
          ),
        i18nFilter("_label_advice_")
          .concat(" ")
          .concat(
            mroDates[mroDates.length - 2].date
              ? $filter("date")(
                  new Date(mroDates[mroDates.length - 2].date),
                  "shortDate"
                )
              : ""
          ),
        i18nFilter("_label_advice_")
          .concat(" ")
          .concat(
            mroDates[mroDates.length - 1].date
              ? $filter("date")(
                  new Date(mroDates[mroDates.length - 1].date),
                  "shortDate"
                )
              : ""
          )
      );

      data.list.push(header);

      animals.forEach(function (animal) {
        var row = [];

        if (animal.Selected) {
          row.push(animal.EarTag);
          row.push(animal.Number);
          row.push(animal.Status);
          row.push(animal.Parity);
          row.push(
            animal.LastCalvingDate ? new Date(animal.LastCalvingDate) : ""
          );
          row.push({
            v: animal.DIM,
            t: "n",
            s: {
              border: { right: { style: "thin", color: { rgb: "000000" } } },
            },
          });
          mroDates.forEach(function (date) {
            row.push(
              setCell(
                animal,
                animal[date.propertyName],
                cowsThreshold,
                heifersThreshold
              )
            );
          });
          row.push({
            v: $filter("number")(animal.tankPercentage, 0),
            t: "n",
            s: {
              border: { left: { style: "thin", color: { rgb: "000000" } } },
            },
          });
          row.push(animal.highSCC);
          row.push(animal.highSCCPrevious);
          row.push(animal.clinicalMastitisCases);
          row.push(animal.clinicalMastitisCasesPrevious);
          row.push(
            animal.advice_2 && animal.advice_2.advice
              ? animal.advice_2.advice.value
              : ""
          );
          row.push(
            animal.advice_1 && animal.advice_1.advice
              ? animal.advice_1.advice.value
              : ""
          );
          row.push(
            animal.advice_0 && animal.advice_0.advice
              ? animal.advice_0.advice.value
              : ""
          );
          data.list.push(row);
        }
      });

      return data;
    }

    function setCell(animal, SCC, cowsThreshold, heifersThreshold) {
      var cell = {
        v: SCC.SCC,
      };

      var s = {};

      var cellClass = getSCCClass(animal, SCC, cowsThreshold, heifersThreshold);

      if (cellClass.includes("CMAlert")) {
        s.font = { bold: true, color: { rgb: "C31C4A" } };
      }

      if (cellClass.includes("dry")) {
        cell.t = "s";
        s.fill = { fgColor: { rgb: "6BA43A" } };
      } else {
        cell.t = "n";
      }

      if (cellClass.includes("highSCC")) {
        s.fill = { fgColor: { rgb: "E7A4B7" } };
      }

      if (s.fill || s.font) {
        cell.s = s;
      }

      return cell;
    }

    function setColumnsWidth(mroDates) {
      var columns = [
        { wch: 20 },
        { wch: 10 },
        { wch: 20 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
      ];

      mroDates.forEach(function (date) {
        columns.push({ wch: 15 });
      });

      columns = columns.concat([
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
      ]);

      return columns;
    }

    function generatePDFData(
      animals,
      mroDates,
      cowsThreshold,
      heifersThreshold
    ) {
      var dd = {
        pageMargins: [10, 10, 10, 10],
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          {
            layout: "attentionListMROLayout",
            table: {
              body: [],
              alignment: "center",
            },
          },
        ],
        styles: {
          basicStyle: {
            fontSize: 4,
          },
          redStyle: {
            fontSize: 4,
            color: "#C31C4A",
            bold: true,
          },
        },
      };

      var widths = ["*", "auto", "*", "auto", "auto", "auto"];

      mroDates.forEach(function (date) {
        widths.push("auto");
      });

      widths = widths.concat([
        "auto",
        "auto",
        "auto",
        "auto",
        "auto",
        "auto",
        "auto",
        "auto",
      ]);
      dd.content[0].table.widths = widths;

      var header = [
        {
          text: i18nFilter("_animal_ear_tag_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_number_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_status_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_parity_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_last_calving_date_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_dim_"),
          style: "basicStyle",
          alignment: "center",
        },
      ];

      mroDates.forEach(function (date) {
        header.push({
          text: $filter("date")(new Date(date.date), "shortDate"),
          style: "basicStyle",
        });
      });

      header = header.concat([
        {
          text: i18nFilter("_label_p_tank_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_n_high_scc_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_n_high_scc_previous_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_n_clinical_mastitis_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_n_clinical_mastitis_previous_"),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_advice_")
            .concat(" ")
            .concat(
              mroDates[mroDates.length - 3].date
                ? $filter("date")(
                    new Date(mroDates[mroDates.length - 3].date),
                    "shortDate"
                  )
                : ""
            ),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_advice_")
            .concat(" ")
            .concat(
              mroDates[mroDates.length - 2].date
                ? $filter("date")(
                    new Date(mroDates[mroDates.length - 2].date),
                    "shortDate"
                  )
                : ""
            ),
          style: "basicStyle",
          alignment: "center",
        },
        {
          text: i18nFilter("_label_advice_")
            .concat(" ")
            .concat(
              mroDates[mroDates.length - 1].date
                ? $filter("date")(
                    new Date(mroDates[mroDates.length - 1].date),
                    "shortDate"
                  )
                : ""
            ),
          style: "basicStyle",
          alignment: "center",
        },
      ]);

      dd.content[0].table.body.push(header);

      animals.forEach(function (animal) {
        if (animal.Selected) {
          var row = [
            { text: animal.EarTag, style: "basicStyle", alignment: "center" },
            {
              text: animal.Number,
              style: "basicStyle",
              alignment: "center",
            },
            { text: animal.Status, style: "basicStyle", alignment: "center" },
            { text: animal.Parity, style: "basicStyle", alignment: "center" },
            {
              text: animal.LastCalvingDate
                ? $filter("date")(new Date(animal.LastCalvingDate), "shortDate")
                : "",
              style: "basicStyle",
              alignment: "center",
            },
            { text: animal.DIM, style: "basicStyle", alignment: "center" },
          ];

          mroDates.forEach(function (date) {
            var item = {
              text: animal[date.propertyName].SCC,
              style: "basicStyle",
              alignment: "center",
            };
            var cellProperties = getCellProperties(
              animal,
              animal[date.propertyName],
              cowsThreshold,
              heifersThreshold
            );

            if (cellProperties.fillColor) {
              item.fillColor = cellProperties.fillColor;
            }

            if (cellProperties.color) {
              item.style = "redStyle";
            }
            row.push(item);
          });

          row = row.concat([
            {
              text: $filter("number")(animal.tankPercentage, 0),
              style: "basicStyle",
              alignment: "center",
            },
            { text: animal.highSCC, style: "basicStyle", alignment: "center" },
            {
              text: animal.highSCCPrevious,
              style: "basicStyle",
              alignment: "center",
            },
            {
              text: animal.clinicalMastitisCases,
              style: "basicStyle",
              alignment: "center",
            },
            {
              text: animal.clinicalMastitisCasesPrevious,
              style: "basicStyle",
              alignment: "center",
            },
            {
              text:
                animal.advice_2 && animal.advice_2.advice
                  ? animal.advice_2.advice.value
                  : "",
              style: "basicStyle",
              alignment: "center",
            },
            {
              text:
                animal.advice_1 && animal.advice_1.advice
                  ? animal.advice_1.advice.value
                  : "",
              style: "basicStyle",
              alignment: "center",
            },
            {
              text:
                animal.advice_0 && animal.advice_0.advice
                  ? animal.advice_0.advice.value
                  : "",
              style: "basicStyle",
              alignment: "center",
            },
          ]);

          dd.content[0].table.body.push(row);
        }
      });

      return dd;
    }

    function getCellProperties(animal, SCC, cowsThreshold, heifersThreshold) {
      var properties = {
        fillColor: undefined,
        color: undefined,
      };

      var cellClass = getSCCClass(animal, SCC, cowsThreshold, heifersThreshold);

      if (cellClass.includes("dry")) {
        properties.fillColor = "#6BA43A";
      }

      if (cellClass.includes("highSCC")) {
        properties.fillColor = "#E7A4B7";
      }

      if (cellClass.includes("CMAlert")) {
        properties.color = true;
      }

      return properties;
    }

    function getCustomLayout() {
      var customLayout = {
        attentionListMROLayout: {
          hLineWidth: function (i, node) {
            return 0.2;
          },
          vLineWidth: function (i, node) {
            if (i === 6 || i === node.table.body[0].length - 6) {
              return 0.5;
            }
            return 0.2;
          },
        },
      };

      return customLayout;
    }

    function calculateTotalMilk(animals, lastMRODate) {
      var propertyName = "SCC_" + lastMRODate;

      var totalMilk = 0;
      animals.forEach(function (animal) {
        if (animal[propertyName].SCC && animal[propertyName].SCC != dryLabel) {
          totalMilk += animal[propertyName].SCC * animal[propertyName].AmountKg;
        }
      });
      return totalMilk;
    }

    function setTankPercentage(animals, total, lastMRODate) {
      var propertyName = "SCC_" + lastMRODate;
      return animals.map(function (animal) {
        animal.tankPercentage =
          animal[propertyName].SCC &&
          animal[propertyName].SCC != dryLabel &&
          animal[propertyName].AmountKg
            ? ((animal[propertyName].SCC * animal[propertyName].AmountKg) /
                total) *
              100
            : 0;
        return animal;
      });
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.attentionMRO")
    .factory("attentionListMROService", attentionListMROService);
  /** @ngInject */
  function attentionListMROService($http, $q, APP_CONSTANTS) {
    return {
      getAnimals: getAnimals,
      getMROResults: getMROResults,
      getHealthEvents: getHealthEvents,
      updateAdvice: updateAdvice,
      getLactations: getLactations
    };

    function getAnimals(herdId) {
      return $http
        .get(APP_CONSTANTS.animals_base_url + "herds/" + herdId + "/animals")
        .then(success)
        .catch(error);
    }

    function getMROResults(herdId, startDate, endDate) {
      return $http
        .get(
          APP_CONSTANTS.animals_base_url +
            "herds/" +
            herdId +
            "/milkrecordings/advicelist?Date=>" +
            startDate +
            "&Date=<" +
            endDate
        )
        .then(success)
        .catch(error);
    }

    function getHealthEvents(herdId, startDate, endDate) {
      return $http
        .get(
          APP_CONSTANTS.animals_base_url +
            "herds/" +
            herdId +
            "/healthevents?-orderBy=-StartDate&HealthCondition=31&StartDate=>" +
            startDate +
            "&StartDate=<" +
            endDate
        )
        .then(success)
        .catch(error);
    }

    function updateAdvice(herdId, advice) {
      return $http
        .post(
          APP_CONSTANTS.animals_base_url +
            "herds/"+herdId+"/milkrecordings/advice",
            advice
        )
        .then(success)
        .catch(error);
    }

    function getLactations(herdId) {
      return $http
      .get(APP_CONSTANTS.animals_base_url + "herds/" + herdId + "/lactations")
      .then(success)
      .catch(error);
    }

    function success(response) {
      return response.data;
    }

    function error(error) {
      return $q.reject(error);
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.animals")
    .controller("animalsCtrl", animalsCtrl);
  /** @ngInject */
  function animalsCtrl(
    animalsService,
    $state,
    $scope,
    $q,
    $filter,
    $timeout,
    activeAnimalsService,
    $rootScope,
    $uibModal,
    $uibModalStack,
    $location,
    $anchorScroll,
    COUNTRY_CODES,
    $locale,
    xlsxService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var searchTimer;
    var filterTimer;
    var switchTimer;
    vm.selectAnimal = selectAnimal;
    vm.getAnimalClass = getAnimalClass;
    vm.search = search;
    vm.selectSearchBy = selectSearchBy;
    vm.paginationChanged = paginationChanged;
    vm.selectLayout = selectLayout;
    vm.goToImportAnimals = goToImportAnimals;
    vm.showExportLayout = showExportLayout;
    vm.openPdfExportModal = openPdfExportModal;
    vm.exportAnimals = exportAnimals;
    vm.selectAll = selectAll;
    vm.exportDataCsvXls = exportDataCsvXls;
    vm.openExportModal = openExportModal;
    vm.closeModal = closeModal;
    vm.exportPdf = exportPdf;
    vm.exportData = exportData;
    vm.getCsvData = getCsvData;
    vm.getCsvHeader = getCsvHeader;
    vm.init = init;
    vm.goBack = goBack;
    vm.selectHefers = selectHefers;
    vm.changeExportAnimalsType = changeExportAnimalsType;
    vm.exportAnimalsType = "toggle_off";
    init();

    function init() {
      setStyleType();
      toDataURL("assets/img/logo_mmm.png", function (dataurl) {
        vm.logo = dataurl;
      });
      toDataURL("assets/img/logo.png", function (dataurl) {
        vm.defaultImageDataUrl = dataurl;
      });
      vm.loading = true;
      vm.numError = false;
      vm.showAnimals = false;
      vm.firstLoad = true;
      vm.errorLoading = false;
      vm.selectedFormat = 1;
      vm.selectedLayout = 2;
      vm.exportAnimalsList = [];
      vm.tooltipText = i18nFilter("_label_export_pdf_");
      vm.tooltipTextCsv = i18nFilter("_button_export_") + " .csv/.xls";
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.selectedTeam == 3091) {
        vm.showExportBlock = true;
      } else {
        vm.showExportBlock = false;
      }
      vm.animalList = JSON.parse(localStorage.getItem("animalList"));
      vm.showActive = true;
      vm.showHistorical = false;
      vm.showBackButton = false;
      vm.countyCodes = COUNTRY_CODES.codes;
      if (vm.defaultValues.herd_ids.length == 1) {
        if (vm.defaultValues.herd_ids[0]) {
          vm.selectedHerd = vm.defaultValues.herd_ids[0];
          vm.currentPage = 1;
          getAnimals(vm.defaultValues.herd_ids[0], "?isonfarm=true");
          getHerdInfo(vm.selectedHerd);
        }
      } else {
        vm.numError = true;
        vm.showAnimals = false;
        vm.loading = false;
      }
    }

    function setStyleType(){
      var style = localStorage.getItem("style");
      if(style && style.length){
        vm.style = style;
      }
    }

    function getHerdInfo(herdId) {
      return activeAnimalsService
        .getHerdInfo(herdId)
        .then(function (response) {
          vm.dairyCompany = response;
          vm.herdName = response.Name;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function getAnimals(herd_id, suffix) {
      activeAnimalsService
        .getAnimals(herd_id, suffix)
        .then(function (response) {
          response.map(function (animal) {
            animal.GlobalId = generateGlobalId(animal.EarTag);
            if (!animal.Breed) {
              animal.Breed = "HO";
            }
            animal.SireGlobalId = animal.SireEarTag
              ? animal.Breed + generateGlobalId(animal.SireEarTag)
              : null;
            animal.DamGlobalId = animal.DamEarTag
              ? animal.Breed + generateGlobalId(animal.DamEarTag)
              : null;
            animal.GenderShort = i18nFilter($filter("gender")(animal.Gender));
            animal.imageUrl = animal.PictureThumbnailUrl;
            return animal;
          });
          handleAnimalsResponse(response);
          vm.currentPage = 1;
          if (vm.searchString) {
            vm.animals = filterList(
              vm.searchString,
              vm.searchStringNumber,
              vm.searchStringEarTag
            );
          }
          vm.animalHerdId = response.HerdId;
          vm.animalsToShow = getAnimalsByPage(vm.currentPage);
          vm.firstLoad = false;
          vm.loading = false;
          vm.showAnimals = true;
          vm.errorLoading = false;
        })
        .catch(function (error) {
          vm.errorLoading = true;
          vm.numError = false;
          vm.showAnimals = false;
          vm.loading = false;
          console.log(error);
        });
    }

    function handleAnimalsResponse(response) {
      var cows = [];
      var youngstock = [];
      var undefinedAnimalParity = [];
      for (var i = 0; i < response.length; i++) {
        if (response[i].CurrentStatus == 0) {
          response[i].CurrentStatusString = i18nFilter("_animal_status_none_");
          response[i].animalClass = "animal-none";
        } else if (response[i].CurrentStatus == 1) {
          response[i].CurrentStatusString = i18nFilter("_animal_status_open_");
          response[i].animalClass = "animal-open";
        } else if (response[i].CurrentStatus == 3) {
          response[i].CurrentStatusString = i18nFilter(
            "_animal_status_inseminated_"
          );
          response[i].animalClass = "animal-served";
        } else if (response[i].CurrentStatus == 4) {
          response[i].CurrentStatusString = i18nFilter(
            "_animal_status_not_pregnant_"
          );
          response[i].animalClass = "animal-non-pregnant";
        } else if (response[i].CurrentStatus == 5) {
          response[i].CurrentStatusString = i18nFilter(
            "_animal_status_pregnant_"
          );
          response[i].animalClass = "animal-pregnant";
        } else if (response[i].CurrentStatus == 6) {
          response[i].CurrentStatusString = i18nFilter(
            "_animal_status_barren_"
          );
          response[i].animalClass = "animal-barren";
        } else if (response[i].CurrentStatus == 7) {
          response.CurrentStatusString = i18nFilter("_animal_status_aborted_");
        } else if (response[i].CurrentStatus == 8) {
          response[i].CurrentStatusString = i18nFilter("_animal_status_dry_");
          response[i].animalClass = "animal-dry";
        } else if (response[i].CurrentStatus == 9) {
          response[i].CurrentStatusString = i18nFilter("_animal_status_sold_");
        } else if (response[i].CurrentStatus == 10) {
          response[i].CurrentStatusString = i18nFilter("_animal_status_dead_");
        } else if (response[i].CurrentStatus == 11) {
          response[i].CurrentStatusString = i18nFilter(
            "_animal_status_presume_left_"
          );
        }
        if (response[i].Parity > 0) {
          cows.push(response[i]);
        } else if (
          response[i].Parity != null &&
          response[i].Parity != undefined &&
          response[i].Parity == 0
        ) {
          youngstock.push(response[i]);
        } else {
          undefinedAnimalParity.push(response[i]);
        }
      }
      response = cows.concat(youngstock).concat(undefinedAnimalParity);
      vm.allAnimals = response;
      vm.youngstock = youngstock;
      if (
        vm.animalList &&
        vm.animalList.goBack &&
        vm.animalList.state == $state.current.name &&
        vm.animalList.herdId &&
        vm.animalList.herdId == vm.selectedHerd &&
        vm.firstLoad
      ) {
        if (
          vm.animalList.searchString ||
          vm.animalList.searchStringNumber ||
          vm.animalList.searchStringEarTag
        ) {
          if (vm.animalList.searchString) {
            vm.searchString = vm.animalList.searchString;
          }
          if (vm.animalList.searchStringNumber) {
            vm.searchStringNumber = vm.animalList.searchStringNumber;
          }
          if (vm.animalList.searchStringEarTag) {
            vm.searchStringEarTag = vm.animalList.searchStringEarTag;
          }
          vm.animals = filterList(
            vm.searchString,
            vm.searchStringNumber,
            vm.searchStringEarTag
          );
        } else {
          vm.animals = [];
          angular.copy(vm.allAnimals, vm.animals);
        }
        vm.animalList.goBack = false;
        localStorage.setItem("animalList", JSON.stringify(vm.animalList));
      } else {
        vm.animals = [];
        localStorage.removeItem("animalList");
        angular.copy(vm.allAnimals, vm.animals);
      }
      vm.numError = false;
    }

    function getAnimalsByPage(pageNumber) {
      var first = (pageNumber - 1) * 250;
      var last = first + 250;
      var list = [];
      for (var i = first; i < last; i++) {
        if (vm.animals[i]) {
          list.push(vm.animals[i]);
        } else {
          break;
        }
      }
      return list;
    }

    function paginationChanged() {
      vm.loading = true;
      vm.animalsToShow = getAnimalsByPage(vm.currentPage);
      vm.loading = false;
      $timeout(function () {
        $location.hash("search-box");
        $anchorScroll();
      }, 0);
    }

    function filterList(filterString, searchStringNumber, searchStringEarTag) {
      var animalList = angular.copy(vm.allAnimals);
      animalList = filterBy(animalList, "Name", filterString);
      animalList = filterBy(animalList, "NumberString", searchStringNumber);
      animalList = filterBy(animalList, "EarTag", searchStringEarTag);
      return animalList;
    }

    function filterBy(animalList, term, string) {
      if (string) {
        var list = [];
        for (var i = 0; i < animalList.length; i++) {
          if (animalList[i][term]) {
            var str = animalList[i][term].toLowerCase();
            if (str.indexOf(string.toLowerCase()) != -1) {
              list.push(animalList[i]);
            }
          }
        }
      } else {
        list = animalList;
      }
      return list;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        vm.currentPage = 1;
        vm.animals = filterList(
          vm.searchString,
          vm.searchStringNumber,
          vm.searchStringEarTag
        );
        vm.animalsToShow = getAnimalsByPage(vm.currentPage);
      }, 750);
    }
    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });

    function getAnimalClass(animal) {
      return animal.animalClass;
    }

    function selectSearchBy(type) {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      if (!vm.loading) {
        if (type == "active") {
          vm.showActive = !vm.showActive;
        } else if (type == "historical") {
          vm.showHistorical = !vm.showHistorical;
        }
        if (!vm.showActive && !vm.showHistorical) {
          vm.showActive = true;
          vm.showHistorical = true;
        }
        filterTimer = $timeout(function () {
          vm.loading = true;
          vm.showAnimals = false;
          if (vm.showActive && vm.showHistorical) {
            getAnimals(vm.defaultValues.herd_ids[0], "");
          } else if (vm.showActive && !vm.showHistorical) {
            getAnimals(vm.defaultValues.herd_ids[0], "?isonfarm=true");
          } else if (!vm.showActive && vm.showHistorical) {
            getAnimals(vm.defaultValues.herd_ids[0], "?isonfarm=false");
          }
        }, 750);
      }
    }

    function selectAnimal(animal) {
      var animalList = [];
      for (var i = 0; i < vm.animals.length; i++) {
        var obj = {
          id: vm.animals[i].AnimalId,
          number: vm.animals[i].Number,
          pictureImageUrl: vm.animals[i].PictureImageUrl,
          EarTag: vm.animals[i].EarTag,
        };
        animalList.push(obj);
      }
      var data = {
        herdId: vm.selectedHerd,
        list: animalList,
        state: $state.current.name,
        searchString: vm.searchString,
        searchStringNumber: vm.searchStringNumber,
        searchStringEarTag: vm.searchStringEarTag,
      };
      animalsService.animalList = data;
      localStorage.setItem("animalList", JSON.stringify(data));
      $rootScope.$broadcast("animals_selected_animal");
      $state.go("animalDatails", {
        animal_id: animal.AnimalId.toString(16),
      });
    }

    function showExportLayout(type) {
      if (type == 1) {
        vm.exportAnimalsList = angular.copy(vm.youngstock);
      } else {
        vm.exportAnimalsList = angular.copy(vm.allAnimals);
      }
      for (var i = 0; i < vm.exportAnimalsList.length; i++) {
        vm.exportAnimalsList[i].order = moment(
          vm.exportAnimalsList[i].BirthDate
        ).unix();
        for (var j = 0; j < vm.animals.length; j++) {
          if (vm.exportAnimalsList[i].AnimalId == vm.animals[j].AnimalId) {
            vm.exportAnimalsList[i].selected = true;
          }
        }
      }
      vm.exportAnimalsList = $filter("orderBy")(
        vm.exportAnimalsList,
        "order",
        true
      );
      vm.selectedLayout = 3;

      $timeout(function () {
        vm.showBackButton = true;
      }, 600);
    }

    function changeExportAnimalsType() {
      if (switchTimer) {
        $timeout.cancel(switchTimer);
      }

      if (vm.exportAnimalsType === "toggle_off") {
        vm.exportAnimalsType = "toggle_on";
      } else {
        vm.exportAnimalsType = "toggle_off";
      }

      switchTimer = $timeout(function () {
        if (vm.exportAnimalsType === "toggle_off") {
          showExportLayout(1);
        } else {
          showExportLayout(2);
        }
      }, 750);
    }

    function exportAnimals() {
      vm.exportAnimalsType = "toggle_off";
      if (!vm.showBackButton) {
        showExportLayout(1);
      } else {
        exportData();
      }
    }

    function goBack() {
      vm.showBackButton = false;
      $timeout(function () {
        selectLayout(2);
      }, 100);
    }

    function generateGlobalId(earTag) {
      var country = getCountry(earTag);
      if (country) {
        var a3 = country["alpha-3"];
        var tag = getTag(earTag);
        earTag = a3 + tag;
      }

      return earTag;
    }

    function getCountry(earTag) {
      if (earTag) {
        var a2 = earTag.substring(0, 2);
        for (var i = 0; i < vm.countyCodes.length; i++) {
          if (a2 == vm.countyCodes[i]["alpha-2"]) {
            return vm.countyCodes[i];
          }
        }
      }

      return null;
    }

    function getTag(earTag) {
      if (earTag) {
        var tag = earTag.slice(2).trim();
        var l = tag.length;
        var d = 12 - l;
        var z = "";
        if (d > 0) {
          for (var i = 0; i < d; i++) {
            z += "0";
          }

          tag = z.trim() + tag;
        }

        return tag;
      }
      return null;
    }

    function selectAll(selected) {
      for (var i = 0; i < vm.exportAnimalsList.length; i++) {
        vm.exportAnimalsList[i].selected = selected;
      }
    }

    function exportData() {
      var list = generateExportList(vm.exportAnimalsList);
      var date = moment().format("L");
      var file_name = i18nFilter("_page_title_animals_") + "_" + date + ".xlsx";
      var date_format = xlsxService.getShortDateFormat($locale);
      var ws = XLSX.utils.aoa_to_sheet(list, {
        cellDates: true,
        dateNF: date_format,
      });
      ws["!cols"] = [
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, i18nFilter("_page_title_animals_"));
      XLSX.writeFile(wb, file_name);
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
      vm.showBackButton = false;
    }

    function generateExportList(list) {
      var a = [];

      for (var i = 0; i < list.length; i++) {
        if (list[i].selected) {
          var aa = [];

          aa.push(list[i].NumberString ? list[i].NumberString : "");
          aa.push(list[i].Name ? list[i].Name : "");
          aa.push(list[i].EarTag ? list[i].EarTag : "");
          aa.push(list[i].EarTag ? list[i].GlobalId : "");
          aa.push(list[i].GenderShort ? list[i].GenderShort : "");
          aa.push(list[i].OnBirth ? list[i].OnBirth : "");
          aa.push(list[i].Breed ? list[i].Breed : "");
          aa.push(list[i].BirthDate ? new Date(list[i].BirthDate) : "");
          aa.push(list[i].SireGlobalId ? list[i].SireGlobalId : "");
          aa.push(list[i].DamGlobalId ? list[i].DamGlobalId : "");
          a.push(aa);
        }
      }
      return a;
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function openExportModal() {
      openModal("app/pages/herds/animals/export.modal.html", "sm");
    }

    function openPdfExportModal() {
      vm.loadingModal = false;
      vm.includePictures = false;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/herds/animals/exportPdf.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.send();
    }

    function exportPdf() {
      vm.loadingModal = true;
      setPDFPictures();

      function setPDFPictures() {
        var list = [];
        for (var i = 0; i < vm.animals.length; i++) {
          if (
            vm.animals[i].PictureThumbnailUrl &&
            vm.animals[i].PictureThumbnailUrl.length > 0
          ) {
            var name = "pr" + i;
            vm[name] = $q.defer();
            list.push(vm[name].promise);
            getDataUrl(name, i, vm.animals[i].PictureThumbnailUrl);
          }
        }

        function getDataUrl(name, i, picture) {
          toDataURL(picture, function (dataUrl) {
            vm.animals[i].PictureThumbnailUrl = dataUrl;
            vm[name].resolve();
          });
        }
        $q.all(list).then(function () {
          createPDF();
        });
      }

      function createPDF() {
        var tableHeader = {
          table: {
            dontBreakRows: true,
            headerRows: 2,
            keepWithHeaderRows: 2,
            widths: getTableWidths(),
            body: [
              [
                {
                  style: "tableHeader",
                  text: i18nFilter("_animal_number_"),
                  alignment: "center",
                  margin: [0, 60, 0, 0],
                  border: [false, false, false, true],
                },
                {
                  style: "tableHeader",
                  text: i18nFilter("_animal_ear_tag_"),
                  alignment: "center",
                  margin: [0, 60, 0, 0],
                  border: [false, false, false, true],
                },
                {
                  style: "tableHeader",
                  text: i18nFilter("_animal_name_"),
                  alignment: "center",
                  margin: [0, 60, 0, 0],
                  border: [false, false, false, true],
                },
                {
                  style: "tableHeader",
                  text: i18nFilter("_animal_status_"),
                  alignment: "center",
                  margin: [0, 60, 0, 0],
                  border: [false, false, false, true],
                },
              ],
            ],
          },
        };
        if (vm.includePictures) {
          tableHeader.table.body[0].unshift({
            style: "tableHeader",
            text: "",
            alignment: "center",
            margin: [0, 60, 0, 0],
            border: [false, false, false, true],
          });
        }

        function getTableWidths() {
          if (vm.includePictures) {
            return ["20%", "20%", "20%", "20%", "20%"];
          } else {
            return ["25%", "25%", "25%", "25%"];
          }
        }

        var pageSize = "A4";
        var pageOrientation = "landscape";
        var backgroundText = function () {
          return [
            {
              text: i18nFilter("_label_herd_") + ": " + vm.herdName,
              alignment: "right",
              margin: [0, 40, 40, 0],
            },
          ];
        };
        var dd = {
          pageMargins: [25, 5, 25, 5],
          pageSize: pageSize,
          pageOrientation: pageOrientation,
          background: backgroundText,
          content: [tableHeader],
          styles: {
            header: {
              fontSize: 17,
              bold: true,
            },
            tableHeader: {
              bold: true,
            },
          },
          defaultStyle: {
            fontSize: 10,
          },
        };
        var header = [
          {
            columns: [
              {
                image: vm.logo,
                width: 150,
                margin: [25, 10, 0, 0],
              },
            ],
          },
        ];
        dd.header = header;
        for (var i = 0; i < vm.animals.length; i++) {
          var animal = vm.animals[i];
          var row = [
            {
              text: animal.Number,
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: animal.EarTag,
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: animal.Name,
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: animal.CurrentStatusString,
              border: [false, false, false, true],
              alignment: "center",
            },
          ];

          if (vm.includePictures) {
            row.unshift({
              image: animal.PictureThumbnailUrl
                ? animal.PictureThumbnailUrl
                : vm.defaultImageDataUrl,
              fit: [60, 60],
              border: [false, false, false, true],
              alignment: "center",
            });
          }
          dd.content[dd.content.length - 1].table.body.push(row);
        }

        var name =
          vm.herdName + " " + i18nFilter("_page_title_animals_") + ".pdf";
        name = name.replace(/ /g, "_");

        pdfMake.createPdf(dd).download(name, function () {
          closeModal();
        });
      }
    }

    function exportDataCsvXls() {
      if (vm.selectedFormat == 1) {
        var elem = document.getElementById("export-csv-button");

        $timeout(function () {
          elem.click();
        }, 10);
      } else {
        exportToExcel();
      }

      $timeout(function () {
        closeModal();
      }, 200);
    }

    function exportToExcel(version) {
      var list = generateExportList(version, vm.allAnimals);
      var file_name = vm.herdName + ".xlsx";
      var ws = XLSX.utils.aoa_to_sheet(list, {
        cellDates: true,
        dateNF: $locale.DATETIME_FORMATS.shortDate,
      });

      if (version == 1) {
        ws["!cols"] = [{ wch: 15 }, { wch: 20 }, { wch: 15 }];
      } else {
        ws["!cols"] = [
          { wch: 15 },
          { wch: 20 },
          { wch: 15 },
          { wch: 15 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
        ];
      }

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, i18nFilter("_page_title_animals_"));
      XLSX.writeFile(wb, file_name);
    }

    function getCsvData() {
      var list = [];
      for (var i = 0; i < vm.allAnimals.length; i++) {
        var animal = vm.allAnimals[i];

        var obj = {
          a: animal.Number ? animal.Number : "",
          b: animal.EarTag ? animal.EarTag : "",
          c: animal.Name ? animal.Name : "",
          d: animal.CurrentStatusString,
        };

        list.push(obj);
      }
      return list;
    }

    function getCsvHeader() {
      return [
        i18nFilter("_animal_number_"),
        i18nFilter("_animal_ear_tag_"),
        i18nFilter("_animal_name_"),
        i18nFilter("_animal_status_"),
      ];
    }

    function selectHefers() {
      for (var i = 0; i < vm.exportAnimalsList.length; i++) {
        if (
          vm.exportAnimalsList[i].Parity == 0 ||
          vm.exportAnimalsList[i].Parity == null
        ) {
          vm.exportAnimalsList[i].selected = true;
        } else {
          vm.exportAnimalsList[i].selected = false;
        }
      }
    }

    function saveAsFile(content, fileName) {
      var a = document.createElement("a");
      var isBlob = content.toString().indexOf("Blob") > -1;
      var url = content;
      if (isBlob) {
        url = window.URL.createObjectURL(content);
      }
      a.href = url;
      a.download = fileName;
      a.click();
      if (isBlob) {
        window.URL.revokeObjectURL(url);
      }
    }

    function goToImportAnimals() {
      $state.go("importAnimals");
    }
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.animals').factory('activeAnimalsService', animalsService);
    /** @ngInject */
    function animalsService($http, $q, APP_CONSTANTS) {
        return {
            getAnimals: getAnimals,
            getHerdInfo: getHerdInfo
        }

        function getHerdInfo(herdId) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herdId, {
				timeout: 15000
			}).then(success).catch(error);
		}

        function getAnimals(herdId, suffix) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/animals' + suffix, {}).then(success).catch(error);
        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";

  angular.module("My.pages.herds.dashboardsV2").constant("DASH_CONSTANTS", {
    constants: {
      all_categories: [
        {
          name: "_dc_production_",
          id: "production",
          permission: 9,
        },
        {
          name: "_dc_reproduction_",
          id: "reproduction",
          permission: 10,
        },
        {
          name: "_dc_udder_health_",
          id: "udder_health",
          permission: 8,
        },
        {
          name: "_dc_hoof_health_",
          id: "hoof_health",
          permission: 8,
        },
        {
          name: "_dc_herd_characteristics_",
          id: "herd_characteristics",
        },
        {
          name: "_dc_comments_",
          id: "comments",
          permission: 6,
        },
        {
          name: "_dc_environmental_",
          id: "environment",
          permission: 7,
        },
        {
          name: "_dc_genetics_",
          id: "genetics",
        },
        {
          name: "_dc_other_",
          id: "other",
        },
      ],
      // when dashboard name is changed update these ids
      dashboards_filter_pairs: [
        {
          mark: "Number of clinical mastitis cases per month",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Number of clinical mastitis cases per month",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "Aantal klinische mastitis cases per maand",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "Number of clinical mastitis cases per month",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Number of clinical mastitis cases per month",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Number of clinical mastitis cases per month",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Number of Clinical Mastitis cases per month after calving",
          filter: "Action (Number of months after calving)",
          lng: "en-GB",
        },
        {
          mark: "Number of Clinical Mastitis cases per month after calving",
          filter: "Action (Number of months after calving)",
          lng: "en-US",
        },
        {
          mark: "Aantal klinische mastitis cases per maand na afkalven",
          filter: "Action (Number of months after calving)",
          lng: "nl-NL",
        },
        {
          mark: "Number of Clinical Mastitis cases per month after calving",
          filter: "Action (Number of months after calving)",
          lng: "de-DE",
        },
        {
          mark: "Number of Clinical Mastitis cases per month after calving",
          filter: "Action (Number of months after calving)",
          lng: "fr-FR",
        },
        {
          mark: "Number of Clinical Mastitis cases per month after calving",
          filter: "Action (Number of months after calving)",
          lng: "pl-PL",
        },

        {
          mark: "Number of Clinical Mastitis cases per lactation number",
          filter: "Action (Lactation number)",
          lng: "en-GB",
        },
        {
          mark: "Number of Clinical Mastitis cases per lactation number",
          filter: "Action (Lactation number)",
          lng: "en-US",
        },
        {
          mark: "Aantal klinische mastitis cases per lactatienummer",
          filter: "Action (Lactatie nummer)",
          lng: "nl-NL",
        },
        {
          mark: "Number of Clinical Mastitis cases per lactation number",
          filter: "Action (Laktationsanzahl)",
          lng: "de-DE",
        },
        {
          mark: "Number of Clinical Mastitis cases per lactation number",
          filter: "Action (Lactation)",
          lng: "fr-FR",
        },
        {
          mark: "Number of Clinical Mastitis cases per lactation number",
          filter: "Action (Lactation number)",
          lng: "pl-PL",
        },

        {
          mark: "Number of Clinical Mastitis cases per quarter",
          filter: "Action (Quarter)",
          lng: "en-GB",
        },
        {
          mark: "Number of Clinical Mastitis cases per quarter",
          filter: "Action (Quarter)",
          lng: "en-US",
        },
        {
          mark: "Aantal klinische mastitis cases per kwartier",
          filter: "Action (Quarter)",
          lng: "nl-NL",
        },
        {
          mark: "Number of Clinical Mastitis cases per quarter",
          filter: "Action (Viertel)",
          lng: "de-DE",
        },
        {
          mark: "Number of Clinical Mastitis cases per quarter",
          filter: "Action (Quarter)",
          lng: "fr-FR",
        },
        {
          mark: "Number of Clinical Mastitis cases per quarter",
          filter: "Action (Quarter)",
          lng: "pl-PL",
        },

        {
          mark: "Number of cows with recurrent Clinical Mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "en-GB",
        },
        {
          mark: "Number of cows with recurrent Clinical Mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "en-US",
        },
        {
          mark: "Aantal koeien met herhaalde klinische mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "nl-NL",
        },
        {
          mark: "Number of cows with recurrent Clinical Mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "de-DE",
        },
        {
          mark: "Number of cows with recurrent Clinical Mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "fr-FR",
        },
        {
          mark: "Number of cows with recurrent Clinical Mastitis cases",
          filter: "Action (Number recurrings of Clinical Mastitis cases)",
          lng: "pl-PL",
        },

        {
          mark: "Number of Clinical Mastitis cases per production level",
          filter: "Action (Milk yield category)",
          lng: "en-GB",
        },
        {
          mark: "Number of Clinical Mastitis cases per production level",
          filter: "Action (Milk yield category)",
          lng: "en-US",
        },
        {
          mark: "Aantal klinische mastitis cases per productieniveau",
          filter: "Action (Milk yield category)",
          lng: "nl-NL",
        },
        {
          mark: "Number of Clinical Mastitis cases per production level",
          filter: "Action (Milchleistungskategorie)",
          lng: "de-DE",
        },
        {
          mark: "Number of Clinical Mastitis cases per production level",
          filter: "Action (Milk yield category)",
          lng: "fr-FR",
        },
        {
          mark: "Number of Clinical Mastitis cases per production level",
          filter: "Action (Milk yield category)",
          lng: "pl-PL",
        },

        {
          mark: "Open cows",
          filter: "Action (Animal eartag)",
          lng: "en-GB",
        },
        {
          mark: "Open cows",
          filter: "Action (Animal eartag)",
          lng: "en-US",
        },
        {
          mark: "Open koeien",
          filter: "Action (Dieroornummer)",
          lng: "nl-NL",
        },
        {
          mark: "Open cows",
          filter: "Action (Ohrmarke des Tieres)",
          lng: "de-DE",
        },
        {
          mark: "Open cows",
          filter: "Action (Marque auriculaire de l'animal)",
          lng: "fr-FR",
        },
        {
          mark: "Krowy niecielne",
          filter: "Action (Animal eartag)",
          lng: "pl-PL",
        },

        {
          mark: "Subclinical mastitis overview",
          filter: "Action (DIM Category,Parity,Date) 1",
          lng: "en-GB",
        },
        {
          mark: "Subclinical mastitis overview",
          filter: "Action (DIM Category,Parity,Date) 1",
          lng: "en-US",
        },
        {
          mark: "Subclinical mastitis overview",
          filter: "Action (DIM Categorie,Pariteit,Date) 1",
          lng: "nl-NL",
        },
        {
          mark: "Subclinical mastitis overview",
          filter: "Action (TIM-Kategorie,Laktation,Date) 1",
          lng: "de-DE",
        },
        {
          mark: "Subclinical mastitis overview",
          filter: "Action (Catégorie de JEL,Lactation,Date) 1",
          lng: "fr-FR",
        },
        {
          mark: "Przegląd podklinicznego zapalenia gruczołu mlekowego",
          filter: "Action (DIM Category,Parity,Date) 1",
          lng: "pl-PL",
        },

        {
          mark: "New infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "New infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "Nieuwe infecties over de tijd",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "New infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "New infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Nowe infekcje w czasie",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "en-GB",
        },
        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "en-US",
        },
        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "nl-NL",
        },
        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "de-DE",
        },
        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "fr-FR",
        },
        {
          mark: "Subclinical mastitis overview last MRO",
          filter: "Action (Last MRO)",
          lng: "pl-PL",
        },

        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "en-GB",
        },
        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "en-US",
        },
        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "nl-NL",
        },
        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "de-DE",
        },
        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "fr-FR",
        },
        {
          mark: "Subclinical mastitis overview last quarter",
          filter: "Action (Last quarter)",
          lng: "pl-PL",
        },

        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "en-GB",
        },
        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "en-US",
        },
        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "nl-NL",
        },
        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "de-DE",
        },
        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "fr-FR",
        },
        {
          mark: "Subclinical mastitis overview last 6 months",
          filter: "Action (Last 6 months)",
          lng: "pl-PL",
        },

        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Last year)",
          lng: "en-GB",
        },
        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Last year)",
          lng: "en-US",
        },
        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Laatste jaar)",
          lng: "nl-NL",
        },
        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Vorjahr )",
          lng: "de-DE",
        },
        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Last year)",
          lng: "fr-FR",
        },
        {
          mark: "Subclinical mastitis overview last year",
          filter: "Action (Last year)",
          lng: "pl-PL",
        },

        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "en-GB",
        },
        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "en-US",
        },
        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "nl-NL",
        },
        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "de-DE",
        },
        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "fr-FR",
        },
        {
          mark: "Somatic cell count over time",
          filter: "Action (YEAR(Date),MONTH(Date))",
          lng: "pl-PL",
        },

        {
          mark: "Somatic cell count manager",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Somatic cell count manager",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "Celgetal manager",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "Somatic cell count manager",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Somatic cell count manager",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Menedżer liczby komórek somatycznych",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Somatic cell count manager only",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "Infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "Infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "Infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "Infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "Infections over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "Infekcje w czasie",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL",
        },

        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-GB",
        },
        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "en-US",
        },
        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "nl-NL",
        },
        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "de-DE",
        },
        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "fr-FR",
        },
        {
          mark: "General cellcount analysis over time",
          filter: "Action (MONTH(Date)) 1",
          lng: "pl-PL", //proveriti sve^
        },
      ],
      dashboard_id_lng_list: [
        {
          internal_id: "flowchart",
          id: "Zoetisflowchart",
          lng: "en-GB",
          index: 1,
        },
        {
          internal_id: "flowchart",
          id: "Zoetisflowchart",
          lng: "en-US",
          index: 1,
        },
        {
          internal_id: "flowchart",
          id: "GraphiquedeZoetis",
          lng: "fr-FR",
          index: 1,
        },
        {
          internal_id: "flowchart",
          id: "ZoetisFlussdiagramm",
          lng: "de-DE",
          index: 1,
        },
        {
          internal_id: "flowchart",
          id: "Zoetisflowchart",
          lng: "nl-NL",
          index: 1,
        },
        {
          internal_id: "flowchart",
          id: "Zoetisflowchart",
          lng: "pl-PL",
          index: 1,
        },

        {
          internal_id: "insemination_strategy_cows",
          id: "Inseminationstrategyincows",
          lng: "en-GB",
          index: 2,
          size: "1366,768",
        },
        {
          internal_id: "insemination_strategy_cows",
          id: "Inseminationstrategyincows",
          lng: "en-US",
          index: 2,
          size: "1366,768",
        },
        {
          internal_id: "insemination_strategy_cows",
          id: "Stratgiedinsminationpourlesvaches",
          lng: "fr-FR",
          index: 2,
          size: "1366,768",
        },
        {
          internal_id: "insemination_strategy_cows",
          id: "BesamungsstrategiebeiKhen",
          lng: "de-DE",
          index: 2,
          size: "1366,768",
        },
        {
          internal_id: "insemination_strategy_cows",
          id: "Inseminatiestrategiebijkoeien",
          lng: "nl-NL",
          index: 2,
          size: "1366,768",
        },
        {
          internal_id: "insemination_strategy_cows",
          id: "Strategiainseminacjiukrw",
          lng: "pl-PL",
          index: 2,
          size: "1366,768",
        },

        {
          internal_id: "conception_rate_cows",
          id: "Conceptionrateincows",
          lng: "en-GB",
          index: 3,
        },
        {
          internal_id: "conception_rate_cows",
          id: "Conceptionrateincows",
          lng: "en-US",
          index: 3,
        },
        {
          internal_id: "conception_rate_cows",
          id: "Conceptionrateincows",
          lng: "fr-FR",
          index: 3,
        },
        {
          internal_id: "conception_rate_cows",
          id: "Conceptionrateincows",
          lng: "de-DE",
          index: 3,
        },
        {
          internal_id: "conception_rate_cows",
          id: "Drachtpercentagekoeien",
          lng: "nl-NL",
          index: 3,
        },
        {
          internal_id: "conception_rate_cows",
          id: "Wskanikzacieleukrw",
          lng: "pl-PL",
          index: 3,
        },

        {
          internal_id: "sire_strategy",
          id: "Sirestrategyincows",
          lng: "en-GB",
          index: 4,
        },
        {
          internal_id: "sire_strategy",
          id: "Sirestrategyincows",
          lng: "en-US",
          index: 4,
        },
        {
          internal_id: "sire_strategy",
          id: "Stratgieenmatiredereproducteurpourlesvaches",
          lng: "fr-FR",
          index: 4,
        },
        {
          internal_id: "sire_strategy",
          id: "ZuchtstrategiebeiKhen",
          lng: "de-DE",
          index: 4,
        },
        {
          internal_id: "sire_strategy",
          id: "Stiervaderstrategiebijkoeien",
          lng: "nl-NL",
          index: 4,
        },
        {
          internal_id: "sire_strategy",
          id: "Strategiareproduktoraukrw",
          lng: "pl-PL",
          index: 4,
        },

        {
          internal_id: "conception_cusum",
          id: "Conceptioncusumanalysis",
          lng: "en-GB",
          index: 5,
        },
        {
          internal_id: "conception_cusum",
          id: "Conceptioncusumanalysis",
          lng: "en-US",
          index: 5,
        },
        {
          internal_id: "conception_cusum",
          id: "AnalyseCUSUMdelaconception",
          lng: "fr-FR",
          index: 5,
        },
        {
          internal_id: "conception_cusum",
          id: "Conception-Cusum-Analyse",
          lng: "de-DE",
          index: 5,
        },
        {
          internal_id: "conception_cusum",
          id: "Drachtpercentagecusumanalyse",
          lng: "nl-NL",
          index: 5,
        },
        {
          internal_id: "conception_cusum",
          id: "Analizawspczynnikazapodnie",
          lng: "pl-PL",
          index: 5,
        },

        {
          internal_id: "conception_cusum_heifers",
          id: "Conceptioncusumanalysisheifers",
          lng: "en-GB",
          index: 6,
        },
        {
          internal_id: "conception_cusum_heifers",
          id: "Conceptioncusumanalysisheifers",
          lng: "en-US",
          index: 6,
        },
        {
          internal_id: "conception_cusum_heifers",
          id: "Conceptioncusumanalysisheifers",
          lng: "fr-FR",
          index: 6,
        },
        {
          internal_id: "conception_cusum_heifers",
          id: "Drachtpercentagecusumanalysepinken",
          lng: "de-DE",
          index: 6,
        },
        {
          internal_id: "conception_cusum_heifers",
          id: "Drachtpercentagecusumanalysepinken",
          lng: "nl-NL",
          index: 6,
        },
        {
          internal_id: "conception_cusum_heifers",
          id: "Analizacielnocijawek",
          lng: "pl-PL",
          index: 6,
        },

        {
          internal_id: "oestrus_interval",
          id: "Oestrusintervalanalysis",
          lng: "en-GB",
          index: 7,
        },
        {
          internal_id: "oestrus_interval",
          id: "Oestrusintervalanalysis",
          lng: "en-US",
          index: 7,
        },
        {
          internal_id: "oestrus_interval",
          id: "Analysedelintervalleentrelescyclesdovulation",
          lng: "fr-FR",
          index: 7,
        },
        {
          internal_id: "oestrus_interval",
          id: "strusintervallanalyse",
          lng: "de-DE",
          index: 7,
        },
        {
          internal_id: "oestrus_interval",
          id: "Tochtintervalanalyse",
          lng: "nl-NL",
          index: 7,
        },
        {
          internal_id: "oestrus_interval",
          id: "Analizaokreswrui",
          lng: "pl-PL",
          index: 7,
        },

        {
          internal_id: "insemination_strategy_heifers",
          id: "Inseminationstrategyinheifers",
          lng: "en-GB",
          index: 8,
        },
        {
          internal_id: "insemination_strategy_heifers",
          id: "Inseminationstrategyinheifers",
          lng: "en-US",
          index: 8,
        },
        {
          internal_id: "insemination_strategy_heifers",
          id: "Stratgiedinsminationpourlesgnisses",
          lng: "fr-FR",
          index: 8,
        },
        {
          internal_id: "insemination_strategy_heifers",
          id: "BesamungsstrategiebeiFrsen",
          lng: "de-DE",
          index: 8,
        },
        {
          internal_id: "insemination_strategy_heifers",
          id: "Inseminatiestrategiebijpinken",
          lng: "nl-NL",
          index: 8,
        },
        {
          internal_id: "insemination_strategy_heifers",
          id: "Strategiainseminacjiujawek",
          lng: "pl-PL",
          index: 8,
        },

        {
          internal_id: "conception_strategy",
          id: "Conceptionstrategyinheifers",
          lng: "en-GB",
          index: 9,
        },
        {
          internal_id: "conception_strategy",
          id: "Conceptionstrategyinheifers",
          lng: "en-US",
          index: 9,
        },
        {
          internal_id: "conception_strategy",
          id: "Stratgiedeconceptionpourlesgnisses",
          lng: "fr-FR",
          index: 9,
        },
        {
          internal_id: "conception_strategy",
          id: "KonzeptionsstrategiebeiFrsen",
          lng: "de-DE",
          index: 9,
        },
        {
          internal_id: "conception_strategy",
          id: "Drachtstrategiebijpinken",
          lng: "nl-NL",
          index: 9,
        },
        {
          internal_id: "conception_strategy",
          id: "Strategiazacieleujawek",
          lng: "pl-PL",
          index: 9,
        },

        {
          internal_id: "n_c_mastitis_month",
          id: "NumberofClinicalMastitiscasespermonthdashboard",
          lng: "en-GB",
          index: 10,
        },
        {
          internal_id: "n_c_mastitis_month",
          id: "NumberofClinicalMastitiscasespermonthdashboard",
          lng: "en-US",
          index: 10,
        },
        {
          internal_id: "n_c_mastitis_month",
          id: "NumberofClinicalMastitiscasespermonthdashboard",
          lng: "fr-FR",
          index: 10,
        },
        {
          internal_id: "n_c_mastitis_month",
          id: "NumberofClinicalMastitiscasespermonthdashboard",
          lng: "de-DE",
          index: 10,
        },
        {
          internal_id: "n_c_mastitis_month",
          id: "Aantalklinischemastitiscasespermaanddashboard",
          lng: "nl-NL",
          index: 10,
        },
        {
          internal_id: "n_c_mastitis_month",
          id: "Liczbaprzypadkwklinicznegomastitisnamiesictablicawskanikw",
          lng: "pl-PL",
          index: 10,
        },

        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "NumberofClinicalMastitiscasespermonthaftercalvingdashboard",
          lng: "en-GB",
          index: 11,
        },
        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "NumberofClinicalMastitiscasespermonthaftercalvingdashboard",
          lng: "en-US",
          index: 11,
        },
        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "NumberofClinicalMastitiscasespermonthaftercalvingdashboard",
          lng: "fr-FR",
          index: 11,
        },
        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "NumberofClinicalMastitiscasespermonthaftercalvingdashboard",
          lng: "de-DE",
          index: 11,
        },
        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "Aantalklinischemastitiscasespermaandnaafkalvendashboard",
          lng: "nl-NL",
          index: 11,
        },
        {
          internal_id: "n_c_mastitis_month_after_calving",
          id: "Liczbaprzypadkwklinicznegomastitisnamiesicpowycieleniupulpitnawigacyjny",
          lng: "pl-PL",
          index: 11,
        },

        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "NumberofClinicalMastitiscasesperlactationnumberdashboard",
          lng: "en-GB",
          index: 12,
        },
        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "NumberofClinicalMastitiscasesperlactationnumberdashboard",
          lng: "en-US",
          index: 12,
        },
        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "NumberofClinicalMastitiscasesperlactationnumberdashboard",
          lng: "fr-FR",
          index: 12,
        },
        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "NumberofClinicalMastitiscasesperlactationnumberdashboard",
          lng: "de-DE",
          index: 12,
        },
        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "Aantalklinischemastitiscasesperlactatienummerdashboard",
          lng: "nl-NL",
          index: 12,
        },
        {
          internal_id: "n_c_mastitis_lactation_n",
          id: "Liczbaprzypadkwklinicznegozapaleniagruczoumlekowegonalaktacjpulpitnawigacyjny",
          lng: "pl-PL",
          index: 12,
        },

        {
          internal_id: "n_c_mastitis_quarters",
          id: "NumberofClinicalMastitiscasesperquartersdashboard",
          lng: "en-GB",
          index: 13,
        },
        {
          internal_id: "n_c_mastitis_quarters",
          id: "NumberofClinicalMastitiscasesperquartersdashboard",
          lng: "en-US",
          index: 13,
        },
        {
          internal_id: "n_c_mastitis_quarters",
          id: "NumberofClinicalMastitiscasesperquartersdashboard",
          lng: "fr-FR",
          index: 13,
        },
        {
          internal_id: "n_c_mastitis_quarters",
          id: "NumberofClinicalMastitiscasesperquartersdashboard",
          lng: "de-DE",
          index: 13,
        },
        {
          internal_id: "n_c_mastitis_quarters",
          id: "Aantalklinischemastitiscasesperkwartierdashboard",
          lng: "nl-NL",
          index: 13,
        },
        {
          internal_id: "n_c_mastitis_quarters",
          id: "Liczbaprzypadkwklinicznegomastitisnakwartapulpitnawigacyjny",
          lng: "pl-PL",
          index: 13,
        },

        {
          internal_id: "n_cows_recurrent",
          id: "NumberofcowswithrecurrentClinicalMastitiscasesdashboard",
          lng: "en-GB",
          index: 14,
        },
        {
          internal_id: "n_cows_recurrent",
          id: "NumberofcowswithrecurrentClinicalMastitiscasesdashboard",
          lng: "en-US",
          index: 14,
        },
        {
          internal_id: "n_cows_recurrent",
          id: "NumberofcowswithrecurrentClinicalMastitiscasesdashboard",
          lng: "fr-FR",
          index: 14,
        },
        {
          internal_id: "n_cows_recurrent",
          id: "NumberofcowswithrecurrentClinicalMastitiscasesdashboard",
          lng: "de-DE",
          index: 14,
        },
        {
          internal_id: "n_cows_recurrent",
          id: "Aantalkoeienmetherhaaldeklinischemastitiscasesdashboard",
          lng: "nl-NL",
          index: 14,
        },
        {
          internal_id: "n_cows_recurrent",
          id: "Liczbakrwznawracajcymiprzypadkamiklinicznegozapaleniagruczoumlekowegonapulpicienawigacyjnym",
          lng: "pl-PL",
          index: 14,
        },

        {
          internal_id: "n_c_mastitis_production",
          id: "NumberofClinicalMastitiscasesperproductionlevelsdashboard",
          lng: "en-GB",
          index: 15,
        },
        {
          internal_id: "n_c_mastitis_production",
          id: "NumberofClinicalMastitiscasesperproductionlevelsdashboard",
          lng: "en-US",
          index: 15,
        },
        {
          internal_id: "n_c_mastitis_production",
          id: "NumberofClinicalMastitiscasesperproductionlevelsdashboard",
          lng: "fr-FR",
          index: 15,
        },
        {
          internal_id: "n_c_mastitis_production",
          id: "NumberofClinicalMastitiscasesperproductionlevelsdashboard",
          lng: "de-DE",
          index: 15,
        },
        {
          internal_id: "n_c_mastitis_production",
          id: "Aantalklinischemastitiscasesperproductieniveaudashboard",
          lng: "nl-NL",
          index: 15,
        },
        {
          internal_id: "n_c_mastitis_production",
          id: "Liczbaprzypadkwklinicznegomastitisnapoziomprodukcjipulpitnawigacyjny",
          lng: "pl-PL",
          index: 15,
        },

        {
          internal_id: "open_cows",
          id: "Opencowsdashboard",
          lng: "en-GB",
          index: 16,
        },
        {
          internal_id: "open_cows",
          id: "Opencowsdashboard",
          lng: "en-US",
          index: 16,
        },
        {
          internal_id: "open_cows",
          id: "Opencowsdashboard",
          lng: "fr-FR",
          index: 16,
        },
        {
          internal_id: "open_cows",
          id: "Opencowsdashboard",
          lng: "de-DE",
          index: 16,
        },
        {
          internal_id: "open_cows",
          id: "Openkoeiendashboard",
          lng: "nl-NL",
          index: 16,
        },
        {
          internal_id: "open_cows",
          id: "Krowyniecielnepulpitnawigacyjny",
          lng: "pl-PL",
          index: 16,
        },

        {
          internal_id: "somatic_cell_count_over_time",
          id: "Somaticcellcountovertimedashboard",
          lng: "en-GB",
          index: 17,
        },
        {
          internal_id: "somatic_cell_count_over_time",
          id: "Somaticcellcountovertimedashboard",
          lng: "en-US",
          index: 17,
        },
        {
          internal_id: "somatic_cell_count_over_time",
          id: "Somaticcellcountovertimedashboard",
          lng: "fr-FR",
          index: 17,
        },
        {
          internal_id: "somatic_cell_count_over_time",
          id: "Somaticcellcountovertimedashboard",
          lng: "de-DE",
          index: 17,
        },
        {
          internal_id: "somatic_cell_count_over_time",
          id: "Celgetaloverdetijddashboard",
          lng: "nl-NL",
          index: 17,
        },
        {
          internal_id: "somatic_cell_count_over_time",
          id: "Liczbakomreksomatycznychwczasiepulpitnawigacyjny",
          lng: "pl-PL",
          index: 17,
        },

        {
          internal_id: "general_subclinical_table_overview",
          id: "Generalsubclinicaltableoverviewdashboard",
          lng: "en-GB",
          index: 18,
        },
        {
          internal_id: "general_subclinical_table_overview",
          id: "Generalsubclinicaltableoverviewdashboard",
          lng: "en-US",
          index: 18,
        },
        {
          internal_id: "general_subclinical_table_overview",
          id: "Generalsubclinicaltableoverviewdashboard",
          lng: "fr-FR",
          index: 18,
        },
        {
          internal_id: "general_subclinical_table_overview",
          id: "Generalsubclinicaltableoverviewdashboard",
          lng: "de-DE",
          index: 18,
        },
        {
          internal_id: "general_subclinical_table_overview",
          id: "Overzichtsubklinischemastitisdashboard",
          lng: "nl-NL",
          index: 18,
        },
        {
          internal_id: "general_subclinical_table_overview",
          id: "Oglnypulpitnawigacyjnyzprzegldemtabelsubklinicznych",
          lng: "pl-PL",
          index: 18,
        },

        {
          internal_id: "new_infections_over_time",
          id: "Newinfectionsovertimedashboard",
          lng: "en-GB",
          index: 19,
        },
        {
          internal_id: "new_infections_over_time",
          id: "Newinfectionsovertimedashboard",
          lng: "en-US",
          index: 19,
        },
        {
          internal_id: "new_infections_over_time",
          id: "Newinfectionsovertimedashboard",
          lng: "fr-FR",
          index: 19,
        },
        {
          internal_id: "new_infections_over_time",
          id: "Newinfectionsovertimedashboard",
          lng: "de-DE",
          index: 19,
        },
        {
          internal_id: "new_infections_over_time",
          id: "Nieuweinfectiesoverdetijddashboard",
          lng: "nl-NL",
          index: 19,
        },
        {
          internal_id: "new_infections_over_time",
          id: "Pulpitnawigacyjnynowychinfekcjiwczasie",
          lng: "pl-PL",
          index: 19,
        },

        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subclinicalmastitisanalysis",
          lng: "en-GB",
          index: 20,
        },
        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subclinicalmastitisanalysis",
          lng: "en-US",
          index: 20,
        },
        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subclinicalmastitisanalysis",
          lng: "fr-FR",
          index: 20,
        },
        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subclinicalmastitisanalysis",
          lng: "de-DE",
          index: 20,
        },
        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subklinischemastitisanalyse",
          lng: "nl-NL",
          index: 20,
        },
        {
          internal_id: "subclinical_mastitis_analysis",
          id: "Subclinicalmastitisanalysis",
          lng: "pl-PL",
          index: 20,
        },

        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Subclinicalmastitisoverviewovertimedashboard",
          lng: "en-GB",
          index: 21,
        },
        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Subclinicalmastitisoverviewovertimedashboard",
          lng: "en-US",
          index: 21,
        },
        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Subclinicalmastitisoverviewovertimedashboard",
          lng: "fr-FR",
          index: 21,
        },
        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Subclinicalmastitisoverviewovertimedashboard",
          lng: "de-DE",
          index: 21,
        },
        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Overzichtsubklinischemastitisoverdetijddashboard",
          lng: "nl-NL",
          index: 21,
        },
        {
          internal_id: "subclinical_mastitis_overview_over_time",
          id: "Przegldpodklinicznegomastitiswczasiepulpitnawigacyjny",
          lng: "pl-PL",
          index: 21,
        },

        {
          internal_id: "dry_period_cure_rate",//proveriti
          id: "Dryperiodcurerate",
          lng: "en-GB",
          index: 22,
        },
        {
          internal_id: "dry_period_cure_rate",
          id: "Dryperiodcurerate",
          lng: "en-US",
          index: 22,
        },
        {
          internal_id: "dry_period_cure_rate",
          id: "Dryperiodcurerate",
          lng: "fr-FR",
          index: 22,
        },
        {
          internal_id: "dry_period_cure_rate",
          id: "Dryperiodcurerate",
          lng: "de-DE",
          index: 22,
        },
        {
          internal_id: "dry_period_cure_rate",
          id: "Droogstandgenezingspercentage",
          lng: "nl-NL",
          index: 22,
        },
        {
          internal_id: "dry_period_cure_rate",
          id: "Dryperiodcurerate",
          lng: "pl-PL",
          index: 22,
        },

        {
          internal_id: "dry_period_new_infection_rate",//proveriti
          id: "Dryperiodnewinfectionrate",
          lng: "en-GB",
          index: 23,
        },
        {
          internal_id: "dry_period_new_infection_rate",
          id: "Dryperiodnewinfectionrate",
          lng: "en-US",
          index: 23,
        },
        {
          internal_id: "dry_period_new_infection_rate",
          id: "Dryperiodnewinfectionrate",
          lng: "fr-FR",
          index: 23,
        },
        {
          internal_id: "dry_period_new_infection_rate",
          id: "Dryperiodnewinfectionrate",
          lng: "de-DE",
          index: 23,
        },
        {
          internal_id: "dry_period_new_infection_rate",
          id: "Droogstandnieuweinfectiepercentage",
          lng: "nl-NL",
          index: 23,
        },
        {
          internal_id: "dry_period_new_infection_rate",
          id: "Dryperiodnewinfectionrate",
          lng: "pl-PL",
          index: 23,
        },
        

        {
          internal_id: "transition_cow_infection_rate",//proveriti
          id: "Transitioncowinfectionrate",
          lng: "en-GB",
          index: 24,
        },
        {
          internal_id: "transition_cow_infection_rate",
          id: "Transitioncowinfectionrate",
          lng: "en-US",
          index: 24,
        },
        {
          internal_id: "transition_cow_infection_rate",
          id: "Transitioncowinfectionrate",
          lng: "fr-FR",
          index: 24,
        },
        {
          internal_id: "transition_cow_infection_rate",
          id: "Transitioncowinfectionrate",
          lng: "de-DE",
          index: 24,
        },
        {
          internal_id: "transition_cow_infection_rate",
          id: "Transitieinfectiepercentage",
          lng: "nl-NL",
          index: 24,
        },
        {
          internal_id: "transition_cow_infection_rate",
          id: "Transitioncowinfectionrate",
          lng: "pl-PL",
          index: 24,
        },

        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactationnewinfectionrate",
          lng: "en-GB",
          index: 25,
        },
        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactationnewinfectionrate",
          lng: "en-US",
          index: 25,
        },
        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactationnewinfectionrate",
          lng: "fr-FR",
          index: 25,
        },
        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactationnewinfectionrate",
          lng: "de-DE",
          index: 25,
        },
        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactatienieuweinfectiepercentage",
          lng: "nl-NL",
          index: 25,
        },
        {
          internal_id: "lactation_new_infection_rate",
          id: "Lactationnewinfectionrate",
          lng: "pl-PL",
          index: 25,
        },

        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "en-GB",
          index: 26,
        },
        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "en-US",
          index: 26,
        },
        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "fr-FR",
          index: 26,
        },
        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "de-DE",
          index: 26,
        },
        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "nl-NL",
          index: 26,
        },
        {
          internal_id: "infection_rate_long_term_evolution",
          id: "Infectionratelongtermevolution",
          lng: "pl-PL",
          index: 26,
        },

        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "en-GB",
          index: 27,
        },
        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "en-US",
          index: 27,
        },
        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "fr-FR",
          index: 27,
        },
        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "de-DE",
          index: 27,
        },
        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "nl-NL",
          index: 27,
        },
        {
          internal_id: "general_cell_count_dashboard",
          id: "Generalcellcountdashboard",
          lng: "pl-PL",
          index: 27,
        },

        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "en-GB",
          index: 28,
        },
        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "en-US",
          index: 28,
        },
        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "fr-FR",
          index: 28,
        },
        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "de-DE",
          index: 28,
        },
        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "nl-NL",
          index: 28,
        },
        {
          internal_id: "milk_yield_by_lactation_infection_rate",
          id: "Milkyieldbylactationinfectionrate",
          lng: "pl-PL",
          index: 28,
        },

        {
          internal_id: "cell_count_manager_dashboard",
          id: "Cellcountmanagerdashboard",
          lng: "en-GB",
          index: 29,
        },
        {
          internal_id: "cell_count_manager_dashboard",
          id: "Cellcountmanagerdashboard",
          lng: "en-US",
          index: 29,
        },
        {
          internal_id: "cell_count_manager_dashboard",
          id: "Cellcountmanagerdashboard",
          lng: "fr-FR",
          index: 29,
        },
        {
          internal_id: "cell_count_manager_dashboard",
          id: "Cellcountmanagerdashboard",
          lng: "de-DE",
          index: 29,
        },
        {
          internal_id: "cell_count_manager_dashboard",
          id: "Celgetalmanagerdashboard",
          lng: "nl-NL",
          index: 29,
        },
        {
          internal_id: "cell_count_manager_dashboard",
          id: "Pulpitnawigacyjnymenederaliczbykomrek",
          lng: "pl-PL",
          index: 29,
        },

        {
          internal_id: "liner_change_dashboard",
          id: "Linerchangedashboard",
          lng: "en-GB",
          index: 30,
        },
        {
          internal_id: "liner_change_dashboard",
          id: "Linerchangedashboard",
          lng: "en-US",
          index: 30,
        },
        {
          internal_id: "liner_change_dashboard",
          id: "Linerchangedashboard",
          lng: "fr-FR",
          index: 30,
        },
        {
          internal_id: "liner_change_dashboard",
          id: "Linerchangedashboard",
          lng: "de-DE",
          index: 30,
        },
        {
          internal_id: "liner_change_dashboard",
          id: "Tepelvoeringdashboard",
          lng: "nl-NL",
          index: 30,
        },{
          internal_id: "liner_change_dashboard",
          id: "Pulpitnawigacyjnyzmianygumstrzykowych",
          lng: "pl-PL",
          index: 30,
        },

        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Lastmilkyieldbeforedryoffdate",
          lng: "en-GB",
          index: 31,
        },
        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Lastmilkyieldbeforedryoffdate",
          lng: "en-US",
          index: 31,
        },
        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Lastmilkyieldbeforedryoffdate",
          lng: "fr-FR",
          index: 31,
        },
        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Lastmilkyieldbeforedryoffdate",
          lng: "de-DE",
          index: 31,
        },
        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Laatstemelkgiftvoordroogzetten",
          lng: "nl-NL",
          index: 31,
        },
        {
          internal_id: "last_milk_yield_before_dry_off_date_dashboard",
          id: "Lastmilkyieldbeforedryoffdate",
          lng: "pl-PL",
          index: 31,
        },

        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Firstmilkyieldbycalvingdate",
          lng: "en-GB",
          index: 32,
        },
        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Firstmilkyieldbycalvingdate",
          lng: "en-US",
          index: 32,
        },
        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Premireproductionlaitirepardatedevlage",
          lng: "fr-FR",
          index: 32,
        },
        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Erstemilchleistungnachkalbedatum",
          lng: "de-DE",
          index: 32,
        },
        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Eerstemelkproductievolgenskalfdatum",
          lng: "nl-NL",
          index: 32,
        },
        {
          internal_id: "first_milk_yield_by_calving_date_dashboard",
          id: "Wydajnopierwszegomlekawedugdatywycielenia",
          lng: "pl-PL",
          index: 32,
        },


        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Milkyieldrelativetomastitiseventdashboard",
          lng: "en-GB",
          index: 33,
        },
        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Milkyieldrelativetomastitiseventdashboard",
          lng: "en-US",
          index: 33,
        },
        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Milkyieldrelativetomastitiseventdashboard",
          lng: "fr-FR",
          index: 33,
        },
        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Milkyieldrelativetomastitiseventdashboard",
          lng: "de-DE",
          index: 33,
        },
        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Melkproductietoveenmastitiseventdashboard",
          lng: "nl-NL",
          index: 33,
        },
        {
          internal_id: "milk_yield_relative_to_mastitis_event_",
          id: "Milkyieldrelativetomastitiseventdashboard",
          lng: "pl-PL",
          index: 33,
        },


        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectofclinicalmastitisonmilkproductiondashboard",
          lng: "en-GB",
          index: 34,
        },
        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectofclinicalmastitisonmilkproductiondashboard",
          lng: "en-US",
          index: 34,
        },
        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectofclinicalmastitisonmilkproductiondashboard",
          lng: "fr-FR",
          index: 34,
        },
        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectofclinicalmastitisonmilkproductiondashboard",
          lng: "de-DE",
          index: 34,
        },
        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectvanklinischemastitisopdemelkproductiedashboard",
          lng: "nl-NL",
          index: 34,
        },
        {
          internal_id: "effects_of_clinical_mastitis_on_milk_production",
          id: "Effectofclinicalmastitisonmilkproductiondashboard",
          lng: "pl-PL",
          index: 34,
        },
      ],

      //dashboard type
      // zoetis - 1
      // farmchamps - 2
      dashboards: [
        {
          dashboard_id: "_z_zoetis_flow_chart_",
          thumbnail: "zoetis_flowchart",
          event: "dashboard|Zoetis flowchart",
          report: true,
          type: 3,
          order: 1,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_insemination_strategy_cows_",
          thumbnail: "insemination_strategy_cows",
          link: "https://youtu.be/i5yJ55QNYzs",
          event: "dashboard|Insemination strategy in cows",
          report: true,
          type: 3,
          order: 2,
          search_keyword: "#zoetis",
          parameters: [
            {
              name: "_dashboards_parameter_vwp_",
              default: 48,
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              default: 3,
              id: 1,
              worksheetName:
                "_worksheet_name_days_in_milk_first_insemination_sows_",
              m: undefined,
            },
          ],
        },
        {
          dashboard_id: "_z_conception_rate_cows_",
          thumbnail: "conception_rate_cows",
          link: "https://youtu.be/sGna5iXh1-o",
          event: "dashboard|Conception rate in cows",
          report: true,
          type: 3,
          order: 3,
          search_keyword: "#zoetis",
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              default: 3,
              id: 1,
              worksheetName:
                "_worksheet_conception_rate_by_parity_",
              m: undefined,
            },
          ],
        },
        {
          dashboard_id: "_z_sire_strategy_cows_",
          thumbnail: "sire_strategy_cows",
          link: "https://youtu.be/N-4jjSZ_aIU",
          event: "dashboard|Sire strategy in cows",
          report: true,
          type: 3,
          order: 4,
          search_keyword: "#zoetis",
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              default: 3,
              id: 1,
              worksheetName:
                "_worksheet_daughter_pregnancy_rate_by_insemination_date_",
              m: undefined,
            },
          ],
        },
        {
          dashboard_id: "_z_conception_cusum_analysis_",
          thumbnail: "conception_cusum_analysis",
          link: "https://youtu.be/mVkoNdO2HCE",
          event: "dashboard|Conception cusum analysis",
          report: true,
          type: 3,
          order: 5,
          search_keyword: "#zoetis",
          parameters: [
            {
              name: "_dashboards_parameter_select_kpi_",
              default: "na",
            },
            {
              name: "worksheetParam",
              name_untranslated: true,
              default: 1,
            },
          ],
        },
        {
          dashboard_id: "_z_oestrus_interval_analysis_",
          thumbnail: "oestrus_interval_analysis",
          link: "https://youtu.be/oOuEdhT64SI",
          event: "dashboard|Oestrus interval analysis",
          report: true,
          type: 3,
          order: 6,
          search_keyword: "#zoetis",
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              default: 3,
              id: 1,
              worksheetName:
                "_worksheet_oestrus_interval_histogram_",
              m: undefined,
            },
          ],
        },
        {
          dashboard_id: "_z_insemination_strategy_heifers_",
          thumbnail: "insemination_strategy_heifers",
          link: "https://youtu.be/i5yJ55QNYzs",
          event: "dashboard|Insemination strategy in heifers",
          report: true,
          type: 3,
          order: 7,
          search_keyword: "#zoetis",
          parameters: [
            {
              name: "_dashboards_parameter_afi_target_",
              default: 13.1,
            },
          ],
        },
        {
          dashboard_id: "_z_conception_strategy_cows_",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_conception_strategy_heifers_",
          thumbnail: "conception_strategy_heifers",
          event: "dashboard|Conception strategy in heifers",
          report: true,
          type: 3,
          order: 8,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_cases_per_month_",
          thumbnail: "n_cm_month",
          event: "dashboard|Number of Clinical Mastitis cases per month",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_cases_per_month_after_calving_",
          thumbnail: "n_cm_month_after_calving",
          event:
            "dashboard|Number of Clinical Mastitis cases per month after calving",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_cases_per_lactation_n_",
          thumbnail: "n_cm_lactation_n",
          event:
            "dashboard|Number of Clinical Mastitis cases per lactation number",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_cases_per_quarters_",
          thumbnail: "n_cm_quarters",
          event: "dashboard|Number of Clinical Mastitis cases per quarters",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_recurrent_",
          thumbnail: "n_cm_recurrent",
          event:
            "dashboard|Number of cows with recurrent Clinical Mastitis cases",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_cases_per_production_",
          thumbnail: "n_cm_production",
          event:
            "dashboard|Number of Clinical Mastitis cases per production levels",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_mastitis_open_cows_",
          thumbnail: "open_cows",
          event: "dashboard|Open cows",
          report: true,
          type: 3,
          order: 9,
          search_keyword: "#zoetis",
          parameters: [
            {
              name: "D50",
              name_untranslated: true,
              default: 50,
            },
            {
              name: "DY",
              name_untranslated: true,
              default: 120,
            },
            {
              name: "DX",
              name_untranslated: true,
              default: 90,
            },
          ],
        },
        {
          dashboard_id: "_z_conception_cusum_analysis_heifers_",
          thumbnail: "conception_cusum_analysis_heifers",
          link: "https://youtu.be/mVkoNdO2HCE",
          event: "dashboard|Conception cusum analysis heifers",
          report: true,
          type: 3,
          order: 10,
          search_keyword: "#zoetis",
          parameters: [
            {
              name: "_dashboards_parameter_select_kpi_",
              default: "na",
            },
          ],
        },
        {
          dashboard_id: "_z_bull_strategy_cows_",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_bull_strategy_heifers_",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_sire_strategy_heifers_",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_milk_meter_dashboard_",
          thumbnail: "milk_meter_dashboard",
          event: "dashboard|Milk meter dashboard",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_milk_recording_dashboard_",
          thumbnail: "milk_recording_dashboard",
          event: "dashboard|Milk recording dashboard",
          report: true,
          type: 3,
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_somatic_cell_count_over_time_",
          thumbnail: "somatic_cell_count_over_time",
          link: "https://youtu.be/xSo98PZPpt8?t=430",
          event: "dashboard|Somatic cell count over time dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_scc_ln_",
              default: "na",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_somatic_cell_count_over_time_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_somatic_cell_count_over_time_",
            },
          ],
        },
        {
          dashboard_id: "_z_general_subclinical_table_overview_",
          thumbnail: "general_subclinical_table_overview",
          link: "https://youtu.be/xSo98PZPpt8?t=143",
          event: "dashboard|General subclinical table overview dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_subclinical_mastitis_overview_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_subclinical_mastitis_overview_",
            },
            {
              name: "DateFilter",
              name_untranslated: true,
              id: 1,
              m: 1,
              worksheetName: "_subclinical_mastitis_overview_",
            },
          ],
        },
        {
          dashboard_id: "_z_new_infections_over_time_",
          thumbnail: "new_infections_over_time",
          link: "https://youtu.be/xSo98PZPpt8?t=321",
          event: "dashboard|New infections over time dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_new_infections_over_time_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_new_infections_over_time_",
            },
          ],
        },
        {
          dashboard_id: "_z_subclinical_mastitis_overview_over_time_",
          thumbnail: "subclinical_mastitis_overview_over_time",
          link: "https://youtu.be/xSo98PZPpt8?t=561",
          event: "dashboard|Subclinical mastitis overview over time dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_subclinical_mastitis_overview_last_mro_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_subclinical_mastitis_overview_last_mro_",
            },
          ],
        },
        {
          dashboard_id: "_dashboard_id_deviation_by_ingredient_dashboard_",
          thumbnail: "deviationbyingredientdashboard",
          type: 3,
        },
        {
          dashboard_id: "_dashboard_id_deviation_by_day_of_week_dashboard_",
          thumbnail: "deviationbydayofweekdashboard",
          type: 3,
        },
        {
          dashboard_id: "_dashboard_id_loading_schedule_dashboard_",
          thumbnail: "loadingscheduledashboard",
          type: 3,
        },
        {
          dashboard_id:
            "_dashboard_id_ingredients_loaded_over_time_total_dashboard_",
          thumbnail: "ingredientsloadedovertimetotaldashboard",
          type: 3,
        },
        {
          dashboard_id:
            "_dashboard_id_dry_matter_intake_per_day_by_load_dashboard_",
          thumbnail: "drymatterintakeperdaybyloaddashboard",
        },
        {
          dashboard_id: "_dashboard_id_total_amount_loaded_per_day_dashboard_",
          thumbnail: "totalamountloadedperdaydashboard",
          type: 3,
        },
        {
          dashboard_id:
            "_dashboard_id_ingredients_loaded_over_time_per_pen_dashboard_",
          thumbnail: "ingredientsloadedovertimeperpendashboard",
          type: 3,
        },
        {
          dashboard_id:
            "_dashboard_id_ingredients_dropped_over_time_per_pen_dashboard_",
          thumbnail: "ingredientsdroppedovertimeperpendashboard",
          type: 3,
        },
        {
          dashboard_id: "_dashboard_id_dropping_starts_dashboard_",
          thumbnail: "droppingstartsdashboard",
          type: 3,
        },
        {
          dashboard_id: "_dashboard_id_total_costs_per_day_dashboard_",
          thumbnail: "totalcostsperdaydashboard",
          type: 3,
        },
        {
          dashboard_id:
            "_dashboard_id_dry_matter_intake_per_cow_per_day_by_pen_dashboard_",
          thumbnail: "drymatterintakepercowperdaybypendashboard",
          type: 3,
        },
        {
          dashboard_id: "_z_dry_period_cure_rate_",
          thumbnail: "dry_period_cure_rate",
          event: "dashboard|Dry period cure rate over time dashboard",
          report: true,
        },
        {
          dashboard_id: "_z_dry_period_new_infection_rate_",
          thumbnail: "dry_period_new_infection_rate",
          event: "dashboard|Dry period new infection rate",
          report: true,
        },
        {
          dashboard_id: "_z_infection_rate_long_term_evolution_",
          thumbnail: "infection_rate_long_term_evolution",
          event: "dashboard|Infection rate long term evolution",
          report: true,
        },
        {
          dashboard_id: "_z_general_cell_count_dashboard_",
          thumbnail: "general_cell_count_dashboard",
          event: "dashboard|General cell count dashboard",
          report: true,
        },
        {
          dashboard_id: "_z_milk_yield_by_lactation_infection_rate_",
          thumbnail: "milk_yield_by_lactation_infection_rate",
          event: "dashboard|Milk yield by lactation infection rate",
          report: true,
        },
        {
          dashboard_id: "_z_liner_change_",
          thumbnail: "liner_change_dashboard",
          event: "dashboard|Liner change dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_number_of_cows_",
              default: 100,
            },
            {
              name: "_dashboards_parameter_liner_types_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_number_of_clusters_",
              default: 10,
            },
            {
              name: "_dashboards_parameter_daily_milkings_",
              default: 2,
            },
            {
              name: "_dashboards_parameter_last_liner_change_",
              default: "na",
            },
          ],
        },
        {
          dashboard_id: "_z_cell_count_manager_",
          thumbnail: "cell_count_manager_dashboard",
          event: "dashboard|Cell count manager dashboard",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_animal_contribution_",
              default: "No",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_cell_count_manager_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_cell_count_manager_",
            },
          ],
        },
        {
          dashboard_id: "_z_dry_period_new_infection_rate_over_time_",
          thumbnail: "dry_period_new_infection_rate_over_time_dashboard",
          event: "dashboard|Dry period new infection rate over time dashboard",
          report: true,
          type: 3,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },

            {
              name: "_dashboard_name_parameter_exclude_early_dim_",
              default: "Exclude none",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName:
                "_worksheet_dry_period_new_infection_rate_over_time_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName:
                "_worksheet_dry_period_new_infection_rate_over_time_",
            },
          ],
        },
        {
          dashboard_id: "_z_dry_period_cure_rate_over_time_",
          thumbnail: "dry_period_cure_rate_over_time_dashboard",
          event: "dashboard|Dry period cure rate over time dashboard",
          report: true,
          type: 3,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },

            {
              name: "_dashboard_name_parameter_exclude_early_dim_",
              default: "Exclude none",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_worksheet_dry_period_cure_rate_over_time_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_worksheet_dry_period_cure_rate_over_time_",
            },
          ],
        },
        {
          dashboard_id: "_z_dry_period_cell_count_evaluation_",
          thumbnail: "dry_period_cell_count_evaluation",
          event: "dashboard|Dry period cell count evaluation",
          report: true,
          type: 3,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },

            {
              name: "_dashboard_name_parameter_exclude_early_dim_",
              default: "Exclude none",
            },
          ],
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 1,
              m: undefined,
              worksheetName: "_worksheet_dry_period_cell_count_evaluation_",
            },
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_worksheet_dry_period_cell_count_evaluation_",
            },
          ],
        },
        {
          dashboard_id:
            "_z_effect_of_cell_count_on_milk_yield_during_lactation_",
          thumbnail: "effect_of_cell_count_on_milk_yield_during_lactation",
          event:
            "dashboard|Effect of cell count on milk yield during lactation",
          report: true,
          type: 3,
          responsive: true,
          parameters: [
            {
              name: "_dashboards_parameter_parity_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_dim_categories_",
              default: "na",
            },
            {
              name: "_dashboards_parameter_cow_scc_treshold_",
              default: 250,
            },
            {
              name: "_dashboards_parameter_heifer_scc_treshold_",
              default: 150,
            },
          ],
          filters: [
            {
              name: "_dashboard_name_parameter_dim_category_",
              id: 1,
              m: undefined,
              worksheetName: "_worksheet_milk_yield_by_lactation_infection_",
            },

            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              use_n_2: true,
              id: 2,
              m: undefined,
              worksheetName: "_worksheet_milk_yield_by_lactation_infection_",
            },
          ],
        },
        {
          dashboard_id: "_z_lact_curve_analysis_bmrd_",
          thumbnail: "lactation_curve_analysis_by_milk_recording_date",
          event: "dashboard|Lactation curve analysis by milk recording date",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_lact_curve_analysis_bcd_",
          thumbnail: "lactation_curve_analysis_by_calving_date",
          event: "dashboard|Lactation curve analysis by calving date",
          search_keyword: "#zoetis",
        },
        {
          dashboard_id: "_z_dry_period_cell_count_evaluation_",
          thumbnail: "dry_period_cell_count_evaluation",
          event: "dashboard|Dry period cell count evaluation",
        },
        {
          dashboard_id:
            "_z_effect_of_cell_count_on_milk_yield_during_lactation_",
          thumbnail: "effect_of_cell_count_on_milk_yield_during_lactation",
          event:
            "dashboard|Effect of cell count on milk yield during lactation",
        },
        {
          dashboard_id: "_z_subclinical_mastitis_analysis_",
          thumbnail: "subclinical_mastitis_analysis",
          link: "https://youtu.be/xSo98PZPpt8",
          event: "dashboard|Subclinical mastitis analysis",
          report: true,
          type: 3,
        },
        {
          dashboard_id: "_z_last_milk_yield_before_dry_off_date_",
          thumbnail: "last_milk_yield_before_dry_off_date",
          event: "dashboard|Last milk yield before dry off date",
          report: true,
          type: 3,
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              id: 2,
              m: undefined,
              worksheetName: "_worksheet_last_milk_yield_before_dry_off_date_",
            },
          ],
          parameters: [
            {
              name: "_dashboards_parameter_select_kpi_",
              default: "na",
            },
          ],
        },
        {
          dashboard_id: "_z_first_milk_yield_by_calving_date_",
          dashboard_subcategory: "milk-meter-first",
          thumbnail: "first_milk_yield_by_calving_date",
          event: "dashboard|First milk yield by calving date",
          report: true,
          type: 3,
          filters: [
            {
              name: "_dashboard_name_filter_parity_",
              name_2: "_dashboard_name_filter_parity_filter_",
              id: 2,
              m: undefined,
              worksheetName: "_worksheet_first_milk_yield_by_calving_date_",
            },
          ],
          parameters: [
            {
              name: "Select KPI first",
              default: "na",
              name_untranslated: true,
            },
          ],
        },
        {
          dashboard_id: "_z_milk_yield_relative_to_mastitis_event_",
          thumbnail: "milk_yield_relative_to_mastitis_event_dashboard",
          event: "dashboard|Milk yield relative to mastitis event dashboard",
          report: true,
          type: 1,
          filters: [
          
          ],
          parameters: [
            {
              name: "_dashboard_name_parameter_view_by_",
              default: true,
            }
          
          ],
        },
        {
          dashboard_id: "_z_effects_of_clinical_mastitis_on_milk_production_dashboard_id_",
          thumbnail: "effect_of_clinical_mastitis_on_milk_production_dashboard",
          event: "dashboard|Effect of clinical mastitis on milk production dashboard",
          report: true,
          type: 1,
          filters: [
          
          ],
        },
        {
          dashboard_id: "_z_lactation_curve_parity_dashboard_id_",
          thumbnail: "lactation_curve_by_parity_dashboard",
          event: "dashboard|Lactation curve by parity dashboard",
          report: true,
          type: 1,
        },
        {
          dashboard_id: "_z_transition_cow_infection_rate_",
          thumbnail: "transition_cow_infection_rate",
          event: "dashboard|Transition cow infection rate",
          report: true,
        },
        {
          dashboard_id: "_z_lactation_new_infection_rate_",
          thumbnail: "lactation_new_infection_rate",
          event: "dashboard|lactation new infection rate",
          report: true,
        },
      ],
    },
    experimental: {
      dashboards: [
        {
          dev: true,
          id: "Milkyieldanalysisovertime",
          description: "Milk yield analysis over time",
          category: "production",
          subcategory: "milk-recording-story",
          locale: "en-GB",
          url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Milkyieldanalysisovertime?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
        },
        {
          dev: true,
          id: "Milkcomponentanalysis",
          description: "Milk component analysis",
          category: "production",
          subcategory: "milk-recording-story",
          locale: "en-GB",
          url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Milkcomponentanalysis?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
        },
        {
          dev: true,
          id: "Lactationcurveanalysis",
          description: "Lactation curve analysis",
          category: "production",
          subcategory: "milk-recording-story",
          locale: "en-GB",
          url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Lactationcurveanalysis?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
        },
        {
          dev: true,
          id: "Geneticanalysisovertime",
          description: "Genetic analysis overtime",
          category: "production",
          subcategory: "milk-recording-story",
          locale: "en-GB",
          url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Geneticanalysisovertime?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
        },
        {
          dev: true,
          id: "Geneticresponse",
          description: "Genetic response",
          category: "production",
          subcategory: "milk-recording-story",
          locale: "en-GB",
          url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Geneticresponse?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
        },
      ],
    },
    development: {
      local_dashboard_url:
        "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-health-cows-mastitis-to-milkyield_en-GB_twb/Effectofclinicalmastitisonmilkproductiondashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
      local_dashboards: [],
      local_reports: [],
      local_image_url: "assets/img/thumbnails/open_cows.png?4564545",
    },
  });
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.dashboardsV2")
    .controller("herdsDashboardsCtrlV2", herdsDashboardsCtrl);
  /** @ngInject */
  function herdsDashboardsCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    dashboardsDataService,
    $cookies,
    Upload,
    $location,
    cookiesService
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    var dashboard_constants = DASH_CONSTANTS;
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var viewName;
    var viewByName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs =
      dashboard_constants.constants.dashboards_filter_pairs;
    var dashboardIdLngList =
      dashboard_constants.constants.dashboard_id_lng_list;
    var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
    var dashboardsList = dashboard_constants.constants.dashboards;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;
    vm.canAddToReport = false;

    init();

    function init() {
      vm.selectedLayout = 1;
      if (permissionService.can(334) && permissionService.can(335)) {
        vm.canAddToReport = true;
      }
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = angular.copy(
        dashboard_constants.constants.all_categories
      );
      vm.currentUserType = permissionService.getDashboardsType();
      if (permissionService.can(333)) {
        vm.hideTiles = false;
        vm.selectedLayout = 2;
      }else {
        vm.selectedLayout = 1;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!dashboardsDataService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      worksheetParamName = "worksheetParam";
      viewByName = i18nFilter("_dashboard_name_parameter_view_by_");
      viewName = i18nFilter("_dashboard_name_parameter_view_");
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      var production_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          hoof_health_index = i;
        }

        if(vm.allCategories[i].id == "production"){
          production_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {

        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = dashboard_constants.development.local_dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id && 
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = dashboard_constants.experimental.dashboards;
                //response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        if (user_type == "zoetis") {
          response.forEach(function (dashboard) {
            var isZoetis = dashboardsList.find(function (item) {
              return (
                (dashboard.id == i18nFilter(item.dashboard_id) &&
                  item.type &&
                  (item.type & 1) == 1 &&
                  !item.restricted &&
                  (item.dashboard_subcategory
                    ? dashboard.subcategory == item.dashboard_subcategory
                    : true)) ||
                (dashboard.id == i18nFilter(item.dashboard_id) &&
                  item.type &&
                  (item.type & 1) == 1 &&
                  item.restricted &&
                  item.restricted == vm.selectedTeam &&
                  (item.dashboard_subcategory
                    ? dashboard.subcategory == item.dashboard_subcategory
                    : true))
              );
            });
            if (isZoetis) {
              dashboard.title = dashboard.description;
              list.push(dashboard);
            }
          });
          list = orderDashboards(list);
        } else if (user_type == "farmchamps") {
          response.forEach(function (dashboard) {
            var isFarmchamps = dashboardsList.find(function (item) {
              return (
                (dashboard.id == i18nFilter(item.dashboard_id) &&
                  item.type &&
                  (item.type & 2) == 2 &&
                  !item.restricted) ||
                (dashboard.id == i18nFilter(item.dashboard_id) &&
                  item.type &&
                  (item.type & 2) == 2 &&
                  item.restricted &&
                  item.restricted == vm.selectedTeam)
              );
            });
            if (isFarmchamps) {
              dashboard.title = dashboard.description;
              list.push(dashboard);
            }
          });
          list = orderDashboards(list);
        } else if (user_type == "ff") {
          for (var i = 0; i < response.length; i++) {
            if (
              response[i].category != "plus" &&
              response[i].subcategory == "rap-fame-v3"
            ) {
              response[i].title = response[i].description;
              list.push(response[i]);
            }
          }
          list = $filter("orderBy")(list, "description");
        } else {
          for (var i = 0; i < response.length; i++) {
            if (
              response[i].category != "plus" &&
              response[i].subcategory != "rap-fame-v3"
            ) {
              response[i].title = response[i].description;
              list.push(response[i]);
            }
          }
          list = $filter("orderBy")(list, "description");
        }
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var report = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.report;
      });
      if (report) {
        return true;
      }
      return false;
    }

    function setDashboardThumbnail(dashboard) {
      var thmbn = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.thumbnail;
      });
      if (thmbn) {
        return "assets/img/thumbnails/" + thmbn.thumbnail + ".png";
      }
      return null;
    }

    function setInfoLink(dashboard) {
      var l_item = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.link;
      });

      if (l_item) {
        return l_item.link;
      }

      return null;
    }

    function orderDashboards(list) {
      list = list.map(function (dashboard) {
        var order = dashboardsList.find(function (item) {
          return dashboard.id == i18nFilter(item.dashboard_id) && item.order;
        });

        if (order) {
          dashboard.order = order.order;
        } else {
          dashboard.order = 99;
        }
        return dashboard;
      });
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboardsV2/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard);
      embedPage(dash);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, dev);
        } else {
          embedUrl(url, true, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url = dashboard_constants.development.local_dashboard_url;
        embed(url, herds, useTabvis);
      }
    }

    function embed(url, herds, useTabvis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          //"Parity Filter": "≥2",
          onFirstInteractive: function () {
             /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*console.log(wrks);

              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }

    function checkIfIsResponsive(dashboard) {
      var res = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.responsive;
      });
      if (res) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard) {
      var event = dashboardsList.find(function (item) {
        return dashboard.id == i18nFilter(item.dashboard_id) && item.event;
      });

      if (
        event &&
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", event.event);
        } catch (error) {
          console.log(error);
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];

      if (keyword == "zoetis") {
        vm.allDashboards.forEach(function (dashboard) {
          var dash = dashboardsList.find(function (item) {
            return (
              dashboard.id == i18nFilter(item.dashboard_id) &&
              item.search_keyword &&
              item.search_keyword.indexOf("#zoetis") != 1
            );
          });

          if (dash) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == dashboard.category.id) {
                list.push(dashboard);
              }
            } else {
              list.push(dashboard);
            }
          }
        });
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
      
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
      
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboardsV2/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = dashboard_constants.development.local_reports;
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Analizawspczynnikazapodnie") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var parityFFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;
      var selectKPIFilterString;
      var selectKPIFirstFilterString;
      var viewString;
      var viewByString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("OPP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Parytet=") != -1 ||
          splitted[i].indexOf("Laktacja=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Parity Filter=") != -1) {
          parityFFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Cel WPI=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("Kategoria DL=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (
          splitted[i].indexOf("Cow SCC threshold=") != -1 ||
          splitted[i].indexOf("Próg LKS dla krów=") != -1
        ) {
          cowSccString = splitted[i];
        }
        if (
          splitted[i].indexOf("Heifer SCC threshold=") != -1 ||
          splitted[i].indexOf("Próg LKS jałówek=") != -1
        ) {
          heiferSccString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity categories=") != -1 ||
          splitted[i].indexOf("Kategorie parzystości=") != -1
        ) {
          parityCategoriesFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM categories=") != -1 ||
          splitted[i].indexOf("Kategorie dni laktacji=") != -1
        ) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("SCC vs LN=") != -1 ||
          splitted[i].indexOf("LKS vs NL=") != -1
        ) {
          SCCLNFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Animal contribution=") != -1 ||
          splitted[i].indexOf("Udział zwierząt=") != -1
        ) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Liczba krów=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Liner type=") != -1 ||
          splitted[i].indexOf("Typ gum strzukowych=") != -1
        ) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Daily milkings=") != -1 ||
          splitted[i].indexOf("Dzienne udoje=") != -1
        ) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Data ostatniej wymiany gum strzykowych=") !=
            -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (
          splitted[i].indexOf("Exclude early DIM=") != -1 ||
          splitted[i].indexOf("Wyklucz wczesny DL=") != -1
        ) {
          excludeEarlyDIMFilterString = splitted[i];
        }

        if (
          splitted[i].indexOf("Select KPI=") != -1 ||
          splitted[i].indexOf("Wybierz KPI=") != -1 ||
          splitted[i].indexOf("Selecteer KPI=") != -1
        ) {
          selectKPIFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Select KPI first=") != -1) {
          selectKPIFirstFilterString = splitted[i];
        }

        if (splitted[i].indexOf("View=") != -1) {
          viewString = splitted[i];
        }

        if (splitted[i].indexOf("View by=") != -1) {
          viewByString = splitted[i];
        }
      }
      var parity;
      var parityF;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;
      var selectKPI;
      var selectKPIFirst;
      var view;
      var viewBy;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_filter" &&
          filtersLngList[i].lng == lng
        ) {
          parityF = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "select_kpi" &&
          filtersLngList[i].lng == lng
        ) {
          selectKPI = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "select_kpi_first" &&
          filtersLngList[i].lng == lng
        ) {
          selectKPIFirst = filtersLngList[i].name;
        }

        if (
          filtersLngList[i].internal_id == "view" &&
          filtersLngList[i].lng == lng
        ) {
          view = filtersLngList[i].name;
        }

        if (
          filtersLngList[i].internal_id == "view_by" &&
          filtersLngList[i].lng == lng
        ) {
          viewBy = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (parityF && parityFFilterString) {
        parityFFilterString = changeFilterNameLanguage(
          parityFFilterString,
          parityF,
          "Parity Filter"
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      if (selectKPI && selectKPIFilterString) {
        selectKPIFilterString = changeFilterNameLanguage(
          selectKPIFilterString,
          selectKPI,
          selectKPIParamName
        );
      }

      if (selectKPIFirst && selectKPIFirstFilterString) {
        selectKPIFirstFilterString = changeFilterNameLanguage(
          selectKPIFirstFilterString,
          selectKPIFirst,
          "Select KPI first"
        );
      }

      if (view && viewString) {
        viewString = changeFilterNameLanguage(
          viewString,
          view,
          viewName
        );
      }

      if (viewBy && viewByString) {
        viewByString = changeFilterNameLanguage(
          viewByString,
          viewBy,
          viewByName
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (parityFFilterString) {
        filterString += "&" + parityFFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      if (selectKPIFilterString) {
        filterString += "&" + selectKPIFilterString;
      }
      if (selectKPIFirstFilterString) {
        filterString += "&" + selectKPIFirstFilterString;
      }
      if (viewString) {
        filterString += "&" + viewString;
      }
      if (viewByString) {
        filterString += "&" + viewByString;
      }
      return filterString;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      //enable multiple entries per dashboard
      var entry;
      handleEntry(entry);
    }

    function handleEntry(entry) {
      vm.modalComment = "";
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = [];
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < addedToReport.length; j++) {
          if (list[i].id == addedToReport[j].dashboardId) {
            var newDashboard = angular.copy(list[i]);
            newDashboard.comment = addedToReport[j].comment;
            newDashboard.end_date = new Date(addedToReport[j].endDate);
            newDashboard.start_date = new Date(addedToReport[j].startDate);
            newDashboard.selected = true;
            newDashboard.filter = addedToReport[j].filter;
            newDashboard.entry_id = addedToReport[j].id;
            list2.push(newDashboard);
          }
        }
      }
      for (var k = 0; k < list.length; k++) {
        var found = false;
        for (var l = 0; l < list2.length; l++) {
          if (list[k].id == list2[l].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          list2.push(angular.copy(list[k]));
        }
      }
      list2 = $filter("orderBy")(list2, "position");
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                      var p_name = filterList.parameters[j].name;
                      if (
                        parameters[i].getCurrentValue().value !=
                        filterList.parameters[j].default
                      ) {
                        if (
                          p_name ==
                          i18nFilter("_dashboards_parameter_last_liner_change_")
                        ) {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            $filter("date")(
                              new Date(parameters[i].getCurrentValue().value),
                              "yyyy-MM-dd"
                            );
                        } else {
                          filter +=
                            "&" +
                            filterList.parameters[j].name +
                            "=" +
                            parameters[i].getCurrentValue().value;
                        }
                      }
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  for (var i = 0; i < filtersResponse.length; i++) {
                    var name = filtersResponse[i].getFieldName();
                    var filterValue;
                    for (var j = 0; j < filterList.filters.length; j++) {
                      if (
                        name == i18nFilter("_dashboard_name_filter_parity_") ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_dim_category_"
                          ) ||
                        name == "DateFilter" ||
                        name ==
                          i18nFilter(
                            "_dashboard_name_parameter_exclude_early_dim_"
                          ) ||
                        name == "Parity Filter"
                      ) {
                        if (name == filterList.filters[j].name) {
                          var filter_values =
                            filtersResponse[i].getAppliedValues();
                          if (name == "DateFilter") {
                            for (var f = 0; f < filter_values.length; f++) {
                              filter_values[f].formattedValue = $filter("date")(
                                new Date(filter_values[f].value),
                                "yyyy-MM-dd"
                              );
                            }
                          }

                          if (
                            (filterList.filters[j].m != undefined) &
                            (filterList.filters[j].m == filter_values.length)
                          ) {
                            filterValue = getFilterString(filter_values, name);
                          } else {
                            if (
                              filtersResponse[i].getFilterType() ==
                              "categorical"
                            ) {
                              if (!filtersResponse[i].getIsAllSelected()) {
                                filterValue = getFilterString(
                                  filter_values,
                                  name
                                );
                              }
                            } else {
                              filterValue = getFilterString(
                                filter_values,
                                name
                              );
                            }
                          }

                          var p_name = "pr_f_" + filterList.filters[j].name;
                          if (filterValue) {
                            filter += filterValue;
                          }
                          vm[p_name].resolve();
                          filterValue = null;
                        }
                      }
                    }
                  }
                });
            }
          } else {
            for (var i = 0; i < filterList.parameters.length; i++) {
              var name = "pr_p_" + filterList.parameters[i].name;
              vm[name].resolve();
            }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getFilterString(value, name) {
      var filter = "";
      if (value.length == 1) {
        filter = value[0].formattedValue;
      } else {
        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            filter = filter + value[i].formattedValue;
          } else {
            filter = filter + "," + value[i].formattedValue;
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      var dash = dashboardsList.find(function (item) {
        return (
          dashboardId == i18nFilter(item.dashboard_id) &&
          (item.parameters || item.filters)
        );
      });

      if (dash) {
        if (dash.parameters && dash.parameters.length) {
          dash.parameters.forEach(function (item) {
            var parameter = Object.assign({}, item);
            if (parameter.name && !parameter.name_untranslated) {
              parameter.name = i18nFilter(parameter.name);
            }
            obj.parameters.push(parameter);
          });
        }

        if (dash.filters && dash.filters.length) {
          dash.filters.forEach(function (item) {
            var filter = Object.assign({}, item);
            if (filter.use_n_2) {
              if (filter.name_2) {
                if (filter.name_untranslated) {
                  filter.name = filter.name_2;
                } else {
                  filter.name = i18nFilter(filter.name_2);
                }
              }
            } else {
              if (filter.name && !filter.name_untranslated) {
                filter.name = i18nFilter(filter.name);
              }
            }

            if (filter.worksheetName) {
              filter.worksheetName = i18nFilter(filter.worksheetName);
            }
            obj.filters.push(filter);
          });
        }
      }
      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.addToReportModalLoading = false;
        });
    }

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(dashboardIdLngList);
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getReportDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getReportDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (var i = 0; i < dashboardIdLngList.length; i++) {
        if (dashboardIdLngList[i].lng == currentLng) {
          listOfDashboardsIds.push(dashboardIdLngList[i]);
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboardsV2/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboardsV2/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !dashboardsDataService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);

      var reportMeta = {
        dashboards: vm.reportDashboards,
        herd_id: vm.selectedHerds[0],
        user: vm.user,
        positive_points: vm.positivePoints,
        points_to_improve: vm.pointsToImprove,
        herd_name: vm.currentHerdName,
        work_locally: vm.work_locally,
        title: vm.report_title,
      };

      return dashboardsDataService
        .setReportData(reportMeta)
        .then(function (data) {
          createPDF(data);
        })
        .catch(function (error) {
          console.log(error);
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function createPDF(pdfData) {
      var dd = dashboardsDataService.generatePdfFile(pdfData);
      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.dashboardsV2")
    .factory("dashboardsDataService", dashboardsDataService);
  /** @ngInject */
  function dashboardsDataService(
    $http,
    $q,
    APP_CONSTANTS,
    DASH_CONSTANTS,
    $filter,
    bugsnagService,
    $timeout
  ) {
    var i18nFilter = $filter("i18n");
    var vm = this;
    var dashboard_constants = DASH_CONSTANTS;

    return {
      excludeUsers: excludeUsers,
      setReportData: setReportData,
      generatePdfFile: generatePdfFile,
      createPDF: createPDF,
    };

    function excludeUsers(user) {
      var user_list = [
        "auth0|5acdfe8c2735d3736e8298fe",
        "auth0|5ad5dca65fb3bc1b6d7a3ebe",
        "auth0|5ad4605f3467830fef67091f",
        "auth0|604f46844b70b10070bfc294",
        "auth0|56b37779ec9cf8243c80f211",
        "google-oauth2|108831753800092786976",
        "google-oauth2|110442934239793747425",
      ];

      if (user_list.includes(user.user_id)) {
        return true;
      }

      return false;
    }

    function setReportData(meta) {
      var deffered = $q.defer();

      var list = meta.dashboards.filter(function (item) {
        return item.selected;
      });

      vm.orderedDashboards = $filter("orderBy")(list, "index");
      var url_promise_list = [];

      vm.orderedDashboards.forEach(function (item, index) {
        var name = "pr" + index;
        vm[name] = $q.defer();
        url_promise_list.push(vm[name].promise);
        getImageUrl(item.url, index, name, meta.work_locally);
      });

      $q.all(url_promise_list)
        .then(function () {
          setDataUrls(vm.orderedDashboards, meta);
        })
        .catch(function (error) {
          deffered.reject(error);
        });

      return deffered.promise;

      function getImageUrl(url, index, name, work_locally) {
        if (work_locally) {
          var image_url = dashboard_constants.development.local_image_url;
          vm.orderedDashboards[index].image_url = image_url;
          vm.orderedDashboards[index].image_loaded = true;
          vm[name].resolve();
        } else {
          return setSession(url)
            .then(function (response) {
              var image_url = response.headers("tabvis-location");
              vm.orderedDashboards[index].image_url = image_url;
              vm.orderedDashboards[index].image_loaded = true;
              vm[name].resolve();
            })
            .catch(function (error) {
              vm[name].resolve();
            });
        }
      }

      function setDataUrls(dashboards, meta) {
        var image_url_promise_list = [];
        dashboards.forEach(function (item, index) {
          if (item.image_loaded) {
            var name = "imgpr" + index;
            vm[name] = $q.defer();
            image_url_promise_list.push(vm[name].promise);
            var image_url = setImageUrl(item, meta);
            getDataUrl(image_url, index, name);
          }
        });
        vm.logoPrm = $q.defer();
        vm.logoMmmPrm = $q.defer();

        image_url_promise_list.push(vm.logoPrm.promise);
        image_url_promise_list.push(vm.logoMmmPrm.promise);

        if (meta.style && meta.style == "aveve") {
          vm.logoAvevePrm = $q.defer();
          image_url_promise_list.push(vm.logoAvevePrm.promise);
          toDataURL(
            "assets/img/logo_l2m.png",
            function (dataUrl) {
              vm.logo_aveve = dataUrl;
              vm.logoAvevePrm.resolve();
            },
            "logoAvevePrm"
          );

          vm.aveveSwooshPrm = $q.defer();
          image_url_promise_list.push(vm.aveveSwooshPrm);
          toDataURL(
            "assets/img/aveve_swoosh.png",
            function (dataUrl) {
              vm.aveve_swoosh = dataUrl;
              vm.aveveSwooshPrm.resolve();
            },
            "aveveSwooshPrm"
          );
        }

        if (meta.style && meta.style == "proxani") {
          vm.logoProxaniPrm = $q.defer();
          image_url_promise_list.push(vm.logoProxaniPrm.promise);
          toDataURL(
            "assets/img/logo_proXpert.png",
            function (dataUrl) {
              vm.logo_proxani = dataUrl;
              vm.logoProxaniPrm.resolve();
            },
            "logoProxaniPrm"
          );

          vm.proxaniSwooshPrm = $q.defer();
          image_url_promise_list.push(vm.proxaniSwooshPrm);
          toDataURL(
            "assets/img/proxani_swoosh.png",
            function (dataUrl) {
              vm.proxani_swoosh = dataUrl;
              vm.proxaniSwooshPrm.resolve();
            },
            "proxaniSwooshPrm"
          );
        }

        if (meta.style && (meta.style == "aveve" || meta.style == "proxani")) {
          vm.logoMMMInsidePrm = $q.defer();
          image_url_promise_list.push(vm.logoMMMInsidePrm.promise);
          toDataURL(
            "assets/img/mmm_inside.png",
            function (dataUrl) {
              vm.logo_mmm_inside = dataUrl;
              vm.logoMMMInsidePrm.resolve();
            },
            "logoMMMInsidePrm"
          );
        }

        toDataURL(
          "assets/img/zoetis_logo.png",
          function (dataUrl) {
            vm.logo = dataUrl;
            vm.logoPrm.resolve();
          },
          "logoPrm"
        );

        toDataURL(
          "assets/img/logo_mmm.png",
          function (dataUrl) {
            vm.logoMmm = dataUrl;
            vm.logoMmmPrm.resolve();
          },
          "logoMmmPrm"
        );
        $q.all(image_url_promise_list)
          .then(function () {
            var date = new Date();
            date = $filter("date")(date);
            var pdfData = {
              date: date,
              logo: vm.logo,
              logoMmm: vm.logoMmm,
              logo_aveve: vm.logo_aveve,
              logo_proxani: vm.logo_proxani,
              logo_mmm_inside: vm.logo_mmm_inside,
              proxani_swoosh: vm.proxani_swoosh,
              aveve_swoosh: vm.aveve_swoosh,
              user: meta.user.name,
              colour_1: "#E0E0E1",
              colour_2:
                meta.style && meta.style == "aveve"
                  ? "#00936F"
                  : meta.style && meta.style == "proxani"
                  ? "#546121"
                  : "#ff661f",
              colour_text:
                meta.style && meta.style == "aveve" ? "#414042" : "#666666",
              red: "red",
              positive_points: meta.positive_points ? meta.positive_points : "",
              points_to_improve: meta.points_to_improve
                ? meta.points_to_improve
                : "",
              herd_name: meta.herd_name,
              dashboards: vm.orderedDashboards,
              title: meta.title,
              style: meta.style,
              include_positive_points: meta.include_positive_points,
              include_points_to_improve: meta.include_points_to_improve,
            };
            deffered.resolve(pdfData);
          })
          .catch(function (error) {
            deffered.reject(error);
          });
      }

      function setImageUrl(dashboard, meta) {
        var image_url;
        var size = "1280,720";
        var splitted = dashboard.image_url.split("?");
        if (meta.work_locally) {
          image_url = splitted[0];
        } else {
          image_url = splitted[0] + ".png";
        }
        var start_date = moment(dashboard.start_date).format("YYYY-MM-DD");
        var end_date = moment(dashboard.end_date).format("YYYY-MM-DD");
        var herd = meta.herd_id;
        var suffix =
          "?Start%20Date=" +
          start_date +
          "&End%20Date=" +
          end_date +
          "&HerdIdentifier=" +
          herd +
          "&Herd%20Parameter=" +
          herd;

        image_url = image_url + suffix;
        if (dashboard.filter) {
          image_url = image_url + dashboard.filter;
        }

        if (dashboard.size) {
          image_url = image_url + "&:size=" + dashboard.size;
        } else {
          if (
            meta.style &&
            (meta.style == "proxani" || meta.style == "aveve")
          ) {
            image_url = image_url + "&:size=1440,720";
          } else {
            image_url = image_url + "&:size=" + size;
          }
        }
        image_url = image_url.replaceAll("+", "%2B");
        image_url = image_url.replaceAll("≥3", "%E2%89%A53");
        image_url = image_url.replaceAll("≥2", "%E2%89%A52");
        return image_url;
      }

      function getDataUrl(url, index, name) {
        toDataURL(
          url,
          function (dataUrl) {
            vm.orderedDashboards[index].image = dataUrl;
            vm[name].resolve();
          },
          name
        );
      }

      function toDataURL(url, callback, prm) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.onloadend = function () {
            callback(reader.result);
          };
          if (xhr.status == 200 || xhr.status == 204) {
            reader.readAsDataURL(xhr.response);
          } else {
            vm[prm].resolve();
          }
        };
        xhr.open("GET", url);
        xhr.setRequestHeader(
          "Authorization",
          "Bearer " + localStorage.getItem("id_token")
        );
        xhr.responseType = "blob";
        xhr.withCredentials = true;
        xhr.send();
      }
    }

    function generatePdfFile(pdf_data) {
      var dd = {
        pageMargins:
          pdf_data.style && pdf_data.style == "aveve"
            ? [20, 80, 20, 120]
            : pdf_data.style && pdf_data.style == "proxani"
            ? [20, 80, 20, 120]
            : [20, 60, 20, 70],
        pageSize: "A4",
        defaultStyle: {
          font: "Arboria",
        },
        header: function (page) {
          if (
            pdf_data.style &&
            (pdf_data.style == "aveve" || pdf_data.style == "proxani")
          ) {
            var l = {
              table: {
                widths: ["50%", "*"],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      image:
                        pdf_data.style && pdf_data.style == "aveve"
                          ? pdf_data.logo_aveve
                          : pdf_data.style && pdf_data.style == "proxani"
                          ? pdf_data.logo_proxani
                          : pdf_data.logoMmm,
                      width:
                        pdf_data.style && pdf_data.style == "aveve" ? 130 : 200,
                      alignment: "left",
                      margin: [10, 0, 0, 0],
                    },
                    {
                      margin:
                        pdf_data.style && pdf_data.style == "aveve"
                          ? [0, 35, 10, 0]
                          : [0, 20, 10, 0],
                      border: [false, false, false, false],
                      image: pdf_data.logo_mmm_inside,
                      width: 90,
                      alignment: "right",
                    },
                  ],
                ],
              },
            };

            return l;
          } else {
            if (page == 1)
              return {
                image: pdf_data.logoMmm,
                width: 150,
                alignment: "left",
                margin: [50, 30, 0, 20],
              };
            else
              return {
                margin: [30, 30, 0, 20],
                image: pdf_data.logoMmm,
                width: 110,
                alignment: "left",
              };
          }
        },
        content: [
          {
            text: pdf_data && pdf_data.title ? pdf_data.title : "",
            alignment: "left",
            fontSize: 23,
            bold: true,
            color: pdf_data.colour_2,
            margin: [40, 80, 40, 25],
          },
          {
            text: i18nFilter("_zts_report_text_"),
            alignment: "left",
            fontSize: 12,
            color: pdf_data.colour_text,
            margin: [40, 0, 40, 12],
            font: "Arial",
          },
          {
            text: i18nFilter("_label_herd_") + ": " + pdf_data.herd_name,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdf_data.colour_text,
            margin:
              pdf_data.style && pdf_data.style == "aveve"
                ? [40, 25, 40, 0]
                : [40, 7, 40, 0],
            font:
              pdf_data.style && pdf_data.style == "proxani"
                ? "Merriweather"
                : "Arial",
          },
          {
            text: i18nFilter("_label_date_") + ": " + pdf_data.date,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdf_data.colour_text,
            margin: [40, 7, 40, 0],
            font:
              pdf_data.style && pdf_data.style == "proxani"
                ? "Merriweather"
                : "Arial",
          },
          {
            text:
              (pdf_data.style &&
              (pdf_data.style == "proxani" || pdf_data.style == "aveve")
                ? i18nFilter("_label_advisor_")
                : i18nFilter("_title_vet_")) +
              ": " +
              pdf_data.user,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdf_data.colour_text,
            margin: [40, 7, 40, 22],
            font:
              pdf_data.style && pdf_data.style == "proxani"
                ? "Merriweather"
                : "Arial",
          },
        ],
      };

      if (pdf_data.style && pdf_data.style == "proxani") {
        dd.footer = {
          columns: [{ image: pdf_data.proxani_swoosh, width: 600 }],
        };
      }
      if (pdf_data.style && pdf_data.style == "aveve") {
        dd.footer = {
          columns: [{ image: pdf_data.aveve_swoosh, width: 600 }],
        };
      }
      var c = 0;
      var s = 0;
      var p_points = {
        margin: [40, 0, 40, 25],
        table: {
          widths: [465],
          heights: ["auto", 150],
          body: [
            [
              {
                text: i18nFilter("_report_positive_points_") + ":",
                color: pdf_data.colour_2,
                fontSize: 14,
                border: [true, true, true, false],
                bold: true,
                font:
                  pdf_data.style && pdf_data.style == "proxani"
                    ? "Merriweather"
                    : "Arial",
              },
            ],
            [
              {
                text: pdf_data.positive_points,
                color: pdf_data.colour_text,
                fontSize: 12,
                border: [true, false, true, true],
                width: 465,
                height: 150,
                font:
                  pdf_data.style && pdf_data.style == "proxani"
                    ? "Montserrat"
                    : "Arial",
              },
            ],
          ],
        },
        layout: {
          hLineColor: pdf_data.colour_1,
          vLineColor: pdf_data.colour_1,
        },
      };

      var i_points = {
        margin: [40, 0, 40, 0],
        table: {
          widths: [465],
          heights: ["auto", 150],

          body: [
            [
              {
                text: i18nFilter("_report_points_to_improve_") + ":",
                color: pdf_data.colour_2,
                fontSize: 14,
                border: [true, true, true, false],
                bold: true,
                font:
                  pdf_data.style && pdf_data.style == "proxani"
                    ? "Merriweather"
                    : "Arial",
              },
            ],
            [
              {
                text: pdf_data.points_to_improve,
                color: pdf_data.colour_text,
                fontSize: 12,
                border: [true, false, true, true],
                height: 150,
                width: 465,
                font:
                  pdf_data.style && pdf_data.style == "proxani"
                    ? "Montserrat"
                    : "Arial",
              },
            ],
          ],
        },
        layout: {
          hLineColor: pdf_data.colour_1,
          vLineColor: pdf_data.colour_1,
        },
      };

      if (
        pdf_data.style &&
        (pdf_data.style == "aveve" || pdf_data.style == "proxani")
      ) {
        dd.content.splice(0, 2);

        if (pdf_data.include_positive_points) {
          dd.content.push(p_points);
        }

        if (pdf_data.include_points_to_improve) {
          if (pdf_data.include_positive_points) {
            i_points.pageBreak = "after";
          }

          dd.content.push(i_points);
        }
      } else {
        dd.content.push(p_points, i_points);
      }

      if (
        pdf_data.style &&
        (pdf_data.style == "aveve" || pdf_data.style == "proxani")
      ) {
        if (
          !pdf_data.include_points_to_improve ||
          !pdf_data.include_positive_points
        ) {
          c++;
        }

        for (var i = 0; i < pdf_data.dashboards.length; i++) {
          var table = {
            margin:
              pdf_data.style &&
              (pdf_data.style == "proxani")
                ? [10, 10, 10, 10]
                : [10, 30, 10, 10],
            table: {
              dontBreakRows: true,
              widths: ["*"],

              body: [
                [
                  {
                    image: pdf_data.dashboards[i].image,
                    width: 500,
                    border: [true, true, true, true],
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: pdf_data.dashboards[i].comment
                      ? pdf_data.dashboards[i].comment
                      : "",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 5],
                    fontSize: 10,
                    bold: false,
                    font:
                      pdf_data.style && pdf_data.style == "proxani"
                        ? "Montserrat"
                        : "Arial",
                    color: pdf_data.colour_text,
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdf_data.colour_1,
              vLineColor: pdf_data.colour_1,
            },
          };
          if (
            pdf_data.dashboards[i].selected &&
            pdf_data.dashboards[i].image_loaded &&
            pdf_data.dashboards[i].image
          ) {
            c++;
            s++;
            if (c != 0 && c % 2 == 0) {
              table.pageBreak = "after";
            }
            dd.content.push(table);
          }
        }

        if (dd.content[dd.content.length - 1].pageBreak) {
          delete dd.content[dd.content.length - 1].pageBreak;
        }
      } else {
        for (var i = 0; i < pdf_data.dashboards.length; i++) {
          var table = {
            margin: [10, 10, 10, 5],
            table: {
              dontBreakRows: true,
              widths: ["*"],

              body: [
                [
                  {
                    image: pdf_data.dashboards[i].image,
                    width: 500,
                    border: [true, true, true, true],
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: pdf_data.dashboards[i].comment
                      ? pdf_data.dashboards[i].comment
                      : "",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 5],
                    fontSize: 10,
                    bold: false,
                    font:
                      pdf_data.style && pdf_data.style == "proxani"
                        ? "Montserrat"
                        : "Arial",
                    color: pdf_data.colour_text,
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdf_data.colour_1,
              vLineColor: pdf_data.colour_1,
            },
          };
          if (
            pdf_data.dashboards[i].selected &&
            pdf_data.dashboards[i].image_loaded &&
            pdf_data.dashboards[i].image
          ) {
            c++;
            s++;
            if (
              pdf_data.dashboards[i].id == "Zoetisflowchart" ||
              pdf_data.dashboards[i].id == "ZoetisFlussdiagramm" ||
              pdf_data.dashboards[i].id == "GraphiquedeZoetis"
            ) {
              c = 0;
              table.pageBreak = "after";
            }
            if (c != 0 && c % 2 == 0) {
              table.pageBreak = "after";
            }
            dd.content.push(table);
          }
        }
        if (s > 0) {
          dd.content[6].pageBreak = "after";
        }

        if (dd.content[dd.content.length - 1].pageBreak) {
          delete dd.content[dd.content.length - 1].pageBreak;
        }
      }

      return dd;
    }

    function setSession(url) {
      return $http
        .get(url, {
          withCredentials: true,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (response) {
          return response;
        });
    }

    function createPDF(pdfData) {
      var pdf_promise = $q.defer();

      var dd = this.generatePdfFile(pdfData);
      var report_name = "Report ".concat(
        $filter("date")(new Date(), "yyyy-MM-dd")
      );
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
        Merriweather: {
          normal: "Merriweather-Black.ttf",
          bold: "Merriweather-Black.ttf",
          italics: "Merriweather-Black.ttf",
          bolditalics: "Merriweather-Black.ttf",
        },
        Montserrat: {
          normal: "Montserrat-Medium.ttf",
          bold: "Montserrat-Medium.ttf",
          italics: "Montserrat-Medium.ttf",
          bolditalics: "Montserrat-Medium.ttf",
        },
      };

      var dd2 = angular.copy(dd);
      var pdf = pdfMake.createPdf(dd);

      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = report_name + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              pdf_promise.reject("_message_error_");
            }
          }
        } else {
          pdfMake.createPdf(dd).download(report_name);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          pdf_promise.reject("_report_create_popup_message_");
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(report_name);
        }, 500);
      }

      $timeout(function () {
        pdf_promise.resolve();
      }, 1000);

      return pdf_promise.promise;
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.dashboardsV2")
    .factory("herdDashboardsServiceV2", herdDashboardsService);
  /** @ngInject */
  function herdDashboardsService($http, $q, APP_CONSTANTS) {
    return {
      getDashboards: getDashboards,
      getDashboardById: getDashboardById,
      getTableauDashboards: getTableauDashboards,
      setTableauTenant: setTableauTenant,
      getHerdsByTeam: getHerdsByTeam,
      getReports: getReports,
      addToReport: addToReport,
      updateReportEntry: updateReportEntry,
      setSession: setSession,
      excludeUsers: excludeUsers,
      tableauStored: {},
    };

    function getDashboards(team_id) {
      return $http
        .get(APP_CONSTANTS.tableau_base_url + team_id + "/dashboards", {
          withCredentials: true,
          timeout: 13000,
        })
        .then(success)
        .catch(error);
    }

    function getDashboardById(team_id, dashboard_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url +
            team_id +
            "/dashboards/" +
            dashboard_id +
            suffix,
          {
            withCredentials: true,
          }
        )
        .then(success)
        .catch(error);
    }

    function getTableauDashboards(team_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url + team_id + "/dashboards" + suffix,
          {
            withCredentials: true,
            timeout: 13000,
          }
        )
        .then(success)
        .catch(error);
    }

    function setTableauTenant(team_id) {
      return $http
        .post(
          APP_CONSTANTS.tableau_base_url + team_id + "/session",
          {},
          { withCredentials: true }
        )
        .then(success)
        .catch(error);
    }

    function getHerdsByTeam(team_id) {
      return $http
        .get(APP_CONSTANTS.backoffice_base_url + "teams/" + team_id + "/herds")
        .then(success)
        .catch(error);
    }

    function getReports(suffix) {
      return $http
        .get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function updateReportEntry(id, obj) {
      return $http
        .put(
          APP_CONSTANTS.tableau_reports_base_url + "/reportentry/" + id,
          obj,
          {
            withCredentials: true,
          }
        )
        .then(success)
        .catch(error);
    }

    function addToReport(obj) {
      return $http
        .post(APP_CONSTANTS.tableau_reports_base_url + "/reportentry", obj, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function setSession(url) {
      return $http
        .get(url, {
          withCredentials: true,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (response) {
          return $q.reject(response);
        });
    }

    function excludeUsers(user) {
      var user_list = [
        "auth0|5acdfe8c2735d3736e8298fe",
        "auth0|5ad5dca65fb3bc1b6d7a3ebe",
        "auth0|5ad4605f3467830fef67091f",
		"auth0|604f46844b70b10070bfc294",
		"auth0|56b37779ec9cf8243c80f211",
		"google-oauth2|108831753800092786976",
		"google-oauth2|110442934239793747425"
      ];

      if (user_list.includes(user.user_id)) {
        return true;
      }

      return false;
    }

    function success(response) {
      return response.data;
    }

    function error(error) {
      return $q.reject(error);
    }
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboardsV2').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds")
    .controller("herdsDashboardsCtrl", herdsDashboardsCtrl);
  /** @ngInject */
  function herdsDashboardsCtrl(
    herdDashboardsService,
    $q,
    $timeout,
    $rootScope,
    $filter,
    $scope,
    $uibModal,
    $uibModalStack,
    permissionService,
    APP_CONSTANTS,
    rapService,
    $interval,
    toastr,
    $window,
    bugsnagService,
    dashboardsService,
    $cookies,
    Upload,
    $location
  ) {
    var vm = this;
    var searchTimer;
    var herdSelectedTimer;
    var i18nFilter = $filter("i18n");
    vm.selectGroup = selectGroup;
    vm.selectDashboard = selectDashboard;
    vm.goBackToDashboard = goBackToDashboard;
    vm.getLabelId = getLabelId;
    vm.search = search;
    vm.setButtonColor = setButtonColor;
    vm.getBtnClass = getBtnClass;
    vm.categorySelected = categorySelected;
    vm.getTableClass = getTableClass;
    vm.closeModal = closeModal;
    vm.customTimeSelected = customTimeSelected;
    vm.timeSelectorChanged = timeSelectorChanged;
    vm.getCurrentUserClass = getCurrentUserClass;
    vm.openAddToReportModal = openAddToReportModal;
    vm.addToReport = addToReport;
    vm.openCreateReport = openCreateReport;
    vm.openReportDashboardPeriodModal = openReportDashboardPeriodModal;
    vm.setReportDashboardRange = setReportDashboardRange;
    vm.setReportData = setReportData;
    vm.closeCreateReport = closeCreateReport;
    vm.setReportDashboardComment = setReportDashboardComment;
    vm.init = init;
    vm.reload = reload;
    vm.goBack = goBack;
    vm.openReportCommentModal = openReportCommentModal;
    vm.setReportDate = setReportDate;
    vm.selectLayout = selectLayout;
    vm.getDashboardClass = getDashboardClass;
    vm.goBackOnClose = goBackOnClose;
    vm.sendErrorInfo = sendErrorInfo;
    var tableauPromise;
    var viz;
    var viewDataDashboardName;
    var viewDataDashboardName2;
    var dataDashboardSheetName;
    var dataDashboardSheetName2;
    var kpiTableName;
    var measureNameParam;
    var herdParamName;
    var herdsPromise;
    var addToReportPromise;
    var dashboardsPromise;
    var parityFilter;
    var vwpFilterName;
    var afiFilterName;
    var DIMCategoryName;
    var cowSccName;
    var heiferSccName;
    var parityCategoriesName;
    var DIMCategoriesName;
    var SCCLNName;
    var animalContributionName;
    var numberOfCowsName;
    var linerTypeName;
    var numberOfClustersName;
    var dailyMilkingsName;
    var dateLastLinerChangeName;
    var excludeEarlyDIMName;
    var dashboardsFilterPairs = APP_CONSTANTS.constants.dashboardsFilterPairs;
    var loadingDotsCounter = 0;
    var loadingDotsInterval;
    var promiseTimeout;
    var milkmeterdashboard;
    var mrodashboard;
    var lastMilkYieldBeforeDryOffDate;
    var firstMilkYieldByCalvingDate;
    var lastInsPosCheckFilterName;
    var selectKPIParamName;
    var worksheetParamName;
    vm.searchDescriptionString = "";
    vm.searchTypeString = "";
    vm.searchCategoryString = "";
    vm.hideTiles = true;
    vm.activeCategory = null;
    vm.activeCategoryName = null;
    vm.tableauError = false;
    vm.errorLoadingReports = false;
    vm.work_locally = false;
    vm.hideAddToReportButton = false;

    init();

    function init() {
      localStorage.removeItem("dashboards-table");
      setStrings();
      //time selector
      // 7 - 7 days
      // 30 - 30 days
      // 1 - 1 year
      // 69 - custom
      // 90 - 90 days
      vm.selectedTime = 1;
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
          .toISOString()
      );

      vm.itemsToShow = [
        {
          label: "10",
          value: 10,
        },
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "All",
          value: 999999,
        },
      ];
      vm.itemsPerPage = vm.itemsToShow[2];
      vm.loadingBaseTable = true;
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
      if (vm.defaultValues.team_id) {
        vm.selectedTeam = vm.defaultValues.team_id;
      }
      if (vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }
      vm.allCategories = [
        {
          name: "_dc_production_",
          id: "production",
          permission: 9,
        },
        {
          name: "_dc_reproduction_",
          id: "reproduction",
          permission: 10,
        },
        {
          name: "_dc_udder_health_",
          id: "udder_health",
          permission: 8,
        },
        {
          name: "_dc_hoof_health_",
          id: "hoof_health",
          permission: 8,
        },
        {
          name: "_dc_herd_characteristics_",
          id: "herd_characteristics",
        },
        {
          name: "_dc_comments_",
          id: "comments",
          permission: 6,
        },
        {
          name: "_dc_environmental_",
          id: "environment",
          permission: 7,
        },
        {
          name: "_dc_genetics_",
          id: "genetics",
        },
        {
          name: "_dc_other_",
          id: "other",
        },
      ];
      vm.currentUserType = permissionService.getDashboardsType();
      if (vm.currentUserType == "zoetis" || vm.currentUserType == "admin") {
        vm.hideTiles = false;
      }
      if (vm.currentUserType == "zoetis" && !vm.hideTiles) {
        if (!herdDashboardsService.excludeUsers(vm.user)) {
          try {
            gtag("event", "zoetis-dashboards", {
              user_id: vm.user.user_id,
            });
          } catch (error) {
            console.log(error);
          }
        }
        vm.selectedLayout = 2;
      } else {
        vm.selectedLayout = 1;
      }
      for (var i = 0; i < vm.allCategories.length; i++) {
        vm.allCategories[i].name = i18nFilter(vm.allCategories[i].name);
      }
      if (vm.defaultValues && vm.defaultValues.team_id) {
        tableauPromise = $q.defer();

        getTableauDashboards(vm.defaultValues.team_id);
        setResolveAll();
      }
      vm.showBaseTable = true;
      vm.showFrame = false;
    }

    function setStrings() {
      parityFilter = i18nFilter("_dashboard_name_filter_parity_");
      vwpFilterName = i18nFilter("_dashboards_parameter_vwp_");
      viewDataDashboardName = i18nFilter("_mastitis_view_data_");
      viewDataDashboardName2 = viewDataDashboardName + " (2)";
      dataDashboardSheetName = i18nFilter("_mastitis_view_data_table_");
      dataDashboardSheetName2 = dataDashboardSheetName + " (2)";
      kpiTableName = "KPI worksheet for mastits per lactation period";
      measureNameParam = "Measure name parameter";
      herdParamName = "Herd Parameter";
      afiFilterName = i18nFilter("_dashboards_parameter_afi_target_");
      DIMCategoryName = i18nFilter("_dashboard_name_parameter_dim_category_");
      cowSccName = i18nFilter("_dashboards_parameter_cow_scc_treshold_");
      heiferSccName = i18nFilter("_dashboards_parameter_heifer_scc_treshold_");
      parityCategoriesName = i18nFilter(
        "_dashboards_parameter_parity_categories_"
      );
      DIMCategoriesName = i18nFilter("_dashboards_parameter_dim_categories_");
      SCCLNName = i18nFilter("_dashboards_parameter_scc_ln_");
      animalContributionName = i18nFilter(
        "_dashboards_parameter_animal_contribution_"
      );
      numberOfCowsName = i18nFilter("_dashboards_parameter_number_of_cows_");
      linerTypeName = i18nFilter("_dashboards_parameter_liner_types_");
      numberOfClustersName = i18nFilter(
        "_dashboards_parameter_number_of_clusters_"
      );
      dailyMilkingsName = i18nFilter("_dashboards_parameter_daily_milkings_");
      dateLastLinerChangeName = i18nFilter(
        "_dashboards_parameter_last_liner_change_"
      );
      excludeEarlyDIMName = "Exclude early DIM";
      milkmeterdashboard = i18nFilter("_z_milk_meter_dashboard_");
      lastMilkYieldBeforeDryOffDate = i18nFilter(
        "_z_last_milk_yield_before_dry_off_date_"
      );
      firstMilkYieldByCalvingDate = i18nFilter(
        "_z_first_milk_yield_by_calving_date_"
      );
      mrodashboard = i18nFilter("_z_milk_recording_dashboard_");
      lastInsPosCheckFilterName = i18nFilter(
        "_dashboard_filter_name_last_positive_preg_"
      );
      selectKPIParamName = i18nFilter("_dashboards_parameter_select_kpi_");
      //selectKPIParamName = 'Select KPI';
      worksheetParamName = "worksheetParam";
    }

    function setResolveAll() {
      $q.all([tableauPromise.promise])
        .then(function () {
          vm.dashboards = [];
          vm.dashboards = vm.dashboards.concat(vm.tableauDashboards);
          vm.dashboards = setCategories(vm.dashboards);
          vm.dashboards = setSubCategories(vm.dashboards);
          vm.dashboardsSafe = vm.dashboards;
          vm.allDashboards = vm.dashboards;
          if (vm.activeCategory) {
            vm.dashboardsFiltered = filterByCategory(vm.activeCategoryObject);
          }
          filterList(vm.searchString);
          if (vm.lastUsedDashboard) {
            var found;
            for (var i = 0; i < vm.allDashboards.length; i++) {
              if (vm.allDashboards[i].id == vm.lastUsedDashboard.id) {
                found = true;
                break;
              }
            }
            if (found) {
              vm.showFrame = false;
              vm.loadingBaseTable = true;
              selectDashboard(
                vm.lastUsedDashboard,
                vm.lastUsedDashboardType,
                true
              );
            }
          }
          vm.loadingError = false;
          vm.loadingBaseTable = false;
        })
        .catch(function (error) {
          bugsnagService.logUnhandledError(error);
          vm.loadingBaseTable = false;
          vm.loadingError = true;
        });
    }

    function setCategories(dashboards) {
      var udder_health_index;
      var hoof_health_index;
      for (var i = 0; i < vm.allCategories.length; i++) {
        if (vm.allCategories[i].id == "udder_health") {
          var udder_health_index = i;
        }

        if (vm.allCategories[i].id == "hoof_health") {
          var hoof_health_index = i;
        }
      }

      for (var i = 0; i < dashboards.length; i++) {
        dashboards[i].position = i;
        for (var j = 0; j < vm.allCategories.length; j++) {
          if (dashboards[i].category == vm.allCategories[j].id) {
            vm.allCategories[j].used = true;
            dashboards[i].category = vm.allCategories[j];
            break;
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name && dashboards[i].subcategory) {
          if (
            (dashboards[i].subcategory.indexOf("udder") !== -1 &&
              dashboards[i].subcategory.indexOf("health") !== -1) ||
            (dashboards[i].subcategory.indexOf("cows") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1) ||
            (dashboards[i].subcategory.indexOf("subclinical") !== -1 &&
              dashboards[i].subcategory.indexOf("mastitis") !== -1)
          ) {
            vm.allCategories[udder_health_index].used = true;
            dashboards[i].category = vm.allCategories[udder_health_index];
          } else if (
            dashboards[i].subcategory.indexOf("cows") !== -1 &&
            dashboards[i].subcategory.indexOf("hoof") !== -1
          ) {
            vm.allCategories[hoof_health_index].used = true;
            dashboards[i].category = vm.allCategories[hoof_health_index];
          }
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (!dashboards[i].category.name) {
          var category = {
            name: dashboards[i].category,
            id: dashboards[i].category,
          };
          dashboards[i].category = category;
        }
      }
      return dashboards;
    }

    function setSubCategories(dashboards) {
      for (var i = 0; i < dashboards.length; i++) {
        if (
          dashboards[i].subcategory == "zoetis" ||
          dashboards[i].subcategory == "zoetis-flowchart" ||
          dashboards[i].subcategory == "cows-mastitis-list" ||
          dashboards[i].subcategory == "subclinical-mastitis-list"
        ) {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_zoetis_");
        }
        if (dashboards[i].subcategory == "cows") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_cows_");
        }

        if (dashboards[i].subcategory == "youngstock") {
          dashboards[i].category = angular.copy(dashboards[i].category);
          dashboards[i].category.name += "-" + i18nFilter("_ds_youngstock_");
        }
      }

      return dashboards;
    }

    function getTableauDashboards(team_id) {
      if (vm.work_locally) {
        var dashboards = [];
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        handleResponse(dashboards, vm.currentUserType);
      } else {
        return herdDashboardsService
          .setTableauTenant(team_id)
          .then(function () {
            if (
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(vm.currentUserType);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                handleResponse(dashboards, vm.currentUserType);
              }
            } else {
              useAPI(vm.currentUserType);
            }
          })
          .catch(function (error) {
            tableauPromise.reject();
          });
      }

      function useAPI(user_type) {
        if (localStorage.getItem("tableauLoading")) {
          $scope.$on("tableau_loaded", function () {
            $timeout(function () {
              var response = [];
              angular.copy(
                dashboardsService.loadedDashboards.dashboards,
                response
              );
              handleResponse(response, user_type);
            }, 250);
          });
        } else {
          var tableauSuffix = "?locale=" + vm.currentLng;
          return herdDashboardsService
            .getTableauDashboards(team_id, tableauSuffix)
            .then(function (response) {
              if (vm.selectedTeam == 3091) {
                var list = [
                  {
                    dev: true,
                    id: "Milkyieldanalysisovertime",
                    description: "Milk yield analysis over time",
                    category: "production",
                    subcategory: "milk-recording-story",
                    locale: "en-GB",
                    url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Milkyieldanalysisovertime?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
                  },
                  {
                    dev: true,
                    id: "Milkcomponentanalysis",
                    description: "Milk component analysis",
                    category: "production",
                    subcategory: "milk-recording-story",
                    locale: "en-GB",
                    url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Milkcomponentanalysis?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
                  },
                  {
                    dev: true,
                    id: "Lactationcurveanalysis",
                    description: "Lactation curve analysis",
                    category: "production",
                    subcategory: "milk-recording-story",
                    locale: "en-GB",
                    url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Lactationcurveanalysis?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
                  },
                  {
                    dev: true,
                    id: "Geneticanalysisovertime",
                    description: "Genetic analysis overtime",
                    category: "production",
                    subcategory: "milk-recording-story",
                    locale: "en-GB",
                    url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Geneticanalysisovertime?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
                  },
                  {
                    dev: true,
                    id: "Geneticresponse",
                    description: "Genetic response",
                    category: "production",
                    subcategory: "milk-recording-story",
                    locale: "en-GB",
                    url: "https://visual-stg.mmmooogle.com/t/Development/views/team-3091-production-milk-recording-story/Geneticresponse?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no",
                  },
                ];
                response = response.concat(list);
              }

              var obj = {
                dashboards: response,
                expires: moment().add(30, "minutes").format(),
                team_id: team_id,
                lng: vm.currentLng,
              };
              dashboardsService.loadedDashboards = obj;
              handleResponse(response, user_type);
            })
            .catch(function (error) {
              console.log(error);
              vm.tableauDashboards = [];
              vm.tableauError = true;
              tableauPromise.reject();
            });
        }
      }

      function handleResponse(response, user_type) {
        var list = [];
        if (user_type == "zoetis") {
          for (var i = 0; i < response.length; i++) {
            if (
              (response[i].category == "reproduction" &&
                (response[i].subcategory == "zoetis" ||
                  response[i].subcategory == "zoetis-flowchart")) ||
              (response[i].category == "health" &&
                response[i].subcategory == "cows-mastitis-list") ||
              (response[i].category == "health" &&
                response[i].subcategory == "subclinical-mastitis-list") ||
              (response[i].category == "production" &&
                response[i].subcategory == "milk-recording-story") ||
              (response[i].category == "production" &&
                response[i].subcategory == "feed-list") ||
              (response[i].category == "production" &&
                (response[i].id == milkmeterdashboard ||
                  response[i].id == mrodashboard)) ||
              response[i].subcategory == "milk-meter-first"
            ) {
              response[i].title = response[i].description;
              list.push(response[i]);
            }
          }
          list = orderZoetisDashboards(list);
        } else if (user_type == "ff") {
          for (var i = 0; i < response.length; i++) {
            if (
              response[i].category != "plus" &&
              response[i].subcategory == "rap-fame-v3"
            ) {
              response[i].title = response[i].description;
              list.push(response[i]);
            }
          }
          list = $filter("orderBy")(list, "description");
        } else {
          for (var i = 0; i < response.length; i++) {
            if (
              response[i].category != "plus" &&
              response[i].subcategory != "rap-fame-v3"
            ) {
              response[i].title = response[i].description;
              list.push(response[i]);
            }
          }
          list = $filter("orderBy")(list, "description");
        }
        var dash = [];
        for (var j = 0; j < list.length; j++) {
          var addToReport = canBeAddedToReport(list[j]);
          var temp = {
            title: list[j].title,
            type: "tableau",
            category: list[j].category,
            id: list[j].id,
            url: list[j].url,
            subcategory: list[j].subcategory,
            addToReport: addToReport,
            thumbnail: setDashboardThumbnail(addToReport, list[j]),
            infoLink: setInfoLink(list[j]),
            dev: list[j].dev,
          };
          dash.push(temp);
        }
        //setDashboardThumbnails(dash);
        vm.tableauDashboards = dash;
        tableauPromise.resolve();
      }
    }

    function canBeAddedToReport(dashboard) {
      var canBeAdded = false;
      if (
        ((dashboard.subcategory == "zoetis" ||
          dashboard.subcategory == "zoetis-flowchart" ||
          dashboard.subcategory == "cows-mastitis-list" ||
          dashboard.subcategory == "subclinical-mastitis-list") &&
          dashboard.subcategory == "milk-meter-first" ||
          (dashboard.id == i18nFilter("_z_mastitis_cases_per_month_") ||
            dashboard.id ==
              i18nFilter("_z_mastitis_cases_per_month_after_calving_") ||
            dashboard.id == i18nFilter("_z_mastitis_cases_per_lactation_n_") ||
            dashboard.id == i18nFilter("_z_mastitis_cases_per_quarters_") ||
            dashboard.id == i18nFilter("_z_mastitis_recurrent_") ||
            dashboard.id == i18nFilter("_z_mastitis_cases_per_production_") ||
            dashboard.id == i18nFilter("_z_mastitis_open_cows_") ||
            dashboard.id == i18nFilter("_z_zoetis_flow_chart_") ||
            dashboard.id == i18nFilter("_z_insemination_strategy_cows_") ||
            dashboard.id == i18nFilter("_z_conception_rate_cows_") ||
            dashboard.id == i18nFilter("_z_sire_strategy_cows_") ||
            dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
            dashboard.id == i18nFilter("_z_oestrus_interval_analysis_") ||
            dashboard.id == i18nFilter("_z_insemination_strategy_heifers_") ||
            dashboard.id == i18nFilter("_z_conception_strategy_heifers_") ||
            dashboard.id ==
              i18nFilter("_z_conception_cusum_analysis_heifers_") ||
            dashboard.id == i18nFilter("_z_somatic_cell_count_over_time_") ||
            dashboard.id ==
              i18nFilter("_z_general_subclinical_table_overview_") ||
            dashboard.id == i18nFilter("_z_subclinical_mastitis_analysis_") ||
            dashboard.id ==
              i18nFilter("_z_subclinical_mastitis_overview_over_time_") ||
            dashboard.id == i18nFilter("_z_dry_period_cure_rate_") ||
            dashboard.id == i18nFilter("_z_dry_period_new_infection_rate_") ||
            dashboard.id == i18nFilter("_z_transition_cow_infection_rate_") ||
            dashboard.id == i18nFilter("_z_lactation_new_infection_rate_") ||
            dashboard.id ==
              i18nFilter("_z_infection_rate_long_term_evolution_") ||
            dashboard.id == i18nFilter("_z_general_cell_count_dashboard_") ||
            dashboard.id ==
              i18nFilter("_z_milk_yield_by_lactation_infection_rate_") ||
            dashboard.id == i18nFilter("_z_liner_change_") ||
            dashboard.id == i18nFilter("_z_cell_count_manager_") ||
            dashboard.id == i18nFilter("_z_lact_curve_analysis_bcd_") ||
            dashboard.id == i18nFilter("_z_lact_curve_analysis_bmrd_") ||
            dashboard.id ==
              i18nFilter("_z_dry_period_new_infection_rate_over_time_") ||
            dashboard.id == i18nFilter("_z_dry_period_cure_rate_over_time_") ||
            dashboard.id ==
              i18nFilter("_z_dry_period_cell_count_evaluation_") ||
            dashboard.id ==
              i18nFilter(
                "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
              ) ||
            dashboard.id == i18nFilter("_z_new_infections_over_time_")||
            dashboard.id == i18nFilter("_z_last_milk_yield_before_dry_off_date_")||
            dashboard.id == i18nFilter("_z_first_milk_yield_by_calving_date_"))) ||
        dashboard.id == i18nFilter("_z_milk_meter_dashboard_") ||
        dashboard.id == i18nFilter("_z_milk_recording_dashboard_")
      ) {
        canBeAdded = true;
      }
      return canBeAdded;
    }

    function setDashboardThumbnail(zoetis, dashboard) {
      var thumb;
      switch (dashboard.id) {
        case i18nFilter("_z_zoetis_flow_chart_"):
          thumb = "assets/img/thumbnails/zoetis_flowchart.png";
          break;
        case i18nFilter("_z_insemination_strategy_cows_"):
          thumb = "assets/img/thumbnails/insemination_strategy_cows.png";
          break;
        case i18nFilter("_z_conception_rate_cows_"):
          thumb = "assets/img/thumbnails/conception_rate_cows.png";
          break;
        case i18nFilter("_z_sire_strategy_cows_"):
          thumb = "assets/img/thumbnails/sire_strategy_cows.png";
          break;
        case i18nFilter("_z_conception_cusum_analysis_"):
          thumb = "assets/img/thumbnails/conception_cusum_analysis.png";
          break;
        case i18nFilter("_z_oestrus_interval_analysis_"):
          thumb = "assets/img/thumbnails/oestrus_interval_analysis.png";
          break;
        case i18nFilter("_z_insemination_strategy_heifers_"):
          thumb = "assets/img/thumbnails/insemination_strategy_heifers.png";
          break;
        case i18nFilter("_z_conception_strategy_heifers_"):
          thumb = "assets/img/thumbnails/conception_strategy_heifers.png";
          break;
        case i18nFilter("_z_mastitis_cases_per_month_"):
          thumb = "assets/img/thumbnails/n_cm_month.png";
          break;
        case i18nFilter("_z_mastitis_cases_per_month_after_calving_"):
          thumb = "assets/img/thumbnails/n_cm_month_after_calving.png";
          break;
        case i18nFilter("_z_mastitis_cases_per_lactation_n_"):
          thumb = "assets/img/thumbnails/n_cm_lactation_n.png";
          break;
        case i18nFilter("_z_mastitis_cases_per_quarters_"):
          thumb = "assets/img/thumbnails/n_cm_quarters.png";
          break;
        case i18nFilter("_z_mastitis_recurrent_"):
          thumb = "assets/img/thumbnails/n_cm_recurrent.png";
          break;
        case i18nFilter("_z_mastitis_cases_per_production_"):
          thumb = "assets/img/thumbnails/n_cm_production.png";
          break;
        case i18nFilter("_z_mastitis_open_cows_"):
          thumb = "assets/img/thumbnails/open_cows.png";
          break;
        case i18nFilter("_z_conception_cusum_analysis_heifers_"):
          thumb = "assets/img/thumbnails/conception_cusum_analysis_heifers.png";
          break;
        case i18nFilter("_z_milk_meter_dashboard_"):
          thumb = "assets/img/thumbnails/milk_meter_dashboard.png";
          break;
        case i18nFilter("_z_milk_recording_dashboard_"):
          thumb = "assets/img/thumbnails/milk_recording_dashboard.png";
          break;
        case i18nFilter("_z_somatic_cell_count_over_time_"):
          thumb =
            "assets/img/thumbnails/somatic_cell_count_over_time_dashboard.png";
          break;
        case i18nFilter("_z_general_subclinical_table_overview_"):
          thumb =
            "assets/img/thumbnails/general_subclinical_table_overview.png";
          break;
        case i18nFilter("_z_new_infections_over_time_"):
          thumb = "assets/img/thumbnails/new_infections_over_time.png";
          break;
        case i18nFilter("_z_subclinical_mastitis_analysis_"):
          thumb = "assets/img/thumbnails/subclinical_mastitis_analysis.png";
          break;
        case i18nFilter("_z_subclinical_mastitis_overview_over_time_"):
          thumb =
            "assets/img/thumbnails/subclinical_mastitis_overview_over_time.png";
          break;
        case i18nFilter("_dashboard_id_deviation_by_ingredient_dashboard_"):
          thumb = "assets/img/thumbnails/deviationbyingredientdashboard.png";
          break;
        case i18nFilter("_dashboard_id_deviation_by_day_of_week_dashboard_"):
          thumb = "assets/img/thumbnails/deviationbydayofweekdashboard.png";
          break;
        case i18nFilter("_dashboard_id_loading_schedule_dashboard_"):
          thumb = "assets/img/thumbnails/loadingscheduledashboard.png";
          break;
        case i18nFilter(
          "_dashboard_id_ingredients_loaded_over_time_total_dashboard_"
        ):
          thumb =
            "assets/img/thumbnails/ingredientsloadedovertimetotaldashboard.png";
          break;
        case i18nFilter(
          "_dashboard_id_dry_matter_intake_per_day_by_load_dashboard_"
        ):
          thumb =
            "assets/img/thumbnails/drymatterintakeperdaybyloaddashboard.png";
          break;
        case i18nFilter("_dashboard_id_total_amount_loaded_per_day_dashboard_"):
          thumb = "assets/img/thumbnails/totalamountloadedperdaydashboard.png";
          break;
        case i18nFilter("_dashboard_id_dropping_starts_dashboard_"):
          thumb = "assets/img/thumbnails/droppingstartsdashboard.png";
          break;
        case i18nFilter(
          "_dashboard_id_ingredients_loaded_over_time_per_pen_dashboard_"
        ):
          thumb =
            "assets/img/thumbnails/ingredientsloadedovertimeperpendashboard.png";
          break;
        case i18nFilter(
          "_dashboard_id_ingredients_dropped_over_time_per_pen_dashboard_"
        ):
          thumb =
            "assets/img/thumbnails/ingredientsdroppedovertimeperpendashboard.png";
          break;
        case i18nFilter("_dashboard_id_total_costs_per_day_dashboard_"):
          thumb = "assets/img/thumbnails/totalcostsperdaydashboard.png";
          break;
        case i18nFilter(
          "_dashboard_id_dry_matter_intake_per_cow_per_day_by_pen_dashboard_"
        ):
          thumb =
            "assets/img/thumbnails/drymatterintakepercowperdaybypendashboard.png";
          break;
        case i18nFilter("_z_dry_period_cure_rate_"):
          thumb = "assets/img/thumbnails/dry_period_cure_rate.png";
          break;
        case i18nFilter("_z_dry_period_new_infection_rate_"):
          thumb = "assets/img/thumbnails/dry_period_new_infection_rate.png";
          break;
        case i18nFilter("_z_transition_cow_infection_rate_"):
          thumb = "assets/img/thumbnails/transition_cow_infection_rate.png";
          break;
        case i18nFilter("_z_lactation_new_infection_rate_"):
          thumb = "assets/img/thumbnails/lactation_new_infection_rate.png";
          break;
        case i18nFilter("_z_infection_rate_long_term_evolution_"):
          thumb =
            "assets/img/thumbnails/infection_rate_long_term_evolution.png";
          break;
        case i18nFilter("_z_general_cell_count_dashboard_"):
          thumb = "assets/img/thumbnails/general_cell_count_dashboard.png";
          break;
        case i18nFilter("_z_milk_yield_by_lactation_infection_rate_"):
          thumb =
            "assets/img/thumbnails/milk_yield_by_lactation_infection_rate.png";
          break;
        case i18nFilter("_z_liner_change_"):
          thumb = "assets/img/thumbnails/liner_change_dashboard.png";
          break;
        case i18nFilter("_z_cell_count_manager_"):
          thumb = "assets/img/thumbnails/cell_count_manager_dashboard.png";
          break;
        case i18nFilter("_z_lact_curve_analysis_bmrd_"):
          thumb =
            "assets/img/thumbnails/lactation_curve_analysis_by_milk_recording_date.png";
          break;
        case i18nFilter("_z_lact_curve_analysis_bcd_"):
          thumb =
            "assets/img/thumbnails/lactation_curve_analysis_by_calving_date.png";
          break;
        case i18nFilter("_z_dry_period_new_infection_rate_over_time_"):
          thumb =
            "assets/img/thumbnails/dry_period_new_infection_rate_over_time_dashboard.png";
          break;
        case i18nFilter("_z_dry_period_cure_rate_over_time_"):
          thumb =
            "assets/img/thumbnails/dry_period_cure_rate_over_time_dashboard.png";
          break;
        case i18nFilter("_z_dry_period_cell_count_evaluation_"):
          thumb = "assets/img/thumbnails/dry_period_cell_count_evaluation.png";
          break;
        case i18nFilter(
          "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
        ):
          thumb =
            "assets/img/thumbnails/effect_of_cell_count_on_milk_yield_during_lactation.png";
          break;
        case i18nFilter("_z_last_milk_yield_before_dry_off_date_"):
          thumb =
            "assets/img/thumbnails/last_milk_yield_before_dry_off_date.png";
          break;
        case i18nFilter("_z_first_milk_yield_by_calving_date_"):
          thumb = "assets/img/thumbnails/first_milk_yield_by_calving_date.png";
          break;
        default:
          thumb = null;
          break;
      }

      return thumb;
    }

    function setInfoLink(dashboard) {
      var link = null;
      switch (dashboard.id) {
        case i18nFilter("_z_insemination_strategy_cows_"):
          link = "https://youtu.be/i5yJ55QNYzs";
          break;
        case i18nFilter("_z_insemination_strategy_heifers_"):
          link = "https://youtu.be/i5yJ55QNYzs";
          break;
        case i18nFilter("_z_oestrus_interval_analysis_"):
          link = "https://youtu.be/oOuEdhT64SI";
          break;
        case i18nFilter("_z_conception_cusum_analysis_heifers_"):
          link = "https://youtu.be/mVkoNdO2HCE";
          break;
        case i18nFilter("_z_conception_cusum_analysis_"):
          link = "https://youtu.be/mVkoNdO2HCE";
          break;
        case i18nFilter("_z_conception_rate_cows_"):
          link = "https://youtu.be/sGna5iXh1-o";
          break;
        case i18nFilter("_z_sire_strategy_cows_"):
          link = "https://youtu.be/N-4jjSZ_aIU";
          break;
        case i18nFilter("_z_subclinical_mastitis_analysis_"):
          link = "https://youtu.be/xSo98PZPpt8";
          break;
        case i18nFilter("_z_general_subclinical_table_overview_"):
          link = "https://youtu.be/xSo98PZPpt8?t=143";
          break;
        case i18nFilter("_z_new_infections_over_time_"):
          link = "https://youtu.be/xSo98PZPpt8?t=321";
          break;
        case i18nFilter("_z_somatic_cell_count_over_time_"):
          link = "https://youtu.be/xSo98PZPpt8?t=430";
          break;
        case i18nFilter("_z_subclinical_mastitis_overview_over_time_"):
          link = "https://youtu.be/xSo98PZPpt8?t=561";
          break;
        default:
          break;
      }
      return link;
    }

    function orderZoetisDashboards(list) {
      for (var i = 0; i < list.length; i++) {
        if (
          list[i].id == "Zoetisflowchart" ||
          list[i].id == "ZoetisFlussdiagramm" ||
          list[i].id == "GraphiquedeZoetis"
        ) {
          list[i].order = 1;
        } else if (
          list[i].id == "Inseminationstrategyincows" ||
          list[i].id == "Inseminatiestrategiebijkoeien" ||
          list[i].id == "Stratgiedinsminationpourlesvaches" ||
          list[i].id == "BesamungsstrategiebeiKhen"
        ) {
          list[i].order = 2;
        } else if (
          list[i].id == "Conceptionrateincows" ||
          list[i].id == "Drachtpercentagekoeien" ||
          list[i].id == "Conceptionrateincows" ||
          list[i].id == "Conceptionrateincows"
        ) {
          list[i].order = 3;
        } else if (
          list[i].id == "Sirestrategyincows" ||
          list[i].id == "Stiervaderstrategiebijkoeien" ||
          list[i].id == "Stratgieenmatiredereproducteurpourlesvaches" ||
          list[i].id == "ZuchtstrategiebeiKhen"
        ) {
          list[i].order = 4;
        } else if (
          list[i].id == "Conceptioncusumanalysis" ||
          list[i].id == "Drachtpercentagecusumanalyse" ||
          list[i].id == "AnalyseCUSUMdelaconception" ||
          list[i].id == "Conception-Cusum-Analyse"
        ) {
          list[i].order = 5;
        } else if (
          list[i].id == "Oestrusintervalanalysis" ||
          list[i].id == "Tochtintervalanalyse" ||
          list[i].id == "Analysedelintervalleentrelescyclesdovulation" ||
          list[i].id == "strusintervallanalyse"
        ) {
          list[i].order = 6;
        } else if (
          list[i].id == "Inseminationstrategyinheifers" ||
          list[i].id == "Inseminatiestrategiebijpinken" ||
          list[i].id == "Stratgiedinsminationpourlesgnisses" ||
          list[i].id == "BesamungsstrategiebeiFrsen"
        ) {
          list[i].order = 7;
        } else if (
          list[i].id == "Conceptionstrategyinheifers" ||
          list[i].id == "Drachtstrategiebijpinken" ||
          list[i].id == "Stratgiedeconceptionpourlesgnisses" ||
          list[i].id == "KonzeptionsstrategiebeiFrsen"
        ) {
          list[i].order = 8;
        } else if (
          list[i].id == "Opencowsdashboard" ||
          list[i].id == "Openkoeiendashboard"
        ) {
          list[i].order = 9;
        } else if (
          list[i].id == "Conceptioncusumanalysisheifers" ||
          list[i].id == "Drachtpercentagecusumanalysepinken" ||
          list[i].id == "Drachtpercentagecusumanalysepinken"
        ) {
          list[i].order = 10;
        } else {
          list[i].order = 99;
        }
      }
      var orderList = $filter("orderBy")(list, "order");
      return orderList;
    }

    function createLastWeekSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(7, "days")
      );
    }

    function createLastMonthSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(30, "days")
      );
    }

    function createLast90DaysSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(90, "days")
      );
    }

    function createLastYearSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(1, "years")
      );
    }

    function createLastTwoYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(2, "years")
      );
    }

    function createLastFiveYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(5, "years")
      );
    }

    function createLastTenYearsSuffix() {
      vm.end_date = new Date(
        moment().hour(12).minute(0).seconds(0).millisecond(0)
      );
      vm.start_date = new Date(
        moment()
          .hour(12)
          .minute(0)
          .seconds(0)
          .millisecond(0)
          .subtract(10, "years")
      );
    }

    function timeSelectorChanged(type) {
      if (type != 69) {
        vm.selectedTime = type;
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, false);
      } else {
        openModal("app/pages/herds/dashboards/custom.modal.html", "sm");
      }
    }

    function selectGroup(group_id) {
      if (group_id == "production") {
        vm.itemList = vm.production;
      } else if (group_id == "reproduction") {
        vm.itemList = vm.reproduction;
      } else if (group_id == "udder_health") {
        vm.itemList = vm.udder_health;
      } else if (group_id == "hoof_health") {
        vm.itemList = vm.hoof_health;
      } else if (group_id == "herd_characteristics") {
        vm.itemList = vm.herd_char;
      } else if (group_id == "comments") {
        vm.itemList = vm.comments;
      } else if (group_id == "environmental") {
        vm.itemList = vm.envirenmental;
      } else if (group_id == "genetics") {
        vm.itemList = vm.genetics;
      } else if (group_id == "other") {
        vm.itemList = vm.other;
      }
      vm.showDashboardTable = true;
      vm.showBaseTable = false;
      vm.showFrame = false;
    }

    function goBackToDashboard() {
      vm.activeCategory = null;
      vm.activeCategoryName = null;
      vm.activeCategoryObject = null;
      vm.showFrame = false;
      vm.showBaseTable = false;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
      $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
        vm.showBaseTable = true;
      }, 50);
    }

    function goBackOnClose() {
      setBackButtonVisibility(false);
      $rootScope.$broadcast("dashboard_deselect");
      if (vm.activeCategory) {
        vm.showFrame = false;
        vm.showBaseTable = true;
        vm.lastUsedDashboard = null;
        vm.lastUsedDashboardType = null;
        vm.embed = null;
        viz = null;
      } else {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    }

    function setDefaultValues(dashboard) {
      if (
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_")
      ) {
        vm.selectedTime = 69;
        createLastTwoYearsSuffix();
      } else {
        vm.selectedTime = 1;
      }
    }

    function selectDashboard(dashboard, type, set_default, selectedTime) {
      vm.loadingBaseTable = false;
      vm.errorLoading = false;
      vm.dashboardNotAvailable = false;
      vm.showAddToReportButton = false;
      if (set_default) {
        setDefaultValues(dashboard);
      }
      openDashboard(dashboard, type, selectedTime);
    }

    function openDashboard(dashboard, type, selectedTime) {
      if (selectedTime) {
        vm.selectedTime = selectedTime;
        setStartEndDate();
      }
      broadcastDashboard(dashboard);
      var isZoetisDashboard = getIsZoetisDashboard(dashboard);
      vm.lastUsedDashboard = dashboard;
      vm.lastUsedDashboardType = type;
      var dash = {};
      angular.copy(dashboard, dash);
      sendEvent(dashboard, isZoetisDashboard);
      embedPage(dash, isZoetisDashboard);
    }

    function setStartEndDate() {
      if (vm.selectedTime == 7) {
        createLastWeekSuffix();
      } else if (vm.selectedTime == 30) {
        createLastMonthSuffix();
      } else if (vm.selectedTime == 1) {
        createLastYearSuffix();
      } else if (vm.selectedTime == 90) {
        createLast90DaysSuffix();
      } else if (vm.selectedTime == 2) {
        createLastTwoYearsSuffix();
      } else if (vm.selectedTime == 5) {
        createLastFiveYearsSuffix();
      } else if (vm.selectedTime == 10) {
        createLastTenYearsSuffix();
      }
    }

    function embedPage(dashboard, isZoetis) {
      vm.isResponsive = checkIfIsResponsive(dashboard);
      sendShowPanicButtonEvent(false);
      var url = dashboard.url;
      var dev = dashboard.dev;
      if (vm.selectedTime == 69) {
        if (vm.work_locally) {
          embedUrl(url, false, isZoetis, dev);
        } else {
          embedUrl(url, true, isZoetis, dev);
        }
      } else {
        setStartEndDate();
        if (vm.work_locally) {
          embedUrl(url, false, isZoetis, dev);
        } else {
          embedUrl(url, true, isZoetis, dev);
        }
      }
    }

    function embedUrl(url, useTabvis, isZoetis, dev) {
      vm.showBaseTable = false;
      vm.showFrame = true;
      if (viz) {
        viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
        viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
        viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
        viz.dispose();
      }
      var herds;
      if (vm.selectedHerds.length > 0) {
        herds = angular.copy(vm.selectedHerds);
      } else {
        herds = [0];
      }
      if (useTabvis) {
        if (dev) {
          embed(url, herds, useTabvis, isZoetis);
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              vm.loadingDashboards = false;
              vm.showButtons = true;
              var url = response.headers("tabvis-location");
              embed(url, herds, useTabvis, isZoetis);
            })
            .catch(function (response) {
              if (response.status && response.status == 404) {
                vm.dashboardNotAvailable = true;
              }
              vm.embed = null;
              vm.errorLoading = true;
              vm.loading = false;

              console.log("error getting tabvis-location header");
            });
        }
      } else {
        var url ="https://visual-prd.mmmooogle.com/t/Production/views/team-3091-production-milk-meter-first_nl-NL_twb/Eerstemelkproductievolgenskalfdatum?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        //var url ="https://visual-prd.mmmooogle.com/t/Production/views/team-3091-production-milk-meter-first_en-GB_twb/Lastmilkyieldbeforedryoffdate?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        //var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-3091-health-subclinical-mastitis-list_en-GB_twb/Linerchangedashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';

        // team-3091-reproduction-zoetis_nl-NL_twb/Inseminatiestrategiebijkoeien
        // team-3091-reproduction-zoetis_en-GB_twb/Inseminationstrategyincows

        embed(url, herds, useTabvis, isZoetis);
      }
    }

    function embed(url, herds, useTabvis, isZoetis) {
      vm.hideAddToReportButton = false;
      var herdParam = createHerdParam(herds);
      if (vm.selectedHerds.length > 0) {
        url = url + getHerdSuffix();
      }

      var deviceType;
      var parser = new UAParser();
      var device = parser.getDevice();
      if (device && device.type) {
        if (device.type == "mobile") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else if (device.type == "tablet") {
          deviceType = "tablet";
        } else if (device.type == "smarttv") {
          deviceType = "desktop";
        } else if (device.type == "wearable") {
          //deviceType = 'phone';
          deviceType = "tablet";
        } else {
          //deviceType = 'phone';
          deviceType = "tablet";
        }
      } else {
        if (window.screen.height <= 900 || window.screen.width <= 1000) {
          deviceType = "tablet";
        } else {
          deviceType = "desktop";
        }
      }
      if (url) {
        var options = {
          device: deviceType,
          "Start Date": $filter("date")(vm.start_date, "yyyy-MM-dd"),
          "End Date": $filter("date")(vm.end_date, "yyyy-MM-dd"),
          onFirstInteractive: function () {
            /*viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                console.log(parameters);
              });*/

            var workbook = viz.getWorkbook();
            var sheetType = workbook.getActiveSheet().getSheetType();

            if (sheetType == "dashboard") {
              var wrks = workbook.getActiveSheet().getWorksheets();
              var activeSheet = workbook.getActiveSheet().getName();
              var worksheetName;
              for (var i = 0; i < wrks.length; i++) {
                if (wrks[i].getName()) {
                  worksheetName = wrks[i].getName();
                  break;
                }
              }

              /*viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(worksheetName)
                .getFiltersAsync()
                .then(function (filters) {
                  console.log(filters);
                  if (
                    activeSheet ==
                      "General subclinical table overview dashboard" ||
                    activeSheet == "Overzicht subklinische mastitis dashboard"
                  ) {
                    viz
                      .getWorkbook()
                      .getActiveSheet()
                      .getWorksheets()
                      .get("Subclinical mastitis overview")
                      .clearFilterAsync("DateFilter")
                      .then(function (response) {
                        viz
                          .getWorkbook()
                          .getActiveSheet()
                          .getWorksheets()
                          .get("Subclinical mastitis overview")
                          .applyFilterAsync(
                            "DateFilter",
                            "",
                            tableau.FilterUpdateType.ALL
                          );
                      });
                  }
                });*/

              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            } else {
              viz
                .getWorkbook()
                .changeParameterValueAsync(measureNameParam, "0");
              $timeout(function () {
                vm.showAddToReportButton = true;
                sendShowPanicButtonEvent(true);
              }, 50);
            }
          },
        };

        options[herdParamName] = herdParam;

        if (viz) {
          viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
          viz.removeEventListener(tableau.TableauEventName.MARKS_SELECTION);
          viz.removeEventListener(tableau.TableauEventName.STORY_POINT_SWITCH);
          viz.dispose();
        }
        $timeout(function () {
          var containerDiv = document.getElementById("frame");
          var flowChartDashboard = i18nFilter("_z_zoetis_flow_chart_");
          if (
            vm.lastUsedDashboard &&
            vm.lastUsedDashboard.id == flowChartDashboard &&
            containerDiv
          ) {
            var w = containerDiv.offsetWidth + "px";
            var h = containerDiv.offsetHeight + "px";
            options.width = w;
            options.height = h;
          }
          viz = new tableau.Viz(containerDiv, url, options);
          viz.addEventListener(
            tableau.TableauEventName.TAB_SWITCH,
            onTabSwitch
          );
          viz.addEventListener(
            tableau.TableauEventName.MARKS_SELECTION,
            onMarkSelection
          );
          viz.addEventListener(
            tableau.TableauEventName.STORY_POINT_SWITCH,
            onStoryPointChange
          );
        }, 1000);
      }
    }
    function checkIfIsResponsive(dashboard) {
      if (
        dashboard.id == $filter("i18n")("_z_somatic_cell_count_over_time_") ||
        dashboard.id ==
          $filter("i18n")("_z_general_subclinical_table_overview_") ||
        dashboard.id ==
          $filter("i18n")("_z_subclinical_mastitis_overview_over_time_") ||
        dashboard.id == $filter("i18n")("_z_new_infections_over_time_") ||
        dashboard.id == $filter("i18n")("_z_liner_change_") ||
        dashboard.id == $filter("i18n")("_z_cell_count_manager_") ||
        dashboard.id ==
          $filter("i18n")(
            "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
          )
      ) {
        return true;
      }
      return false;
    }

    function sendEvent(dashboard, isZoetis) {
      if (
        isZoetis ||
        dashboard.id == i18nFilter("_z_milk_meter_dashboard_") ||
        dashboard.id == i18nFilter("_z_milk_recording_dashboard_") ||
        dashboard.id == i18nFilter("_z_zoetis_flow_chart_")
      ) {
        var event_name;
        switch (dashboard.id) {
          case i18nFilter("_z_zoetis_flow_chart_"):
            event_name = "dashboard|Zoetis flowchart";
            break;
          case i18nFilter("_z_insemination_strategy_cows_"):
            event_name = "dashboard|Insemination strategy in cows";
            break;
          case i18nFilter("_z_conception_rate_cows_"):
            event_name = "dashboard|Conception rate in cows";
            break;
          case i18nFilter("_z_sire_strategy_cows_"):
            event_name = "dashboard|Sire strategy in cows";
            break;
          case i18nFilter("_z_conception_cusum_analysis_"):
            event_name = "dashboard|Conception cusum analysis";
            break;
          case i18nFilter("_z_oestrus_interval_analysis_"):
            event_name = "dashboard|Oestrus interval analysis";
            break;
          case i18nFilter("_z_insemination_strategy_heifers_"):
            event_name = "dashboard|Insemination strategy in heifers";
            break;
          case i18nFilter("_z_conception_strategy_heifers_"):
            event_name = "dashboard|Conception strategy in heifers";
            break;
          case i18nFilter("_z_mastitis_cases_per_month_"):
            event_name =
              "dashboard|Number of Clinical Mastitis cases per month";
            break;
          case i18nFilter("_z_mastitis_cases_per_month_after_calving_"):
            event_name =
              "dashboard|Number of Clinical Mastitis cases per month after calving";
            break;
          case i18nFilter("_z_mastitis_cases_per_lactation_n_"):
            event_name =
              "dashboard|Number of Clinical Mastitis cases per lactation number";
            break;
          case i18nFilter("_z_mastitis_cases_per_quarters_"):
            event_name =
              "dashboard|Number of Clinical Mastitis cases per quarters";
            break;
          case i18nFilter("_z_mastitis_recurrent_"):
            event_name =
              "dashboard|Number of cows with recurrent Clinical Mastitis cases";
            break;
          case i18nFilter("_z_mastitis_cases_per_production_"):
            event_name =
              "dashboard|Number of Clinical Mastitis cases per production levels";
            break;
          case i18nFilter("_z_mastitis_open_cows_"):
            event_name = "dashboard|Open cows";
            break;
          case i18nFilter("_z_conception_cusum_analysis_heifers_"):
            event_name = "dashboard|Conception cusum analysis heifers";
            break;
          case i18nFilter("_z_milk_meter_dashboard_"):
            event_name = "dashboard|Milk meter dashboard";
            break;
          case i18nFilter("_z_milk_recording_dashboard_"):
            event_name = "dashboard|Milk recording dashboard";
            break;
          case i18nFilter("_z_somatic_cell_count_over_time_"):
            event_name = "dashboard|Somatic cell count over time dashboard";
            break;
          case i18nFilter("_z_general_subclinical_table_overview_"):
            event_name =
              "dashboard|General subclinical table overview dashboard";
            break;
          case i18nFilter("_z_new_infections_over_time_"):
            event_name = "dashboard|New infections over time dashboard";
            break;
          case i18nFilter("_z_subclinical_mastitis_analysis_"):
            event_name = "dashboard|Subclinical mastitis analysis";
            break;
          case i18nFilter("_z_subclinical_mastitis_overview_over_time_"):
            event_name =
              "dashboard|Subclinical mastitis overview over time dashboard";
            break;
          case i18nFilter("_z_liner_change_"):
            event_name = "dashboard|Liner change dashboard";
            break;
          case i18nFilter("_z_cell_count_manager_"):
            event_name = "dashboard|Cell count manager dashboard";
            break;
          case i18nFilter("_z_dry_period_new_infection_rate_over_time_"):
            event_name =
              "dashboard|Dry period new infection rate over time dashboard";
            break;
          case i18nFilter("_z_dry_period_cure_rate_over_time_"):
            event_name = "dashboard|Dry period cure rate over time dashboard";
            break;
          case i18nFilter("_z_dry_period_cell_count_evaluation_"):
            event_name = "dashboard|Dry period cell count evaluation";
            break;
          case i18nFilter(
            "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
          ):
            event_name =
              "dashboard|Effect of cell count on milk yield during lactation";
            break;
          case i18nFilter("_z_last_milk_yield_before_dry_off_date_"):
            event_name = "dashboard|Last milk yield before dry off date";
            break;
          case i18nFilter("_z_first_milk_yield_by_calving_date_"):
            event_name = "dashboard|First milk yield by calving date";
            break;
          default:
            break;
        }

        if (
          vm.currentUserType == "zoetis" &&
          !herdDashboardsService.excludeUsers(vm.user)
        ) {
          try {
            gtag("event", event_name);
          } catch (error) {
            console.log(error);
          }
        }
      }
    }

    function createHerdParam(herds) {
      if (vm.selectedHerds.length == 0) {
        return 0;
      }
      var herdsString = "";

      for (var i = 0; i < herds.length; i++) {
        if (i == 0) {
          herdsString += herds[i];
        } else {
          herdsString += " " + herds[i];
        }
      }
      return herdsString;
    }

    function onMarkSelection(event) {
      vm.lastSelectedMark = event.getWorksheet().getName();
    }

    function onTabSwitch(marksEvent) {
      vm.hideAddToReportButton = false;
      var activeSheet = marksEvent.getViz().getWorkbook().getActiveSheet();
      var sheetType = activeSheet.getSheetType();
      var oldSheetName = marksEvent.getOldSheetName();
      var newSheetName = marksEvent.getNewSheetName();
      vm.lastSheetName = oldSheetName;
      var worksheetName;

      if (marksEvent.getEventName() == "tabswitch") {
        if (sheetType == "dashboard") {
          var wrks = marksEvent
            .getViz()
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < wrks.length; i++) {
            var name = wrks[i].getName();
            if (name) {
              worksheetName = name;
              break;
            }
          }
        } else {
          worksheetName = newSheetName;
        }
        if (
          newSheetName == viewDataDashboardName ||
          newSheetName == viewDataDashboardName2
        ) {
          vm.hideAddToReportButton = true;
          if (newSheetName == viewDataDashboardName) {
            vm.viewDataDashboard = dataDashboardSheetName;
          } else {
            vm.viewDataDashboard = dataDashboardSheetName2;
          }

          var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
          if (vm.lastSelectedMark != kpiTableName) {
            checkFilters(wrks, vm.viewDataDashboard, activeFilterName);
          } else {
            checkFilters(wrks, vm.viewDataDashboard, "empty");
          }

          setBackButtonVisibility(true);
        } else if (
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_over_time_heifers_") ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_bull_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_insemination_heifers_"
            ) ||
          newSheetName ==
            i18nFilter("_worksheet_name_conception_rate_by_age_heifers_") ||
          newSheetName ==
            i18nFilter(
              "_worksheet_name_conception_rate_by_day_of_week_heifers_"
            )
        ) {
          vm.hideAddToReportButton = true;
          setBackButtonVisibility(true);
        } else {
          viz.getWorkbook().changeParameterValueAsync(measureNameParam, "0");
          setBackButtonVisibility(false);
        }

        /*viz.getWorkbook()
					.getParametersAsync()
					.then(function (parameters) {
						console.log(parameters);
					});
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(worksheetName)
					.getFiltersAsync()
					.then(function (filter) {
						console.log(filter);
					});*/
      }
    }

    function checkFilters(wrks, sheet_name, filter_name) {
      //console.log(vm.lastSelectedMark);
      //console.log(filter_name);
      wrks
        .get(sheet_name)
        .getFiltersAsync()
        .then(function (filters) {
          var l = filters.length;
          var actionFilterList = [];
          vm.actionFilterList = [];
          for (var i = 0; i < l; i++) {
            var name = filters[i].getFieldName();
            if (name.indexOf("Action") != -1) {
              actionFilterList.push(name);
            }
          }
          if (actionFilterList.length > 0 && filter_name) {
            var listToClear = [];
            var l = actionFilterList.length;
            for (var i = 0; i < l; i++) {
              if (actionFilterList[i] != filter_name) {
                listToClear.push(actionFilterList[i]);
                vm.actionFilterList.push(actionFilterList[i]);
              } else {
                vm.actionFilterList.push(actionFilterList[i]);
              }
            }

            var ll = listToClear.length;
            if (ll > 0) {
              for (var i = 0; i < ll; i++) {
                //resetFilter(listToClear[i]);
              }
            }
            //console.log('clear', listToClear);
          } else {
            vm.actionFilterList = actionFilterList;
          }
          //console.log('action', vm.actionFilterList);
        });
    }

    function resetFilter(filter) {
      viz
        .getWorkbook()
        .getActiveSheet()
        .getWorksheets()
        .get(vm.viewDataDashboard)
        .clearFilterAsync(filter);
    }

    function getActiveFilterName(mark) {
      var filter;
      var list = dashboardsFilterPairs;
      var l = list.length;
      for (var i = 0; i < l; i++) {
        if (list[i].mark == mark && vm.currentLng == list[i].lng) {
          filter = list[i].filter;
          break;
        }
      }
      return filter;
    }

    function onStoryPointChange(event) {
      viz
        .getWorkbook()
        .changeParameterValueAsync(
          "Start Date",
          $filter("date")(vm.start_date, "yyyy-MM-dd")
        )
        .then(function (param) {
          viz
            .getWorkbook()
            .changeParameterValueAsync(
              "End Date",
              $filter("date")(vm.end_date, "yyyy-MM-dd")
            )
            .then(function (param) {
              var herds;
              if (vm.selectedHerds.length > 0) {
                herds = angular.copy(vm.selectedHerds);
              } else {
                herds = [0];
              }
              var herdParam = createHerdParam(herds);
              viz
                .getWorkbook()
                .changeParameterValueAsync(herdParamName, herdParam);
            });
        });
    }

    function goBack() {
      var l = vm.actionFilterList ? vm.actionFilterList.length : 0;
      if (l > 0) {
        resetFilterN(0);
      } else {
        viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
        setBackButtonVisibility(false);
      }

      function resetFilterBack(filter) {
        var d = $q.defer();
        viz
          .getWorkbook()
          .getActiveSheet()
          .getWorksheets()
          .get(vm.viewDataDashboard)
          .clearFilterAsync(filter)
          .then(function (response) {
            d.resolve();
          });

        return d.promise;
      }

      function resetFilterN(index) {
        return resetFilterBack(vm.actionFilterList[index]).then(function () {
          index++;
          if (index < l) {
            resetFilterN(index);
          } else {
            viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
            setBackButtonVisibility(false);
          }
        });
      }
    }

    function setBackButtonVisibility(display) {
      $timeout(function () {
        vm.showBackButton = display;
      }, 0);
    }

    function getIsZoetisDashboard(dashboard) {
      var isZoetis = false;
      if (
        dashboard.id == i18nFilter("_z_mastitis_cases_per_month_") ||
        dashboard.id ==
          i18nFilter("_z_mastitis_cases_per_month_after_calving_") ||
        dashboard.id == i18nFilter("_z_mastitis_cases_per_lactation_n_") ||
        dashboard.id == i18nFilter("_z_mastitis_cases_per_quarters_") ||
        dashboard.id == i18nFilter("_z_mastitis_recurrent_") ||
        dashboard.id == i18nFilter("_z_mastitis_cases_per_production_") ||
        dashboard.id == i18nFilter("_z_mastitis_open_cows_") ||
        dashboard.id == i18nFilter("_z_insemination_strategy_heifers_") ||
        dashboard.id == i18nFilter("_z_conception_strategy_heifers_") ||
        dashboard.id == i18nFilter("_z_insemination_strategy_cows_") ||
        dashboard.id == i18nFilter("_z_conception_rate_cows_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_") ||
        dashboard.id == i18nFilter("_z_conception_cusum_analysis_heifers_") ||
        dashboard.id == i18nFilter("_z_oestrus_interval_analysis_") ||
        dashboard.id == i18nFilter("_z_sire_strategy_cows_") ||
        dashboard.id == i18nFilter("_z_somatic_cell_count_over_time_") ||
        dashboard.id == i18nFilter("_z_general_subclinical_table_overview_") ||
        dashboard.id == i18nFilter("_z_subclinical_mastitis_analysis_") ||
        dashboard.id ==
          i18nFilter("_z_subclinical_mastitis_overview_over_time_") ||
        dashboard.id == i18nFilter("_z_dry_period_cure_rate_") ||
        dashboard.id == i18nFilter("_z_dry_period_new_infection_rate_") ||
        dashboard.id == i18nFilter("_z_transition_cow_infection_rate_") ||
        dashboard.id == i18nFilter("_z_lactation_new_infection_rate_") ||
        dashboard.id == i18nFilter("_z_infection_rate_long_term_evolution_") ||
        dashboard.id == i18nFilter("_z_general_cell_count_dashboard_") ||
        dashboard.id ==
          i18nFilter("_z_milk_yield_by_lactation_infection_rate_") ||
        dashboard.id == i18nFilter("_z_liner_change_") ||
        dashboard.id == i18nFilter("_z_cell_count_manager_") ||
        dashboard.id == i18nFilter("_z_new_infections_over_time_") ||
        dashboard.id == i18nFilter("_z_milk_meter_dashboard_") ||
        dashboard.id ==
          i18nFilter("_z_dry_period_new_infection_rate_over_time_") ||
        dashboard.id == i18nFilter("_z_dry_period_cure_rate_over_time_") ||
        dashboard.id == i18nFilter("_z_dry_period_cell_count_evaluation_") ||
        dashboard.id ==
          i18nFilter(
            "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
          ) ||
        dashboard.id == i18nFilter("_z_milk_recording_dashboard_") ||
        dashboard.id == i18nFilter("_z_last_milk_yield_before_dry_off_date_") ||
        dashboard.id == i18nFilter("_z_first_milk_yield_by_calving_date_")
      ) {
        isZoetis = true;
      }
      return isZoetis;
    }

    function getHerdSuffix() {
      var suffix = "&HerdIdentifier=";
      for (var i = 0; i < vm.selectedHerds.length; i++) {
        if (i > 0) {
          suffix = suffix + ",";
        }
        suffix = suffix + vm.selectedHerds[i];
      }
      return suffix;
    }

    function addHerdsSuffix(dashboard, type) {
      if (vm.selectedHerds.length > 0) {
        var url = dashboard.url + "&herd=";
        for (var i = 0; i < vm.selectedHerds.length; i++) {
          if (i > 0) {
            url = url + ",";
          }
          url = url + vm.selectedHerds[i];
        }
        dashboard.url = url;
      }
      return dashboard;
    }

    function getLabelId(dashboard) {
      return "label-" + dashboard.category.id;
    }

    function getDashboardClass(dashboard) {
      return dashboard.category.id;
    }

    function search() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }, 750);
    }

    function filterWithKeyword(keyword) {
      var list = [];
      if (keyword == "zoetis") {
        try {
          var zoetis_1 = i18nFilter("_z_insemination_strategy_cows_");
        } catch (error) {
          var zoetis_1 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_2 = i18nFilter("_z_insemination_strategy_heifers_");
        } catch (error) {
          var zoetis_2 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_3 = i18nFilter("_z_conception_strategy_cows_");
        } catch (error) {
          var zoetis_3 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_4 = i18nFilter("_z_conception_strategy_heifers_");
        } catch (error) {
          var zoetis_4 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_5 = i18nFilter("_z_conception_cusum_analysis_");
        } catch (error) {
          var zoetis_5 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_6 = i18nFilter("_z_bull_strategy_cows_");
        } catch (error) {
          var zoetis_6 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_7 = i18nFilter("_z_bull_strategy_heifers_");
        } catch (error) {
          var zoetis_7 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_8 = i18nFilter("_z_sire_strategy_cows_");
        } catch (error) {
          var zoetis_8 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_9 = i18nFilter("_z_sire_strategy_heifers_");
        } catch (error) {
          var zoetis_9 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_10 = i18nFilter("_z_zoetis_flow_chart_");
        } catch (error) {
          var zoetis_10 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_11 = i18nFilter("_z_oestrus_interval_analysis_");
        } catch (error) {
          var zoetis_11 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_12 = i18nFilter("_z_milk_meter_dashboard_");
        } catch (error) {
          var zoetis_12 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_13 = i18nFilter("_z_milk_recording_dashboard_");
        } catch (error) {
          var zoetis_13 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_14 = i18nFilter("_z_lact_curve_analysis_bcd_");
        } catch (error) {
          var zoetis_14 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_15 = i18nFilter("_z_lact_curve_analysis_bmrd_");
        } catch (error) {
          var zoetis_15 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_16 = i18nFilter("_z_mastitis_cases_per_month_");
        } catch (error) {
          var zoetis_16 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_17 = i18nFilter(
            "_z_mastitis_cases_per_month_after_calving_"
          );
        } catch (error) {
          var zoetis_17 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_18 = i18nFilter("_z_mastitis_cases_per_lactation_n_");
        } catch (error) {
          var zoetis_18 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_19 = i18nFilter("_z_mastitis_cases_per_quarters_");
        } catch (error) {
          var zoetis_19 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_20 = i18nFilter("_z_mastitis_recurrent_");
        } catch (error) {
          var zoetis_20 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_21 = i18nFilter("_z_mastitis_cases_per_production_");
        } catch (error) {
          var zoetis_21 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_22 = i18nFilter("_z_mastitis_open_cows_");
        } catch (error) {
          var zoetis_22 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_23 = i18nFilter("_z_conception_rate_cows_");
        } catch (error) {
          var zoetis_23 = "zzzyyyzzz";
          console.log(error);
        }
        try {
          var zoetis_24 = i18nFilter("_z_conception_cusum_analysis_heifers_");
        } catch (error) {
          var zoetis_24 = "zzzyyyzzz";
          console.log(error);
        }

        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (
            vm.allDashboards[i].id == zoetis_1 ||
            vm.allDashboards[i].id == zoetis_2 ||
            vm.allDashboards[i].id == zoetis_3 ||
            vm.allDashboards[i].id == zoetis_4 ||
            vm.allDashboards[i].id == zoetis_5 ||
            vm.allDashboards[i].id == zoetis_6 ||
            vm.allDashboards[i].id == zoetis_7 ||
            vm.allDashboards[i].id == zoetis_8 ||
            vm.allDashboards[i].id == zoetis_9 ||
            vm.allDashboards[i].id == zoetis_10 ||
            vm.allDashboards[i].id == zoetis_11 ||
            vm.allDashboards[i].id == zoetis_12 ||
            vm.allDashboards[i].id == zoetis_13 ||
            vm.allDashboards[i].id == zoetis_14 ||
            vm.allDashboards[i].id == zoetis_15 ||
            vm.allDashboards[i].id == zoetis_16 ||
            vm.allDashboards[i].id == zoetis_17 ||
            vm.allDashboards[i].id == zoetis_18 ||
            vm.allDashboards[i].id == zoetis_19 ||
            vm.allDashboards[i].id == zoetis_20 ||
            vm.allDashboards[i].id == zoetis_21 ||
            vm.allDashboards[i].id == zoetis_22 ||
            vm.allDashboards[i].id == zoetis_23 ||
            vm.allDashboards[i].id == zoetis_24
          ) {
            if (vm.activeCategory != null && vm.activeCategory != undefined) {
              if (vm.activeCategoryName == vm.allDashboards[i].category.id) {
                list.push(vm.allDashboards[i]);
              }
            } else {
              list.push(vm.allDashboards[i]);
            }
          }
        }
      } else if (keyword == "fame") {
        for (var i = 0; i < vm.allDashboards.length; i++) {
          if (vm.allDashboards[i].subcategory == "rap-fame") {
            list.push(vm.allDashboards[i]);
          }
        }
      }
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filterList() {
      var list = [];
      if (vm.activeCategory != null) {
        angular.copy(vm.dashboardsFiltered, list);
      } else {
        angular.copy(vm.allDashboards, list);
      }
      list = filter(list, "title", vm.searchDescriptionString);
      list = filter(list, "type", vm.searchTypeString);
      list = filter(list, "category", vm.searchCategoryString, "name");
      vm.dashboards = list;
      vm.dashboardsSafe = vm.dashboards;
    }

    function filter(list, property, filterString, subProperty) {
      var filteredList = [];
      for (var i = 0; i < list.length; i++) {
        if (subProperty) {
          var str = list[i][property][subProperty].toLowerCase();
        } else {
          var str = list[i][property].toLowerCase();
        }
        if (str.indexOf(filterString.toLowerCase()) != -1) {
          filteredList.push(list[i]);
        }
      }
      return filteredList;
    }

    function setButtonColor(button) {
      var btnClass = "";
      if (button.description.toLowerCase() == "last week") {
        btnClass = "btn-lw";
      } else if (button.description.toLowerCase() == "last month") {
        btnClass = "btn-lm";
      } else if (button.description.toLowerCase() == "last quarter") {
        btnClass = "btn-lq";
      } else if (button.description.toLowerCase() == "last year") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "custom") {
        btnClass = "btn-ly";
      } else if (button.description.toLowerCase() == "") {
        btnClass = "btn-preview";
      }
      return btnClass;
    }

    function categorySelected(index, category) {
      if (vm.activeCategory == index) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        $rootScope.$broadcast("category_selected", null);
        $rootScope.$broadcast("set_category_background", null);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      } else {
        vm.activeCategory = index;
        vm.activeCategoryName = category.id;
        vm.activeCategoryObject = category;
        $rootScope.$broadcast("category_selected", category);
        $rootScope.$broadcast("set_category_background", index);
        vm.dashboardsFiltered = filterByCategory(category);
        if (
          vm.searchDescriptionString.toLowerCase() != "zoetis" &&
          vm.searchDescriptionString.toLowerCase() != "fame"
        ) {
          filterList();
        } else {
          if (vm.searchDescriptionString.toLowerCase() == "zoetis") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory == 1 ||
              vm.activeCategory == 2 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          } else if (vm.searchDescriptionString.toLowerCase() == "fame") {
            if (
              vm.activeCategory == null ||
              vm.activeCategory === 0 ||
              vm.activeCategory == undefined
            ) {
              filterWithKeyword(vm.searchDescriptionString.toLowerCase());
            } else {
              filterList();
            }
          }
        }
      }
    }

    function filterByCategory(category) {
      var list = [];
      for (var i = 0; i < vm.allDashboards.length; i++) {
        if (vm.allDashboards[i].category.id == category.id) {
          list.push(vm.allDashboards[i]);
        }
      }
      return list;
    }

    function getBtnClass(category, index) {
      var cl = "btn-" + category.id;
      if (index == vm.activeCategory) {
        cl = cl + " " + "active-category";
      }
      return cl;
    }

    function getTableClass() {
      if (vm.activeCategory == 0) {
        return "image-production";
      } else if (vm.activeCategory == 1) {
        return "image-reproduction";
      } else if (vm.activeCategory == 2) {
        return "image-udder_health";
      } else if (vm.activeCategory == 3) {
        return "image-hoof_health";
      } else if (vm.activeCategory == 4) {
        return "image-herd_characteristics";
      } else if (vm.activeCategory == 5) {
        return "image-comments";
      } else if (vm.activeCategory == 6) {
        return "image-herd_environmental";
      } else if (vm.activeCategory == 7) {
        return "image-herd_genetics";
      } else {
        return "";
      }
    }

    function customTimeSelected() {
      if (vm.start_date && vm.end_date) {
        if (
          moment(vm.end_date).isBefore(
            moment().hour(12).minute(0).seconds(0).millisecond(0).add(1, "days")
          )
        ) {
          if (moment(vm.end_date).isAfter(moment(vm.start_date))) {
            closeModal();
            vm.selectedTime = 69;
            vm.showFrame = false;
            vm.loadingBaseTable = true;
            selectDashboard(
              vm.lastUsedDashboard,
              vm.lastUsedDashboardType,
              false
            );
          } else {
            vm.timePickerError = true;
            removeError("timePickerError");
          }
        } else {
          vm.timePickerError = true;
          removeError("timePickerError");
        }
      } else {
        vm.timePickerError = true;
        removeError("timePickerError");
      }
    }

    function removeError(key) {
      $timeout(function () {
        vm[key] = false;
      }, 3000);
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function getCurrentUserClass() {
      var houseStyle = permissionService.getHouseStyle();
      return houseStyle;
    }

    function openAddToReportModal(dashboard) {
      vm.currentDashboard = dashboard.id;
      vm.addToReportModalLoading = true;
      vm.entryAlradyExist = false;
      vm.currentEntry = null;
      var date = new Date();
      getAddedToReport(false, date, false);
      openModal("app/pages/herds/dashboards/addToReport.modal.html", "sm");
    }

    function getAddedToReport(init, date, createReport) {
      vm.multipleReports = false;
      vm.errorLoadingReports = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        var date =
          moment(vm.reportDate)
            .hour(0)
            .minute(0)
            .seconds(0)
            .milliseconds(0)
            .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
        var suffix = "?HerdId=" + vm.selectedHerds;
        suffix = suffix + "&Date=" + date;
        if (vm.work_locally) {
          var response = [];
          handleReports(init, createReport, response);
        } else {
          return herdDashboardsService
            .getReports(suffix)
            .then(function (response) {
              handleReports(init, createReport, response);
            })
            .catch(function (error) {
              vm.addToReportModalLoading = false;
              vm.errorLoadingReports = true;
              if (createReport) {
                setReport(init, null);
                addToReportPromise.resolve();
              }
            });
        }
      } else {
        if (!createReport) {
          vm.addToReportModalLoading = false;
        }
      }
    }

    function handleReports(init, createReport, response) {
      var added = response[0];
      added = handleCusumDashboards(added);
      vm.availableReports = response;
      vm.selectedReport = response[0];
      if (response.length > 1) {
        vm.multipleReports = true;
      }
      if (createReport) {
        setReport(init, added);
      } else {
        setCurrentEntry(added);
      }
    }

    function handleCusumDashboards(reports) {
      if (reports) {
        for (var i = 0; i < reports.entries.length; i++) {
          var id = reports.entries[i].dashboardId;
          if (
            id &&
            (id.indexOf("Conceptioncusumanalysis") != -1 ||
              id.indexOf("Conception-Cusum-Analyse") != -1 ||
              id.indexOf("AnalyseCUSUMdelaconception") != -1 ||
              id.indexOf("Drachtpercentagecusumanalyse") != -1)
          ) {
            reports.entries[i].cusumDashboard = true;
            var splitted = reports.entries[i].dashboardId.split("|");
            reports.entries[i].dashboardId = splitted[0].trim();
            var KPI = splitted[1] ? splitted[1].trim() : null;
            var worksheetParam = splitted[2] ? splitted[2].trim() : null;
            reports.entries[i].dashboardId = splitted[0].trim();
            reports.entries[i].filter += "&" + selectKPIParamName + "=" + KPI;
            reports.entries[i].descName = KPI;
            reports.entries[i].kpi = KPI;
            reports.entries[i].wsp = worksheetParam;
            if (worksheetParam) {
              reports.entries[i].filter +=
                "&" + worksheetParamName + "=" + worksheetParam;
            }
          }
        }
      }
      return reports;
    }

    function setReport(init, added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      if (!init) {
        vm.reportDashboards = checkForAddedToReport(
          vm.allReportDashboards,
          vm.addedToReport
        );
      }
      if (init) {
        addToReportPromise.resolve();
      } else {
        vm.reportLoading = false;
      }
    }

    function getCurrentLngFilter(filter, lng, dashboard_id) {
      var filterString = angular.copy(filter);
      //split filter by param
      var splitted = filterString.split("&");
      var parityFilterString;
      var vwpFilterString;
      var afiFilerString;
      var D50FilterString;
      var DYFilterString;
      var DXFilterString;
      var DIMCategoryString;
      var DateString;
      var cowSccString;
      var heiferSccString;
      var parityCategoriesFilterString;
      var DIMCategoriesFilterString;
      var SCCLNFilterString;
      var animalContributionFilterString;
      var numberOfCowsFilterString;
      var linerTypeNameFilterString;
      var numberOfClustersFilterString;
      var dailyMilkingsFilterString;
      var dateLastLinerChangeFilterString;
      var excludeEarlyDIMFilterString;
      var selectKPIFilterString;
      var selectKPIFirstFilterString;

      for (var i = 0; i < splitted.length; i++) {
        if (
          splitted[i].indexOf("VWP=") != -1 ||
          splitted[i].indexOf("Période d'attente volontaire (VWP)=") != -1 ||
          splitted[i].indexOf("VWP (Vrijwillige wachtperiode)=") != -1
        ) {
          vwpFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Parity=") != -1 ||
          splitted[i].indexOf("Pariteit=") != -1 ||
          splitted[i].indexOf("Laktation=") != -1 ||
          splitted[i].indexOf("Lactation=") != -1
        ) {
          parityFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("AFI target=") != -1 ||
          splitted[i].indexOf("AFI-Ziel=") != -1 ||
          splitted[i].indexOf("Objectif AFI=") != -1 ||
          splitted[i].indexOf("Doel eerste inseminatie=") != -1
        ) {
          afiFilerString = splitted[i];
        }
        if (splitted[i].indexOf("D50=") != -1) {
          D50FilterString = splitted[i];
        }
        if (splitted[i].indexOf("DY=") != -1) {
          DYFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DX=") != -1) {
          DXFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("DIM Category=") != -1 ||
          splitted[i].indexOf("TIM-Kategorie=") != -1 ||
          splitted[i].indexOf("Catégorie de JEL=") != -1 ||
          splitted[i].indexOf("DIM Categorie=") != -1
        ) {
          DIMCategoryString = splitted[i];
        }
        if (splitted[i].indexOf("DateFilter=") != -1) {
          DateString = splitted[i];
        }
        if (splitted[i].indexOf("Cow SCC threshold=") != -1) {
          cowSccString = splitted[i];
        }
        if (splitted[i].indexOf("Heifer SCC threshold=") != -1) {
          heiferSccString = splitted[i];
        }
        if (splitted[i].indexOf("Parity categories=") != -1) {
          parityCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("DIM categories=") != -1) {
          DIMCategoriesFilterString = splitted[i];
        }
        if (splitted[i].indexOf("SCC vs LN=") != -1) {
          SCCLNFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Animal contribution=") != -1) {
          animalContributionFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Number of cows=") != -1 ||
          splitted[i].indexOf("Aantal koeien=") != -1
        ) {
          numberOfCowsFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Liner type=") != -1) {
          linerTypeNameFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Number of clusters=") != -1) {
          numberOfClustersFilterString = splitted[i];
        }
        if (splitted[i].indexOf("Daily milkings=") != -1) {
          dailyMilkingsFilterString = splitted[i];
        }
        if (
          splitted[i].indexOf("Date last liner change=") != -1 ||
          splitted[i].indexOf("Tepelvoering=") != -1
        ) {
          dateLastLinerChangeFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Exclude early DIM=") != -1) {
          excludeEarlyDIMFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Select KPI=") != -1 || splitted[i].indexOf("Selecteer KPI=") != -1) {
          selectKPIFilterString = splitted[i];
        }

        if (splitted[i].indexOf("Select KPI first=") != -1) {
          selectKPIFirstFilterString = splitted[i];
        }
      }
      var filtersLngList = APP_CONSTANTS.constants.filtersLngList;
      var parity;
      var vwp;
      var afiFilter;
      var DIMCategory;
      var cowScc;
      var heiferScc;
      var parityCategories;
      var DIMCategories;
      var SCCLN;
      var animalContribution;
      var numberOfCows;
      var linerType;
      var numberOfClusters;
      var dailyMilkings;
      var dateLastLinerChange;
      var excludeEarlyDIM;
      var selectKPI;
      var selectKPIFirst;

      for (var i = 0; i < filtersLngList.length; i++) {
        if (
          filtersLngList[i].internal_id == "parity" &&
          filtersLngList[i].lng == lng
        ) {
          parity = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "vwp" &&
          filtersLngList[i].lng == lng
        ) {
          vwp = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "afi" &&
          filtersLngList[i].lng == lng
        ) {
          afiFilter = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_category" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategory = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "cow_scc" &&
          filtersLngList[i].lng == lng
        ) {
          cowScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "heifer_scc" &&
          filtersLngList[i].lng == lng
        ) {
          heiferScc = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "parity_categories" &&
          filtersLngList[i].lng == lng
        ) {
          parityCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "dim_categories" &&
          filtersLngList[i].lng == lng
        ) {
          DIMCategories = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "scc_ln" &&
          filtersLngList[i].lng == lng
        ) {
          SCCLN = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "animal_contribution" &&
          filtersLngList[i].lng == lng
        ) {
          animalContribution = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_cows" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfCows = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "liner_type" &&
          filtersLngList[i].lng == lng
        ) {
          linerType = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "number_of_clusters" &&
          filtersLngList[i].lng == lng
        ) {
          numberOfClusters = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "daily_milkings" &&
          filtersLngList[i].lng == lng
        ) {
          dailyMilkings = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "date_last_liner_change" &&
          filtersLngList[i].lng == lng
        ) {
          dateLastLinerChange = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "exclude_early_dim" &&
          filtersLngList[i].lng == lng
        ) {
          excludeEarlyDIM = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "select_kpi" &&
          filtersLngList[i].lng == lng
        ) {
          selectKPI = filtersLngList[i].name;
        }
        if (
          filtersLngList[i].internal_id == "select_kpi_first" &&
          filtersLngList[i].lng == lng
        ) {
          selectKPIFirst = filtersLngList[i].name;
        }
      }
      if (parity && parityFilterString) {
        parityFilterString = changeFilterNameLanguage(
          parityFilterString,
          parity,
          parityFilter
        );
      }
      if (vwp && vwpFilterString) {
        vwpFilterString = changeFilterNameLanguage(
          vwpFilterString,
          vwp,
          vwpFilterName
        );
      }
      if (afiFilter && afiFilerString) {
        afiFilerString = changeFilterNameLanguage(
          afiFilerString,
          afiFilter,
          afiFilterName
        );
      }
      if (DIMCategory && DIMCategoryString) {
        DIMCategoryString = changeFilterNameLanguage(
          DIMCategoryString,
          DIMCategory,
          DIMCategoryName
        );
      }
      if (cowScc && cowSccString) {
        cowSccString = changeFilterNameLanguage(
          cowSccString,
          cowScc,
          cowSccName
        );
      }
      if (heiferScc && heiferSccString) {
        heiferSccString = changeFilterNameLanguage(
          heiferSccString,
          heiferScc,
          heiferSccName
        );
      }
      if (parityCategories && parityCategoriesFilterString) {
        parityCategoriesFilterString = changeFilterNameLanguage(
          parityCategoriesFilterString,
          parityCategories,
          parityCategoriesName
        );
      }
      if (DIMCategories && DIMCategoriesFilterString) {
        DIMCategoriesFilterString = changeFilterNameLanguage(
          DIMCategoriesFilterString,
          DIMCategories,
          DIMCategoriesName
        );
      }
      if (SCCLN && SCCLNFilterString) {
        SCCLNFilterString = changeFilterNameLanguage(
          SCCLNFilterString,
          SCCLN,
          SCCLNName
        );
      }
      if (animalContribution && animalContributionFilterString) {
        animalContributionFilterString = changeFilterNameLanguage(
          animalContributionFilterString,
          animalContribution,
          animalContributionName
        );
      }
      if (numberOfCows && numberOfCowsFilterString) {
        numberOfCowsFilterString = changeFilterNameLanguage(
          numberOfCowsFilterString,
          numberOfCows,
          numberOfCowsName
        );
      }
      if (linerType && linerTypeNameFilterString) {
        linerTypeNameFilterString = changeFilterNameLanguage(
          linerTypeNameFilterString,
          linerType,
          linerTypeName
        );
      }
      if (numberOfClusters && numberOfClustersFilterString) {
        numberOfClustersFilterString = changeFilterNameLanguage(
          numberOfClustersFilterString,
          numberOfClusters,
          numberOfClustersName
        );
      }
      if (dailyMilkings && dailyMilkingsFilterString) {
        dailyMilkingsFilterString = changeFilterNameLanguage(
          dailyMilkingsFilterString,
          dailyMilkings,
          dailyMilkingsName
        );
      }
      if (dateLastLinerChange && dateLastLinerChangeFilterString) {
        dateLastLinerChangeFilterString = changeFilterNameLanguage(
          dateLastLinerChangeFilterString,
          dateLastLinerChange,
          dateLastLinerChangeName
        );
      }

      if (excludeEarlyDIM && excludeEarlyDIMFilterString) {
        excludeEarlyDIMFilterString = changeFilterNameLanguage(
          excludeEarlyDIMFilterString,
          excludeEarlyDIM,
          excludeEarlyDIMName
        );
      }

      if (selectKPI && selectKPIFilterString) {
        selectKPIFilterString = changeFilterNameLanguage(
          selectKPIFilterString,
          selectKPI,
          selectKPIParamName
        );
      }

      if (selectKPIFirst && selectKPIFirstFilterString) {
        selectKPIFirstFilterString = changeFilterNameLanguage(
          selectKPIFirstFilterString,
          selectKPIFirst,
          "Select KPI first"
        );
      }

      filterString = "";
      if (parityFilterString) {
        filterString += "&" + parityFilterString;
      }
      if (vwpFilterString) {
        filterString += "&" + vwpFilterString;
      }
      if (afiFilerString) {
        filterString += "&" + afiFilerString;
      }
      if (D50FilterString) {
        filterString += "&" + D50FilterString;
      }
      if (DYFilterString) {
        filterString += "&" + DYFilterString;
      }
      if (DXFilterString) {
        filterString += "&" + DXFilterString;
      }
      if (DIMCategoryString) {
        filterString += "&" + DIMCategoryString;
      }
      if (DateString) {
        filterString += "&" + DateString;
      }
      if (cowSccString) {
        filterString += "&" + cowSccString;
      }
      if (heiferSccString) {
        filterString += "&" + heiferSccString;
      }
      if (parityCategoriesFilterString) {
        filterString += "&" + parityCategoriesFilterString;
      }
      if (DIMCategoriesFilterString) {
        filterString += "&" + DIMCategoriesFilterString;
      }
      if (SCCLNFilterString) {
        filterString += "&" + SCCLNFilterString;
      }
      if (animalContributionFilterString) {
        filterString += "&" + animalContributionFilterString;
      }
      if (numberOfCowsFilterString) {
        filterString += "&" + numberOfCowsFilterString;
      }
      if (linerTypeNameFilterString) {
        filterString += "&" + linerTypeNameFilterString;
      }
      if (numberOfClustersFilterString) {
        filterString += "&" + numberOfClustersFilterString;
      }
      if (dailyMilkingsFilterString) {
        filterString += "&" + dailyMilkingsFilterString;
      }
      if (dateLastLinerChangeFilterString) {
        filterString += "&" + dateLastLinerChangeFilterString;
      }
      if (excludeEarlyDIMFilterString) {
        filterString += "&" + excludeEarlyDIMFilterString;
      }
      if (selectKPIFilterString) {
        filterString += "&" + selectKPIFilterString;
      }
      if (selectKPIFirstFilterString) {
        filterString += "&" + selectKPIFirstFilterString;
      }
      return filterString;
    }

    function setCurrentLngCusumDashboard(entry) {
      var filter = "";
      if (entry.kpi) {
        filter += "&" + selectKPIParamName + "=" + entry.kpi;
      }
      if (entry.wsp) {
        filter += "&" + worksheetParamName + "=" + entry.wsp;
      }
      entry.filter = filter;
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20pregnant%20cow" &&
        entry.wsp == 1
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_pregnant_animal_"
        );
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20non-pregnant%20cow" &&
        entry.wsp == 1
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_non_pregnant_animal_"
        );
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20inseminated%20cow" &&
        entry.wsp == 1
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_inseminated_animal_"
        );
      }

      if (
        entry.kpi == "Number%20of%20inseminations%20per%20pregnant%20cow" &&
        entry.wsp == 2
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_pregnant_animal_w_parity_"
        );
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20non-pregnant%20cow" &&
        entry.wsp == 2
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_non_pregnant_animal_w_parity_"
        );
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20inseminated%20cow" &&
        entry.wsp == 2
      ) {
        entry.title = i18nFilter(
          "_dashboards_parameter_select_kpi_value_n_per_inseminated_animal_w_parity_"
        );
      }

      if (
        entry.kpi == "Number%20of%20inseminations%20per%20pregnant%20cow" &&
        entry.wsp == null
      ) {
        entry.title =
          i18nFilter(
            "_dashboards_parameter_select_kpi_value_n_per_pregnant_animal_"
          ) +
          " (" +
          i18nFilter("_animal_heifers_") +
          ")";
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20non-pregnant%20cow" &&
        entry.wsp == null
      ) {
        entry.title =
          i18nFilter(
            "_dashboards_parameter_select_kpi_value_n_per_non_pregnant_animal_"
          ) +
          " (" +
          i18nFilter("_animal_heifers_") +
          ")";
      }
      if (
        entry.kpi == "Number%20of%20inseminations%20per%20inseminated%20cow" &&
        entry.wsp == null
      ) {
        entry.title =
          i18nFilter(
            "_dashboards_parameter_select_kpi_value_n_per_inseminated_animal_"
          ) +
          " (" +
          i18nFilter("_animal_heifers_") +
          ")";
      }
      return entry;
    }

    function changeFilterNameLanguage(filter, old_name, new_name) {
      var str = angular.copy(filter);
      return str.replace(old_name, new_name);
    }

    function setCurrentEntry(added) {
      var lng = vm.currentLng;
      if (added && added.entries) {
        for (var i = 0; i < added.entries.length; i++) {
          if (added.entries[i].locale != lng) {
            added.entries[i].dashboardId = getCurrentLngId(
              added.entries[i].dashboardId,
              lng
            );
            added.entries[i].filter = getCurrentLngFilter(
              added.entries[i].filter,
              added.entries[i].locale,
              added.entries[i].dashboardId
            );
            added.entries[i].locale = lng;
          }
        }
        vm.addedToReport = added.entries;
      } else {
        vm.addedToReport = [];
      }
      var entry;

        for (var i = 0; i < vm.addedToReport.length; i++) {
          if (vm.addedToReport[i].dashboardId == vm.currentDashboard) {
            entry = vm.addedToReport[i];
            break;
          }
        }
        handleEntry(entry);
    }

    function handleEntry(entry) {
      if (entry) {
        vm.entryAlradyExist = true;
        vm.currentEntry = entry;
        vm.modalComment = angular.copy(vm.currentEntry.comment);
      } else {
        vm.modalComment = "";
      }
      $timeout(function () {
        vm.addToReportModalLoading = false;
      }, 10);
    }

    function checkForAddedToReport(dashboards, addedToReport) {
      var list = angular.copy(dashboards);
      var list2 = []
      for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < addedToReport.length; j++) {
            if (list[i].id == addedToReport[j].dashboardId) {
                var newDashboard = angular.copy(list[i]); 
                newDashboard.comment = addedToReport[j].comment;
                newDashboard.end_date = new Date(addedToReport[j].endDate);
                newDashboard.start_date = new Date(addedToReport[j].startDate);
                newDashboard.selected = true;
                newDashboard.filter = addedToReport[j].filter;
                newDashboard.entry_id = addedToReport[j].id;
                list2.push(newDashboard);
              }
          }
      }
        for (var k = 0; k < list.length; k++) {
            var found = false;
            for (var l = 0; l < list2.length; l++) {
                if (list[k].id == list2[l].id) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                list2.push(angular.copy(list[k]));
            }
          }
      return list2;
    }

    function addToReport() {
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        vm.addToReportModalLoading = true;
        var filterList = getFilterListByDashboardId(vm.currentDashboard);
        var filter = "";
        var paramName = "";

        var promiseList = [];
        var promiseNameList = [];

        for (var i = 0; i < filterList.parameters.length; i++) {
          var name = "pr_p_" + filterList.parameters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        for (var i = 0; i < filterList.filters.length; i++) {
          var name = "pr_f_" + filterList.filters[i].name;
          vm[name] = $q.defer();
          promiseList.push(vm[name].promise);
          promiseNameList.push(name);
        }

        $q.all(promiseList)
          .then(function () {
            setEntry(filter, paramName);
          })
          .catch(function (error) {
            vm.addToReportModalLoading = false;
          });

        promiseList = $timeout(function () {
          for (var i = 0; i < promiseNameList.length; i++) {
            vm[promiseNameList[i]].resolve();
          }
        }, 10000);
        //}, 100000);

        try {
          if (viz) {
            viz
              .getWorkbook()
              .getParametersAsync()
              .then(function (parameters) {
                for (var j = 0; j < filterList.parameters.length; j++) {
                  for (var i = 0; i < parameters.length; i++) {
                    if (
                      parameters[i].getName() == filterList.parameters[j].name
                    ) {
                        var p_name = filterList.parameters[j].name;
                        if (
                          parameters[i].getCurrentValue().value !=
                          filterList.parameters[j].default
                        ) {
                          if (
                            p_name ==
                            i18nFilter(
                              "_dashboards_parameter_last_liner_change_"
                            )
                          ) {
                            filter +=
                              "&" +
                              filterList.parameters[j].name +
                              "=" +
                              $filter("date")(
                                new Date(parameters[i].getCurrentValue().value),
                                "yyyy-MM-dd"
                              );
                          } else {
                            filter +=
                              "&" +
                              filterList.parameters[j].name +
                              "=" +
                              parameters[i].getCurrentValue().value;
                          }
                        }   
                      var name = "pr_p_" + filterList.parameters[j].name;
                      vm[name].resolve();
                    }
                  }
                }
              });

            if (filterList.filters.length) {
              viz
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets()
                .get(filterList.filters[0].worksheetName)
                .getFiltersAsync()
                .then(function (filtersResponse) {
                  if (
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_name_days_in_milk_first_insemination_sows_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_somatic_cell_count_over_time_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_new_infections_over_time_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_subclinical_mastitis_overview_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_liner_change_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_cell_count_manager_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_subclinical_mastitis_overview_last_mro_") ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_dry_period_new_infection_rate_over_time_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_dry_period_cure_rate_over_time_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_dry_period_cell_count_evaluation_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_milk_yield_by_lactation_infection_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter(
                        "_worksheet_last_milk_yield_before_dry_off_date_"
                      ) ||
                    filterList.filters[0].worksheetName ==
                      i18nFilter("_worksheet_first_milk_yield_by_calving_date_")
                  ) {
                    for (var i = 0; i < filtersResponse.length; i++) {
                      var name = filtersResponse[i].getFieldName();
                      var filterValue;
                      for (var j = 0; j < filterList.filters.length; j++) {
                        if (
                          name ==
                            i18nFilter("_dashboard_name_filter_parity_") ||
                          name ==
                            i18nFilter(
                              "_dashboard_name_parameter_dim_category_"
                            ) ||
                          name == "DateFilter" ||
                          name ==
                            i18nFilter(
                              "_dashboard_name_parameter_exclude_early_dim_"
                            )
                        ) {
                          if (name == filterList.filters[j].name) {
                            var filter_values =
                              filtersResponse[i].getAppliedValues();
                            if (name == "DateFilter") {
                              for (var f = 0; f < filter_values.length; f++) {
                                filter_values[f].formattedValue = $filter(
                                  "date"
                                )(
                                  new Date(filter_values[f].value),
                                  "yyyy-MM-dd"
                                );
                              }
                            }
                            if (
                              (filterList.filters[j].n != undefined) &
                              (filterList.filters[j].n != filter_values.length)
                            ) {
                              filterValue = getParityFilterString(
                                filter_values,
                                name
                              );
                            } else if (
                              (filterList.filters[j].m != undefined) &
                              (filterList.filters[j].m == filter_values.length)
                            ) {
                              filterValue = getParityFilterString(
                                filter_values,
                                name
                              );
                            } else if (
                              filterList.filters[j].n == undefined &&
                              filterList.filters[j].m == undefined
                            ) {
                              filterValue = getParityFilterString(
                                filter_values,
                                name
                              );
                            }

                            var p_name = "pr_f_" + filterList.filters[j].name;
                            if (filterValue) {
                              filter += filterValue;
                            }
                            vm[p_name].resolve();
                            filterValue = null;
                          }
                        }
                      }
                    }
                  }
                });
            }
          } else {
              for (var i = 0; i < filterList.parameters.length; i++) {
                var name = "pr_p_" + filterList.parameters[i].name;
                vm[name].resolve();
              }

            for (var j = 0; j < filterList.filters.length; j++) {
              var name = "pr_f_" + filterList.filters[j].name;

              vm[name].resolve();
            }
          }
        } catch (error) {
          console.log(error);
          for (var i = 0; i < promiseNameList.length; i++) {
            try {
              vm[promiseNameList[i]].reject();
            } catch (error) {}
          }
        }
      }
    }

    function getParityFilterString(value, name) {
      var filter = "";
      if (value.length != 3) {
        if (value.length == 1) {
          filter = value[0].formattedValue;
        } else {
          for (var i = 0; i < value.length; i++) {
            if (i == 0) {
              filter = filter + value[i].formattedValue;
            } else {
              filter = filter + "," + value[i].formattedValue;
            }
          }
        }
      }
      if (!filter.length) {
        filter = null;
      } else {
        filter = "&" + name + "=" + filter;
      }

      return filter;
    }

    function getFilterListByDashboardId(dashboardId) {
      var obj = {
        parameters: [],
        filters: [],
      };

      switch (dashboardId) {
        case i18nFilter("_z_mastitis_open_cows_"):
          obj.parameters = [
            {
              name: "D50",
              default: 50,
            },
            {
              name: "DY",
              default: 120,
            },
            {
              name: "DX",
              default: 90,
            },
          ];

          break;

        case i18nFilter("_z_insemination_strategy_heifers_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_afi_target_"),
              default: 13.1,
            },
          ];

          break;

        case i18nFilter("_z_insemination_strategy_cows_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_vwp_"),
              default: 48,
            },
          ];

          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              default: 3,
              id: 1,
              worksheetName: i18nFilter(
                "_worksheet_name_days_in_milk_first_insemination_sows_"
              ),
              m: undefined,
              n: undefined,
            },
          ];

          break;

        case i18nFilter("_z_conception_cusum_analysis_"):
          obj.parameters = [
            {
              name: selectKPIParamName,
              default: "Number%20of%20inseminations%20per%20pregnant%20cow",
            },
            {
              name: worksheetParamName,
              default: 1,
            },
          ];

          break;

        case i18nFilter("_z_conception_cusum_analysis_heifers_"):
          obj.parameters = [
            {
              name: selectKPIParamName,
              default: "Number%20of%20inseminations%20per%20pregnant%20cow",
            },
          ];
          break;

        case i18nFilter("_z_somatic_cell_count_over_time_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter("_somatic_cell_count_over_time_"),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter("_somatic_cell_count_over_time_"),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_scc_ln_"),
              default: "na",
            },
          ];
          break;

        case i18nFilter("_z_new_infections_over_time_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter("_new_infections_over_time_"),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter("_new_infections_over_time_"),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },
          ];
          break;

        case i18nFilter("_z_general_subclinical_table_overview_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter("_subclinical_mastitis_overview_"),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter("_subclinical_mastitis_overview_"),
            },
            {
              name: "DateFilter",
              id: 1,
              n: undefined,
              m: 1,
              worksheetName: i18nFilter("_subclinical_mastitis_overview_"),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
          ];
          break;

        case i18nFilter("_z_subclinical_mastitis_overview_over_time_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_subclinical_mastitis_overview_last_mro_"
              ),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter(
                "_subclinical_mastitis_overview_last_mro_"
              ),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
          ];
          break;

        case i18nFilter("_z_liner_change_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_number_of_cows_"),
              default: 100,
            },
            {
              name: i18nFilter("_dashboards_parameter_liner_types_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_number_of_clusters_"),
              default: 10,
            },
            {
              name: i18nFilter("_dashboards_parameter_daily_milkings_"),
              default: 2,
            },
            {
              name: i18nFilter("_dashboards_parameter_last_liner_change_"),
              default: "na",
            },
          ];
          break;

        case i18nFilter("_z_cell_count_manager_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter("_cell_count_manager_"),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter("_cell_count_manager_"),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_animal_contribution_"),
              default: "No",
            },
          ];
          break;

        case i18nFilter("_z_dry_period_new_infection_rate_over_time_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },

            {
              name: i18nFilter("_dashboard_name_parameter_exclude_early_dim_"),
              default: "Exclude none",
            },
          ];

          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_new_infection_rate_over_time_"
              ),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_new_infection_rate_over_time_"
              ),
            },
          ];
          break;

        case i18nFilter("_z_dry_period_cure_rate_over_time_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },

            {
              name: i18nFilter("_dashboard_name_parameter_exclude_early_dim_"),
              default: "Exclude none",
            },
          ];

          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_cure_rate_over_time_"
              ),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_cure_rate_over_time_"
              ),
            },
          ];
          break;

        case i18nFilter("_z_dry_period_cell_count_evaluation_"):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },

            {
              name: i18nFilter("_dashboard_name_parameter_exclude_early_dim_"),
              default: "Exclude none",
            },
          ];

          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 1,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_cell_count_evaluation_"
              ),
            },
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_dry_period_cell_count_evaluation_"
              ),
            },
          ];
          break;

        case i18nFilter(
          "_z_effect_of_cell_count_on_milk_yield_during_lactation_"
        ):
          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_parity_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_dim_categories_"),
              default: "na",
            },
            {
              name: i18nFilter("_dashboards_parameter_cow_scc_treshold_"),
              default: 250,
            },
            {
              name: i18nFilter("_dashboards_parameter_heifer_scc_treshold_"),
              default: 150,
            },
          ];

          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_parameter_dim_category_"),
              id: 1,
              n: 6,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_milk_yield_by_lactation_infection_"
              ),
            },

            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 2,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_milk_yield_by_lactation_infection_"
              ),
            },
          ];
          break;

        case i18nFilter("_z_last_milk_yield_before_dry_off_date_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 2,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_last_milk_yield_before_dry_off_date_"
              ),
            },
          ];

          obj.parameters = [
            {
              name: i18nFilter("_dashboards_parameter_select_kpi_"),
              default: "Last daily milk yield (moving average)",
            }
          ];
          break;

        case i18nFilter("_z_first_milk_yield_by_calving_date_"):
          obj.filters = [
            {
              name: i18nFilter("_dashboard_name_filter_parity_"),
              id: 2,
              n: undefined,
              m: undefined,
              worksheetName: i18nFilter(
                "_worksheet_first_milk_yield_by_calving_date_"
              ),
            },
          ];

          obj.parameters = [
            {
              name: "Select KPI first",
              default: "First daily milk yield (moving average)",
            }
          ];
          break;

        default:
          break;
      }

      return obj;
    }

    function setEntry(filterUrl, paramName) {
      var start_date =
        moment(vm.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";

      var end_date =
        moment(vm.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var lng = vm.currentLng;
      var date =
        moment()
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var obj = {
        date: date,
        herdId: vm.selectedHerds[0],
        comment: vm.modalComment,
        endDate: end_date,
        startDate: start_date,
        locale: lng,
        dashboardId: paramName
          ? vm.currentDashboard + paramName
          : vm.currentDashboard,
        filter: filterUrl,
      };
      return herdDashboardsService
        .addToReport(obj)
        .then(function (response) {
          closeModal();
        })
        .catch(function (error) {
            console.log(error);
            vm.addToReportModalLoading = false;
          });
      }
    

    function getCurrentLngId(id, lng) {
      var dashboardList = angular.copy(
        APP_CONSTANTS.constants.zoetisDashboardIdLngList
      );
      //find internal id
      var internal_id;
      for (var i = 0; i < dashboardList.length; i++) {
        if (dashboardList[i].id == id) {
          internal_id = dashboardList[i].internal_id;
          break;
        }
      }
      var translated_id;
      //find language id for current language
      if (internal_id) {
        for (var i = 0; i < dashboardList.length; i++) {
          if (
            internal_id == dashboardList[i].internal_id &&
            lng == dashboardList[i].lng
          ) {
            translated_id = dashboardList[i].id;
            break;
          }
        }
      }
      if (translated_id) {
        id = translated_id;
      }
      return id;
    }

    function openCreateReport() {
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      vm.report_title = i18nFilter("_zts_report_title_default_");
      if (os.name == "iOS" && brw.name == "Mobile Safari") {
        vm.safariMobileUsed = true;
      } else {
        vm.safariMobileUsed = false;
      }
      vm.reportDate = new Date();
      vm.showCreateReportBlock = true;
      vm.reportLoading = true;
      vm.pdfLoading = false;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        herdsPromise = $q.defer();
        addToReportPromise = $q.defer();
        dashboardsPromise = $q.defer();
        $q.all([
          herdsPromise.promise,
          addToReportPromise.promise,
          dashboardsPromise.promise,
        ])
          .then(function () {
            vm.reportError = false;
            vm.reportDashboards = checkForAddedToReport(
              vm.allReportDashboards,
              vm.addedToReport
            );
            if (vm.reportDashboards.length) {
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            } else {
              vm.showCreateReportBlock = false;
              vm.noAvailableDashboards = true;
              vm.reportLoading = false;
              vm.herdNotSelected = false;
            }
          })
          .catch(function (error) {
            bugsnagService.logUnhandledError(error);
            vm.reportLoading = false;
            vm.reportError = true;
            vm.pdfLoading = false;
          });
        getAddedToReport(true, vm.reportDate, true);
        var herd_id = vm.selectedHerds[0];
        checkHerds(herd_id);
        checkAllDashboards();
      } else {
        vm.reportLoading = false;
        $interval.cancel(loadingDotsInterval);
        vm.herdNotSelected = true;
      }
    }

    function checkHerds(herd_id) {
      if (
        rapService.loadedHerds &&
        rapService.loadedHerds.herds &&
        rapService.loadedHerds.herds.length &&
        rapService.loadedHerds.team_id &&
        rapService.loadedHerds.team_id == vm.selectedTeam
      ) {
        vm.currentHerdName = getHerdNameById(
          herd_id,
          rapService.loadedHerds.herds
        );
        herdsPromise.resolve();
      } else {
        return herdDashboardsService
          .getHerdsByTeam(vm.selectedTeam)
          .then(function (response) {
            vm.currentHerdName = getHerdNameById(herd_id, response);
            herdsPromise.resolve();
          })
          .catch(function (error) {
            herdsPromise.reject();
          });
      }
    }

    function checkAllDashboards() {
      vm.allReportDashboards = getZoetisDashboards(vm.allDashboards);
      dashboardsPromise.resolve();
    }

    function setReportDate() {
      vm.reportDateOpened = false;
      if (vm.reportDate) {
        getAddedToReport(false, vm.reportDate, true);
      }
    }

    function getZoetisDashboards(dashboards) {
      var list = [];
      var listOfDashboardsIds = [];
      var currentLng = vm.currentLng;
      for (
        var i = 0;
        i < APP_CONSTANTS.constants.zoetisDashboardIdLngList.length;
        i++
      ) {
        if (
          APP_CONSTANTS.constants.zoetisDashboardIdLngList[i].lng == currentLng
        ) {
          listOfDashboardsIds.push(
            APP_CONSTANTS.constants.zoetisDashboardIdLngList[i]
          );
        }
      }
      for (var i = 0; i < dashboards.length; i++) {
        if (dashboards[i].addToReport) {
          dashboards[i].start_date = vm.start_date;
          dashboards[i].end_date = vm.end_date;
          for (var j = 0; j < listOfDashboardsIds.length; j++) {
            if (listOfDashboardsIds[j].id == dashboards[i].id) {
              dashboards[i].index = listOfDashboardsIds[j].index;
              dashboards[i].size = listOfDashboardsIds[j].size;
            }
          }
          list.push(dashboards[i]);
        }
      }
      return list;
    }

    function getHerdNameById(herd_id, herds) {
      var herdName = "";
      for (var i = 0; i < herds.length; i++) {
        if (herds[i].Id == herd_id) {
          herdName = herds[i].Name;
          break;
        }
      }
      return herdName;
    }

    function openReportDashboardPeriodModal(index) {
      vm.report_modal_start_date = vm.reportDashboards[index].start_date;
      vm.report_modal_end_date = vm.reportDashboards[index].end_date;
      vm.selectedReportDashboardIndex = index;
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.setRangeModalLoading = false;
      openModal(
        "app/pages/herds/dashboards/reportRangeSelector.modal.html",
        "sm"
      );
    }

    function openReportCommentModal(index) {
      vm.selectedReportDashboard = angular.copy(vm.reportDashboards[index]);
      vm.selectedReportDashboardIndex = index;
      vm.addCommentModalLoading = false;
      openModal("app/pages/herds/dashboards/reportComment.modal.html", "sm");
    }

    function setReportDashboardComment() {
      vm.addCommentModalLoading = true;
      var end_date =
        moment(vm.selectedReportDashboard.end_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var start_date =
        moment(vm.selectedReportDashboard.start_date)
          .hour(0)
          .minute(0)
          .seconds(0)
          .milliseconds(0)
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      if (vm.selectedReportDashboard.entry_id) {
        var obj = {
          id: vm.selectedReportDashboard.entry_id,
          comment: vm.selectedReportDashboard.comment,
          endDate: end_date,
          startDate: start_date,
          locale: vm.selectedReportDashboard.locale,
          dashboardId: vm.selectedReportDashboard.id,
        };
        return herdDashboardsService
          .updateReportEntry(obj.id, obj)
          .then(function (response) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
              vm.selectedReportDashboard.comment;
            closeModal();
          })
          .catch(function (error) {
            console.log(error);
            vm.addCommentModalLoading = false;
          });
      } else {
        vm.reportDashboards[vm.selectedReportDashboardIndex].comment =
          vm.selectedReportDashboard.comment;
        closeModal();
      }
    }

    function setReportDashboardRange() {
      var range_error = checkRangeError(
        vm.selectedReportDashboard.actual,
        vm.report_modal_start_date,
        vm.report_modal_end_date
      );
      if (!range_error) {
        vm.setRangeModalLoading = true;
        if (vm.selectedReportDashboard.entry_id) {
          var end_date =
            moment(vm.report_modal_end_date)
              .hour(0)
              .minute(0)
              .seconds(0)
              .milliseconds(0)
              .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          if (vm.selectedReportDashboard.actual) {
            var start_date =
              moment(vm.report_modal_end_date)
                .subtract(7, "days")
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          } else {
            var start_date =
              moment(vm.report_modal_start_date)
                .hour(0)
                .minute(0)
                .seconds(0)
                .milliseconds(0)
                .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
          }
          var obj = {
            id: vm.selectedReportDashboard.entry_id,
            comment: vm.selectedReportDashboard.comment,
            endDate: end_date,
            startDate: start_date,
            locale: vm.selectedReportDashboard.locale,
            dashboardId: vm.selectedReportDashboard.id,
            filter: vm.selectedReportDashboard.filter,
          };
          return herdDashboardsService
            .updateReportEntry(obj.id, obj)
            .then(function (response) {
              vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
                vm.report_modal_end_date;
              if (vm.selectedReportDashboard.actual) {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = new Date(
                  moment(vm.report_modal_end_date).subtract(7, "days")
                );
              } else {
                vm.reportDashboards[
                  vm.selectedReportDashboardIndex
                ].start_date = vm.report_modal_start_date;
              }
              closeModal();
            })
            .catch(function (error) {
              console.log(error);
              vm.setRangeModalLoading = false;
            });
        } else {
          vm.reportDashboards[vm.selectedReportDashboardIndex].end_date =
            vm.report_modal_end_date;
          if (vm.selectedReportDashboard.actual) {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              new Date(moment(vm.report_modal_end_date).subtract(7, "days"));
          } else {
            vm.reportDashboards[vm.selectedReportDashboardIndex].start_date =
              vm.report_modal_start_date;
          }
          closeModal();
        }
      }
    }

    function checkRangeError(actual_open, start_date, end_date) {
      var error = false;
      var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
      if (today.isBefore(end_date)) {
        error = true;
      }
      if (!actual_open) {
        if (moment(end_date).isBefore(start_date)) {
          error = true;
        }
      }
      return error;
    }

    function setReportData() {
      if (
        vm.currentUserType == "zoetis" &&
        !herdDashboardsService.excludeUsers(vm.user)
      ) {
        try {
          gtag("event", "dashboard|Create report");
        } catch (error) {
          console.log(error);
        }
      }

      vm.errorLoadingReports = false;
      var parser = new UAParser();
      var brw = parser.getBrowser();
      var os = parser.getOS();
      vm.reportLoading = true;
      vm.pdfLoading = true;
      loadingDotsCounter = 0;
      loadingDotsInterval = $interval(function () {
        if (loadingDotsCounter == 0) {
          vm.loadingDots = ".";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 1) {
          vm.loadingDots = "..";
          loadingDotsCounter++;
        } else if (loadingDotsCounter == 2) {
          vm.loadingDots = "...";
          loadingDotsCounter = 0;
        }
      }, 400);
      var list = [];
      for (var i = 0; i < vm.reportDashboards.length; i++) {
        if (vm.reportDashboards[i].selected) {
          list.push(vm.reportDashboards[i]);
        }
      }
      vm.orderedDashboards = $filter("orderBy")(list, "index");
      var url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        var name = "pr" + i;
        vm[name] = $q.defer();
        url_promise_list.push(vm[name].promise);
        getImageUrl(vm.orderedDashboards[i].url, i, name);
      }

      function getImageUrl(url, index, name) {
        if (vm.work_locally) {
          var image_url = "assets/img/thumbnails/open_cows.png?4564545";
          vm.orderedDashboards[index].image_url = image_url;
          vm.orderedDashboards[index].image_loaded = true;
          vm[name].resolve();
        } else {
          return herdDashboardsService
            .setSession(url)
            .then(function (response) {
              var image_url = response.headers("tabvis-location");
              vm.orderedDashboards[index].image_url = image_url;
              vm.orderedDashboards[index].image_loaded = true;
              vm[name].resolve();
            })
            .catch(function (error) {
              vm[name].resolve();
            });
        }
      }
      $q.all(url_promise_list)
        .then(function () {
          setDataUrls(vm.orderedDashboards);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function setDataUrls() {
      var image_url_promise_list = [];
      for (var i = 0; i < vm.orderedDashboards.length; i++) {
        if (vm.orderedDashboards[i].image_loaded) {
          var name = "imgpr" + i;
          vm[name] = $q.defer();
          image_url_promise_list.push(vm[name].promise);
          var image_url = setImageUrl(vm.orderedDashboards[i]);
          getDataUrl(image_url, i, name);
        }
      }
      vm.logoPrm = $q.defer();
      vm.logoMmmPrm = $q.defer();
      image_url_promise_list.push(vm.logoPrm.promise);
      image_url_promise_list.push(vm.logoMmmPrm.promise);
      toDataURL(
        "assets/img/zoetis_logo.png",
        function (dataUrl) {
          vm.logo = dataUrl;
          vm.logoPrm.resolve();
        },
        "logoPrm"
      );

      toDataURL(
        "assets/img/logo_mmm.png",
        function (dataUrl) {
          vm.logoMmm = dataUrl;
          vm.logoMmmPrm.resolve();
        },
        "logoMmmPrm"
      );
      $q.all(image_url_promise_list)
        .then(function () {
          var date = new Date();
          date = $filter("date")(date);
          var pdfData = {
            date: date,
            logo: vm.logo,
            logoMmm: vm.logoMmm,
            user: vm.user.name,
            colour_1: "#E0E0E1",
            colour_2: "#ff661f",
            colour_text: "#666666",
            red: "red",
            positive_points: vm.positivePoints ? vm.positivePoints : "",
            points_to_improve: vm.pointsToImprove ? vm.pointsToImprove : "",
            herd_name: vm.currentHerdName,
            dashboards: vm.orderedDashboards,
            title: vm.report_title,
          };
          createPDF(pdfData);
        })
        .catch(function (error) {
          vm.reportLoading = false;
          vm.reportError = true;
          vm.pdfLoading = false;
        });
    }

    function getDataUrl(url, index, name) {
      toDataURL(
        url,
        function (dataUrl) {
          vm.orderedDashboards[index].image = dataUrl;
          vm[name].resolve();
        },
        name
      );
    }

    function toDataURL(url, callback, prm) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        if (xhr.status == 200 || xhr.status == 204) {
          reader.readAsDataURL(xhr.response);
        } else {
          vm[prm].reject();
        }
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.withCredentials = true;
      xhr.send();
    }

    function setImageUrl(dashboard) {
      var image_url;
      var size = "1280,720";
      var splitted = dashboard.image_url.split("?");
      if (vm.work_locally) {
        image_url = splitted[0];
      } else {
        image_url = splitted[0] + ".png";
      }
      var start_date = moment(dashboard.start_date).format("YYYY-MM-DD");
      var end_date = moment(dashboard.end_date).format("YYYY-MM-DD");
      var herd = vm.selectedHerds[0];
      var suffix =
        "?Start%20Date=" +
        start_date +
        "&End%20Date=" +
        end_date +
        "&HerdIdentifier=" +
        herd +
        "&Herd%20Parameter=" +
        herd;

      image_url = image_url + suffix;
      if (dashboard.filter) {
        image_url = image_url + dashboard.filter;
      }

      if (dashboard.size) {
        image_url = image_url + "&:size=" + dashboard.size;
      } else {
        image_url = image_url + "&:size=" + size;
      }
      image_url = image_url.replaceAll("+", "%2B");
      image_url = image_url.replaceAll("≥3", "%E2%89%A53");
      image_url = image_url.replaceAll("≥2", "%E2%89%A52");
      return image_url;
    }

    function createPDF(pdfData) {
      var dd = {
        pageMargins: [20, 60, 20, 70],
        pageSize: "A4",
        defaultStyle: {
          font: "Arboria",
        },
        header: function (page) {
          if (page == 1)
            return {
              image: pdfData.logoMmm,
              width: 150,
              alignment: "left",
              margin: [50, 30, 0, 20],
            };
          else
            return {
              margin: [30, 30, 0, 20],
              image: pdfData.logoMmm,
              width: 110,
              alignment: "left",
            };
        },
        content: [
          {
            text: pdfData.title,
            alignment: "left",
            fontSize: 23,
            bold: true,
            color: pdfData.colour_2,
            margin: [40, 80, 40, 25],
          },
          {
            text: i18nFilter("_zts_report_text_"),
            alignment: "left",
            fontSize: 12,
            color: pdfData.colour_text,
            margin: [40, 0, 40, 12],
            font: "Arial",
          },
          {
            text: i18nFilter("_label_herd_") + ": " + pdfData.herd_name,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdfData.colour_text,
            margin: [40, 7, 40, 0],
            font: "Arial",
          },
          {
            text: i18nFilter("_label_date_") + ": " + pdfData.date,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdfData.colour_text,
            margin: [40, 7, 40, 0],
            font: "Arial",
          },
          {
            text: i18nFilter("_title_vet_") + ": " + pdfData.user,
            alignment: "left",
            fontSize: 12,
            bold: true,
            color: pdfData.colour_text,
            margin: [40, 7, 40, 22],
            font: "Arial",
          },
          {
            margin: [40, 0, 40, 25],
            table: {
              widths: [465],
              heights: ["auto", 150],
              body: [
                [
                  {
                    text: i18nFilter("_report_positive_points_") + ":",
                    color: pdfData.colour_2,
                    fontSize: 14,
                    border: [true, true, true, false],
                    bold: true,
                  },
                ],
                [
                  {
                    text: pdfData.positive_points,
                    color: pdfData.colour_text,
                    fontSize: 12,
                    border: [true, false, true, true],
                    width: 465,
                    height: 150,
                    font: "Arial",
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdfData.colour_1,
              vLineColor: pdfData.colour_1,
            },
          },
          {
            margin: [40, 0, 40, 0],
            table: {
              widths: [465],
              heights: ["auto", 150],

              body: [
                [
                  {
                    text: i18nFilter("_report_points_to_improve_") + ":",
                    color: pdfData.colour_2,
                    fontSize: 14,
                    border: [true, true, true, false],
                    bold: true,
                  },
                ],
                [
                  {
                    text: pdfData.points_to_improve,
                    color: pdfData.colour_text,
                    fontSize: 12,
                    border: [true, false, true, true],
                    height: 150,
                    width: 465,
                    font: "Arial",
                  },
                ],
              ],
            },
            layout: {
              hLineColor: pdfData.colour_1,
              vLineColor: pdfData.colour_1,
            },
          },
        ],
      };
      var c = 0;
      var s = 0;
      for (var i = 0; i < pdfData.dashboards.length; i++) {
        var obj = {};
        var table = {
          margin: [10, 30, 10, 10],
          table: {
            dontBreakRows: true,
            widths: ["*"],

            body: [
              [
                {
                  image: pdfData.dashboards[i].image,
                  width: 500,
                  border: [true, true, true, true],
                },
              ],
              [
                {
                  text: pdfData.dashboards[i].comment
                    ? pdfData.dashboards[i].comment
                    : "",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 10],
                  fontSize: 10,
                  bold: false,
                  color: pdfData.colour_text,
                },
              ],
            ],
          },
          layout: {
            hLineColor: pdfData.colour_1,
            vLineColor: pdfData.colour_1,
          },
        };
        if (
          pdfData.dashboards[i].selected &&
          pdfData.dashboards[i].image_loaded
        ) {
          c++;
          s++;
          if (
            pdfData.dashboards[i].id == "Zoetisflowchart" ||
            pdfData.dashboards[i].id == "ZoetisFlussdiagramm" ||
            pdfData.dashboards[i].id == "GraphiquedeZoetis"
          ) {
            c = 0;
            table.pageBreak = "after";
          }
          if (c != 0 && c % 2 == 0) {
            table.pageBreak = "after";
          }
          dd.content.push(table);
        }
      }
      if (s > 0) {
        dd.content[6].pageBreak = "after";
      }

      if (dd.content[dd.content.length - 1].pageBreak) {
        delete dd.content[dd.content.length - 1].pageBreak;
      }

      var reportName =
        i18nFilter("_report_title_robot_analysis_") +
        " " +
        $filter("date")(new Date(), "yyyy-MM-dd");
      var parser = new UAParser();
      var os = parser.getOS();
      var brw = parser.getBrowser();
      var device = parser.getDevice();
      pdfMake.fonts = {
        Arboria: {
          normal: "Arboria-Bold.ttf",
          bold: "Arboria-Bold.ttf",
          italics: "Arboria-Bold.ttf",
          bolditalics: "Arboria-Bold.ttf",
        },
        Arial: {
          normal: "arial.ttf",
          bold: "arialbd.ttf",
          italics: "arial.ttf",
          bolditalics: "arial.ttf",
        },
      };
      var pdf = pdfMake.createPdf(dd);
      var dd2 = angular.copy(dd);
      if (device && device.type) {
        if (os.name == "iOS") {
          if (brw.name == "Mobile Safari") {
            pdf.open();
          } else {
            try {
              var reader = new FileReader();
              pdf.open();
              pdf.getBlob(function (blob) {
                reader.onload = function (e) {
                  var uri = reader.result;
                  var link = document.createElement("a");
                  link.download = reportName + ".pdf";
                  link.href = uri;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                };
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              toastr.error(error);
              console.log(error);
              bugsnagService.logUnhandledError(error);
            }
          }
        } else {
          pdfMake.createPdf(dd).download(reportName);
        }
      } else {
        try {
          pdfMake.createPdf(dd).open();
        } catch (error) {
          console.log(error);
          bugsnagService.logUnhandledError(error);
          toastr.error(i18nFilter("_report_create_popup_message_"));
        }

        $timeout(function () {
          pdfMake.createPdf(dd2).download(reportName);
        }, 500);
      }
      vm.pointsToImprove = "";
      vm.positivePoints = "";
      $timeout(function () {
        vm.showCreateReportBlock = false;
        vm.reportLoading = false;
        vm.pdfLoading = false;
        $interval.cancel(loadingDotsInterval);
      }, 500);
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function reload() {
      sendShowPanicButtonEvent(false);
      vm.errorLoading = false;
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.dashboardNotAvailable = false;
      vm.embed = null;
      viz = null;
      $rootScope.$broadcast("dashboard_deselect");
    }

    function closeCreateReport() {
      vm.showCreateReportBlock = false;
      vm.pointsToImprove = "";
      vm.positivePoints = "";
    }

    function selectLayout(n) {
      vm.selectedLayout = n;
    }

    function broadcastDashboard(dashboard) {
      dashboard.selectedTime = vm.selectedTime;
      $rootScope.$broadcast("dashboard_selected", dashboard);
    }

    function sendErrorInfo(comment) {
      if (viz) {
        vm.errorInfo = {
          sheet: "",
          comment: comment,
          herds: vm.selectedHerds,
          team: vm.selectedTeam,
          mmmooogle_tenant: null,
          parameters: [],
          filters: [],
          user_id: vm.user.user_id,
          host: $location.host(),
          url: $location.url(),
          last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : "/",
          dashboard: vm.lastUsedDashboard ? vm.lastUsedDashboard.title : "/",
          last_sheet_name: vm.lastSheetName ? vm.lastSheetName : "/",
        };
        var parameters;
        var filters;
        var p = $q.defer();
        var f = $q.defer();

        var cookies = $cookies.getAll();
        angular.forEach(cookies, function (value, key) {
          if (key == "mmmooogle_tenant") {
            vm.errorInfo.mmmooogle_tenant = value;
          }
        });

        $q.all([p.promise, f.promise])
          .then(function (response) {
            var p_list = [];
            var f_list = [];

            if (parameters) {
              for (var i = 0; i < parameters.length; i++) {
                var obj = {
                  name: null,
                  value: null,
                  formated_value: null,
                };

                obj.name = parameters[i].getName();
                obj.value = parameters[i].getCurrentValue().value;
                obj.formated_value =
                  parameters[i].getCurrentValue().formattedValue;

                p_list.push(obj);
              }
            }

            if (filters) {
              for (var i = 0; i < filters.length; i++) {
                var type = filters[i].getFilterType();
                var obj = {
                  name: null,
                  value: null,
                };
                if (type == "categorical") {
                  obj.name = filters[i].getFieldName();
                  obj.value = filters[i].getAppliedValues();
                } else if (type == "quantitative") {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    d_max: filters[i].getDomainMax(),
                    d_min: filters[i].getDomainMin(),
                    max: filters[i].getMax(),
                    min: filters[i].getMin(),
                  };
                } else {
                  obj.name = filters[i].getFieldName();
                  obj.value = {
                    period: filters[i].getDomainMax(),
                    range: filters[i].getRange(),
                    rangeN: filters[i].getRangeN(),
                  };
                }
                f_list.push(obj);
              }
            }
            vm.errorInfo.parameters = p_list;
            vm.errorInfo.filters = f_list;

            var json = JSON.stringify(vm.errorInfo);
            var blob = new Blob([json], {
              type: "application/json",
            });

            var file_name =
              vm.errorInfo.user_id.replaceAll("|", "_") +
              "_" +
              vm.errorInfo.team +
              ".json";
            var file = Upload.rename(blob, file_name);

            $timeout(function () {
              Upload.upload({
                url: "https://io.mmmooogle.com/api/v1/files/upload?path=panic-button",

                data: {
                  files: file,
                },
              })
                .then(function (response) {
                  $rootScope.$broadcast("panic_button_success");
                })
                .catch(function (error) {
                  console.log(error);
                  $rootScope.$broadcast("panic_button_error");
                });
            }, 500);
          })
          .catch(function (error) {
            console.log(error);
          });

        $timeout(function () {
          if (!parameters) {
            p.resolve();
          }
          if (!filters) {
            f.resolve();
          }
        }, 3000);
        var wb = viz.getWorkbook();
        wb.getParametersAsync().then(function (_parameters) {
          parameters = _parameters;
          p.resolve();
        });

        var a_sheet = wb.getActiveSheet();
        vm.errorInfo.sheet = a_sheet.getName();
        var wrks = a_sheet.getWorksheets();

        var worksheetName;
        for (var i = 0; i < wrks.length; i++) {
          if (wrks[i].getName()) {
            worksheetName = wrks[i].getName();
            break;
          }
        }

        wrks
          .get(worksheetName)
          .getFiltersAsync()
          .then(function (_filters) {
            filters = _filters;
            f.resolve();
          });
      } else {
        vm.modalError = true;
      }
    }

    function sendShowPanicButtonEvent(event) {
      if (event) {
        $rootScope.$broadcast("show_panic_button");
      } else {
        $rootScope.$broadcast("hide_panic_button");
      }
    }

    function gtag() {
      $window.dataLayer = $window.dataLayer || [];
      dataLayer.push(arguments);
    }

    function encode(string) {
      var s = encodeURIComponent(string);
      s = s.replaceAll("(", "%28");
      s = s.replaceAll(")", "%29");
      return s;
    }

    $scope.$on("send_error_info", function (event, data) {
      if (data.state == "herds.dashboards") {
        sendErrorInfo(data.comment);
      }
    });

    $scope.$on("default_team_selected", function (event, data) {
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      $rootScope.$broadcast("dashboard_deselect");
      vm.dashboards = [];
      init();
    });
    $scope.$on("default_herd_selected", function (event, data) {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      if (vm.showFrame && vm.lastUsedDashboard) {
        if (herdSelectedTimer) {
          $timeout.cancel(herdSelectedTimer);
        }
        vm.showFrame = false;
        vm.loadingBaseTable = true;
        herdSelectedTimer = $timeout(function () {
          selectDashboard(vm.lastUsedDashboard, vm.lastUsedDashboardType, true);
        }, 1000);
      }
    });
    $scope.$on("dashboards_back", function () {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      if (vm.showFrame) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      } else if (vm.activeCategory) {
        vm.activeCategory = null;
        vm.activeCategoryName = null;
        vm.activeCategoryObject = null;
        goBackToDashboard();
      }
    });
    $scope.$on("category_back", function (event, data) {
      sendShowPanicButtonEvent(false);
      setBackButtonVisibility(false);
      vm.showFrame = false;
      vm.showBaseTable = true;
      vm.lastUsedDashboard = null;
      vm.lastUsedDashboardType = null;
      vm.embed = null;
      viz = null;
    });
    $scope.$on("time_selector_changed", function (event, data) {
      timeSelectorChanged(data);
    });

    $scope.$on("$destroy", function () {
      $rootScope.$broadcast("dashboard_selected", null);
      $rootScope.$broadcast("category_selected", null);
      localStorage.removeItem("dashboards-table");
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds")
    .factory("herdDashboardsService", herdDashboardsService);
  /** @ngInject */
  function herdDashboardsService($http, $q, APP_CONSTANTS) {
    return {
      getDashboards: getDashboards,
      getDashboardById: getDashboardById,
      getTableauDashboards: getTableauDashboards,
      setTableauTenant: setTableauTenant,
      getHerdsByTeam: getHerdsByTeam,
      getReports: getReports,
      addToReport: addToReport,
      updateReportEntry: updateReportEntry,
      setSession: setSession,
      excludeUsers: excludeUsers,
      tableauStored: {},
    };

    function getDashboards(team_id) {
      return $http
        .get(APP_CONSTANTS.tableau_base_url + team_id + "/dashboards", {
          withCredentials: true,
          timeout: 13000,
        })
        .then(success)
        .catch(error);
    }

    function getDashboardById(team_id, dashboard_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url +
            team_id +
            "/dashboards/" +
            dashboard_id +
            suffix,
          {
            withCredentials: true,
          }
        )
        .then(success)
        .catch(error);
    }

    function getTableauDashboards(team_id, suffix) {
      return $http
        .get(
          APP_CONSTANTS.tableau_base_url + team_id + "/dashboards" + suffix,
          {
            withCredentials: true,
            timeout: 13000,
          }
        )
        .then(success)
        .catch(error);
    }

    function setTableauTenant(team_id) {
      return $http
        .post(
          APP_CONSTANTS.tableau_base_url + team_id + "/session",
          {},
          { withCredentials: true }
        )
        .then(success)
        .catch(error);
    }

    function getHerdsByTeam(team_id) {
      return $http
        .get(APP_CONSTANTS.backoffice_base_url + "teams/" + team_id + "/herds")
        .then(success)
        .catch(error);
    }

    function getReports(suffix) {
      return $http
        .get(APP_CONSTANTS.tableau_reports_base_url + suffix, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function updateReportEntry(id, obj) {
      return $http
        .put(
          APP_CONSTANTS.tableau_reports_base_url + "/reportentry/" + id,
          obj,
          {
            withCredentials: true,
          }
        )
        .then(success)
        .catch(error);
    }

    function addToReport(obj) {
      return $http
        .post(APP_CONSTANTS.tableau_reports_base_url + "/reportentry", obj, {
          withCredentials: true,
        })
        .then(success)
        .catch(error);
    }

    function setSession(url) {
      return $http
        .get(url, {
          withCredentials: true,
        })
        .then(function (response) {
          return response;
        })
        .catch(function (response) {
          return $q.reject(response);
        });
    }

    function excludeUsers(user) {
      var user_list = [
        "auth0|5acdfe8c2735d3736e8298fe",
        "auth0|5ad5dca65fb3bc1b6d7a3ebe",
        "auth0|5ad4605f3467830fef67091f",
		"auth0|604f46844b70b10070bfc294",
		"auth0|56b37779ec9cf8243c80f211",
		"google-oauth2|108831753800092786976",
		"google-oauth2|110442934239793747425"
      ];

      if (user_list.includes(user.user_id)) {
        return true;
      }

      return false;
    }

    function success(response) {
      return response.data;
    }

    function error(error) {
      return $q.reject(error);
    }
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.herds.dashboards').directive('stPersist', function () {
		return {
			require: '^stTable',
			link: function (scope, element, attr, ctrl) {
				var nameSpace = attr.stPersist;

				//save the table state every time it changes
				scope.$watch(
					function () {
						return ctrl.tableState();
					},
					function (newValue, oldValue) {
						if (newValue !== oldValue) {
							localStorage.setItem(nameSpace, JSON.stringify(newValue));
						}
					},
					true
				);

				//fetch the table state when the directive is loaded
				if (localStorage.getItem(nameSpace)) {
					var savedState = JSON.parse(localStorage.getItem(nameSpace));
					var tableState = ctrl.tableState();

					angular.extend(tableState, savedState);
					ctrl.pipe();
				}
			}
		};
	});
})();

(function () {
	'use strict';
	angular.module('My.pages.editHerd').controller('editHerdCtrl', editHerdCtrl);
	/** @ngInject */
	function editHerdCtrl(editHerdService, $stateParams, APP_CONSTANTS, $state) {
		var vm = this;
		vm.saveHerd = saveHerd;
		vm.init = init;
		vm.cancel = cancel;
		init();

		function init() {
			setCountries();
			vm.loading = true;
			vm.herdDTO = {};
			vm.errorOccured = false;
			vm.loadingError = false;
			vm.successfullyAdded = false;
			vm.addressChanged = false;
			vm.selectPlaceholder = '_label_select_country_placeholder_';
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var herd_id = $stateParams.herd_id;
			getHerdById(herd_id)
		}


		function getHerdById(herd_id) {
			return editHerdService.getHerdById(herd_id).then(function (response) {
				vm.herdDTO = response;
				var countryCode = getCodeByCodeNumber(response.CountryCode);
				vm.selectedCountry = getCountryByCode(countryCode);
				vm.loading = false;
			}).catch(function (error) {
				console.log(error);
				vm.loading = false;
				vm.loadingError = true;
			})
		}

		function getCodeByName(name) {
			var code = 0;
			var list = APP_CONSTANTS.constants.countryCodeList
			angular.forEach(list, function (value, key) {
				if (key == name) {
					code = value;
				}
			})
			return code;
		}

		function getCountryByCode(code){
			var country;
			for(var i = 0; i < vm.countries.length; i++){
				if(vm.countries[i].code == code){
					country = vm.countries[i];
					break;
				}
			}
			return country;
		}

		function saveHerd() {
			if (!vm.herdForm.$invalid) {
				vm.loading = true;
				vm.errorOccured = false;
				var herd = angular.copy(vm.herdDTO);
				herd.Address.CountryCode = getCodeByName(vm.selectedCountry.code);
				if (vm.addressChanged) {
					herd.Latitude = null;
					herd.Longitude = null;
				}
				return editHerdService.updateHerd(herd).then(function (response) {
					$state.go('myHerds');
				}).catch(function (error) {
					console.log(error)
					vm.loading = false;
					vm.errorOccured = true;
				})
			}
		}

		function getCodeByCodeNumber(code) {
			var name = null;
			var list = APP_CONSTANTS.constants.countryCodeList
			angular.forEach(list, function (value, key) {
				if (value == code) {
					name = key;
				}
			})
			return name;
		}

		function setCountries(){
			vm.countries = angular.copy(APP_CONSTANTS.constants.countries);
		}

		function cancel(){
			$state.go('myHerds')
		}

	}
})();

(function () {
	'use strict';
	angular.module('My.pages.editHerd').factory('editHerdService', editHerdService);
	/** @ngInject */
	function editHerdService(APP_CONSTANTS, $http, $q) {
		return {
			getHerdById: getHerdById,
			updateHerd: updateHerd
			
		}

		function getHerdById(herd_id) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd_id).then(success).catch(error);
		}
		
		function updateHerd(herd) {
			return $http.post(APP_CONSTANTS.backoffice_base_url + 'herds/update', herd).then(success).catch(error);
		}
		

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();
(function () {
  "use strict";
  angular
    .module("My.pages.herds.listGeneratorV2")
    .controller("listGeneratorCtrl", listGeneratorCtrl);
  /** @ngInject */
  function listGeneratorCtrl(
    listGeneratorService,
    listGeneratorDataService,
    $filter,
    $timeout,
    APP_CONSTANTS,
    $scope,
    animalsService,
    $state,
    Upload,
    $uibModal,
    $uibModalStack,
    $q,
    $window,
    $cookies,
    $rootScope,
    $sce,
    cookiesService,
    bugsnagService
  ) {
    var vm = this;
    var filterTimer;
    var searchTimer;
    var sliderTimer;
    var Filter = $filter("filter");
    var i18nFilter = $filter("i18n");
    var animals;
    var dataPromise;
    var listsPromise;
    var orderPromise;
    vm.selectLayout = selectLayout;
    vm.selectFilter = selectFilter;
    vm.customParityChanged = customParityChanged;
    vm.tagsChanged = tagsChanged;
    vm.getAnimalClass = getAnimalClass;
    vm.removeAnimal = removeAnimal;
    vm.selectAnimal = selectAnimal;
    vm.sort = sort;
    vm.animalSearchChanged = animalSearchChanged;
    vm.addAnimal = addAnimal;
    vm.exportPdf = exportPdf;
    vm.openExportModal = openExportModal;
    vm.showNewDiscussion = showNewDiscussion;
    vm.newDiscussionSetTags = newDiscussionSetTags;
    vm.sliderChanged = sliderChanged;
    vm.tagsSliderChanged = tagsSliderChanged;
    vm.selectPictureFilter = selectPictureFilter;
    vm.selectEventFilter = selectEventFilter;
    vm.selectPredefinedList = selectPredefinedList;
    vm.paginationChanged = paginationChanged;
    vm.addStatusDateRange = addStatusDateRange;
    vm.addDIMRange = addDIMRange;
    vm.removeFromStatusDateList = removeFromStatusDateList;
    vm.removeFromDIMList = removeFromDIMList;
    vm.selectedPickerList = selectedPickerList;
    vm.openNewDiscussionModal = openNewDiscussionModal;
    vm.addNewDiscussion = addNewDiscussion;
    vm.hideFilterBlock = hideFilterBlock;
    vm.emptyList = emptyList;
    vm.selectSearchBy = selectSearchBy;
    vm.deviationSelected = deviationSelected;
    vm.selectDeviationTime = selectDeviationTime;
    vm.deviationValueChanged = deviationValueChanged;
    vm.sccValueChanged = sccValueChanged;
    vm.openSaveListModal = openSaveListModal;
    vm.saveList = saveList;
    vm.hasLongName = hasLongName;
    vm.init = init;
    vm.searchByName = true;
    vm.searchByNumber = true;
    vm.searchByEarTag = true;
    vm.selectedLayout = 1;
    vm.showFilterBlock = true;
    var filters = [
      "at_newborn",
      "at_ce_tc",
      "m_a_milk",
      "h_e_diseases",
      "h_e_prevention",
      "u_h_clinical",
      "u_h_subclinical",
      "c_h",
      "s_d",
      "sa_active",
      "sa_history",
      "st_none",
      "st_open",
      "st_served",
      "st_not_pregnant",
      "st_pregnant",
      "st_barren",
      "st_aborted",
      "st_dry",
      "st_sold",
      "st_dead",
      "st_presume_left",
      "p_zero",
      "p_one",
      "p_two",
      "p_three_and_more",
      "p_custom",
      "dim_1",
      "dim_2",
      "dim_3",
      "dim_4",
      "dim_5",
      "dim_6",
      "dim_7",
      "g_female",
      "g_male",
      "age_1",
      "age_2",
      "age_3",
      "al_mp",
      "al_scc",
      "min_dev_p",
      "min_dev_kg",
      "dev_y",
      "dev_t",
      "dev_tda",
    ];

    var predefinedLists = [
      {
        n: 13,
        id: "attention_list_scc",
        label: "_label_attention_list_scc_",
        translated: i18nFilter("_label_attention_list_scc_"),
      },
      {
        n: 1,
        id: "cows",
        label: "_label_show_cows_",
        translated: i18nFilter("_label_show_cows_"),
      },
      {
        n: 2,
        id: "female_youngstock",
        label: "_label_show_female_youngstock_",
        translated: i18nFilter("_label_show_female_youngstock_"),
      },
      {
        n: 3,
        id: "dry_cow_attention",
        label: "_label_show_to_be_dried_off_list_",
        translated: i18nFilter("_label_show_to_be_dried_off_list_"),
      },
      {
        n: 4,
        id: "open_cows",
        label: "_label_show_open_cows_",
        translated: i18nFilter("_label_show_open_cows_"),
      },
      {
        n: 5,
        id: "heat_attention",
        label: "_label_show_heat_attention_",
        translated: i18nFilter("_label_show_heat_attention_"),
      },
      {
        n: 6,
        id: "heifers_to_be_inseminated",
        label: "_label_show_heifers_to_be_inseminated_",
        translated: i18nFilter("_label_show_heifers_to_be_inseminated_"),
      },
      {
        n: 7,
        id: "preg_check",
        label: "_label_show_pregnancy_check_list_",
        translated: i18nFilter("_label_show_pregnancy_check_list_"),
      },
      {
        n: 8,
        id: "transition_cows",
        label: "_label_show_transition_cow_list_",
        translated: i18nFilter("_label_show_transition_cow_list_"),
      },
      {
        n: 9,
        id: "calving_attentions",
        label: "_label_show_calving_attention_list_",
        translated: i18nFilter("_label_show_calving_attention_list_"),
      },
      {
        n: 10,
        id: "daily_milk_production",
        label: "_label_show_daily_milk_production_",
        translated: i18nFilter("_label_show_daily_milk_production_"),
      },
      {
        n: 11,
        id: "treated_cows_heifers",
        label: "_label_show_treated_cows_heifers_",
        translated: i18nFilter("_label_show_treated_cows_heifers_"),
      },
      {
        n: 11,
        id: "attention_list_milk_production",
        label: "_label_show_attention_list_milk_production_",
        translated: i18nFilter("_label_show_attention_list_milk_production_"),
      },
      {
        n: 12,
        id: "milk_production_7_days",
        label: "_label_milk_production_last_7_days_list_",
        translated: i18nFilter("_label_milk_production_last_7_days_list_"),
      },
    ];

    $timeout(function () {
      for (var i = 0; i < predefinedLists.length; i++) {
        predefinedLists[i].translated = i18nFilter(predefinedLists[i].label);
      }
    }, 350);
    var sliderValues = [
      {
        label: "1 " + i18nFilter("_label_days_"),
        date: moment().subtract(1, "days"),
      },
      {
        label: "2 " + i18nFilter("_label_days_"),
        date: moment().subtract(2, "days"),
      },
      {
        label: "3 " + i18nFilter("_label_days_"),
        date: moment().subtract(3, "days"),
      },
      {
        label: "4 " + i18nFilter("_label_days_"),
        date: moment().subtract(4, "days"),
      },
      {
        label: "5 " + i18nFilter("_label_days_"),
        date: moment().subtract(5, "days"),
      },
      {
        label: "6 " + i18nFilter("_label_days_"),
        date: moment().subtract(6, "days"),
      },
      {
        label: "7 " + i18nFilter("_label_days_"),
        date: moment().subtract(7, "days"),
      },
      {
        label: "8 " + i18nFilter("_label_days_"),
        date: moment().subtract(8, "days"),
      },
      {
        label: "9 " + i18nFilter("_label_days_"),
        date: moment().subtract(9, "days"),
      },
      {
        label: "10 " + i18nFilter("_label_days_"),
        date: moment().subtract(10, "days"),
      },
      {
        label: "11 " + i18nFilter("_label_days_"),
        date: moment().subtract(11, "days"),
      },
      {
        label: "12 " + i18nFilter("_label_days_"),
        date: moment().subtract(12, "days"),
      },
      {
        label: "13 " + i18nFilter("_label_days_"),
        date: moment().subtract(13, "days"),
      },
      {
        label: "14 " + i18nFilter("_label_days_"),
        date: moment().subtract(14, "days"),
      },
      {
        label: i18nFilter("_label_one_month_"),
        date: moment().subtract(1, "months"),
      },
      {
        label: i18nFilter("_label_two_months_"),
        date: moment().subtract(2, "months"),
      },
      {
        label: i18nFilter("_label_qurter_"),
        date: moment().subtract(3, "months"),
      },
      {
        label: i18nFilter("_label_six_months_"),
        date: moment().subtract(6, "months"),
      },
      {
        label: i18nFilter("_label_one_year_"),
        date: moment().subtract(1, "years"),
      },
    ];

    vm.selectedStatusList = [
      {
        id: "st_global",
        label: "_label_all_",
        translated: $filter("i18n")("_label_all_"),
      },
    ];

    var picture_filter_list = ["p_profile", "p_recent", "p_oldest", "p_event"];
    var picture_filter_event_list = [
      "p_e_calving",
      "p_e_colostrum",
      "p_e_first_milk",
      "p_e_exemination",
      "p_e_tests",
      "p_e_milk_m",
      "p_e_clinical",
      "p_e_subclinical",
      "p_e_misc",
      "p_e_diseases",
      "p_e_prevention",
      "p_e_claw_health",
    ];

    init();

    function init() {
      resetShowColumns();
      toDataURL("assets/img/logo_mmm.png", function (dataurl) {
        vm.logo = dataurl;
      });
      toDataURL("assets/img/logo.png", function (dataurl) {
        vm.defaultPicture = dataurl;
      });
      var today = moment();
      var yesterday = moment().subtract(1, "days").format();
      var two_days_ago = moment().subtract(2, "days").format();
      dataPromise = $q.defer();
      orderPromise = $q.defer();
      vm.min_dev_p_value = 30;
      vm.lg1_scc = 250;
      vm.l1_scc = 150;
      vm.min_dev_kg_value = 5;
      vm.today = new Date(today.format());
      vm.yesterday = new Date(yesterday);
      vm.two_days_ago = new Date(two_days_ago);
      vm.showTable = true;
      vm.loadingTable = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.tagsList = angular.copy(APP_CONSTANTS.constants.tags);
      vm.tagsList.splice(0, 1);
      vm.sliderOptionsActive = {
        floor: 0,
        ceil: 18,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onChange: function () {
          sliderChanged();
        },
      };
      vm.tagsSliderOptionsActive = {
        floor: 0,
        ceil: 14,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onChange: function () {
          tagsSliderChanged();
        },
      };
      if (vm.defaultValues.herd_ids && vm.defaultValues.herd_ids.length == 1) {
        vm.selectedHerd = vm.defaultValues.herd_ids[0];
        setDefaultFilters();
        getAnimalData(vm.selectedHerd);
        //getLists(vm.selectedHerd);
        //getListsOrder(vm.selectedHerd);
        vm.loading = true;

        $q.all([dataPromise.promise])
          .then(function () {
            vm.lists = setLists(predefinedLists, vm.userLists, vm.listOrder);
            vm.loading = false;
          })
          .catch(function (error) {
            vm.loading = false;
            vm.errorLoading = true;
          });
      } else {
        vm.selectedHerd = null;
        vm.loading = false;
      }
    }

    function setLists(predefined_lists, user_lists, order) {
      var lists = setPositions(predefined_lists, order);
      //lists = lists.concat(user_lists).concat(predefined_lists);
      $timeout(function () {
        if (
          vm["st_not_pregnant"] ||
          vm["u_h_clinical"] ||
          vm["u_h_subclinical"]
        ) {
          if (vm["st_not_pregnant"]) {
            vm["st_not_pregnant"] = false;
            selectFilter("st_not_pregnant", 13);
          }
          if (vm["u_h_clinical"]) {
            vm["u_h_clinical"] = false;
            selectFilter("u_h_clinical", 13);
          }
          if (vm["u_h_subclinical"]) {
            vm["u_h_subclinical"] = false;
            selectFilter("u_h_subclinical", 13);
          }
        } else {
          if (vm.selectedPredefinedList) {
            setTableDimensions(vm.selectedPredefinedList);
          }
        }
        var width = document.getElementById("shortcuts").offsetWidth;
        generateShortcuts(width, lists);
      }, 100);
      return lists;
    }

    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.send();
    }

    function setEvents() {
      vm.eventsFilter = null;
    }

    function setPositions(lists, order) {
      if (order) {
        var l_order = order.counters;
        for (var i = 0; i < lists.length; i++) {
          lists[i].number = lists.length - i;
          for (var j = 0; j < l_order.length; j++) {
            if (lists[i].id == l_order[j].listId) {
              lists[i].number += l_order[j].value * 100;
            }
          }
        }
      }

      lists = $filter("orderBy")(lists, "number", true);
      return lists;
    }

    function getAnimalData(herd_id) {
      vm.errorLoading = false;
      animals = $q.defer();
      getAnimals(vm.selectedHerd);
      $q.all([animals.promise])
        .then(function () {
          vm.allAnimals = angular.copy(vm.rawAnimalData);
          if (vm.picturesToShowFilter) {
            if (vm.picturesToShowFilter == "p_event") {
              setEventPictureToShow(vm.eventsToShowFilter);
            } else {
              setPictureToShow(vm.picturesToShowFilter);
            }
          }
          if (vm.goBackActive) {
            var listOfAnimals = [];
            for (var l = 0; l < vm.animalList.list.length; l++) {
              for (var a = 0; a < vm.allAnimals.length; a++) {
                if (vm.animalList.list[l].id == vm.allAnimals[a].AnimalId) {
                  listOfAnimals.push(vm.allAnimals[a]);
                }
              }
            }
            vm.predefinedList = listOfAnimals;
            vm.animalsToShow = listOfAnimals;
            vm.animalsToShow = removeDuplicates(vm.animalsToShow);
          } else {
            if (vm.selectedPredefinedList) {
              vm.selectedPredefinedList = null;
            }
            vm.animalsToShow = filterAnimalList(vm.allAnimals);
          }
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          vm.animals = [];
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
          dataPromise.resolve();
        })
        .catch(function (error) {
          console.log(error);
          dataPromise.reject(error);
          if (error != "canceled") {
            vm.errorLoading = true;
            vm.loading = false;
          }
        });
    }

    function getLists(herd_id) {
      listGeneratorService
        .getListsByHerdId(herd_id)
        .then(function (response) {
          vm.userlistsRaw = response;
          vm.userLists = setUserLists(response);
          listsPromise.resolve();
        })
        .catch(function (error) {
          listsPromise.reject();
          console.log(error);
        });
    }

    function getListsOrder(herd_id) {
      listGeneratorService
        .getListsOrder(herd_id)
        .then(function (response) {
          vm.listOrder = response;
          orderPromise.resolve();
        })
        .catch(function (error) {
          console.log(error);
          orderPromise.reject();
        });
    }

    function setUserLists(lists) {
      var list = [];

      for (var i = 0; i < lists.length; i++) {
        var obj = {
          id: lists[i].id,
          translated: lists[i].list_name,
          user_defined: true,
        };
        list.push(obj);
      }
      return list;
    }

    function generateShortcuts(width, lists) {
      vm.showShortcutItems = true;
      var space = width - 235;
      var numberOfButtons = space / 200;
      numberOfButtons = Math.floor(numberOfButtons);
      vm.predefinedButtonsList = [];
      vm.predefinedPickerList = [];
      for (var i = 0; i < lists.length; i++) {
        if (i < numberOfButtons) {
          vm.predefinedButtonsList.push(lists[i]);
        } else {
          vm.predefinedPickerList.push(lists[i]);
        }
      }
    }

    function setCurrentAnimalList(index, list) {
      if (list.length > 100) {
        vm.showPagination = true;
        var lowerIndex = (index - 1) * 100;
        var upperIndex = index * 100;
        var updateList = [];
        for (var i = lowerIndex; i < upperIndex; i++) {
          if (list[i]) {
            updateList.push(list[i]);
          } else {
            break;
          }
        }
        vm.animals = updateList;
      } else {
        vm.showPagination = false;
        vm.animals = list;
      }
    }

    function paginationChanged() {
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      $timeout(function () {
        $window.scrollTo(0, 0);
      }, 0);
    }

    function setDefaultFilters() {
      setEvents();
      vm.pictureFilter = null;
      vm.animalList = JSON.parse(localStorage.getItem("animalList"));
      if (
        vm.animalList &&
        vm.animalList.goBack &&
        vm.animalList.state == $state.current.name &&
        vm.animalList.herdId &&
        vm.animalList.herdId == vm.selectedHerd
      ) {
        vm.goBackActive = true;
        vm.animalList.goBack = false;
        localStorage.setItem("animalList", JSON.stringify(vm.animalList));
        if (vm.animalList.filters) {
          angular.forEach(vm.animalList.filters, function (value, key) {
            vm[value] = true;
          });
        }
        if (vm.animalList.slider) {
          vm.slider_value = vm.animalList.slider;
          vm.selected_slider_value = sliderValues[vm.animalList.slider].label;
        }
        if (vm.p_custom && vm.animalList.customParity) {
          vm.custom_parity = vm.animalList.customParity;
        }
        if (vm.animalList.tags) {
          vm.tags = vm.animalList.tags;
        }
        if (vm.animalList.tagSlider) {
          vm.tag_slider_value = vm.animalList.tagSlider;
          vm.selected_tags_slider_value =
            sliderValues[vm.animalList.tagSlider].label;
        }
        if (vm.animalList.min_dev_kg_value) {
          vm.min_dev_kg_value = vm.animalList.min_dev_kg_value;
        }
        if (vm.animalList.min_dev_p_value) {
          vm.min_dev_p_value = vm.animalList.min_dev_p_value;
        }
        if (vm.animalList.l1_scc) {
          vm.l1_scc = vm.animalList.l1_scc;
        }
        if (vm.animalList.lg1_scc) {
          vm.lg1_scc = vm.animalList.lg1_scc;
        }
        if (vm.animalList.pictureFilter) {
          vm.pictureFilter = vm.animalList.pictureFilter;
          vm.picturesToShowFilter = vm.animalList.pictureFilter;
          if (vm.animalList.pictureFilter == "p_event") {
            vm.showEventSelector = true;
            if (
              vm.animalList.eventFilter != null &&
              vm.animalList.eventFilter != undefined
            ) {
              vm.eventsFilter = vm.animalList.eventFilter;
              vm.eventsToShowFilter = vm.animalList.eventFilter;
            }
          }
        } else {
          vm.pictureFilter[0] = true;
          vm.picturesToShowFilter = "p_profile";
        }
        if (vm.animalList.predefinedList) {
          vm.selectedPredefinedList = vm.animalList.predefinedList;
          for (var i = 0; i < vm.predefinedLists.length; i++) {
            if (vm.predefinedLists[i].id == vm.animalList.predefinedList) {
              vm.selectedListModel = vm.predefinedLists[i];
              break;
            }
          }
        }
        if (vm.animalList.statusDateList) {
          vm.statusDateList = vm.animalList.statusDateList;
        }
        if (vm.animalList.DIMList) {
          vm.DIMList = vm.animalList.DIMList;
        }
      } else {
        vm.goBackActive = false;
        localStorage.removeItem("animalList");
        vm.statusDateList = [];
        vm.DIMList = [];
        vm.pictureFilter = "p_profile";
        vm.picturesToShowFilter = "p_profile";
        vm.slider_value = 13;
        vm.tag_slider_value = 13;
        vm.selected_slider_value = sliderValues[13].label;
        vm.selected_tags_slider_value = sliderValues[13].label;
        vm.min_dev_kg = true;
        vm.min_dev_p = true;
        vm.dev_y = true;
        vm.sa_active = true;
        vm.g_female = true;
      }
    }

    function selectFilter(key, skipfilter) {
      vm[key] = !vm[key];
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        if (key == "u_h_clinical") {
          if (vm["u_h_clinical"]) {
            vm.order = "DESC";
            vm.sortedColumn = "NrMastCurLact";
            vm.sort_col = "NrMastCurLact_DESC";
          }
        }
        if (key == "u_h_subclinical") {
          if (vm["u_h_subclinical"]) {
            vm.order = "DESC";
            vm.sortedColumn = "NrMastCurLact";
            vm.sort_col = "NrMastCurLact_DESC";
          }
        }
        if (skipfilter != 13) {
          vm.animalsToShow = filterAnimalList(vm.allAnimals);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
        }

        if (
          key == "st_none" ||
          key == "st_open" ||
          key == "st_served" ||
          key == "st_not_pregnant" ||
          key == "st_pregnant" ||
          key == "st_barren" ||
          key == "st_aborted" ||
          key == "st_dry" ||
          key == "st_sold" ||
          key == "st_dead" ||
          key == "st_presume_left"
        ) {
          setStatusDateList(key, vm[key]);
        }

        if (key == "s_d" && vm[key]) {
          setStatusDateList();
        }

        setTableDimensions();
      }, 696);
    }

    function setStatusDateList(key, value) {
      var list = [
        {
          id: "st_global",
          label: "_label_all_",
          translated: $filter("i18n")("_label_all_"),
        },
      ];

      var status_list = [
        "st_none",
        "st_open",
        "st_served",
        "st_not_pregnant",
        "st_pregnant",
        "st_barren",
        "st_aborted",
        "st_dry",
        "st_sold",
        "st_dead",
        "st_presume_left",
      ];

      for (var i = 0; i < status_list.length; i++) {
        if (vm[status_list[i]]) {
          var obj = getStatusObject(status_list[i]);
          if (obj) {
            list.push(obj);
          }
        }
      }

      vm.selectedStatusList = list;

      if (value && key) {
        var item = vm.selectedStatusList.findIndex(function (element) {
          return element.id == key;
        });
        if (item == -1) {
          vm.selectedStatus =
            vm.selectedStatusList[vm.selectedStatusList.length - 1];
        } else {
          vm.selectedStatus = vm.selectedStatusList[item];
        }
      } else {
        vm.selectedStatus =
          vm.selectedStatusList[vm.selectedStatusList.length - 1];
      }
    }

    function getStatusObject(key) {
      var obj;
      switch (key) {
        case "st_none":
          obj = {
            id: "st_none",
            label: "_animal_status_none_",
            translated: $filter("i18n")("_animal_status_none_"),
            status: 0,
          };
          break;
        case "st_open":
          obj = {
            id: "st_open",
            label: "_animal_status_open_",
            translated: $filter("i18n")("_animal_status_open_"),
            status: 1,
          };
          break;
        case "st_served":
          obj = {
            id: "st_served",
            label: "_animal_status_inseminated_",
            translated: $filter("i18n")("_animal_status_inseminated_"),
            status: 3,
          };
          break;
        case "st_not_pregnant":
          obj = {
            id: "st_not_pregnant",
            label: "_animal_status_not_pregnant_",
            translated: $filter("i18n")("_animal_status_not_pregnant_"),
            status: 4,
          };
          break;
        case "st_pregnant":
          obj = {
            id: "st_pregnant",
            label: "_animal_status_pregnant_",
            translated: $filter("i18n")("_animal_status_pregnant_"),
            status: 5,
          };
          break;
        case "st_barren":
          obj = {
            id: "st_barren",
            label: "_animal_status_barren_",
            translated: $filter("i18n")("_animal_status_barren_"),
            status: 6,
          };
          break;
        case "st_aborted":
          obj = {
            id: "st_aborted",
            label: "_animal_status_aborted_",
            translated: $filter("i18n")("_animal_status_aborted_"),
            status: 7,
          };
          break;
        case "st_dry":
          obj = {
            id: "st_dry",
            label: "_animal_status_dry_",
            translated: $filter("i18n")("_animal_status_dry_"),
            status: 8,
          };
          break;
        case "st_sold":
          obj = {
            id: "st_sold",
            label: "_animal_status_sold_",
            translated: $filter("i18n")("_animal_status_sold_"),
            status: 9,
          };
          break;
        case "st_dead":
          obj = {
            id: "st_dead",
            label: "_animal_status_dead_",
            translated: $filter("i18n")("_animal_status_dead_"),
            status: 10,
          };
          break;
        case "st_presume_left":
          obj = {
            id: "st_presume_left",
            label: "_animal_status_presume_left_",
            translated: $filter("i18n")("_animal_status_presume_left_"),
            status: 11,
          };
          break;
        case "st_global":
          obj = {
            id: "st_global",
            label: "_label_all_",
            translated: $filter("i18n")("_label_all_"),
            status: 99,
          };
          break;

        default:
          break;
      }

      return obj;
    }

    function deviationSelected(key) {
      vm[key] = !vm[key];
      if (key == "min_dev_p") {
        if (!vm[key] && !vm.min_dev_kg) {
          vm.min_dev_kg = true;
        }
      } else if (key == "min_dev_kg") {
        if (!vm[key] && !vm.min_dev_p) {
          vm.min_dev_p = true;
        }
      }
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function selectDeviationTime(key) {
      if (!vm[key]) {
        if (key == "dev_t") {
          vm.dev_t = true;
          vm.dev_y = false;
          vm.dev_tda = false;
        } else if (key == "dev_y") {
          vm.dev_t = false;
          vm.dev_y = true;
          vm.dev_tda = false;
        } else if (key == "dev_tda") {
          vm.dev_t = false;
          vm.dev_y = false;
          vm.dev_tda = true;
        }
      }
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function deviationValueChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function sccValueChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function selectedPickerList() {
      selectPredefinedList(vm.selectedListModel, true);
    }

    function emptyList() {
      deselectAllFilters();
      vm.animalsToShow = [];
      vm.animals = [];
      vm.totalAnimals = 0;
    }

    function selectPredefinedList(list, picker) {
      var type = list.id;
      if (vm.selectedPredefinedList == type) {
        vm.selectedPredefinedList = null;
        vm.selectedListModel = null;
        setTableDimensions("default");
        deselectAllFilters();
        setDefaultFilters();
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        checkComments();
      } else {
        if (!picker) {
          vm.selectedListModel = null;
        }
        deselectAllFilters();
        vm.selectedPredefinedList = type;
        sendDataToEventBus(type);
        //updateFavorites(type);

        if (!list.user_defined) {
          var list = [];
          if (vm.allAnimals.length > 0) {
            if (type == "transition_cows") {
              selectPredefinedFilters("transition_cows");
              list = Filter(vm.allAnimals, function (el) {
                return el.Parity >= 0 && el.DIM < 30;
              });
              list = $filter("orderBy")(list, "DIM");
            } else if (type == "calving_attentions") {
              selectPredefinedFilters("calving_attentions");
              list = Filter(vm.allAnimals, function (el) {
                if (el.ExpectedCalvingDate) {
                  var difference = moment(el.ExpectedCalvingDate).diff(
                    moment(),
                    "days"
                  );
                  return (
                    el.ExpectedCalvingDate &&
                    difference > -60 &&
                    difference < 30
                  );
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "DaysSinceLastHI", true);
            } else if (type == "dry_cow_attention") {
              selectPredefinedFilters("dry_cow_attention");
              list = Filter(vm.allAnimals, function (el) {
                if (el.ExpectedDryDate) {
                  var difference = moment(el.ExpectedDryDate).diff(
                    moment(),
                    "days"
                  );
                  return el.CurrentStatus == 5 && difference > -60;
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "ExpectedDryDate");
            } else if (type == "preg_check") {
              selectPredefinedFilters("preg_check");
              list = Filter(vm.allAnimals, function (el) {
                if (el.StatusDate) {
                  var difference = moment(el.StatusDate).diff(moment(), "days");
                  return (
                    el.CurrentStatus == 3 &&
                    difference <= -28 &&
                    difference >= -100
                  );
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "StatusDate");
            } else if (type == "cows") {
              selectPredefinedFilters("cows");
              list = Filter(vm.allAnimals, function (el) {
                return el.Parity && el.Parity > 0 && el.IsOnFarm;
              });
            } else if (type == "female_youngstock") {
              selectPredefinedFilters("female_youngstock");
              list = Filter(vm.allAnimals, function (el) {
                return el.Gender == 0 && el.Parity == 0 && el.IsOnFarm;
              });
            } else if (type == "heat_attention") {
              selectPredefinedFilters("heat_attention");
              list = Filter(vm.allAnimals, function (el) {
                var status_date =
                  moment().diff(moment(el.StatusDate), "days") + 1;
                return (
                  el.IsOnFarm &&
                  el.Parity >= 0 &&
                  el.CurrentStatus == 3 &&
                  ((status_date > 17 && status_date < 25) ||
                    (status_date > 35 && status_date < 49))
                );
              });
              list = $filter("orderBy")(list, "StatusDate");
            } else if (type == "heifers_to_be_inseminated") {
              selectPredefinedFilters("heifers_to_be_inseminated");
              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 7) &&
                  el.Age > 400 &&
                  el.Parity == 0
                );
              });
              list = $filter("orderBy")(list, "BirthDate");
            } else if (type == "open_cows") {
              selectPredefinedFilters("open_cows");
              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 7) &&
                  el.Parity > 0
                );
              });
              list = $filter("orderBy")(list, "LastCalvingDate");
            } else if (type == "daily_milk_production") {
              selectPredefinedFilters("daily_milk_production");
              list = Filter(vm.allAnimals, function (el) {
                return el.IsOnFarm && el.Gender == 0 && el.Parity > 0;
              });
            } else if (type == "treated_cows_heifers") {
              selectPredefinedFilters("treated_cows_heifers");
              list = Filter(vm.allAnimals, function (el) {
                var hasTag = false;
                if (el.LactPics && el.LactPics.length > 0) {
                  for (var j = 0; j < el.LactPics.length; j++) {
                    if (
                      el.LactPics[j].Tags &&
                      el.LactPics[j].Tags.length > 0 &&
                      moment(el.LactPics[j].D).isAfter(
                        sliderValues[vm.tag_slider_value].date
                      ) &&
                      el.LactPics[j].Tags.indexOf("TreatedCows") != -1
                    ) {
                      hasTag = true;
                      break;
                    }
                  }
                }
                if (el.Tags && !hasTag) {
                  var tags = el.Tags.split("#");
                  for (var t = 0; t < tags.length; t++) {
                    if (tags[t].indexOf("TreatedCows") != -1) {
                      hasTag = true;
                      break;
                    }
                  }
                }
                return el.IsOnFarm && el.Gender == 0 && hasTag;
              });
            } else if (type == "attention_list_milk_production") {
              selectPredefinedFilters("attention_list_milk_production");
              list = Filter(vm.allAnimals, function (el) {
                var lwm_index;
                if (vm.dev_t) {
                  lwm_index = 0;
                } else if (vm.dev_y) {
                  lwm_index = 1;
                } else if (vm.dev_tda) {
                  lwm_index = 2;
                }
                return (
                  el.IsOnFarm &&
                  el.DIM > 14 &&
                  el.LastWeekMilk &&
                  el.LastWeekMilk[lwm_index].v &&
                  el.LastWeekMilkRecords >= 3 &&
                  el.LastWeekMilk[lwm_index].dev_kg > vm.min_dev_kg_value &&
                  el.LastWeekMilk[lwm_index].dev_percent > vm.min_dev_p_value
                );
              });
            } else if (type == "milk_production_7_days") {
              selectPredefinedFilters("milk_production_7_days");

              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  el.Parity > 0 &&
                  el.Gender == 0 &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 3 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 5)
                );
              });

              list = $filter("orderBy")(list, "MilkSort");
            } else if (type == "attention_list_scc") {
              selectPredefinedFilters("attention_list_scc");

              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  el.LastMilkRecording &&
                  el.LastMilkRecording.SCC &&
                  ((el.Parity == 1 && el.LastMilkRecording.SCC > vm.l1_scc) ||
                    (el.Parity > 1 && el.LastMilkRecording.SCC > vm.lg1_scc))
                );
              });
            }
          }
          vm.predefinedList = list;
          vm.animalsToShow = list;
          vm.animalsToShow = removeDuplicates(vm.animalsToShow);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
        } else {
          var list_raw = vm.userlistsRaw.find(function (item) {
            return item.id == list.id;
          });

          if (list_raw) {
            angular.forEach(list_raw, function (value, key) {
              if (
                key == "st_none" ||
                key == "st_open" ||
                key == "st_served" ||
                key == "st_not_pregnant" ||
                key == "st_pregnant" ||
                key == "st_barren" ||
                key == "st_aborted" ||
                key == "st_dry" ||
                key == "st_sold" ||
                key == "st_dead" ||
                key == "st_presume_left" ||
                key == "s_d" ||
                key == "p_zero" ||
                key == "p_one" ||
                key == "p_two" ||
                key == "p_three_and_more" ||
                key == "p_custom" ||
                key == "custom_parity" ||
                key == "dim_1" ||
                key == "dim_2" ||
                key == "dim_3" ||
                key == "dim_4" ||
                key == "dim_5" ||
                key == "dim_6" ||
                key == "dim_7" ||
                key == "age_1" ||
                key == "age_2" ||
                key == "age_3" ||
                key == "tag_slider_value" ||
                key == "g_male" ||
                key == "g_female" ||
                key == "sa_active" ||
                key == "sa_history" ||
                key == "at_ce_tc" ||
                key == "m_a_milk" ||
                key == "h_e_diseases" ||
                key == "h_e_prevention" ||
                key == "u_h_clinical" ||
                key == "u_h_subclinical" ||
                key == "c_h" ||
                key == "al_mp" ||
                key == "al_scc" ||
                key == "min_dev_p" ||
                key == "min_dev_p_value" ||
                key == "l1_scc" ||
                key == "lg1_scc" ||
                key == "min_dev_kg" ||
                key == "min_dev_kg_value" ||
                key == "dev_t" ||
                key == "dev_y" ||
                key == "dev_tda"
              ) {
                vm[key] = value;
              }

              if (key == "s_days") {
                vm.statusDateList = getStatusDateList(value);
              }

              if (key == "tags") {
                vm.tags = getTags(value);
              }

              if (vm.tags && vm.tags.length) {
                vm.selected_tags_slider_value =
                  sliderValues[vm.tag_slider_value].label;
                vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
              }

              if (key == "image_filter") {
                vm.pictureFilter = value;
              }

              if (vm.pictureFilter == "p_event") {
                vm.showEventSelector = true;
              } else {
                vm.showEventSelector = false;
              }

              if (key == "image_event_filter") {
                vm.eventsFilter = value;
              }

              if (key == "e_slider_value") {
                vm.slider_value = value;
              }
            });

            if (vm.tags && vm.tags.length) {
              vm.selected_tags_slider_value =
                sliderValues[vm.tag_slider_value].label;
              vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
            }

            if (
              vm.at_ce_tc ||
              vm.m_a_milk ||
              vm.h_e_diseases ||
              vm.h_e_prevention ||
              vm.u_h_clinical ||
              vm.u_h_subclinical ||
              vm.c_h
            ) {
              vm.selected_slider_value = sliderValues[vm.slider_value].label;
              vm.selected_slider = sliderValues[vm.slider_value];
            }

            if (vm.s_d) {
              setStatusDateList();
            }

            vm.animalsToShow = filterAnimalList(vm.allAnimals);
            vm.totalAnimals = vm.animalsToShow.length;
            vm.currentPage = 1;
            setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
            checkComments();
          }
        }
        $timeout(function () {
          setTableDimensions();
        }, 50);
      }
    }

    function getStatusDateList(list) {
      for (var i = 0; i < list.length; i++) {
        list[i].uuid = uuidv4();
        var status = getStatusObject(list[i].status);
        if (status) {
          list[i].label = status.label;
          list[i].status_label = status.label
            ? $filter("i18n")(status.label)
            : "";
        }
      }

      return list;
    }

    function getTags(tags) {
      var list = [];
      if (tags) {
        var l_tags = tags.split("#");
        for (var i = 0; i < l_tags.length; i++) {
          for (var j = 0; j < vm.tagsList.length; j++) {
            if (l_tags[i] == vm.tagsList[j].value) {
              list.push(vm.tagsList[j]);
            }
          }
        }
      }
      return list;
    }

    function setTableDimensions(type) {
      vm.showTable = false;
      setShowColumns();
      $timeout(function () {
        vm.showTable = true;
      }, 10);
    }

    function sendDataToEventBus(type) {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      // then to call it, plus stitch in '4' in the third group
      var guid = (
        S4() +
        S4() +
        "-" +
        S4() +
        "-4" +
        S4().substr(0, 3) +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      ).toLowerCase();
      var user = JSON.parse(localStorage.getItem("user_profile"));
      var eb_object = {
        event_type: "mymmmooogle",
        event_id: guid,
        source_id: "NlhcYlJF3qLmUApBigr5iaH7u4DNcMaW",
        timestamp: new Date().toISOString(),
        payload: {
          user: user.user_id,
          subject: "predefined_list",
          subject_id: type,
        },
      };
      return listGeneratorService
        .sendDataToEventBus(eb_object)
        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        });
    }

    function updateFavorites(type) {
      var list = {
        list_id: type,
      };
      listGeneratorService
        .updateOrder(list, vm.selectedHerd)
        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        });
    }

    function selectPredefinedFilters(type) {
      resetSelectedStatus();
      if (type == "cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.g_female = true;
        vm.p_three_and_more = true;
      } else if (type == "female_youngstock") {
        vm.g_female = true;
        vm.p_zero = true;
      } else if (type == "calving_attentions") {
        vm.st_pregnant = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 250,
          to: 300,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
      } else if (type == "dry_cow_attention") {
        vm.st_pregnant = true;
        vm.s_d = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.g_female = true;
        vm.p_three_and_more = true;
        var obj = {
          uuid: uuidv4(),
          from: 220,
          to: 300,
          status: vm.selectedStatus.id,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
      } else if (type == "open_cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_open = true;
        vm.st_not_pregnant = true;
        vm.st_aborted = true;
        vm.g_female = true;
      } else if (type == "heat_attention") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 18,
          to: 24,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
        var obj1 = {
          uuid: uuidv4(),
          from: 36,
          to: 48,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj1);
      } else if (type == "heifers_to_be_inseminated") {
        vm.st_open = true;
        vm.st_not_pregnant = true;
        vm.st_aborted = true;
        vm.p_zero = true;
        vm.age_3 = true;
        vm.g_female = true;
      } else if (type == "preg_check") {
        vm.st_served = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 28,
          to: 34,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
        var obj1 = {
          uuid: uuidv4(),
          from: 35,
          to: 99,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj1);
      } else if (type == "transition_cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.dim_1 = true;
        vm.g_female = true;
      } else if (type == "daily_milk_production") {
        vm.g_female = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_none = true;
        vm.st_open = true;
        vm.st_served = true;
        vm.st_not_pregnant = true;
        vm.st_not_pregnant = true;
        vm.st_pregnant = true;
        vm.st_barren = true;
        vm.st_aborted = true;
      } else if (type == "treated_cows_heifers") {
        vm.g_female = true;
        vm.tags = [
          {
            value: "TreatedCows",
            label: "Treated Cows",
            group: "All",
            trackByIndex: 58,
          },
        ];
      } else if (type == "attention_list_milk_production") {
        vm.al_mp = true;
        vm.min_dev_p = true;
        vm.min_dev_kg = true;
        vm.dev_y = true;
      } else if (type == "milk_production_7_days") {
        vm.g_female = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_open = true;
        vm.st_served = true;
        vm.st_not_pregnant = true;
        vm.st_pregnant = true;
      } else if (type == "attention_list_scc") {
        vm.al_scc = true;
      }
    }

    function resetSelectedStatus() {
      vm.selectedStatusList = [
        {
          id: "st_global",
          label: "_label_all_",
          translated: $filter("i18n")("_label_all_"),
        },
      ];

      vm.selectedStatus = vm.selectedStatusList[0];
    }

    function deselectAllFilters() {
      angular.forEach(filters, function (value, key) {
        if (value != "sa_active") {
          vm[value] = false;
        } else {
          vm[value] = true;
        }
      });
      vm.tags = [];
      vm.statusDateList = [];
    }

    function selectPictureFilter(type) {
      if (type != vm.pictureFilter) {
        vm.pictureFilter = type;

        if (type == "p_event") {
          vm.showEventSelector = true;
        } else {
          setPictureToShow(type);
          vm.showEventSelector = false;
        }
      }
    }

    function selectEventFilter(type) {
      if (type != vm.eventsFilter) {
        vm.eventsFilter = type;
        setEventPictureToShow(type);
      }
    }

    function setEventPictureToShow(type) {
      if (type == "p_e_calving") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCaP) {
            image = vm.allAnimals[i];
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_colostrum") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCoP) {
            image = vm.allAnimals[i].LCoP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_first_milk") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMIP) {
            image = vm.allAnimals[i].LMIP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_exemination") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LObP) {
            image = vm.allAnimals[i].LObP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_tests") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LTeP) {
            image = vm.allAnimals[i].LTeP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_milk_m") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMMP) {
            image = vm.allAnimals[i].LMMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_clinical") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCMP) {
            image = vm.allAnimals[i].LCMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_subclinical") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LSMP) {
            image = vm.allAnimals[i].LSMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_misc") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMiscP) {
            image = vm.allAnimals[i].LMiscP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_diseases") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LDP) {
            image = vm.allAnimals[i].LDP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_prevention") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LPP) {
            image = vm.allAnimals[i].LPP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_claw_health") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCHP) {
            image = vm.allAnimals[i].LCHP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      }
      vm.hideImage = true;
      $timeout(function () {
        vm.hideImage = false;
      }, 100);
    }

    function setPictureToShow(type) {
      if (type == "p_profile") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].PP) {
            image = vm.allAnimals[i].PP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_recent") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LP) {
            image = vm.allAnimals[i].LP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_oldest") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].FP) {
            image = vm.allAnimals[i].FP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
        }
      }
      vm.hideImage = true;
      $timeout(function () {
        vm.hideImage = false;
      }, 100);
    }

    function setAnimalPicture(id, picture) {
      if (vm.animals) {
        for (var i = 0; i < vm.animals.length; i++) {
          if (vm.animals[i].AnimalId == id) {
            vm.animals[i].PictureToShow = picture;
            break;
          }
        }
      }
    }

    function setAnimalToShowPicture(id, picture) {
      if (vm.animals) {
        for (var i = 0; i < vm.animals.length; i++) {
          if (vm.animalsToShow[i].AnimalId == id) {
            vm.animalsToShow[i].PictureToShow = picture;
            break;
          }
        }
      }
    }

    function customParityChanged() {
      if (vm.p_custom) {
        if (filterTimer) {
          $timeout.cancel(filterTimer);
        }
        filterTimer = $timeout(function () {
          vm.animalsToShow = filterAnimalList(vm.allAnimals);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        }, 696);
      }
    }

    function tagsChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function sliderChanged() {
      vm.selected_slider_value = sliderValues[vm.slider_value].label;
      vm.selected_slider = sliderValues[vm.slider_value];
      if (sliderTimer) {
        $timeout.cancel(sliderTimer);
      }
      sliderTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function tagsSliderChanged() {
      vm.selected_tags_slider_value = sliderValues[vm.tag_slider_value].label;
      vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
      if (sliderTimer) {
        $timeout.cancel(sliderTimer);
      }
      sliderTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function addStatusDateRange(type) {
      if (type == 1) {
        if (vm.s_d_from && vm.s_d_to && vm.s_d_from <= vm.s_d_to) {
          var obj = {
            uuid: uuidv4(),
            from: vm.s_d_from,
            to: vm.s_d_to,
            status:
              vm.selectedStatus && vm.selectedStatus.id
                ? vm.selectedStatus.id
                : null,
            status_v:
              vm.selectedStatus && vm.selectedStatus.status
                ? vm.selectedStatus.status
                : null,
            status_label:
              vm.selectedStatus && vm.selectedStatus.label
                ? $filter("i18n")(vm.selectedStatus.label)
                : "",
            type: type,
          };
          if (vm.statusDateList.length == 0) {
            vm.statusDateList.push(obj);
          } else {
            if (checkStatusDateList(obj)) {
              vm.statusDateList.push(obj);
            }
          }
        }
      } else {
        if (vm.s_d_less || vm.s_d_greater) {
          if (vm.s_d_less) {
            var obj = {
              uuid: uuidv4(),
              from: 1,
              to: vm.s_d_less,
              status:
                vm.selectedStatus && vm.selectedStatus.id
                  ? vm.selectedStatus.id
                  : null,
              status_v:
                vm.selectedStatus && vm.selectedStatus.status
                  ? vm.selectedStatus.status
                  : null,
              status_label:
                vm.selectedStatus && vm.selectedStatus.label
                  ? $filter("i18n")(vm.selectedStatus.label)
                  : "",
              type: type,
              ineq: 1,
            };

            if (vm.statusDateList.length == 0) {
              vm.statusDateList.push(obj);
            } else {
              if (checkStatusDateList(obj)) {
                vm.statusDateList.push(obj);
              }
            }
          }

          if (vm.s_d_greater) {
            var obj = {
              uuid: uuidv4(),
              from: vm.s_d_greater,
              to: 99999,
              status:
                vm.selectedStatus && vm.selectedStatus.id
                  ? vm.selectedStatus.id
                  : null,
              status_v:
                vm.selectedStatus && vm.selectedStatus.status
                  ? vm.selectedStatus.status
                  : null,
              status_label:
                vm.selectedStatus && vm.selectedStatus.label
                  ? $filter("i18n")(vm.selectedStatus.label)
                  : "",
              type: type,
              ineq: 2,
            };

            if (vm.statusDateList.length == 0) {
              vm.statusDateList.push(obj);
            } else {
              if (checkStatusDateList(obj)) {
                vm.statusDateList.push(obj);
              }
            }
          }
        }
      }

      function checkStatusDateList(object) {
        var addObject = true;
        for (var i = 0; i < vm.statusDateList.length; i++) {
          if (object.uuid == vm.statusDateList[i].uuid) {
            object.uuid = object.uuid + "xz";
          }
          if (
            object.from == vm.statusDateList[i].from &&
            object.to == vm.statusDateList[i].to &&
            object.status == vm.statusDateList[i].status &&
            object.type == vm.statusDateList[i].type
          ) {
            addObject = false;
            break;
          }
        }
        return addObject;
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      resetStatusDates();
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function addDIMRange(type) {
      if (type == 1) {
        if (vm.dim_7_from && vm.dim_7_to && vm.dim_7_from <= vm.dim_7_to) {
          var obj = {
            uuid: uuidv4(),
            from: vm.dim_7_from,
            to: vm.dim_7_to,
            type: type,
          };
          if (vm.DIMList.length == 0) {
            vm.DIMList.push(obj);
          } else {
            if (checkDIMList(obj)) {
              vm.DIMList.push(obj);
            }
          }
        }
      } else {
        if (vm.dim_7_less || vm.dim_7_greater) {
          if (vm.dim_7_less) {
            var obj = {
              uuid: uuidv4(),
              from: 1,
              to: vm.dim_7_less,
              type: type,
              ineq: 1,
            };

            if (vm.DIMList.length == 0) {
              vm.DIMList.push(obj);
            } else {
              if (checkDIMList(obj)) {
                vm.DIMList.push(obj);
              }
            }
          }

          if (vm.dim_7_greater) {
            var obj = {
              uuid: uuidv4(),
              from: vm.dim_7_greater,
              to: 99999,
              type: type,
              ineq: 2,
            };

            if (vm.DIMList.length == 0) {
              vm.DIMList.push(obj);
            } else {
              if (checkDIMList(obj)) {
                vm.DIMList.push(obj);
              }
            }
          }
        }
      }

      function checkDIMList(object) {
        var addObject = true;
        for (var i = 0; i < vm.DIMList.length; i++) {
          if (object.uuid == vm.DIMList[i].uuid) {
            object.uuid = object.uuid + "xz";
          }
          if (
            object.from == vm.DIMList[i].from &&
            object.to == vm.DIMList[i].to &&
            object.type == vm.DIMList[i].type
          ) {
            addObject = false;
            break;
          }
        }
        return addObject;
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      resetDIM();
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function resetStatusDates() {
      vm.s_d_from = null;
      vm.s_d_to = null;
      vm.s_d_less = null;
      vm.s_d_greater = null;
    }

    function resetDIM() {
      vm.dim_7_from = null;
      vm.dim_7_to = null;
      vm.dim_7_less = null;
      vm.dim_7_greater = null;
    }

    function uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    }

    function removeFromStatusDateList(item) {
      for (var i = 0; i < vm.statusDateList.length; i++) {
        if (item.uuid == vm.statusDateList[i].uuid) {
          vm.statusDateList.splice(i, 1);
          break;
        }
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function removeFromDIMList(item) {
      for (var i = 0; i < vm.DIMList.length; i++) {
        if (item.uuid == vm.DIMList[i].uuid) {
          vm.DIMList.splice(i, 1);
          break;
        }
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function filterAnimalList(animals) {
      var list = [];
      if (animals && animals.length > 0) {
        animals = checkGender(animals);
        animals = checkShowAnimals(animals);
        animals = checkAnimalEvents(animals);
        animals = checkStatus(animals);
        //animals = checkStatusDate(animals);
        animals = checkParity(animals);
        animals = checkAge(animals);
        animals = checkDIM(animals);
        animals = checkTags(animals);
        animals = checkDeviation(animals);
        animals = checkScc(animals);

        function checkGender(list) {
          if (vm.g_female || vm.g_male) {
            var female = [];
            var male = [];
            if (vm.g_female) {
              female = Filter(list, function (el) {
                return el.Gender == 0;
              });
            }
            if (vm.g_male) {
              male = Filter(list, function (el) {
                return el.Gender == 1;
              });
            }
            return female.concat(male);
          } else {
            return list;
          }
        }

        function checkAnimalEvents(list) {
          if (
            vm.at_newborn ||
            vm.at_ce_tc ||
            vm.m_a_milk ||
            vm.h_e_diseases ||
            vm.h_e_prevention ||
            vm.u_h_clinical ||
            vm.u_h_subclinical ||
            vm.c_h
          ) {
            var newborn = [];
            if (vm.at_newborn) {
              newborn = Filter(list, function (el) {
                var found = false;
                for (var i = 0; i < el.Pictures.length; i++) {
                  if (
                    el.Pictures[i].Tags &&
                    el.Pictures[i].ImageCreated &&
                    el.Pictures[i].Tags.indexOf("#NewbornCalves") != -1 &&
                    moment(el.Pictures[i].ImageCreated).isAfter(
                      sliderValues[vm.slider_value].date
                    )
                  ) {
                    found = true;
                    break;
                  }
                }
                return found;
              });
            }
            var at_ce_tc = [];
            if (vm.at_ce_tc) {
              at_ce_tc = Filter(list, function (el) {
                return (
                  el.LastClinicalExamTransition &&
                  moment(el.LastClinicalExamTransition).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var m_a_milk = [];
            if (vm.m_a_milk) {
              m_a_milk = Filter(list, function (el) {
                return (
                  el.LastManualMilkDate &&
                  moment(el.LastManualMilkDate).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var h_e_diseases = [];
            if (vm.h_e_diseases) {
              h_e_diseases = Filter(list, function (el) {
                return (
                  el.LastDiseaseEvent &&
                  moment(el.LastDiseaseEvent).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var h_e_prevention = [];
            if (vm.h_e_prevention) {
              h_e_prevention = Filter(list, function (el) {
                return (
                  el.LastPreventionEvent &&
                  moment(el.LastPreventionEvent).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var u_h_clinical = [];
            if (vm.u_h_clinical) {
              u_h_clinical = Filter(list, function (el) {
                return (
                  el.LastClinicalMastitis &&
                  moment(el.LastClinicalMastitis).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var u_h_subclinical = [];
            if (vm.u_h_subclinical) {
              u_h_subclinical = Filter(list, function (el) {
                return (
                  el.LastSubClinicalMastitis &&
                  moment(el.LastSubClinicalMastitis).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var c_h = [];
            if (vm.c_h) {
              c_h = Filter(list, function (el) {
                return (
                  el.LastClawHealthDate &&
                  moment(el.LastClawHealthDate).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var returnList = [];
            returnList = concatWithoutDuplicates(returnList, newborn);
            returnList = concatWithoutDuplicates(returnList, at_ce_tc);
            returnList = concatWithoutDuplicates(returnList, m_a_milk);
            returnList = concatWithoutDuplicates(returnList, h_e_diseases);
            returnList = concatWithoutDuplicates(returnList, h_e_prevention);
            returnList = concatWithoutDuplicates(returnList, u_h_clinical);
            returnList = concatWithoutDuplicates(returnList, u_h_subclinical);
            returnList = concatWithoutDuplicates(returnList, c_h);
            return returnList;
          } else {
            return list;
          }
        }

        function checkShowAnimals(list) {
          if (vm.sa_active || vm.sa_history) {
            var active = [];
            var history = [];
            if (vm.sa_active) {
              active = Filter(list, function (el) {
                return el.IsOnFarm == true;
              });
            }
            if (vm.sa_history) {
              history = Filter(list, function (el) {
                return el.IsOnFarm == false;
              });
            }
            var returnList = active.concat(history);
            return returnList;
          } else {
            return list;
          }
        }

        function checkStatus(list) {
          if (
            vm.s_d ||
            vm.st_none ||
            vm.st_open ||
            vm.st_served ||
            vm.st_not_pregnant ||
            vm.st_pregnant ||
            vm.st_barren ||
            vm.st_aborted ||
            vm.st_dry ||
            vm.st_sold ||
            vm.st_dead ||
            vm.st_presume_left
          ) {
            var global = [];

            var use_global = vm.statusDateList.find(function (status) {
              return status.status == "st_global";
            });

            if (use_global) {
              global = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                list,
                "st_global"
              );
            }

            var none = [];
            if (vm.st_none) {
              none = Filter(list, function (el) {
                return el.CurrentStatus == 0;
              });

              none = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                none,
                "st_none"
              );
            }
            var open = [];
            if (vm.st_open) {
              open = Filter(list, function (el) {
                return el.CurrentStatus == 1;
              });

              open = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                open,
                "st_open"
              );
            }
            var served = [];
            if (vm.st_served) {
              served = Filter(list, function (el) {
                return el.CurrentStatus == 3;
              });
              served = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                served,
                "st_served"
              );
            }
            var not_pregnant = [];
            if (vm.st_not_pregnant) {
              not_pregnant = Filter(list, function (el) {
                return el.CurrentStatus == 4;
              });
              not_pregnant = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                not_pregnant,
                "st_not_pregnant"
              );
            }
            var pregnant = [];
            if (vm.st_pregnant) {
              pregnant = Filter(list, function (el) {
                return el.CurrentStatus == 5;
              });
              pregnant = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                pregnant,
                "st_pregnant"
              );
            }
            var barren = [];
            if (vm.st_barren) {
              barren = Filter(list, function (el) {
                return el.CurrentStatus == 6;
              });
              barren = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                barren,
                "st_barren"
              );
            }
            var aborted = [];
            if (vm.st_aborted) {
              aborted = Filter(list, function (el) {
                return el.CurrentStatus == 7;
              });
              aborted = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                aborted,
                "st_aborted"
              );
            }
            var dry = [];
            if (vm.st_dry) {
              dry = Filter(list, function (el) {
                return el.CurrentStatus == 8;
              });
              dry = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                dry,
                "st_dry"
              );
            }
            var sold = [];
            if (vm.st_sold) {
              sold = Filter(list, function (el) {
                return el.CurrentStatus == 9;
              });
              sold = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                sold,
                "st_sold"
              );
            }
            var dead = [];
            if (vm.st_dead) {
              dead = Filter(list, function (el) {
                return el.CurrentStatus == 10;
              });
              dead = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                dead,
                "st_dead"
              );
            }
            var presume_left = [];
            if (vm.st_presume_left) {
              presume_left = Filter(list, function (el) {
                return el.CurrentStatus == 11;
              });
              presume_left = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                presume_left,
                "st_presume_left"
              );
            }
            var returnList = global
              .concat(none)
              .concat(open)
              .concat(served)
              .concat(not_pregnant)
              .concat(pregnant)
              .concat(barren)
              .concat(aborted)
              .concat(dry)
              .concat(sold)
              .concat(dead)
              .concat(presume_left);
            return returnList;
          } else {
            return list;
          }
        }

        function filterByStatusDate(
          is_filter_active,
          status_list,
          animal_list,
          status
        ) {
          if (is_filter_active) {
            var cs_status_list = Filter(status_list, function (el) {
              return el.status == status;
            });

            if (cs_status_list && cs_status_list.length) {
              var s_d = [];
              for (var i = 0; i < cs_status_list.length; i++) {
                var l = Filter(animal_list, function (el) {
                  var statusDate =
                    moment().diff(moment(el.StatusDate), "days") + 1;
                  if (cs_status_list[i].status_v) {
                    return (
                      statusDate > cs_status_list[i].from - 1 &&
                      statusDate < cs_status_list[i].to + 1 &&
                      el.CurrentStatus == cs_status_list[i].status_v
                    );
                  }
                  return (
                    statusDate > cs_status_list[i].from - 1 &&
                    statusDate < cs_status_list[i].to + 1
                  );
                });
                s_d = concatWithoutDuplicates(s_d, l);
              }
              return s_d;
            } else {
              return animal_list;
            }
          } else {
            return animal_list;
          }
        }

        function checkParity(list) {
          if (
            vm.p_zero ||
            vm.p_one ||
            vm.p_two ||
            vm.p_three_and_more ||
            vm.p_custom
          ) {
            var one = [];
            var two = [];
            var three = [];
            var custom = [];
            var zero = [];
            if (vm.p_zero) {
              zero = Filter(list, function (el) {
                return el.Parity == 0;
              });
            }
            if (vm.p_one) {
              one = Filter(list, function (el) {
                return el.Parity == 1;
              });
            }
            if (vm.p_two) {
              two = Filter(list, function (el) {
                return el.Parity == 2;
              });
            }
            if (vm.p_three_and_more) {
              three = Filter(list, function (el) {
                return el.Parity > 2;
              });
            }
            if (vm.p_custom) {
              if (vm.custom_parity != undefined) {
                custom = Filter(list, function (el) {
                  return el.Parity == vm.custom_parity;
                });
              } else {
                custom = list;
              }
            }
            var returnList = [];
            returnList = concatWithoutDuplicates(returnList, zero);
            returnList = concatWithoutDuplicates(returnList, one);
            returnList = concatWithoutDuplicates(returnList, two);
            returnList = concatWithoutDuplicates(returnList, three);
            returnList = concatWithoutDuplicates(returnList, custom);
            return returnList;
          } else {
            return list;
          }
        }

        function checkDIM(list) {
          var today = moment();
          if (
            vm.dim_1 ||
            vm.dim_2 ||
            vm.dim_3 ||
            vm.dim_4 ||
            vm.dim_5 ||
            vm.dim_6 ||
            (vm.dim_7 && vm.DIMList.length)
          ) {
            var dim_1 = [];
            if (vm.dim_1) {
              dim_1 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 0 && dim < 30;
              });
            }
            var dim_2 = [];
            if (vm.dim_2) {
              dim_2 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 29 && dim < 61;
              });
            }
            var dim_3 = [];
            if (vm.dim_3) {
              dim_3 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 59 && dim < 121;
              });
            }
            var dim_4 = [];
            if (vm.dim_4) {
              dim_4 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 119 && dim < 201;
              });
            }
            var dim_5 = [];
            if (vm.dim_5) {
              dim_5 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 199 && dim < 306;
              });
            }
            var dim_6 = [];
            if (vm.dim_6) {
              dim_6 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 305;
              });
            }
            var dim_7 = [];
            if (vm.dim_7 && vm.DIMList.length) {
              for (var i = 0; i < vm.DIMList.length; i++) {
                var l = Filter(list, function (el) {
                  var dim = today.diff(el.LastCalvingDate, "days") + 1;
                  return (
                    dim > vm.DIMList[i].from - 1 && dim < vm.DIMList[i].to + 1
                  );
                });
                dim_7 = concatWithoutDuplicates(dim_7, l);
              }
            }
            var returnList = dim_1
              .concat(dim_2)
              .concat(dim_3)
              .concat(dim_4)
              .concat(dim_5)
              .concat(dim_6);

            returnList = concatWithoutDuplicates(returnList, dim_7);
            return returnList;
          } else {
            return list;
          }
        }

        function checkAge(list) {
          if (vm.age_1 || vm.age_2 || vm.age_3) {
            var age_1 = [];
            if (vm.age_1) {
              age_1 = Filter(list, function (el) {
                return el.Age > 0 && el.Age < 200;
              });
            }
            var age_2 = [];
            if (vm.age_2) {
              age_2 = Filter(list, function (el) {
                return el.Age > 199 && el.Age < 401;
              });
            }
            var age_3 = [];
            if (vm.age_3) {
              age_3 = Filter(list, function (el) {
                return el.Age > 400;
              });
            }
            var returnList = age_1.concat(age_2).concat(age_3);
            return returnList;
          } else {
            return list;
          }
        }

        function checkTags(list) {
          if (vm.tags && vm.tags.length > 0) {
            var returnList = Filter(list, function (el) {
              var insert = false;
              if (el.LactPics && el.LactPics.length > 0) {
                for (var i = 0; i < vm.tags.length; i++) {
                  for (var j = 0; j < el.LactPics.length; j++) {
                    if (
                      el.LactPics[j].Tags &&
                      el.LactPics[j].Tags.length > 0 &&
                      moment(el.LactPics[j].D).isAfter(
                        sliderValues[vm.tag_slider_value].date
                      ) &&
                      el.LactPics[j].Tags.indexOf(vm.tags[i].value) != -1
                    ) {
                      insert = true;
                      break;
                    }
                  }
                }
              }
              if (el.Tags && !insert) {
                var tags = el.Tags.split("#");
                for (var i = 0; i < vm.tags.length; i++) {
                  for (var t = 0; t < tags.length; t++) {
                    if (tags[t].indexOf(vm.tags[i].value) != -1) {
                      insert = true;
                      break;
                    }
                  }
                }
              }
              return insert;
            });
            return returnList;
          } else {
            return list;
          }
        }

        function checkDeviation(list) {
          if (vm.al_mp) {
            if (vm.min_dev_p || vm.min_dev_kg) {
              if (vm.min_dev_p) {
                list = Filter(list, function (el) {
                  var lwm_index;
                  if (vm.dev_t) {
                    lwm_index = 0;
                  } else if (vm.dev_y) {
                    lwm_index = 1;
                  } else if (vm.dev_tda) {
                    lwm_index = 2;
                  }
                  return el.LastWeekMilk
                    ? el.LastWeekMilk[lwm_index].dev_percent >
                        vm.min_dev_p_value
                    : false;
                });
              }
              if (vm.min_dev_kg) {
                list = Filter(list, function (el) {
                  var lwm_index;
                  if (vm.dev_t) {
                    lwm_index = 0;
                  } else if (vm.dev_y) {
                    lwm_index = 1;
                  } else if (vm.dev_tda) {
                    lwm_index = 2;
                  }
                  return el.LastWeekMilk
                    ? el.LastWeekMilk[lwm_index].dev_kg > vm.min_dev_kg_value
                    : false;
                });
              }
              return list;
            } else {
              return list;
            }
          } else {
            return list;
          }
        }
        function checkScc(list) {
          if (vm.al_scc) {
            list = Filter(list, function (el) {
              return (
                el.IsOnFarm &&
                el.LastMilkRecording &&
                el.LastMilkRecording.SCC &&
                ((el.Parity == 1 && el.LastMilkRecording.SCC > vm.l1_scc) ||
                  (el.Parity > 1 && el.LastMilkRecording.SCC > vm.lg1_scc))
              );
            });

            return list;
          } else {
            return list;
          }
        }
        animals = orderList(animals);
        animals = removeDuplicates(animals);
        return animals;
      } else {
        return animals;
      }
    }

    function concatWithoutDuplicates(list1, list2) {
      for (var i = 0; i < list2.length; i++) {
        if (checkAnimalList(list1, list2[i])) {
          list1.push(list2[i]);
        }
      }
      return list1;

      function checkAnimalList(list, animal) {
        var doInsert = true;
        for (var i = 0; i < list.length; i++) {
          if (list[i].AnimalId == animal.AnimalId) {
            doInsert = false;
            break;
          }
        }
        return doInsert;
      }
    }

    function getAnimalClass(animal) {
      return animal.animalClass;
    }

    function getAnimals(herd_id) {
      return listGeneratorService
        .getAnimals(herd_id)
        .then(function (response) {
          if (herd_id == vm.selectedHerd) {
            var today = moment();
            for (var i = 0; i < response.length; i++) {
              if (response[i].LastCalvingDate) {
                response[i].DIM =
                  today.diff(response[i].LastCalvingDate, "days") + 1;
              }

              response[i].Age = today.diff(response[i].BirthDate, "days") + 1;
              if (response[i].LastHeatInseminationDate) {
                response[i].DaysSinceLastHI = today.diff(
                  response[i].LastHeatInseminationDate,
                  "days"
                );
              }
              if (response[i].PP) {
                response[i].PictureToShow = response[i].PP;
              } else {
                response[i].PictureToShow = null;
              }
              if (response[i].StatusDate) {
                response[i].DateString = $filter("date")(
                  response[i].StatusDate,
                  "shortDate"
                );
              }
              if (response[i].CurrentStatus == 0) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_none_"
                );
                response[i].animalClass = "animal-none";
              } else if (response[i].CurrentStatus == 1) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_open_"
                );
                response[i].animalClass = "animal-open";
              } else if (response[i].CurrentStatus == 3) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_inseminated_"
                );
                response[i].animalClass = "animal-served";
              } else if (response[i].CurrentStatus == 4) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_not_pregnant_"
                );
                response[i].animalClass = "animal-non-pregnant";
              } else if (response[i].CurrentStatus == 5) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_pregnant_"
                );
                response[i].animalClass = "animal-pregnant";
              } else if (response[i].CurrentStatus == 6) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_barren_"
                );
                response[i].animalClass = "animal-barren";
              } else if (response[i].CurrentStatus == 7) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_aborted_"
                );
              } else if (response[i].CurrentStatus == 8) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_dry_"
                );
                response[i].animalClass = "animal-dry";
              } else if (response[i].CurrentStatus == 9) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_sold_"
                );
              } else if (response[i].CurrentStatus == 10) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_dead_"
                );
              } else if (response[i].CurrentStatus == 11) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_presume_left_"
                );
              }
              response[i].Comments = null;
              if (
                response[i].LastCalvingDate &&
                moment(response[i].LastHeatInseminationDate).isBefore(
                  response[i].LastCalvingDate
                )
              ) {
                response[i].LastHeatInseminationDate = null;
              }
              response[i].StatusDays =
                today.diff(response[i].StatusDate, "days") + 1;
              if (response[i].CurrentStatus == 8) {
                response[i].DaysDry = response[i].StatusDays;
                response[i].DIM = response[i].DIM - response[i].DaysDry + 1;
              }
              response[i].NumberOfInseminations = response[i].NrInsCurLact;
              if (response[i].LastWeekMilk) {
                response[i].LastWeekMilk.reverse();
                if (response[i].LastWeekMilk[0]) {
                  response[i].MilkSort = response[i].LastWeekMilk[0];
                } else {
                  response[i].MilkSort = 0;
                }
                var c = 0;
                var sum = 0;
                var last_date;
                for (var j = 0; j < response[i].LastWeekMilk.length; j++) {
                  if (
                    response[i].LastWeekMilk[j] !== null &&
                    response[i].LastWeekMilk[j] !== undefined
                  ) {
                    c++;
                    sum += response[i].LastWeekMilk[j];
                  }
                  var obj = {
                    v: response[i].LastWeekMilk[j],
                    d: moment().subtract(j, "days").format(),
                  };
                  if (obj.v) {
                    if (!last_date) {
                      last_date = obj.d;
                    }
                  }
                  if (sum && c) {
                    response[i].Avg_MP = sum / c;
                    response[i].LastWeekMilkRecords = c;
                  }
                  response[i].LastWeekMilk[j] = obj;
                }
                for (var j = 0; j < response[i].LastWeekMilk.length; j++) {
                  if (response[i].LastWeekMilk[j].v) {
                    response[i].LastWeekMilk[j].dev_kg = round(
                      Math.abs(
                        response[i].LastWeekMilk[j].v - response[i].Avg_MP
                      ),
                      2
                    );
                    response[i].LastWeekMilk[j].dev_percent = round(
                      (response[i].LastWeekMilk[j].dev_kg /
                        response[i].Avg_MP) *
                        100,
                      2
                    );
                  }
                }
                response[i].LastWeekMilkSvg = $sce.trustAsHtml(
                  response[i].LastWeekMilkSvg
                );
                response[i].LastWeekMilkSort = last_date;
              } else {
                response[i].MilkSort = 0;
              }

              if (
                response[i].LastClinicalMastitis &&
                response[i].LastSubClinicalMastitis
              ) {
                if (
                  moment(response[i].LastClinicalMastitis).isAfter(
                    response[i].LastSubClinicalMastitis
                  )
                ) {
                  response[i].LastMastitis = response[i].LastClinicalMastitis;
                } else {
                  response[i].LastMastitis =
                    response[i].LastSubClinicalMastitis;
                }
              } else if (response[i].LastClinicalMastitis) {
                response[i].LastMastitis = response[i].LastClinicalMastitis;
              } else if (response[i].LastSubClinicalMastitis) {
                response[i].LastMastitis = response[i].LastSubClinicalMastitis;
              }
              if (response[i].LastMastitis) {
              }
            }
            vm.rawAnimalData = response;
            animals.resolve();
          }
        })
        .catch(function (error) {
          animals.reject();
          vm.loading = false;
        });
    }

    function sort(column) {
      if (!vm.loadingTable) {
        var col;
        if (column != vm.sortedColumn) {
          vm.sortedColumn = column;
          vm.order = "ASC";
          col = column + "_" + vm.order;
        } else {
          if (vm.order == "ASC") {
            vm.order = "DESC";
            col = column + "_" + vm.order;
          } else if (vm.order == "DESC") {
            vm.order = null;
            vm.sortedColumn = null;
            col = null;
          }
        }
        vm.sort_col = col;
        vm.animalsToShow = orderList(vm.animalsToShow);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        if (vm.searchAnimals && vm.searchAnimals.length > 0) {
          vm.searchAnimals = orderList(vm.searchAnimals);
        }
      }
    }

    function orderList(list) {
      var order;
      if (vm.order == "ASC") {
        order = false;
      } else if (vm.order == "DESC") {
        order = true;
      }
      if (vm.sortedColumn) {
        list = $filter("orderBy")(list, vm.sortedColumn, order);
      } else {
        if (!vm.selectedPredefinedList) {
          list = $filter("orderBy")(list, "Number");
        }
      }
      return list;
    }

    function selectAnimal(animal) {
      var activeFilters = [];
      angular.forEach(filters, function (value, key) {
        if (vm[value]) {
          activeFilters.push(value);
        }
      });
      var animalList = [];
      for (var i = 0; i < vm.animals.length; i++) {
        if (vm.animals[i].PictureToShow) {
          var obj = {
            id: vm.animals[i].AnimalId,
            p_id: vm.animals[i].PictureToShow.Id,
            p: vm.animals[i].PictureToShow.I,
            d: vm.animals[i].PictureToShow.D,
            number: vm.animals[i].Number,
            pictureImageUrl: vm.animals[i].PictureToShow.I,
            EarTag: vm.animals[i].EarTag,
          };
        } else {
          var obj = {
            id: vm.animals[i].AnimalId,
            number: vm.animals[i].Number,
            EarTag: vm.animals[i].EarTag,
          };
        }
        animalList.push(obj);
      }
      var pictureFilter = vm.pictureFilter;
      var eventFilter = vm.eventsFilter;
      var data = {
        herdId: vm.selectedHerd,
        list: animalList,
        state: "herds.listGenerator",
        filters: activeFilters,
        slider: vm.slider_value,
        tagSlider: vm.tag_slider_value,
        customParity: vm.custom_parity,
        tags: vm.tags,
        pictureFilter: pictureFilter,
        eventFilter: eventFilter,
        predefinedList: vm.selectedPredefinedList,
        statusDateList: vm.statusDateList,
        min_dev_p_value: vm.min_dev_p_value,
        min_dev_kg_value: vm.min_dev_kg_value,
        l1_scc: vm.l1_scc,
        lg1_scc: vm.lg1_scc,
      };
      animalsService.animalList = data;
      localStorage.setItem("animalList", JSON.stringify(data));
      $rootScope.$broadcast("list_selected_animal");
      $state.go("animalDatails", {
        animal_id: animal.AnimalId.toString(16),
      });
    }

    function openNewDiscussionModal(animal) {
      vm.selectedAnimalId = animal.AnimalId;
      vm.discussion = {};
      vm.discussion.importance = 0;
      vm.loadingNewDiscussion = false;
      vm.discussion.created = new Date().toISOString();
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/herds/listGeneratorV2/addNewDiscussion.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function addNewDiscussion() {
      vm.loadingNewDiscussion = true;
      var suffix = "?created=" + vm.discussion.created;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix =
          suffix +
          "&tags=" +
          encodeURIComponent(vm.discussion.tags) +
          encodeURIComponent("#") +
          encodeURIComponent(setALTags());
      } else {
        suffix = suffix + "&tags=" + encodeURIComponent(setALTags());
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      return listGeneratorService
        .addNewDiscussion(vm.selectedAnimalId, suffix)
        .then(function (response) {
          vm.loadingNewDiscussion = false;
          for (var i = 0; i < vm.animals.length; i++) {
            if (vm.animals[i].AnimalId == vm.selectedAnimalId) {
              vm.animals[i].Comments = vm.discussion.comments;
            }
          }
          for (var i = 0; i < vm.animalsToShow.length; i++) {
            if (vm.animalsToShow[i].AnimalId == vm.selectedAnimalId) {
              vm.animals[i].animalsToShow = vm.discussion.comments;
            }
          }
          for (var i = 0; i < vm.allAnimals.length; i++) {
            if (vm.allAnimals[i].AnimalId == vm.selectedAnimalId) {
              vm.allAnimals[i].animalsToShow = vm.discussion.comments;
            }
          }
          $uibModalStack.dismissAll();
        })
        .catch(function (error) {
          console.log(error);
          vm.loadingNewDiscussion = false;
        });
    }

    function animalSearchChanged() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (vm.animal_search_string && vm.animal_search_string.length > 0) {
          vm.searchAnimals = Filter(vm.allAnimals, function (el) {
            var name = false;
            if (
              el.Name &&
              el.Name.toLowerCase().indexOf(
                vm.animal_search_string.toLowerCase()
              ) != -1
            ) {
              name = true;
            }
            var number = false;
            var n = angular.copy(el.Number);
            if (
              el.Number &&
              n
                .toString()
                .toLowerCase()
                .indexOf(vm.animal_search_string.toLowerCase()) != -1
            ) {
              number = true;
            }
            var earTag = false;
            var et = angular.copy(el.EarTag);
            if (
              el.EarTag &&
              et
                .toString()
                .toLowerCase()
                .indexOf(vm.animal_search_string.toLowerCase()) != -1
            ) {
              earTag = true;
            }
            if (!vm.searchByName) {
              name = false;
            }
            if (!vm.searchByNumber) {
              number = false;
            }
            if (!vm.searchByEarTag) {
              earTag = false;
            }
            return name || number || earTag;
          });
        } else {
          vm.searchAnimals = [];
          vm.showSearchResults = false;
        }
        if (vm.searchAnimals.length > 0) {
          vm.showSearchResults = true;
        } else {
          vm.showSearchResults = false;
        }
      }, 750);
    }

    function selectSearchBy(type) {
      if (type == "number") {
        vm.searchByNumber = !vm.searchByNumber;
      } else if (type == "name") {
        vm.searchByName = !vm.searchByName;
      } else if (type == "ear_tag") {
        vm.searchByEarTag = !vm.searchByEarTag;
      }
      if (!vm.searchByNumber && !vm.searchByName && !vm.searchByEarTag) {
        vm.searchByNumber = true;
        vm.searchByName = true;
        vm.searchByEarTag = true;
      }
      animalSearchChanged();
    }

    function addAnimal(index, animal) {
      animal.inserted = true;
      var found = false;
      for (var i = 0; i < vm.animalsToShow.length; i++) {
        if (vm.animalsToShow[i].AnimalId == animal.AnimalId) {
          found = true;
        }
      }
      if (!found) {
        vm.animalsToShow.splice(0, 0, animal);
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }
      vm.searchAnimals = [];
      vm.showSearchResults = false;
    }

    function selectLayout(type) {
      vm.selectedLayout = type;
      if (type == 1) {
        $timeout(function () {
          setTableDimensions(vm.selectedPredefinedList);
        }, 100);
      }
    }

    function removeAnimal($index, animal) {
      vm.animals.splice($index, 1);
      for (var i = 0; i < vm.animalsToShow.length; i++) {
        if (vm.animalsToShow[i].AnimalId == animal.AnimalId) {
          vm.animalsToShow.splice(i, 1);
          break;
        }
      }
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function openExportModal() {
      var file_name_metadata = {
        selected_predefined_list: vm.selectedPredefinedList,
        selected_slider_value: vm.selected_slider_value,
        status_date_list: vm.statusDateList,
        g_male: vm.g_male,
        g_female: vm.g_female,
        at_ce_tc: vm.at_ce_tc,
        m_a_milk: vm.m_a_milk,
        h_e_diseases: vm.h_e_diseases,
        h_e_prevention: vm.h_e_prevention,
        u_h_clinical: vm.u_h_clinical,
        u_h_subclinical: vm.u_h_subclinical,
        c_h: vm.c_h,
        at_newborn: vm.at_newborn,
        st_none: vm.st_none,
        st_open: vm.st_open,
        st_served: vm.st_served,
        st_not_pregnant: vm.st_not_pregnant,
        st_pregnant: vm.st_pregnant,
        st_barren: vm.st_barren,
        st_aborted: vm.st_aborted,
        st_dry: vm.st_dry,
        st_sold: vm.st_sold,
        st_dead: vm.st_dead,
        st_presume_left: vm.st_presume_left,
        p_zero: vm.p_zero,
        p_one: vm.p_one,
        p_two: vm.p_two,
        p_three_and_more: vm.p_three_and_more,
        p_custom: vm.p_custom,
        custom_parity: vm.custom_parity,
        dim_1: vm.dim_1,
        dim_2: vm.dim_2,
        dim_3: vm.dim_3,
        dim_4: vm.dim_4,
        dim_5: vm.dim_5,
        dim_6: vm.dim_6,
        dim_7: vm.dim_7,
        dim_list: vm.DIMList,
        age_1: vm.age_1,
        age_2: vm.age_2,
        age_3: vm.age_3,
        tags: vm.tags,
        sa_active: vm.sa_active,
        sa_history: vm.sa_history,
        al_scc: vm.al_scc,
        l1_scc: vm.l1_scc,
        lg1_scc: vm.lg1_scc,
      };
      vm.file_name =
        listGeneratorDataService.createFileName(file_name_metadata);
      vm.file_header = "";
      vm.showNewDiscussionBlock = false;
      vm.loadingModal = false;
      vm.includePictures = false;
      vm.discussion = {};
      vm.discussion.importance = 0;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/herds/listGeneratorV2/exportPdf.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function openSaveListModal() {
      vm.list_name = "";
      vm.loadingModal = false;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/herds/listGeneratorV2/saveList.modal.html",
        size: "sm",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function saveList() {
      vm.saveListError = false;
      var list = {
        list_name: vm.list_name,
        st_none: vm.st_none,
        st_open: vm.st_open,
        st_served: vm.st_served,
        st_not_pregnant: vm.st_not_pregnant,
        st_pregnant: vm.st_pregnant,
        st_barren: vm.st_barren,
        st_aborted: vm.st_aborted,
        st_dry: vm.st_dry,
        st_sold: vm.st_sold,
        st_dead: vm.st_dead,
        st_presume_left: vm.st_presume_left,
        s_d: vm.s_d,
        s_days: setStatusDays(vm.statusDateList),
        p_zero: vm.p_zero,
        p_one: vm.p_one,
        p_two: vm.p_two,
        p_three_and_more: vm.p_three_and_more,
        p_custom: vm.p_custom,
        custom_parity: vm.custom_parity,
        dim_1: vm.dim_1,
        dim_2: vm.dim_2,
        dim_3: vm.dim_3,
        dim_4: vm.dim_4,
        dim_5: vm.dim_5,
        dim_6: vm.dim_6,
        dim_7: vm.dim_7,
        dim_list: setDimList(vm.DIMList),
        age_1: vm.age_1,
        age_2: vm.age_2,
        age_3: vm.age_3,
        tags: setTags(vm.tags),
        tag_slider_value: vm.tag_slider_value,
        image_filter: vm.pictureFilter,
        image_event_filter: vm.eventsFilter,
        g_male: vm.g_male,
        g_female: vm.g_female,
        sa_active: vm.sa_active,
        sa_history: vm.sa_history,
        at_ce_tc: vm.at_ce_tc,
        m_a_milk: vm.m_a_milk,
        h_e_diseases: vm.h_e_diseases,
        h_e_prevention: vm.h_e_prevention,
        u_h_clinical: vm.u_h_clinical,
        u_h_subclinical: vm.u_h_subclinical,
        c_h: vm.c_h,
        e_slider_value: vm.slider_value,
        al_mp: vm.al_mp,
        al_scc: vm.al_scc,
        min_dev_p: vm.min_dev_p,
        min_dev_p_value: vm.min_dev_p_value,
        l1_scc: vm.l1_scc,
        lg1_scc: vm.lg1_scc,
        min_dev_kg: vm.min_dev_kg,
        min_dev_kg_value: vm.min_dev_kg_value,
        dev_t: vm.dev_t,
        dev_y: vm.dev_y,
        dev_tda: vm.dev_tda,
      };

      vm.loadingModal = true;
      listGeneratorService
        .addNewList(list, vm.selectedHerd)
        .then(function (response) {
          vm.userlistsRaw.push(response);
          vm.userLists = setUserLists(vm.userlistsRaw);
          vm.lists = setLists(predefinedLists, vm.userLists, vm.listOrder);
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.saveListError = true;
          vm.loadingModal = false;
        });
    }

    function showNewDiscussion() {
      vm.showNewDiscussionBlock = true;
    }

    function newDiscussionSetTags(item, index) {
      var tagsString = "";
      for (var i = 0; i < vm.discussion.tags_list.length; i++) {
        tagsString = tagsString + vm.discussion.tags_list[i].value;
        if (i < vm.discussion.tags_list.length - 1) {
          tagsString = tagsString + "#";
        }
      }
      vm.discussion.tags = tagsString;
    }

    function setALTags() {
      var tags = "AnimalList#AL";
      var date = $filter("date")(new Date(), "yyyy-MM-dd");
      tags = tags + date;
      tags = tags + "#ALF";
      for (var i = 0; i < filters.length; i++) {
        if (vm[filters[i]]) {
          if (filters[i] == "p_custom") {
            tags = tags + "$" + filters[i] + "|" + vm.custom_parity;
          } else if (filters[i] == "s_d") {
            tags = tags + "$" + filters[i] + "|";
            for (var j = 0; j < vm.statusDateList.length; j++) {
              tags =
                tags +
                vm.statusDateList[j].from +
                "-" +
                vm.statusDateList[j].from +
                ";";
            }
          } else {
            tags = tags + "$" + filters[i];
          }
        }
      }
      if (vm.tags && vm.tags.length > 0) {
        tags = tags + "$tags|";
        for (var i = 0; i < vm.tags.length; i++) {
          tags = tags + vm.tags[i].value + ";";
        }
      }
      if (
        vm.at_ce_tc ||
        vm.m_a_milk ||
        vm.h_e_diseases ||
        vm.h_e_prevention ||
        vm.u_h_clinical ||
        vm.u_h_subclinical ||
        vm.c_h
      ) {
        tags = tags + "$slider|" + vm.slider_value;
      }
      return tags;
    }

    function checkComments() {
      var tag = setALTags();
      for (var i = 0; i < vm.animals.length; i++) {
        if (vm.animals[i].ALPics) {
          var commentAdded = false;
          for (var j = 0; j < vm.animals[i].ALPics.length; j++) {
            for (var t = 0; t < vm.animals[i].ALPics[j].Tags.length; t++) {
              var alfTag;
              if (vm.animals[i].ALPics[j].Tags[t].indexOf("ALF") != -1) {
                alfTag = vm.animals[i].ALPics[j].Tags[t];
              }
            }
            if (tag.indexOf(alfTag) != -1) {
              vm.animals[i].Comments = vm.animals[i].ALPics[j].Conversation;
              commentAdded = true;
            } else {
              if (!commentAdded) {
                vm.animals[i].Comments = null;
              }
            }
          }
        }
      }
    }

    function exportPdf(newDiscussion) {
      vm.loadingModal = true;
      return listGeneratorService
        .getHerdById(vm.selectedHerd)
        .then(function (response) {
          try {
            if (vm.includePictures) {
              setPDFPictures(newDiscussion, response.Name);
            } else {
              createPdf(vm.includePictures, newDiscussion, response.Name);
            }
          } catch (error) {
            console.log(error);
            bugsnagService.logUnhandledError(error);
            vm.pdfError = true;
            vm.loadingModal = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.pdfError = true;
          vm.loadingModal = false;
        });

      function setPDFPictures(newDiscussion, herd_name) {
        var list = [];
        for (var i = 0; i < vm.animalsToShow.length; i++) {
          vm.animalsToShow[i].PDFPicture = null;
          if (
            vm.animalsToShow[i].PictureToShow &&
            vm.animalsToShow[i].PictureToShow.T
          ) {
            var name = "pr" + i;
            vm[name] = $q.defer();
            list.push(vm[name].promise);
            getDataUrl(name, i, vm.animalsToShow[i].PictureToShow.T);
          }
        }

        function getDataUrl(name, i, picture) {
          toDataURL(picture, function (dataUrl) {
            vm.animalsToShow[i].PDFPicture = dataUrl;
            vm[name].resolve();
          });
        }
        $q.all(list).then(function () {
          createPdf(vm.includePictures, newDiscussion, herd_name);
        });
      }

      function createPdf(include_pictures, new_discussion, herd_name) {
        var meta = {
          selected_predefined_list: vm.selectedPredefinedList,
          st_not_pregnant: vm.st_not_pregnant,
          st_served: vm.st_served,
          u_h_clinical: vm.u_h_clinical,
          u_h_subclinical: vm.u_h_subclinical,
          today: vm.today,
          yesterday: vm.yesterday,
          two_days_ago: vm.two_days_ago,
          include_pictures: include_pictures,
          file_header: vm.file_header,
          logo: vm.logo,
          animals_to_show: vm.animalsToShow,
          default_picture: vm.defaultPicture,
          herd_name: herd_name,
          show: vm.show,
        };
        return listGeneratorDataService
          .generatePDFObject(meta)
          .then(function (response) {
            var dd = response;
            var name = vm.file_name + ".pdf";
            var dd2 = angular.copy(dd);
            if (newDiscussion) {
              pdfMake.createPdf(dd).getBlob(function (data) {
                pdfMake.createPdf(dd2).download(name, function () {
                  createNewDiscussion(data);
                });
              });
            } else {
              pdfMake.createPdf(dd).download(name, function () {
                $uibModalStack.dismissAll();
              });
            }
          });
      }
    }

    function createNewDiscussion(file) {
      file.name = vm.file_name;
      var date = new Date().toISOString();
      var suffix = "?created=" + date;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix = suffix + "&tags=" + encodeURIComponent(vm.discussion.tags);
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      var url =
        APP_CONSTANTS.animals_base_url +
        "herds/" +
        vm.selectedHerd +
        "/pictures" +
        suffix;
      Upload.upload({
        url: url,
        data: {
          file: file,
        },
      })
        .then(function (response) {
          $uibModalStack.dismissAll();
          vm.loadingModal = false;
          vm.loadingNewDiscussion = false;
        })
        .catch(function (error) {
          vm.loadingModal = false;
          console.log(error);
        });
    }

    function hideFilterBlock() {
      vm.showFilterBlock = !vm.showFilterBlock;
    }

    function removeDuplicates(list) {
      var _list = list.filter(function (item, pos) {
        return list.indexOf(item) == pos;
      });

      return _list;
    }

    function setStatusDays(s_days) {
      var list = [];

      for (var i = 0; i < s_days.length; i++) {
        var obj = {
          from: s_days[i].from,
          status: s_days[i].status,
          status_v: s_days[i].status_v,
          to: s_days[i].to,
          type: s_days[i].type,
          ineq: s_days[i].ineq,
        };

        list.push(obj);
      }
      return list;
    }

    function setDimList(dim_list) {
      var list = [];
      for (var i = 0; i < dim_list.length; i++) {
        var obj = {
          from: dim_list[i].from,
          to: dim_list[i].to,
          type: dim_list[i].type,
          ineq: dim_list[i].ineq,
        };

        list.push(obj);
      }

      return list;
    }

    function setTags(tags) {
      var t_string;
      if (tags && tags.length) {
        t_string = "";
        for (var i = 0; i < tags.length; i++) {
          t_string += "#" + tags[i].value;
        }
      }
      return t_string;
    }

    function setShowColumns() {
      resetShowColumns();
      setByPredefinedList(vm.selectedPredefinedList);
      setBySelectedFilter();
    }

    function setByPredefinedList(selected_predefined_list) {
      if (selected_predefined_list) {
        if (selected_predefined_list == "attention_list_scc") {
          vm.show.last_mro_scc = true;
        } else if (selected_predefined_list == "female_youngstock") {
          vm.show.bull = true;
          vm.show.age = true;
          vm.show.last_calving_date = false;
          vm.show.last_mro_mm = false;
        } else if (selected_predefined_list == "dry_cow_attention") {
          vm.show.predicted_dry_off = true;
          vm.show.bull = true;
        } else if (selected_predefined_list == "heifers_to_be_inseminated") {
          vm.show.age = true;
          vm.show.last_calving_date = false;
          vm.show.bull = true;
          vm.show.last_mro_mm = false;
        } else if (selected_predefined_list == "preg_check") {
          vm.show.bull = true;
        } else if (selected_predefined_list == "transition_cows") {
          vm.show.last_mro_mm = false;
          vm.show.daily_milk_production = true;
          vm.show.last_heat_insemination = false;
        } else if (selected_predefined_list == "calving_attentions") {
          vm.show.days_pregnant = true;
          vm.show.days_dry = true;
          vm.show.last_calving_date = false;
          vm.show.expected_calving_date = true;
          vm.show.predicted_dry_off = true;
          vm.show.bull = true;
        } else if (selected_predefined_list == "daily_milk_production") {
          vm.show.last_mro_mm = false;
          vm.show.daily_milk_production = false;
          vm.show.milk_2_d = true;
          vm.show.milk_1_d = true;
          vm.show.milk_t = true;
          vm.show.last_week_milk = true;
          vm.show.last_heat_insemination = false;
        } else if (
          selected_predefined_list == "attention_list_milk_production"
        ) {
          vm.show.last_mro_mm = false;
          vm.show.daily_milk_production = true;
          vm.show.deviation_kg = true;
          vm.show.deviation_percentage = true;
        } else if (selected_predefined_list == "milk_production_7_days") {
          vm.show.birth_date = false;
          vm.show.last_mro_mm = false;
          vm.show.daily_milk_production = false;
          vm.show.last_heat_insemination = false;
          vm.show.n_inseminations = false;
          vm.show.milk_production = true;
          vm.show.milk_t1 = true;
          vm.show.milk_t2 = true;
          vm.show.milk_t3 = true;
          vm.show.milk_t4 = true;
          vm.show.milk_t5 = true;
          vm.show.milk_t6 = true;
          vm.show.milk_t7 = true;
          vm.show.milk_avg = true;
        }
      }
    }

    function setBySelectedFilter() {
      if (vm.u_h_clinical) {
        vm.show.last_mro_mm = false;
        vm.show.daily_milk_production = true;
        vm.show.mastitis = true;
        vm.show.last_mastitis = true;
      }

      if (vm.u_h_subclinical) {
        vm.show.last_mro_mm = false;
        vm.show.daily_milk_production = true;
        vm.show.mastitis = true;
        vm.show.last_mastitis = true;
      }

      if (vm.al_scc) {
        vm.show.last_mro_mm = true;
        vm.show.last_mro_scc = true;
      }

      if (vm.st_not_pregnant) {
        vm.show.n_inseminations = true;
        vm.show.predicted_dry_off = false;
      }

      if (vm.st_served) {
        vm.show.n_inseminations = true;
      }
    }

    function resetShowColumns() {
      vm.show = {
        birth_date: true,
        age: false,
        days_pregnant: false,
        days_dry: false,
        last_calving_date: true,
        last_mro_mm: true,
        last_mro_scc: false,
        expected_calving_date: false,
        daily_milk_production: false,
        deviation_kg: false,
        deviation_percentage: false,
        milk_2_d: false,
        milk_1_d: false,
        milk_t: false,
        last_week_milk: false,
        mastitis: false,
        last_mastitis: false,
        last_heat_insemination: true,
        n_inseminations: false,
        predicted_dry_off: false,
        bull: false,
        milk_production: false,
        milk_t1: false,
        milk_t2: false,
        milk_t3: false,
        milk_t4: false,
        milk_t5: false,
        milk_t6: false,
        milk_t7: false,
        milk_avg: false,
      };
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function round(value, decimals) {
      if (isNaN(value) == false) {
        return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
      } else {
        return value;
      }
    }

    function hasLongName(button) {
      if (button.translated && button.translated.length > 33) {
        return { "padding-top": "2px" };
      }
      return "";
    }
    $scope.$on("default_herd_selected", function (event, data) {
      if (animals) {
        animals.reject("canceled");
      }
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      if (animals) {
        animals.reject("canceled");
      }
      init();
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.listGeneratorV2")
    .factory("listGeneratorDataService", listGeneratorDataService);
  /** @ngInject */
  function listGeneratorDataService(
    $q,
    $filter
  ) {
    var i18nFilter = $filter("i18n");

    return {
      createFileName: createFileName,
      generatePDFObject: generatePDFObject,
    };

    function generatePDFObject(meta) {
      var deffered = $q.defer();

      var header_r1 = [
        {
          text: i18nFilter("_animal_number_"),
          border: [false, false, false, false],
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_name_"),
          border: [false, false, false, false],
          alignment: "center",
        },
      ];
      var header_r2 = [
        {
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        },
        {
          text: i18nFilter("_animal_ear_tag_"),
          border: [false, false, false, true],
          alignment: "center",
        },
      ];

      var widths = ["*", "*"];

      if (meta.show.birth_date) {
        header_r1.push({
          text: i18nFilter("_animal_date_of_birth_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });
        widths.push("auto");
      }
      if (meta.show.age) {
        header_r1.push({
          text: i18nFilter("_animal_age_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });
        widths.push("auto");
      }

      header_r1.push({
        text: i18nFilter("_animal_status_"),
        border: [false, false, false, false],
        alignment: "center",
      });

      header_r2.push({
        text: i18nFilter("_animal_status_days_"),
        border: [false, false, false, true],
        alignment: "center",
      });

      widths.push("auto");

      if (meta.show.days_pregnant) {
        header_r1.push({
          text: i18nFilter("_animal_days_pregnant_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.days_dry) {
        header_r1.push({
          text: i18nFilter("_animal_days_dry_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      header_r1.push({
        text: i18nFilter("_animal_parity_"),
        border: [false, false, false, false],
        alignment: "center",
      });

      header_r2.push({
        text: "",
        border: [false, false, false, true],
        alignment: "center",
      });

      widths.push("auto");

      if (meta.show.last_calving_date) {
        header_r1.push({
          text: i18nFilter("_animal_last_calving_date_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_dim_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.last_mro_mm) {
        header_r1.push({
          text: i18nFilter("_label_last_mro_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_label_milk_meter_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.last_mro_scc) {
        header_r1.push({
          text: i18nFilter("_label_last_mro_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_scc_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.expected_calving_date) {
        header_r1.push({
          text: i18nFilter("_animal_expected_calving_date_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_dim_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.daily_milk_production) {
        header_r1.push({
          text: i18nFilter("_calendar_daily_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_details_tab_milk_production_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.deviation_kg) {
        header_r1.push({
          text: i18nFilter("_label_deviation_") + " " + "Kg",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.deviation_percentage) {
        header_r1.push({
          text: i18nFilter("_label_deviation_") + " " + "%",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_2_d) {
        header_r1.push({
          text: i18nFilter("_animal_milk_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: meta.two_days_ago,
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_1_d) {
        header_r1.push({
          text: i18nFilter("_animal_milk_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: meta.yesterday,
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t) {
        header_r1.push({
          text: i18nFilter("_animal_milk_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: meta.today,
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.last_week_milk) {
        header_r1.push({
          text: i18nFilter("_calendar_daily_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_details_tab_milk_production_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }
      if (meta.show.mastitis) {
        header_r1.push({
          text: i18nFilter("_animal_mastitis_case_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.last_mastitis) {
        header_r1.push({
          text: i18nFilter("_label_last_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_mastitis_case_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.last_heat_insemination) {
        header_r1.push({
          text: i18nFilter("_animal_last_heat_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_insemination_date_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.n_inseminations) {
        header_r1.push({
          text: i18nFilter("_animal_number_of_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_inseminations_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.predicted_dry_off) {
        header_r1.push({
          text: i18nFilter("_label_predicted_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_dry_off_date_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.bull) {
        header_r1.push({
          text: i18nFilter("_animal_ear_tag_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_bull_name_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_production) {
        header_r1.push({
          text: i18nFilter("_animal_details_tab_milk_production_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_label_today_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t1) {
        header_r1.push({
          text: "t-1",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t2) {
        header_r1.push({
          text: "t-2",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t3) {
        header_r1.push({
          text: "t-3",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t4) {
        header_r1.push({
          text: "t-4",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t5) {
        header_r1.push({
          text: "t-5",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t6) {
        header_r1.push({
          text: "t-6",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_t7) {
        header_r1.push({
          text: "t-7",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      if (meta.show.milk_avg) {
        header_r1.push({
          text: i18nFilter("_animal_details_tab_milk_production_"),
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.push({
          text: i18nFilter("_animal_details_average_value_"),
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.push("auto");
      }

      header_r1.push({
        text: i18nFilter("_dc_comments_"),
        border: [false, false, false, false],
        alignment: "center",
      });

      header_r2.push({
        text: "",
        border: [false, false, false, true],
        alignment: "center",
      });

      widths.push("auto");

      if (meta.include_pictures) {
        header_r1.splice(0, 0, {
          text: "",
          border: [false, false, false, false],
          alignment: "center",
        });

        header_r2.splice(0, 0, {
          text: "",
          border: [false, false, false, true],
          alignment: "center",
        });

        widths.splice(0, 0, "*");
      }

      var header = [];

      if (
        meta.file_header &&
        meta.file_header != "" &&
        meta.file_header.length > 0
      ) {
        header.push({
          columns: [
            {
              image: meta.logo,
              width: 150,
              margin: [25, 0, 0, 0],
            },
            {
              stack: [
                {
                  text: i18nFilter("_label_herd_") + ": " + meta.herd_name,
                  margin: [250, 15, 0, 0],
                },
                {
                  text: meta.file_header,
                  margin: [50, 0, 0, 0],
                },
              ],
            },
          ],
        });
      } else {
        header.push({
          columns: [
            {
              image: meta.logo,
              width: 150,
              margin: [25, 0, 0, 0],
            },
            {
              text: i18nFilter("_label_herd_") + ": " + meta.herd_name,
              margin: [250, 15, 0, 0],
            },
          ],
        });
      }

      var dd = {
        pageOrientation: "landscape",
        pageMargins: [25, 50, 20, 0],
        header: header,
        content: [
          {
            table: {
              dontBreakRows: true,
              headerRows: 2,
              keepWithHeaderRows: 2,
              widths: widths,
              body: [header_r1, header_r2],
            },
          },
        ],
        defaultStyle: {
          fontSize: 8,
        },
        styles: {
          headerStyle: {
            fontSize: 9,
            bold: true,
          },
        },
      };

      meta.animals_to_show.forEach(function (animal) {
        var animal_row = [
          {
            text: animal.NumberString ? animal.NumberString : "",
            border: [false, false, false, true],
            alignment: "center",
          },
          {
            text:
              (animal.Name ? animal.Name : "") +
              "\n" +
              (animal.EarTag ? animal.EarTag : ""),
            border: [false, false, false, true],
            alignment: "center",
          },
        ];

        if (meta.show.birth_date) {
          animal_row.push({
            text: animal.BirthDate
              ? $filter("date")(animal.BirthDate, "shortDate")
              : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.age) {
          animal_row.push({
            text: animal.Age ? animal.Age : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        animal_row.push({
          text:
            (animal.CurrentStatusString
              ? animal.CurrentStatusString +
                "(" +
                (animal.DateString ? animal.DateString : "") +
                ")"
              : "" + "(" + (animal.DateString ? animal.DateString : "") + ")") +
            "\n" +
            (animal.StatusDays ? animal.StatusDays : ""),
          border: [false, false, false, true],
          alignment: "center",
        });

        if (meta.show.days_pregnant) {
          animal_row.push({
            text: animal.DaysSinceLastHI ? animal.DaysSinceLastHI : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.days_dry) {
          animal_row.push({
            text: animal.DaysDry ? animal.DaysDry : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        animal_row.push({
          text:
            animal.Parity != null || animal.Parity != undefined
              ? animal.Parity
              : "",
          border: [false, false, false, true],
          alignment: "center",
        });

        if (meta.show.last_calving_date) {
          animal_row.push({
            text:
              (animal.LastCalvingDate
                ? $filter("date")(animal.LastCalvingDate, "shortDate")
                : "") +
              "\n" +
              (animal.DIM ? animal.DIM : ""),
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.last_mro_mm) {
          var obj = {
            border: [false, false, false, true],
            alignment: "center",
          };

          if (animal.LastWeekMilk) {
            obj.table = {};
            obj.table.body = [];

            animal.LastWeekMilk.forEach(function (milk) {
              var r = [
                {
                  text: milk && milk.v ? milk.v : "",
                  border: [false, false, false, false],
                  alignment: "center",
                },
                {
                  text: "(" + $filter("date")(milk.d, "shortDate") + ")",
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ];

              if (milk.v) {
                obj.table.body.push(r);
              }
            });
          } else {
            obj.text = animal.LastMilkRecording
              ? (animal.LastMilkRecording.KgMilk
                  ? animal.LastMilkRecording.KgMilk
                  : "") +
                "(" +
                $filter("date")(animal.LastMilkRecording.Date, "shortDate") +
                ")"
              : "";
          }

          animal_row.push(obj);
        }

        if (meta.show.last_mro_scc) {
          animal_row.push({
            border: [false, false, false, true],
            alignment: "center",
            text: animal.LastMilkRecording
              ? (animal.LastMilkRecording.SCC
                  ? animal.LastMilkRecording.SCC
                  : "") +
                "(" +
                $filter("date")(animal.LastMilkRecording.Date, "shortDate") +
                ")"
              : "",
          });
        }

        if (meta.show.expected_calving_date) {
          animal_row.push({
            text:
              (animal.ExpectedCalvingDate
                ? $filter("date")(animal.ExpectedCalvingDate, "shortDate")
                : "") +
              "\n" +
              (animal.DIM ? animal.DIM : ""),
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.daily_milk_production) {
          var obj = {
            border: [false, false, false, true],
            alignment: "center",
          };

          if (animal.LastWeekMilk) {
            obj.table = {};
            obj.table.body = [];

            animal.LastWeekMilk.forEach(function (milk) {
              var r = [
                {
                  text: milk && milk.v ? milk.v : "",
                  border: [false, false, false, false],
                  alignment: "center",
                },
                {
                  text: "(" + $filter("date")(milk.d, "shortDate") + ")",
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ];

              if (milk.v) {
                obj.table.body.push(r);
              }
            });
          } else {
            obj.text = animal.LastMilkRecording
              ? (animal.LastMilkRecording.KgMilk
                  ? animal.LastMilkRecording.KgMilk
                  : "") +
                "(" +
                $filter("date")(animal.LastMilkRecording.Date, "shortDate") +
                ")"
              : "";
          }

          animal_row.push(obj);
        }

        if (meta.show.deviation_kg) {
          var obj = {
            border: [false, false, false, true],
            alignment: "center",
          };

          if (animal.LastWeekMilk) {
            obj.table = {
              body: [],
            };
            animal.LastWeekMilk.forEach(function (milk) {
              var r = [
                {
                  text: milk.dev_kg,
                  border: [false, false, false, false],
                  alignment: "center",
                },
                {
                  text: "(" + $filter("date")(milk.d, "shortDate") + ")",
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ];
              if (milk.dev_kg) {
                obj.table.body.push(r);
              }
            });
          } else {
            obj.text = "";
          }

          animal_row.push(obj);
        }

        if (meta.show.deviation_percentage) {
          var obj = {
            border: [false, false, false, true],
            alignment: "center",
          };

          if (animal.LastWeekMilk) {
            obj.table = {
              body: [],
            };
            animal.LastWeekMilk.forEach(function (milk) {
              var r = [
                {
                  text: milk.dev_percent,
                  border: [false, false, false, false],
                  alignment: "center",
                },
                {
                  text: "(" + $filter("date")(milk.d, "shortDate") + ")",
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ];
              if (milk.dev_percent) {
                obj.table.body.push(r);
              }
            });
          } else {
            obj.text = "";
          }

          animal_row.push(obj);
        }

        if (meta.show.milk_2_d) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[2].v
                ? animal.LastWeekMilk[2].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_1_d) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[1].v
                ? animal.LastWeekMilk[1].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[0].v
                ? animal.LastWeekMilk[0].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.last_week_milk) {
          var obj = {
            border: [false, false, false, true],
            alignment: "center",
          };

          if (animal.LastWeekMilk) {
            obj.table = {};
            obj.table.body = [];

            animal.LastWeekMilk.forEach(function (milk) {
              var r = [
                {
                  text: milk && milk.v ? milk.v : "",
                  border: [false, false, false, false],
                  alignment: "center",
                },
                {
                  text: "(" + $filter("date")(milk.d, "shortDate") + ")",
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ];

              if (milk.v) {
                obj.table.body.push(r);
              }
            });
          } else {
            obj.text = animal.LastMilkRecording
              ? (animal.LastMilkRecording.KgMilk
                  ? animal.LastMilkRecording.KgMilk
                  : "") +
                "(" +
                $filter("date")(animal.LastMilkRecording.Date, "shortDate") +
                ")"
              : "";
          }

          animal_row.push(obj);
        }

        if (meta.show.mastitis) {
          animal_row.push({
            text: animal.NrMastCurLact ? animal.NrMastCurLact : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.last_mastitis) {
          animal_row.push({
            text: animal.LastMastitis
              ? $filter("date")(animal.LastMastitis, "shortDate")
              : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.last_heat_insemination) {
          animal_row.push({
            text: animal.LastHeatInseminationDate
              ? $filter("date")(animal.LastHeatInseminationDate, "shortDate")
              : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.n_inseminations) {
          animal_row.push({
            text: animal.NumberOfInseminations
              ? animal.NumberOfInseminations
              : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.predicted_dry_off) {
          animal_row.push({
            text: animal.ExpectedDryDate
              ? $filter("date")(animal.ExpectedDryDate, "shortDate")
              : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.bull) {
          animal_row.push({
            text: animal.BreedingBull ? animal.BreedingBull : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_production) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[0].v
                ? animal.LastWeekMilk[0].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t1) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[1].v
                ? animal.LastWeekMilk[1].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t2) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[2].v
                ? animal.LastWeekMilk[2].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t3) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[3].v
                ? animal.LastWeekMilk[3].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t4) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[4].v
                ? animal.LastWeekMilk[4].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t5) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[5].v
                ? animal.LastWeekMilk[5].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t6) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[6].v
                ? animal.LastWeekMilk[6].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_t7) {
          animal_row.push({
            text:
              animal.LastWeekMilk && animal.LastWeekMilk[7].v
                ? animal.LastWeekMilk[7].v
                : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (meta.show.milk_avg) {
          animal_row.push({
            text: animal.Avg_MP ? round(animal.Avg_MP, 2) : "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        animal_row.push({
          text: animal.Comments ? animal.Comments : "",
          border: [false, false, false, true],
          alignment: "center",
        });

        if (meta.include_pictures) {
          var r = {
            image: animal.PDFPicture
              ? animal.PDFPicture
              : meta.default_picture,
            border: [false, false, false, true],
            alignment: "center",
            fit: [70, 70],
          };
          animal_row.splice(0, 0, r);
        }

        dd.content[0].table.body.push(animal_row);
      });

      deffered.resolve(dd);

      return deffered.promise;
    }

    function createFileName(meta) {
      var name = "";
      var predefined;
      var gender;
      var events;
      var status;
      var parity;
      var dim;
      var age;
      var tags;
      var show_animal;
      var scc;
      if (meta.selected_predefined_list) {
        if (meta.selected_predefined_list == "cows") {
          name = name + i18nFilter("_label_list_cows_");
        } else if (meta.selected_predefined_list == "female_youngstock") {
          name = name + i18nFilter("_label_list_female_youngstock_");
        } else if (meta.selected_predefined_list == "dry_cow_attention") {
          name = name + i18nFilter("_label_list_to_be_dried_off_");
        } else if (meta.selected_predefined_list == "open_cows") {
          name = name + i18nFilter("_label_list_open_cows_");
        } else if (meta.selected_predefined_list == "heat_attention") {
          name = name + i18nFilter("_label_list_heat_attention_");
        } else if (
          meta.selected_predefined_list == "heifers_to_be_inseminated"
        ) {
          name = name + i18nFilter("_label_list_to_be_inseminated_");
        } else if (meta.selected_predefined_list == "preg_check") {
          name = name + i18nFilter("_label_list_pregnancy_check_");
        } else if (meta.selected_predefined_list == "transition_cows") {
          name = name + i18nFilter("_label_list_transition_cows_");
        } else if (meta.selected_predefined_list == "calving_attentions") {
          name = name + i18nFilter("_label_list_calving_attention_");
        } else if (meta.selected_predefined_list == "daily_milk_production") {
          name = name + i18nFilter("_label_list_daily_milk_production_");
        } else if (meta.selected_predefined_list == "treated_cows_heifers") {
          name = name + i18nFilter("_label_list_treated_cows_heifers_");
        } else if (
          meta.selected_predefined_list == "attention_list_milk_production"
        ) {
          name =
            name + i18nFilter("_label_show_attention_list_milk_production_");
        } else if (meta.selected_predefined_list == "milk_production_7_days") {
          name = name + i18nFilter("_label_list_milk_production_7_days_");
        } else if (meta.selected_predefined_list == "attention_list_scc") {
          name = name + i18nFilter("_label_attention_list_scc_");
        }
        predefined = true;
        name = name + " ";
      }
      if (meta.g_female || meta.g_male) {
        if (predefined) {
          name = name + "/ ";
        }
        name = name + i18nFilter("_animal_gender_") + "(";
        if (meta.g_female) {
          name = name + i18nFilter("_animal_gender_female_");
        }
        if (meta.g_male) {
          if (meta.g_female) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_gender_male_");
        }
        name = name + ")";
        gender = true;
      }
      if (
        meta.at_ce_tc ||
        meta.m_a_milk ||
        meta.h_e_diseases ||
        meta.h_e_prevention ||
        meta.u_h_clinical ||
        meta.u_h_subclinical ||
        meta.c_h ||
        meta.s_d
      ) {
        if (predefined || gender) {
          name = name + "/ ";
        }
        name = name + i18nFilter("_label_events_") + "(";
        if (meta.at_newborn) {
          name = name + i18nFilter("_animal_newborn_");
        }
        if (meta.at_ce_tc) {
          if (meta.at_newborn) {
            name = name + ", ";
          }
          name =
            name + i18nFilter("_animal_clinical_examination_transition_cows_");
        }
        if (meta.m_a_milk) {
          if (meta.at_ce_tc || meta.at_newborn) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_manually_added_milk_");
        }
        if (meta.h_e_diseases) {
          if (meta.m_a_milk || meta.at_ce_tc || meta.at_newborn) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_health_event_diseases_");
        }
        if (meta.h_e_prevention) {
          if (
            meta.h_e_diseases ||
            meta.m_a_milk ||
            meta.at_ce_tc ||
            meta.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_health_event_prevention_");
        }
        if (meta.u_h_clinical) {
          if (
            meta.h_e_prevention ||
            meta.h_e_diseases ||
            meta.m_a_milk ||
            meta.at_ce_tc ||
            meta.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_udder_health_clinical_mastitis_");
        }
        if (meta.u_h_subclinical) {
          if (
            meta.u_h_clinical ||
            meta.h_e_prevention ||
            meta.h_e_diseases ||
            meta.m_a_milk ||
            meta.at_ce_tc ||
            meta.at_newborn
          ) {
            name = name + ", ";
          }
          name =
            name + i18nFilter("_animal_udder_health_subclinical_mastitis_");
        }
        if (meta.c_h) {
          if (
            meta.u_h_subclinical ||
            meta.u_h_clinical ||
            meta.h_e_prevention ||
            meta.h_e_diseases ||
            meta.m_a_milk ||
            meta.at_ce_tc ||
            meta.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_claw_health_");
        }
        if (
          meta.at_ce_tc ||
          meta.m_a_milk ||
          meta.h_e_diseases ||
          meta.h_e_prevention ||
          meta.u_h_clinical ||
          meta.u_h_subclinical ||
          meta.c_h
        ) {
          name = name + "[" + meta.selected_slider_value + "]";
        }
        if (meta.s_d) {
          if (
            meta.c_h ||
            meta.u_h_subclinical ||
            meta.u_h_clinical ||
            meta.h_e_prevention ||
            meta.h_e_diseases ||
            meta.m_a_milk ||
            meta.at_ce_tc ||
            meta.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_date_");
          if (meta.status_date_list.length > 0) {
            name = name + ": [";
            for (var i = 0; i < meta.status_date_list.length; i++) {
              name =
                name +
                meta.status_date_list[i].from +
                "-" +
                meta.status_date_list[i].to;
              if (i != meta.status_date_list.length - 1) {
                name = name + ", ";
              }
            }
            name = name + "]";
          }
        }
        events = true;
        name = name + ")";
      }
      if (
        meta.st_none ||
        meta.st_open ||
        meta.st_served ||
        meta.st_not_pregnant ||
        meta.st_pregnant ||
        meta.st_barren ||
        meta.st_aborted ||
        meta.st_dry ||
        meta.st_sold ||
        meta.st_dead ||
        meta.st_presume_left
      ) {
        if (predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_current_status_") + "(";
        if (meta.st_none) {
          name = name + i18nFilter("_animal_status_none_");
        }
        if (meta.st_open) {
          if (meta.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_open_");
        }
        if (meta.st_served) {
          if (meta.st_open || meta.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_inseminated_");
        }
        if (meta.st_not_pregnant) {
          if (meta.st_served || meta.st_open || meta.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_not_pregnant_");
        }
        if (meta.st_pregnant) {
          if (
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_pregnant_");
        }
        if (meta.st_barren) {
          if (
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_barren_");
        }
        if (meta.st_aborted) {
          if (
            meta.st_barren ||
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_aborted_");
        }
        if (meta.st_dry) {
          if (
            meta.st_aborted ||
            meta.st_barren ||
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_dry_");
        }
        if (meta.st_sold) {
          if (
            meta.st_dry ||
            meta.st_aborted ||
            meta.st_barren ||
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_sold_");
        }
        if (meta.st_dead) {
          if (
            meta.st_sold ||
            meta.st_dry ||
            meta.st_aborted ||
            meta.st_barren ||
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_dead_");
        }
        if (meta.st_presume_left) {
          if (
            meta.st_dead ||
            meta.st_sold ||
            meta.st_dry ||
            meta.st_aborted ||
            meta.st_barren ||
            meta.st_pregnant ||
            meta.st_not_pregnant ||
            meta.st_served ||
            meta.st_open ||
            meta.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_presume_left_");
        }
        name = name + ")";
        status = true;
      }
      if (
        meta.p_zero ||
        meta.p_one ||
        meta.p_two ||
        meta.p_three_and_more ||
        meta.p_custom
      ) {
        if (status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_parity_") + "(";
        if (meta.p_zero) {
          name = name + "0";
        }
        if (meta.p_one) {
          if (meta.p_zero) {
            name = name + ", ";
          }
          name = name + "1";
        }
        if (meta.p_two) {
          if (meta.p_one || meta.p_zero) {
            name = name + ", ";
          }
          name = name + "2";
        }
        if (meta.p_three_and_more) {
          if (meta.p_two || meta.p_one || meta.p_zero) {
            name = name + ", ";
          }
          name = name + "3+";
        }
        if (meta.p_custom && meta.custom_parity) {
          if (
            meta.p_three_and_more ||
            meta.p_two ||
            meta.p_one ||
            meta.p_zero
          ) {
            name = name + ", ";
          }
          name = name + meta.custom_parity;
        }
        name = name + ")";
        parity = true;
      }
      if (
        meta.dim_1 ||
        meta.dim_2 ||
        meta.dim_3 ||
        meta.dim_4 ||
        meta.dim_5 ||
        meta.dim_6 ||
        (meta.dim_7 && meta.dim_list.length)
      ) {
        if (parity || status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_days_in_milk_") + "(";
        if (meta.dim_1) {
          name = name + "<30";
        }
        if (meta.dim_2) {
          if (meta.dim_1) {
            name = name + ", ";
          }
          name = name + "30-60";
        }
        if (meta.dim_3) {
          if (meta.dim_2 || meta.dim_1) {
            name = name + ", ";
          }
          name = name + "60-120";
        }
        if (meta.dim_4) {
          if (meta.dim_3 || meta.dim_2 || meta.dim_1) {
            name = name + ", ";
          }
          name = name + "120-200";
        }
        if (meta.dim_5) {
          if (meta.dim_4 || meta.dim_3 || meta.dim_2 || meta.dim_1) {
            name = name + ", ";
          }
          name = name + "200-305";
        }
        if (meta.dim_6) {
          if (
            meta.dim_5 ||
            meta.dim_4 ||
            meta.dim_3 ||
            meta.dim_2 ||
            meta.dim_1
          ) {
            name = name + ", ";
          }
          name = name + ">305";
        }
        if (meta.dim_7 && meta.dim_list.length) {
          if (
            meta.dim_6 ||
            meta.dim_5 ||
            meta.dim_4 ||
            meta.dim_3 ||
            meta.dim_2 ||
            meta.dim_1
          ) {
            name = name + ", ";
          }
          meta.dim_list.forEach(function (item, index) {
            if (item.type == 1) {
              name = name + item.from + "-" + item.to;
            } else {
              if (item.ineq == 1) {
                name = name + "<" + item.to;
              } else {
                name = name + ">" + item.from;
              }
            }
            if (meta.dim_list[index + 1]) {
              name = name + ", ";
            }
          });
        }
        name = name + ")";
        dim = true;
      }
      if (meta.age_1 || meta.age_2 || meta.age_3) {
        if (dim || parity || status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_age_") + "(";
        if (meta.age_1) {
          name = name + "<20";
        }
        if (meta.age_2) {
          if (meta.age_1) {
            name = name + ", ";
          }
          name = name + "200-400";
        }
        if (meta.age_3) {
          if (meta.age_2 || meta.age_1) {
            name = name + ", ";
          }
          name = name + ">400";
        }
        name = name + ")";
        age = true;
      }
      if (meta.tags && meta.tags.length > 0) {
        if (age || dim || parity || status || events || predefined || gender) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_tags_") + "(";
        for (var i = 0; i < meta.tags.length; i++) {
          name = name + meta.tags[i].label;
          if (i != meta.tags.length - 1) {
            name = name + ", ";
          }
        }
        name = name + ")";
        tags = true;
      }
      if (meta.sa_active || meta.sa_history) {
        if (
          tags ||
          age ||
          dim ||
          parity ||
          status ||
          events ||
          predefined ||
          gender
        ) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_show_animals_") + "(";
        if (meta.sa_active) {
          name = name + i18nFilter("_animal_active_");
        }
        if (meta.sa_history) {
          if (meta.sa_active) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_historic_");
        }
        name = name + ")";
        show_animal = true;
      }
      var date = $filter("date")(new Date(), "shortDate");

      if (meta.al_scc) {
        if (
          tags ||
          age ||
          dim ||
          parity ||
          status ||
          events ||
          predefined ||
          gender ||
          show_animal
        ) {
          name = name + "/";
        }
        name =
          name +
          i18nFilter("_scc_alert_") +
          " " +
          i18nFilter("_animal_lactation_") +
          "1 " +
          "(" +
          meta.l1_scc +
          ")" +
          " " +
          i18nFilter("_animal_lactation_") +
          ">1 " +
          "(" +
          meta.lg1_scc +
          ")";
      }

      if (
        show_animal ||
        tags ||
        age ||
        dim ||
        parity ||
        status ||
        events ||
        predefined ||
        gender ||
        scc
      ) {
        name = name + "/ ";
      }

      name = name + date;
      return name;
    }

    function round(value, decimals) {
      if (isNaN(value) == false) {
        return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
      } else {
        return value;
      }
    }
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.listGeneratorV2').factory('listGeneratorService', listGeneratorService);
    /** @ngInject */
    function listGeneratorService($http, $q, APP_CONSTANTS) {
        return {
            getAnimals: getAnimals,
            getPictures: getPictures,
            sendDataToEventBus: sendDataToEventBus,
            addNewDiscussion: addNewDiscussion,
            getHerdById: getHerdById,
            getListsByHerdId: getListsByHerdId,
            addNewList: addNewList,
            getListsOrder: getListsOrder,
            updateOrder: updateOrder
        }

        function getAnimals(herdId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/animallist', {}).then(success).catch(error);
        }

        function getPictures(herdId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/pictures', {}).then(success).catch(error);
        }

        function sendDataToEventBus(data) {
            return $http.post('https://events.mmmooogle.com/event', data).then(success).catch(error);
        }

        function addNewDiscussion(animal_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/pictures' + suffix).then(success).catch(error);

        }

        function getHerdById(herd_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd_id).then(success).catch(error);

        }

        function getListsByHerdId(herd_id) {
            return $http.get(APP_CONSTANTS.my_api_base_url + 'config-lists/' + herd_id).then(success).catch(error);

        }

        function addNewList(list, herd_id) {
            return $http.post(APP_CONSTANTS.my_api_base_url + 'config-list?herdId=' + herd_id, list).then(success).catch(error);

        }

        function getListsOrder(herd_id) {
            return $http.get(APP_CONSTANTS.my_api_base_url + 'counters?herdId=' + herd_id).then(success).catch(error);

        }

        function updateOrder(list, herd_id) {
            return $http.post(APP_CONSTANTS.my_api_base_url + 'counters?herdId=' + herd_id, list).then(success).catch(error);

        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }

    }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.herds.listGenerator")
    .controller("listGeneratorCtrl", listGeneratorCtrl);
  /** @ngInject */
  function listGeneratorCtrl(
    listGeneratorService,
    $filter,
    $timeout,
    APP_CONSTANTS,
    $scope,
    animalsService,
    $state,
    Upload,
    $uibModal,
    $uibModalStack,
    $q,
    $window,
    $cookies,
    $rootScope,
    $sce,
    cookiesService,
    bugsnagService
  ) {
    var vm = this;
    var filterTimer;
    var searchTimer;
    var sliderTimer;
    var Filter = $filter("filter");
    var i18nFilter = $filter("i18n");
    var animals;
    var dataPromise;
    // var listsPromise;
    var orderPromise;
    vm.selectLayout = selectLayout;
    vm.selectFilter = selectFilter;
    vm.customParityChanged = customParityChanged;
    vm.tagsChanged = tagsChanged;
    vm.getAnimalClass = getAnimalClass;
    vm.removeAnimal = removeAnimal;
    vm.selectAnimal = selectAnimal;
    vm.sort = sort;
    vm.animalSearchChanged = animalSearchChanged;
    vm.addAnimal = addAnimal;
    vm.exportPdf = exportPdf;
    vm.openExportModal = openExportModal;
    vm.showNewDiscussion = showNewDiscussion;
    vm.newDiscussionSetTags = newDiscussionSetTags;
    vm.sliderChanged = sliderChanged;
    vm.tagsSliderChanged = tagsSliderChanged;
    vm.selectPictureFilter = selectPictureFilter;
    vm.selectEventFilter = selectEventFilter;
    vm.selectPredefinedList = selectPredefinedList;
    vm.paginationChanged = paginationChanged;
    vm.addStatusDateRange = addStatusDateRange;
    vm.addDIMRange = addDIMRange;
    vm.removeFromStatusDateList = removeFromStatusDateList;
    vm.removeFromDIMList = removeFromDIMList;
    vm.selectedPickerList = selectedPickerList;
    vm.openNewDiscussionModal = openNewDiscussionModal;
    vm.addNewDiscussion = addNewDiscussion;
    vm.hideFilterBlock = hideFilterBlock;
    vm.emptyList = emptyList;
    vm.selectSearchBy = selectSearchBy;
    vm.deviationSelected = deviationSelected;
    vm.selectDeviationTime = selectDeviationTime;
    vm.deviationValueChanged = deviationValueChanged;
    vm.sccValueChanged = sccValueChanged;
    vm.openSaveListModal = openSaveListModal;
    vm.saveList = saveList;
    vm.init = init;
    vm.searchByName = true;
    vm.searchByNumber = true;
    vm.searchByEarTag = true;
    vm.selectedLayout = 1;
    vm.showFilterBlock = true;
    var filters = [
      "at_newborn",
      "at_ce_tc",
      "m_a_milk",
      "h_e_diseases",
      "h_e_prevention",
      "u_h_clinical",
      "u_h_subclinical",
      "c_h",
      "s_d",
      "sa_active",
      "sa_history",
      "st_none",
      "st_open",
      "st_served",
      "st_not_pregnant",
      "st_pregnant",
      "st_barren",
      "st_aborted",
      "st_dry",
      "st_sold",
      "st_dead",
      "st_presume_left",
      "p_zero",
      "p_one",
      "p_two",
      "p_three_and_more",
      "p_custom",
      "dim_1",
      "dim_2",
      "dim_3",
      "dim_4",
      "dim_5",
      "dim_6",
      "dim_7",
      "g_female",
      "g_male",
      "age_1",
      "age_2",
      "age_3",
      "al_mp",
      "al_scc",
      "min_dev_p",
      "min_dev_kg",
      "dev_y",
      "dev_t",
      "dev_tda",
    ];

    var predefinedLists = [
      {
        n: 13,
        id: "attention_list_scc",
        label: "_label_attention_list_scc_",
        translated: i18nFilter("_label_attention_list_scc_"),
      },
      {
        n: 1,
        id: "cows",
        label: "_label_show_cows_",
        translated: i18nFilter("_label_show_cows_"),
      },
      {
        n: 2,
        id: "female_youngstock",
        label: "_label_show_female_youngstock_",
        translated: i18nFilter("_label_show_female_youngstock_"),
      },
      {
        n: 3,
        id: "dry_cow_attention",
        label: "_label_show_to_be_dried_off_list_",
        translated: i18nFilter("_label_show_to_be_dried_off_list_"),
      },
      {
        n: 4,
        id: "open_cows",
        label: "_label_show_open_cows_",
        translated: i18nFilter("_label_show_open_cows_"),
      },
      {
        n: 5,
        id: "heat_attention",
        label: "_label_show_heat_attention_",
        translated: i18nFilter("_label_show_heat_attention_"),
      },
      {
        n: 6,
        id: "heifers_to_be_inseminated",
        label: "_label_show_heifers_to_be_inseminated_",
        translated: i18nFilter("_label_show_heifers_to_be_inseminated_"),
      },
      {
        n: 7,
        id: "preg_check",
        label: "_label_show_pregnancy_check_list_",
        translated: i18nFilter("_label_show_pregnancy_check_list_"),
      },
      {
        n: 8,
        id: "transition_cows",
        label: "_label_show_transition_cow_list_",
        translated: i18nFilter("_label_show_transition_cow_list_"),
      },
      {
        n: 9,
        id: "calving_attentions",
        label: "_label_show_calving_attention_list_",
        translated: i18nFilter("_label_show_calving_attention_list_"),
      },
      {
        n: 10,
        id: "daily_milk_production",
        label: "_label_show_daily_milk_production_",
        translated: i18nFilter("_label_show_daily_milk_production_"),
      },
      {
        n: 11,
        id: "treated_cows_heifers",
        label: "_label_show_treated_cows_heifers_",
        translated: i18nFilter("_label_show_treated_cows_heifers_"),
      },
      {
        n: 11,
        id: "attention_list_milk_production",
        label: "_label_show_attention_list_milk_production_",
        translated: i18nFilter("_label_show_attention_list_milk_production_"),
      },
      {
        n: 12,
        id: "milk_production_7_days",
        label: "_label_milk_production_last_7_days_list_",
        translated: i18nFilter("_label_milk_production_last_7_days_list_"),
      },
    ];

    $timeout(function () {
      for (var i = 0; i < predefinedLists.length; i++) {
        predefinedLists[i].translated = i18nFilter(predefinedLists[i].label);
      }
    }, 350);
    var sliderValues = [
      {
        label: "1 " + i18nFilter("_label_days_"),
        date: moment().subtract(1, "days"),
      },
      {
        label: "2 " + i18nFilter("_label_days_"),
        date: moment().subtract(2, "days"),
      },
      {
        label: "3 " + i18nFilter("_label_days_"),
        date: moment().subtract(3, "days"),
      },
      {
        label: "4 " + i18nFilter("_label_days_"),
        date: moment().subtract(4, "days"),
      },
      {
        label: "5 " + i18nFilter("_label_days_"),
        date: moment().subtract(5, "days"),
      },
      {
        label: "6 " + i18nFilter("_label_days_"),
        date: moment().subtract(6, "days"),
      },
      {
        label: "7 " + i18nFilter("_label_days_"),
        date: moment().subtract(7, "days"),
      },
      {
        label: "8 " + i18nFilter("_label_days_"),
        date: moment().subtract(8, "days"),
      },
      {
        label: "9 " + i18nFilter("_label_days_"),
        date: moment().subtract(9, "days"),
      },
      {
        label: "10 " + i18nFilter("_label_days_"),
        date: moment().subtract(10, "days"),
      },
      {
        label: "11 " + i18nFilter("_label_days_"),
        date: moment().subtract(11, "days"),
      },
      {
        label: "12 " + i18nFilter("_label_days_"),
        date: moment().subtract(12, "days"),
      },
      {
        label: "13 " + i18nFilter("_label_days_"),
        date: moment().subtract(13, "days"),
      },
      {
        label: "14 " + i18nFilter("_label_days_"),
        date: moment().subtract(14, "days"),
      },
      {
        label: i18nFilter("_label_one_month_"),
        date: moment().subtract(1, "months"),
      },
      {
        label: i18nFilter("_label_two_months_"),
        date: moment().subtract(2, "months"),
      },
      {
        label: i18nFilter("_label_qurter_"),
        date: moment().subtract(3, "months"),
      },
      {
        label: i18nFilter("_label_six_months_"),
        date: moment().subtract(6, "months"),
      },
      {
        label: i18nFilter("_label_one_year_"),
        date: moment().subtract(1, "years"),
      },
    ];

    vm.selectedStatusList = [
      {
        id: "st_global",
        label: "_label_all_",
        translated: $filter("i18n")("_label_all_"),
      },
    ];

    var picture_filter_list = ["p_profile", "p_recent", "p_oldest", "p_event"];
    var picture_filter_event_list = [
      "p_e_calving",
      "p_e_colostrum",
      "p_e_first_milk",
      "p_e_exemination",
      "p_e_tests",
      "p_e_milk_m",
      "p_e_clinical",
      "p_e_subclinical",
      "p_e_misc",
      "p_e_diseases",
      "p_e_prevention",
      "p_e_claw_health",
    ];


    init();

    function init() {
      toDataURL("assets/img/logo_mmm.png", function (dataurl) {
        vm.logo = dataurl;
      });
      toDataURL("assets/img/logo.png", function (dataurl) {
        vm.defaultPicture = dataurl;
      });
      var today = moment();
      var yesterday = moment().subtract(1, "days").format();
      var two_days_ago = moment().subtract(2, "days").format();
      dataPromise = $q.defer();
      // listsPromise = $q.defer();
      orderPromise = $q.defer();
      vm.min_dev_p_value = 30;
      vm.lg1_scc = 250;
      vm.l1_scc = 150;
      vm.min_dev_kg_value = 5;
      vm.today = new Date(today.format());
      vm.yesterday = new Date(yesterday);
      vm.two_days_ago = new Date(two_days_ago);
      vm.showTable = true;
      vm.loadingTable = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.tagsList = angular.copy(APP_CONSTANTS.constants.tags);
      vm.tagsList.splice(0, 1);
      vm.sliderOptionsActive = {
        floor: 0,
        ceil: 18,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onChange: function () {
          sliderChanged();
        },
      };
      vm.tagsSliderOptionsActive = {
        floor: 0,
        ceil: 14,
        hideLimitLabels: true,
        hidePointerLabels: true,
        onChange: function () {
          tagsSliderChanged();
        },
      };
      if (vm.defaultValues.herd_ids && vm.defaultValues.herd_ids.length == 1) {
        vm.selectedHerd = vm.defaultValues.herd_ids[0];
        setDefaultFilters();
        getAnimalData(vm.selectedHerd);
        // getLists(vm.selectedHerd);
        getListsOrder(vm.selectedHerd);
        vm.loading = true;

        $q.all([
          dataPromise.promise,
          // listsPromise.promise,
          orderPromise.promise,
        ])
          .then(function () {
            vm.lists = setLists(predefinedLists, vm.listOrder);
            vm.loading = false;
          })
          .catch(function (error) {
            vm.loading = false;
            vm.errorLoading = true;
          });
      } else {
        vm.selectedHerd = null;
        vm.loading = false;
      }
    }

    function setLists(predefined_lists, order) {
      var lists = [];
      lists = lists.concat(predefined_lists);
      lists = setPositions(lists, order);
      $timeout(function () {
        if (
          vm["st_not_pregnant"] ||
          vm["u_h_clinical"] ||
          vm["u_h_subclinical"]
        ) {
          if (vm["st_not_pregnant"]) {
            vm["st_not_pregnant"] = false;
            selectFilter("st_not_pregnant", 13);
          }
          if (vm["u_h_clinical"]) {
            vm["u_h_clinical"] = false;
            selectFilter("u_h_clinical", 13);
          }
          if (vm["u_h_subclinical"]) {
            vm["u_h_subclinical"] = false;
            selectFilter("u_h_subclinical", 13);
          }
        } else {
          if (vm.selectedPredefinedList) {
            setTableDimensions(vm.selectedPredefinedList);
          }
        }
        var width = document.getElementById("shortcuts").offsetWidth;
        generateShortcuts(width, lists);
      }, 100);
      return lists;
    }

    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("id_token")
      );
      xhr.responseType = "blob";
      xhr.send();
    }

    function setEvents() {
      vm.eventsFilter = null;
    }

    function setPositions(lists, order) {
      var l_order = order.counters;
      for (var i = 0; i < lists.length; i++) {
        lists[i].number = lists.length - i;
        for (var j = 0; j < l_order.length; j++) {
          if (lists[i].id == l_order[j].listId) {
            lists[i].number += l_order[j].value * 100;
          }
        }
      }
      lists = $filter("orderBy")(lists, "number", true);
      return lists;
    }

    function getAnimalData(herd_id) {
      vm.errorLoading = false;
      animals = $q.defer();
      getAnimals(vm.selectedHerd);
      $q.all([animals.promise])
        .then(function () {
          vm.allAnimals = angular.copy(vm.rawAnimalData);
          if (vm.picturesToShowFilter) {
            if (vm.picturesToShowFilter == "p_event") {
              setEventPictureToShow(vm.eventsToShowFilter);
            } else {
              setPictureToShow(vm.picturesToShowFilter);
            }
          }
          if (vm.goBackActive) {
            var listOfAnimals = [];
            for (var l = 0; l < vm.animalList.list.length; l++) {
              for (var a = 0; a < vm.allAnimals.length; a++) {
                if (vm.animalList.list[l].id == vm.allAnimals[a].AnimalId) {
                  listOfAnimals.push(vm.allAnimals[a]);
                }
              }
            }
            vm.predefinedList = listOfAnimals;
            vm.animalsToShow = listOfAnimals;
            vm.animalsToShow = removeDuplicates(vm.animalsToShow);
          } else {
            if (vm.selectedPredefinedList) {
              vm.selectedPredefinedList = null;
            }
            vm.animalsToShow = filterAnimalList(vm.allAnimals);
          }
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          vm.animals = [];
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
          dataPromise.resolve();
        })
        .catch(function (error) {
          console.log(error);
          dataPromise.reject(error);
          if (error != "canceled") {
            vm.errorLoading = true;
            vm.loading = false;
          }
        });
    }

    // function getLists(herd_id) {
    //   // listGeneratorService
    //   //   .getListsByHerdId(herd_id)
    //   //   .then(function (response) {
    //   //     vm.userlistsRaw = response;
    //   //     vm.userLists = setUserLists(response);
    //   //     listsPromise.resolve();
    //   //   })
    //   //   .catch(function (error) {
    //   //     listsPromise.reject();
    //   //     console.log(error);
    //   //   });
    // }

    function getListsOrder(herd_id) {
      listGeneratorService
        .getListsOrder(herd_id)
        .then(function (response) {
          vm.listOrder = response;
          orderPromise.resolve();
        })
        .catch(function (error) {
          console.log(error);
          orderPromise.reject();
        });
    }

    function setUserLists(lists) {
      var list = [];

      for (var i = 0; i < lists.length; i++) {
        var obj = {
          id: lists[i].id,
          translated: lists[i].list_name,
          user_defined: true,
        };
        list.push(obj);
      }
      return list;
    }

    function generateShortcuts(width, lists) {
      vm.showShortcutItems = true;
      var space = width - 235;
      var numberOfButtons = space / 200;
      numberOfButtons = Math.floor(numberOfButtons);
      vm.predefinedButtonsList = [];
      vm.predefinedPickerList = [];
      for (var i = 0; i < lists.length; i++) {
        if (i < numberOfButtons) {
          vm.predefinedButtonsList.push(lists[i]);
        } else {
          vm.predefinedPickerList.push(lists[i]);
        }
      }
    }

    function setCurrentAnimalList(index, list) {
      if (list.length > 100) {
        vm.showPagination = true;
        var lowerIndex = (index - 1) * 100;
        var upperIndex = index * 100;
        var updateList = [];
        for (var i = lowerIndex; i < upperIndex; i++) {
          if (list[i]) {
            updateList.push(list[i]);
          } else {
            break;
          }
        }
        vm.animals = updateList;
      } else {
        vm.showPagination = false;
        vm.animals = list;
      }
    }

    function paginationChanged() {
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      $timeout(function () {
        $window.scrollTo(0, 0);
      }, 0);
    }

    function setDefaultFilters() {
      setEvents();
      vm.pictureFilter = null;
      vm.animalList = JSON.parse(localStorage.getItem("animalList"));
      if (
        vm.animalList &&
        vm.animalList.goBack &&
        vm.animalList.state == $state.current.name &&
        vm.animalList.herdId &&
        vm.animalList.herdId == vm.selectedHerd
      ) {
        vm.goBackActive = true;
        vm.animalList.goBack = false;
        localStorage.setItem("animalList", JSON.stringify(vm.animalList));
        if (vm.animalList.filters) {
          angular.forEach(vm.animalList.filters, function (value, key) {
            vm[value] = true;
          });
        }
        if (vm.animalList.slider) {
          vm.slider_value = vm.animalList.slider;
          vm.selected_slider_value = sliderValues[vm.animalList.slider].label;
        }
        if (vm.p_custom && vm.animalList.customParity) {
          vm.custom_parity = vm.animalList.customParity;
        }
        if (vm.animalList.tags) {
          vm.tags = vm.animalList.tags;
        }
        if (vm.animalList.tagSlider) {
          vm.tag_slider_value = vm.animalList.tagSlider;
          vm.selected_tags_slider_value =
            sliderValues[vm.animalList.tagSlider].label;
        }
        if (vm.animalList.min_dev_kg_value) {
          vm.min_dev_kg_value = vm.animalList.min_dev_kg_value;
        }
        if (vm.animalList.min_dev_p_value) {
          vm.min_dev_p_value = vm.animalList.min_dev_p_value;
        }
        if (vm.animalList.l1_scc) {
          vm.l1_scc = vm.animalList.l1_scc;
        }
        if (vm.animalList.lg1_scc) {
          vm.lg1_scc = vm.animalList.lg1_scc;
        }
        if (vm.animalList.pictureFilter) {
          vm.pictureFilter = vm.animalList.pictureFilter;
          vm.picturesToShowFilter = vm.animalList.pictureFilter;
          if (vm.animalList.pictureFilter == "p_event") {
            vm.showEventSelector = true;
            if (
              vm.animalList.eventFilter != null &&
              vm.animalList.eventFilter != undefined
            ) {
              vm.eventsFilter = vm.animalList.eventFilter;
              vm.eventsToShowFilter = vm.animalList.eventFilter;
            }
          }
        } else {
          vm.pictureFilter[0] = true;
          vm.picturesToShowFilter = "p_profile";
        }
        if (vm.animalList.predefinedList) {
          vm.selectedPredefinedList = vm.animalList.predefinedList;
          for (var i = 0; i < vm.predefinedLists.length; i++) {
            if (vm.predefinedLists[i].id == vm.animalList.predefinedList) {
              vm.selectedListModel = vm.predefinedLists[i];
              break;
            }
          }
        }
        if (vm.animalList.statusDateList) {
          vm.statusDateList = vm.animalList.statusDateList;
        }
        if (vm.animalList.DIMList) {
          vm.DIMList = vm.animalList.DIMList;
        }
      } else {
        vm.goBackActive = false;
        localStorage.removeItem("animalList");
        vm.statusDateList = [];
        vm.DIMList = [];
        vm.pictureFilter = "p_profile";
        vm.picturesToShowFilter = "p_profile";
        vm.slider_value = 13;
        vm.tag_slider_value = 13;
        vm.selected_slider_value = sliderValues[13].label;
        vm.selected_tags_slider_value = sliderValues[13].label;
        vm.min_dev_kg = true;
        vm.min_dev_p = true;
        vm.dev_y = true;
        vm.sa_active = true;
        vm.g_female = true;
      }
    }

    function selectFilter(key, skipfilter) {
      vm[key] = !vm[key];
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        if (key == "u_h_clinical") {
          if (vm["u_h_clinical"]) {
            vm.order = "DESC";
            vm.sortedColumn = "NrMastCurLact";
            vm.sort_col = "NrMastCurLact_DESC";
          }
        }
        if (key == "u_h_subclinical") {
          if (vm["u_h_subclinical"]) {
            vm.order = "DESC";
            vm.sortedColumn = "NrMastCurLact";
            vm.sort_col = "NrMastCurLact_DESC";
          }
        }
        if (skipfilter != 13) {
          vm.animalsToShow = filterAnimalList(vm.allAnimals);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
        }
        if (key == "u_h_clinical" || key == "u_h_subclinical") {
          setTableDimensions(vm.selectedPredefinedList);
        }
        if (key == "st_not_pregnant") {
          setTableDimensions();
        }
        if (key == "st_served") {
          setTableDimensions();
        }

        if (
          key == "st_none" ||
          key == "st_open" ||
          key == "st_served" ||
          key == "st_not_pregnant" ||
          key == "st_pregnant" ||
          key == "st_barren" ||
          key == "st_aborted" ||
          key == "st_dry" ||
          key == "st_sold" ||
          key == "st_dead" ||
          key == "st_presume_left"
        ) {
          setStatusDateList(key, vm[key]);
        }

        if (key == "s_d" && vm[key]) {
          setStatusDateList();
        }
      }, 696);
    }

    function setStatusDateList(key, value) {
      var list = [
        {
          id: "st_global",
          label: "_label_all_",
          translated: $filter("i18n")("_label_all_"),
        },
      ];

      var status_list = [
        "st_none",
        "st_open",
        "st_served",
        "st_not_pregnant",
        "st_pregnant",
        "st_barren",
        "st_aborted",
        "st_dry",
        "st_sold",
        "st_dead",
        "st_presume_left",
      ];

      for (var i = 0; i < status_list.length; i++) {
        if (vm[status_list[i]]) {
          var obj = getStatusObject(status_list[i]);
          if (obj) {
            list.push(obj);
          }
        }
      }

      vm.selectedStatusList = list;

      if (value && key) {
        var item = vm.selectedStatusList.findIndex(function (element) {
          return element.id == key;
        });
        if (item == -1) {
          vm.selectedStatus =
            vm.selectedStatusList[vm.selectedStatusList.length - 1];
        } else {
          vm.selectedStatus = vm.selectedStatusList[item];
        }
      } else {
        vm.selectedStatus =
          vm.selectedStatusList[vm.selectedStatusList.length - 1];
      }
    }

    function getStatusObject(key) {
      var obj;
      switch (key) {
        case "st_none":
          obj = {
            id: "st_none",
            label: "_animal_status_none_",
            translated: $filter("i18n")("_animal_status_none_"),
            status: 0,
          };
          break;
        case "st_open":
          obj = {
            id: "st_open",
            label: "_animal_status_open_",
            translated: $filter("i18n")("_animal_status_open_"),
            status: 1,
          };
          break;
        case "st_served":
          obj = {
            id: "st_served",
            label: "_animal_status_inseminated_",
            translated: $filter("i18n")("_animal_status_inseminated_"),
            status: 3,
          };
          break;
        case "st_not_pregnant":
          obj = {
            id: "st_not_pregnant",
            label: "_animal_status_not_pregnant_",
            translated: $filter("i18n")("_animal_status_not_pregnant_"),
            status: 4,
          };
          break;
        case "st_pregnant":
          obj = {
            id: "st_pregnant",
            label: "_animal_status_pregnant_",
            translated: $filter("i18n")("_animal_status_pregnant_"),
            status: 5,
          };
          break;
        case "st_barren":
          obj = {
            id: "st_barren",
            label: "_animal_status_barren_",
            translated: $filter("i18n")("_animal_status_barren_"),
            status: 6,
          };
          break;
        case "st_aborted":
          obj = {
            id: "st_aborted",
            label: "_animal_status_aborted_",
            translated: $filter("i18n")("_animal_status_aborted_"),
            status: 7,
          };
          break;
        case "st_dry":
          obj = {
            id: "st_dry",
            label: "_animal_status_dry_",
            translated: $filter("i18n")("_animal_status_dry_"),
            status: 8,
          };
          break;
        case "st_sold":
          obj = {
            id: "st_sold",
            label: "_animal_status_sold_",
            translated: $filter("i18n")("_animal_status_sold_"),
            status: 9,
          };
          break;
        case "st_dead":
          obj = {
            id: "st_dead",
            label: "_animal_status_dead_",
            translated: $filter("i18n")("_animal_status_dead_"),
            status: 10,
          };
          break;
        case "st_presume_left":
          obj = {
            id: "st_presume_left",
            label: "_animal_status_presume_left_",
            translated: $filter("i18n")("_animal_status_presume_left_"),
            status: 11,
          };
          break;
        case "st_global":
          obj = {
            id: "st_global",
            label: "_label_all_",
            translated: $filter("i18n")("_label_all_"),
            status: 99,
          };
          break;

        default:
          break;
      }

      return obj;
    }

    function deviationSelected(key) {
      vm[key] = !vm[key];
      if (key == "min_dev_p") {
        if (!vm[key] && !vm.min_dev_kg) {
          vm.min_dev_kg = true;
        }
      } else if (key == "min_dev_kg") {
        if (!vm[key] && !vm.min_dev_p) {
          vm.min_dev_p = true;
        }
      }
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function selectDeviationTime(key) {
      if (!vm[key]) {
        if (key == "dev_t") {
          vm.dev_t = true;
          vm.dev_y = false;
          vm.dev_tda = false;
        } else if (key == "dev_y") {
          vm.dev_t = false;
          vm.dev_y = true;
          vm.dev_tda = false;
        } else if (key == "dev_tda") {
          vm.dev_t = false;
          vm.dev_y = false;
          vm.dev_tda = true;
        }
      }
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function deviationValueChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function sccValueChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function selectedPickerList() {
      selectPredefinedList(vm.selectedListModel, true);
    }

    function emptyList() {
      deselectAllFilters();
      vm.animalsToShow = [];
      vm.animals = [];
      vm.totalAnimals = 0;
    }

    function selectPredefinedList(list, picker) {
      var type = list.id;
      if (vm.selectedPredefinedList == type) {
        vm.selectedPredefinedList = null;
        vm.selectedListModel = null;
        setTableDimensions("default");
        deselectAllFilters();
        setDefaultFilters();
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        checkComments();
      } else {
        if (!picker) {
          vm.selectedListModel = null;
        }
        deselectAllFilters();
        vm.selectedPredefinedList = type;
        setTableDimensions(vm.selectedPredefinedList);
        sendDataToEventBus(type);
        updateFavorites(type);

        if (!list.user_defined) {
          var list = [];
          if (vm.allAnimals.length > 0) {
            if (type == "transition_cows") {
              selectPredefinedFilters("transition_cows");
              list = Filter(vm.allAnimals, function (el) {
                return el.Parity >= 0 && el.DIM < 30;
              });
              list = $filter("orderBy")(list, "DIM");
            } else if (type == "calving_attentions") {
              selectPredefinedFilters("calving_attentions");
              list = Filter(vm.allAnimals, function (el) {
                if (el.ExpectedCalvingDate) {
                  var difference = moment(el.ExpectedCalvingDate).diff(
                    moment(),
                    "days"
                  );
                  return (
                    el.ExpectedCalvingDate &&
                    difference > -60 &&
                    difference < 30
                  );
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "DaysSinceLastHI", true);
            } else if (type == "dry_cow_attention") {
              selectPredefinedFilters("dry_cow_attention");
              list = Filter(vm.allAnimals, function (el) {
                if (el.ExpectedDryDate) {
                  var difference = moment(el.ExpectedDryDate).diff(
                    moment(),
                    "days"
                  );
                  return el.CurrentStatus == 5 && difference > -60;
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "ExpectedDryDate");
            } else if (type == "preg_check") {
              selectPredefinedFilters("preg_check");
              list = Filter(vm.allAnimals, function (el) {
                if (el.StatusDate) {
                  var difference = moment(el.StatusDate).diff(moment(), "days");
                  return (
                    el.CurrentStatus == 3 &&
                    difference <= -28 &&
                    difference >= -100
                  );
                } else {
                  return false;
                }
              });
              list = $filter("orderBy")(list, "StatusDate");
            } else if (type == "cows") {
              selectPredefinedFilters("cows");
              list = Filter(vm.allAnimals, function (el) {
                return el.Parity && el.Parity > 0 && el.IsOnFarm;
              });
            } else if (type == "female_youngstock") {
              selectPredefinedFilters("female_youngstock");
              list = Filter(vm.allAnimals, function (el) {
                return el.Gender == 0 && el.Parity == 0 && el.IsOnFarm;
              });
            } else if (type == "heat_attention") {
              selectPredefinedFilters("heat_attention");
              list = Filter(vm.allAnimals, function (el) {
                var status_date =
                  moment().diff(moment(el.StatusDate), "days") + 1;
                return (
                  el.IsOnFarm &&
                  el.Parity >= 0 &&
                  el.CurrentStatus == 3 &&
                  ((status_date > 17 && status_date < 25) ||
                    (status_date > 35 && status_date < 49))
                );
              });
              list = $filter("orderBy")(list, "StatusDate");
            } else if (type == "heifers_to_be_inseminated") {
              selectPredefinedFilters("heifers_to_be_inseminated");
              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 7) &&
                  el.Age > 400 &&
                  el.Parity == 0
                );
              });
              list = $filter("orderBy")(list, "BirthDate");
            } else if (type == "open_cows") {
              selectPredefinedFilters("open_cows");
              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 7) &&
                  el.Parity > 0
                );
              });
              list = $filter("orderBy")(list, "LastCalvingDate");
            } else if (type == "daily_milk_production") {
              selectPredefinedFilters("daily_milk_production");
              list = Filter(vm.allAnimals, function (el) {
                return el.IsOnFarm && el.Gender == 0 && el.Parity > 0;
              });
            } else if (type == "treated_cows_heifers") {
              selectPredefinedFilters("treated_cows_heifers");
              list = Filter(vm.allAnimals, function (el) {
                var hasTag = false;
                if (el.LactPics && el.LactPics.length > 0) {
                  for (var j = 0; j < el.LactPics.length; j++) {
                    if (
                      el.LactPics[j].Tags &&
                      el.LactPics[j].Tags.length > 0 &&
                      moment(el.LactPics[j].D).isAfter(
                        sliderValues[vm.tag_slider_value].date
                      ) &&
                      el.LactPics[j].Tags.indexOf("TreatedCows") != -1
                    ) {
                      hasTag = true;
                      break;
                    }
                  }
                }
                if (el.Tags && !hasTag) {
                  var tags = el.Tags.split("#");
                  for (var t = 0; t < tags.length; t++) {
                    if (tags[t].indexOf("TreatedCows") != -1) {
                      hasTag = true;
                      break;
                    }
                  }
                }
                return el.IsOnFarm && el.Gender == 0 && hasTag;
              });
            } else if (type == "attention_list_milk_production") {
              selectPredefinedFilters("attention_list_milk_production");
              list = Filter(vm.allAnimals, function (el) {
                var lwm_index;
                if (vm.dev_t) {
                  lwm_index = 0;
                } else if (vm.dev_y) {
                  lwm_index = 1;
                } else if (vm.dev_tda) {
                  lwm_index = 2;
                }
                return (
                  el.IsOnFarm &&
                  el.DIM > 14 &&
                  el.LastWeekMilk &&
                  el.LastWeekMilk[lwm_index].v &&
                  el.LastWeekMilkRecords >= 3 &&
                  el.LastWeekMilk[lwm_index].dev_kg > vm.min_dev_kg_value &&
                  el.LastWeekMilk[lwm_index].dev_percent > vm.min_dev_p_value
                );
              });
            } else if (type == "milk_production_7_days") {
              selectPredefinedFilters("milk_production_7_days");

              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  el.Parity > 0 &&
                  el.Gender == 0 &&
                  (el.CurrentStatus == 1 ||
                    el.CurrentStatus == 3 ||
                    el.CurrentStatus == 4 ||
                    el.CurrentStatus == 5)
                );
              });

              list = $filter("orderBy")(list, "MilkSort");
            } else if (type == "attention_list_scc") {
              selectPredefinedFilters("attention_list_scc");

              list = Filter(vm.allAnimals, function (el) {
                return (
                  el.IsOnFarm &&
                  el.LastMilkRecording &&
                  el.LastMilkRecording.SCC &&
                  ((el.Parity == 1 && el.LastMilkRecording.SCC > vm.l1_scc) ||
                    (el.Parity > 1 && el.LastMilkRecording.SCC > vm.lg1_scc))
                );
              });
            }
          }
          vm.predefinedList = list;
          vm.animalsToShow = list;
          vm.animalsToShow = removeDuplicates(vm.animalsToShow);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
          checkComments();
        } else {
          var list_raw = vm.userlistsRaw.find(function (item) {
            return item.id == list.id;
          });

          if (list_raw) {
            angular.forEach(list_raw, function (value, key) {
              if (
                key == "st_none" ||
                key == "st_open" ||
                key == "st_served" ||
                key == "st_not_pregnant" ||
                key == "st_pregnant" ||
                key == "st_barren" ||
                key == "st_aborted" ||
                key == "st_dry" ||
                key == "st_sold" ||
                key == "st_dead" ||
                key == "st_presume_left" ||
                key == "s_d" ||
                key == "p_zero" ||
                key == "p_one" ||
                key == "p_two" ||
                key == "p_three_and_more" ||
                key == "p_custom" ||
                key == "custom_parity" ||
                key == "dim_1" ||
                key == "dim_2" ||
                key == "dim_3" ||
                key == "dim_4" ||
                key == "dim_5" ||
                key == "dim_6" ||
                key == "dim_7" ||
                key == "age_1" ||
                key == "age_2" ||
                key == "age_3" ||
                key == "tag_slider_value" ||
                key == "g_male" ||
                key == "g_female" ||
                key == "sa_active" ||
                key == "sa_history" ||
                key == "at_ce_tc" ||
                key == "m_a_milk" ||
                key == "h_e_diseases" ||
                key == "h_e_prevention" ||
                key == "u_h_clinical" ||
                key == "u_h_subclinical" ||
                key == "c_h" ||
                key == "al_mp" ||
                key == "al_scc" ||
                key == "min_dev_p" ||
                key == "min_dev_p_value" ||
                key == "l1_scc" ||
                key == "lg1_scc" ||
                key == "min_dev_kg" ||
                key == "min_dev_kg_value" ||
                key == "dev_t" ||
                key == "dev_y" ||
                key == "dev_tda"
              ) {
                vm[key] = value;
              }

              if (key == "s_days") {
                vm.statusDateList = getStatusDateList(value);
              }

              if (key == "tags") {
                vm.tags = getTags(value);
              }

              if (vm.tags && vm.tags.length) {
                vm.selected_tags_slider_value =
                  sliderValues[vm.tag_slider_value].label;
                vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
              }

              if (key == "image_filter") {
                vm.pictureFilter = value;
              }

              if (vm.pictureFilter == "p_event") {
                vm.showEventSelector = true;
              } else {
                vm.showEventSelector = false;
              }

              if (key == "image_event_filter") {
                vm.eventsFilter = value;
              }

              if (key == "e_slider_value") {
                vm.slider_value = value;
              }
            });

            if (vm.tags && vm.tags.length) {
              vm.selected_tags_slider_value =
                sliderValues[vm.tag_slider_value].label;
              vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
            }

            if (
              vm.at_ce_tc ||
              vm.m_a_milk ||
              vm.h_e_diseases ||
              vm.h_e_prevention ||
              vm.u_h_clinical ||
              vm.u_h_subclinical ||
              vm.c_h
            ) {
              vm.selected_slider_value = sliderValues[vm.slider_value].label;
              vm.selected_slider = sliderValues[vm.slider_value];
            }

            if (vm.s_d) {
              setStatusDateList();
            }

            vm.animalsToShow = filterAnimalList(vm.allAnimals);
            vm.totalAnimals = vm.animalsToShow.length;
            vm.currentPage = 1;
            setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
            checkComments();
            setTableDimensions();
          }
        }
      }
    }

    function getStatusDateList(list) {
      for (var i = 0; i < list.length; i++) {
        list[i].uuid = uuidv4();
        var status = getStatusObject(list[i].status);
        if (status) {
          list[i].label = status.label;
          list[i].status_label = status.label
            ? $filter("i18n")(status.label)
            : "";
        }
      }

      return list;
    }

    function getTags(tags) {
      var list = [];
      if (tags) {
        var l_tags = tags.split("#");
        for (var i = 0; i < l_tags.length; i++) {
          for (var j = 0; j < vm.tagsList.length; j++) {
            if (l_tags[i] == vm.tagsList[j].value) {
              list.push(vm.tagsList[j]);
            }
          }
        }
      }
      return list;
    }

    function setTableDimensions(type) {
      vm.showTable = false;
      $timeout(function () {
        vm.showTable = true;
      }, 10);
    }

    function sendDataToEventBus(type) {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      // then to call it, plus stitch in '4' in the third group
      var guid = (
        S4() +
        S4() +
        "-" +
        S4() +
        "-4" +
        S4().substr(0, 3) +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      ).toLowerCase();
      var user = JSON.parse(localStorage.getItem("user_profile"));
      var eb_object = {
        event_type: "mymmmooogle",
        event_id: guid,
        source_id: "NlhcYlJF3qLmUApBigr5iaH7u4DNcMaW",
        timestamp: new Date().toISOString(),
        payload: {
          user: user.user_id,
          subject: "predefined_list",
          subject_id: type,
        },
      };
      return listGeneratorService
        .sendDataToEventBus(eb_object)
        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        });
    }

    function updateFavorites(type) {
      var list = {
        list_id: type,
      };
      listGeneratorService
        .updateOrder(list, vm.selectedHerd)
        .then(function (response) {})
        .catch(function (error) {
          console.log(error);
        });
    }

    function selectPredefinedFilters(type) {
      resetSelectedStatus();
      if (type == "cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.g_female = true;
        vm.p_three_and_more = true;
      } else if (type == "female_youngstock") {
        vm.g_female = true;
        vm.p_zero = true;
      } else if (type == "calving_attentions") {
        vm.st_pregnant = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 250,
          to: 300,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
      } else if (type == "dry_cow_attention") {
        vm.st_pregnant = true;
        vm.s_d = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.g_female = true;
        vm.p_three_and_more = true;
        var obj = {
          uuid: uuidv4(),
          from: 220,
          to: 300,
          status: vm.selectedStatus.id,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
      } else if (type == "open_cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_open = true;
        vm.st_not_pregnant = true;
        vm.st_aborted = true;
        vm.g_female = true;
      } else if (type == "heat_attention") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 18,
          to: 24,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
        var obj1 = {
          uuid: uuidv4(),
          from: 36,
          to: 48,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj1);
      } else if (type == "heifers_to_be_inseminated") {
        vm.st_open = true;
        vm.st_not_pregnant = true;
        vm.st_aborted = true;
        vm.p_zero = true;
        vm.age_3 = true;
        vm.g_female = true;
      } else if (type == "preg_check") {
        vm.st_served = true;
        vm.s_d = true;
        vm.g_female = true;
        var obj = {
          uuid: uuidv4(),
          from: 28,
          to: 34,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj);
        var obj1 = {
          uuid: uuidv4(),
          from: 35,
          to: 99,
          status:
            vm.selectedStatus && vm.selectedStatus.id
              ? vm.selectedStatus.id
              : null,
          status_v:
            vm.selectedStatus && vm.selectedStatus.status
              ? vm.selectedStatus.status
              : null,
          status_label:
            vm.selectedStatus && vm.selectedStatus.label
              ? $filter("i18n")(vm.selectedStatus.label)
              : "",
          type: 1,
        };
        vm.statusDateList.push(obj1);
      } else if (type == "transition_cows") {
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.dim_1 = true;
        vm.g_female = true;
      } else if (type == "daily_milk_production") {
        vm.g_female = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_none = true;
        vm.st_open = true;
        vm.st_served = true;
        vm.st_not_pregnant = true;
        vm.st_not_pregnant = true;
        vm.st_pregnant = true;
        vm.st_barren = true;
        vm.st_aborted = true;
      } else if (type == "treated_cows_heifers") {
        vm.g_female = true;
        vm.tags = [
          {
            value: "TreatedCows",
            label: "Treated Cows",
            group: "All",
            trackByIndex: 58,
          },
        ];
      } else if (type == "attention_list_milk_production") {
        vm.al_mp = true;
        vm.min_dev_p = true;
        vm.min_dev_kg = true;
        vm.dev_y = true;
      } else if (type == "milk_production_7_days") {
        vm.g_female = true;
        vm.p_one = true;
        vm.p_two = true;
        vm.p_three_and_more = true;
        vm.st_open = true;
        vm.st_served = true;
        vm.st_not_pregnant = true;
        vm.st_pregnant = true;
      } else if (type == "attention_list_scc") {
        vm.al_scc = true;
      }
    }

    function resetSelectedStatus() {
      vm.selectedStatusList = [
        {
          id: "st_global",
          label: "_label_all_",
          translated: $filter("i18n")("_label_all_"),
        },
      ];

      vm.selectedStatus = vm.selectedStatusList[0];
    }

    function deselectAllFilters() {
      angular.forEach(filters, function (value, key) {
        if (value != "sa_active") {
          vm[value] = false;
        } else {
          vm[value] = true;
        }
      });
      vm.tags = [];
      vm.statusDateList = [];
    }

    function selectPictureFilter(type) {
      if (type != vm.pictureFilter) {
        vm.pictureFilter = type;

        if (type == "p_event") {
          vm.showEventSelector = true;
        } else {
          setPictureToShow(type);
          vm.showEventSelector = false;
        }
      }
    }

    function selectEventFilter(type) {
      if (type != vm.eventsFilter) {
        vm.eventsFilter = type;
        setEventPictureToShow(type);
      }
    }

    function setEventPictureToShow(type) {
      if (type == "p_e_calving") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCaP) {
            image = vm.allAnimals[i];
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_colostrum") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCoP) {
            image = vm.allAnimals[i].LCoP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_first_milk") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMIP) {
            image = vm.allAnimals[i].LMIP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_exemination") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LObP) {
            image = vm.allAnimals[i].LObP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_tests") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LTeP) {
            image = vm.allAnimals[i].LTeP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_milk_m") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMMP) {
            image = vm.allAnimals[i].LMMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_clinical") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCMP) {
            image = vm.allAnimals[i].LCMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_subclinical") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LSMP) {
            image = vm.allAnimals[i].LSMP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_misc") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LMiscP) {
            image = vm.allAnimals[i].LMiscP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_diseases") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LDP) {
            image = vm.allAnimals[i].LDP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_prevention") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LPP) {
            image = vm.allAnimals[i].LPP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_e_claw_health") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LCHP) {
            image = vm.allAnimals[i].LCHP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      }
      vm.hideImage = true;
      $timeout(function () {
        vm.hideImage = false;
      }, 100);
    }

    function setPictureToShow(type) {
      if (type == "p_profile") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].PP) {
            image = vm.allAnimals[i].PP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_recent") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].LP) {
            image = vm.allAnimals[i].LP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
          setAnimalPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
          setAnimalToShowPicture(
            vm.allAnimals[i].AnimalId,
            vm.allAnimals[i].PictureToShow
          );
        }
      } else if (type == "p_oldest") {
        for (var i = 0; i < vm.allAnimals.length; i++) {
          var image;
          if (vm.allAnimals[i].FP) {
            image = vm.allAnimals[i].FP;
          } else {
            image = null;
          }
          vm.allAnimals[i].PictureToShow = image;
        }
      }
      vm.hideImage = true;
      $timeout(function () {
        vm.hideImage = false;
      }, 100);
    }

    function setAnimalPicture(id, picture) {
      if (vm.animals) {
        for (var i = 0; i < vm.animals.length; i++) {
          if (vm.animals[i].AnimalId == id) {
            vm.animals[i].PictureToShow = picture;
            break;
          }
        }
      }
    }

    function setAnimalToShowPicture(id, picture) {
      if (vm.animals) {
        for (var i = 0; i < vm.animals.length; i++) {
          if (vm.animalsToShow[i].AnimalId == id) {
            vm.animalsToShow[i].PictureToShow = picture;
            break;
          }
        }
      }
    }

    function customParityChanged() {
      if (vm.p_custom) {
        if (filterTimer) {
          $timeout.cancel(filterTimer);
        }
        filterTimer = $timeout(function () {
          vm.animalsToShow = filterAnimalList(vm.allAnimals);
          vm.totalAnimals = vm.animalsToShow.length;
          vm.currentPage = 1;
          setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        }, 696);
      }
    }

    function tagsChanged() {
      if (filterTimer) {
        $timeout.cancel(filterTimer);
      }
      filterTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function sliderChanged() {
      vm.selected_slider_value = sliderValues[vm.slider_value].label;
      vm.selected_slider = sliderValues[vm.slider_value];
      if (sliderTimer) {
        $timeout.cancel(sliderTimer);
      }
      sliderTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function tagsSliderChanged() {
      vm.selected_tags_slider_value = sliderValues[vm.tag_slider_value].label;
      vm.selected_slider_tag = sliderValues[vm.tag_slider_value];
      if (sliderTimer) {
        $timeout.cancel(sliderTimer);
      }
      sliderTimer = $timeout(function () {
        vm.animalsToShow = filterAnimalList(vm.allAnimals);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }, 696);
    }

    function addStatusDateRange(type) {
      if (type == 1) {
        if (vm.s_d_from && vm.s_d_to && vm.s_d_from <= vm.s_d_to) {
          var obj = {
            uuid: uuidv4(),
            from: vm.s_d_from,
            to: vm.s_d_to,
            status:
              vm.selectedStatus && vm.selectedStatus.id
                ? vm.selectedStatus.id
                : null,
            status_v:
              vm.selectedStatus && vm.selectedStatus.status
                ? vm.selectedStatus.status
                : null,
            status_label:
              vm.selectedStatus && vm.selectedStatus.label
                ? $filter("i18n")(vm.selectedStatus.label)
                : "",
            type: type,
          };
          if (vm.statusDateList.length == 0) {
            vm.statusDateList.push(obj);
          } else {
            if (checkStatusDateList(obj)) {
              vm.statusDateList.push(obj);
            }
          }
        }
      } else {
        if (vm.s_d_less || vm.s_d_greater) {
          if (vm.s_d_less) {
            var obj = {
              uuid: uuidv4(),
              from: 1,
              to: vm.s_d_less,
              status:
                vm.selectedStatus && vm.selectedStatus.id
                  ? vm.selectedStatus.id
                  : null,
              status_v:
                vm.selectedStatus && vm.selectedStatus.status
                  ? vm.selectedStatus.status
                  : null,
              status_label:
                vm.selectedStatus && vm.selectedStatus.label
                  ? $filter("i18n")(vm.selectedStatus.label)
                  : "",
              type: type,
              ineq: 1,
            };

            if (vm.statusDateList.length == 0) {
              vm.statusDateList.push(obj);
            } else {
              if (checkStatusDateList(obj)) {
                vm.statusDateList.push(obj);
              }
            }
          }

          if (vm.s_d_greater) {
            var obj = {
              uuid: uuidv4(),
              from: vm.s_d_greater,
              to: 99999,
              status:
                vm.selectedStatus && vm.selectedStatus.id
                  ? vm.selectedStatus.id
                  : null,
              status_v:
                vm.selectedStatus && vm.selectedStatus.status
                  ? vm.selectedStatus.status
                  : null,
              status_label:
                vm.selectedStatus && vm.selectedStatus.label
                  ? $filter("i18n")(vm.selectedStatus.label)
                  : "",
              type: type,
              ineq: 2,
            };

            if (vm.statusDateList.length == 0) {
              vm.statusDateList.push(obj);
            } else {
              if (checkStatusDateList(obj)) {
                vm.statusDateList.push(obj);
              }
            }
          }
        }
      }

      function checkStatusDateList(object) {
        var addObject = true;
        for (var i = 0; i < vm.statusDateList.length; i++) {
          if (object.uuid == vm.statusDateList[i].uuid) {
            object.uuid = object.uuid + "xz";
          }
          if (
            object.from == vm.statusDateList[i].from &&
            object.to == vm.statusDateList[i].to &&
            object.status == vm.statusDateList[i].status &&
            object.type == vm.statusDateList[i].type
          ) {
            addObject = false;
            break;
          }
        }
        return addObject;
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      resetStatusDates();
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function addDIMRange(type) {
      if (type == 1) {
        if (vm.dim_7_from && vm.dim_7_to && vm.dim_7_from <= vm.dim_7_to) {
          var obj = {
            uuid: uuidv4(),
            from: vm.dim_7_from,
            to: vm.dim_7_to,
            type: type,
          };
          if (vm.DIMList.length == 0) {
            vm.DIMList.push(obj);
          } else {
            if (checkDIMList(obj)) {
              vm.DIMList.push(obj);
            }
          }
        }
      } else {
        if (vm.dim_7_less || vm.dim_7_greater) {
          if (vm.dim_7_less) {
            var obj = {
              uuid: uuidv4(),
              from: 1,
              to: vm.dim_7_less,
              type: type,
              ineq: 1,
            };

            if (vm.DIMList.length == 0) {
              vm.DIMList.push(obj);
            } else {
              if (checkDIMList(obj)) {
                vm.DIMList.push(obj);
              }
            }
          }

          if (vm.dim_7_greater) {
            var obj = {
              uuid: uuidv4(),
              from: vm.dim_7_greater,
              to: 99999,
              type: type,
              ineq: 2,
            };

            if (vm.DIMList.length == 0) {
              vm.DIMList.push(obj);
            } else {
              if (checkDIMList(obj)) {
                vm.DIMList.push(obj);
              }
            }
          }
        }
      }

      function checkDIMList(object) {
        var addObject = true;
        for (var i = 0; i < vm.DIMList.length; i++) {
          if (object.uuid == vm.DIMList[i].uuid) {
            object.uuid = object.uuid + "xz";
          }
          if (
            object.from == vm.DIMList[i].from &&
            object.to == vm.DIMList[i].to &&
            object.type == vm.DIMList[i].type
          ) {
            addObject = false;
            break;
          }
        }
        return addObject;
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      resetDIM();
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function resetStatusDates() {
      vm.s_d_from = null;
      vm.s_d_to = null;
      vm.s_d_less = null;
      vm.s_d_greater = null;
    }

    function resetDIM() {
      vm.dim_7_from = null;
      vm.dim_7_to = null;
      vm.dim_7_less = null;
      vm.dim_7_greater = null;
    }

    function uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    }

    function removeFromStatusDateList(item) {
      for (var i = 0; i < vm.statusDateList.length; i++) {
        if (item.uuid == vm.statusDateList[i].uuid) {
          vm.statusDateList.splice(i, 1);
          break;
        }
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function removeFromDIMList(item) {
      for (var i = 0; i < vm.DIMList.length; i++) {
        if (item.uuid == vm.DIMList[i].uuid) {
          vm.DIMList.splice(i, 1);
          break;
        }
      }

      vm.animalsToShow = filterAnimalList(vm.allAnimals);
      vm.totalAnimals = vm.animalsToShow.length;
      vm.currentPage = 1;
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function filterAnimalList(animals) {
      var list = [];
      if (animals && animals.length > 0) {
        animals = checkGender(animals);
        animals = checkShowAnimals(animals);
        animals = checkAnimalEvents(animals);
        animals = checkStatus(animals);
        //animals = checkStatusDate(animals);
        animals = checkParity(animals);
        animals = checkAge(animals);
        animals = checkDIM(animals);
        animals = checkTags(animals);
        animals = checkDeviation(animals);
        animals = checkScc(animals);

        function checkGender(list) {
          if (vm.g_female || vm.g_male) {
            var female = [];
            var male = [];
            if (vm.g_female) {
              female = Filter(list, function (el) {
                return el.Gender == 0;
              });
            }
            if (vm.g_male) {
              male = Filter(list, function (el) {
                return el.Gender == 1;
              });
            }
            return female.concat(male);
          } else {
            return list;
          }
        }

        function checkAnimalEvents(list) {
          if (
            vm.at_newborn ||
            vm.at_ce_tc ||
            vm.m_a_milk ||
            vm.h_e_diseases ||
            vm.h_e_prevention ||
            vm.u_h_clinical ||
            vm.u_h_subclinical ||
            vm.c_h
          ) {
            var newborn = [];
            if (vm.at_newborn) {
              newborn = Filter(list, function (el) {
                var found = false;
                for (var i = 0; i < el.Pictures.length; i++) {
                  if (
                    el.Pictures[i].Tags &&
                    el.Pictures[i].ImageCreated &&
                    el.Pictures[i].Tags.indexOf("#NewbornCalves") != -1 &&
                    moment(el.Pictures[i].ImageCreated).isAfter(
                      sliderValues[vm.slider_value].date
                    )
                  ) {
                    found = true;
                    break;
                  }
                }
                return found;
              });
            }
            var at_ce_tc = [];
            if (vm.at_ce_tc) {
              at_ce_tc = Filter(list, function (el) {
                return (
                  el.LastClinicalExamTransition &&
                  moment(el.LastClinicalExamTransition).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var m_a_milk = [];
            if (vm.m_a_milk) {
              m_a_milk = Filter(list, function (el) {
                return (
                  el.LastManualMilkDate &&
                  moment(el.LastManualMilkDate).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var h_e_diseases = [];
            if (vm.h_e_diseases) {
              h_e_diseases = Filter(list, function (el) {
                return (
                  el.LastDiseaseEvent &&
                  moment(el.LastDiseaseEvent).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var h_e_prevention = [];
            if (vm.h_e_prevention) {
              h_e_prevention = Filter(list, function (el) {
                return (
                  el.LastPreventionEvent &&
                  moment(el.LastPreventionEvent).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var u_h_clinical = [];
            if (vm.u_h_clinical) {
              u_h_clinical = Filter(list, function (el) {
                return (
                  el.LastClinicalMastitis &&
                  moment(el.LastClinicalMastitis).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var u_h_subclinical = [];
            if (vm.u_h_subclinical) {
              u_h_subclinical = Filter(list, function (el) {
                return (
                  el.LastSubClinicalMastitis &&
                  moment(el.LastSubClinicalMastitis).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var c_h = [];
            if (vm.c_h) {
              c_h = Filter(list, function (el) {
                return (
                  el.LastClawHealthDate &&
                  moment(el.LastClawHealthDate).isAfter(
                    sliderValues[vm.slider_value].date
                  )
                );
              });
            }
            var returnList = [];
            returnList = concatWithoutDuplicates(returnList, newborn);
            returnList = concatWithoutDuplicates(returnList, at_ce_tc);
            returnList = concatWithoutDuplicates(returnList, m_a_milk);
            returnList = concatWithoutDuplicates(returnList, h_e_diseases);
            returnList = concatWithoutDuplicates(returnList, h_e_prevention);
            returnList = concatWithoutDuplicates(returnList, u_h_clinical);
            returnList = concatWithoutDuplicates(returnList, u_h_subclinical);
            returnList = concatWithoutDuplicates(returnList, c_h);
            return returnList;
          } else {
            return list;
          }
        }

        function checkShowAnimals(list) {
          if (vm.sa_active || vm.sa_history) {
            var active = [];
            var history = [];
            if (vm.sa_active) {
              active = Filter(list, function (el) {
                return el.IsOnFarm == true;
              });
            }
            if (vm.sa_history) {
              history = Filter(list, function (el) {
                return el.IsOnFarm == false;
              });
            }
            var returnList = active.concat(history);
            return returnList;
          } else {
            return list;
          }
        }

        function checkStatus(list) {
          if (
            vm.s_d ||
            vm.st_none ||
            vm.st_open ||
            vm.st_served ||
            vm.st_not_pregnant ||
            vm.st_pregnant ||
            vm.st_barren ||
            vm.st_aborted ||
            vm.st_dry ||
            vm.st_sold ||
            vm.st_dead ||
            vm.st_presume_left
          ) {
            var global = [];

            global = filterByStatusDate(
              vm.s_d,
              vm.statusDateList,
              list,
              "st_global"
            );

            var none = [];
            if (vm.st_none) {
              none = Filter(list, function (el) {
                return el.CurrentStatus == 0;
              });

              none = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                none,
                "st_none"
              );
            }
            var open = [];
            if (vm.st_open) {
              open = Filter(list, function (el) {
                return el.CurrentStatus == 1;
              });

              open = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                open,
                "st_open"
              );
            }
            var served = [];
            if (vm.st_served) {
              served = Filter(list, function (el) {
                return el.CurrentStatus == 3;
              });
              served = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                served,
                "st_served"
              );
            }
            var not_pregnant = [];
            if (vm.st_not_pregnant) {
              not_pregnant = Filter(list, function (el) {
                return el.CurrentStatus == 4;
              });
              not_pregnant = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                not_pregnant,
                "st_not_pregnant"
              );
            }
            var pregnant = [];
            if (vm.st_pregnant) {
              pregnant = Filter(list, function (el) {
                return el.CurrentStatus == 5;
              });
              pregnant = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                pregnant,
                "st_pregnant"
              );
            }
            var barren = [];
            if (vm.st_barren) {
              barren = Filter(list, function (el) {
                return el.CurrentStatus == 6;
              });
              barren = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                barren,
                "st_barren"
              );
            }
            var aborted = [];
            if (vm.st_aborted) {
              aborted = Filter(list, function (el) {
                return el.CurrentStatus == 7;
              });
              aborted = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                aborted,
                "st_aborted"
              );
            }
            var dry = [];
            if (vm.st_dry) {
              dry = Filter(list, function (el) {
                return el.CurrentStatus == 8;
              });
              dry = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                dry,
                "st_dry"
              );
            }
            var sold = [];
            if (vm.st_sold) {
              sold = Filter(list, function (el) {
                return el.CurrentStatus == 9;
              });
              sold = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                sold,
                "st_sold"
              );
            }
            var dead = [];
            if (vm.st_dead) {
              dead = Filter(list, function (el) {
                return el.CurrentStatus == 10;
              });
              dead = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                dead,
                "st_dead"
              );
            }
            var presume_left = [];
            if (vm.st_presume_left) {
              presume_left = Filter(list, function (el) {
                return el.CurrentStatus == 11;
              });
              presume_left = filterByStatusDate(
                vm.s_d,
                vm.statusDateList,
                presume_left,
                "st_presume_left"
              );
            }
            var returnList = global
              .concat(none)
              .concat(open)
              .concat(served)
              .concat(not_pregnant)
              .concat(pregnant)
              .concat(barren)
              .concat(aborted)
              .concat(dry)
              .concat(sold)
              .concat(dead)
              .concat(presume_left);
            return returnList;
          } else {
            return list;
          }
        }

        function filterByStatusDate(
          is_filter_active,
          status_list,
          animal_list,
          status
        ) {
          if (is_filter_active) {
            var cs_status_list = Filter(status_list, function (el) {
              return el.status == status;
            });

            if (cs_status_list && cs_status_list.length) {
              var s_d = [];
              for (var i = 0; i < cs_status_list.length; i++) {
                var l = Filter(animal_list, function (el) {
                  var statusDate =
                    moment().diff(moment(el.StatusDate), "days") + 1;
                  if (cs_status_list[i].status_v) {
                    return (
                      statusDate > cs_status_list[i].from - 1 &&
                      statusDate < cs_status_list[i].to + 1 &&
                      el.CurrentStatus == cs_status_list[i].status_v
                    );
                  }
                  return (
                    statusDate > cs_status_list[i].from - 1 &&
                    statusDate < cs_status_list[i].to + 1
                  );
                });
                s_d = concatWithoutDuplicates(s_d, l);
              }
              return s_d;
            } else {
              return animal_list;
            }
          } else {
            return animal_list;
          }
        }

        function checkParity(list) {
          if (
            vm.p_zero ||
            vm.p_one ||
            vm.p_two ||
            vm.p_three_and_more ||
            vm.p_custom
          ) {
            var one = [];
            var two = [];
            var three = [];
            var custom = [];
            var zero = [];
            if (vm.p_zero) {
              zero = Filter(list, function (el) {
                return el.Parity == 0;
              });
            }
            if (vm.p_one) {
              one = Filter(list, function (el) {
                return el.Parity == 1;
              });
            }
            if (vm.p_two) {
              two = Filter(list, function (el) {
                return el.Parity == 2;
              });
            }
            if (vm.p_three_and_more) {
              three = Filter(list, function (el) {
                return el.Parity > 2;
              });
            }
            if (vm.p_custom) {
              if (vm.custom_parity != undefined) {
                custom = Filter(list, function (el) {
                  return el.Parity == vm.custom_parity;
                });
              } else {
                custom = list;
              }
            }
            var returnList = [];
            returnList = concatWithoutDuplicates(returnList, zero);
            returnList = concatWithoutDuplicates(returnList, one);
            returnList = concatWithoutDuplicates(returnList, two);
            returnList = concatWithoutDuplicates(returnList, three);
            returnList = concatWithoutDuplicates(returnList, custom);
            return returnList;
          } else {
            return list;
          }
        }

        function checkDIM(list) {
          var today = moment();
          if (
            vm.dim_1 ||
            vm.dim_2 ||
            vm.dim_3 ||
            vm.dim_4 ||
            vm.dim_5 ||
            vm.dim_6 ||
            (vm.dim_7 && vm.DIMList.length)
          ) {
            var dim_1 = [];
            if (vm.dim_1) {
              dim_1 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 0 && dim < 30;
              });
            }
            var dim_2 = [];
            if (vm.dim_2) {
              dim_2 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 29 && dim < 61;
              });
            }
            var dim_3 = [];
            if (vm.dim_3) {
              dim_3 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 59 && dim < 121;
              });
            }
            var dim_4 = [];
            if (vm.dim_4) {
              dim_4 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 119 && dim < 201;
              });
            }
            var dim_5 = [];
            if (vm.dim_5) {
              dim_5 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 199 && dim < 306;
              });
            }
            var dim_6 = [];
            if (vm.dim_6) {
              dim_6 = Filter(list, function (el) {
                var dim = today.diff(el.LastCalvingDate, "days") + 1;
                return dim > 305;
              });
            }
            var dim_7 = [];
            if (vm.dim_7 && vm.DIMList.length) {
              for (var i = 0; i < vm.DIMList.length; i++) {
                var l = Filter(list, function (el) {
                  var dim = today.diff(el.LastCalvingDate, "days") + 1;
                  return (
                    dim > vm.DIMList[i].from - 1 && dim < vm.DIMList[i].to + 1
                  );
                });
                dim_7 = concatWithoutDuplicates(dim_7, l);
              }
            }
            var returnList = dim_1
              .concat(dim_2)
              .concat(dim_3)
              .concat(dim_4)
              .concat(dim_5)
              .concat(dim_6);

            returnList = concatWithoutDuplicates(returnList, dim_7);
            return returnList;
          } else {
            return list;
          }
        }

        function checkAge(list) {
          if (vm.age_1 || vm.age_2 || vm.age_3) {
            var age_1 = [];
            if (vm.age_1) {
              age_1 = Filter(list, function (el) {
                return el.Age > 0 && el.Age < 200;
              });
            }
            var age_2 = [];
            if (vm.age_2) {
              age_2 = Filter(list, function (el) {
                return el.Age > 199 && el.Age < 401;
              });
            }
            var age_3 = [];
            if (vm.age_3) {
              age_3 = Filter(list, function (el) {
                return el.Age > 400;
              });
            }
            var returnList = age_1.concat(age_2).concat(age_3);
            return returnList;
          } else {
            return list;
          }
        }

        function checkTags(list) {
          if (vm.tags && vm.tags.length > 0) {
            var returnList = Filter(list, function (el) {
              var insert = false;
              if (el.LactPics && el.LactPics.length > 0) {
                for (var i = 0; i < vm.tags.length; i++) {
                  for (var j = 0; j < el.LactPics.length; j++) {
                    if (
                      el.LactPics[j].Tags &&
                      el.LactPics[j].Tags.length > 0 &&
                      moment(el.LactPics[j].D).isAfter(
                        sliderValues[vm.tag_slider_value].date
                      ) &&
                      el.LactPics[j].Tags.indexOf(vm.tags[i].value) != -1
                    ) {
                      insert = true;
                      break;
                    }
                  }
                }
              }
              if (el.Tags && !insert) {
                var tags = el.Tags.split("#");
                for (var i = 0; i < vm.tags.length; i++) {
                  for (var t = 0; t < tags.length; t++) {
                    if (tags[t].indexOf(vm.tags[i].value) != -1) {
                      insert = true;
                      break;
                    }
                  }
                }
              }
              return insert;
            });
            return returnList;
          } else {
            return list;
          }
        }

        function checkDeviation(list) {
          if (vm.al_mp) {
            if (vm.min_dev_p || vm.min_dev_kg) {
              if (vm.min_dev_p) {
                list = Filter(list, function (el) {
                  var lwm_index;
                  if (vm.dev_t) {
                    lwm_index = 0;
                  } else if (vm.dev_y) {
                    lwm_index = 1;
                  } else if (vm.dev_tda) {
                    lwm_index = 2;
                  }
                  return el.LastWeekMilk
                    ? el.LastWeekMilk[lwm_index].dev_percent >
                        vm.min_dev_p_value
                    : false;
                });
              }
              if (vm.min_dev_kg) {
                list = Filter(list, function (el) {
                  var lwm_index;
                  if (vm.dev_t) {
                    lwm_index = 0;
                  } else if (vm.dev_y) {
                    lwm_index = 1;
                  } else if (vm.dev_tda) {
                    lwm_index = 2;
                  }
                  return el.LastWeekMilk
                    ? el.LastWeekMilk[lwm_index].dev_kg > vm.min_dev_kg_value
                    : false;
                });
              }
              return list;
            } else {
              return list;
            }
          } else {
            return list;
          }
        }
        function checkScc(list) {
          if (vm.al_scc) {
            list = Filter(list, function (el) {
              return (
                el.IsOnFarm &&
                el.LastMilkRecording &&
                el.LastMilkRecording.SCC &&
                ((el.Parity == 1 && el.LastMilkRecording.SCC > vm.l1_scc) ||
                  (el.Parity > 1 && el.LastMilkRecording.SCC > vm.lg1_scc))
              );
            });

            return list;
          } else {
            return list;
          }
        }
        animals = orderList(animals);
        animals = removeDuplicates(animals);
        return animals;
      } else {
        return animals;
      }
    }

    function concatWithoutDuplicates(list1, list2) {
      for (var i = 0; i < list2.length; i++) {
        if (checkAnimalList(list1, list2[i])) {
          list1.push(list2[i]);
        }
      }
      return list1;

      function checkAnimalList(list, animal) {
        var doInsert = true;
        for (var i = 0; i < list.length; i++) {
          if (list[i].AnimalId == animal.AnimalId) {
            doInsert = false;
            break;
          }
        }
        return doInsert;
      }
    }

    function getAnimalClass(animal) {
      return animal.animalClass;
    }

    function getAnimals(herd_id) {
      return listGeneratorService
        .getAnimals(herd_id)
        .then(function (response) {
          if (herd_id == vm.selectedHerd) {
            var today = moment();
            for (var i = 0; i < response.length; i++) {
              if (response[i].LastCalvingDate) {
                response[i].DIM =
                  today.diff(response[i].LastCalvingDate, "days") + 1;
              }

              response[i].Age = today.diff(response[i].BirthDate, "days") + 1;
              if (response[i].LastHeatInseminationDate) {
                response[i].DaysSinceLastHI = today.diff(
                  response[i].LastHeatInseminationDate,
                  "days"
                );
              }
              if (response[i].PP) {
                response[i].PictureToShow = response[i].PP;
              } else {
                response[i].PictureToShow = null;
              }
              if (response[i].StatusDate) {
                response[i].DateString = $filter("date")(
                  response[i].StatusDate,
                  "shortDate"
                );
              }
              if (response[i].CurrentStatus == 0) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_none_"
                );
                response[i].animalClass = "animal-none";
              } else if (response[i].CurrentStatus == 1) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_open_"
                );
                response[i].animalClass = "animal-open";
              } else if (response[i].CurrentStatus == 3) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_inseminated_"
                );
                response[i].animalClass = "animal-served";
              } else if (response[i].CurrentStatus == 4) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_not_pregnant_"
                );
                response[i].animalClass = "animal-non-pregnant";
              } else if (response[i].CurrentStatus == 5) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_pregnant_"
                );
                response[i].animalClass = "animal-pregnant";
              } else if (response[i].CurrentStatus == 6) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_barren_"
                );
                response[i].animalClass = "animal-barren";
              } else if (response[i].CurrentStatus == 7) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_aborted_"
                );
              } else if (response[i].CurrentStatus == 8) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_dry_"
                );
                response[i].animalClass = "animal-dry";
              } else if (response[i].CurrentStatus == 9) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_sold_"
                );
              } else if (response[i].CurrentStatus == 10) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_dead_"
                );
              } else if (response[i].CurrentStatus == 11) {
                response[i].CurrentStatusString = i18nFilter(
                  "_animal_status_presume_left_"
                );
              }
              response[i].Comments = null;
              if (
                response[i].LastCalvingDate &&
                moment(response[i].LastHeatInseminationDate).isBefore(
                  response[i].LastCalvingDate
                )
              ) {
                response[i].LastHeatInseminationDate = null;
              }
              response[i].StatusDays =
                today.diff(response[i].StatusDate, "days") + 1;
              if (response[i].CurrentStatus == 8) {
                response[i].DaysDry = response[i].StatusDays;
                response[i].DIM = response[i].DIM - response[i].DaysDry + 1;
              }
              response[i].NumberOfInseminations = response[i].NrInsCurLact;
              if (response[i].LastWeekMilk) {
                response[i].LastWeekMilk.reverse();
                if (response[i].LastWeekMilk[0]) {
                  response[i].MilkSort = response[i].LastWeekMilk[0];
                } else {
                  response[i].MilkSort = 0;
                }
                var c = 0;
                var sum = 0;
                var last_date;
                for (var j = 0; j < response[i].LastWeekMilk.length; j++) {
                  if (
                    response[i].LastWeekMilk[j] !== null &&
                    response[i].LastWeekMilk[j] !== undefined
                  ) {
                    c++;
                    sum += response[i].LastWeekMilk[j];
                  }
                  var obj = {
                    v: response[i].LastWeekMilk[j],
                    d: moment().subtract(j, "days").format(),
                  };
                  if (obj.v) {
                    if (!last_date) {
                      last_date = obj.d;
                    }
                  }
                  if (sum && c) {
                    response[i].Avg_MP = sum / c;
                    response[i].LastWeekMilkRecords = c;
                  }
                  response[i].LastWeekMilk[j] = obj;
                }
                for (var j = 0; j < response[i].LastWeekMilk.length; j++) {
                  if (response[i].LastWeekMilk[j].v) {
                    response[i].LastWeekMilk[j].dev_kg = round(
                      Math.abs(
                        response[i].LastWeekMilk[j].v - response[i].Avg_MP
                      ),
                      2
                    );
                    response[i].LastWeekMilk[j].dev_percent = round(
                      (response[i].LastWeekMilk[j].dev_kg /
                        response[i].Avg_MP) *
                        100,
                      2
                    );
                  }
                }
                response[i].LastWeekMilkSvg = $sce.trustAsHtml(
                  response[i].LastWeekMilkSvg
                );
                response[i].LastWeekMilkSort = last_date;
              } else {
                response[i].MilkSort = 0;
              }

              if (
                response[i].LastClinicalMastitis &&
                response[i].LastSubClinicalMastitis
              ) {
                if (
                  moment(response[i].LastClinicalMastitis).isAfter(
                    response[i].LastSubClinicalMastitis
                  )
                ) {
                  response[i].LastMastitis = response[i].LastClinicalMastitis;
                } else {
                  response[i].LastMastitis =
                    response[i].LastSubClinicalMastitis;
                }
              } else if (response[i].LastClinicalMastitis) {
                response[i].LastMastitis = response[i].LastClinicalMastitis;
              } else if (response[i].LastSubClinicalMastitis) {
                response[i].LastMastitis = response[i].LastSubClinicalMastitis;
              }
              if (response[i].LastMastitis) {
              }
            }
            vm.rawAnimalData = response;
            animals.resolve();
          }
        })
        .catch(function (error) {
          animals.reject();
          vm.loading = false;
        });
    }

    function sort(column) {
      if (!vm.loadingTable) {
        var col;
        if (column != vm.sortedColumn) {
          vm.sortedColumn = column;
          vm.order = "ASC";
          col = column + "_" + vm.order;
        } else {
          if (vm.order == "ASC") {
            vm.order = "DESC";
            col = column + "_" + vm.order;
          } else if (vm.order == "DESC") {
            vm.order = null;
            vm.sortedColumn = null;
            col = null;
          }
        }
        vm.sort_col = col;
        vm.animalsToShow = orderList(vm.animalsToShow);
        vm.totalAnimals = vm.animalsToShow.length;
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
        if (vm.searchAnimals && vm.searchAnimals.length > 0) {
          vm.searchAnimals = orderList(vm.searchAnimals);
        }
      }
    }

    function orderList(list) {
      var order;
      if (vm.order == "ASC") {
        order = false;
      } else if (vm.order == "DESC") {
        order = true;
      }
      if (vm.sortedColumn) {
        list = $filter("orderBy")(list, vm.sortedColumn, order);
      } else {
        if (!vm.selectedPredefinedList) {
          list = $filter("orderBy")(list, "Number");
        }
      }
      return list;
    }

    function selectAnimal(animal) {
      var activeFilters = [];
      angular.forEach(filters, function (value, key) {
        if (vm[value]) {
          activeFilters.push(value);
        }
      });
      var animalList = [];
      for (var i = 0; i < vm.animals.length; i++) {
        if (vm.animals[i].PictureToShow) {
          var obj = {
            id: vm.animals[i].AnimalId,
            p_id: vm.animals[i].PictureToShow.Id,
            p: vm.animals[i].PictureToShow.I,
            d: vm.animals[i].PictureToShow.D,
            number: vm.animals[i].Number,
            pictureImageUrl: vm.animals[i].PictureToShow.I,
            EarTag: vm.animals[i].EarTag,
          };
        } else {
          var obj = {
            id: vm.animals[i].AnimalId,
            number: vm.animals[i].Number,
            EarTag: vm.animals[i].EarTag,
          };
        }
        animalList.push(obj);
      }
      var pictureFilter = vm.pictureFilter;
      var eventFilter = vm.eventsFilter;
      var data = {
        herdId: vm.selectedHerd,
        list: animalList,
        state: "herds.listGenerator",
        filters: activeFilters,
        slider: vm.slider_value,
        tagSlider: vm.tag_slider_value,
        customParity: vm.custom_parity,
        tags: vm.tags,
        pictureFilter: pictureFilter,
        eventFilter: eventFilter,
        predefinedList: vm.selectedPredefinedList,
        statusDateList: vm.statusDateList,
        min_dev_p_value: vm.min_dev_p_value,
        min_dev_kg_value: vm.min_dev_kg_value,
        l1_scc: vm.l1_scc,
        lg1_scc: vm.lg1_scc,
      };
      animalsService.animalList = data;
      localStorage.setItem("animalList", JSON.stringify(data));
      $rootScope.$broadcast("list_selected_animal");
      $state.go("animalDatails", {
        animal_id: animal.AnimalId.toString(16),
      });
    }

    function openNewDiscussionModal(animal) {
      vm.selectedAnimalId = animal.AnimalId;
      vm.discussion = {};
      vm.discussion.importance = 0;
      vm.loadingNewDiscussion = false;
      vm.discussion.created = new Date().toISOString();
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/herds/listGenerator/addNewDiscussion.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function addNewDiscussion() {
      vm.loadingNewDiscussion = true;
      var suffix = "?created=" + vm.discussion.created;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix =
          suffix +
          "&tags=" +
          encodeURIComponent(vm.discussion.tags) +
          encodeURIComponent("#") +
          encodeURIComponent(setALTags());
      } else {
        suffix = suffix + "&tags=" + encodeURIComponent(setALTags());
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      return listGeneratorService
        .addNewDiscussion(vm.selectedAnimalId, suffix)
        .then(function (response) {
          vm.loadingNewDiscussion = false;
          for (var i = 0; i < vm.animals.length; i++) {
            if (vm.animals[i].AnimalId == vm.selectedAnimalId) {
              vm.animals[i].Comments = vm.discussion.comments;
            }
          }
          for (var i = 0; i < vm.animalsToShow.length; i++) {
            if (vm.animalsToShow[i].AnimalId == vm.selectedAnimalId) {
              vm.animals[i].animalsToShow = vm.discussion.comments;
            }
          }
          for (var i = 0; i < vm.allAnimals.length; i++) {
            if (vm.allAnimals[i].AnimalId == vm.selectedAnimalId) {
              vm.allAnimals[i].animalsToShow = vm.discussion.comments;
            }
          }
          $uibModalStack.dismissAll();
        })
        .catch(function (error) {
          console.log(error);
          vm.loadingNewDiscussion = false;
        });
    }

    function animalSearchChanged() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        if (vm.animal_search_string && vm.animal_search_string.length > 0) {
          vm.searchAnimals = Filter(vm.allAnimals, function (el) {
            var name = false;
            if (
              el.Name &&
              el.Name.toLowerCase().indexOf(
                vm.animal_search_string.toLowerCase()
              ) != -1
            ) {
              name = true;
            }
            var number = false;
            var n = angular.copy(el.Number);
            if (
              el.Number &&
              n
                .toString()
                .toLowerCase()
                .indexOf(vm.animal_search_string.toLowerCase()) != -1
            ) {
              number = true;
            }
            var earTag = false;
            var et = angular.copy(el.EarTag);
            if (
              el.EarTag &&
              et
                .toString()
                .toLowerCase()
                .indexOf(vm.animal_search_string.toLowerCase()) != -1
            ) {
              earTag = true;
            }
            if (!vm.searchByName) {
              name = false;
            }
            if (!vm.searchByNumber) {
              number = false;
            }
            if (!vm.searchByEarTag) {
              earTag = false;
            }
            return name || number || earTag;
          });
        } else {
          vm.searchAnimals = [];
          vm.showSearchResults = false;
        }
        if (vm.searchAnimals.length > 0) {
          vm.showSearchResults = true;
        } else {
          vm.showSearchResults = false;
        }
      }, 750);
    }

    function selectSearchBy(type) {
      if (type == "number") {
        vm.searchByNumber = !vm.searchByNumber;
      } else if (type == "name") {
        vm.searchByName = !vm.searchByName;
      } else if (type == "ear_tag") {
        vm.searchByEarTag = !vm.searchByEarTag;
      }
      if (!vm.searchByNumber && !vm.searchByName && !vm.searchByEarTag) {
        vm.searchByNumber = true;
        vm.searchByName = true;
        vm.searchByEarTag = true;
      }
      animalSearchChanged();
    }

    function addAnimal(index, animal) {
      animal.inserted = true;
      var found = false;
      for (var i = 0; i < vm.animalsToShow.length; i++) {
        if (vm.animalsToShow[i].AnimalId == animal.AnimalId) {
          found = true;
        }
      }
      if (!found) {
        vm.animalsToShow.splice(0, 0, animal);
        vm.currentPage = 1;
        setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
      }
      vm.searchAnimals = [];
      vm.showSearchResults = false;
    }

    function selectLayout(type) {
      vm.selectedLayout = type;
      if (type == 1) {
        $timeout(function () {
          setTableDimensions(vm.selectedPredefinedList);
        }, 100);
      }
    }

    function removeAnimal($index, animal) {
      vm.animals.splice($index, 1);
      for (var i = 0; i < vm.animalsToShow.length; i++) {
        if (vm.animalsToShow[i].AnimalId == animal.AnimalId) {
          vm.animalsToShow.splice(i, 1);
          break;
        }
      }
      setCurrentAnimalList(vm.currentPage, vm.animalsToShow);
    }

    function openExportModal() {
      vm.file_name = createFileName();
      vm.file_header = "";
      vm.showNewDiscussionBlock = false;
      vm.loadingModal = false;
      vm.includePictures = false;
      vm.discussion = {};
      vm.discussion.importance = 0;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/herds/listGenerator/exportPdf.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function openSaveListModal() {
      vm.list_name = "";
      vm.loadingModal = false;
      $uibModal.open({
        animation: true,
        templateUrl: "app/pages/herds/listGenerator/saveList.modal.html",
        size: "sm",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function saveList() {
      vm.saveListError = false;
      var list = {
        list_name: vm.list_name,
        st_none: vm.st_none,
        st_open: vm.st_open,
        st_served: vm.st_served,
        st_not_pregnant: vm.st_not_pregnant,
        st_pregnant: vm.st_pregnant,
        st_barren: vm.st_barren,
        st_aborted: vm.st_aborted,
        st_dry: vm.st_dry,
        st_sold: vm.st_sold,
        st_dead: vm.st_dead,
        st_presume_left: vm.st_presume_left,
        s_d: vm.s_d,
        s_days: setStatusDays(vm.statusDateList),
        p_zero: vm.p_zero,
        p_one: vm.p_one,
        p_two: vm.p_two,
        p_three_and_more: vm.p_three_and_more,
        p_custom: vm.p_custom,
        custom_parity: vm.custom_parity,
        dim_1: vm.dim_1,
        dim_2: vm.dim_2,
        dim_3: vm.dim_3,
        dim_4: vm.dim_4,
        dim_5: vm.dim_5,
        dim_6: vm.dim_6,
        dim_7: vm.dim_7,
        dim_list: setDimList(vm.DIMList),
        age_1: vm.age_1,
        age_2: vm.age_2,
        age_3: vm.age_3,
        tags: setTags(vm.tags),
        tag_slider_value: vm.tag_slider_value,
        image_filter: vm.pictureFilter,
        image_event_filter: vm.eventsFilter,
        g_male: vm.g_male,
        g_female: vm.g_female,
        sa_active: vm.sa_active,
        sa_history: vm.sa_history,
        at_ce_tc: vm.at_ce_tc,
        m_a_milk: vm.m_a_milk,
        h_e_diseases: vm.h_e_diseases,
        h_e_prevention: vm.h_e_prevention,
        u_h_clinical: vm.u_h_clinical,
        u_h_subclinical: vm.u_h_subclinical,
        c_h: vm.c_h,
        e_slider_value: vm.slider_value,
        al_mp: vm.al_mp,
        al_scc: vm.al_scc,
        min_dev_p: vm.min_dev_p,
        min_dev_p_value: vm.min_dev_p_value,
        l1_scc: vm.l1_scc,
        lg1_scc: vm.lg1_scc,
        min_dev_kg: vm.min_dev_kg,
        min_dev_kg_value: vm.min_dev_kg_value,
        dev_t: vm.dev_t,
        dev_y: vm.dev_y,
        dev_tda: vm.dev_tda,
      };

      vm.loadingModal = true;
      listGeneratorService
        .addNewList(list, vm.selectedHerd)
        .then(function (response) {
          vm.userlistsRaw.push(response);
          vm.userLists = setUserLists(vm.userlistsRaw);
          vm.lists = setLists(predefinedLists, vm.userLists, vm.listOrder);
          closeModal();
        })
        .catch(function (error) {
          console.log(error);
          vm.saveListError = true;
          vm.loadingModal = false;
        });
    }

    function createFileName() {
      var name = "";
      var predefined;
      var gender;
      var events;
      var status;
      var parity;
      var dim;
      var age;
      var tags;
      var show_animal;
      var scc;
      if (vm.selectedPredefinedList) {
        if (vm.selectedPredefinedList == "cows") {
          name = name + i18nFilter("_label_list_cows_");
        } else if (vm.selectedPredefinedList == "female_youngstock") {
          name = name + i18nFilter("_label_list_female_youngstock_");
        } else if (vm.selectedPredefinedList == "dry_cow_attention") {
          name = name + i18nFilter("_label_list_to_be_dried_off_");
        } else if (vm.selectedPredefinedList == "open_cows") {
          name = name + i18nFilter("_label_list_open_cows_");
        } else if (vm.selectedPredefinedList == "heat_attention") {
          name = name + i18nFilter("_label_list_heat_attention_");
        } else if (vm.selectedPredefinedList == "heifers_to_be_inseminated") {
          name = name + i18nFilter("_label_list_to_be_inseminated_");
        } else if (vm.selectedPredefinedList == "preg_check") {
          name = name + i18nFilter("_label_list_pregnancy_check_");
        } else if (vm.selectedPredefinedList == "transition_cows") {
          name = name + i18nFilter("_label_list_transition_cows_");
        } else if (vm.selectedPredefinedList == "calving_attentions") {
          name = name + i18nFilter("_label_list_calving_attention_");
        } else if (vm.selectedPredefinedList == "daily_milk_production") {
          name = name + i18nFilter("_label_list_daily_milk_production_");
        } else if (vm.selectedPredefinedList == "treated_cows_heifers") {
          name = name + i18nFilter("_label_list_treated_cows_heifers_");
        } else if (
          vm.selectedPredefinedList == "attention_list_milk_production"
        ) {
          name =
            name + i18nFilter("_label_show_attention_list_milk_production_");
        } else if (vm.selectedPredefinedList == "milk_production_7_days") {
          name = name + i18nFilter("_label_list_milk_production_7_days_");
        } else if (vm.selectedPredefinedList == "attention_list_scc") {
          name = name + i18nFilter("_label_attention_list_scc_");
        }
        predefined = true;
        name = name + " ";
      }
      if (vm.g_female || vm.g_male) {
        if (predefined) {
          name = name + "/ ";
        }
        name = name + i18nFilter("_animal_gender_") + "(";
        if (vm.g_female) {
          name = name + i18nFilter("_animal_gender_female_");
        }
        if (vm.g_male) {
          if (vm.g_female) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_gender_male_");
        }
        name = name + ")";
        gender = true;
      }
      if (
        vm.at_ce_tc ||
        vm.m_a_milk ||
        vm.h_e_diseases ||
        vm.h_e_prevention ||
        vm.u_h_clinical ||
        vm.u_h_subclinical ||
        vm.c_h ||
        vm.s_d
      ) {
        if (predefined || gender) {
          name = name + "/ ";
        }
        name = name + i18nFilter("_label_events_") + "(";
        if (vm.at_newborn) {
          name = name + i18nFilter("_animal_newborn_");
        }
        if (vm.at_ce_tc) {
          if (vm.at_newborn) {
            name = name + ", ";
          }
          name =
            name + i18nFilter("_animal_clinical_examination_transition_cows_");
        }
        if (vm.m_a_milk) {
          if (vm.at_ce_tc || vm.at_newborn) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_manually_added_milk_");
        }
        if (vm.h_e_diseases) {
          if (vm.m_a_milk || vm.at_ce_tc || vm.at_newborn) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_health_event_diseases_");
        }
        if (vm.h_e_prevention) {
          if (vm.h_e_diseases || vm.m_a_milk || vm.at_ce_tc || vm.at_newborn) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_health_event_prevention_");
        }
        if (vm.u_h_clinical) {
          if (
            vm.h_e_prevention ||
            vm.h_e_diseases ||
            vm.m_a_milk ||
            vm.at_ce_tc ||
            vm.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_udder_health_clinical_mastitis_");
        }
        if (vm.u_h_subclinical) {
          if (
            vm.u_h_clinical ||
            vm.h_e_prevention ||
            vm.h_e_diseases ||
            vm.m_a_milk ||
            vm.at_ce_tc ||
            vm.at_newborn
          ) {
            name = name + ", ";
          }
          name =
            name + i18nFilter("_animal_udder_health_subclinical_mastitis_");
        }
        if (vm.c_h) {
          if (
            vm.u_h_subclinical ||
            vm.u_h_clinical ||
            vm.h_e_prevention ||
            vm.h_e_diseases ||
            vm.m_a_milk ||
            vm.at_ce_tc ||
            vm.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_claw_health_");
        }
        if (
          vm.at_ce_tc ||
          vm.m_a_milk ||
          vm.h_e_diseases ||
          vm.h_e_prevention ||
          vm.u_h_clinical ||
          vm.u_h_subclinical ||
          vm.c_h
        ) {
          name = name + "[" + vm.selected_slider_value + "]";
        }
        if (vm.s_d) {
          if (
            vm.c_h ||
            vm.u_h_subclinical ||
            vm.u_h_clinical ||
            vm.h_e_prevention ||
            vm.h_e_diseases ||
            vm.m_a_milk ||
            vm.at_ce_tc ||
            vm.at_newborn
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_date_");
          if (vm.statusDateList.length > 0) {
            name = name + ": [";
            for (var i = 0; i < vm.statusDateList.length; i++) {
              name =
                name +
                vm.statusDateList[i].from +
                "-" +
                vm.statusDateList[i].to;
              if (i != vm.statusDateList.length - 1) {
                name = name + ", ";
              }
            }
            name = name + "]";
          }
        }
        events = true;
        name = name + ")";
      }
      if (
        vm.st_none ||
        vm.st_open ||
        vm.st_served ||
        vm.st_not_pregnant ||
        vm.st_pregnant ||
        vm.st_barren ||
        vm.st_aborted ||
        vm.st_dry ||
        vm.st_sold ||
        vm.st_dead ||
        vm.st_presume_left
      ) {
        if (predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_current_status_") + "(";
        if (vm.st_none) {
          name = name + i18nFilter("_animal_status_none_");
        }
        if (vm.st_open) {
          if (vm.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_open_");
        }
        if (vm.st_served) {
          if (vm.st_open || vm.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_inseminated_");
        }
        if (vm.st_not_pregnant) {
          if (vm.st_served || vm.st_open || vm.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_not_pregnant_");
        }
        if (vm.st_pregnant) {
          if (vm.st_not_pregnant || vm.st_served || vm.st_open || vm.st_none) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_pregnant_");
        }
        if (vm.st_barren) {
          if (
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_barren_");
        }
        if (vm.st_aborted) {
          if (
            vm.st_barren ||
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_aborted_");
        }
        if (vm.st_dry) {
          if (
            vm.st_aborted ||
            vm.st_barren ||
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_dry_");
        }
        if (vm.st_sold) {
          if (
            vm.st_dry ||
            vm.st_aborted ||
            vm.st_barren ||
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_sold_");
        }
        if (vm.st_dead) {
          if (
            vm.st_sold ||
            vm.st_dry ||
            vm.st_aborted ||
            vm.st_barren ||
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_dead_");
        }
        if (vm.st_presume_left) {
          if (
            vm.st_dead ||
            vm.st_sold ||
            vm.st_dry ||
            vm.st_aborted ||
            vm.st_barren ||
            vm.st_pregnant ||
            vm.st_not_pregnant ||
            vm.st_served ||
            vm.st_open ||
            vm.st_none
          ) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_status_presume_left_");
        }
        name = name + ")";
        status = true;
      }
      if (
        vm.p_zero ||
        vm.p_one ||
        vm.p_two ||
        vm.p_three_and_more ||
        vm.p_custom
      ) {
        if (status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_parity_") + "(";
        if (vm.p_zero) {
          name = name + "0";
        }
        if (vm.p_one) {
          if (vm.p_zero) {
            name = name + ", ";
          }
          name = name + "1";
        }
        if (vm.p_two) {
          if (vm.p_one || vm.p_zero) {
            name = name + ", ";
          }
          name = name + "2";
        }
        if (vm.p_three_and_more) {
          if (vm.p_two || vm.p_one || vm.p_zero) {
            name = name + ", ";
          }
          name = name + "3+";
        }
        if (vm.p_custom && vm.custom_parity) {
          if (vm.p_three_and_more || vm.p_two || vm.p_one || vm.p_zero) {
            name = name + ", ";
          }
          name = name + vm.custom_parity;
        }
        name = name + ")";
        parity = true;
      }
      if (
        vm.dim_1 ||
        vm.dim_2 ||
        vm.dim_3 ||
        vm.dim_4 ||
        vm.dim_5 ||
        vm.dim_6 ||
        (vm.dim_7 && vm.DIMList.length)
      ) {
        if (parity || status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_days_in_milk_") + "(";
        if (vm.dim_1) {
          name = name + "<30";
        }
        if (vm.dim_2) {
          if (vm.dim_1) {
            name = name + ", ";
          }
          name = name + "30-60";
        }
        if (vm.dim_3) {
          if (vm.dim_2 || vm.dim_1) {
            name = name + ", ";
          }
          name = name + "60-120";
        }
        if (vm.dim_4) {
          if (vm.dim_3 || vm.dim_2 || vm.dim_1) {
            name = name + ", ";
          }
          name = name + "120-200";
        }
        if (vm.dim_5) {
          if (vm.dim_4 || vm.dim_3 || vm.dim_2 || vm.dim_1) {
            name = name + ", ";
          }
          name = name + "200-305";
        }
        if (vm.dim_6) {
          if (vm.dim_5 || vm.dim_4 || vm.dim_3 || vm.dim_2 || vm.dim_1) {
            name = name + ", ";
          }
          name = name + ">305";
        }
        if (vm.dim_7 && vm.DIMList.length) {
          if (
            vm.dim_6 ||
            vm.dim_5 ||
            vm.dim_4 ||
            vm.dim_3 ||
            vm.dim_2 ||
            vm.dim_1
          ) {
            name = name + ", ";
          }
          vm.DIMList.forEach(function (item, index) {
            if (item.type == 1) {
              name = name + item.from + "-" + item.to;
            } else {
              if (item.ineq == 1) {
                name = name + "<" + item.to;
              } else {
                name = name + ">" + item.from;
              }
            }
            if (vm.DIMList[index + 1]) {
              name = name + ", ";
            }
          });
        }
        name = name + ")";
        dim = true;
      }
      if (vm.age_1 || vm.age_2 || vm.age_3) {
        if (dim || parity || status || predefined || gender || events) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_age_") + "(";
        if (vm.age_1) {
          name = name + "<20";
        }
        if (vm.age_2) {
          if (vm.age_1) {
            name = name + ", ";
          }
          name = name + "200-400";
        }
        if (vm.age_3) {
          if (vm.age_2 || vm.age_1) {
            name = name + ", ";
          }
          name = name + ">400";
        }
        name = name + ")";
        age = true;
      }
      if (vm.tags && vm.tags.length > 0) {
        if (age || dim || parity || status || events || predefined || gender) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_tags_") + "(";
        for (var i = 0; i < vm.tags.length; i++) {
          name = name + vm.tags[i].label;
          if (i != vm.tags.length - 1) {
            name = name + ", ";
          }
        }
        name = name + ")";
        tags = true;
      }
      if (vm.sa_active || vm.sa_history) {
        if (
          tags ||
          age ||
          dim ||
          parity ||
          status ||
          events ||
          predefined ||
          gender
        ) {
          name = name + "/";
        }
        name = name + i18nFilter("_animal_show_animals_") + "(";
        if (vm.sa_active) {
          name = name + i18nFilter("_animal_active_");
        }
        if (vm.sa_history) {
          if (vm.sa_active) {
            name = name + ", ";
          }
          name = name + i18nFilter("_animal_historic_");
        }
        name = name + ")";
        show_animal = true;
      }
      var date = $filter("date")(new Date(), "shortDate");

      if (vm.al_scc) {
        if (
          tags ||
          age ||
          dim ||
          parity ||
          status ||
          events ||
          predefined ||
          gender ||
          show_animal
        ) {
          name = name + "/";
        }
        name =
          name +
          i18nFilter("_scc_alert_") +
          " " +
          i18nFilter("_animal_lactation_") +
          "1 " +
          "(" +
          vm.l1_scc +
          ")" +
          " " +
          i18nFilter("_animal_lactation_") +
          ">1 " +
          "(" +
          vm.lg1_scc +
          ")";
      }

      if (
        show_animal ||
        tags ||
        age ||
        dim ||
        parity ||
        status ||
        events ||
        predefined ||
        gender ||
        scc
      ) {
        name = name + "/ ";
      }

      name = name + date;
      return name;
    }

    function showNewDiscussion() {
      vm.showNewDiscussionBlock = true;
    }

    function newDiscussionSetTags(item, index) {
      var tagsString = "";
      for (var i = 0; i < vm.discussion.tags_list.length; i++) {
        tagsString = tagsString + vm.discussion.tags_list[i].value;
        if (i < vm.discussion.tags_list.length - 1) {
          tagsString = tagsString + "#";
        }
      }
      vm.discussion.tags = tagsString;
    }

    function setALTags() {
      var tags = "AnimalList#AL";
      var date = $filter("date")(new Date(), "yyyy-MM-dd");
      tags = tags + date;
      tags = tags + "#ALF";
      for (var i = 0; i < filters.length; i++) {
        if (vm[filters[i]]) {
          if (filters[i] == "p_custom") {
            tags = tags + "$" + filters[i] + "|" + vm.custom_parity;
          } else if (filters[i] == "s_d") {
            tags = tags + "$" + filters[i] + "|";
            for (var j = 0; j < vm.statusDateList.length; j++) {
              tags =
                tags +
                vm.statusDateList[j].from +
                "-" +
                vm.statusDateList[j].from +
                ";";
            }
          } else {
            tags = tags + "$" + filters[i];
          }
        }
      }
      if (vm.tags && vm.tags.length > 0) {
        tags = tags + "$tags|";
        for (var i = 0; i < vm.tags.length; i++) {
          tags = tags + vm.tags[i].value + ";";
        }
      }
      if (
        vm.at_ce_tc ||
        vm.m_a_milk ||
        vm.h_e_diseases ||
        vm.h_e_prevention ||
        vm.u_h_clinical ||
        vm.u_h_subclinical ||
        vm.c_h
      ) {
        tags = tags + "$slider|" + vm.slider_value;
      }
      return tags;
    }

    function checkComments() {
      var tag = setALTags();
      for (var i = 0; i < vm.animals.length; i++) {
        if (vm.animals[i].ALPics) {
          var commentAdded = false;
          for (var j = 0; j < vm.animals[i].ALPics.length; j++) {
            for (var t = 0; t < vm.animals[i].ALPics[j].Tags.length; t++) {
              var alfTag;
              if (vm.animals[i].ALPics[j].Tags[t].indexOf("ALF") != -1) {
                alfTag = vm.animals[i].ALPics[j].Tags[t];
              }
            }
            if (tag.indexOf(alfTag) != -1) {
              vm.animals[i].Comments = vm.animals[i].ALPics[j].Conversation;
              commentAdded = true;
            } else {
              if (!commentAdded) {
                vm.animals[i].Comments = null;
              }
            }
          }
        }
      }
    }

    function exportPdf(newDiscussion) {
      vm.loadingModal = true;
      return listGeneratorService
        .getHerdById(vm.selectedHerd)
        .then(function (response) {
          try {
            if (vm.includePictures) {
              setPDFPictures(newDiscussion, response.Name);
            } else {
              createPDF(newDiscussion, response.Name);
            }
          } catch (error) {
            console.log(error);
            bugsnagService.logUnhandledError(error);
            vm.pdfError = true;
            vm.loadingModal = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.pdfError = true;
          vm.loadingModal = false;
        });

      function setPDFPictures(newDiscussion, herd_name) {
        var list = [];
        for (var i = 0; i < vm.animalsToShow.length; i++) {
          vm.animalsToShow[i].PDFPicture = null;
          if (
            vm.animalsToShow[i].PictureToShow &&
            vm.animalsToShow[i].PictureToShow.T
          ) {
            var name = "pr" + i;
            vm[name] = $q.defer();
            list.push(vm[name].promise);
            getDataUrl(name, i, vm.animalsToShow[i].PictureToShow.T);
          }
        }

        function getDataUrl(name, i, picture) {
          toDataURL(picture, function (dataUrl) {
            vm.animalsToShow[i].PDFPicture = dataUrl;
            vm[name].resolve();
          });
        }
        $q.all(list).then(function () {
          createPDF(newDiscussion, herd_name);
        });
      }

      function createPDF(newDiscussion, herd_name) {
        var dd = {
          pageOrientation: "landscape",
          pageMargins: [25, 50, 20, 0],
          content: [
            {
              table: {
                dontBreakRows: true,
                headerRows: 2,
                keepWithHeaderRows: 2,
                widths: [
                  "*",
                  "*",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                ],
                body: [
                  [
                    {
                      text: i18nFilter("_animal_number_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_name_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_date_of_birth_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_status_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_parity_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_last_calving_date_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_last_heat_") + "/",
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_label_predicted_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_dc_comments_"),
                      border: [false, false, false, false],
                      alignment: "center",
                    },
                  ],
                  [
                    {
                      text: "",
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_ear_tag_"),
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: "",
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_status_days_"),
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: "",
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_dim_"),
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_insemination_date_"),
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: i18nFilter("_animal_dry_off_date_"),
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                    {
                      text: "",
                      border: [false, false, false, true],
                      alignment: "center",
                    },
                  ],
                ],
              },
            },
          ],
          defaultStyle: {
            fontSize: 8,
          },
          styles: {
            headerStyle: {
              fontSize: 9,
              bold: true,
            },
          },
        };
        if (
          (vm.selectedPredefinedList != "dry_cow_attention" &&
            vm.selectedPredefinedList != "calving_attentions") ||
          vm.st_not_pregnant
        ) {
          //remove dod column
          dd.content[0].table.widths.splice(7, 1);
          dd.content[0].table.body[0].splice(7, 1);
          dd.content[0].table.body[1].splice(7, 1);
        }
        if (
          (vm.st_not_pregnant || vm.st_served) &&
          vm.selectedPredefinedList != "milk_production_7_days"
        ) {
          //add number of inseminations
          dd.content[0].table.widths.splice(7, 0, "auto");
          dd.content[0].table.body[0].splice(7, 0, {
            text: i18nFilter("_animal_number_of_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(7, 0, {
            text: i18nFilter("_animal_inseminations_"),
            border: [false, false, false, true],
            alignment: "center",
          });
        }
        if (
          vm.selectedPredefinedList == "transition_cows" ||
          vm.selectedPredefinedList == "daily_milk_production" ||
          vm.selectedPredefinedList == "attention_list_milk_production" ||
          vm.selectedPredefinedList == "milk_production_7_days"
        ) {
          //remove last heat/insem column
          dd.content[0].table.widths.splice(6, 1);
          dd.content[0].table.body[0].splice(6, 1);
          dd.content[0].table.body[1].splice(6, 1);
        }
        if (
          (vm.selectedPredefinedList == "transition_cows" ||
            vm.u_h_clinical ||
            vm.u_h_subclinical ||
            vm.selectedPredefinedList == "daily_milk_production" ||
            vm.selectedPredefinedList == "attention_list_milk_production") &&
          vm.selectedPredefinedList != "milk_production_7_days"
        ) {
          //add milk production column
          dd.content[0].table.widths.splice(5, 0, "auto");
          dd.content[0].table.body[0].splice(5, 0, {
            text: i18nFilter("_calendar_daily_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(5, 0, {
            text: i18nFilter("_animal_details_tab_milk_production_"),
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (vm.selectedPredefinedList == "daily_milk_production") {
          dd.content[0].table.widths.splice(5, 0, "auto");
          dd.content[0].table.body[0].splice(5, 0, {
            text: i18nFilter("_animal_milk_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(5, 0, {
            text: vm.today,
            border: [false, false, false, true],
            alignment: "center",
          });
          dd.content[0].table.widths.splice(5, 0, "auto");
          dd.content[0].table.body[0].splice(5, 0, {
            text: i18nFilter("_animal_milk_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(5, 0, {
            text: vm.yesterday,
            border: [false, false, false, true],
            alignment: "center",
          });
          dd.content[0].table.widths.splice(5, 0, "auto");
          dd.content[0].table.body[0].splice(5, 0, {
            text: i18nFilter("_animal_milk_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(5, 0, {
            text: vm.two_days_ago,
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (vm.selectedPredefinedList == "attention_list_milk_production") {
          dd.content[0].table.widths.splice(6, 0, "auto");
          dd.content[0].table.body[0].splice(6, 0, {
            text: i18nFilter("_label_deviation_") + "%",
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(6, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });

          dd.content[0].table.widths.splice(6, 0, "auto");
          dd.content[0].table.body[0].splice(6, 0, {
            text: i18nFilter("_label_deviation_") + "kg",
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(6, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }
        if (vm.u_h_clinical || vm.u_h_subclinical) {
          //add last mastitis case column
          if (vm.selectedPredefinedList == "daily_milk_production") {
            dd.content[0].table.widths.splice(9, 0, "auto");
            dd.content[0].table.body[0].splice(9, 0, {
              text: i18nFilter("_label_last_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(9, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, true],
              alignment: "center",
            });
            //add mastitis case column
            dd.content[0].table.widths.splice(9, 0, "auto");
            dd.content[0].table.body[0].splice(9, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(9, 0, {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            });
          } else if (
            vm.selectedPredefinedList == "attention_list_milk_production"
          ) {
            dd.content[0].table.widths.splice(8, 0, "auto");
            dd.content[0].table.body[0].splice(8, 0, {
              text: i18nFilter("_label_last_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(8, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, true],
              alignment: "center",
            });
            //add mastitis case column
            dd.content[0].table.widths.splice(8, 0, "auto");
            dd.content[0].table.body[0].splice(8, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(8, 0, {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            });
          } else {
            dd.content[0].table.widths.splice(6, 0, "auto");
            dd.content[0].table.body[0].splice(6, 0, {
              text: i18nFilter("_label_last_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(6, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, true],
              alignment: "center",
            });
            //add mastitis case column
            dd.content[0].table.widths.splice(6, 0, "auto");
            dd.content[0].table.body[0].splice(6, 0, {
              text: i18nFilter("_animal_mastitis_case_"),
              border: [false, false, false, false],
              alignment: "center",
            });
            dd.content[0].table.body[1].splice(6, 0, {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }
        }
        if (
          vm.selectedPredefinedList == "preg_check" ||
          vm.selectedPredefinedList == "female_youngstock" ||
          vm.selectedPredefinedList == "heifers_to_be_inseminated" ||
          vm.selectedPredefinedList == "dry_cow_attention" ||
          vm.selectedPredefinedList == "calving_attentions"
        ) {
          //addd bull name column
          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.body[1].length - 2,
            0,
            {
              text: i18nFilter("_animal_ear_tag_"),
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.body[1].length - 2,
            0,
            {
              text: i18nFilter("_animal_bull_name_"),
              border: [false, false, false, true],
              alignment: "center",
            }
          );
        }
        if (
          vm.selectedPredefinedList == "female_youngstock" ||
          vm.selectedPredefinedList == "heifers_to_be_inseminated"
        ) {
          //remove lcd column
          dd.content[0].table.widths.splice(5, 1);
          dd.content[0].table.body[0].splice(5, 1);
          dd.content[0].table.body[1].splice(5, 1);
          //add age column
          dd.content[0].table.widths.splice(2, 0, "auto");
          dd.content[0].table.body[0].splice(2, 0, {
            text: i18nFilter("_animal_age_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(2, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        if (vm.selectedPredefinedList == "milk_production_7_days") {
          //remove date of birth
          dd.content[0].table.widths.splice(2, 1);
          dd.content[0].table.body[0].splice(2, 1);
          dd.content[0].table.body[1].splice(2, 1);

          //add milk production

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: i18nFilter("_animal_details_milk_production_"),
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: i18nFilter("_label_today_"),
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "t-1",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-2",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-3",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-4",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-5",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-6",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: "t-7",
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: "",
              border: [false, false, false, true],
              alignment: "center",
            }
          );

          dd.content[0].table.widths.splice(
            dd.content[0].table.widths.length - 2,
            0,
            "auto"
          );
          dd.content[0].table.body[0].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              //text: i18nFilter('_animal_days_pregnant_'),
              text: i18nFilter("_animal_details_milk_production_"),
              border: [false, false, false, false],
              alignment: "center",
            }
          );
          dd.content[0].table.body[1].splice(
            dd.content[0].table.widths.length - 2,
            0,
            {
              text: i18nFilter("_animal_details_average_value_"),
              border: [false, false, false, true],
              alignment: "center",
            }
          );
        }

        if (vm.selectedPredefinedList == "calving_attentions") {
          //add days pregnant
          dd.content[0].table.widths.splice(4, 0, "auto");
          dd.content[0].table.body[0].splice(4, 0, {
            text: i18nFilter("_animal_days_pregnant_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(4, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });
          //add days dry
          dd.content[0].table.widths.splice(5, 0, "auto");
          dd.content[0].table.body[0].splice(5, 0, {
            text: i18nFilter("_animal_days_dry_"),
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(5, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }
        //add last MRO/ Milk MEter
        if (
          vm.selectedPredefinedList != "transition_cows" &&
          vm.selectedPredefinedList != "attention_list_milk_production" &&
          vm.selectedPredefinedList != "daily_milk_production" &&
          vm.selectedPredefinedList != "female_youngstock" &&
          !vm.u_h_clinical &&
          !vm.u_h_subclinical &&
          vm.selectedPredefinedList != "milk_production_7_days"
        ) {
          var position = 6;
          if (vm.selectedPredefinedList == "calving_attentions") {
            position = 7;
          }
          dd.content[0].table.widths.splice(position, 0, "auto");
          dd.content[0].table.body[0].splice(position, 0, {
            text: i18nFilter("_label_last_mro_") + "/",
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(position, 0, {
            text: i18nFilter("_label_milk_meter_"),
            border: [false, false, false, true],
            alignment: "center",
          });
        }

        //add last MRO/ scc
        if (vm.selectedPredefinedList == "attention_list_scc") {
          var position = 7;
          if (vm.selectedPredefinedList == "calving_attentions") {
            position = 8;
          }
          dd.content[0].table.widths.splice(position, 0, "auto");
          dd.content[0].table.body[0].splice(position, 0, {
            text: i18nFilter("_label_last_mro_") + "/",
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(position, 0, {
            text: i18nFilter("_animal_scc_"),
            border: [false, false, false, true],
            alignment: "center",
          });
        }
        //
        if (vm.includePictures) {
          dd.content[0].table.widths.splice(0, 0, "*");
          dd.content[0].table.body[0].splice(0, 0, {
            text: "",
            border: [false, false, false, false],
            alignment: "center",
          });
          dd.content[0].table.body[1].splice(0, 0, {
            text: "",
            border: [false, false, false, true],
            alignment: "center",
          });
        }
        if (
          vm.file_header &&
          vm.file_header != "" &&
          vm.file_header.length > 0
        ) {
          var header = [
            {
              columns: [
                {
                  image: vm.logo,
                  width: 150,
                  margin: [25, 0, 0, 0],
                },
                {
                  stack: [
                    {
                      text: i18nFilter("_label_herd_") + ": " + herd_name,
                      margin: [250, 15, 0, 0],
                    },
                    {
                      text: vm.file_header,
                      margin: [50, 0, 0, 0],
                    },
                  ],
                },
              ],
            },
          ];
          dd.header = header;
        } else {
          var header = [
            {
              columns: [
                {
                  image: vm.logo,
                  width: 150,
                  margin: [25, 0, 0, 0],
                },
                {
                  text: i18nFilter("_label_herd_") + ": " + herd_name,
                  margin: [250, 15, 0, 0],
                },
              ],
            },
          ];
          dd.header = header;
        }
        for (var i = 0; i < vm.animalsToShow.length; i++) {
          var animalRow = [
            {
              text: vm.animalsToShow[i].NumberString
                ? vm.animalsToShow[i].NumberString
                : "",
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text:
                (vm.animalsToShow[i].Name ? vm.animalsToShow[i].Name : "") +
                "\n" +
                (vm.animalsToShow[i].EarTag ? vm.animalsToShow[i].EarTag : ""),
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: vm.animalsToShow[i].BirthDate
                ? $filter("date")(vm.animalsToShow[i].BirthDate, "shortDate")
                : "",
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text:
                (vm.animalsToShow[i].CurrentStatusString
                  ? vm.animalsToShow[i].CurrentStatusString +
                    "(" +
                    (vm.animalsToShow[i].DateString
                      ? vm.animalsToShow[i].DateString
                      : "") +
                    ")"
                  : "" +
                    "(" +
                    (vm.animalsToShow[i].DateString
                      ? vm.animalsToShow[i].DateString
                      : "") +
                    ")") +
                "\n" +
                (vm.animalsToShow[i].StatusDays
                  ? vm.animalsToShow[i].StatusDays
                  : ""),
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text:
                vm.animalsToShow[i].Parity != null ||
                vm.animalsToShow[i].Parity != undefined
                  ? vm.animalsToShow[i].Parity
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text:
                (vm.animalsToShow[i].LastCalvingDate
                  ? $filter("date")(
                      vm.animalsToShow[i].LastCalvingDate,
                      "shortDate"
                    )
                  : "") +
                "\n" +
                (vm.animalsToShow[i].DIM ? vm.animalsToShow[i].DIM : ""),
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: vm.animalsToShow[i].LastHeatInseminationDate
                ? $filter("date")(
                    vm.animalsToShow[i].LastHeatInseminationDate,
                    "shortDate"
                  )
                : "",
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: vm.animalsToShow[i].ExpectedDryDate
                ? $filter("date")(
                    vm.animalsToShow[i].ExpectedDryDate,
                    "shortDate"
                  )
                : "",
              border: [false, false, false, true],
              alignment: "center",
            },
            {
              text: vm.animalsToShow[i].Comments
                ? vm.animalsToShow[i].Comments
                : "",
              border: [false, false, false, true],
              alignment: "center",
            },
          ];
          if (
            (vm.selectedPredefinedList != "dry_cow_attention" &&
              vm.selectedPredefinedList != "calving_attentions") ||
            vm.st_not_pregnant
          ) {
            animalRow.splice(7, 1);
          }
          if (
            (vm.st_not_pregnant || vm.st_served) &&
            vm.selectedPredefinedList != "milk_production_7_days"
          ) {
            animalRow.splice(7, 0, {
              text: vm.animalsToShow[i].NumberOfInseminations
                ? vm.animalsToShow[i].NumberOfInseminations
                : "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }
          if (
            vm.selectedPredefinedList == "transition_cows" ||
            vm.selectedPredefinedList == "daily_milk_production" ||
            vm.selectedPredefinedList == "attention_list_milk_production" ||
            vm.selectedPredefinedList == "milk_production_7_days"
          ) {
            animalRow.splice(6, 1);
          }
          if (
            (vm.selectedPredefinedList == "transition_cows" ||
              vm.u_h_clinical ||
              vm.u_h_subclinical ||
              vm.selectedPredefinedList == "daily_milk_production" ||
              vm.selectedPredefinedList == "attention_list_milk_production") &&
            vm.selectedPredefinedList != "milk_production_7_days"
          ) {
            animalRow.splice(5, 0, {
              border: [false, false, false, true],
              alignment: "center",
            });
            if (vm.animalsToShow[i].LastWeekMilk) {
              animalRow[5].table = {};
              animalRow[5].table.body = [];
              for (
                var j = 0;
                j < vm.animalsToShow[i].LastWeekMilk.length;
                j++
              ) {
                var r = [
                  {
                    text: vm.animalsToShow[i].LastWeekMilk[j].v,
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                  {
                    text:
                      "(" +
                      $filter("date")(
                        vm.animalsToShow[i].LastWeekMilk[j].d,
                        "shortDate"
                      ) +
                      ")",
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                ];
                if (vm.animalsToShow[i].LastWeekMilk[j].v) {
                  animalRow[5].table.body.push(r);
                }
              }
            } else {
              animalRow[5].text = "";
            }
          }
          if (vm.selectedPredefinedList == "daily_milk_production") {
            animalRow.splice(5, 0, {
              border: [false, false, false, true],
              alignment: "center",
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[0].v
                  ? vm.animalsToShow[i].LastWeekMilk[0].v
                  : "",
            });
            animalRow.splice(5, 0, {
              border: [false, false, false, true],
              alignment: "center",
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[1].v
                  ? vm.animalsToShow[i].LastWeekMilk[1].v
                  : "",
            });
            animalRow.splice(5, 0, {
              border: [false, false, false, true],
              alignment: "center",
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[2].v
                  ? vm.animalsToShow[i].LastWeekMilk[2].v
                  : "",
            });
          }

          if (vm.selectedPredefinedList == "attention_list_milk_production") {
            animalRow.splice(6, 0, {
              border: [false, false, false, true],
              alignment: "center",
            });
            if (vm.animalsToShow[i].LastWeekMilk) {
              animalRow[6].table = {};
              animalRow[6].table.body = [];
              for (
                var j = 0;
                j < vm.animalsToShow[i].LastWeekMilk.length;
                j++
              ) {
                var r = [
                  {
                    text: vm.animalsToShow[i].LastWeekMilk[j].dev_percent,
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                  {
                    text:
                      "(" +
                      $filter("date")(
                        vm.animalsToShow[i].LastWeekMilk[j].d,
                        "shortDate"
                      ) +
                      ")",
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                ];
                if (vm.animalsToShow[i].LastWeekMilk[j].dev_percent) {
                  animalRow[6].table.body.push(r);
                }
              }
            } else {
              animalRow[6].text = "";
            }

            animalRow.splice(6, 0, {
              border: [false, false, false, true],
              alignment: "center",
            });
            if (vm.animalsToShow[i].LastWeekMilk) {
              animalRow[6].table = {};
              animalRow[6].table.body = [];
              for (
                var j = 0;
                j < vm.animalsToShow[i].LastWeekMilk.length;
                j++
              ) {
                var r = [
                  {
                    text: vm.animalsToShow[i].LastWeekMilk[j].dev_kg,
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                  {
                    text:
                      "(" +
                      $filter("date")(
                        vm.animalsToShow[i].LastWeekMilk[j].d,
                        "shortDate"
                      ) +
                      ")",
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                ];
                if (vm.animalsToShow[i].LastWeekMilk[j].dev_kg) {
                  animalRow[6].table.body.push(r);
                }
              }
            } else {
              animalRow[6].text = "";
            }
          }
          if (vm.u_h_clinical || vm.u_h_subclinical) {
            if (vm.selectedPredefinedList == "daily_milk_production") {
              animalRow.splice(9, 0, {
                text: vm.animalsToShow[i].LastMastitis
                  ? $filter("date")(
                      vm.animalsToShow[i].LastMastitis,
                      "shortDate"
                    )
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
              animalRow.splice(9, 0, {
                text: vm.animalsToShow[i].NrMastCurLact
                  ? vm.animalsToShow[i].NrMastCurLact
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
            } else if (
              vm.selectedPredefinedList == "attention_list_milk_production"
            ) {
              animalRow.splice(8, 0, {
                text: vm.animalsToShow[i].LastMastitis
                  ? $filter("date")(
                      vm.animalsToShow[i].LastMastitis,
                      "shortDate"
                    )
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
              animalRow.splice(8, 0, {
                text: vm.animalsToShow[i].NrMastCurLact
                  ? vm.animalsToShow[i].NrMastCurLact
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
            } else {
              animalRow.splice(6, 0, {
                text: vm.animalsToShow[i].LastMastitis
                  ? $filter("date")(
                      vm.animalsToShow[i].LastMastitis,
                      "shortDate"
                    )
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
              animalRow.splice(6, 0, {
                text: vm.animalsToShow[i].NrMastCurLact
                  ? vm.animalsToShow[i].NrMastCurLact
                  : "",
                border: [false, false, false, true],
                alignment: "center",
              });
            }
          }
          if (
            vm.selectedPredefinedList == "preg_check" ||
            vm.selectedPredefinedList == "female_youngstock" ||
            vm.selectedPredefinedList == "heifers_to_be_inseminated" ||
            vm.selectedPredefinedList == "dry_cow_attention" ||
            vm.selectedPredefinedList == "calving_attentions"
          ) {
            animalRow.splice(animalRow.length - 2, 0, {
              text: vm.animalsToShow[i].BreedingBull
                ? vm.animalsToShow[i].BreedingBull
                : "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }
          if (
            vm.selectedPredefinedList == "female_youngstock" ||
            vm.selectedPredefinedList == "heifers_to_be_inseminated"
          ) {
            animalRow.splice(5, 1);
            animalRow.splice(2, 0, {
              text: vm.animalsToShow[i].Age ? vm.animalsToShow[i].Age : "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }
          if (vm.selectedPredefinedList == "milk_production_7_days") {
            //remove date of birth
            animalRow.splice(2, 1);
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[0].v
                  ? vm.animalsToShow[i].LastWeekMilk[0].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[1].v
                  ? vm.animalsToShow[i].LastWeekMilk[1].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[2].v
                  ? vm.animalsToShow[i].LastWeekMilk[2].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[3].v
                  ? vm.animalsToShow[i].LastWeekMilk[3].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[4].v
                  ? vm.animalsToShow[i].LastWeekMilk[4].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[5].v
                  ? vm.animalsToShow[i].LastWeekMilk[5].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[6].v
                  ? vm.animalsToShow[i].LastWeekMilk[6].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text:
                vm.animalsToShow[i].LastWeekMilk &&
                vm.animalsToShow[i].LastWeekMilk[7].v
                  ? vm.animalsToShow[i].LastWeekMilk[7].v
                  : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(animalRow.length - 1, 0, {
              text: vm.animalsToShow[i].Avg_MP
                ? round(vm.animalsToShow[i].Avg_MP, 2)
                : "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }

          if (vm.selectedPredefinedList == "calving_attentions") {
            animalRow.splice(4, 0, {
              text: vm.animalsToShow[i].DaysSinceLastHI
                ? vm.animalsToShow[i].DaysSinceLastHI
                : "",
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow.splice(5, 0, {
              text: vm.animalsToShow[i].DaysDry
                ? vm.animalsToShow[i].DaysDry
                : "",
              border: [false, false, false, true],
              alignment: "center",
            });
          }
          if (
            vm.selectedPredefinedList != "transition_cows" &&
            vm.selectedPredefinedList != "attention_list_milk_production" &&
            vm.selectedPredefinedList != "daily_milk_production" &&
            vm.selectedPredefinedList != "female_youngstock" &&
            !vm.u_h_clinical &&
            !vm.u_h_subclinical &&
            vm.selectedPredefinedList != "milk_production_7_days"
          ) {
            var position = 6;
            if (vm.selectedPredefinedList == "calving_attentions") {
              position = 7;
            }

            animalRow.splice(position, 0, {
              border: [false, false, false, true],
              alignment: "center",
            });
            if (vm.animalsToShow[i].LastWeekMilk) {
              animalRow[position].table = {};
              animalRow[position].table.body = [];
              for (
                var j = 0;
                j < vm.animalsToShow[i].LastWeekMilk.length;
                j++
              ) {
                var r = [
                  {
                    text:
                      vm.animalsToShow[i].LastWeekMilk[j] &&
                      vm.animalsToShow[i].LastWeekMilk[j].v
                        ? vm.animalsToShow[i].LastWeekMilk[j].v
                        : "",
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                  {
                    text:
                      "(" +
                      $filter("date")(
                        vm.animalsToShow[i].LastWeekMilk[j].d,
                        "shortDate"
                      ) +
                      ")",
                    border: [false, false, false, false],
                    alignment: "center",
                  },
                ];
                if (vm.animalsToShow[i].LastWeekMilk[j].v) {
                  animalRow[position].table.body.push(r);
                }
              }
            } else {
              animalRow[position].text = vm.animalsToShow[i].LastMilkRecording
                ? (vm.animalsToShow[i].LastMilkRecording.KgMilk
                    ? vm.animalsToShow[i].LastMilkRecording.KgMilk
                    : "") +
                  "(" +
                  $filter("date")(
                    vm.animalsToShow[i].LastMilkRecording.Date,
                    "shortDate"
                  ) +
                  ")"
                : "";
            }
          }

          if (vm.selectedPredefinedList == "attention_list_scc") {
            var position = 7;
            if (vm.selectedPredefinedList == "calving_attentions") {
              position = 8;
            }

            animalRow.splice(position, 0, {
              border: [false, false, false, true],
              alignment: "center",
            });
            animalRow[position].text = vm.animalsToShow[i].LastMilkRecording
              ? (vm.animalsToShow[i].LastMilkRecording.SCC
                  ? vm.animalsToShow[i].LastMilkRecording.SCC
                  : "") +
                "(" +
                $filter("date")(
                  vm.animalsToShow[i].LastMilkRecording.Date,
                  "shortDate"
                ) +
                ")"
              : "";
          }

          if (vm.includePictures) {
            var r = {
              image: vm.animalsToShow[i].PDFPicture
                ? vm.animalsToShow[i].PDFPicture
                : vm.defaultPicture,
              border: [false, false, false, true],
              alignment: "center",
              fit: [70, 70],
            };
            animalRow.splice(0, 0, r);
          }
          dd.content[0].table.body.push(animalRow);
        }
        var name = vm.file_name + ".pdf";
        var dd2 = angular.copy(dd);
        if (newDiscussion) {
          pdfMake.createPdf(dd).getBlob(function (data) {
            pdfMake.createPdf(dd2).download(name, function () {
              createNewDiscussion(data);
            });
          });
        } else {
          pdfMake.createPdf(dd).download(name, function () {
            $uibModalStack.dismissAll();
          });
        }
      }
    }

    function createNewDiscussion(file) {
      file.name = vm.file_name;
      var date = new Date().toISOString();
      var suffix = "?created=" + date;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix = suffix + "&tags=" + encodeURIComponent(vm.discussion.tags);
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      var url =
        APP_CONSTANTS.animals_base_url +
        "herds/" +
        vm.selectedHerd +
        "/pictures" +
        suffix;
      Upload.upload({
        url: url,
        data: {
          file: file,
        },
      })
        .then(function (response) {
          $uibModalStack.dismissAll();
          vm.loadingModal = false;
          vm.loadingNewDiscussion = false;
        })
        .catch(function (error) {
          vm.loadingModal = false;
          console.log(error);
        });
    }

    function hideFilterBlock() {
      vm.showFilterBlock = !vm.showFilterBlock;
    }

    function removeDuplicates(list) {
      var _list = list.filter(function (item, pos) {
        return list.indexOf(item) == pos;
      });

      return _list;
    }

    function setStatusDays(s_days) {
      var list = [];

      for (var i = 0; i < s_days.length; i++) {
        var obj = {
          from: s_days[i].from,
          status: s_days[i].status,
          status_v: s_days[i].status_v,
          to: s_days[i].to,
          type: s_days[i].type,
          ineq: s_days[i].ineq,
        };

        list.push(obj);
      }
      return list;
    }

    function setDimList(dim_list) {
      var list = [];
      for (var i = 0; i < dim_list.length; i++) {
        var obj = {
          from: dim_list[i].from,
          to: dim_list[i].to,
          type: dim_list[i].type,
          ineq: dim_list[i].ineq,
        };

        list.push(obj);
      }

      return list;
    }

    function setTags(tags) {
      var t_string;
      if (tags && tags.length) {
        t_string = "";
        for (var i = 0; i < tags.length; i++) {
          t_string += "#" + tags[i].value;
        }
      }
      return t_string;
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function round(value, decimals) {
      if (isNaN(value) == false) {
        return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
      } else {
        return value;
      }
    }
    $scope.$on("default_herd_selected", function (event, data) {
      if (animals) {
        animals.reject("canceled");
      }
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      if (animals) {
        animals.reject("canceled");
      }
      init();
    });
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.listGenerator').factory('listGeneratorService', listGeneratorService);
    /** @ngInject */
    function listGeneratorService($http, $q, APP_CONSTANTS) {
        return {
            getAnimals: getAnimals,
            getPictures: getPictures,
            sendDataToEventBus: sendDataToEventBus,
            addNewDiscussion: addNewDiscussion,
            getHerdById: getHerdById,
            // getListsByHerdId: getListsByHerdId,
            addNewList: addNewList,
            getListsOrder: getListsOrder,
            updateOrder: updateOrder
        }

        function getAnimals(herdId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/animallist', {}).then(success).catch(error);
        }

        function getPictures(herdId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/pictures', {}).then(success).catch(error);
        }

        function sendDataToEventBus(data) {
            return $http.post('https://events.mmmooogle.com/event', data).then(success).catch(error);
        }

        function addNewDiscussion(animal_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/pictures' + suffix).then(success).catch(error);

        }

        function getHerdById(herd_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd_id).then(success).catch(error);

        }

        // function getListsByHerdId(herd_id) {
        //     return $http.get(APP_CONSTANTS.my_api_base_url + 'config-lists/' + herd_id).then(success).catch(error);

        // }

        function addNewList(list, herd_id) {
            return $http.post(APP_CONSTANTS.my_api_base_url + 'config-list?herdId=' + herd_id, list).then(success).catch(error);

        }

        function getListsOrder(herd_id) {
            return $http.get(APP_CONSTANTS.my_api_base_url + 'counters?herdId=' + herd_id).then(success).catch(error);

        }

        function updateOrder(list, herd_id) {
            return $http.post(APP_CONSTANTS.my_api_base_url + 'counters?herdId=' + herd_id, list).then(success).catch(error);

        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }

    }
})();

(function () {
	'use strict';
	angular.module('My.pages.myHerds').controller('myHerdsCtrl', myHerdsCtrl);
	/** @ngInject */
	function myHerdsCtrl(myHerdsService, $rootScope, $scope, $state, $timeout, APP_CONSTANTS, $filter, $q, bugsnagService) {
		var vm = this;
		var selectHerdTimeout;
		var herdSelectionTimeout;
		var herds;
		var favorites;
		vm.init = init;
		vm.selectHerd = selectHerd;
		vm.editHerd = editHerd;
		init();

		function init() {
			vm.loading = true;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if (vm.defaultValues && vm.defaultValues.team_id) {
				vm.selectedTeam = vm.defaultValues.team_id;
				vm.selectedHerds = vm.defaultValues.herd_ids;
				herds = $q.defer();
				favorites = $q.defer();
				getHerdsByTeam(vm.selectedTeam);
				getFavoriteHerds();

				$q.all([herds.promise, favorites.promise])
					.then(function () {
						for (var i = 0; i < vm.herds.length; i++) {
							vm.herds[i].favorite = setFavoriteFlag(vm.herds[i].Id);
							if (vm.herds[i].favorite) {
								vm.herds[i].tooltip = $filter('i18n')('_label_disable_sync_');
							} else {
								vm.herds[i].tooltip = $filter('i18n')('_label_enable_sync_');
							}
						}
						vm.herdsSafe = angular.copy(vm.herds);
						vm.loading = false;
					})
					.catch(function (error) {
						console.log(error);
						vm.loading = false;
						vm.errorOccured = true;
					});
			} else {
				vm.loading = false;
			}
		}

		function setFavoriteFlag(herd_id) {
			var favorite = false;
			for (var i = 0; i < vm.favorites.length; i++) {
				if (herd_id == vm.favorites[i].Id) {
					favorite = true;
					break;
				}
			}
			return favorite;
		}

		function getHerdsByTeam(team_id) {
			vm.errorOccured = false;

			return myHerdsService
				.getHerdsByTeam(team_id)
				.then(function (response) {
					vm.successfullyAdded = true;
					response = $filter('orderBy')(response, 'Name');
					vm.herds = response;
					herds.resolve();
				})
				.catch(function (error) {
					console.log(error);
					herds.reject();
				});
		}

		function getFavoriteHerds() {
			return myHerdsService
				.getFavoriteHerds()
				.then(function (response) {
					vm.favorites = response;
					favorites.resolve();
				})
				.catch(function (error) {
					console.log(error);
					favorites.reject();
				});
		}

		function selectHerd(herd) {
			if (!vm.disableFavorite) {
				herd.favorite = !herd.favorite;
				vm.disableFavorite = true;

				if (herd.favorite) {
					setAsFavorite(herd);
				} else {
					removeFavorite(herd);
				}
			}
		}

		function setAsFavorite(herd) {
			return myHerdsService
				.setAsFavorite(herd.Id)
				.then(function () {
					vm.disableFavorite = false;
					setHerd(herd.Id, true);
					sendToBugsnag(herd, true);
				})
				.catch(function (error) {
					vm.disableFavorite = false;
					setHerd(herd_id, false);
				});
		}

		function removeFavorite(herd) {
			return myHerdsService
				.removeFavorite(herd.Id)
				.then(function () {
					vm.disableFavorite = false;
					setHerd(herd.Id, false);
					sendToBugsnag(herd, false);
				})
				.catch(function (error) {
					vm.disableFavorite = false;
					setHerd(herd_id, true);
				});
		}

		function setHerd(herd_id, favorite) {
			for (var i = 0; i < vm.herds.length; i++) {
				if (herd_id == vm.herds[i].Id) {
					if (favorite) {
						vm.herds[i].favorite = true;
						vm.herds[i].tooltip = $filter('i18n')('_label_disable_sync_');
					} else {
						vm.herds[i].favorite = false;
						vm.herds[i].tooltip = $filter('i18n')('_label_enable_sync_');
					}
				}
			}

			for (var i = 0; i < vm.herdsSafe.length; i++) {
				if (herd_id == vm.herdsSafe[i].Id) {
					if (favorite) {
						vm.herdsSafe[i].favorite = true;
						vm.herdsSafe[i].tooltip = $filter('i18n')('_label_disable_sync_');
					} else {
						vm.herdsSafe[i].favorite = false;
						vm.herdsSafe[i].tooltip = $filter('i18n')('_label_enable_sync_');
					}
				}
			}
		}

		function editHerd(herd) {
			$state.go('editHerd', {
				herd_id: herd.Id
			});
		}

		function sendToBugsnag(herd, favorite) {
			var text;

			if (favorite) {
				text = 'Set as favorite';
			} else {
				text = 'Remove favorite';
			}
			var message = {
				message: text,
				metaData: {
					herd: {
						herd_id: herd.Id,
						herd_name: herd.Name
					}
				}
			};
			bugsnagService.logMessage(message);
		}

		$scope.$on('default_team_selected', function () {
			init();
		});
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.myHerds').factory('myHerdsService', myHerdsService);
	/** @ngInject */
	function myHerdsService(APP_CONSTANTS, $http, $q) {
		return {
			getHerdsByTeam: getHerdsByTeam,
			getFavoriteHerds: getFavoriteHerds,
			setAsFavorite: setAsFavorite,
			removeFavorite: removeFavorite
			
		}

		function getHerdsByTeam(team_id) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
		}
		
		function getFavoriteHerds() {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/favorites/').then(success).catch(error);
		}

		function setAsFavorite(herd) {
			return $http.post(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd + '/addtofavorites').then(success).catch(error);
		}
		
		function removeFavorite(herd) {
			return $http.post(APP_CONSTANTS.backoffice_base_url + 'herds/' + herd + '/removefromfavorites').then(success).catch(error);
		}
		
		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();
(function () {
  "use strict";
  angular.module("My").factory("listsDataService", listsDataService);
  /** @ngInject */
  function listsDataService($filter, APP_CONSTANTS) {
    var vm = this;

    vm.hoofReCheckList = APP_CONSTANTS.constants.hoofReCheck;
    var i18nFilter = $filter("i18n");
    return {
      getReasonString: getReasonString,
      getRecheckDate: getRecheckDate,
      setPositionString: setPositionString,
      setLesionString: setLesionString,
      setSeverityString: setSeverityString,
      getRecheckString: getRecheckString,
      setLesionStringShort: setLesionStringShort,
    };

    function getReasonString(reason) {
      var reasonString = "";
      if (reason === 0) {
        reasonString = i18nFilter("_animal_details_visit_reason_trim_");
      } else if (reason == 1) {
        reasonString = i18nFilter("_animal_details_visit_reason_lame_");
      } else if (reason == 2) {
        reasonString = i18nFilter("_animal_details_visit_reason_recheck_");
      } else if (reason == 3) {
        reasonString = i18nFilter("_animal_details_visit_reason_trim_");
      } else if (reason == 4) {
        reasonString = i18nFilter("_animal_details_visit_reason_trim_rear_");
      }
      return reasonString;
    }

    function getRecheckDate(recheck, visit_date, format) {
      var recheckDate = "";

      if (recheck && recheck != 255) {
        var rckD = vm.hoofReCheckList.find(function (r) {
          return r.value === recheck;
        });

        if (rckD) {
          if (format) {
            recheckDate = $filter("date")(
              new Date(moment(visit_date).add(rckD.v, rckD.u)),
              format
            );
          } else {
            recheckDate = new Date(moment(visit_date).add(rckD.v, rckD.u));
          }
        }
      }

      /*if (recheck == 1) {
				if (format) {
					recheckDate = $filter('date')(new Date(moment(visit_date).add(2, 'weeks')), format);
				} else {
					recheckDate = new Date(moment(visit_date).add(2, 'weeks'));
				}
			} else if (recheck == 2) {
				if (format) {
					recheckDate = $filter('date')(new Date(moment(visit_date).add(1, 'months')), format);
				} else {
					recheckDate = new Date(moment(visit_date).add(1, 'months'));
				}
			} else if (recheck == 3) {
				if (format) {
					recheckDate = $filter('date')(new Date(moment(visit_date).add(2, 'months')), format);
				} else {
					recheckDate = new Date(moment(visit_date).add(2, 'months'));
				}
			} else if (recheck == 4) {
				if (format) {
					recheckDate = $filter('date')(new Date(moment(visit_date).add(3, 'months')), format);
				} else {
					recheckDate = new Date(moment(visit_date).add(3, 'months'));
				}
			}*/
      return recheckDate;
    }

    function setPositionString(position) {
      var positionString = "";
      if (position === 0) {
        positionString = i18nFilter("_animal_lf_");
      } else if (position === 1) {
        positionString = i18nFilter("_animal_rf_");
      } else if (position === 2) {
        positionString = i18nFilter("_animal_lr_");
      } else if (position === 3) {
        positionString = i18nFilter("_animal_rr_");
      } else if (position === 4) {
        positionString = i18nFilter("_animal_lfo_");
      } else if (position === 5) {
        positionString = i18nFilter("_animal_lfi_");
      } else if (position === 6) {
        positionString = i18nFilter("_animal_rfo_");
      } else if (position === 7) {
        positionString = i18nFilter("_animal_rfi_");
      } else if (position === 8) {
        positionString = i18nFilter("_animal_lro_");
      } else if (position === 9) {
        positionString = i18nFilter("_animal_lri_");
      } else if (position === 10) {
        positionString = i18nFilter("_animal_rro_");
      } else if (position === 11) {
        positionString = i18nFilter("_animal_rri_");
      }
      return positionString;
    }

    function setLesionString(lesion) {
      var lesionString = "";
      if (lesion === 1) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_abcess_");
      } else if (lesion === 2) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_bruise_");
      } else if (lesion === 3) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_corn_");
      } else if (lesion === 4) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_"
        );
      } else if (lesion === 5) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_erosion_");
      } else if (lesion === 6) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_foot_rot_");
      } else if (lesion === 7) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_deep_digital_sepsis_"
        );
      } else if (lesion === 8) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_hemorrhage_"
        );
      } else if (lesion === 9) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_upper_limb_"
        );
      } else if (lesion === 10) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_rotated_claw_"
        );
      } else if (lesion === 11) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_sole_fracture_"
        );
      } else if (lesion === 12) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_toe_ulcer_"
        );
      } else if (lesion === 13) {
        lesionString = i18nFilter("_animal_details_hoof_lesion_type_ulcer_");
      } else if (lesion === 14) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_vertical_fissure_"
        );
      } else if (lesion === 15) {
        //use toe necrosis instead of hairy attack
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_toe_necrosis_"
        );
      } else if (lesion === 16) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_axial_wall_fissure_"
        );
      } else if (lesion === 17) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_horizontal_fissure_"
        );
      } else if (lesion === 18) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_thin_soles_"
        );
      } else if (lesion === 19) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_toe_necrosis_"
        );
      } else if (lesion === 20) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d1_"
        );
      } else if (lesion === 21) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d2_"
        );
      } else if (lesion === 22) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d3_"
        );
      } else if (lesion === 23) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d4_"
        );
      } else if (lesion === 24) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d5_"
        );
      }
      return lesionString;
    }

    function setLesionStringShort(lesion) {
      var lesionString = "";
      if (lesion === 1) {
        lesionString = "A";
      } else if (lesion === 2) {
        lesionString = "B";
      } else if (lesion === 3) {
        lesionString = "C";
      } else if (lesion === 4) {
        lesionString = "D";
      } else if (lesion === 5) {
        lesionString = "E";
      } else if (lesion === 6) {
        lesionString = "F";
      } else if (lesion === 7) {
        lesionString = "G";
      } else if (lesion === 8) {
        lesionString = "H";
      } else if (lesion === 9) {
        lesionString = "L";
      } else if (lesion === 10) {
        lesionString = "R";
      } else if (lesion === 11) {
        lesionString = "S";
      } else if (lesion === 12) {
        lesionString = "T";
      } else if (lesion === 13) {
        lesionString = "U";
      } else if (lesion === 14) {
        lesionString = "V";
      } else if (lesion === 15) {
        //use toe necrosis instead of hairy attack
        lesionString = "W";
      } else if (lesion === 16) {
        lesionString = "X";
      } else if (lesion === 17) {
        lesionString = "Y";
      } else if (lesion === 18) {
        lesionString = "Z";
      } else if (lesion === 19) {
        lesionString = "W";
      } else if (lesion === 20) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d1_"
        );
      } else if (lesion === 21) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d2_"
        );
      } else if (lesion === 22) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d3_"
        );
      } else if (lesion === 23) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d4_"
        );
      } else if (lesion === 24) {
        lesionString = i18nFilter(
          "_animal_details_hoof_lesion_type_digital_dermatitis_d5_"
        );
      }
      return lesionString;
    }

    function setSeverityString(severity) {
      var severityString = "";
      if (severity === 0) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_none_"
        );
      } else if (severity == 1) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_mild_"
        );
      } else if (severity == 2) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_mild_moderate_"
        );
      } else if (severity == 3) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_moderate_"
        );
      } else if (severity == 4) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_moderate_severe_"
        );
      } else if (severity == 5) {
        severityString = i18nFilter(
          "_animal_details_hoof_lesion_severity_severe_"
        );
      }
      return severityString;
    }

    function getRecheckString(recheck) {
      var recheckString = "";

      if (recheck) {
        if (recheck == 255) {
          recheckString = "/";
        } else {
          var rString = vm.hoofReCheckList.find(function (r) {
            return r.value === recheck;
          });
          if (rString && rString.label_translate) {
            recheckString = i18nFilter(rString.label_translate);
          }
        }
      }

      /*if (recheck === 0) {
				recheckString = i18nFilter('_label_no_');
			} else if (recheck == 1) {
				recheckString = i18nFilter('_animal_details_hoof_treatment_type_two_weeks_');
			} else if (recheck == 2) {
				recheckString = i18nFilter('_animal_details_hoof_recheck_one_month_');
			} else if (recheck == 3) {
				recheckString = i18nFilter('_label_two_months_');
			} else if (recheck == 4) {
				recheckString = i18nFilter('_animal_details_hoof_treatment_type_three_months_');
			} else if (recheck == 255) {
				recheckString = '/';
			}*/
      return recheckString;
    }
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.lists').factory('listsService', listsService);
	/** @ngInject */
	function listsService(APP_CONSTANTS, $http, $q) {
		return {
			getVisitDates: getVisitDates,
			getHoofTrims: getHoofTrims,
			getHoofTrimsSummary: getHoofTrimsSummary,
			getHerdInfo: getHerdInfo,
			getAnimals: getAnimals,
            getHoofTrimsByPeriod: getHoofTrimsByPeriod,
			removeHoofTrimById: removeHoofTrimById
			
		}

		function getVisitDates(herd_id) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/hooftrims/visitdates?-orderby=-VisitDate', {
				timeout: 15000
			}).then(success).catch(error);
		}

        function getHoofTrims(herd_id, date) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/hooftrims?VisitDate=' + date + '&-orderby=AnimalNumber', {
				timeout: 15000
			}).then(success).catch(error);
		}
		
		function getHoofTrimsSummary(herd_id, date) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/hooftrimsummary?VisitDate=>=' + date + '&ReCheck=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,255]&-orderby=AnimalNumber', {
				timeout: 15000
			}).then(success).catch(error);
		}
		
		function getAnimals(list, herd_id) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/animals?AnimalId=' + list, {
				timeout: 15000
			}).then(success).catch(error);
		}
		
		function getHerdInfo(herdId) {
			return $http.get(APP_CONSTANTS.backoffice_base_url + 'herds/' + herdId, {
				timeout: 15000
			}).then(success).catch(error);
		}

        function getHoofTrimsByPeriod(herdId, suffix) {
			return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/hooftrims' + suffix, {
				timeout: 15000
			}).then(success).catch(error);
		}

		function removeHoofTrimById(id){
			return $http.delete(APP_CONSTANTS.animals_base_url + 'hooftrims/' + id, {
				timeout: 15000
			}).then(success).catch(error);
		}

		function success(response) {
			return response.data;
		}

		function error(error) {
			return $q.reject(error);
		}
	}
})();
(function () {
  "use strict";
  angular
    .module("My.pages.lists.blockList")
    .controller("blockListCtrl", blockListCtrl);
  /** @ngInject */
  function blockListCtrl(
    listsService,
    $scope,
    $timeout,
    $filter,
    listsDataService,
    $q,
    $uibModal,
    $uibModalStack,
    appService,
    xlsxService,
    $locale
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var herdInfo;
    var hoofTrimDates;
    var timePeriodUnitTimeout;
    vm.init = init;
    vm.dateSelected = dateSelected;
    vm.exportToPdf = exportToPdf;
    vm.changeHoofTrimPeriod = changeHoofTrimPeriod;
    vm.dateChanged = dateChanged;
    vm.openRangeSelector = openRangeSelector;
    vm.closeModal = closeModal;
    vm.setDateRange = setDateRange;
    vm.getCsvData = getCsvData;
    vm.openExportModal = openExportModal;
    vm.exportData = exportData;
    vm.deleteVisit = deleteVisit;
    vm.openDeleteModal = openDeleteModal;
    vm.getCsvHeader = getCsvHeader;
    vm.dpOptions = {
      customClass: getDayClass,
    };
    init();
    setStrings();

    function init() {
      vm.tooltipText = i18nFilter("_label_export_pdf_");
      vm.tooltipTextCsv = i18nFilter("_button_export_") + " .csv";
      //vm.tooltipTextCsv = i18nFilter('_button_export_') + ' .csv/.xls';
      vm.loading = true;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.selectedTeam = vm.defaultValues.team_id;
      vm.timePeriodUnit = "toggle_off";
      vm.hoofTrimByDate = true;
      vm.selectedFormat = 1;
      vm.selectedVersion = 1;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        getData(vm.selectedHerds[0]);
      }
    }

    function setStrings() {
      vm.Yes = i18nFilter("_label_yes_");
      vm.No = i18nFilter("_label_no_");

      vm.AntibioticTreatment = i18nFilter(
        "_animal_details_hoof_treatment_type_antibiotic_treatment_"
      );
      vm.Conventional = i18nFilter(
        "_animal_details_hoof_treatment_type_conventional_"
      );
      vm.Block = i18nFilter("_animal_details_hoof_treatment_type_block_");
      vm.Wrap = i18nFilter("_animal_details_hoof_treatment_type_wrap_");
    }

    function getData(herd_id) {
      herdInfo = $q.defer();
      hoofTrimDates = $q.defer();
      vm.errorLoading = false;

      $q.all([hoofTrimDates.promise, herdInfo.promise])
        .then(function () {
          vm.fileName =
            vm.herdName + " " + i18nFilter("_page_title_trim_list") + ".csv";
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.loadingHoofTrims = false;
          vm.errorLoading = true;
        });

      getVisitDates(herd_id, true);
      getHerdInfo(herd_id);
    }

    function getVisitDates(herd_id, init) {
      vm.errorLoading = false;
      return listsService
        .getVisitDates(herd_id)
        .then(function (response) {
          if (response) {
            if (response.length == 0) {
              vm.noVisitDates = true;
              vm.loading = false;
            } else {
              vm.noVisitDates = false;

              for (var i = 0; i < response.length; i++) {
                response[i].date = $filter("date")(
                  new Date(response[i].VisitDate),
                  "mediumDate"
                );
              }
              vm.visitDates = response;
              setStartEndDate(response);
              vm.selectedDate = vm.visitDates[0];
              vm.selectedDateObject = new Date(vm.visitDates[0].VisitDate);
              vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
              getHoofTrimsByDate(herd_id, vm.selectedDate.VisitDate, init);
            }
          } else {
            vm.noVisitDates = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          console.log(error);
        });
    }

    function setStartEndDate(dates) {
      var lastDate = dates[0].VisitDate;
      var month = moment(lastDate).month();
      var year = moment(lastDate).year();
      var startDate = moment()
        .date(1)
        .year(year)
        .month(month)
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      var endDate = moment(startDate)
        .endOf("month")
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      vm.startDate = new Date(startDate);
      vm.endDate = new Date(endDate);
    }

    function getHerdInfo(herdId) {
      return listsService
        .getHerdInfo(herdId)
        .then(function (response) {
          vm.herdName = response.Name;
          herdInfo.resolve();
        })
        .catch(function (error) {
          console.log(error);
          herdInfo.reject(error);
        });
    }

    function getHoofTrimsByDate(herd_id, date, init) {
      vm.loadingHoofTrims = true;
      return listsService
        .getHoofTrims(herd_id, date)
        .then(function (response) {
          response = filterOutBlockEvents(response);
          if (!response) {
            response = [];
          }
          vm.rawData = angular.copy(response);
          response = setData(response);
          vm.hoofTrimData = response;
          if (init) {
            hoofTrimDates.resolve();
          }
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
          if (init) {
            hoofTrimDates.reject();
          }
          console.log(error);
        });
    }

    function filterOutBlockEvents(events) {
      var list = [];

      for (var i = 0; i < events.length; i++) {
        var l = [];
        for (var j = 0; j < events[i].Limbs.length; j++) {
          if ((events[i].Limbs[j].ActionType & 1) == 1) {
            l.push(events[i].Limbs[j]);
          }
        }
        if (l.length) {
          events[i].Limbs = l;
          list.push(events[i]);
        }
      }

      return list;
    }

    function getHoofTrimsByPeriod(herdId) {
      vm.loadingHoofTrims = true;
      var startDate = moment(vm.startDate).format("YYYY-MM-DDT00:00:00");
      var endDate = moment(vm.endDate).format("YYYY-MM-DDT23:59:59");
      var suffix = "?VisitDate=>=" + startDate + "&VisitDate=<=" + endDate;
      return listsService
        .getHoofTrimsByPeriod(herdId, suffix)
        .then(function (response) {
          response = filterOutBlockEvents(response);
          vm.rawData = angular.copy(response);
          if (response && response.length) {
            response = setData(response);
          } else {
            response = [];
          }

          var byAnimal = appService.groupBy(response, "AnimalId");
          response = setByAnimalData(byAnimal);
          vm.hoofTrimData = response;
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
        });
    }

    function setData(trim_list) {
      for (var i = 0; i < trim_list.length; i++) {
        trim_list[i].ReasonString = listsDataService.getReasonString(
          trim_list[i].Reason
        );
        if (trim_list[i].Limbs) {
          for (var j = 0; j < trim_list[i].Limbs.length; j++) {
            trim_list[i].Limbs[j].ReasonString = trim_list[i].ReasonString;
            trim_list[i].Limbs[j].PositionString =
              listsDataService.setPositionString(
                trim_list[i].Limbs[j].Position
              );
            trim_list[i].Limbs[j].Therapeutic = getTherapeutic(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Topical = getTopical(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].AntibioticTreatment = getAntibioticTreatment(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Treatments = getTreatments(
              trim_list[i].Limbs[j].TreatmentType,
              trim_list[i].Limbs[j].ActionType
            );
            trim_list[i].Limbs[j].RecheckString =
              listsDataService.getRecheckString(trim_list[i].Limbs[j].ReCheck);
            trim_list[i].Limbs[j].RecheckDate = listsDataService.getRecheckDate(
              trim_list[i].Limbs[j].ReCheck,
              trim_list[i].VisitDate,
              "mediumDate"
            );
            trim_list[i].Limbs[j].RecheckDateObj =
              listsDataService.getRecheckDate(
                trim_list[i].Limbs[j].ReCheck,
                trim_list[i].VisitDate
              );
            if (trim_list[i].Limbs[j].Lesions) {
              for (var k = 0; k < trim_list[i].Limbs[j].Lesions.length; k++) {
                trim_list[i].Limbs[j].Lesions[k].LesionString =
                  listsDataService.setLesionString(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].LesionStringShort =
                  listsDataService.setLesionStringShort(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].SeverityString =
                  listsDataService.setSeverityString(
                    trim_list[i].Limbs[j].Lesions[k].Severity
                  );
              }
            }
          }
          trim_list[i].Limbs = mergeLimbsIfOk(
            trim_list[i].Limbs,
            trim_list[i].ReasonString
          );
        }
      }

      return trim_list;
    }

    function mergeLimbsIfOk(trim_list, reason) {
      var allLimbsPresent = checkAllLimbs(trim_list);
      if (allLimbsPresent) {
        var limbs = [
          {
            ReasonString: reason,
            PositionString: i18nFilter("_label_all_"),
            Lesions: [
              {
                LesionString: i18nFilter("_label_all_feet_ok_"),
                SeverityString: "",
              },
            ],
            Treatments: [],
            Therapeutic: vm.No,
            Topical: vm.No,
            AllOk: true,
          },
        ];
        trim_list = limbs;
      }

      return trim_list;
    }

    function checkAllLimbs(limbs) {
      var limb1 = false;
      var limb2 = false;
      var limb3 = false;
      var limb4 = false;
      var lesionsList = [];
      var lesions = false;
      var tt = true;
      var rc = true;
      var aa = true;
      var len;
      if (limbs && limbs.length == 4) {
        len = true;
      }
      if (limbs) {
        for (var i = 0; i < limbs.length; i++) {
          lesionsList = lesionsList.concat(limbs[i].Lesions);
          if (limbs[i].Position === 0) {
            limb1 = true;
          }
          if (limbs[i].Position === 1) {
            limb2 = true;
          }
          if (limbs[i].Position === 2) {
            limb3 = true;
          }
          if (limbs[i].Position === 3) {
            limb4 = true;
          }
          if (limbs[i].TreatmentType != 0) {
            tt = false;
          }
          if (limbs[i].ReCheck != 0) {
            rc = false;
          }
          if (limbs[i].ActionType != 0) {
            aa = false;
          }
        }
      }

      if (lesionsList && lesionsList.length == 0) {
        lesions = true;
      }
      return (
        limb1 && limb2 && limb3 && limb4 && lesions && len && tt && rc && aa
      );
    }

    function setByAnimalData(trim_list) {
      var list = [];
      angular.forEach(trim_list, function (value, key) {
        var obj = {};
        value = $filter("orderBy")(value, "VisitDate", true);
        if (value) {
          for (var i = 0; i < value.length; i++) {
            if (i == 0) {
              obj.AnimalEarTag = value[i].AnimalEarTag;
              obj.AnimalName = value[i].AnimalName;
              obj.AnimalNumber = value[i].AnimalNumber;
              obj.Limbs = value[i].Limbs;
              obj.VisitDate = value[i].VisitDate;
            } else {
              obj.Limbs = obj.Limbs.concat(value[i].Limbs);
            }
          }
        }

        list.push(obj);
      });

      return $filter("orderBy")(list, ["AnimalNumber", "AnimalEarTag"]);
    }

    function dateSelected() {
      if (vm.selectedDate.VisitDate != vm.lastHoofTrimDate) {
        vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
        getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
      }
    }

    function dateChanged() {
      if (vm.selectedDateObject) {
        var dateFound = false;
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if (
              $filter("date")(vm.selectedDateObject, "mediumDate") ==
              vm.visitDates[i].date
            ) {
              vm.selectedDate = vm.visitDates[i];
              dateSelected();
              dateFound = true;
              break;
            }
          }
        }

        if (dateFound) {
          vm.dateError = false;
        } else {
          vm.dateError = true;
        }
      } else {
        vm.dateError = true;
      }
    }

    function getTherapeutic(type) {
      var therapeutic = vm.No;
      if ((type & 1) == 1) {
        therapeutic = vm.Yes;
      }
      return therapeutic;
    }

    function getTopical(type) {
      var topical = vm.No;
      if ((type & 2) == 2) {
        topical = vm.Yes;
      }
      return topical;
    }

    function getAntibioticTreatment(type) {
      var antibioticTreatment = vm.No;
      if ((type & 4096) == 4096) {
        antibioticTreatment = vm.Yes;
      }
      return antibioticTreatment;
    }

    function getTreatments(type, action) {
      var treatments = [];
      if ((type & 4096) == 4096) {
        treatments.push(vm.AntibioticTreatment);
      }
      if ((type & 8192) == 8192) {
        treatments.push(vm.Conventional);
      }

      if (action != 0) {
        if ((action & 1) == 1) {
          treatments.push(vm.Block);
        }
        if ((action & 2) == 2) {
          treatments.push(vm.Wrap);
        }
      }

      return treatments;
    }

    function changeHoofTrimPeriod() {
      vm.hoofTrimByDate = !vm.hoofTrimByDate;
      if (vm.hoofTrimByDate) {
        vm.timePeriodUnit = "toggle_off";
      } else {
        vm.timePeriodUnit = "toggle_on";
      }

      if (timePeriodUnitTimeout) {
        $timeout.cancel(timePeriodUnitTimeout);
      }

      timePeriodUnitTimeout = $timeout(function () {
        if (vm.hoofTrimByDate) {
          getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate, false);
        } else {
          getHoofTrimsByPeriod(vm.selectedHerds[0]);
        }
      }, 500);
    }

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode == "day") {
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if ($filter("date")(date, "mediumDate") == vm.visitDates[i].date) {
              return "datepicker-highlight";
            }
          }
        }
      }
    }

    function openRangeSelector() {
      if (!vm.loadingHoofTrims) {
        vm.modal_start_date = angular.copy(vm.startDate);
        vm.modal_end_date = angular.copy(vm.endDate);
        openModal("app/pages/lists/common/dateRange.modal.html", "sm");
      }
    }

    function setDateRange() {
      var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
      if (!range_error) {
        vm.startDate = angular.copy(vm.modal_start_date);
        vm.endDate = angular.copy(vm.modal_end_date);

        getHoofTrimsByPeriod(vm.selectedHerds[0]);
        closeModal();
      }
    }

    function checkRangeError(start_date, end_date) {
      var error = false;
      if (moment(end_date).isBefore(start_date)) {
        error = true;
      }
      return error;
    }

    function openDeleteModal() {
      if (vm.selectedDate && vm.selectedDate.HerdVisitId) {
        vm.deleteVisitId = vm.selectedDate.HerdVisitId;
        vm.deleteVisitDate = vm.selectedDate.VisitDate;
        vm.modalLoading = false;
        openModal("app/pages/lists/common/delete.modal.html", "sm");
      }
    }

    function openExportModal() {
      if (vm.hoofTrimData && vm.hoofTrimData.length) {
        openModal("app/pages/lists/common/export.modal.html", "sm");
      }
    }

    function deleteVisit() {
      vm.modalLoading = true;
      return listsService
        .removeHoofTrimById(vm.deleteVisitId)
        .then(function (response) {
          init();
          closeModal();
        })
        .catch(function (error) {
          vm.deleteError = error;
          vm.modalLoading = false;
          console.log(error);
        });
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function exportToPdf() {
      var dd = {
        pageMargins: [25, 30, 25, 30],
        pageSize: "A4",
        pageOrientation: "portrait",
        content: [
          {
            style: "header",

            table: {
              widths: ["*", 100],

              body: [
                [
                  {
                    text: i18nFilter("_page_title_block_list_"),
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: vm.hoofTrimByDate
                      ? $filter("date")(vm.selectedDate.VisitDate, "shortDate")
                      : $filter("date")(vm.startDate, "shortDate") +
                        " - " +
                        $filter("date")(vm.endDate, "shortDate"),
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: ["50%", "50%"],

              body: [
                [
                  {
                    text: " ",
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    text: vm.herdName,
                    alignment: "right",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: ["33%", "33%", "33%"],

              body: [
                [
                  {
                    style: "tableHeader",
                    text: "",
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_label_limb_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_lesion_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 17,
            bold: true,
          },
          headerSm: {
            fontSize: 15,
            bold: true,
          },
          tableHeader: {
            bold: true,
          },
        },
        defaultStyle: {
          fontSize: 10,
        },
      };

      if (!vm.hoofTrimByDate) {
        dd.content[0].table.widths[1] = 200;
      }

      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var obj = [
          {
            text:
              (vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : "") +
              (vm.hoofTrimData[i].AnimalNumber &&
              vm.hoofTrimData[i].AnimalEarTag
                ? " - "
                : "") +
              (vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "") +
              (!vm.hoofTrimData[i].AnimalNumber &&
              !vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalName
                : ""),
            alignment: "left",
            colSpan: 3,
            border: [false, true, false, false],
          },
          {},
          {},
        ];

        dd.content[2].table.body.push(obj);
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var obj2 = [
            {
              text: i18nFilter("_animal_details_hoof_treatment_type_block_"),
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].PositionString
                ? vm.hoofTrimData[i].Limbs[j].PositionString
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              table: {
                widths: ["100%"],
                body: [],
              },
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          if (vm.hoofTrimData[i].Limbs[j].Lesions.length > 1) {
            for (
              var l = 0;
              l < vm.hoofTrimData[i].Limbs[j].Lesions.length;
              l++
            ) {
              var lesions = [
                {
                  text: vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    ? vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    : "",
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ];
              obj2[2].table.body.push(lesions);
            }
          } else {
            obj2[2] = {
              text:
                vm.hoofTrimData[i].Limbs[j].Lesions.length == 1
                  ? vm.hoofTrimData[i].Limbs[j].Lesions[0].LesionString
                  : "",
              alignment: "center",
              border: [false, false, false, false],
            };
          }

          dd.content[2].table.body.push(obj2);
        }
      }

      var name =
        vm.herdName + " " + i18nFilter("_page_title_block_list_") + ".pdf";
      name = name.replace(/ /g, "_");
      pdfMake.createPdf(dd).download(name);
    }

    function exportData() {
      if (vm.selectedFormat == 1) {
        var elem = document.getElementById("export-csv-button");

        $timeout(function () {
          elem.click();
        }, 10);
      } else {
        exportToExcel(vm.selectedVersion);
      }

      $timeout(function () {
        closeModal();
      }, 200);
    }

    function exportToExcel(version) {
      var list = generateExportList(version, vm.hoofTrimData);
      var file_name = vm.herdName + ".xls";
      var date_format = xlsxService.getShortDateFormat($locale);
      var ws = XLSX.utils.aoa_to_sheet(list, {
        cellDates: true,
        dateNF: date_format,
      });

      if (version == 1) {
        ws["!cols"] = [{ wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
      } else if (version == 2) {
        ws["!cols"] = [
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
        ];
      }

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        i18nFilter("_page_title_block_list_")
      );
      XLSX.writeFile(wb, file_name);
    }

    function generateExportList(version, data) {
      var l = [];

      if (version == 1) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      } else if (version == 2) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      }

      data.forEach(function (event) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < event.Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            event.Limbs[j].ReCheck,
            event.VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (version == 1) {
          var ll = [];
          ll.push(
            event.AnimalNumber
              ? event.AnimalNumber
              : event.AnimalEarTag
              ? event.AnimalEarTag
              : ""
          );

          ll.push(listsDataService.getReasonString(event.Reason));
          ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
          ll.push(recheckDate ? new Date(recheckDate) : "");
          l.push(ll);
        } else if (version == 2) {
          event.Limbs.forEach(function (limb) {
            var ll = [];
            ll.push(
              event.AnimalNumber
                ? event.AnimalNumber
                : event.AnimalEarTag
                ? event.AnimalEarTag
                : ""
            );
            ll.push(listsDataService.getReasonString(event.Reason));
            ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
            ll.push(limb.PositionString);
            ll.push(getLesionsShortList(limb.Lesions));
            ll.push(
              limb.AntibioticTreatment == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(
              limb.Topical == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(limb.RecheckDateObj ? limb.RecheckDateObj : "");
            l.push(ll);
          });
        }
      });

      return l;
    }

    function getLesionsShortList(lesions) {
      var list = "";
      for (var i = 0; i < lesions.length; i++) {
        if (lesions.length == 1) {
          list += lesions[i].LesionStringShort;
        } else {
          if (i != lesions.length - 1) {
            list += lesions[i].LesionStringShort + "|";
          } else {
            list += lesions[i].LesionStringShort;
          }
        }
      }
      return list;
    }

    function getCsvData() {
      var list = [];
      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            vm.hoofTrimData[i].Limbs[j].ReCheck,
            vm.hoofTrimData[i].VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (vm.selectedVersion == 1) {
          var obj = {
            a: vm.hoofTrimData[i].AnimalNumber
              ? vm.hoofTrimData[i].AnimalNumber
              : vm.hoofTrimData[i].AnimalEarTag
              ? vm.hoofTrimData[i].AnimalEarTag
              : "",
            b: i18nFilter("_animal_details_hoof_treatment_type_block_"),
            c: getLimbsCsv(vm.hoofTrimData[i]),
            d: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
          };
          list.push(obj);
        } else {
          for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
            var obj = {
              a: vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "",
              b: listsDataService.getReasonString(vm.hoofTrimData[i].Reason),
              c: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
              d: vm.hoofTrimData[i].Limbs[j].PositionString,
              e: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : getLesionsShortList(vm.hoofTrimData[i].Limbs[j].Lesions),
              f: vm.hoofTrimData[i].Limbs[0].AllOk
                ? i18nFilter("_label_no_")
                : vm.hoofTrimData[i].Limbs[j].AntibioticTreatment,
              g: vm.hoofTrimData[i].Limbs[0].AllOk
                ? i18nFilter("_label_no_")
                : vm.hoofTrimData[i].Limbs[j].Topical,
              h: $filter("date")(recheckDate, "shortDate"),
            };

            list.push(obj);
          }
        }
      }
      return list;
    }

    function getLimbsCsv(trim) {
      var str = "";
      for (var i = 0; i < trim.Limbs.length; i++) {
        str += trim.Limbs[i].PositionString;
        if (i < trim.Limbs.length - 1) {
          str += ", ";
        }
      }
      return str;
    }

    function getCsvHeader() {
      if (vm.selectedVersion == 1) {
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
      } else {
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
      }
    }

    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });
  }
})();

(function () {
	'use strict';
	angular.module('My.pages.lists.recheckList').controller('recheckListCtrl', recheckListCtrl);
	/** @ngInject */
	function recheckListCtrl(listsService, $scope, $timeout, $filter, listsDataService, $uibModalStack, $uibModal, $q, appService) {
		var vm = this;
		var i18nFilter = $filter('i18n');
		var herdInfo;
		var hoofTrim;
		var animals;
		var dateChangedTimeout;
		vm.init = init;
		vm.closeModal = closeModal;
		vm.exportToPdf = exportToPdf;
		vm.dateChanged = dateChanged;
		init();

		function init() {
			vm.tooltipText = i18nFilter('_label_export_pdf_');
			vm.loading = true;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.selectedTeam = vm.defaultValues.team_id;
			if (vm.selectedHerds.length == 1) {
				vm.date = new Date();
				vm.loading = true;
				getData(vm.selectedHerds[0], vm.date);
			}
		}

		function getData(herd_id, date) {
			herdInfo = $q.defer();
			hoofTrim = $q.defer();
			animals = $q.defer();
			vm.errorLoading = false;

			$q.all([hoofTrim.promise, herdInfo.promise, animals.promise])
				.then(function () {
					vm.loading = false;
					vm.loadingHoofTrims = false;
				})
				.catch(function (error) {
					vm.loading = false;
					vm.loadingHoofTrims = false;
					vm.errorLoading = true;
				});

			getHoofTrimsByDate(herd_id, date, true);
			getHerdInfo(herd_id);
		}

		function getHerdInfo(herdId) {
			return listsService
				.getHerdInfo(herdId)
				.then(function (response) {
					vm.herdName = response.Name;
					herdInfo.resolve();
				})
				.catch(function (error) {
					console.log(error);
					herdInfo.reject(error);
				});
		}

		function getHoofTrimsByDate(herd_id, date, init) {
			var rDate = moment(date).subtract(3, 'months').subtract(1, 'days').format('YYYY-MM-DDT00:00:00');
			vm.loadingHoofTrims = true;
			return listsService
				.getHoofTrimsSummary(herd_id, rDate)
				.then(function (response) {
					vm.noHoofTrims = false;
					response = setData(response);
					response = filterDataByDate(response, date);
					response = createHoofTrimObjectsByCow(response);
					response = $filter('orderBy')(response, ['Date', 'AnimalNumber']);
					if (response && response.length) {
						vm.noHoofTrims = false;
						var animalsList = getAnimalsList(response);
						if (init) {
							hoofTrim.resolve();
						}
						getAnimalsByIds(animalsList, herd_id, response, init);
					} else {
						vm.noHoofTrims = true;
						if (init) {
							hoofTrim.resolve();
							animals.resolve();
						}
						vm.loadingHoofTrims = false;
					}
				})
				.catch(function (error) {
					vm.loading = false;
					vm.errorLoading = true;
					vm.loadingHoofTrims = false;
					if (init) {
						hoofTrim.reject();
					}
					console.log(error);
				});
		}

		function getAnimalsByIds(list, herd_id, hoofTrimData, init) {
			return listsService
				.getAnimals(JSON.stringify(list), herd_id)
				.then(function (response) {
					for (var i = 0; i < response.length; i++) {
						for (var j = 0; j < hoofTrimData.length; j++) {
							if (response[i].AnimalId == hoofTrimData[j].AnimalId) {
								hoofTrimData[j].AnimalEarTag = response[i].EarTag;
							}
						}
					}
					vm.hoofTrimData = hoofTrimData;
					if (init) {
						animals.resolve();
					}
					vm.loadingHoofTrims = false;
				})
				.catch(function (error) {
					vm.loading = false;
					vm.errorLoading = true;
					vm.loadingHoofTrims = false;
					if (init) {
						animals.reject();
					}
					console.log(error);
				});
		}

		function getAnimalsList(list) {
			var animals = [];
			for (var i = 0; i < list.length; i++) {
				animals.push(list[i].AnimalId);
			}
			return animals;
		}

		function setData(trim_list) {
			for (var i = 0; i < trim_list.length; i++) {
				trim_list[i].ReasonString = listsDataService.getReasonString(trim_list[i].Reason);
				trim_list[i].RecheckDate = listsDataService.getRecheckDate(trim_list[i].ReCheck, trim_list[i].VisitDate);
				trim_list[i].RecheckDateObj = new Date(trim_list[i].RecheckDate);
				trim_list[i].RecheckDate = $filter('date')(trim_list[i].RecheckDate, 'mediumDate');
				trim_list[i].RecheckString = listsDataService.getRecheckString(trim_list[i].ReCheck);
				trim_list[i].PositionString = listsDataService.setPositionString(trim_list[i].Position);
				trim_list[i].LesionString = listsDataService.setLesionString(trim_list[i].LesionType);
				trim_list[i].SeverityString = listsDataService.setSeverityString(trim_list[i].Severity);
				trim_list[i].RecheckDateString = moment(trim_list[i].RecheckDateObj).format();
			}
			return trim_list;
		}

		function filterDataByDate(list, date) {
			var eventList = [];
			for (var i = 0; i < list.length; i++) {
				if (moment(date).subtract(1, 'days').isBefore(list[i].RecheckDateObj)) {
					eventList.push(list[i]);
				}
			}
			return eventList;
		}

		function createHoofTrimObjectsByCow(trimList) {
			var list = [];
			var gList = appService.groupBy(trimList, 'AnimalId');
			angular.forEach(gList, function (value, key) {
				var obj = {
					AnimalName: value[0].AnimalName,
					AnimalNumber: value[0].AnimalNumber,
					AnimalId: value[0].AnimalId,
					Date: setFirstDate(value),
					Lesions: []
				};
				for (var i = 0; i < value.length; i++) {
					obj.Lesions.push(value[i]);
				}
				obj.Lesions = $filter('orderBy')(obj.Lesions, 'RecheckDateString');

				list.push(obj);
			});
			return list;
		}

		function setFirstDate(trims) {
			var date;
			if (trims.length) {
				date = trims[0].RecheckDateObj;
			}

			for (var i = 0; i < trims.length; i++) {
				if (moment(trims[i].RecheckDateObj).isBefore(date)) {
					date = trims[i].RecheckDateObj;
				}
			}
			return moment(date).format();
		}

		function dateChanged() {
			if (vm.date) {
				if (dateChangedTimeout) {
					$timeout.cancel(dateChangedTimeout);
				}
				dateChangedTimeout = $timeout(function () {
					getHoofTrimsByDate(vm.selectedHerds[0], vm.date);
				}, 250);
			}
		}

		function exportToPdf() {
			var dd = {
				pageMargins: [25, 30, 25, 30],
				pageSize: 'A4',
				pageOrientation: 'landscape',
				content: [
					{
						style: 'header',

						table: {
							widths: ['*', 100],

							body: [
								[
									{
										text: i18nFilter('_label_lists_recheck_header_'),
										alignment: 'center',
										border: [false, false, false, false]
									},
									{
										text: $filter('date')(vm.date, 'shortDate'),
										border: [false, false, false, false]
									}
								]
							]
						}
					},
					{
						table: {
							widths: ['50%', '50%'],

							body: [
								[
									{
										text: ' ',
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										text: vm.herdName,
										alignment: 'right',
										border: [false, false, false, true]
									}
								]
							]
						}
					},
					{
						table: {
							headerRows: 1,
							keepWithHeaderRows: true,
							widths: ['*', '*', '*', '*', '*', '*', '*'],

							body: [
								[
									{
										style: 'tableHeader',
										text: i18nFilter('_label_date_'),
										alignment: 'left',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_label_event_'),
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_label_limb_'),
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_invoice_label_lesion_'),
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_animal_severity_'),
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_animal_details_hoof_treatment_type_recheck_'),
										alignment: 'center',
										border: [false, false, false, true]
									},
									{
										style: 'tableHeader',
										text: i18nFilter('_label_recheck_date_'),
										alignment: 'center',
										border: [false, false, false, true]
									}
								]
							]
						}
					}
				],
				styles: {
					header: {
						fontSize: 17,
						bold: true
					},
					headerSm: {
						fontSize: 15,
						bold: true
					},
					tableHeader: {
						bold: true
					}
				},
				defaultStyle: {
					fontSize: 10
				}
			};

			for (var i = 0; i < vm.hoofTrimData.length; i++) {
				var obj = [
					{
						text:
							(vm.hoofTrimData[i].AnimalNumber ? vm.hoofTrimData[i].AnimalNumber : '') +
							(vm.hoofTrimData[i].AnimalNumber && vm.hoofTrimData[i].AnimalEarTag ? ' - ' : '') +
							(vm.hoofTrimData[i].AnimalEarTag ? vm.hoofTrimData[i].AnimalEarTag : '') +
							(!vm.hoofTrimData[i].AnimalNumber && !vm.hoofTrimData[i].AnimalEarTag ? vm.hoofTrimData[i].AnimalName : ''),
						alignment: 'left',
						colSpan: 7,
						border: [false, true, false, false]
					},
					{},
					{},
					{},
					{},
					{},
					{}
				];

				dd.content[2].table.body.push(obj);
				for (var j = 0; j < vm.hoofTrimData[i].Lesions.length; j++) {
					var obj2 = [
						{
							text: $filter('date')(vm.hoofTrimData[i].Lesions[j].VisitDate, 'mediumDate'),
							alignment: 'left',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].ReasonString,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].PositionString,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].LesionString,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].SeverityString,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].RecheckString,
							alignment: 'center',
							border: [false, false, false, false]
						},
						{
							text: vm.hoofTrimData[i].Lesions[j].RecheckDate,
							alignment: 'center',
							border: [false, false, false, false]
						}
					];
					dd.content[2].table.body.push(obj2);
				}
			}

			var name = vm.herdName + ' ' + i18nFilter('_page_title_recheck_list') + '.pdf';
			name = name.replace(/ /g, '_');
			pdfMake.createPdf(dd).download(name);
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		$scope.$on('default_herd_selected', function (event, data) {
			init();
		});
		$scope.$on('default_team_selected', function (event, data) {
			init();
		});
	}
})();

(function () {
  "use strict";
  angular
    .module("My.pages.lists.trimList")
    .controller("trimListCtrl", trimListCtrl);
  /** @ngInject */
  function trimListCtrl(
    listsService,
    $scope,
    $timeout,
    $filter,
    listsDataService,
    $q,
    $uibModal,
    $uibModalStack,
    appService,
    xlsxService,
    $locale
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var herdInfo;
    var hoofTrimDates;
    var timePeriodUnitTimeout;
    vm.init = init;
    vm.dateSelected = dateSelected;
    vm.exportToPdf = exportToPdf;
    vm.changeHoofTrimPeriod = changeHoofTrimPeriod;
    vm.dateChanged = dateChanged;
    vm.openRangeSelector = openRangeSelector;
    vm.closeModal = closeModal;
    vm.setDateRange = setDateRange;
    vm.getCsvData = getCsvData;
    vm.openExportModal = openExportModal;
    vm.exportData = exportData;
    vm.deleteVisit = deleteVisit;
    vm.openDeleteModal = openDeleteModal;
    vm.getCsvHeader = getCsvHeader;
    vm.showSystemic = true;
    vm.dpOptions = {
      customClass: getDayClass,
    };
    init();
    setStrings();

    function init() {
      vm.tooltipText = i18nFilter("_label_export_pdf_");
      //vm.tooltipTextCsv = i18nFilter("_button_export_") + " .csv";
      vm.tooltipTextCsv = i18nFilter("_button_export_") + " .csv/.xls";
      vm.loading = true;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.selectedTeam = vm.defaultValues.team_id;
      vm.timePeriodUnit = "toggle_off";
      vm.hoofTrimByDate = true;
      vm.selectedFormat = 1;
      vm.selectedVersion = 1;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        getData(vm.selectedHerds[0]);
      }
    }

    function setStrings() {
      vm.Yes = i18nFilter("_label_yes_");
      vm.No = i18nFilter("_label_no_");

      vm.AntibioticTreatment = i18nFilter(
        "_animal_details_hoof_treatment_type_antibiotic_treatment_"
      );
      vm.Conventional = i18nFilter(
        "_animal_details_hoof_treatment_type_conventional_"
      );
      vm.Block = i18nFilter("_animal_details_hoof_treatment_type_block_");
      vm.Wrap = i18nFilter("_animal_details_hoof_treatment_type_wrap_");
    }

    function getData(herd_id) {
      herdInfo = $q.defer();
      hoofTrimDates = $q.defer();
      vm.errorLoading = false;

      $q.all([hoofTrimDates.promise, herdInfo.promise])
        .then(function () {
          vm.fileName =
            vm.herdName + " " + i18nFilter("_page_title_trim_list") + ".csv";
          vm.loading = false;
          vm.loadingHoofTrims = false;
          $timeout(function () {
            createGraph();
          }, 150);
        })
        .catch(function (error) {
          vm.loading = false;
          vm.loadingHoofTrims = false;
          vm.errorLoading = true;
        });

      getVisitDates(herd_id, true);
      getHerdInfo(herd_id);
    }

    function getVisitDates(herd_id, init) {
      vm.errorLoading = false;
      return listsService
        .getVisitDates(herd_id)
        .then(function (response) {
          if (response) {
            if (response.length == 0) {
              vm.noVisitDates = true;
              vm.loading = false;
            } else {
              vm.noVisitDates = false;

              for (var i = 0; i < response.length; i++) {
                response[i].date = $filter("date")(
                  new Date(response[i].VisitDate),
                  "mediumDate"
                );
              }
              vm.visitDates = response;
              setStartEndDate(response);
              vm.selectedDate = vm.visitDates[0];
              vm.selectedDateObject = new Date(vm.visitDates[0].VisitDate);
              vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
              getHoofTrimsByDate(herd_id, vm.selectedDate.VisitDate, init);
            }
          } else {
            vm.noVisitDates = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          console.log(error);
        });
    }

    function setStartEndDate(dates) {
      var lastDate = dates[0].VisitDate;
      var month = moment(lastDate).month();
      var year = moment(lastDate).year();
      var startDate = moment()
        .date(1)
        .year(year)
        .month(month)
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      var endDate = moment(startDate)
        .endOf("month")
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      vm.startDate = new Date(startDate);
      vm.endDate = new Date(endDate);
    }

    function getHerdInfo(herdId) {
      return listsService
        .getHerdInfo(herdId)
        .then(function (response) {
          vm.herdName = response.Name;
          herdInfo.resolve();
        })
        .catch(function (error) {
          console.log(error);
          herdInfo.reject(error);
        });
    }

    function getHoofTrimsByDate(herd_id, date, init) {
      if (vm.chart) {
        vm.chart.destroy();
      }
      vm.loadingHoofTrims = true;
      return listsService
        .getHoofTrims(herd_id, date)
        .then(function (response) {
          if (!response) {
            response = [];
          }
          vm.rawData = angular.copy(response);
          response = setData(response);
          vm.hoofTrimData = response[0];
          vm.hoofTrimSummary = response[1];
          if (init) {
            hoofTrimDates.resolve();
          } else {
            $timeout(function () {
              createGraph();
            }, 150);
          }
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
          if (init) {
            hoofTrimDates.reject();
          }
          console.log(error);
        });
    }

    function getHoofTrimsByPeriod(herdId) {
      if (vm.chart) {
        vm.chart.destroy();
      }
      vm.loadingHoofTrims = true;
      var startDate = moment(vm.startDate).format("YYYY-MM-DDT00:00:00");
      var endDate = moment(vm.endDate).format("YYYY-MM-DDT23:59:59");
      var suffix = "?VisitDate=>=" + startDate + "&VisitDate=<=" + endDate;
      return listsService
        .getHoofTrimsByPeriod(herdId, suffix)
        .then(function (response) {
          vm.rawData = angular.copy(response);
          if (response && response.length) {
            response = setData(response);
            vm.hoofTrimSummary = response[1];
            var hoofTrimData = response[0];
          } else {
            var hoofTrimData = [];
          }

          /*var byAnimal = appService.groupBy(hoofTrimData, "AnimalId");
          hoofTrimData = setByAnimalData(byAnimal);*/
          vm.hoofTrimData = hoofTrimData;
          vm.loading = false;
          vm.loadingHoofTrims = false;
          $timeout(function () {
            createGraph();
          }, 150);
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
        });
    }

    function setData(trim_list) {
      var data = {
        trim: 0,
        trim_rear: 0,
        lame: 0,
        recheck: 0,
        wrap: 0,
        block: 0,
        total: 0,
        lesions: {
          n_lesions: 0,
          u_lesions: 0,
          abcess: {
            n_lesions: 0,
            lesion: i18nFilter("_animal_details_hoof_lesion_type_abcess_"),
          },
          other: {
            n_lesions: 0,
            lesion: i18nFilter("_animal_details_disease_other_"),
          },
          dd: {
            n_lesions: 0,
            lesion: i18nFilter(
              "_animal_details_hoof_lesion_type_digital_dermatitis_"
            ),
          },
          soleFracture: {
            n_lesions: 0,
            lesion: i18nFilter(
              "_animal_details_hoof_lesion_type_sole_fracture_"
            ),
          },
          toeUlcer: {
            n_lesions: 0,
            lesion: i18nFilter("_animal_details_hoof_lesion_type_toe_ulcer_"),
          },
          ulcer: {
            n_lesions: 0,
            lesion: i18nFilter("_animal_details_hoof_lesion_type_ulcer_"),
          },
          thinSoles: {
            n_lesions: 0,
            lesion: i18nFilter("_animal_details_hoof_lesion_type_thin_soles_"),
          },
        },
      };
      for (var i = 0; i < trim_list.length; i++) {
        trim_list[i].ReasonString = listsDataService.getReasonString(
          trim_list[i].Reason
        );
        var reasonType = getReasonType(trim_list[i].Reason);
        if (reasonType) {
          data.total++;
          data[reasonType]++;
        }

        if (trim_list[i].Limbs) {
          for (var j = 0; j < trim_list[i].Limbs.length; j++) {
            if ((trim_list[i].Limbs[j].ActionType & 2) == 2) {
              data.wrap++;
            }
            if ((trim_list[i].Limbs[j].ActionType & 1) == 1) {
              data.block++;
            }

            trim_list[i].Limbs[j].ReasonString = trim_list[i].ReasonString;
            trim_list[i].Limbs[j].PositionString =
              listsDataService.setPositionString(trim_list[i].Limbs[j].Position);
            trim_list[i].Limbs[j].Therapeutic = getTherapeutic(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Topical = getTopical(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].AntibioticTreatment = getAntibioticTreatment(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Treatments = getTreatments(
              trim_list[i].Limbs[j].TreatmentType,
              trim_list[i].Limbs[j].ActionType
            );
            trim_list[i].Limbs[j].RecheckString = listsDataService.getRecheckString(
              trim_list[i].Limbs[j].ReCheck
            );
            trim_list[i].Limbs[j].RecheckDate = listsDataService.getRecheckDate(
              trim_list[i].Limbs[j].ReCheck,
              trim_list[i].VisitDate,
              "mediumDate"
            );
            trim_list[i].Limbs[j].RecheckDateObj = listsDataService.getRecheckDate(
              trim_list[i].Limbs[j].ReCheck,
              trim_list[i].VisitDate
            );
            if (trim_list[i].Limbs[j].Lesions) {
              for (var k = 0; k < trim_list[i].Limbs[j].Lesions.length; k++) {
                trim_list[i].Limbs[j].Lesions[k].LesionString =
                  listsDataService.setLesionString(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].LesionStringShort =
                  listsDataService.setLesionStringShort(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].SeverityString =
                  listsDataService.setSeverityString(
                    trim_list[i].Limbs[j].Lesions[k].Severity
                  );
                var lesionType = getLesionType(
                  trim_list[i].Limbs[j].Lesions[k]
                );
                if (lesionType) {
                  data.lesions.n_lesions++;
                  data.lesions[lesionType]
                    ? data.lesions[lesionType].n_lesions++
                    : null;
                }
              }
            }
          }
          trim_list[i].Limbs = mergeLimbsIfOk(
            trim_list[i].Limbs,
            trim_list[i].ReasonString
          );
        }
      }

      if (data.lesions.abcess.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.other.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.dd.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.soleFracture.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.toeUlcer.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.ulcer.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.thinSoles.n_lesions) {
        data.lesions.u_lesions++;
      }
      if (data.lesions.u_lesions < 4) {
        data.lesions.h = { height: (4 - data.lesions.u_lesions) * 36 + "px" };
      }
      if (data.lesions.u_lesions > 4) {
        data.lesions.h2 = { height: (data.lesions.u_lesions - 4) * 36 + "px" };
      }

      return [trim_list, data];
    }

    function getLesionType(lesion) {
      var l;
      if (lesion.LesionType == 1) {
        l = "abcess";
      } else if (lesion.LesionType == 2) {
        l = "other";
      } else if (lesion.LesionType == 3) {
        l = "other";
      } else if (lesion.LesionType == 4) {
        l = "dd";
      } else if (lesion.LesionType == 5) {
        l = "other";
      } else if (lesion.LesionType == 6) {
        l = "other";
      } else if (lesion.LesionType == 7) {
        l = "other";
      } else if (lesion.LesionType == 8) {
        l = "other";
      } else if (lesion.LesionType == 9) {
        l = "other";
      } else if (lesion.LesionType == 10) {
        l = "other";
      } else if (lesion.LesionType == 11) {
        l = "soleFracture";
      } else if (lesion.LesionType == 12) {
        l = "toeUlcer";
      } else if (lesion.LesionType == 13) {
        l = "ulcer";
      } else if (lesion.LesionType == 14) {
        l = "other";
      } else if (lesion.LesionType == 15) {
        l = "other";
      } else if (lesion.LesionType == 16) {
        l = "other";
      } else if (lesion.LesionType == 17) {
        l = "other";
      } else if (lesion.LesionType == 18) {
        l = "thinSoles";
      } else if (lesion.LesionType == 19) {
        l = "other";
      }

      return l;
    }

    function getReasonType(en_type) {
      var reason;
      if (en_type === 0) {
        reason = "trim";
      } else if (en_type == 1) {
        reason = "lame";
      } else if (en_type == 2) {
        reason = "recheck";
      } else if (en_type == 3) {
        reason = "trim";
      } else if (en_type == 4) {
        reason = "trim_rear";
      }
      return reason;
    }

    function createGraph() {
      var data = {
        labels: [],
        datasets: [
          {
            label: i18nFilter("_invoice_label_number_of_lesions_"),
            data: [],

            borderWidth: 1,
          },
        ],
      };

      if (
        vm.hoofTrimSummary.lesions.abcess &&
        vm.hoofTrimSummary.lesions.abcess.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_abcess_") +
            " [" +
            vm.hoofTrimSummary.lesions.abcess.n_lesions +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimSummary.lesions.abcess.n_lesions);
      }
      if (
        vm.hoofTrimSummary.lesions.dd &&
        vm.hoofTrimSummary.lesions.dd.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_digital_dermatitis_") +
            " [" +
            vm.hoofTrimSummary.lesions.dd.n_lesions +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimSummary.lesions.dd.n_lesions);
      }
      if (
        vm.hoofTrimSummary.lesions.toeUlcer &&
        vm.hoofTrimSummary.lesions.toeUlcer.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_toe_ulcer_") +
            " [" +
            vm.hoofTrimSummary.lesions.toeUlcer.n_lesions +
            "]"
        );
        data.datasets[0].data.push(
          vm.hoofTrimSummary.lesions.toeUlcer.n_lesions
        );
      }
      if (
        vm.hoofTrimSummary.lesions.ulcer &&
        vm.hoofTrimSummary.lesions.ulcer.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_ulcer_") +
            " [" +
            vm.hoofTrimSummary.lesions.ulcer.n_lesions +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimSummary.lesions.ulcer.n_lesions);
      }
      if (
        vm.hoofTrimSummary.lesions.soleFracture &&
        vm.hoofTrimSummary.lesions.soleFracture.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_sole_fracture_") +
            " [" +
            vm.hoofTrimSummary.lesions.soleFracture.n_lesions +
            "]"
        );
        data.datasets[0].data.push(
          vm.hoofTrimSummary.lesions.soleFracture.n_lesions
        );
      }
      if (
        vm.hoofTrimSummary.lesions.thinSoles &&
        vm.hoofTrimSummary.lesions.thinSoles.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_hoof_lesion_type_thin_soles_") +
            " [" +
            vm.hoofTrimSummary.lesions.thinSoles.n_lesions +
            "]"
        );
        data.datasets[0].data.push(
          vm.hoofTrimSummary.lesions.thinSoles.n_lesions
        );
      }
      if (
        vm.hoofTrimSummary.lesions.other &&
        vm.hoofTrimSummary.lesions.other.n_lesions
      ) {
        data.labels.push(
          i18nFilter("_animal_details_disease_other_") +
            " [" +
            vm.hoofTrimSummary.lesions.other.n_lesions +
            "]"
        );
        data.datasets[0].data.push(vm.hoofTrimSummary.lesions.other.n_lesions);
      }
      var options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: i18nFilter("_invoice_label_number_of_lesions_"),
              },
              gridLines: {
                display: true,
              },
              ticks: {
                stepSize: 2,
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: i18nFilter("_invoice_label_lesion_"),
              },
              ticks: {
                autoSkip: false,
                maxRotation: 45,
                minRotation: 45,
              },
            },
          ],
        },
      };
    }

    function mergeLimbsIfOk(trim_list, reason) {
      var allLimbsPresent = checkAllLimbs(trim_list);
      if (allLimbsPresent) {
        var limbs = [
          {
            ReasonString: reason,
            PositionString: i18nFilter("_label_all_"),
            Lesions: [
              {
                LesionString: i18nFilter("_label_all_feet_ok_"),
                SeverityString: "",
              },
            ],
            Treatments: [],
            Therapeutic: vm.No,
            Topical: vm.No,
            AllOk: true,
          },
        ];
        trim_list = limbs;
      }

      return trim_list;
    }

    function checkAllLimbs(limbs) {
      var limb1 = false;
      var limb2 = false;
      var limb3 = false;
      var limb4 = false;
      var lesionsList = [];
      var lesions = false;
      var tt = true;
      var rc = true;
      var aa = true;
      var len;
      if (limbs && limbs.length == 4) {
        len = true;
      }
      if (limbs) {
        for (var i = 0; i < limbs.length; i++) {
          lesionsList = lesionsList.concat(limbs[i].Lesions);
          if (limbs[i].Position === 0) {
            limb1 = true;
          }
          if (limbs[i].Position === 1) {
            limb2 = true;
          }
          if (limbs[i].Position === 2) {
            limb3 = true;
          }
          if (limbs[i].Position === 3) {
            limb4 = true;
          }
          if (limbs[i].TreatmentType != 0) {
            tt = false;
          }
          if (limbs[i].ReCheck != 0) {
            rc = false;
          }
          if (limbs[i].ActionType != 0) {
            aa = false;
          }
        }
      }

      if (lesionsList && lesionsList.length == 0) {
        lesions = true;
      }
      return (
        limb1 && limb2 && limb3 && limb4 && lesions && len && tt && rc && aa
      );
    }

    function setByAnimalData(trim_list) {
      var list = [];
      angular.forEach(trim_list, function (value, key) {
        var obj = {};
        value = $filter("orderBy")(value, "VisitDate", true);
        if (value) {
          for (var i = 0; i < value.length; i++) {
            if (i == 0) {
              obj.AnimalEarTag = value[i].AnimalEarTag;
              obj.AnimalName = value[i].AnimalName;
              obj.AnimalNumber = value[i].AnimalNumber;
              obj.Limbs = value[i].Limbs;
              obj.VisitDate = value[i].VisitDate;
            } else {
              obj.Limbs = obj.Limbs.concat(value[i].Limbs);
            }
          }
        }

        list.push(obj);
      });

      return $filter("orderBy")(list, ["AnimalNumber", "AnimalEarTag"]);
    }

    function dateSelected() {
      if (vm.selectedDate.VisitDate != vm.lastHoofTrimDate) {
        vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
        getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
      }
    }

    function dateChanged() {
      if (vm.selectedDateObject) {
        var dateFound = false;
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if (
              $filter("date")(vm.selectedDateObject, "mediumDate") ==
              vm.visitDates[i].date
            ) {
              vm.selectedDate = vm.visitDates[i];
              dateSelected();
              dateFound = true;
              break;
            }
          }
        }

        if (dateFound) {
          vm.dateError = false;
        } else {
          vm.dateError = true;
        }
      } else {
        vm.dateError = true;
      }
    }

    function getTherapeutic(type) {
      var therapeutic = vm.No;
      if ((type & 1) == 1) {
        therapeutic = vm.Yes;
      }
      return therapeutic;
    }

    function getTopical(type) {
      var topical = vm.No;
      if ((type & 2) == 2) {
        topical = vm.Yes;
      }
      return topical;
    }

    function getAntibioticTreatment(type) {
      var antibioticTreatment = vm.No;
      if ((type & 4096) == 4096) {
        antibioticTreatment = vm.Yes;
      }
      return antibioticTreatment;
    }

    function getTreatments(type, action) {
      var treatments = [];
      if ((type & 4096) == 4096) {
        treatments.push(vm.AntibioticTreatment);
      }
      if ((type & 8192) == 8192) {
        treatments.push(vm.Conventional);
      }

      if (action != 0) {
        if ((action & 1) == 1) {
          treatments.push(vm.Block);
        }
        if ((action & 2) == 2) {
          treatments.push(vm.Wrap);
        }
      }

      return treatments;
    }

    function changeHoofTrimPeriod() {
      vm.hoofTrimByDate = !vm.hoofTrimByDate;
      if (vm.hoofTrimByDate) {
        vm.timePeriodUnit = "toggle_off";
      } else {
        vm.timePeriodUnit = "toggle_on";
      }

      if (timePeriodUnitTimeout) {
        $timeout.cancel(timePeriodUnitTimeout);
      }

      timePeriodUnitTimeout = $timeout(function () {
        if (vm.hoofTrimByDate) {
          getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate, false);
        } else {
          getHoofTrimsByPeriod(vm.selectedHerds[0]);
        }
      }, 500);
    }

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode == "day") {
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if ($filter("date")(date, "mediumDate") == vm.visitDates[i].date) {
              return "datepicker-highlight";
            }
          }
        }
      }
    }

    function openRangeSelector() {
      if (!vm.loadingHoofTrims) {
        vm.modal_start_date = angular.copy(vm.startDate);
        vm.modal_end_date = angular.copy(vm.endDate);
        openModal("app/pages/lists/common/dateRange.modal.html", "sm");
      }
    }

    function setDateRange() {
      var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
      if (!range_error) {
        vm.startDate = angular.copy(vm.modal_start_date);
        vm.endDate = angular.copy(vm.modal_end_date);

        getHoofTrimsByPeriod(vm.selectedHerds[0]);
        closeModal();
      }
    }

    function checkRangeError(start_date, end_date) {
      var error = false;
      if (moment(end_date).isBefore(start_date)) {
        error = true;
      }
      return error;
    }

    function openDeleteModal() {
      if (vm.selectedDate && vm.selectedDate.HerdVisitId) {
        vm.deleteVisitId = vm.selectedDate.HerdVisitId;
        vm.deleteVisitDate = vm.selectedDate.VisitDate;
        vm.modalLoading = false;
        openModal("app/pages/lists/common/delete.modal.html", "sm");
      }
    }

    function openExportModal() {
      if (vm.hoofTrimData && vm.hoofTrimData.length) {
        openModal("app/pages/lists/common/export.modal.html", "sm");
      }
    }

    function deleteVisit() {
      vm.modalLoading = true;
      return listsService
        .removeHoofTrimById(vm.deleteVisitId)
        .then(function (response) {
          init();
          closeModal();
        })
        .catch(function (error) {
          vm.deleteError = error;
          vm.modalLoading = false;
          console.log(error);
        });
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function exportToPdf() {
      var dd = {
        pageMargins: [25, 30, 25, 30],
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          {
            style: "header",

            table: {
              widths: ["*", 100],

              body: [
                [
                  {
                    text: i18nFilter("_label_lists_trim_header_"),
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: vm.hoofTrimByDate
                      ? $filter("date")(vm.selectedDate.VisitDate, "shortDate")
                      : $filter("date")(vm.startDate, "shortDate") +
                        " - " +
                        $filter("date")(vm.endDate, "shortDate"),
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: ["50%", "50%"],

              body: [
                [
                  {
                    text: " ",
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    text: vm.herdName,
                    alignment: "right",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },

          {
            style: "headerSm",

            table: {
              widths: ["*", "*"],

              body: [
                [
                  {
                    text: i18nFilter("_trim_list_label_trimming_summary_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    text: i18nFilter("_invoice_label_lesion_summary_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },

          {
            table: {
              widths: ["25%", "25%", "25%", "25%"],

              body: [
                [
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_type_"),
                    alignment: "left",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_n_cows_"),
                    alignment: "center",
                    border: [false, false, true, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_lesion_"),
                    alignment: "left",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_count_"),
                    alignment: "center",
                    border: [false, false, true, true],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: [
                "8%",
                "7%",
                "15%",
                "15%",
                "10%",
                "10%",
                "15%",
                "10%",
                "10%",
              ],

              body: [
                [
                  {
                    style: "tableHeader",
                    text: i18nFilter("_label_event_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_label_limb_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_lesion_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_animal_severity_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter(
                      "_animal_details_hoof_treatment_type_therapeutic_trim_"
                    ),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter(
                      "_animal_details_hoof_treatment_type_topical_"
                    ),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_animal_treatment_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter(
                      "_animal_details_hoof_treatment_type_recheck_"
                    ),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_label_recheck_date_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 17,
            bold: true,
          },
          headerSm: {
            fontSize: 15,
            bold: true,
          },
          tableHeader: {
            bold: true,
          },
        },
        defaultStyle: {
          fontSize: 10,
        },
      };

      var obj = [
        {
          text: i18nFilter("_animal_details_visit_reason_trim_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.trim ? vm.hoofTrimSummary.trim : 0,
          alignment: "center",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter("_animal_details_hoof_lesion_type_ulcer_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.ulcer.n_lesions
            ? vm.hoofTrimSummary.lesions.ulcer.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_animal_details_visit_reason_trim_rear_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.trim_rear ? vm.hoofTrimSummary.trim_rear : 0,
          alignment: "center",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter("_animal_details_hoof_lesion_type_abcess_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.abcess.n_lesions
            ? vm.hoofTrimSummary.lesions.abcess.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_animal_details_visit_reason_lame_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lame ? vm.hoofTrimSummary.lame : 0,
          alignment: "center",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter("_animal_details_hoof_lesion_type_toe_ulcer_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.toeUlcer.n_lesions
            ? vm.hoofTrimSummary.lesions.toeUlcer.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_animal_details_visit_reason_recheck_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.recheck ? vm.hoofTrimSummary.recheck : 0,
          alignment: "center",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter("_animal_details_hoof_lesion_type_sole_fracture_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.soleFracture.n_lesions
            ? vm.hoofTrimSummary.lesions.soleFracture.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_invoice_label_total_cows_"),
          style: "tableHeader",
          alignment: "center",
          border: [false, false, false, true],
        },
        {
          text: vm.hoofTrimSummary.total ? vm.hoofTrimSummary.total : "",
          alignment: "center",
          style: "tableHeader",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter(
            "_animal_details_hoof_lesion_type_digital_dermatitis_"
          ),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.dd.n_lesions
            ? vm.hoofTrimSummary.lesions.dd.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          style: "tableHeader",
          text: i18nFilter("_invoice_label_action_"),
          alignment: "left",
          border: [false, false, false, true],
        },
        {
          style: "tableHeader",
          text: i18nFilter("_invoice_label_count_"),
          alignment: "center",
          border: [false, true, true, false],
        },

        {
          text: i18nFilter("_animal_details_hoof_lesion_type_thin_soles_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.thinSoles.n_lesions
            ? vm.hoofTrimSummary.lesions.thinSoles.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_animal_details_hoof_treatment_type_block_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.block ? vm.hoofTrimSummary.block : 0,
          alignment: "center",
          border: [false, true, true, false],
        },

        {
          text: i18nFilter("_animal_details_disease_other_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.other.n_lesions
            ? vm.hoofTrimSummary.lesions.other.n_lesions
            : 0,
          alignment: "center",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: i18nFilter("_animal_details_hoof_treatment_type_wrap_"),
          alignment: "left",
          border: [false, false, false, false],
        },
        {
          text: vm.hoofTrimSummary.wrap ? vm.hoofTrimSummary.wrap : 0,
          alignment: "center",
          border: [false, false, true, false],
        },

        {
          text: i18nFilter("_animal_details_total_"),
          style: "tableHeader",
          alignment: "center",
          border: [false, true, false, false],
        },
        {
          text: vm.hoofTrimSummary.lesions.n_lesions
            ? vm.hoofTrimSummary.lesions.n_lesions
            : 0,
          style: "tableHeader",
          alignment: "center",
          border: [false, true, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);

      var obj = [
        {
          text: "",
          border: [false, false, false, false],
        },
        {
          text: "",
          border: [false, false, false, false],
        },

        {
          text: "",
          border: [false, false, false, false],
        },
        {
          text: "",
          border: [false, false, false, false],
        },
      ];

      dd.content[3].table.body.push(obj);
      dd.content[3].table.body.push(obj);

      if (!vm.hoofTrimByDate) {
        dd.content[0].table.widths[1] = 200;
      }

      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var obj = [
          {
            text:
              (vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : "") +
              (vm.hoofTrimData[i].AnimalNumber &&
              vm.hoofTrimData[i].AnimalEarTag
                ? " - "
                : "") +
              (vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "") +
              (!vm.hoofTrimData[i].AnimalNumber &&
              !vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalName
                : ""),
            alignment: "left",
            colSpan: 9,
            border: [false, true, false, false],
          },
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
        ];

        dd.content[4].table.body.push(obj);
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var obj2 = [
            {
              text: vm.hoofTrimData[i].Limbs[j].ReasonString
                ? vm.hoofTrimData[i].Limbs[j].ReasonString
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].PositionString
                ? vm.hoofTrimData[i].Limbs[j].PositionString
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              table: {
                widths: ["100%"],
                body: [],
              },
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              table: {
                widths: ["100%"],
                body: [],
              },
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].Therapeutic
                ? vm.hoofTrimData[i].Limbs[j].Therapeutic
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].Topical
                ? vm.hoofTrimData[i].Limbs[j].Topical
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              table: {
                widths: ["100%"],
                body: [],
              },
              alignment: "center",

              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].RecheckString
                ? vm.hoofTrimData[i].Limbs[j].RecheckString
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].RecheckDate
                ? vm.hoofTrimData[i].Limbs[j].RecheckDate
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          if (vm.hoofTrimData[i].Limbs[j].Lesions.length > 1) {
            for (
              var l = 0;
              l < vm.hoofTrimData[i].Limbs[j].Lesions.length;
              l++
            ) {
              var lesions = [
                {
                  text: vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    ? vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    : "",
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ];
              var severity = [
                {
                  text: vm.hoofTrimData[i].Limbs[j].Lesions[l].SeverityString
                    ? vm.hoofTrimData[i].Limbs[j].Lesions[l].SeverityString
                    : "",
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ];
              obj2[2].table.body.push(lesions);
              obj2[3].table.body.push(severity);
            }
          } else {
            obj2[2] = {
              text:
                vm.hoofTrimData[i].Limbs[j].Lesions.length == 1
                  ? vm.hoofTrimData[i].Limbs[j].Lesions[0].LesionString
                  : "",
              alignment: "center",
              border: [false, false, false, false],
            };
            obj2[3] = {
              text:
                vm.hoofTrimData[i].Limbs[j].Lesions.length == 1
                  ? vm.hoofTrimData[i].Limbs[j].Lesions[0].SeverityString
                  : "",
              alignment: "center",
              border: [false, false, false, false],
            };
          }

          if (vm.hoofTrimData[i].Limbs[j].Treatments.length > 1) {
            for (
              var l = 0;
              l < vm.hoofTrimData[i].Limbs[j].Treatments.length;
              l++
            ) {
              var treatment = [
                {
                  text: vm.hoofTrimData[i].Limbs[j].Treatments[l]
                    ? vm.hoofTrimData[i].Limbs[j].Treatments[l]
                    : "",
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ];
              obj2[6].table.body.push(treatment);
            }
          } else {
            obj2[6] = {
              text:
                vm.hoofTrimData[i].Limbs[j].Treatments.length == 1
                  ? vm.hoofTrimData[i].Limbs[j].Treatments[0]
                  : "",
              alignment: "center",
              border: [false, false, false, false],
            };
          }

          dd.content[4].table.body.push(obj2);
        }
      }

      var name =
        vm.herdName + " " + i18nFilter("_page_title_trim_list") + ".pdf";
      name = name.replace(/ /g, "_");

      pdfMake.createPdf(dd).download(name);
    }

    function exportData() {
      if (vm.selectedFormat == 1) {
        var elem = document.getElementById("export-csv-button");

        $timeout(function () {
          elem.click();
        }, 10);
      } else {
        exportToExcel(vm.selectedVersion);
      }

      $timeout(function () {
        closeModal();
      }, 200);
    }

    function exportToExcel(version) {
      var list = generateExportList(version, vm.hoofTrimData);
      var file_name = vm.herdName + ".xlsx";
      var date_format = xlsxService.getShortDateFormat($locale);
      var ws = XLSX.utils.aoa_to_sheet(list, {
        cellDates: true,
        dateNF: date_format,
      });
      if (version == 1) {
        ws["!cols"] = [{ wch: 15 }, { wch: 10 }, { wch: 10 }, { wch: 15 }];
      } else if (version == 2) {
        ws["!cols"] = [
          { wch: 15 },
          { wch: 10 },
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
        ];
      } else if (version == 3) {
        ws["!cols"] = [
          { wch: 15 },
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 15 },
        ];
      }
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, i18nFilter("_page_title_trim_list"));
      XLSX.writeFile(wb, file_name);
    }


    function generateExportList(version, data) {
      var l = [];
      if (version == 1) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      } else if (version == 2) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      } else if (version == 3) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      }
      data.forEach(function (event) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < event.Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            event.Limbs[j].ReCheck,
            event.VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (version == 1) {
          var ll = [];
          ll.push(
            event.AnimalNumber
              ? event.AnimalNumber
              : event.AnimalEarTag
              ? event.AnimalEarTag
              : ""
          );

          ll.push(listsDataService.getReasonString(event.Reason));
          ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
          ll.push(recheckDate ? new Date(recheckDate) : "");
          l.push(ll);
        } else if (version == 2){
          event.Limbs.forEach(function (limb) {
            var ll = [];
            ll.push(
              event.AnimalNumber
                ? event.AnimalNumber
                : event.AnimalEarTag
                ? event.AnimalEarTag
                : ""
            );
            ll.push(listsDataService.getReasonString(event.Reason));
            ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
            ll.push(limb.PositionString);
            ll.push(getLesionsShortList(limb.Lesions));
            ll.push(
              limb.AntibioticTreatment == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(
              limb.Topical == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(limb.RecheckDateObj ? limb.RecheckDateObj : "");
            l.push(ll);
          });
        } else if (version == 3){
          event.Limbs.forEach(function (limb) {
            var ll = [];
            ll.push(
              event.AnimalNumber
                ? event.AnimalNumber
                : event.AnimalEarTag
                ? event.AnimalEarTag
                : ""
            );
            ll.push(listsDataService.getReasonString(event.Reason));
            ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
            ll.push(
              limb.AntibioticTreatment == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(limb.RecheckDateObj ? limb.RecheckDateObj : "");
            l.push(ll);
          });
        }
      });

      return l;
    }

    function getLesionsShortList(lesions) {
      var list = "";
      var orderList = ["U", "A", "T", "F", "D"];
      lesions = orderLeasions(angular.copy(lesions), orderList);
      for (var i = 0; i < lesions.length; i++) {
        if (lesions.length == 1) {
          list += lesions[i].LesionStringShort
            ? lesions[i].LesionStringShort
            : "";
        } else {
          if (i != lesions.length - 1) {
            list += lesions[i].LesionStringShort + ", ";
          } else {
            list += lesions[i].LesionStringShort;
          }
        }
      }
      return list;
    }

    function orderLeasions(lesions, orderList) {
      var list = [];
      orderList.forEach(function (order) {
        var l = lesions.length - 1;
        for (var i = l; i >= 0; i--) {
          if (lesions[i].LesionStringShort == order) {
            list.push(lesions[i]);
            lesions.splice(i, 1);
          }
        }
      });
      return list.concat(lesions);
    }

    function getCsvData() {
      var list = [];
      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            vm.hoofTrimData[i].Limbs[j].ReCheck,
            vm.hoofTrimData[i].VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (vm.selectedVersion == 1) {
          var obj = {
            a: vm.hoofTrimData[i].AnimalNumber
              ? vm.hoofTrimData[i].AnimalNumber
              : vm.hoofTrimData[i].AnimalEarTag
              ? vm.hoofTrimData[i].AnimalEarTag
              : "",
            b: listsDataService.getReasonString(vm.hoofTrimData[i].Reason),
            c: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
            d: $filter("date")(recheckDate, "shortDate"),
          };
          list.push(obj);
        } else if (vm.selectedVersion == 2 ){
          for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
            var obj = {
              a: vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "",
              b: listsDataService.getReasonString(vm.hoofTrimData[i].Reason),
              c: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
              d: vm.hoofTrimData[i].Limbs[j].PositionString,
              e: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : getLesionsShortList(vm.hoofTrimData[i].Limbs[j].Lesions),
              f: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : vm.hoofTrimData[i].Limbs[j].AntibioticTreatment
                ? vm.hoofTrimData[i].Limbs[j].AntibioticTreatment ==
                  i18nFilter("_label_yes_")
                  ? vm.hoofTrimData[i].Limbs[j].AntibioticTreatment
                  : ""
                : "",
              g: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : vm.hoofTrimData[i].Limbs[j].Topical
                ? vm.hoofTrimData[i].Limbs[j].Topical ==
                  i18nFilter("_label_yes_")
                  ? vm.hoofTrimData[i].Limbs[j].Topical
                  : ""
                : "",
              h: $filter("date")(recheckDate, "shortDate"),
            };

            list.push(obj);
          }
        } else if (vm.selectedVersion == 3 ){
          for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
            var obj = {
              a: vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "",
              b: listsDataService.getReasonString(vm.hoofTrimData[i].Reason),
              c: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
              f: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : vm.hoofTrimData[i].Limbs[j].AntibioticTreatment
                ? vm.hoofTrimData[i].Limbs[j].AntibioticTreatment ==
                  i18nFilter("_label_yes_")
                  ? vm.hoofTrimData[i].Limbs[j].AntibioticTreatment
                  : ""
                : "",
              h: $filter("date")(recheckDate, "shortDate"),
            };

            list.push(obj);
          }
        }
      }
      return list;
    }

    function getCsvHeader() {
      if (vm.selectedVersion == 1) {
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
      } else if (vm.selectedVersion == 2 ){
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
      } else if (vm.selectedVersion == 3 ){
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_label_recheck_date_"),
        ];
      }
    }

    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.lists.wrapList")
    .controller("wrapListCtrl", wrapListCtrl);
  /** @ngInject */
  function wrapListCtrl(
    listsService,
    $scope,
    $timeout,
    $filter,
    listsDataService,
    $q,
    $uibModal,
    $uibModalStack,
    appService,
    xlsxService,
    $locale
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var herdInfo;
    var hoofTrimDates;
    var timePeriodUnitTimeout;
    vm.init = init;
    vm.dateSelected = dateSelected;
    vm.exportToPdf = exportToPdf;
    vm.changeHoofTrimPeriod = changeHoofTrimPeriod;
    vm.dateChanged = dateChanged;
    vm.openRangeSelector = openRangeSelector;
    vm.closeModal = closeModal;
    vm.setDateRange = setDateRange;
    vm.getCsvData = getCsvData;
    vm.openExportModal = openExportModal;
    vm.exportData = exportData;
    vm.deleteVisit = deleteVisit;
    vm.openDeleteModal = openDeleteModal;
    vm.getCsvHeader = getCsvHeader;
    vm.dpOptions = {
      customClass: getDayClass,
    };
    init();
    setStrings();

    function init() {
      vm.tooltipText = i18nFilter("_label_export_pdf_");
      vm.tooltipTextCsv = i18nFilter("_button_export_") + " .csv";
      //vm.tooltipTextCsv = i18nFilter('_button_export_') + ' .csv/.xls';
      vm.loading = true;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.selectedTeam = vm.defaultValues.team_id;
      vm.timePeriodUnit = "toggle_off";
      vm.hoofTrimByDate = true;
      vm.selectedFormat = 1;
      vm.selectedVersion = 1;
      if (vm.selectedHerds && vm.selectedHerds.length == 1) {
        getData(vm.selectedHerds[0]);
      }
    }

    function setStrings() {
      vm.Yes = i18nFilter("_label_yes_");
      vm.No = i18nFilter("_label_no_");

      vm.AntibioticTreatment = i18nFilter(
        "_animal_details_hoof_treatment_type_antibiotic_treatment_"
      );
      vm.Conventional = i18nFilter(
        "_animal_details_hoof_treatment_type_conventional_"
      );
      vm.Block = i18nFilter("_animal_details_hoof_treatment_type_block_");
      vm.Wrap = i18nFilter("_animal_details_hoof_treatment_type_wrap_");
    }

    function getData(herd_id) {
      herdInfo = $q.defer();
      hoofTrimDates = $q.defer();
      vm.errorLoading = false;

      $q.all([hoofTrimDates.promise, herdInfo.promise])
        .then(function () {
          vm.fileName =
            vm.herdName + " " + i18nFilter("_page_title_trim_list") + ".csv";
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.loadingHoofTrims = false;
          vm.errorLoading = true;
        });

      getVisitDates(herd_id, true);
      getHerdInfo(herd_id);
    }

    function getVisitDates(herd_id, init) {
      vm.errorLoading = false;
      return listsService
        .getVisitDates(herd_id)
        .then(function (response) {
          if (response) {
            if (response.length == 0) {
              vm.noVisitDates = true;
              vm.loading = false;
            } else {
              vm.noVisitDates = false;

              for (var i = 0; i < response.length; i++) {
                response[i].date = $filter("date")(
                  new Date(response[i].VisitDate),
                  "mediumDate"
                );
              }
              vm.visitDates = response;
              setStartEndDate(response);
              vm.selectedDate = vm.visitDates[0];
              vm.selectedDateObject = new Date(vm.visitDates[0].VisitDate);
              vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
              getHoofTrimsByDate(herd_id, vm.selectedDate.VisitDate, init);
            }
          } else {
            vm.noVisitDates = true;
            vm.loading = false;
          }
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          console.log(error);
        });
    }

    function setStartEndDate(dates) {
      var lastDate = dates[0].VisitDate;
      var month = moment(lastDate).month();
      var year = moment(lastDate).year();
      var startDate = moment()
        .date(1)
        .year(year)
        .month(month)
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      var endDate = moment(startDate)
        .endOf("month")
        .hour(12)
        .minutes(0)
        .seconds(0)
        .format();
      vm.startDate = new Date(startDate);
      vm.endDate = new Date(endDate);
    }

    function getHerdInfo(herdId) {
      return listsService
        .getHerdInfo(herdId)
        .then(function (response) {
          vm.herdName = response.Name;
          herdInfo.resolve();
        })
        .catch(function (error) {
          console.log(error);
          herdInfo.reject(error);
        });
    }

    function getHoofTrimsByDate(herd_id, date, init) {
      vm.loadingHoofTrims = true;
      return listsService
        .getHoofTrims(herd_id, date)
        .then(function (response) {
          response = filterOutWrapEvents(response);
          if (!response) {
            response = [];
          }
          vm.rawData = angular.copy(response);
          response = setData(response);
          vm.hoofTrimData = response;
          if (init) {
            hoofTrimDates.resolve();
          }
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
          if (init) {
            hoofTrimDates.reject();
          }
          console.log(error);
        });
    }

    function filterOutWrapEvents(events) {
      var list = [];

      for (var i = 0; i < events.length; i++) {
        var l = [];
        for (var j = 0; j < events[i].Limbs.length; j++) {
          if ((events[i].Limbs[j].ActionType & 2) == 2) {
            l.push(events[i].Limbs[j]);
          }
        }
        if (l.length) {
          events[i].Limbs = l;
          list.push(events[i]);
        }
      }

      return list;
    }

    function getHoofTrimsByPeriod(herdId) {
      vm.loadingHoofTrims = true;
      var startDate = moment(vm.startDate).format("YYYY-MM-DDT00:00:00");
      var endDate = moment(vm.endDate).format("YYYY-MM-DDT23:59:59");
      var suffix = "?VisitDate=>=" + startDate + "&VisitDate=<=" + endDate;
      return listsService
        .getHoofTrimsByPeriod(herdId, suffix)
        .then(function (response) {
          response = filterOutWrapEvents(response);
          vm.rawData = angular.copy(response);
          if (response && response.length) {
            response = setData(response);
          } else {
            response = [];
          }

          var byAnimal = appService.groupBy(response, "AnimalId");
          response = setByAnimalData(byAnimal);
          vm.hoofTrimData = response;
          vm.loading = false;
          vm.loadingHoofTrims = false;
        })
        .catch(function (error) {
          vm.loading = false;
          vm.errorLoading = true;
          vm.loadingHoofTrims = false;
        });
    }

    function setData(trim_list) {
      for (var i = 0; i < trim_list.length; i++) {
        trim_list[i].ReasonString = listsDataService.getReasonString(
          trim_list[i].Reason
        );
        if (trim_list[i].Limbs) {
          for (var j = 0; j < trim_list[i].Limbs.length; j++) {
            trim_list[i].Limbs[j].ReasonString = trim_list[i].ReasonString;
            trim_list[i].Limbs[j].PositionString =
              listsDataService.setPositionString(
                trim_list[i].Limbs[j].Position
              );
            trim_list[i].Limbs[j].Therapeutic = getTherapeutic(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Topical = getTopical(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].AntibioticTreatment = getAntibioticTreatment(
              trim_list[i].Limbs[j].TreatmentType
            );
            trim_list[i].Limbs[j].Treatments = getTreatments(
              trim_list[i].Limbs[j].TreatmentType,
              trim_list[i].Limbs[j].ActionType
            );
            trim_list[i].Limbs[j].RecheckString =
              listsDataService.getRecheckString(trim_list[i].Limbs[j].ReCheck);
            trim_list[i].Limbs[j].RecheckDate = listsDataService.getRecheckDate(
              trim_list[i].Limbs[j].ReCheck,
              trim_list[i].VisitDate,
              "mediumDate"
            );
            trim_list[i].Limbs[j].RecheckDateObj =
              listsDataService.getRecheckDate(
                trim_list[i].Limbs[j].ReCheck,
                trim_list[i].VisitDate
              );
            if (trim_list[i].Limbs[j].Lesions) {
              for (var k = 0; k < trim_list[i].Limbs[j].Lesions.length; k++) {
                trim_list[i].Limbs[j].Lesions[k].LesionString =
                  listsDataService.setLesionString(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].LesionStringShort =
                  listsDataService.setLesionStringShort(
                    trim_list[i].Limbs[j].Lesions[k].LesionType
                  );
                trim_list[i].Limbs[j].Lesions[k].SeverityString =
                  listsDataService.setSeverityString(
                    trim_list[i].Limbs[j].Lesions[k].Severity
                  );
              }
            }
          }
          trim_list[i].Limbs = mergeLimbsIfOk(
            trim_list[i].Limbs,
            trim_list[i].ReasonString
          );
        }
      }

      return trim_list;
    }

    function mergeLimbsIfOk(trim_list, reason) {
      var allLimbsPresent = checkAllLimbs(trim_list);
      if (allLimbsPresent) {
        var limbs = [
          {
            ReasonString: reason,
            PositionString: i18nFilter("_label_all_"),
            Lesions: [
              {
                LesionString: i18nFilter("_label_all_feet_ok_"),
                SeverityString: "",
              },
            ],
            Treatments: [],
            Therapeutic: vm.No,
            Topical: vm.No,
            AllOk: true,
          },
        ];
        trim_list = limbs;
      }

      return trim_list;
    }

    function checkAllLimbs(limbs) {
      var limb1 = false;
      var limb2 = false;
      var limb3 = false;
      var limb4 = false;
      var lesionsList = [];
      var lesions = false;
      var tt = true;
      var rc = true;
      var aa = true;
      var len;
      if (limbs && limbs.length == 4) {
        len = true;
      }
      if (limbs) {
        for (var i = 0; i < limbs.length; i++) {
          lesionsList = lesionsList.concat(limbs[i].Lesions);
          if (limbs[i].Position === 0) {
            limb1 = true;
          }
          if (limbs[i].Position === 1) {
            limb2 = true;
          }
          if (limbs[i].Position === 2) {
            limb3 = true;
          }
          if (limbs[i].Position === 3) {
            limb4 = true;
          }
          if (limbs[i].TreatmentType != 0) {
            tt = false;
          }
          if (limbs[i].ReCheck != 0) {
            rc = false;
          }
          if (limbs[i].ActionType != 0) {
            aa = false;
          }
        }
      }

      if (lesionsList && lesionsList.length == 0) {
        lesions = true;
      }
      return (
        limb1 && limb2 && limb3 && limb4 && lesions && len && tt && rc && aa
      );
    }

    function setByAnimalData(trim_list) {
      var list = [];
      angular.forEach(trim_list, function (value, key) {
        var obj = {};
        value = $filter("orderBy")(value, "VisitDate", true);
        if (value) {
          for (var i = 0; i < value.length; i++) {
            if (i == 0) {
              obj.AnimalEarTag = value[i].AnimalEarTag;
              obj.AnimalName = value[i].AnimalName;
              obj.AnimalNumber = value[i].AnimalNumber;
              obj.Limbs = value[i].Limbs;
              obj.VisitDate = value[i].VisitDate;
            } else {
              obj.Limbs = obj.Limbs.concat(value[i].Limbs);
            }
          }
        }

        list.push(obj);
      });

      return $filter("orderBy")(list, ["AnimalNumber", "AnimalEarTag"]);
    }

    function dateSelected() {
      if (vm.selectedDate.VisitDate != vm.lastHoofTrimDate) {
        vm.lastHoofTrimDate = angular.copy(vm.selectedDate.VisitDate);
        getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate);
      }
    }

    function dateChanged() {
      if (vm.selectedDateObject) {
        var dateFound = false;
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if (
              $filter("date")(vm.selectedDateObject, "mediumDate") ==
              vm.visitDates[i].date
            ) {
              vm.selectedDate = vm.visitDates[i];
              dateSelected();
              dateFound = true;
              break;
            }
          }
        }

        if (dateFound) {
          vm.dateError = false;
        } else {
          vm.dateError = true;
        }
      } else {
        vm.dateError = true;
      }
    }

    function getTherapeutic(type) {
      var therapeutic = vm.No;
      if ((type & 1) == 1) {
        therapeutic = vm.Yes;
      }
      return therapeutic;
    }

    function getTopical(type) {
      var topical = vm.No;
      if ((type & 2) == 2) {
        topical = vm.Yes;
      }
      return topical;
    }

    function getAntibioticTreatment(type) {
      var antibioticTreatment = vm.No;
      if ((type & 4096) == 4096) {
        antibioticTreatment = vm.Yes;
      }
      return antibioticTreatment;
    }

    function getTreatments(type, action) {
      var treatments = [];
      if ((type & 4096) == 4096) {
        treatments.push(vm.AntibioticTreatment);
      }
      if ((type & 8192) == 8192) {
        treatments.push(vm.Conventional);
      }

      if (action != 0) {
        if ((action & 1) == 1) {
          treatments.push(vm.Block);
        }
        if ((action & 2) == 2) {
          treatments.push(vm.Wrap);
        }
      }

      return treatments;
    }

    function changeHoofTrimPeriod() {
      vm.hoofTrimByDate = !vm.hoofTrimByDate;
      if (vm.hoofTrimByDate) {
        vm.timePeriodUnit = "toggle_off";
      } else {
        vm.timePeriodUnit = "toggle_on";
      }

      if (timePeriodUnitTimeout) {
        $timeout.cancel(timePeriodUnitTimeout);
      }

      timePeriodUnitTimeout = $timeout(function () {
        if (vm.hoofTrimByDate) {
          getHoofTrimsByDate(vm.selectedHerds[0], vm.lastHoofTrimDate, false);
        } else {
          getHoofTrimsByPeriod(vm.selectedHerds[0]);
        }
      }, 500);
    }

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode == "day") {
        if (vm.visitDates) {
          for (var i = 0; i < vm.visitDates.length; i++) {
            if ($filter("date")(date, "mediumDate") == vm.visitDates[i].date) {
              return "datepicker-highlight";
            }
          }
        }
      }
    }

    function openRangeSelector() {
      if (!vm.loadingHoofTrims) {
        vm.modal_start_date = angular.copy(vm.startDate);
        vm.modal_end_date = angular.copy(vm.endDate);
        openModal("app/pages/lists/common/dateRange.modal.html", "sm");
      }
    }

    function setDateRange() {
      var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
      if (!range_error) {
        vm.startDate = angular.copy(vm.modal_start_date);
        vm.endDate = angular.copy(vm.modal_end_date);

        getHoofTrimsByPeriod(vm.selectedHerds[0]);
        closeModal();
      }
    }

    function checkRangeError(start_date, end_date) {
      var error = false;
      if (moment(end_date).isBefore(start_date)) {
        error = true;
      }
      return error;
    }

    function openDeleteModal() {
      if (vm.selectedDate && vm.selectedDate.HerdVisitId) {
        vm.deleteVisitId = vm.selectedDate.HerdVisitId;
        vm.deleteVisitDate = vm.selectedDate.VisitDate;
        vm.modalLoading = false;
        openModal("app/pages/lists/common/delete.modal.html", "sm");
      }
    }

    function openExportModal() {
      if (vm.hoofTrimData && vm.hoofTrimData.length) {
        openModal("app/pages/lists/common/export.modal.html", "sm");
      }
    }

    function deleteVisit() {
      vm.modalLoading = true;
      return listsService
        .removeHoofTrimById(vm.deleteVisitId)
        .then(function (response) {
          init();
          closeModal();
        })
        .catch(function (error) {
          vm.deleteError = error;
          vm.modalLoading = false;
          console.log(error);
        });
    }

    function openModal(template, size) {
      $uibModal.open({
        animation: true,
        templateUrl: template,
        size: size,
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
    }

    function exportToPdf() {
      var dd = {
        pageMargins: [25, 30, 25, 30],
        pageSize: "A4",
        pageOrientation: "portrait",
        content: [
          {
            style: "header",

            table: {
              widths: ["*", 100],

              body: [
                [
                  {
                    text: i18nFilter("_page_title_wrap_list_"),
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: vm.hoofTrimByDate
                      ? $filter("date")(vm.selectedDate.VisitDate, "shortDate")
                      : $filter("date")(vm.startDate, "shortDate") +
                        " - " +
                        $filter("date")(vm.endDate, "shortDate"),
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: ["50%", "50%"],

              body: [
                [
                  {
                    text: " ",
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    text: vm.herdName,
                    alignment: "right",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
          {
            table: {
              widths: ["33%", "33%", "33%"],

              body: [
                [
                  {
                    style: "tableHeader",
                    text: "",
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_label_limb_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    style: "tableHeader",
                    text: i18nFilter("_invoice_label_lesion_"),
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
        ],
        styles: {
          header: {
            fontSize: 17,
            bold: true,
          },
          headerSm: {
            fontSize: 15,
            bold: true,
          },
          tableHeader: {
            bold: true,
          },
        },
        defaultStyle: {
          fontSize: 10,
        },
      };

      if (!vm.hoofTrimByDate) {
        dd.content[0].table.widths[1] = 200;
      }

      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var obj = [
          {
            text:
              (vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : "") +
              (vm.hoofTrimData[i].AnimalNumber &&
              vm.hoofTrimData[i].AnimalEarTag
                ? " - "
                : "") +
              (vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "") +
              (!vm.hoofTrimData[i].AnimalNumber &&
              !vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalName
                : ""),
            alignment: "left",
            colSpan: 3,
            border: [false, true, false, false],
          },
          {},
          {},
        ];

        dd.content[2].table.body.push(obj);
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var obj2 = [
            {
              text: i18nFilter("_animal_details_hoof_treatment_type_wrap_"),
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              text: vm.hoofTrimData[i].Limbs[j].PositionString
                ? vm.hoofTrimData[i].Limbs[j].PositionString
                : "",
              alignment: "center",
              border: [false, false, false, false],
            },
            {
              table: {
                widths: ["100%"],
                body: [],
              },
              alignment: "center",
              border: [false, false, false, false],
            },
          ];

          if (vm.hoofTrimData[i].Limbs[j].Lesions.length > 1) {
            for (
              var l = 0;
              l < vm.hoofTrimData[i].Limbs[j].Lesions.length;
              l++
            ) {
              var lesions = [
                {
                  text: vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    ? vm.hoofTrimData[i].Limbs[j].Lesions[l].LesionString
                    : "",
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ];
              obj2[2].table.body.push(lesions);
            }
          } else {
            obj2[2] = {
              text:
                vm.hoofTrimData[i].Limbs[j].Lesions.length == 1
                  ? vm.hoofTrimData[i].Limbs[j].Lesions[0].LesionString
                  : "",
              alignment: "center",
              border: [false, false, false, false],
            };
          }

          dd.content[2].table.body.push(obj2);
        }
      }

      var name =
        vm.herdName + " " + i18nFilter("_page_title_wrap_list_") + ".pdf";
      name = name.replace(/ /g, "_");
      pdfMake.createPdf(dd).download(name);
    }

    function exportData() {
      if (vm.selectedFormat == 1) {
        var elem = document.getElementById("export-csv-button");

        $timeout(function () {
          elem.click();
        }, 10);
      } else {
        exportToExcel(vm.selectedVersion);
      }

      $timeout(function () {
        closeModal();
      }, 200);
    }

    function exportToExcel(version) {
      var list = generateExportList(version, vm.hoofTrimData);
      var file_name = vm.herdName + ".xls";
      var date_format = xlsxService.getShortDateFormat($locale);
      var ws = XLSX.utils.aoa_to_sheet(list, {
        cellDates: true,
        dateNF: date_format,
      });

      if (version == 1) {
        ws["!cols"] = [{ wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
      } else if (version == 2) {
        ws["!cols"] = [
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
        ];
      }

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        i18nFilter("_page_title_wrap_list_")
      );
      XLSX.writeFile(wb, file_name);
    }

    function generateExportList(version, data) {
      var l = [];

      if (version == 1) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      } else if (version == 2) {
        var header = [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
        l.push(header);
      }

      data.forEach(function (event) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < event.Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            event.Limbs[j].ReCheck,
            event.VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (version == 1) {
          var ll = [];
          ll.push(
            event.AnimalNumber
              ? event.AnimalNumber
              : event.AnimalEarTag
              ? event.AnimalEarTag
              : ""
          );

          ll.push(listsDataService.getReasonString(event.Reason));
          ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
          ll.push(recheckDate ? new Date(recheckDate) : "");
          l.push(ll);
        } else if (version == 2) {
          event.Limbs.forEach(function (limb) {
            var ll = [];
            ll.push(
              event.AnimalNumber
                ? event.AnimalNumber
                : event.AnimalEarTag
                ? event.AnimalEarTag
                : ""
            );
            ll.push(listsDataService.getReasonString(event.Reason));
            ll.push(event.VisitDate ? new Date(event.VisitDate) : "");
            ll.push(limb.PositionString);
            ll.push(getLesionsShortList(limb.Lesions));
            ll.push(
              limb.AntibioticTreatment == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(
              limb.Topical == i18nFilter("_label_yes_")
                ? i18nFilter("_label_yes_")
                : ""
            );
            ll.push(limb.RecheckDateObj ? limb.RecheckDateObj : "");
            l.push(ll);
          });
        }
      });

      return l;
    }

    function getLesionsShortList(lesions) {
      var list = "";
      for (var i = 0; i < lesions.length; i++) {
        if (lesions.length == 1) {
          list += lesions[i].LesionStringShort;
        } else {
          if (i != lesions.length - 1) {
            list += lesions[i].LesionStringShort + "|";
          } else {
            list += lesions[i].LesionStringShort;
          }
        }
      }
      return list;
    }

    function getCsvData() {
      var list = [];
      for (var i = 0; i < vm.hoofTrimData.length; i++) {
        var recheckDate = "";
        var recheckDateP = "";
        var recheckDateN = "";
        for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
          var rd = listsDataService.getRecheckDate(
            vm.hoofTrimData[i].Limbs[j].ReCheck,
            vm.hoofTrimData[i].VisitDate
          );
          if (rd) {
            var diff = moment(rd).diff(moment(), "days");
            if (diff > 0) {
              if (!recheckDateP) {
                recheckDateP = rd;
              } else {
                var diffp = moment(recheckDateP).diff(moment(), "days");
                if (diff < diffp) {
                  recheckDateP = rd;
                }
              }
            } else {
              if (!recheckDateN) {
                recheckDateN = rd;
              } else {
                var diffn = moment(recheckDateN).diff(moment(), "days");
                if (diff > diffn) {
                  recheckDateN = rd;
                }
              }
            }
          }
        }
        if (recheckDateN && recheckDateP) {
          recheckDate = recheckDateP;
        } else if (recheckDateN && !recheckDateP) {
          recheckDate = recheckDateN;
        } else if (recheckDateP && !recheckDateN) {
          recheckDate = recheckDateP;
        }

        if (vm.selectedVersion == 1) {
          var obj = {
            a: vm.hoofTrimData[i].AnimalNumber
              ? vm.hoofTrimData[i].AnimalNumber
              : vm.hoofTrimData[i].AnimalEarTag
              ? vm.hoofTrimData[i].AnimalEarTag
              : "",
            b: i18nFilter("_animal_details_hoof_treatment_type_wrap_"),
            c: getLimbsCsv(vm.hoofTrimData[i]),
            d: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
          };
          list.push(obj);
        } else {
          for (var j = 0; j < vm.hoofTrimData[i].Limbs.length; j++) {
            var obj = {
              a: vm.hoofTrimData[i].AnimalNumber
                ? vm.hoofTrimData[i].AnimalNumber
                : vm.hoofTrimData[i].AnimalEarTag
                ? vm.hoofTrimData[i].AnimalEarTag
                : "",
              b: listsDataService.getReasonString(vm.hoofTrimData[i].Reason),
              c: $filter("date")(vm.hoofTrimData[i].VisitDate, "shortDate"),
              d: vm.hoofTrimData[i].Limbs[j].PositionString,
              e: vm.hoofTrimData[i].Limbs[0].AllOk
                ? ""
                : getLesionsShortList(vm.hoofTrimData[i].Limbs[j].Lesions),
              f: vm.hoofTrimData[i].Limbs[0].AllOk
                ? i18nFilter("_label_no_")
                : vm.hoofTrimData[i].Limbs[j].AntibioticTreatment,
              g: vm.hoofTrimData[i].Limbs[0].AllOk
                ? i18nFilter("_label_no_")
                : vm.hoofTrimData[i].Limbs[j].Topical,
              h: $filter("date")(recheckDate, "shortDate"),
            };

            list.push(obj);
          }
        }
      }
      return list;
    }

    function getLimbsCsv(trim) {
      var str = "";
      for (var i = 0; i < trim.Limbs.length; i++) {
        str += trim.Limbs[i].PositionString;
        if (i < trim.Limbs.length - 1) {
          str += ", ";
        }
      }
      return str;
    }

    function getCsvHeader() {
      if (vm.selectedVersion == 1) {
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_recheck_date_"),
        ];
      } else {
        return [
          i18nFilter("_animal_number_"),
          i18nFilter("_label_event_"),
          i18nFilter("_label_date_"),
          i18nFilter("_label_limb_"),
          i18nFilter("_animal_leasion_"),
          i18nFilter(
            "_animal_details_hoof_treatment_type_antibiotic_treatment_"
          ),
          i18nFilter("_animal_details_hoof_treatment_type_topical_"),
          i18nFilter("_label_recheck_date_"),
        ];
      }
    }

    $scope.$on("default_herd_selected", function (event, data) {
      init();
    });
    $scope.$on("default_team_selected", function (event, data) {
      init();
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milk-production.components")
    .controller("componentsCtrl", componentsCtrl);
  /** @ngInject */
  function componentsCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      vm.selectedTeam = vm.defaultValues.team_id;
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeSource = aDashboardsService.milkTrendSourceType;
      var activeType = aDashboardsService.milkTrendActiveType;
      var dashboard_id;
      if (!activeType && !activeSource) {
        dashboard_id = vm.componentsTrendDashboard;
        aDashboardsService.milkTrendActiveType = "trend";
      } else {
        if (activeType == "trend") {
          if (activeSource) {
            dashboard_id = vm.componentsTrendMroDashboard;
          } else {
            dashboard_id = vm.componentsTrendDashboard;
          }
        } else {
          if (activeSource) {
            dashboard_id = vm.componentsMroDashboard;
          } else {
            dashboard_id = vm.componentsDashboard;
          }
        }
      }

      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-milk-yield_en-GB_twb/ComponentsTrenddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milk-production.components",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkMRO: true,
          checkMilk: true,
          stateList: [
            {
              title: "_page_title_milk_trend_",
              state: "milk-production.milk-trend",
            },
            { title: "_page_title_spp_", state: "milk-production.spp" },
            {
              title: "_page_title_components_",
            },
            { title: "_page_title_conductivity_short_",state: "milk-production.conductivity", permission: 528},
            {
              title: "_page_title_pregnant_",
              state: "milk-production.pregnant",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.componentsDashboard = i18nFilter("_arv_components_dashboard_");
      vm.componentsTrendDashboard = i18nFilter(
        "_arv_components_trend_dashboard_"
      );
      vm.componentsMroDashboard = i18nFilter("_arv_components_dashboard_mro_");
      vm.componentsTrendMroDashboard = i18nFilter(
        "_arv_components_trend_dashboard_mro_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milk-production.conductivity")
    .controller("conductivityCtrl", conductivityCtrl);
  /** @ngInject */
  function conductivityCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.selectedTeam = vm.defaultValues.team_id;

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var dashboard_id;
     dashboard_id = vm.conductivityDashboard;

      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            " https://visual-stg.mmmooogle.com/t/Development/views/team-4083-production-proxani-milk-yield_en-GB_twb/ConductivitybyDIMdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milk-production.conductivity",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          stateList: [
            {
              title: "_page_title_milk_trend_",
              state: "milk-production.milk-trend",
            },
            { title: "_page_title_spp_", state: "milk-production.spp" },
            {
              title: "_page_title_components_",
              state: "milk-production.components",
            },

            { title: "_page_title_conductivity_short_" , permission: 528},
            {
              title: "_page_title_pregnant_",
              state: "milk-production.pregnant",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.conductivityDashboard = i18nFilter("_dashboard_id_conductivity_dim_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milk-production.milk-trend")
    .controller("milkTrendCtrl", milkTrendCtrl);
  /** @ngInject */
  function milkTrendCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.selectedTeam = vm.defaultValues.team_id;

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.milkTrendActiveType;
      var activeSource = aDashboardsService.milkTrendSourceType;
      var dashboard_id;
      if (!activeType && !activeSource) {
        dashboard_id = vm.milkTrendDashboard;
        aDashboardsService.milkTrendActiveType = "trend";
      } else {
        if (activeType == "trend") {
          if (activeSource) {
            dashboard_id = vm.milkTrendMroDashboard;
          } else {
            dashboard_id = vm.milkTrendDashboard;
          }
        } else {
          if (activeSource) {
            dashboard_id = vm.milkActualMroDashboard;
          } else {
            dashboard_id = vm.milkActualDashboard;
          }
        }
      }

      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            " https://visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-milk-yield_en-GB_twb/Milkyieldtrend?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milk-production.milk-trend",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkMRO: true,
          checkMilk: true,
          stateList: [
            { title: "_page_title_milk_trend_" },
            { title: "_page_title_spp_", state: "milk-production.spp" },
            {
              title: "_page_title_components_",
              state: "milk-production.components",
            },
            { title: "_page_title_conductivity_short_",state: "milk-production.conductivity" , permission: 528},
            {
              title: "_page_title_pregnant_",
              state: "milk-production.pregnant",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.milkTrendDashboard = i18nFilter("_arv_milk_yield_trend_dashboard");
      vm.milkTrendMroDashboard = i18nFilter(
        "_dashboard_id_milk_yield_trend_mro_"
      );
      vm.milkActualDashboard = i18nFilter(
        "_rap_workbook_id_milk_yield_actual_"
      );
      vm.milkActualMroDashboard = i18nFilter(
        "_dashboard_id_milk_yield_actual_mro_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milk-production.pregnant")
    .controller("pregnantCtrl", pregnantCtrl);
  /** @ngInject */
  function pregnantCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.selectedTeam = vm.defaultValues.team_id;

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var dashboard_id = vm.daysPregnantDashboard;
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            " https://visual-stg.mmmooogle.com/t/Development/views/team-4717-production-proxani-milk-yield_en-GB_twb/Dayspregnantdashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milk-production.pregnant",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
          changeStateVisible: true,
          stateList: [
            {
              title: "_page_title_milk_trend_",
              state: "milk-production.milk-trend",
            },
            { title: "_page_title_spp_", state: "milk-production.spp" },
            {
              title: "_page_title_components_",
              state: "milk-production.components",
            },

            {
              title: "_page_title_conductivity_short_",
              state: "milk-production.conductivity", permission: 528
            },
            { title: "_page_title_pregnant_" },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ") {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.daysPregnantDashboard = $filter("i18n")(
        "_dashboard_id_days_pregnant_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milkings.refusals")
    .controller("refusalsCtrl", refusalsCtrl);
  /** @ngInject */
  function refusalsCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.milkingsActiveType;
      var dashboard_id;
      if (!activeType) {
        dashboard_id = vm.refusalsTrendDashboard;
        aDashboardsService.milkingsActiveType = "trend";
      } else {
        if (activeType == "trend") {
          dashboard_id = vm.refusalsTrendDashboard;
        } else {
          dashboard_id = vm.refusalsDashboard;
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/Refusalstrenddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milkings.refusals",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
          changeStateVisible: true,
          checkMilkings: true,
          category: "refusals",
          stateList: [
            { title: "_page_title_milkings_", state: "milkings.actual" },
            { title: "_page_title_refusals_" },
            {
              title: "_page_title_failures_",
              state: "milkings.failures",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.refusalsDashboard = i18nFilter("_dashboard_id_refusals_");
      vm.refusalsTrendDashboard = i18nFilter("_dashboard_id_refusals_trend_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular.module("My.pages.milk-production.spp").controller("sppCtrl", sppCtrl);
  /** @ngInject */
  function sppCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      setStrings();
      setLanguage();
      setStyleType();

      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      vm.selectedTeam = vm.defaultValues.team_id;

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "milk-yield"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "milk-yield"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.milkTrendActiveType;
      var activeSource = aDashboardsService.milkTrendSourceType;
      var dashboard_id;

      if (!activeType && !activeSource) {
        dashboard_id = vm.sppDashboard;
        aDashboardsService.milkTrendActiveType = "trend";
      } else {
        if (activeType == "trend") {
          if (activeSource) {
            dashboard_id = vm.sppMroDashboard;
          } else {
            dashboard_id = vm.sppDashboard;
          }
        } else {
          if (activeSource) {
            dashboard_id = vm.sppActualMroDashboard;
          } else {
            dashboard_id = vm.sppActualDashboard;
          }
        }
      }

      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-milk-yield" ||
              _dash.subcategory == "proxani-milk-yield") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;

      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-stg.mmmooogle.com/t/Development/views/team-4710-production-proxani-milk-yield_en-GB_twb/SPPtrendMRO?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }

        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milk-production.spp",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          checkMRO: true,
          checkMilk: true,
          stateList: [
            {
              title: "_page_title_milk_trend_",
              state: "milk-production.milk-trend",
            },
            { title: "_page_title_spp_" },
            {
              title: "_page_title_components_",
              state: "milk-production.components",
            },
             { title: "_page_title_conductivity_short_",state: "milk-production.conductivity" , permission: 528}, 
            {
              title: "_page_title_pregnant_",
              state: "milk-production.pregnant",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.sppDashboard = i18nFilter("_rap_workbook_id_spp_trend_");
      vm.sppMroDashboard = i18nFilter("_dashboard_id_spp_trend_mro_");
      vm.sppActualDashboard = i18nFilter("_rap_workbook_id_spp_actual_");
      vm.sppActualMroDashboard = i18nFilter("_dashboard_id_spp_actual_mro_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milkings.actual")
    .controller("actualCtrl", actualCtrl);
  /** @ngInject */
  function actualCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.milkingsActiveType;
      var dashboard_id;
      if (!activeType) {
        dashboard_id = vm.milkingsTrendDashboard;
        aDashboardsService.milkingsActiveType = "trend";
      } else {
        if (activeType == "trend") {
          dashboard_id = vm.milkingsTrendDashboard;
        } else {
          dashboard_id = vm.milkingsActualDashboard;
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/Milkingstrenddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milkings.actual",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
          changeStateVisible: true,
          checkMilkings: true,
          category: "milkings",
          stateList: [
            { title: "_page_title_milkings_" },
            { title: "_page_title_refusals_", state: "milkings.refusals" },
            {
              title: "_page_title_failures_",
              state: "milkings.failures",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.milkingsActualDashboard = i18nFilter("_dashboard_id_milkings_");
      vm.milkingsTrendDashboard = i18nFilter("_dashboard_id_milkings_trend_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.milkings.failures")
    .controller("failuresCtrl", failuresCtrl);
  /** @ngInject */
  function failuresCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }

      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.embed = null;
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var activeType = aDashboardsService.milkingsActiveType;
      var dashboard_id;
      if (!activeType) {
        dashboard_id = vm.failuresTrendDashboard;
        aDashboardsService.milkingsActiveType = "trend";
      } else {
        if (activeType == "trend") {
          dashboard_id = vm.failuresTrendDashboard;
        } else {
          dashboard_id = vm.failuresDashboard;
        }
      }
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == dashboard_id
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/Milkingstrenddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "milkings.failures",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: false,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap",
          showTopBar: true,
          changeStateVisible: true,
          checkMilkings: true,
          category: "failures",
          stateList: [
            { title: "_page_title_milkings_", state: "milkings.actual" },
            { title: "_page_title_refusals_", state: "milkings.refusals" },
            {
              title: "_page_title_failures_",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.failuresDashboard = i18nFilter("_dashboard_id_failures_");
      vm.failuresTrendDashboard = i18nFilter("_dashboard_id_failures_trend_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('clawHealthDirCtrl', clawHealthDirCtrl);

	/** @ngInject */
	function clawHealthDirCtrl($scope, $timeout, overviewService, $uibModal, $uibModalStack) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;
		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;

		function init() {
			vm.allKPIS = [
				{
					label: "Last trimming date",
					kpi: "Number of Trimmed Cows",
					kpiValue: "Number of Trimmed Cows",
					db: "Last trimming date",
					dbiValue: "Last trimming date",
					iid: 1,
					selected: true
				}, {
					label: "Number of lame cows (block)",
					kpi: "Number of lame cows",
					kpiValue: "Number of lame cows",
					db: "Number of lame cows",
					dbiValue: "Number of lame cows",
					iid: 2,
					selected: true
				}, {
					label: "Number of lame cows",
					kpi: "Number of lame cows",
					kpiValue: "Number of lame cows",
					db: "Number of Trimmed Cows",
					dbiValue: "Number of Trimmed Cows",
					iid: 3,
					selected: true
				}, {
					label: "Number of trimmed cows (block)",
					kpi: "Number of Trimmed Cows",
					kpiValue: "Number of Trimmed Cows",
					db: "Number of lame cows",
					dbiValue: "Number of lame cows",
					iid: 4,
					selected: true
				}, {
					label: "Number of trimmed cows",
					kpi: "Number of Trimmed Cows",
					kpiValue: "Number of Trimmed Cows",
					db: "Number of Trimmed Cows",
					dbiValue: "Number of Trimmed Cows",
					iid: 5,
					selected: true
				},
			]
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showClawHealth = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.clawHealthUrl = getUrl(vm.dashboards);
				embedPage(vm.clawHealthUrl);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == 'Clawhealthmoduleoverview') {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard) {
			if (dashboard) {
				vm.errorLoading = false;
				vm.dashboardNotAvailable = false;
				if (viz) {
					viz.dispose();
				}

				var endDate = moment().hour(23).minute(59).seconds(59).millisecond(999).toISOString();
				var startDate = moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(5, 'years').toISOString();
				var suffix = "&startDate=" + startDate + "&endDate=" + endDate;
				dashboard.url = dashboard.url + suffix;
				//local testing
				return overviewService.setSession(dashboard.url).then(function (response) {
				var url = response.headers('tabvis-location');
				//local testing
				//var url = dashboard.url;
				if (url) {
					url = url + '&:render=true&:refresh=yes'
					var options = {
						device: 'tablet',
						"Herd Parameter": 0,
						HerdIdentifier: [],
						"Select DB": "Last trimming date",
						"KPIparam": "Number of Trimmed Cows",
						onFirstInteractive: function () {
							workbook = viz.getWorkbook();
							var wrks = workbook.getActiveSheet().getWorksheets();
							var worksheetName;
							for (var i = 0; i < wrks.length; i++) {
								if (wrks[i].getName()) {
									worksheetName = wrks[i].getName();
									break;
								}
							}

							/*workbook.getParametersAsync().then(function (parameters) {
								console.log(parameters)
							});

							workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
								console.log(filters)
							})*/

							$timeout(function () {
								vm.disableSelector = false;
							}, 50)
						}
					}
					vm.showClawHealth = true;
					if (vm.selectedHerds.length > 0) {
						var herdParams = [];
						for (var k = 0; k < vm.selectedHerds.length; k++) {
							herdParams.push(vm.selectedHerds[k])
						}
						options.HerdIdentifier = herdParams;
					}
					$timeout(function () {
						var containerDiv = document.getElementById("clawHealthFrame");
						viz = new tableau.Viz(containerDiv, url, options);
					}, 300)



				}

				}).catch(function (error) {
					vm.errorLoading = true;
					console.log(error)
				})

			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500)

			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
		}

		function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
			if (viz) {
				vm.disableSelector = true;
				if (responseTimeout) {
					$timeout.cancel(responseTimeout);
				}
				responseTimeout = $timeout(function () {
					vm.disableSelector = false;
				}, 10000);
				if (kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100)

						});
					})
				} else if (kpiChanged && !dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				} else if (!kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				}
			}
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = angular.copy(vm.allKPIS)
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}


		}

		function saveKpis() {

			var selected = false;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					selected = true;
					break;
				}
			}
			if (selected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.allKPIS.length; j++) {
						if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
							vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				var kpis = [];
				var selectedKPIFound;
				for (var i = 0; i < vm.allKPIS.length; i++) {
					if (vm.allKPIS[i].selected) {
						kpis.push(vm.allKPIS[i]);
						if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
							selectedKPIFound = true;
						}
					}
				}
				vm.showSelector = false;
				vm.KPIS = kpis;
				if (!selectedKPIFound) {
					vm.selectedKPI = vm.KPIS[0];
					kpiSelected();
				}
				$timeout(function () {
					vm.showSelector = true;
					closeModal();
				}, 50)
			}


		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			})
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('$destroy', function () {

			if (viz) {
				viz.dispose();
			}
		});

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('clawHealth', clawHealth);

	/** @ngInject */
	function clawHealth() {
		var dir = {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'clawHealthDirCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/clawHealth/clawHealth.html',
			bindToController: true
		}
		
		return dir;
		
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('emergencyWallCtrl', emergencyWallCtrl);

	/** @ngInject */
	function emergencyWallCtrl($scope, $timeout, baConfig, baUtil, $sce) {
		var ev = this;

	console.log('emergencyWallCtrl')

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('emergencyWall', emergencyWall);

	/** @ngInject */
	function emergencyWall() {
		return {
			restrict: 'AE',
			controller: 'emergencyWallCtrl',
			controllerAs: 'ev',
			templateUrl: 'app/pages/overview/emergencyWall/emergencyWall.html'
		};
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('mainKpiCtrl', mainKpiCtrl);

	/** @ngInject */
	function mainKpiCtrl($timeout, $filter) {
		var vm = this;
		
		vm.$onInit = init;

		function init() {
			
			vm.KPIS = getMainKPIS(vm.dashboards);
			vm.KPIS = setInfo(vm.KPIS)
			$timeout(function () {
				vm.showKPIS = true;
			}, 500)
		}
		
		function getMainKPIS(dashboards){
			var kpis = [];
			for(var i = 0; i < dashboards.length; i++){
				if(dashboards[i].selected){
					kpis.push(dashboards[i]);
				}
			}
			
			return kpis;
		}
		
		function setInfo(dasboards){
			for(var i = 0; i < dasboards.length; i++){
				dasboards[i].info = getInfo(dasboards[i]);
			}
			return dasboards;
		}
		
		function getInfo(dashboard){
			
			var allDatePeriodTypes = [{
				name: 'Last day',
				id: 1
			}, {
				name: 'Current week',
				id: 2
			}, {
				name: 'Last week',
				id: 3
			}, {
				name: 'Current and last week',
				id: 4
			}, {
				name: 'Last two weeks',
				id: 5
			}, {
				name: 'Current month',
				id: 6
			}, {
				name: 'Last month',
				id: 7
			}, {
				name: 'Current quarter',
				id: 8
			}, {
				name: 'Last quarter',
				id: 9
			}, {
				name: 'Last 6 months',
				id: 10
			}, {
				name: 'Current year',
				id: 11
			}, {
				name: 'Last year',
				id: 12
			}, {
				name: 'Custom',
				id: 99
			}];
			var info = '';
			for(var i = 0; i < allDatePeriodTypes.length; i++){
				if(dashboard.datePeriod == allDatePeriodTypes[i].id){
					if(allDatePeriodTypes[i].id == 99){
						info = $filter('date')(dashboard.startDate, 'shortDate') + " - " + $filter('date')(dashboard.endDate, 'shortDate')
					}else{
						info = allDatePeriodTypes[i].name;
					}
					
					break;
				}
			}
			return info;
			
		}

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('mainKpi', mainKpi);

	/** @ngInject */
	function mainKpi() {
		var dir = {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'mainKpiCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/mainKPI/mainKPI.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview').controller('lactationAnalysisModuleCtrl', lactationAnalysisModuleCtrl);

	/** @ngInject */
	function lactationAnalysisModuleCtrl($scope, $timeout, overviewService, $uibModal, $uibModalStack, $filter) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;

		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;

		function init() {
			vm.allKPIS = [
				{
					label: 'Age at first insemination',
					kpi: 1,
					kpiValue: 'Age at first insemination',
					db: 1,
					dbiValue: 'First insemination',
					iid: 1,
					selected: true
				},
				{
					label: 'CR% at first insemination',
					kpi: 2,
					kpiValue: 'CR% at first inseminetion',
					db: 2,
					dbiValue: 'Over time',
					iid: 2,
					selected: true
				},
				{
					label: 'DIM at first insemination',
					kpi: 3,
					kpiValue: 'DIM at first Insemination',
					db: 1,
					dbiValue: 'First insemination',
					iid: 3,
					selected: true
				},
				{
					label: 'Conception rate',
					kpi: 4,
					kpiValue: 'CR%',
					db: 2,
					dbiValue: 'Over time',
					iid: 4,
					selected: true
				}
			];
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showLactationAnalysis = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.lactationAnalysisUrl = getUrl(vm.dashboards);
				embedPage(vm.lactationAnalysisUrl, true);
				//local testing
				//embedPage(vm.lactationAnalysisUrl, false);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var dashboard;
			var lactationAnalysisDashboardId = $filter('i18n')('_lactation_analysis_dashboard_id_');
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].subcategory == 'module-lactation-analysis' && dashboards[i].id == lactationAnalysisDashboardId) {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard, useTabvis) {
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 2) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				var herdParam = createHerdParam(herds);
				if (dashboard) {
					vm.errorLoading = false;
					vm.dashboardNotAvailable = false;
					if (viz) {
						viz.dispose();
					}

					if (useTabvis) {
						return overviewService
							.setSession(dashboard.url)
							.then(function (response) {
								var url = response.headers('tabvis-location');
								embed(url, herdParam);
							})
							.catch(function (error) {
								vm.errorLoading = true;
								console.log(error);
							});
					} else {
						if (vm.currentLng == 'en-GB') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_en-GB_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'en-US') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_en-GB_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'fr-FR') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_fr-FR_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'de-DE') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_de-DE_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'nl-NL') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_nl-NL_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'pl-PL') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-lactation-analysis_pl-PL_twb/LactationanalysisbyDIMMRO?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						}

						embed(url, herdParam);
					}
				} else {
					vm.dashboardNotAvailable = true;
				}
			}
		}

		function embed(url, herdParameter) {
			if (url) {
				url = url + '&:render=true&:refresh=yes';
				var endDate = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
				var startDate = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(3, 'years').toISOString());
				var options = {
					device: 'desktop',
					'Start Date': $filter('date')(startDate, 'yyyy-MM-dd'),
					'End Date': $filter('date')(endDate, 'yyyy-MM-dd'),
					onFirstInteractive: function () {
						workbook = viz.getWorkbook();
						var wrks = workbook.getActiveSheet().getWorksheets();
						var worksheetName;
						for (var i = 0; i < wrks.length; i++) {
							if (wrks[i].getName()) {
								worksheetName = wrks[i].getName();
								break;
							}
						}

						/*workbook.getParametersAsync().then(function (parameters) {
							console.log(parameters)
						});

						workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
							console.log(filters)
						})*/
						$timeout(function () {
							vm.disableSelector = false;
						}, 50);
					}
				};
				options['Herd Parameter'] = herdParameter;
				vm.showLactationAnalysis = true;
				$timeout(function () {
					var containerDiv = document.getElementById('lactationAnalysisFrame');
					viz = new tableau.Viz(containerDiv, url, options);
				}, 100);
			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500);
			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
		}

		function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
			if (viz) {
				vm.disableSelector = true;
				if (responseTimeout) {
					$timeout.cancel(responseTimeout);
				}
				responseTimeout = $timeout(function () {
					vm.disableSelector = false;
				}, 10000);
				if (kpiChanged && dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('KPIparam', kpi)
						.then(function (param) {
							viz.getWorkbook()
								.changeParameterValueAsync('Select DB', db)
								.then(function (res) {
									$timeout(function () {
										vm.disableSelector = false;
									}, 100);
								});
						});
				} else if (kpiChanged && !dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('KPIparam', kpi)
						.then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100);
						});
				} else if (!kpiChanged && dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('Select DB', db)
						.then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100);
						});
				}
			}
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = angular.copy(vm.allKPIS);
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}
		}

		function saveKpis() {
			var selected = false;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					selected = true;
					break;
				}
			}
			if (selected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.allKPIS.length; j++) {
						if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
							vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				var kpis = [];
				var selectedKPIFound;
				for (var i = 0; i < vm.allKPIS.length; i++) {
					if (vm.allKPIS[i].selected) {
						kpis.push(vm.allKPIS[i]);
						if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
							selectedKPIFound = true;
						}
					}
				}
				vm.showSelector = false;
				vm.KPIS = kpis;
				if (!selectedKPIFound) {
					vm.selectedKPI = vm.KPIS[0];
					kpiSelected();
				}
				$timeout(function () {
					vm.showSelector = true;
					closeModal();
				}, 50);
			}
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('$destroy', function () {
			if (viz) {
				viz.dispose();
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('lactationAnalysis', lactationAnalysis);

	/** @ngInject */
	function lactationAnalysis() {
		var dir =  {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'lactationAnalysisModuleCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/lactationAnalysis/lactationAnalysis.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('mapHerdsCtrl', mapHerdsCtrl);

	/** @ngInject */
	function mapHerdsCtrl($scope, $timeout, overviewService, $rootScope) {
		var vm = this;
		var viz;
		var workbook;
		var worksheetName;
		var markChangeTimeout;
		vm.$onInit = onInit;

		function onInit() {
			vm.showMap = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.mapUrl = getUrl(vm.dashboards);
				embedPage(vm.mapUrl);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == 'Homeclawhealthdashboard') {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}



		function embedPage(dashboard) {
			if (dashboard) {
				vm.dashboardNotAvailable = false;
				vm.errorLoading = false;
				if (viz) {
					viz.dispose();
				}

				var endDate = moment().hour(23).minute(59).seconds(59).millisecond(999).toISOString();
				var startDate = moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(10, 'years').toISOString();
				
				//local testing
				//return overviewService.setSession(dashboard.url).then(function (response) {
				//var url = response.headers('tabvis-location');
				//local testing
				var url = "https://visual-stg.mmmooogle.com/t/Development/views/MasterTable/MapDashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
				if (url) {
					url = url + '&:render=true&:refresh=yes'
					var options = {
						device: 'tablet',
						"Start Date": moment(startDate).format("YYYY-MM-DD"),
						"End Date": moment(endDate).format("YYYY-MM-DD"),
						"Herd Parameter": 0,
						onFirstInteractive: function () {

							workbook = viz.getWorkbook();
							var wrks = workbook.getActiveSheet().getWorksheets();
							worksheetName;
							for (var i = 0; i < wrks.length; i++) {
								if (wrks[i].getName()) {
									worksheetName = wrks[i].getName();
									break;
								}
							}

							/*workbook.getParametersAsync().then(function (parameters) {
								console.log(parameters)
							});

							workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
								console.log(filters)
							})*/



						}
					}
					vm.showMap = true;
					$timeout(function () {
						var containerDiv = document.getElementById("herdMapFrame");
						viz = new tableau.Viz(containerDiv, url, options);
						viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onSelect);
					}, 100)



				}

				/*	}).catch(function (error) {
						vm.errorLoading = true;
						console.log(error)
					})*/
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function onSelect(markEvent) {
			if (markChangeTimeout) {
				$timeout.cancel(markChangeTimeout)
			}

			markChangeTimeout = $timeout(function () {
				markEvent.getMarksAsync().then(function (response) {
					if (response[0]) {
						var pairs = response[0].getPairs();
						var value;
						for (var i = 0; i < pairs.length; i++) {
							if (pairs[i].fieldName == "HerdIdentifier") {
								value = pairs[i].value;
							}
						}
						if (value) {
							if (vm.selectedHerds.length == 0 || (vm.selectedHerds.length) > 1 || (vm.selectedHerds.length == 1 && vm.selectedHerds[0] != value)) {
								vm.selectedHerd = value;
								$rootScope.$broadcast('default_herd_from_map_selected', value);
							}

						}


					}
				})
			}, 750)

		}

		$scope.$on('$destroy', function () {

			if (viz) {
				viz.dispose();
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('mapHerds', mapHerds);

	/** @ngInject */
	function mapHerds() {
		var dir = {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'mapHerdsCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/map/map.html',
			bindToController: true
			
		};
		
		return dir;
		
		function link(scope, element, attrs){
		}
		
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('presalesAuditModuleCtrl', presalesAuditModuleCtrl);

	/** @ngInject */
	function presalesAuditModuleCtrl($scope, $timeout, overviewService, $uibModal, $uibModalStack, $filter) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;

		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;

		function init() {

			vm.allKPIS = [
				{
					label: "Age at first insemination",
					kpi: 1,
					kpiValue: "Age at first insemination",
					db: 1,
					dbiValue: "First insemination",
					iid: 1,
					selected: true
				}, {
					label: "CR% at first insemination",
					kpi: 2,
					kpiValue: "CR% at first inseminetion",
					db: 2,
					dbiValue: "Over time",
					iid: 2,
					selected: true
				}, {
					label: "DIM at first insemination",
					kpi: 3,
					kpiValue: "DIM at first Insemination",
					db: 1,
					dbiValue: "First insemination",
					iid: 3,
					selected: true
				}, {
					label: "Conception rate",
					kpi: 4,
					kpiValue: "CR%",
					db: 2,
					dbiValue: "Over time",
					iid: 4,
					selected: true
				},
			]
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showPresalesAudit = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.presalesAuditUrl = getUrl(vm.dashboards);
				embedPage(vm.presalesAuditUrl);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == 'ReproductionModuleOverview') {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard) {

			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 2) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}
			if (!vm.herdsLimitReached) {
				var herdParam = createHerdParam(herds);
				if (dashboard) {
					vm.errorLoading = false;
					vm.dashboardNotAvailable = false;
					if (viz) {
						viz.dispose();
					}

					var endDate = moment().hour(23).minute(59).seconds(59).millisecond(999).toISOString();
					var startDate = moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(1, 'years').toISOString();
					var suffix = "&startDate=" + startDate + "&endDate=" + endDate;
					dashboard.url = dashboard.url + suffix;
					//local testing
					//return overviewService.setSession(dashboard.url).then(function (response) {
					//var url = response.headers('tabvis-location');
					//local testing
					if(vm.currentLng == "en-GB"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_en-GB_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}else if(vm.currentLng =="en-US"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_en-US_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}else if(vm.currentLng =="fr-FR"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_fr-FR_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}else if(vm.currentLng =="de-DE"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_de-DE_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}else if(vm.currentLng =="nl-NL"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_nl-NL_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}else if(vm.currentLng =="pl-PL"){
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1812-reproduction-pre-sales-audit_pl-PL_twb/HerdInventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
					}

					if (url) {
						url = url + '&:render=true&:refresh=yes'
						var options = {
							device: 'desktop',
							"Start Date": $filter('date')(startDate, "yyyy-MM-dd"),
							"End Date": $filter('date')(endDate, "yyyy-MM-dd"),
							onFirstInteractive: function () {

								workbook = viz.getWorkbook();
								var wrks = workbook.getActiveSheet().getWorksheets();
								var worksheetName;
								for (var i = 0; i < wrks.length; i++) {
									if (wrks[i].getName()) {
										worksheetName = wrks[i].getName();
										break;
									}
								}

								/*workbook.getParametersAsync().then(function (parameters) {
									console.log(parameters)
								});
	
								workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
									console.log(filters)
								})*/
								$timeout(function () {
									vm.disableSelector = false;
								}, 50)

							}
						}
						options["Herd Parameter"] = herdParam;
						vm.showPresalesAudit = true;
						$timeout(function () {
							var containerDiv = document.getElementById("presalesAuditFrame");
							viz = new tableau.Viz(containerDiv, url, options);
						}, 100)



					}

					/*}).catch(function (error) {
						vm.errorLoading = true;
						console.log(error)
					})*/

				} else {
					vm.dashboardNotAvailable = true;
				}

			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500)

			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
		}

		function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
			if (viz) {
				vm.disableSelector = true;
				if (responseTimeout) {
					$timeout.cancel(responseTimeout);
				}
				responseTimeout = $timeout(function () {
					vm.disableSelector = false;
				}, 10000);
				if (kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100)

						});
					})
				} else if (kpiChanged && !dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				} else if (!kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				}
			}
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = angular.copy(vm.allKPIS)
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}


		}

		function saveKpis() {

			var selected = false;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					selected = true;
					break;
				}
			}
			if (selected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.allKPIS.length; j++) {
						if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
							vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				var kpis = [];
				var selectedKPIFound;
				for (var i = 0; i < vm.allKPIS.length; i++) {
					if (vm.allKPIS[i].selected) {
						kpis.push(vm.allKPIS[i]);
						if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
							selectedKPIFound = true;
						}
					}
				}
				vm.showSelector = false;
				vm.KPIS = kpis;
				if (!selectedKPIFound) {
					vm.selectedKPI = vm.KPIS[0];
					kpiSelected();
				}
				$timeout(function () {
					vm.showSelector = true;
					closeModal();
				}, 50)
			}


		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += (" " + herds[i]);
				}
			}
			return herdsString;
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			})
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('$destroy', function () {

			if (viz) {
				viz.dispose();
			}
		});

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('presalesAudit', presalesAudit);

	/** @ngInject */
	function presalesAudit() {
		var dir =  {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'presalesAuditModuleCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/presalesAudit/presalesAudit.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('mroModuleCtrl', mroModuleCtrl);

	/** @ngInject */
	function mroModuleCtrl($scope, $timeout, overviewService, $uibModal, $uibModalStack, $filter) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;

		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;

		function init() {

			vm.allKPIS = [
				{
					label: "Age at first insemination",
					kpi: 1,
					kpiValue: "Age at first insemination",
					db: 1,
					dbiValue: "First insemination",
					iid: 1,
					selected: true
				}, {
					label: "CR% at first insemination",
					kpi: 2,
					kpiValue: "CR% at first inseminetion",
					db: 2,
					dbiValue: "Over time",
					iid: 2,
					selected: true
				}, {
					label: "DIM at first insemination",
					kpi: 3,
					kpiValue: "DIM at first Insemination",
					db: 1,
					dbiValue: "First insemination",
					iid: 3,
					selected: true
				}, {
					label: "Conception rate",
					kpi: 4,
					kpiValue: "CR%",
					db: 2,
					dbiValue: "Over time",
					iid: 4,
					selected: true
				},
			]
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showMRO = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.mroUrl = getUrl(vm.dashboards);
				embedPage(vm.mroUrl, true);
				//local testing
				//embedPage(vm.mroUrl, false);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var reproDashboardId = $filter('i18n')('_mro_dashboard_id_');
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].subcategory == 'module-mro' && dashboards[i].id == reproDashboardId) {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard, useTabvis){

			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 2) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}
			if (!vm.herdsLimitReached) {
				var herdParam = createHerdParam(herds);
				if (dashboard) {
					vm.errorLoading = false;
					vm.dashboardNotAvailable = false;
					if (viz) {
						viz.dispose();
					}

					if(useTabvis){
						return overviewService
							.setSession(dashboard.url)
							.then(function (response) {
								var url = response.headers('tabvis-location');
								embed(url, herdParam);
							})
							.catch(function (error) {
								vm.errorLoading = true;
								console.log(error);
							});
					}else{
						if(vm.currentLng == "en-GB"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_en-GB_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}else if(vm.currentLng =="en-US"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_en-GB_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}else if(vm.currentLng =="fr-FR"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_fr-FR_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}else if(vm.currentLng =="de-DE"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_de-DE_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}else if(vm.currentLng =="nl-NL"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_nl-NL_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}else if(vm.currentLng =="pl-PL"){
							var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-module-MRO_pl-PL_twb/MROdashboard?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
						}

						embed(url, herdParam);
					}
				} else {
					vm.dashboardNotAvailable = true;
				}
			}

		}

		function embed(url, herdParameter){
			if (url) {
				url = url + '&:render=true&:refresh=yes';
				var endDate = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
				var startDate = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(3, 'years').toISOString());
				var options = {
					device: 'desktop',
					"Start Date": $filter('date')(startDate, "yyyy-MM-dd"),
					"End Date": $filter('date')(endDate, "yyyy-MM-dd"),
					onFirstInteractive: function () {

						workbook = viz.getWorkbook();
						var wrks = workbook.getActiveSheet().getWorksheets();
						var worksheetName;
						for (var i = 0; i < wrks.length; i++) {
							if (wrks[i].getName()) {
								worksheetName = wrks[i].getName();
								break;
							}
						}

						/*workbook.getParametersAsync().then(function (parameters) {
							console.log(parameters)
						});

						workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
							console.log(filters)
						})*/
						$timeout(function () {
							vm.disableSelector = false;
						}, 50)

					}
				}
				options["Herd Parameter"] = herdParameter;
				vm.showMRO = true;
				$timeout(function () {
					var containerDiv = document.getElementById("mroFrame");
					viz = new tableau.Viz(containerDiv, url, options);
				}, 100)
			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500)

			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
		}

		function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
			if (viz) {
				vm.disableSelector = true;
				if (responseTimeout) {
					$timeout.cancel(responseTimeout);
				}
				responseTimeout = $timeout(function () {
					vm.disableSelector = false;
				}, 10000);
				if (kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (param) {
						viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100)

						});
					})
				} else if (kpiChanged && !dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("KPIparam", kpi).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				} else if (!kpiChanged && dbChanged) {
					viz.getWorkbook().changeParameterValueAsync("Select DB", db).then(function (res) {
						$timeout(function () {
							vm.disableSelector = false;
						}, 100)
					});
				}
			}
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = angular.copy(vm.allKPIS)
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}


		}

		function saveKpis() {

			var selected = false;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					selected = true;
					break;
				}
			}
			if (selected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.allKPIS.length; j++) {
						if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
							vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				var kpis = [];
				var selectedKPIFound;
				for (var i = 0; i < vm.allKPIS.length; i++) {
					if (vm.allKPIS[i].selected) {
						kpis.push(vm.allKPIS[i]);
						if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
							selectedKPIFound = true;
						}
					}
				}
				vm.showSelector = false;
				vm.KPIS = kpis;
				if (!selectedKPIFound) {
					vm.selectedKPI = vm.KPIS[0];
					kpiSelected();
				}
				$timeout(function () {
					vm.showSelector = true;
					closeModal();
				}, 50)
			}


		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += (" " + herds[i]);
				}
			}
			return herdsString;
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			})
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('$destroy', function () {

			if (viz) {
				viz.dispose();
			}
		});

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('mro', mro);

	/** @ngInject */
	function mro() {
		var dir =  {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'mroModuleCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/MRO/MRO.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('masterKpiCtrl', masterKpiCtrl);

	/** @ngInject */
	function masterKpiCtrl($scope, $uibModal, $uibModalStack, $timeout, overviewService, permissionService, cookiesService) {
		var vm = this;
		var viz;
		var workbook;
		var worksheetName

		vm.openMasterKPI = openMasterKPI;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.setFilter = setFilter;
		vm.getFilters = getFilters;
		vm.openMasterKPIConfig = openMasterKPIConfig;
		vm.selectFrequency = selectFrequency;
		vm.saveConfig = saveConfig;
		vm.openKPISettings = openKPISettings;
		vm.periodTypeselected = periodTypeselected;
		vm.openRangeSelector = openRangeSelector;
		vm.setDateRange = setDateRange;
		vm.setPeriodType = setPeriodType;
		vm.useTableau = false;
		init();

		function init() {
			vm.allDatePeriodTypes = [
				/*{
				name: 'Last day',
				id: 1
			}, */
				{
					name: 'Current week',
					id: 2
			}, {
					name: 'Last week',
					id: 3
			}, {
					name: 'Current and last week',
					id: 4
			}, {
					name: 'Last two weeks',
					id: 5
			}, {
					name: 'Current month',
					id: 6
			}, {
					name: 'Last month',
					id: 7
			}, {
					name: 'Current quarter',
					id: 8
			}, {
					name: 'Last quarter',
					id: 9
			}, {
					name: 'Last 6 months',
					id: 10
			}, {
					name: 'Current year',
					id: 11
			}, {
					name: 'Last year',
					id: 12
			}, {
					name: 'Custom',
					id: 99
			}];
			vm.frequency = [false, false, true, false, false];
			vm.numberOfPeriods = 36;
			vm.endDate = new Date();
			vm.lastConfig = {
				frequency: angular.copy(vm.frequency),
				endDate: angular.copy(vm.endDate),
				numberOfPeriods: angular.copy(vm.numberOfPeriods),
				dashboardId: "MasterDashboardMonth"
			}
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.showPeriodSettings = false;
		}

		function openMasterKPI() {
			if (!vm.loading) {
				vm.showMasterKPI = false;
				if (vm.dashboards && vm.dashboards.length) {
					vm.masterKpiDashboard = getUrl(vm.dashboards, vm.lastConfig);
					embedPage(vm.masterKpiDashboard, vm.lastConfig);
				} else {
					vm.dashboardNotAvailable = true;
				}

				openModal('app/pages/overview/masterKpi/masterKpi.modal.html', 'lg', 'master-kpi-modal');
			}

		}

		function openMasterKPIConfig() {
			vm.showMasterConfig = true;
			vm.modalLoading = false;
			/*vm.lastConfig = {
				frequency: angular.copy(vm.frequency),
				endDate: angular.copy(vm.endDate),
				numberOfPeriods: angular.copy(vm.numberOfPeriods)
			}*/
		}

		function saveConfig() {

			var dateError;
			var NPError;
			var freqChanged;
			var SDChanged;
			var EDChanged;
			var startDate;
			var endDate;
			var dateFormat;
			var dFormat;
			var sheetName;
			var dashboardId;

			if (!vm.numberOfPeriods) {
				NPError = true;
				vm.NPError = true;
				removeError('NPError');
			}

			if (!vm.endDate) {
				dateError = true;
				vm.dateError = true;
				removeError('dateError');
			}
			if (vm.frequency[0]) {
				dateFormat = "day";
				dFormat = "d";
				sheetName = "Master Dashboard Day";
				dashboardId = "MasterDashboardDay";
			} else if (vm.frequency[1]) {
				dateFormat = "week";
				dFormat = "w";
				sheetName = "Master Dashboard Week";
				dashboardId = "MasterDashboardWeek";
			} else if (vm.frequency[2]) {
				dateFormat = "month";
				dFormat = "M";
				sheetName = "Master Dashboard Month";
				dashboardId = "MasterDashboardMonth";
			} else if (vm.frequency[3]) {
				dateFormat = "quarter";
				dFormat = "Q";
				sheetName = "Master Dashboard Quarter";
				dashboardId = "MasterDashboardQuarter";
			} else if (vm.frequency[4]) {
				dateFormat = "year";
				dFormat = "y";
				sheetName = "Master Dashboard Year";
				dashboardId = "MasterDashboardYear";
			}

			if (!NPError && !dateError) {
				if (vm.lastConfig.frequency[0] != vm.frequency[0] || vm.lastConfig.frequency[1] != vm.frequency[1] || vm.lastConfig.frequency[2] != vm.frequency[2] || vm.lastConfig.frequency[3] != vm.frequency[3] || vm.lastConfig.frequency[4] != vm.frequency[4]) {
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).hour(0).minute(0).seconds(1).millisecond(1).toISOString());

					freqChanged = true;
					SDChanged = true;
				}

				if (vm.lastConfig.numberOfPeriods != vm.numberOfPeriods) {
					SDChanged = true;
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).hour(0).minute(0).seconds(1).millisecond(1).toISOString());


				}

				if (moment(vm.lastConfig.endDate).format('YYYY-MM-DD') != moment(vm.endDate).format('YYYY-MM-DD')) {
					endDate = angular.copy(vm.endDate);
					startDate = new Date(moment(vm.endDate).subtract(vm.numberOfPeriods, dFormat).hour(0).minute(0).seconds(1).millisecond(1).toISOString());
					EDChanged = true;
					SDChanged = true;
				}

				
				vm.lastConfig = {
					frequency: angular.copy(vm.frequency),
					endDate: angular.copy(vm.endDate),
					numberOfPeriods: angular.copy(vm.numberOfPeriods),
					dashboardId: dashboardId
				}
				
				if (freqChanged) {
					vm.mainKPIDashboards = getUrl(vm.dashboards, vm.lastConfig);
					embedPage(vm.mainKPIDashboards, vm.lastConfig);
				} else {
					checkStartEndDate(SDChanged, EDChanged, startDate, endDate);
				}

				function checkStartEndDate(sdc, edc, sd, ed) {
					if (sdc && edc) {
						workbook.changeParameterValueAsync('Start Date', sd).then(function (param) {
							workbook.changeParameterValueAsync('End Date', ed);
						})
					} else if (sdc && !edc) {
						workbook.changeParameterValueAsync('Start Date', sd);
					}
				}

				
				vm.showMasterConfig = false;
			}


		}

		function removeError(name) {
			$timeout(function () {
				vm[name] = false;
			}, 2000)
		}

		function selectFrequency(index) {
			for (var i = 0; i < vm.frequency.length; i++) {
				if (i == index) {
					vm.frequency[i] = true;
				} else {
					vm.frequency[i] = false;
				}
			}
		}

		function closeModal() {
			if (viz) {
				viz.dispose();
			}
			$uibModalStack.dismissAll();
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			})
		}

		function getUrl(dashboards, lastConfig) {
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == lastConfig.dashboardId) {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard, lastConfig) {
			if (dashboard) {
				vm.dashboardNotAvailable = false;
				if (viz) {
					viz.dispose();
				}
				var freq = getFrequency(vm.lastConfig.frequency);
				var endDate = moment(lastConfig.endDate).hour(23).minute(59).seconds(59).millisecond(999).toISOString();
				var startDate = moment(lastConfig.endDate).hour(23).minute(59).seconds(59).millisecond(999).subtract(vm.lastConfig.numberOfPeriods, freq).toISOString();


				if (vm.useTableau) {
					return overviewService.setSession(dashboard.url).then(function (response) {
						var url = response.headers('tabvis-location');
						//local testing
						if (url) {
							embed(url, startDate, endDate, freq);
						}

					}).catch(function (error) {
						console.log(error)
					})
				} else {
					var url = dashboard.url;
					if (url) {
						embed(url, startDate, endDate, freq);
					}
				}
			} else {
				vm.dashboardNotAvailable = true;
			}



		}

		function embed(url, startDate, endDate, freq) {
			var measureNames;
			measureNames = setMeasureNamesFilter();
			url = url + '&:render=true&:refresh=yes'
			var options = {
				device: 'desktop',
				"Start Date": moment(startDate).format("YYYY-MM-DD"),
				"End Date": moment(endDate).format("YYYY-MM-DD"),
				//HerdIdentifier: [],
				"Measure Names": measureNames,
				"dateFormat": freq,
				onFirstInteractive: function () {
					workbook = viz.getWorkbook();
					var wrks = workbook.getActiveSheet().getWorksheets();
					worksheetName;
					for (var i = 0; i < wrks.length; i++) {
						if (wrks[i].getName()) {
							worksheetName = wrks[i].getName();
							break;
						}
					}

					/*workbook.getParametersAsync().then(function (parameters) {
						console.log(parameters)
					});

					workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
						console.log(filters)
					})*/

				}
			}
			/*if (vm.selectedHerds.length > 0) {
				var herdParams = [];
				for (var k = 0; k < vm.selectedHerds.length; k++) {
					herdParams.push(vm.selectedHerds[k])
				}
				options.HerdIdentifier = herdParams;
			}*/
			vm.showMasterKPI = true;
			$timeout(function () {
				var containerDiv = document.getElementById("masterKPIFrame");
				viz = new tableau.Viz(containerDiv, url, options);
			}, 300)
		}

		function getFrequency(obj) {
			var f;
			if (obj[0]) {
				f = "day";
			} else if (obj[1]) {
				f = "week";
			} else if (obj[2]) {
				f = "month";
			} else if (obj[3]) {
				f = "quarter";
			} else if (obj[4]) {
				f = "year";
			}
			return f;
		}

		function setMeasureNamesFilter() {
			var list = [];

			//check claw health permission 
			if (permissionService.can(42)) {
				var clawHealthFilterValues = [
				"[sqlproxy.0vc1z960xu8u74193hgyy0hhq60n].[usr:Calculation_744219862621671428:qk]",
				"[sqlproxy.0vc1z960xu8u74193hgyy0hhq60n].[usr:Calculation_744219862624780293:qk]"];
				list = list.concat(clawHealthFilterValues);
			}

			//check repro permission 
			if (permissionService.can(42)) {
				var reproFilterValues = [
					"[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[avg:Interval:qk]",
					"[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838913212438:qk]",
					"[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838914420759:qk]",
					"[sqlproxy.1s3hra30l0i1rh12huuez0oidv3c].[usr:Calculation_418271838914899992:qk]"];
				list = list.concat(reproFilterValues);
			}

			//check feed permission 
			if (permissionService.can(423)) {
				var feedFilterValues = [
					"[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:IntakeConsumedKg:qk]",
					"[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:IntakeProgrammedKg:qk]",
					"[sqlproxy.10c8hcb01qef7018jo67h1eepzjz].[avg:LeftoverKg:qk]"];
				list = list.concat(feedFilterValues);
			}

			//check milk permission 
			if (permissionService.can(42)) {
				var milkFilterValues = [
					"[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:CalculatedSPP:qk]",
					"[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:DaysInMilk:qk]",
					"[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[avg:MilkYieldKg:qk]"];
				list = list.concat(milkFilterValues);
			}

			return list;

		}

		function setFilter() {
			workbook.getActiveSheet().getWorksheets().get(worksheetName).applyFilterAsync("Measure Names", ["[sqlproxy.0ip42ym0bds6jr1h0wu8d0mfx9z8].[sum:DaysInMilk:qk]"], tableau.FilterUpdateType.REPLACE).then(function (response) {});
		}

		function getFilters() {
			console.log('get ')
			workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
				for (var i = 0; i < filters.length; i++) {
					var n = filters[i].getFieldName()
					var f = filters.get(n).getAppliedValues();
				}
			})

			workbook.getParametersAsync().then(function (parameters) {
				console.log(parameters)
			});
		}

		function saveKpis() {
			vm.modalLoading = true;
			vm.kpidashboards = angular.copy(vm.KPIS);
			setKPICookie(vm.kpidashboards);
			$timeout(function () {
				closeModal();
				vm.setKpis();
				vm.modalLoading = false;
			}, 1234)

		}

		function setKPICookie(dashboards) {
			var list = [];
			for (var i = 0; i < dashboards.length; i++) {
				var obj = {
					iid: dashboards[i].iid,
					datePeriod: dashboards[i].datePeriod,
					selected: dashboards[i].selected,
				}
				if (dashboards[i].datePeriod == 99) {
					obj.startDate = new Date(dashboards[i].startDate).toISOString();
					obj.endDate = new Date(dashboards[i].endDate).toISOString();
				}
				list.push(obj);
			}
			var cookie = JSON.stringify(list);
			var cookieName = vm.user.email + "_KPI";
			var expireDate = moment().add(1, 'years');
			expireDate = new Date(expireDate);
			cookiesService.setCookie(cookieName, cookie, {
				expires: expireDate,
				samesite: "Strict"
			});
		}

		function openKPIConfig() {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.searchString = '';
				vm.KPIS = angular.copy(vm.kpidashboards);
				openModal('app/pages/overview/masterKpi/kpiConf.modal.html', 'md');
			}
		}

		function openKPISettings(kpi) {
			vm.selectedKPI = angular.copy(kpi);
			vm.datePeriodTypes = angular.copy(vm.allDatePeriodTypes);
			vm.selectedPeriodType = getPeriodById(kpi.datePeriod);
			vm.settingsStartEndDate = {
				start_date: kpi.startDate,
				end_date: kpi.endDate
			}
			vm.showPeriodSettings = true;
		}

		function periodTypeselected() {
			vm.settingsStartEndDate = getStartEndDateByPeriod(vm.selectedPeriodType.id);

		}

		function getPeriodById(id) {
			var period;
			for (var i = 0; i < vm.allDatePeriodTypes.length; i++) {
				if (id == vm.allDatePeriodTypes[i].id) {
					period = vm.allDatePeriodTypes[i];
					break;
				}
			}
			return period;
		}

		function getStartEndDateByPeriod(periodType) {
			var obj = {};
			if (periodType == 1) {
				obj.start_date = null;
				obj.end_date = new Date(moment().format());
			} else if (periodType == 2) {
				obj.start_date = new Date(moment().startOf('isoWeek').format())
				obj.end_date = new Date(moment().endOf('isoWeek').format())
			} else if (periodType == 3) {
				obj.start_date = new Date(moment().subtract(1, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().subtract(1, 'weeks').endOf('isoWeek').format());
			} else if (periodType == 4) {
				obj.start_date = new Date(moment().subtract(1, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().endOf('isoWeek').format());
			} else if (periodType == 5) {
				obj.start_date = new Date(moment().subtract(2, 'weeks').startOf('isoWeek').format());
				obj.end_date = new Date(moment().subtract(1, 'weeks').endOf('isoWeek').format());
			} else if (periodType == 6) {
				obj.start_date = new Date(moment().startOf('month').format());
				obj.end_date = new Date(moment().endOf('month').format());
			} else if (periodType == 7) {
				obj.start_date = new Date(moment().subtract(1, 'months').startOf('month').format());
				obj.end_date = new Date(moment().subtract(1, 'months').endOf('month').format());
			} else if (periodType == 8) {
				obj.start_date = new Date(moment().startOf('quarter').format());
				obj.end_date = new Date(moment().endOf('quarter').format());
			} else if (periodType == 9) {
				obj.start_date = new Date(moment().subtract(1, 'quarters').startOf('quarter').format());
				obj.end_date = new Date(moment().subtract(1, 'quarters').endOf('quarter').format());
			} else if (periodType == 10) {
				obj.start_date = new Date(moment().subtract(5, 'months').startOf('month').format());
				obj.end_date = new Date(moment().endOf('month').format());
			} else if (periodType == 11) {
				obj.start_date = new Date(moment().startOf('year').format());
				obj.end_date = new Date(moment().endOf('year').format());
			} else if (periodType == 12) {
				obj.start_date = new Date(moment().subtract(1, 'years').startOf('year').format());
				obj.end_date = new Date(moment().subtract(1, 'years').endOf('year').format());
			} else if (periodType == 99) {
				obj.start_date = new Date(moment().subtract(1, 'months').format());
				obj.end_date = new Date(moment().format());
			}
			return obj;
		}

		function openRangeSelector() {
			vm.modal_start_date = angular.copy(vm.settingsStartEndDate.start_date);
			vm.modal_end_date = angular.copy(vm.settingsStartEndDate.end_date);
			vm.timePickerError = false;
			vm.showDateSelector = true;

		}

		function setDateRange() {
			var range_error = checkRangeError(vm.modal_start_date, vm.modal_end_date);
			if (range_error) {
				vm.timePickerError = true;
			} else {
				vm.settingsStartEndDate.start_date = angular.copy(vm.modal_start_date);
				vm.settingsStartEndDate.end_date = angular.copy(vm.modal_end_date);
				vm.showDateSelector = false;
			}
		}

		function setPeriodType() {
			for (var i = 0; i < vm.KPIS.length; i++) {
				if (vm.KPIS[i].id == vm.selectedKPI.id) {
					vm.KPIS[i].datePeriod = vm.selectedPeriodType.id;
					vm.KPIS[i].startDate = angular.copy(vm.settingsStartEndDate.start_date);
					vm.KPIS[i].endDate = angular.copy(vm.settingsStartEndDate.end_date);
				}
			}
			vm.showPeriodSettings = false;
		}

		function checkRangeError(start_date, end_date) {
			var error = false;
			var today = moment().hour(23).minute(59).seconds(59).millisecond(999);
			if (today.isBefore(start_date)) {
				error = true;
			}

			if (moment(end_date).isBefore(start_date)) {
				error = true;
			}
			return error;
		}


		$scope.$on('$destroy', function () {

			if (viz) {
				viz.dispose();
			}
		});

	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('masterKpi', masterKpi);

	/** @ngInject */
	function masterKpi() {
		var dir = {
			restrict: 'AE',
			scope: {
				dashboards: '=',
				kpidashboards: '=',
				loading: '=',
				setKpis: '&',
			},
			link: link,
			controller: 'masterKpiCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/masterKpi/masterKpi.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
		
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview').controller('productionModuleCtrl', productionModuleCtrl);

	/** @ngInject */
	function productionModuleCtrl($scope, $timeout, overviewService, $uibModal, $uibModalStack, $filter) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;

		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;

		function init() {
			vm.allKPIS = [
				{
					label: 'Age at first insemination',
					kpi: 1,
					kpiValue: 'Age at first insemination',
					db: 1,
					dbiValue: 'First insemination',
					iid: 1,
					selected: true
				},
				{
					label: 'CR% at first insemination',
					kpi: 2,
					kpiValue: 'CR% at first inseminetion',
					db: 2,
					dbiValue: 'Over time',
					iid: 2,
					selected: true
				},
				{
					label: 'DIM at first insemination',
					kpi: 3,
					kpiValue: 'DIM at first Insemination',
					db: 1,
					dbiValue: 'First insemination',
					iid: 3,
					selected: true
				},
				{
					label: 'Conception rate',
					kpi: 4,
					kpiValue: 'CR%',
					db: 2,
					dbiValue: 'Over time',
					iid: 4,
					selected: true
				}
			];
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showProduction = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.productionUrl = getUrl(vm.dashboards);
				embedPage(vm.productionUrl, true);
				//local testing
				//embedPage(vm.productionUrl, false);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function getUrl(dashboards) {
			var productionDashboardId =  $filter('i18n')('_milk_meter_dashboard_id_');
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].subcategory == 'milk-meter-module' && dashboards[i].id == productionDashboardId) {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard, useTabvis) {
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 2) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}
			if (!vm.herdsLimitReached) {
				var herdParam = createHerdParam(herds);
				if (dashboard) {
					vm.errorLoading = false;
					vm.dashboardNotAvailable = false;
					if (viz) {
						viz.dispose();
					}

					if (useTabvis) {
						return overviewService
							.setSession(dashboard.url)
							.then(function (response) {
								var url = response.headers('tabvis-location');
								embed(url, herdParam);
							})
							.catch(function (error) {
								vm.errorLoading = true;
								console.log(error);
							});
					} else {
						if (vm.currentLng == 'en-GB') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_en-GB_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'en-US') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_en-GB_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'fr-FR') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_fr-FR_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'de-DE') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_de-DE_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'nl-NL') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_nl-NL_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						} else if (vm.currentLng == 'pl-PL') {
							var url = 'https://visual-stg.mmmooogle.com/t/Development/views/team-1-production-milk-meter-module_pl-PL_twb/Milkyield?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
						}
						embed(url, herdParam);
					}
				} else {
					vm.dashboardNotAvailable = true;
				}
			}
		}

		function embed(url, herdParameter) {
			if (url) {
				var endDate = new Date(moment().hour(23).minute(59).seconds(59).millisecond(999));
				var startDate = new Date(moment().hour(0).minute(0).seconds(1).millisecond(1).subtract(3, 'years').toISOString());
				var options = {
					device: 'desktop',
					'Start Date': $filter('date')(startDate, 'yyyy-MM-dd'),
					'End Date': $filter('date')(endDate, 'yyyy-MM-dd'),
					onFirstInteractive: function () {
						workbook = viz.getWorkbook();
						var wrks = workbook.getActiveSheet().getWorksheets();
						var worksheetName;
						for (var i = 0; i < wrks.length; i++) {
							if (wrks[i].getName()) {
								worksheetName = wrks[i].getName();
								break;
							}
						}

						/*	workbook.getParametersAsync().then(function (parameters) {
								console.log(parameters)
							});

							workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
								console.log(filters)
							})*/
						$timeout(function () {
							vm.disableSelector = false;
						}, 50);
					}
				};
				options['Herd Parameter'] = herdParameter;
				vm.showProduction = true;
				$timeout(function () {
					var containerDiv = document.getElementById('productionFrame');
					viz = new tableau.Viz(containerDiv, url, options);
				}, 100);
			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500);
			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
		}

		function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
			if (viz) {
				vm.disableSelector = true;
				if (responseTimeout) {
					$timeout.cancel(responseTimeout);
				}
				responseTimeout = $timeout(function () {
					vm.disableSelector = false;
				}, 10000);
				if (kpiChanged && dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('KPIparam', kpi)
						.then(function (param) {
							viz.getWorkbook()
								.changeParameterValueAsync('Select DB', db)
								.then(function (res) {
									$timeout(function () {
										vm.disableSelector = false;
									}, 100);
								});
						});
				} else if (kpiChanged && !dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('KPIparam', kpi)
						.then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100);
						});
				} else if (!kpiChanged && dbChanged) {
					viz.getWorkbook()
						.changeParameterValueAsync('Select DB', db)
						.then(function (res) {
							$timeout(function () {
								vm.disableSelector = false;
							}, 100);
						});
				}
			}
		}

		function openKPIConfig(module) {
			if (!vm.loading) {
				vm.modalLoading = false;
				vm.KPIFilters = angular.copy(vm.allKPIS);
				openModal('app/pages/overview/kpiConfig.modal.html', 'md');
			}
		}

		function saveKpis() {
			var selected = false;
			for (var i = 0; i < vm.KPIFilters.length; i++) {
				if (vm.KPIFilters[i].selected) {
					selected = true;
					break;
				}
			}
			if (selected) {
				for (var i = 0; i < vm.KPIFilters.length; i++) {
					for (var j = 0; j < vm.allKPIS.length; j++) {
						if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
							vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
						}
					}
				}
				var kpis = [];
				var selectedKPIFound;
				for (var i = 0; i < vm.allKPIS.length; i++) {
					if (vm.allKPIS[i].selected) {
						kpis.push(vm.allKPIS[i]);
						if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
							selectedKPIFound = true;
						}
					}
				}
				vm.showSelector = false;
				vm.KPIS = kpis;
				if (!selectedKPIFound) {
					vm.selectedKPI = vm.KPIS[0];
					kpiSelected();
				}
				$timeout(function () {
					vm.showSelector = true;
					closeModal();
				}, 50);
			}
		}

		function createHerdParam(herds) {
			var herdsString = '';

			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function openModal(template, size, wClass) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				scope: $scope,
				backdrop: 'static',
				keyboard: false,
				size: size,
				windowClass: wClass ? wClass : ''
			});
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		$scope.$on('$destroy', function () {
			if (viz) {
				viz.dispose();
			}
		});
	}
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('production', production);

	/** @ngInject */
	function production() {
		var dir =  {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'productionModuleCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/production/production.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.postSalesReport').controller('postSalesReportCtrl', postSalesReportCtrl);
	/** @ngInject */
	function postSalesReportCtrl($timeout, postSalesReportService, $q, APP_CONSTANTS, $rootScope, $http, $scope, $filter, $window, dashboardsService, $location, Upload, $cookies, $uibModal, $uibModalStack, herdDashboardsService) {
		var vm = this;
		var teamTimeout;
		var herdChangeTimeout;
		var viz;
		var timeout;
		var herdParamName;
		var oldSheetName;
		var newSheetName;
		var dataDashboardSheetName;
		var dataDashboardSheetNameCulling;
		var viewDataDashboardName;
		var viewDataDashboardNameCulling;
		var viewDataDashboardNameHealth;
		var dataDashboardNameHealth;
		var measureNameParam;
		var kpiTableName;
		var kpiTableNameResponseKpi;
		var kpiTableNameDPRKpi;
		var kpiTableNameGenomic;
		var kpiTableNameGenomicNetMerit;
		var dateFilterSheetName;
		var dateFilterName;
		var mapTimeout;
		var postSalesReportFilterPairs = APP_CONSTANTS.constants.postSalesReportFilterPairs;
		vm.goBack = goBack;
		vm.init = init;
		vm.sendErrorInfo = sendErrorInfo;
		vm.closeModal = closeModal;
		init();

		function init() {
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			if(!herdDashboardsService.excludeUsers(vm.user)){
				try {
					gtag('event', 'zoetis-postsales', {
						user_id: vm.user.user_id
					});
				} catch (error) {
					console.log(error);
				}
			}
			
			vm.currentDate = null;
			setStrings();
			setBackButtonVisibility(false);
			if (teamTimeout) {
				$timeout.cancel(teamTimeout);
			}
			vm.dashboards = [];
			vm.errorLoading = false;
			vm.loadingDashboards = true;
			vm.showButtons = false;
			vm.noAvailableDashboards = false;
			vm.reselectTeamError = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.user = JSON.parse(localStorage.getItem('user_profile'));
			var lng = localStorage.getItem('lng');
			if (lng) {
				if (lng == 'es-ES' || lng == 'ja-JP' || lng == 'cs-CZ') {
					vm.currentLng = 'en-GB';
				} else {
					vm.currentLng = lng;
				}
			} else {
				vm.currentLng = 'en-GB';
			}
			if (vm.defaultValues && vm.defaultValues.herd_ids) {
				vm.selectedTeam = vm.defaultValues.team_id;
				vm.selectedHerds = vm.defaultValues.herd_ids;
			} else {
				vm.selectedHerds = [];
			}
			if (vm.defaultValues && vm.defaultValues.team_id) {
				getDashboards(vm.defaultValues.team_id);
			} else {
				teamTimeout = $timeout(function () {
					vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
					if (vm.defaultValues && vm.defaultValues.team_id) {
						getDashboards(vm.defaultValues.team_id);
					} else {
						vm.embed = null;
						vm.loadingDashboards = false;
						vm.reselectTeamError = true;
					}
				}, 5000);
			}
		}

		function setStrings() {
			dataDashboardSheetName = $filter('i18n')('_show_all_data_dashboard_name_');
			viewDataDashboardName = $filter('i18n')('_dashboard_name_show_data_');
			viewDataDashboardNameCulling = 'Show data Culling';
			dataDashboardSheetNameCulling = 'Show data herd response culling';
			viewDataDashboardNameHealth = 'Show data Health';
			dataDashboardNameHealth = 'Show data health response';
			herdParamName = 'Herd Parameter';
			measureNameParam = 'Measure name parameter';
			kpiTableName = 'Sires Of Conception Table';
			kpiTableNameResponseKpi = 'Herd Response Milk KPIs';
			dateFilterSheetName = 'Trends navigation worksheet';
			dateFilterName = 'Date2';
			kpiTableNameDPRKpi = 'Herd Response DPR KPIs';
			kpiTableNameGenomic = 'Genomic Testing DWP KPIs';
			kpiTableNameGenomicNetMerit = 'Genomic Testing Net Merit KPIs';
		}

		function getDashboards(team_id) {
			var dashboards = angular.copy(dashboardsService.loadedDashboards);
			//local testing
			/*dashboards.dashboards = [{
				"id": $filter('i18n')('_dashboard_id_herd_inventory_'),
				"description": "Production dashboard",
				"category": "reproduction",
				"subcategory": "post-sales-audit",
				"locale": "en-GB",
				"url": "https://tabvis-dev.mmmooogle.com/dashboard?id=Reproductiondashboard&category=reproduction&subcategory=module&locale=en-GB"
			}];
			dashboards.team_id = team_id;
			dashboards.expires = new Date("2100-12-31");*/
			if (dashboards.dashboards && dashboards.team_id == team_id) {
				if (moment(dashboards.expires).isBefore(moment())) {
					useAPI(team_id);
				} else {
					processDashboards(dashboards.dashboards, team_id);
				}
			} else {
				useAPI(team_id);
			}
		}

		function useAPI(team_id) {
			localStorage.setItem('tableauLoading', true);
			timeout = $q.defer();
			var setSession = setSessionHandler(team_id);
			setSession.then(
				function (data) {
					var tableauSuffix = '?locale=' + vm.currentLng;
					return postSalesReportService
						.getDashboards(team_id, tableauSuffix)
						.then(function (response) {
							var obj = {
								dashboards: response,
								expires: moment().add(30, 'minutes').format(),
								team_id: team_id
							};
							dashboardsService.loadedDashboards = obj;
							localStorage.removeItem('tableauLoading');
							$rootScope.$broadcast('tableau_loaded');
							processDashboards(response, team_id);
						})
						.catch(function (error) {
							localStorage.removeItem('tableauLoading');
							vm.loadingDashboards = false;
							vm.errorLoading = true;
						});
				},
				function (error) {
					if (!vm.teamReselected) {
						localStorage.removeItem('tableauLoading');
						vm.loadingDashboards = false;
						vm.errorLoading = true;
					} else {
						vm.teamReselected = false;
					}
				}
			);
		}

		function setSessionHandler(team_id) {
			var result = $q.defer(),
				setSession,
				url = APP_CONSTANTS.tableau_base_url + team_id + '/session';
			setSession = $http({
				method: 'post',
				url: url,
				data: {},
				cache: false,
				timeout: timeout.promise,
				withCredentials: true
			});
			setSession.success(function (data, status, headers, config) {
				result.resolve(data);
			});
			setSession.error(function (data, status, headers, config) {
				result.reject(data);
			});
			return result.promise;
		}

		function processDashboards(response, team_id) {
			var postSalesReportId = $filter('i18n')('_dashboard_id_herd_inventory_');
			if (response.length > 0) {
				var dashboards = [];
				for (var i = 0; i < response.length; i++) {
					if (response[i].subcategory == 'post-sales-audit' && response[i].id == postSalesReportId) {
						vm.postSalesReport = response[i];
					}
				}
				vm.allDashboards = response;
				vm.dashboards = dashboards;
				vm.mapActive = vm.postSalesReport;
				if (vm.postSalesReport) {
					embedPage(vm.postSalesReport, true);
					//local testing
					//embedPage(vm.postSalesReport, false);
					mapTimeout = $timeout(function () {
						var height = document.getElementById('panel-map').offsetHeight;
						if (height == 666) {
							try {
								var bodyHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
								var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
								if (bodyWidth > 767) {
									var newHeight = bodyHeight - 300;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 330;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('postSalesReportFrame').style.height = newHeightFrame + 'px';
								} else {
									var newHeight = bodyHeight - 435;
									document.getElementById('panel-map').firstChild.style.height = newHeight + 'px';
									var newHeightFrame = bodyHeight - 465;
									document.getElementById('dashboard-area').style.height = newHeightFrame + 'px';
									document.getElementById('postSalesReportFrame').style.height = newHeightFrame + 'px';
								}
							} catch (error) {
								console.log(error);
							}
						}
					}, 0);
				} else {
					vm.embed = null;
					vm.loadingDashboards = false;
					vm.noAvailableDashboards = true;
				}
			} else {
				vm.embed = null;
				vm.loadingDashboards = false;
				vm.noAvailableDashboards = true;
			}
		}

		function embedPage(dashboard, useTabvis) {
			sendShowPanicButtonEvent(false);
			vm.currentSheetName = angular.copy(dashboard.description);
			vm.loadingDashboards = false;
			var url = dashboard.url;
			vm.workSheetName = dashboard.description;
			$rootScope.$broadcast('home_dashboard_embedded', dashboard.description);
			embedUrl(url, useTabvis);
		}

		function embedUrl(url, useTabvis) {
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 20) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}

			if (!vm.herdsLimitReached) {
				if (useTabvis) {
					return postSalesReportService
						.setSession(url)
						.then(function (response) {
							vm.loadingDashboards = false;
							vm.showButtons = true;
							var url = response.headers('tabvis-location');
							embed(url, herds, useTabvis);
						})
						.catch(function (response) {
							vm.embed = null;
							vm.errorLoading = true;
							vm.loading = false;
							console.log('error getting tabvis-location header');
						});
				} else {
					if (vm.currentLng == 'en-GB') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_en-GB_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'en-US') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_en-GB_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'fr-FR') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_fr-FR_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'de-DE') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_de-DE_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'nl-NL') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_nl-NL_twb/Bedrijfsoverzicht?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					} else if (vm.currentLng == 'pl-PL') {
						var url = 'https://visual-prd.mmmooogle.com/t/Production/views/team-3091-reproduction-post-sales-audit_pl-PL_twb/Herdinventory?:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no';
					}
					embed(url, herds, useTabvis);
				}
			}
		}

		function embed(url, herds, useTabvis) {
			var herdParam = createHerdParam(herds);

			var deviceType;
			var parser = new UAParser();
			var device = parser.getDevice();
			if (device && device.type) {
				if (device.type == 'mobile') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else if (device.type == 'tablet') {
					deviceType = 'tablet';
				} else if (device.type == 'smarttv') {
					deviceType = 'desktop';
				} else if (device.type == 'wearable') {
					//deviceType = 'phone';
					deviceType = 'tablet';
				} else {
					//deviceType = 'phone';
					deviceType = 'tablet';
				}
			} else {
				if (window.screen.height <= 900) {
					deviceType = 'tablet';
				} else {
					deviceType = 'desktop';
				}
			}
			if (url) {
				var options = {
					device: deviceType,
					onFirstInteractive: function () {
						/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
								console.log(parameters)
							})*/
						var wrks = viz.getWorkbook().getActiveSheet().getWorksheets();
						viz.getWorkbook()
							.changeParameterValueAsync(measureNameParam, '0')
							.then(function (param) {
								wrks.get(dateFilterSheetName)
									.getFiltersAsync()
									.then(function (filters) {
										var date = filters.get(dateFilterName).getDomainMax().value;
										$timeout(function () {
											vm.currentDate = $filter('date')(new Date(date), 'shortDate');
										}, 0);
									});
							});

						$timeout(function () {
							sendShowPanicButtonEvent(true);
						}, 100);
					}
				};
				options[herdParamName] = herdParam;

				$timeout(function () {
					var containerDiv = document.getElementById('postSalesReportFrame');
					viz = new tableau.Viz(containerDiv, url, options);
					viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, onTabSwitch);
					viz.addEventListener(tableau.TableauEventName.MARKS_SELECTION, onMarkSelection);
				}, 1000);
			}
		}

		function onMarkSelection(event) {
			vm.lastSelectedMark = event.getWorksheet().getName();
			var wsName = event.getWorksheet().getName();
			if (wsName == 'Heifers' || wsName == 'Herd') {
				viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
			}
		}

		function createHerdParam(herds) {
			var herdsString = '';
			for (var i = 0; i < herds.length; i++) {
				if (i == 0) {
					herdsString += herds[i];
				} else {
					herdsString += ' ' + herds[i];
				}
			}
			return herdsString;
		}

		function onTabSwitch(marksEvent) {
			var wrks = marksEvent.getViz().getWorkbook().getActiveSheet().getWorksheets();
			var worksheetName;
			oldSheetName = marksEvent.getOldSheetName();
			newSheetName = marksEvent.getNewSheetName();
			vm.lastSheetName = oldSheetName;

			if (marksEvent.getEventName() == 'tabswitch') {
				for (var i = 0; i < wrks.length; i++) {
					var name = wrks[i].getName();
					if (name) {
						worksheetName = name;
						break;
					}
				}
				if (newSheetName == viewDataDashboardName || newSheetName == viewDataDashboardNameCulling || newSheetName == viewDataDashboardNameHealth) {
					vm.filterDashboardName;

					if (newSheetName == viewDataDashboardName) {
						vm.filterDashboardName = dataDashboardSheetName;
					} else if (newSheetName == viewDataDashboardNameHealth) {
						vm.filterDashboardName = dataDashboardNameHealth;
					} else {
						vm.filterDashboardName = dataDashboardSheetNameCulling;
					}
					var activeFilterName = getActiveFilterName(vm.lastSelectedMark);
					//console.log(vm.lastSelectedMark)
					//console.log(activeFilterName)
					if (vm.lastSelectedMark != kpiTableName && vm.lastSelectedMark != kpiTableNameResponseKpi && vm.lastSelectedMark != kpiTableNameDPRKpi && vm.lastSelectedMark != kpiTableNameGenomic && vm.lastSelectedMark != kpiTableNameGenomicNetMerit) {
						checkFilters(wrks, vm.filterDashboardName, activeFilterName);
					} else {
						checkFilters(wrks, vm.filterDashboardName, 'empty');
					}
					setBackButtonVisibility(true);
				} else {
					viz.getWorkbook().changeParameterValueAsync(measureNameParam, '0');
					setBackButtonVisibility(false);
				}

				/*viz.getWorkbook().getParametersAsync().then(function (parameters) {
					console.log(parameters)
				})
				viz.getWorkbook().getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filter) {
					console.log(filter)
				})*/
			}
		}

		function checkFilters(wrks, sheet_name, filter_name) {
			vm.actionFilterList = [];
			wrks.get(sheet_name)
				.getFiltersAsync()
				.then(function (filters) {
					var l = filters.length;
					var actionFilterList = [];
					vm.actionFilterList = [];
					for (var i = 0; i < l; i++) {
						var name = filters[i].getFieldName();
						if (name.indexOf('Action') != -1) {
							actionFilterList.push(name);
						}
					}
					if (actionFilterList.length > 0 && filter_name) {
						var listToClear = [];
						var l = actionFilterList.length;
						for (var i = 0; i < l; i++) {
							if (actionFilterList[i] != filter_name) {
								listToClear.push(actionFilterList[i]);
							} else {
								vm.actionFilterList.push(actionFilterList[i]);
							}
						}

						var ll = listToClear.length;
						if (ll > 0) {
							for (var i = 0; i < ll; i++) {
								resetFilter(listToClear[i]);
							}
						}
						//console.log('clear', listToClear)
					} else {
						vm.actionFilterList = actionFilterList;
					}

					//console.log('action', vm.actionFilterList)
				});
		}

		function resetFilter(filter) {
			viz.getWorkbook().getActiveSheet().getWorksheets().get(vm.filterDashboardName).clearFilterAsync(filter);
		}

		function getActiveFilterName(mark) {
			var filter;
			var list = postSalesReportFilterPairs;
			var l = list.length;
			for (var i = 0; i < l; i++) {
				if (list[i].mark == mark && vm.currentLng == list[i].lng) {
					filter = list[i].filter;
					break;
				}
			}
			return filter;
		}

		function goBack() {
			var l = vm.actionFilterList.length;
			if (l > 0) {
				resetFilterN(0);
			} else {
				viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
				setBackButtonVisibility(false);
			}

			function resetFilterBack(filter) {
				var d = $q.defer();
				viz.getWorkbook()
					.getActiveSheet()
					.getWorksheets()
					.get(vm.filterDashboardName)
					.clearFilterAsync(filter)
					.then(function (response) {
						d.resolve();
					});

				return d.promise;
			}

			function resetFilterN(index) {
				return resetFilterBack(vm.actionFilterList[index]).then(function () {
					index++;
					if (index < l) {
						resetFilterN(index);
					} else {
						viz.getWorkbook().activateSheetAsync(vm.lastSheetName);
						setBackButtonVisibility(false);
					}
				});
			}
		}

		function setBackButtonVisibility(display) {
			$timeout(function () {
				vm.showBackButton = display;
			}, 0);
		}

		function setHerdParameter(param, value) {
			var control = 0;
			set(param, value);
			function set(parameter, herdValue) {
				if (control < 6) {
					try {
						viz.getWorkbook().changeParameterValueAsync(parameter, herdValue);
					} catch (error) {
						console.log('try again to set parameter');
						control++;
						$timeout(function () {
							set(parameter, herdValue);
						}, 500);
					}
				} else {
					console.log('reinitialize');
					init();
				}
			}
		}

		function closeModal() {
			$uibModalStack.dismissAll();
		}

		function openModal(template, size) {
			$uibModal.open({
				animation: true,
				templateUrl: template,
				size: size,
				scope: $scope,
				backdrop: 'static',
				keyboard: false
			});
		}

		function sendErrorInfo(comment) {
			if (viz) {
				vm.errorInfo = {
					sheet: '',
					comment: comment,
					herds: vm.selectedHerds,
					team: vm.selectedTeam,
					mmmooogle_tenant: null,
					parameters: [],
					filters: [],
					user_id: vm.user.user_id,
					host: $location.host(),
					url: $location.url(),
					last_selected_mark: vm.lastSelectedMark ? vm.lastSelectedMark : '/',
					dashboard: 'Post Sales',
					last_sheet_name: vm.lastSheetName ? vm.lastSheetName : '/'
				};
				vm.modalError = false;
				vm.modalLoading = true;
				var parameters;
				var filters;
				var p = $q.defer();
				var f = $q.defer();

				var cookies = $cookies.getAll();
				angular.forEach(cookies, function (value, key) {
					if (key == 'mmmooogle_tenant') {
						vm.errorInfo.mmmooogle_tenant = value;
					}
				});

				$q.all([p.promise, f.promise])
					.then(function (response) {
						var p_list = [];
						var f_list = [];

						if (parameters) {
							for (var i = 0; i < parameters.length; i++) {
								var obj = {
									name: null,
									value: null,
									formated_value: null
								};

								obj.name = parameters[i].getName();
								obj.value = parameters[i].getCurrentValue().value;
								obj.formated_value = parameters[i].getCurrentValue().formattedValue;

								p_list.push(obj);
							}
						}

						if (filters) {
							for (var i = 0; i < filters.length; i++) {
								var type = filters[i].getFilterType();
								var obj = {
									name: null,
									value: null
								};
								if (type == 'categorical') {
									obj.name = filters[i].getFieldName();
									obj.value = filters[i].getAppliedValues();
								} else if (type == 'quantitative') {
									obj.name = filters[i].getFieldName();
									obj.value = {
										d_max: filters[i].getDomainMax(),
										d_min: filters[i].getDomainMin(),
										max: filters[i].getMax(),
										min: filters[i].getMin()
									};
								} else {
									obj.name = filters[i].getFieldName();
									obj.value = {
										period: filters[i].getDomainMax(),
										range: filters[i].getRange(),
										rangeN: filters[i].getRangeN()
									};
								}
								f_list.push(obj);
							}
						}
						vm.errorInfo.parameters = p_list;
						vm.errorInfo.filters = f_list;

						var json = JSON.stringify(vm.errorInfo);
						var blob = new Blob([json], {
							type: 'application/json'
						});

						var file_name = vm.errorInfo.user_id.replaceAll('|', '_') + '_' + vm.errorInfo.team + '.json';
						var file = Upload.rename(blob, file_name);

						$timeout(function () {
							Upload.upload({
								url: 'https://io.mmmooogle.com/api/v1/files/upload?path=panic-button',

								data: {
									files: file
								}
							})
								.then(function (response) {
									$rootScope.$broadcast('panic_button_success');
								})
								.catch(function (error) {
									console.log(error);
									$rootScope.$broadcast('panic_button_error');
								});
						}, 500);
					})
					.catch(function (error) {
						console.log(error);
					});

				$timeout(function () {
					if (!parameters) {
						p.resolve();
					}
					if (!filters) {
						f.resolve();
					}
				}, 3000);
				var wb = viz.getWorkbook();
				wb.getParametersAsync().then(function (_parameters) {
					parameters = _parameters;
					p.resolve();
				});

				var a_sheet = wb.getActiveSheet();
				vm.errorInfo.sheet = a_sheet.getName();
				var wrks = a_sheet.getWorksheets();

				var worksheetName;
				for (var i = 0; i < wrks.length; i++) {
					if (wrks[i].getName()) {
						worksheetName = wrks[i].getName();
						break;
					}
				}

				wrks.get(worksheetName)
					.getFiltersAsync()
					.then(function (_filters) {
						filters = _filters;
						f.resolve();
					});
			} else {
				vm.modalError = true;
			}
		}

		function sendShowPanicButtonEvent(event) {
			if (event) {
				$rootScope.$broadcast('show_panic_button');
			} else {
				$rootScope.$broadcast('hide_panic_button');
			}
		}
		$scope.$on('send_error_info', function (event, data) {
			if (data.state == 'postSalesReport') {
				sendErrorInfo(data.comment);
			}
		});

		$scope.$on('default_herd_selected', function () {
			if (herdChangeTimeout) {
				$timeout.cancel(herdChangeTimeout);
			}

			herdChangeTimeout = $timeout(function () {
				vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
				vm.selectedHerds = [];
				vm.selectedHerds = vm.defaultValues.herd_ids;
				var herds;
				var numberOFHerds;
				if (vm.selectedHerds.length > 0) {
					herds = angular.copy(vm.selectedHerds);
					numberOFHerds = vm.selectedHerds.length;
					if (numberOFHerds > 20) {
						vm.herdsLimitReached = true;
					} else {
						vm.herdsLimitReached = false;
					}
				} else {
					herds = [0];
					vm.herdsLimitReached = false;
				}
				if (!vm.herdsLimitReached) {
					if (vm.initialEmbedDone) {
						var herdParam = createHerdParam(herds);
						setHerdParameter(herdParamName, herdParam);
					} else {
						init();
					}
				}
				sendShowPanicButtonEvent(true);
			}, 750);
		});

		function gtag() {
			$window.dataLayer = $window.dataLayer || [];
			dataLayer.push(arguments);
		}

		$scope.$on('default_team_selected', function () {
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = [];
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
			$timeout(function () {
				if (timeout) {
					timeout.resolve('cancel_request');
				}

				init();
			}, 100);
		});

		$scope.$on('$destroy', function () {
			if (timeout) {
				timeout.resolve('cancel_request');
			}

			if (viz) {
				viz.removeEventListener(tableau.TableauEventName.TAB_SWITCH);
				viz.dispose();
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('My.pages.postSalesReport').factory('postSalesReportService', postSalesReportService);
    /** @ngInject */
    function postSalesReportService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.controller('reproductionModuleCtrl', reproductionModuleCtrl);

	/** @ngInject */
	function reproductionModuleCtrl($scope, $timeout, $uibModal, $uibModalStack, $filter) {
		var vm = this;
		var viz;
		var workbook;
		var kpiTimeout;
		var responseTimeout;
		var kpiParamName;
		var dbParamName;
		var herdParamName;

		vm.$onInit = init;
		vm.kpiSelected = kpiSelected;
		vm.openKPIConfig = openKPIConfig;
		vm.closeModal = closeModal;
		vm.saveKpis = saveKpis;
		vm.init = init;
		vm.useTabvis = false;

		function init() {
			vm.allKPIS = [
				{
					label: "Age at first insemination",
					kpi: 1,
					kpiValue: vm.useTabvis ? "Age at first insemination" : "{{Age at first insemination}}",
					db: 1,
					dbiValue: vm.useTabvis ? "First insemination" : "{{First insemination}}",
					iid: 1,
					selected: true
				}, {
					label: "CR% at first insemination",
					kpi: 2,
					kpiValue: vm.useTabvis ? "CR% at first inseminetion" : "{{CR% at first inseminetion}}",
					db: 2,
					dbiValue: vm.useTabvis ? "Over time" : "{{Over time}}",
					iid: 2,
					selected: true
				}, {
					label: "DIM at first insemination",
					kpi: 3,
					kpiValue: vm.useTabvis ? "DIM at first insemination" : "{{DIM at first insemination}}",
					db: 1,
					dbiValue: vm.useTabvis ? "First insemination" : "{{First insemination}}",
					iid: 3,
					selected: true
				}, {
					label: "Conception rate",
					kpi: 4,
					kpiValue: vm.useTabvis ? "CR%" : "{{CR%}}",
					db: 2,
					dbiValue: vm.useTabvis ? "Over time" : "{{Over time}}",
					iid: 4,
					selected: true
				},
			]
			setStrings(vm.useTabvis);
			vm.KPIS = angular.copy(vm.allKPIS);
			vm.showSelector = true;
			vm.selectedKPI = vm.KPIS[0];
			vm.lastUsedKPI = angular.copy(vm.selectedKPI);
			vm.disableSelector = true;
			vm.showReproduction = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedTeam = vm.defaultValues.team_id;
			vm.selectedHerds = vm.defaultValues.herd_ids;
			if (vm.dashboards && vm.dashboards.length) {
				vm.reproductionUrl = getUrl(vm.dashboards);
				embedPage(vm.reproductionUrl, vm.useTabvis);
			} else {
				vm.dashboardNotAvailable = true;
			}
		}

		function setStrings(useTabvis) {
			kpiParamName = useTabvis ? "KPIparam" : "{{KPIparam}}";
			dbParamName = useTabvis ? "Select DB" : "{{Select DB}}";
			herdParamName = "Herd Parameter";
		}

		function getUrl(dashboards) {
			var dashboard;
			for (var i = 0; i < dashboards.length; i++) {
				if (dashboards[i].id == 'ReproductionModuleOverview') {
					dashboard = dashboards[i];
					break;
				}
			}
			return dashboard;
		}

		function embedPage(dashboard, useTabvis) {
			if (viz) {
				viz.dispose();
			}
			var herds;
			var numberOFHerds;
			if (vm.selectedHerds.length > 0) {
				herds = angular.copy(vm.selectedHerds);
				numberOFHerds = vm.selectedHerds.length;
				if (numberOFHerds > 2) {
					vm.herdsLimitReached = true;
					vm.initialEmbedDone = false;
				} else {
					vm.herdsLimitReached = false;
					vm.initialEmbedDone = true;
				}
			} else {
				herds = [0];
				vm.herdsLimitReached = false;
				vm.initialEmbedDone = true;
			}
			if (!vm.herdsLimitReached) {
				if (dashboard) {
					if (useTabvis) {
						return overviewService.setSession(dashboard.url).then(function (response) {
							var url = response.headers('tabvis-location');
							embed(url, herds);
							vm.errorLoading = false;
							vm.dashboardNotAvailable = false;
						}).catch(function (error) {
							vm.errorLoading = true;
							console.log(error)
						})
					}else{
						var url = "https://visual-stg.mmmooogle.com/t/Development/views/team-2756-reproduction-module_en-GB_twb/Reproductiondashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no&:device=tablet";
						embed(url, herds)
					}
				} else {
					vm.dashboardNotAvailable = true;
				}
			}

		}

		function embed(url, herds){
			var herdParam = createHerdParam(herds);
			var endDate = moment().hour(23).minute(59).seconds(59).millisecond(999).toISOString();
			var startDate = moment().hour(23).minute(59).seconds(59).millisecond(999).subtract(1, 'years').toISOString();
			if (url) {
				url = url + '&:render=true&:refresh=yes'
				var options = {
					device: 'tablet',
					"Start Date": $filter('date')(startDate, "yyyy-MM-dd"),
					"End Date": $filter('date')(endDate, "yyyy-MM-dd"),
					onFirstInteractive: function () {
						workbook = viz.getWorkbook();
						var wrks = workbook.getActiveSheet().getWorksheets();
						var worksheetName;
						for (var i = 0; i < wrks.length; i++) {
							if (wrks[i].getName()) {
								worksheetName = wrks[i].getName();
								break;
							}
						}

						workbook.getParametersAsync().then(function (parameters) {
							console.log(parameters)
						});

						workbook.getActiveSheet().getWorksheets().get(worksheetName).getFiltersAsync().then(function (filters) {
							console.log(filters)
						})
						$timeout(function () {
							vm.disableSelector = false;
						}, 50)

					}
				}
				options[herdParamName] = herdParam;
				options[kpiParamName] = 1;
				options[dbParamName] = 1;
				vm.showReproduction = true;
				$timeout(function () {
					var containerDiv = document.getElementById("reproductionFrame");
					viz = new tableau.Viz(containerDiv, url, options);
				}, 100)
			}
		}

		function kpiSelected() {
			if (vm.selectedKPI.iid != vm.lastUsedKPI.iid) {
				if (kpiTimeout) {
					$timeout.cancel(kpiTimeout);
				}

				kpiTimeout = $timeout(function () {
					var kpiChanged = false;
					var dbChanged = false;
					if (vm.selectedKPI.db != vm.lastUsedKPI.db) {
						dbChanged = true;
					}
					if (vm.selectedKPI.kpi != vm.lastUsedKPI.kpi) {
						kpiChanged = true;
					}
					vm.lastUsedKPI = angular.copy(vm.selectedKPI);
					updateKpiDbParameters(kpiChanged, dbChanged, vm.selectedKPI.kpiValue, vm.selectedKPI.dbiValue);
				}, 500)

			}

			/*viz.getWorkbook().changeParameterValueAsync('Select DB', "Over time").then(function(response){
				console.log(response)
			});*/
				}

				function updateKpiDbParameters(kpiChanged, dbChanged, kpi, db) {
					if (viz) {
						vm.disableSelector = true;
						if (responseTimeout) {
							$timeout.cancel(responseTimeout);
						}
						responseTimeout = $timeout(function () {
							vm.disableSelector = false;
						}, 10000);
						if (kpiChanged && dbChanged) {
							viz.getWorkbook().changeParameterValueAsync(kpiParamName, kpi).then(function (param) {
								viz.getWorkbook().changeParameterValueAsync(dbParamName, db).then(function (res) {
									$timeout(function () {
										vm.disableSelector = false;
									}, 100)

								});
							})
						} else if (kpiChanged && !dbChanged) {
							viz.getWorkbook().changeParameterValueAsync(kpiParamName, kpi).then(function (res) {
								$timeout(function () {
									vm.disableSelector = false;
								}, 100)
							});
						} else if (!kpiChanged && dbChanged) {
							viz.getWorkbook().changeParameterValueAsync(dbParamName, db).then(function (res) {
								$timeout(function () {
									vm.disableSelector = false;
								}, 100)
							});
						}
					}
				}

				function openKPIConfig(module) {
					if (!vm.loading) {
						vm.modalLoading = false;
						vm.KPIFilters = angular.copy(vm.allKPIS)
						openModal('app/pages/overview/kpiConfig.modal.html', 'md');
					}
				}

				function saveKpis() {
					var selected = false;
					for (var i = 0; i < vm.KPIFilters.length; i++) {
						if (vm.KPIFilters[i].selected) {
							selected = true;
							break;
						}
					}
					if (selected) {
						for (var i = 0; i < vm.KPIFilters.length; i++) {
							for (var j = 0; j < vm.allKPIS.length; j++) {
								if (vm.KPIFilters[i].iid == vm.allKPIS[j].iid) {
									vm.allKPIS[j].selected = vm.KPIFilters[i].selected;
								}
							}
						}
						var kpis = [];
						var selectedKPIFound;
						for (var i = 0; i < vm.allKPIS.length; i++) {
							if (vm.allKPIS[i].selected) {
								kpis.push(vm.allKPIS[i]);
								if (vm.allKPIS[i].iid == vm.selectedKPI.iid) {
									selectedKPIFound = true;
								}
							}
						}
						vm.showSelector = false;
						vm.KPIS = kpis;
						if (!selectedKPIFound) {
							vm.selectedKPI = vm.KPIS[0];
							kpiSelected();
						}
						$timeout(function () {
							vm.showSelector = true;
							closeModal();
						}, 50)
					}
				}

				function createHerdParam(herds) {
					var herdsString = '';

					for (var i = 0; i < herds.length; i++) {
						if (i == 0) {
							herdsString += herds[i];
						} else {
							herdsString += (" " + herds[i]);
						}
					}
					return herdsString;
				}

				function openModal(template, size, wClass) {
					$uibModal.open({
						animation: true,
						templateUrl: template,
						scope: $scope,
						backdrop: 'static',
						keyboard: false,
						size: size,
						windowClass: wClass ? wClass : ''
					})
				}

				function closeModal() {
					$uibModalStack.dismissAll();
				}

				$scope.$on('$destroy', function () {

					if (viz) {
						viz.dispose();
					}
				});

			}
		}) ();

(function () {
	'use strict';

	angular.module('My.pages.overview')
		.directive('reproduction', reproduction);

	/** @ngInject */
	function reproduction() {
		var dir =  {
			restrict: 'AE',
			scope: {
				dashboards: '='
			},
			link: link,
			controller: 'reproductionModuleCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/pages/overview/reproduction/reproduction.html',
			bindToController: true
		}
		
		return dir;
		
		function link(scope, element, attrs){
		}
	}
})();

(function () {
	'use strict';
	angular.module('My.pages.postSalesImport').controller('postSalesImportCtrl', postSalesImportCtrl);
	/** @ngInject */
	function postSalesImportCtrl($timeout, $scope, Upload) {
		var vm = this;

		vm.uploadChanged = uploadChanged;
		vm.removeFile = removeFile;
		vm.uploadFile = uploadFile;
		init();

		function init() {
			vm.file = null;
			vm.showChooseButton = true;
			vm.showUploadButton = false;
			vm.defaultValues = JSON.parse(localStorage.getItem('default_values'));
			vm.selectedHerds = vm.defaultValues.herd_ids;
			vm.showPreviewPage = false;
			if (vm.defaultValues.herd_ids.length == 1) {
				vm.numError = false;
			} else {
				vm.numError = true;
			}
		}

		function uploadChanged(iles, file, newFiles, duplicateFiles, invalidFiles, event) {
			vm.uploadError = false;
			vm.uploadSuccessful = false;
			vm.wrongFormatError = false;
			if (vm.file) {
				vm.showChooseButton = false;
				$timeout(function () {
					vm.showUploadButton = true;
				}, 200)
				vm.fileName = vm.file.name;
			} else {
				if (invalidFiles && invalidFiles.length) {
					vm.wrongFormatError = true;
					vm.showUploadButton = false;
					$timeout(function () {
						vm.showChooseButton = true;
					}, 200)
				}

			}
		}

		function uploadFile() {
			vm.loading = true;
			vm.uploadSuccessful = false;
			vm.wrongFormatError = false;
			var fileName = vm.selectedHerds[0] + '_' + vm.fileName;
			var file = Upload.rename(vm.file, fileName);

			$timeout(function(){
				Upload.upload({
					url: "https://io.mmmooogle.com/api/v1/files/upload?path=genetic-results",
					
					data: {
						files: file
					}
				}).then(function (response) {
					vm.loading = false;
					vm.file = null;
					vm.uploadError = false;
					vm.showUploadButton = false;
					vm.uploadSuccessful = true;
					$timeout(function () {
						vm.showChooseButton = true;
					}, 200)
				}).catch(function (error) {
					console.log(error)
					$timeout(function () {
						vm.loading = false;
						vm.uploadError = true;
						vm.uploadSuccessful = false;
						console.log(error);
					}, 100)
				})
			},500)
		}

		function removeFile() {
			vm.file = null;
			vm.showUploadButton = false;
			vm.uploadSuccessful = false;
			vm.uploadError = false;
			$timeout(function () {
				vm.showChooseButton = true;
			}, 100)
		}

		$scope.$on('default_herd_selected', function (event, data) {
			init();
		});
		$scope.$on('default_team_selected', function (event, data) {
			init();
		})

	}
})();

(function () {
    'use strict';
    angular.module('My.pages.postSalesImport').factory('postSalesImportService', postSalesImportService);
    /** @ngInject */
    function postSalesImportService($http, $q, APP_CONSTANTS) {
        return {
            getDashboards: getDashboards
            , setSession: setSession
			, getHerdsByTeamId: getHerdsByTeamId
            , loadedDashboards: {}
            , herds: []
        }

        function getDashboards(team_id, suffix) {
            return $http.get(APP_CONSTANTS.tableau_base_url + team_id + '/dashboards' + suffix, {
                withCredentials: true
                , timeout: 20000
            }).then(success).catch(error);
        }
		
		function getHerdsByTeamId(team_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'teams/' + team_id + '/herds').then(success).catch(error);
        }

        function setSession(url) {
            return $http.get(url, {
                withCredentials: true
            }).then(function (response) {
                return response;
            }).catch(function (response) {
                return $q.reject(response);
            });
        }

        function success(response) {
            return response.data;
        };

        function error(error) {
            console.log(error)
            return $q.reject(error);
        }
    }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.robot-efficiency.milk-speed")
    .controller("milkingSpeedCtrl", milkingSpeedCtrl);
  /** @ngInject */
  function milkingSpeedCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.embed = null;
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.embed = null;
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.milkingSpeedTrendDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == vm.milkingSpeedTrendDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/Milkingspeedtrenddashboard?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "robot-efficiency.milk-speed",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          stateList: [
            {
              title: "_label_prestations_",
              state: "robot-efficiency.robot-prestations",
            },
            { title: "_label_speed_" },
            {
              title: "_label_milk_hour_cow_",
              state: "robot-efficiency.milk-hour",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.milkingSpeedDashboard = i18nFilter("_dashboard_id_milking_speed_dim_");
      vm.milkingSpeedTrendDashboard = i18nFilter(
        "_dashboard_id_milking_speed_trend_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.robot-efficiency.milk-hour")
    .controller("milkHourCtrl", milkHourCtrl);
  /** @ngInject */
  function milkHourCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.milkHourDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == vm.milkHourDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/MilkbymilkingminutesActual?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "robot-efficiency.milk-hour",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          stateList: [
            {
              title: "_label_prestations_",
              state: "robot-efficiency.robot-prestations",
            },
            { title: "_label_speed_", state: "robot-efficiency.milk-speed" },
            {
              title: "_label_milk_hour_cow_",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.milkHourDashboard = i18nFilter(
        "_dashboard_id_milk_per_milking_minutes_actual_"
      );
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }

        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }

      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

(function () {
  "use strict";
  angular
    .module("My.pages.robot-efficiency.robot-prestations")
    .controller("robotPrestationsCtrl", robotPrestationsCtrl);
  /** @ngInject */
  function robotPrestationsCtrl(
    arvestaDashboardService,
    $filter,
    $timeout,
    dashboardsService,
    A_DASH_CONSTANTS,
    aDashboardsService,
    $scope,
    cookiesService,
    permissionService
  ) {
    var vm = this;
    var i18nFilter = $filter("i18n");
    var teamTimeout;
    var reloadTimeout;
    var timeout;
    var dashboards_list = A_DASH_CONSTANTS.dashboards;

    vm.init = init;

    init();

    function init() {
      vm.loadingDashboards = true;
      vm.errorLoading = false;
      vm.noAvailableDashboards = false;
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.user = JSON.parse(localStorage.getItem("user_profile"));
      vm.selectedTeam = vm.defaultValues.team_id;

      setStrings();
      setLanguage();
      setStyleType();

      if (teamTimeout) {
        $timeout.cancel(teamTimeout);
      }
      if (vm.defaultValues && vm.defaultValues.herd_ids) {
        vm.selectedHerds = vm.defaultValues.herd_ids;
      } else {
        vm.selectedHerds = [];
      }

      vm.herdsLimitReached = false;

      if (vm.selectedHerds.length > 20) {
        vm.herdsLimitReached = true;
      }

      vm.workLocally = A_DASH_CONSTANTS.development.work_locally;

      if (vm.selectedTeam) {
        getDashboards(vm.selectedTeam);
      } else {
        teamTimeout = $timeout(function () {
          vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
          if (vm.defaultValues && vm.defaultValues.team_id) {
            getDashboards(vm.defaultValues.team_id);
          } else {
            vm.loadingDashboards = false;
            vm.reselectTeamError = true;
          }
        }, 5000);
      }
    }

    function getDashboards(team_id) {
      if (vm.workLocally) {
        var dashboards = A_DASH_CONSTANTS.development.dashboards;
        var obj = {
          dashboards: dashboards,
          expires: moment().add(30, "minutes").format(),
          team_id: team_id,
          lng: vm.currentLng,
        };
        dashboardsService.loadedDashboards = obj;
        processDashboards(dashboards, team_id);
      } else {
        return arvestaDashboardService
          .setTableauTenant(team_id)
          .then(function (response) {
            if (response && response.token) {
              var expireDate = moment();
              expireDate.add(10, "hours");
              expireDate = new Date(expireDate);
              cookiesService.setCookie("dashboard_token", response.token, {
                samesite: "none",
                secure: true,
                domain: ".mmmooogle.com",
                expires: expireDate,
              });
            }
            if (
              dashboardsService &&
              dashboardsService.loadedDashboards.dashboards &&
              dashboardsService.loadedDashboards.team_id == team_id &&
              dashboardsService.loadedDashboards.lng == vm.currentLng
            ) {
              if (
                moment(dashboardsService.loadedDashboards.expires).isBefore(
                  moment()
                )
              ) {
                useAPI(team_id);
              } else {
                var dashboards = [];
                angular.copy(
                  dashboardsService.loadedDashboards.dashboards,
                  dashboards
                );
                processDashboards(dashboards, team_id);
              }
            } else {
              useAPI(team_id);
            }
          })
          .catch(function (error) {
            console.log(error);
            if (!vm.teamReselected) {
              vm.loadingDashboards = false;
              vm.errorLoading = true;
            } else {
              vm.teamReselected = false;
            }
          });
      }
    }

    function useAPI(team_id) {
      var tableauSuffix = "?locale=" + vm.currentLng;
      return arvestaDashboardService
        .getDashboards(team_id, tableauSuffix)
        .then(function (response) {
          var obj = {
            dashboards: response,
            expires: moment().add(30, "minutes").format(),
            team_id: team_id,
            lng: vm.currentLng,
          };
          dashboardsService.loadedDashboards = obj;
          processDashboards(response, team_id);
        })
        .catch(function (error) {
          vm.loadingDashboards = false;
          vm.errorLoading = true;
        });
    }

    function processDashboards(dashboards) {
      if (dashboards.length > 0) {
        var isGlobalAdmin = permissionService.isGlobalAdmin;
        if (isGlobalAdmin) {
          var orders = aDashboardsService.orders;
          if (orders && orders.length) {
            var dashboard_category = aDashboardsService.getDashboardCategory(
              orders,
              "robot"
            );
            process(isGlobalAdmin, dashboards, dashboard_category);
          } else {
            return arvestaDashboardService
              .getOrders(vm.selectedTeam)
              .then(function (response) {
                dashboard_category = aDashboardsService.getDashboardCategory(
                  response,
                  "robot"
                );
                aDashboardsService.orders = response;
                process(isGlobalAdmin, dashboards, dashboard_category);
              })
              .catch(function (error) {
                console.log(error);
                vm.loadingDashboards = false;
                vm.noAvailableDashboards = true;
              });
          }
        } else {
          process(isGlobalAdmin, dashboards);
        }
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function process(is_global_admin, response, dashboard_category) {
      var list = [];
      var dashboard;
      response.forEach(function (_dash) {
        if (is_global_admin) {
          if (
            _dash.subcategory == dashboard_category &&
            _dash.id == vm.prestationsDashboard
          ) {
            dashboard = _dash;
          }
        } else {
          if (
            (_dash.subcategory == "aveve-robot" ||
              _dash.subcategory == "proxani-robot") &&
            _dash.id == vm.prestationsDashboard
          ) {
            dashboard = _dash;
          }
        }
        var arv_dashboard = dashboards_list.find(function (item) {
          return _dash.id == i18nFilter(item.dashboard_id);
        });

        if (arv_dashboard) {
          _dash.title = _dash.description;
          list.push(_dash);
        }
      });

      var dash = [];

      list.forEach(function (item) {
        var temp = {
          title: item.title,
          type: "tableau",
          category: item.category,
          id: item.id,
          url: item.url,
          subcategory: item.subcategory,
          addToReport: true,
        };

        dash.push(temp);
      });

      var allDashboards = dash;
      if (dashboard) {
        if (vm.workLocally) {
          dashboard.url =
            "https://visual-prd.mmmooogle.com/t/Production/views/team-4710-production-proxani-robot_en-GB_twb/RobotEfficiency?:showAppBanner=false&:display_count=no&:showVizHome=no&:embed=yes&:showAppBanner=no&:showShareOptions=false&:toolbar=no&:tooltip=yes&:tabs=no";
        }
        vm.dashboardData = {
          dashboard: dashboard,
          allDashboards: allDashboards,
          state: "robot-efficiency.robot-prestations",
          style: vm.style,
          language: vm.currentLng,
          workLocally: vm.workLocally,
          selectedHerds: vm.selectedHerds,
          selectedTeam: vm.selectedTeam,
          handleViewData: true,
          viewDataDashboard: vm.viewDataDashboard,
          user: vm.user,
          frameClass: "dashboard-wrapper-rap-quick-buttons",
          showTopBar: true,
          changeStateVisible: true,
          quickButtonsVisible: true,
          category: "robot_efficiency",
          stateList: [
            { title: "_label_prestations_" },
            { title: "_label_speed_", state: "robot-efficiency.milk-speed" },
            {
              title: "_label_milk_hour_cow_",
              state: "robot-efficiency.milk-hour",
            },
          ],
        };

        $timeout(function () {
          vm.loadingDashboards = false;
        }, 200);
      } else {
        vm.loadingDashboards = false;
        vm.noAvailableDashboards = true;
      }
    }

    function setLanguage() {
      var lng = localStorage.getItem("lng");
      if (lng) {
        if (lng == "es-ES" || lng == "ja-JP" || lng == "cs-CZ"  ) {
          vm.currentLng = "en-GB";
        } else {
          vm.currentLng = lng;
        }
      } else {
        vm.currentLng = "en-GB";
      }
    }

    function setStrings() {
      vm.prestationsDashboard = i18nFilter("_dashboard_id_robot_efficiency_");
      vm.viewDataDashboard = i18nFilter("_dashboard_name_view_data_");
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;
      }
    }

    $scope.$on("default_herd_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      init();
    });

    $scope.$on("default_team_selected", function () {
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.selectedHerds = [];
      vm.selectedHerds = vm.defaultValues.herd_ids;
      vm.teamReselected = true;
      reloadTimeout = $timeout(function () {
        if (timeout) {
          timeout.resolve("cancel_request");
        }
        init();
      }, 500);
    });

    $scope.$on("$destroy", function () {
      if (reloadTimeout) {
        $timeout.cancel(reloadTimeout);
      }
      if (timeout) {
        timeout.resolve("cancel_request");
      }
    });
  }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
  "use strict";
  angular
    .module("My.pages.herds.animals.details")
    .controller("animalDetailsCtrl", animalDetailsCtrl);
  /** @ngInject */
  function animalDetailsCtrl(
    $stateParams,
    animalDetailsService,
    $q,
    APP_CONSTANTS,
    $filter,
    $uibModal,
    $uibModalStack,
    $scope,
    Upload,
    animalsService,
    $interval,
    $timeout,
    $rootScope,
    permissionService,
    $cookies,
    appService
  ) {
    var vm = this;
    var reporoduction;
    var animal;
    var calving;
    var images;
    var observation;
    var lactations;
    var milkControl;
    var manualMilk;
    var udderHealth;
    var healthEvents;
    var hoofTrims;
    var clawHealth;
    var comments;
    var milkMeter;
    var herdAccess;
    var feedIntake;
    var sliderTimer;
    var animals;
    var searchTimer;
    var animalByNumberTimer;
    var mctx;
    var mixedChartModal;
    var mctx2;
    var mixedChartModal2;
    var ctx;
    var ctx2;
    var mixedChart;
    var mixedChart2;
    var movements;
    vm.openNewDiscussionModal = openNewDiscussionModal;
    vm.addNewDiscussion = addNewDiscussion;
    vm.newDiscussionSetTags = newDiscussionSetTags;
    vm.uploadChanged = uploadChanged;
    vm.removeSelectedFile = removeSelectedFile;
    vm.previousAnimal = previousAnimal;
    vm.nextAnimal = nextAnimal;
    vm.changeCarousel = changeCarousel;
    vm.selectImage = selectImage;
    vm.closeModal = closeModal;
    vm.previousImage = previousImage;
    vm.nextImage = nextImage;
    vm.showMenuModal = showMenuModal;
    vm.changeImportance = changeImportance;
    vm.changeIsTask = changeIsTask;
    vm.addComment = addComment;
    vm.addCommentOnEnter = addCommentOnEnter;
    vm.addTag = addTag;
    vm.removeTag = removeTag;
    vm.rotateImage = rotateImage;
    vm.loadMoreImages = loadMoreImages;
    vm.rotateProfilePicture = rotateProfilePicture;
    vm.setProfileStyle = setProfileStyle;
    vm.openIntervalModal = openIntervalModal;
    vm.setCarouselInterval = setCarouselInterval;
    vm.showImageByType = showImageByType;
    vm.showImage = showImage;
    vm.selectFromAll = selectFromAll;
    vm.showOneImage = showOneImage;
    vm.loadMoreEvents = loadMoreEvents;
    vm.setActiveButton = setActiveButton;
    vm.setActiveMilkButton = setActiveMilkButton;
    vm.setActiveUHButton = setActiveUHButton;
    vm.getAnimalById = getAnimalById;
    vm.setActiveClawHealtButton = setActiveClawHealtButton;
    vm.openDeleteImageModal = openDeleteImageModal;
    vm.deleteImage = deleteImage;
    vm.loadMoreFeedIntakes = loadMoreFeedIntakes;
    vm.loadMoreMilkIntakes = loadMoreMilkIntakes;
    vm.init = init;
    vm.sliderChanged = sliderChanged;
    vm.openGraphModal = openGraphModal;
    vm.openSearchModal = openSearchModal;
    vm.searchInputChanged = searchInputChanged;
    vm.goToAnimal = goToAnimal;
    vm.goToAnimalByNumber = goToAnimalByNumber;
    vm.loadMoreFameTableData = loadMoreFameTableData;
    vm.getBackgroundColor = getBackgroundColor;
    vm.animalSearchKeyPress = animalSearchKeyPress;
    vm.changeView = changeView;
    vm.lactationChanged = lactationChanged;
    var menuActivated = false;
    var activeMenu;
    var i18nFilter = $filter("i18n");
    vm.carouselTime = 7000;
    vm.carouselTimeSec = 7;
    var carouselTimer;
    vm.adviceList = angular.copy(APP_CONSTANTS.constants.adviceList);
    var graphColors = [
      "#e6194B",
      "#4363d8",
      "#f58231",
      "#3cb44b",
      "#ffe119",
      "#911eb4",
      "#bfef45",
      "#42d4f4",
      "#f032e6",
      "#a9a9a9",
      "#800000",
      "#000075",
      "#9A6324",
      "#808000",
      "#469990",
      "#fabebe",
      "#ffd8b1",
      "#aaffc3",
      "#fffac8",
      "#e6beff",
    ];

    var aveveGraphColors = [
      "#00936f",
      "#eb9e9d",
      "#5bc4bf",
      "#414042",
      "#5ebc5e",
      "#42d4f4",
      "#f032e6",
      "#a9a9a9",
      "#800000",
      "#000075",
      "#9A6324",
      "#808000",
      "#469990",
      "#fabebe",
      "#ffd8b1",
      "#aaffc3",
      "#fffac8",
      "#e6beff",
    ];

    var proxaniGraphColors = [
      "#cd5b1b",
      "#2b4390",
      "#146f67",
      "#f2d807",
      "#50adc8",
      "#42d4f4",
      "#f032e6",
      "#a9a9a9",
      "#800000",
      "#000075",
      "#9A6324",
      "#808000",
      "#469990",
      "#fabebe",
      "#ffd8b1",
      "#aaffc3",
      "#fffac8",
      "#e6beff",
    ];
    checkIsFarmer();
    init();

    function checkIsFarmer() {
      if (permissionService.isGlobalAdmin) {
        vm.isGlobalAdmin = true;
        vm.is_farmer = true;
        vm.view_icon = "toggle_on";
      } else {
        if (
          permissionService.can(50) ||
          permissionService.can(49) ||
          permissionService.can(355) ||
          permissionService.can(356) ||
          permissionService.can(294)
        ) {
          vm.is_farmer = true;
        } else {
          vm.is_farmer = false;
        }
      }
    }

    function init() {
      setStyleType();
      vm.idNotValid = false;
      checkRapCookie();
      if (vm.is_farmer) {
        vm.showAnimalHeader = false;
      } else {
        vm.showAnimalHeader = true;
      }
      vm.errorLoadingAnimal = false;
      vm.noAnimalDataAvailable = false;
      if (vm.is_farmer) {
        vm.activeButton = 9;
      } else {
        vm.activeButton = 0;
      }
      vm.defaultValues = JSON.parse(localStorage.getItem("default_values"));
      vm.hoofReCheckList = angular.copy(APP_CONSTANTS.constants.hoofReCheck);
      var param = $stateParams.animal_id;
      var herd_id_param = $stateParams.hi;
      if (herd_id_param) {
        checkSelectedHerdAndHerdParam(herd_id_param, vm.defaultValues);
        $timeout(function () {
          $rootScope.$broadcast(
            "default_herd_from_dashboard_selected",
            herd_id_param
          );
        }, 1000);

        getAnimalIdByEarTag(param, herd_id_param);
      } else {
        param = parseInt(param, 16);
        setPreloadData(param);
      }
    }

    function setStyleType() {
      var style = localStorage.getItem("style");
      if (style && style.length) {
        vm.style = style;

        if (style == "aveve") {
          graphColors = aveveGraphColors;
        }
        if (style == "proxani") {
          graphColors = proxaniGraphColors;
        }
      }
    }

    function checkSelectedHerdAndHerdParam(herd_id, default_values) {
      if (
        default_values.herd_ids.length != 1 ||
        default_values.herd_ids[0] != herd_id
      ) {
        vm.defaultValues.herd_ids[0] = herd_id;
      }
    }

    function getAnimalIdByEarTag(eartag, herd_id) {
      eartag = eartag.replace(/\s/g, "");
      return animalDetailsService
        .getAllAnimalsByHerdId(herd_id)
        .then(function (response) {
          response.forEach(function (el) {
            el.EarTag = el.EarTag ? el.EarTag.replace(/\s/g, "") : el.EarTag;
            return el;
          });
          var animals = response.filter(function (el) {
            return el.EarTag == eartag;
          });
          if (animals && animals.length) {
            if (animals.length == 1) {
              if (animals[0].AnimalId) {
                setPreloadData(animals[0].AnimalId);
              } else {
                vm.noAnimalDataAvailable = true;
              }
            } else {
              var found = false;
              for (var i = 0; i < response.length; i++) {
                if (animals[i].IsOnFarm) {
                  setPreloadData(animals[i].AnimalId);
                  found = true;
                  break;
                }
              }
              if (!found) {
                setPreloadData(animals[animals.length - 1].AnimalId);
              }
            }
          } else {
            vm.noAnimalDataAvailable = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.errorLoadingAnimal = true;
        });
    }

    function setPreloadData(param) {
      var loadAnimals = false;
      var loadAnimalsUsingAnimal = false;
      if (Number.isInteger(param)) {
        vm.animal_id = param;
        var animalList = animalsService.animalList.list;
        vm.state = animalsService.animalList.state;
        if (animalList && animalList.length > 0) {
          vm.animalList = animalList;
        } else {
          var list = JSON.parse(localStorage.getItem("animalList"));
          if (list) {
            var list = JSON.parse(localStorage.getItem("animalList")).list;
            vm.state = JSON.parse(localStorage.getItem("animalList")).state;
            if (list && list.length > 0) {
              vm.animalList = list;
            } else {
              if (vm.defaultValues.herd_ids.length == 1) {
                loadAnimals = true;
              } else {
                loadAnimalsUsingAnimal = true;
                vm.animalList = [];
              }
            }
          } else {
            $timeout(function () {
              $rootScope.$broadcast("animals_selected_animal");
            }, 200);
            if (vm.defaultValues.herd_ids.length == 1) {
              loadAnimals = true;
            } else {
              loadAnimalsUsingAnimal = true;
              vm.animalList = [];
            }
          }
        }
        if (vm.animalList && vm.animalList.length > 1) {
          vm.index = setCurrentAnimal(vm.animalList, vm.animal_id);
          if (vm.index == 0) {
          } else if (vm.index == vm.animalList.length - 1) {
          }
          vm.showNavigation = true;
          vm.showCarouselNavigation = true;
        }
        vm.tagsList = [];
        angular.copy(APP_CONSTANTS.constants.tags, vm.tagsList);
        vm.tagsList = setTagTranslations(vm.tagsList);
        vm.tags = angular.copy(APP_CONSTANTS.constants.tags);
        vm.tags = setTagTranslations(vm.tags);
        vm.tagsList.shift();
        getAnimalData(vm.animal_id, loadAnimals, loadAnimalsUsingAnimal);
      } else {
        vm.idNotValid = true;
      }
      addKeyDownListener();
    }

    function setTagTranslations(tagsList) {
      var tags = angular.copy(tagsList);
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].label_translate) {
          tags[i].label = i18nFilter(tags[i].label_translate);
        } else {
          tags[i].label = "";
        }
      }

      return tags;
    }

    function changeView() {
      vm.is_farmer = !vm.is_farmer;
      if (vm.is_farmer) {
        vm.view_icon = "toggle_off";
      } else {
        vm.view_icon = "toggle_on";
      }
      //vm.hidePage = true;
      $timeout(function () {
        setPreloadData(vm.animal.AnimalId);
      }, 50);
    }

    function checkRapCookie() {
      var fromAnimal = localStorage.getItem("fromAnimal");
      if (!fromAnimal) {
        var cookie = $cookies.getAll();
        angular.forEach(cookie, function (value, key) {
          if (key == "rap_actual_dates") {
            setRapDates(value);
          }
        });
      } else {
        localStorage.removeItem("fromAnimal");
      }
    }

    function setRapDates(dates) {
      if (dates) {
        try {
          var dates = JSON.parse(dates);
          vm.rapDates = dates;
          vm.useRapDates = true;
        } catch (error) {
          vm.useRapDates = false;
        }
      }
    }
    //events
    /* eventTypes
		birth - 1
		reproduction - 2
		calving - 3
		observation - 4
		lactation - 5
		milk control - 6
		udder health - 7
		helth events - 8
		claw healt - 9
		manual milk  - 10
		images - 11
		comments  - 12
		milk meters - 13
		hoof trims - 14
		feed intake - 15
		movements - 16
		dry - 17
		udder health streamer - 18


		ReproTypes
		Heat = 0,
		Breeding = 1,
		PregnancyDiagnosis = 2,
		Barren = 3,
		Abortion = 4,
		EmbryoTransferFlush = 5

		PregnancyDiagnosisResult
		Positive = 1,
		Negative = 2,
		Uncertain = 3

		movements types
		Birth = 0,
        Purchase = 1,
        Sale = 2,
        Dead = 3
		*/
    //add event listener to detect arrows press
    function addKeyDownListener() {
      document.body.onkeydown = function (e) {
        if (vm.showOverview && vm.showNavigation) {
          if (e.keyCode == 39) {
            if (vm.modalOpen) {
              nextImage(true);
            } else {
              nextAnimal();
            }
          } else if (e.keyCode == 37) {
            if (vm.modalOpen) {
              previousImage(true);
            } else {
              previousAnimal();
            }
          }
        }
      };
    }

    function loadMoreEvents() {
      vm.eventsNumber++;
      var images = getNElementsFromList(
        vm.events,
        vm.eventsNumber,
        50,
        "showLoadMoreEvents"
      );
      vm.eventsToShow = vm.eventsToShow.concat(images);
    }

    function loadMoreFeedIntakes() {
      vm.feedIntakesPageNumber++;
      var intakes = getNElementsFromList(
        vm.allFeedIntakes,
        vm.feedIntakesPageNumber,
        50,
        "showLoadMoreFeedIntakes"
      );
      vm.feedIntakes = vm.feedIntakes.concat(intakes);
    }

    function loadMoreMilkIntakes() {
      vm.milkIntakesPageNumber++;
      var intakes = getNElementsFromList(
        vm.allMilkMeterData,
        vm.milkIntakesPageNumber,
        50,
        "showLoadMoreMilkIntakes"
      );
      vm.milkMeterData = vm.milkMeterData.concat(intakes);
    }

    function loadMoreFameTableData() {
      vm.fameTableDataNumber++;
      var data = getNElementsFromList(
        vm.allFameTableData,
        vm.fameTableDataNumber,
        50,
        "showLoadMoreFameTableData"
      );
      vm.fameTableData = vm.fameTableData.concat(data);
    }

    function getAnimalData(animal_id, loadAnimals, loadAnimalsUsingAnimal) {
      vm.showLoadMoreEvents = false;
      vm.showMore = false;
      getAnimal(animal_id, loadAnimalsUsingAnimal);
      animal = $q.defer();
      animals = $q.defer();
      herdAccess = $q.defer();
      getHerdAccess();
      vm.events = [];
      vm.diseaseEvents = [];
      if (loadAnimals) {
        vm.disableAnimalSearchInput = true;
        getAnimals(vm.defaultValues.herd_ids[0]);
      } else {
        if (!loadAnimalsUsingAnimal) {
          vm.disableAnimalSearchInput = false;
          animals.resolve();
        }
      }
    }

    function getAnimalById(animal_id) {
      if (animal_id && vm.showOverview) {
        vm.showNavigation = false;
        vm.showCarouselNavigation = false;
        vm.animalList = null;
        getAnimalData(animal_id);
      }
    }

    function getAnimals(herd_id) {
      return animalDetailsService
        .getAnimals(herd_id)
        .then(function (response) {
          if (response && response.length > 1) {
            for (var i = 0; i < response.length; i++) {
              response[i].id = response[i].AnimalId;
              response[i].number = response[i].Number;
              response[i].pictureImageUrl = response[i].PictureImageUrl;
            }
            vm.animalList = response;
            vm.index = setCurrentAnimal(vm.animalList, vm.animal_id);
            if (vm.index == 0) {
            } else if (vm.index == vm.animalList.length - 1) {
            }
            vm.showNavigation = true;
            vm.showCarouselNavigation = true;
          }
          vm.disableAnimalSearchInput = false;
          animals.resolve();
        })
        .catch(function (error) {
          console.log(error);
          animals.reject();
        });
    }

    function getHerdAccess() {
      var user = JSON.parse(localStorage.getItem("user_profile"));
      return animalDetailsService
        .getTeamHerdAccess(user.user_id)
        .then(function (response) {
          vm.teamHerdAccess = response;
          herdAccess.resolve();
        })
        .catch(function (error) {
          herdAccess.reject();
        });
    }

    function setActiveButton(n) {
      if (vm.showOverview) {
        vm.activeButton = n;
        if (vm.is_farmer) {
          if (n == 0) {
            vm.showAnimalHeader = true;
          } else {
            vm.showAnimalHeader = false;
          }
        }
        if (n == 0) {
          vm.eventsToShow = [];
          vm.eventsNumber = 0;
          if (vm.events.length == 0) {
          } else if (vm.events.length > 50) {
            vm.eventsNumber = 0;
            vm.eventsToShow = getNElementsFromList(
              vm.events,
              vm.eventsNumber,
              50,
              "showLoadMoreEvents"
            );
            vm.showLoadMoreEvents = true;
          } else {
            vm.eventsToShow = vm.events;
          }
        } else if (n == 3) {
          vm.activeMilkButton = 0;
        } else if (n == 4) {
          vm.activeUHButton = 0;
        } else if (n == 6) {
          vm.activeClawHealtButton = 0;
        } else if (n == 8) {
          vm.feedIntakes = setFeedIntakes(vm.allFeedIntakes);
        } else if (n == 9) {
          vm.fameTableData = setFameTableData(vm.allFameTableData);
        } else if (n == 10) {
          vm.hideChart = false;
          $timeout(function () {
            createMilkGraph();
          }, 100);
        }
      }
    }

    function setActiveMilkButton(n) {
      if (vm.showOverview) {
        vm.activeMilkButton = n;
      }
      if (n == 4 && !vm.is_farmer) {
        createMilkGraph();
      } else if (n == 1) {
        vm.milkMeterData = setMilkIntakes(vm.allMilkMeterData);
      }
    }

    function setActiveUHButton(n) {
      if (vm.showOverview) {
        vm.activeUHButton = n;
      }
    }

    function setActiveClawHealtButton(n) {
      if (vm.showOverview) {
        vm.activeClawHealtButton = n;
      }
    }

    function setCurrentAnimal(animal_list, animal_id) {
      var index;
      for (var i = 0; i < animal_list.length; i++) {
        if (animal_list[i].id == animal_id) {
          index = i;
          break;
        }
      }
      return index;
    }

    function previousAnimal() {
      if (vm.rapDates && vm.rapDates.start_date && vm.rapDates.end_date) {
        vm.useRapDates = true;
      } else {
        vm.useRapDates = false;
      }
      vm.showLoadMoreEvents = false;
      var currentIndex = vm.index;
      var previousIndex = currentIndex - 1;
      if (previousIndex > 0) {
        vm.index = previousIndex;
        getAnimalData(vm.animalList[previousIndex].id);
      } else if (previousIndex == 0) {
        vm.index = previousIndex;
        getAnimalData(vm.animalList[previousIndex].id);
        vm.hidePrevious = true;
      } else if (previousIndex == -1) {
        vm.index = vm.animalList.length - 1;
        getAnimalData(vm.animalList[vm.index].id);
      } else {
        vm.index = 0;
        getAnimalData(vm.animalList[0].id);
      }
    }

    function nextAnimal() {
      if (vm.rapDates && vm.rapDates.start_date && vm.rapDates.end_date) {
        vm.useRapDates = true;
      } else {
        vm.useRapDates = false;
      }

      vm.showOverview = false;
      var currentIndex = vm.index;
      vm.showLoadMoreEvents = false;
      var nextIndex = currentIndex + 1;
      if (nextIndex < vm.animalList.length - 1) {
        vm.index = nextIndex;
        getAnimalData(vm.animalList[nextIndex].id);
      } else if (nextIndex == vm.animalList.length - 1) {
        vm.index = nextIndex;
        getAnimalData(vm.animalList[nextIndex].id);
      } else if (nextIndex == vm.animalList.length) {
        vm.index = 0;
        getAnimalData(vm.animalList[0].id);
      } else {
        vm.index = 0;
        getAnimalData(vm.animalList[0].id);
      }
    }

    function getEvents(animal_id) {
      reporoduction = $q.defer();
      calving = $q.defer();
      images = $q.defer();
      observation = $q.defer();
      lactations = $q.defer();
      milkControl = $q.defer();
      manualMilk = $q.defer();
      udderHealth = $q.defer();
      healthEvents = $q.defer();
      clawHealth = $q.defer();
      comments = $q.defer();
      milkMeter = $q.defer();
      hoofTrims = $q.defer();
      feedIntake = $q.defer();
      movements = $q.defer();
      getReproduction(animal_id);
      getCalving(animal_id);
      getImages(animal_id);
      getObservations(animal_id);
      getLactations(animal_id);
      getMilkRecordings(animal_id);
      getManualMilk(animal_id);
      getUdderHealth(animal_id);
      getHealthEvents(animal_id);
      getClawHealth(animal_id);
      getAllComments(animal_id);
      getMilkMeters(animal_id);
      getHoofTrims(animal_id);
      getFeedIntake(animal_id);
      getMovements(animal_id);
      vm.showOverview = false;
      $q.all([
        animal.promise,
        animals.promise,
        reporoduction.promise,
        calving.promise,
        images.promise,
        observation.promise,
        lactations.promise,
        milkControl.promise,
        manualMilk.promise,
        healthEvents.promise,
        clawHealth.promise,
        comments.promise,
        milkMeter.promise,
        hoofTrims.promise,
        herdAccess.promise,
        feedIntake.promise,
        movements.promise,
      ])
        .then(function (responses) {
          handleResponseFromAllEvents();
        })
        .catch(function (error) {
          console.log(error);
          vm.errorLoadingAnimal = true;
        });
    }

    function handleResponseFromAllEvents() {
      vm.healthEvents = setHealthEvents(vm.diseaseEvents);
      vm.lactations = setLactations(vm.lactations, vm.allMilkMeterData);
      if (!vm.dim) {
        var dateToUse;
        if (vm.animal.LastCalvingDate) {
          dateToUse = vm.animal.LastCalvingDate;
        } else {
          if (vm.animal.BirthDate) {
            dateToUse = vm.animal.BirthDate;
          } else {
            dateToUse = moment().date(1).month(0);
          }
        }
        var calvingDate = moment(dateToUse);
        var today = moment();
        vm.dim = today.diff(calvingDate, "days") + 1;
      }
      if (vm.noLactations) {
        if (vm.animal.BirthDate) {
          var today = moment();
          vm.doa = today.diff(vm.animal.BirthDate, "days");
        }
      }
      vm.showOverview = false;
      vm.eventsToShow = [];
      vm.eventsNumber = 0;
      vm.role = 0;
      for (var th = 0; th < vm.teamHerdAccess.length; th++) {
        if (vm.teamHerdAccess[th].HerdId == vm.animal.HerdId) {
          vm.role = vm.teamHerdAccess[th].Role;
          break;
        }
      }
      for (var p = 0; p < vm.images.length; p++) {
        vm.images[p].Comments = [];
        if (vm.images[p].NumberComments > 0) {
          for (var c = 0; c < vm.allComments.length; c++) {
            if (vm.images[p].Id == vm.allComments[c].EntityId) {
              vm.images[p].Comments.push(vm.allComments[c]);
            }
          }
        }
      }
      for (var i = 0; i < vm.events.length; i++) {
        if (vm.events[i].DIM) {
          if (moment(vm.events[i].eventDate).isBefore(vm.firstLact)) {
            vm.events[i].beforeFirstLact = true;
          }
        }
        if (vm.events[i].eventType == 12) {
          vm.events[i].Comments = [];
          for (var c = 0; c < vm.allComments.length; c++) {
            if (vm.events[i].Id == vm.allComments[c].EntityId) {
              vm.events[i].Comments.push(vm.allComments[c]);
            }
          }
        }
        if (vm.events[i].Pictures && vm.events[i].Pictures.length > 0) {
          for (var j = 0; j < vm.events[i].Pictures.length; j++) {
            for (var p = 0; p < vm.images.length; p++) {
              if (vm.events[i].Pictures[j].Id == vm.images[p].Id) {
                vm.events[i].Pictures[j] = vm.images[p];
                break;
              }
            }
            if (vm.events[i].Pictures[j].Tags) {
              var tags = vm.events[i].Pictures[j].Tags.split("#");
              for (var t = 0; t < tags.length; t++) {
                if (
                  tags[t] == "Calving" ||
                  tags[t] == "Calf1" ||
                  tags[t] == "Calf2"
                ) {
                  if (
                    checkImage(
                      vm.events[i].CalvingImages,
                      vm.events[i].Pictures[j]
                    )
                  ) {
                    vm.events[i].CalvingImages.push(vm.events[i].Pictures[j]);
                  }
                }
                if (tags[t] == "Colostrum") {
                  if (
                    checkImage(
                      vm.events[i].ColostrumImages,
                      vm.events[i].Pictures[j]
                    )
                  ) {
                    vm.events[i].ColostrumImages.push(vm.events[i].Pictures[j]);
                  }
                }
                if (tags[t] == "MilkIntake") {
                  if (
                    checkImage(
                      vm.events[i].MilkIntakeImages,
                      vm.events[i].Pictures[j]
                    )
                  ) {
                    vm.events[i].MilkIntakeImages.push(
                      vm.events[i].Pictures[j]
                    );
                  }
                }
              }
            }
          }
        }
        if (vm.events[i].eventType == 8) {
          for (var j = 0; j < vm.images.length; j++) {
            if (vm.images[j].Tags) {
              if (
                vm.images[j].Tags.indexOf(vm.events[i].tagDate) !== -1 &&
                vm.images[j].Tags.indexOf("Disease") !== -1
              ) {
                if (checkImage(vm.events[i].DiseasesPictures, vm.images[j])) {
                  vm.events[i].DiseasesPictures.push(vm.images[j]);
                }
              }
              if (
                vm.images[j].Tags.indexOf(vm.events[i].tagDate) !== -1 &&
                vm.images[j].Tags.indexOf("Prevention") !== -1
              ) {
                if (
                  checkImage(vm.events[i].PreventionsPictures, vm.images[j])
                ) {
                  vm.events[i].PreventionsPictures.push(vm.images[j]);
                }
              }
            }
          }
        }
        if (vm.events[i].eventType == 9) {
          var date = $filter("date")(vm.events[i].eventDate, "yyyy-MM-dd");
          var pictures = [];
          var lf = [];
          var rf = [];
          var lr = [];
          var rr = [];
          for (var j = 0; j < vm.images.length; j++) {
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("claw") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("clawhealth") != -1)
            ) {
              pictures.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("lfmain") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("lfo") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("lfi") != -1)
            ) {
              lf.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("rfmain") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("rfi") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("rfo") != -1)
            ) {
              rf.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("lrmain") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("lri") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("lro") != -1)
            ) {
              lr.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("rrmain") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("rri") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("rro") != -1)
            ) {
              rr.push(vm.images[j]);
            }
          }
          vm.events[i].Pictures = pictures;
          vm.events[i].LRPictures = lr;
          vm.events[i].LFPictures = lf;
          vm.events[i].RFPictures = rf;
          vm.events[i].RRPictures = rr;
        }
        if (vm.events[i].eventType == 10) {
          var date = $filter("date")(vm.events[i].eventDate, "yyyy-MM-dd");
          if (!vm.events[i].Pictures) {
            vm.events[i].Pictures = [];
          }
          for (var j = 0; j < vm.images.length; j++) {
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              (vm.images[j].Tags.toLowerCase().indexOf("manualmilk") != -1 ||
                vm.images[j].Tags.toLowerCase().indexOf("milkintake") != -1)
            ) {
              if (checkImage(vm.events[i].Pictures, vm.images[j])) {
                vm.events[i].Pictures.push(vm.images[j]);
              }
            }
          }
        }
        if (vm.events[i].eventType == 7) {
          var date = $filter("date")(vm.events[i].eventDate, "yyyy-MM-dd");
          var miscImages = [];
          var clinicalImages = [];
          var subclinicalImages = [];
          for (var j = 0; j < vm.images.length; j++) {
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("mastitis") != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("clinicalmastitis") != -1
            ) {
              clinicalImages.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("misc") != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("miscellaneous") != -1
            ) {
              miscImages.push(vm.images[j]);
            }
            if (
              vm.images[j].Tags &&
              vm.images[j].Tags.indexOf(date) != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("subclinical") != -1 &&
              vm.images[j].Tags.toLowerCase().indexOf("subclinicalmastitis") !=
                -1
            ) {
              subclinicalImages.push(vm.images[j]);
            }
          }
          vm.events[i].miscImages = miscImages;
          vm.events[i].clinicalImages = clinicalImages;
          vm.events[i].subclinicalImages = subclinicalImages;
        }
      }
      for (var i = 0; i < vm.lactations.length; i++) {
        for (var j = 0; j < vm.allMilkMeterData.length; j++) {
          if (vm.lactations[i].Parity == vm.allMilkMeterData[j].Parity) {
            vm.allMilkMeterData[j].LactationStartDate =
              vm.lactations[i].CalvingDate;
          }
        }
        for (var k = 0; k < vm.events.length; k++) {
          if (vm.events[k].eventType == 6) {
            if (vm.events[k].Parity == vm.lactations[i].Parity) {
              vm.events[k].LactationStartDate = vm.lactations[i].CalvingDate;
            }
          }
        }
      }
      vm.events = $filter("orderBy")(vm.events, "eventDate", true);
      if (vm.events.length == 0) {
      } else if (vm.events.length > 50) {
        vm.eventsNumber = 0;
        vm.eventsToShow = getNElementsFromList(
          vm.events,
          vm.eventsNumber,
          50,
          "showLoadMoreEvents"
        );
        vm.showLoadMoreEvents = true;
      } else {
        vm.eventsToShow = vm.events;
      }

      function checkImage(list, image) {
        var insert = true;
        for (var i = 0; i < list.length; i++) {
          if (list[i].ImageUrl == image.ImageUrl) {
            insert = false;
            break;
          }
        }
        return insert;
      }
      vm.feedIntakes = setFeedIntakes(vm.allFeedIntakes);
      vm.milkMeterData = setMilkIntakes(vm.allMilkMeterData);
      var dates;
      if (vm.useRapDates) {
        dates = getDataPeriodByLactation(vm.rapDates);
      } else {
        vm.currentLactation = angular.copy(vm.lastLactation);
        dates = {
          start_date: vm.last_calving_date,
        };
      }
      createMilkGraphData(dates.start_date, dates.end_date);
      vm.showOverview = true;
      if (!vm.is_farmer && vm.activeMilkButton == 4 && vm.activeButton == 3) {
        createMilkGraph();
      }
      if (vm.is_farmer && vm.activeButton == 10) {
        createMilkGraph();
      }
      if (vm.is_farmer) {
        if (vm.useRapDates) {
          createFameTableData(dates.start_date, dates.end_date);
        } else {
          createFameTableData(vm.last_calving_date);
        }
      }
    }

    function lactationChanged() {
      var start_date = vm.currentLactation.CalvingDate;
      var nextLactation = getNextLactation(vm.currentLactation);
      var end_date;
      if (vm.currentLactation.DryOffDate) {
        end_date = moment(vm.currentLactation.DryOffDate).add(1, "days");
      } else {
        if (nextLactation) {
          if (nextLactation.CalvingInterval) {
            end_date = moment(vm.currentLactation.CalvingDate)
              .add(nextLactation.CalvingInterval, "days")
              .format("YYYY-MM-DDTHH:mm:ss");
          }
          var lastMilkingInCurrentLactation = getLastMilking(
            vm.currentLactation.CalvingDate,
            nextLactation.CalvingDate,
            vm.allMilkMeterData
          );
          if (lastMilkingInCurrentLactation) {
            end_date = moment(lastMilkingInCurrentLactation.eventDate)
              .add(1, "days")
              .format("YYYY-MM-DDTHH:mm:ss");
          } else {
            if (moment(end_date).isAfter(nextLactation.CalvingDate)) {
              end_date = moment(nextLactation.CalvingDate)
                .subtract(1, "days")
                .format("YYYY-MM-DDTHH:mm:ss");
            }
          }
        }
      }

      if (vm.currentLactation.Parity == vm.lastLactation.Parity) {
        end_date = null;
      }

      vm.hideChart = true;
      vm.noMilkGraphData = true;
      vm.useRapDates = false;
      vm.showSlider = false;
      createFameTableData(start_date, end_date);
      createMilkGraphData(start_date, end_date);
      if (mixedChart) {
        mixedChart.destroy();
      }
      if (mixedChart2) {
        mixedChart2.destroy();
      }
      if (mixedChartModal) {
        mixedChartModal.destroy();
      }
      if (mixedChartModal2) {
        mixedChartModal2.destroy();
      }

      if (vm.activeButton == 10) {
        $timeout(function () {
          vm.hideChart = false;

          createMilkGraph();
        }, 100);
      }
    }

    function getNextLactation(current_lactation) {
      var c_parity = current_lactation.Parity;
      var n_parity = c_parity + 1;
      var next_lactation = vm.availableLactations.find(function (e) {
        return e.Parity == n_parity;
      });
      return next_lactation;
    }

    function getLastMilking(current_lactation, next_lactation, milk_data) {
      var c_list = milk_data.filter(function (e) {
        return (
          moment(e.eventDate).isBefore(next_lactation) &&
          moment(e.eventDate).isAfter(current_lactation)
        );
      });

      c_list = $filter("orderBy")(c_list, "eventDate", true);
      return c_list[0];
    }

    function getDataPeriodByLactation(dates) {
      var found_from = false;
      var found_to = false;
      var lac_from;
      var lac_to;
      for (var i = 0; i < vm.lactations.length; i++) {
        if (vm.lactations[i].CalvingDate) {
          if (vm.lactations[i].DryOffDate) {
            if (
              moment(dates.start_date).isBetween(
                moment(vm.lactations[i].CalvingDate),
                moment(vm.lactations[i].DryOffDate)
              )
            ) {
              lac_from = angular.copy(vm.lactations[i]);
              found_from = true;
              break;
            }
          } else {
            if (vm.lactations[i].CalvingInterval) {
              var end_date = moment(vm.lactations[i].CalvingDate)
                .add(vm.lactations[i].CalvingInterval, "days")
                .format("YYYY-MM-DDTHH:mm:ss");
              if (
                moment(dates.start_date).isBetween(
                  moment(vm.lactations[i].CalvingDate),
                  moment(end_date)
                )
              ) {
                lac_from = angular.copy(vm.lactations[i]);
                lac_from.DryOffDate = end_date;
                found_from = true;
                break;
              }
            }
          }
        }
      }

      for (var i = 0; i < vm.lactations.length; i++) {
        if (vm.lactations[i].CalvingDate) {
          if (vm.lactations[i].DryOffDate) {
            if (
              moment(dates.end_date).isBetween(
                moment(vm.lactations[i].CalvingDate),
                moment(vm.lactations[i].DryOffDate)
              )
            ) {
              lac_to = angular.copy(vm.lactations[i]);
              found_to = true;
              break;
            }
          } else {
            if (vm.lactations[i].CalvingInterval) {
              var end_date = moment(vm.lactations[i].CalvingDate)
                .add(vm.lactations[i].CalvingInterval, "days")
                .format("YYYY-MM-DDTHH:mm:ss");
              if (
                moment(dates.end_date).isBetween(
                  moment(vm.lactations[i].CalvingDate),
                  moment(end_date)
                )
              ) {
                lac_to = angular.copy(vm.lactations[i]);
                lac_to.DryOffDate = end_date;
                found_to = true;
                break;
              }
            }
          }
        }
      }
      if (found_from && found_to) {
        if (lac_from.Parity == lac_to.Parity) {
          vm.currentLactation = lac_from;
          if (vm.last_calving_date == lac_from.CalvingDate) {
            dates = {
              start_date: vm.last_calving_date,
            };
          } else {
            dates = {
              start_date: lac_from.CalvingDate,
              end_date: lac_from.DryOffDate,
            };
          }
        } else {
          dates = {
            start_date: lac_from.CalvingDate,
            end_date: lac_to.DryOffDate,
          };
        }
      } else if (found_from && !found_to) {
        if (vm.last_calving_date == lac_from.CalvingDate) {
          dates = {
            start_date: vm.last_calving_date,
            end_date: dates.end_date,
          };
        } else {
          dates = {
            start_date: lac_from.CalvingDate,
            end_date: dates.end_date,
          };
        }
      } else if (!found_from && found_to) {
        dates = {
          start_date: getCalvingDate(dates.start_date, vm.lactations),
          end_date: lac_to.DryOffDate,
        };
      } else {
        //check is last lactation
        if (vm.lastLactation) {
          if (vm.lastLactation.CalvingDate) {
            vm.currentLactation = angular.copy(vm.lastLactation);
          }
        }
        if (vm.animal.CurrentStatus == 8) {
          vm.dim_to_show = vm.dim_to_show - vm.animal.status_days + 1;
        }

        dates = {
          start_date: vm.last_calving_date,
        };
      }
      return dates;
    }

    function getCalvingDate(date, lactations) {
      lactations = $filter("orderBy")(lactations, "CalvingDate");
      for (var i = 0; i < lactations.length; i++) {
        if (
          lactations[i] &&
          lactations[i].CalvingDate &&
          lactations[i + 1] &&
          lactations[i + 1].CalvingDate
        ) {
          if (
            (moment(date).isBetween(moment(lactations[i]).CalvingDate),
            moment(lactations[i + 1].CalvingDate))
          ) {
            return lactations[i].CalvingDate;
          }
        }
      }

      return lactations[0] ? lactations[0].CalvingDate : "1992-03-27T00:00:00";
    }

    function getBackgroundColor(legend) {
      var obj = {
        backgroundColor: legend.fillStyle,
      };
      if (legend.text == i18nFilter("_animal_details_tab_milk_production_")) {
        obj.border = "medium dashed";

        if (vm.style && vm.style.length) {
          if (vm.style == "aveve") {
            obj.border = obj.border.concat("#99bb39");
          } else if (vm.style == "proxani") {
          } else {
            obj.border = obj.border.concat(" black");
          }
        } else {
          obj.border = obj.border.concat(" black");
        }
      }
      return obj;
    }
    //set all data for milk graph
    function createMilkGraphData(from_date, to_date) {
      if (!to_date) {
        var to_date = moment()
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("milisecond", 0)
          .add(1, "days")
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      var difference = moment(to_date).diff(from_date, "days");
      vm.max_graph_value = difference;

      //  if (vm.dim) {
      vm.noMilkGraphData = false;
      var x_axis = [];
      var dates = [];
      var dateDIMList = [];
      for (var i = 0; i < difference; i++) {
        var date = moment(from_date)
          .add(i, "days")
          .set("hour", 0)
          .format("YYYY-MM-DDTHH:mm:ss");
        x_axis.push(i);
        //create date dim list to use for slider filtering
        var ddl = {
          date: date,
          index: i + 1,
        };
        dateDIMList.push(ddl);
      }
      for (var i = 0; i < dateDIMList.length; i++) {
        for (var j = 0; j < vm.allMilkMeterData.length; j++) {
          if (dateDIMList[i].date == vm.allMilkMeterData[j].Date) {
            dateDIMList[i].DIM = vm.allMilkMeterData[j].DIM;
          }
        }
      }
      vm.feedIntakeColors = [];
      for (var i = 0; i < vm.feedNamesList.length; i++) {
        if (graphColors[i]) {
          vm.feedIntakeColors.push(graphColors[i]);
        } else {
          vm.feedIntakeColors.push(getRandomColor());
        }
      }
      if (vm.allMilkMeterData.length > 7) {
        vm.rollingAverageMilk = calculateRollingAverageMikData(
          dateDIMList,
          vm.allMilkMeterData
        );
        vm.MIGRollingAverageMilkDataPresent = true;
      } else {
        vm.MIGRollingAverageMilkDataPresent = false;
      }
      //by default show whole lactation
      var first_day = 0;

      if (vm.useRapDates) {
        var rap_first_day;
        var rap_last_day;
        var rap_dates = angular.copy(vm.rapDates);
        rap_dates.start_date = moment(rap_dates.start_date)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("milisecond", 0)
          .format("YYYY-MM-DDTHH:mm:ss");
        rap_dates.end_date = moment(rap_dates.end_date)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("milisecond", 0)
          .format("YYYY-MM-DDTHH:mm:ss");

        for (var i = 0; i < dateDIMList.length; i++) {
          if (dateDIMList[i].date == rap_dates.start_date) {
            rap_first_day = dateDIMList[i].index;
          }
          if (dateDIMList[i].date == rap_dates.end_date) {
            rap_last_day = dateDIMList[i].index;
          }
        }
        first_day = rap_first_day ? rap_first_day : 1;
        difference = rap_last_day
          ? rap_last_day + 1
          : dateDIMList[dateDIMList.length - 1].index + 1;
      }
      dates = setGraphDates(dateDIMList, first_day, difference);
      setXAxis(first_day, difference);
      setMilkIntakeGraphData(dates);
      setNumberOfMilkingsGraphData(dates);
      if (vm.MIGRollingAverageMilkDataPresent) {
        setRollingAverageMilkIntakeGraphData(first_day, difference);
      }
      vm.feedIntakeDatasets = setFeedIntakeDatasets(vm.feedNamesList, dates);
      vm.programmedFeedIntakeDatasets = setProgrammedFeedIntakeDatasets(
        vm.feedNamesList,
        dates
      );
      vm.diseaseDatasets = setDiseaseDatasets(vm.healthEvents, dates);
      vm.hoofTrimDatasets = setHoofTrimDatasets(vm.hoofEvents, dates);
      vm.dateDimList = dateDIMList;
    }
    //set feed intake datasets according to used feeds
    function setFeedIntakeDatasets(feeds, dates) {
      var dataSetList = [];
      for (var i = 0; i < feeds.length; i++) {
        var dataSet = {
          name: feeds[i],
          data: [],
          color: vm.feedIntakeColors[i],
          stack: "actual",
        };
        dataSet.data = setFeedIntakeDataSet(feeds[i], dates);
        dataSetList.push(dataSet);
      }
      return dataSetList;
    }

    function setFeedIntakeDataSet(feed, dates) {
      var feedIntake = [];
      for (var i = 0; i < dates.length; i++) {
        //flag that feed data for the same date is found in feedintake data
        var found = false;
        for (var j = 0; j < vm.allFeedIntakes.length; j++) {
          //check are dates the same
          if (
            dates[i] == vm.allFeedIntakes[j].eventDate &&
            feed == vm.allFeedIntakes[j].ProductName
          ) {
            found = true;
            if (vm.allFeedIntakes[j].IntakeKg) {
              feedIntake.push(vm.allFeedIntakes[j].IntakeKg);
            } else {
              //if intake amount is missing add null value
              feedIntake.push(0);
            }
            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          feedIntake.push(0);
        }
      }
      return feedIntake;
    }
    //set programmed feed intake datasets according to used feeds
    function setProgrammedFeedIntakeDatasets(feeds, dates) {
      var dataSetList = [];
      for (var i = 0; i < feeds.length; i++) {
        var dataSet = {
          name: feeds[i],
          data: [],
          stack: "programmed",
        };
        dataSet.data = setProgrammedFeedIntakeDataSet(feeds[i], dates);
        dataSetList.push(dataSet);
      }
      return dataSetList;
    }

    function setProgrammedFeedIntakeDataSet(feed, dates) {
      var feedIntake = [];
      for (var i = 0; i < dates.length; i++) {
        //flag that feed data for the same date is found in feedintake data
        var found = false;
        for (var j = 0; j < vm.allFeedIntakes.length; j++) {
          //check are dates the same
          if (
            dates[i] == vm.allFeedIntakes[j].eventDate &&
            feed == vm.allFeedIntakes[j].ProductName
          ) {
            found = true;
            if (vm.allFeedIntakes[j].RationKg) {
              feedIntake.push(vm.allFeedIntakes[j].RationKg);
            } else {
              //if intake amount is missing add null value
              feedIntake.push(0);
            }
            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          feedIntake.push(0);
        }
      }
      return feedIntake;
    }

    function setDiseaseDatasets(events, dates) {
      var dataSet = {
        name: $filter("i18n")("_animal_disease_"),
        data: [],
        diseases: [],
        dates: [],
        data_show: [],
      };

      for (var i = 0; i < dates.length; i++) {
        var found = false;
        dataSet.dates.push(dates[i]);
        for (var j = 0; j < events.length; j++) {
          if (dates[i] == events[j].eventDate) {
            found = true;
            if (events[j].diseases && events[j].diseases.length) {
              dataSet.data.push(10);
              dataSet.data_show.push(events[j].n);
              dataSet.diseases.push(events[j].diseases);
            }

            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          dataSet.data_show.push(null);
          dataSet.data.push(null);
          dataSet.diseases.push(null);
        }
      }

      return dataSet;
    }

    function setHoofTrimDatasets(events, dates) {
      var dataSet = {
        name: "hoof health",
        data: [],
        events: [],
        dates: [],
      };

      for (var i = 0; i < dates.length; i++) {
        var found = false;
        dataSet.dates.push(dates[i]);
        for (var j = 0; j < events.length; j++) {
          if (dates[i] == events[j].eventDate) {
            found = true;
            dataSet.data.push(10);
            dataSet.events.push(events[j].visit_reason_string);
            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          dataSet.events.push(null);
          dataSet.data.push(null);
        }
      }

      return dataSet;
    }

    //return list of used dates
    function setGraphDates(list, first_item, last_item) {
      var dates = [];
      if (list[first_item]) {
        vm.start_date = list[first_item].date;
      }
      if (list[last_item - 1]) {
        vm.end_date = list[last_item - 1].date;
      }
      for (var i = first_item; i < last_item; i++) {
        if (list[i]) {
          dates.push(list[i].date);
        }
      }
      return dates;
    }
    //set dim values for x axis
    function setXAxis(first_item, last_item) {
      var xAxis = [];
      for (var i = first_item; i < last_item; i++) {
        xAxis.push(i + 1);
      }
      vm.MIGX_axis = xAxis;
    }
    //set mik intake data for graph
    //input parameter is list of dates for which milk meter data will be used
    function setMilkIntakeGraphData(dates) {
      var milkIntake = [];
      var milkIntakeDataPresent = false;
      for (var i = 0; i < dates.length; i++) {
        //flag that milk data for the same date is found in milkmeterdata
        var found = false;
        for (var j = 0; j < vm.allMilkMeterData.length; j++) {
          //check are dates the same
          if (dates[i] == vm.allMilkMeterData[j].eventDate) {
            found = true;
            if (vm.allMilkMeterData[j].AmountKg) {
              milkIntake.push(vm.allMilkMeterData[j].AmountKg);
              milkIntakeDataPresent = true;
            } else {
              //if intake amount is missing add null value
              milkIntake.push(null);
            }
            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          milkIntake.push(null);
        }
      }
      vm.MIGMilkIntakeDataPresent = milkIntakeDataPresent;
      vm.MIGMilkIntake = milkIntake;
    }
    //set rolling average milk intake data for graph
    function setRollingAverageMilkIntakeGraphData(first_item, last_item) {
      var milkIntake = [];
      for (var i = first_item; i < last_item; i++) {
        if (vm.rollingAverageMilk[i]) {
          milkIntake.push(vm.rollingAverageMilk[i]);
        } else {
          milkIntake.push(null);
        }
      }
      vm.MIGRollingAverageMilkIntake = milkIntake;
    }
    //function for calculaton of rolling average for 7 days of milk intake
    function calculateRollingAverageMikData(dateDimList, milkIntake) {
      var list = [];
      for (var i = 0; i < dateDimList.length; i++) {
        var calculateSum = false;
        if (i < 6) {
          list.push(null);
        } else {
          calculateSum = true;
          var sum = 0;
          for (var j = 0; j < milkIntake.length; j++) {
            if (dateDimList[i].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 1].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 2].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 3].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 4].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 5].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
            if (dateDimList[i - 6].date == milkIntake[j].eventDate) {
              if (milkIntake[j].AmountKg) {
                sum += milkIntake[j].AmountKg;
              }
            }
          }
        }
        if (calculateSum) {
          sum = appService.round(sum / 7, 2);
          list.push(sum);
        }
      }
      return list;
    }
    //function for calculation of rolling average for 7 days
    //input parameters data list
    //property for which average is calculated
    //name of resulting parameter
    function calculateRollingAverage(
      data,
      property,
      calculated_property,
      decimals
    ) {
      if (data[0] && data[0].dim && angular.isDefined(data[0].dim)) {
        data = $filter("orderBy")(data, "dim");
        for (var i = 0; i < data.length; i++) {
          var calculateSum = false;
          if (i < 6) {
            data[i][calculated_property] = "-";
          } else {
            calculateSum = true;
            var sum = 0;
            var items = 0;
            if (angular.isNumber(data[i][property])) {
              sum += data[i][property];
              items++;
            }
            if (angular.isNumber(data[i - 1][property])) {
              sum += data[i - 1][property];
              items++;
            }
            if (angular.isNumber(data[i - 2][property])) {
              sum += data[i - 2][property];
              items++;
            }
            if (angular.isNumber(data[i - 3][property])) {
              sum += data[i - 3][property];
              items++;
            }
            if (angular.isNumber(data[i - 4][property])) {
              sum += data[i - 4][property];
              items++;
            }
            if (angular.isNumber(data[i - 5][property])) {
              sum += data[i - 5][property];
              items++;
            }
            if (angular.isNumber(data[i - 6][property])) {
              sum += data[i - 6][property];
              items++;
            }
          }
          if (calculateSum) {
            if (decimals) {
              sum = appService.round(sum / items, decimals);
            } else {
              sum = appService.round(sum / items, 2);
            }

            if (angular.isNumber(sum) && !isNaN(sum)) {
              data[i][calculated_property] = sum;
            } else {
              data[i][calculated_property] = "-";
            }
          }
        }
      }
      return data;
    }
    //set number of milkings data for graph
    //input parameter is list of dates for which milk meter data will be used
    function setNumberOfMilkingsGraphData(dates) {
      var numberOfMilkings = [];
      var numberOfMilkingsDataPresent = false;
      for (var i = 0; i < dates.length; i++) {
        //flag that number of milkings data for the same date is found in milkmeterdata
        var found = false;
        for (var j = 0; j < vm.allMilkMeterData.length; j++) {
          //check are dates the same
          if (dates[i] == vm.allMilkMeterData[j].eventDate) {
            found = true;
            if (vm.allMilkMeterData[j].Milkings) {
              numberOfMilkings.push(vm.allMilkMeterData[j].Milkings);
              numberOfMilkingsDataPresent = true;
            } else {
              //if intake amount is missing add null value
              numberOfMilkings.push(null);
            }
            break;
          }
        }
        //if data for current date is not found add null value
        if (!found) {
          numberOfMilkings.push(null);
        }
      }
      vm.MIGNumberOfMilkingsDataPresent = numberOfMilkingsDataPresent;
      vm.MIGNumberOfMilkingsData = numberOfMilkings;
    }

    function createFameTableData(from_date, to_date) {
      if (!to_date) {
        var to_date = moment()
          .add(1, "days")
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("milisecond", 0)
          .format("YYYY-MM-DDTHH:mm:ss");
      }
      var difference = moment(to_date).diff(from_date, "days");
      var fameTableData = [];
      for (var i = 0; i <= difference; i++) {
        var date = moment(from_date)
          .add(i, "days")
          .set("hour", 0)
          .format("YYYY-MM-DDTHH:mm:ss");
        var obj = {
          date: date,
        };
        fameTableData.push(obj);
      }
      for (var i = 0; i < fameTableData.length; i++) {
        for (var j = 0; j < vm.allMilkMeterData.length; j++) {
          if (fameTableData[i].date == vm.allMilkMeterData[j].eventDate) {
            fameTableData[i].found = true;
            fameTableData[i].dim = vm.allMilkMeterData[j].DIM;
            fameTableData[i].milkIntake = vm.allMilkMeterData[j].AmountKg;
            if (angular.isNumber(vm.allMilkMeterData[j].Failures)) {
              fameTableData[i].failures = vm.allMilkMeterData[j].Failures;
            }
            if (angular.isNumber(vm.allMilkMeterData[j].Milkings)) {
              fameTableData[i].milkings = vm.allMilkMeterData[j].Milkings;
            }
            if (angular.isNumber(vm.allMilkMeterData[j].Refusals)) {
              fameTableData[i].refusals = vm.allMilkMeterData[j].Refusals;
            }
            if (angular.isNumber(vm.allMilkMeterData[j].MilkSpeed)) {
              fameTableData[i].milkSpeed = appService.round(
                vm.allMilkMeterData[j].MilkSpeed,
                1
              );
            }
          }
        }
        for (var k = 0; k < vm.allMilkRecordings.length; k++) {
          if (fameTableData[i].date == vm.allMilkRecordings[k].eventDate) {
            fameTableData[i].spp =
              vm.allMilkRecordings && vm.allMilkRecordings[k]
                ? vm.allMilkRecordings[k].SPP
                : null;
          }
        }
        fameTableData[i] = setConcentrateIntakeAndLeftovers(fameTableData[i]);
      }
      for (var i = 0; i < fameTableData.length; i++) {
        if (!angular.isNumber(fameTableData[i].failures)) {
          fameTableData[i].failures = "-";
        }
        if (!angular.isNumber(fameTableData[i].milkSpeed)) {
          fameTableData[i].milkSpeed = "-";
        }
        if (!angular.isNumber(fameTableData[i].milkings)) {
          fameTableData[i].milkings = "-";
        }
        if (!angular.isNumber(fameTableData[i].refusals)) {
          fameTableData[i].refusals = "-";
        }
      }
      fameTableData = $filter("orderBy")(fameTableData, "date");
      //console.table(fameTableData)
      if (fameTableData.length) {
        fameTableData = calculateRollingAverage(
          fameTableData,
          "milkings",
          "milkings_average",
          1
        );
        fameTableData = calculateRollingAverage(
          fameTableData,
          "failures",
          "failures_average",
          1
        );
        fameTableData = calculateRollingAverage(
          fameTableData,
          "refusals",
          "refusals_average",
          1
        );
        var sum = 0;
        var nMilkIntake = 0;
        for (var i = 0; i < fameTableData.length; i++) {
          if (fameTableData[i].milkIntake) {
            sum += fameTableData[i].milkIntake;
            nMilkIntake++;
          }
          if (
            fameTableData[i - 1] &&
            fameTableData[i - 1].milkIntake &&
            fameTableData[i].milkIntake
          ) {
            fameTableData[i].deviation = calculateDeviation(
              fameTableData[i - 1].milkIntake,
              fameTableData[i].milkIntake
            );
          }
        }
        var milk_production_sum;
        var milk_production_avg;
        if (sum) {
          milk_production_sum = appService.round(sum, 2);
          milk_production_avg = appService.round(sum / nMilkIntake, 2);
        } else {
          milk_production_sum = null;
          milk_production_avg = null;
        }
        vm.std = {
          milk_production_avg: milk_production_avg,
          milk_production_sum: milk_production_sum,
        };
        vm.allFameTableData = $filter("orderBy")(fameTableData, "date", true);
        vm.fameTableData = setFameTableData(vm.allFameTableData);
      }
    }

    function setConcentrateIntakeAndLeftovers(event) {
      var totalCalculatedConcentrate = 0;
      var totalConsumedConcentrate = 0;
      var l = vm.allFeedIntakes.length;
      for (var i = 0; i < l; i++) {
        if (event.date == vm.allFeedIntakes[i].eventDate) {
          totalCalculatedConcentrate += vm.allFeedIntakes[i].RationKg;
          totalConsumedConcentrate += vm.allFeedIntakes[i].IntakeKg;
        }
      }
      if (totalCalculatedConcentrate) {
        event.totalCalculatedConcentrate =
          appService.round(totalCalculatedConcentrate, 1) + "Kg";
        if (totalConsumedConcentrate) {
          var leftovers = totalCalculatedConcentrate - totalConsumedConcentrate;
          if (leftovers < 0) {
            leftovers = 0;
          }
          event.leftovers = appService.round(leftovers, 1) + "Kg";
        }
      }

      return event;
    }

    function setFameTableData(fameTableData) {
      var list = [];
      if (vm.useRapDates) {
        var start_date = vm.rapDates.start_date;
        var end_date = vm.rapDates.end_date;
        for (var i = 0; i < fameTableData.length; i++) {
          if (
            moment(fameTableData[i].date).isAfter(start_date) &&
            moment(fameTableData[i].date).isBefore(end_date)
          ) {
            list.push(fameTableData[i]);
            vm.showLoadMoreFameTableData = false;
          }
        }
      } else {
        if (fameTableData.length > 50) {
          vm.showLoadMoreFameTableData = true;
          vm.fameTableDataNumber = 0;
          list = list.concat(
            getNElementsFromList(
              fameTableData,
              vm.fameTableDataNumber,
              50,
              "showLoadMoreFameTableData"
            )
          );
        } else {
          list = fameTableData;
        }
      }

      return list;
    }

    function createMilkGraph(dim_change) {
      vm.diseaseImage = new Image(50, 50);
      vm.diseaseImage.src = "assets/img/thermometer.svg";
      vm.hoofTrimImage = new Image(36, 36);
      vm.hoofTrimImage.src = "assets/img/icons/clawHealth.png";
      var MIGX_axis = angular.copy(vm.MIGX_axis);
      for (var i = 0; i < MIGX_axis.length; i++) {
        for (var j = 0; j < vm.dateDimList.length; j++) {
          if (MIGX_axis[i] == vm.dateDimList[j].index) {
            MIGX_axis[i] =
              (vm.dateDimList[j].DIM ? vm.dateDimList[j].DIM : "") +
              ";" +
              $filter("date")(vm.dateDimList[j].date, "shortDate") +
              ";" +
              i;
          }
        }
      }
      if (!vm.noMilkGraphData) {
        var programmedData = [];
        for (var i = 0; i < vm.programmedFeedIntakeDatasets.length; i++) {
          var dataSet = {
            label: vm.programmedFeedIntakeDatasets[i].name,
            data: vm.programmedFeedIntakeDatasets[i].data,
            yAxisID: "right-axis",
            backgroundColor: vm.programmedFeedIntakeDatasets[i].color,
            borderColor: vm.programmedFeedIntakeDatasets[i].color,
            stack: vm.programmedFeedIntakeDatasets[i].stack,
          };
          programmedData.push(dataSet);
        }
        var ylabelwidth = 0;
        var legendItems = [];
        var chartNMilkings = {
          type: "bar",
          data: {
            datasets: [
              {
                label: i18nFilter("_animal_details_number_of_milkings_"),
                data: vm.MIGNumberOfMilkingsData,
                backgroundColor: vm.style
                  ? vm.style == "aveve"
                    ? "#e3b258"
                    : vm.style == "proxani"
                    ? "#536121"
                    : "#0000FF"
                  : "#0000FF",
                borderColor: vm.style
                  ? vm.style == "aveve"
                    ? "#e3b258"
                    : vm.style == "proxani"
                    ? "#536121"
                    : "#0000FF"
                  : "#00a00FF",
                xAxisID: "xAxis1",
              },
            ],
            labels: MIGX_axis,
          },
          options: {
            legendCallback: function (chart) {
              legendItems = legendItems.concat(chart.legend.legendItems);
            },
            layout: {
              padding: {},
            },
            legend: {
              display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
              mode: "nearest",
              intersect: false,
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            scales: {
              xAxes: [
                {
                  display: true,
                  stacked: true,
                  scaleLabel: {
                    display: true,
                    labelString: i18nFilter("_animal_days_in_milk_"),
                  },
                  id: "xAxis1",
                  type: "category",
                  ticks: {
                    callback: function (label) {
                      var dim = label.split(";")[0];
                      return dim;
                    },
                  },
                },
                {
                  id: "xAxis2",
                  type: "category",
                  gridLines: {
                    drawOnChartArea: false, // only want the grid lines for one axis to show up
                  },
                  ticks: {
                    autoSkip: false,
                    callback: function (label) {
                      var date = label.split(";")[1];
                      var index = label.split(";")[2];
                      if (index == 0 || index % 7 == 0) {
                        return date;
                      } else {
                        return "";
                      }
                    },
                  },
                },
              ],
              yAxes: [
                {
                  type: "linear",
                  id: "left-axis",
                  display: true,
                  position: "left",
                  scaleLabel: {
                    display: true,
                    labelString: i18nFilter(
                      "_animal_details_number_of_milkings_"
                    ),
                  },
                  ticks: {
                    stepSize: 1,
                    beginAtZero: true,
                  },
                  afterFit: function (scaleInstance) {
                    if (ylabelwidth < scaleInstance.width) {
                      ylabelwidth = scaleInstance.width;
                    } else {
                      scaleInstance.width = ylabelwidth;
                      scaleInstance.maxWidth = ylabelwidth;
                      scaleInstance.minSize.width = ylabelwidth;
                    }
                  },
                },
                {
                  type: "linear",
                  id: "right-axis",
                  display: false,
                  position: "right",
                  stacked: true,
                  scaleLabel: {
                    display: true,
                    labelString:
                      i18nFilter("_animal_details_rap_graph_feed_intake_") +
                      " (Kg)",
                  },
                  ticks: {
                    stepSize: 1,
                  },
                  afterFit: function (scaleInstance) {
                    if (ylabelwidth < scaleInstance.width) {
                      ylabelwidth = scaleInstance.width;
                    } else {
                      scaleInstance.width = ylabelwidth;
                      scaleInstance.maxWidth = ylabelwidth;
                      scaleInstance.minSize.width = ylabelwidth;
                    }
                  },
                  gridLines: {
                    drawOnChartArea: false,
                  },
                },
              ],
            },
          },
        };
        var chartData = {
          type: "bar",
          data: {
            datasets: [
              {
                label: i18nFilter("_animal_details_tab_milk_production_"),
                data: vm.MIGMilkIntake,
                fill: false,
                spanGaps: true,
                type: "line",
                yAxisID: "left-axis",
                borderColor: vm.style
                  ? vm.style == "aveve"
                    ? "#00564a"
                    : vm.style == "proxani"
                    ? "#99bb39"
                    : "#000000"
                  : "#000000",
                backgroundColor: "#FFFFFF",
                borderDash: [3, 3],
                pointRadius: 0,
              },
              {
                label: $filter("i18n")("_animal_disease_"),
                data: vm.diseaseDatasets.data,
                type: "bubble",
                pointStyle: vm.diseaseImage,
                radius: 40,
                order: 2,
                //borderColor: '#000000',
                //backgroundColor: '#e6b400'
              },
              {
                label: "hoof trims",
                data: vm.hoofTrimDatasets.data,
                type: "bubble",
                pointStyle: vm.hoofTrimImage,
                radius: 40,
                order: 2,
                //borderColor: '#000000',
                //backgroundColor: '#e6b400'
              },
            ],
            labels: vm.MIGX_axis,
          },
          options: {
            onClick: function (e) {
              var activePoints = mixedChart.getElementsAtEvent(e);
              if (activePoints.length) {
                var hoofTrimEventDate;
                for (var i = 0; i < activePoints.length; i++) {
                  if (activePoints[i]._datasetIndex == 2) {
                    hoofTrimEventDate =
                      vm.hoofTrimDatasets.dates[activePoints[i]._index];
                    break;
                  }
                }
              }
              if (hoofTrimEventDate) {
                showHoofTrimInfoModal(hoofTrimEventDate);
              }
            },
            legendCallback: function (chart) {
              var li = chart.legend.legendItems.filter(function (item) {
                return (
                  item.text != $filter("i18n")("_animal_disease_") &&
                  item.text != "hoof trims"
                );
              });
              legendItems = legendItems.concat(li);
            },
            legend: {
              position: "bottom",
              usePointStyle: true,
              display: false,
              labels: {
                fontSize: 13,
                fontStyle: "bold",
              },
            },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
              mode: "nearest",
              intersect: false,
              callbacks: {
                afterLabel: function (item, data) {
                  var dataSet = item.datasetIndex;
                  var index = item.index;
                  var label = data.datasets[dataSet].label;
                  for (var i = 0; i < programmedData.length; i++) {
                    if (programmedData[i].label == label) {
                      data = programmedData[i].data[index];
                      break;
                    }
                  }

                  if (
                    label ==
                      i18nFilter("_animal_details_tab_milk_production_") ||
                    label ==
                      i18nFilter("_animal_details_rolling_milk_intake_average_")
                  ) {
                    return undefined;
                  } else if (label == $filter("i18n")("_animal_disease_")) {
                    var string = "(";
                    for (
                      var i = 0;
                      i < vm.diseaseDatasets.diseases[index].length;
                      i++
                    ) {
                      string += $filter("i18n")(
                        vm.diseaseDatasets.diseases[index][i].label_translate
                      );
                      if (vm.diseaseDatasets.diseases[index][i + 1]) {
                        string += "\n";
                      }
                    }

                    string += ")";
                    return string;
                  } else if (label == "hoof trims") {
                    return undefined;
                  } else {
                    return "(" + data + ")";
                  }
                },
                beforeLabel: function (item, data) {
                  var dataSet = item.datasetIndex;
                  var index = item.index;
                  var label = data.datasets[dataSet].label;
                  var data;
                  return $filter("date")(
                    new Date(vm.diseaseDatasets.dates[index]),
                    "shortDate"
                  );
                },
                title: function (item, data) {
                  return undefined;
                },
                label: function (item, data) {
                  var dataset = data.datasets[item.datasetIndex].label;
                  var value = item.yLabel;
                  var index = item.index;
                  var diseaseValue = vm.diseaseDatasets.data_show[index];
                  if (dataset == $filter("i18n")("_animal_disease_")) {
                    return dataset + ": " + diseaseValue;
                  } else if (dataset == "hoof trims") {
                    return " " + vm.hoofTrimDatasets.events[index];
                  } else {
                    return dataset + ": " + value;
                  }
                },
              },
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            scales: {
              xAxes: [
                {
                  display: false,
                  stacked: true,
                  scaleLabel: {
                    display: false,
                    labelString: i18nFilter("_animal_days_in_milk_"),
                  },
                },
              ],
              yAxes: [
                {
                  type: "linear",
                  id: "left-axis",
                  display: true,
                  position: "left",
                  scaleLabel: {
                    display: true,
                    labelString:
                      i18nFilter("_animal_details_tab_milk_production_") +
                      " (Kg)",
                  },
                  afterFit: function (scaleInstance) {
                    if (ylabelwidth < scaleInstance.width) {
                      ylabelwidth = scaleInstance.width;
                    } else {
                      scaleInstance.width = ylabelwidth;
                      scaleInstance.maxWidth = ylabelwidth;
                      scaleInstance.minSize.width = ylabelwidth;
                    }
                  },
                },
                {
                  type: "linear",
                  id: "right-axis",
                  display: true,
                  position: "right",
                  stacked: true,
                  scaleLabel: {
                    display: true,
                    labelString:
                      i18nFilter("_animal_details_rap_graph_feed_intake_") +
                      " (Kg)",
                  },
                  gridLines: {
                    drawOnChartArea: false,
                  },
                  afterFit: function (scaleInstance) {
                    if (ylabelwidth < scaleInstance.width) {
                      ylabelwidth = scaleInstance.width;
                    } else {
                      scaleInstance.width = ylabelwidth;
                      scaleInstance.maxWidth = ylabelwidth;
                      scaleInstance.minSize.width = ylabelwidth;
                    }
                  },
                },
              ],
            },
          },
        };
        if (vm.MIGRollingAverageMilkDataPresent) {
          var dataSet = {
            label: i18nFilter("_animal_details_rolling_milk_intake_average_"),
            data: vm.MIGRollingAverageMilkIntake,
            fill: false,
            spanGaps: true,
            type: "line",
            yAxisID: "left-axis",
            borderColor: vm.style
              ? vm.style == "aveve"
                ? "#00564a"
                : vm.style == "proxani"
                ? "#99bb39"
                : "#000000"
              : "#000000",
            backgroundColor: vm.style
              ? vm.style == "aveve"
                ? "#00564a"
                : vm.style == "proxani"
                ? "#99bb39"
                : "#000000"
              : "#000000",
            pointRadius: 0,
          };
          chartData.data.datasets.push(dataSet);
        }
        for (var i = 0; i < vm.feedIntakeDatasets.length; i++) {
          var dataSet = {
            label: vm.feedIntakeDatasets[i].name,
            data: vm.feedIntakeDatasets[i].data,
            yAxisID: "right-axis",
            backgroundColor: vm.feedIntakeDatasets[i].color,
            borderColor: vm.feedIntakeDatasets[i].color,
            stack: vm.feedIntakeDatasets[i].stack,
          };
          chartData.data.datasets.push(dataSet);
        }
        vm.chartData = chartData;
        vm.chartNMilkings = chartNMilkings;
        vm.fromSlider = vm.MIGX_axis[0];
        vm.toSlider = vm.MIGX_axis[vm.MIGX_axis.length - 1];
        if (
          (vm.MIGMilkIntakeDataPresent || chartData.data.datasets.length > 1) &&
          vm.MIGX_axis.length
        ) {
          vm.noMilkGraphData = false;
          $timeout(function () {
            vm.showSlider = true;
            if (vm.graphModalOpened) {
              mctx = document.getElementById("myChartModal");
              mixedChartModal = new Chart(mctx, vm.chartData);
              mctx2 = document.getElementById("myChartModal2");
              mixedChartModal2 = new Chart(mctx2, vm.chartNMilkings);
              mixedChartModal.destroy();
              mixedChartModal2.destroy();
              mixedChartModal = new Chart(mctx, vm.chartData);
              mixedChartModal2 = new Chart(mctx2, vm.chartNMilkings);
            }
            ctx = document.getElementById("myChart");
            if (ctx) {
              mixedChart = new Chart(ctx, chartData);
            }
            ctx2 = document.getElementById("myChart2");
            if (ctx2) {
              mixedChart2 = new Chart(ctx2, chartNMilkings);
            }
            if (mixedChart) {
              mixedChart.destroy();
            }

            if (mixedChart2) {
              mixedChart2.destroy();
            }

            mixedChart2 = new Chart(ctx2, chartNMilkings);
            mixedChart = new Chart(ctx, chartData);
            if (!dim_change) {
              mixedChart.generateLegend();
              mixedChart2.generateLegend();
              vm.legendItems = legendItems;
            }
          }, 300);
        } else {
          vm.noMilkGraphData = true;
        }
      }
    }
    //check is there more than 50 feed intakes
    // if yes show only 50 and set parameters
    function setFeedIntakes(feedIntakes) {
      var list = [];
      if (feedIntakes.length > 50) {
        vm.showLoadMoreFeedIntakes = true;
        vm.feedIntakesPageNumber = 0;
        list = list.concat(
          getNElementsFromList(
            feedIntakes,
            vm.feedIntakesPageNumber,
            50,
            "showLoadMoreFeedIntakes"
          )
        );
      } else {
        list = feedIntakes;
      }
      return list;
    }

    function setMilkIntakes(milkIntakes) {
      var list = [];
      if (milkIntakes.length > 50) {
        vm.showLoadMoreMilkIntakes = true;
        vm.milkIntakesPageNumber = 0;
        list = list.concat(
          getNElementsFromList(
            milkIntakes,
            vm.milkIntakesPageNumber,
            50,
            "showLoadMoreMilkIntakes"
          )
        );
      } else {
        list = milkIntakes;
      }
      return list;
    }

    function sliderChanged() {
      if (sliderTimer) {
        $timeout.cancel(sliderTimer);
      }
      sliderTimer = $timeout(function () {
        filterGraphByDIM();
      }, 1000);
    }

    function filterGraphByDIM() {
      if (vm.dateDimList) {
        vm.hideChart = true;
        var dates;
        dates = setGraphDates(vm.dateDimList, vm.fromSlider - 1, vm.toSlider);
        var start_d = new Date(dates[0]).toISOString();
        var end_d = new Date(dates[dates.length - 1]).toISOString();
        setXAxis(vm.fromSlider - 1, vm.toSlider);
        setMilkIntakeGraphData(dates);
        setNumberOfMilkingsGraphData(dates);
        if (vm.MIGRollingAverageMilkDataPresent) {
          setRollingAverageMilkIntakeGraphData(vm.fromSlider - 1, vm.toSlider);
        }
        vm.feedIntakeDatasets = setFeedIntakeDatasets(vm.feedNamesList, dates);
        vm.programmedFeedIntakeDatasets = setProgrammedFeedIntakeDatasets(
          vm.feedNamesList,
          dates
        );
        vm.diseaseDatasets = setDiseaseDatasets(vm.healthEvents, dates);
        vm.hoofTrimDatasets = setHoofTrimDatasets(vm.hoofEvents, dates);
        $timeout(function () {
          vm.hideChart = false;
          createMilkGraph(true);
        }, 100);
      }
    }
    //extract n elements from list according to current page
    // inputs: list to extract from; number of page; how menu items to extract; parameter to set to false if end of list is reached
    // output list of n items from index to index + lenght
    function getNElementsFromList(list, index, lenght, parameter) {
      var returnList = [];
      var firstItem = index * lenght;
      var lastItem = firstItem + lenght;
      for (var i = firstItem; i < lastItem; i++) {
        if (list[i]) {
          returnList.push(list[i]);
        } else {
          if (parameter) {
            vm[parameter] = false;
          }
        }
      }
      return returnList;
    }

    function getObservations(animal_id) {
      return animalDetailsService
        .getObservations(animal_id)
        .then(function (response) {
          vm.observations = response;
          var events = [];
          var obj = appService.groupBy(response, "ObservationDate");
          angular.forEach(obj, function (value, key) {
            var event = {
              eventDate: key,
              eventType: 4,
              Pictures: [],
            };
            for (var i = 0; i < value.length; i++) {
              if (value[i].Type == 1) {
                event.Pictures = value[i].Pictures;
                event.BCS = value[i].Value;
              } else if (value[i].Type == 2) {
                event.Temperature = value[i].Value;
              } else if (value[i].Type == 3) {
                event.ParturitionInjury = value[i].Value;
              } else if (value[i].Type == 4) {
                event.PlacentaOff = value[i].Value;
                for (
                  var j = 0;
                  j < APP_CONSTANTS.constants.retainedPlacenta.length;
                  j++
                ) {
                  if (
                    value[i].Value ==
                    APP_CONSTANTS.constants.retainedPlacenta[j].value
                  ) {
                    event.PlacentaOffString =
                      APP_CONSTANTS.constants.retainedPlacenta[j].label;
                    break;
                  }
                }
              } else if (value[i].Type == 5) {
                event.RumenFill = value[i].Value;
              } else if (value[i].Type == 6) {
                event.UterineDischarge = value[i].Value;
              } else if (value[i].Type == 7) {
                event.ManureScore = value[i].Value;
              } else if (value[i].Type == 8) {
                event.UrinaryPH = value[i].Value;
              } else if (value[i].Type == 9) {
                event.UrineBhb = value[i].Value;
                if (value[i].Value == 0) {
                  event.UrineBhbColor = 1;
                } else if (value[i].Value == 5) {
                  event.UrineBhbColor = 2;
                } else if (value[i].Value == 15) {
                  event.UrineBhbColor = 3;
                } else if (value[i].Value == 40) {
                  event.UrineBhbColor = 4;
                } else if (value[i].Value == 80) {
                  event.UrineBhbColor = 5;
                } else if (value[i].Value == 160) {
                  event.UrineBhbColor = 6;
                }
              } else if (value[i].Type == 10) {
                event.MilkBhb = value[i].Value;
                if (value[i].Value == 0) {
                  event.MilkBhbColor = 1;
                } else if (value[i].Value == 50) {
                  event.MilkBhbColor = 2;
                } else if (value[i].Value == 100) {
                  event.MilkBhbColor = 3;
                } else if (value[i].Value == 200) {
                  event.MilkBhbColor = 4;
                } else if (value[i].Value == 500) {
                  event.MilkBhbColor = 5;
                } else if (value[i].Value == 1000) {
                  event.MilkBhbColor = 6;
                }
              } else if (value[i].Type == 11) {
                event.BloodBhb = value[i].Value;
                if (value[i].Value < 1) {
                  event.BloodBhbColor = 1;
                } else if (value[i].Value >= 1 && value[i].Value < 1.4) {
                  event.BloodBhbColor = 2;
                } else {
                  event.BloodBhbColor = 3;
                }
              } else if (value[i].Type == 12) {
                event.BloodCalcium = value[i].Value;
                if (value[i].Value >= 8.7 && value[i].Value <= 11) {
                  event.BloodCalciumColor = 1;
                } else if (value[i].Value <= 8.6 && value[i].Value > 8) {
                  event.BloodCalciumColor = 2;
                } else if (value[i].Value < 8) {
                  event.BloodCalciumColor = 3;
                }
              }
            }
            vm.events.push(event);
          });
          observation.resolve();
        })
        .catch(function (error) {
          console.log(error);
          images.reject();
        });
    }

    function getHealthEvents(animal_id) {
      return animalDetailsService
        .getHealthEvents(animal_id)
        .then(function (response) {
          vm.diseaseEvents = vm.diseaseEvents.concat(response);
          var mastitisList = response.filter(function (element) {
            return (
              element.HealthCondition == 31 || element.HealthCondition == 32
            );
          });

          response = response.filter(function (element) {
            return (
              element.HealthCondition != 31 && element.HealthCondition != 32
            );
          });

          mastitisList = setMastitisEvents(mastitisList);
          vm.events = vm.events.concat(mastitisList);
          var obj = appService.groupBy(response, "StartDate");
          angular.forEach(obj, function (value, key) {
            var event = {
              eventDate: key,
              eventType: 8,
              DiseasesPictures: [],
              PreventionsPictures: [],
              Diseases: [],
              Preventions: [],
              DIM: value[0].DIM,
            };
            event.tagDate = $filter("date")(key, "yyyy-MM-dd");
            for (var i = 0; i < value.length; i++) {
              for (
                var d = 0;
                d < APP_CONSTANTS.constants.diseases.length;
                d++
              ) {
                if (
                  value[i].HealthCondition ==
                  APP_CONSTANTS.constants.diseases[d].value
                ) {
                  event.Diseases.push(APP_CONSTANTS.constants.diseases[d]);
                }
              }
              for (
                var d = 0;
                d < APP_CONSTANTS.constants.preventions.length;
                d++
              ) {
                if (
                  value[i].HealthCondition ==
                  APP_CONSTANTS.constants.preventions[d].value
                ) {
                  event.Preventions.push(
                    APP_CONSTANTS.constants.preventions[d]
                  );
                }
              }
            }
            vm.events.push(event);
          });
          healthEvents.resolve();
        })
        .catch(function (error) {
          console.log(error);
          healthEvents.reject();
        });
    }

    function setHealthEvents(events) {
      var e_list = [];
      events = appService.groupBy(events, "StartDate");

      angular.forEach(events, function (value, key) {
        var d_value = removeDuplicates(value);
        var event = {
          eventDate: key,
          n: d_value.length,
          diseases: getDiseases(d_value),
        };
        e_list.push(event);
      });

      function removeDuplicates(list) {
        var l = [];

        for (var i = 0; i < list.length; i++) {
          if (notAdded(l, list[i])) {
            l.push(list[i]);
          }
        }

        function notAdded(_list, item) {
          var added = false;
          for (var j = 0; j < _list.length; j++) {
            if (_list[j].HealthCondition == item.HealthCondition) {
              added = true;
              break;
            }
          }

          return !added;
        }

        return l;
      }
      return e_list;
    }

    function getDiseases(events) {
      var list = [];
      for (var i = 0; i < events.length; i++) {
        for (var d = 0; d < APP_CONSTANTS.constants.diseases.length; d++) {
          if (
            events[i].HealthCondition ==
            APP_CONSTANTS.constants.diseases[d].value
          ) {
            list.push(APP_CONSTANTS.constants.diseases[d]);
          }
        }
      }
      return list;
    }

    function setMastitisEvents(events) {
      var clinical = [];
      var subclinical = [];
      var list = [];
      for (var i = 0; i < events.length; i++) {
        if (events[i].HealthCondition == 31) {
          clinical.push(events[i]);
        } else {
          subclinical.push(events[i]);
        }
      }

      for (var i = 0; i < clinical.length; i++) {
        var event = {
          eventDate: clinical[i].StartDate,
          eventType: 18,
          UdderHealthType: 0,
          DIM: clinical[i].DIM,
        };

        var locations = decodeLocations(clinical[i].Location);
        if (locations.length) {
          for (var l = 0; l < locations.length; l++) {
            event[locations[l].l] = {
              Quarter: locations[l].q,
            };
          }
        } else {
          event.UN = {
            Quarter: 99,
          };
        }

        list.push(event);
      }

      for (var i = 0; i < subclinical.length; i++) {
        var event = {
          eventDate: subclinical[i].StartDate,
          eventType: 18,
          UdderHealthType: 1,
          DIM: subclinical[i].DIM,
        };

        var locations = decodeLocations(subclinical[i].Location);
        if (locations.length) {
          for (var l = 0; l < locations.length; l++) {
            event[locations[l].l] = {
              Quarter: locations[l].q,
            };
          }
        } else {
          event.UN = {
            Quarter: 99,
          };
        }

        list.push(event);
      }
      return list;
    }

    function getClawHealth(animal_id) {
      return animalDetailsService
        .getClawHealth(animal_id)
        .then(function (response) {
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].VisitDate;
            response[i].eventType = 9;
            if (response[i].Claws.length > 0) {
              var LF = {
                Lesions: [],
                Treatments: [],
              };
              var RF = {
                Lesions: [],
                Treatments: [],
              };
              var LR = {
                Lesions: [],
                Treatments: [],
              };
              var RR = {
                Lesions: [],
                Treatments: [],
              };
              var includeLF = false;
              var includeRF = false;
              var includeLR = false;
              var includeRR = false;
              for (var l = 0; l < response[i].Claws.length; l++) {
                if (
                  response[i].Claws[l].Position == 0 ||
                  response[i].Claws[l].Position == 4 ||
                  response[i].Claws[l].Position == 5
                ) {
                  if (response[i].Claws[l].Position == 0) {
                    response[i].LFSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 4) {
                    response[i].LFOSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 5) {
                    response[i].LFISeverity = response[i].Claws[l].Severity;
                  }
                  if (response[i].Claws[l].Lesions) {
                    LF.Lesions.push(response[i].Claws[l].Lesions);
                  }
                  if (response[i].Claws[l].Treatments) {
                    LF.Treatments.push(response[i].Claws[l].Treatments);
                  }
                  LF.Treatments = LF.Treatments.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  LF.Lesions = LF.Lesions.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  includeLF = true;
                } else if (
                  response[i].Claws[l].Position == 1 ||
                  response[i].Claws[l].Position == 6 ||
                  response[i].Claws[l].Position == 7
                ) {
                  if (response[i].Claws[l].Position == 1) {
                    response[i].RFSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 6) {
                    response[i].RFOSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 7) {
                    response[i].RFISeverity = response[i].Claws[l].Severity;
                  }
                  if (response[i].Claws[l].Lesions) {
                    RF.Lesions.push(response[i].Claws[l].Lesions);
                  }
                  if (response[i].Claws[l].Treatments) {
                    RF.Treatments.push(response[i].Claws[l].Treatments);
                  }
                  RF.Treatments = RF.Treatments.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  RF.Lesions = RF.Lesions.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  includeRF = true;
                } else if (
                  response[i].Claws[l].Position == 2 ||
                  response[i].Claws[l].Position == 8 ||
                  response[i].Claws[l].Position == 9
                ) {
                  if (response[i].Claws[l].Position == 2) {
                    response[i].LRSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 8) {
                    response[i].LROSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 9) {
                    response[i].LRISeverity = response[i].Claws[l].Severity;
                  }
                  if (response[i].Claws[l].Lesions) {
                    LR.Lesions.push(response[i].Claws[l].Lesions);
                  }
                  if (response[i].Claws[l].Treatments) {
                    LR.Treatments.push(response[i].Claws[l].Treatments);
                  }
                  LR.Treatments = LR.Treatments.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  LR.Lesions = LR.Lesions.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  includeLR = true;
                } else if (
                  response[i].Claws[l].Position == 3 ||
                  response[i].Claws[l].Position == 10 ||
                  response[i].Claws[l].Position == 11
                ) {
                  if (response[i].Claws[l].Position == 3) {
                    response[i].RRSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 10) {
                    response[i].RROSeverity = response[i].Claws[l].Severity;
                  } else if (response[i].Claws[l].Position == 11) {
                    response[i].RRISeverity = response[i].Claws[l].Severity;
                  }
                  if (response[i].Claws[l].Lesions) {
                    RR.Lesions.push(response[i].Claws[l].Lesions);
                  }
                  if (response[i].Claws[l].Treatments) {
                    RR.Treatments.push(response[i].Claws[l].Treatments);
                  }
                  RR.Treatments = RR.Treatments.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  RR.Lesions = RR.Lesions.reduce(function (a, b) {
                    if (a.indexOf(b) < 0) a.push(b);
                    return a;
                  }, []);
                  includeRR = true;
                }
              }
              if (includeLF) {
                response[i].LF = LF;
              }
              if (includeRF) {
                response[i].RF = RF;
              }
              if (includeLR) {
                response[i].LR = LR;
              }
              if (includeRR) {
                response[i].RR = RR;
              }
            }
            if (response[i].LF && response[i].LF.Lesions) {
              var list = [];
              for (var t = 0; t < response[i].LF.Lesions.length; t++) {
                list = list.concat(
                  decodeLesionTypes(response[i].LF.Lesions[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].LF.Lesions = list;
            }
            if (response[i].RF && response[i].RF.Lesions) {
              var list = [];
              for (var t = 0; t < response[i].RF.Lesions.length; t++) {
                list = list.concat(
                  decodeLesionTypes(response[i].RF.Lesions[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].RF.Lesions = list;
            }
            if (response[i].LR && response[i].LR.Lesions) {
              var list = [];
              for (var t = 0; t < response[i].LR.Lesions.length; t++) {
                list = list.concat(
                  decodeLesionTypes(response[i].LR.Lesions[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].LR.Lesions = list;
            }
            if (response[i].RR && response[i].RR.Lesions) {
              var list = [];
              for (var t = 0; t < response[i].RR.Lesions.length; t++) {
                list = list.concat(
                  decodeLesionTypes(response[i].RR.Lesions[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].RR.Lesions = list;
            }
            if (response[i].LF && response[i].LF.Treatments) {
              var list = [];
              for (var t = 0; t < response[i].LF.Treatments.length; t++) {
                list = list.concat(
                  decodeTreatmentTypes(response[i].LF.Treatments[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].LF.Treatments = list;
            }
            if (response[i].RF && response[i].RF.Treatments) {
              var list = [];
              for (var t = 0; t < response[i].RF.Treatments.length; t++) {
                list = list.concat(
                  decodeTreatmentTypes(response[i].RF.Treatments[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].RF.Treatments = list;
            }
            if (response[i].LR && response[i].LR.Treatments) {
              var list = [];
              for (var t = 0; t < response[i].LR.Treatments.length; t++) {
                list = list.concat(
                  decodeTreatmentTypes(response[i].LR.Treatments[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].LR.Treatments = list;
            }
            if (response[i].RR && response[i].RR.Treatments) {
              var list = [];
              for (var t = 0; t < response[i].RR.Treatments.length; t++) {
                list = list.concat(
                  decodeTreatmentTypes(response[i].RR.Treatments[t])
                );
              }
              list = list.reduce(function (a, b) {
                if (a.indexOf(b) < 0) a.push(b);
                return a;
              }, []);
              response[i].RR.Treatments = list;
            }
            vm.events.push(response[i]);
          }
          clawHealth.resolve();
        })
        .catch(function (error) {
          console.log(error);
          clawHealth.reject();
        });
    }

    function getHoofTrims(animal_id) {
      return animalDetailsService
        .getHoofTrims(animal_id)
        .then(function (response) {
          vm.hoofEvents = [];
          for (var i = 0; i < response.length; i++) {
            var e = {
              eventDate: response[i].VisitDate,
              reason: response[i].Reason,
              eventType: 14,
              DIM: response[i].DIM,
              LF: {
                TreatmentTypeString: [],
                ActionTypeString: [],
                Lesions: [],
              },
              RF: {
                TreatmentTypeString: [],
                ActionTypeString: [],
                Lesions: [],
              },
              LR: {
                TreatmentTypeString: [],
                ActionTypeString: [],
                Lesions: [],
              },
              RR: {
                TreatmentTypeString: [],
                ActionTypeString: [],
                Lesions: [],
              },
            };
            if (response[i].Reason == 0) {
              e.visit_reason_string = i18nFilter(
                "_animal_details_visit_reason_trim_"
              );
            } else if (response[i].Reason == 1) {
              e.visit_reason_string = i18nFilter(
                "_animal_details_visit_reason_lame_"
              );
            } else if (response[i].Reason == 2) {
              e.visit_reason_string = i18nFilter(
                "_animal_details_visit_reason_recheck_"
              );
            } else if (response[i].Reason == 3) {
              e.visit_reason_string = i18nFilter(
                "_animal_details_visit_reason_not_lame_"
              );
            } else if (response[i].Reason == 4) {
              e.visit_reason_string = i18nFilter(
                "_animal_details_visit_reason_trim_rear_"
              );
            }

            for (var j = 0; j < response[i].Limbs.length; j++) {
              var treatments = [];
              if (response[i].Limbs[j].TreatmentType == 0) {
                /*treatments.push(
                  i18nFilter("_animal_details_hoof_treatment_type_none_")
                );*/
              } else {
                if ((response[i].Limbs[j].TreatmentType & 1) == 1) {
                  treatments.push(
                    i18nFilter(
                      "_animal_details_hoof_treatment_type_therapeutic_trim_"
                    )
                  );
                }
                if ((response[i].Limbs[j].TreatmentType & 2) == 2) {
                  treatments.push(
                    i18nFilter("_animal_details_hoof_treatment_type_topical_")
                  );
                }
                if ((response[i].Limbs[j].TreatmentType & 4) == 4) {
                  treatments.push(
                    i18nFilter(
                      "_animal_details_hoof_treatment_type_preventive_trim_"
                    )
                  );
                }
                if ((response[i].Limbs[j].TreatmentType & 4096) == 4096) {
                  treatments.push(
                    i18nFilter(
                      "_animal_details_hoof_treatment_type_antibiotic_treatment_"
                    )
                  );
                }
                if ((response[i].Limbs[j].TreatmentType & 8192) == 8192) {
                  treatments.push(
                    i18nFilter(
                      "_animal_details_hoof_treatment_type_conventional_"
                    )
                  );
                }
              }

              var actions = [];
              if (response[i].Limbs[j].ActionType == 0) {
                //actions.push(i18nFilter("_animal_details_action_type_none_"));
              } else {
                if ((response[i].Limbs[j].ActionType & 1) == 1) {
                  actions.push(
                    i18nFilter("_animal_details_hoof_treatment_type_block_")
                  );
                }
                if ((response[i].Limbs[j].ActionType & 2) == 2) {
                  actions.push(
                    i18nFilter("_animal_details_hoof_treatment_type_wrap_")
                  );
                }
              }

              var lesions = [];
              response[i].Limbs[j].Lesions = $filter("orderBy")(
                response[i].Limbs[j].Lesions,
                "LesionType"
              );
              for (var l = 0; l < response[i].Limbs[j].Lesions.length; l++) {
                var obj = {};
                if (response[i].Limbs[j].Lesions[l].LesionType == 1) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_abcess_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 2) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_bruise_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 3) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_corn_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 4) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_digital_dermatitis_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 5) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_erosion_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 6) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_foot_rot_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 7) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_deep_digital_sepsis_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 8) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_hemorrhage_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 9) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_upper_limb_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 10) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_rotated_claw_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 11) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_sole_fracture_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 12) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_toe_ulcer_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 13) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_ulcer_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 14) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_vertical_fissure_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 15) {
                  //show toe nacrosis instead hairy attack (accutrim)
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_toe_necrosis_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 16) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_axial_wall_fissure_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 17) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_horizontal_fissure_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 18) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_thin_soles_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 19) {
                  obj.LesionTypeString = i18nFilter(
                    "_animal_details_hoof_lesion_type_toe_necrosis_"
                  );
                  obj.type = response[i].Limbs[j].Lesions[l].LesionType;
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 20) {
                  lesions = setDDSubType(
                    i18nFilter(
                      "_animal_details_hoof_lesion_type_digital_dermatitis_d1_"
                    ),
                    lesions
                  );
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 21) {
                  lesions = setDDSubType(
                    i18nFilter(
                      "_animal_details_hoof_lesion_type_digital_dermatitis_d2_"
                    ),
                    lesions
                  );
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 22) {
                  lesions = setDDSubType(
                    i18nFilter(
                      "_animal_details_hoof_lesion_type_digital_dermatitis_d3_"
                    ),
                    lesions
                  );
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 23) {
                  lesions = setDDSubType(
                    i18nFilter(
                      "_animal_details_hoof_lesion_type_digital_dermatitis_d4_"
                    ),
                    lesions
                  );
                } else if (response[i].Limbs[j].Lesions[l].LesionType == 24) {
                  lesions = setDDSubType(
                    i18nFilter(
                      "_animal_details_hoof_lesion_type_digital_dermatitis_d5_"
                    ),
                    lesions
                  );
                }
                if (response[i].Limbs[j].Lesions[l].Severity == 0) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_none_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].Severity == 1) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_mild_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].Severity == 2) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_mild_moderate_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].Severity == 3) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_moderate_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].Severity == 4) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_moderate_severe_"
                  );
                } else if (response[i].Limbs[j].Lesions[l].Severity == 5) {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_severe_"
                  );
                } else {
                  obj.SeverityString = i18nFilter(
                    "_animal_details_hoof_lesion_severity_none_"
                  );
                }
                if (obj.LesionTypeString) {
                  lesions.push(obj);
                }
              }

              if (response[i].Limbs[j].Position > 3) {
                if (
                  response[i].Limbs[j].Position == 4 ||
                  response[i].Limbs[j].Position == 6 ||
                  response[i].Limbs[j].Position == 8 ||
                  response[i].Limbs[j].Position == 10
                ) {
                  for (var a = 0; a < actions.length; a++) {
                    actions[a] += " (o)";
                  }
                  for (var t = 0; t < treatments.length; t++) {
                    treatments[t] += " (o)";
                  }
                  for (var l = 0; l < lesions.length; l++) {
                    lesions[l].LesionTypeString += " (o)";
                  }
                }

                if (
                  response[i].Limbs[j].Position == 5 ||
                  response[i].Limbs[j].Position == 7 ||
                  response[i].Limbs[j].Position == 9 ||
                  response[i].Limbs[j].Position == 11
                ) {
                  for (var a = 0; a < actions.length; a++) {
                    actions[a] += " (i)";
                  }
                  for (var t = 0; t < treatments.length; t++) {
                    treatments[t] += " (i)";
                  }
                  for (var l = 0; l < lesions.length; l++) {
                    lesions[l].LesionTypeString += " (i)";
                  }
                }
              }
              var position = getHoofTrimPosition(response[i].Limbs[j].Position);
              if (position) {
                e[position].TreatmentTypeString =
                  e[position].TreatmentTypeString.concat(treatments);
                e[position].ActionTypeString =
                  e[position].ActionTypeString.concat(actions);
                e[position].Lesions = e[position].Lesions.concat(lesions);
                e[position].treated = true;
                e[position].ReCheck = response[i].Limbs[j].ReCheck;
                e[position].ReCheckString = getRecheckString(
                  response[i].Limbs[j].ReCheck
                );
              }
            }
            vm.hoofEvents.push(e);
            vm.events.push(e);
          }
          hoofTrims.resolve();
        })
        .catch(function (error) {
          console.log(error);
          hoofTrims.reject();
        });
    }

    function getRecheckString(recheck) {
      if (recheck) {
        var rString = vm.hoofReCheckList.find(function (r) {
          return r.value === recheck;
        });

        if (rString && rString.label_translate) {
        }
        return i18nFilter(rString.label_translate);
      }

      return "";
    }

    function getHoofTrimPosition(position) {
      if (position === 0 || position === 4 || position === 5) {
        return "LF";
      }
      if (position === 1 || position === 6 || position === 7) {
        return "RF";
      }
      if (position === 2 || position === 8 || position === 9) {
        return "LR";
      }
      if (position === 3 || position === 10 || position === 11) {
        return "RR";
      }
      return null;
    }

    function setDDSubType(subType, lesions) {
      for (var i = 0; i < lesions.length; i++) {
        if (lesions[i].type == 4) {
          lesions[i].LesionTypeString += " (" + subType + ")";
          break;
        }
      }
      return lesions;
    }

    function getFeedIntake(animal_id) {
      vm.allFeedIntakes = [];
      return animalDetailsService
        .getFeedIntake(animal_id)
        .then(function (response) {
          var date = moment()
            .hour(0)
            .minute(0)
            .second(0)
            .subtract(1, "years")
            .subtract(1, "days");
          for (var i = 0; i < response.length; i++) {
            var event = {
              eventDate: response[i].Date,
              eventType: 15,
              ProductName: response[i].ProductName,
              ProductCategory: response[i].ProductCategory,
              RationKg: response[i].RationKg,
              IntakeKg: response[i].IntakeKg,
              DM: response[i].ProductDryMatterPercentage,
            };
            if (date.isBefore(response[i].Date)) {
              vm.allFeedIntakes.push(event);
            }
          }
          vm.allFeedIntakesByDate = appService.groupBy(
            vm.allFeedIntakes,
            "eventDate"
          );
          var allFeedNames = appService.groupBy(
            vm.allFeedIntakes,
            "ProductName"
          );
          var FeedNamesList = [];
          angular.forEach(allFeedNames, function (value, key) {
            FeedNamesList.push(key);
          });
          vm.feedNamesList = FeedNamesList;
          feedIntake.resolve();
        })
        .catch(function (error) {
          console.log(error);
          feedIntake.reject();
        });
    }

    function getMovements(animal_id) {
      return animalDetailsService
        .getMovements(animal_id)
        .then(function (response) {
          response = response.filter(function (item) {
            return item.Type != 0;
          });

          response = appService.groupBy(response, "StartDate");
          var responseList = [];
          angular.forEach(response, function (value, key) {
            responseList.push({
              d: key,
              v: value,
            });
          });
          responseList = $filter("orderBy")(responseList, "d", true);

          for (var i = 0; i < responseList.length; i++) {
            createEvents(responseList[i].v, i);
          }

          function createEvents(list, index) {
            if (list.lenght == 1) {
              addEvent(list[0]);
            } else {
              for (var i = 0; i < list.length; i++) {
                if (index == 0) {
                  list = addEventTime(vm.animalStatus, list);
                } else {
                  list = addEventTime(69, list);
                }
                addEvent(list[i]);
              }
            }
          }

          function addEventTime(status, list) {
            if (status == 9) {
              for (var i = 0; i < list.length; i++) {
                if (list[i].Type == 2) {
                  var s = list[i].StartDate.split("T");
                  list[i].StartDate = s[0] + "T12:00:00";
                }
              }
            } else {
              for (var i = 0; i < list.length; i++) {
                if (list[i].Type == 1) {
                  var s = list[i].StartDate.split("T");
                  list[i].StartDate = s[0] + "T12:00:00";
                }
              }
            }

            return list;
          }

          function addEvent(event) {
            event.eventDate = event.StartDate;
            event.eventType = 16;
            vm.events.push(event);
          }

          movements.resolve();
        })
        .catch(function (error) {
          console.log(error);
          movements.reject();
        });
    }

    function decodeLesionTypes(type) {
      var list = [];
      for (var i = 0; i < APP_CONSTANTS.constants.hoofLesionTypes.length; i++) {
        if (
          checkNumber(type, APP_CONSTANTS.constants.hoofLesionTypes[i].value)
        ) {
          list.push(
            i18nFilter(
              APP_CONSTANTS.constants.hoofLesionTypes[i].label_translate
            )
          );
        }
      }
      return list;
    }

    function decodeTreatmentTypes(type) {
      var list = [];
      for (
        var i = 0;
        i < APP_CONSTANTS.constants.hoofTreatmentTypes.length;
        i++
      ) {
        if (
          checkNumber(type, APP_CONSTANTS.constants.hoofTreatmentTypes[i].value)
        ) {
          list.push(
            i18nFilter(
              APP_CONSTANTS.constants.hoofTreatmentTypes[i].label_translate
            )
          );
        }
      }
      return list;
    }

    function decodeLocations(type) {
      var locations = [
        { l: "LF", v: 1, q: 0 },
        { l: "RF", v: 2, q: 1 },
        { l: "LR", v: 4, q: 2 },
        { l: "RR", v: 8, q: 3 },
      ];

      var list = [];
      for (var i = 0; i < locations.length; i++) {
        if (checkNumber(type, locations[i].v)) {
          list.push(locations[i]);
        }
      }

      return list;
    }

    function checkNumber(number, mask) {
      if ((number & mask) == mask) {
        return true;
      } else {
        return false;
      }
    }

    function openDeleteImageModal(image) {
      vm.modalLoading = false;
      vm.deleteError = null;
      vm.pictureToDelete = image;
      $uibModal
        .open({
          animation: true,
          templateUrl: "app/pages/cockpit/delete.modal.html",
          size: "sm",
          scope: $scope,
          backdrop: "static",
          keyboard: false,
        })
        .closed.then(function () {
          vm.pictureToDelete = null;
        });
    }

    function openGraphModal() {
      vm.graphModalOpened = true;
      $uibModal
        .open({
          animation: true,
          templateUrl: "app/pages/herds/animals/animalDetails/graph.modal.html",
          size: "custom-lg",
          scope: $scope,
          backdrop: "static",
          keyboard: false,
        })
        .closed.then(function () {
          vm.pictureToDelete = null;
        });
      $timeout(function () {
        mctx = document.getElementById("myChartModal");
        mixedChartModal = new Chart(mctx, vm.chartData);
        mctx2 = document.getElementById("myChartModal2");
        mixedChartModal2 = new Chart(mctx2, vm.chartNMilkings);
        mixedChartModal.destroy();
        mixedChartModal2.destroy();
        mixedChartModal = new Chart(mctx, vm.chartData);
        mixedChartModal2 = new Chart(mctx2, vm.chartNMilkings);
      }, 200);
    }

    function openSearchModal() {
      if (vm.showOverview) {
        vm.searchAnimalList = [];
        vm.searchAnimalString = "";
        $uibModal
          .open({
            animation: true,
            templateUrl:
              "app/pages/herds/animals/animalDetails/search.modal.html",
            size: "sm",
            scope: $scope,
            backdrop: "static",
            keyboard: false,
          })
          .closed.then(function () {
            vm.pictureToDelete = null;
          });
      }
    }

    function deleteImage() {
      vm.modalLoading = true;
      if (vm.pictureToDelete && vm.pictureToDelete.Id) {
        animalDetailsService
          .deletePicture(vm.pictureToDelete.Id)
          .then(function () {
            for (var p = 0; p < vm.images.length; p++) {
              if (vm.images[p].Id == vm.selectedImage.Id) {
                vm.images.splice(p, 1);
                break;
              }
            }
            for (var p = 0; p < vm.imagesToShow.length; p++) {
              if (vm.imagesToShow[p].Id == vm.selectedImage.Id) {
                vm.imagesToShow.splice(p, 1);
                break;
              }
            }
            if (vm.selectedEventType === undefined) {
              vm.selectedEvent.hideEvent = true;
              for (var i = 0; i < vm.selectedEvent.Pictures.length; i++) {
                if (vm.selectedEvent.Pictures[i].Id == vm.selectedImage.Id) {
                  vm.selectedEvent.Pictures.splice(i, 1);
                  if (vm.sliderImages[0]) {
                    vm.selectedImage = vm.sliderImages[0];
                    vm.hideImage = true;
                    var top = $uibModalStack.getTop();
                    if (top) {
                      $uibModalStack.dismiss(top.key);
                    }
                    $timeout(function () {
                      vm.hideImage = false;
                    }, 10);
                  } else {
                    $uibModalStack.dismissAll();
                  }
                  break;
                }
              }
              $timeout(function () {
                vm.selectedEvent.hideEvent = false;
              }, 0);
            } else if (vm.selectedEventType == "all") {
              removePictureFromEvent(vm.selectedImage);
              if (vm.sliderImages[vm.selectedImageIndex + 1]) {
                nextImage();
                var top = $uibModalStack.getTop();
                if (top) {
                  $uibModalStack.dismiss(top.key);
                }
              } else if (vm.sliderImages[vm.selectedImageIndex - 1]) {
                previousImage();
                var top = $uibModalStack.getTop();
                if (top) {
                  $uibModalStack.dismiss(top.key);
                }
              } else {
                $uibModalStack.dismissAll();
              }
            } else if (vm.selectedEventType == "one") {
              for (var e = 0; e < vm.events.length; e++) {
                if (vm.events[e].Id == vm.selectedEvent.Id) {
                  vm.events.splice(e, 1);
                  vm.selectedEvent.hideEvent = true;
                  $uibModalStack.dismissAll();
                  break;
                }
              }
            } else {
              vm.selectedEvent.hideEvent = true;
              for (
                var i = 0;
                i < vm.selectedEvent[vm.selectedEventType].length;
                i++
              ) {
                if (
                  vm.selectedEvent[vm.selectedEventType][i].Id ==
                  vm.selectedImage.Id
                ) {
                  vm.selectedEvent[vm.selectedEventType].splice(i, 1);
                  if (vm.sliderImages[0]) {
                    vm.selectedImage = vm.sliderImages[0];
                    vm.hideImage = true;
                    var top = $uibModalStack.getTop();
                    if (top) {
                      $uibModalStack.dismiss(top.key);
                    }
                    $timeout(function () {
                      vm.hideImage = false;
                    }, 10);
                  } else {
                    $uibModalStack.dismissAll();
                  }
                  break;
                }
              }
              $timeout(function () {
                vm.selectedEvent.hideEvent = false;
              }, 0);
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.modalLoading = false;
            vm.deleteError = error;
          });
      }
    }

    function removePictureFromEvent(pic) {
      var PictureDeleted = false;
      for (var i = 0; i < vm.events.length; i++) {
        if (vm.events[i].eventType == 11 || vm.events[i].eventType == 12) {
          if (vm.events[i].Id == pic.Id) {
            vm.events.splice(i, 1);
            PictureDeleted = true;
            break;
          }
        } else {
          if (vm.events[i].Pictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].Pictures.length; p++) {
              if (vm.events[i].Pictures[p].Id == pic.Id) {
                vm.events[i].Pictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].CalvingImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].CalvingImages.length; p++) {
              if (vm.events[i].CalvingImages[p].Id == pic.Id) {
                vm.events[i].CalvingImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].ColostrumImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].ColostrumImages.length; p++) {
              if (vm.events[i].ColostrumImages[p].Id == pic.Id) {
                vm.events[i].ColostrumImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].MilkIntakeImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].MilkIntakeImages.length; p++) {
              if (vm.events[i].MilkIntakeImages[p].Id == pic.Id) {
                vm.events[i].MilkIntakeImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].DiseasesPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].DiseasesPictures.length; p++) {
              if (vm.events[i].DiseasesPictures[p].Id == pic.Id) {
                vm.events[i].DiseasesPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].PreventionsPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].PreventionsPictures.length; p++) {
              if (vm.events[i].PreventionsPictures[p].Id == pic.Id) {
                vm.events[i].PreventionsPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].LRPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].LRPictures.length; p++) {
              if (vm.events[i].LRPictures[p].Id == pic.Id) {
                vm.events[i].LRPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].LFPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].LFPictures.length; p++) {
              if (vm.events[i].LFPictures[p].Id == pic.Id) {
                vm.events[i].LFPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].RFPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].RFPictures.length; p++) {
              if (vm.events[i].RFPictures[p].Id == pic.Id) {
                vm.events[i].RFPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].RRPictures && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].RRPictures.length; p++) {
              if (vm.events[i].RRPictures[p].Id == pic.Id) {
                vm.events[i].RRPictures.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].miscImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].miscImages.length; p++) {
              if (vm.events[i].miscImages[p].Id == pic.Id) {
                vm.events[i].miscImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].clinicalImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].clinicalImages.length; p++) {
              if (vm.events[i].clinicalImages[p].Id == pic.Id) {
                vm.events[i].clinicalImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
          if (vm.events[i].subclinicalImages && !PictureDeleted) {
            for (var p = 0; p < vm.events[i].subclinicalImages.length; p++) {
              if (vm.events[i].subclinicalImages[p].Id == pic.Id) {
                vm.events[i].subclinicalImages.splice(p, 1);
                PictureDeleted = true;
                break;
              }
            }
          }
        }
      }
    }

    function getUdderHealth(animal_id) {
      return animalDetailsService
        .getUdderHealth(animal_id)
        .then(function (response) {
          var diseases = [];
          var antibiotics = [];
          angular.copy(APP_CONSTANTS.constants.antibiotic, antibiotics);
          antibiotics.reverse();
          var bacterium = [];
          angular.copy(APP_CONSTANTS.constants.bacterium, bacterium);
          bacterium.reverse();
          for (var i = 0; i < response.length; i++) {
            var obj = angular.copy(response[i]);
            obj.HealthCondition =
              response[i].UdderHealthType === 0
                ? 31
                : response[i].UdderHealthType === 1
                ? 32
                : 99;
            obj.StartDate = response[i].DiagnosisDate;
            diseases.push(obj);
            response[i].eventDate = response[i].DiagnosisDate;
            response[i].eventType = 7;
            if (response[i].Samples.length > 0) {
              for (var s = 0; s < response[i].Samples.length; s++) {
                var ant = [];
                for (var a = 0; a < antibiotics.length; a++) {
                  if (
                    response[i].Samples[s].Antibiotics > antibiotics[a].value
                  ) {
                    ant.push(antibiotics[a]);
                    response[i].Samples[s].Antibiotics =
                      response[i].Samples[s].Antibiotics - antibiotics[a].value;
                  } else if (
                    response[i].Samples[s].Antibiotics == antibiotics[a].value
                  ) {
                    ant.push(antibiotics[a]);
                    break;
                  } else if (
                    response[i].Samples[s].Antibiotics >
                    antibiotics[a + 1].value
                  ) {
                    ant.push(antibiotics[a + 1]);
                    response[i].Samples[s].Antibiotics =
                      response[i].Samples[s].Antibiotics -
                      antibiotics[a + 1].value;
                  }
                }
                response[i].Samples[s].Antibiotics = ant;
                var bac = [];
                for (var b = 0; b < bacterium.length; b++) {
                  if (response[i].Samples[s].Bacteria > bacterium[b].value) {
                    bac.push(bacterium[b]);
                    response[i].Samples[s].Bacteria =
                      response[i].Samples[s].Bacteria - bacterium[b].value;
                  } else if (
                    response[i].Samples[s].Bacteria == bacterium[b].value
                  ) {
                    bac.push(bacterium[b]);
                    break;
                  } else if (
                    response[i].Samples[s].Bacteria > bacterium[b + 1].value
                  ) {
                    bac.push(bacterium[b + 1]);
                    response[i].Samples[s].Bacteria =
                      response[i].Samples[s].Bacteria - bacterium[b + 1].value;
                  }
                  if (
                    !response[i].Samples[s].Severity &&
                    (ant.length > 0 || bac.length > 0)
                  ) {
                    response[i].Samples[s].Severity = 13;
                  }
                }
                response[i].Samples[s].Bacteria = bac;
                if (response[i].Samples[s].Quarter == 0) {
                  response[i].LF = response[i].Samples[s];
                } else if (response[i].Samples[s].Quarter == 1) {
                  response[i].RF = response[i].Samples[s];
                } else if (response[i].Samples[s].Quarter == 2) {
                  response[i].LR = response[i].Samples[s];
                } else if (response[i].Samples[s].Quarter == 3) {
                  response[i].RR = response[i].Samples[s];
                }
              }
            }
            vm.events.push(response[i]);
          }
          vm.diseaseEvents = vm.diseaseEvents.concat(diseases);
          udderHealth.resolve();
        })
        .catch(function (error) {
          console.log(error);
          udderHealth.reject();
        });
    }

    function getMilkRecordings(animal_id) {
      return animalDetailsService
        .getMilkRecordings(animal_id)
        .then(function (response) {
          var milkRecordings = [];
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].Date;
            response[i].eventType = 6;
            response[i].Advice = setAdvice(response[i].Advice);
            milkRecordings.push(response[i]);
            vm.events.push(response[i]);
          }
          vm.allMilkRecordings = milkRecordings;
          milkControl.resolve();
        })
        .catch(function (error) {
          console.log(error);
          milkControl.reject();
        });
    }

    function setAdvice(advice) {
      var adviceValue = vm.adviceList.find(function (a) {
        return a.id === advice;
      });

      return adviceValue ? i18nFilter(adviceValue.value) : "-";
    }

    function getManualMilk(animal_id) {
      return animalDetailsService
        .getManualMilk(animal_id)
        .then(function (response) {
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].Date;
            response[i].eventType = 10;
            var milk = 0;
            if (response[i].Amount1Kg) {
              milk = milk + response[i].Amount1Kg;
            }
            if (response[i].Amount2Kg) {
              milk = milk + response[i].Amount2Kg;
            }
            if (response[i].Amount3Kg) {
              milk = milk + response[i].Amount3Kg;
            }
            response[i].Milk = milk;
            vm.events.push(response[i]);
          }
          manualMilk.resolve();
        })
        .catch(function (error) {
          console.log(error);
          manualMilk.reject();
        });
    }

    function getMilkMeters(animal_id) {
      return animalDetailsService
        .getMilkMeters(animal_id)
        .then(function (response) {
          vm.allMilkMeterData = [];
          for (var i = 0; i < response.length; i++) {
            response[i].eventType = 13;
            response[i].eventDate = response[i].Date;
            vm.allMilkMeterData.push(response[i]);
          }
          milkMeter.resolve();
        })
        .catch(function (error) {
          milkMeter.reject();
        });
    }

    function calculateDeviation(previous_value, value) {
      var difference = appService.round(value - previous_value, 2);
      var deviationPercent = (100 * difference) / previous_value;
      return appService.round(deviationPercent, 1);
    }

    function getLactations(animal_id) {
      return animalDetailsService
        .getLactations(animal_id)
        .then(function (response) {
          if (!response.length) {
            vm.noLactations = true;
          }
          vm.lactations = [];
          vm.totalMilk = 0;
          vm.totalFat = 0;
          vm.totalProtein = 0;
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].CalvingDate;
            response[i].eventType = 5;
            if (response[i].KgMilkLactation) {
              vm.totalMilk += response[i].KgMilkLactation;
            }
            if (response[i].KgFatLactation) {
              vm.totalFat += response[i].KgFatLactation;
            }
            if (response[i].KgFatLactation) {
              vm.totalProtein += response[i].KgProteinLactation;
            }
            if (response[i].KgMilkLactation && response[i].KgFatLactation) {
              response[i].KgFatPercent =
                (response[i].KgFatLactation * 100) /
                response[i].KgMilkLactation;
            }
            if (response[i].KgMilk305 && response[i].KgFat305) {
              response[i].KgFat305Percent =
                (response[i].KgFat305 * 100) / response[i].KgMilk305;
            }
            if (response[i].KgMilkLactation && response[i].KgProteinLactation) {
              response[i].KgProteinPercent =
                (response[i].KgProteinLactation * 100) /
                response[i].KgMilkLactation;
            }
            if (response[i].KgMilk305 && response[i].KgProtein305) {
              response[i].KgProtein305Percent =
                (response[i].KgProtein305 * 100) / response[i].KgMilk305;
            }
            if (response[i].KgFatLactation && response[i].KgProteinLactation) {
              response[i].KgSum =
                response[i].KgFatLactation + response[i].KgProteinLactation;
            }
            if (response[i].KgProtein305 && response[i].KgFat305) {
              response[i].Kg305Sum =
                response[i].KgProtein305 + response[i].KgFat305;
            }
            vm.events.push(response[i]);
            vm.lactations.push(response[i]);
            if (response[i].DryOffDate) {
              var dOff = angular.copy(response[i]);
              dOff.eventDate = dOff.DryOffDate;
              dOff.eventType = 17;
              vm.events.push(dOff);
            }
          }
          var lact = [];
          angular.copy(response, lact);
          lact = $filter("orderBy")(lact, "eventDate", true);
          if (lact[0]) {
            var calvingDate = moment(lact[0].CalvingDate);
            var today = moment();
            vm.dim = today.diff(calvingDate, "days") + 1;
            vm.lastLactation = lact[0];
            vm.dim_to_show = angular.copy(vm.dim);
          }
          if (lact.length) {
            vm.availableLactations = [];
            for (var i = 0; i < lact.length; i++) {
              if (lact[i].CalvingDate) {
                vm.availableLactations.push(lact[i]);
              }
            }

            var firstLact = lact[lact.length - 1].CalvingDate;
            vm.firstLact = firstLact;
          } else {
            vm.firstLact = null;
          }

          vm.totalSum = Math.round(vm.totalFat + vm.totalProtein);
          vm.totalMilk = Math.round(vm.totalMilk);
          vm.totalFat = Math.round(vm.totalFat);
          vm.totalProtein = Math.round(vm.totalProtein);
          vm.totalFatPercentage = (vm.totalFat * 100) / vm.totalMilk;
          vm.totalProteinPercentage = (vm.totalProtein * 100) / vm.totalMilk;
          lactations.resolve();
        })
        .catch(function (error) {
          lactations.reject();
          console.log(error);
        });
    }

    function setLactations(lactations, milkings) {
      lactations = $filter("orderBy")(lactations, "CalvingDate");
      for (var i = 0; i < lactations.length; i++) {
        if (
          lactations[i].CalvingDate &&
          lactations[i - 1] &&
          lactations[i - 1].CalvingDate
        ) {
          if (!lactations[i].CalvingInterval) {
            lactations[i].CalvingInterval =
              moment(lactations[i].CalvingDate).diff(
                lactations[i - 1].CalvingDate,
                "days"
              ) - 1;
          }
        }
      }
      return lactations;
    }

    function getImages(animal_id) {
      return animalDetailsService
        .getImages(animal_id)
        .then(function (response) {
          var list = [];
          vm.showImagesIndex = 1;
          response = $filter("orderBy")(response, "ImageCreated", true);
          var imagesEvents = [];
          var imagesAlone = [];
          var commentImages = [];
          for (var i = 0; i < response.length; i++) {
            response[i].ImageCreatedDate = $filter("date")(
              response[i].ImageCreated,
              "shortDate"
            );
            if (response[i].Tags) {
              response[i].TagsToShow = [];
              var tags = response[i].Tags.split("#");
              for (var j = 0; j < tags.length; j++) {
                for (var k = 0; k < vm.tags.length; k++) {
                  if (tags[j] == vm.tags[k].value && tags[j] != "") {
                    var tag_added = false;
                    for (var t = 0; t < response[i].TagsToShow.length; t++) {
                      if (response[i].TagsToShow[t].value == vm.tags[k].value) {
                        tag_added = true;
                      }
                    }
                    if (!tag_added) {
                      response[i].TagsToShow.push(vm.tags[k]);
                    }
                    break;
                  }
                }
              }
            }
            if (i < 100) {
              list.push(response[i]);
            }
            var date = $filter("date")(
              response[i].ImageCommentDate,
              "yyyy-MM-dd"
            );
            if (
              !response[i].Tags ||
              (response[i].Tags &&
                response[i].Tags.indexOf("Calving") == -1 &&
                response[i].Tags.indexOf("Calf1") == -1 &&
                response[i].Tags.indexOf("Calf2") == -1 &&
                response[i].Tags.indexOf("Colostrum") == -1 &&
                response[i].Tags.indexOf("MilkIntake") == -1 &&
                response[i].Tags.indexOf("Calved") == -1 &&
                response[i].Tags.indexOf("NewbornCalves") == -1 &&
                response[i].Tags.indexOf("ClinicalExamTransitionCows") == -1 &&
                response[i].Tags.indexOf("Disease") == -1 &&
                response[i].Tags.indexOf("Mastitis") == -1 &&
                response[i].Tags.indexOf("Subclinical") == -1 &&
                response[i].Tags.indexOf("Miscellaneous") == -1 &&
                response[i].Tags.indexOf("Prevention") == -1 &&
                response[i].Tags.indexOf("Milk") == -1 &&
                response[i].Tags.indexOf("ClawHealth") == -1 &&
                response[i].Tags.indexOf("Comment") == -1 &&
                response[i].Tags.indexOf("LFmain") == -1 &&
                response[i].Tags.indexOf("RFmain") == -1 &&
                response[i].Tags.indexOf("LRmain") == -1 &&
                response[i].Tags.indexOf("RRmain") == -1 &&
                response[i].Tags.indexOf("LFo") == -1 &&
                response[i].Tags.indexOf("LFi") == -1 &&
                response[i].Tags.indexOf("RFi") == -1 &&
                response[i].Tags.indexOf("RFo") == -1 &&
                response[i].Tags.indexOf("LRi") == -1 &&
                response[i].Tags.indexOf("LRo") == -1 &&
                response[i].Tags.indexOf("RRi") == -1 &&
                response[i].Tags.indexOf("RRo") == -1 &&
                response[i].Tags.indexOf("AnimalList") == -1)
            ) {
              imagesEvents.push(response[i]);
              response[i].eventType = 11;
              response[i].eventDate = response[i].ImageCreated;
              vm.events.push(response[i]);
            } else if (
              response[i].Tags &&
              response[i].Tags.indexOf("Comment") != -1 &&
              response[i].Tags.indexOf(date) == -1
            ) {
              commentImages.push(response[i]);
              response[i].eventDate = response[i].ImageCommentDate;
              response[i].eventType = 12;
              vm.events.push(response[i]);
            } else if (
              response[i].Tags &&
              response[i].Tags.indexOf("AnimalList") != -1
            ) {
              commentImages.push(response[i]);
              response[i].eventDate = response[i].ImageCommentDate;
              response[i].eventType = 12;
              vm.events.push(response[i]);
            } else {
              imagesAlone.push(response[i]);
            }
          }
          if (list.length == 100) {
            vm.showMore = true;
          }
          vm.images = response;
          vm.imagesToShow = list;
          images.resolve();
        })
        .catch(function (error) {
          console.log(error);
          images.reject();
        });
    }

    function getAllComments(animal_id) {
      return animalDetailsService
        .getCommentsByAnimalId(animal_id)
        .then(function (response) {
          vm.allComments = response;
          comments.resolve();
        })
        .catch(function (error) {
          console.log(error);
          comments.reject();
        });
    }

    function getReproduction(animal_id) {
      return animalDetailsService
        .getReproduction(animal_id)
        .then(function (response) {
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].StartDate;
            response[i].eventType = 2;
            if (response[i].ReproType == 1) {
              for (
                var j = 0;
                j < APP_CONSTANTS.constants.breedingTypes.length;
                j++
              ) {
                if (
                  response[i].BreedingType ==
                  APP_CONSTANTS.constants.breedingTypes[j].value
                ) {
                  response[i].BreedingTypeString = i18nFilter(
                    APP_CONSTANTS.constants.breedingTypes[j].label_translate
                  );
                  break;
                }
              }
            }
            vm.events.push(response[i]);
          }
          var repr = [];
          angular.copy(response, repr);
          repr = $filter("orderBy")(repr, "eventDate", true);
          var bre = [];
          for (var i = 0; i < repr.length; i++) {
            if (repr[i].ReproType == 1 && repr[i].ResultedInPregnancy) {
              bre.push(repr[i]);
            }
          }
          reporoduction.resolve();
        })
        .catch(function (error) {
          console.log(error);
          reporoduction.reject();
        });
    }

    function getCalving(animal_id) {
      return animalDetailsService
        .getCalving(animal_id)
        .then(function (response) {
          for (var i = 0; i < response.length; i++) {
            response[i].eventDate = response[i].CalvingDate;
            response[i].eventType = 3;
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.calvingEase.length;
              j++
            ) {
              if (
                response[i].CalvingEase ==
                APP_CONSTANTS.constants.calvingEase[j].value
              ) {
                response[i].CalvingEaseString = i18nFilter(
                  APP_CONSTANTS.constants.calvingEase[j].label_translate
                );
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.animalGender.length;
              j++
            ) {
              if (
                response[i].Calf1Gender ==
                APP_CONSTANTS.constants.animalGender[j].value
              ) {
                response[i].Calf1GenderString = i18nFilter(
                  APP_CONSTANTS.constants.animalGender[j].label_translate
                );
              }
              if (
                response[i].Calf2Gender ==
                APP_CONSTANTS.constants.animalGender[j].value
              ) {
                response[i].Calf2GenderString = i18nFilter(
                  APP_CONSTANTS.constants.animalGender[j].label_translate
                );
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.calfPresentation.length;
              j++
            ) {
              if (
                response[i].Calf1Presentation ==
                APP_CONSTANTS.constants.calfPresentation[j].value
              ) {
                response[i].Calf1PresentationString = i18nFilter(
                  APP_CONSTANTS.constants.calfPresentation[j].label_translate
                );
              }
              if (
                response[i].Calf2Presentation ==
                APP_CONSTANTS.constants.calfPresentation[j].value
              ) {
                response[i].Calf2PresentationString = i18nFilter(
                  APP_CONSTANTS.constants.calfPresentation[j].label_translate
                );
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.calfVitality.length;
              j++
            ) {
              if (
                response[i].Calf1Vitality ==
                APP_CONSTANTS.constants.calfVitality[j].value
              ) {
                response[i].Calf1VitalityString = i18nFilter(
                  APP_CONSTANTS.constants.calfVitality[j].label_translate
                );
              }
              if (
                response[i].Calf2Vitality ==
                APP_CONSTANTS.constants.calfVitality[j].value
              ) {
                response[i].Calf2VitalityString = i18nFilter(
                  APP_CONSTANTS.constants.calfVitality[j].label_translate
                );
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.colostrumQuantity.length;
              j++
            ) {
              if (
                response[i].ColostrumAmountKg ==
                APP_CONSTANTS.constants.colostrumQuantity[j].value
              ) {
                response[i].ColostrumAmountKgString =
                  APP_CONSTANTS.constants.colostrumQuantity[j].label;
                break;
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.colostrumQuality.length;
              j++
            ) {
              if (
                response[i].ColostrumQuality ==
                APP_CONSTANTS.constants.colostrumQuality[j].value
              ) {
                response[i].ColostrumQualityString = i18nFilter(
                  APP_CONSTANTS.constants.colostrumQuality[j].label_translate
                );
                break;
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.colostrumMeasurementType.length;
              j++
            ) {
              if (
                response[i].ColostrumQualityMeasurementType ==
                APP_CONSTANTS.constants.colostrumMeasurementType[j].value
              ) {
                response[i].ColostrumQualityMeasurementTypeString = i18nFilter(
                  APP_CONSTANTS.constants.colostrumMeasurementType[j]
                    .label_translate
                );
                break;
              }
            }
            for (
              var j = 0;
              j < APP_CONSTANTS.constants.ColostrumIntake.length;
              j++
            ) {
              if (
                response[i].ColostrumIntakeKgCalf1 ==
                APP_CONSTANTS.constants.ColostrumIntake[j].value
              ) {
                response[i].ColostrumIntakeKgCalf1String =
                  APP_CONSTANTS.constants.ColostrumIntake[j].label;
              }
              if (
                response[i].ColostrumIntakeKgCalf2 ==
                APP_CONSTANTS.constants.ColostrumIntake[j].value
              ) {
                response[i].ColostrumIntakeKgCalf2String =
                  APP_CONSTANTS.constants.ColostrumIntake[j].label;
              }
            }
            response[i].CalvingImages = [];
            response[i].ColostrumImages = [];
            response[i].MilkIntakeImages = [];
            vm.events.push(response[i]);
          }
          calving.resolve();
          return calving.promise;
        })
        .catch(function (error) {
          console.log(error);
          calving.reject();
        });
    }

    function getAnimal(animal_id, loadAnimalsUsingAnimal) {
      vm.showPedigree = false;
      vm.showStatusDaysString = false;
      return animalDetailsService
        .getAnimalById(animal_id)
        .then(function (response) {
          if (response) {
            vm.animalStatus = response.CurrentStatus;
            getEvents(animal_id);
            if (loadAnimalsUsingAnimal) {
              if (response.HerdId) {
                vm.disableAnimalSearchInput = true;
                getAnimals(response.HerdId);
              }
            }
            if (response.CurrentStatus == 0) {
              response.CurrentStatusString = i18nFilter("_animal_status_none_");
            } else if (response.CurrentStatus == 1) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter(
                "_animal_status_open_days_"
              );
              response.CurrentStatusString = i18nFilter("_animal_status_open_");
            } else if (response.CurrentStatus == 3) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter(
                "_animal_status_inseminated_days_"
              );
              response.CurrentStatusString = i18nFilter(
                "_animal_status_inseminated_"
              );
            } else if (response.CurrentStatus == 4) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter(
                "_animal_days_not_pregnant_"
              );
              response.CurrentStatusString = i18nFilter(
                "_animal_status_not_pregnant_"
              );
            } else if (response.CurrentStatus == 5) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter("_animal_days_pregnant_");
              response.CurrentStatusString = i18nFilter(
                "_animal_status_pregnant_"
              );
            } else if (response.CurrentStatus == 6) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter(
                "_animal_status_barren_days_"
              );
              response.CurrentStatusString = i18nFilter(
                "_animal_status_barren_"
              );
            } else if (response.CurrentStatus == 7) {
              response.CurrentStatusString = i18nFilter(
                "_animal_status_aborted_"
              );
            } else if (response.CurrentStatus == 8) {
              vm.showStatusDaysString = true;
              response.statusDaysString = i18nFilter("_animal_days_dry_");
              response.CurrentStatusString = i18nFilter("_animal_status_dry_");
            } else if (response.CurrentStatus == 9) {
              response.CurrentStatusString = i18nFilter("_animal_status_sold_");
            } else if (response.CurrentStatus == 10) {
              response.CurrentStatusString = i18nFilter("_animal_status_dead_");
            } else if (response.CurrentStatus == 11) {
              response.CurrentStatusString = i18nFilter(
                "_animal_status_presume_left_"
              );
            }
            var birth = {
              eventDate: response.BirthDate,
              eventType: 1,
            };
            if (
              (response.DamEarTag || response.DamName || response.DamNumber) &&
              (response.SireEarTag || response.SireName || response.SireNumber)
            ) {
              vm.showPedigree = true;
            }
            vm.last_insemination_date = response.LastHeatInseminationDate;
            if (response.LastCalvingDate) {
              vm.last_calving_date = response.LastCalvingDate;
            } else {
              vm.last_calving_date = response.BirthDate;
            }
            var statusDate = moment(response.StatusDate);
            var today = moment();
            response.status_days = today.diff(statusDate, "days");
            if (birth.eventDate) {
              vm.events.push(birth);
            }
            if (response.Tags) {
              response.TagsToShow = [];
              var tags = response.Tags.split("#");
              for (var j = 0; j < tags.length; j++) {
                for (var k = 0; k < vm.tags.length; k++) {
                  if (tags[j] == vm.tags[k].value && tags[j] != "") {
                    var tag_added = false;
                    for (var t = 0; t < response.TagsToShow.length; t++) {
                      if (response.TagsToShow[t].value == vm.tags[k].value) {
                        tag_added = true;
                      }
                    }
                    if (!tag_added) {
                      response.TagsToShow.push(vm.tags[k]);
                    }
                    break;
                  }
                }
              }
            }
            var getDate = false;
            var picture_id;
            if (vm.animalList && vm.animalList[vm.index]) {
              if (vm.animalList[vm.index].d) {
                response.PictureCreateDate = vm.animalList[vm.index].d;
              } else {
                if (vm.animalList[vm.index].p_id) {
                  picture_id = vm.animalList[vm.index].p_id;
                  getDate = true;
                } else {
                  picture_id = response.PictureId;
                  getDate = true;
                }
              }
              if (vm.state == "herds.listGenerator") {
                if (vm.animalList[vm.index].p) {
                  response.PictureImageUrl = vm.animalList[vm.index].p;
                } else {
                  response.PictureImageUrl = null;
                }
              }
            } else {
              picture_id = response.PictureId;
              getDate = true;
            }
            if (getDate && picture_id) {
              var suffix = "?id=" + picture_id;
              return animalDetailsService
                .getPictureById(response.HerdId, suffix)
                .then(function (picture_response) {
                  if (picture_response[0]) {
                    response.PictureCreateDate =
                      picture_response[0].ImageCreated;
                  }
                  vm.animal = response;
                  animal.resolve();
                })
                .catch(function (error) {
                  response.PictureCreateDate = null;
                  vm.animal = response;
                  animal.resolve();
                });
            } else {
              vm.animal = response;
              animal.resolve();
            }
          } else {
            vm.noAnimalDataAvailable = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          animal.reject();
        });
    }
    var timelineBlocks = $(".cd-timeline-block"),
      offset = 0.8;
    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);
    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on("scroll", function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function openNewDiscussionModal() {
      vm.discussion = {};
      vm.discussion.importance = 0;
      vm.loadingNewDiscussion = false;
      vm.discussion.created = new Date().toISOString();
      stopCarousel();
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/herds/animals/animalDetails/addNewDiscussion.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function addNewDiscussion() {
      vm.loadingNewDiscussion = true;
      var suffix = "?created=" + vm.discussion.created;
      if (vm.discussion.tags && vm.discussion.tags != "") {
        suffix = suffix + "&tags=" + encodeURIComponent(vm.discussion.tags);
      }
      if (vm.discussion.comments && vm.discussion.comments != "") {
        suffix = suffix + "&comments=" + vm.discussion.comments;
      }
      suffix = suffix + "&importance=" + vm.discussion.importance;
      if (vm.discussion.isTask) {
        suffix = suffix + "&isTask=true";
      } else {
        suffix = suffix + "&isTask=false";
      }
      if (vm.file) {
        var url =
          APP_CONSTANTS.animals_base_url +
          "animals/" +
          vm.animal_id +
          "/pictures" +
          suffix;
        Upload.upload({
          url: url,
          data: {
            file: vm.file,
          },
        })
          .then(function (response) {
            $uibModalStack.dismissAll();
          })
          .catch(function (error) {
            vm.loadingNewDiscussion = false;
            console.log(error);
          });
      } else {
        return animalDetailsService
          .addNewDiscussion(vm.animal_id, suffix)
          .then(function (response) {
            $uibModalStack.dismissAll();
          })
          .catch(function (error) {
            console.log(error);
            vm.loadingNewDiscussion = false;
          });
      }
    }

    function uploadChanged() {
      vm.fileName = vm.file.name;
    }

    function removeSelectedFile() {
      vm.file = null;
      vm.fileName = null;
    }

    function startCarousel() {
      vm.carouselActive = true;
      if (carouselTimer) {
        $interval.cancel(carouselTimer);
      }
      carouselTimer = $interval(function () {
        if (vm.index == vm.animalList.length - 1) {
          vm.index = -1;
        }
        nextAnimal();
      }, vm.carouselTime);
    }

    function stopCarousel() {
      $interval.cancel(carouselTimer);
      vm.carouselActive = false;
    }

    function changeCarousel() {
      if (vm.carouselActive) {
        stopCarousel();
      } else {
        startCarousel();
      }
    }

    function openIntervalModal() {
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/herds/animals/animalDetails/interval.modal.html",
        size: "sm",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function setCarouselInterval() {
      if (angular.isNumber(vm.carouselTimeSec)) {
        vm.carouselTime = vm.carouselTimeSec * 1000;
        closeModal();
      }
    }

    function newDiscussionSetTags(item, index) {
      var tagsString = "";
      for (var i = 0; i < vm.discussion.tags_list.length; i++) {
        tagsString = tagsString + vm.discussion.tags_list[i].value;
        if (i < vm.discussion.tags_list.length - 1) {
          tagsString = tagsString + "#";
        }
      }
      vm.discussion.tags = tagsString;
    }

    function selectImage(index) {
      vm.selectedImage = vm.sliderImages[index];
      checkForComments(index, vm.selectedImage);
      vm.selectedImageIndex = index;
      if (!vm.carouselActive) {
        vm.modalOpen = true;
        $uibModal
          .open({
            animation: true,
            templateUrl:
              "app/pages/herds/animals/animalDetails/picture.modal.html",
            size: "lg",
            scope: $scope,
            backdrop: "static",
            keyboard: false,
          })
          .closed.then(function () {
            vm.modalOpen = false;
          });
      }
    }

    function checkForComments(index, image) {
      if (image.NumberComments > 0) {
        getComments(index, image.Id);
      }
    }

    function getComments(index, id) {
      return animalDetailsService
        .getComments(id)
        .then(function (response) {
          response = $filter("orderBy")(response, "CommentTimeStamp", true);
          if (vm.imagesToShow[index]) {
            vm.imagesToShow[index].Comments = response;
          }
          vm.sliderImages[index].Comments = response;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function closeModal() {
      $uibModalStack.dismissAll();
      if (mixedChartModal) {
        mixedChartModal.destroy();
      }
      if (mixedChartModal2) {
        mixedChartModal2.destroy();
      }

      vm.graphModalOpened = false;
    }

    function previousImage(click) {
      if (vm.selectedImageIndex > 0) {
        vm.selectedImageIndex = vm.selectedImageIndex - 1;
        vm.selectedImage = vm.sliderImages[vm.selectedImageIndex];
        checkForComments(vm.selectedImageIndex, vm.selectedImage);
        vm.hideImage = true;
        $scope.$evalAsync();
        $timeout(function () {
          vm.hideImage = false;
        }, 10);
      }
    }

    function nextImage(click) {
      if (vm.selectedImageIndex < vm.sliderImages.length - 1) {
        vm.selectedImageIndex = vm.selectedImageIndex + 1;
        vm.selectedImage = vm.sliderImages[vm.selectedImageIndex];
        checkForComments(vm.selectedImageIndex, vm.selectedImage);
        vm.hideImage = true;
        $scope.$evalAsync();
        $timeout(function () {
          vm.hideImage = false;
        }, 10);
      }
    }

    function showMenuModal() {
      menuActivated = true;
      activeMenu = "modalMenu";
      document.getElementById("modalMenu").style.display = "block";
    }

    function changeImportance(image, value, index, isCarousel) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (vm.images[i].Id == image.Id) {
            index = i;
            break;
          }
        }
      }
      if (image.Importance != value) {
        image.Importance = value;
        if (isCarousel) {
          vm.images[index] = image;
        }
        var suffix = "";
        if (image.Tags) {
          suffix = "&tags=" + encodeURIComponent(image.Tags);
        }
        setImportance(image.Id, value, suffix);
      }
    }

    function changeIsTask(image, value, index, isCarousel) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (image.Id == vm.images[i].Id) {
            index = i;
            break;
          }
        }
      }
      var suffix = "/updateTask?isTask=";
      if (value) {
        var date = new Date().toISOString();
        suffix = suffix + true + "&taskCompleted=" + date;
        image.IsTask = true;
        image.TaskCompleted = date;
        vm.images[index].IsTask = true;
        vm.images[index].TaskCompleted = date;
        if (isCarousel) {
          vm.selectedImage.IsTask = true;
          vm.selectedImage.TaskCompleted = date;
        }
      } else {
        suffix = suffix + !image.IsTask;
        image.IsTask = !image.IsTask;
        vm.images[index].IsTask = !vm.images[index].IsTask;
        if (isCarousel) {
          vm.selectedImage.IsTask = !vm.selectedImage.IsTask;
        }
        if (!image.IsTask) {
          image.TaskCompleted = null;
          image.TaskCompletedBy = null;
          vm.images[index].TaskCompleted = null;
          vm.images[index].TaskCompletedBy = null;
          if (isCarousel) {
            vm.selectedImage.TaskCompleted = null;
            vm.selectedImage.TaskCompletedBy = null;
          }
        }
      }
      setIsTask(image.Id, suffix, index, isCarousel);
    }

    function setImportance(imageId, value, suffix) {
      return animalDetailsService
        .setImportance(imageId, value, suffix)
        .then(function (response) {
          for (var i = 0; i < vm.images.length; i++) {
            if (vm.images[i].Id == imageId) {
              vm.images[i].Importance = response.Importance;
              if (vm.imagesToShow[i]) {
                vm.imagesToShow[i].Importance = response.Importance;
              }
              break;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function setIsTask(imageId, suffix, index, isCarousel) {
      return animalDetailsService
        .setIsTask(imageId, suffix)
        .then(function (response) {
          for (var i = 0; i < vm.images.length; i++) {
            if (vm.images[i].Id == imageId) {
              vm.images[i].IsTask = response.IsTask;
              vm.images[i].TaskCompleted = response.TaskCompleted;
              vm.images[i].TaskCompletedBy = response.TaskCompletedBy;
              if (vm.imagesToShow[i]) {
                vm.imagesToShow[i].IsTask = response.IsTask;
                vm.imagesToShow[i].TaskCompleted = response.TaskCompleted;
                vm.imagesToShow[i].TaskCompletedBy = response.TaskCompletedBy;
              }
            }
          }
          if (response.TaskCompletedBy) {
            if (isCarousel) {
              vm.selectedImage.TaskCompletedBy = response.TaskCompletedBy;
            }
            vm.images[index].TaskCompletedBy = response.TaskCompletedBy;
            if (vm.imagesToShow) {
              vm.imagesToShow[index].TaskCompletedBy = response.TaskCompletedBy;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function addCommentOnEnter(event, image, index, isCarousel) {
      if (event.keyCode == 13) {
        addComment(image, index, isCarousel);
      } else if (event.keyCode == 32) {
        event.preventDefault();
      }
    }

    function addComment(image, index, isCarousel) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (vm.images[i].Id == image.Id) {
            index = i;
            break;
          }
        }
      }
      if (vm.commentText) {
        vm.commentText.trim();
      }
      if (vm.commentText && vm.commentText.length) {
        var comment = {
          Message: vm.commentText,
        };
        addNewComment(image.Id, comment, index, isCarousel);
      }
    }

    function addNewComment(imageId, comment, index) {
      return animalDetailsService
        .addComment(imageId, comment)
        .then(function (response) {
          if (!vm.images[index].Comments) {
            vm.images[index].Comments = [];
          }
          vm.images[index].Comments.splice(0, 0, response);
          vm.images[index].NumberComments = vm.images[index].NumberComments + 1;
          vm.commentText = null;
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function addTag(image, item, index) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (vm.images[i].Id == image.Id) {
            index = i;
            break;
          }
        }
      }
      if (image.Tags) {
        var tags = image.Tags + "#" + item.value;
        vm.images[index].Tags = tags;
      } else {
        var tags = "#" + item.value;
        vm.images[index].Tags = tags;
      }
      var suffix =
        "tagevent/" +
        image.Id +
        "/updateParameters?importance=" +
        image.Importance +
        "&tags=" +
        encodeURIComponent(tags);
      updateTags(image.Id, suffix);
    }

    function updateTags(imageId, suffix) {
      return animalDetailsService
        .updateTags(suffix)
        .then(function (response) {
          for (var i = 0; i < vm.images.length; i++) {
            if (vm.images[i].Id == imageId) {
              vm.images[i].Tags = response.Tags;
              break;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function removeTag(image, item, index) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (vm.images[i].Id == image.Id) {
            index = i;
            break;
          }
        }
      }
      var tags = image.Tags.split("#");
      var tagsToSend = [];
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] != "" && tags[i] != item.value) {
          tagsToSend.push(tags[i]);
        }
      }
      var newTags = "";
      for (var i = 0; i < tagsToSend.length; i++) {
        newTags = newTags + "#" + tagsToSend[i];
      }
      vm.images[index].Tags = newTags;
      var suffix =
        "tagevent/" +
        image.Id +
        "/updateParameters?importance=" +
        image.Importance +
        "&tags=" +
        encodeURIComponent(newTags);
      updateTags(image.Id, suffix);
    }

    function rotateImage(image, rotation, index, isCarousel) {
      if (!index) {
        for (var i = 0; i < vm.images.length; i++) {
          if (vm.images[i].Id == image.Id) {
            index = i;
            break;
          }
        }
      }
      return animalDetailsService
        .rotateImage(image.Id, rotation)
        .then(function (response) {
          var date = new Date().getTime();
          if (vm.selectedEvent) {
            vm.selectedEvent.hideEvent = true;
            var found = false;
            if (vm.selectedEvent.eventType == 3) {
              if (vm.selectedEvent.CalvingImages.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.CalvingImages.length;
                  i++
                ) {
                  if (vm.selectedEvent.CalvingImages[i].Id == image.Id) {
                    vm.selectedEvent.CalvingImages[i].ThumbnailUrl =
                      vm.selectedEvent.CalvingImages[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.CalvingImages[i].ImageUrl =
                      vm.selectedEvent.CalvingImages[i].ImageUrl + "?" + date;
                    found = true;
                    break;
                  }
                }
              }
              if (!found && vm.selectedEvent.ColostrumImages.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.ColostrumImages.length;
                  i++
                ) {
                  if (vm.selectedEvent.ColostrumImages[i].Id == image.Id) {
                    vm.selectedEvent.ColostrumImages[i].ThumbnailUrl =
                      vm.selectedEvent.ColostrumImages[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.ColostrumImages[i].ImageUrl =
                      vm.selectedEvent.ColostrumImages[i].ImageUrl + "?" + date;
                    found = true;
                    break;
                  }
                }
              }
              if (!found && vm.selectedEvent.MilkIntakeImages.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.MilkIntakeImages.length;
                  i++
                ) {
                  if (vm.selectedEvent.MilkIntakeImages[i].Id == image.Id) {
                    vm.selectedEvent.MilkIntakeImages[i].ThumbnailUrl =
                      vm.selectedEvent.MilkIntakeImages[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.MilkIntakeImages[i].ImageUrl =
                      vm.selectedEvent.MilkIntakeImages[i].ImageUrl +
                      "?" +
                      date;
                    found = true;
                    break;
                  }
                }
              }
            } else if (
              vm.selectedEvent.eventType == 4 ||
              vm.selectedEvent.eventType == 9 ||
              vm.selectedEvent.eventType == 10
            ) {
              for (var i = 0; i < vm.selectedEvent.Pictures.length; i++) {
                if (vm.selectedEvent.Pictures[i].Id == image.Id) {
                  vm.selectedEvent.Pictures[i].ThumbnailUrl =
                    vm.selectedEvent.Pictures[i].ThumbnailUrl + "?" + date;
                  vm.selectedEvent.Pictures[i].ImageUrl =
                    vm.selectedEvent.Pictures[i].ImageUrl + "?" + date;
                  break;
                }
              }
            } else if (vm.selectedEvent.eventType == 7) {
              var found = false;
              if (vm.selectedEvent.miscImages.length > 0) {
                for (var i = 0; i < vm.selectedEvent.miscImages.length; i++) {
                  if (vm.selectedEvent.miscImages[i].Id == image.Id) {
                    vm.selectedEvent.miscImages[i].ThumbnailUrl =
                      vm.selectedEvent.miscImages[i].ThumbnailUrl + "?" + date;
                    vm.selectedEvent.miscImages[i].ImageUrl =
                      vm.selectedEvent.miscImages[i].ImageUrl + "?" + date;
                    found = true;
                    break;
                  }
                }
              }
              if (!found && vm.selectedEvent.clinicalImages.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.clinicalImages.length;
                  i++
                ) {
                  if (vm.selectedEvent.clinicalImages[i].Id == image.Id) {
                    vm.selectedEvent.clinicalImages[i].ThumbnailUrl =
                      vm.selectedEvent.clinicalImages[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.clinicalImages[i].ImageUrl =
                      vm.selectedEvent.clinicalImages[i].ImageUrl + "?" + date;
                    found = true;
                    break;
                  }
                }
              }
              if (!found && vm.selectedEvent.subclinicalImages.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.subclinicalImages.length;
                  i++
                ) {
                  if (vm.selectedEvent.subclinicalImages[i].Id == image.Id) {
                    vm.selectedEvent.subclinicalImages[i].ThumbnailUrl =
                      vm.selectedEvent.subclinicalImages[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.subclinicalImages[i].ImageUrl =
                      vm.selectedEvent.subclinicalImages[i].ImageUrl +
                      "?" +
                      date;
                    ImageUrl;
                    found = true;
                    break;
                  }
                }
              }
            } else if (vm.selectedEvent.eventType == 8) {
              var found = false;
              if (vm.selectedEvent.DiseasesPictures.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.DiseasesPictures.length;
                  i++
                ) {
                  if (vm.selectedEvent.DiseasesPictures[i].Id == image.Id) {
                    vm.selectedEvent.DiseasesPictures[i].ThumbnailUrl =
                      vm.selectedEvent.DiseasesPictures[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.DiseasesPictures[i].ImageUrl =
                      vm.selectedEvent.DiseasesPictures[i].ImageUrl +
                      "?" +
                      date;
                    found = true;
                    break;
                  }
                }
              }
              if (!found && vm.selectedEvent.PreventionsPictures.length > 0) {
                for (
                  var i = 0;
                  i < vm.selectedEvent.PreventionsPictures.length;
                  i++
                ) {
                  if (vm.selectedEvent.PreventionsPictures[i].Id == image.Id) {
                    vm.selectedEvent.PreventionsPictures[i].ThumbnailUrl =
                      vm.selectedEvent.PreventionsPictures[i].ThumbnailUrl +
                      "?" +
                      date;
                    vm.selectedEvent.PreventionsPictures[i].ImageUrl =
                      vm.selectedEvent.PreventionsPictures[i].ImageUrl +
                      "?" +
                      date;
                    found = true;
                    break;
                  }
                }
              }
            } else if (vm.selectedEvent.eventType == 11) {
              vm.selectedEvent.ThumbnailUrl =
                vm.selectedEvent.ThumbnailUrl + "?" + date;
              vm.selectedEvent.ImageUrl =
                vm.selectedEvent.ImageUrl + "?" + date;
            }
          }
          vm.images[index].hideImage = true;
          if (isCarousel) {
            vm.selectedImage.hideImage = true;
          }
          vm.images[index].ThumbnailUrl =
            vm.images[index].ThumbnailUrl + "?" + date;
          vm.images[index].ImageUrl = vm.images[index].ImageUrl + "?" + date;
          if (isCarousel) {
            vm.selectedImage.ThumbnailUrl =
              vm.images[index].ThumbnailUrl + "?" + date;
            vm.selectedImage.ImageUrl = vm.images[index].ImageUrl + "?" + date;
          }
          $timeout(function () {
            vm.images[index].hideImage = false;
            if (vm.selectedEvent) {
              vm.selectedEvent.hideEvent = false;
            }
            if (isCarousel) {
              vm.selectedImage.hideImage = false;
            }
          }, 0);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function rotateProfilePicture() {
      stopCarousel();
      var rotation = 1;
      return animalDetailsService
        .rotateImage(vm.animal.PictureId, rotation)
        .then(function (response) {
          var date = new Date().getTime();
          vm.animal.PictureImageUrl = vm.animal.PictureImageUrl + "?" + date;
          vm.hideProfileImage = true;
          $timeout(function () {
            vm.hideProfileImage = false;
          }, 100);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    function showImage(index, images, event, type) {
      vm.selectedEventType = type;
      vm.selectedEvent = event;
      vm.sliderImages = images;
      selectImage(index);
    }

    function showImageByType(index, type, event) {
      var images = event[type];
      showImage(index, images, event, type);
    }

    function selectFromAll(id) {
      var index = 0;
      for (var i = 0; i < vm.images.length; i++) {
        if (vm.images[i].Id == id) {
          index = i;
        }
      }
      showImage(index, vm.images, null, "all");
    }

    function showOneImage(image) {
      vm.selectedEvent = image;
      showImage(0, [image], image, "one");
    }

    function setProfileStyle() {
      if (!vm.hideProfileImage) {
        if (vm.animal) {
          if (vm.animal.PictureImageUrl) {
            return {
              "background-image": "url(" + vm.animal.PictureImageUrl + ")",
            };
          } else {
            return {
              "background-image": "url(assets/img/logo.png)",
            };
          }
        }
      }
    }

    function loadMoreImages() {
      var current = vm.showImagesIndex;
      var i = current * 100;
      var endIndex = i + 100;
      var list = [];
      for (i; i < endIndex; i++) {
        if (vm.images[i]) {
          list.push(vm.images[i]);
        } else {
          break;
        }
      }
      vm.imagesToShow = vm.imagesToShow.concat(list);
      vm.showImagesIndex = vm.showImagesIndex + 1;
      if (vm.images[endIndex]) {
        vm.showMore = true;
      } else {
        vm.showMore = false;
      }
    }

    function searchInputChanged() {
      if (searchTimer) {
        $timeout.cancel(searchTimer);
      }
      searchTimer = $timeout(function () {
        var list = [];
        for (var i = 0; i < vm.animalList.length; i++) {
          var num = vm.animalList[i].number;
          if (num) {
            var str = num.toString();
          }
          if (str && str.indexOf(vm.searchAnimalString) != -1) {
            list.push(vm.animalList[i]);
          }
        }
        vm.searchAnimalList = list;
      }, 750);
    }

    function goToAnimal(animal) {
      var index;
      for (var i = 0; i < vm.animalList.length; i++) {
        if (vm.animalList[i].id == animal.id) {
          index = i;
          break;
        }
      }
      if (index) {
        closeModal();
        vm.index = index;
        getAnimalData(vm.animalList[index].id);
      }
    }

    function goToAnimalByNumber() {
      if (animalByNumberTimer) {
        $timeout.cancel(animalByNumberTimer);
      }
      animalByNumberTimer = $timeout(function () {
        if (vm.showOverview) {
          if (vm.animalSearchNumber) {
            if (isNaN(vm.animalSearchNumber)) {
              vm.animalSearchNumberError = true;
            } else {
              vm.animalSearchNumberError = false;
              var index;
              for (var i = 0; i < vm.animalList.length; i++) {
                if (vm.animalList[i].number) {
                  if (vm.animalList[i].number == vm.animalSearchNumber) {
                    index = i;
                    break;
                  }
                } else {
                  if (vm.animalList[i].Number == vm.animalSearchNumber) {
                    index = i;
                    break;
                  }
                }
              }
              if (index) {
                vm.index = index;
                getAnimalData(vm.animalList[index].id);
                vm.animalSearchNumber = null;
              } else {
                vm.animalSearchNumberError = true;
              }
            }
          } else {
            vm.animalSearchNumberError = true;
          }
        }
      }, 500);
    }

    function showHoofTrimInfoModal(date) {
      var trims = vm.events.filter(function (e) {
        return e.eventType == 14 && e.eventDate == date;
      });
      vm.hoofTrimInfoData = angular.copy(trims);
      for (var i = 0; i < vm.hoofTrimInfoData.length; i++) {
        vm.hoofTrimInfoData[i].showDate = true;
      }
      $uibModal.open({
        animation: true,
        templateUrl:
          "app/pages/herds/animals/animalDetails/trimInfo.modal.html",
        size: "md",
        scope: $scope,
        backdrop: "static",
        keyboard: false,
      });
    }

    function animalSearchKeyPress(event) {
      if (event.keyCode == 13) {
        goToAnimalByNumber();
      }
    }

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        $(this).offset().top >
          $(window).scrollTop() + $(window).height() * offset &&
          $(this)
            .find(".cd-timeline-img, .cd-timeline-content")
            .addClass("is-hidden");
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        $(this).offset().top <=
          $(window).scrollTop() + $(window).height() * offset &&
          $(this).find(".cd-timeline-img").hasClass("is-hidden") &&
          $(this)
            .find(".cd-timeline-img, .cd-timeline-content")
            .removeClass("is-hidden")
            .addClass("bounce-in");
      });
    }

    function getRandomColor() {
      var a =
        "#" +
        (function co(lor) {
          return (lor += [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
          ][Math.floor(Math.random() * 16)]) && lor.length == 6
            ? lor
            : co(lor);
        })("");
      return a;
    }
    $(function () {
      $("body").click(function (e) {
        if (menuActivated) {
          $timeout(function () {
            menuActivated = false;
          }, 250);
        } else {
          if (
            e.target.id == activeMenu ||
            $(e.target).parents("#" + activeMenu + "").length
          ) {
          } else {
            if (activeMenu) {
              document.getElementById(activeMenu).style.display = "none";
              activeMenu = null;
            }
          }
        }
      });
    });
    $scope.$on("$destroy", function () {
      stopCarousel();
      document.body.onkeydown = null;
    });
  }
})();

(function () {
    'use strict';
    angular.module('My.pages.herds.animals.details').factory('animalDetailsService', animalDetailsService);
    /** @ngInject */
    function animalDetailsService($http, $q, APP_CONSTANTS) {
        return {
            getAnimals: getAnimals
            , getAnimalById: getAnimalById
            , getReproduction: getReproduction
            , getCalving: getCalving
            , getImages: getImages
            , getObservations: getObservations
            , getLactations: getLactations
            , getMilkRecordings: getMilkRecordings
            , getManualMilk: getManualMilk
            , getUdderHealth: getUdderHealth
            , getHealthEvents: getHealthEvents
            , getClawHealth: getClawHealth
            , getHoofTrims: getHoofTrims
            , addNewDiscussion: addNewDiscussion
            , getComments: getComments
            , setImportance: setImportance
            , setIsTask: setIsTask
            , addComment: addComment
            , updateTags: updateTags
            , rotateImage: rotateImage
            , getCommentsByAnimalId: getCommentsByAnimalId
            , getMilkMeters: getMilkMeters
            , getPictureById: getPictureById
            , getTeamHerdAccess: getTeamHerdAccess
            , deletePicture: deletePicture
            , getFeedIntake: getFeedIntake
            , getAnimalByEarTag: getAnimalByEarTag
            , getMovements: getMovements
            , getAllAnimalsByHerdId: getAllAnimalsByHerdId
        }

        function getAnimalById(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId, {}).then(success).catch(error);
        }

        function getAnimals(herdId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herdId + '/animals?isonfarm=true&-orderby=-lastcalvingdate', {}).then(success).catch(error);
        }

        function getPictureById(herd_id, suffix) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/pictures' + suffix).then(success).catch(error);
        }

        function getReproduction(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/repro', {}).then(success).catch(error);
        }

        function getCalving(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/calvingdetails', {}).then(success).catch(error);
        }

        function getImages(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/pictures', {}).then(success).catch(error);
        }

        function getObservations(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/observations', {}).then(success).catch(error);
        }

        function getLactations(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/lactations', {}).then(success).catch(error);
        }

        function getMilkRecordings(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/milkrecordings', {}).then(success).catch(error);
        }

        function getManualMilk(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/manualmilkings', {}).then(success).catch(error);
        }

        function getMilkMeters(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/dailymilkmeteryields?-orderby=-date', {}).then(success).catch(error);
        }

        function getUdderHealth(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/clinicaludderhealths', {}).then(success).catch(error);
        }

        function getHealthEvents(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/healthevents', {}).then(success).catch(error);
        }

        function getClawHealth(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/clawhealths', {}).then(success).catch(error);
        }

        function getHoofTrims(animalId) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animalId + '/hooftrims', {}).then(success).catch(error);
        }

        function addNewDiscussion(animal_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/pictures' + suffix).then(success).catch(error);
        }

        function getComments(picture_id) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'pictures/' + picture_id + '/comments').then(success).catch(error);
        }

        function getCommentsByAnimalId(animal_id) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/comments').then(success).catch(error);
        }

        function setImportance(image_id, value, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'tagevent/' + image_id + '/updateParameters?importance=' + value + suffix).then(success).catch(error);
        }

        function setIsTask(image_id, suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + suffix, {
                withCredentials: true
            }).then(success).catch(error);
        }

        function addComment(image_id, comment) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + image_id + '/comments', comment).then(success).catch(error);
        }

        function updateTags(suffix) {
            return $http.post(APP_CONSTANTS.animals_base_url + suffix).then(success).catch(error);
        }

        function rotateImage(imagId, rotation) {
            return $http.post(APP_CONSTANTS.animals_base_url + 'pictures/' + imagId + '/rotate/' + rotation).then(success).catch(error);
        }

        function getTeamHerdAccess(user_id) {
            return $http.get(APP_CONSTANTS.backoffice_base_url + 'users/' + user_id + '/userteamherdaccess').then(success).catch(error);
        }

        function deletePicture(picture_id) {
            return $http.delete(APP_CONSTANTS.animals_base_url + 'pictures/' + picture_id).then(success).catch(error);
        }

        function getFeedIntake(animal_id) {
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/dailyfeedintakes?-orderby=-date').then(success).catch(error);
        }

        function getAnimalByEarTag(herd_id, ear_tag){
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/eartag/' + ear_tag).then(success).catch(error);
        }

        function getMovements(animal_id){
            return $http.get(APP_CONSTANTS.animals_base_url + 'animals/' + animal_id + '/movements').then(success).catch(error);
        }

        function getAllAnimalsByHerdId(herd_id){
            return $http.get(APP_CONSTANTS.animals_base_url + 'herds/' + herd_id + '/animals').then(success).catch(error);
        }

        function success(response) {
            return response.data;
        }

        function error(error) {
            return $q.reject(error);
        }
    }
})();
angular.module('My').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/agroscoop/agroscoop.html','<div class="row"><div class="col-xs-12" ng-hide="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto" id="panel-map"><div style="text-align: right"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle=""><data-i18n i18n="_report_create_report_">Create report</data-i18n><span class="caret"></span></button><ul uib-dropdown-menu="" class="dropdown-menu-right report-agro-dropdown-button"><li><a href="" ng-click="vm.openCreateReport(true)">Default</a></li><li><a href="" ng-click="vm.openCreateReport()"><data-i18n i18n="_label_time_custom_">Custom</data-i18n></a></li></ul></div></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px; height: 34px" ng-if="!vm.showCreateReportButton"></div><div><div ng-if="vm.reselectTeamError"><span style="color: red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><span style="color: red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" class="loading-spinner"><div class="loading-animation"></div></div><div id="frame" class="dashboard-wrapper-home"></div></div></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.hideCustomPart" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError && !vm.hideCustomPart"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox" style="color: darkred" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.description}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove"></textarea></div><div><button class="btn btn-primary" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span style="color: red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span style="color: red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div></div><div ng-if="vm.showCropArea"><div ng-repeat="image in vm.images" style="position: absolute; top: 500000px"><img id="image-test{{image.index}}" ng-src="{{image.image}}"></div><div ng-show="true"></div></div>');
$templateCache.put('app/pages/agroscoop/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/agroscoop/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/agroscoop/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/arvestaDashboard/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/arvestaDashboard/arvestaDashboard.html','<div style="height: auto;" ng-hide="vm.showCreateReportBlock"><div style="text-align: right;"><div class="arvesta-top-bar" ng-if="vm.showTopBar()"><div class="col-sm-4 col-xs-12 navigation-buttons"><div ng-if="vm.showChangeState()"><button class="btn btn-primary" ng-repeat="state in vm.stateList" ng-click="vm.changeState(state.state)" ng-class="state.state ? \'\' : \'active-category-md\'">{{state.title | i18n}}</button></div></div><div class="col-sm-4 col-xs-12 dashboard-navigation-buttons"><div class="dashboard-link" ng-repeat="link in vm.dashboardLinks"><img uib-tooltip="{{link.tooltip | i18n}}" tooltip-is-open="tooltipOpen" tooltip-placement="top" tooltip-class="customBlue top" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-src="{{link.icon | appImage}}" ng-click="vm.changeSheet(link)"></div></div><div class="col-sm-4 col-xs-12 report-block"><div class="report-button"><button class="btn btn-primary" ng-click="vm.openAddToReportModal()" ng-disabled="vm.selectedHerds.length != 1 || vm.disableAddToReport"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div><div class="report-button"><button class="btn btn-primary" ng-click="vm.openCreateReport()" ng-disabled="vm.selectedHerds.length !=1" ng-if="!vm.style || vm.style==\'zoetis\'"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button><div ng-if="vm.style == \'aveve\'" class="icon-button"><img src="assets/img/print.svg" ng-click="vm.openCreateReport()"></div><div ng-if="vm.style == \'proxani\'" class="icon-button"><img src="assets/img/print_proxani.png" ng-click="vm.openCreateReport()"></div></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.startDate | date:\'shortDate\'}} - {{vm.endDate | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableRangeSelector ? \'disabled\': \'\'"></i></div></div></div></div><div style="display: flex; flex-wrap: wrap; justify-content: right; padding-bottom: 10px; min-height: 32px;" ng-if="vm.showQuickButtons()"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px;" ng-hide="vm.disableQuickButtons"><button class="btn btn-primary btn-xs" ng-click="vm.quickSetDates(1)" ng-disabled="vm.disableQuickButtons"><data-i18n i18n="_label_3_months_short_">3M</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px;" ng-hide="vm.disableQuickButtons"><button class="btn btn-primary btn-xs" ng-click="vm.quickSetDates(2)" ng-disabled="vm.disableQuickButtons"><data-i18n i18n="_label_1_year_short_">1Y</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom;" ng-hide="vm.disableQuickButtons"><button class="btn btn-primary btn-xs" ng-click="vm.quickSetDates(3)" ng-disabled="vm.disableQuickButtons"><data-i18n i18n="_label_5_years_short_">5Y</data-i18n></button></div></div><div id="dashboard-frame" ng-class="vm.getFrameClass()" ng-if="vm.initDone"><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png" ng-if="!vm.style || vm.style==\'zoetis\'"> <img src="assets/img/back_aveve.svg" ng-if="vm.style==\'aveve\'"> <img src="assets/img/proxani-back-icon.png" ng-if="vm.style==\'proxani\'"></div><div ng-if="vm.showActualCurrentDateMessage" class="day-filter-info"><div class="close-button" ng-click="vm.showActualCurrentDateMessage = false"><span class="material-icons">close</span></div><div><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n>:</div><div ng-if="vm.actualFilterValue.type == 1">{{vm.actualFilterValue.day | date:\'shortDate\'}}</div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_animal_dim_">DIM</data-i18n>:<span style="margin-left: 3px;">{{vm.actualFilterValue.dim }}</span></div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_dashboard_name_filter_parity_">Parity</data-i18n>:<span style="margin-left: 3px;">{{vm.actualFilterValue.parity }}</span></div></div></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div include-with-scope="app/pages/arvestaDashboard/reportBlock.html"></div></div>');
$templateCache.put('app/pages/arvestaDashboard/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modalStartDate" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modalEndDate" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/arvestaDashboard/reportBlock.html','<div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.startDate | date:\'shortDate\'}} - {{dashboard.endDate | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><div><div class="filter-checkbox" ng-class="vm.includePPoints ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includePPoints = !vm.includePPoints" style="display: inline-block"></div><label style="display: inline-block; vertical-align: middle; margin-left: 5px;"><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label></div><textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" ng-disabled="!vm.includePPoints"></textarea></div><div class="form-group"><div><div class="filter-checkbox" ng-class="vm.includeIPoints ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includeIPoints = !vm.includeIPoints" style="display: inline-block"></div><label style="display: inline-block; vertical-align: middle; margin-left: 5px;"><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label></div><textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" ng-disabled="!vm.includeIPoints"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div>');
$templateCache.put('app/pages/claw_health/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/claw_health/claw_health.html','<div class="row"><div class="col-xs-12" ng-hide="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px"><button class="btn btn-primary" ng-click="vm.openAddToReportModal()" ng-show="vm.showAddToReportButton"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openCreateReport()"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div class="claw-health-warning-button"><i class="fa fa-exclamation-triangle" aria-hidden="true" ng-click="vm.openWarningModal()"></i></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="frame" class="dashboard-wrapper-claw-health" style="position: relative" ng-if="!vm.loadingDashboards"><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png"></div></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height: 20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.description}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)" ng-if="vm.showStartEndDate(dashboard)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="time-period row" ng-click="vm.openReportDashboardDayModal($index)" ng-if="!vm.showStartEndDate(dashboard)">{{dashboard.report_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div></div>');
$templateCache.put('app/pages/claw_health/daySelector.modal.html','<div><div class="modal-header" ng-if="!vm.setDateModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setDateModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_dashboard_name_parameter_date_">Date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setActualReportDate()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/claw_health/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/claw_health/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/claw_health/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/claw_health/warning.modal.html','<div><div class="modal-body" style="height: 120px"><div><span><data-i18n i18n="_message_warning_claw_health_">Please be aware that herds with incorect address will not be visible in the map. Please set correct address for herds.</data-i18n></span></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.closeModal()">OK</button> <button class="btn btn-xs btn-primary pull-right" ng-click="vm.redirectToHerds()" style="margin-right: 10px;"><data-i18n i18n="_button_update_herd_">Update herd</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/calendar/calendar.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12" ng-if="!vm.error"><div ba-panel="" ba-panel-class="xmedium-panel no-bottom-margin" ng-class="vm.showCreatePdfBlock || vm.showEditBlock? \'create-pdf\': \'\'" style="margin-bottom: 0px"><dashboard-calendar></dashboard-calendar></div><div ba-panel="" ng-if="!vm.showEditBlock && !vm.showCreatePdfBlock"><div class="calendar-legend"><div ng-repeat="herd in vm.herdsList" class="item"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': herd.color}"></div><div style="display: inline-block">{{herd.Name}}</div></div></div></div></div><div ng-if="vm.error" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/calendar/calendar.panel.html','<div id="calendar" class="blurCalendar" ng-if="!vm.loadingEvents && vm.selectedTeam && !vm.showCreatePdfBlock && !vm.showEditBlock"></div><div ng-if="vm.loadingEvents && vm.selectedTeam"><div class="loading-animation"></div></div><div ng-if="vm.showCreatePdfBlock && !vm.showEditBlock"><div style="text-align: right"><button class="btn btn-primary btn-sm" ng-click="vm.openExportModal()"><data-i18n i18n="_label_export_pdf_">Export pdf</data-i18n></button> <button class="btn btn-danger btn-sm" ng-click="vm.hideCreatePdfBlock()"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div><div ng-repeat="event in vm.eventsForPdf" class="events-preview"><div><div class="event-info" style="margin-left: 0px">{{event.Title}}</div></div><div><div class="image-holder" ng-if="event.Pictures && event.Pictures.length>0"><img ng-src="{{event.Pictures[0].ThumbnailUrl}}"></div><div class="general-info"><div style="font-weight: bold"><span>{{event.StartDate | date: \'shortDate\'}}</span><span style="margin-right: 2px; margin-left: 2px;">&mdash;</span><span>{{event.EndDate | date: \'shortDate\'}}</span></div><div ng-if="event.Recurring && event.Recurring > 0"><span><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n>:</span><div class="event-info"><data-i18n i18n="{{event.ReccuringString}}"></data-i18n></div></div><div ng-if="event.Recurring && event.Recurring > 0"><span><data-i18n i18n="_calendar_repeat_interval_">Repeat Interval</data-i18n>:</span><div class="event-info">{{event.RecurringInterval}}</div></div><div ng-if="event.RecurringEndDate"><span><data-i18n i18n="_calendar_repeat_end_">Repeat End</data-i18n>:</span><div class="event-info">{{event.RecurringEndDate | date: \'shortDate\'}}</div></div><div><data-i18n i18n="_label_herd_"></data-i18n>:<div class="event-info">{{event.HerdName}}</div></div></div></div><div ng-if="event.Description"><data-i18n i18n="_calendar_event_description_"></data-i18n>:<div class="event-info">{{event.Description}}</div></div><div><data-i18n i18n="_dc_comments_">Comments</data-i18n>:</div><div><input type="text" class="form-control" ng-model="event.Comment" maxlength="1023"></div></div></div><div ng-if="vm.showEditBlock"><div style="height: 30px;"><button class="btn btn-danger btn-sm" style="float: right"><data-i18n i18n="_label_cancel_" ng-click="vm.closeEditBlock()">Cancel</data-i18n></button></div><div style="margin-top: 10px"><div><input type="text" class="form-control" placeholder="Add title" ng-model="vm.selected_event.Title" maxlength="1023"> <textarea class="form-control" ng-model="vm.selected_event.Description" placeholder="Add description" style="resize: none; width: 100%; margin-top: 10px"></textarea></div><div ng-if="vm.hidePicturesButton"><div class="event-picture" ng-if="vm.selected_event.Pictures.length>0"><div ng-if="vm.selected_event.Pictures && vm.selected_event.Pictures.length>0" class="animal-reproduction" style="text-align: center; padding-left: 0px"><div class="reproduction-thumbnail" ng-class="vm.selected_event.Pictures[0].Importance == 1 ? \'importance-1\' : (vm.selected_event.Pictures[0].Importance == 2 ? \'importance-2\' : (vm.selected_event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)" style="position: relative"><div class="animal-remove-icon" ng-click="vm.removePicture()"><i class="ion-ios-close-outline"></i></div><img src="assets/img/logo.png" lazy-img="{{vm.selected_event.Pictures[0].ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="!vm.selected_event.Pictures[0].hideImage" ng-style="vm.selected_event.Pictures[0].FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div></div></div></div><div style="padding-top: 5px; padding-bottom: 5px" ng-if="!vm.hidePicturesButton"><button class="btn btn-primary btn-sm" ng-click="vm.showAddPictureBlock = true;"><data-i18n i18n="_label_add_picture_">Add picture</data-i18n></button></div><div ng-if="vm.showAddPictureBlock"><div class="upload-file-block"><div ng-if="!vm.fileName"><i class="ion-ios-cloud-upload"></i></div><div ng-if="!vm.fileName"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.fileName"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div><div style="height: 166px; overflow-x: auto; white-space: nowrap" lazy-img-container="" ng-if="vm.showPictures"><div class="calendar-pictures-navigation" ng-if="vm.showLoadLeft && !vm.loadingPictures"><div ng-click="vm.loadLeft()"><span><i class="ion-chevron-left"></i></span><span><i class="ion-chevron-left"></i></span></div></div><div ng-repeat="picture in vm.pictures" style="display: inline" ng-if="!vm.loadingPictures"><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectPicture(picture)" style="margin-top:0px"><img src="assets/img/logo.png" lazy-img="{{picture.ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="picture.ThumbnailUrl && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!picture.ThumbnailUrl || vm.hideImage"></div></div></div><div class="calendar-pictures-navigation" ng-if="vm.showLoadRight && !vm.loadingPictures"><div ng-click="vm.loadRight()"><span><i class="ion-chevron-right"></i></span><span><i class="ion-chevron-right"></i></span></div></div><div ng-if="vm.loadingPictures" style="text-align: center"><div class="loading-animation"></div></div></div></div><div class="calendar-date-time-picker"><div class="date-time-picker-cell time-icon"><i class="ion-ios-clock-outline"></i></div><div class="date-time-picker-cell time-holder" ng-class="!vm.showTime ? \'show-button\' : \'\'"><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.StartDate" is-open="vm.showStartPicker" show-button-bar="false" ng-click="vm.showStartPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><ui-select ng-model="vm.selected_event.startTime" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.date_string}}</ui-select-match><ui-select-choices repeat="time in vm.times">{{time.date_string}}</ui-select-choices></ui-select></div><div class="time-holder-cell dash-cell">-</div><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.EndDate" is-open="vm.showEndPicker" show-button-bar="false" ng-click="vm.showEndPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><ui-select ng-model="vm.selected_event.endTime" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.date_string}}</ui-select-match><ui-select-choices repeat="time in vm.times">{{time.date_string}}</ui-select-choices></ui-select></div></div><div ng-if="!vm.showTime" class="date-time-picker-cell" style="float: right"><button class="btn btn-sm btn-primary" ng-click="vm.showTimePickers()"><data-i18n i18n="_calendar_show_time_">Show Time</data-i18n></button></div></div><div><div class="row" style="padding: 15px;"><button class="btn btn-sm btn-primary" ng-click="vm.showRepeatBlock()"><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n></button></div></div><div class="repeat-event-block" ng-if="vm.showRepeat"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_">Repeat</data-i18n>:</div><div class="repeat-selector"><ui-select ng-model="vm.selected_event.RecurringObject" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.label | i18n}}</ui-select-match><ui-select-choices repeat="repeat in vm.repeatList">{{repeat.label | i18n}}</ui-select-choices></ui-select></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.selected_event.RecurringObject.value" style="margin-top: 10px; padding-bottom: 0px"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:</div><div class="repeat-selector"><input type="number" step="1" class="input-group" style="height: 36px;" min="0" ng-model="vm.selected_event.RecurringInterval"></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.selected_event.RecurringObject.value"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>:</div><div class="repeat-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.selected_event.RecurringEndDate" is-open="vm.showEndRepeat" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showEndRepeat = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div><button type="button" class="btn btn-success" ng-click="vm.updateEvent()" ng-disabled="!vm.selected_event.Title || vm.selected_event.Title.lenght<=0" style="float: right"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div></div><div class="row" ng-if="!vm.selectedTeam"><div><span><data-i18n i18n="_message_error_default_team_not_defined_">Default team not defined</data-i18n></span></div></div>');
$templateCache.put('app/pages/calendar/description.modal.html','<div class="modal-content calendar-description"><div class="modal-header" style="padding: 10px" ng-style="{\'background-color\': \'{{vm.selected_event.color}}\'}"><div class="header-buttons"><i class="fa fa-pencil-square-o calendar-description-header-button" ng-click="vm.editEvent()"></i> <i class="fa fa-times calendar-description-header-button" ng-click="$dismiss()"></i></div><div class="event-title">{{vm.selected_event.Title}}</div></div><div class="modal-body" style="padding-top: 10px;"><div><div class="event-picture" ng-if="vm.selected_event.Pictures.length>0"><div ng-if="vm.selected_event.Pictures && vm.selected_event.Pictures.length>0" class="animal-reproduction" style="text-align: center"><div class="reproduction-thumbnail" ng-class="vm.selected_event.Pictures[0].Importance == 1 ? \'importance-1\' : (vm.selected_event.Pictures[0].Importance == 2 ? \'importance-2\' : (vm.selected_event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)"><img src="assets/img/logo.png" lazy-img="{{vm.selected_event.Pictures[0].ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="!vm.selected_event.Pictures[0].hideImage" ng-style="vm.selected_event.Pictures[0].FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div></div></div><div class="event-details"><div><span><i class="fa fa-clock-o" style="margin-right: 5px;"></i>{{vm.selected_event.startDate }} - {{vm.selected_event.endDate }}</span></div><div ng-if="vm.selected_event.Recurring"><span><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n>:<data-i18n i18n="{{vm.selected_event.ReccuringString}}" style="margin-left: 5px"></data-i18n></span></div><div ng-if="vm.selected_event.Recurring && vm.selected_event.RecurringInterval"><span><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:<span style="margin-left: 5px">{{vm.selected_event.RecurringInterval}}</span></span></div><div ng-if="vm.selected_event.Recurring && vm.selected_event.RecurringEndDate"><span><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>: <span style="margin-left: 5px">{{vm.selected_event.RecurringEndDate | date:\'shortDate\'}}</span></span></div></div></div><div class="event-description">{{vm.selected_event.Description}}</div></div></div>');
$templateCache.put('app/pages/calendar/exportPdf.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.exportForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_file_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_file_name_\' | i18n}}" ng-model="vm.file_name" required=""></div><span style="margin-top: -15px; font-size: 12px;" class="help-block basic-block color-red" ng-if="vm.file_name.length > 250"><data-i18n i18n="_message_error_file_name_too_long">File name too long</data-i18n></span><div class="form-group"><label for="name"><data-i18n i18n="_label_file_header_">File header</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_file_header_\' | i18n}}" ng-model="vm.file_header" required=""></div></form><div ng-if="vm.showNewDiscussionBlock"><div class="event-herd-selector" ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true" placeholder="Select herd"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block">{{$select.selected.Name}}</div></ui-select-match><ui-select-choices repeat="herd in vm.herdsList"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': herd.color}"></div><div style="display: inline-block">{{herd.Name}}</div></ui-select-choices></ui-select></div><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.pdfError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion && !vm.loadingModal"><button type="button" class="btn btn-info" ng-click="vm.showNewDiscussion()" ng-if="!vm.showNewDiscussionBlock" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250"><data-i18n i18n="_label_export_pdf_discussion_">export and create discussion</data-i18n></button> <button type="button" class="btn btn-info" ng-click="vm.exportPdf()" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="!vm.showNewDiscussionBlock"><data-i18n i18n="_label_export_pdf_">export to pdf</data-i18n></button> <button type="button" class="btn btn-info" ng-click="vm.exportPdf(true)" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250 || !vm.selectedHerd" ng-if="vm.showNewDiscussionBlock"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/calendar/newEvent.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><div ng-if="vm.showEventPicker"><button type="button" class="btn btn-sm btn-primary" style="margin-right: 10px;" ng-click="vm.showNewEventBlock = true;" ng-if="!vm.showNewEventBlock">Create new event</button> <button type="button" class="btn btn-sm btn-primary" ng-if="!vm.showNewEventBlock" ng-click="vm.openCreatePdf()">Create PDF</button></div></div><div class="modal-body" ng-if="!vm.loadingAddNewEvent && vm.showNewEventBlock"><div class="event-herd-selector" ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" theme="selectize" class="select-tags" style="height:20px" ng-change="vm.herdSelectedChanged()"><ui-select-match allow-clear="true" placeholder="Select herd"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block">{{$select.selected.Name}}</div></ui-select-match><ui-select-choices repeat="herd in vm.herdsList"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': herd.color}"></div><div style="display: inline-block">{{herd.Name}}</div></ui-select-choices></ui-select></div><div><input type="text" class="form-control" placeholder="Add title" ng-model="vm.newEvent.title" maxlength="1023"> <textarea class="form-control" ng-model="vm.newEvent.description" placeholder="Add description" style="resize: none; width: 100%; margin-top: 10px"></textarea></div><div style="padding-top: 5px; padding-bottom: 5px"><button class="btn btn-primary btn-sm" ng-click="vm.showAddPictureBlock = true;"><data-i18n i18n="_label_add_picture_">Add picture</data-i18n></button></div><div ng-if="vm.showAddPictureBlock"><div class="upload-file-block"><div ng-if="!vm.fileName"><i class="ion-ios-cloud-upload"></i></div><div ng-if="!vm.fileName"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.fileName"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div><div style="height: 166px; overflow-x: auto; white-space: nowrap" lazy-img-container="" ng-if="vm.showPictures"><div class="calendar-pictures-navigation" ng-if="vm.showLoadLeft && !vm.loadingPictures"><div ng-click="vm.loadLeft()"><span><i class="ion-chevron-left"></i></span><span><i class="ion-chevron-left"></i></span></div></div><div ng-repeat="picture in vm.pictures" style="display: inline" ng-if="!vm.loadingPictures"><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectPicture(picture)" style="margin-top:0px"><img src="assets/img/logo.png" lazy-img="{{picture.ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="picture.ThumbnailUrl && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!picture.ThumbnailUrl || vm.hideImage"></div></div></div><div class="calendar-pictures-navigation" ng-if="vm.showLoadRight && !vm.loadingPictures"><div ng-click="vm.loadRight()"><span><i class="ion-chevron-right"></i></span><span><i class="ion-chevron-right"></i></span></div></div><div ng-if="vm.loadingPictures" style="text-align: center"><div class="loading-animation"></div></div></div></div><div class="calendar-date-time-picker"><div class="date-time-picker-cell time-icon"><i class="ion-ios-clock-outline"></i></div><div class="date-time-picker-cell time-holder" ng-class="!vm.showTime ? \'show-button\' : \'\'"><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.startDate" is-open="vm.showStartPicker" show-button-bar="false" ng-click="vm.showStartPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><ui-select ng-model="vm.newEvent.startTime" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.date_string}}</ui-select-match><ui-select-choices repeat="time in vm.times">{{time.date_string}}</ui-select-choices></ui-select></div><div class="time-holder-cell dash-cell">-</div><div class="time-holder-cell" ng-class="!vm.showTime ? \'hide-time\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.endDate" is-open="vm.showEndPicker" show-button-bar="false" ng-click="vm.showEndPicker = true"></div><div class="time-holder-cell input-group" ng-if="vm.showTime"><ui-select ng-model="vm.newEvent.endTime" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.date_string}}</ui-select-match><ui-select-choices repeat="time in vm.times">{{time.date_string}}</ui-select-choices></ui-select></div></div><div ng-if="!vm.showTime" class="date-time-picker-cell" style="float: right"><button class="btn btn-sm btn-primary" ng-click="vm.showTimePickers()"><data-i18n i18n="_calendar_show_time_">Show Time</data-i18n></button></div></div><div><div class="row" style="padding: 15px;"><button class="btn btn-sm btn-primary" ng-click="vm.showRepeatBlock()"><data-i18n i18n="_calendar_repeat_event_">Repeat event</data-i18n></button></div></div><div class="repeat-event-block" ng-if="vm.showRepeat"><div class="repeat-label"><data-i18n i18n="_calendar_repeat_">Repeat</data-i18n>:</div><div class="repeat-selector"><ui-select ng-model="vm.newEvent.repeatType" theme="selectize" class="select-tags" style="height:20px"><ui-select-match allow-clear="true">{{$select.selected.label | i18n}}</ui-select-match><ui-select-choices repeat="repeat in vm.repeatList">{{repeat.label | i18n}}</ui-select-choices></ui-select></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.newEvent.repeatType.value" style="margin-top: 10px; padding-bottom: 0px"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_interval_">Repeat interval</data-i18n>:</div><div class="repeat-selector"><input type="number" step="1" class="input-group" style="height: 36px;" min="0" ng-model="vm.newEvent.repeatInterval"></div></div><div class="repeat-event-block" ng-if="vm.showRepeat && vm.newEvent.repeatType.value"><div class="repeat-label" style="vertical-align: baseline"><data-i18n i18n="_calendar_repeat_end_">Repeat end</data-i18n>:</div><div class="repeat-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.newEvent.endRepeat" is-open="vm.showEndRepeat" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showEndRepeat = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.addNewEvent()" ng-disabled="!vm.newEvent.title || vm.newEvent.title.lenght == 0 || !vm.selectedHerd"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div><div class="modal-body" ng-if="vm.loadingAddNewEvent" style="text-align: center"><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/cockpit/addNewDiscussion.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><div ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required="" name="feed_type"><ui-select-match placeholder="{{\'_placeholder_select_herd_\'|i18n}}"><span>{{$select.selected.HerdName}}</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | filter: $select.search"><span ng-bind-html="herd.HerdName"></span></ui-select-choices></ui-select></div><div><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div><div class="upload-file-block"><div ng-if="!vm.file"><i class="ion-ios-cloud-upload"></i></div><div ng-if="!vm.file"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.file"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingNewDiscussion"><div class="loading-animation"></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><button type="button" class="btn btn-success" ng-click="vm.addNewDiscussion()" ng-disabled="vm.selectedHerds.length != 1"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/cockpit/cockpit.html','<div class="slider-container" ng-if="vm.showSlider && vm.imagesLoaded"><rzslider rz-slider-model="vm.sliderOptions.value" rz-slider-options="vm.sliderOptions.options" ng-init="vm.showDates = false" ng-mouseenter="vm.showDates = true" ng-mouseleave="vm.showDates = false" ng-class="!vm.showDates ? \'hide-dates\' : \'\'"></rzslider></div><div class="loader" ng-if="vm.loading"><div class="loading-animation"></div></div><div class="notification" ng-if="vm.showNotification"><span class="ion-arrow-up-c" ng-click="vm.moveToTop()"></span> <span ng-click="vm.moveToTop()"><data-i18n i18n="_message_new_image_available_">New images available</data-i18n></span><span class="ion-close-round close-notification" ng-click="vm.hideNotification()"></span></div><div ba-panel="" class="fixed-menu" ng-show="vm.showFixedMenu"><div class="row filter-row fixed-row"><div ng-bind-html=""></div><div class="col-20" style="text-align: center"><div class="add-comment-icon" style="float: left"><i class="material-icons" ng-click="vm.openNewDiscussionModal()">message</i></div><div class="set-range-icon" style="float: none"><i class="material-icons" ng-click="vm.openDateRangeSelector()">date_range</i></div></div><div class="col-20" style="position: relative"><div class="input-group"><span class="input-group-addon search-options-button" style="padding: 5px 7px; font-size:20px" ng-click="vm.showSearchSetings = !vm.showSearchSetings"><span class="ion-search"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_animal_\'|i18n}}" ng-model="vm.animal" ng-keyup="vm.setAnimalFilterEnter($event)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.setAnimalFilter()"><span class="ion-chevron-right"></span></span><div class="reset-search-button" ng-if="vm.showResetAnimalSearchButton"><button ng-click="vm.resetAnimalSearch()">x</button></div></div><div class="search-options-box" ng-if="vm.showSearchSetings"><div><div class="filter-checkbox" ng-class="vm.searchByEarTag ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'ear_tag\')"><span><data-i18n i18n="_label_search_by_ear_tag_">Search by ear tag</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByNumber ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'number\')"><span><data-i18n i18n="_label_search_by_number_">Search by number</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByName ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'name\')"><span><data-i18n i18n="_label_search_by_name_">Search by name</data-i18n></span></div></div></div></div><div class="col-20"><div id="tagsearch" class="input-group multiple-tag-select"><span class="input-group-addon"><span class="fa fa-tags" style="padding: 1px 0px; font-size:16px"></span></span><ui-select multiple="" ng-model="vm.selectedTags" theme="selectize" class="select-tags" style="height:18px" on-remove="vm.setTagFilter()" on-select="vm.setTagFilter($item)" search-enabled="true"><ui-select-match allow-clear="true">{{$item.label}}</ui-select-match><ui-select-choices group-by="\'group\'" repeat="tag in vm.tags | filter: $select.search">{{tag.label || (\'_label_none_\' | i18n)}}</ui-select-choices></ui-select></div></div><div class="col-20"><div class="input-group"><span class="input-group-addon" style="padding: 5px 7px; font-size:20px"><span class="ion-search"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comments_\'|i18n}}" ng-model="vm.comment" ng-keyup="vm.setCommentFilterEnter($event)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.setCommentFilter()"><span class="ion-chevron-right"></span></span><div ng-if="vm.showResetCommentSearchButton" class="reset-search-button"><button ng-click="vm.resetCommentSearch()">x</button></div></div></div><div class="col-20"><div id="includepp" class="checkbox"><label><input type="checkbox" ng-model="vm.includePP" style="margin-top:1px" ng-change="vm.includePPChanged()"><data-i18n i18n="_cockpit_profile_pictures_">Profile pictures</data-i18n></label></div></div></div></div><div class="widgets" lazy-scroll="vm.loadMore()" lazy-scroll-trigger="99" exec-on-scroll-to-top="" on-top="vm.loadUp()"><div class="row"><div class="col-xs-12" ng-style="vm.showDates && {\'padding-right\': \'120px\'}"><div ba-panel="" ba-panel-class="with-scroll images-panel"><div include-with-scope="app/pages/cockpit/cockpit.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/cockpit/cockpit.image.modal.html','<div id="modal-image-slider" ng-keypress="vm.test($event)" tabindex="0"><div class="modal-content"><div class="pictureCarousel carousel lazy" data-interval="false"><div class="carousel-inner" role="listbox"><div class="loading-animation"></div><div class="item active"><img ng-if="!vm.selectedImage.hideImage && !vm.hideImage" class="img-responsive center-block importance-none" lazy-img="{{vm.selectedImage.ImageUrl}}" ng-class="vm.selectedImage.Importance == 1 ? \'importance-1\' : (vm.selectedImage.Importance == 2 ? \'importance-2\' : (vm.selectedImage.Importance == 3 ? \'importance-3\' : \'\'))" lazy-img-error="assets/img/logo.jpg" ng-style="vm.selectedImage.FileUrl && {\'min-width\': \'20px\', \'min-height\': \'20px\'}"></div></div><a class="left carousel-control" ng-click="vm.previousImage(true)" role="button" data-slide="prev" id="previousImageLink"><span class="icon-prev"></span></a> <a class="right carousel-control" ng-click="vm.nextImage(true)" role="button" data-slide="next" id="nextImageLink"><span class="icon-next"></span></a></div><div class="image-info image-tile"><span class="image-who">{{vm.selectedImage.Creator}}</span> <span class="image-when">{{vm.selectedImage.ImageCreated | date:\'short\'}}</span> <span class="image-when">{{vm.selectedImage.HerdName}}</span><hr class="mmmsep"><div class="image-legend"><div class="image-who animal-link" ng-click="vm.goToAnimal(vm.selectedImage)">{{vm.selectedImage.AnimalEarTag}}</div><div class="image-when">{{vm.selectedImage.AnimalNumberString}} <span ng-show="vm.selectedImage.AnimalNumberString && vm.selectedImage.AnimalName">-</span> {{vm.selectedImage.AnimalName}}</div></div><div class="image-comment-panel" ng-if="vm.selectedImage.TagsToShow.length>0 || vm.selectedImage.NumberComments>0 || vm.selectedImage.FileUrl"><div class="image-tags" ng-if="vm.selectedImage.TagsToShow.length>0"><span class="fa fa-tags"></span> <span ng-repeat="tag in vm.selectedImage.TagsToShow track by tag.value" class="image-tag">{{::tag.label}}</span></div><div class="image-file image-modal" ng-if="vm.selectedImage.FileUrl" style="margin-bottom: 0"><div style="display: inline-block; vertical-align: middle"><span class="ion-paperclip" style="font-size: 20px"></span></div><div style="display: inline-block; vertical-align: middle"><span><a target="_blank" ng-href="{{vm.selectedImage.FileUrl}}">{{vm.selectedImage.FileName}}</a></span></div></div><div class="image-comment image-modal" ng-repeat="comment in vm.selectedImage.Comments"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div><div class="modal-closer"><button type="button" class="rotate-button no-button" ng-if="vm.checkIsAdmin(vm.selectedImage)"><i class="material-icons image-delete" ng-click="vm.openDeleteImageModal(vm.selectedImage)">delete</i></button> <button type="button" class="rotate-button no-button"><span ng-class="vm.slideshow ? \'ion-pause\' : \'ion-play\'" class="image-slideshow" ng-click="vm.startstopSlideshow()"></span></button> <button type="button" class="rotate-button no-button"><span class="fa fa-undo image-rotator image-rotator-ccw" ng-click="vm.rotateImage(vm.selectedImage, 3, $index, true)"></span></button> <button type="button" class="rotate-button no-button"><span class="fa fa-repeat image-rotator image-rotator-cw" ng-click="vm.rotateImage(vm.selectedImage, 1, $index, true)"></span></button> <button id="action-button" type="button" class="no-button"><span class="ion-android-apps action-button" ng-click="vm.showMenuModal()"></span><ul id="modalMenu" class="image-action-menu image-action-menu-modal dropdown-menu dropdown-actions-menu" role="menu" ng-click="$event.stopPropagation()"><li id="action-priority"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.changeImportance(vm.selectedImage, 0, $index, true)" ng-class="vm.selectedImage.Importance==0 ? \'label-importance-selected\' : (!vm.selectedImage.Importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.selectedImage.Importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 1, $index, true)"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.selectedImage.Importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 2, $index, true)"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.selectedImage.Importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 3, $index, true)"><data-i18n i18n="_label_high_">High</data-i18n></span></li><li id="action-task"><span class="action-menu-label"><data-i18n i18n="_label_task_">Task</data-i18n></span> <i class="material-icons action-task text-danger" ng-if="!event.TaskCompleted" tabindex="0" ng-class="vm.selectedImage.IsTask ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(vm.selectedImage, false, false, true)">error</i> <i class="material-icons action-task text-success" tabindex="0" ng-class="vm.selectedImage.TaskCompleted ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(vm.selectedImage,true, false, true)">check_circle</i> <span class="action-task-done-by"></span></li><li ng-if="vm.selectedImage.TaskCompletedBy" style="font-size:13px"><span>{{vm.selectedImage.TaskCompletedBy}}</span></li><li id="action-comment"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.commentText" ng-keyup="vm.addCommentOnEnter($event, vm.selectedImage, $index, true)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.addComment(vm.selectedImage, false, true)"><span class="ion-chevron-right"></span></span></div></li><li id="action-tags" style="overflow:visible"><div class="input-group" style="max-width:270px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" ng-change="$event.stopPropagation()" ng-model="vm.selectedImage.TagsToShow" on-select="vm.addTag(vm.selectedImage, $item, $index)" on-remove="vm.removeTag(vm.selectedImage, $item, $index)"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li></ul></button> <button type="button" class="close" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button></div></div></div>');
$templateCache.put('app/pages/cockpit/cockpit.panel.html','<div><div class="row filter-row"><div class="col-20" style="text-align: center"><div class="add-comment-icon" style="float: left"><i class="material-icons" ng-click="vm.openNewDiscussionModal()">message</i></div><div class="set-range-icon" style="float: none"><i class="material-icons" ng-click="vm.openDateRangeSelector()">date_range</i></div></div><div class="col-20" style="position: relative"><div class="input-group"><span class="input-group-addon search-options-button" style="padding: 5px 7px; font-size: 20px" ng-click="vm.showSearchSetings = !vm.showSearchSetings"><span class="ion-search"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_animal_\'|i18n}}" ng-model="vm.animal" ng-keyup="vm.setAnimalFilterEnter($event)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.setAnimalFilter()"><span class="ion-chevron-right"></span></span><div class="reset-search-button" ng-if="vm.showResetAnimalSearchButton"><button ng-click="vm.resetAnimalSearch()">x</button></div></div><div class="search-options-box" ng-if="vm.showSearchSetings"><div><div class="filter-checkbox" ng-class="vm.searchByEarTag ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'ear_tag\')"><span><data-i18n i18n="_label_search_by_ear_tag_">Search by ear tag</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByNumber ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'number\')"><span><data-i18n i18n="_label_search_by_number_">Search by number</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByName ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'name\')"><span><data-i18n i18n="_label_search_by_name_">Search by name</data-i18n></span></div></div></div></div><div class="col-20"><div id="tagsearch" class="input-group multiple-tag-select"><span class="input-group-addon"><span class="fa fa-tags" style="padding: 1px 0px; font-size:16px"></span></span><ui-select multiple="" ng-model="vm.selectedTags" theme="selectize" class="select-tags" style="height:18px" on-remove="vm.setTagFilter()" on-select="vm.setTagFilter($item)" search-enabled="true"><ui-select-match allow-clear="true">{{$item.label}}</ui-select-match><ui-select-choices group-by="\'group\'" repeat="tag in vm.tags | filter: $select.search">{{tag.label || (\'_label_none_\' | i18n)}}</ui-select-choices></ui-select></div></div><div class="col-20"><div class="input-group"><span class="input-group-addon" style="padding: 5px 7px; font-size: 20px"><span class="ion-search"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comments_\'|i18n}}" ng-model="vm.comment" ng-keyup="vm.setCommentFilterEnter($event)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.setCommentFilter()"><span class="ion-chevron-right"></span></span><div ng-if="vm.showResetCommentSearchButton" class="reset-search-button"><button ng-click="vm.resetCommentSearch()">x</button></div></div></div><div class="col-20"><div id="includepp" class="checkbox"><label><input type="checkbox" ng-model="vm.includePP" style="margin-top: 1px" ng-change="vm.includePPChanged()"><data-i18n i18n="_cockpit_profile_pictures_">Profile pictures</data-i18n></label></div></div></div><div ng-repeat="image in vm.images | unique: \'Id\' track by image.Id" class="image-wrapper" ng-class="image.highlighted ? \'highlight\' : \'\'" id="image{{image.Id}}"><div class="image-info"><span class="image-who">{{::image.Creator}}</span> <span class="image-when">{{::image.ImageCreated | date:\'short\'}}</span> <span class="image-when">{{::image.HerdName}}</span><div style="height: 20px; position: relative"><span class="fa fa-undo image-rotator image-rotator-ccw" ng-click="vm.rotateImage(image, 3, $index, false)"></span> <span class="fa fa-repeat image-rotator" ng-click="vm.rotateImage(image, 1, $index, false)"></span> <span class="ion-android-apps action-button" ng-click="vm.showMenu(image.Id, $index)"></span></div><div><ul id="{{image.Id}}" class="image-action-menu dropdown-menu dropdown-actions-menu" role="menu" ng-click="$event.stopPropagation()"><li id="action-priority" ng-if="image.showMenu"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.changeImportance(image, 0, $index, false)" ng-class="image.Importance==0 ? \'label-importance-selected\' : (!image.Importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="image.Importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 1, $index, false)"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="image.Importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 2, $index, false)"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="image.Importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 3, $index, false)"><data-i18n i18n="_label_high_">High</data-i18n></span></li><li id="action-task"><span class="action-menu-label"><data-i18n i18n="_label_task_">Task</data-i18n></span> <i class="material-icons action-task text-danger" ng-if="!event.TaskCompleted" tabindex="0" ng-class="image.IsTask ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(image, false, $index, false)">error</i> <i class="material-icons action-task text-success" tabindex="0" ng-class="image.TaskCompleted ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(image, true, $index, false)">check_circle</i> <span class="action-task-done-by"></span></li><li ng-if="image.TaskCompletedBy" style="font-size: 13px"><span>{{image.TaskCompletedBy}}</span></li><li id="action-comment"><div class="input-group" style="max-width: 310px"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.commentText" ng-keyup="vm.addCommentOnEnter($event, image, $index, false)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.addComment(image, $index, false)"><span class="ion-chevron-right"></span></span></div></li><li id="action-tags" style="overflow: visible"><div class="input-group" style="max-width: 270px"><span class="input-group-addon"><span style="padding: 0px 0px; font-size: 18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="image.TagsToShow" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px" on-select="vm.addTag(image, $item, $index)" on-remove="vm.removeTag(image, $item, $index)"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li></ul></div></div><div style="margin-top: 0" class="image-canvas" ng-class="image.Importance == 1 ? \'importance-1\' : (image.Importance == 2 ? \'importance-2\' : (image.Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)"><img src="assets/img/logo.png" lazy-img="{{image.ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="!image.hideImage" ng-style="image.FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div><div class="image-task-details" ng-if="image.IsTask"><i class="material-icons is-task-icon" ng-if="!image.TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="image.TaskCompleted">check_circle</i></div><div class="image-legend"><div class="image-who animal-link" ng-click="vm.goToAnimal(image)">{{::image.AnimalEarTag}}</div><div class="image-when">{{::image.AnimalNumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::image.AnimalName}}</div></div><div class="image-comment-panel" ng-if="image.TagsToShow.length>0 || image.NumberComments > 0 || image.FileUrl"><div class="image-tags" ng-if="image.TagsToShow.length>0"><span class="fa fa-tags"></span> <span ng-repeat="tag in image.TagsToShow track by tag.value" class="image-tag">{{::tag.label}}</span></div><div class="image-file" ng-if="image.FileUrl"><span class="ion-paperclip" style="font-size: 20px"></span> <span><a target="_blank" ng-href="{{image.FileUrl}}">{{image.FileName}}</a></span></div><div class="image-comment" ng-repeat="comment in image.Comments track by comment.Id"><span class="image-who" style="padding-top: 4px">{{::comment.CommentedBy}}</span> <span class="image-when">{{::comment.CommentTimeStamp | date:\'short\'}}</span> <span class="comment-text">{{::comment.Message}}</span></div></div></div></div>');
$templateCache.put('app/pages/cockpit/dateRange.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_start" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_end" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()" style="margin-left:5px;"><data-i18n i18n="_label_apply_">apply</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.closeModal()" style="margin-left:5px;"><data-i18n i18n="_label_cancel_">cancel</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.resetRange()" style="margin-left:5px;" ng-if="vm.use_date_range"><data-i18n i18n="_label_reset_">reset</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/cockpit/delete.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" style="padding-top: 0px;" ng-if="!vm.modalLoading"><span><data-i18n i18n="_label_delete_picture_question_">Are you sure you want to delete this picture?</data-i18n></span></div><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-danger" ng-click="vm.deleteImage()"><data-i18n i18n="_label_yes_">yes</data-i18n></button> <button type="button" class="btn btn-success" ng-click="$dismiss()"><data-i18n i18n="_label_cancel_">cancel</data-i18n></button></div><div class="modal-body" style="text-align: center" ng-if="vm.modalLoading"><dev class="loading-animation"></dev></div><div class="modal-body color-red" ng-if="!vm.modalLoading && vm.deleteError"><span>{{vm.deleteError.data.Message}}</span></div></div>');
$templateCache.put('app/pages/common/reportBlock.html','<div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><div><div class="filter-checkbox" ng-class="vm.include_p_points ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.include_p_points = !vm.include_p_points" style="display: inline-block"></div><label style="display: inline-block; vertical-align: middle; margin-left: 5px;"><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label></div><textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" ng-disabled="!vm.include_p_points"></textarea></div><div class="form-group"><div><div class="filter-checkbox" ng-class="vm.include_i_points ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.include_i_points = !vm.include_i_points" style="display: inline-block"></div><label style="display: inline-block; vertical-align: middle; margin-left: 5px;"><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label></div><textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" ng-disabled="!vm.include_i_points"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div>');
$templateCache.put('app/pages/common/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/common/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportModalStartDate" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportModalEndDate" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/conceptionCusumAnalysis/conceptionCusumAnalysis.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/conceptionCusumAnalysisHeifers/conceptionCusumAnalysisHeifers.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/conceptionRateCows/conceptionRateCows.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/conceptionRateCows/conceptionRateCows.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/conceptionRateCows/conceptionRateCows.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/conceptionRateCows/conceptionRateCows.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/conceptionRateCows/conceptionRateCows.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/conceptionStrategyHeifers/conceptionStrategyHeifers.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/DQ/dq.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/DQ/dq.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/DQ/dq.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/DQ/dq.panel.html','<div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError"><div include-with-scope="app/pages/DQ/dq.tiles.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame" class="dashboards-frame"><div style="text-align: right; padding: 5px 10px; height: 30px" ng-if="vm.showDatePeriod()"><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper-dq" ng-if="!vm.errorLoading"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/DQ/dq.tiles.html','<div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div></div><div ba-panel="" ba-panel-class="with-scroll" style="height: auto" ng-if="!vm.dashboardsSafe.length"><data-i18n i18n="_message_no_available_dashboards_">There is no available dashboards for selected team</data-i18n></div>');
$templateCache.put('app/pages/DQ/dq2.html','<div class="row" ng-if="vm.selectedTeam"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height: auto" id="panel-map"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.errorLoading"><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableRangeSelector ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div id="rapFrame" class="dashboard-wrapper-rap" ng-if="!vm.loadingDashboards && !vm.errorLoading"></div></div></div></div></div></div><div class="row" ng-if="!vm.selectedTeam"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll">Select team</div></div></div>');
$templateCache.put('app/pages/greeting/greeting.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="dashboard-wrapper-rap greeting"><div class="row"><div class="col-xs-4"></div><div class="col-xs-4"><div class="logo"><img src="assets/img/MmmooOgle_logo_baseline.svg"></div></div><div class="col-xs-4"></div></div><div class="row" style="padding-top: 40vh;"><div class="col-xs-4"></div><div class="col-xs-4"><div class="logo"><div><span><data-i18n i18n="_text_greeting_message_">Your account will be activated within 24 hours. In case of questions/problems, please contact</data-i18n></span>&nbsp;<span><a href="mailto:kristienneyens@mmmooogle.com">kristienneyens@mmmooogle.com</a></span></div></div></div><div class="col-xs-4"></div></div></div></div></div></div>');
$templateCache.put('app/pages/herdOverview/herdOverview.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/importAnimals/dateFormatConfiguration.html','<div class="date-format-config"><h3 class="with-line" style="padding-top: 0"><data-i18n i18n="_label_date_">Date</data-i18n></h3><div><div class="text-block"><data-i18n i18n="_date_format_info_p1_">Date can be separated into three segments, each segment represents a day, month or year. Segments are separated using date separator.</data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p2_">Let\'s use 23-10-2021 as an eample</data-i18n>:</div><table class="table example-table"><tbody><tr><td colspan="4" class="date-header"><span>23</span><span>-</span><span>10</span><span>-</span><span>2021</span></td></tr><tr><td><data-i18n i18n="_date_format_date_segment_">Date segment</data-i18n>1</td><td><data-i18n i18n="_date_format_date_segment_">Date segment</data-i18n>2</td><td><data-i18n i18n="_date_format_date_segment_">Date segment</data-i18n>3</td><td><data-i18n i18n="_date_format_date_separator_">Date separator</data-i18n></td></tr><tr><td>23</td><td>10</td><td>2021</td><td>-</td></tr><tr><td><data-i18n i18n="_label_day_">Day</data-i18n></td><td><data-i18n i18n="_label_month_">Month</data-i18n></td><td><data-i18n i18n="_label_year_">Year</data-i18n></td><td></td></tr></tbody></table><div class="text-block"><data-i18n i18n="_date_format_info_p3_">In the table we can see how a date can be separated into segments, also we can see what each of the segments represents.</data-i18n></div></div><h3 class="with-line" style="padding-top: 0"><data-i18n i18n="_date_format_format_configurator_">Format configurator</data-i18n></h3><div><div class="text-block"><data-i18n i18n="_date_format_info_p4_">The goal here is to try to describe date format by defining date segments and what each of them represents. If the date format is correctly described we will be able to read the date.</data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p5_">You will see that we have two different formats for day, month and year.</data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p6_">One digit day and month values can be formatted using one digit or two digits, for example 1st day of the month can be formated as 1 and as 01, also January can be formated as 1 and as 01, it is important to select correct format so date can be read correctly.</data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p7_">Year can also be formatted in two ways, 2021 can also be formated as 21.</data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p8_"></data-i18n></div><div class="text-block"><data-i18n i18n="_date_format_info_p9_">Use our configurator and try to define the correct date format. Resulting date format and non-standard date formats should be the same.</data-i18n></div><table class="table" style="margin-top: 10px"><tbody><tr><td class="align-right"><data-i18n i18n="_label_non_standard_date_format_">Non standard date format</data-i18n></td><td class="align-left">{{vm.config.invalidDate}}</td></tr><tr><td class="align-right color-red" <data-i18n="" i18n="_date_format_date_segment_">Date segment 1</td><td class="align-left"><a href="#" editable-select="vm.config.segmentOne" e-ng-options="segment as segment.name for segment in vm.dateSegments" onaftersave="vm.dateFormatSegmentChanged(vm.currentDateType)">{{vm.config.segmentOne.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td class="align-right color-green"><data-i18n i18n="_date_format_date_segment_">Date segment</data-i18n>2</td><td class="align-left"><a href="#" editable-select="vm.config.segmentTwo" e-ng-options="segment as segment.name for segment in vm.dateSegments" onaftersave="vm.dateFormatSegmentChanged()">{{vm.config.segmentTwo.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td class="align-right color-blue"><data-i18n i18n="_date_format_date_segment_">Date segment</data-i18n>3</td><td class="align-left"><a href="#" editable-select="vm.config.segmentThree" e-ng-options="segment as segment.name for segment in vm.dateSegments" onaftersave="vm.dateFormatSegmentChanged()">{{vm.config.segmentThree.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td rowspan="5" class="align-right color-orange"><data-i18n i18n="_label_separator_">Separator</data-i18n></td><td class="align-left"><div class="format-checkbox" ng-class="vm.config.d1 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDelimiter(\'d1\')"><span>"."</span></div></td></tr><tr><td class="align-left" style="border-top: none"><div class="format-checkbox" ng-class="vm.config.d2 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDelimiter(\'d2\')"><span>"-"</span></div></td></tr><tr><td class="align-left" style="border-top: none"><div class="format-checkbox" ng-class="vm.config.d3 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDelimiter(\'d3\')"><span>"/"</span></div></td></tr><tr><td class="align-left" style="border-top: none"><div class="format-checkbox" ng-class="vm.config.d4 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDelimiter(\'d4\')"><span>"(space)"</span></div></td></tr><tr><td class="align-left" style="border-top: none"><div class="format-checkbox inline" ng-class="vm.config.d5 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDelimiter(\'d5\')"></div><div class="inline"><span editable-text="vm.config.customDateDelimiter" blur="cancel" e-maxlength="1" onaftersave="vm.createDateDilimiter()" ng-click="$event.stopPropagation();">{{vm.config.customDateDelimiter || (\'_label_separator_custom_\' | i18n)}}</span></div></td></tr><tr><td class="align-right"><data-i18n i18n="_label_resulting_date_format_">Resulting date format</data-i18n></td><td class="align-left"><span class="color-red">{{vm.config.segmentOne.date}}</span><span class="color-orange">{{vm.config.dateDelimiter}}</span><span class="color-green">{{vm.config.segmentTwo.date}}</span><span class="color-orange">{{vm.config.dateDelimiter}}</span><span class="color-blue">{{vm.config.segmentThree.date}}</span></td></tr></tbody></table></div><h3 class="with-line" style="padding-top: 0"><data-i18n i18n="_date_format_date_reading_">Date reading</data-i18n></h3><div><div class="text-block"><data-i18n i18n="_date_format_info_p10_">If you think that configuration was done correctly you can try to read the date. If the resulting date is the correct representation of the non-standard date, configuration and reading were done correctly.</data-i18n></div><table class="table" style="margin-top: 10px"><tbody><tr><td class="align-right" colspan="2" style="width: 50%"><data-i18n i18n="_label_non_standard_date_format_">Non standard date format</data-i18n></td><td class="align-left" style="width: 50%">{{vm.config.invalidDate}}</td></tr><tr style="height: 40px"><td class="align-left" style="width: 25%"><button class="btn btn-primary pull-right" ng-click="vm.parseInvalidDate()" ng-disabled="(!vm.config.segmentOne || !vm.config.segmentTwo || !vm.config.segmentThree) || (!vm.config.d1 && !vm.config.d2 && !vm.config.d3 && !vm.config.d4 && !vm.config.d5)" style="margin-top: 5px;"><data-i18n i18n="_label_read_">Read</data-i18n></button></td><td class="align-right" style="width: 25%; padding-top: 5px;"><data-i18n i18n="_label_resulting_date_">Resulting date</data-i18n></td><td class="align-left" style="width: 50%; padding-top: 5px;">{{vm.config.resultingDate | date: \'mediumDate\'}}</td></tr></tbody></table></div><h3 class="with-line" style="padding-top: 0"><data-i18n i18n="_date_format_reading_result_">Reading result</data-i18n></h3><div class="text-block" ng-if="!vm.disableCustomButton && vm.readingDone"><data-i18n i18n="_date_format_info_p11_">Reading was successfully done, if the resulting date is correct, you can choose to use defined format to read dates.</data-i18n></div><div class="text-block" ng-if="vm.disableCustomButton && vm.readingDone"><data-i18n i18n="_date_format_info_p12_">Reading was not successfully done, please try to configure date format again.</data-i18n></div><div style="margin-bottom: 20px;height: 35px;"><button class="btn btn-danger pull-right" ng-click="vm.closeDateConfig()" style="margin-left: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button> <button class="btn btn-success pull-right" ng-click="vm.parseDatesUsingCustomFilter(vm.currentDateType)" ng-disabled="vm.disableCustomButton"><data-i18n i18n="_label_use_">Use</data-i18n></button></div></div>');
$templateCache.put('app/pages/importAnimals/dateInfo.modal.html','<div class="date-format-modal"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div style="margin-bottom: 10px;"><date-i18n i18n="_date_format_date_info_">To be sure that date reading was done correctly you can compare source date and result date. If there are any differences you can try to manually configure source date format.</date-i18n></div><div style="margin-bottom: 10px; height: 35px"><button class="btn btn-primary pull-right" ng-click="vm.openDateFormatConfigurationPage( vm.currentDateType, true)"><data-i18n i18n="_label_configure_">Configure</data-i18n></button></div><div style="max-height: 500px; overflow-y: auto"><table class="table"><tbody><tr><td><data-i18n i18n="_source_date_label_">Source date</data-i18n></td><td><data-i18n i18n="_result_date_label_">Result date</data-i18n></td></tr><tr ng-repeat="animal in vm.modalAnimals"><td>{{vm.currentDateType == "date" ? animal[vm.date.name] : animal[vm.birthDate.name]}}</td><td>{{vm.currentDateType == "date" ? animal.importDate : animal.importDateBirth}}</td></tr></tbody></table><div style="padding: 20px; text-align: center" ng-if="vm.modalShowLoadMore"><button class="btn btn-primary" ng-click="vm.modalLoadMore()"><data-i18n i18n="_label_load_more_">Load more</data-i18n></button></div></div></div></div>');
$templateCache.put('app/pages/importAnimals/failedPreviewPage.html','<div><div class="table-wrapper"><table class="table"><thead><tr><th><data-i18n i18n="_animal_ear_tag_">Ear Tag</data-i18n></th><th><data-i18n i18n="_animal_name_">Name</data-i18n></th><th><data-i18n i18n="_animal_number_">Number</data-i18n></th><th><data-i18n i18n="_animal_details_lactation_">Lactation</data-i18n></th><th><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n></th><th><data-i18n i18n="_animal_date_of_birth_">Birth date</data-i18n></th><th></th></tr></thead><tbody><tr ng-repeat="animal in vm.results.failedAnimals"><td>{{animal.Animal.EarTag}}</td><td>{{animal.Animal.Name}}</td><td>{{animal.Animal.Number}}</td><td>{{animal.Animal.Parity}}</td><td>{{animal.Animal.LastCalvingDate | date:\'mediumDate\'}}</td><td>{{animal.Animal.BirthDate | date:\'mediumDate\'}}</td><td>{{animal.ErrorMessage}}</td></tr></tbody></table></div><div style="margin-bottom: 20px;height: 35px;"><button class="btn btn-danger pull-right" ng-click="vm.showFailedPreviewPage = false" style="margin-left: 10px"><data-i18n i18n="_label_close_">Close</data-i18n></button></div></div>');
$templateCache.put('app/pages/importAnimals/importAnimals.html','<div class="widgets" id="a_details"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll" ng-if="!vm.hidePage"><div include-with-scope="app/pages/importAnimals/importAnimals.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/importAnimals/importAnimals.panel.html','<div ng-if="vm.numError"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div class="import-animals" ng-if="!vm.numError && !vm.loading && !vm.error" ng-show="!vm.showDateConfigBlock && !vm.showPreviewPage && !vm.showFailedPreviewPage"><h3 class="with-line" style="padding-top: 0" ng-if="vm.showImportResults && vm.file">Import results</h3><div class="results-block" ng-if="vm.showImportResults && vm.file"><table class="table"><tbody><tr><td colspan="3" style="text-align: center">Results</td></tr><tr><td>Successfully imported</td><td>{{vm.results.sucessful}}</td><td ng-if="vm.results.failed > 0"></td></tr><tr><td>Import failed</td><td>{{vm.results.failed}}</td><td ng-if="vm.results.failed > 0"><button class="btn btn-xs btn-primary" ng-click="vm.previewFailedAnimals()"><data-i18n i18n="_label_preview_">Preview</data-i18n></button></td></tr></tbody></table></div><h3 class="with-line" style="padding-top: 0"><data-i18n i18n="_file_upload_label_">File upload</data-i18n></h3><div class="upload-file-block"><div ng-if="!vm.file"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)" ngf-pattern="\'.csv\'" ngf-accept="\'.csv\'"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.file"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.file = null"></span></div><div ng-if="vm.wrongFormatError" class="error-message"><span>Selected file is not .csv file. Please use .scv files only.</span></div></div><h3 class="with-line" style="padding-top: 0" ng-if="vm.showTable && vm.file"><data-i18n i18n="_label_reading_config_">Reading configuration</data-i18n></h3><div class="read-config-block" ng-if="vm.showTable && vm.file"><div class="row"><div class="col-md-4 header-block"><div class="form-group row clearfix"><label class="control-label"><div class="checkbox" ng-class="vm.headerIncluded ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.headerIncludedChanged()"><span><data-i18n i18n="_label_header_included_">Header included</data-i18n></span></div></label></div></div><div class="col-md-4"><div class="delimiter"><table class="table"><tbody><tr><td><data-i18n i18n="_label_field_delimiter_">Field delimiter</data-i18n></td><td><div class="form-group row clearfix selector"><ui-select ng-model="vm.fieldDelimiter" on-select="vm.fieldDelimiterChanged($index)"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="delimiter in vm.fieldDelimiters">{{delimiter.name}}</ui-select-choices></ui-select></div></td></tr></tbody></table></div></div><div class="col-md-4"><div class="delimiter"><table class="table"><tbody><tr><td><data-i18n i18n="_label_string_delimiter_">String delimiter</data-i18n></td><td><div class="form-group row clearfix selector"><ui-select ng-model="vm.stringDelimiter" on-select="vm.stringDelimiterChanged($index)"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="delimiter in vm.stringDelimiters">{{delimiter.name}}</ui-select-choices></ui-select></div></td></tr></tbody></table></div></div></div></div><h3 class="with-line" style="padding-top: 0" ng-if="vm.showTable && vm.file"><data-i18n i18n="_data_mapping_label_">Data mapping</data-i18n></h3><div class="config-block" ng-if="vm.showTable && vm.file"><table class="table"><tbody><tr><td colspan="2" style="text-align: center"><data-i18n i18n="_mapping_label_">mapping</data-i18n><i class="fa fa-info-circle" ng-click="vm.openInfoModal()"></i></td></tr><tr><td><data-i18n i18n="_animal_ear_tag_">Ear tag</data-i18n></td><td><a href="#" editable-select="vm.earTag" e-ng-options="property as property.name for property in vm.properties">{{vm.earTag.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td><data-i18n i18n="_animal_name_">Name</data-i18n></td><td><a href="#" editable-select="vm.name" e-ng-options="property as property.name for property in vm.properties">{{vm.name.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td><data-i18n i18n="_animal_number_">Number</data-i18n></td><td><a href="#" editable-select="vm.number" e-ng-options="property as property.name for property in vm.properties" onaftersave="vm.mappingChanged(\'number\')">{{vm.number.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td><data-i18n i18n="_animal_lactations_">Lactation</data-i18n></td><td><a href="#" editable-select="vm.parity" e-ng-options="property as property.name for property in vm.properties" onaftersave="vm.mappingChanged(\'parity\')">{{vm.parity.name || (\'_select_property_label_\' | i18n)}}</a></td></tr><tr><td ng-if="vm.useSeparatedDates"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n></td><td ng-if="!vm.useSeparatedDates"><data-i18n i18n="_animals_last_calving_birth_date_">Last calving/birth date</data-i18n></td><td><a href="#" editable-select="vm.date" e-ng-options="property as property.name for property in vm.properties" onaftersave="vm.mappingChanged(\'date\')">{{vm.date.name || (\'_select_property_label_\' | i18n)}}</a> <i class="fa fa-info-circle" ng-click="vm.openDateInfoModal(\'date\')" ng-if="vm.date"></i></td></tr><tr ng-if="vm.useSeparatedDates"><td><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n></td><td><a href="#" editable-select="vm.birthDate" e-ng-options="property as property.name for property in vm.properties" onaftersave="vm.mappingChanged(\'birthDate\')">{{vm.birthDate.name || (\'_select_property_label_\' | i18n)}}</a> <i class="fa fa-info-circle" ng-click="vm.openDateInfoModal(\'birthDate\')" ng-if="vm.birthDate"></i></td></tr><tr><td colspan="2" style="text-align: center;"><div class="form-group row clearfix"><label class="control-label"><div class="checkbox" ng-class="vm.separatedDates ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.separatedDatesChanged()"><span><data-i18n i18n="_label_header_separated_last_calving_birth_">Separated last calving/birth date</data-i18n></span></div></label></div></td></tr></tbody></table></div><div ng-if="vm.showTable && vm.file" class="btn-wrapper"><button class="btn btn-primary" ng-click="vm.previewAnimals()" ng-disabled="!vm.earTag.id && !vm.number.id"><data-i18n i18n="_label_preview_">Preview</data-i18n></button></div><h3 class="with-line" style="padding-top: 0; position: relative" ng-if="vm.showTable && vm.file"><data-i18n i18n="_page_animals_">Animals</data-i18n><div class="warning-msg-box" ng-if="vm.dateError || vm.dateErrorBirth || vm.parityError || vm.numberError"><div class="msg number-msg" ng-if="vm.numberError"><data-i18n i18n="_error_message_number_format_invalid_">Column used for animal number may contain data that is not valid animal number data.</data-i18n></div><div class="msg parity-msg" ng-if="vm.parityError"><data-i18n i18n="_error_message_parity_format_invalid_">Column used for lactation may contain data that is not valid lactation data.</data-i18n></div><div class="msg date-msg" ng-if="vm.dateError && !vm.useSeparatedDates"><data-i18n i18n="_error_message_date_format_invalid_">Column used for last calving/birth date may contain data that is not valid date data.</data-i18n></div><div class="msg date-msg" ng-if="vm.dateError && vm.useSeparatedDates"><data-i18n i18n="_error_message_date_format_invalid_calving_">Column used for last calving date may contain data that is not valid date data. If you are sure that selected data contains a valid date, date format may not be standard. You can try to manually configure the date format.</data-i18n></div><div ng-if="vm.dateError"><button style="margin-left: 10px" class="btn btn-primary" ng-click="vm.openDateFormatConfigurationPage(\'date\', false)"><data-i18n i18n="_label_configure_">Configure</data-i18n></button></div><div class="msg date-msg" ng-if="vm.dateErrorBirth"><data-i18n i18n="_error_message_date_format_invalid_birth_">Column used for birth date may contain data that is not valid date data. If you are sure that selected data contains a valid date, date format may not be standard. You can try to manually configure the date format.</data-i18n></div><div ng-if="vm.dateErrorBirth"><button style="margin-left: 10px" class="btn btn-primary" ng-click="vm.openDateFormatConfigurationPage(\'birthDate\', false)"><data-i18n i18n="_label_configure_">Configure</data-i18n></button></div><div class="msg"><data-i18n i18n="_error_message_import_mapping">Please be aware that this could affect import results.</data-i18n></div><div class="button-wrapper"><button class="btn btn-sm btn-primary" ng-click="vm.hideErrorMessages()"><data-i18n i18n="_label_ok_">Ok</data-i18n></button></div></div></h3><div ng-if="vm.showTable && vm.file" class="table-wrapper"><table class="table"><thead><tr><th ng-repeat="property in vm.properties" ng-hide="property.hidden">{{property.name}}</th></tr></thead><tbody><tr ng-repeat="animal in vm.animals"><td ng-repeat="property in vm.properties" ng-hide="property.hidden">{{animal[property.name]}}</td></tr></tbody></table><div class="load-more-button" ng-if="vm.showLoadMore"><button class="btn btn-primary" ng-click="vm.loadMore()"><data-i18n i18n="_label_load_more_">Load more</data-i18n></button></div></div><div ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div><div class="import-animals" ng-if="vm.showPreviewPage && !vm.loading"><div include-with-scope="app/pages/importAnimals/previewPage.html"></div></div><div class="import-animals" ng-if="vm.showFailedPreviewPage && !vm.loading"><div include-with-scope="app/pages/importAnimals/failedPreviewPage.html"></div></div><div class="import-animals" ng-if="vm.showDateConfigBlock"><div include-with-scope="app/pages/importAnimals/dateFormatConfiguration.html"></div><div ng-if="vm.error" class="invoice-error"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span><span class="material-icons" ng-click="vm.init()">replay</span></div></div><div ng-if="vm.loading" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/importAnimals/mappingInfo.modal.html','<div class="date-format-modal"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div><div><data-i18n i18n="_mapping_info_p1_">To be able to sucessfully import animals you will have to connect animal properties (Ear Tag, Name, Number, Lactation, Last calving/birth date) to columns in the file. You can see column names and data in the Animals table.</data-i18n></div><br><div><data-i18n i18n="_mapping_info_p2_">The goal here is to select correct column for each of the given properties. Name of the column doesn\'t have to be the same as the name of the property. You can also use the same column for more than one property.</data-i18n></div><br><div><data-i18n i18n="_mapping_info_p3_">Importing rules</data-i18n>:<ul><li><data-i18n i18n="_mapping_info_p4_">It is mandatory to connect Ear tag or Number. If at least one is not connected import will not work.</data-i18n></li><li><data-i18n i18n="_mapping_info_p5_">When connecting Number to a column, pick column that contains number values, because only number values will be successfully imported.</data-i18n></li><li><data-i18n i18n="_mapping_info_p6_">When connecting Lactation to a column, pick column that contains number values, because only number values will be successfully imported.</data-i18n></li><li><data-i18n i18n="_mapping_info_p7_">When connecting Last calving/birth date to a column, pick column that contains valid date, in the case when date is not formated in the standard way, you will have to manually define date format.</data-i18n></li></ul></div></div></div></div>');
$templateCache.put('app/pages/importAnimals/previewPage.html','<div><div class="table-wrapper"><table class="table"><thead><tr><th><data-i18n i18n="_animal_ear_tag_">Ear Tag</data-i18n></th><th><data-i18n i18n="_animal_name_">Name</data-i18n></th><th><data-i18n i18n="_animal_number_">Number</data-i18n></th><th><data-i18n i18n="_animal_details_lactation_">Lactation</data-i18n></th><th><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n></th><th><data-i18n i18n="_animal_date_of_birth_">Birth date</data-i18n></th></tr></thead><tbody><tr ng-repeat="animal in vm.importAnimalsList"><td>{{animal.EarTag}}</td><td>{{animal.Name}}</td><td>{{animal.Number}}</td><td>{{animal.Parity}}</td><td>{{animal.LastCalvingDate | date:\'mediumDate\'}}</td><td>{{animal.BirthDate | date:\'mediumDate\'}}</td></tr></tbody></table><div class="load-more-button" ng-if="vm.showPreviewLoadMore"><button class="btn btn-primary" ng-click="vm.previewLoadMore()"><data-i18n i18n="_label_load_more_">Load more</data-i18n></button></div></div><div style="margin-bottom: 20px;height: 35px;"><button class="btn btn-danger pull-right" ng-click="vm.showPreviewPage = false" style="margin-left: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button> <button class="btn btn-success pull-right" ng-click="vm.importAnimals()"><data-i18n i18n="_import_label_">Import</data-i18n></button></div></div>');
$templateCache.put('app/pages/home/home.html','<div class="row" style="display: flex; justify-content: center; flex-wrap: wrap"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ng-if="vm.showCockpitShortcut"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts"><div class="col-xs-2"><a href="" class="ion-android-home" style="font-size: 72px"></a></div><div class="col-xs-10 description" align="right" style="padding: 10px 0px 0px 10px"><div class="ng-binding" style="margin-bottom: 10px"><data-i18n i18n="_shortcut_farm_cockpit_">View farm cockpit</data-i18n>.</div><button class="btn btn-primary btn-xs" style="margin-left: 5px; min-width: 50px" ng-click="vm.goToState(\'cockpit\')"><data-i18n i18n="_btn_view_">View</data-i18n></button></div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ng-if="vm.showDashboardsShortcut"><div ba-panel="" ba-panel-class="small-panel" style="height: auto"><div class="row pie-charts"><div class="col-xs-2"><a href="" class="ion-android-home" style="font-size: 72px"></a></div><div class="col-xs-10 description" align="right" style="padding: 10px 0px 0px 10px"><div class="ng-binding" style="margin-bottom: 10px"><data-i18n i18n="_shortcut_dashboards_">View dashboards</data-i18n>.</div><button class="btn btn-primary btn-xs" style="margin-left: 5px; min-width: 50px" ng-click="vm.goToState(\'herds.dashboards\')"><data-i18n i18n="_btn_view_">View</data-i18n></button></div></div></div></div></div><div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="dashboard-map-panel-large" style="height: auto" id="panel-map" ng-if="!vm.showCockpitShortcut && !vm.showDashboardsShortcut"><div class="maps-slider" ng-if="!vm.loadingDashboards && !vm.noAvailableDashboards && !vm.errorLoading"><i class="ion-arrow-left-b" ng-click="vm.hideButtons()" ng-class="vm.showButtons ? \'ion-arrow-left-b\' : \'ion-arrow-right-b\'"></i></div><div class="btn-group-vertical maps-btn-group" ng-if="vm.showButtons"><button class="btn btn-map" ng-click="vm.setActiveMap(button)" ng-class="vm.mapActive.id==\'{{button.id}}\' ? \'btn-map-active\' : \'\'" ng-repeat="button in vm.dashboards">{{button.description}}</button></div><div id="dashboard-area" class="dashboard-map"><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" class="loading-spinner"><div class="loading-animation"></div></div><iframe ng-src="{{vm.embed}}" class="dashboard-map" id="frame" style="width: 100%" ng-if="!vm.loadingDashboards && !vm.noAvailableDashboards && !vm.errorLoading"></iframe></div></div><div ba-panel="" ba-panel-class="dashboard-map-panel" style="height: auto" id="panel-map" ng-if="vm.showCockpitShortcut || vm.showDashboardsShortcut"><div class="maps-slider" ng-if="!vm.loadingDashboards && !vm.noAvailableDashboards && !vm.errorLoading"><i class="ion-arrow-left-b" ng-click="vm.hideButtons()" ng-class="vm.showButtons ? \'ion-arrow-left-b\' : \'ion-arrow-right-b\'"></i></div><div class="btn-group-vertical maps-btn-group" ng-if="vm.showButtons"><button class="btn btn-map" ng-click="vm.setActiveMap(button)" ng-class="vm.mapActive.id==\'{{button.id}}\' ? \'btn-map-active\' : \'\'" ng-repeat="button in vm.dashboards">{{button.description}}</button></div><div id="dashboard-area" class="dashboard-map"><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" class="loading-spinner"><div class="loading-animation"></div></div><iframe ng-src="{{vm.embed}}" class="dashboard-map" id="frame" style="width: 100%" ng-if="!vm.loadingDashboards && !vm.noAvailableDashboards && !vm.errorLoading"></iframe></div></div></div></div>');
$templateCache.put('app/pages/home/home_new.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openCreateReport()"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div><div class="message-block" ng-if="vm.showDPMessage"><div><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.showDPMessage = false">OK</button></div></div><div class="message-block-arrow" ng-if="vm.showDPMessage"></div></div></div><div><div ng-if="vm.reselectTeamError"><span style="color: red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><span style="color: red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" class="loading-spinner"><div class="loading-animation"></div></div><div style="text-align: center" ng-if="!vm.loadingDashboards && !vm.noAvailableDashboards && !vm.reselectTeamError && !vm.errorLoading"><button class="btn btn-home" ng-disabled="vm.disableCategoryButtons" ng-click="vm.selectCategory(1)" ng-class="vm.selectedCategory==1 ? \'selected\': \'\'">Reproduction</button> <button class="btn btn-home" ng-disabled="vm.disableCategoryButtons" ng-click="vm.selectCategory(2)" ng-class="vm.selectedCategory==2 ? \'selected\': \'\'">Production</button> <button class="btn btn-home" ng-disabled="vm.disableCategoryButtons" ng-click="vm.selectCategory(3)" ng-class="vm.selectedCategory==3 ? \'selected\': \'\'">Claw Health</button> <button class="btn btn-home" ng-disabled="vm.disableCategoryButtons" ng-click="vm.selectCategory(4)" ng-class="vm.selectedCategory==4 ? \'selected\': \'\'">Udder Health</button> <button class="btn btn-home" ng-disabled="vm.disableCategoryButtons" ng-click="vm.selectCategory(5)" ng-class="vm.selectedCategory==5 ? \'selected\': \'\'">Diseases</button></div><div id="frame" class="dashboard-wrapper-home home-page" style="position: relative"><img ng-if="vm.showUnderConstruction" style="width: 100%; height: 100%; padding-top: 5px" src="assets/img/u_c.jpg"><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/home/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/herds/herds.html','<div ba-panel="" ba-panel-class="with-scroll"><ui-view></ui-view></div>');
$templateCache.put('app/pages/homeArvesta/homeArvesta.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/inseminationStrategyHeifers/inseminationStrategyHeifers.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/inseminationStrategyCows/inseminationStrategyCows.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/inseminationStrategyCows/inseminationStrategyCows.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/inseminationStrategyCows/inseminationStrategyCows.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/inseminationStrategyCows/inseminationStrategyCows.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/inseminationStrategyCowsCtrl/inseminationStrategyCowsCtrl.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/inseminationStrategyCowsCtrl/inseminationStrategyCowsCtrl.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/inseminationStrategyCows/inseminationStrategyCows.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/inseminationStrategyCows/inseminationStrategyCows.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/invoice/invoice.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_invoice_\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/invoice/invoice.panel.html"></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/invoice/invoice.panel.html','<div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && !vm.loading && !vm.errorLoading && !vm.noVisitDates"><div class="invoice"><h3 class="with-line"><data-i18n i18n="_invoice_label_trimmer_info_">Trimmer information</data-i18n></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputTrimmerCompanyName" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_company_name_">Company name</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerCompanyName" placeholder="" ng-model="vm.trimmerCompany.Name" ng-change="vm.trimmerDataChanged(\'company_name\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputTrimmerStreet" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_street_">Street</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerStreet" placeholder="" ng-model="vm.trimmerCompany.Address.Street" ng-change="vm.trimmerDataChanged(\'address_street\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputTrimmerCity" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_city_">City</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerCity" placeholder="" ng-model="vm.trimmerCompany.Address.City" ng-change="vm.trimmerDataChanged(\'address_city\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputTrimmerZip" class="col-sm-3 control-label">Zip</label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerZip" placeholder="" ng-model="vm.trimmerCompany.Address.Zip" ng-change="vm.trimmerDataChanged(\'address_zip\')" maxlength="10"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputTrimmerName" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_trimmer_name_">Trimmer Name</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerName" placeholder="" ng-model="vm.trimmerName" ng-change="vm.trimmerDataChanged(\'trimmer_name\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputTrimmerStreetNumber" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_street_number_">Street number</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerStreetNumber" placeholder="" ng-model="vm.trimmerCompany.Address.Number" ng-change="vm.trimmerDataChanged(\'address_number\')" maxlength="15"></div></div><div class="form-group row clearfix"><label for="inputTrimmerState" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_state_">State</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputTrimmerState" placeholder="" ng-model="vm.trimmerCompany.Address.State" ng-change="vm.trimmerDataChanged(\'address_state\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputTrimmerPhone" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_phone_number_">Phone</data-i18n></label><div class="col-sm-9"><input type="tel" class="form-control" id="inputTrimmerPhone" placeholder="" ng-model="vm.trimmerCompany.PhoneNumber" maxlength="15" ng-change="vm.trimmerDataChanged(\'trimmer_phone\')"></div></div></div></div><h3 class="with-line"><data-i18n i18n="_invoice_label_dairy_info_">Dairy information</data-i18n></h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputDairyCompanyName" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_company_name_">Company name</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyCompanyName" placeholder="" ng-model="vm.dairyCompany.Name" ng-change="vm.dairyDataChanged(\'company_name\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputDairyStreet" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_street_">Street</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyStreet" placeholder="" ng-model="vm.dairyCompany.Street" ng-change="vm.dairyDataChanged(\'address_street\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputDairyCity" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_city_">City</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyCity" placeholder="" ng-model="vm.dairyCompany.City" ng-change="vm.dairyDataChanged(\'address_city\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputDairyZip" class="col-sm-3 control-label"><data-i18n i18n="_label_zip_postal_">Zip</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyZip" placeholder="" ng-model="vm.dairyCompany.Zip" ng-change="vm.dairyDataChanged(\'address_zip\')" maxlength="10"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputDairyEmail" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyEmail" placeholder="" ng-model="vm.dairyCompany.Email" ng-change="vm.dairyDataChanged(\'dairy_email\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputDairyStreetNumber" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_street_number_">Street number</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyStreetNumber" placeholder="" ng-model="vm.dairyCompany.Number" ng-change="vm.dairyDataChanged(\'address_number\')" maxlength="15"></div></div><div class="form-group row clearfix"><label for="inputDairyState" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_state_">State</data-i18n></label><div class="col-sm-9"><input type="text" class="form-control" id="inputDairyState" placeholder="" ng-model="vm.dairyCompany.State" ng-change="vm.dairyDataChanged(\'address_state\')" maxlength="40"></div></div><div class="form-group row clearfix"><label for="inputDairyPhone" class="col-sm-3 control-label"><data-i18n i18n="_invoice_label_phone_number_">Phone</data-i18n></label><div class="col-sm-9"><input type="tel" class="form-control" id="inputDairyPhone" placeholder="" ng-model="vm.dairyCompany.PhoneNumber" maxlength="15" ng-change="vm.dairyDataChanged(\'dairy_phone\')"></div></div></div></div><h3 class="with-line"><data-i18n i18n="_invoice_label_trim_date_">Trim date</data-i18n></h3><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="toggle-group" style="margin: auto; width: fit-content"><span><data-i18n i18n="_invoice_label_visit_date_">Visit date</data-i18n></span> <span class="material-icons" ng-click="vm.changeHoofTrimPeriod()" ng-class="!vm.loadingHoofTrims ? \'\' : \'disabled\'">{{vm.timePeriodUnit}}</span> <span><data-i18n i18n="_report_time_period_">Time period</data-i18n></span></div></div></div><div class="row" ng-if="vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="invoice-date-selector"><p class="input-group" ng-class="vm.dateError ? \'date-error\' : \'\'"><input type="text" class="form-control" ng-init="vm.resetTrimmerSelection()" uib-datepicker-popup="mediumDate" ng-model="vm.selectedDateObject" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.loadingHoofTrims" ng-change="vm.dateChanged()" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default trim-btn" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></p></div></div><div class="col-md-4"></div></div><div class="row" ng-if="!vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="invoice-range-selector"><div class="range-selector-block selector-dates">{{vm.startDate | date:\'mediumDate\'}} - {{vm.endDate | date:\'mediumDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.loadingHoofTrims ? \'disabled\': \'\'"></i></div></div></div><div class="col-md-4"></div></div><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="toggle-group" style="margin: auto; width: fit-content"><span><data-i18n i18n="_invoice_label_by_herd_">By herd</data-i18n></span> <span class="material-icons" ng-click="vm.changeFilter()" ng-class="!vm.loadingHoofTrims ? \'\' : \'disabled\'">{{vm.filterUnit}}</span> <span><data-i18n i18n="_invoice_label_by_trimmer_">By trimmer</data-i18n></span></div></div><div class="col-md-4"></div></div><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="form-group has-feedback trimmer-selector" ng-if="!vm.hoofTrimByHerd"><ui-select id="trimmer" name="trimmer" ng-required="true" ng-model="vm.selectedTrimmer" theme="bootstrap" class="select-tags" style="height: 20px" on-select="vm.onTrimmerSelected()"><ui-select-match allow-clear="true" placeholder="{{\'_invoice_label_trimmer_name_\' | i18n}}"><div class="selector-input">{{$select.selected}}</div></ui-select-match><ui-select-choices repeat="trimmer in vm.trimmerNames | filter: $select.search"><div class="selector-list-item">{{trimmer}}</div></ui-select-choices></ui-select></div></div><div class="col-md-4"></div></div><div class="total-line" ng-if="!vm.hoofTrimByDate" style="margin-top: 15px"><div class="total-amount"><td><data-i18n i18n="_invoice_label_total_number_visits_">Total number of visits</data-i18n></td>: {{vm.numberOfVisits}}</div></div><div class="row"><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_label_visit_reason_"></data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_type_">Type</data-i18n></th><th><data-i18n i18n="_invoice_label_n_cows_">Number of cows</data-i18n></th><th><data-i18n i18n="_invoice_label_price_">Price</data-i18n></th><th><data-i18n i18n="_invoice_label_cost_">Cost</data-i18n></th></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_trim_">Trim</data-i18n></td><td>{{vm.hoofTrimData.reason.trim.n}}</td><td><span editable-number="vm.hoofTrimData.reason.trim.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'reason\', \'trim\')">{{vm.hoofTrimData.reason.trim.price | currency}}</span></td><td>{{vm.hoofTrimData.reason.trim.cost | currency}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_trim_rear_">Trim rear</data-i18n></td><td>{{vm.hoofTrimData.reason.trimRear.n}}</td><td><span editable-number="vm.hoofTrimData.reason.trimRear.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'reason\', \'trimRear\')">{{vm.hoofTrimData.reason.trimRear.price | currency}}</span></td><td>{{vm.hoofTrimData.reason.trimRear.cost | currency}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_lame_">Lame</data-i18n></td><td>{{vm.hoofTrimData.reason.lame.n}}</td><td><span editable-number="vm.hoofTrimData.reason.lame.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'reason\', \'lame\')">{{vm.hoofTrimData.reason.lame.price | currency}}</span></td><td>{{vm.hoofTrimData.reason.lame.cost | currency}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_recheck_">Recheck</data-i18n></td><td>{{vm.hoofTrimData.reason.recheck.n}}</td><td><span editable-number="vm.hoofTrimData.reason.recheck.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'reason\', \'recheck\')">{{vm.hoofTrimData.reason.recheck.price | currency}}</span></td><td>{{vm.hoofTrimData.reason.recheck.cost | currency}}</td></tr><tr></tr><tr><td><data-i18n i18n="_animal_details_total_">Total</data-i18n></td><td>{{vm.hoofTrimData.reason.cows}}</td><td></td><td>{{vm.hoofTrimData.reason.cost | currency}}</td></tr></table></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_treatments_">Treatments</data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_type_">Type</data-i18n></th><th><data-i18n i18n="_invoice_label_count_">Count</data-i18n></th><th><data-i18n i18n="_invoice_label_price_">Price</data-i18n></th><th><data-i18n i18n="_invoice_label_cost_">Cost</data-i18n></th></tr><tr><td><span editable-text="vm.treatmentNames.therapeuticTrim" blur="cancel" e-maxlength="20" e-required="">{{vm.treatmentNames.therapeuticTrim}}</span></td><td>{{vm.hoofTrimData.treatments.therapeuticTrim.n}}</td><td><span editable-number="vm.hoofTrimData.treatments.therapeuticTrim.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'treatments\', \'therapeuticTrim\')">{{vm.hoofTrimData.treatments.therapeuticTrim.price | currency}}</span></td><td>{{vm.hoofTrimData.treatments.therapeuticTrim.cost | currency}}</td></tr><tr><td><span editable-text="vm.treatmentNames.topical" blur="cancel" e-maxlength="20" e-required="">{{vm.treatmentNames.topical}}</span></td><td>{{vm.hoofTrimData.treatments.topical.n}}</td><td><span editable-number="vm.hoofTrimData.treatments.topical.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'treatments\', \'topical\')">{{vm.hoofTrimData.treatments.topical.price | currency}}</span></td><td>{{vm.hoofTrimData.treatments.topical.cost | currency}}</td></tr><tr><td><span editable-text="vm.treatmentNames.antibioticTreatment" blur="cancel" e-maxlength="20" e-required="">{{vm.treatmentNames.antibioticTreatment}}</span></td><td>{{vm.hoofTrimData.treatments.antibioticTreatment.n}}</td><td><span editable-number="vm.hoofTrimData.treatments.antibioticTreatment.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'treatments\', \'antibioticTreatment\')">{{vm.hoofTrimData.treatments.antibioticTreatment.price | currency}}</span></td><td>{{vm.hoofTrimData.treatments.antibioticTreatment.cost | currency}}</td></tr><tr><td><span editable-text="vm.treatmentNames.conventional" blur="cancel" e-maxlength="20" e-required="">{{vm.treatmentNames.conventional}}</span></td><td>{{vm.hoofTrimData.treatments.conventional.n}}</td><td><span editable-number="vm.hoofTrimData.treatments.conventional.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'treatments\', \'conventional\')">{{vm.hoofTrimData.treatments.conventional.price | currency}}</span></td><td>{{vm.hoofTrimData.treatments.conventional.cost | currency}}</td></tr><tr><td><data-i18n i18n="_animal_details_total_">Total</data-i18n></td><td>{{vm.hoofTrimData.treatments.c}}</td><td></td><td>{{vm.hoofTrimData.treatments.cost | currency}}</td></tr></table></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_optional_treatments_">Optional treatments</data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th><th><data-i18n i18n="_invoice_label_count_">Count</data-i18n></th><th><data-i18n i18n="_invoice_label_price_">Price</data-i18n></th><th><data-i18n i18n="_invoice_label_cost_">Cost</data-i18n></th></tr><tr><td><data-i18n i18n="_animal_details_hoof_treatment_type_block_">Block</data-i18n></td><td>{{vm.hoofTrimData.standardTreatments.block.n}}</td><td><span editable-number="vm.hoofTrimData.standardTreatments.block.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'standardTreatments\', \'block\')">{{vm.hoofTrimData.standardTreatments.block.price | currency}}</span></td><td>{{vm.hoofTrimData.standardTreatments.block.cost | currency}}</td></tr><tr><td><data-i18n i18n="_animal_details_hoof_treatment_type_wrap_">Wrap</data-i18n></td><td>{{vm.hoofTrimData.standardTreatments.wrap.n}}</td><td><span editable-number="vm.hoofTrimData.standardTreatments.wrap.price" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.priceChanged($data, \'standardTreatments\', \'wrap\')">{{vm.hoofTrimData.standardTreatments.wrap.price | currency}}</span></td><td>{{vm.hoofTrimData.standardTreatments.wrap.cost | currency}}</td></tr><tr><td colspan="4" style="height: 72px"></td></tr><tr><td><data-i18n i18n="_animal_details_total_">Total</data-i18n></td><td>{{vm.hoofTrimData.standardTreatments.c}}</td><td></td><td>{{vm.hoofTrimData.standardTreatments.cost | currency}}</td></tr></table></div></div><div class="total-line"><div class="total-amount" style="width: 100%"><table style="width: 100%"><tbody><tr><td style="width: 50%" class="invoice-checkbox"><button class="btn btn-primary" ng-click="vm.setAllPricesToZero()"><data-i18n i18n="_invoice_label_set_all_prices_">Set all prices to 0</data-i18n></button></td><td style="width: 50%; text-align: right"><span><data-i18n i18n="_animal_details_total_">Total</data-i18n>:&nbsp;</span><span>{{vm.hoofTrimData.standardCosts | currency}}</span></td></tr></tbody></table></div></div><h3 class="with-line"><data-i18n i18n="_invoice_label_additional_charges_">Additional charges</data-i18n></h3><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.includeTripCharge ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includeAdditionalCharges(\'trip\')"><span><data-i18n i18n="_invoice_label_trip_charges_">Trip charge</data-i18n></span></div></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.tripCharge" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.additionalChargesChanged($data, \'tripCharge\')" edit-disabled="!vm.includeTripCharge" ng-class="vm.includeTripCharge ? \'\' : \'disabled\'">{{vm.hoofTrimData.tripCharge | currency}}</span></div></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.includeVisitCharge ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includeAdditionalCharges(\'visit\')"><span><data-i18n i18n="_invoice_label_visit_charges_">Visit charge</data-i18n></span></div></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.visitCharge" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.additionalChargesChanged($data, \'visitCharge\')" edit-disabled="!vm.includeVisitCharge" ng-class="vm.includeVisitCharge ? \'\' : \'disabled\'">{{vm.hoofTrimData.visitCharge | currency}}</span></div></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.includeSetupCharge ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includeAdditionalCharges(\'setup\')"><span><data-i18n i18n="_invoice_label_setup_charges_">Setup charge</data-i18n></span></div></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.setupCharge" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.additionalChargesChanged($data, \'setupCharge\')" edit-disabled="!vm.includeSetupCharge" ng-class="vm.includeSetupCharge ? \'\' : \'disabled\'">{{vm.hoofTrimData.setupCharge | currency}}</span></div></div></div></div></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_additional_charges_total_">Additional charges total</data-i18n>: {{vm.hoofTrimData.additionalCharges | currency}}</div></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_sub_total_">Sub-total</data-i18n>: {{vm.hoofTrimData.subTotal | currency}}</div></div><div class="row"><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_discount_">Discount</data-i18n></h3><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.includeDiscount ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.addDiscount()"><span><data-i18n i18n="_invoice_label_add_discount_">Add discount</data-i18n></span></div></label><div class="col-xs-6"><div class="toggle-group"><span>%</span> <span class="material-icons" ng-click="vm.changeDiscountUnit()" ng-class="vm.includeDiscount ? \'\' : \'disabled\'">{{vm.discountUnit}}</span> <span><data-i18n i18n="_invoice_label_fixed_value_">Fixed value</data-i18n></span></div></div></div><div class="form-group row clearfix" style="height: 41px"><label class="col-xs-6 control-label"></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.discount.discountPercentage" blur="cancel" e-min="0" e-max="100" e-step="0.01" onbeforesave="vm.discountValueChanged($data, \'discountPercentage\')" edit-disabled="!vm.includeDiscount" ng-class="vm.includeDiscount ? \'\' : \'disabled\'" ng-if="vm.discountUsePercentage">%{{vm.hoofTrimData.discount.discountPercentage | number : 2}}</span> <span editable-number="vm.hoofTrimData.discount.discountFixed" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.discountValueChanged($data, \'discountFixed\')" edit-disabled="!vm.includeDiscount" ng-class="vm.includeDiscount ? \'\' : \'disabled\'" ng-if="!vm.discountUsePercentage">{{vm.hoofTrimData.discount.discountFixed | currency}}</span></div></div></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_discount_">Discount</data-i18n>: {{vm.hoofTrimData.totalDiscount | currency}}</div></div></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_tax_">Tax</data-i18n></h3><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.taxIncluded ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.includeTax()"><span><data-i18n i18n="_invoice_label_tax_included_">Tax included</data-i18n></span></div></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.tax" blur="cancel" e-min="0" e-max="100" e-step="0.01" onbeforesave="vm.taxValueChanged($data)" edit-disabled="vm.taxIncluded" ng-class="vm.taxIncluded ? \'disabled\' : \'\'">%{{vm.hoofTrimData.tax | number : 2}}</span></div></div></div><div class="form-group row clearfix" style="height: 46px"></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_tax_">Tax</data-i18n>: {{vm.hoofTrimData.totalTax | currency}}</div></div></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_surcharge_">Surcharge</data-i18n></h3><div class="form-group row clearfix"><label class="col-xs-6 control-label"><div class="invoice-checkbox" ng-class="vm.includeSurcharge ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.addSurcharge()"><span><data-i18n i18n="_invoice_label_add_surcharge_">Add surcharge</data-i18n></span></div></label><div class="col-xs-6"><div class="toggle-group"><span>%</span> <span class="material-icons" ng-click="vm.changeSurchargeUnit()" ng-class="vm.includeSurcharge ? \'\' : \'disabled\'">{{vm.surchargeUnit}}</span> <span><data-i18n i18n="_invoice_label_fixed_value_">Fixed value</data-i18n></span></div></div></div><div class="form-group row clearfix"><label class="col-xs-6 control-label"><input type="text" class="form-control" id="inputSurchargeName" placeholder="Surcharge name" ng-model="vm.surchargeName" maxlength="20" ng-disabled="!vm.includeSurcharge"></label><div class="col-xs-6"><div class="input-group"><span editable-number="vm.hoofTrimData.surcharge.surchargePercentage" blur="cancel" e-min="0" e-max="100" e-step="0.01" onbeforesave="vm.surchargeValueChanged($data, \'surchargePercentage\')" edit-disabled="!vm.includeSurcharge" ng-class="vm.includeSurcharge ? \'\' : \'disabled\'" ng-if="vm.surchargeUsePercentage">%{{vm.hoofTrimData.surcharge.surchargePercentage | number : 2}}</span> <span editable-number="vm.hoofTrimData.surcharge.surchargeFixed" blur="cancel" e-min="0" e-step="0.01" onbeforesave="vm.surchargeValueChanged($data, \'surchargeFixed\')" edit-disabled="!vm.includeSurcharge" ng-class="vm.includeSurcharge ? \'\' : \'disabled\'" ng-if="!vm.surchargeUsePercentage">{{vm.hoofTrimData.surcharge.surchargeFixed | currency}}</span></div></div></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_surcharge_">Surcharge</data-i18n>: {{vm.hoofTrimData.totalSurcharge | currency}}</div></div></div></div><div class="total-line"><div class="total-amount"><data-i18n i18n="_invoice_label_total_before_tax_">Total before tax</data-i18n>: {{vm.hoofTrimData.beforeTax | currency}}</div></div><div class="total-line" style="border-color: white"><div class="total-amount"><data-i18n i18n="_animal_details_total_">Total</data-i18n>: {{vm.hoofTrimData.total | currency}}</div></div><h3 class="with-line"><data-i18n i18n="_animal_leasion_">Lesions</data-i18n></h3><div class="row" style="text-align: center"><div><data-i18n i18n="_invoice_label_total_number_of_lesions_">Total number of lesions</data-i18n>= {{vm.hoofTrimData.lesions.total}}</div><div style="height: 600px; width: 400px; position: relative; left: 0; right: 0; margin: auto;" ng-if="vm.hoofTrimData.lesions.total"><canvas id="graph" height="600" width="400"></canvas></div></div><div style="padding-top: 40px"><button style="float: right" class="btn btn-primary" ng-click="vm.exportToPdf()"><data-i18n i18n="_label_export_pdf_">Export to pdf</data-i18n></button></div></div></div><div ng-if="vm.selectedHerds.length == 1 && vm.loading && !vm.errorLoading && !vm.noVisitDates" align="center"><div><div class="loading-animation"></div></div></div><div ng-if="vm.noVisitDates" class="invoice-error"><span><data-i18n i18n="_invoice_message_no_data_">No data found for selected herd.</data-i18n></span></div>');
$templateCache.put('app/pages/lactationAnalysis/lactationAnalysis.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="lactationAnalysisFrame" class="dashboard-wrapper-home home-page" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/MRO/MRO.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="mroFrame" class="dashboard-wrapper-home home-page" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()" ng-class="vm.backPositionRight ? \'right\' : \'\'"><img src="assets/img/back.png"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/oestrusIntervalAnalysis/oestrusIntervalAnalysis.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/overview/kpiConfig.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.modalLoading"><ul class="main-kpi-list"><li ng-repeat="filter in vm.KPIFilters"><div class="main-kpi-list-item" ng-click="filter.selected = !filter.selected"><div class="kpi-name">{{filter.label}}</div><div class="selector"><div class="kpi-checkbox" ng-class="filter.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"></div></div></div></li></ul><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.saveKpis()"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></div><div class="modal-body kpi-config" ng-if="vm.modalLoading"><div class="kpi-conf-modal-loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/overview/overview.html','<div ng-if="vm.errorLoading" class="error-msg-wrapper" style="margin-bottom: 10px;"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><main-kpi ng-if="!vm.loading && !vm.hideMainKPIS && !vm.hide" dashboards="vm.mainKPIDashboards"></main-kpi><div class="row" ng-if="!vm.hideAll"><div class="col-lg-5 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Emergency wall" ba-panel-class="medium-panel" ng-if="vm.showEmergencyWall"><emergency-wall ng-if="!vm.hide"></emergency-wall></div><div ng-class="vm.showEmergencyWall ? \'col-lg-2 col-md-5 col-sm-12\' : \'col-lg-4 col-md-5 col-sm-12\'" ba-panel="" ba-panel-class="medium-panel master-kpi" ng-if="!vm.hide"><master-kpi loading="vm.loading" dashboards="vm.allDashboards" set-kpis="vm.setKpis()" kpidashboards="vm.mainKPIDashboards"></master-kpi></div><div ng-class="vm.showEmergencyWall ? \'col-lg-5 col-md-7 col-sm-12\' : \'col-lg-8 col-md-7 col-sm-12\'" ba-panel="" ba-panel-title="Herds" ba-panel-class="medium-panel herds-map"><map-herds ng-if="!vm.loading" dashboards="vm.allDashboards"></map-herds><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Reproduction" ba-panel-class="medium-panel reproduction" ng-if="vm.showReproductionModule && !vm.hide" ng-class="vm.showLargeReproduction ? \'large-reproduction\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'reproduction\')">{{vm.repoLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'reproduction\')">launch</div><div class="master-button" ng-click="vm.openMasterTable(\'repro\')"><div class="text">M</div></div></div><reproduction ng-if="!vm.loading" dashboards="vm.allDashboards"></reproduction><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Claw health" ba-panel-class="medium-panel claw-health" ng-if="vm.showClawHealthModule && !vm.hide" ng-class="vm.showLargeCHealth ? \'large-ch\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'claw_health\')">{{vm.CHLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'clawHealth\')">launch</div><div class="master-button" ng-click="vm.openMasterTable(\'clawHealth\')"><div class="text">M</div></div></div><claw-health ng-if="!vm.loading" dashboards="vm.allDashboards"></claw-health><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="{{\'_page_milk_meter_\'| i18n}}" ba-panel-class="medium-panel production" ng-if="vm.showProductionModule && !vm.hide" ng-class="vm.showLargeProduction ? \'large-production\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'production\')">{{vm.prductionLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'production\')">launch</div></div><production ng-if="!vm.loading" dashboards="vm.allDashboards"></production><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="MRO" ba-panel-class="medium-panel mro" ng-if="vm.showMROModule && !vm.hide" ng-class="vm.showLargeMRO ? \'large-mro\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'mro\')">{{vm.MROLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'mro\')">launch</div></div><mro ng-if="!vm.loading" dashboards="vm.allDashboards"></mro><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Lactation Analysis" ba-panel-class="medium-panel lactation-analysis" ng-if="vm.showLactationAnalysisModule && !vm.hide" ng-class="vm.showLargeLactationAnalysis ? \'large-lactation-analysis\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'lactationAnalysis\')">{{vm.lactationAnalysisLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'lactationAnalysis\')">launch</div></div><lactation-analysis ng-if="!vm.loading" dashboards="vm.allDashboards"></lactation-analysis><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Presales Audit" ba-panel-class="medium-panel presales-audit" ng-if="vm.showPresalesAuditModule && !vm.hide" ng-class="vm.showLargePresalesAudit ? \'large-presales-audit-analysis\' : \'\'"><div class="panel-navigation" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="material-icons go-to-button" ng-click="vm.openLargeView(\'presalesAudit\')">{{vm.presalesAuditLargeIcon}}</div><div class="material-icons go-to-button" ng-click="vm.goTo(\'presalesAudit\')">launch</div></div><presales-audit ng-if="!vm.loading" dashboards="vm.allDashboards"></presales-audit><div ng-if="vm.loading && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.errorLoading" class="error-loading"><div><span class="material-icons">cloud_off</span></div></div></div></div>');
$templateCache.put('app/pages/presalesAudit/presalesAudit.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px; height: 20px;" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div ng-show="vm.currentDate"><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n><span style="margin-left: 3px;">{{vm.currentDate}}</span></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="presalesAuditFrame" class="dashboard-wrapper-presales" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/production/production.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="productionFrame" class="dashboard-wrapper-home home-page" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/back.png"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/rap/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/rap/datePeriodMessage.modal.html','<div><div class="modal-body" style="height: 120px"><div><span><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></span></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.closeModal()">OK</button></div></div></div>');
$templateCache.put('app/pages/rap/daySelector.modal.html','<div><div class="modal-header" ng-if="!vm.setDateModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setDateModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_date_">Date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setActualReportDate()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/rap/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/rap/rap.html','<div class="row"><div class="col-xs-12" ng-hide="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto" id="panel-map"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.errorLoading"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="!vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openAddToReportModal()" ng-disabled="vm.selectedHerds.length!=1 || vm.disableAddToReport" ng-show="vm.showAddToReportButton"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openCreateReport()" ng-disabled="vm.selectedHerds.length != 1"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableRangeSelector ? \'disabled\': \'\'"></i></div><div class="message-block" ng-if="vm.showDPMessage"><div><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.showDPMessage = false">OK</button></div></div><div class="message-block-arrow" ng-if="vm.showDPMessage"></div></div></div><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="rapFrame" class="dashboard-wrapper-rap" ng-if="!vm.loadingDashboards && !vm.errorLoading"><div ng-if="vm.showActualCurrentDateMessage" class="day-filter-info"><div class="close-button" ng-click="vm.showActualCurrentDateMessage = false"><span class="material-icons">close</span></div><div><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n>:</div><div ng-if="vm.actualFilterValue.type == 1">{{vm.actualFilterValue.day | date:\'shortDate\'}}</div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_animal_dim_">DIM</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.dim }}</span></div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_dashboard_name_filter_parity_">Parity</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.parity }}</span></div></div><div class="missing-data-info-message" ng-if="vm.showMissingDataMessage"><div><div class="icon"><span class="fa fa-info-circle"></span></div><div class="text"><div style="margin-bottom: 10px"><data-i18n i18n="_rap_missing_data_message_">Some data is missing for selected herd. Columns with data missing</data-i18n>:</div><ul style="text-align: left"><li ng-repeat="item in vm.missingDataColumns">{{item}}</li></ul></div></div><div style="margin-top: 5px; padding: 5px"><div class="do-not-show-again" ng-click="vm.doNotShowAgain = !vm.doNotShowAgain"><span class="check-box" ng-class="vm.doNotShowAgain ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"></span><datai-i18n i18n="_label_do_not_show_again_">Do not show again</datai-i18n><span></span></div><button class="btn btn-xs btn-info pull-right" ng-click="vm.hideMissingDataMessage()">Ok</button></div></div></div></div></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.description}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)" ng-if="vm.showStartEndDate(dashboard)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="time-period row" ng-click="vm.openReportDashboardDayModal($index)" ng-if="!vm.showStartEndDate(dashboard)">{{dashboard.report_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div></div>');
$templateCache.put('app/pages/rap/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/rap/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/reproduction/recheckDate.modal.html','<div><div class="modal-header" ng-if="!vm.setDateModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setDateModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><span style="margin-right: 3px"><data-i18n i18n="_animal_details_hoof_treatment_type_recheck_">Recheck</data-i18n></span><span><data-i18n i18n="_label_date_">Date</data-i18n></span></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.recheckDate" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRecheckDate()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/reproduction/reproduction.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom" ng-if="!vm.showRecheckDateSelector"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom" ng-if="vm.showRecheckDateSelector"><div class="range-selector-block selector-dates">{{vm.recheckDate | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRecheckDateModal()" ng-class="vm.disableCategoryButtons ? \'disabled\': \'\'"></i></div></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="frame" class="dashboard-wrapper-home home-page" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/robotView/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/robotView/datePeriodMessage.modal.html','<div><div class="modal-body" style="height: 120px"><div><span><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></span></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.closeModal()">OK</button></div></div></div>');
$templateCache.put('app/pages/robotView/daySelector.modal.html','<div><div class="modal-header" ng-if="!vm.setDateModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setDateModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_dashboard_name_parameter_date_">Date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.setActualReportDate()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setDateModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/robotView/rangeSelector.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/robotView/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_btn_add_">Add</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/robotView/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/robotView/robotView.html','<div class="row" ng-if="vm.selectedHerds.length == 1"><div class="col-xs-12" ng-hide="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll" style="height: auto" id="panel-map"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.errorLoading"><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="!vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openAddToReportModal()" ng-disabled="vm.selectedHerds.length != 1 || vm.disableAddToReport" ng-show="vm.showAddToReportButton"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div><div style="display: inline-block; vertical-align: bottom; margin-right: 5px" ng-if="vm.showCreateReportButton"><button class="btn btn-primary" ng-click="vm.openCreateReport()" ng-disabled="vm.selectedHerds.length !=1"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div class="dashboard-range-selector" style="display: inline-block; vertical-align: bottom"><div class="range-selector-block selector-dates">{{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.disableRangeSelector ? \'disabled\': \'\'"></i></div><div class="message-block" ng-if="vm.showDPMessage"><div><data-i18n i18n="_date_period_message_">Last milk date is before selected last date, because of that selected last date will be automatically set to last milk date.</data-i18n></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.showDPMessage = false">OK</button></div></div><div class="message-block-arrow" ng-if="vm.showDPMessage"></div></div></div><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div id="rapFrame" class="dashboard-wrapper-rap" ng-if="!vm.loadingDashboards && !vm.errorLoading"><div ng-if="vm.showActualCurrentDateMessage" class="day-filter-info"><div class="close-button" ng-click="vm.showActualCurrentDateMessage = false"><span class="material-icons">close</span></div><div><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n>:</div><div ng-if="vm.actualFilterValue.type == 1">{{vm.actualFilterValue.day | date:\'shortDate\'}}</div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_animal_dim_">DIM</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.dim }}</span></div><div ng-if="vm.actualFilterValue.type == 2"><data-i18n i18n="_dashboard_name_filter_parity_">Parity</data-i18n>:<span style="margin-left: 3px">{{vm.actualFilterValue.parity }}</span></div></div><div class="missing-data-info-message" ng-if="vm.showMissingDataMessage"><div><div class="icon"><span class="fa fa-info-circle"></span></div><div class="text"><div style="margin-bottom: 10px"><data-i18n i18n="_rap_missing_data_message_">Some data is missing for selected herd. Columns with data missing</data-i18n>:</div><ul style="text-align: left"><li ng-repeat="item in vm.missingDataColumns">{{item}}</li></ul></div></div><div style="margin-top: 5px; padding: 5px"><div class="do-not-show-again" ng-click="vm.doNotShowAgain = !vm.doNotShowAgain"><span class="check-box" ng-class="vm.doNotShowAgain ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"></span><datai-i18n i18n="_label_do_not_show_again_">Do not show again</datai-i18n><span></span></div><button class="btn btn-xs btn-info pull-right" ng-click="vm.hideMissingDataMessage()">Ok</button></div></div></div></div></div></div></div><div ng-if="vm.showCreateReportBlock" class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height: 20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.description}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)" ng-if="vm.showStartEndDate(dashboard)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td><td class="time-period row" ng-click="vm.openReportDashboardDayModal($index)" ng-if="!vm.showStartEndDate(dashboard)">{{dashboard.report_date | date:\'shortDate\'}}</td><td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_dashboard_default_herd_not_defined_">Default herd is not defined</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div></div><div ng-if="vm.selectedHerds.length != 1"><div ba-panel=""><data-i18n i18n="_message_error_select_only_one_herd_">Please select only one herd</data-i18n></div></div>');
$templateCache.put('app/pages/streamerHealth/streamerHealth.html','<div class="row" ng-if="vm.selectedTeam"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height: auto" id="panel-map"><div style="text-align: right"><div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.errorLoading"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center"><span class="color-red" style="margin-bottom: 10px"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden"><div class="loading-animation"></div></div><div id="rapFrame" class="dashboard-wrapper-rap" ng-if="!vm.loadingDashboards && !vm.errorLoading"></div></div></div></div></div></div><div class="row" ng-if="!vm.selectedTeam"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll">Select team</div></div></div>');
$templateCache.put('app/pages/settings/settings.html','<div ba-panel="" ba-panel-class="profile-page"><div ng-if="!vm.loading"><div class="panel-content"><h3 class="with-line"><data-i18n i18n="_label_user_settings_">User Settings</data-i18n></h3><div class="row"><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12"></div><div class="col-xlg-4 col-lg-4 col-md-4 col-sm-12"><div class="form-group"><label><data-i18n i18n="_label_localization_">Localization</data-i18n></label><ui-select ng-model="vm.currentLanguage" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match><div style="display: flex;gap: 10px; align-items: center;"><img ng-src="{{$select.selected.image | flagImg}}"><div>{{$select.selected.name}}</div></div></ui-select-match><ui-select-choices repeat="language in vm.languages | filter: $select.search"><div style="display: flex; padding: 3px; gap: 10px"><img ng-src="{{language.image | flagImg}}"><div ng-bind-html="language.name"></div></div></ui-select-choices></ui-select></div></div></div><div class="settings-ver-info" style="text-align: right"><button type="button" class="btn btn-primary btn-with-icon save-profile" ng-click="vm.save()"><i class="ion-android-checkmark-circle"></i><data-i18n i18n="_label_save_">Save</data-i18n></button><div><label class="info-note"><a href="https://flagpedia.net" target="_blank">Icons by flagpedia</a></label></div></div></div></div><div ng-if="vm.loading" align="center"><div style="overflow: hidden"><div class="loading-animation" style="display: inline-block"></div></div></div></div>');
$templateCache.put('app/pages/treatments_protocols/newFile.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><div><div class="upload-file-block"><div ng-if="!vm.file"><i class="ion-ios-cloud-upload"></i></div><div ng-if="!vm.file"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.file"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingNewDiscussion"><div class="loading-animation"></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><button type="button" class="btn btn-success" ng-click="vm.addNewFile()" ng-disabled="!vm.selectedHerd || !vm.file"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/treatments_protocols/treatments_protocols.html','<div class="row"><div class="col-xs-12" ng-style="vm.showDates && {\'padding-right\': \'120px\'}" ng-if="!vm.errorLoading"><div ba-panel="" ba-panel-class="with-scroll images-panel"><div include-with-scope="app/pages/treatments_protocols/treatments_protocols.panel.html"></div></div></div><div class="col-xs-12"><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/treatments_protocols/treatments_protocols.panel.html','<div ng-if="!vm.loading && vm.selectedHerd"><div class="row filter-row"><div class="col-lg-1 col-sm-1 add-comment-icon"><i class="ion-ios-cloud-upload" ng-click="vm.openNewDiscussionModal()"></i></div></div><div ng-repeat="image in vm.images track by image.Id" class="image-wrapper" ng-class="image.highlighted ? \'highlight\' : \'\'" id="image{{image.Id}}"><div class="image-info"><span class="image-who">{{::image.Creator}}</span> <span class="image-when">{{image.ImageCreated | date:\'short\'}}</span> <span class="image-when">{{::image.HerdName}}</span><div><span class="ion-android-apps action-button" ng-click="vm.showMenu(image.Id, $index)"></span><ul id="{{image.Id}}" class="image-action-menu dropdown-menu dropdown-actions-menu" role="menu" ng-click="$event.stopPropagation()"><li id="action-priority" ng-if="image.showMenu"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.changeImportance(image, 0, $index, false)" ng-class="image.Importance==0 ? \'label-importance-selected\' : (!image.Importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="image.Importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 1, $index, false)"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="image.Importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 2, $index, false)"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="image.Importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(image, 3, $index, false)"><data-i18n i18n="_label_high_">High</data-i18n></span></li><li id="action-task"><span class="action-menu-label"><data-i18n i18n="_label_task_">Task</data-i18n></span> <i class="material-icons action-task text-danger" tabindex="0" ng-class="image.IsTask ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(image, false, false, true)">error</i> <i class="material-icons action-task text-success" tabindex="0" ng-class="image.TaskCompleted ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(image,true, false, true)">check_circle</i></li><li ng-if="image.TaskCompletedBy" style="font-size:13px"><span>{{image.TaskCompletedBy}}</span></li><li id="action-comment"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.commentText" ng-keyup="vm.addCommentOnEnter($event, image, $index, false)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.addComment(image, $index, false)"><span class="ion-chevron-right"></span></span></div></li><li id="action-tags" style="overflow:visible"><div class="input-group" style="max-width:270px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="image.TagsToShow" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.addTag(image, $item, $index)" on-remove="vm.removeTag(image, $item, $index)"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li><li ng-if="image.Private"><button class="btn btn-primary btn-sm" style="float: right"><data-i18n i18n="_label_publish_" ng-click="vm.publishFile(image, $index)">Publish</data-i18n></button></li></ul></div></div><div class="image-canvas" ng-class="image.Importance == 1 ? \'importance-1\' : (image.Importance == 2 ? \'importance-2\' : (image.Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage($index)"><img src="assets/img/logo.png" lazy-img="{{image.ThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="!image.hideImage" ng-style="image.FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div><div class="image-task-details" ng-if="image.IsTask"><i class="material-icons is-task-icon" ng-if="!image.TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="image.TaskCompleted">check_circle</i></div><div class="image-legend"><div class="image-who">{{::image.AnimalEarTag}}</div><div class="image-when">{{::image.AnimalNumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::image.AnimalName}}</div></div><div class="image-comment-panel" ng-if="image.TagsToShow.length>0 || image.NumberComments > 0 || image.FileUrl"><div class="image-tags" ng-if="image.TagsToShow.length>0"><span class="fa fa-tags"></span> <span ng-repeat="tag in image.TagsToShow track by tag.value" class="image-tag">{{::tag.value}}</span></div><div class="image-file" ng-if="image.FileUrl"><span class="ion-paperclip" style="font-size: 20px"></span> <span><a target="_blank" ng-href="{{image.FileUrl}}">{{image.FileName}}</a></span></div><div class="image-comment" ng-repeat="comment in image.Comments track by comment.Id"><span class="image-who" style="padding-top:4px">{{::comment.CommentedBy}}</span> <span class="image-when">{{::comment.CommentTimeStamp | date:\'short\'}}</span> <span class="comment-text">{{::comment.Message}}</span></div></div></div><div ng-if="vm.showLoadMore" style="text-align: center"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreImages()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></div></div><div ng-if="vm.loading && vm.selectedHerd" style="text-align: center;"><div class="loading-animation"></div></div><div ng-if="!vm.selectedHerd" class="color-red"><div><span><data-i18n i18n="_message_error_select_only_one_herd_">Please select only one herd</data-i18n></span></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop" ng-class="getBackground()"><ul ng-class="{active : activeMenu === item}" class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight" ng-if="showMenu"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && !item.fixedHref" class="al-sidebar-list-link hide-tip" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}" ng-class="$baSidebarService.isMenuCollapsed() ? \'large-icon\' : \'wrap\'"><i class="{{ ::item.icon }}" ng-if="item.icon" ng-class="{ \'large-icon\': $baSidebarService.isMenuCollapsed() }"></i> <img ng-src="{{item.img}}" ng-if="item.img"> <span><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></span></a><a ng-mouseenter="hoverItem($event, item)" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && item.fixedHref" class="al-sidebar-list-link" target="_blank" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}" ng-class="$baSidebarService.isMenuCollapsed() ? \'large-icon\' : \'wrap\'"><i class="{{ ::item.icon }}" ng-if="item.icon"></i> <img ng-src="{{item.img}}" ng-if="item.img"> <span><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></span></a><a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler="" uib-tooltip="{{item.titleTranslated }}" tooltip-is-open="feedNameIsOpen" tooltip-placement="right" tooltip-class="customBlue right" tooltip-popup-delay="500" tooltip-append-to-body="true" tooltip-enable="{{$baSidebarService.isMenuCollapsed()}}" ng-class="$baSidebarService.isMenuCollapsed() ? \'large-icon\' : \'wrap\'"><i class="{{ ::item.icon }}" ng-if="item.icon"></i> <img ng-src="{{item.img}}" ng-if="item.img"> <span><data-i18n i18n="{{ ::item.title }}">{{ ::item.title }}</data-i18n></span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link"><data-i18n i18n="{{ ::subSubitem.title }}">{{ ::subSubitem.title }}</data-i18n></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><data-i18n i18n="{{ ::subSubitem.title }}">{{ ::subSubitem.title }}</data-i18n></a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link"><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled && !subitem.fixedHref)" ui-sref="{{subitem.stateRef}}" ng-click="stateTo(subitem.stateRef)" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled && subitem.fixedHref)" target="_blank" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><data-i18n i18n="{{ ::subitem.title }}">{{ ::subitem.title }}</data-i18n></a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix" ng-cloak=""><ul class="breadcrumb al-breadcrumb"><li ng-if="vm.showHome()"><a href="" ng-click="vm.goToHome()"><data-i18n i18n="_page_title_home_">home</data-i18n></a></li><li ng-if="vm.showAnimals()" class="al-title-hover" ng-click="vm.goToAnimals()">{{vm.previousState}}</li><li ng-class="vm.addClass()" ng-if="activePageTitle && vm.checkCurrentState() && !vm.isArvestaState()" ng-click="vm.activePageSelected()"><data-i18n ng-if="activePageTitle" i18n="{{ activePageTitle }}">{{ activePageTitle }}</data-i18n></li><li ng-if="vm.showDashboardState()" class="al-title-hover" ng-click="vm.activeCategorySelected()">{{vm.category.name}}</li><li ng-if="vm.showSelectedDashboard() && (vm.currentState == \'herds.dashboards\' || vm.currentState == \'dq\')">{{vm.selectedDashboard}}</li><li ng-if="!vm.checkCurrentState() && !vm.hideDashboardName">{{vm.dashboard_name}}</li><li ng-if="vm.hasParent() && activePageSideBarMeta && activePageSideBarMeta.parentTitle"><data-i18n i18n="{{activePageSideBarMeta.parentTitle}}">{{activePageSideBarMeta.parentTitle}}</data-i18n></li><li ng-if="vm.isArvestaState()"><span ng-bind="vm.getDashboardName()"></span></li></ul><div class="dashboard-pills period-selector" style="text-align: right" ng-if="vm.showSelectedDashboard()"><button class="btn time-selector" ng-if="vm.showDateSelector()" ng-class="vm.selectedTime==7 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(7)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="btn time-selector" ng-if="vm.showDateSelector()" ng-class="vm.selectedTime==30 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(30)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="btn time-selector" ng-if="vm.showDateSelector()" ng-class="vm.selectedTime==90 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(90)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==1 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(1)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==5 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(5)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==10 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(10)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="btn time-selector" ng-class="vm.selectedTime==69 ? \'active-time-selector\' : \'\'" ng-click="vm.timeSelectorChanged(69)" style="padding: 6px 12px; font-size: 14px; font-weight: 400"><data-i18n i18n="_label_time_custom_">Custom</data-i18n></button></div><div ng-if="vm.showMMMInside()" class="mmm-inside"><div><img ng-src="{{\'logo_mmm.png\' | appImage}}"></div><div class="inside">inside</div></div></div>');
$templateCache.put('app/theme/components/cookiePolicy/cookiePolicy.html','<div class="cookie-policy"><div class="cookie-policy-wraper" ng-if="vm.showCookiePolicyMessage"><div class="cp-header">Cookies</div><div class="cp-body"><div class="cp-text">Cookies help us deliver our services. By using our services, you agree to our use of cookies. <span ng-click="vm.openPrivacyPolicy()">Learn more.</span></div><div class="cp-button"><button class="btn" ng-click="vm.acceptCookies()">Accept</button></div></div></div><div class="policy-text" ng-if="vm.showPrivacyPolicyText"><div class="button-holder"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closePrivacyPolicy()"></i></div><div class="heading">Privacy Policy</div><div>This privacy policy (the \u201CPrivacy Policy\u201D) covers Bovicom/MmmooOgle service (the \u201CService\u201D). Please read below to review our Privacy Policy and the types of information we gather through our Service. In this Privacy Policy, \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D and other similar references mean Bovicom/MmmooOgle and \u201Cyou\u201D and \u201Cyour\u201D and other similar references mean a specific user of the Service. Bovicom/MmmooOgle knows that you care about how your personal information is used and shared, and we take your privacy seriously. Please read the following to learn more about our privacy policy. By visiting Bovicom/MmmooOgle website and by using Bovicom/MmmooOgle Services, you are accepting the practices outlined in this Privacy Policy.</div><div class="heading">1. Website Visitors</div><div>Like most website operators, Bovicom/MmmooOgle collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Bovicom/MmmooOgle\u2019s purpose in collecting non-personally identifying information is to better understand how Bovicom/MmmooOgle\u2019s visitors use its website. From time to time, Bovicom/MmmooOgle may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its website. Bovicom/MmmooOgle also collects potentially personally-identifying information like Internet Protocol (IP) addresses for logged in users.</div><div class="heading">2. Gathering of Personally-Identifying Information</div><div>Certain visitors to Bovicom/MmmooOgle\u2019s websites choose to interact with Bovicom/MmmooOgle in ways that require Bovicom/MmmooOgle to gather personally-identifying information. The amount and type of information that Bovicom/MmmooOgle gathers depends on the nature of the interaction. In each case, Bovicom/MmmooOgle collects such information only insofar as is necessary or appropriate to fulfill the purpose of the visitor\u2019s interaction with Bovicom/MmmooOgle. Bovicom/MmmooOgle does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities.</div><div class="heading">3. Links</div><div>Bovicom/MmmooOgle may contain links to other sites. Our site is not responsible for the privacy policies and/or practices on other sites. When linking to another site a user should read the privacy policy stated on that site.</div><div class="heading">4. Aggregated Statistic</div><div>Bovicom/MmmooOgle may collect statistics about the behavior of visitors to its websites. However, Bovicom/MmmooOgle does not disclose personally-identifying information other than as described below.</div><div class="heading">5. Protection of Certain Personally-Identifying Information</div><div>Bovicom/MmmooOgle collects and uses your personal information to operate and deliver the Services.</div><div>Bovicom/MmmooOgle discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Bovicom/MmmooOgle\u2019s behalf or to provide services available at Bovicom/MmmooOgle\u2019s websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Bovicom/MmmooOgle\u2019s websites, you consent to the transfer of such information to them. Bovicom/MmmooOgle will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Bovicom/MmmooOgle discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when Bovicom/MmmooOgle believes in good faith that disclosure is reasonably necessary to protect the property or rights of Bovicom/MmmooOgle, third parties or the public at large. If you are a registered user of the Bovicom/MmmooOgle website and have supplied your email address, Bovicom/MmmooOgle may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what\u2019s going on with Bovicom/MmmooOgle and our products. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. Bovicom/MmmooOgle takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.</div><div class="heading">6. Cookies</div><div>A cookie is a string of information that a website stores on a visitor\u2019s computer, and that the visitor\u2019s browser provides to the website each time the visitor returns. Bovicom/MmmooOgle uses cookies to help Bovicom/MmmooOgle identify and track visitors, their usage of Bovicom/MmmooOgle website, and their website access preferences. Bovicom/MmmooOgle visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Bovicom/MmmooOgle\u2019s websites, with the drawback that certain features of Bovicom/MmmooOgle\u2019s websites may not function properly without the aid of cookies.</div><div class="heading">7. Processing herd data</div><div>Herd data is processed on behalf of, and in accordance with the instruction from, those making this data available.</div><div>Bovicom/MmmooOgle may use herd data for internal business purposes, such as data analysis, providing customer support, customizing and improving our Services, product development, providing, selling and licensing products and services based on anonymised and/or aggregated herd data, meeting government regulatory requirements, and so forth.</div><div class="heading">8. Access and rectification</div><div>Bovicom/MmmooOgle complies with applicable law regarding your ability to access, correct and delete your personally identifiable information. If you have an online account, you may be able to log into your account to access and update certain information you provided to us. If you need assistance updating or deleting your personal information, please contact us via email to info@mmmooogle.com. Please provide your name, address, and detailed information about the change you would like to make.</div><div class="heading">9. Privacy Policy Changes</div><div>Bovicom/MmmooOgle may change its Privacy Policy from time to time, and in Bovicom/MmmooOgle\u2019s sole discretion. Bovicom/MmmooOgle encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.</div><div class="heading">10. Contacting Us</div><div>If there are any questions regarding this Privacy Policy you may contact us using the information below. Bovicom BVBA, Zeutestraat 1, 2870 Puurs, BELGIUM</div><div class="heading">11. Last Modification</div><div>This Privacy Policy was last modified on March the 3rd, 2017.</div></div></div>');
$templateCache.put('app/theme/components/cookiePolicy/cookiePolicy.modal.html','<div style="z-index: 99999999"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_start" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="shortDate" ng-model="vm.period_end" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-info pull-right" ng-click="vm.setRange()" style="margin-left:5px;"><data-i18n i18n="_label_apply_">apply</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.closeModal()" style="margin-left:5px;"><data-i18n i18n="_label_cancel_">cancel</data-i18n></button> <button class="btn btn-xs btn-danger pull-right" ng-click="vm.resetRange()" style="margin-left:5px;" ng-if="vm.use_date_range"><data-i18n i18n="_label_reset_">reset</data-i18n></button></div></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center"><li uib-dropdown="" keyboard-nav="true" auto-close="outsideClick" is-open="vm.teamSelectorIsOpen"><div class="top-bar" uib-dropdown-toggle=""><div class="selector-text" uib-tooltip="{{vm.selectedTeam.Name }}" tooltip-is-open="teamIsOpen" tooltip-placement="bottom" tooltip-class="customBlue bottom" tooltip-popup-delay="500" tooltip-append-to-body="true">{{vm.selectedTeam.Name}}</div><div id="team-selector" class="dropdown"><a href=""><span class="fa fa-chevron-down" style="margin-left: 5px"></span></a></div></div><ul class="dropdown-menu-right" uib-dropdown-menu="" role="menu" aria-labelledby="team-selector" style="max-height: 150px; overflow-y: auto"><div class="option-filter"><input type="text" class="form-control" placeholder="{{\'_placeholder_type_to_filter_\' | i18n}}" ng-model="vm.textFilter" autofocus=""></div><li role="menuitem" ng-repeat="team in vm.teams | filter:vm.textFilter" ng-click="vm.selectTeam(team)" ng-if="vm.teamsLoaded"><a href="#">{{team.Name}}</a></li><li ng-if="!vm.teamsLoaded"><a href=""><data-i18n i18n="_message_loading_">loading</data-i18n>...</a></li></ul></li><li uib-dropdown="" style="margin-top: -5px" ng-if="vm.showPanicButton" ng-click="vm.openPanicButton()" is-open="vm.panicButtonOpened"><a href="" uib-dropdown-toggle="" uib-tooltip="{{\'_label_panic_button_tooltip_\' | i18n}}" tooltip-is-open="isOpenBell" tooltip-placement="bottom" tooltip-class="customBlue bottom border" tooltip-popup-delay="500" tooltip-append-to-body="true"><img ng-src="{{vm.panic_button | appImage}}" style="height: 24px;" class="clicable"></a><div uib-dropdown-menu="" class="top-dropdown-menu" ng-click="$event.stopPropagation()"><i class="dropdown-arr"></i><div class="header clearfix"><strong><data-i18n i18n="_label_send_error_info_">Send error info</data-i18n></strong></div><div class="modal-body" ng-if="!vm.loadingPanicButton"><span style="margin-top: -15px; font-size: 12px" class="help-block basic-block color-red" ng-if="vm.panicButtonError"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.panic_button_text" maxlength="200"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.sendErrorInfo()"><data-i18n i18n="_button_send_">Send</data-i18n></button></div></div><div class="modal-body" ng-if="vm.loadingPanicButton"><div style="text-align: center; height: 182px"><div class="loading-animation" style="top: 60px;"></div></div></div></div></li><li style="margin-top: 2px"><a href="https://mmmpublic.blob.core.windows.net/public/Mmmooogle-Streamer/BETA/MmmooOgle-Streamer.exe" class="msg" style="color: white"><i class="fa fa-download"></i></a></li><li ng-if="vm.showOpenPdf"><a href="" class="msg" ng-click="vm.openPdf()" style="color: white"><span style="font-size: 17px;" class="material-icons">policy</span></a></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div class="logo-wrapper"><a href="#/dashboard" class="al-logo clearfix"><img ng-src="{{vm.logo | appImage}}" style="margin-right: 5px"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a> <a href="" class="collapse-header-menu-link ion-chevron-down" ng-click="vm.show = !vm.show"></a></div><div class="multiselect-wraper" ng-if="!vm.hideHerdSelector"><ui-select multiple="" ng-model="vm.selectedHerds" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" on-remove="vm.selectedHerdChanged()" on-select="vm.selectedHerdChanged()"><ui-select-match placeholder="{{vm.getPlaceholder()}}"><span style="margin-right: 1ex;">{{$item.Name}}</span><span ng-if="$item.Address && $item.Address.City">({{$item.Address.City}})</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | propsFilter: {Name: $select.search}"><span><div style="display: inline-block; margin-right: 1ex;">{{herd.Name}}</div><div style="display: inline-block;" ng-if="herd.Address && herd.Address.City">({{herd.Address.City}})</div></span></ui-select-choices></ui-select></div><div class="user-profile" uib-dropdown=""><div class="al-user-profile" ng-if="vm.showProfileIcon"><a uib-dropdown-toggle="" class="profile-toggle-link"><img lazy-img="{{vm.profilePicture}}" lazy-img-error="assets/img/app/profile/Avatar.png" src="assets/img/app/profile/Avatar.png"></a></div><div class="name-holder" uib-dropdown-toggle=""><span>{{vm.name}}</span></div><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><div class="duplicated-herd-filter"><input type="checkbox" ng-model="vm.filterDuplicated" ng-change="vm.filterDuplicatedChanged()"><span><data-i18n i18n="_user_filter_duplicated_herds_">filter duplicated herds</data-i18n></span></div></li><li><a href="" class="signout" ng-click="vm.openSettings()"><i class="fa fa-sliders"></i><data-i18n i18n="_label_settings_">Settings</data-i18n></a></li><li><a href="" class="signout" ng-click="vm.logout()"><i class="fa fa-power-off"></i><data-i18n i18n="_user_sign_out_">Sign out</data-i18n></a></li></ul><msg-center></msg-center></div><div ng-show="vm.show" class="user-profile-small"><ul><li><div uib-dropdown=""><div class="al-user-profile"><a uib-dropdown-toggle="" class="profile-toggle-link"><img lazy-img="{{vm.profilePicture}}" lazy-img-error="assets/img/app/profile/Avatar.png" src="assets/img/app/profile/Avatar.png"></a></div><div class="name-holder" uib-dropdown-toggle=""><span>{{vm.name}}</span></div><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><div class="duplicated-herd-filter"><input type="checkbox" ng-model="vm.filterDuplicated" ng-change="vm.filterDuplicatedChanged()"><span><data-i18n i18n="_user_filter_duplicated_herds_">filter duplicated herds</data-i18n></span></div></li><li><a href="" class="signout" ng-click="vm.logout()"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></li><li><div class="top-bar" style="float: right"><div uib-dropdown="" style="font-size: 18px; margin-right: 10px;" ng-if="vm.showPanicButton" ng-click="vm.openPanicButton()" is-open="vm.panicButtonOpenedPT"><a href="" uib-dropdown-toggle="" uib-tooltip="{{\'_label_panic_button_tooltip_\' | i18n}}" tooltip-is-open="isOpenBell" tooltip-placement="bottom" tooltip-class="customBlue bottom border" tooltip-popup-delay="500" tooltip-append-to-body="true"><img ng-src="{{vm.panic_button | appImage}}" style="height: 24px;" class="clicable"></a><div uib-dropdown-menu="" class="top-dropdown-menu" ng-click="$event.stopPropagation()"><i class="dropdown-arr"></i><div class="header clearfix"><strong><data-i18n i18n="_label_send_error_info_">Send error info</data-i18n></strong></div><div class="modal-body" ng-if="!vm.loadingPanicButton"><span style="margin-top: -15px; font-size: 12px" class="help-block basic-block color-red" ng-if="vm.panicButtonError"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.panic_button_text" maxlength="200"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.sendErrorInfo()"><data-i18n i18n="_button_send_">Send</data-i18n></button></div></div><div class="modal-body" ng-if="vm.loadingPanicButton"><div style="text-align: center; height: 182px"><div class="loading-animation" style="top: 60px;"></div></div></div></div></div><div style="font-size: 18px;"><a href="https://mmmpublic.blob.core.windows.net/public/Mmmooogle-Streamer/BETA/MmmooOgle-Streamer.exe" class="msg" style="color: white;"><i class="fa fa-download"></i></a></div><div ng-if="vm.showOpenPdf" style="font-size: 17px; margin-left: 10px;"><a href="" class="msg" style="color: white;" ng-click="vm.openPdf()"><span style="font-size: 17px;" class="material-icons">policy</span></a></div></div></li><li uib-dropdown="" keyboard-nav="true" auto-close="outsideClick" is-open="vm.teamSelectorIsOpenPT"><div class="top-bar" uib-dropdown-toggle="" style="float: right"><div class="selector-text">{{vm.selectedTeam.Name}}</div><div id="team-selector" class="dropdown"><a href=""><span class="fa fa-chevron-down" style="margin-left: 5px"></span></a></div></div><ul class="dropdown-menu-right" uib-dropdown-menu="" role="menu" aria-labelledby="team-selector" style="max-height: 150px; overflow-y: auto"><div class="option-filter"><input type="text" class="form-control" placeholder="{{\'_placeholder_type_to_filter_\' | i18n}}" ng-model="vm.textFilter" autofocus=""></div><li role="menuitem" ng-repeat="team in vm.teams | filter:vm.textFilter" ng-click="vm.selectTeam(team)" ng-if="vm.teamsLoaded"><a href="#">{{team.Name}}</a></li><li ng-if="!vm.teamsLoaded"><a href=""><data-i18n i18n="_message_loading_">loading</data-i18n>...</a></li></ul></li></ul><div><ui-select multiple="" ng-model="vm.selectedHerds" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" on-remove="vm.selectedHerdChanged()" on-select="vm.selectedHerdChanged()"><ui-select-match placeholder="{{\'_placeholder_select_herd_\' | i18n}}"><span style="margin-right: 1ex;">{{$item.Name}}</span><span ng-if="$item.Address && $item.Address.City">({{$item.Address.City}})</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | propsFilter: {Name: $select.search}"><span><div style="display: inline-block; margin-right: 1ex;">{{herd.Name}}</div><div style="display: inline-block;" ng-if="herd.Address && herd.Address.City">({{herd.Address.City}})</div></span></ui-select-choices></ui-select></div></div></div>');
$templateCache.put('app/theme/components/swoosh/swoosh.html','<div id="swoosh" class="swoosh"><img ng-src="{{vm.swoosh}}"> <img class="aveve-img" ng-if="vm.style == \'aveve\'" src="assets/img/aveve.svg"></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/concentrate/concentrateFeeding/concentrateFeeding.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/concentrate/concentrateIntake/concentrateIntake.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/concentrate/leftovers/leftovers.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/concentrate/overview/overview.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/herds/animals/animals.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_panel_title_animals_\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/herds/animals/animals.panel.html"></div></div><div class="error-msg-wrapper" ng-if="!vm.loading && vm.errorLoading"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animals.panel.html','<div ng-if="vm.numError"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.numError"><div class="row"><div class="col-sm-3" style="padding-bottom:5px"><input type="search" placeholder="{{\'_placeholder_search_cow_ear_tag_\' | i18n}}" class="form-control" ng-model="vm.searchStringEarTag" ng-change="vm.search()" id="search-box" ng-if="vm.selectedLayout != 3"></div><div class="col-sm-3" style="padding-bottom:5px"><input type="search" placeholder="{{\'_placeholder_search_cow_number_\' | i18n}}" class="form-control" ng-model="vm.searchStringNumber" ng-change="vm.search()" id="search-box" ng-if="vm.selectedLayout != 3"></div><div class="col-sm-3" style="padding-bottom:5px"><input type="search" placeholder="{{\'_placeholder_search_cow_\' | i18n}}" class="form-control" ng-model="vm.searchString" ng-change="vm.search()" id="search-box" ng-if="vm.selectedLayout != 3"></div><div class="col-sm-3" style="padding-bottom:5px"><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="vm.selectedLayout != 3"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div><div style="display: inline-block; vertical-align: middle; padding-right: 10px" class="animals-table-search-wraper" ng-if="vm.selectedLayout != 3"><div style="display: inline-block; position: relative" class="animals-filter-icon"><span class="glyphicon glyphicon-filter" ng-click="vm.showSearchSetings = !vm.showSearchSetings" style="position: relative" ng-if="!vm.style || vm.style==\'zoetis\'"></span><div ng-if="vm.style == \'aveve\'" class="icon-button"><img src="assets/img/filter.svg" ng-click="vm.showSearchSetings = !vm.showSearchSetings"></div><div ng-if="vm.style == \'proxani\'" class="icon-button"><img src="assets/img/filter_proxani.png" ng-click="vm.showSearchSetings = !vm.showSearchSetings"></div><div class="search-options-box animals" ng-if="vm.showSearchSetings"><div><div class="filter-checkbox" ng-class="vm.showActive ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'active\')"><span><data-i18n i18n="_label_show_active_animals">Show active animals</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.showHistorical ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'historical\')"><span><data-i18n i18n="_label_show_historical_animals_">show historical animals</data-i18n></span></div></div></div></div></div><div style="display: inline-block; vertical-align: middle; padding-right: 10px;" ng-if="vm.showExportBlock"><button class="btn btn-primary" ng-click="vm.exportAnimals()">Export</button> <button class="btn btn-primary" ng-click="vm.goBack()" ng-if="vm.showBackButton" style="margin-left: 5px;">Back</button></div></div></div><div></div><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/herds/animals/animals.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/herds/animals/animals.table.html"></div><div ng-if="vm.selectedLayout == 3" include-with-scope="app/pages/herds/animals/exportAnimals.table.html"></div></div><div ng-if="vm.loading" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/herds/animals/animals.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover" style="font-size: 14px"><thead><tr class="list-generator-list-header"><th style="text-align: center; padding: 12px"></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_ear_tag_">Animal ear tag</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_number_">Animal number</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_name_">Animal name</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_status_">Status</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingTable" lazy-img-container=""><tr ng-repeat="animal in vm.animalsToShow" class="animal-list" ng-click="vm.selectAnimal(animal)"><td><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" ng-if="!vm.style || vm.style==\'zoetis\'"><img src="assets/img/logo.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureThumbnailUrl"></div><div class="image-canvas list" ng-class="vm.getAnimalClass(animal)" ng-if="vm.style == \'aveve\'"><img src="assets/img/logo_l2m.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo_l2m.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo_l2m.png" ng-if="!animal.PictureThumbnailUrl"></div><div class="image-canvas list" ng-class="vm.getAnimalClass(animal)" ng-if="vm.style == \'proxani\'"><img src="assets/img/logo_proXpert.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo_proXpert.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo_proXpert.png" ng-if="!animal.PictureThumbnailUrl"></div></div></td><td style="text-align: center" class="animal_name pointer"><div>{{::animal.EarTag}}</div></td><td style="text-align: center" class="animal_number pointer">{{::animal.NumberString}}</td><td style="text-align: center" class="animal_name pointer"><div>{{::animal.Name}}</div></td><td style="text-align: center" class="animal_status pointer">{{::animal.CurrentStatusString}}</td></tr></tbody></table><div style="text-align: center" ng-if="!vm.loading && vm.animals.length>250"><div uib-pagination="" boundary-links="true" total-items="vm.animals.length" ng-model="vm.currentPage" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" max-size="5" ng-change="vm.paginationChanged()" items-per-page="250"></div></div></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/animals/animals.tiles.html','<div ng-repeat="animal in vm.animalsToShow" class="animal-wrapper clearfix pointer" ng-click="vm.selectAnimal(animal)" ng-if="vm.showAnimals"><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" ng-if="!vm.style || vm.style==\'zoetis\'"><img src="assets/img/logo.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureThumbnailUrl"></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" ng-if="vm.style == \'aveve\'"><img src="assets/img/logo_l2m.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo_l2m.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo_l2m.png" ng-if="!animal.PictureThumbnailUrl"></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" ng-if="vm.style == \'proxani\'"><img src="assets/img/logo_proXpert.png" lazy-img="{{animal.PictureThumbnailUrl}}" lazy-img-error="assets/img/logo_proXpert.png" ng-if="animal.PictureThumbnailUrl"> <img ng-src="assets/img/logo_proXpert.png" ng-if="!animal.PictureThumbnailUrl"></div><div class="image-legend"><div class="image-who">{{::animal.EarTag}}</div><div class="image-when">{{::animal.NumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::animal.Name}}</div><div class="image-who">{{::animal.CurrentStatusString}}</div></div></div><div style="text-align: center" ng-if="!vm.loading && vm.animals.length>250"><div uib-pagination="" boundary-links="true" total-items="vm.animals.length" ng-model="vm.currentPage" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" max-size="5" ng-change="vm.paginationChanged()" items-per-page="250"></div></div>');
$templateCache.put('app/pages/herds/animals/export.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="input-demo radio-demo row"><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="format1" id="format1" ng-value="1" ng-model="vm.selectedFormat"> <span>.csv</span></label></div><div class="col-md-6"><label class="radio-inline custom-radio nowrap"><input type="radio" name="format2" id="format2" ng-value="2" ng-model="vm.selectedFormat"> <span>.xls</span></label></div></div></div><div class="modal-footer"><div style="text-align: right"><button type="button" class="btn btn-success" ng-click="vm.exportDataCsvXls()"><data-i18n i18n="_button_export_">Export</data-i18n></button></div></div><button id="export-csv-button" style="display: none" ng-csv="vm.getCsvData()" filename="{{vm.fileName}}" csv-header="vm.getCsvHeader()"></button></div>');
$templateCache.put('app/pages/herds/animals/exportAnimals.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover" style="font-size: 14px" id="main-table"><thead><tr class="list-generator-list-header"><th colspan="10"><div class="toggle-group"><span><data-i18n i18n="_animal_youngstock_">Youngstock</data-i18n></span> <span class="material-icons" ng-click="vm.changeExportAnimalsType()">{{vm.exportAnimalsType}}</span> <span><data-i18n i18n="_button_show_all_">Show all</data-i18n></span></div></th></tr><tr class="list-generator-list-header"><th style="text-align: center; padding: 12px"><div style="display: inline-block; padding-right: 4px;" class="filter-checkbox ion-ios-checkmark-outline" ng-click="vm.selectAll(true)"></div><div style="display: inline-block; padding-right: 2px;" class="filter-checkbox ion-ios-circle-outline" ng-click="vm.selectAll(false)"></div></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_on_farm_id_">On Farm ID</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_name_">Name</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_official_id_">Official ID</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_global_id_">Global ID</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_sex_title_">Sex (M or F)</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_breed_">Breed</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_birth_date_">Birth date</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_sire_id17_">Sire ID17</data-i18n></th><th style="text-align: center" align="center"><data-i18n i18n="_animal_dam_id17_">Dam ID17</data-i18n></th></tr></thead><tbody ng-if="!vm.loadingTable" lazy-img-container=""><tr ng-repeat="animal in vm.exportAnimalsList" class="animal-list"><td><div class="filter-checkbox" ng-class="animal.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="animal.selected = !animal.selected"></div></td><td style="text-align: center" align="center">{{animal.NumberString}}</td><td style="text-align: center" align="center">{{animal.Name}}</td><td style="text-align: center" align="center">{{animal.EarTag}}</td><td style="text-align: center" align="center">{{animal.GlobalId}}</td><td style="text-align: center" align="center">{{animal.GenderShort}}</td><td style="text-align: center" align="center">{{animal.Breed}}</td><td style="text-align: center" align="center">{{animal.BirthDate | date:\'shortDate\'}}</td><td style="text-align: center" align="center">{{animal.SireGlobalId}}</td><td style="text-align: center" align="center">{{animal.DamGlobalId}}</td></tr></tbody></table></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/animals/exportPdf.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.exportForm"><div class="form-group"><div class="filter-checkbox" ng-class="vm.includePictures ? \'ion-ios-checkmark-outline\' : \' ion-ios-circle-outline\'" ng-click="vm.includePictures = !vm.includePictures"><span><i18n i18n="_label_include_pictures_">Include pictures</i18n></span></div></div></form></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.pdfError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingModal"><button type="button" class="btn btn-primary" ng-click="vm.exportPdf()"><data-i18n i18n="_label_export_pdf_">export to pdf</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/addNewHerd/addNewHerd.html','<div ng-if="vm.errorOccured" ba-panel=""><div ng-if="!vm.errorMessage"><span class="color-red"><data-i18n i18n="_message_error_">error</data-i18n></span></div></div><div ba-panel="" class="ng-cloak"><div class="panel-group" ng-if="vm.selectedTeam"><form name="vm.herdForm" novalidate="" ng-if="!vm.loading && !vm.successfullyAdded"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.herd_name.$invalid && (vm.herdForm.herd_name.$dirty || vm.herdForm.$submitted)}"><label for="herd_name"><data-i18n i18n="_label_herd_name_">Herd name</data-i18n></label> <input type="text" class="form-control" id="herd_name" name="herd_name" placeholder="{{\'_label_herd_name_\'|i18n}}" ng-model="vm.herdDTO.Name" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_label_herd_name_required_">herd name is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.email.$invalid && (vm.herdForm.email.$dirty || vm.herdForm.$submitted)}"><label for="email"><data-i18n i18n="_label_email_">Email</data-i18n></label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'_label_email_\'|i18n}}" ng-model="vm.herdDTO.Email" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_label_email_required_">Email is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.street_address.$invalid && (vm.herdForm.street_address.$dirty || vm.herdForm.$submitted)}"><label for="street_address"><data-i18n i18n="_label_street_address_">Street address</data-i18n></label> <input type="text" class="form-control" id="street_address" name="street_address" placeholder="{{\'_label_street_address_\'|i18n}}" ng-model="vm.herdDTO.Address.Street" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_label_street_address_required_">street address is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.zip.$invalid && (vm.herdForm.zip.$dirty || vm.herdForm.$submitted)}"><label for="zip"><data-i18n i18n="_label_zip_postal_">Zip / postal code</data-i18n></label> <input type="text" class="form-control" id="zip" name="zip" placeholder="{{\'_label_zip_postal_\'|i18n}}" ng-model="vm.herdDTO.Address.Zip" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_label_zip_postal_required_">zip / postal code is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.city.$invalid && (vm.herdForm.city.$dirty || vm.herdForm.$submitted)}"><label for="city"><data-i18n i18n="_label_city_">City</data-i18n></label> <input type="text" class="form-control" id="city" name="city" placeholder="{{\'_label_city_\'|i18n}}" ng-model="vm.herdDTO.Address.City" required=""><span class="help-block error-block basic-block"><data-i18n i18n="_label_city_required_">city is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.country.$invalid && (vm.herdForm.country.$dirty || vm.herdForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_label_country_">Country</data-i18n></label><ui-select id="country" name="country" ng-required="true" ng-model="vm.selectedCountry" theme="bootstrap" class="select-tags" style="height:20px"><ui-select-match allow-clear="true" placeholder="{{\'_label_select_country_placeholder_\' | i18n}}"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block">{{$select.selected.name}}</div></ui-select-match><ui-select-choices repeat="country in vm.countries | filter: $select.search"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': herd.color}"></div><div style="display: inline-block">{{country.name}}</div></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_label_country_required_">country is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="sync-checkbox" ng-class="vm.setFavorite ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.setFavorite = !vm.setFavorite"><span><data-i18n i18n="_label_enable_sync_to_mobile_">Enable sync to mobile devices</data-i18n></span></div></div></div><div align="right"><button type="submit" class="btn btn-success" ng-click="vm.addNewHerd()"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></form><div ng-if="vm.loading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.successfullyAdded" class="successfully-added-info"><div><data-i18n i18n="_label_herd_added_">Herd successfully added.</data-i18n><span ng-click="vm.init()" ng-if="!vm.setFavoriteError"><data-i18n i18n="_label_add_another_herd_">Add another herd.</data-i18n></span> <span ng-if="vm.setFavoriteError" class="color-red" ng-click="vm.goToMyHerds()"><data-i18n i18n="_message_error_sync_enable_">We have issues with activating sync for added herd. Please try on my herds page.</data-i18n></span></div></div></div><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_message_error_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div>');
$templateCache.put('app/pages/herds/attentionListMRO/attentionListMRO.html','<div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_attention_mro_\'|i18n}}" ba-panel-class="with-scroll"><div include-with-scope="app/pages/herds/attentionListMRO/attentionListMRO.panel.html" ng-if="!vm.loading && vm.selectedHerds.length == 1 && !vm.errorLoading"></div><div class="error-msg-wrapper" ng-if="!vm.loading && vm.errorLoading && vm.selectedHerds.length == 1"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.loading && vm.selectedHerds.length == 1" align="center"><div><div class="loading-animation"></div></div></div><div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div></div></div></div>');
$templateCache.put('app/pages/herds/attentionListMRO/attentionListMRO.panel.html','<div class="row attention-list-header"><div class="pdf-icon pull-right" style="margin-left: 10px"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipPDF}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPDF()"></i></div><div class="pdf-icon pull-right" style="margin-left: 7px"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipExcel}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToExcel()"></i></div></div><div class="table-wrapper-attention-list-mro"><div class="row attention-list-mro"><table class="table"><thead><tr><th class="sticky-col left" id="select" style="z-index: 55555;"><div style="display: inline-block; padding-right: 4px;" class="filter-checkbox ion-ios-checkmark-outline" ng-click="vm.selectAll(true)"></div><div style="display: inline-block; padding-right: 2px;" class="filter-checkbox ion-ios-circle-outline" ng-click="vm.selectAll(false)"></div></th><th class="sticky-col left clickable-column" id="earTag" style="z-index: 55555;" ng-click="vm.sort(\'EarTag\')"><data-i18n i18n="_animal_ear_tag_">Ear tag</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'EarTag_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'EarTag_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col left clickable-column" id="number" style="z-index: 55555;" ng-click="vm.sort(\'Number\')"><data-i18n i18n="_animal_number_">Number</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Number_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Number_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col left clickable-column" id="name" style="z-index: 55555;" ng-click="vm.sort(\'CurrentStatus\')"><data-i18n i18n="_animal_status_">Status</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'CurrentStatus_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'CurrentStatus_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col left clickable-column" id="parity" style="z-index: 55555;" ng-click="vm.sort(\'Parity\')"><data-i18n i18n="_animal_parity_">Parity</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Parity_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Parity_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col left clickable-column" id="lcd" style="z-index: 55555;" ng-click="vm.sort(\'LastCalvingDate\')"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col left clickable-column" id="dim" style="z-index: 55555;" ng-click="vm.sort(\'DIM\')"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th id="mro" class="clickable-column" ng-repeat="date in vm.mroDates" ng-click="vm.sort(date.displayPropertyName)">{{date.date | date:\'shortDate\'}} <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'{{date.displayPropertyName}}_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'{{date.displayPropertyName}}_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="tank" ng-click="vm.sort(\'tankPercentage\')" ng-if="vm.showColumns"><data-i18n i18n="_label_p_tank_">% tank</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'tankPercentage_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'tankPercentage_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="hSCS" ng-click="vm.sort(\'highSCC\')" ng-if="vm.showColumns"><data-i18n i18n="_label_n_high_scc_"># high SCC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'highSCC_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'highSCC_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="hSCSp" ng-click="vm.sort(\'highSCCPrevious\')" ng-if="vm.showColumns"><data-i18n i18n="_label_n_high_scc_previous_"># high SCC previous</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'highSCCPrevious_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'highSCCPrevious_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="CM" ng-click="vm.sort(\'clinicalMastitisCases\')" ng-if="vm.showColumns"><data-i18n i18n="_label_n_clinical_mastitis_"># CM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'clinicalMastitisCases_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'clinicalMastitisCases_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="CMp" ng-click="vm.sort(\'clinicalMastitisCasesPrevious\')" ng-if="vm.showColumns"><data-i18n i18n="_label_n_clinical_mastitis_previous_"># CM previous</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'clinicalMastitisCasesPrevious_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'clinicalMastitisCasesPrevious_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="adviceDate" ng-click="vm.sort(\'advice_2\')" ng-if="vm.showColumns"><data-i18n i18n="_label_advice_">Advice</data-i18n><br>{{vm.mroDates[vm.mroDates.length - 3].date | date:\'shortDate\'}} <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'advice_2_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'advice_2_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="adviceDate" ng-click="vm.sort(\'advice_1\')" ng-if="vm.showColumns"><data-i18n i18n="_label_advice_">Advice</data-i18n><br>{{vm.mroDates[vm.mroDates.length - 2].date | date:\'shortDate\'}} <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'advice_1_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'advice_1_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th><th class="sticky-col right clickable-column" style="z-index: 55555;" id="advice" ng-click="vm.sort(\'advice_0\')" ng-if="vm.showColumns"><data-i18n i18n="_label_advice_">Advice</data-i18n><br>{{vm.mroDates[vm.mroDates.length - 1].date | date:\'shortDate\'}} <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'advice_0_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'advice_0_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></th></tr></thead><tbody><tr ng-repeat="animal in vm.filteredAnimals"><td class="sticky-col left"><div class="filter-checkbox" ng-class="animal.Selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="animal.Selected = !animal.Selected"></div></td><td class="sticky-col left clickable-column" ng-click="vm.goToCow(animal)">{{animal.EarTag}}</td><td class="sticky-col left clickable-column" ng-click="vm.goToCow(animal)">{{animal.Number}}</td><td class="sticky-col left clickable-column animal-status" ng-click="vm.goToCow(animal)"><span>{{animal.Status}}</span>&nbsp;<span>({{animal.StatusDays}})</span></td><td class="sticky-col left">{{animal.Parity}}</td><td class="sticky-col left">{{animal.LastCalvingDate | date:\'shortDate\'}}</td><td class="sticky-col left" id="dim">{{animal.DIM}}</td><td id="mro" ng-repeat="date in vm.mroDates" ng-class="vm.getSCCClass(animal, date)">{{animal[date.propertyName].SCC}}</td><td class="sticky-col right" id="tank" ng-if="vm.showColumns">{{animal.tankPercentage | number:0 }}</td><td class="sticky-col right" id="hSCS" ng-if="vm.showColumns">{{animal.highSCC}}</td><td class="sticky-col right" ng-if="vm.showColumns">{{animal.highSCCPrevious}}</td><td class="sticky-col right" ng-if="vm.showColumns">{{animal.clinicalMastitisCases}}</td><td class="sticky-col right" ng-if="vm.showColumns">{{animal.clinicalMastitisCasesPrevious}}</td><td class="sticky-col right" ng-if="vm.showColumns">{{animal.advice_2.advice ? animal.advice_2.advice.value : \'\'}}</td><td class="sticky-col right" ng-if="vm.showColumns">{{animal.advice_1.advice ? animal.advice_1.advice.value : \'\'}}</td><td class="sticky-col right" id="advice" ng-if="vm.showColumns"><a href="#" editable-select="animal.advice_0.advice" e-ng-options="advice as advice.value for advice in vm.adviceList" onbeforesave="vm.saveAdvice($data, animal.advice_0)">{{animal.advice_0.advice.value || (\'_label_select_advice_\' | i18n)}}</a></td></tr></tbody></table></div></div><div class="attention-list-slider" ng-class="{\'opened\': vm.showColumns}"><div class="slider-body"></div><div class="filter-button" ng-click="vm.showColumns = !vm.showColumns"><i ng-class="{\'ion-arrow-right-b\': vm.showColumns, \'ion-arrow-left-b\': !vm.showColumns}"></i></div></div><div class="attention-list-filter-block" ng-class="{\'open\': vm.showFilterBlock}"><div class="filter-button" ng-click="vm.showFilterBlock = !vm.showFilterBlock"><i ng-class="{\'ion-arrow-right-b\': vm.showFilterBlock, \'ion-arrow-left-b\': !vm.showFilterBlock}"></i></div><div class="filter-body"><ul><li class="list-header"><data-i18n i18n="_dashboards_parameter_parity_categories_">Parity categories</data-i18n></li><li style="margin-top: 10px"><div class="input-group status-date"><ui-select ng-model="vm.selectedParityCategory" theme="selectize" class="select-tags" ng-change="vm.parityCategoryChanged()"><ui-select-match allow-clear="true">{{$select.selected.value }}</ui-select-match><ui-select-choices repeat="parity in vm.parityCategories">{{parity.value}}</ui-select-choices></ui-select></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_parity_">Parity</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.allParities ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectParity({id: 69, value: \'all\'})"><span><data-i18n i18n="_label_all_">All</data-i18n></span></div></li><li ng-repeat="parity in vm.parityList"><div class="filter-checkbox" ng-class="parity.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectParity(parity)"><span>{{parity.value}}</span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_parity_categories_">DIM categories</data-i18n></li><li style="margin-top: 10px"><div class="input-group status-date"><ui-select ng-model="vm.selectedDIMCategory" theme="selectize" class="select-tags" ng-change="vm.DIMCategoryChanged()"><ui-select-match allow-clear="true">{{$select.selected.translatedValue }}</ui-select-match><ui-select-choices repeat="dim in vm.DIMCategories">{{dim.translatedValue }}</ui-select-choices></ui-select></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_dim_categories_">DIM category</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.allDIMs ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDIM({id: 69, value: \'all\'})"><span><data-i18n i18n="_label_all_">All</data-i18n></span></div></li><li ng-repeat="dim in vm.DIMList"><div class="filter-checkbox" ng-class="dim.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDIM(dim)"><span>{{dim.value}}</span></div></li></ul><ul><li><div class="filter-checkbox" ng-class="vm.showDry ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectShowDry()"><span><data-i18n i18n="_label_always_show_dry_animals_">Always show dry animals</data-i18n></span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_cow_scc_treshold_">Cow scc threshold</data-i18n></li><li><div class="status-date-input"><input type="number" min="1" max="2000" step="1" ng-model="vm.cowSCCThreshold" ng-change="vm.thresholdChanged()"></div></li><li style="margin-top: 10px"><div class="inline-checkbox"><div class="filter-checkbox" ng-class="vm.cowLessThan ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'cow\', 1)"><span>&lt</span></div><div class="filter-checkbox" ng-class="vm.cowEqual ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'cow\', 2)"><span>=</span></div><div class="filter-checkbox" ng-class="vm.cowGreaterThan ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'cow\', 3)"><span>&gt</span></div></div></li><li><div class="status-date-input"><input type="number" min="1" max="2000" step="1" ng-model="vm.cowSCCFilterValue" ng-change="vm.thresholdChanged()"></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_heifer_scc_treshold_">Heifers threshold</data-i18n></li><li><div class="status-date-input"><input type="number" min="1" max="2000" step="1" ng-model="vm.heiferSCCThreshold" ng-change="vm.thresholdChanged()"></div></li><li style="margin-top: 10px"><div class="inline-checkbox"><div class="filter-checkbox" ng-class="vm.heiferLessThan ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'heifer\', 1)"><span>&lt</span></div><div class="filter-checkbox" ng-class="vm.heiferEqual ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'heifer\', 2)"><span>=</span></div><div class="filter-checkbox" ng-class="vm.heiferGreaterThan ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.sccFilterChanged(\'heifer\', 3)"><span>&gt</span></div></div></li><li><div class="status-date-input"><input type="number" min="1" max="2000" step="1" ng-model="vm.heiferSCCFilterValue" ng-change="vm.thresholdChanged()"></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_advice_">Advice</data-i18n></li><li style="margin-top: 10px"><div class="input-group status-date"><ui-select ng-model="vm.selectedAdvice" theme="selectize" class="select-tags" ng-change="vm.adviceChanged()"><ui-select-match allow-clear="true">{{$select.selected.value }}</ui-select-match><ui-select-choices repeat="advice in vm.adviceList">{{advice.value}}</ui-select-choices></ui-select></div></li></ul></div></div>');
$templateCache.put('app/pages/herds/dashboards/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboards/custom.modal.html','<div ng-class="vm.getCurrentUserClass()"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.customTimeSelected()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/herds/dashboards/dashboards.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/herds/dashboards/dashboards.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/herds/dashboards/dashboards.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboards/dashboards.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/herds/dashboards/dashboards.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/herds/dashboards/dashboards.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton )">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/dashboards/dashboards.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboards/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/herds/dashboards/dashboards.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/herds/dashboards/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li ng-if="currentPage > 1"><a ng-click="selectPage(1)">&lt;&lt;</a></li><li ng-if="currentPage > 1"><a ng-click="selectPage(currentPage-1)">&lt;</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(currentPage+1)">></a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(numPages)">>></a></li></ul></div>');
$templateCache.put('app/pages/herds/dashboards/panic.modal.html','<div ng-class="vm.getCurrentUserClass()"><div class="modal-header"><h5 class="modal-title"><data-i18n i18n="_label_send_error_info_">Send error info</data-i18n><i class="ion-ios-close-outline close-modal" style="float: right; position: relative; top: -10px; right: -5px" ng-click="vm.closeModal()"></i></h5></div><div class="modal-body" ng-if="!vm.modalLoading"><span style="margin-top: -15px; font-size: 12px" class="help-block basic-block color-red" ng-if="vm.modalError"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.errorInfo.comment" maxlength="150"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.sendErrorInfo()"><data-i18n i18n="_button_send_">Send</data-i18n></button></div></div><div class="modal-body" ng-if="vm.modalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboards/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboards/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/addToReport.modal.html','<div><div class="modal-header" ng-if="!vm.addToReportModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addToReportModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.modalComment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-primary pull-right" ng-click="vm.addToReport()"><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addToReportModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/custom.modal.html','<div ng-class="vm.getCurrentUserClass()"><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" current-text="{{\'_label_today_\' | i18n}}" clear-text="{{\'_label_clear_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.customTimeSelected()"><data-i18n i18n="_label_preview_">preview</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/dashboards.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll no-padding" ng-if="vm.showFrame"><div include-with-scope="app/pages/herds/dashboardsV2/dashboards.panel.html"></div></div><div ng-if="!vm.showFrame"><div include-with-scope="app/pages/herds/dashboardsV2/dashboards.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/dashboards.panel.html','<div class="row" style="margin: 0px" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.showCreateReportBlock"><div class="dashboard-pills"><button ng-repeat="category in vm.allCategories" class="btn btn-sm" ng-class="vm.getBtnClass(category, $index)" ng-click="vm.categorySelected($index, category)" ng-if="category.used">{{category.name}}</button><div class="btn-group" style="display: inline-block; vertical-align: middle" ng-if="!vm.hideTiles && !vm.loadingError"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" href="https://youtu.be/G8mG6L6siUU" target="_blank" style="font-size: 22px; margin-right:10px; padding-top: 3px" ng-if="vm.currentUserType == \'zoetis\' || vm.currentUserType == \'admin\'"></a> <button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div><div class="horizontal-scroll" ng-if="vm.showBaseTable && !vm.loadingBaseTable && !vm.loadingError && !vm.showCreateReportBlock"><div ng-if="vm.selectedLayout == 2" include-with-scope="app/pages/herds/dashboardsV2/dashboards.tiles.html"></div><div ng-if="vm.selectedLayout == 1" include-with-scope="app/pages/herds/dashboardsV2/dashboards.table.html"></div></div><div ng-if="vm.loadingError && !vm.loadingBaseTable" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="vm.showFrame && !vm.showCreateReportBlock" class="dashboards-frame" ng-class="{ \'responsive\': vm.isResponsive }"><div style="text-align: right; padding: 5px 10px; height: 30px;"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto; float: left;" ng-click="vm.openAddToReportModal(vm.lastUsedDashboard, vm.lastUsedDashboard.type)" ng-if="(vm.selectedHerds.length == 1 && vm.lastUsedDashboard && vm.lastUsedDashboard.addToReport && vm.showAddToReportButton && !vm.hideAddToReportButton && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button> <a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="vm.lastUsedDashboard.infoLink" ng-href="{{vm.lastUsedDashboard.infoLink}}" target="_blank"></a><div>({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div></div><div id="frame" class="dashboard-wrapper" ng-if="!vm.errorLoading"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_" ng-if="!vm.dashboardNotAvailable">Error</data-i18n><data-i18n i18n="_message_error_dashboard_not_available_" ng-if="vm.dashboardNotAvailable">Dashboard not available</data-i18n></span> <button class="btn btn-primary" ng-click="vm.reload()" ng-if="!vm.dashboardNotAvailable"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button> <button class="btn btn-primary" ng-click="vm.goBackOnClose()" ng-if="vm.dashboardNotAvailable"><span><data-i18n i18n="_label_close_">Close</data-i18n></span></button></div></div></div><div ng-if="vm.showCreateReportBlock"><div ba-panel="" ba-panel-class="with-scroll"><div class="ios-message" ng-if="vm.safariMobileUsed"><div class="info-icon"><i class="material-icons">info</i></div><div class="message"><data-i18n i18n="_ios_message_safari_"></data-i18n></div></div><div class="report-error-message" ng-if="vm.errorLoadingReports"><data-i18n i18n="_error_message_loading_reports_">There was an error loading reports</data-i18n></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError" class="report-page-header"><div class="input-group report-selector" ng-if="vm.multipleReports"><ui-select ng-model="vm.selectedReport" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.reportSelected()"><ui-select-match allow-clear="true"><span style="margin-right: 3px">Report</span>{{$select.selected.id }}</ui-select-match><ui-select-choices repeat="report in vm.availableReports track by report.id"><span style="margin-right: 3px">Report</span> {{report.id}}</ui-select-choices></ui-select></div><div class="date-selector"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.reportDate" is-open="vm.reportDateOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-change="vm.setReportDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.reportDateOpened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><table class="table report-table"><thead><tr><th><data-i18n i18n="_report_add_to_report_">Add to report</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th class="time-period"><data-i18n i18n="_report_time_period_">Time period</data-i18n></th><th style="text-align: center"><data-i18n i18n="_placeholder_comments_">Comments</data-i18n></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.reportDashboards"><td><div class="filter-checkbox" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="dashboard.selected = !dashboard.selected" ng-if="!dashboard.default"></div><div class="filter-checkbox color-red" ng-class="dashboard.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-if="dashboard.default"></div></td><td>{{dashboard.title}}</td><td class="time-period row" ng-click="vm.openReportDashboardPeriodModal($index)">{{dashboard.start_date | date:\'shortDate\'}} - {{dashboard.end_date | date:\'shortDate\'}}</td>{{dashboard.report_date | date:\'shortDate\'}}<td class="comment" ng-click="vm.openReportCommentModal($index)">{{dashboard.comment}}</td></tr></tbody></table></div><div ng-if="!vm.reportLoading && !vm.herdNotSelected && !vm.reportError"><div class="form-group"><label for="title"><data-i18n i18n="_zts_report_title_">Report title</data-i18n></label> <input type="text" class="form-control" id="title" name="title" placeholder="{{\'_zts_report_title_\' | i18n}}" ng-model="vm.report_title" maxlength="40"></div><div class="form-group"><label><data-i18n i18n="_report_positive_points_">Positive points</data-i18n>:</label> <textarea placeholder="{{\'_report_positive_points_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.positivePoints" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div class="form-group"><label><data-i18n i18n="_report_points_to_improve_">Points to improve</data-i18n>:</label> <textarea placeholder="{{\'_report_points_to_improve_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.pointsToImprove" maxlength="700" onkeydown="return (event.keyCode!=13);"></textarea></div><div><button class="btn btn-success" ng-click="vm.setReportData()" style="float: right"><data-i18n i18n="_report_create_report_">Create report</data-i18n></button></div><div><button class="btn btn-danger" ng-click="vm.closeCreateReport()" style="float: right; margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div><div ng-if="vm.reportLoading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.pdfLoading" style="text-align: center"><span><data-i18n i18n="_report_create_message_">Please wait while the document is being prepared</data-i18n></span><div style="width: 25px; display: inline-block; text-align: left">{{vm.loadingDots}}</div></div><div ng-if="vm.herdNotSelected"><span class="color-red"><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><span class="color-red"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span></div><div ng-if="!vm.reportLoading && vm.reportError"><button class="btn btn-primary" style="line-height: 1px" ng-click="vm.openCreateReport()"><i class="material-icons">replay</i></button></div></div></div><div style="text-align: center" ng-if="vm.loadingBaseTable && !vm.showFrame"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/dashboards.table.html','<table class="table table-limitless dashboards-table" st-table="vm.dashboards" st-safe-src="vm.dashboardsSafe" ng-class="vm.getTableClass()" st-persist="dashboards-table"><thead><tr class="sortable"><th st-sort="category.name"><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th st-sort="title"><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th st-sort="" style="text-align: center"><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th></tr><tr><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable"></th><th style="text-align: right"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead><tbody><tr ng-repeat="dashboard in vm.dashboards"><td style="text-align: left"><span class="info-label" ng-class="[vm.getLabelId(dashboard), vm.activeCategory == $index ? \'btn-info\' : \'\']">{{dashboard.category.name}}</span></td><td>{{dashboard.title}}</td><td style="text-align: right"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin-right: 10px; float: none"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)">{{\'_label_preview_\' | i18n}}</button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 7)"><data-i18n i18n="_label_time_7_days_">7 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 30)"><data-i18n i18n="_label_time_30_days_">30 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 90)"><data-i18n i18n="_label_time_90_days_">90 days</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 1)"><data-i18n i18n="_label_time_1_year_">1 year</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 5)"><data-i18n i18n="_label_time_5_years_">5 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.selectDashboard(dashboard, dashboard.type, true, 10)"><data-i18n i18n="_label_time_10_years_">10 years</data-i18n></button> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-template="app/pages/herds/dashboardsV2/pagination.html" st-pagination="" st-items-by-page="vm.itemsPerPage.value" st-displayed-pages="5"></div><div style="float: right" class="table-select-number-wraper"><label><span><data-i18n i18n="_label_show_">Show</data-i18n>:</span><select class="form-control selectpicker show-tick dropup" selectpicker="" title="" ng-model="vm.itemsPerPage" ng-options="i.label for i in vm.itemsToShow"></select></label></div></td></tr></tfoot></table>');
$templateCache.put('app/pages/herds/dashboardsV2/dashboards.tiles.html','<table class="table table-limitless dashboards-table"><thead><tr class="sortable"><th></th><th><data-i18n i18n="_dashboards_category_">Category</data-i18n></th><th><data-i18n i18n="_dashboards_description_">Description</data-i18n></th><th></th></tr><tr><th style="width: 120px"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchCategoryString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th><input class="input-sm form-control search-input" type="search" ng-model="vm.searchDescriptionString" ng-change="vm.search()" ng-disabled="vm.loadingTable" placeholder="{{\'_placeholder_type_to_filter_\'|i18n}}"></th><th style="text-align: right; width: 120px"><button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openCreateReport()" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && vm.canAddToReport)">{{\'_report_create_report_\' | i18n}}</button></th></tr></thead></table><div ng-repeat="dashboard in vm.dashboardsSafe" class="dashboards-tile-wrapper clearfix"><div class="dashboard-thumbnail image-canvas" ng-class="vm.getDashboardClass(dashboard)" ng-click="vm.selectDashboard(dashboard, dashboard.type, true)"><img src="assets/img/thumbnails/thumbnail.png" lazy-img="{{dashboard.thumbnail}}" lazy-img-error="assets/img/thumbnails/thumbnail.png"></div><div class="dashboard-title">{{dashboard.title}}</div><div class="dashboard-action"><a class="fa fa-info-circle info-video-icon" aria-hidden="true" ng-if="dashboard.infoLink" ng-href="{{dashboard.infoLink}}" target="_blank" style="margin: 0"></a> <button class="status-button btn btn-xs btn-primary btn-dashboards" style="width: auto" ng-click="vm.openAddToReportModal(dashboard, dashboard.type)" ng-if="(!vm.hideTiles && vm.selectedHerds.length == 1 && dashboard.addToReport && vm.canAddToReport)">{{\'_report_add_to_report_\' | i18n}}</button></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li ng-if="currentPage > 1"><a ng-click="selectPage(1)">&lt;&lt;</a></li><li ng-if="currentPage > 1"><a ng-click="selectPage(currentPage-1)">&lt;</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(currentPage+1)">></a></li><li ng-if="currentPage < numPages"><a ng-click="selectPage(numPages)">>></a></li></ul></div>');
$templateCache.put('app/pages/herds/dashboardsV2/panic.modal.html','<div ng-class="vm.getCurrentUserClass()"><div class="modal-header"><h5 class="modal-title"><data-i18n i18n="_label_send_error_info_">Send error info</data-i18n><i class="ion-ios-close-outline close-modal" style="float: right; position: relative; top: -10px; right: -5px" ng-click="vm.closeModal()"></i></h5></div><div class="modal-body" ng-if="!vm.modalLoading"><span style="margin-top: -15px; font-size: 12px" class="help-block basic-block color-red" ng-if="vm.modalError"><data-i18n i18n="_message_error_">Error occurred, please try again.</data-i18n></span><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.errorInfo.comment" maxlength="150"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.sendErrorInfo()"><data-i18n i18n="_button_send_">Send</data-i18n></button></div></div><div class="modal-body" ng-if="vm.modalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/reportComment.modal.html','<div><div class="modal-header" ng-if="!vm.addCommentModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.addCommentModalLoading"><div class="form-group"><label><data-i18n i18n="_placeholder_comments_">Comments</data-i18n>:</label> <textarea placeholder="{{\'_placeholder_comments_\' | i18n}}" class="form-control" style="resize: none" ng-model="vm.selectedReportDashboard.comment"></textarea></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardComment()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.addCommentModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/herds/dashboardsV2/reportRangeSelector.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.selectedReportDashboard.actual"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.report_modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setReportDashboardRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div class="loading-spinner"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/herds/editHerd/editHerd.html','<div ng-if="vm.errorOccured" ba-panel=""><div ng-if="!vm.errorMessage"><span class="color-red"><data-i18n i18n="_message_error_">error</data-i18n></span></div></div><div ng-if="vm.loadingError" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ba-panel="" class="ng-cloak" ng-if="!vm.loadingError"><div class="panel-group"><form name="vm.herdForm" novalidate="" ng-if="!vm.loading && !vm.successfullyAdded"><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.herd_name.$invalid && (vm.herdForm.herd_name.$dirty || vm.herdForm.$submitted)}"><label for="herd_name"><data-i18n i18n="_label_herd_name_">Herd name</data-i18n></label> <input type="text" class="form-control" id="herd_name" name="herd_name" placeholder="{{\'_label_herd_name_\'|i18n}}" ng-model="vm.herdDTO.Name" required="" ng-change="vm.nameChanged = true"> <span class="help-block error-block basic-block"><data-i18n i18n="_label_herd_name_required_">herd name is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.email.$invalid && (vm.herdForm.email.$dirty || vm.herdForm.$submitted)}"><label for="email"><data-i18n i18n="_label_email_">Email</data-i18n></label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'_label_email_\'|i18n}}" ng-model="vm.herdDTO.Email" required=""> <span class="help-block error-block basic-block"><data-i18n i18n="_label_email_required_">Email is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.street_address.$invalid && (vm.herdForm.street_address.$dirty || vm.herdForm.$submitted)}"><label for="street_address"><data-i18n i18n="_label_street_address_">Street address</data-i18n></label> <input type="text" class="form-control" id="street_address" name="street_address" placeholder="{{\'_label_street_address_\'|i18n}}" ng-model="vm.herdDTO.Address.Street" required="" ng-change="vm.addressChanged = true"><span class="help-block error-block basic-block"><data-i18n i18n="_label_street_address_required_">street address is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.zip.$invalid && (vm.herdForm.zip.$dirty || vm.herdForm.$submitted)}"><label for="zip"><data-i18n i18n="_label_zip_postal_">Zip / postal code</data-i18n></label> <input type="text" class="form-control" id="zip" name="zip" placeholder="{{\'_label_zip_postal_\'|i18n}}" ng-model="vm.herdDTO.Address.Zip" required="" ng-change="vm.addressChanged = true"><span class="help-block error-block basic-block"><data-i18n i18n="_label_zip_postal_required_">zip / postal code is required</data-i18n></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.city.$invalid && (vm.herdForm.city.$dirty || vm.herdForm.$submitted)}"><label for="city"><data-i18n i18n="_label_city_">City</data-i18n></label> <input type="text" class="form-control" id="city" name="city" placeholder="{{\'_label_city_\'|i18n}}" ng-model="vm.herdDTO.Address.City" required="" ng-change="vm.addressChanged = true"><span class="help-block error-block basic-block"><data-i18n i18n="_label_city_required_">city is required</data-i18n></span></div></div><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.herdForm.country.$invalid && (vm.herdForm.country.$dirty || vm.herdForm.$submitted)}"><label for="feed_name"><data-i18n i18n="_label_country_">Country</data-i18n></label><ui-select id="country" name="country" ng-required="true" ng-model="vm.selectedCountry" theme="bootstrap" class="select-tags" style="height:20px"><ui-select-match allow-clear="true" placeholder="{{\'_label_select_country_placeholder_\' | i18n}}"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block">{{$select.selected.name}}</div></ui-select-match><ui-select-choices repeat="country in vm.countries | filter: $select.search"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': herd.color}"></div><div style="display: inline-block">{{country.name}}</div></ui-select-choices></ui-select><span class="help-block error-block basic-block"><data-i18n i18n="_label_country_required_">country is required</data-i18n></span></div></div></div><div align="right"><button class="btn btn-danger" ng-click="vm.cancel()" style="margin-right: 10px"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button> <button type="submit" class="btn btn-success" ng-click="vm.saveHerd()"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></form><div ng-if="vm.loading" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.successfullyAdded" class="successfully-added-info"><div><data-i18n i18n="_label_herd_added_">Herd successfully added.</data-i18n><span ng-click="vm.init()"><data-i18n i18n="_label_add_another_herd_">Add another herd.</data-i18n></span></div></div></div></div>');
$templateCache.put('app/pages/herds/listGenerator/addNewDiscussion.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><div ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required="" name="feed_type"><ui-select-match placeholder="{{\'_placeholder_select_herd_\'|i18n}}"><span>{{$select.selected.HerdName}}</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | filter: $select.search"><span ng-bind-html="herd.HerdName"></span></ui-select-choices></ui-select></div><div><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingNewDiscussion"><div class="loading-animation"></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><button type="button" class="btn btn-success" ng-click="vm.addNewDiscussion()"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/listGenerator/exportPdf.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.exportForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_file_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_file_name_\' | i18n}}" ng-model="vm.file_name" required=""></div><span style="margin-top: -15px; font-size: 12px;" class="help-block basic-block color-red" ng-if="vm.file_name.length > 250"><data-i18n i18n="_message_error_file_name_too_long">File name too long</data-i18n></span><div class="form-group"><label for="name"><data-i18n i18n="_label_file_header_">File header</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_file_header_\' | i18n}}" ng-model="vm.file_header" required="" maxlength="135"></div><div class="form-group"><div class="filter-checkbox" ng-class="vm.includePictures ? \'ion-ios-checkmark-outline\' : \' ion-ios-circle-outline\'" ng-click="vm.includePictures = !vm.includePictures"><span><i18n i18n="_label_include_pictures_">Include pictures</i18n></span></div></div></form><div ng-if="vm.showNewDiscussionBlock"><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.pdfError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion && !vm.loadingModal"><button type="button" class="btn btn-primary" ng-click="vm.showNewDiscussion()" ng-if="!vm.showNewDiscussionBlock" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250"><data-i18n i18n="_label_export_pdf_discussion_">export and create discussion</data-i18n></button> <button type="button" class="btn btn-primary" ng-click="vm.exportPdf()" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="!vm.showNewDiscussionBlock"><data-i18n i18n="_label_export_pdf_">export to pdf</data-i18n></button> <button type="button" class="btn btn-success" ng-click="vm.exportPdf(true)" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="vm.showNewDiscussionBlock"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.filter-block.html','<div><div class="hide-filter-button"><i class="ion-arrow-right-b" ng-click="vm.hideFilterBlock()"></i></div><ul><li class="list-header"><data-i18n i18n="_animal_current_status_">current status</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.st_none ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_none\')"><span><data-i18n i18n="_animal_status_none_">None</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_open ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_open\')"><span><data-i18n i18n="_animal_status_open_">Open</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_served ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_served\')"><span><data-i18n i18n="_animal_status_inseminated_">Served</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_not_pregnant ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_not_pregnant\')"><span><data-i18n i18n="_animal_status_not_pregnant_">Not pregnant</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_pregnant ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_pregnant\')"><span><data-i18n i18n="_animal_status_pregnant_">Pregnant</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_barren ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_barren\')"><span><data-i18n i18n="_animal_status_barren_">Barren</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_aborted ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_aborted\')"><span><data-i18n i18n="_animal_status_aborted_">Aborted</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_dry ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_dry\')"><span><data-i18n i18n="_animal_status_dry_">Dry</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_sold ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_sold\')"><span><data-i18n i18n="_animal_status_sold_">Sold</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_dead ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_dead\')"><span><data-i18n i18n="_animal_status_dead_">Dead</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_presume_left ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_presume_left\')"><span><data-i18n i18n="_animal_status_presume_left_">Presume left</data-i18n></span></div></li></ul><ul style="padding-top: 0"><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'s_d\')" ng-class="vm.s_d ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_status_days_">Status days</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="input-group status-date"><ui-select ng-model="vm.selectedStatus" theme="selectize" class="select-tags"><ui-select-match allow-clear="true">{{$select.selected.translated }}</ui-select-match><ui-select-choices repeat="list in vm.selectedStatusList | filter: $select.search track by list.id">{{list.label | i18n}}</ui-select-choices></ui-select></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.s_d_from"></div><div class="status-date-dash">-</div><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.s_d_to"></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addStatusDateRange(1)"></i></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8804;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.s_d_less"></div></div><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8805;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.s_d_greater"></div></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addStatusDateRange(2)"></i></div></li><li><div class="status-date-list-wrapper" ng-if="vm.statusDateList.length>0"><div ng-repeat="item in vm.statusDateList" class="status-date-list-item"><div ng-if="item.type == 1"><span>{{item.from}}</span><span>-</span><span>{{item.to}}</span><span ng-if="item.status != \'st_global\'">({{item.status_label}})</span><span style="font-weight: 900" ng-click="vm.removeFromStatusDateList(item)">x</span></div><div ng-if="item.type == 2"><span ng-if="item.ineq == 1">&#8804;</span><span ng-if="item.ineq == 2">&#8805;</span><span ng-if="item.ineq == 1">{{item.to}}</span><span ng-if="item.ineq == 2">{{item.from}}</span><span ng-if="item.status != \'st_global\'">({{item.status_label}})</span><span style="font-weight: 900" ng-click="vm.removeFromStatusDateList(item)">x</span></div></div></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_parity_">Parity</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.p_zero ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_zero\')"><span>0</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_one ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_one\')"><span>1</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_two ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_two\')"><span>2</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_three_and_more ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_three_and_more\')"><span>3+</span></div></li><li class="filter-parity"><span><div class="filter-checkbox" ng-class="vm.p_custom ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_custom\')" style="display: inline-block"></div><input style="width: 170px; display: inline-block" type="number" min="0" ng-model="vm.custom_parity" ng-change="vm.customParityChanged()"></span></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_days_in_milk_">Days in milk</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.dim_1 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_1\')"><span>&#60;30</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_2 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_2\')"><span>30-60</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_3 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_3\')"><span>60-120</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_4 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_4\')"><span>120-200</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_5 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_5\')"><span>200-305</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_6 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_6\')"><span>&#62;305</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_7 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_7\')"><span><data-i18n i18n="_label_time_custom_">Custom</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.dim_7"><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.dim_7_from"></div><div class="status-date-dash">-</div><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.dim_7_to"></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addDIMRange(1)"></i></div></li><li style="margin-top: 10px" ng-if="vm.dim_7"><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8804;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.dim_7_less"></div></div><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8805;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.dim_7_greater"></div></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addDIMRange(2)"></i></div></li><li><div class="status-date-list-wrapper" ng-if="vm.DIMList.length>0"><div ng-repeat="item in vm.DIMList" class="status-date-list-item"><div ng-if="item.type == 1"><span>{{item.from}}</span><span>-</span><span>{{item.to}}</span><span style="font-weight: 900" ng-click="vm.removeFromDIMList(item)">x</span></div><div ng-if="item.type == 2"><span ng-if="item.ineq == 1">&#8804;</span><span ng-if="item.ineq == 2">&#8805;</span><span ng-if="item.ineq == 1">{{item.to}}</span><span ng-if="item.ineq == 2">{{item.from}}</span><span style="font-weight: 900" ng-click="vm.removeFromDIMList(item)">x</span></div></div></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_age_">Age</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.age_1 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_1\')"><span>&#60;200</span></div></li><li><div class="filter-checkbox" ng-class="vm.age_2 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_2\')"><span>200-400</span></div></li><li><div class="filter-checkbox" ng-class="vm.age_3 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_3\')"><span>&#62;400</span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_tags_">Tags</data-i18n></li><li><div class="input-group" style="max-width: 150px"><ui-select multiple="" ng-model="vm.tags" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px" on-select="vm.tagsChanged()" on-remove="vm.tagsChanged()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li><li style="margin-top: 10px" ng-if="vm.tags.length>0"><div><span><data-i18n i18n="_label_in_last_">In last</data-i18n>:</span><span style="margin-left: 3px">{{vm.selected_tags_slider_value}}</span></div><div class="time-slider"><rzslider rz-slider-model="vm.tag_slider_value" rz-slider-options="vm.tagsSliderOptionsActive"></rzslider></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_picture_to_show_">Picture to show</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_profile\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_profile\')"><span><data-i18n i18n="_label_profile_picture_">profile picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_recent\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_recent\')"><span><data-i18n i18n="_label_most_recent_picture_">Most recent picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_oldest\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_oldest\')"><span><data-i18n i18n="_label_oldest_picture_">Oldest picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_event\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_event\')"><span><data-i18n i18n="_label_event_status_picture_">Event / status picture</data-i18n></span></div></li><ul ng-if="vm.showEventSelector" style="padding-left: 10px; padding-top: 5px"><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_calving\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_calving\')"><span><data-i18n i18n="_label_add_calving_">Add calving</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_colostrum\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_colostrum\')"><span><data-i18n i18n="_label_add_colostrum_">Add colostrum</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_first_milk\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_first_milk\')"><span><data-i18n i18n="_label_add_first_milk_intake_">Add first milk intake</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_exemination\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_exemination\')"><span><data-i18n i18n="_label_add_examination_">Add examination</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_tests\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_tests\')"><span><data-i18n i18n="_label_add_tests_">Add tests</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_milk_m\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_milk_m\')"><span><data-i18n i18n="_label_add_milk_manually_">Add milk manually</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_clinical\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_clinical\')"><span><data-i18n i18n="_label_add_clinical_mastitis_">Add clinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_subclinical\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_subclinical\')"><span><data-i18n i18n="_label_add_subclinical_mastitis_">Add subclinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_misc\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_misc\')"><span><data-i18n i18n="_label_add_miscellaneous_">Add miscellaneous</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_diseases\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_diseases\')"><span><data-i18n i18n="_label_add_diseases_">Add diseases</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_prevention\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_prevention\')"><span><data-i18n i18n="_label_add_prevention_">Add prevention</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_claw_health\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_claw_health\')"><span><data-i18n i18n="_label_add_claw_health_">Add claw health</data-i18n></span></div></li></ul></ul><ul><li class="list-header"><data-i18n i18n="_animal_gender_">Gender</data-i18n></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'g_female\')" ng-class="vm.g_female ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_gender_female_">Female</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'g_male\')" ng-class="vm.g_male ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_gender_male_">Male</data-i18n></span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_show_animals_">Show animals</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.sa_active ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'sa_active\')"><span><data-i18n i18n="_animal_active_">Active</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.sa_history ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'sa_history\')"><span><data-i18n i18n="_animal_historic_">Historic</data-i18n></span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_events_">Events</data-i18n></li><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'al_scc\')" ng-class="vm.al_scc ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_scc_alert_">SCC alert</data-i18n></span></div></li><ul ng-if="vm.al_scc"><li style="display: flex; justify-content: space-between; width: 160px;"><span><data-i18n i18n="_animal_lactation_">Lactation</data-i18n>1</span><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" max="999" step="1" ng-model="vm.l1_scc" ng-change="vm.sccValueChanged()" style="width: 50px;"></div></li><li style="display: flex; justify-content: space-between; width: 160px;"><span><data-i18n i18n="_animal_lactation_">Lactation</data-i18n>>1</span><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" step="999" ng-model="vm.lg1_scc" ng-change="vm.sccValueChanged()" style="width: 50px;"></div></li></ul><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'at_ce_tc\')" ng-class="vm.at_ce_tc ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_clinical_examination_transition_cows_">Clinical examination Transition cows</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'m_a_milk\')" ng-class="vm.m_a_milk ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_manually_added_milk_">Manually added milk</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'h_e_diseases\')" ng-class="vm.h_e_diseases ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_health_event_diseases_">Health events: diseases</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'h_e_prevention\')" ng-class="vm.h_e_prevention ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_health_event_prevention_">Health events: prevention</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'u_h_clinical\')" ng-class="vm.u_h_clinical ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_udder_health_clinical_mastitis_">Udder health: clinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'u_h_subclinical\')" ng-class="vm.u_h_subclinical ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_udder_health_subclinical_mastitis_">Udder health: subclinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'c_h\')" ng-class="vm.c_h ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_claw_health_">Claw health</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.at_newborn || vm.at_ce_tc || vm.m_a_milk || vm.h_e_diseases || vm.h_e_prevention || vm.u_h_clinical || vm.u_h_subclinical || vm.c_h"><div><span><data-i18n i18n="_label_in_last_">In last</data-i18n>:</span><span style="margin-left: 3px">{{vm.selected_slider_value}}</span></div><div class="time-slider"><rzslider rz-slider-model="vm.slider_value" rz-slider-options="vm.sliderOptionsActive"></rzslider></div></li><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'al_mp\')" ng-class="vm.al_mp ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_milk_production_alert_">Milk production alert</data-i18n></span></div></li><ul ng-if="vm.al_mp"><li><div class="filter-checkbox" ng-class="vm.min_dev_p ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.deviationSelected(\'min_dev_p\')"><span>Minimum deviation %</span></div><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" max="100" step="1" ng-model="vm.min_dev_p_value" ng-change="vm.deviationValueChanged()">%</div></li><li><div class="filter-checkbox" ng-class="vm.min_dev_kg ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.deviationSelected(\'min_dev_kg\')"><span>Minimum deviation kg</span></div><div class="status-date-input" style="margin-left: 20px"><input type="number" min="0.1" step="0.1" ng-model="vm.min_dev_kg_value" ng-change="vm.deviationValueChanged()">kg</div></li><li><div class="filter-checkbox" ng-class="vm.dev_t ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_t\')"><span>Today</span></div></li><li><div class="filter-checkbox" ng-class="vm.dev_y ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_y\')"><span>Yesterday</span></div></li><li><div class="filter-checkbox" ng-class="vm.dev_tda ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_tda\')"><span>Two days ago</span></div></li></ul></ul></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.grid.html','<div ng-repeat="animal in vm.animals | unique: \'AnimalId\'" class="animal-wrapper clearfix pointer" ng-click="vm.selectAnimal(animal)"><div class="animal-remove-icon" ng-click="vm.removeAnimal($index)"><i class="ion-ios-close-outline"></i></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)"><img src="assets/img/logo.png" lazy-img="{{animal.PictureToShow.T}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureToShow.T && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T || vm.hideImage"></div><div class="image-legend"><div class="image-who">{{::animal.EarTag}}</div><div class="image-when">{{::animal.NumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::animal.Name}}</div><div class="image-who"><span>{{::animal.CurrentStatusString}}</span><span>&#32({{::animal.DateString}})</span></div><div class="image-who" ng-if="::animal.Parity>0"><span><data-i18n i18n="_animal_parity_">Parity</data-i18n>:&#32</span><span>{{::animal.Parity}}</span><span>&#32-&#32<data-i18n i18n="_animal_dim_">DIM</data-i18n>:&#32</span><span>{{::animal.DIM}}</span></div></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.panel.html"></div></div><div class="error-msg-wrapper" ng-if="!vm.loading && vm.errorLoading"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd && !vm.errorLoading"><div class="lists-header"><div class="lists-header-item search-box"><div class="input-group"><span class="input-group-addon search-options-button" style="padding: 0px; font-size:20px" ng-click="vm.showSearchSetings = !vm.showSearchSetings"><i class="material-icons">add_circle</i></span> <input type="text" class="form-control" placeholder="{{\'_label_add_animal_to_list_\'|i18n}}" ng-model="vm.animal_search_string" ng-change="vm.animalSearchChanged()"></div><div class="search-options-box" ng-if="vm.showSearchSetings"><div><div class="filter-checkbox" ng-class="vm.searchByEarTag ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'ear_tag\')"><span><data-i18n i18n="_label_search_by_ear_tag_">Search by ear tag</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByNumber ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'number\')"><span><data-i18n i18n="_label_search_by_number_">Search by number</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByName ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'name\')"><span><data-i18n i18n="_label_search_by_name_">Search by name</data-i18n></span></div></div></div></div><div class="lists-header-item shortcut-items" id="shortcuts"><div class="shortcut-button" ng-if="vm.showShortcutItems" ng-repeat="button in vm.predefinedButtonsList"><div class="list-shortcut" ng-click="vm.selectPredefinedList(button)" ng-class="vm.selectedPredefinedList == button.id? \'selected\' : \'\'"><div>{{button.translated}}</div></div></div><div class="shortcut-selector" ng-if="vm.showShortcutItems"><div class="input-group"><ui-select ng-model="vm.selectedListModel" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.selectedPickerList()"><ui-select-match allow-clear="true">{{$select.selected.translated }}</ui-select-match><ui-select-choices repeat="list in vm.predefinedPickerList | filter: $select.search track by list.id">{{list.translated}}</ui-select-choices></ui-select></div></div></div><div class="lists-header-item export-view-box"><div style="display: inline-block; vertical-align: middle; margin-right: 5px; text-align: right" class="export-pdf-button" ng-click="vm.openExportModal()"><i class="fa fa-file-pdf-o"></i></div><div class="btn-group" style="display: inline-block"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div></div><div class="row" ng-if="!vm.loading && vm.selectedHerd && !vm.errorLoading" style="margin: -12px -12px"><div class="list-generator-images" ng-if="vm.selectedLayout == 1 && vm.showSearchResults" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.search-results.table.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 1" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.table.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 2 && vm.showSearchResults" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.search-results.grid.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 2" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.grid.html"></div></div><div class="list-generator-filter-block" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGenerator/listGenerator.filter-block.html" style="width: 250px"></div></div><div class="show-filter-button" ng-if="!vm.showFilterBlock" ng-click="vm.hideFilterBlock()"><i class="ion-arrow-left-b"></i></div></div><div ng-if="vm.showPagination && !vm.loading && vm.selectedHerd && !vm.errorLoading" style="text-align: center; margin-top: 20px;" class="row"><ul uib-pagination="" boundary-links="true" total-items="vm.totalAnimals" ng-model="vm.currentPage" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" max-size="5" ng-change="vm.paginationChanged()" items-per-page="100"></ul></div><div class="row" ng-if="vm.loading && !vm.errorLoading" style="text-align: center"><div class="loading-animation"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd"><div><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.search-results.grid.html','<div><data-i18n i18n="_label_search_results_">Search results</data-i18n></div><div ng-repeat="animal in vm.searchAnimals" class="animal-wrapper clearfix search-result-grid"><div class="animal-remove-icon blue" ng-click="vm.addAnimal($index, animal)"><i class="ion-android-add"></i></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)"><img ng-src="{{animal.PictureToShow.T}}" ng-if="animal.PictureToShow.T"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T"></div><div class="image-legend"><div class="image-who">{{::animal.EarTag}}</div><div class="image-when">{{::animal.NumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::animal.Name}}</div><div class="image-who"><span>{{::animal.CurrentStatusString}}</span><span>&#32({{::animal.DateString}})</span></div><div class="image-who" ng-if="::animal.Parity>0"><span><data-i18n i18n="_animal_parity_">Parity</data-i18n>:&#32</span><span>{{::animal.Parity}}</span><span>&#32-&#32<data-i18n i18n="_animal_dim_">DIM</data-i18n>:&#32</span><span>{{::animal.DIM}}</span></div></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.search-results.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover search-result-table" style="font-size:14px"><thead><tr class="list-generator-list-header"><th style="min-width: 20px; width: 20px; text-align: left; color: #a28c12" colspan="2"></th><th style="text-align: center" align="center" ng-click="vm.sort(\'Number\')"><div class="with-hover-effect"><data-i18n i18n="_animal_number_">Animal number</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Number_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Number_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div ng-click="vm.sort(\'Name\')" class="with-hover-effect"><data-i18n i18n="_animal_name_">Animal name</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'EarTag\')" class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Animal ear tag</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'EarTag_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'EarTag_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'BirthDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'BirthDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BirthDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div class="with-hover-effect" ng-click="vm.sort(\'CurrentStatusString\')"><data-i18n i18n="_animal_status_">Status</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'CurrentStatusString_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'CurrentStatusString_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'StatusDate\')"><data-i18n i18n="_animal_status_days_">Status days</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'StatusDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'StatusDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'Parity\')"><div class="with-hover-effect"><data-i18n i18n="_animal_parity_">Parity</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Parity_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Parity_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div ng-click="vm.sort(\'LastCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'LastCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'LastHeatInseminationDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_last_heat_">Last heat</data-i18n>/<i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'LastHeatInseminationDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastHeatInseminationDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_insemination_date_">insemination date</data-i18n></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'ExpectedDryDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_dry_off_date_">Dry off date</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'ExpectedDryDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedDryDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="animal in vm.searchAnimals"><td style="min-width: 20px; width: 20px"><div ng-click="vm.addAnimal($index, animal)" class="animal-remove-icon-list blue"><i class="ion-android-add" style="font-size: 30px"></i></div></td><td><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" style="margin-top:0px"><img ng-src="{{animal.PictureToShow.T}}" ng-if="animal.PictureToShow.T"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T"></div></div></td><td style="text-align: center">{{::animal.NumberString}}</td><td style="text-align: center"><div>{{::animal.Name}}</div><div>{{::animal.EarTag}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.BirthDate | date: \'shortDate\'}}</td><td style="text-align: center"><div>{{::animal.CurrentStatusString}}</div><div>{{::animal.DateString}}</div><div>{{::animal.StatusDays}}</div></td><td style="text-align: center">{{::animal.Parity}}</td><td style="text-align: center"><div>{{::animal.LastCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.LastHeatInseminationDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.ExpectedDryDate | date: \'shortDate\'}}</td></tr></tbody></table></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/listGenerator/listGenerator.table.html','<div class="horizontal-scroll list-generator-table-panel" ng-if="!vm.loading" ng-class="vm.showFilterBlock ? \'\' : \'fit-to-screen\'" lazy-img-container=""><table class="table table-hover fixed_headers" style="font-size: 14px" id="lg_table" ng-if="vm.showTable"><thead><tr class="list-generator-list-header"><th></th><th style="text-align: center; padding: 12px"><button class="btn btn-primary btn-xs" ng-click="vm.emptyList()"><data-i18n i18n="_label_empty_list_">Empty List</data-i18n></button></th><th class="animal_number" style="text-align: center" align="center" ng-click="vm.sort(\'Number\')"><div class="with-hover-effect"><data-i18n i18n="_animal_number_">Animal number</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Number_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Number_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_name" style="text-align: center" align="center"><div ng-click="vm.sort(\'Name\')" class="with-hover-effect"><data-i18n i18n="_animal_name_">Animal name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'EarTag\')" class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Animal ear tag</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'EarTag_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'EarTag_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_dof" style="text-align: center" align="center" ng-click="vm.sort(\'BirthDate\')" ng-if="vm.selectedPredefinedList != \'milk_production_7_days\'"><div class="with-hover-effect"><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'BirthDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BirthDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_age" style="text-align: center" align="center" ng-click="vm.sort(\'Age\')" ng-if="vm.selectedPredefinedList == \'female_youngstock\' || vm.selectedPredefinedList == \'heifers_to_be_inseminated\'"><div class="with-hover-effect"><data-i18n i18n="_animal_age_">Age</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'AgeDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'AgeDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_status" style="text-align: center" align="center"><div class="with-hover-effect" ng-click="vm.sort(\'CurrentStatusString\')"><data-i18n i18n="_animal_status_">Status</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'CurrentStatusString_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'CurrentStatusString_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'StatusDate\')"><data-i18n i18n="_animal_status_days_">Status days</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'StatusDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'StatusDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_days_pregnant" style="text-align: center" align="center" ng-click="vm.sort(\'DaysSinceLastHI\')" ng-if="vm.selectedPredefinedList == \'calving_attentions\'"><div class="with-hover-effect"><data-i18n i18n="_animal_days_pregnant_">Days pregnant</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DaysSinceLastHI_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DaysSinceLastHI_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_days_dry" style="text-align: center" align="center" ng-click="vm.sort(\'DaysDry\')" ng-if="vm.selectedPredefinedList == \'calving_attentions\'"><div class="with-hover-effect"><data-i18n i18n="_animal_days_dry_">Days dry</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DaysDry_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DaysDry_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_parity" style="text-align: center" align="center" ng-click="vm.sort(\'Parity\')"><div class="with-hover-effect"><data-i18n i18n="_animal_parity_">Parity</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Parity_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Parity_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_lcd" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList != \'female_youngstock\' && vm.selectedPredefinedList != \'heifers_to_be_inseminated\' && vm.selectedPredefinedList != \'calving_attentions\'"><div ng-click="vm.sort(\'LastCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-if="vm.selectedPredefinedList != \'transition_cows\' && vm.selectedPredefinedList != \'attention_list_milk_production\' && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'female_youngstock\' && !vm.u_h_clinical && !vm.u_h_subclinical && vm.selectedPredefinedList != \'milk_production_7_days\'"><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.KgMilk\')"><data-i18n i18n="_label_last_mro_">Last MRO</data-i18n>/ <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMilkRecording.KgMilk_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMilkRecording.KgMilk_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_label_milk_meter_">Milk meter</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'attention_list_scc\' || vm.al_scc"><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.SCC\')"><data-i18n i18n="_label_last_mro_">Last MRO</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.SCC\')"><data-i18n i18n="_animal_scc_">SCC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMilkRecording.SCC_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMilkRecording.SCC_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_ecd" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'calving_attentions\'"><div ng-click="vm.sort(\'ExpectedCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_expected_calving_date_">Expected calving date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ExpectedCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'transition_cows\' || vm.selectedPredefinedList == \'attention_list_milk_production\' || ((vm.u_h_clinical || vm.u_h_subclinical) && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'milk_production_7_days\')"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_calendar_daily_">Daily</data-i18n></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'attention_list_milk_production\'"><div class="with-hover-effect"><data-i18n i18n="_label_deviation_">Deviation</data-i18n>Kg</div><div style="min-height: 24px"></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'attention_list_milk_production\'"><div class="with-hover-effect"><data-i18n i18n="_label_deviation_">Deviation</data-i18n>%</div><div style="min-height: 24px"></div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilk[2].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[2].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[2].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.two_days_ago | date:\'shortDate\'}}</div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilk[1].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[1].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[1].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.yesterday | date:\'shortDate\'}}</div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div class="with-hover-effec" ng-click="vm.sort(\'LastWeekMilk[0].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[0].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[0].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.today | date:\'shortDate\'}}</div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_calendar_daily_">Daily</data-i18n></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_mas_case" style="text-align: center" align="center" ng-if="vm.u_h_clinical || vm.u_h_subclinical" ng-click="vm.sort(\'NrMastCurLact\')"><div class="with-hover-effect"><data-i18n i18n="_animal_mastitis_case_">Mastitis case</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'NrMastCurLact_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'NrMastCurLact_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_last_mas" style="text-align: center" align="center" ng-if="vm.u_h_clinical || vm.u_h_subclinical" ng-click="vm.sort(\'LastMastitis\')"><div class="with-hover-effect"><data-i18n i18n="_label_last_">Last</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div><div class="with-hover-effect"><data-i18n i18n="_animal_mastitis_case_">Mastitis case</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMastitis_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMastitis_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_lhid" style="text-align: center" align="center" ng-click="vm.sort(\'LastHeatInseminationDate\')" ng-if="vm.selectedPredefinedList != \'transition_cows\' && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'milk_production_7_days\'"><div class="with-hover-effect"><data-i18n i18n="_animal_last_heat_">Last heat</data-i18n>/<i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastHeatInseminationDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastHeatInseminationDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_insemination_date_">insemination date</data-i18n></div></th><th class="animal_noi" style="text-align: center" align="center" ng-click="vm.sort(\'NumberOfInseminations\')" ng-if="(vm.st_not_pregnant || vm.st_served) && vm.selectedPredefinedList != \'milk_production_7_days\'"><div class="with-hover-effect"><data-i18n i18n="_animal_number_of_">Number of</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'NumberOfInseminations_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'NumberOfInseminations_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_inseminations_">inseminations</data-i18n></div></th><th class="animal_dod" style="text-align: center" align="center" ng-click="vm.sort(\'ExpectedDryDate\')" ng-if="(vm.selectedPredefinedList == \'dry_cow_attention\' || vm.selectedPredefinedList == \'calving_attentions\') && !vm.st_not_pregnant"><div class="with-hover-effect"><data-i18n i18n="_label_predicted_">Predicted</data-i18n></div><div class="with-hover-effect"><data-i18n i18n="_animal_dry_off_date_">Dry off date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ExpectedDryDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedDryDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_bull_name" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'female_youngstock\' || vm.selectedPredefinedList == \'heifers_to_be_inseminated\' || vm.selectedPredefinedList == \'preg_check\' || vm.selectedPredefinedList == \'dry_cow_attention\' || vm.selectedPredefinedList == \'calving_attentions\'" ng-click="vm.sort(\'BreedingBull\')"><div class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Ear tag</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'BreedingBull_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BreedingBull_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect"><data-i18n i18n="_animal_bull_name_">Bull name</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'" ng-click="vm.sort(\'MilkSort\')"><div class="with-hover-effect"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'MilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'MilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px; text-transform: lowercase"><data-i18n i18n="_label_today_">Today</data-i18n></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-1</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-2</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-3</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-4</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-5</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-6</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div>t-7</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'"><div class="with-hover-effect"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'MilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'MilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px; text-transform: lowercase"><data-i18n i18n="_animal_details_average_value_">Average</data-i18n></div></th><th class="animal_com" style="text-align: center"><div><data-i18n i18n="_dc_comments_"></data-i18n></div><div style="min-height: 24px"></div></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="animal in vm.animals | unique: \'AnimalId\'"><td><div ng-click="vm.removeAnimal($index, animal)" class="animal-remove-icon-list"><i class="ion-ios-close-outline"></i></div></td><td><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectAnimal(animal)" ng-class="vm.getAnimalClass(animal)" style="margin-top: 0px"><img src="assets/img/logo.png" lazy-img="{{animal.PictureToShow.T}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureToShow.T && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T || vm.hideImage"></div></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_number pointer">{{::animal.NumberString}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_name pointer"><div>{{::animal.Name}}</div><div>{{::animal.EarTag}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_dof pointer" ng-if="vm.selectedPredefinedList != \'milk_production_7_days\'">{{::animal.BirthDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_age pointer" ng-if="vm.selectedPredefinedList == \'female_youngstock\' || vm.selectedPredefinedList == \'heifers_to_be_inseminated\'">{{::animal.Age}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_status pointer"><div>{{::animal.CurrentStatusString}}<span style="margin-left: 3px">({{::animal.DateString}})</span></div><div>{{::animal.StatusDays}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_days_pregnant pointer" ng-if="vm.selectedPredefinedList == \'calving_attentions\'">{{::animal.DaysSinceLastHI}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_days_dry pointer" ng-if="vm.selectedPredefinedList == \'calving_attentions\'">{{::animal.DaysDry}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_parity pointer">{{::animal.Parity}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_lcd pointer" ng-if="vm.selectedPredefinedList != \'female_youngstock\' && vm.selectedPredefinedList != \'heifers_to_be_inseminated\' && vm.selectedPredefinedList != \'calving_attentions\'"><div>{{::animal.LastCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" ng-if="vm.selectedPredefinedList != \'transition_cows\' && vm.selectedPredefinedList != \'attention_list_milk_production\' && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'female_youngstock\' && !vm.u_h_clinical && !vm.u_h_subclinical && vm.selectedPredefinedList != \'milk_production_7_days\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[3].v">{{::animal.LastWeekMilk[3].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[3].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[4].v">{{::animal.LastWeekMilk[4].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[4].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[5].v">{{::animal.LastWeekMilk[5].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[5].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[6].v">{{::animal.LastWeekMilk[6].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[6].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[7].v">{{::animal.LastWeekMilk[7].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[7].d | date: \'shortDate\'}})</span></div><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div><div ng-if="!animal.LastWeekMilk && animal.LastMilkRecording">{{::animal.LastMilkRecording.KgMilk}}<span style="margin-left: 3px">({{::animal.LastMilkRecording.Date | date: \'shortDate\'}})</span></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" ng-if="vm.selectedPredefinedList == \'attention_list_scc\' || vm.al_scc"><div style="display: inline-block">{{::animal.LastMilkRecording.SCC}}</div>&nbsp;<div style="display: inline-block">({{::animal.LastMilkRecording.Date | date: \'shortDate\'}})</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_ecd pointer" ng-if="vm.selectedPredefinedList == \'calving_attentions\'"><div>{{::animal.ExpectedCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.selectedPredefinedList == \'transition_cows\' || vm.selectedPredefinedList == \'attention_list_milk_production\' || ((vm.u_h_clinical || vm.u_h_subclinical) && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'milk_production_7_days\')"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[3].v">{{::animal.LastWeekMilk[3].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[3].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[4].v">{{::animal.LastWeekMilk[4].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[4].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[5].v">{{::animal.LastWeekMilk[5].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[5].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[6].v">{{::animal.LastWeekMilk[6].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[6].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[7].v">{{::animal.LastWeekMilk[7].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[7].d | date: \'shortDate\'}})</span></div><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div><div ng-if="!animal.LastWeekMilk && animal.LastManualMilkDate"><data-i18n i18n="_animal_manually_added_milk_"></data-i18n><span style="margin-left: 3px"><br>({{::animal.LastManualMilkDate | date: \'shortDate\'}})</span></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.selectedPredefinedList == \'attention_list_milk_production\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].dev_kg">{{::animal.LastWeekMilk[0].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].dev_kg">{{::animal.LastWeekMilk[1].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].dev_kg">{{::animal.LastWeekMilk[2].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.selectedPredefinedList == \'attention_list_milk_production\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].dev_percent">{{::animal.LastWeekMilk[0].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].dev_percent">{{::animal.LastWeekMilk[1].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].dev_percent">{{::animal.LastWeekMilk[2].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.selectedPredefinedList == \'daily_milk_production\'"><div ng-if="animal.LastWeekMilk"><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_mas_case pointer" ng-if="vm.u_h_clinical || vm.u_h_subclinical"><div>{{::animal.NrMastCurLact}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_last_mas pointer" ng-if="vm.u_h_clinical || vm.u_h_subclinical">{{::animal.LastMastitis | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_lhid pointer" ng-if="vm.selectedPredefinedList != \'transition_cows\' && vm.selectedPredefinedList != \'daily_milk_production\' && vm.selectedPredefinedList != \'milk_production_7_days\'">{{::animal.LastHeatInseminationDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_noi pointer" ng-if="(vm.st_not_pregnant || vm.st_served) && vm.selectedPredefinedList != \'milk_production_7_days\'">{{::animal.NumberOfInseminations }}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_dod pointer" ng-if="(vm.selectedPredefinedList == \'dry_cow_attention\' || vm.selectedPredefinedList == \'calving_attentions\') && !vm.st_not_pregnant">{{::animal.ExpectedDryDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_bull_name pointer" ng-if="vm.selectedPredefinedList == \'female_youngstock\' || vm.selectedPredefinedList == \'heifers_to_be_inseminated\' || vm.selectedPredefinedList == \'preg_check\' || vm.selectedPredefinedList == \'dry_cow_attention\' || vm.selectedPredefinedList == \'calving_attentions\'"><div>{{::animal.BreedingBull }}</div></td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[0].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[1].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[2].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[3].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[4].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[5].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[6].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.LastWeekMilk[7].v}}</td><td style="text-align: center" ng-if="vm.selectedPredefinedList == \'milk_production_7_days\'">{{::animal.Avg_MP| number : 2}}</td><td class="animal_com" style="text-align: center"><i class="material-icons add-comment-icon" ng-click="vm.openNewDiscussionModal(animal)" style="font-size: 30px" ng-if="!animal.Comments">message</i><div>{{animal.Comments}}</div></td></tr></tbody></table></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/listGenerator/saveList.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.saveListForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_list_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_list_name_\' | i18n}}" ng-model="vm.list_name" required="" maxlength="50"></div></form></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.saveListError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.loadingModal"><button type="button" class="btn btn-primary" ng-click="vm.saveList()" ng-disabled="!vm.list_name || vm.list_name.length == 0"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/addNewDiscussion.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><div ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required="" name="feed_type"><ui-select-match placeholder="{{\'_placeholder_select_herd_\'|i18n}}"><span>{{$select.selected.HerdName}}</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | filter: $select.search"><span ng-bind-html="herd.HerdName"></span></ui-select-choices></ui-select></div><div><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingNewDiscussion"><div class="loading-animation"></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><button type="button" class="btn btn-success" ng-click="vm.addNewDiscussion()"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/exportPdf.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.exportForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_file_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_file_name_\' | i18n}}" ng-model="vm.file_name" required=""></div><span style="margin-top: -15px; font-size: 12px;" class="help-block basic-block color-red" ng-if="vm.file_name.length > 250"><data-i18n i18n="_message_error_file_name_too_long">File name too long</data-i18n></span><div class="form-group"><label for="name"><data-i18n i18n="_label_file_header_">File header</data-i18n></label> <input type="text" class="form-control" placeholder="{{\'_label_file_header_\' | i18n}}" ng-model="vm.file_header" required="" maxlength="135"></div><div class="form-group"><div class="filter-checkbox" ng-class="vm.includePictures ? \'ion-ios-checkmark-outline\' : \' ion-ios-circle-outline\'" ng-click="vm.includePictures = !vm.includePictures"><span><i18n i18n="_label_include_pictures_">Include pictures</i18n></span></div></div></form><div ng-if="vm.showNewDiscussionBlock"><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.pdfError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion && !vm.loadingModal"><button type="button" class="btn btn-primary" ng-click="vm.showNewDiscussion()" ng-if="!vm.showNewDiscussionBlock" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250"><data-i18n i18n="_label_export_pdf_discussion_">export and create discussion</data-i18n></button> <button type="button" class="btn btn-primary" ng-click="vm.exportPdf()" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="!vm.showNewDiscussionBlock"><data-i18n i18n="_label_export_pdf_">export to pdf</data-i18n></button> <button type="button" class="btn btn-success" ng-click="vm.exportPdf(true)" ng-disabled="!vm.file_name || vm.file_name== \'\' || vm.file_name.lenght == 0 || vm.file_name.length > 250" ng-if="vm.showNewDiscussionBlock"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.filter-block.html','<div><div class="hide-filter-button"><i class="ion-arrow-right-b" ng-click="vm.hideFilterBlock()"></i></div><ul><li class="list-header"><data-i18n i18n="_animal_current_status_">current status</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.st_none ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_none\')"><span><data-i18n i18n="_animal_status_none_">None</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_open ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_open\')"><span><data-i18n i18n="_animal_status_open_">Open</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_served ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_served\')"><span><data-i18n i18n="_animal_status_inseminated_">Served</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_not_pregnant ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_not_pregnant\')"><span><data-i18n i18n="_animal_status_not_pregnant_">Not pregnant</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_pregnant ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_pregnant\')"><span><data-i18n i18n="_animal_status_pregnant_">Pregnant</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_barren ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_barren\')"><span><data-i18n i18n="_animal_status_barren_">Barren</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_aborted ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_aborted\')"><span><data-i18n i18n="_animal_status_aborted_">Aborted</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_dry ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_dry\')"><span><data-i18n i18n="_animal_status_dry_">Dry</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_sold ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_sold\')"><span><data-i18n i18n="_animal_status_sold_">Sold</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_dead ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_dead\')"><span><data-i18n i18n="_animal_status_dead_">Dead</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.st_presume_left ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'st_presume_left\')"><span><data-i18n i18n="_animal_status_presume_left_">Presume left</data-i18n></span></div></li></ul><ul style="padding-top: 0"><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'s_d\')" ng-class="vm.s_d ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_status_days_">Status days</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="input-group status-date"><ui-select ng-model="vm.selectedStatus" theme="selectize" class="select-tags"><ui-select-match allow-clear="true">{{$select.selected.translated }}</ui-select-match><ui-select-choices repeat="list in vm.selectedStatusList | filter: $select.search track by list.id">{{list.label | i18n}}</ui-select-choices></ui-select></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.s_d_from"></div><div class="status-date-dash">-</div><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.s_d_to"></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addStatusDateRange(1)"></i></div></li><li style="margin-top: 10px" ng-if="vm.s_d"><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8804;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.s_d_less"></div></div><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8805;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.s_d_greater"></div></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addStatusDateRange(2)"></i></div></li><li><div class="status-date-list-wrapper" ng-if="vm.statusDateList.length>0"><div ng-repeat="item in vm.statusDateList" class="status-date-list-item"><div ng-if="item.type == 1"><span>{{item.from}}</span><span>-</span><span>{{item.to}}</span><span ng-if="item.status != \'st_global\'">({{item.status_label}})</span><span style="font-weight: 900" ng-click="vm.removeFromStatusDateList(item)">x</span></div><div ng-if="item.type == 2"><span ng-if="item.ineq == 1">&#8804;</span><span ng-if="item.ineq == 2">&#8805;</span><span ng-if="item.ineq == 1">{{item.to}}</span><span ng-if="item.ineq == 2">{{item.from}}</span><span ng-if="item.status != \'st_global\'">({{item.status_label}})</span><span style="font-weight: 900" ng-click="vm.removeFromStatusDateList(item)">x</span></div></div></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_parity_">Parity</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.p_zero ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_zero\')"><span>0</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_one ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_one\')"><span>1</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_two ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_two\')"><span>2</span></div></li><li><div class="filter-checkbox" ng-class="vm.p_three_and_more ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_three_and_more\')"><span>3+</span></div></li><li class="filter-parity"><span><div class="filter-checkbox" ng-class="vm.p_custom ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'p_custom\')" style="display: inline-block"></div><input style="width: 170px; display: inline-block" type="number" min="0" ng-model="vm.custom_parity" ng-change="vm.customParityChanged()"></span></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_days_in_milk_">Days in milk</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.dim_1 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_1\')"><span>&#60;30</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_2 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_2\')"><span>30-60</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_3 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_3\')"><span>60-120</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_4 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_4\')"><span>120-200</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_5 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_5\')"><span>200-305</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_6 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_6\')"><span>&#62;305</span></div></li><li><div class="filter-checkbox" ng-class="vm.dim_7 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'dim_7\')"><span><data-i18n i18n="_label_time_custom_">Custom</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.dim_7"><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.dim_7_from"></div><div class="status-date-dash">-</div><div class="status-date-input"><input type="number" min="1" step="1" ng-model="vm.dim_7_to"></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addDIMRange(1)"></i></div></li><li style="margin-top: 10px" ng-if="vm.dim_7"><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8804;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.dim_7_less"></div></div><div class="status-date-group"><div class="input-group status-date"><span class="input-group-addon addon-left">&#8805;</span> <input type="number" class="form-control" min="1" step="1" ng-model="vm.dim_7_greater"></div></div><div class="status-date-add"><i class="ion-ios-plus" ng-click="vm.addDIMRange(2)"></i></div></li><li><div class="status-date-list-wrapper" ng-if="vm.DIMList.length>0"><div ng-repeat="item in vm.DIMList" class="status-date-list-item"><div ng-if="item.type == 1"><span>{{item.from}}</span><span>-</span><span>{{item.to}}</span><span style="font-weight: 900" ng-click="vm.removeFromDIMList(item)">x</span></div><div ng-if="item.type == 2"><span ng-if="item.ineq == 1">&#8804;</span><span ng-if="item.ineq == 2">&#8805;</span><span ng-if="item.ineq == 1">{{item.to}}</span><span ng-if="item.ineq == 2">{{item.from}}</span><span style="font-weight: 900" ng-click="vm.removeFromDIMList(item)">x</span></div></div></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_age_">Age</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.age_1 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_1\')"><span>&#60;200</span></div></li><li><div class="filter-checkbox" ng-class="vm.age_2 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_2\')"><span>200-400</span></div></li><li><div class="filter-checkbox" ng-class="vm.age_3 ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'age_3\')"><span>&#62;400</span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_tags_">Tags</data-i18n></li><li><div class="input-group" style="max-width: 150px"><ui-select multiple="" ng-model="vm.tags" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px" on-select="vm.tagsChanged()" on-remove="vm.tagsChanged()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li><li style="margin-top: 10px" ng-if="vm.tags.length>0"><div><span><data-i18n i18n="_label_in_last_">In last</data-i18n>:</span><span style="margin-left: 3px">{{vm.selected_tags_slider_value}}</span></div><div class="time-slider"><rzslider rz-slider-model="vm.tag_slider_value" rz-slider-options="vm.tagsSliderOptionsActive"></rzslider></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_picture_to_show_">Picture to show</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_profile\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_profile\')"><span><data-i18n i18n="_label_profile_picture_">profile picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_recent\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_recent\')"><span><data-i18n i18n="_label_most_recent_picture_">Most recent picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_oldest\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_oldest\')"><span><data-i18n i18n="_label_oldest_picture_">Oldest picture</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.pictureFilter == \'p_event\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectPictureFilter(\'p_event\')"><span><data-i18n i18n="_label_event_status_picture_">Event / status picture</data-i18n></span></div></li><ul ng-if="vm.showEventSelector" style="padding-left: 10px; padding-top: 5px"><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_calving\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_calving\')"><span><data-i18n i18n="_label_add_calving_">Add calving</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_colostrum\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_colostrum\')"><span><data-i18n i18n="_label_add_colostrum_">Add colostrum</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_first_milk\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_first_milk\')"><span><data-i18n i18n="_label_add_first_milk_intake_">Add first milk intake</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_exemination\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_exemination\')"><span><data-i18n i18n="_label_add_examination_">Add examination</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_tests\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_tests\')"><span><data-i18n i18n="_label_add_tests_">Add tests</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_milk_m\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_milk_m\')"><span><data-i18n i18n="_label_add_milk_manually_">Add milk manually</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_clinical\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_clinical\')"><span><data-i18n i18n="_label_add_clinical_mastitis_">Add clinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_subclinical\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_subclinical\')"><span><data-i18n i18n="_label_add_subclinical_mastitis_">Add subclinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_misc\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_misc\')"><span><data-i18n i18n="_label_add_miscellaneous_">Add miscellaneous</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_diseases\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_diseases\')"><span><data-i18n i18n="_label_add_diseases_">Add diseases</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_prevention\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_prevention\')"><span><data-i18n i18n="_label_add_prevention_">Add prevention</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.eventsFilter == \'p_e_claw_health\' ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectEventFilter(\'p_e_claw_health\')"><span><data-i18n i18n="_label_add_claw_health_">Add claw health</data-i18n></span></div></li></ul></ul><ul><li class="list-header"><data-i18n i18n="_animal_gender_">Gender</data-i18n></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'g_female\')" ng-class="vm.g_female ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_gender_female_">Female</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'g_male\')" ng-class="vm.g_male ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_gender_male_">Male</data-i18n></span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_animal_show_animals_">Show animals</data-i18n></li><li><div class="filter-checkbox" ng-class="vm.sa_active ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'sa_active\')"><span><data-i18n i18n="_animal_active_">Active</data-i18n></span></div></li><li><div class="filter-checkbox" ng-class="vm.sa_history ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFilter(\'sa_history\')"><span><data-i18n i18n="_animal_historic_">Historic</data-i18n></span></div></li></ul><ul><li class="list-header"><data-i18n i18n="_label_events_">Events</data-i18n></li><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'al_scc\')" ng-class="vm.al_scc ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_scc_alert_">SCC alert</data-i18n></span></div></li><ul ng-if="vm.al_scc"><li style="display: flex; justify-content: space-between; width: 160px;"><span><data-i18n i18n="_animal_lactation_">Lactation</data-i18n>1</span><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" max="999" step="1" ng-model="vm.l1_scc" ng-change="vm.sccValueChanged()" style="width: 50px;"></div></li><li style="display: flex; justify-content: space-between; width: 160px;"><span><data-i18n i18n="_animal_lactation_">Lactation</data-i18n>>1</span><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" step="999" ng-model="vm.lg1_scc" ng-change="vm.sccValueChanged()" style="width: 50px;"></div></li></ul><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'at_ce_tc\')" ng-class="vm.at_ce_tc ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_clinical_examination_transition_cows_">Clinical examination Transition cows</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'m_a_milk\')" ng-class="vm.m_a_milk ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_manually_added_milk_">Manually added milk</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'h_e_diseases\')" ng-class="vm.h_e_diseases ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_health_event_diseases_">Health events: diseases</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'h_e_prevention\')" ng-class="vm.h_e_prevention ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_health_event_prevention_">Health events: prevention</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'u_h_clinical\')" ng-class="vm.u_h_clinical ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_udder_health_clinical_mastitis_">Udder health: clinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'u_h_subclinical\')" ng-class="vm.u_h_subclinical ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_udder_health_subclinical_mastitis_">Udder health: subclinical mastitis</data-i18n></span></div></li><li><div class="filter-checkbox" ng-click="vm.selectFilter(\'c_h\')" ng-class="vm.c_h ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_claw_health_">Claw health</data-i18n></span></div></li><li style="margin-top: 10px" ng-if="vm.at_newborn || vm.at_ce_tc || vm.m_a_milk || vm.h_e_diseases || vm.h_e_prevention || vm.u_h_clinical || vm.u_h_subclinical || vm.c_h"><div><span><data-i18n i18n="_label_in_last_">In last</data-i18n>:</span><span style="margin-left: 3px">{{vm.selected_slider_value}}</span></div><div class="time-slider"><rzslider rz-slider-model="vm.slider_value" rz-slider-options="vm.sliderOptionsActive"></rzslider></div></li><li style="margin-top: 10px"><div class="filter-checkbox" ng-click="vm.selectFilter(\'al_mp\')" ng-class="vm.al_mp ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'"><span><data-i18n i18n="_animal_milk_production_alert_">Milk production alert</data-i18n></span></div></li><ul ng-if="vm.al_mp"><li><div class="filter-checkbox" ng-class="vm.min_dev_p ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.deviationSelected(\'min_dev_p\')"><span>Minimum deviation %</span></div><div class="status-date-input" style="margin-left: 20px"><input type="number" min="1" max="100" step="1" ng-model="vm.min_dev_p_value" ng-change="vm.deviationValueChanged()">%</div></li><li><div class="filter-checkbox" ng-class="vm.min_dev_kg ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.deviationSelected(\'min_dev_kg\')"><span>Minimum deviation kg</span></div><div class="status-date-input" style="margin-left: 20px"><input type="number" min="0.1" step="0.1" ng-model="vm.min_dev_kg_value" ng-change="vm.deviationValueChanged()">kg</div></li><li><div class="filter-checkbox" ng-class="vm.dev_t ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_t\')"><span>Today</span></div></li><li><div class="filter-checkbox" ng-class="vm.dev_y ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_y\')"><span>Yesterday</span></div></li><li><div class="filter-checkbox" ng-class="vm.dev_tda ? \'ion-ios-circle-filled\' : \'ion-ios-circle-outline\'" ng-click="vm.selectDeviationTime(\'dev_tda\')"><span>Two days ago</span></div></li></ul></ul></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.grid.html','<div ng-repeat="animal in vm.animals | unique: \'AnimalId\'" class="animal-wrapper clearfix pointer" ng-click="vm.selectAnimal(animal)"><div class="animal-remove-icon" ng-click="vm.removeAnimal($index)"><i class="ion-ios-close-outline"></i></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)"><img src="assets/img/logo.png" lazy-img="{{animal.PictureToShow.T}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureToShow.T && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T || vm.hideImage"></div><div class="image-legend"><div class="image-who">{{::animal.EarTag}}</div><div class="image-when">{{::animal.NumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::animal.Name}}</div><div class="image-who"><span>{{::animal.CurrentStatusString}}</span><span>&#32({{::animal.DateString}})</span></div><div class="image-who" ng-if="::animal.Parity>0"><span><data-i18n i18n="_animal_parity_">Parity</data-i18n>:&#32</span><span>{{::animal.Parity}}</span><span>&#32-&#32<data-i18n i18n="_animal_dim_">DIM</data-i18n>:&#32</span><span>{{::animal.DIM}}</span></div></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.panel.html"></div></div><div class="error-msg-wrapper" ng-if="!vm.loading && vm.errorLoading"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.panel.html','<div class="row" ng-if="!vm.loading && vm.selectedHerd && !vm.errorLoading"><div class="lists-header"><div class="lists-header-item search-box"><div class="input-group"><span class="input-group-addon search-options-button" style="padding: 0px; font-size:20px" ng-click="vm.showSearchSetings = !vm.showSearchSetings"><i class="material-icons">add_circle</i></span> <input type="text" class="form-control" placeholder="{{\'_label_add_animal_to_list_\'|i18n}}" ng-model="vm.animal_search_string" ng-change="vm.animalSearchChanged()"></div><div class="search-options-box" ng-if="vm.showSearchSetings"><div><div class="filter-checkbox" ng-class="vm.searchByEarTag ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'ear_tag\')"><span><data-i18n i18n="_label_search_by_ear_tag_">Search by ear tag</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByNumber ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'number\')"><span><data-i18n i18n="_label_search_by_number_">Search by number</data-i18n></span></div></div><div><div class="filter-checkbox" ng-class="vm.searchByName ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectSearchBy(\'name\')"><span><data-i18n i18n="_label_search_by_name_">Search by name</data-i18n></span></div></div></div></div><div class="lists-header-item shortcut-items" id="shortcuts"><div class="shortcut-button" ng-if="vm.showShortcutItems" ng-repeat="button in vm.predefinedButtonsList"><div class="list-shortcut" ng-click="vm.selectPredefinedList(button)" ng-class="vm.selectedPredefinedList == button.id? \'selected\' : \'\'"><div ng-style="vm.hasLongName(button)">{{button.translated}}</div></div></div><div class="shortcut-selector" ng-if="vm.showShortcutItems"><div class="input-group"><ui-select ng-model="vm.selectedListModel" theme="selectize" class="select-tags" style="height:20px; width: 220px" on-select="vm.selectedPickerList()"><ui-select-match allow-clear="true">{{$select.selected.translated }}</ui-select-match><ui-select-choices repeat="list in vm.predefinedPickerList | filter: $select.search track by list.id">{{list.translated}}</ui-select-choices></ui-select></div></div></div><div class="lists-header-item export-view-box"><div style="display: inline-block; vertical-align: middle; margin-right: 5px; text-align: right" class="export-pdf-button" ng-click="vm.openExportModal()"><i class="fa fa-file-pdf-o"></i></div><div class="btn-group" style="display: inline-block"><button id="list" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(1)" ng-class="vm.selectedLayout == 1 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th-list"></span></button> <button id="grid" class="btn btn-layout-switch btn-sm" ng-click="vm.selectLayout(2)" ng-class="vm.selectedLayout == 2 ? \'btn-active-primary\' : \'\'"><span class="glyphicon glyphicon-th"></span></button></div></div></div></div><div class="row" ng-if="!vm.loading && vm.selectedHerd && !vm.errorLoading" style="margin: -12px -12px"><div class="list-generator-images" ng-if="vm.selectedLayout == 1 && vm.showSearchResults" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.search-results.table.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 1" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.table.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 2 && vm.showSearchResults" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.search-results.grid.html"></div></div><div class="list-generator-images" ng-if="vm.selectedLayout == 2" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.grid.html"></div></div><div class="list-generator-filter-block" ng-class="vm.showFilterBlock ? \'\' : \'hide-filter-block\'"><div include-with-scope="app/pages/herds/listGeneratorV2/listGenerator.filter-block.html" style="width: 250px"></div></div><div class="show-filter-button" ng-if="!vm.showFilterBlock" ng-click="vm.hideFilterBlock()"><i class="ion-arrow-left-b"></i></div></div><div ng-if="vm.showPagination && !vm.loading && vm.selectedHerd && !vm.errorLoading" style="text-align: center; margin-top: 20px;" class="row"><ul uib-pagination="" boundary-links="true" total-items="vm.totalAnimals" ng-model="vm.currentPage" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;" max-size="5" ng-change="vm.paginationChanged()" items-per-page="100"></ul></div><div class="row" ng-if="vm.loading && !vm.errorLoading" style="text-align: center"><div class="loading-animation"></div></div><div class="row" ng-if="!vm.loading && !vm.selectedHerd"><div><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.search-results.grid.html','<div><data-i18n i18n="_label_search_results_">Search results</data-i18n></div><div ng-repeat="animal in vm.searchAnimals" class="animal-wrapper clearfix search-result-grid"><div class="animal-remove-icon blue" ng-click="vm.addAnimal($index, animal)"><i class="ion-android-add"></i></div><div class="image-canvas" ng-class="vm.getAnimalClass(animal)"><img ng-src="{{animal.PictureToShow.T}}" ng-if="animal.PictureToShow.T"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T"></div><div class="image-legend"><div class="image-who">{{::animal.EarTag}}</div><div class="image-when">{{::animal.NumberString}} <span ng-show="image.AnimalNumberString && image.AnimalName">-</span> {{::animal.Name}}</div><div class="image-who"><span>{{::animal.CurrentStatusString}}</span><span>&#32({{::animal.DateString}})</span></div><div class="image-who" ng-if="::animal.Parity>0"><span><data-i18n i18n="_animal_parity_">Parity</data-i18n>:&#32</span><span>{{::animal.Parity}}</span><span>&#32-&#32<data-i18n i18n="_animal_dim_">DIM</data-i18n>:&#32</span><span>{{::animal.DIM}}</span></div></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.search-results.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table table-hover search-result-table" style="font-size:14px"><thead><tr class="list-generator-list-header"><th style="min-width: 20px; width: 20px; text-align: left; color: #a28c12" colspan="2"></th><th style="text-align: center" align="center" ng-click="vm.sort(\'Number\')"><div class="with-hover-effect"><data-i18n i18n="_animal_number_">Animal number</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Number_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Number_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div ng-click="vm.sort(\'Name\')" class="with-hover-effect"><data-i18n i18n="_animal_name_">Animal name</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'EarTag\')" class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Animal ear tag</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'EarTag_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'EarTag_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'BirthDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'BirthDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BirthDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div class="with-hover-effect" ng-click="vm.sort(\'CurrentStatusString\')"><data-i18n i18n="_animal_status_">Status</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'CurrentStatusString_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'CurrentStatusString_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'StatusDate\')"><data-i18n i18n="_animal_status_days_">Status days</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'StatusDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'StatusDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'Parity\')"><div class="with-hover-effect"><data-i18n i18n="_animal_parity_">Parity</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'Parity_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Parity_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th><th style="text-align: center" align="center"><div ng-click="vm.sort(\'LastCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'LastCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'LastHeatInseminationDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_last_heat_">Last heat</data-i18n>/<i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'LastHeatInseminationDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastHeatInseminationDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_insemination_date_">insemination date</data-i18n></div></th><th style="text-align: center" align="center" ng-click="vm.sort(\'ExpectedDryDate\')"><div class="with-hover-effect"><data-i18n i18n="_animal_dry_off_date_">Dry off date</data-i18n><i style="font-size: 17px; vertical-align:middle" ng-class="vm.sort_col == \'ExpectedDryDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedDryDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height:24px;"></div></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="animal in vm.searchAnimals"><td style="min-width: 20px; width: 20px"><div ng-click="vm.addAnimal($index, animal)" class="animal-remove-icon-list blue"><i class="ion-android-add" style="font-size: 30px"></i></div></td><td><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-class="vm.getAnimalClass(animal)" style="margin-top:0px"><img ng-src="{{animal.PictureToShow.T}}" ng-if="animal.PictureToShow.T"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T"></div></div></td><td style="text-align: center">{{::animal.NumberString}}</td><td style="text-align: center"><div>{{::animal.Name}}</div><div>{{::animal.EarTag}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.BirthDate | date: \'shortDate\'}}</td><td style="text-align: center"><div>{{::animal.CurrentStatusString}}</div><div>{{::animal.DateString}}</div><div>{{::animal.StatusDays}}</div></td><td style="text-align: center">{{::animal.Parity}}</td><td style="text-align: center"><div>{{::animal.LastCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.LastHeatInseminationDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="pointer">{{::animal.ExpectedDryDate | date: \'shortDate\'}}</td></tr></tbody></table></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/listGenerator.table.html','<div class="horizontal-scroll list-generator-table-panel" ng-if="!vm.loading" ng-class="vm.showFilterBlock ? \'\' : \'fit-to-screen\'" lazy-img-container=""><table class="table table-hover fixed_headers" style="font-size: 14px" id="lg_table" ng-if="vm.showTable"><thead><tr class="list-generator-list-header"><th></th><th style="text-align: center; padding: 12px"><button class="btn btn-primary btn-xs" ng-click="vm.emptyList()"><data-i18n i18n="_label_empty_list_">Empty List</data-i18n></button></th><th class="animal_number" style="text-align: center" align="center" ng-click="vm.sort(\'Number\')"><div class="with-hover-effect"><data-i18n i18n="_animal_number_">Animal number</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Number_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Number_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_name" style="text-align: center" align="center"><div ng-click="vm.sort(\'Name\')" class="with-hover-effect"><data-i18n i18n="_animal_name_">Animal name</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Name_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Name_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'EarTag\')" class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Animal ear tag</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'EarTag_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'EarTag_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_dof" style="text-align: center" align="center" ng-click="vm.sort(\'BirthDate\')" ng-if="vm.show.birth_date"><div class="with-hover-effect"><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'BirthDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BirthDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_age" style="text-align: center" align="center" ng-click="vm.sort(\'Age\')" ng-if="vm.show.age"><div class="with-hover-effect"><data-i18n i18n="_animal_age_">Age</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'AgeDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'AgeDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_status" style="text-align: center" align="center"><div class="with-hover-effect" ng-click="vm.sort(\'CurrentStatusString\')"><data-i18n i18n="_animal_status_">Status</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'CurrentStatusString_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'CurrentStatusString_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'StatusDate\')"><data-i18n i18n="_animal_status_days_">Status days</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'StatusDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'StatusDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_days_pregnant" style="text-align: center" align="center" ng-click="vm.sort(\'DaysSinceLastHI\')" ng-if="vm.show.days_pregnant"><div class="with-hover-effect"><data-i18n i18n="_animal_days_pregnant_">Days pregnant</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DaysSinceLastHI_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DaysSinceLastHI_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_days_dry" style="text-align: center" align="center" ng-click="vm.sort(\'DaysDry\')" ng-if="vm.show.days_dry"><div class="with-hover-effect"><data-i18n i18n="_animal_days_dry_">Days dry</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DaysDry_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DaysDry_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_parity" style="text-align: center" align="center" ng-click="vm.sort(\'Parity\')"><div class="with-hover-effect"><data-i18n i18n="_animal_parity_">Parity</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'Parity_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'Parity_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_lcd" style="text-align: center" align="center" ng-if="vm.show.last_calving_date"><div ng-click="vm.sort(\'LastCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-if="vm.show.last_mro_mm"><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.KgMilk\')"><data-i18n i18n="_label_last_mro_">Last MRO</data-i18n>/ <i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMilkRecording.KgMilk_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMilkRecording.KgMilk_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_label_milk_meter_">Milk meter</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th style="text-align: center" align="center" ng-if="vm.show.last_mro_scc"><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.SCC\')"><data-i18n i18n="_label_last_mro_">Last MRO</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div><div class="with-hover-effect" ng-click="vm.sort(\'LastMilkRecording.SCC\')"><data-i18n i18n="_animal_scc_">SCC</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMilkRecording.SCC_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMilkRecording.SCC_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_ecd" style="text-align: center" align="center" ng-if="vm.show.expected_calving_date"><div ng-click="vm.sort(\'ExpectedCalvingDate\')" class="with-hover-effect"><data-i18n i18n="_animal_expected_calving_date_">Expected calving date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ExpectedCalvingDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedCalvingDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div ng-click="vm.sort(\'DIM\')" class="with-hover-effect"><data-i18n i18n="_animal_dim_">DIM</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'DIM_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'DIM_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.show.daily_milk_production"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_calendar_daily_">Daily</data-i18n></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.show.deviation_kg"><div class="with-hover-effect"><data-i18n i18n="_label_deviation_">Deviation</data-i18n>Kg</div><div style="min-height: 24px"></div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.show.deviation_percentage"><div class="with-hover-effect"><data-i18n i18n="_label_deviation_">Deviation</data-i18n>%</div><div style="min-height: 24px"></div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.show.milk_2_d"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilk[2].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[2].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[2].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.two_days_ago | date:\'shortDate\'}}</div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.show.milk_1_d"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilk[1].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[1].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[1].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.yesterday | date:\'shortDate\'}}</div></th><th class="animal_d_milk_day" style="text-align-last: center" align="center" ng-if="vm.show.milk_t"><div class="with-hover-effec" ng-click="vm.sort(\'LastWeekMilk[0].v\')"><data-i18n i18n="_animal_milk_">Milk</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilk[0].v_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilk[0].v_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect">{{vm.today | date:\'shortDate\'}}</div></th><th class="animal_d_milk" style="text-align: center" align="center" ng-if="vm.show.last_week_milk"><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_calendar_daily_">Daily</data-i18n></div><div class="with-hover-effect" ng-click="vm.sort(\'LastWeekMilkSort\')"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastWeekMilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastWeekMilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_mas_case" style="text-align: center" align="center" ng-if="vm.show.mastitis" ng-click="vm.sort(\'NrMastCurLact\')"><div class="with-hover-effect"><data-i18n i18n="_animal_mastitis_case_">Mastitis case</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'NrMastCurLact_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'NrMastCurLact_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px"></div></th><th class="animal_last_mas" style="text-align: center" align="center" ng-if="vm.show.last_mastitis" ng-click="vm.sort(\'LastMastitis\')"><div class="with-hover-effect"><data-i18n i18n="_label_last_">Last</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div><div class="with-hover-effect"><data-i18n i18n="_animal_mastitis_case_">Mastitis case</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastMastitis_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastMastitis_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_lhid" style="text-align: center" align="center" ng-click="vm.sort(\'LastHeatInseminationDate\')" ng-if="vm.show.last_heat_insemination"><div class="with-hover-effect"><data-i18n i18n="_animal_last_heat_">Last heat</data-i18n>/<i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'LastHeatInseminationDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'LastHeatInseminationDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_insemination_date_">insemination date</data-i18n></div></th><th class="animal_noi" style="text-align: center" align="center" ng-click="vm.sort(\'NumberOfInseminations\')" ng-if="vm.show.n_inseminations"><div class="with-hover-effect"><data-i18n i18n="_animal_number_of_">Number of</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'NumberOfInseminations_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'NumberOfInseminations_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="text-transform: lowercase" class="with-hover-effect"><data-i18n i18n="_animal_inseminations_">inseminations</data-i18n></div></th><th class="animal_dod" style="text-align: center" align="center" ng-click="vm.sort(\'ExpectedDryDate\')" ng-if="vm.show.predicted_dry_off"><div class="with-hover-effect"><data-i18n i18n="_label_predicted_">Predicted</data-i18n></div><div class="with-hover-effect"><data-i18n i18n="_animal_dry_off_date_">Dry off date</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'ExpectedDryDate_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'ExpectedDryDate_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div></th><th class="animal_bull_name" style="text-align: center" align="center" ng-click="vm.sort(\'BreedingBull\')" ng-if="vm.show.bull"><div class="with-hover-effect"><data-i18n i18n="_animal_ear_tag_">Ear tag</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'BreedingBull_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'BreedingBull_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div class="with-hover-effect"><data-i18n i18n="_animal_bull_name_">Bull name</data-i18n><i style="font-size: 17px; vertical-align: middle"></i></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-click="vm.sort(\'MilkSort\')" ng-if="vm.show.milk_production"><div class="with-hover-effect"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'MilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'MilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px; text-transform: lowercase"><data-i18n i18n="_label_today_">Today</data-i18n></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t1"><div>t-1</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t2"><div>t-2</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t3"><div>t-3</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t4"><div>t-4</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t5"><div>t-5</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t6"><div>t-6</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_t7"><div>t-7</div><div style="min-height: 24px"></div></th><th class="animal_milk_production" style="text-align: center" align="center" ng-if="vm.show.milk_avg"><div class="with-hover-effect"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n><i style="font-size: 17px; vertical-align: middle" ng-class="vm.sort_col == \'MilkSort_DESC\'? \'ion-arrow-down-b\' : (vm.sort_col == \'MilkSort_ASC\'? \'ion-arrow-up-b\' : \'\')"></i></div><div style="min-height: 24px; text-transform: lowercase"><data-i18n i18n="_animal_details_average_value_">Average</data-i18n></div></th><th class="animal_com" style="text-align: center"><div><data-i18n i18n="_dc_comments_"></data-i18n></div><div style="min-height: 24px"></div></th></tr></thead><tbody ng-if="!vm.loadingTable"><tr ng-repeat="animal in vm.animals | unique: \'AnimalId\'"><td><div ng-click="vm.removeAnimal($index, animal)" class="animal-remove-icon-list"><i class="ion-ios-close-outline"></i></div></td><td><div class="animal-wrapper-list clearfix"><div class="image-canvas" ng-click="vm.selectAnimal(animal)" ng-class="vm.getAnimalClass(animal)" style="margin-top: 0px"><img src="assets/img/logo.png" lazy-img="{{animal.PictureToShow.T}}" lazy-img-error="assets/img/logo.png" ng-if="animal.PictureToShow.T && !vm.hideImage"> <img ng-src="assets/img/logo.png" ng-if="!animal.PictureToShow.T || vm.hideImage"></div></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_number pointer">{{::animal.NumberString}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_name pointer"><div>{{::animal.Name}}</div><div>{{::animal.EarTag}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_dof pointer" ng-if="vm.show.birth_date">{{::animal.BirthDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_age pointer" ng-if="vm.show.age">{{::animal.Age}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_status pointer"><div>{{::animal.CurrentStatusString}}<span style="margin-left: 3px">({{::animal.DateString}})</span></div><div>{{::animal.StatusDays}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_days_pregnant pointer" ng-if="vm.show.days_pregnant">{{::animal.DaysSinceLastHI}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_days_dry pointer" ng-if="vm.show.days_dry">{{::animal.DaysDry}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_parity pointer">{{::animal.Parity}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_lcd pointer" ng-if="vm.show.last_calving_date"><div>{{::animal.LastCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" ng-if="vm.show.last_mro_mm"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[3].v">{{::animal.LastWeekMilk[3].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[3].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[4].v">{{::animal.LastWeekMilk[4].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[4].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[5].v">{{::animal.LastWeekMilk[5].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[5].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[6].v">{{::animal.LastWeekMilk[6].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[6].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[7].v">{{::animal.LastWeekMilk[7].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[7].d | date: \'shortDate\'}})</span></div><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div><div ng-if="!animal.LastWeekMilk && animal.LastMilkRecording">{{::animal.LastMilkRecording.KgMilk}}<span style="margin-left: 3px">({{::animal.LastMilkRecording.Date | date: \'shortDate\'}})</span></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" ng-if="vm.show.last_mro_scc"><div style="display: inline-block">{{::animal.LastMilkRecording.SCC}}</div>&nbsp;<div style="display: inline-block">({{::animal.LastMilkRecording.Date | date: \'shortDate\'}})</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_ecd pointer" ng-if="vm.show.expected_calving_date"><div>{{::animal.ExpectedCalvingDate | date: \'shortDate\'}}</div><div>{{::animal.DIM}}</div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.show.daily_milk_production"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[3].v">{{::animal.LastWeekMilk[3].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[3].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[4].v">{{::animal.LastWeekMilk[4].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[4].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[5].v">{{::animal.LastWeekMilk[5].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[5].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[6].v">{{::animal.LastWeekMilk[6].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[6].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[7].v">{{::animal.LastWeekMilk[7].v}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[7].d | date: \'shortDate\'}})</span></div><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div><div ng-if="!animal.LastWeekMilk && animal.LastManualMilkDate"><data-i18n i18n="_animal_manually_added_milk_"></data-i18n><span style="margin-left: 3px"><br>({{::animal.LastManualMilkDate | date: \'shortDate\'}})</span></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.show.deviation_kg"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].dev_kg">{{::animal.LastWeekMilk[0].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].dev_kg">{{::animal.LastWeekMilk[1].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].dev_kg">{{::animal.LastWeekMilk[2].dev_kg}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.show.deviation_percentage"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].dev_percent">{{::animal.LastWeekMilk[0].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[0].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[1].dev_percent">{{::animal.LastWeekMilk[1].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[1].d | date: \'shortDate\'}})</span></div><div ng-if="animal.LastWeekMilk[2].dev_percent">{{::animal.LastWeekMilk[2].dev_percent}}<span style="margin-left: 3px">({{::animal.LastWeekMilk[2].d | date: \'shortDate\'}})</span></div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.show.milk_2_d"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[2].v">{{::animal.LastWeekMilk[2].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.show.milk_1_d"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[1].v">{{::animal.LastWeekMilk[1].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk_day pointer" ng-if="vm.show.milk_t"><div ng-if="animal.LastWeekMilk"><div ng-if="animal.LastWeekMilk[0].v">{{::animal.LastWeekMilk[0].v}}</div></div></td><td style="text-align: center; line-height: 20px" ng-click="vm.selectAnimal(animal)" class="animal_d_milk pointer" ng-if="vm.show.last_week_milk"><div ng-if="animal.LastWeekMilk"><div class="last-week-milk-svg"><div ng-bind-html="animal.LastWeekMilkSvg"></div></div></div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_mas_case pointer" ng-if="vm.show.mastitis"><div>{{::animal.NrMastCurLact}}</div></td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_last_mas pointer" ng-if="vm.show.last_mastitis">{{::animal.LastMastitis | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_lhid pointer" ng-if="vm.show.last_heat_insemination">{{::animal.LastHeatInseminationDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_noi pointer" ng-if="vm.show.n_inseminations">{{::animal.NumberOfInseminations }}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_dod pointer" ng-if="vm.show.predicted_dry_off">{{::animal.ExpectedDryDate | date: \'shortDate\'}}</td><td style="text-align: center" ng-click="vm.selectAnimal(animal)" class="animal_bull_name pointer" ng-if="vm.show.bull"><div>{{::animal.BreedingBull }}</div></td><td style="text-align: center" ng-if="vm.show.milk_production">{{::animal.LastWeekMilk[0].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t1">{{::animal.LastWeekMilk[1].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t2">{{::animal.LastWeekMilk[2].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t3">{{::animal.LastWeekMilk[3].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t4">{{::animal.LastWeekMilk[4].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t5">{{::animal.LastWeekMilk[5].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t6">{{::animal.LastWeekMilk[6].v}}</td><td style="text-align: center" ng-if="vm.show.milk_t7">{{::animal.LastWeekMilk[7].v}}</td><td style="text-align: center" ng-if="vm.show.milk_avg">{{::animal.Avg_MP| number : 2}}</td><td class="animal_com" style="text-align: center"><i class="material-icons add-comment-icon" ng-click="vm.openNewDiscussionModal(animal)" style="font-size: 30px" ng-if="!animal.Comments">message</i><div>{{animal.Comments}}</div></td></tr></tbody></table></div><div ng-if="vm.loadingTable" align="center"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/herds/listGeneratorV2/saveList.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingModal"><form novalidate="" form="vm.saveListForm"><div class="form-group"><label for="name"><data-i18n i18n="_label_list_name_">File name</data-i18n></label> <input type="text" class="form-control" id="name" name="name" placeholder="{{\'_label_list_name_\' | i18n}}" ng-model="vm.list_name" required="" maxlength="50"></div></form></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingModal"><div class="loading-animation"></div></div><div class="modal-body" style="text-align: center" ng-if="vm.saveListError"><div><span class="color-red"><data-i18n i18n="_message_error_">Error</data-i18n></span></div></div><div class="modal-footer" ng-if="!vm.loadingModal"><button type="button" class="btn btn-primary" ng-click="vm.saveList()" ng-disabled="!vm.list_name || vm.list_name.length == 0"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/myHerds/myHerds.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ng-if="vm.errorOccured" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div><div ng-if="!vm.errorOccured" ba-panel="" ba-panel-class="with-scroll"><div include-with-scope="app/pages/herds/myHerds/myHerds.table.html"></div></div></div></div></div>');
$templateCache.put('app/pages/herds/myHerds/myHerds.table.html','<div class="horizontal-scroll" ng-if="!vm.loading"><table class="table" st-table="vm.herds" st-safe-src="vm.herdsSafe" ng-if="vm.selectedTeam" style="font-size:14px"><thead><tr class="sortable"><th style="min-width: 400px; text-align: left;" st-sort-default="true" st-sort="Name"><data-i18n i18n="_label_herd_name_">herd name</data-i18n></th><th style="min-width: 300px; text-align: left;" st-sort="Email">Email</th><th></th></tr><tr><th><input st-search="Name" placeholder="{{\'_label_search_by_name_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th><input st-search="Email" placeholder="{{\'_label_search_by_email_\' | i18n }}" class="input-sm form-control search-input" type="search"></th><th></th></tr></thead><tbody><tr ng-repeat="herd in vm.herds"><td style="text-align: left;">{{herd.Name}}</td><td style="text-align: left;">{{herd.Email}}</td><td style="text-align: center; font-size: 24px" ng-class="vm.disableFavorite ? \'disabled\' : \'\'"><a ng-class="herd.favorite ? \'ion-star\' : \'ion-ios-star-outline\'" href="" uib-tooltip="{{herd.tooltip}}" tooltip-is-open="tooltipIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" style="margin-right:5px" ng-click="vm.selectHerd(herd, $index)" class="favorite-star"></a> <a class="ion-edit" href="" uib-tooltip="{{\'_label_edit_herd_\' | i18n}}" tooltip-is-open="tooltipIsOpenEdit" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" style="margin-right:5px" ng-click="vm.editHerd(herd)"></a></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="vm.itemsPerPage" st-displayed-pages="5"></div></td></tr></tfoot></table><div ng-if="!vm.selectedTeam" align="center"><div><h3><data-i18n i18n="_message_error_default_team_not_defined_">Default team is not defined</data-i18n></h3></div></div></div><div ng-if="vm.loading" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/lists/common/dateRange.modal.html','<div><div class="modal-header" ng-if="!vm.setRangeModalLoading"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.setRangeModalLoading"><div class="row" style="margin: 0; padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.selectedReportDashboard.actual" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.selectedReportDashboard.actual"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.setDateRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="modal-body" ng-if="vm.setRangeModalLoading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/lists/common/delete.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" style="padding-top: 0px;" ng-if="!vm.modalLoading"><span><data-i18n i18n="_label_delete_visit_dialog_1_">Are you sure you want to delete herd visit for</data-i18n></span>&nbsp<span>{{vm.deleteVisitDate | date:\'mediumDate\'}}?</span>&nbsp<data-i18n i18n="_label_delete_visit_dialog_2_">All trims will be deleted.</data-i18n></div><div class="modal-footer" ng-if="!vm.modalLoading"><button type="button" class="btn btn-danger" ng-click="vm.deleteVisit()"><data-i18n i18n="_label_yes_">yes</data-i18n></button> <button type="button" class="btn btn-success" ng-click="$dismiss()"><data-i18n i18n="_label_cancel_">cancel</data-i18n></button></div><div class="modal-body" style="text-align: center" ng-if="vm.modalLoading"><dev class="loading-animation"></dev></div><div class="modal-body color-red" ng-if="!vm.modalLoading && vm.deleteError"><span>{{vm.deleteError.data.Message}}</span></div></div>');
$templateCache.put('app/pages/lists/common/export.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body"><div class="row"><div class="col-md-6"><div class="input-demo radio-demo"><label class="radio-inline custom-radio nowrap"><input type="radio" name="format1" id="format1" ng-value="1" ng-model="vm.selectedFormat"> <span>.csv</span></label></div></div><div class="col-md-6"><div class="input-demo radio-demo"><label class="radio-inline custom-radio nowrap"><input type="radio" name="version1" id="version1" ng-value="1" ng-model="vm.selectedVersion"> <span><data-i18n i18n="_label_simple_">Simple</data-i18n></span></label></div></div></div><div class="row"><div class="col-md-6"><div class="input-demo radio-demo"><label class="radio-inline custom-radio nowrap"><input type="radio" name="format2" id="format2" ng-value="2" ng-model="vm.selectedFormat"> <span>.xls</span></label></div></div><div class="col-md-6"><div class="input-demo radio-demo"><label class="radio-inline custom-radio nowrap"><input type="radio" name="version2" id="version2" ng-value="2" ng-model="vm.selectedVersion"> <span><data-i18n i18n="_label_regular_">Regular</data-i18n></span></label></div></div></div><div class="row" ng-if="vm.showSystemic"><div class="col-md-6"></div><div class="col-md-6"><div class="input-demo radio-demo"><label class="radio-inline custom-radio nowrap"><input type="radio" name="version3" id="version3" ng-value="3" ng-model="vm.selectedVersion"> <span><data-i18n i18n="_label_systemic_">Systemic</data-i18n></span></label></div></div></div></div><div class="modal-footer"><div style="text-align: right"><button type="button" class="btn btn-success" ng-click="vm.exportData()"><data-i18n i18n="_button_export_">Export</data-i18n></button></div></div><button id="export-csv-button" style="display: none" ng-csv="vm.getCsvData()" filename="{{vm.fileName}}" csv-header="vm.getCsvHeader()"></button></div>');
$templateCache.put('app/pages/lists/blockList/blockList.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_block_list_\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/lists/blockList/blockList.panel.html"></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/lists/blockList/blockList.panel.html','<div style="min-height: 500px"><div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && !vm.loading && !vm.errorLoading && !vm.noVisitDates" class="claw-health-list"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="toggle-group" style="margin: auto; width: fit-content"><span><data-i18n i18n="_invoice_label_visit_date_">Visit date</data-i18n></span> <span class="material-icons" ng-click="vm.changeHoofTrimPeriod()" ng-class="!vm.loadingHoofTrims ? \'\' : \'disabled\'">{{vm.timePeriodUnit}}</span> <span><data-i18n i18n="_report_time_period_">Time period</data-i18n></span></div></div></div><div class="row" ng-if="vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-date-selector"><p class="input-group" ng-class="vm.dateError ? \'date-error\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.selectedDateObject" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.loadingHoofTrims" ng-change="vm.dateChanged()" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default trim-btn" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></p></div></div><div class="col-md-4"><div style="text-align: right"><button class="btn btn-danger" ng-click="vm.openDeleteModal()" style="vertical-align: bottom; margin-right: 10px"><data-i18n i18n="_button_delete_visit_">Delete visit</data-i18n></button><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px;"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.openExportModal()"></i></div></div></div></div><div class="row" ng-if="!vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-range-selector"><div class="range-selector-block selector-dates">{{vm.startDate | date:\'mediumDate\'}} - {{vm.endDate | date:\'mediumDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.loadingHoofTrims ? \'disabled\': \'\'"></i></div></div></div><div class="col-md-4"><div style="text-align: right"><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-csv="vm.getCsvData()" filename="{{vm.fileName}}"></i></div></div></div></div><div class="row"><div style="padding: 0px 10px"><div include-with-scope="app/pages/lists/blockList/blockList.table.html"></div></div></div></div><div ng-if="vm.noVisitDates && vm.selectedHerds.length == 1 && !vm.errorLoading && !vm.loading" class="invoice-error"><span><data-i18n i18n="_invoice_message_no_data_">No data found for selected herd.</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && vm.loading && !vm.errorLoading && !vm.noVisitDates" align="center"><div><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/lists/blockList/blockList.table.html','<div class="horizontal-scroll"><table class="table" ng-if="!vm.loadingHoofTrims"><thead><tr class="header" style="margin-right: 15px"><th></th><th><data-i18n i18n="_label_limb_">Limb</data-i18n></th><th><data-i18n i18n="_invoice_label_lesion_">Lesion</data-i18n></th></tr></thead><tbody ng-repeat="(hoofTrimIndex, hoofTrim) in vm.hoofTrimData"><tr class="animal-info"><td colspan="9">{{hoofTrim.AnimalNumber}}<span ng-if="hoofTrim.AnimalEarTag && hoofTrim.AnimalNumber">-</span>{{hoofTrim.AnimalEarTag}} <span ng-if="!hoofTrim.AnimalNumber && !hoofTrim.AnimalEarTag">{{hoofTrim.AnimalName}}</span></td></tr><tr ng-repeat="(eventIndex, event) in hoofTrim.Limbs"><td><data-i18n i18n="_animal_details_hoof_treatment_type_block_">Block</data-i18n></td><td style="padding: 3px 3px; text-transform: uppercase">{{event.PositionString}}</td><td style="padding: 3px 3px"><div ng-repeat="lesion in event.Lesions">{{lesion.LesionString}}</div></td></tr></tbody><tbody ng-if="vm.hoofTrimData.length == 0"><tr><td colspan="3" ng-if="vm.hoofTrimByDate"><data-i18n i18n="_message_error_no_data_found_date_">No data found for selected herd and date.</data-i18n></td><td colspan="3" ng-if="!vm.hoofTrimByDate"><data-i18n i18n="_message_error_no_data_found_date_period_">No data found for selected herd and date period.</data-i18n></td></tr></tbody></table></div><div ng-if="vm.loadingHoofTrims" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/lists/recheckList/recheckList.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_recheck_list\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/lists/recheckList/recheckList.panel.html"></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/lists/recheckList/recheckList.panel.html','<div style="min-height: 500px;"><div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && !vm.loading && !vm.errorLoading && !vm.noVisitDates" class="claw-health-list"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-date-selector"><p class="input-group" ng-class="vm.dateError ? \'date-error\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.loadingHoofTrims" ng-change="vm.dateChanged()" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default trim-btn" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></p></div></div><div class="col-md-4"><div style="text-align: right;" ng-if="!vm.noHoofTrims"><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div></div></div></div><div class="row" ng-if="!vm.noHoofTrims"><div style="padding:0px 10px"><div include-with-scope="app/pages/lists/recheckList/recheckList.table.html"></div></div></div><div ng-if="vm.noHoofTrims" class="recheck-no-data-message"><span><data-i18n i18n="_message_error_no_data_found_date_">No data found for selected herd and date.</data-i18n></span></div></div><div ng-if="vm.selectedHerds.length == 1 && vm.loading && !vm.errorLoading && !vm.noVisitDates" align="center"><div><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/lists/recheckList/recheckList.table.html','<div class="horizontal-scroll"><table class="table" ng-if="!vm.loadingHoofTrims"><thead><tr class="header" style="margin-right: 15px"><th><data-i18n i18n="_label_date_">Date</data-i18n></th><th><data-i18n i18n="_label_event_">Event</data-i18n></th><th><data-i18n i18n="_label_limb_">Limb</data-i18n></th><th><data-i18n i18n="_invoice_label_lesion_">Lesion</data-i18n></th><th><data-i18n i18n="_animal_severity_">Severity</data-i18n></th><th><data-i18n i18n="_animal_details_hoof_treatment_type_recheck_">Recheck</data-i18n></th><th><data-i18n i18n="_label_recheck_date_">Recheck date</data-i18n></th></tr></thead><tbody ng-repeat="hoofTrim in vm.hoofTrimData"><tr class="animal-info"><td colspan="7">{{hoofTrim.AnimalNumber}}<span ng-if="hoofTrim.AnimalEarTag && hoofTrim.AnimalNumber">-</span>{{hoofTrim.AnimalEarTag}} <span ng-if="!hoofTrim.AnimalNumber && !hoofTrim.AnimalEarTag">{{hoofTrim.AnimalName}}</span></td></tr><tr ng-repeat="event in hoofTrim.Lesions"><td>{{event.VisitDate | date:\'mediumDate\'}}</td><td>{{event.ReasonString}}</td><td style="padding: 3px 3px;">{{event.PositionString}}</td><td style="padding: 3px 3px;">{{event.LesionString}}</td><td style="padding: 3px 3px;">{{event.SeverityString}}</td><td>{{event.RecheckString}}</td><td>{{event.RecheckDate}}</td></tr></tbody></table></div><div ng-if="vm.loadingHoofTrims" class="loading-spinner"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/lists/trimList/trimList.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_trim_list\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/lists/trimList/trimList.panel.html"></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/lists/trimList/trimList.panel.html','<div style="min-height: 500px" class="invoice"><div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && !vm.loading && !vm.errorLoading && !vm.noVisitDates" class="claw-health-list"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="toggle-group" style="margin: auto; width: fit-content"><span><data-i18n i18n="_invoice_label_visit_date_">Visit date</data-i18n></span> <span class="material-icons" ng-click="vm.changeHoofTrimPeriod()" ng-class="!vm.loadingHoofTrims ? \'\' : \'disabled\'">{{vm.timePeriodUnit}}</span> <span><data-i18n i18n="_report_time_period_">Time period</data-i18n></span></div></div></div><div class="row" ng-if="vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-date-selector"><p class="input-group" ng-class="vm.dateError ? \'date-error\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.selectedDateObject" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.loadingHoofTrims" ng-change="vm.dateChanged()" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default trim-btn" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></p></div></div><div class="col-md-4"><div style="text-align: right"><button class="btn btn-danger" ng-click="vm.openDeleteModal()" style="vertical-align: bottom; margin-right: 10px"><data-i18n i18n="_button_delete_visit_">Delete visit</data-i18n></button><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.openExportModal()"></i></div></div></div></div><div class="row" ng-if="!vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-range-selector"><div class="range-selector-block selector-dates">{{vm.startDate | date:\'mediumDate\'}} - {{vm.endDate | date:\'mediumDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.loadingHoofTrims ? \'disabled\': \'\'"></i></div></div></div><div class="col-md-4"><div style="text-align: right"><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.openExportModal()"></i></div></div></div></div><div class="row" ng-if="!vm.loading && !vm.loadingHoofTrims"><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_label_visit_reason_"></data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_type_">Type</data-i18n></th><th><data-i18n i18n="_invoice_label_n_cows_">Number of cows</data-i18n></th></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_trim_">Trim</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.trim}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_trim_rear_">Trim rear</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.trim_rear}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_lame_">Lame</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lame}}</td></tr><tr><td><data-i18n i18n="_animal_details_visit_reason_recheck_">Recheck</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.recheck}}</td></tr><tr><td colspan="4" ng-style="{{vm.hoofTrimSummary.lesions.h2}}"></td></tr><tr><td><data-i18n i18n="_animal_details_total_">Total</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.total}}</td></tr></table></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_invoice_label_treatments_">Treatments</data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_action_">Action</data-i18n></th><th><data-i18n i18n="_invoice_label_count_">Count</data-i18n></th></tr><tr><td><data-i18n i18n="_animal_details_hoof_treatment_type_block_">Block</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.block}}</td></tr><tr><td><data-i18n i18n="_animal_details_hoof_treatment_type_wrap_">Wrap</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.wrap}}</td></tr><tr><td colspan="4" ng-style="{{vm.hoofTrimSummary.lesions.h2}}"></td></tr><tr><td colspan="4" style="height: 72px; border-top: none"></td></tr><tr><td></td></tr></table></div><div class="col-lg-4"><h3 class="with-line"><data-i18n i18n="_animal_leasion_">Lesions</data-i18n></h3><table class="table cost-table"><tr><th><data-i18n i18n="_invoice_label_lesion_">Lesion</data-i18n></th><th><data-i18n i18n="_invoice_label_count_">Count</data-i18n></th></tr><tr ng-if="vm.hoofTrimSummary.lesions.ulcer.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_ulcer_">Ulcer</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.ulcer.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.abcess.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_abcess_">Abcess</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.abcess.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.toeUlcer.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_toe_ulcer_">Toe Ulcer</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.toeUlcer.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.soleFracture.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_sole_fracture_">Sole fracture</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.soleFracture.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.dd.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_digital_dermatitis_">DD</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.dd.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.thinSoles.n_lesions"><td><data-i18n i18n="_animal_details_hoof_lesion_type_thin_soles_">thin Soles</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.thinSoles.n_lesions}}</td></tr><tr ng-if="vm.hoofTrimSummary.lesions.other.n_lesions"><td><data-i18n i18n="_animal_details_disease_other_">Other</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.other.n_lesions}}</td></tr><tr><td colspan="4" ng-style="{{vm.hoofTrimSummary.lesions.h}}"></td></tr><tr><td><data-i18n i18n="_animal_details_total_">Total</data-i18n></td><td style="text-align: center">{{vm.hoofTrimSummary.lesions.n_lesions}}</td></tr></table></div></div><div class="total-line" ng-if="!vm.loading && !vm.loadingHoofTrims"></div><div class="row"><div style="padding: 0px 10px"><div include-with-scope="app/pages/lists/trimList/trimList.table.html"></div></div></div></div><div ng-if="vm.noVisitDates && vm.selectedHerds.length == 1 && !vm.errorLoading && !vm.loading" class="invoice-error"><span><data-i18n i18n="_invoice_message_no_data_">No data found for selected herd.</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && vm.loading && !vm.errorLoading && !vm.noVisitDates" align="center"><div><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/lists/trimList/trimList.table.html','<div class="horizontal-scroll"><table class="table" ng-if="!vm.loadingHoofTrims"><thead><tr class="header" style="margin-right: 15px"><th><data-i18n i18n="_label_event_">Event</data-i18n></th><th><data-i18n i18n="_label_limb_">Limb</data-i18n></th><th><data-i18n i18n="_invoice_label_lesion_">Lesion</data-i18n></th><th><data-i18n i18n="_animal_severity_">Severity</data-i18n></th><th><data-i18n i18n="_animal_details_hoof_treatment_type_therapeutic_trim_">Therapeutic trim</data-i18n></th><th><data-i18n i18n="_animal_details_hoof_treatment_type_topical_">Topical</data-i18n></th><th><data-i18n i18n="_animal_treatment_">Treatment</data-i18n></th><th><data-i18n i18n="_animal_details_hoof_treatment_type_recheck_">Recheck</data-i18n></th><th><data-i18n i18n="_label_recheck_date_">Recheck date</data-i18n></th></tr></thead><tbody ng-repeat="(hoofTrimIndex, hoofTrim) in vm.hoofTrimData"><tr class="animal-info"><td colspan="9">{{hoofTrim.AnimalNumber}}<span ng-if="hoofTrim.AnimalEarTag && hoofTrim.AnimalNumber">-</span>{{hoofTrim.AnimalEarTag}} <span ng-if="!hoofTrim.AnimalNumber && !hoofTrim.AnimalEarTag">{{hoofTrim.AnimalName}}</span></td></tr><tr ng-repeat="(eventIndex, event) in hoofTrim.Limbs"><td>{{event.ReasonString}}</td><td style="padding: 3px 3px; text-transform: uppercase;">{{event.PositionString}}</td><td style="padding: 3px 3px;"><div ng-repeat="lesion in event.Lesions">{{lesion.LesionString}}</div></td><td style="padding: 3px 3px;"><div ng-repeat="lesion in event.Lesions">{{lesion.SeverityString}}</div></td><td style="padding: 3px 3px;">{{event.Therapeutic}}</td><td style="padding: 3px 3px;">{{event.Topical}}</td><td><div ng-repeat="treatment in event.Treatments">{{treatment}}</div></td><td>{{event.RecheckString}}</td><td>{{event.RecheckDate}}</td></tr></tbody></table></div><div ng-if="vm.loadingHoofTrims" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/lists/wrapList/wrapList.html','<div class="widgets"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="{{\'_page_title_wrap_list_\'|i18n}}" ba-panel-class="with-scroll" ng-if="!vm.errorLoading"><div include-with-scope="app/pages/lists/wrapList/wrapList.panel.html"></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/lists/wrapList/wrapList.panel.html','<div style="min-height: 500px"><div ng-if="vm.selectedHerds.length != 1"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && !vm.loading && !vm.errorLoading && !vm.noVisitDates" class="claw-health-list"><div class="row"><div class="col-md-4"></div><div class="col-md-4"><div class="toggle-group" style="margin: auto; width: fit-content"><span><data-i18n i18n="_invoice_label_visit_date_">Visit date</data-i18n></span> <span class="material-icons" ng-click="vm.changeHoofTrimPeriod()" ng-class="!vm.loadingHoofTrims ? \'\' : \'disabled\'">{{vm.timePeriodUnit}}</span> <span><data-i18n i18n="_report_time_period_">Time period</data-i18n></span></div></div></div><div class="row" ng-if="vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-date-selector"><p class="input-group" ng-class="vm.dateError ? \'date-error\' : \'\'"><input type="text" class="form-control" uib-datepicker-popup="mediumDate" ng-model="vm.selectedDateObject" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\',\'dd-MMMM-yyyy\', \'yyyy/MM/dd\', \'dd.MM.yyyy\', \'shortDate\']" ng-disabled="vm.loadingHoofTrims" ng-change="vm.dateChanged()" datepicker-options="vm.dpOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default trim-btn" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></p></div></div><div class="col-md-4"><div style="text-align: right"><button class="btn btn-danger" ng-click="vm.openDeleteModal()" style="vertical-align: bottom; margin-right: 10px"><data-i18n i18n="_button_delete_visit_">Delete visit</data-i18n></button><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px;"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.openExportModal()"></i></div></div></div></div><div class="row" ng-if="!vm.hoofTrimByDate"><div class="col-md-4"></div><div class="col-md-4"><div class="trim-range-selector"><div class="range-selector-block selector-dates">{{vm.startDate | date:\'mediumDate\'}} - {{vm.endDate | date:\'mediumDate\'}}</div><div class="range-selector-block selector-icon"><i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-class="vm.loadingHoofTrims ? \'disabled\': \'\'"></i></div></div></div><div class="col-md-4"><div style="text-align: right"><div class="pdf-icon"><i class="fa fa-file-pdf-o" uib-tooltip="{{vm.tooltipText}}" tooltip-is-open="feedNameIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-click="vm.exportToPdf()"></i></div><div class="pdf-icon" style="margin-left: 10px"><i class="fa fa-file-excel-o" uib-tooltip="{{vm.tooltipTextCsv}}" tooltip-is-open="csvIsOpen" tooltip-placement="left" tooltip-class="customBlue left" tooltip-popup-delay="500" tooltip-append-to-body="true" ng-csv="vm.getCsvData()" filename="{{vm.fileName}}"></i></div></div></div></div><div class="row"><div style="padding: 0px 10px"><div include-with-scope="app/pages/lists/wrapList/wrapList.table.html"></div></div></div></div><div ng-if="vm.noVisitDates && vm.selectedHerds.length == 1 && !vm.errorLoading && !vm.loading" class="invoice-error"><span><data-i18n i18n="_invoice_message_no_data_">No data found for selected herd.</data-i18n></span></div><div ng-if="vm.selectedHerds.length == 1 && vm.loading && !vm.errorLoading && !vm.noVisitDates" align="center"><div><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/lists/wrapList/wrapList.table.html','<div class="horizontal-scroll"><table class="table" ng-if="!vm.loadingHoofTrims"><thead><tr class="header" style="margin-right: 15px"><th></th><th><data-i18n i18n="_label_limb_">Limb</data-i18n></th><th><data-i18n i18n="_invoice_label_lesion_">Lesion</data-i18n></th></tr></thead><tbody ng-repeat="(hoofTrimIndex, hoofTrim) in vm.hoofTrimData"><tr class="animal-info"><td colspan="9">{{hoofTrim.AnimalNumber}}<span ng-if="hoofTrim.AnimalEarTag && hoofTrim.AnimalNumber">-</span>{{hoofTrim.AnimalEarTag}} <span ng-if="!hoofTrim.AnimalNumber && !hoofTrim.AnimalEarTag">{{hoofTrim.AnimalName}}</span></td></tr><tr ng-repeat="(eventIndex, event) in hoofTrim.Limbs"><td><data-i18n i18n="_animal_details_hoof_treatment_type_wrap_">Wrap</data-i18n></td><td style="padding: 3px 3px; text-transform: uppercase">{{event.PositionString}}</td><td style="padding: 3px 3px"><div ng-repeat="lesion in event.Lesions">{{lesion.LesionString}}</div></td></tr></tbody><tbody ng-if="vm.hoofTrimData.length == 0"><tr><td colspan="3" ng-if="vm.hoofTrimByDate"><data-i18n i18n="_message_error_no_data_found_date_">No data found for selected herd and date.</data-i18n></td><td colspan="3" ng-if="!vm.hoofTrimByDate"><data-i18n i18n="_message_error_no_data_found_date_period_">No data found for selected herd and date period.</data-i18n></td></tr></tbody></table></div><div ng-if="vm.loadingHoofTrims" align="center"><div><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/milkings/failures/failures.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkings/milkingsActual/milkingsActual.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkings/refusals/refusals.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkProduction/components/components.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkProduction/conductivity/conductivity.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkProduction/pregnant/pregnant.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/milkProduction/milkTrend/milkTrend.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/postSales/postSalesImport/postSalesImport.html','<div class="widgets" id="a_details"><div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" ng-if="!vm.hidePage"><div include-with-scope="app/pages/postSales/postSalesImport/postSalesImport.panel.html"></div></div></div></div></div>');
$templateCache.put('app/pages/postSales/postSalesImport/postSalesImport.panel.html','<div ng-if="vm.numError"><span><data-i18n i18n="_message_error_select_only_one_herd_">Select one herd</data-i18n></span></div><div class="import-block-wrapper" ng-if="!vm.numError"><div class="import-block" ng-if="!vm.loading"><div class="import-icon-wrapper"><i class="ion-upload import-icon" ng-if="!vm.file"></i><div ng-if="vm.file"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeFile()"></span></div></div><div class="import-button"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event)" ngf-pattern="\'.xlsx,.xls\'" ngf-accept="\'.xlsx,.xls\'" ng-if="vm.showChooseButton"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button> <button class="btn btn-primary" ng-if="vm.showUploadButton" ng-click="vm.uploadFile()">Upload</button></div><div class="import-message"><div ng-if="vm.uploadSuccessful" class="success"><data-i18n i18n="_post_sales_import_success_message_">File uploaded</data-i18n></div><div ng-if="vm.uploadError" class="failed"><data-i18n i18n="_post_sales_import_failed_message_">Upload failed</data-i18n></div></div></div><div class="import-block" ng-if="vm.loading"><div style="text-align: center; height: 182px"><div class="loading-animation" style="margin-top: 70px;"></div></div></div></div>');
$templateCache.put('app/pages/overview/clawHealth/clawHealth.html','<div class="material-icons settings-button" ng-click="vm.openKPIConfig(\'clawHealth\')">settings</div><div class="form-group row clearfix selector" ng-if="vm.showClawHealth"><ui-select ng-model="vm.selectedKPI" on-select="vm.kpiSelected($index)" ng-disabled="vm.disableSelector" ng-if="vm.showSelector" style="margin-top: 10px"><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="kpi in vm.KPIS track by $index">{{kpi.label}}</ui-select-choices></ui-select></div><div id="clawHealthFrame" class="claw-health-dashboard-wrapper" ng-if="vm.showClawHealth"></div><div ng-if="!vm.showClawHealth && !vm.dashboardNotAvailable && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/postSales/postSalesReport/postSalesReport.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" style="height:auto;" id="panel-map" ng-if="!vm.errorLoading"><div style="text-align: right"><div style="text-align: right; margin-bottom: 5px; height: 20px;" ng-hide="vm.loadingDashboards || vm.noAvailableDashboards || vm.reselectTeamError || vm.errorLoading || vm.herdsLimitReached"><div ng-show="vm.currentDate"><data-i18n i18n="_rap_day_filter_message_">Showing data for</data-i18n><span style="margin-left: 3px;">{{vm.currentDate}}</span></div></div><div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.reselectTeamError"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.noAvailableDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center"><div class="loading-animation"></div></div><div id="postSalesReportFrame" class="dashboard-wrapper-presales" style="position: relative" ng-if="!vm.loadingDashboards" ng-hide="vm.herdsLimitReached"></div><div class="claw-health-back-button" ng-style="vm.showBackButton && {\'display\': \'block\'}" ng-click="vm.goBack()"><img src="assets/img/Zoetis_Previous.png"></div></div></div></div><div ng-if="vm.errorLoading" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div>');
$templateCache.put('app/pages/milkProduction/spp/spp.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/overview/emergencyWall/emergencyWall.html','');
$templateCache.put('app/pages/overview/lactationAnalysis/lactationAnalysis.html','<div id="lactationAnalysisFrame" class="lactation-analysis-dashboard-wrapper" ng-if="vm.showLactationAnalysis" ng-hide="vm.herdsLimitReached"></div><div ng-if="!vm.showLactationAnalysis && !vm.dashboardNotAvailable && !vm.errorLoading && !vm.herdsLimitReached" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.herdsLimitReached"><span style="padding: 5px;"><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/overview/mainKPI/mainKPI.html','<div class="row main-kpis"><div class="main-kpis-item-container" ng-repeat="KPI in vm.KPIS"><div ba-panel=""><iframe ng-src="{{KPI.trastedUrl}}" id="frame + $index" ng-if="vm.showKPIS"></iframe><div class="kpi-info">{{KPI.info}}</div></div></div></div>');
$templateCache.put('app/pages/overview/map/map.html','<div id="herdMapFrame" class="map-dashboard-wrapper" ng-if="vm.showMap"></div><div ng-if="!vm.showMap && !vm.dashboardNotAvailable && !vm.errorLoading" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/overview/MRO/MRO.html','<div id="mroFrame" class="mro-dashboard-wrapper" ng-if="vm.showMRO" ng-hide="vm.herdsLimitReached"></div><div ng-if="!vm.showMRO && !vm.dashboardNotAvailable && !vm.errorLoading && !vm.herdsLimitReached" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.herdsLimitReached"><span style="padding: 5px"><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/overview/masterKpi/kpiConf.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.modalLoading"><div class="date-period" ng-if="vm.showPeriodSettings"><div style="height: 35px"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.showPeriodSettings = false"></i></div><div class="form-group row clearfix selector"><ui-select ng-model="vm.selectedPeriodType" on-select="vm.periodTypeselected()"><ui-select-match>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="period in vm.datePeriodTypes track by $index">{{period.name}}</ui-select-choices></ui-select></div><div class="period-preview"><div class="period-dates">{{vm.settingsStartEndDate.start_date | date:\'mediumDate\'}}<span ng-if="vm.settingsStartEndDate.start_date" style="margin-left: 5px; margin-right: 5px">-</span> {{vm.settingsStartEndDate.end_date | date:\'mediumDate\'}} <i class="fa fa-calendar" aria-hidden="true" ng-click="vm.openRangeSelector()" ng-if="vm.selectedPeriodType.id == 99"></i></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" style="margin-right: 20px;" ng-click="vm.setPeriodType()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div></div><div class="date-selector" ng-if="vm.showDateSelector"><div style="height: 35px"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.showDateSelector = false"></i></div><div class="ds-panel" style="padding: 5px" ng-class="vm.timePickerError ? \'time-picker-error\' : \'\'"><label><data-i18n i18n="_label_start_date_">Start date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_start_date" is-open="vm.popupOpened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']" ng-disabled="vm.actualDashboardOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popupOpened = true" ng-disabled="vm.actualDashboardOpen"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label><data-i18n i18n="_label_end_date_">End date</data-i18n></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.modal_end_date" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div style="height: 20px; margin-top: 10px"><button class="btn btn-xs btn-success pull-right" style="margin-right: 20px;" ng-click="vm.setDateRange()"><data-i18n i18n="_report_set_">Set</data-i18n></button></div></div><div class="input-group" style="width: 80%; position: relative; margin: auto; left: 0; right: 0;"><span class="input-group-addon search-options-button" style="padding: 5px 7px; font-size:20px" ng-click="vm.showSearchSetings = !vm.showSearchSetings"><span class="ion-search"></span></span> <input type="text" class="form-control" ng-model="vm.searchString" ng-keyup="vm.setAnimalFilterEnter($event)"></div><ul class="main-kpi-list"><li ng-repeat="kpi in vm.KPIS | filter:vm.searchString"><div class="main-kpi-list-item"><div class="kpi-name" ng-click="kpi.selected = !kpi.selected">{{kpi.description}}</div><div class="selector"><div class="kpi-checkbox" ng-class="kpi.selected ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="kpi.selected = !kpi.selected"></div><div class="material-icons kpi-settings" ng-click="vm.openKPISettings(kpi)">settings</div></div></div></li></ul><div style="height: 20px; margin-top: 10px; margin-right: 10px; margin-bottom: 10px"><button class="btn btn-xs btn-success pull-right" ng-click="vm.saveKpis()"><data-i18n i18n="_label_save_">Save</data-i18n></button></div></div><div class="modal-body kpi-config" ng-if="vm.modalLoading"><div class="kpi-conf-modal-loading-spinner"><img src="assets/img/loader.gif"></div></div></div>');
$templateCache.put('app/pages/overview/masterKpi/masterKpi.html','<div class="conf-button" ng-class="vm.loading ? \'disabled\' : \'\'"><div class="button" ng-click="vm.openMasterKPI()"><div class="text">M</div></div></div><div class="settings-icon"><div class="material-icons" ng-class="vm.loading ? \'disabled\' : \'\'" ng-click="vm.openKPIConfig()">settings</div></div><div class="loading-spinner"><div class="loading-animation"></div></div>');
$templateCache.put('app/pages/overview/masterKpi/masterKpi.modal.html','<div class="modal-header"><div class="settings-icon"><div class="material-icons" ng-click="vm.openMasterKPIConfig()">settings</div></div><i class="ion-ios-close-outline close-modal" ng-click="vm.closeModal()"></i></div><div class="modal-body" ng-if="!vm.modalLoading"><div id="masterKPIFrame" class="master-kpi-dashboard-wrapper" ng-if="vm.showMasterKPI"></div><div ng-if="!vm.showMasterKPI && !vm.dashboardNotAvailable" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div class="master-config" ng-if="vm.showMasterConfig"><div class="tabs-wrapper"><uib-tabset active="vm.active"><uib-tab index="0" heading="General"><div class="period"><span class="header">Period</span><div class="period-table"><table class="table"><tbody><tr><td><data-i18n i18n="_label_end_date_">End date</data-i18n></td><td><p class="input-group"><input type="text" ng-class="vm.dateError ? \'error\' : \'\'" class="form-control" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.endDate" is-open="vm.popup2Opened" ng-required="true" close-text="{{\'_label_close_\' | i18n}}" alt-input-formats="[\'d!/M!/yyyy\']"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.popup2Opened = true"><i class="glyphicon glyphicon-calendar"></i></button></span></p></td></tr><tr class="n-periods"><td>Number of periods</td><td><input type="number" class="form-control" ng-model="vm.numberOfPeriods" min="1" ng-class="vm.NPError ? \'error\' : \'\'"></td></tr></tbody></table></div></div><div class="frequency"><span class="header">Frequency</span><div class="frequency-selector"><ul><li ng-hide="vm.hideDayFrequency"><div class="frequency-checkbox" ng-class="vm.frequency[0] ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFrequency(0)"><span>Day</span></div></li><li><div class="frequency-checkbox" ng-class="vm.frequency[1] ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFrequency(1)"><span>Week</span></div></li><li><div class="frequency-checkbox" ng-class="vm.frequency[2] ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFrequency(2)"><span>Month</span></div></li><li><div class="frequency-checkbox" ng-class="vm.frequency[3] ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFrequency(3)"><span>Quarter</span></div></li><li><div class="frequency-checkbox" ng-class="vm.frequency[4] ? \'ion-ios-checkmark-outline\' : \'ion-ios-circle-outline\'" ng-click="vm.selectFrequency(4)"><span>Year</span></div></li></ul></div></div></uib-tab></uib-tabset></div><div style="padding-right: 15px" align="right"><button type="button" class="btn btn-success" ng-click="vm.saveConfig()">Save</button> <button type="button" class="btn btn-danger" ng-click="vm.showMasterConfig = false">Cancel</button></div></div></div><div class="modal-body kpi-config" ng-if="vm.modalLoading"><div class="kpi-conf-modal-loading-spinner loading-spinner"><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/overview/presalesAudit/presalesAudit.html','<div id="presalesAuditFrame" class="presales-audit-dashboard-wrapper" ng-if="vm.showPresalesAudit" ng-hide="vm.herdsLimitReached"></div><div ng-if="!vm.showPresalesAudit && !vm.dashboardNotAvailable && !vm.errorLoading && !vm.herdsLimitReached" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.herdsLimitReached"><span style="padding: 5px;"><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/overview/production/production.html','<div id="productionFrame" class="production-dashboard-wrapper" ng-if="vm.showProduction" ng-hide="vm.herdsLimitReached"></div><div ng-if="!vm.showProduction && !vm.dashboardNotAvailable && !vm.errorLoading && !vm.herdsLimitReached" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.herdsLimitReached"><span style="padding: 5px;"><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/overview/reproduction/reproduction.html','<div class="material-icons settings-button" ng-click="vm.openKPIConfig()" ng-class="vm.loading ? \'disabled\' : \'\'">settings</div><div class="form-group row clearfix selector" ng-if="vm.showReproduction"><ui-select ng-model="vm.selectedKPI" on-select="vm.kpiSelected($index)" ng-disabled="vm.disableSelector" ng-if="vm.showSelector" style="margin-top: 10px"><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="kpi in vm.KPIS track by $index">{{kpi.label}}</ui-select-choices></ui-select></div><div id="reproductionFrame" class="reproduction-dashboard-wrapper" ng-if="vm.showReproduction" ng-hide="vm.herdsLimitReached"></div><div ng-if="!vm.showReproduction && !vm.dashboardNotAvailable && !vm.errorLoading && !vm.herdsLimitReached" class="loading-spinner"><div class="loading-animation"></div></div><div ng-if="vm.herdsLimitReached"><span style="padding: 5px;"><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><div ng-if="vm.dashboardNotAvailable"><span>Dashboard not available</span></div><div ng-if="vm.errorLoading" class="error-block"><span class="color-red">Error loading please reload and try again.</span> <button class="btn btn-primary btn-xs" ng-click="vm.init()" style="margin-left: 15px"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons" style="vertical-align: text-bottom; font-size: 19px">refresh</span></button></div>');
$templateCache.put('app/pages/robotEfficiency/robotPrestations/robotPrestations.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/robotEfficiency/milkingSpeed/milkingSpeed.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/robotEfficiency/milkHour/milkHour.html','<div class="row"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll" id="dashboard-panel"><div ng-if="vm.errorLoading && !vm.loadingDashboards"><div style="display: flex; justify-content: center; flex-direction: column; align-items: center;"><span class="color-red" style="margin-bottom: 10px;"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span ng-if="!vm.style || vm.style==\'zoetis\'" class="material-icons" style="vertical-align: text-bottom; font-size: 19px;">refresh</span> <span ng-if="vm.style==\'aveve\'"><img src="assets/img/refresh.svg" style="width: 20px; margin-top: -3px;"></span> <span ng-if="vm.style==\'proxani\'"><img src="assets/img/refresh_proxani.png" style="width: 20px; margin-top: -3px;"></span></button></div></div><div ng-if="vm.noAvailableDashboards && !vm.loadingDashboards"><span><data-i18n i18n="_message_no_available_dashboards_">No dashboards</data-i18n></span></div><div ng-if="vm.loadingDashboards" style="text-align: center; overflow: hidden;"><div class="loading-animation"></div></div><div ng-if="vm.reselectTeamError && !vm.loadingDashboards"><span class="color-red"><data-i18n i18n="_message_reselect_team_">Reselect team</data-i18n></span></div><div ng-if="vm.herdsLimitReached"><span><data-i18n i18n="_message_error_herds_limit_">Maximum number of selected herds is 20. Please select less herds.</data-i18n></span></div><arvesta-dashboard ng-if="!vm.loadingDashboards && !vm.reselectTeamError && !vm.noAvailableDashboards && !vm.errorLoading && !vm.herdsLimitReached" dashboard-data="vm.dashboardData"></arvesta-dashboard></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/accutrimBlock.html','<div><h5><data-i18n i18n="_page_accutrim_">Accutrim</data-i18n></h5><div ng-if="event.showDate"><span><data-i18n i18n="_label_date_">Date</data-i18n></span>:<span>{{event.eventDate | date:\'shortDate\'}}</span></div><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div><data-i18n i18n="_label_visit_reason_">Visit reason</data-i18n>:<span style="margin-left: 3px">{{event.visit_reason_string}}</span></div><div><table align="center" class="claw-health-table"><tbody><tr><td><div class="animal-claw"><div class="claw-base" ng-class="{\'treated-limb\' : event.LF.treated}"><data-i18n i18n="_animal_lf_">LF</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="{\'treated-limb\' : event.LF.treated}">o</div><div class="claw-toe-r" ng-class="{\'treated-limb\' : event.LF.treated}">i</div></div></div></td><td><div class="animal-claw"><div class="claw-base" ng-class="{\'treated-limb\' : event.RF.treated}"><data-i18n i18n="_animal_rf_">RF</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="{\'treated-limb\' : event.RF.treated}">i</div><div class="claw-toe-r" ng-class="{\'treated-limb\' : event.RF.treated}">o</div></div></div></td></tr><tr><td><table class="milk-summary"><tbody><tr><th><data-i18n i18n="_animal_medication_" ng-if="event.LF.TreatmentTypeString.length">Medication</data-i18n></th><th><data-i18n i18n="_animal_treatment_" ng-if="event.LF.ActionTypeString.length">Treatment</data-i18n></th></tr><tr><td style="padding-bottom: 10px"><div ng-repeat="treatment in event.LF.TreatmentTypeString">{{treatment}}</div></td><td style="padding-bottom: 10px"><div ng-repeat="action in event.LF.ActionTypeString">{{action}}</div></td></tr><tr style="border-top: 1px solid #d9d9d9" ng-if="event.LF.Lesions.length>0"><th style="padding-top: 10px"><data-i18n i18n="_animal_leasion_">Leasion</data-i18n></th><th style="padding-top: 10px"><data-i18n i18n="_animal_severity_">Severity</data-i18n></th></tr><tr ng-repeat="lesion in event.LF.Lesions" ng-if="event.LF.Lesions.length>0"><td>{{lesion.LesionTypeString}}</td><td>{{lesion.SeverityString}}</td></tr></tbody></table><div ng-if="event.LF.ReCheck" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #d9d9d9;"><span><data-i18n i18n="_animal_re_check_">Re check</data-i18n>: {{event.LF.ReCheckString}}</span></div></td><td><table class="milk-summary"><tbody><tr><th><data-i18n i18n="_animal_medication_" ng-if="event.RF.TreatmentTypeString.length">Medication</data-i18n></th><th><data-i18n i18n="_animal_treatment_" ng-if="event.RF.ActionTypeString.length">Treatment</data-i18n></th></tr><tr><td style="padding-bottom: 10px"><div ng-repeat="treatment in event.RF.TreatmentTypeString">{{treatment}}</div></td><td style="padding-bottom: 10px"><div ng-repeat="action in event.RF.ActionTypeString">{{action}}</div></td></tr><tr style="border-top: 1px solid #d9d9d9" ng-if="event.RF.Lesions.length>0"><th style="padding-top: 10px"><data-i18n i18n="_animal_leasion_">Leasion</data-i18n></th><th style="padding-top: 10px"><data-i18n i18n="_animal_severity_">Severity</data-i18n></th></tr><tr ng-repeat="lesion in event.RF.Lesions" ng-if="event.RF.Lesions.length>0"><td>{{lesion.LesionTypeString}}</td><td>{{lesion.SeverityString}}</td></tr></tbody></table><div ng-if="event.RF.ReCheck" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #d9d9d9;"><span><data-i18n i18n="_animal_re_check_">Re check</data-i18n>: {{event.RF.ReCheckString}}</span></div></td></tr></tbody></table></div><div><table align="center" class="claw-health-table"><tbody><tr><td><div class="animal-claw"><div class="claw-base" ng-class="{\'treated-limb\' : event.LR.treated}"><data-i18n i18n="_animal_lr_">LR</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="{\'treated-limb\' : event.LR.treated}">o</div><div class="claw-toe-r" ng-class="{\'treated-limb\' : event.LR.treated}">i</div></div></div></td><td><div class="animal-claw"><div class="claw-base" ng-class="{\'treated-limb\' : event.RR.treated}"><data-i18n i18n="_animal_rr_">RR</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="{\'treated-limb\' : event.RR.treated}">i</div><div class="claw-toe-r" ng-class="{\'treated-limb\' : event.RR.treated}">o</div></div></div></td></tr><tr><td><table class="milk-summary"><tbody><tr><th><data-i18n i18n="_animal_medication_" ng-if="event.LR.TreatmentTypeString.length">Medication</data-i18n></th><th><data-i18n i18n="_animal_treatment_" ng-if="event.LR.ActionTypeString.length">Treatment</data-i18n></th></tr><tr><td style="padding-bottom: 10px"><div ng-repeat="treatment in event.LR.TreatmentTypeString">{{treatment}}</div></td><td style="padding-bottom: 10px"><div ng-repeat="action in event.LR.ActionTypeString">{{action}}</div></td></tr><tr style="border-top: 1px solid #d9d9d9" ng-if="event.LR.Lesions.length>0"><th style="padding-top: 10px"><data-i18n i18n="_animal_leasion_">Leasion</data-i18n></th><th style="padding-top: 10px"><data-i18n i18n="_animal_severity_">Severity</data-i18n></th></tr><tr ng-repeat="lesion in event.LR.Lesions" ng-if="event.LR.Lesions.length>0"><td>{{lesion.LesionTypeString}}</td><td>{{lesion.SeverityString}}</td></tr></tbody></table><div ng-if="event.LR.ReCheck" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #d9d9d9;"><span><data-i18n i18n="_animal_re_check_">Re check</data-i18n>: {{event.LR.ReCheckString}}</span></div></td><td><table class="milk-summary"><tbody><tr><th><data-i18n i18n="_animal_medication_" ng-if="event.RR.TreatmentTypeString.length">Medication</data-i18n></th><th><data-i18n i18n="_animal_treatment_" ng-if="event.RR.ActionTypeString.length">Treatment</data-i18n></th></tr><tr><td style="padding-bottom: 10px"><div ng-repeat="treatment in event.RR.TreatmentTypeString">{{treatment}}</div></td><td style="padding-bottom: 10px"><div ng-repeat="action in event.RR.ActionTypeString">{{action}}</div></td></tr><tr style="border-top: 1px solid #d9d9d9" ng-if="event.RR.Lesions.length>0"><th style="padding-top: 10px"><data-i18n i18n="_animal_leasion_">Leasion</data-i18n></th><th style="padding-top: 10px"><data-i18n i18n="_animal_severity_">Severity</data-i18n></th></tr><tr ng-repeat="lesion in event.RR.Lesions" ng-if="event.RR.Lesions.length>0"><td>{{lesion.LesionTypeString}}</td><td>{{lesion.SeverityString}}</td></tr></tbody></table><div ng-if="event.RR.ReCheck" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #d9d9d9;"><span><data-i18n i18n="_animal_re_check_">Re check</data-i18n>: {{event.RR.ReCheckString}}</span></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/addNewDiscussion.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><div ng-if="vm.showHerdSelector"><ui-select ng-model="vm.selectedHerd" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="false" search-enabled="false" required="" name="feed_type"><ui-select-match placeholder="{{\'_placeholder_select_herd_\'|i18n}}"><span>{{$select.selected.HerdName}}</span></ui-select-match><ui-select-choices repeat="herd in vm.herds | filter: $select.search"><span ng-bind-html="herd.HerdName"></span></ui-select-choices></ui-select></div><div><div style="padding: 10px 20px"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.discussion.importance=0" ng-class="vm.discussion.importance==0 ? \'label-importance-selected\' : (!vm.discussion.importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.discussion.importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=1"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.discussion.importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=2"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.discussion.importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.discussion.importance=3"><data-i18n i18n="_label_high_">High</data-i18n></span></div><div style="padding: 10px 20px"><span class="action-menu-label" style="margin-top: 3px;"><data-i18n i18n="_label_is_task_">is task</data-i18n>?</span> <input type="checkbox" ng-model="vm.discussion.isTask"></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.discussion.comments"></div></div><div style="padding: 10px 20px"><div class="input-group" style="max-width:310px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-model="vm.discussion.tags_list" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" on-select="vm.newDiscussionSetTags()" on-remove="vm.newDiscussionSetTags()"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></div><div class="upload-file-block"><div ng-if="!vm.file"><i class="ion-ios-cloud-upload"></i></div><div ng-if="!vm.file"><button type="file" class="btn btn-primary" ngf-select="" ng-model="vm.file" name="file" ngf-max-size="10MB" ngf-change="vm.uploadChanged()"><data-i18n i18n="_btn_choose_file_to_upload_">choose file</data-i18n></button></div><div ng-if="vm.file"><span>{{vm.fileName}}</span><span class="ion-close-circled remove-selected" ng-click="vm.removeSelectedFile()"></span></div></div></div></div><div class="modal-body" ng-if="vm.selectHerdError"><div style="text-align: center"><h4 class="color-red"><data-i18n i18n="_message_error_default_herd_not_defined_">Default herd is not defined</data-i18n></h4></div></div><div class="modal-body" style="text-align: center" ng-if="vm.loadingNewDiscussion"><div class="loading-animation"></div></div><div class="modal-footer" ng-if="!vm.selectHerdError && !vm.loadingNewDiscussion"><button type="button" class="btn btn-success" ng-click="vm.addNewDiscussion()"><data-i18n i18n="_label_save_">save</data-i18n></button></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.clawHealth.html','<div ba-panel=""><div class="animal-tabs"><button class="animal-tabs-button" ng-class="vm.activeClawHealtButton == 0 ? \'active-button\' : \'\'" ng-click="vm.setActiveClawHealtButton(0)"><data-i18n i18n="_label_mmmooogle_trim_">mmmooogle trim</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeClawHealtButton == 1 ? \'active-button\' : \'\'" ng-click="vm.setActiveClawHealtButton(1)"><data-i18n i18n="_page_accutrim_">Accutrim</data-i18n></button></div><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview && vm.activeClawHealtButton == 0"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 9 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Sneakers-2\' | kameleonImg )}}" ng-if="event.eventType == 9 || event.eventType == 14"></div></div><div class="cd-timeline-content-animal"><div ng-if="event.eventType == 9"><div include-with-scope="app/pages/herds/animals/animalDetails/mmmTrimBlock.html"></div></div></div></div></section><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview && vm.activeClawHealtButton == 1"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 14 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Sneakers-2\' | kameleonImg )}}" ng-if="event.eventType == 9 || event.eventType == 14"></div></div><div class="cd-timeline-content-animal"><div ng-if="event.eventType == 14"><div include-with-scope="app/pages/herds/animals/animalDetails/accutrimBlock.html"></div></div></div></div></section></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.fame.html','<div ba-panel="" style="text-align: center"><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><div class="row" ng-if="vm.showOverview"><div class="col-sm-12 col-md-6 lactation-selector"><div class="event-herd-selector" ng-show="vm.availableLactations"><ui-select ng-model="vm.currentLactation" theme="selectize" class="select-tags" style="height:20px" ng-change="vm.lactationChanged()"><ui-select-match allow-clear="true" placeholder="{{\'_animal_lactation_\' | i18n}}"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span> {{$select.selected.Parity}}</div></ui-select-match><ui-select-choices repeat="lactation in vm.availableLactations"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span><span>{{lactation.Parity}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-12 col-md-6 fullscreen-icon" ng-if="!vm.noMilkGraphData"><i class="material-icons animal-details-clickable-icon" ng-click="vm.openGraphModal()">fullscreen</i></div></div><table class="table table-hover rap-tables fit-to-screen" ng-if="vm.showOverview"><thead><tr><th></th><th style="text-align: center"><span></span><div style="margin-bottom: 19px"><data-i18n i18n="_animal_dim_">DIM</data-i18n></div></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_label_date_">Date</data-i18n></div></th><th style="text-align: center"><data-i18n i18n="_animal_details_total_">Total</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_programmed_concentrate_">programmed concentrate</data-i18n></span></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_animal_details_leftovers_">Leftovers</data-i18n></div></th><th style="text-align: center"><data-i18n i18n="_animal_details_daily_">Daily</data-i18n><br><data-i18n i18n="_animal_details_milk_production_">milk production</data-i18n></th><th style="text-align: center"><data-i18n i18n="_animal_details_deviation_">Deviation</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_milk_production_deviation_">milk production</data-i18n></span></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_animal_details_spp_">SPP</data-i18n></div></th><th style="text-align: center"><data-i18n i18n="_animal_details_number_">Number</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_of_milkings_">of milkings</data-i18n></span></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_animal_details_milking_speed_">Milking speed</data-i18n></div></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_animal_details_refusal_">Refusal</data-i18n></div></th><th style="text-align: center"><div style="margin-bottom: 19px"><data-i18n i18n="_animal_details_failures_">Failures</data-i18n></div></th><th style="text-align: center"><data-i18n i18n="_animal_details_avarage_">Average</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_milkings_">Milkings</data-i18n></span></th><th style="text-align: center"><data-i18n i18n="_animal_details_avarage_refusal_">Average</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_refusal_average_">refusal</data-i18n></span></th><th style="text-align: center"><data-i18n i18n="_animal_details_avarage_failures_">Average</data-i18n><br><span style="text-transform: lowercase"><data-i18n i18n="_animal_details_failures_average_">Failures</data-i18n></span></th></tr><tr><th><data-i18n i18n="_animal_details_sum_">SUM</data-i18n></th><th></th><th></th><th></th><th></th><th style="text-align: center">{{vm.std.milk_production_sum || \'-\'}}<span ng-if="vm.std.milk_production_sum">Kg</span></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr><tr><th><data-i18n i18n="_animal_details_average_value_">Average</data-i18n></th><th></th><th></th><th></th><th></th><th style="text-align: center">{{vm.std.milk_production_avg || \'-\'}}<span ng-if="vm.std.milk_production_avg">Kg</span></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.fameTableData"><td></td><td style="text-align: center">{{item.dim}}</td><td style="text-align: center">{{item.date | date:\'shortDate\'}}</td><td style="text-align: center">{{item.totalCalculatedConcentrate || \'-\' }}</td><td style="text-align: center">{{item.leftovers || \'-\' }}</td><td style="text-align: center">{{item.milkIntake || \'-\'}}<span ng-if="item.milkIntake">Kg</span></td><td style="text-align: center" ng-class="item.deviation < 0 ? \'color-red\' : \'\'">{{item.deviation || \'-\'}}<span ng-if="item.deviation">%</span></td><td style="text-align: center">{{item.spp }}</td><td style="text-align: center">{{item.milkings }}</td><td style="text-align: center">{{item.milkSpeed}}</td><td style="text-align: center">{{item.refusals }}</td><td style="text-align: center">{{item.failures }}</td><td style="text-align: center">{{item.milkings_average }}</td><td style="text-align: center">{{item.refusals_average }}</td><td style="text-align: center">{{item.failures_average }}</td></tr><tr ng-if="vm.showLoadMoreFameTableData" style="text-align: center"><td colspan="15" style="padding: 5px;"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreFameTableData()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></td></tr><tr ng-if="!vm.showLoadMoreFameTableData && vm.useRapDates" style="text-align: center"><td colspan="15" style="padding: 5px;"><button class="btn btn-primary btn-sm" ng-click="vm.lactationChanged()"><data-i18n i18n="_button_show_all_">Show all</data-i18n></button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.feedIntake.html','<div ba-panel=""><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><table class="table table-hover table-limitless" ng-show="vm.showOverview"><thead><tr><th><data-i18n i18n="_animal_status_date_">Date</data-i18n></th><th><data-i18n i18n="_animal_details_product_name_">Product name</data-i18n></th><th><data-i18n i18n="_animal_details_product_category_">Product category</data-i18n></th><th><data-i18n i18n="_animal_intake_amount_">Intake amount</data-i18n><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_animal_intake_amount_ration_">Ration intake</data-i18n><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_animal_details_dm_">DM</data-i18n></th></tr></thead><tbody><tr ng-repeat="event in vm.feedIntakes | orderBy:\'-eventDate\'" ng-if="event.eventType == 15 && !event.hideEvent"><td>{{event.eventDate | date:\'shortDate\'}}</td><td>{{event.ProductName}}</td><td>{{event.ProductCategory || \'-\'}}</td><td>{{event.IntakeKg || \'-\'}}</td><td>{{event.RationKg || \'-\'}}</td><td>{{event.DM || \'-\'}}</td></tr></tbody></table></div><div ng-if="vm.showLoadMoreFeedIntakes" style="text-align: center"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreFeedIntakes()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.healthEvents.html','<div ba-panel=""><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 8 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Surgeon\' | kameleonImg )}}" ng-if="event.eventType == 8"></div></div><div class="cd-timeline-content-animal"><div ng-if="event.eventType == 8"><div include-with-scope="app/pages/herds/animals/animalDetails/animalHealthBlock.html"></div></div></div></div></section></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.html','<div class="widgets" id="a_details"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-class="with-scroll" ng-if="!vm.hidePage && !vm.errorLoadingAnimal"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.panel.html"></div></div><div ng-if="vm.errorLoadingAnimal" class="error-msg-wrapper"><div class="error-block"><span class="msg-text"><data-i18n i18n="_message_error_">Error</data-i18n></span> <button class="btn btn-primary" ng-click="vm.init()"><span><data-i18n i18n="_button_reload_">Reload</data-i18n></span> <span class="material-icons">refresh</span></button></div></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.milkProduction.html','<div ba-panel=""><div class="animal-tabs"><button class="animal-tabs-button" ng-class="vm.activeMilkButton == 0 ? \'active-button\' : \'\'" ng-click="vm.setActiveMilkButton(0)"><data-i18n i18n="_label_milk_control_">milk control</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeMilkButton == 1 ? \'active-button\' : \'\'" ng-click="vm.setActiveMilkButton(1)"><data-i18n i18n="_label_milk_meter_">Milk meter</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeMilkButton == 2 ? \'active-button\' : \'\'" ng-click="vm.setActiveMilkButton(2)"><data-i18n i18n="_animal_lactations_">Lactations</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeMilkButton == 3 ? \'active-button\' : \'\'" ng-click="vm.setActiveMilkButton(3)"><data-i18n i18n="_animal_manually_added_milk_">Manual milk</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeMilkButton == 4 ? \'active-button\' : \'\'" ng-click="vm.setActiveMilkButton(4)" ng-if="!vm.is_farmer"><data-i18n i18n="_animal_details_graph_">Graph</data-i18n></button></div><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><div ng-if="vm.showOverview && vm.activeMilkButton == 0"><table class="table table-hover table-limitless"><thead><tr><th><data-i18n i18n="_animal_status_date_">Date</data-i18n></th><th><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></th><th><data-i18n i18n="_animal_dim_">DIM</data-i18n></th><th><data-i18n i18n="_animal_milk_">milk</data-i18n><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_animal_fat_percentage_">Fat percentage</data-i18n></th><th><data-i18n i18n="_animal_protein_percentage_">Protein percentage</data-i18n></th><th><data-i18n i18n="_animal_scc_">SCC</data-i18n></th><th><data-i18n i18n="_animal_urea_">Urea</data-i18n></th><th><data-i18n i18n="_label_advice_">Advice</data-i18n></th></tr></thead><tbody><tr ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 6 && !event.hideEvent"><td>{{event.eventDate | date:\'shortDate\'}}</td><td>{{event.Parity}}</td><td>{{event.DIM || \'-\'}}</td><td>{{event.AmountKg || \'-\'}}</td><td>{{event.FatPercentage || \'-\'}}</td><td>{{event.ProteinPercentage || \'-\'}}</td><td>{{event.SCC || \'-\'}}</td><td>{{event.Urea || \'-\'}}</td><td>{{event.Advice || \'-\'}}</td></tr></tbody></table></div><div ng-if="vm.showOverview && vm.activeMilkButton == 1"><table class="table table-hover table-limitless"><thead><tr><th><data-i18n i18n="_animal_status_date_">Date</data-i18n></th><th><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></th><th><data-i18n i18n="_animal_dim_">DIM</data-i18n></th><th><data-i18n i18n="_animal_milk_">milk</data-i18n><span style="margin-left: 3px">(Kg)</span></th></tr></thead><tbody><tr ng-repeat="event in vm.milkMeterData | orderBy:\'-eventDate\'" ng-if="event.eventType == 13 && !event.hideEvent"><td>{{event.eventDate | date:\'shortDate\'}}</td><td>{{event.Parity}}</td><td>{{event.DIM || \'-\'}}</td><td>{{event.AmountKg || \'-\'}}</td></tr></tbody></table><div ng-if="vm.showLoadMoreMilkIntakes" style="text-align: center"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreMilkIntakes()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></div></div><div ng-if="vm.showOverview && vm.activeMilkButton == 3"><table class="table table-hover table-limitless"><thead><tr><th><data-i18n i18n="_animal_status_date_">Date</data-i18n></th><th><data-i18n i18n="_animal_dim_">DIM</data-i18n></th><th><data-i18n i18n="_animal_milk_">milk</data-i18n><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_label_amount_">amount</data-i18n><span style="margin-left: 3px">1</span><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_label_amount_">amount</data-i18n><span style="margin-left: 3px">2</span><span style="margin-left: 3px">(Kg)</span></th><th><data-i18n i18n="_label_amount_">amount</data-i18n><span style="margin-left: 3px">3</span><span style="margin-left: 3px">(Kg)</span></th></tr></thead><tbody><tr ng-repeat-start="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 10 && !event.hideEvent"><td>{{event.eventDate | date:\'shortDate\'}}</td><td>{{event.DIM || \'-\'}}</td><td>{{event.Milk || \'-\'}}</td><td>{{event.Amount1Kg || \'-\'}}</td><td>{{event.Amount2Kg || \'-\'}}</td><td>{{event.Amount3Kg || \'-\'}}</td></tr><tr ng-repeat-end="" ng-if="event.eventType == 10 && !event.hideEvent"><td colspan="8" style="line-height: 20px"><div ng-if="event.Pictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[0].Importance == 1 ? \'importance-1\' : (event.Pictures[0].Importance == 2 ? \'importance-2\' : (event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[0].Creator}}</div><div class="image-details">{{event.Pictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[0].NumberComments && event.Pictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[1].Importance == 1 ? \'importance-1\' : (event.Pictures[1].Importance == 2 ? \'importance-2\' : (event.Pictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[1].Creator}}</div><div class="image-details">{{event.Pictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[1].NumberComments && event.Pictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.Pictures, event)">+{{event.Pictures.length - 2}}</span></div></div></div></td></tr></tbody></table></div><div ng-if="vm.showOverview && vm.activeMilkButton == 2"><table class="table table-hover table-limitless"><thead style="display: none"><tr><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat-start="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 5 && !event.hideEvent"><td colspan="6" class="lactation-table-header"><span><span><data-i18n i18n="_animal_details_lactation_">Lactation</data-i18n>&#32</span> {{event.Parity}}&#32 <span style="margin-right: 3px; text-transform: lowercase;"><data-i18n i18n="_animal_details_started_">started</data-i18n>&#32</span></span><span style="margin-right: 3px"><span>({{event.eventDate | date:\'shortDate\'}})</span></span></td></tr><tr ng-if="event.eventType == 5 && !event.hideEvent"><td colspan="6" class="lactation-table-header"><data-i18n i18n="_label_total_summary_">Total summary</data-i18n></td></tr><tr ng-if="event.eventType == 5 && !event.hideEvent"><td><data-i18n i18n="_animal_milk_">Milk</data-i18n><span style="margin-left: 3px">(Kg)</span></td><td><data-i18n i18n="_animal_fat_percentage_">Fat(%)</data-i18n></td><td><data-i18n i18n="_animal_fat_kg_">Fat(Kg)</data-i18n></td><td><data-i18n i18n="_animal_protein_percentage_">Protein(%)</data-i18n></td><td><data-i18n i18n="_animal_protein_kg_">Protein(Kg)</data-i18n></td><td>&#x3A3;<span style="margin-left: 3px">(Kg)</span></td></tr><tr ng-if="event.eventType == 5 && !event.hideEvent"><td>{{(event.KgMilkLactation |number:0) || \'-\'}}</td><td>{{(event.KgFatPercent | number: 2) || \'-\'}}</td><td>{{(event.KgFatLactation | number: 0) || \'-\'}}</td><td>{{(event.KgProteinPercent | number: 2) || \'-\'}}</td><td>{{(event.KgProteinLactation | number: 0) || \'-\'}}</td><td>{{(event.KgSum | number: 0) || \'-\'}}</td></tr><tr ng-if="event.eventType == 5 && !event.hideEvent"><td colspan="6" class="lactation-table-header"><data-i18n i18n="_label_305_summary_">305 summary</data-i18n></td></tr><tr ng-if="event.eventType == 5 && !event.hideEvent"><td><data-i18n i18n="_animal_milk_">Milk</data-i18n><span style="margin-left: 3px">(Kg)</span> <span class="milk-info-icon"><div class="info-icon" uib-tooltip="{{\'_label_305_milk_tooltip_\' | i18n}}" tooltip-is-open="tooltipOpen" tooltip-placement="top" tooltip-class="customBlue top" tooltip-popup-delay="500" tooltip-append-to-body="true"><i class="material-icons">info</i></div></span></td><td><data-i18n i18n="_animal_fat_percentage_">Fat(%)</data-i18n></td><td><data-i18n i18n="_animal_fat_kg_">Fat(Kg)</data-i18n></td><td><data-i18n i18n="_animal_protein_percentage_">Protein(%)</data-i18n></td><td><data-i18n i18n="_animal_protein_kg_">Protein(Kg)</data-i18n></td><td>&#x3A3;<span style="margin-left: 3px">(Kg)</span></td></tr><tr ng-repeat-end="" ng-if="event.eventType == 5 && !event.hideEvent" class="lactation-table-footer"><td>{{(event.KgMilk305 |number:0) || \'-\'}}</td><td>{{(event.KgFat305Percent | number: 2) || \'-\'}}</td><td>{{(event.KgFat305 | number: 0) || \'-\'}}</td><td>{{(event.KgProtein305Percent | number: 2) || \'-\'}}</td><td>{{(event.KgProtein305 | number: 0) || \'-\'}}</td><td>{{(event.Kg305Sum | number: 0) || \'-\'}}</td></tr><tr><td colspan="6" class="lactation-table-header">&#x3A3;</td></tr><tr><td><data-i18n i18n="_animal_milk_">Milk</data-i18n><span style="margin-left: 3px">(Kg)</span></td><td><data-i18n i18n="_animal_fat_">Fat</data-i18n><span style="margin-left: 3px">(%)</span></td><td><data-i18n i18n="_animal_fat_">Fat</data-i18n><span style="margin-left: 3px">(Kg)</span></td><td><data-i18n i18n="_animal_protein_">Protein</data-i18n><span style="margin-left: 3px">(%)</span></td><td><data-i18n i18n="_animal_protein_">Protein</data-i18n><span style="margin-left: 3px">(Kg)</span></td><td>&#x3A3;<span style="margin-left: 3px">(Kg)</span></td></tr><tr><td>{{(vm.totalMilk |number:0) || \'-\'}}</td><td>{{(vm.totalFatPercentage | number: 2) || \'-\'}}</td><td>{{(vm.totalFat | number: 0) || \'-\'}}</td><td>{{(vm.totalProteinPercentage | number: 2) || \'-\'}}</td><td>{{(vm.totalProtein | number: 0) || \'-\'}}</td><td>{{(vm.totalSum | number: 0) || \'-\'}}</td></tr></tbody></table></div><div ng-if="vm.activeMilkButton == 4 && vm.showOverview"><div style="text-align: right" ng-if="!vm.noMilkGraphData"><i class="material-icons animal-details-clickable-icon" ng-click="vm.openGraphModal()">fullscreen</i></div><div class="slider-box" ng-if="vm.showOverview && !vm.noMilkGraphData"><input ion-range-slider="" min="0" max="vm.dim" from="vm.fromSlider" to="vm.toSlider" type="double" on-change="vm.sliderChanged()"></div><div ng-if="vm.showOverview && !vm.noMilkGraphData" style="text-align: right; padding: 10px 5px">({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div><div style="height: 230px" ng-if="!vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChart" width="100%" height="300"></canvas></div><div style="height: 250px" ng-if="!vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChart2" width="100%" height="300"></canvas></div><div class="graph-legend"><div ng-repeat="legend in vm.legendItems" class="graph-legend-item"><div ng-style="vm.getBackgroundColor(legend)"></div>{{legend.text}}</div></div><div style="height: 550px" ng-if="vm.noMilkGraphData" class="no-graph-data"><i class="ion-minus-circled" style="position: absolute; top: 150px; left: 0; right: 0; margin: auto"></i></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.overview.html','<div ba-panel=""><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview"><div class="cd-timeline-block" ng-repeat="event in vm.eventsToShow | orderBy:\'-eventDate\'" ng-if="event.eventType!=13 && !event.hideEvent && event.eventType!=14 && event.eventType!=15"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning" style="margin-top:5px"><img ng-src="{{::( \'Party-Poppers\' | kameleonImg )}}" ng-if="event.eventType == 1"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Dna\' | kameleonImg )}}" ng-if="event.eventType == 2"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Nurse-1\' | kameleonImg )}}" ng-if="event.eventType == 3"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Microscope\' | kameleonImg )}}" ng-if="event.eventType == 4 || event.eventType==6 || event.eventType==7 || event.eventType==10 || event.eventType==18"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Bell\' | kameleonImg )}}" ng-if="event.eventType == 5 || event.eventType == 11 || event.eventType == 12 || event.eventType == 16 || event.eventType == 17"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Surgeon\' | kameleonImg )}}" ng-if="event.eventType == 8"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Sneakers-2\' | kameleonImg )}}" ng-if="event.eventType == 9"></div></div><div class="cd-timeline-content-animal" ng-class="event.eventType == 5 ? \'lactation-started\': \'\'"><div ng-if="event.eventType == 1"><h5><data-i18n i18n="_animal_birth_">animal birth</data-i18n></h5></div><div ng-if="event.eventType == 2"><div include-with-scope="app/pages/herds/animals/animalDetails/reproBlock.html"></div></div><div ng-if="event.eventType == 3"><div include-with-scope="app/pages/herds/animals/animalDetails/calvingBlock.html"></div></div><div ng-if="event.eventType == 4"><div include-with-scope="app/pages/herds/animals/animalDetails/examinationBlock.html"></div></div><div ng-if="event.eventType == 5"><div include-with-scope="app/pages/herds/animals/animalDetails/lactationBlock.html"></div></div><div ng-if="event.eventType == 6"><div><h5><span style="margin-left: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span><span>&#32</span>{{event.Parity}}<span style="margin-left: 3px">({{event.LactationStartDate | date:\'shortDate\'}})</span> <span><span>&#32-&#32</span><data-i18n i18n="_label_milk_control_">milk control</data-i18n></span></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div><data-i18n i18n="_animal_milk_">Milk</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.AmountKg || \'-\'}}</span></div></div><div class="animal-reproduction"><div><data-i18n i18n="_animal_fat_percentage_">Fat percentage</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.FatPercentage || \'-\'}}</span></div><div><data-i18n i18n="_animal_protein_percentage_">Protein percentage</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.ProteinPercentage || \'-\'}}</span></div></div><div class="animal-reproduction"><div><data-i18n i18n="_animal_scc_">SCC</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.SCC || \'-\'}}</span></div><div><data-i18n i18n="_animal_urea_">Urea</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Urea || \'-\'}}</span></div></div><div class="animal-reproduction"><div><data-i18n i18n="_label_advice_">Advice</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Advice}}</span></div></div></div></div><div ng-if="event.eventType == 7 || event.eventType == 18"><div><h5><data-i18n i18n="_animal_udder_health_clinical_mastitis_" ng-if="event.UdderHealthType == 0">Udder Health - Clinical</data-i18n><data-i18n i18n="_animal_udder_health_misc_" ng-if="event.UdderHealthType == 2">Udder Health - Misc</data-i18n><data-i18n i18n="_animal_udder_health_subclinical_mastitis_" ng-if="event.UdderHealthType == 1">Udder Health - subclinical</data-i18n></h5><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthBlock.html" ng-if="event.eventType == 7"></div><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthStreamerBlock.html" ng-if="event.eventType == 18"></div><div ng-if="event.UdderHealthType == 0 && event.clinicalImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.clinicalImages[0].Importance == 1 ? \'importance-1\' : (event.clinicalImages[0].Importance == 2 ? \'importance-2\' : (event.clinicalImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'clinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.clinicalImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.clinicalImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.clinicalImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.clinicalImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.clinicalImages[0].Creator}}</div><div class="image-details">{{event.clinicalImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.clinicalImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.clinicalImages[0].NumberComments && event.clinicalImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.clinicalImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.clinicalImages[1].Importance == 1 ? \'importance-1\' : (event.clinicalImages[1].Importance == 2 ? \'importance-2\' : (event.clinicalImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'clinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.clinicalImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.clinicalImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.clinicalImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.clinicalImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.clinicalImages[1].Creator}}</div><div class="image-details">{{event.clinicalImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.clinicalImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.clinicalImages[1].NumberComments && event.clinicalImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.clinicalImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'clinicalImages\', event)">+{{event.clinicalImages.length - 2}}</span></div></div></div><div ng-if="event.UdderHealthType == 2 && event.miscImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.miscImages[0].Importance == 1 ? \'importance-1\' : (event.miscImages[0].Importance == 2 ? \'importance-2\' : (event.miscImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'miscImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.miscImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.miscImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.miscImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.miscImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.miscImages[0].Creator}}</div><div class="image-details">{{event.miscImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.miscImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.miscImages[0].NumberComments && event.miscImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.miscImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.miscImages[1].Importance == 1 ? \'importance-1\' : (event.miscImages[1].Importance == 2 ? \'importance-2\' : (event.miscImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'miscImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.miscImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.miscImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.miscImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.miscImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.miscImages[1].Creator}}</div><div class="image-details">{{event.miscImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.miscImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.miscImages[1].NumberComments && event.miscImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.miscImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'miscImages\', event)">+{{event.miscImages.length - 2}}</span></div></div></div><div ng-if="event.UdderHealthType == 1 && event.subclinicalImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.subclinicalImages[0].Importance == 1 ? \'importance-1\' : (event.subclinicalImages[0].Importance == 2 ? \'importance-2\' : (event.subclinicalImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'subclinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.subclinicalImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.subclinicalImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.subclinicalImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.subclinicalImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.subclinicalImages[0].Creator}}</div><div class="image-details">{{event.subclinicalImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.subclinicalImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.subclinicalImages[0].NumberComments && event.subclinicalImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.subclinicalImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.subclinicalImages[1].Importance == 1 ? \'importance-1\' : (event.subclinicalImages[1].Importance == 2 ? \'importance-2\' : (event.subclinicalImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'subclinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.subclinicalImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.subclinicalImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.subclinicalImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.subclinicalImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.subclinicalImages[1].Creator}}</div><div class="image-details">{{event.subclinicalImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.subclinicalImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.subclinicalImages[1].NumberComments && event.subclinicalImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.subclinicalImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'subclinicalImages\', event)">+{{event.subclinicalImages.length - 2}}</span></div></div></div></div></div><div ng-if="event.eventType == 8"><div include-with-scope="app/pages/herds/animals/animalDetails/animalHealthBlock.html"></div></div><div ng-if="event.eventType == 9"><div include-with-scope="app/pages/herds/animals/animalDetails/mmmTrimBlock.html"></div></div><div ng-if="event.eventType == 10"><div><h5><span style="margin-left: 3px;"><data-i18n i18n="_animal_manually_added_milk_">Manually added milk</data-i18n></span></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><table class="milk-summary"><thead><tr><th><data-i18n i18n="_animal_milk_">Milk</data-i18n></th><th><data-i18n i18n="_label_amount_">amount</data-i18n><span>1</span></th><th>{{event.Amount1Kg || \'-\'}} <span ng-if="event.Amount1Kg">Kg</span></th></tr></thead><tbody><tr><td>{{event.Milk }}<span>Kg</span></td><td><data-i18n i18n="_label_amount_">amount</data-i18n><span>2</span></td><td>{{event.Amount2Kg || \'-\'}} <span ng-if="event.Amount2Kg">Kg</span></td></tr><tr><td></td><td><data-i18n i18n="_label_amount_">amount</data-i18n><span>3</span></td><td>{{event.Amount3Kg || \'-\'}} <span ng-if="event.Amount3Kg">Kg</span></td></tr></tbody></table></div><div ng-if="event.Pictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[0].Importance == 1 ? \'importance-1\' : (event.Pictures[0].Importance == 2 ? \'importance-2\' : (event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[0].Creator}}</div><div class="image-details">{{event.Pictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[0].NumberComments && event.Pictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[1].Importance == 1 ? \'importance-1\' : (event.Pictures[1].Importance == 2 ? \'importance-2\' : (event.Pictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[1].Creator}}</div><div class="image-details">{{event.Pictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[1].NumberComments && event.Pictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.Pictures, event)">+{{event.Pictures.length - 2}}</span></div></div></div></div></div><div ng-if="event.eventType == 11"><h5><span style="margin-left: 3px;"><data-i18n i18n="_label_new_picture_added_">New picture added</data-i18n></span></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Importance == 1 ? \'importance-1\' : (event.Importance == 2 ? \'importance-2\' : (event.Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showOneImage(event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{::event.ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.IsTask"><i class="material-icons is-task-icon" ng-if="!event.TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.TaskCompleted">check_circle</i></div><div class="image-details">{{::event.Creator}}</div><span class="image-when">{{::event.ImageCreated | date:\'short\'}}</span><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.NumberComments && event.NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div></div><div ng-if="event.eventType == 12"><h5><span style="margin-left: 3px;"><data-i18n i18n="_label_new_comment_added_">New comment added</data-i18n></span></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Importance == 1 ? \'importance-1\' : (event.Importance == 2 ? \'importance-2\' : (event.Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showOneImage(event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{::event.ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.IsTask"><i class="material-icons is-task-icon" ng-if="!event.TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.TaskCompleted">check_circle</i></div><div class="image-details">{{::event.Creator}}</div><span class="image-when">{{::event.ImageCreated | date:\'short\'}}</span><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.NumberComments && event.NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div></div><div ng-if="event.eventType == 16"><h5><span style="margin-left: 3px;" ng-if="event.Type == 1"><data-i18n i18n="_animal_movement_purchase_">Animal purchased</data-i18n></span></h5><h5><span style="margin-left: 3px;" ng-if="event.Type == 2"><data-i18n i18n="_animal_movement_sold_">Animal sold</data-i18n></span></h5><h5><span style="margin-left: 3px;" ng-if="event.Type == 3"><data-i18n i18n="_animal_movement_died_">Animal died</data-i18n></span></h5></div><div ng-if="event.eventType == 17"><h5><span style="margin-left: 3px;"><data-i18n i18n="_animal_repro_event_dry_">Dry off</data-i18n></span></h5></div></div></div></section></div><div ng-if="vm.showLoadMoreEvents" style="text-align: center"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreEvents()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.panel.html','<div ng-if="!vm.errorLoadingAnimal && !vm.noAnimalDataAvailable && !vm.idNotValid"><div ng-if="vm.isGlobalAdmin" class="view-selector" style="position: relative; z-index: 9999999"><div style="width: 49%; display: inline-block; vertical-align: sub"><div style="display: inline-block; vertical-align: middle">Farmer</div><div style="display: inline-block; vertical-align: middle"><i class="material-icons pen-toggle-icon" ng-click="vm.changeView()">{{vm.view_icon}}</i></div><div style="display: inline-block; vertical-align: middle">Regular user</div></div></div><div><div style="position: relative" class="animal-details-header"><div class="profile-cover-img" ng-class="!vm.animal.PictureImageUrl ? \'default-image\':\'\'" ng-style="vm.setProfileStyle()" ng-if="(vm.animal.PictureImageUrl || vm.showPedigree) && vm.showAnimalHeader"></div><div ng-if="(!vm.animal.PictureImageUrl && !vm.showPedigree) || !vm.showAnimalHeader" style="height: 65px"></div><div class="profile-pedigree-holder" ng-if="vm.showPedigree && vm.showAnimalHeader"><table class="pedigree-chart-table"><tr><td colspan="4" style="text-align: center"><div class="pedigree-title"><data-i18n i18n="_label_pedigree_">Pedigree</data-i18n></div></td></tr><tr><td></td><td></td><td></td><td class="border-left border-top border-right" ng-class="vm.animal.SireId ? \'pedigree-clickable\' : \'\'" ng-click="vm.getAnimalById(vm.animal.SireId)"><div class="pedigree-item" style="min-height: 37px"><div class="pedigree-item" style="min-height: 37px"><div style="text-align: center"><data-i18n i18n="_animal_sire_">Sire</data-i18n></div><div>{{vm.animal.SireEarTag}}</div></div></div></td></tr><tr><td></td><td></td><td class="border-left border-top"></td><td class="border-left border-bottom border-right" ng-class="vm.animal.SireId ? \'pedigree-clickable\' : \'\'" ng-click="vm.getAnimalById(vm.animal.SireId)"><div class="pedigree-item" style="min-height: 37px"><div>{{vm.animal.SireName}}</div><div>{{vm.animal.SireNumber}}</div></div></td></tr><tr><td class="border-left border-top border-right"><div class="pedigree-item" style="min-height: 18px"><div style="margin-top: 18px">{{vm.animal.EarTag}}</div></div></td><td class="border-bottom"></td><td class="border-left"></td><td></td></tr><tr><td class="border-left border-bottom border-right"><div class="pedigree-item" style="min-height: 37px"><div>{{vm.animal.Name}}</div><div>{{vm.animal.Number}}</div></div></td><td></td><td class="border-left"></td><td></td></tr><tr><td></td><td></td><td class="border-left border-bottom"></td><td class="border-left border-top border-right" ng-class="vm.animal.DamId ? \'pedigree-clickable\' : \'\'" ng-click="vm.getAnimalById(vm.animal.DamId)"><div class="pedigree-item" style="min-height: 37px"><div style="text-align: center"><data-i18n i18n="_animal_dam_">Dam</data-i18n></div><div>{{vm.animal.DamEarTag}}</div></div></td></tr><tr><td></td><td></td><td></td><td class="border-left border-bottom border-right" ng-class="vm.animal.DamId ? \'pedigree-clickable\' : \'\'" ng-click="vm.getAnimalById(vm.animal.DamId)"><div class="pedigree-item" style="min-height: 37px"></div></td></tr></table></div><div class="carousel-navigation" ng-if="vm.showAnimalHeader"><div><div ng-if="vm.animal.PictureImageUrl"><i class="fa fa-repeat" style="font-size: 38px" ng-click="vm.rotateProfilePicture()"></i></div><div ng-if="vm.showCarouselNavigation"><i ng-class="vm.carouselActive ? \'ion-ios-pause\' : \'ion-ios-play\'" ng-click="vm.changeCarousel()"></i></div><div ng-if="vm.showCarouselNavigation && !vm.carouselActive"><i style="font-size: 38px" class="ion-ios-gear" ng-click="vm.openIntervalModal()"></i></div></div></div><div class="picture-create-date" ng-if="vm.animal.PictureImageUrl && vm.showAnimalHeader">{{vm.animal.PictureCreateDate | date: \'shortDate\'}}</div><a class="left carousel-control" ng-click="vm.previousAnimal()" role="button" data-slide="prev" id="previousImageLink" ng-if="vm.showNavigation"><span class="icon-prev" ng-class="((!vm.animal.PictureImageUrl && !vm.showPedigree) || !vm.showAnimalHeader)? \'small-icon\' : \'\'"></span></a> <a class="right carousel-control" ng-click="vm.nextAnimal()" role="button" data-slide="next" id="nextImageLink" ng-if="vm.showNavigation"><span class="icon-next" ng-class="((!vm.animal.PictureImageUrl && !vm.showPedigree) || !vm.showAnimalHeader) ? \'small-icon\' : \'\'"></span></a></div></div><div class="animal-tags primary-clr" ng-if="vm.animal.TagsToShow && vm.animal.TagsToShow.length>0"><span class="fa fa-tags"></span><div ng-repeat="tag in vm.animal.TagsToShow" style="margin-left: 5px; display: inline-block">{{tag.label}}</div></div><div class="animal-item-holder"><div><div class="animal-basic-item animal-status" ng-class="vm.animal.CurrentStatus == 0 ? \'animal-none\' : (vm.animal.CurrentStatus == 1 ? \'animal-open\': (vm.animal.CurrentStatus == 3 ? \'animal-served\': (vm.animal.CurrentStatus == 4 ? \'animal-non-pregnant\' : (vm.animal.CurrentStatus == 5 ? \'animal-pregnant\' : (vm.animal.CurrentStatus == 6 ? \'animal-barren\' : (vm.animal.CurrentStatus == 8 ? \'animal-dry\' : \'\'))))))"><div class="basic-big"><span>{{vm.animal.EarTag}}</span></div><div class="basic-smaller"><span>{{vm.animal.CurrentStatusString}}</span></div></div><div class="animal-basic-item"><div class="basic-big primary-clr"><span>{{vm.animal.NumberString}}</span></div><div class="basic-big primary-clr"><span>{{vm.animal.Name}}</span></div></div><div class="animal-basic-item"><div class="basic-big primary-clr"><span>{{vm.animal.Parity}}</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_parity_">parity</data-i18n></span></div></div><div class="animal-basic-item" ng-if="!vm.noLactations"><div class="basic-big primary-clr"><span>{{vm.dim_to_show || \'-\'}}</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_dim_">dim</data-i18n></span></div></div><div class="animal-basic-item" ng-if="vm.noLactations"><div class="basic-big primary-clr"><span>{{vm.doa || \'-\'}}</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_doa_">DOA</data-i18n></span></div></div><div class="animal-basic-item" ng-if="vm.animal.CurrentStatus"><div class="basic-big primary-clr"><span>{{vm.animal.status_days || \'-\'}}</span></div><div class="basic-smaller"><span ng-if="!vm.showStatusDaysString"><data-i18n i18n="_animal_status_days_">status days</data-i18n></span> <span ng-if="vm.showStatusDaysString">{{vm.animal.statusDaysString}}</span></div></div><div class="animal-basic-item"><div class="basic-big primary-clr" ng-if="!vm.noLactations"><span>{{vm.last_calving_date || \'-\' | date: \'shortDate\' }}</span></div><div class="basic-big primary-clr" ng-if="vm.noLactations"><span>-</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_last_calving_date_">Last calving date</data-i18n></span></div></div><div class="animal-basic-item"><div class="basic-big primary-clr"><span>{{vm.last_insemination_date || \'-\' | date: \'shortDate\'}}</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_last_insemination_date_">Last insemination date</data-i18n></span></div></div><div class="animal-basic-item"><div class="basic-big primary-clr"><span>{{vm.animal.BirthDate || \'-\' | date: \'shortDate\'}}</span></div><div class="basic-smaller"><span><data-i18n i18n="_animal_date_of_birth_">Date of birth</data-i18n></span></div></div><div class="animal-basic-item icon-holder"><div class="add-comment-icon"><i class="material-icons" ng-click="vm.openNewDiscussionModal()">message</i></div></div><div class="animal-basic-item icon-holder" ng-if="!vm.style || vm.style==\'zoetis\'"><div class="search-animal-icon"><i class="material-icons" ng-click="vm.openSearchModal()" style="margin-top: 5px">search</i></div></div><div class="animal-basic-item icon-button-holder" ng-if="vm.style == \'aveve\'"><div class="icon-button"><img style="width: 34px;" src="assets/img/search.svg" ng-click="vm.openSearchModal()"></div></div><div class="animal-basic-item icon-button-holder" ng-if="vm.style == \'proxani\'"><div class="icon-button"><img style="width: 34px;" src="assets/img/search_proxani.png" ng-click="vm.openSearchModal()"></div></div><div class="animal-basic-item" style="padding: 7px"><div class="search-box"><div class="search-input"><input type="text" class="form-control" placeholder="{{\'_placeholder_enter_animal_number_\' | i18n}}" ng-model="vm.animalSearchNumber" ng-class="vm.animalSearchNumberError ? \'border-color-red\' : \'\'" ng-disabled="vm.disableAnimalSearchInput" ng-keypress="vm.animalSearchKeyPress($event)"></div><div class="go-icon" ng-click="vm.goToAnimalByNumber()"><i class="ion-chevron-right"></i></div></div></div></div></div><div class="animal-tabs"><button class="animal-tabs-button" ng-class="vm.activeButton == 9 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(9)" ng-if="vm.is_farmer"><data-i18n i18n="_page_title_robot_view_">RobotView</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 10 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(10)" ng-if="vm.is_farmer"><data-i18n i18n="_animal_details_tab_lactation_graph_">Lactation Graph</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 0 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(0)"><data-i18n i18n="_animal_details_tab_overview_">Overview</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 1 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(1)"><data-i18n i18n="_animal_details_tab_reproduction_">Reproduction</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 2 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(2)"><data-i18n i18n="_animal_details_tab_transition_">Transition</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 3 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(3)"><data-i18n i18n="_animal_details_tab_milk_production_">Milk production</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 4 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(4)"><data-i18n i18n="_animal_details_tab_udder_health_">Udder health</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 5 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(5)"><data-i18n i18n="_animal_details_tab_health_events_">Health events</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 6 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(6)"><data-i18n i18n="_animal_details_tab_hoof_trims_">Hoof trims</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 8 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(8)"><data-i18n i18n="_animal_details_tab_feed_intake_">Feed intake</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeButton == 7 ? \'active-button\' : \'\'" ng-click="vm.setActiveButton(7)"><data-i18n i18n="_animal_details_tab_pictures_">Pictures</data-i18n></button></div><div ng-if="vm.activeButton == 0"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.overview.html"></div></div><div ng-if="vm.activeButton == 1"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.reproduction.html"></div></div><div ng-if="vm.activeButton == 2"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.transition.html"></div></div><div ng-if="vm.activeButton == 3"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.milkProduction.html"></div></div><div ng-if="vm.activeButton == 4"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.udderHealth.html"></div></div><div ng-if="vm.activeButton == 5"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.healthEvents.html"></div></div><div ng-if="vm.activeButton == 6"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.clawHealth.html"></div></div><div ng-if="vm.activeButton == 7"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.pictures.html"></div></div><div ng-if="vm.activeButton == 8"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.feedIntake.html"></div></div><div ng-if="vm.activeButton == 9"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.fame.html"></div></div><div ng-if="vm.activeButton == 10"><div include-with-scope="app/pages/herds/animals/animalDetails/animalDetails.rapGraph.html"></div></div></div><div ng-if="vm.noAnimalDataAvailable"><span class="color-red"><data-i18n i18n="_message_error_no_data_found_">No data found for selected animal.</data-i18n></span></div><div ng-if="vm.idNotValid"><span class="color-red"><data-i18n i18n="_message_error_id_not_valid_">Animal identifier not valid.</data-i18n></span></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.pictures.html','<div ng-repeat="(key, value) in vm.imagesToShow | groupBy:\'ImageCreatedDate\'"><div class="images-group-header"><span style="margin-right: 3px;"><data-i18n i18n="_label_picture_taken_">Picture taken</data-i18n>:</span>{{key}}</div><div class="animal-reproduction" ng-repeat="image in value"><div class="image-block"><div class="image-canvas" ng-class="image.Importance == 1 ? \'importance-1\' : (image.Importance == 2 ? \'importance-2\' : (image.Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.selectFromAll(image.Id)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{image.ThumbnailUrl}}" class="reproduction-thumbnail" ng-if="!image.hideImage"></div><div class="image-task-details" ng-if="image.IsTask"><i class="material-icons is-task-icon" ng-if="!image.TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="image.TaskCompleted">check_circle</i></div><div class="image-details">{{image.Creator}}</div><div class="image-details">{{image.ImageCreated | date:\'shortDate\'}}</div><div class="image-details" ng-if="image.NumberComments"><span style="font-size:18px" class="ion-chatboxes"><div class="com-number">{{image.NumberComments}}</div></span></div></div></div></div><div ng-if="vm.showMore" style="text-align: center"><button class="btn btn-primary btn-sm" ng-click="vm.loadMoreImages()"><data-i18n i18n="_label_load_more_">load more</data-i18n></button></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.rapGraph.html','<div ba-panel="" ng-if="vm.showOverview"><div class="row"><div class="col-sm-12 col-md-6 lactation-selector"><div class="event-herd-selector" ng-show="vm.availableLactations"><ui-select ng-model="vm.currentLactation" theme="selectize" class="select-tags" style="height:20px" ng-change="vm.lactationChanged()"><ui-select-match allow-clear="true" placeholder="{{\'_animal_lactation_\' | i18n}}"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span> {{$select.selected.Parity}}</div></ui-select-match><ui-select-choices repeat="lactation in vm.availableLactations"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span><span>{{lactation.Parity}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-12 col-md-6 fullscreen-icon" ng-if="!vm.noMilkGraphData"><i class="material-icons animal-details-clickable-icon" ng-click="vm.openGraphModal()">fullscreen</i></div></div><div class="slider-box" ng-if="vm.showOverview && vm.showSlider && !vm.noMilkGraphData"><input ion-range-slider="" min="1" max="vm.max_graph_value" from="vm.fromSlider" to="vm.toSlider" type="double" on-change="vm.sliderChanged()"></div><div ng-if="vm.showOverview && !vm.noMilkGraphData" style="text-align: right; padding: 10px 5px">({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div><div style="height: 230px" ng-if="!vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChart" width="100%" height="300"></canvas></div><div style="height: 250px" ng-if="!vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChart2" width="100%" height="300"></canvas></div><div class="graph-legend" ng-if="!vm.noMilkGraphData"><div ng-repeat="legend in vm.legendItems" class="graph-legend-item" ng-class="legend.lineDash ? \'dashed-line\' : \'\'"><div ng-style="vm.getBackgroundColor(legend)"></div>{{legend.text}}</div></div><div style="float: right; font-size: 10px;"><a href="https://dryicons.com/free-icons/thermometer">Icon by Dryicons</a></div><div style="height: 550px" ng-if="vm.noMilkGraphData" class="no-graph-data"><i class="ion-minus-circled" style="position: absolute; top: 150px; left: 0; right: 0; margin: auto"></i></div></div><div ng-if="!vm.showOverview"><div style="height: 600px;text-align: center"><div class="loading-animation"></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.reproduction.html','<div ba-panel=""><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="(event.eventType == 2 || event.eventType == 3 || event.eventType == 5 || event.eventType == 1 || event.eventType == 17) && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning" style="margin-top:5px"><img ng-src="{{::( \'Party-Poppers\' | kameleonImg )}}" ng-if="event.eventType == 1"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Dna\' | kameleonImg )}}" ng-if="event.eventType != 1 && event.eventType != 17"></div><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Bell\' | kameleonImg )}}" ng-if="event.eventType == 17"></div></div><div class="cd-timeline-content-animal" ng-class="event.eventType == 5 ? \'lactation-started\': \'\'"><div ng-if="event.eventType == 2"><div include-with-scope="app/pages/herds/animals/animalDetails/reproBlock.html"></div></div><div ng-if="event.eventType == 3"><div include-with-scope="app/pages/herds/animals/animalDetails/calvingBlock.html"></div></div><div ng-if="event.eventType == 5"><div include-with-scope="app/pages/herds/animals/animalDetails/lactationBlock.html"></div></div><div ng-if="event.eventType == 1"><h5><data-i18n i18n="_animal_birth_">animal birth</data-i18n></h5></div><div ng-if="event.eventType == 17"><h5><span style="margin-left: 3px;"><data-i18n i18n="_animal_repro_event_dry_">Dry off</data-i18n></span></h5></div></div></div></section></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.transition.html','<div ba-panel=""><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 4 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Microscope\' | kameleonImg )}}" ng-if="event.eventType == 4 || event.eventType==6 || event.eventType==7"></div></div><div class="cd-timeline-content-animal"><div ng-if="event.eventType == 4"><div include-with-scope="app/pages/herds/animals/animalDetails/examinationBlock.html"></div></div></div></div></section></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalDetails.udderHealth.html','<div ba-panel=""><div class="animal-tabs"><button class="animal-tabs-button" ng-class="vm.activeUHButton == 0 ? \'active-button\' : \'\'" ng-click="vm.setActiveUHButton(0)"><data-i18n i18n="_animal_clinical_mastitis_">Clinical mastitis</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeUHButton == 1 ? \'active-button\' : \'\'" ng-click="vm.setActiveUHButton(1)"><data-i18n i18n="_animal_subclinical_mastitis_">Subclinical mastitis</data-i18n></button> <button class="animal-tabs-button" ng-class="vm.activeUHButton == 2 ? \'active-button\' : \'\'" ng-click="vm.setActiveUHButton(2)"><data-i18n i18n="_animal_miscellaneous_">Misc</data-i18n></button></div><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview && vm.activeUHButton == 0"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="(event.eventType == 7 || event.eventType == 18) && event.UdderHealthType == 0 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Microscope\' | kameleonImg )}}"></div></div><div class="cd-timeline-content-animal"><div><div><h5><data-i18n i18n="_animal_udder_health_clinical_mastitis_">Udder Health - Clinical</data-i18n></h5><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthBlock.html" ng-if="event.eventType == 7"></div><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthStreamerBlock.html" ng-if="event.eventType == 18"></div></div></div><div ng-if="event.UdderHealthType == 0 && event.clinicalImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.clinicalImages[0].Importance == 1 ? \'importance-1\' : (event.clinicalImages[0].Importance == 2 ? \'importance-2\' : (event.clinicalImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'clinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.clinicalImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.clinicalImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.clinicalImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.clinicalImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.clinicalImages[0].Creator}}</div><div class="image-details">{{event.clinicalImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.clinicalImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.clinicalImages[0].NumberComments && event.clinicalImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.clinicalImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.clinicalImages[1].Importance == 1 ? \'importance-1\' : (event.clinicalImages[1].Importance == 2 ? \'importance-2\' : (event.clinicalImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'clinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.clinicalImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.clinicalImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.clinicalImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.clinicalImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.clinicalImages[1].Creator}}</div><div class="image-details">{{event.clinicalImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.clinicalImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.clinicalImages[1].NumberComments && event.clinicalImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.clinicalImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'clinicalImages\', event)">+{{event.clinicalImages.length - 2}}</span></div></div></div></div></div></section><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview && vm.activeUHButton == 1"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="(event.eventType == 7 || event.eventType == 18) && event.UdderHealthType == 1 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Microscope\' | kameleonImg )}}"></div></div><div class="cd-timeline-content-animal"><div><div><h5><data-i18n i18n="_animal_udder_health_subclinical_mastitis_">Udder Health - subclinical</data-i18n></h5><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthBlock.html" ng-if="event.eventType == 7"></div><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthStreamerBlock.html" ng-if="event.eventType == 18"></div></div></div><div ng-if="event.UdderHealthType == 1 && event.subclinicalImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.subclinicalImages[0].Importance == 1 ? \'importance-1\' : (event.subclinicalImages[0].Importance == 2 ? \'importance-2\' : (event.subclinicalImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'subclinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.subclinicalImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.subclinicalImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.subclinicalImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.subclinicalImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.subclinicalImages[0].Creator}}</div><div class="image-details">{{event.subclinicalImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.subclinicalImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.subclinicalImages[0].NumberComments && event.subclinicalImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.subclinicalImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.subclinicalImages[1].Importance == 1 ? \'importance-1\' : (event.subclinicalImages[1].Importance == 2 ? \'importance-2\' : (event.subclinicalImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'subclinicalImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.subclinicalImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.subclinicalImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.subclinicalImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.subclinicalImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.subclinicalImages[1].Creator}}</div><div class="image-details">{{event.subclinicalImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.subclinicalImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.subclinicalImages[1].NumberComments && event.subclinicalImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.subclinicalImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'subclinicalImages\', event)">+{{event.subclinicalImages.length - 2}}</span></div></div></div></div></div></section><section id="cd-timeline" class="cd-container cssanimations" ng-if="vm.showOverview && vm.activeUHButton == 2"><div class="cd-timeline-block" ng-repeat="event in vm.events | orderBy:\'-eventDate\'" ng-if="event.eventType == 7 && event.UdderHealthType == 2 && !event.hideEvent"><div class="cd-timeline-date">{{event.eventDate | date:\'shortDate\'}}</div><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Microscope\' | kameleonImg )}}" ng-if="event.eventType == 4 || event.eventType==6 || event.eventType==7"></div></div><div class="cd-timeline-content-animal"><div ng-if="event.eventType == 7"><div><h5><data-i18n i18n="_animal_udder_health_misc_" ng-if="event.UdderHealthType == 2">Udder Health - Misc</data-i18n></h5><div include-with-scope="app/pages/herds/animals/animalDetails/udderHealthBlock.html"></div></div></div><div ng-if="event.UdderHealthType == 2 && event.miscImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.miscImages[0].Importance == 1 ? \'importance-1\' : (event.miscImages[0].Importance == 2 ? \'importance-2\' : (event.miscImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'miscImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.miscImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.miscImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.miscImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.miscImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.miscImages[0].Creator}}</div><div class="image-details">{{event.miscImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.miscImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.miscImages[0].NumberComments && event.miscImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.miscImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.miscImages[1].Importance == 1 ? \'importance-1\' : (event.miscImages[1].Importance == 2 ? \'importance-2\' : (event.miscImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'miscImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.miscImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.miscImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.miscImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.miscImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.miscImages[1].Creator}}</div><div class="image-details">{{event.miscImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.miscImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.miscImages[1].NumberComments && event.miscImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.miscImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'miscImages\', event)">+{{event.miscImages.length - 2}}</span></div></div></div></div></div></section></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/animalHealthBlock.html','<div ng-if="event.Diseases.length > 0 || event.DiseasesPictures.length>0"><h5><data-i18n i18n="_animal_disease_">Disease</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><table class="milk-summary" align="left"><tbody><tr ng-repeat="disease in event.Diseases" style="text-align: left"><td>{{disease.label_translate | i18n}}</td></tr></tbody></table></div><div ng-if="event.DiseasesPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.DiseasesPictures[0].Importance == 1 ? \'importance-1\' : (event.DiseasesPictures[0].Importance == 2 ? \'importance-2\' : (event.DiseasesPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'DiseasesPictures\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.DiseasesPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.DiseasesPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.DiseasesPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.DiseasesPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.DiseasesPictures[0].Creator}}</div><div class="image-details">{{event.DiseasesPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.DiseasesPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.DiseasesPictures[0].NumberComments && event.DiseasesPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.DiseasesPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.DiseasesPictures[1].Importance == 1 ? \'importance-1\' : (event.DiseasesPictures[1].Importance == 2 ? \'importance-2\' : (event.DiseasesPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'DiseasesPictures\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.DiseasesPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.DiseasesPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.DiseasesPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.DiseasesPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.DiseasesPictures[1].Creator}}</div><div class="image-details">{{event.DiseasesPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.DiseasesPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.DiseasesPictures[1].NumberComments && event.DiseasesPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.DiseasesPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'DiseasesPictures\', event)">+{{event.DiseasesPictures.length - 2}}</span></div></div></div></div><div ng-if="event.Preventions.length > 0 || event.PreventionsPictures.length>0"><h5><data-i18n i18n="_animal_prevention_">Prevention</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><table class="milk-summary" align="left"><tbody><tr ng-repeat="prevention in event.Preventions" style="text-align: left"><td>{{prevention.label_translate | i18n}}</td></tr></tbody></table></div><div ng-if="event.PreventionsPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.PreventionsPictures[0].Importance == 1 ? \'importance-1\' : (event.PreventionsPictures[0].Importance == 2 ? \'importance-2\' : (event.PreventionsPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'PreventionsPictures\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.PreventionsPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.PreventionsPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.PreventionsPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.PreventionsPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.PreventionsPictures[0].Creator}}</div><div class="image-details">{{event.PreventionsPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.PreventionsPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.PreventionsPictures[0].NumberComments && event.PreventionsPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.PreventionsPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.PreventionsPictures[1].Importance == 1 ? \'importance-1\' : (event.PreventionsPictures[1].Importance == 2 ? \'importance-2\' : (event.PreventionsPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'PreventionsPictures\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.PreventionsPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.PreventionsPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.PreventionsPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.PreventionsPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.PreventionsPictures[1].Creator}}</div><div class="image-details">{{event.PreventionsPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.PreventionsPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.PreventionsPictures[1].NumberComments && event.PreventionsPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.PreventionsPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'PreventionsPictures\', event)">+{{event.PreventionsPictures.length - 2}}</span></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/calvingBlock.html','<div><h5><data-i18n i18n="_animal_calving_">Calving</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div ng-if="event.BCS"><data-i18n i18n="_animal_bcs_">BCS</data-i18n>:&#32<span style="float:right">{{event.BCS | number:1}}</span></div><div ng-if="event.CalvingEaseString"><data-i18n i18n="_animal_calving_ease_">Calving ease</data-i18n>:&#32<span ng-class="event.CalvingEase==1 ? \'animal-colorAccent-col\' : (event.CalvingEase==2 ? \'animal-dryCode-col\': \'animal-warning-col\')">{{event.CalvingEaseString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.Calf1GenderString"><data-i18n i18n="_animal_calf_gender_">Calf gender</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf1GenderString}}</span></div><div ng-if="event.Calf1PresentationString"><data-i18n i18n="_animal_calf_presentation_">Calf presentation</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf1PresentationString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.Calf1Dead!=undefined"><data-i18n i18n="_animal_calf_alive_">Calf alive</data-i18n>: <span ng-if="event.Calf1Dead" class="positive" style="float:right; padding-left:5px"><data-i18n i18n="_label_yes_">Yes</data-i18n></span><span ng-if="!event.Calf1Dead" class="negative" style="float:right; padding-left:5px"><data-i18n i18n="_label_no_">No</data-i18n></span></div><div ng-if="event.Calf1VitalityString"><data-i18n i18n="_animal_calf_vitality_">Calf vitality</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.Calf1Vitality == 1 ? \'animal-warning-col\' : (event.Calf1Vitality == 2 ? \'animal-dryCode-col\' : (event.Calf1Vitality == 3 ? \'animal-colorAccent-col\' : \'\'))">{{event.Calf1VitalityString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.Calf2GenderString"><data-i18n i18n="_animal_calf_gender_2_">Calf 2 gender</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf2GenderString}}</span></div><div ng-if="event.Calf2PresentationString"><data-i18n i18n="_animal_calf_presentation_2_">Calf 2 presentation</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf2PresentationString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.Calf2Dead!=undefined"><data-i18n i18n="_animal_calf_alive_2_">Calf 2 alive</data-i18n>: <span ng-if="event.Calf2Dead" class="positive" style="float:right; padding-left:5px"><data-i18n i18n="_label_yes_">Yes</data-i18n></span><span ng-if="!event.Calf2Dead" class="negative" style="float:right; padding-left:5px"><data-i18n i18n="_label_no_">No</data-i18n></span></div><div ng-if="event.Calf2VitalityString"><data-i18n i18n="_animal_calf_vitality_">Calf 2 vitality</data-i18n>&#32<span>2</span>:&#32<span style="float:right; padding-left:5px" ng-class="event.Calf2Vitality == 1 ? \'animal-warning-col\' : (event.Calf2Vitality == 2 ? \'animal-dryCode-col\' : (event.Calf2Vitality == 3 ? \'animal-colorAccent-col\' : \'\'))">{{event.Calf2VitalityString}}</span></div></div><div ng-if="event.CalvingImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.CalvingImages[0].Importance == 1 ? \'importance-1\' : (event.CalvingImages[0].Importance == 2 ? \'importance-2\' : (event.CalvingImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'CalvingImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.CalvingImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.CalvingImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.CalvingImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.CalvingImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.CalvingImages[0].Creator}}</div><div class="image-details">{{event.CalvingImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.CalvingImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.CalvingImages[0].NumberComments && event.CalvingImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.CalvingImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.CalvingImages[1].Importance == 1 ? \'importance-1\' : (event.CalvingImages[1].Importance == 2 ? \'importance-2\' : (event.CalvingImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'CalvingImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.CalvingImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.CalvingImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.CalvingImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.CalvingImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.CalvingImages[1].Creator}}</div><div class="image-details">{{event.CalvingImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.CalvingImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.CalvingImages[1].NumberComments && event.CalvingImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.CalvingImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'CalvingImages\', event)">+{{event.CalvingImages.length - 2}}</span></div></div></div></div><div ng-if="event.ColostrumDate"><h5><data-i18n i18n="_animal_colostrum_">Colostrum</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div ng-if="event.ColostrumAmountKg"><data-i18n i18n="_label_quantity_">Quantity</data-i18n>:&#32<span>{{event.ColostrumAmountKgString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.ColostrumQualityString"><data-i18n i18n="_label_quality_">Quality</data-i18n>:&#32<span ng-class="event.ColostrumQuality == 1 ? \'animal-warning-col\' : (event.ColostrumQuality == 2 ? \'animal-dryCode-col\' : (event.ColostrumQuality == 3 ? \'animal-colorAccent-col\' : \'\'))">{{event.ColostrumQualityString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.ColostrumQualityMeasurementTypeString"><data-i18n i18n="_animal_measurement_type_">Measurement Type</data-i18n>:&#32<span>{{event.ColostrumQualityMeasurementTypeString}}</span></div></div><div ng-if="event.ColostrumImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.ColostrumImages[0].Importance == 1 ? \'importance-1\' : (event.ColostrumImages[0].Importance == 2 ? \'importance-2\' : (event.ColostrumImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'ColostrumImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.ColostrumImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.ColostrumImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.ColostrumImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.ColostrumImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.ColostrumImages[0].Creator}}</div><div class="image-details">{{event.ColostrumImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.ColostrumImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.ColostrumImages[0].NumberComments && event.ColostrumImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.ColostrumImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.ColostrumImages[1].Importance == 1 ? \'importance-1\' : (event.ColostrumImages[1].Importance == 2 ? \'importance-2\' : (event.ColostrumImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'ColostrumImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.ColostrumImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.ColostrumImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.ColostrumImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.ColostrumImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.ColostrumImages[1].Creator}}</div><div class="image-details">{{event.ColostrumImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.ColostrumImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.ColostrumImages[1].NumberComments && event.ColostrumImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.ColostrumImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'ColostrumImages\', event)">+{{event.ColostrumImages.length - 2}}</span></div></div></div></div><div ng-if="event.ColostrumFirstIntake"><h5><data-i18n i18n="_animal_milk_">Milk</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div ng-if="event.Calf1Name"><data-i18n i18n="_animal_calf_name_">Calf name</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf1Name}}</span></div><div ng-if="event.ColostrumIntakeKgCalf1String"><data-i18n i18n="_animal_intake_amount_">Intake amount</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.ColostrumIntakeKgCalf1String}}</span></div></div><div class="animal-reproduction"><div ng-if="event.Calf2Name"><data-i18n i18n="_animal_calf_name_2_">Calf 2 name</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Calf2Name}}</span></div><div ng-if="event.ColostrumIntakeKgCalf2String"><data-i18n i18n="_animal_intake_amount_">Intake amount</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.ColostrumIntakeKgCalf2String}}</span></div></div><div ng-if="event.MilkIntakeImages.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.MilkIntakeImages[0].Importance == 1 ? \'importance-1\' : (event.MilkIntakeImages[0].Importance == 2 ? \'importance-2\' : (event.MilkIntakeImages[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(0 , \'MilkIntakeImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.MilkIntakeImages[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.MilkIntakeImages[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.MilkIntakeImages[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.MilkIntakeImages[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.MilkIntakeImages[0].Creator}}</div><div class="image-details">{{event.MilkIntakeImages[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.MilkIntakeImages[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.MilkIntakeImages[0].NumberComments && event.MilkIntakeImages[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.MilkIntakeImages[1]"><div class="image-block"><div class="image-canvas" ng-class="event.MilkIntakeImages[1].Importance == 1 ? \'importance-1\' : (event.MilkIntakeImages[1].Importance == 2 ? \'importance-2\' : (event.MilkIntakeImages[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImageByType(1 , \'MilkIntakeImages\', event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.MilkIntakeImages[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.MilkIntakeImages[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.MilkIntakeImages[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.MilkIntakeImages[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.MilkIntakeImages[1].Creator}}</div><div class="image-details">{{event.MilkIntakeImages[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.MilkIntakeImages[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.MilkIntakeImages[1].NumberComments && event.MilkIntakeImages[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.MilkIntakeImages[2]"><div class="more-images-label-holder"><span ng-click="vm.showImageByType(2 , \'MilkIntakeImages\', event)">+{{event.MilkIntakeImages.length - 2}}</span></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/examinationBlock.html','<div><h5><data-i18n i18n="_animal_examination_">Examination</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div ng-if="event.BCS"><data-i18n i18n="_animal_bcs_">BCS</data-i18n>:&#32<span style="float:right">{{event.BCS | number:1}}</span></div><div ng-if="event.Temperature"><data-i18n i18n="_animal_details_temperature_">Temperature</data-i18n>:&#32<span>{{event.Temperature}}&#176C</span></div></div><div class="animal-reproduction"><div ng-if="event.ParturitionInjury"><data-i18n i18n="_animal_details_parturition_injury_">Parturition Injury</data-i18n>:&#32<span ng-if="event.ParturitionInjury == 0" style="float:right; padding-left:5px" class="positive"><data-i18n i18n="_label_no_">No</data-i18n></span> <span ng-if="event.ParturitionInjury == 2" style="float:right; padding-left:5px" class="negative"><data-i18n i18n="_label_yes_">Yes</data-i18n></span></div><div ng-if="event.PlacentaOff"><data-i18n i18n="_animal_details_disease_retained_placenta_">Retained Placenta</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.PlacentaOff == 5 ? \'animal-colorAccent-col\' : (event.PlacentaOff == 9 ? \'animal-colorAccent-col\' : (event.PlacentaOff == 18 ? \'animal-dryCode-col\' : (event.PlacentaOff == 60 ? \'animal-warning-col\' : (event.PlacentaOff == 84 ? \'animal-warning-col\' : \'\'))))">{{event.PlacentaOffString}}</span></div></div><div class="animal-reproduction"><div ng-if="event.RumenFill"><data-i18n i18n="_animal_details_rummen_fill_">Rummen fill</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.RumenFill | number:1}}</span></div><div ng-if="event.UterineDischarge"><data-i18n i18n="_animal_details_uterine_discharge_">Uterine discharge</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.UterineDischarge| number:1}}</span></div></div><div class="animal-reproduction"><div ng-if="event.ManureScore"><data-i18n i18n="_animal_details_manure_">Manure</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.ManureScore| number:1}}</span></div></div><div ng-if="event.Pictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[0].Importance == 1 ? \'importance-1\' : (event.Pictures[0].Importance == 2 ? \'importance-2\' : (event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[0].Creator}}</div><div class="image-details">{{event.Pictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[0].NumberComments && event.Pictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[1].Importance == 1 ? \'importance-1\' : (event.Pictures[1].Importance == 2 ? \'importance-2\' : (event.Pictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[1].Creator}}</div><div class="image-details">{{event.Pictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[1].NumberComments && event.Pictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.Pictures, event)">+{{event.Pictures.length - 2}}</span></div></div></div></div><div><h5><data-i18n i18n="_animal_tests_">Tests</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div ng-if="event.UrinaryPH"><data-i18n i18n="_animal_urinary_ph_">Urinary pH</data-i18n>:&#32<span>{{event.UrinaryPH}}</span></div><div ng-if="event.UrineBhb"><data-i18n i18n="_animal_urine_bhb_ketosis_">Urine BHB ketosis</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.UrineBhbColor == 1 ? \'urine-bhb1\' : (event.UrineBhbColor == 2 ? \'urine-bhb2\' : (event.UrineBhbColor == 3 ? \'urine-bhb3\' : (event.UrineBhbColor == 4 ? \'urine-bhb4\' : (event.UrineBhbColor == 5 ? \'urine-bhb5\' : (event.UrineBhbColor == 6 ? \'urine-bhb6\' : \'\')))))">{{event.UrineBhb | number:1}}</span></div></div><div class="animal-reproduction"><div ng-if="event.BloodBhb"><data-i18n i18n="_animal_blood_bhb_ketosis_">Blood BHB ketosis</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.BloodBhbColor == 1 ? \'animal-colorAccent-col\' : (event.BloodBhbColor == 2 ? \'animal-dryCode-col\' : \'animal-warning-col\')">{{event.BloodBhb | number:2}}</span></div><div ng-if="event.BloodCalcium"><data-i18n i18n="_animal_blood_calcium_">Blood Calcium</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.BloodCalciumColor == 1 ? \'animal-colorAccent-col\' : (event.BloodCalciumColor == 2 ? \'animal-dryCode-col\' : (event.BloodCalciumColor == 3 ? \'animal-warning-col\' : \'\'))">{{event.BloodCalcium | number:2}}</span></div></div><div class="animal-reproduction"><div ng-if="event.MilkBhb"><data-i18n i18n="_animal_milk_bhb_ketosis_">Milk BHB ketosis</data-i18n>:&#32<span style="float:right; padding-left:5px" ng-class="event.MilkBhbColor == 1 ? \'milk-bhb1\' : (event.MilkBhbColor == 2 ? \'milk-bhb2\' : (event.MilkBhbColor == 3 ? \'milk-bhb3\' : (event.MilkBhbColor == 4 ? \'milk-bhb4\' : (event.MilkBhbColor == 5 ? \'milk-bhb5\' : (event.MilkBhbColor == 6 ? \'milk-bhb6\' : \'\')))))">{{event.MilkBhb}}</span></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/graph.modal.html','<div class="modal-custom-lg"><div class="modal-header"><div class="row"><div class="col-sm-12 col-md-6 lactation-selector"><div class="event-herd-selector" ng-show="vm.availableLactations"><ui-select ng-model="vm.currentLactation" theme="selectize" class="select-tags" style="height:20px" ng-change="vm.lactationChanged()"><ui-select-match allow-clear="true" placeholder="{{\'_animal_lactation_\' | i18n}}"><div style="height: 10px; width: 10px; display: inline-block; margin-right: 5px;" ng-style="{\'backgroundColor\': $select.selected.color}"></div><div style="display: inline-block"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span> {{$select.selected.Parity}}</div></ui-select-match><ui-select-choices repeat="lactation in vm.availableLactations"><span style="margin-right: 3px;"><data-i18n i18n="_animal_lactation_">Lactation</data-i18n></span><span>{{lactation.Parity}}</span></ui-select-choices></ui-select></div></div><div class="col-sm-12 col-md-6 fullscreen-icon"><i class="ion-ios-close-outline close-modal" ng-click="vm.closeModal()"></i></div></div></div><div class="slider-box" ng-if="vm.showOverview && vm.showSlider" style="padding-left: 10px; padding-right: 10px"><input ion-range-slider="" min="0" max="vm.max_graph_value" from="vm.fromSlider" to="vm.toSlider" type="double" on-change="vm.sliderChanged()"></div><div ng-if="vm.showOverview && !vm.noMilkGraphData" style="text-align: right; padding: 10px 5px">({{vm.start_date | date:\'shortDate\'}} - {{vm.end_date | date:\'shortDate\'}})</div><div class="modal-milk-graph" style="padding: 10px;"><div class="mix-graph" ng-if="vm.showOverview && !vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChartModal" width="100%" height="100%"></canvas></div><div class="n-milking-graph" ng-if="vm.showOverview && !vm.noMilkGraphData"><canvas ng-if="!vm.hideChart && vm.showOverview" id="myChartModal2" width="100%" height="100%"></canvas></div><div class="graph-legend" ng-if="vm.showOverview && !vm.noMilkGraphData"><div ng-repeat="legend in vm.legendItems" class="graph-legend-item"><div ng-style="vm.getBackgroundColor(legend)"></div>{{legend.text}}</div></div><div style="height: 550px" ng-if="vm.noMilkGraphData" class="no-graph-data"><i class="ion-minus-circled" style="position: absolute; top: 150px; left: 0; right: 0; margin: auto"></i></div><div ng-if="!vm.showOverview" style="text-align: center"><div class="loading-animation"></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/interval.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-content"><div style="padding: 10px"><data-i18n i18n="_message_set_carousel_time_interval_">Set carousel time interval</data-i18n></div><input type="number" class="form-control" min="3" step="1" ng-model="vm.carouselTimeSec"></div><div class="modal-footer"><div style="margin-top: 15px;"><button class="btn btn-success" ng-click="vm.setCarouselInterval()"><data-i18n i18n="_label_ok_">Ok</data-i18n></button> <button class="btn btn-danger" ng-click="vm.closeModal()"><data-i18n i18n="_label_cancel_">Cancel</data-i18n></button></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/lactationBlock.html','<div><h5><span><data-i18n i18n="_animal_calving_">Calving</data-i18n></span>&#32-&#32<span><data-i18n i18n="_animal_details_lactation_">Lactation</data-i18n>&#32</span> {{event.Parity}}&#32 <span style="margin-right: 3px; text-transform: lowercase;"><data-i18n i18n="_animal_details_started_">started</data-i18n>&#32</span></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction" ng-if="event.KgMilkLactation && event.KgFatLactation && event.KgProteinLactation"><table class="milk-summary"><thead><tr><th colspan="3"><data-i18n i18n="_label_total_summary_">Total summary</data-i18n></th></tr><tr><th><data-i18n i18n="_animal_milk_">Milk</data-i18n></th><th><data-i18n i18n="_animal_fat_">Fat</data-i18n></th><th><data-i18n i18n="_animal_protein_">Protein</data-i18n></th></tr></thead><tbody><tr><td>{{event.KgMilkLactation |number:0}}</td><td>{{event.KgFatPercent | number: 2}}</td><td>{{event.KgProteinPercent | number: 2}}</td></tr><tr><td></td><td>{{event.KgFatLactation | number: 0}}</td><td>{{event.KgProteinLactation | number: 0}}</td></tr><tr><td></td><td colspan="2" class="with-border">{{event.KgSum | number: 0}}</td></tr></tbody></table></div><div class="animal-reproduction" ng-if="event.KgMilk305 && event.KgFat305 && event.KgProtein305"><table class="milk-summary"><thead><tr><th colspan="3"><data-i18n i18n="_label_305_summary_">305 summary</data-i18n></th></tr><tr><th><data-i18n i18n="_animal_milk_">Milk</data-i18n></th><th><data-i18n i18n="_animal_fat_">Fat</data-i18n></th><th><data-i18n i18n="_animal_protein_">Protein</data-i18n></th></tr></thead><tbody><tr><td>{{event.KgMilk305 |number:0}}</td><td>{{event.KgFat305Percent | number: 2}}</td><td>{{event.KgProtein305Percent | number: 2}}</td></tr><tr><td></td><td>{{event.KgFat305 | number: 0}}</td><td>{{event.KgProtein305 | number: 0}}</td></tr><tr><td></td><td colspan="2" class="with-border">{{event.Kg305Sum | number: 0}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/mmmTrimBlock.html','<div><h5><data-i18n i18n="_label_mmmooogle_trim_">MmmooOgle trim</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div><data-i18n i18n="_label_lame_cow_">Lame cow</data-i18n>: <span ng-if="!event.Lame"><data-i18n i18n="_label_no_">No</data-i18n></span> <span ng-if="event.Lame"><data-i18n i18n="_label_yes_">Yes</data-i18n></span></div><div ng-if="event.LocomotionScore"><data-i18n i18n="_label_locomotion_score_">Locomotion score</data-i18n>: <span style="margin-right: 3px;">{{event.LocomotionScore}}</span></div><div align="center" ng-if="event.Pictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[0].Importance == 1 ? \'importance-1\' : (event.Pictures[0].Importance == 2 ? \'importance-2\' : (event.Pictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[0].Creator}}</div><div class="image-details">{{event.Pictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[0].NumberComments && event.Pictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.Pictures[1].Importance == 1 ? \'importance-1\' : (event.Pictures[1].Importance == 2 ? \'importance-2\' : (event.Pictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.Pictures, event)"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.Pictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.Pictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.Pictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.Pictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.Pictures[1].Creator}}</div><div class="image-details">{{event.Pictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.Pictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.Pictures[1].NumberComments && event.Pictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.Pictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.Pictures, event)">+{{event.Pictures.length - 2}}</span></div></div></div><div><table align="center" class="claw-health-table"><tbody><tr><td><div class="animal-claw"><div class="claw-base" ng-class="event.LFSeverity == 1 ? \'udder-health-yellow\' : (event.LFSeverity == 3 || event.LFSeverity == 2 ? \'udder-health-orange\' : (event.LFSeverity == 5 || event.LFSeverity == 4 ? \'udder-health-red\' : (event.LFSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_lf_">LF</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="event.LFOSeverity == 1 ? \'udder-health-yellow\' : (event.LFOSeverity == 3 || event.LFOSeverity == 2 ? \'udder-health-orange\' : (event.LFOSeverity == 5 || event.LFOSeverity == 4 ? \'udder-health-red\' : (event.LFOSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">o</div><div class="claw-toe-r" ng-class="event.LFISeverity == 1 ? \'udder-health-yellow\' : (event.LFISeverity == 3 || event.LFISeverity == 2 ? \'udder-health-orange\' : (event.LFISeverity == 5 || event.LFISeverity == 4 ? \'udder-health-red\' : (event.LFISeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">i</div></div></div></td><td><div class="animal-claw"><div class="claw-base" ng-class="event.RFSeverity == 1 ? \'udder-health-yellow\' : (event.RFSeverity == 3 || event.RFSeverity == 2 ? \'udder-health-orange\' : (event.RFSeverity == 5 || event.RFSeverity == 4 ? \'udder-health-red\' : (event.RFSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_rf_">RF</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="event.RFISeverity == 1 ? \'udder-health-yellow\' : (event.RFISeverity == 3 || event.RFISeverity == 2? \'udder-health-orange\' : (event.RFISeverity == 5 || event.RFISeverity == 4 ? \'udder-health-red\' : (event.RFISeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">i</div><div class="claw-toe-r" ng-class="event.RFOSeverity == 1 ? \'udder-health-yellow\' : (event.RFOSeverity == 3 || event.RFOSeverity == 2? \'udder-health-orange\' : (event.RFOSeverity == 5 || event.RFOSeverity == 4 ? \'udder-health-red\' : (event.RFOSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">o</div></div></div></td></tr><tr><td><div style="min-width: 190px; text-align: center"><div><div ng-repeat="treatment in event.LF.Treatments">{{treatment}}</div></div><div><div ng-repeat="lesion in event.LF.Lesions">{{lesion}}</div></div></div></td><td><div style="min-width: 190px; text-align: center"><div><div ng-repeat="treatment in event.RF.Treatments">{{treatment}}</div></div><div><div ng-repeat="lesion in event.RF.Lesions">{{lesion}}</div></div></div></td></tr><tr><td><div align="center" ng-if="event.LFPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.LFPictures[0].Importance == 1 ? \'importance-1\' : (event.LFPictures[0].Importance == 2 ? \'importance-2\' : (event.LFPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.LFPictures, event, \'LFPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.LFPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.LFPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.LFPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.LFPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.LFPictures[0].Creator}}</div><div class="image-details">{{event.LFPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.LFPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.LFPictures[0].NumberComments && event.LFPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.LFPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.LFPictures[1].Importance == 1 ? \'importance-1\' : (event.LFPictures[1].Importance == 2 ? \'importance-2\' : (event.LFPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.LFPictures, event, \'LFPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.LFPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.LFPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.LFPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.LFPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.LFPictures[1].Creator}}</div><div class="image-details">{{event.LFPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.LFPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.LFPictures[1].NumberComments && event.LFPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.LFPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.LFPictures , event, \'LFPictures\')">+{{event.LFPictures.length - 2}}</span></div></div></div></td><td><div align="center" ng-if="event.RFPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.RFPictures[0].Importance == 1 ? \'importance-1\' : (event.RFPictures[0].Importance == 2 ? \'importance-2\' : (event.RFPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.RFPictures, event, \'RFPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.RFPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.RFPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.RFPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.RFPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.RFPictures[0].Creator}}</div><div class="image-details">{{event.RFPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.RFPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.RFPictures[0].NumberComments && event.RFPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.RFPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.RFPictures[1].Importance == 1 ? \'importance-1\' : (event.RFPictures[1].Importance == 2 ? \'importance-2\' : (event.RFPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.RFPictures, event, \'RFPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.RFPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.RFPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.RFPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.RFPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.RFPictures[1].Creator}}</div><div class="image-details">{{event.RFPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.RFPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.RFPictures[1].NumberComments && event.RFPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.RFPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.RFPictures, event, \'RFPictures\')">+{{event.RFPictures.length - 2}}</span></div></div></div></td></tr></tbody></table></div><table align="center" class="claw-health-table"><tbody><tr><td><div class="animal-claw"><div class="claw-base" ng-class="event.LRSeverity == 1 ? \'udder-health-yellow\' : (event.LRSeverity == 3 || event.LRSeverity == 2 ? \'udder-health-orange\' : (event.LRSeverity == 5 || event.LRSeverity == 4 ? \'udder-health-red\' : (event.LRSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_lr_">LR</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="event.LROSeverity == 1 ? \'udder-health-yellow\' : (event.LROSeverity == 3 || event.LROSeverity == 2? \'udder-health-orange\' : (event.LROSeverity == 5 || event.LROSeverity == 4? \'udder-health-red\' : (event.LROSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">o</div><div class="claw-toe-r" ng-class="event.LRISeverity == 1 ? \'udder-health-yellow\' : (event.LRISeverity == 3 || event.LRISeverity == 2? \'udder-health-orange\' : (event.LRISeverity == 5 || event.LRISeverity == 4? \'udder-health-red\' : (event.LRISeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">i</div></div></div></td><td><div class="animal-claw"><div class="claw-base" ng-class="event.RRSeverity == 1 ? \'udder-health-yellow\' : (event.RRSeverity == 3 || event.RRSeverity == 2 ? \'udder-health-orange\' : (event.RRSeverity == 5 || event.RRSeverity == 4 ? \'udder-health-red\' : (event.RRSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_rr_">RR</data-i18n></div><div class="claw-toes"><div class="claw-toe-l" ng-class="event.RRISeverity == 1 ? \'udder-health-yellow\' : (event.RRISeverity == 3 || event.RRISeverity == 2 ? \'udder-health-orange\' : (event.RRISeverity == 5 || event.RRISeverity == 4? \'udder-health-red\' : (event.RRISeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">i</div><div class="claw-toe-r" ng-class="event.RROSeverity == 1 ? \'udder-health-yellow\' : (event.RROSeverity == 3 || event.RROSeverity == 2 ? \'udder-health-orange\' : (event.RROSeverity == 5 || event.RROSeverity == 4? \'udder-health-red\' : (event.RROSeverity==0 ? \'udder-health-blue\' : \'udder-health-unknown\')))">o</div></div></div></td></tr><tr><td><div style="min-width: 190px;text-align: center"><div><div ng-repeat="treatment in event.LR.Treatments">{{treatment}}</div></div><div><div ng-repeat="lesion in event.LR.Lesions">{{lesion}}</div></div></div></td><td><div style="min-width: 190px;text-align: center"><div><div ng-repeat="treatment in event.RR.Treatments">{{treatment}}</div></div><div><div ng-repeat="lesion in event.RR.Lesions">{{lesion}}</div></div></div></td></tr><tr><td><div align="center" ng-if="event.LRPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.LRPictures[0].Importance == 1 ? \'importance-1\' : (event.LRPictures[0].Importance == 2 ? \'importance-2\' : (event.LRPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.LRPictures, event, \'LRPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.LRPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.LRPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.LRPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.LRPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.LRPictures[0].Creator}}</div><div class="image-details">{{event.LRPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.LRPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.LRPictures[0].NumberComments && event.LRPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.LRPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.LRPictures[1].Importance == 1 ? \'importance-1\' : (event.LRPictures[1].Importance == 2 ? \'importance-2\' : (event.LRPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.LRPictures, event, \'LRPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.LRPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.LRPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.LRPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.LRPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.LRPictures[1].Creator}}</div><div class="image-details">{{event.LRPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.LRPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.LRPictures[1].NumberComments && event.LRPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.LRPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.LRPictures, event, \'LRPictures\')">+{{event.LRPictures.length - 2}}</span></div></div></div></td><td><div align="center" ng-if="event.RRPictures.length>0"><div class="animal-reproduction"><div class="image-block"><div class="image-canvas" ng-class="event.RRPictures[0].Importance == 1 ? \'importance-1\' : (event.RRPictures[0].Importance == 2 ? \'importance-2\' : (event.RRPictures[0].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(0, event.RRPictures, event, \'RRPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.RRPictures[0].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.RRPictures[0].IsTask"><i class="material-icons is-task-icon" ng-if="!event.RRPictures[0].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.RRPictures[0].TaskCompleted">check_circle</i></div><div class="image-details">{{event.RRPictures[0].Creator}}</div><div class="image-details">{{event.RRPictures[0].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.RRPictures[0].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.RRPictures[0].NumberComments && event.RRPictures[0].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.RRPictures[1]"><div class="image-block"><div class="image-canvas" ng-class="event.RRPictures[1].Importance == 1 ? \'importance-1\' : (event.RRPictures[1].Importance == 2 ? \'importance-2\' : (event.RRPictures[1].Importance == 3 ? \'importance-3\' : \'\'))" ng-click="vm.showImage(1, event.RRPictures, event, \'RRPictures\')"><img ng-src="assets/img/logo.png" lazy-img-error="assets/img/logo.png" lazy-img="{{event.RRPictures[1].ThumbnailUrl}}" class="reproduction-thumbnail"></div><div class="image-task-details" ng-if="event.RRPictures[1].IsTask"><i class="material-icons is-task-icon" ng-if="!event.RRPictures[1].TaskCompleted">error</i> <i class="material-icons task-completed-icon" ng-if="event.RRPictures[1].TaskCompleted">check_circle</i></div><div class="image-details">{{event.RRPictures[1].Creator}}</div><div class="image-details">{{event.RRPictures[1].ImageCreated | date:\'shortDate\'}}</div><div class="image-comment-panel overview"><div class="image-comment" ng-repeat="comment in event.RRPictures[1].Comments | orderBy: \'-CommentTimeStamp\'" ng-if="event.RRPictures[1].NumberComments && event.RRPictures[1].NumberComments > 0"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div></div><div class="animal-reproduction" ng-if="event.RRPictures[2]"><div class="more-images-label-holder"><span ng-click="vm.showImage(2, event.RRPictures, event, \'RRPictures\')">+{{event.RRPictures.length - 2}}</span></div></div></div></td></tr></tbody></table></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/picture.modal.html','<div id="modal-image-slider" ng-keypress="vm.test($event)" tabindex="0"><div class="modal-content"><div class="pictureCarousel carousel lazy" data-interval="false"><div class="carousel-inner" role="listbox"><div class="loading-animation"></div><div class="item active"><img ng-if="!vm.selectedImage.hideImage && !vm.hideImage" class="img-responsive center-block importance-none" lazy-img="{{vm.selectedImage.ImageUrl}}" ng-class="vm.selectedImage.Importance == 1 ? \'importance-1\' : (vm.selectedImage.Importance == 2 ? \'importance-2\' : (vm.selectedImage.Importance == 3 ? \'importance-3\' : \'\'))" lazy-img-error="assets/img/logo.jpg" ng-style="vm.selectedImage.FileUrl && {\'min-width\': \'96px\', \'min-height\': \'96px\'}"></div></div><a class="left carousel-control" ng-click="vm.previousImage(true)" role="button" data-slide="prev" id="previousImageLink" ng-if="vm.sliderImages.length > 1"><span class="icon-prev"></span></a> <a class="right carousel-control" ng-click="vm.nextImage(true)" role="button" data-slide="next" id="nextImageLink" ng-if="vm.sliderImages.length > 1"><span class="icon-next"></span></a></div><div class="image-info image-tile"><span class="image-who">{{vm.selectedImage.Creator}}</span> <span class="image-when">{{vm.selectedImage.ImageCreated | date:\'short\'}}</span> <span class="image-when">{{vm.selectedImage.HerdName}}</span><hr class="mmmsep"><div class="image-legend"><div class="image-who">{{vm.selectedImage.AnimalEarTag}}</div><div class="image-when">{{vm.selectedImage.AnimalNumberString}} <span ng-show="vm.selectedImage.AnimalNumberString && vm.selectedImage.AnimalName">-</span> {{vm.selectedImage.AnimalName}}</div></div><div class="image-comment-panel" ng-if="vm.selectedImage.TagsToShow.length>0 || vm.selectedImage.NumberComments>0 || vm.selectedImage.FileUrl"><div class="image-tags" ng-if="vm.selectedImage.TagsToShow.length>0"><span class="fa fa-tags"></span> <span ng-repeat="tag in vm.selectedImage.TagsToShow track by tag.value" class="image-tag">{{::tag.value}}</span></div><div class="image-file" ng-if="vm.selectedImage.FileUrl"><span class="ion-paperclip" style="font-size: 20px"></span> <span><a target="_blank" ng-href="{{vm.selectedImage.FileUrl}}">{{vm.selectedImage.FileName}}</a></span></div><div class="image-comment" ng-repeat="comment in vm.selectedImage.Comments"><span class="image-who">{{comment.CommentedBy}}</span><span class="image-when">{{comment.CommentTimeStamp | date:\'short\'}}</span><span class="comment-text">{{comment.Message}}</span></div></div></div><div class="modal-closer"><button type="button" class="rotate-button no-button" ng-if="vm.role"><i class="material-icons image-delete" ng-click="vm.openDeleteImageModal(vm.selectedImage)">delete</i></button> <button type="button" class="rotate-button no-button"><span class="fa fa-undo image-rotator image-rotator-ccw" ng-click="vm.rotateImage(vm.selectedImage, 3, $index, true)"></span></button> <button type="button" class="rotate-button no-button"><span class="fa fa-repeat image-rotator image-rotator-cw" ng-click="vm.rotateImage(vm.selectedImage, 1, $index, true)"></span></button> <button id="action-button" type="button" class="no-button"><span class="ion-android-apps action-button" ng-click="vm.showMenuModal()"></span><ul id="modalMenu" class="image-action-menu image-action-menu-modal dropdown-menu dropdown-actions-menu" role="menu" ng-click="$event.stopPropagation()"><li id="action-priority"><span class="action-menu-label"><data-i18n i18n="_label_priority_">Priority</data-i18n>:</span> <span class="label label-importance label-importance-none" data-importance="0" tabindex="0" ng-click="vm.changeImportance(vm.selectedImage, 0, $index, true)" ng-class="vm.selectedImage.Importance==0 ? \'label-importance-selected\' : (!vm.selectedImage.Importance ? \'label-importance-selected\': \'\')"><data-i18n i18n="_label_none_">None</data-i18n></span> <span class="label label-importance label-importance-1" data-importance="1" tabindex="0" ng-class="vm.selectedImage.Importance==1 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 1, $index, true)"><data-i18n i18n="_label_low_">Low</data-i18n></span> <span class="label label-importance label-importance-2" data-importance="2" tabindex="0" ng-class="vm.selectedImage.Importance==2 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 2, $index, true)"><data-i18n i18n="_label_medium_">Medium</data-i18n></span> <span class="label label-importance label-importance-3" data-importance="3" tabindex="0" ng-class="vm.selectedImage.Importance==3 ? \'label-importance-selected\' : \'\'" ng-click="vm.changeImportance(vm.selectedImage, 3, $index, true)"><data-i18n i18n="_label_high_">High</data-i18n></span></li><li id="action-task"><span class="action-menu-label"><data-i18n i18n="_label_task_">Task</data-i18n></span> <i class="material-icons action-task text-danger" ng-if="!event.TaskCompleted" tabindex="0" ng-class="vm.selectedImage.IsTask ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(vm.selectedImage, false, false, true)">error</i> <i class="material-icons action-task text-success" tabindex="0" ng-class="vm.selectedImage.TaskCompleted ? \'action-task-active\' : \'\'" ng-click="vm.changeIsTask(vm.selectedImage,true, false, true)">check_circle</i> <span class="action-task-done-by"></span></li><li ng-if="vm.selectedImage.TaskCompletedBy" style="font-size:13px"><span>{{vm.selectedImage.TaskCompletedBy}}</span></li><li id="action-comment"><div class="input-group" style="max-width:310px;"><span class="input-group-addon" style="padding: 0px 7px; font-size: 27px;"><span class="ion-ios-chatbubble-outline"></span></span> <input type="text" class="form-control" placeholder="{{\'_placeholder_comment_add_\'|i18n}}" tabindex="0" ng-model="vm.commentText" ng-keyup="vm.addCommentOnEnter($event, vm.selectedImage, $index, true)"> <span class="input-group-addon input-group-addon-hover" ng-click="vm.addComment(vm.selectedImage, false, true)"><span class="ion-chevron-right"></span></span></div></li><li id="action-tags" style="overflow:visible"><div class="input-group" style="max-width:270px;"><span class="input-group-addon"><span style="padding: 0px 0px; font-size:18px" class="fa fa-tags"></span></span><ui-select multiple="" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control" style="border-top-right-radius:0px; border-bottom-right-radius:0px;" ng-change="$event.stopPropagation()" ng-model="vm.selectedImage.TagsToShow" on-select="vm.addTag(vm.selectedImage, $item, $index)" on-remove="vm.removeTag(vm.selectedImage, $item, $index)"><ui-select-match>{{$item.label}}</ui-select-match><ui-select-choices repeat="tag in vm.tagsList | filter: $select.search">{{tag.label}}</ui-select-choices></ui-select></div></li></ul></button> <button type="button" class="close" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/reproBlock.html','<h5 ng-if="event.ReproType == 0"><data-i18n i18n="_animal_heat_">Heat</data-i18n></h5><div ng-if="event.DIM && event.ReproType == 0"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div ng-if="event.ReproType == 1"><h5 ng-class="event.ResultedInPregnancy ? \'positive\' : \'negative\'"><data-i18n i18n="_animal_breeding_">Animal breeding</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><data-i18n i18n="_animal_breeding_type_">Breeding type</data-i18n>:&#32{{event.BreedingTypeString}}</div><div class="animal-reproduction"><data-i18n i18n="_animal_bull_ear_tag_">Bull ear tag</data-i18n>:&#32{{event.BullEarTag}}</div><div class="animal-reproduction"><data-i18n i18n="_animal_bull_name_">bull name</data-i18n>:&#32{{event.BullName}}</div></div><div ng-if="event.ReproType == 2"><h5 ng-class="event.PregnancyDiagnosisResult==1 ? \'positive\' : (event.PregnancyDiagnosisResult==2 ? \'negative\' : \'\')"><data-i18n i18n="_animal_pregnancy_diagnosis_">pregnancy diagnosis</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div style="display: inline-block; vertical-align: sub;"><data-i18n i18n="_animal_pregnancy_diagnosis_result_">Pregnancy diagnosis result</data-i18n>:</div><div style="display: inline-block; vertical-align: middle;"><span ng-if="event.PregnancyDiagnosisResult==1" class="ion-ios-plus-outline animal-pregnancy-result positive"></span> <span ng-if="event.PregnancyDiagnosisResult==2" class="ion-ios-minus-outline animal-pregnancy-result negative"></span> <span ng-if="event.PregnancyDiagnosisResult==3" class="ion-ios-help-outline animal-pregnancy-result"></span></div></div></div><div ng-if="event.ReproType == 3"><h5 class="barren"><data-i18n i18n="_animal_barren_">animal barren</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div></div><div ng-if="event.ReproType == 4"><h5><data-i18n i18n="_animal_abortion_">Abortion</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div></div><div ng-if="event.ReproType == 5"><h5><data-i18n i18n="_animal_embryio_transfer_flush_">Embryio transfer flush</data-i18n></h5><div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span><span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span>:<span style="margin-right: 3px">{{event.DIM}}</span></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/search.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><input type="text" class="form-control" placeholder="{{\'_label_search_by_number_\'|i18n}}" autofocus="" ng-change="vm.searchInputChanged()" ng-model="vm.searchAnimalString"><div class="search-modal-body" lazy-img-container=""><div ng-repeat="animal in vm.searchAnimalList | orderBy:\'number\'" class="search-modal-animal-wrapper" ng-click="vm.goToAnimal(animal)"><div class="animal-picture"><img src="assets/img/logo.png" lazy-img="{{animal.pictureImageUrl}}" ng-if="animal.pictureImageUrl"> <img ng-src="assets/img/logo.png" ng-if="!animal.pictureImageUrl"></div><div class="animal-description"><div><span>{{animal.number}}</span></div><div><span>{{animal.EarTag}}</span></div></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/trimInfo.modal.html','<div><div class="modal-header"><i class="ion-ios-close-outline close-modal" style="float: right" ng-click="vm.closeModal()"></i></div><div class="modal-content"><div style="padding: 10px"><div class="cd-timeline-block" ng-repeat="event in vm.hoofTrimInfoData | orderBy:\'-eventDate\'"><div class="cd-timeline-content-animal" style="margin-left: 0;"><div><div include-with-scope="app/pages/herds/animals/animalDetails/accutrimBlock.html"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/udderHealthBlock.html','<div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span> <span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span> :<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction bordered" ng-if="event.UN"><table class="milk-summary"><thead><th colspan="2" style="text-align:-webkit-center"><div class="udder-health" ng-class="event.UN.Severity == 1 ? \'udder-health-yellow\' : (event.UN.Severity == 3 ? \'udder-health-orange\' : (event.UN.Severity == 5 ? \'udder-health-red\' : (event.UN.Severity == 13 ? \'udder-health-blue\' : \'udder-health-unknown\')))">-</div></th></thead><tbody><tr><th><data-i18n i18n="_animal_bacteria_">Bacteria</data-i18n></th><th><data-i18n i18n="_animal_antibiotics_">Antibiotics</data-i18n></th></tr><tr><td><table><tbody><tr ng-repeat="bacteria in event.UN.Bacteria"><td>{{bacteria.label_translate | i18n}}</td></tr></tbody></table></td><td><table><tbody><tr ng-repeat="antibiotic in event.UN.Antibiotics"><td>{{antibiotic.label_translate | i18n}}</td></tr></tbody></table></td></tr></tbody></table></div><div class="animal-reproduction bordered" ng-if="event.LF"><table class="milk-summary"><thead><th colspan="2" style="text-align:-webkit-center"><div class="udder-health" ng-class="event.LF.Severity == 1 ? \'udder-health-yellow\' : (event.LF.Severity == 3 ? \'udder-health-orange\' : (event.LF.Severity == 5 ? \'udder-health-red\' : (event.LF.Severity == 13 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_lf_">LF</data-i18n></div></th></thead><tbody><tr><th><data-i18n i18n="_animal_bacteria_">Bacteria</data-i18n></th><th><data-i18n i18n="_animal_antibiotics_">Antibiotics</data-i18n></th></tr><tr><td><table><tbody><tr ng-repeat="bacteria in event.LF.Bacteria"><td>{{bacteria.label_translate | i18n}}</td></tr></tbody></table></td><td><table><tbody><tr ng-repeat="antibiotic in event.LF.Antibiotics"><td>{{antibiotic.label_translate | i18n}}</td></tr></tbody></table></td></tr></tbody></table></div><div class="animal-reproduction bordered" ng-if="event.RF"><table class="milk-summary"><thead><th colspan="2" style="text-align:-webkit-center"><div class="udder-health" ng-class="event.RF.Severity == 1 ? \'udder-health-yellow\' : (event.RF.Severity == 3 ? \'udder-health-orange\' : (event.RF.Severity == 5 ? \'udder-health-red\' : (event.RF.Severity == 13 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_rf_">RF</data-i18n></div></th></thead><tbody><tr><th><data-i18n i18n="_animal_bacteria_">Bacteria</data-i18n></th><th><data-i18n i18n="_animal_antibiotics_">Antibiotics</data-i18n></th></tr><tr><td><table><tbody><tr ng-repeat="bacteria in event.RF.Bacteria"><td>{{bacteria.label_translate | i18n}}</td></tr></tbody></table></td><td><table><tbody><tr ng-repeat="antibiotic in event.RF.Antibiotics"><td>{{antibiotic.label_translate | i18n}}</td></tr></tbody></table></td></tr></tbody></table></div><div class="animal-reproduction bordered" ng-if="event.LR"><table class="milk-summary"><thead><th colspan="2" style="text-align:-webkit-center"><div class="udder-health" ng-class="event.LR.Severity == 1 ? \'udder-health-yellow\' : (event.LR.Severity == 3 ? \'udder-health-orange\' : (event.LR.Severity == 5 ? \'udder-health-red\' : (event.LR.Severity == 13 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_lr_">LR</data-i18n></div></th></thead><tbody><tr><th><data-i18n i18n="_animal_bacteria_">Bacteria</data-i18n></th><th><data-i18n i18n="_animal_antibiotics_">Antibiotics</data-i18n></th></tr><tr><td><table><tbody><tr ng-repeat="bacteria in event.LR.Bacteria"><td>{{bacteria.label_translate | i18n}}</td></tr></tbody></table></td><td><table><tbody><tr ng-repeat="antibiotic in event.LR.Antibiotics"><td>{{antibiotic.label_translate | i18n}}</td></tr></tbody></table></td></tr></tbody></table></div><div class="animal-reproduction bordered" ng-if="event.RR"><table class="milk-summary"><thead><th colspan="2" style="text-align:-webkit-center"><div class="udder-health" ng-class="event.RR.Severity == 1 ? \'udder-health-yellow\' : (event.RR.Severity == 3 ? \'udder-health-orange\' : (event.RR.Severity == 5 ? \'udder-health-red\' : (event.RR.Severity == 13 ? \'udder-health-blue\' : \'udder-health-unknown\')))"><data-i18n i18n="_animal_rr_">RR</data-i18n></div></th></thead><tbody><tr><th><data-i18n i18n="_animal_bacteria_">Bacteria</data-i18n></th><th><data-i18n i18n="_animal_antibiotics_">Antibiotics</data-i18n></th></tr><tr><td><table><tbody><tr ng-repeat="bacteria in event.RR.Bacteria"><td>{{bacteria.label_translate | i18n}}</td></tr></tbody></table></td><td><table><tbody><tr ng-repeat="antibiotic in event.RR.Antibiotics"><td>{{antibiotic.label_translate | i18n}}</td></tr></tbody></table></td></tr></tbody></table></div><div class="animal-reproduction"><div><data-i18n i18n="_label_protocol_">Protocol</data-i18n>:&#32<span style="float:right; padding-left:5px">{{event.Protocol || \'-\'}}</span></div></div>');
$templateCache.put('app/pages/herds/animals/animalDetails/udderHealthStreamerBlock.html','<div ng-if="event.DIM"><span ng-if="!event.beforeFirstLact"><data-i18n i18n="_animal_dim_">DIM</data-i18n></span> <span ng-if="event.beforeFirstLact"><data-i18n i18n="_animal_doa_">DOA</data-i18n></span> :<span style="margin-right: 3px">{{event.DIM}}</span></div><div class="animal-reproduction"><div class="udder"><div class="udder-row front"><div class="udder-quarter" ng-class="event.LF ? \'udder-health-blue\' : \'\'"><data-i18n i18n="_animal_lf_">LF</data-i18n></div><div class="udder-quarter" ng-class="event.RF ? \'udder-health-blue\' : \'\'"><data-i18n i18n="_animal_rf_">RF</data-i18n></div></div><div class="udder-row rear"><div class="udder-quarter" ng-class="event.LR ? \'udder-health-blue\' : \'\'"><data-i18n i18n="_animal_lr_">LR</data-i18n></div><div class="udder-quarter" ng-class="event.RR ? \'udder-health-blue\' : \'\'"><data-i18n i18n="_animal_rr_">RR</data-i18n></div></div></div></div>');}]);